/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"c95ac764","1":"05c105ac"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 317);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(328);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(56), 'Object', { defineProperty: __webpack_require__(63).f });


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(130);
var test = {};
test[__webpack_require__(49)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(69)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(52);
var has = __webpack_require__(84);
var DESCRIPTORS = __webpack_require__(56);
var $export = __webpack_require__(30);
var redefine = __webpack_require__(69);
var META = __webpack_require__(338).KEY;
var $fails = __webpack_require__(55);
var shared = __webpack_require__(127);
var setToStringTag = __webpack_require__(133);
var uid = __webpack_require__(111);
var wks = __webpack_require__(49);
var wksExt = __webpack_require__(215);
var wksDefine = __webpack_require__(339);
var enumKeys = __webpack_require__(340);
var isArray = __webpack_require__(159);
var anObject = __webpack_require__(54);
var isObject = __webpack_require__(64);
var toObject = __webpack_require__(75);
var toIObject = __webpack_require__(74);
var toPrimitive = __webpack_require__(126);
var createDesc = __webpack_require__(110);
var _create = __webpack_require__(120);
var gOPNExt = __webpack_require__(341);
var $GOPD = __webpack_require__(117);
var $GOPS = __webpack_require__(134);
var $DP = __webpack_require__(63);
var $keys = __webpack_require__(95);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(119).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(118).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(112)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(83)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(116);
var step = __webpack_require__(343);
var Iterators = __webpack_require__(114);
var toIObject = __webpack_require__(74);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(217)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(197)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(217)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(4);
var getKeys = __webpack_require__(95);
var redefine = __webpack_require__(69);
var global = __webpack_require__(52);
var hide = __webpack_require__(83);
var Iterators = __webpack_require__(114);
var wks = __webpack_require__(49);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkOpen */
/* harmony export (immutable) */ __webpack_exports__["c"] = shortImageSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = handlePrice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_date_to_string_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_date_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_date_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_to_string_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_search_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_search_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_search_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_last_index_of_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_last_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_last_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_values_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_values_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_values_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_md5__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__clipboard_copy__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_device_detect__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_react_device_detect__);
function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}var innerWidth=typeof window!=='undefined'?window.innerWidth:0;var isTabletDevice=__WEBPACK_IMPORTED_MODULE_40_react_device_detect__["isTablet"]&&innerWidth>600;var scene=getParams('scene')||'shihuoApp';var iframe=getParams('isIframe')=='1';var nativeInfo=getParams('nativeInfo');var colorScheme='',safeBottomHeight=0,statusBarHeight=0;if(nativeInfo){nativeInfo=JSON.parse(decodeURIComponent(nativeInfo||'{}'));colorScheme=nativeInfo.colorScheme||'light';safeBottomHeight=nativeInfo.safeBottomHeight||0;statusBarHeight=nativeInfo.statusBarHeight||0;}// 记录最大浏览深度
var maxScrollDepth=0;function getNativeInfo(){return{colorScheme:colorScheme,safeBottomHeight:safeBottomHeight,statusBarHeight:statusBarHeight};}function isAndroid(){if(typeof window==="undefined"){return true;}return navigator.userAgent.indexOf("Android")>-1||navigator.userAgent.indexOf("Adr")>-1;}function isHarmonyOS(){if(typeof window==="undefined"){return false;}return navigator.userAgent.indexOf("OpenHarmony")>-1;};function isHuPuAPP(){if(typeof window==="undefined"){return true;}return navigator.userAgent.indexOf("hupush")>-1||navigator.userAgent.indexOf("kanqiu")>-1;}function parseToken(obj){var paramsToken="";Object.keys(obj).sort().forEach(function(item){if(obj[item]){paramsToken+=obj[item].toString();}});paramsToken+="123456";return __WEBPACK_IMPORTED_MODULE_36_md5___default()(paramsToken);}//判断是否在识货中
function isShihuo(){if(typeof window==="undefined"){return true;}var ua=navigator.userAgent.toLowerCase();if(ua.indexOf("shihuo")>-1){return true;}else{return false;}}// 获取指定url字符串中的参数
function getUrlParams(url,name){var reg=new RegExp("(^|&)"+name+"=([^&]*)(&|$)");var r=url.split("?")[1].match(reg);if(r!=null){return decodeURIComponent(r[2]);}return null;//返回参数值
}//获取链接参数
function getParams(name){if(typeof window=='undefined')return null;var reg=new RegExp("(^|&)"+name+"=([^&]*)(&|$)","i");var r=window.location.search.substr(1).match(reg);if(r!=null){return decodeURIComponent(r[2]);// 使用 decodeURIComponent  
}return null;}function getQueryString(name){if(typeof window=='undefined')return null;var reg=new RegExp("(^|&)"+name+"=([^&]*)(&|$)","i");var r=window.location.search.substr(1).match(reg);if(r!=null)return decodeURI(r[2]);return null;}function getCookie(name){var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"),iosreg=new RegExp("(^|)"+name+"=([^;]*)(;|$)");return new Promise(function(resolve){if(isShihuo()){//resolve(null)
//return false
try{if(document.cookie.indexOf("sensorsdata2015jssdkcross")>-1){document.cookie="sensorsdata2015jssdkcross=; path=/; domain=.shihuo.cn; expires=Thu, 01 Jan 1970 00:00:00 GMT";}window.Jockey.send("fetchCookies",{url:"http://www.shihuo.cn"},function(res){if(res.status==0){if(isAndroid()){arr=decodeURIComponent(res.data.str).match(reg);}else{arr=decodeURIComponent(res.data.str).match(iosreg);}if(arr){resolve(unescape(arr[2]));}else{resolve(null);}}else{resolve(null);}});}catch(e){console.log(e);resolve(null);}}else{if(arr=document.cookie.match(reg)){resolve(unescape(arr[2]));}else{resolve(null);}}});}function getDeviceInfo(){return new Promise(function(resolve){if(isShihuo()){window.Jockey.send("device",{},function(res){console.log("device-------",res);resolve({deviceId:res.idfa||res.deviceId,abtest_tag:res.abtest_tag||""});});}else{resolve({deviceId:"",abtest:""});}});}function asyncForEach(_x,_x2){return _asyncForEach.apply(this,arguments);}function _asyncForEach(){_asyncForEach=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(array,callback){var index;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:index=0;case 1:if(!(index<array.length)){_context.next=7;break;}_context.next=4;return callback(array[index],index,array);case 4:index++;_context.next=1;break;case 7:case"end":return _context.stop();}}},_callee);}));return _asyncForEach.apply(this,arguments);}function convertHref(href){if(-1==href.indexOf("shihuo://www.shihuo.cn?")){var mdStr=href.split("#%7B")[1];var href=href.split("#%7B")[0];// app首页
var webHomeRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/?$/i;if(webHomeRegExp.test(href)){return href.replace(webHomeRegExp,"shihuo://www.shihuo.cn?route=index"+(mdStr?"#%7B"+mdStr:""));}// 商品列表
var goodsListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/sports\/list\?(.+)$/i;if(goodsListRegExp.test(href)){return href.replace(goodsListRegExp,"shihuo://www.shihuo.cn?route=goodsList&$1"+(mdStr?"#%7B"+mdStr:""));}// 篮球专区
var basketballRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/basketball$/i;if(basketballRegExp.test(href)){return href.replace(basketballRegExp,"shihuo://www.shihuo.cn?route=basketball"+(mdStr?"#%7B"+mdStr:""));}var basketballParamRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/basketball\?haojiaId=(\d+)$/i;if(basketballParamRegExp.test(href)){return href.replace(basketballParamRegExp,"shihuo://www.shihuo.cn?route=basketball&haojiaId=$1"+(mdStr?"#%7B"+mdStr:""));}// 跑步专区
var runningRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/running$/i;if(runningRegExp.test(href)){return href.replace(runningRegExp,"shihuo://www.shihuo.cn?route=running"+(mdStr?"#%7B"+mdStr:""));}var runningParamRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/running\?haojiaId=(\d+)$/i;if(runningParamRegExp.test(href)){return href.replace(runningParamRegExp,"shihuo://www.shihuo.cn?route=running&haojiaId=$1"+(mdStr?"#%7B"+mdStr:""));}// 休闲专区
var freestyleRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/freestyle$/i;if(freestyleRegExp.test(href)){return href.replace(freestyleRegExp,"shihuo://www.shihuo.cn?route=freestyle"+(mdStr?"#%7B"+mdStr:""));}var freestyleParamRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/freestyle\?haojiaId=(\d+)$/i;if(freestyleParamRegExp.test(href)){return href.replace(freestyleParamRegExp,"shihuo://www.shihuo.cn?route=freestyle&haojiaId=$1"+(mdStr?"#%7B"+mdStr:""));}// 健身专区
var fitnessRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/fitness$/i;if(fitnessRegExp.test(href)){return href.replace(fitnessRegExp,"shihuo://www.shihuo.cn?route=fitness"+(mdStr?"#%7B"+mdStr:""));}// 足球专区
var footballRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/football$/i;if(footballRegExp.test(href)){return href.replace(footballRegExp,"shihuo://www.shihuo.cn?route=football"+(mdStr?"#%7B"+mdStr:""));}// 数码专区
var digitalRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/digital$/i;if(digitalRegExp.test(href)){return href.replace(digitalRegExp,"shihuo://www.shihuo.cn?route=digital"+(mdStr?"#%7B"+mdStr:""));}// 理容专区
var beautyRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/beauty$/i;if(beautyRegExp.test(href)){return href.replace(beautyRegExp,"shihuo://www.shihuo.cn?route=beauty"+(mdStr?"#%7B"+mdStr:""));}// 商品详情
var goodsDetailRegExpOne=/^https?:\/\/[www|m]+\.shihuo\.cn\/sports\/detail\/(\d+).html$/i;if(goodsDetailRegExpOne.test(href)){return href.replace(goodsDetailRegExpOne,"shihuo://www.shihuo.cn?route=goodsDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 商品详情
var goodsDetailRegExpTwo=/^https?:\/\/[www|m]+\.shihuo\.cn\/sports\/detail\/(\d+).html\?(.+)$/i;if(goodsDetailRegExpTwo.test(href)){return href.replace(goodsDetailRegExpTwo,"shihuo://www.shihuo.cn?route=goodsDetail&id=$1&$2"+(mdStr?"#%7B"+mdStr:""));}// 商品详情
var goodsDetailRegExpOne=/^https?:\/\/[m-]+share+\.shihuo\.cn\/sports\/detail\/(\d+).html$/i;if(goodsDetailRegExpOne.test(href)){return href.replace(goodsDetailRegExpOne,"shihuo://www.shihuo.cn?route=goodsDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 商品详情
var goodsDetailRegExpTwo=/^https?:\/\/[m-]+share+\.shihuo\.cn\/sports\/detail\/(\d+).html\?(.+)$/i;if(goodsDetailRegExpTwo.test(href)){return href.replace(goodsDetailRegExpTwo,"shihuo://www.shihuo.cn?route=goodsDetail&id=$1&$2"+(mdStr?"#%7B"+mdStr:""));}// 商品详情
var goodsDetailRegExpThree=/^https?:\/\/[m-]+share+\.shihuo\.cn\/app\/assets\/h5app\/ShihuoDetail.html\?(.+)$/i;if(goodsDetailRegExpThree.test(href)){var goodsId=getUrlParams(href,'goodsId');var styleId=getUrlParams(href,'styleId');var skuId=getUrlParams(href,'skuId');var device=getUrlParams(href,'device');var platform=getUrlParam(href,'platform');return href.replace(goodsDetailRegExpThree,"shihuo://www.shihuo.cn?route=goodsDetail&id=".concat(goodsId).concat(styleId?'&styleId='+styleId:'').concat(skuId?'&skuId='+skuId:'').concat(device?'&device='+device:'').concat(platform?'&platform='+platform:'')+(mdStr?"#%7B"+mdStr:""));}// 优惠列表
var youhuiListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/youhui$/i;if(youhuiListRegExp.test(href)){return href.replace(youhuiListRegExp,"shihuo://www.shihuo.cn?route=youhuiList"+(mdStr?"#%7B"+mdStr:""));}// 优惠详情
var youhuiDetailRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/youhui\/(\d+).html(.*|\?.*)$/i;if(youhuiDetailRegExp.test(href)){return href.replace(youhuiDetailRegExp,"shihuo://www.shihuo.cn?route=youhuiDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 海淘首页
var haitaoHomeRegExp;if(href.indexOf("www.shihuo.cn")>-1||href.indexOf("www.haitaodashi.cn")>-1){haitaoHomeRegExp=/^https?:\/\/www\.[shihuo|haitaodashi]+\.cn\/haitao$/i;}else if(href.indexOf("m.shihuo.cn")>-1){haitaoHomeRegExp=/^https?:\/\/m\.shihuo\.cn\/haitao\/index$/i;}if(haitaoHomeRegExp&&haitaoHomeRegExp.test(href)){return href.replace(haitaoHomeRegExp,"shihuo://www.shihuo.cn?route=haitaoIndex"+(mdStr?"#%7B"+mdStr:""));}// 海淘列表
var haitaoListRegExp;if(href.indexOf("www.shihuo.cn")>-1){haitaoListRegExp=/^https?:\/\/www\.shihuo\.cn\/haitao\/youhui$/i;}else if(href.indexOf("m.shihuo.cn")>-1){haitaoListRegExp=/^https?:\/\/m\.shihuo\.cn\/haitao$/i;}if(haitaoListRegExp&&haitaoListRegExp.test(href)){return href.replace(haitaoListRegExp,"shihuo://www.shihuo.cn?route=haitaoList"+(mdStr?"#%7B"+mdStr:""));}// 海淘详情
var haitaoDetailRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/haitao\/youhui\/(\d+).html$/i;if(haitaoDetailRegExp.test(href)){return href.replace(haitaoDetailRegExp,"shihuo://www.shihuo.cn?route=haitaoDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 代购详情
var daigouDetailRegExpOne;if(href.indexOf("www.shihuo.cn")>-1||href.indexOf("www.haitaodashi.cn")>-1){daigouDetailRegExpOne=/^https?:\/\/www\.[shihuo|haitaodashi]+\.cn\/haitao\/buy\/(\d+).html(.*|\?.*)$/i;}else if(href.indexOf("m.shihuo.cn")>-1){daigouDetailRegExpOne=/^https?:\/\/m\.shihuo\.cn\/daigou\/(\d+).html(.*|\?.*)$/i;}if(daigouDetailRegExpOne&&daigouDetailRegExpOne.test(href)){return href.replace(daigouDetailRegExpOne,"shihuo://www.shihuo.cn?route=daigouDetail&pid=$1"+(mdStr?"#%7B"+mdStr:""));}// 代购详情 ？
var daigouDetailRegExpOneParam;if(href.indexOf("m.shihuo.cn")>-1){daigouDetailRegExpOneParam=/^https?:\/\/m\.shihuo\.cn\/daigou\/(\d+).html(.*|\?.*)$/i;}if(daigouDetailRegExpOneParam&&daigouDetailRegExpOneParam.test(href)){return href.replace(daigouDetailRegExpOneParam,"shihuo://www.shihuo.cn?route=daigouDetail&pid=$1"+(mdStr?"#%7B"+mdStr:""));}// 代购详情
var daigouDetailRegExpTwo;if(href.indexOf("www.shihuo.cn")>-1||href.indexOf("www.haitaodashi.cn")>-1){daigouDetailRegExpTwo=/^https?:\/\/www\.[shihuo|haitaodashi]+\.cn\/haitao\/buy\/(\d+)-(\d+).html(.*|\?.*)$/i;}else if(href.indexOf("m.shihuo.cn")>-1){daigouDetailRegExpTwo=/^https?:\/\/m\.shihuo\.cn\/daigou\/(\d+)-(\d+).html(.*|\?.*)$/i;}if(daigouDetailRegExpTwo&&daigouDetailRegExpTwo.test(href)){return href.replace(daigouDetailRegExpTwo,"shihuo://www.shihuo.cn?route=daigouDetail&pid=$1&gid=$2"+(mdStr?"#%7B"+mdStr:""));}// 现货详情
var xianhuoDetailRegExpOne=/^https?:\/\/[www|m]+\.shihuo\.cn\/xianhuo\/buy\/(\d+).html$/i;if(xianhuoDetailRegExpOne.test(href)){return href.replace(xianhuoDetailRegExpOne,"shihuo://www.shihuo.cn?route=daigouDetail&pid=$1"+(mdStr?"#%7B"+mdStr:""));}// 现货详情
var xianhuoDetailRegExpTwo=/^https?:\/\/[www|m]+\.shihuo\.cn\/xianhuo\/buy\/(\d+)-(\d+).html$/i;if(xianhuoDetailRegExpTwo.test(href)){return href.replace(xianhuoDetailRegExpTwo,"shihuo://www.shihuo.cn?route=daigouDetail&pid=$1&gid=$2"+(mdStr?"#%7B"+mdStr:""));}// 团购列表
var tuangouListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/tuangou$/i;if(tuangouListRegExp.test(href)){return href.replace(tuangouListRegExp,"shihuo://www.shihuo.cn?route=grouponHome"+(mdStr?"#%7B"+mdStr:""));}// 团购详情
var tuangouDetailRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/tuangou\/(\d+)(.*|\?.*)$/i;if(tuangouDetailRegExp.test(href)){return href.replace(tuangouDetailRegExp,"shihuo://www.shihuo.cn?route=grouponDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 运动鞋列表
var shoeListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/shoe$/i;if(shoeListRegExp.test(href)){return href.replace(shoeListRegExp,"shihuo://www.shihuo.cn?route=shoesList"+(mdStr?"#%7B"+mdStr:""));}// 运动鞋详情
var shoeDetailRegExp;if(href.indexOf("www.shihuo.cn")>-1){shoeDetailRegExp=/^https?:\/\/www\.shihuo\.cn\/detail\/(\d+).html$/i;}else if(href.indexOf("m.shihuo.cn")>-1){shoeDetailRegExp=/^https?:\/\/m\.shihuo\.cn\/shoe\/detail\/(\d+).html$/i;}if(shoeDetailRegExp&&shoeDetailRegExp.test(href)){return href.replace(shoeDetailRegExp,"shihuo://www.shihuo.cn?route=shoesDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 晒物列表
var shaiwuListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/shaiwu$/i;if(shaiwuListRegExp.test(href)){return href.replace(shaiwuListRegExp,"shihuo://www.shihuo.cn?route=shaiwuList"+(mdStr?"#%7B"+mdStr:""));}// 晒物详情
var shaiwuDetailRegExp;if(href.indexOf("www.shihuo.cn")>-1){shaiwuDetailRegExp=/^https?:\/\/www\.shihuo\.cn\/shaiwu\/detail\/(\d+).html$/i;}else if(href.indexOf("m.shihuo.cn")>-1){shaiwuDetailRegExp=/^https?:\/\/m\.shihuo\.cn\/shaiwu\/detail\/(\d+)(.*|\?.*)$/i;}if(shaiwuDetailRegExp&&shaiwuDetailRegExp.test(href)){return href.replace(shaiwuDetailRegExp,"shihuo://www.shihuo.cn?route=shaiwuDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 优惠券列表
var couponListRegExp;if(href.indexOf("www.shihuo.cn")>-1){couponListRegExp=/^https?:\/\/www\.shihuo\.cn\/coupons\/quan$/i;}else if(href.indexOf("m.shihuo.cn")>-1){couponListRegExp=/^https?:\/\/m\.shihuo\.cn\/coupon$/i;}if(couponListRegExp&&couponListRegExp.test(href)){return href.replace(couponListRegExp,"shihuo://www.shihuo.cn?route=myWallet"+(mdStr?"#%7B"+mdStr:""));}// 我的优惠券列表
var myCouponListRegExp;if(href.indexOf("www.shihuo.cn")>-1){myCouponListRegExp=/^https?:\/\/www\.shihuo\.cn\/ucenter\/myCoupon$/i;}if(myCouponListRegExp&&myCouponListRegExp.test(href)){return href.replace(myCouponListRegExp,"shihuo://www.shihuo.cn?route=myCoupon"+(mdStr?"#%7B"+mdStr:""));}// 优惠券详情
var couponDetailRegExp;if(href.indexOf("www.shihuo.cn")>-1){couponDetailRegExp=/^https?:\/\/www\.shihuo\.cn\/duihuan\/(\w+).html$/i;}else if(href.indexOf("m.shihuo.cn")>-1){couponDetailRegExp=/^https?:\/\/m\.shihuo\.cn\/coupon\/(\w+).html$/i;}if(couponDetailRegExp&&couponDetailRegExp.test(href)){return href.replace(couponDetailRegExp,"shihuo://www.shihuo.cn?route=youhuiquanDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 文章详情
var articleDetailRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/article\/detail\/(\d+).html(.*|\?.*)$/i;if(articleDetailRegExp.test(href)){return href.replace(articleDetailRegExp,"shihuo://www.shihuo.cn?route=articleDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 栏目列表
var columnListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/column\/(\d+).html(.*|\?.*)$/i;if(columnListRegExp.test(href)){return href.replace(columnListRegExp,"shihuo://www.shihuo.cn?route=columnHome&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 活动列表
var activityListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/activity\/(\d+).html(.*|\?.*)$/i;if(activityListRegExp.test(href)){return href.replace(activityListRegExp,"shihuo://www.shihuo.cn?route=activityHome&id=$1"+(mdStr?"#%7B"+mdStr:""));}if(0===href.indexOf("http://item.taobao.com/item.htm")||0===href.indexOf("http://detail.tmall.com/item.htm")||0===href.indexOf("https://detail.m.tmall.com/item.htm")||0===href.indexOf("https://item.taobao.com/item.htm")||0===href.indexOf("https://detail.tmall.com/item.htm")||0===href.indexOf("http://detail.tmall.hk/hk/item.htm")||0===href.indexOf("https://detail.tmall.hk/hk/item.htm")||0===href.indexOf("https://h5.m.taobao.com/awp/core/detail.htm")||0===href.indexOf("http://h5.m.taobao.com/awp/core/detail.htm")||0===href.indexOf("https://s.click.taobao.com")||0===href.indexOf("http://s.click.taobao.com")||0===href.indexOf("https://g.click.taobao.com")||0===href.indexOf("http://g.click.taobao.com")||0===href.indexOf("https://market.m.taobao.com")||0===href.indexOf("https://uland.taobao.com")||0===href.indexOf("https://u.jd.com")||0===href.indexOf("https://pages.tmall.com")||0===href.indexOf("http")&&new URL(href).host.indexOf('shihuo')===-1){return"shihuo://www.shihuo.cn?route=go&url="+encodeURIComponent(href)+(mdStr?"#%7B"+mdStr:"");}//专题地址转换
var specialRegExp=/^https?:\/\/t\.shihuo\.cn\/(\d+).html$/i;var specialMRegExp=/^https?:\/\/t\.shihuo\.cn\/m\/(\d+).html$/i;if(specialRegExp&&specialRegExp.test(href)){return href.replace(specialRegExp,"http://t.shihuo.cn/app/$1.html"+(mdStr?"#%7B"+mdStr:""));}if(specialMRegExp&&specialMRegExp.test(href)){return href.replace(specialMRegExp,"http://t.shihuo.cn/app/$1.html"+(mdStr?"#%7B"+mdStr:""));}//栏目活动详情
var pictureDetailRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/picture\/detail\/(\d+).html(.*|\?.*)$/i;if(pictureDetailRegExp.test(href)){return href.replace(pictureDetailRegExp,"shihuo://www.shihuo.cn?route=pictureDetail&id=$1"+(mdStr?"#%7B"+mdStr:""));}// 装备集合页
var goodsTabRegExp=/^https?:\/\/m\.shihuo\.cn\/zhuangbei$/i;if(goodsTabRegExp.test(href)){return href.replace(goodsTabRegExp,"shihuo://www.shihuo.cn?route=zoneHomes"+(mdStr?"#%7B"+mdStr:""));}// 发现首页
var findHomeRegExp=/^https?:\/\/m\.shihuo\.cn\/find\/index$/i;if(findHomeRegExp.test(href)){return href.replace(findHomeRegExp,"shihuo://www.shihuo.cn?route=shiwuHome"+(mdStr?"#%7B"+mdStr:""));}// 推荐店铺
var recommendShopRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/shop$/i;if(recommendShopRegExp.test(href)){return href.replace(recommendShopRegExp,"shihuo://www.shihuo.cn?route=shop"+(mdStr?"#%7B"+mdStr:""));}// 优惠列表
var baicaiListRegExp=/^https?:\/\/[www|m]+\.shihuo\.cn\/baicai$/i;if(baicaiListRegExp.test(href)){return href.replace(baicaiListRegExp,"shihuo://www.shihuo.cn?route=baicaiList"+(mdStr?"#%7B"+mdStr:""));}// 以上都无法匹配
return href+(mdStr?"#%7B"+mdStr:"");}else{return href;}}// 复制内容到剪贴板，此函数必须在点击事件或者其他事件中执行，不然无效
function copyToClipBoard(copyText){Object(__WEBPACK_IMPORTED_MODULE_38__clipboard_copy__["a" /* default */])(copyText);}// 解析特定序列化字符串
function parseQueryStringParams(queryString,key){var reg=new RegExp("(^|&)"+key+"=([^&]*)(&|$)","i");var r=queryString.match(reg);if(r!=null){return unescape(r[2]);}return null;}function isJSON(str){if(typeof str=="string"){try{JSON.parse(str);return true;}catch(e){console.log(e);return false;}}}function isIphoneX(){return!isAndroid()&&(window.screen.width===375&&window.screen.height===812||window.screen.width===414&&window.screen.height===896||window.screen.width===390&&window.screen.height===844||window.screen.width===428&&window.screen.height===926);}function isIphone14ProMax(){return!isAndroid()&&(window.screen.width===393&&window.screen.height===852||window.screen.width===402&&window.screen.height===874||window.screen.width===420&&window.screen.height===912||window.screen.width===430&&window.screen.height===932||window.screen.width===440&&window.screen.height===956);}function getQueryVariable(variable,query){var vars=query.split("&");for(var i=0;i<vars.length;i++){var pair=vars[i].split("=");if(pair[0]==variable){return pair[1];}}return{};}function getTPExtra(tpExtra){if(typeof tpExtra=="string"&&tpExtra){tpExtra=decodeURIComponent(tpExtra)||{};}if(tpExtra){if(isJSON(tpExtra)){tpExtra=JSON.parse(tpExtra);}tpExtra=_objectSpread(_objectSpread({},tpExtra),{},{ffTp:tpExtra.fTp||"",ffTpName:tpExtra.fTpName||""});return tpExtra;}else{return{};}}function formatTPExtraData(str,tpExtra){var index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var pathname=window.location.pathname;var firstIndex=pathname.indexOf("page/");var lastIndex=pathname.indexOf("/index.html");var id="";if(firstIndex>-1&&lastIndex>-1&&firstIndex!=lastIndex){id=pathname.substring(firstIndex+5,lastIndex)||"";}console.log("id",id);var tempTPExtra=tpExtra||{};if(typeof str=="string"&&str){var formatStr=decodeURIComponent(str)||{};isJSON(formatStr)?(formatStr=JSON.parse(formatStr)||{},tempTPExtra.fTp=formatStr&&formatStr.block?formatStr.block+"_"+id:"_"+id,tempTPExtra.fTpName="专题_"+id,tempTPExtra=JSON.stringify(tempTPExtra)):tempTPExtra=encodeURIComponent(tempTPExtra);return encodeURIComponent(tempTPExtra);}else{tempTPExtra.fTp="_"+id;tempTPExtra.fTpName="专题_"+id;return encodeURIComponent(JSON.stringify(tempTPExtra));}}function jumpToUrl(value){var url=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var hashStringUrl=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var id=arguments.length>4&&arguments[4]!==undefined?arguments[4]:-1;var data=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};var hasCombine=arguments.length>6&&arguments[6]!==undefined?arguments[6]:true;var ptiOptions=arguments.length>7&&arguments[7]!==undefined?arguments[7]:{};var otherTpExtra=arguments.length>8&&arguments[8]!==undefined?arguments[8]:{};var formatUrl=arguments.length>9&&arguments[9]!==undefined?arguments[9]:true;var templatePti=data.templatePti;url=url.trim();var productUrl=formatUrl?url.split("#")[0]:url;var hashString=hashStringUrl.indexOf("#")>-1?hashStringUrl.split("#")[1]:"";var pageId=getPageId();id=id==-1?pageId:id;options.block=data?data.customAttributes["data-component-block"]:"";options.from="shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_SpecialTopics&page=ShoesSpecialShows&options=".concat(encodeURIComponent(JSON.stringify({id:pageId})));options.extra={from:options.from,block:options.block};try{if(hashString&&hasCombine){var oldOptions=JSON.parse(decodeURIComponent(hashString));options=_objectSpread(_objectSpread({},oldOptions),options);// 数据合并
// Object.assign(options, oldOptions);
}}catch(error){}if(isShihuo()){var tpExtra={};// console.log("value", value, productUrl);
if(value){var obj=typeof value=="string"?JSON.parse(value):value;tpExtra=obj&&obj.tpExtra?obj.tpExtra:{};}tpExtra=getTPExtra(tpExtra);if(otherTpExtra){Object.assign(tpExtra,otherTpExtra);}if(ptiOptions&&ptiOptions.id){// 追加sourceTp
Object.assign(tpExtra,{sourceTp:ptiOptions.id,sourceTpName:ptiOptions.tpName});}// console.log(
//   "tpExtra=AB1==",
//   tpExtra,
//   "tpExtra",
//   JSON.stringify(tpExtra)
// );
// console.log("hashString", hashString, "productUrl", productUrl);
var newTPExtra=formatTPExtraData(encodeURIComponent(JSON.stringify(options)),tpExtra,id);// console.log("newTPExtra", newTPExtra, "item.id", id);
var link=productUrl;if(formatUrl){if(productUrl.includes("?")){link="".concat(productUrl,"&tpExtra=").concat(newTPExtra,"#").concat(encodeURIComponent(JSON.stringify(options)));}else{link="".concat(productUrl,"?tpExtra=").concat(newTPExtra,"#").concat(encodeURIComponent(JSON.stringify(options)));}}// 站外链接转换为识货路由
if(!productUrl.includes("shihuo.cn")){link="shihuo://www.shihuo.cn?route=fastWebview&url=".concat(encodeURIComponent(productUrl),"&tpExtra=").concat(newTPExtra,"#").concat(encodeURIComponent(JSON.stringify(options)));}console.log("跳转链接",link,"tpExtra",JSON.stringify(tpExtra));if(getParams('community_tab')=='1'){localStorage.setItem('jumpSubPage','1');}if(templatePti==='lego-inventory'){link=url;}// 跳转及埋点上报
navigateWithTrack(link,data,pageId,options,ptiOptions);}else{if(window.HW_MANAGED_JS||window.lives&&typeof window.lives.getAppExists=='function'){// 如果是在华为智慧搜素或华为生活服务App打开
productUrl=formatRouteToH5(productUrl);}var _link="".concat(productUrl,"#").concat(encodeURIComponent(JSON.stringify(options)));if(templatePti==='lego-inventory'){_link=url;}console.log("跳转链接",_link);// 跳转及埋点上报
navigateWithTrack(_link,data,pageId,options,ptiOptions);}}function handleToufangClick(_ref){var link=_ref.link,props=_ref.props,index=_ref.index,clickType=_ref.clickType;link=link.trim();var longurl=getParams('longurl');if(longurl){var _from=getUrlParams(longurl,'from');// 当前页面是B站投放页面时，给link设置默认值，页面所有热区点击都可进行场景还原
if(['kiwi-release-signed-shihuo','kiwi-release-signed-bilibili'].indexOf(_from)>=0){link='http://www.shihuo.cn';}}var compName=props.customAttributes["data-component-name"];var shouldRedirect=link&&['pipeline-image','pipeline-imgList','pipeline-imgHotMap','pipeline-lottery'].includes(compName);var _props$downloadUrl=props.downloadUrl,downloadUrl=_props$downloadUrl===void 0?"":_props$downloadUrl,_props$from=props.from,from=_props$from===void 0?"":_props$from,_props$kouling=props.kouling,kouling=_props$kouling===void 0?"":_props$kouling;var block=props.customAttributes["data-component-block"];var app_link=link;var pageId=getPageId();var options=decodeURIComponent(getUrlParam(link,"options"));var optionsProps={sort:index};if(options){options=JSON.parse(options);options=Object.assign({},options,{from:from,block:block,sort:index});options="&options="+encodeURIComponent(JSON.stringify(options));var link_url=removeURLParameter(link,"options");app_link=link_url+options;}if(isShihuo()){window.__dace.sendEvent("".concat(from,"_h5_").concat(block,"_index").concat(index));app_link=convertHref(app_link);app_link=app_link+"#"+encodeURIComponent("{\"from\": \"".concat(from,"\",\"block\":\"h5_").concat(block,"_index").concat(index,"\",\"index\":\"").concat(index,"\"}"));// 跳转及埋点上报
navigateWithTrack(app_link,props,pageId,optionsProps);}else{uploadTrack(props,optionsProps);uploadTrack(props,optionsProps,{ptiId:"".concat(props.templatePti,":beginDownload"),bizExtra:{kouling:kouling,ua:navigator.userAgent,downloadUrl:downloadUrl}});this.checkOpen(function(){// 唤端成功的回调
// 唤端成功埋点
var ptiOptions={ptiId:"".concat(props.templatePti,":arouseSuss"),bizExtra:{kouling:kouling,ua:navigator.userAgent,downloadUrl:downloadUrl}};uploadTrack(props,optionsProps,ptiOptions);},function(){// 唤端失败的回调
// 唤端失败埋点
uploadTrack(props,optionsProps,{ptiId:"".concat(props.templatePti,":arouseFail"),bizExtra:{kouling:kouling,ua:navigator.userAgent,downloadUrl:downloadUrl}});// 唤端失败，跳转下载埋点
uploadTrack(props,optionsProps,{ptiId:"".concat(props.templatePti,":endDownload"),bizExtra:{kouling:kouling,ua:navigator.userAgent,downloadUrl:downloadUrl}});if(isAndroid()){androidDownload(props);}},function(){// 唤端捕获异常的回调
if(isAndroid()){androidDownload(props);}});// 如果有口令，将口令复制到剪贴板，同时将跳转link改为首页
if(kouling){var m_device_id=window.localStorage.getItem('m_device_id')||'';m_device_id?copyToClipBoard("".concat(kouling,"##").concat(m_device_id,"##")):copyToClipBoard(kouling);link="shihuo://www.shihuo.cn?route=convert&navigationBar=false&tl=replace_kl&url=".concat(encodeURIComponent("https://zt-public.shihuo.cn/page/9999/index.html?kl=".concat(kouling,"&device_id=").concat(m_device_id,"&tl=replace_kl")));}if(!shouldRedirect){return;}// 复制口令动作异步执行，后续跳转放在异步回调中
setTimeout(function(){if(isAndroid()){window.location.href=link;}else{var href="https://m.shihuo.cn/api/transit?source=".concat(encodeURIComponent(link),"&target=").concat(encodeURIComponent(downloadUrl));window.location.href=href;}},40);}}// 投放页面安卓下载
function androidDownload(props){var _props$downloadUrl2=props.downloadUrl,downloadUrl=_props$downloadUrl2===void 0?'':_props$downloadUrl2,_props$from2=props.from,from=_props$from2===void 0?'':_props$from2,_props$abTestEnable=props.abTestEnable,abTestEnable=_props$abTestEnable===void 0?'':_props$abTestEnable,_props$legoAb=props.legoAb,legoAb=_props$legoAb===void 0?'':_props$legoAb;if(from!=='kuaishou'){// 非快手（如抖音、B站）投放页下载
window.location.href=downloadUrl;}else{// 快手投放页下载
if(abTestEnable==='否'||abTestEnable==='是'&&legoAb==='B'){window.location.href="vivomarket://details?id=com.hupu.shihuo";// vivo应用商店
window.location.href="oppomarket://details?packagename=com.hupu.shihuo";// oppo应用商店
window.location.href="appmarket://details?id=com.hupu.shihuo";// 华为应用商店
window.location.href="mimarket://details?id=com.hupu.shihuo";// 小米应用商店
window.location.href="samsungapps://ProductDetail/com.hupu.shihuo";// 三星应用商店
window.location.href="mstore://details?package_name=com.hupu.shihuo";// 魅族应用商店
checkOpen(function(){// 跳转应用商店成功
},function(){// 跳转应用商店失败
window.location.href=downloadUrl;},function(){// 跳转应用商店失败
window.location.href=downloadUrl;},1000);}else{window.location.href=downloadUrl;}}}function getIphoneUrl(downloadUrl){var searchString=downloadUrl.split('?')[1]||'';var queryObj={};searchString.split('&').forEach(function(item){var itemObj=item.split('=');queryObj[itemObj[0]]=decodeURIComponent(itemObj[1]);});return queryObj.iphone_url||'';}function getUrlParam(url,paraName){var arrObj=url.split("?");if(arrObj.length>1){var arrPara=arrObj[1].split("&");var arr;for(var i=0;i<arrPara.length;i++){arr=arrPara[i].split("=");if(arr!=null&&arr[0]===paraName){return arr[1];}}return"";}else{return"";}}function removeURLParameter(url,parameter){var urlparts=url.split('?');if(urlparts.length>=2){//参数名前缀
var prefix=encodeURIComponent(parameter)+'=';var pars=urlparts[1].split(/[&;]/g);//循环查找匹配参数
for(var i=pars.length;i-->0;){if(pars[i].lastIndexOf(prefix,0)!==-1){//存在则删除
pars.splice(i,1);}}return urlparts[0]+(pars.length>0?'?'+pars.join('&'):'');}return url;}function getWeightRandom(arr){var total=0;var i,j,percent;//下标标记数组
var index=new Array();for(i=0;i<arr.length;i++){//判断元素的权重，为了实现小数权重，先将所有的值放大100倍
percent="undefined"!=typeof arr[i].percent?parseInt(arr[i].percent*100):0;for(j=0;j<percent;j++){index.push(i);}total+=percent;}//随机数值
var rand=Math.floor(Math.random()*total);return arr[index[rand]];}function getPageId(){if(typeof window==="undefined"){return'';}var pageId;var h5Url=window.location.href;if(h5Url.indexOf('offlineWeb/page')<0){// 正在加载获取页面ID
var splitUrl=window.location.pathname.split('/');if(['lego-api.shihuo.cn','lego-api-tst.shihuo.cn'].indexOf(window.location.host)>=0){pageId=splitUrl[splitUrl.length-4];}else{pageId=splitUrl[splitUrl.length-2];}}else{// 离线包加载获取页面ID
var match=h5Url.match(/page\/(\d+)\/version/);if(match){pageId=match[1];}else{pageId='';}}return pageId;}function toast(){var content=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var time=arguments.length>1&&arguments[1]!==undefined?arguments[1]:3000;// 新增一个toast弹窗
if(typeof window!=='undefined'){var toastEl=document.createElement('div');toastEl.innerText=content;toastEl.classList.add('global-toast');document.body.appendChild(toastEl);setTimeout(function(){toastEl.remove();},time);}}// 获取版本号
function getVersion(){if(typeof window==="undefined"){return'';}var UA=navigator.userAgent,reg=/\s(shihuo\/.*?)\s/;var match=reg.exec(UA),version=match?match[1].split('/')[1]:null;return version;}// 版本号大小比较
function SHDiffVersion(ver1,ver2){if(!ver1||!ver2){return null;}var ver1Arr=ver1.split('.');var ver2Arr=ver2.split('.');var minL=Math.min(ver1Arr.length,ver2Arr.length);var diffRes=0;var i=0;while(i<minL){diffRes=parseInt(ver1Arr[i])-parseInt(ver2Arr[i]);if(diffRes!=0){break;}i++;}return diffRes>=0;}function formatImgUrl(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var webpSupport=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';if(url.indexOf('.webp')>=0){return url;}var formatUrl='';if(webpSupport){if(url.indexOf('.gif')<0){if(type==='card'){formatUrl="".concat(url,"?imageView2/0/w/376/interlace/1/format/webp/avif/ignore-error/1");}else{formatUrl="".concat(url,"?imageView2/0/interlace/1/format/webp/avif/ignore-error/1");}}else{formatUrl=url;}}else{formatUrl="".concat(url,"?imageslim/zlevel/1|imageMogr2/interlace/1/avif/ignore-error/1");}return formatUrl;}// 跳转埋点
function navigateWithTrack(link){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var pageId=arguments.length>2?arguments[2]:undefined;var options=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var ptiOptions=arguments.length>4&&arguments[4]!==undefined?arguments[4]:{};var templatePti=props.templatePti,customAttributes=props.customAttributes,_props$legoAb2=props.legoAb,legoAb=_props$legoAb2===void 0?'':_props$legoAb2,kouling=props.kouling;var tabChName=props.tabChName||window.sessionStorage.getItem('tabChName');var compName=customAttributes["data-component-name"].replace(/pipeline-/,'');var blockName=ptiOptions.blockName?"-".concat(ptiOptions.blockName):"";var from=ptiOptions.from||options.from;var block=ptiOptions.block||options.block;var PtiIDPosition=typeof options.sort==='number'?String(options.sort):null;var sort=options.sort,goods_id=options.goods_id,style_id=options.style_id;var componentBlockArr=customAttributes["data-component-block"].split('-');//TODO biz 的扩展字段
var _ref2=ptiOptions||{},_ref2$bizExtra=_ref2.bizExtra,bizExtra=_ref2$bizExtra===void 0?{}:_ref2$bizExtra;var sceneFields={};var ptiBizOptions=_objectSpread({pageId:pageId,goods_id:goods_id,style_id:style_id,sort:sort,legoAb:legoAb,kouling:kouling,lego_page_id:pageId,component_id:customAttributes['data-component-id'],tabChName:tabChName,ua:navigator.userAgent},bizExtra);var ptiId='',ptiName='';if(!ptiOptions.ptiId){ptiId=!PtiIDPosition?"".concat(templatePti,":").concat(compName).concat(blockName):"".concat(templatePti,":").concat(compName).concat(blockName,":").concat(PtiIDPosition);}else{ptiId=ptiOptions.ptiId;}if(!ptiOptions.ptiName){ptiName=componentBlockArr[componentBlockArr.length-1].split('_')[0];}else{ptiName=ptiOptions.ptiName;}if(templatePti==='lego-inventory'){var urlPieces=link.split('#');var trackStr=decodeURIComponent(urlPieces[1]);if(urlPieces&&urlPieces.length>1&&isJSON(trackStr)){var trackObj=JSON.parse(trackStr);if(trackObj instanceof Object){var _ptiOptions$from=ptiOptions.from,_from2=_ptiOptions$from===void 0?'':_ptiOptions$from,_ptiOptions$block=ptiOptions.block,_block=_ptiOptions$block===void 0?'':_ptiOptions$block;var extra={from:_from2,block:_block};if(trackObj.extra){if(typeof trackObj.extra=='string'&&isJSON(trackObj.extra)){trackObj.extra=JSON.parse(trackObj.extra);}if(trackObj.extra instanceof Object){Object.assign(trackObj.extra,extra);}else{trackObj.extra=extra;}}else{trackObj.extra=extra;}trackObj.extra=JSON.stringify(trackObj.extra);if(trackObj&&trackObj.scene_id){sceneFields['scene_id']=trackObj.scene_id;}link=urlPieces[0]+'#'+encodeURIComponent(JSON.stringify(trackObj));}}}__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default.a.navigateWithTrack({url:link,pageOptions:_objectSpread(_objectSpread(_objectSpread({from:from,block:block,from_sort:PtiIDPosition,legoAb:legoAb,kouling:kouling,lego_page_id:pageId,tabChName:tabChName,ua:navigator.userAgent},ptiOptions),bizExtra),sceneFields),pti:{id:ptiId,name:ptiName,pageId:pageId,biz:JSON.stringify(_objectSpread(_objectSpread({},ptiBizOptions),sceneFields)),pageOptions:_objectSpread({lego_page_id:pageId,tabChName:tabChName,legoAb:legoAb,kouling:kouling},bizExtra)}});}// 点击埋点
function uploadTrack(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var ptiOptions=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var _props$kouling2=props.kouling,kouling=_props$kouling2===void 0?'':_props$kouling2,_props$source=props.source,source=_props$source===void 0?'':_props$source;var templatePti=props.templatePti;var tabChName=props.tabChName||window.sessionStorage.getItem('tabChName');var legoAb=props.legoAb;var compName=props.customAttributes["data-component-name"].replace(/pipeline-/,'');var blockName=ptiOptions.blockName?"-".concat(ptiOptions.blockName):"";var ptiIdPosition=typeof options.sort==='number'?String(options.sort):null;var componentBlockArr=props.customAttributes["data-component-block"].split('-');//TODO biz 的扩展字段
var _ref3=ptiOptions||{},_ref3$bizExtra=_ref3.bizExtra,bizExtra=_ref3$bizExtra===void 0?{}:_ref3$bizExtra;var pageOptions=_objectSpread({legoAb:legoAb,lego_page_id:getPageId(),component_id:props.customAttributes['data-component-id'],tabChName:tabChName,ua:navigator.userAgent,kouling:kouling,source:source},bizExtra);var ptiId='',ptiName='';if(!ptiOptions.ptiId){ptiId="".concat(templatePti,":").concat(compName).concat(blockName).concat(ptiIdPosition?':'+ptiIdPosition:'');}else{ptiId=ptiOptions.ptiId;}if(!ptiOptions.ptiName){ptiName=componentBlockArr[componentBlockArr.length-1].split('_')[0];}else{ptiName=ptiOptions.ptiName;}__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:ptiId,name:ptiName,biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}// 曝光埋点字段信息
function getExposureData(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var ptiOptions=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var pageId=getPageId();var templatePti=props.templatePti,customAttributes=props.customAttributes,_props$legoAb3=props.legoAb,legoAb=_props$legoAb3===void 0?'':_props$legoAb3,kouling=props.kouling;var tabChName=props.tabChName||window.sessionStorage.getItem('tabChName');var compName=customAttributes["data-component-name"].replace(/pipeline-/,'');var blockName=ptiOptions.blockName?"-".concat(ptiOptions.blockName):"";var PtiIDPosition=typeof options.sort==='number'?String(options.sort):null;var sort=options.sort,goods_id=options.goods_id,style_id=options.style_id;var componentBlockArr=customAttributes["data-component-block"].split('-');//TODO biz 的扩展字段
var _ref4=ptiOptions||{},_ref4$bizExtra=_ref4.bizExtra,bizExtra=_ref4$bizExtra===void 0?{}:_ref4$bizExtra;var biz=_objectSpread({pageId:pageId,goods_id:goods_id,style_id:style_id,sort:sort,legoAb:legoAb,kouling:kouling,lego_page_id:pageId,component_id:customAttributes['data-component-id'],tabChName:tabChName,ua:navigator.userAgent},bizExtra);var ptiId='',ptiName='';if(!ptiOptions.ptiId){ptiId=!PtiIDPosition?"".concat(templatePti,":").concat(compName).concat(blockName):"".concat(templatePti,":").concat(compName).concat(blockName,":").concat(PtiIDPosition);}else{ptiId=ptiOptions.ptiId;}if(!ptiOptions.ptiName){ptiName=componentBlockArr[componentBlockArr.length-1].split('_')[0];}else{ptiName=ptiOptions.ptiName;}return{id:ptiId,name:'',biz:JSON.stringify(biz),exposekey:ptiId};}// 获取识货App商详页路由参数
function getGoodsDetailRouteParams(url){var routeUrl=url.split('#')[0];var routeParams={};if(routeUrl.indexOf('?route=goodsDetail')>=0){var query=routeUrl.split('?')[1];query=query.split('&');for(var i=0;i<query.length;i++){var q=query[i].split('=');if(q.length===2&&q[0]!=='route'){routeParams[q[0]]=q[1];}}}return routeParams;}// 将识货App商详页路由转成华为H5商详页地址
function formatRouteToH5(url){if(url.indexOf('shihuo://www.shihuo.cn?route=goodsDetail')>=0){var routeParams=getGoodsDetailRouteParams(url);var _routeParams$detailRo=routeParams.detailRouteType,detailRouteType=_routeParams$detailRo===void 0?'':_routeParams$detailRo,_routeParams$id=routeParams.id,id=_routeParams$id===void 0?'':_routeParams$id,_routeParams$styleId=routeParams.styleId,styleId=_routeParams$styleId===void 0?'':_routeParams$styleId;var h5Url="https://m.shihuo.cn/app/assets/h5app/SkuDetail.html?detail_route_type=".concat(detailRouteType,"&goods_id=").concat(id,"&style_id=").concat(styleId);return h5Url;}else{return url;}}// 将组件尺寸发送消息给后台编辑器
function postComponentSizeToEditor(){if(typeof window!=='undefined'&&window.parent&&iframe){try{window.onload=function(){setTimeout(function(){var pipelineSize=SyncComponentsSize(null,[]);console.log('获取组件宽高发送给后台编辑器',pipelineSize);window.parent.postMessage&&window.parent.postMessage({msgType:'pageLoadComplete',pipelineSize:pipelineSize},'*');postPictureSizes();},2000);};}catch(err){console.log(err);}}}// 同步组件尺寸配置（主要针对页面里同步渲染的组件，不包含通过异步获取数据再渲染的组件）
function SyncComponentsSize(targetNote){var pipelineSize=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var windowHeight=window.innerHeight||document.documentElement.clientHeight;var targetNoteChilds=null;if(!targetNote){var iFrameRoot=document.querySelector('#root');var iFrameRootApp=iFrameRoot&&iFrameRoot.children[0];targetNoteChilds=iFrameRootApp&&iFrameRootApp.childNodes;}else{targetNoteChilds=targetNote.childNodes;}if(!targetNoteChilds||targetNoteChilds&&targetNoteChilds.length<=0){return;}for(var index=0;index<targetNoteChilds.length;index++){var pipelineTarget=targetNoteChilds[index].getAttribute('data-component-id')?targetNoteChilds[index]:targetNoteChilds[index].childNodes&&targetNoteChilds[index].childNodes[0];if(pipelineTarget){var componentName=pipelineTarget.getAttribute('data-component-name');var componentId=pipelineTarget.getAttribute('data-component-id');var childNoteSizeList=[];var adaptNoteSize={};if(['pipeline-imgList','pipeline-imgHotMap','pipeline-product','pipeline-productLayout3','pipeline-rank'].indexOf(componentName)>=0){childNoteSizeList=getAllImageContainNote(componentName,pipelineTarget);adaptNoteSize=getCompAdaptNodeSize(componentName,pipelineTarget);}if(componentId&&componentId.indexOf('pipeline-tab-')>=0){var tabNav=pipelineTarget.querySelector('.tab-nav');var tabContent=pipelineTarget.querySelector('.tab-content');if(tabNav){// 将Tab组件中Tab切换栏的尺寸进行记录保存
var pipelineComps={id:componentId,size:{width:String(getStyle(tabNav,'width')),height:String(getStyle(tabNav,'height')),delayLoad:tabNav.offsetTop>windowHeight?true:false// 标记非首屏的组件，用于延迟加载
},childNoteSizeList:childNoteSizeList,adaptNoteSize:adaptNoteSize};pipelineSize.push(pipelineComps);}if(tabContent){for(var _index=0;_index<tabContent.childNodes.length;_index++){var _targetNote=tabContent.childNodes[_index];SyncComponentsSize(_targetNote,pipelineSize);}}}else{pipelineTarget.style.minHeight=0;// 每次页面渲染完成后，先将渲染后组件minHeight置为0，防止后续获取组件高度时获取的是上一次的minHeight高度
var _pipelineComps={id:componentId,size:{width:String(getStyle(pipelineTarget,'width')),height:String(getStyle(pipelineTarget,'height')),delayLoad:pipelineTarget.offsetTop>windowHeight?true:false// 标记非首屏的组件，用于延迟加载
},childNoteSizeList:childNoteSizeList,adaptNoteSize:adaptNoteSize};pipelineSize.push(_pipelineComps);// 遍历拿到页面中的组件及组件尺寸 
}}}return pipelineSize;}// 同步组件尺寸配置（主要针对异步获取完数据再渲染的组件）
function SyncComponentsSizeAsync(pipelineTarget){if(pipelineTarget){pipelineTarget.style.minHeight=0;// 每次页面渲染完成后，先将渲染后组件minHeight置为0，防止后续获取组件高度时获取的是上一次的minHeight高度
var windowHeight=window.innerHeight||document.documentElement.clientHeight;var componentId=pipelineTarget.getAttribute('data-component-id');var pipelineSize={id:componentId,size:{width:String(getStyle(pipelineTarget,'width')),height:String(getStyle(pipelineTarget,'height')),delayLoad:pipelineTarget.offsetTop>windowHeight?true:false// 标记非首屏的组件，用于延迟加载
}};console.log('异步加载的组件尺寸',pipelineSize);window.parent.postMessage&&window.parent.postMessage({msgType:'componentLoadComplete',pipelineSize:pipelineSize},'*');}}// 获取图片组件和热区组件中所有图片容器节点
function getAllImageContainNote(componentName,parentNode){var allImageNotes=null,childNoteSizeList=[];if(componentName==='pipeline-imgList'){allImageNotes=parentNode.querySelectorAll('.img-item');}if(allImageNotes&&allImageNotes.length>0){for(var index=0;index<allImageNotes.length;index++){var childNote=allImageNotes[index];if(childNote){var childNoteImg=childNote.querySelector('img');if(childNoteImg){var childNoteSize={width:String(getStyle(childNoteImg,'width')),height:String(getStyle(childNoteImg,'height'))};childNoteSizeList.push(childNoteSize);}}}}return childNoteSizeList;}// 获取组件中自适应元素节点的尺寸
function getCompAdaptNodeSize(componentName,componentNode){var adaptNodeSize={};if(componentName==='pipeline-product'){var imageTitle=componentNode.querySelector('.title-image')||componentNode.querySelector('.product-banner');if(imageTitle){var titleImageSize={width:String(getStyle(imageTitle,'width')),height:String(getStyle(imageTitle,'height'))};adaptNodeSize['titleImageSize']=titleImageSize;}else{adaptNodeSize['titleImageSize']={width:'',height:''};}}else if(componentName==='pipeline-productLayout3'){// 商品组件一行三里，图片标题和图片Tab是自适应高度的元素，需要预取这两个元素的渲染高度
var _imageTitle=componentNode.querySelector('.title-image');var imageTab=componentNode.querySelector('.image-tab');if(_imageTitle){var _titleImageSize={width:String(getStyle(_imageTitle,'width')),height:String(getStyle(_imageTitle,'height'))};adaptNodeSize['titleImageSize']=_titleImageSize;}else{adaptNodeSize['titleImageSize']={width:'',height:''};}if(imageTab){var tabSize={width:String(getStyle(imageTab,'width')),height:String(getStyle(imageTab,'height'))};adaptNodeSize['tabSize']=tabSize;}else{adaptNodeSize['tabSize']={width:'',height:''};}}else if(componentName==='pipeline-rank'){var rankProductLayoutMore=componentNode.querySelector('.rank-product-layout-more');if(rankProductLayoutMore){var _imageTitle2=componentNode.querySelector('.title-image');if(_imageTitle2){var _titleImageSize2={width:String(getStyle(_imageTitle2,'width')),height:String(getStyle(_imageTitle2,'height'))};adaptNodeSize['titleImageSize']=_titleImageSize2;}else{adaptNodeSize['titleImageSize']={width:'',height:''};}}}return adaptNodeSize;}function getStyle(dom,attr){// 该方式对设置了display:none的元素不生效
var result=dom.currentStyle?dom.currentStyle[attr]:getComputedStyle(dom,false)[attr];return result.replace(/px/,'');}// 获取DOM节点预渲染的骨架尺寸
function getAdaptImageSize(){var size=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var width='100%',height='auto';if(!iframe&&size){width=size.width?Object(__WEBPACK_IMPORTED_MODULE_39__px2rem__["a" /* default */])("".concat(size.width,"px")):'100%';height=size.height?Object(__WEBPACK_IMPORTED_MODULE_39__px2rem__["a" /* default */])("".concat(size.height,"px")):'auto';}return{width:width,height:height};}function formatTimestampToDate(data){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'date';var time=new Date(data);var year=time.getFullYear();var month=time.getMonth()+1;var day=time.getDate();var hour=time.getHours();var min=time.getMinutes();var sec=time.getSeconds();//自定义选择想要返回的类型
if(type==="date"){return"".concat(year,"-").concat(month,"-").concat(day);}else{return"".concat(year,"-").concat(month,"-").concat(day," ").concat(hour,":").concat(min,":").concat(sec);}}var postPictureSizes=function postPictureSizes(){var androidDpi=1080;var multiple=androidDpi/375;var pictureSizes=0,pictures=0;// 获取所有的img标签，并计算其占用内存的大小（这里无法获取使用了懒加载的图片元素）
Object.values(document.getElementsByTagName('img')).forEach(function(item){var imageSize=item.clientWidth*multiple*(item.clientHeight*multiple)*4;pictures++;pictureSizes+=imageSize;});// 获取所有的懒加载图片元素，并计算其占用内存的大小
Object.values(document.getElementsByClassName('lazy-load-placeholder')).forEach(function(item){var imageSize=item.clientWidth*multiple*(item.clientHeight*multiple)*4;pictures++;pictureSizes+=imageSize;});pictureSizes="".concat(parseFloat((pictureSizes/(1024*1024)).toFixed(2)),"MB");console.log("window.onload\u540E \u4E00\u5171\u83B7\u53D6\u5230".concat(pictures,"\u5F20\u56FE\u7247\uFF0C\u5360\u7528\u5185\u5B58").concat(pictureSizes));window.parent.postMessage&&window.parent.postMessage({msgType:'setPictureSizes',pictureSizes:pictureSizes},'*');};var hidden;var visibilityChange;function getSupportedProperty(){if(typeof document==='undefined')return;if(typeof document.hidden!=='undefined'){// Opera 12.10 and Firefox 18 and later support
hidden='hidden';visibilityChange='visibilitychange';}else if(typeof document.msHidden!=='undefined'){hidden='msHidden';visibilityChange='msvisibilitychange';}else if(typeof document.webkitHidden!=='undefined'){hidden='webkitHidden';visibilityChange='webkitvisibilitychange';}}getSupportedProperty();/**
 * 判断页面是否隐藏（进入后台）
 */function isPageHidden(){if(typeof hidden==='undefined')return false;return document[hidden];}/**
 * hack 检测是否唤端成功
 * 原理见： https://developer.mozilla.org/zh-CN/docs/Web/API/Page_Visibility_API
 * @param failure - 唤端失败回调函数
 * @param success - 唤端成功回调函数
 * @param error - 唤端异常函数
 * @param timeout - hack 失败检测延时 - 一般会触发下载
 */function checkOpen(){var success=arguments.length>0&&arguments[0]!==undefined?arguments[0]:function(){};var failure=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};var error=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};var timeout=arguments.length>3&&arguments[3]!==undefined?arguments[3]:1500;var haveChanged=false;var pageChange=function pageChange(e){haveChanged=true;if(document.hidden||e.hidden||document.visibilityState=='hidden'){success();}else{error();}// window.addEventListener('pagehide', pageChange, false);
document.removeEventListener(visibilityChange,pageChange,false);};var timer=setTimeout(function(){clearTimeout(timer);if(haveChanged){return;}// window.addEventListener('pagehide', pageChange, false);
document.removeEventListener(visibilityChange,pageChange,false);// 判断页面是否隐藏（进入后台）
var pageHidden=isPageHidden();if(!pageHidden){failure();}else{error();}haveChanged=true;},timeout);// window.addEventListener('pagehide', pageChange, false);
document.addEventListener(visibilityChange,pageChange,false);}// 页面隐藏/关闭时，页面停留时长埋点上报，未防止漏报，同时存储埋点相关参数
function pageStayUpload(templatePti,pageOptions){var pageId=getPageId();if(pageId){// 停留时长埋点
localStorage.setItem('stayPage',pageId);localStorage.setItem('stayEnd',String(new Date().getTime()));localStorage.setItem('pageOptions',JSON.stringify(pageOptions));var stayStart=localStorage.getItem('stayStart')?Number(localStorage.getItem('stayStart')):null;var stayEnd=new Date().getTime();if(stayStart){var duration=stayEnd-stayStart;if(duration>0){Object.assign(pageOptions,{duration:duration});__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:"".concat(templatePti,":timeStatistics"),biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}}// 浏览深度埋点上报
var currentDeep=getCurrentDepth();var totalDeep=getTotalDepth();localStorage.setItem('browseDeepPage',pageId);localStorage.setItem('browseTotalDeep',totalDeep);localStorage.setItem('browseCurrentDeep',currentDeep);Object.assign(pageOptions,{total_deep:totalDeep,currently_deep:currentDeep,lego_page_id:pageId,tabChName:'',legoAb:'',model_block:'',kouling:'',ua:navigator.userAgent});__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:"".concat(templatePti,":browseDeep:"),biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}}// 页面停留时长监听及埋点上报
function pageStayTrack(templatePti,pageOptions){if(typeof window==="undefined"){return true;}var pageId=getPageId();var stayPage=localStorage.getItem('stayPage');var stayEnd=localStorage.getItem('stayEnd');var stayStart=localStorage.getItem('stayStart');var pageOptionsLocal=localStorage.getItem('pageOptions');if(stayPage&&stayEnd&&stayStart){if(stayPage!=pageId){pageOptions=pageOptionsLocal?JSON.parse(pageOptionsLocal):{};}var duration=Number(stayEnd)-Number(stayStart);if(duration>0){Object.assign(pageOptions,{duration:duration});__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:"".concat(templatePti,":timeStatistics"),biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}localStorage.removeItem('stayPage');localStorage.removeItem('stayEnd');localStorage.removeItem('pageOptions');}var browseDeepPage=localStorage.getItem('browseDeepPage')||'';var browseTotalDeep=localStorage.getItem('browseTotalDeep')||'';var browseCurrentDeep=localStorage.getItem('browseCurrentDeep')||'';if(browseDeepPage&&(browseTotalDeep||browseCurrentDeep)){if(browseDeepPage!=pageId){pageOptions=pageOptionsLocal?JSON.parse(pageOptionsLocal):{};}Object.assign(pageOptions,{total_deep:browseTotalDeep,currently_deep:browseCurrentDeep,lego_page_id:pageId,tabChName:'',legoAb:'',model_block:'',kouling:'',ua:navigator.userAgent});__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:"".concat(templatePti,":browseDeep:"),biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});localStorage.removeItem('browseDeepPage');localStorage.removeItem('browseTotalDeep');localStorage.removeItem('browseCurrentDeep');}localStorage.setItem('stayStart',String(new Date().getTime()));window.addEventListener('beforeunload',function(){pageStayUpload(templatePti,pageOptions);});if(getParams('community_tab')!='1'){// 基于页面可见性API，在页面可见时记录停留开始时间，在页面隐藏时计算停留时长，进行埋点上报
document.addEventListener('visibilitychange',function(event){if(document.hidden){// 页面隐藏时，计算停留时长，并进行埋点上报
pageStayUpload(templatePti,pageOptions);}else{// 页面可见时，重置页面停留开始时间
localStorage.setItem('stayStart',String(new Date().getTime()));}});}}// 数组指定范围随机
function arrayRangeRandom(array,n){// 判断数组长度是否小于等于N，如果是则返回原数组
if(array.length<n){return array;}// 复制数组的前N项到一个新数组
var firstN=array.slice(0,n);// 对新数组进行随机排序
for(var i=firstN.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var temp=firstN[i];firstN[i]=firstN[j];firstN[j]=temp;}// 将新数组的排序结果与原数组的剩余项进行合并
var result=firstN.concat(array.slice(n));return result;}function richTextToPlainText(richText){// 创建一个空的 DOM 元素 
var el=document.createElement('div');// 将富文本字符串设置为元素的 innerHTML 
el.innerHTML=richText;// 返回元素的文本内容 
return el.textContent;}function getOptionImageSize(imageUrl){var widthRange=arguments.length>1&&arguments[1]!==undefined?arguments[1]:100;if(scene==='shihuoApp'){return{width:"".concat(widthRange||100,"%"),height:'auto'};}else{return{width:"100px",height:'auto'};}}/**
 * 获取富文本中的img标签，并根据指定规则设置img的宽高，最后返回富文本
 */function processImageTagImg(richText){if(scene==='shihuoApp'){return richText.replace(/<img[^>]+src=["']([^"']*?)_([0-9]+)x([0-9]+)\.[^"']+["'][^>]*>/g,function(match,src,width,height){if(width&&height){var imageW=width/3;var imageH=height/3;if(imageW<335&&imageH<335){// 原始宽高除以3后均小于335
return match.replace(/<img/,"<img width=\"".concat(imageW,"\" height=\"").concat(imageH,"\""));}else if(imageW>335||imageH>335){// 原始宽高除以3后，其中任意一边大于335
if(imageW>imageH){// 宽高比大于1
return match.replace(/<img/,"<img width=\"".concat(335,"\" height=\"auto\""));}else if(imageW<imageH){// 宽高比小于1
return match.replace(/<img/,"<img width=\"auto\" height=\"".concat(335,"\""));}else{// 宽高比等于1
return match.replace(/<img/,"<img width=\"".concat(335,"\" height=\"",335,"\""));}}}});}else{return richText.replace(/<img\s+[^>]*src="([^"]+)"[^>]*>/g,function(match,src){var newSrc=formatImgUrl(src,true);return match.replace(src,newSrc);});}}// 指定范围内的img标签添加大图预览
function onImageClickEvent(target){var white_list=['static.shihuocdn.cn/admin/files/20230712/bd166bc8497abec9a9cbcad38e59ca4f.png','static.shihuocdn.cn/admin/files/20230712/36fda26aabba8e475eb09aaf2d9ffaa0.png','static.shihuocdn.cn/admin/files/20230712/2d3a4bad8b873a139c64c12fb0c96e18.png','static.shihuocdn.cn/admin/files/20230712/22f2760d4489589b8173dc2ce0dadf45.png','static.shihuocdn.cn/admin/files/20230518/c5266c4d31d322f93a8d42203071e61c.png','static.shihuocdn.cn/admin/files/20260114/dd63cd5c0240f5ba2354f560b0ca3e82.png','static.shihuocdn.cn/admin/files/20260113/bbe658291688880d03e8cfc67ff57057.png','static.shihuocdn.cn/admin/files/20260114/f7d9ed3663b648bb761f3c9b5c708aea.png','static.shihuocdn.cn/admin/files/20260114/38ba8767a4edecad5e52574e33412eb0.png','static.shihuocdn.cn/admin/files/20260114/73a09312864a07596478e82b9f7da5c9.png','static.shihuocdn.cn/admin/files/20260114/d57e8ccd37021c402b547f05985bcba4.png','static.shihuocdn.cn/admin/files/20260114/faab925cd1463ad8e28cc487784aa397.png','static.shihuocdn.cn/admin/files/20260114/8524b1b27907d09790fa1d7ed9670f8b.png','static.shihuocdn.cn/admin/files/20260114/4eabfdd4a285974d4fa2bd9fcbfe2415.png','static.shihuocdn.cn/admin/files/20260114/23f095a9a548c4fc0c3587ff23f90ed0.png','static.shihuocdn.cn/admin/files/20260114/52e055a88afefd183f5f0e8a843f5edf.png','static.shihuocdn.cn/admin/files/20260114/5e9f069ed3b4256250b4ffbf18978d1f.png','static.shihuocdn.cn/admin/files/20260129/32bd1454f01a6f2b81ec60ec32f054dd.png'];var allImgsTag=target&&target.querySelectorAll('img');// 遍历每个 img 标签并添加点击事件监听器  
if(allImgsTag&&allImgsTag.length>0){allImgsTag.forEach(function(item){if(item&&!item.hasAttribute('preview')){item.setAttribute('preview',true);var disabled=item.getAttribute('class')&&item.getAttribute('class').includes('禁用');if(!disabled&&!white_list.includes(item.src.replace(/^(https?:\/\/)/,''))){// class没有设置disabled  且不在白名单范围内的图片，绑定点击事件
item.addEventListener('click',function(){if(isShihuo()){window.Jockey.send('images',{index:'1',list:[item.src]});}else{if(scene==='parttimePlatform'){// 兼职平台场景的问卷，点击图片大图预览
imagePreviewPC(item.src);}else{window.open(item.src);}}});}}});}}// 富文本标签图片大图预览
function imagePreviewPC(imgUrl){// 创建蒙层和图片元素  
var overlay=document.createElement('div');var preview=document.createElement('img');var close=document.createElement('img');// 设定蒙层的样式  
overlay.style.position='fixed';overlay.style.top='0';overlay.style.left='0';overlay.style.width='100%';overlay.style.height='100%';overlay.style.backgroundColor='rgba(0, 0, 0, 0.85)';overlay.style.display='flex';overlay.style.justifyContent='center';overlay.style.alignItems='center';overlay.style.zIndex='99999';// 确保蒙层在最上面 
overlay.style.cursor='pointer';// 设定大图的样式  
preview.style.maxWidth='90%';preview.style.maxHeight='90%';preview.style.cursor='pointer';// 设置关闭按钮样式
close.style.position='absolute';close.style.top='24px';close.style.right='24px';close.style.width='24px';close.style.height='24px';close.style.cursor='pointer';// 将蒙层和大图添加到文档中  
overlay.appendChild(preview);overlay.appendChild(close);document.body.appendChild(overlay);preview.src=imgUrl;close.src='https://sh1.shihuocdn.cn/images/bargain/close.png';overlay.style.display='flex';// 点击蒙层隐藏大图和蒙层  
overlay.addEventListener('click',setOverlayState);preview.addEventListener('click',setOverlayState);close.addEventListener('click',setOverlayState);function setOverlayState(){overlay.removeEventListener('click',setOverlayState);preview.removeEventListener('click',setOverlayState);close.removeEventListener('click',setOverlayState);document.body.removeChild(overlay);}}/**
 * 主要用来获取页面里所有超链，并判断超链是否为图片，若为图片则给图片添加大图预览功能
 */function processImageTagA(){// 获取所有的 a 标签
var allTagA=document.querySelectorAll('a');if(allTagA&&allTagA.length>0){var imageRegex=/\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i;allTagA.forEach(function(tagA){var href=tagA.getAttribute('href');if(href&&imageRegex.test(href)){var bindEvent=tagA.getAttribute('bindEvent');if(!bindEvent){tagA.setAttribute('bindEvent',true);tagA.onclick=function(event){event.preventDefault();// 阻止默认的点击行为  
if(isShihuo()&&typeof window!=='undefined'){window.Jockey.send('images',{index:'1',list:[href]});}else{window.open(href);}};}}});}}function hexColorToRgba(hexColor,opacity){if(!hexColor){return'';}var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}/**
 * 主要用来价格截断,不用四舍五入,且返回是否需要显示万位价格,已把小数截取,返回数组
 * @param {*} baseNum 数
 * @param {*} decimals 截取的位数
 * @param {*} unit 需要达到的标准数
 * @returns 
 */function truncateDecimals(baseNum,decimals){var unit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10000;if(baseNum&&unit&&baseNum*1>=unit){var regEx=new RegExp("(\\d+\\.\\d{"+decimals+"})");var num=baseNum/unit;var matches=num.toString().match(regEx);matches=matches?parseFloat(matches[1]):num.valueOf();return matches.toString().split('.');}return[];}/**
 * 主要用来价格截断,不用四舍五入,且返回是否需要显示万位价格,已把小数截取,返回对象
 * @param {*} baseNum 数
 * @param {*} decimals 截取的位数
 * @param {*} unit 需要达到的标准数
 * @returns 
 */function priceConversion(baseNum,decimals){var unit=1;//千位小数位需要缩小
if(baseNum>=10000&&baseNum<100000000){unit=10000;}else if(baseNum>=100000000){unit=100000000;}if(baseNum&&unit&&baseNum*1>=unit){var regEx=new RegExp("(\\d+\\.\\d{"+decimals+"})");var num=baseNum/unit;var matches=num.toString().match(regEx);matches=matches?parseFloat(matches[1]):num.valueOf();var list=matches.toString().split('.');var unitStr='';if(baseNum>=10000&&baseNum<100000000){unitStr='万';}else if(baseNum>=100000000){unitStr='亿';}return{list:list,unit:unitStr};}return null;}/**
 * 是否可以显示右边原价格
 * @param {*} priceLength 价格长度
 * @param {*} originalPrice 原价
 * @param {*} unit 显示的长度标准
 * @returns 
 */function showRightPrice(priceLength,originalPrice){var unit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:8;var length=originalPrice?originalPrice.toString().length:0;return priceLength+length<=unit;}// 获取沉浸式导航栏的高度和内边距
function getNavigationBarInfo(){var navigationBarPaddingTop=0,navigationBarHeight=0;if(SHDiffVersion(getVersion(),'6.84.0')){navigationBarPaddingTop=isIphoneX()?44:isAndroid()?43:20;if(isIphone14ProMax()){navigationBarPaddingTop=statusBarHeight||54;}if(__WEBPACK_IMPORTED_MODULE_40_react_device_detect__["isTablet"]){navigationBarPaddingTop=24;}}else{navigationBarPaddingTop=isIphoneX()?44:isAndroid()?0:20;if(isIphone14ProMax()){navigationBarPaddingTop=statusBarHeight||54;}if(__WEBPACK_IMPORTED_MODULE_40_react_device_detect__["isTablet"]){navigationBarPaddingTop=60;}}if(__WEBPACK_IMPORTED_MODULE_40_react_device_detect__["isTablet"]){navigationBarHeight=innerWidth>600?40:60;}else{navigationBarHeight=isAndroid()?42:48;}navigationBarHeight=navigationBarHeight+navigationBarPaddingTop;return{navigationBarPaddingTop:navigationBarPaddingTop,navigationBarHeight:navigationBarHeight};}function loadWeixinJsSdk(){return new Promise(function(resolve,reject){var script=document.createElement('script');script.type='text/javascript';script.src='//sh1.shihuocdn.cn/js/lib/weixinJsSdk.js';script.onload=function(){resolve();};script.onerror=function(){reject(new Error('加载callAppLib.js失败'));};document.head.appendChild(script);});}function judgeIsTabletDevice(){return isTabletDevice;}/**
 * 图片转webp&缩略图压缩
 * @param url：原始图片链接
 * @param w：控件的长边，单位为物理点，不传默认给600；传小于0，则修正为0，则仅转webp，图片清晰度不会有任何缩减，适用于一些设计给的小图标签或者大图看细节场景（banner|图片浏览）
 * @param keepOn: 是否需要保持原图
 * @param preload: 如果需要配合客户端资源预加载逻辑，则传true。此时客户端会自动resize到屏幕宽度
 * @param quality: 图片质量 需要配合 keepOn = true 
 * @return 转换之后的链接
 */function shortImageSize(url,w,keepOn){var preload=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var quality=arguments.length>4&&arguments[4]!==undefined?arguments[4]:90;if(!url){return'';}if(!w){w=600;}else if(w<0){w=0;}// 取整
w=parseInt(+w);// 命中部分格式或者后端添加的标识则不会进行转换
var notConverts=['.gif','.webp','#keepOn'];for(var _index2=0;_index2<notConverts.length;_index2++){var element=notConverts[_index2];var targetIndex=url.indexOf(element);if(targetIndex>-1){return url;}}var index=url.indexOf('?');if(index>-1){// 有参数就先截掉
url=url.substring(0,index);}if(url.search('qiniu.dewucdn.com')!=-1){return url+="?imageView2/2/w/".concat(w,"#keepOn");}else if(url.search('cdn.poizon.com')!=-1){return url+="?x-oss-process=image/resize,h_".concat(w,",m_lfit#keepOn");}if(preload){url+="?imageView2/0/w/".concat(w,"/format/webp/q/").concat(quality,"#preload");}else{url+="?imageView2/0/w/".concat(w,"/format/webp/q/").concat(quality).concat(keepOn?'#keepOn':'');}return url;}/**
 * 
 * @param {} price 
 * @returns  { symbol, mainPrice, dotPrice, unitPrice }
 */function handlePrice(price){var showZeroPrice=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;price+='';var symbol='¥';var mainPrice='';var dotPrice='';var unitPrice='';if(price.length<=0||price==='--'||price==='0'&&!showZeroPrice){mainPrice='--';}else if(price.indexOf('.')>-1){var prices=price.split('.');mainPrice=prices[0];var lastPrice=prices[1];var index=lastPrice.indexOf('亿');var wanIndex=lastPrice.indexOf('万');if(wanIndex>-1&&index<0){index=wanIndex;}var qiIndex=lastPrice.indexOf('起');if(qiIndex>-1&&index<0){index=qiIndex;}if(index>-1){unitPrice=lastPrice.substring(index);dotPrice='.'+lastPrice.substring(0,index);}else{dotPrice='.'+lastPrice;}}else{var _index3=price.indexOf('亿');var _wanIndex=price.indexOf('万');if(_wanIndex>-1&&_index3<0){_index3=_wanIndex;}var _qiIndex=price.indexOf('起');if(_qiIndex>-1&&_index3<0){_index3=_qiIndex;}if(_index3>-1){unitPrice=price.substring(_index3);mainPrice=price.substring(0,_index3);}else{mainPrice=price;}}return{symbol:symbol,mainPrice:mainPrice,dotPrice:dotPrice,unitPrice:unitPrice};}// 获取推荐信息流需要过滤掉的商品
function getRecommendFilterIds(){var templateComponents=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(!templateComponents||templateComponents.length===0){return[];}var filter_ids=[];templateComponents.forEach(function(item,index){var ids=[];if(item.name==='pipeline-product'){// 获取商品组件所有商品id
ids=item.data.itemList.map(function(val){return val.id;});}else if(item.name==='pipeline-productGather'){// 商品集合组件
ids=item.data.itemList.map(function(val){return val.id;});}else if(item.name==='pipeline-productLayout3'){// 商品组件一行三
var _item$data=item.data,_item$data$tabConfig=_item$data.tabConfig,tabConfig=_item$data$tabConfig===void 0?{}:_item$data$tabConfig,_item$data$itemList=_item$data.itemList,itemList=_item$data$itemList===void 0?[]:_item$data$itemList,_item$data$tabList=_item$data.tabList,tabList=_item$data$tabList===void 0?[]:_item$data$tabList;if(tabConfig.tabType==='无Tab'){ids=itemList.map(function(val){return val.id;});}else{tabList.forEach(function(tabItem){if(tabItem&&tabItem.itemList){var _ids;var itemsIds=tabItem.itemList.map(function(val){return val.id;});(_ids=ids).push.apply(_ids,_toConsumableArray(itemsIds));}});}}if(ids.length>0){filter_ids.push({ids:ids});}});return filter_ids;}// 获取页面浏览深度
function getCurrentDepth(){if(typeof window==='undefined')return 0;// 兼容获取滚动高度
var scrollTop=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0;// 获取视口高度
var clientHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight||0;// 计算浏览深度（当前滚动高度 + 视口高度）
var scrollDepth=scrollTop+clientHeight;// 计算屏幕数（向上取整）
if(clientHeight>0){return parseFloat((scrollDepth/clientHeight).toFixed(1));}return 0;}// 更新最大深度
function updateMaxDepth(){var currentDepth=getCurrentDepth();if(currentDepth>maxScrollDepth){maxScrollDepth=currentDepth;}}// 监听滚动事件更新最大深度
if(typeof window!=='undefined'){// 初始化计算一次
updateMaxDepth();// 监听滚动，使用防抖机制，只在滚动停止时更新
var scrollTimer=null;window.addEventListener('scroll',function(){if(scrollTimer){clearTimeout(scrollTimer);}scrollTimer=setTimeout(function(){updateMaxDepth();},200);});}// 获取页面浏览深度（返回历史最大深度）
function getTotalDepth(){// 获取时再次尝试更新，确保是最新值
updateMaxDepth();return maxScrollDepth;}/* harmony default export */ __webpack_exports__["a"] = ({getNativeInfo:getNativeInfo,isAndroid:isAndroid,isHarmonyOS:isHarmonyOS,isHuPuAPP:isHuPuAPP,parseToken:parseToken,isShihuo:isShihuo,getParams:getParams,getUrlParams:getUrlParams,getQueryString:getQueryString,getCookie:getCookie,convertHref:convertHref,copyToClipBoard:copyToClipBoard,parseQueryStringParams:parseQueryStringParams,isIphoneX:isIphoneX,isIphone14ProMax:isIphone14ProMax,getTPExtra:getTPExtra,formatTPExtraData:formatTPExtraData,jumpToUrl:jumpToUrl,getDeviceInfo:getDeviceInfo,asyncForEach:asyncForEach,getWeightRandom:getWeightRandom,handleToufangClick:handleToufangClick,getPageId:getPageId,toast:toast,getVersion:getVersion,SHDiffVersion:SHDiffVersion,formatImgUrl:formatImgUrl,uploadTrack:uploadTrack,getExposureData:getExposureData,postComponentSizeToEditor:postComponentSizeToEditor,formatTimestampToDate:formatTimestampToDate,checkOpen:checkOpen,pageStayTrack:pageStayTrack,pageStayUpload:pageStayUpload,SyncComponentsSizeAsync:SyncComponentsSizeAsync,arrayRangeRandom:arrayRangeRandom,richTextToPlainText:richTextToPlainText,getOptionImageSize:getOptionImageSize,processImageTagImg:processImageTagImg,processImageTagA:processImageTagA,onImageClickEvent:onImageClickEvent,hexColorToRgba:hexColorToRgba,truncateDecimals:truncateDecimals,showRightPrice:showRightPrice,priceConversion:priceConversion,getAdaptImageSize:getAdaptImageSize,getNavigationBarInfo:getNavigationBarInfo,loadWeixinJsSdk:loadWeixinJsSdk,judgeIsTabletDevice:judgeIsTabletDevice,shortImageSize:shortImageSize,handlePrice:handlePrice,getRecommendFilterIds:getRecommendFilterIds,getTotalDepth:getTotalDepth,isJSON:isJSON});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(30);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(209).set });


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(75);
var $getPrototypeOf = __webpack_require__(213);

__webpack_require__(166)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(30);
var create = __webpack_require__(120);
var aFunction = __webpack_require__(92);
var anObject = __webpack_require__(54);
var isObject = __webpack_require__(64);
var fails = __webpack_require__(55);
var bind = __webpack_require__(214);
var rConstruct = (__webpack_require__(52).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(120) });


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(30);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(337) });


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var $map = __webpack_require__(99)(1);

$export($export.P + $export.F * !__webpack_require__(94)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contains__ = __webpack_require__(174);
/* unused harmony reexport contains */
/* unused harmony reexport includes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__difference__ = __webpack_require__(629);
/* unused harmony reexport difference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__find__ = __webpack_require__(630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__find__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__find_index__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__find_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__first_value__ = __webpack_require__(632);
/* unused harmony reexport firstValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flatten__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__flatten__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flatten_deep__ = __webpack_require__(634);
/* unused harmony reexport flattenDeep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__get_range__ = __webpack_require__(635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__get_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pull__ = __webpack_require__(636);
/* unused harmony reexport pull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pull_at__ = __webpack_require__(255);
/* unused harmony reexport pullAt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reduce__ = __webpack_require__(256);
/* unused harmony reexport reduce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__remove__ = __webpack_require__(637);
/* unused harmony reexport remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sort_by__ = __webpack_require__(638);
/* unused harmony reexport sortBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__union__ = __webpack_require__(639);
/* unused harmony reexport union */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__uniq__ = __webpack_require__(257);
/* unused harmony reexport uniq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__values_of_key__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_15__values_of_key__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__head__ = __webpack_require__(641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_16__head__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__last__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_17__last__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__starts_with__ = __webpack_require__(643);
/* unused harmony reexport startsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ends_with__ = __webpack_require__(644);
/* unused harmony reexport endsWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__filter__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_20__filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__every__ = __webpack_require__(645);
/* unused harmony reexport every */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__some__ = __webpack_require__(646);
/* unused harmony reexport some */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__group__ = __webpack_require__(647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_23__group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__group_by__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_24__group_by__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__group_to_map__ = __webpack_require__(258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_25__group_to_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__get_wrap_behavior__ = __webpack_require__(648);
/* unused harmony reexport getWrapBehavior */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__wrap_behavior__ = __webpack_require__(649);
/* unused harmony reexport wrapBehavior */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__number2color__ = __webpack_require__(650);
/* unused harmony reexport number2color */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__parse_radius__ = __webpack_require__(651);
/* unused harmony reexport parseRadius */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__clamp__ = __webpack_require__(652);
/* unused harmony reexport clamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__fixed_base__ = __webpack_require__(653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_31__fixed_base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__is_decimal__ = __webpack_require__(654);
/* unused harmony reexport isDecimal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__is_even__ = __webpack_require__(655);
/* unused harmony reexport isEven */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__is_integer__ = __webpack_require__(656);
/* unused harmony reexport isInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__is_negative__ = __webpack_require__(657);
/* unused harmony reexport isNegative */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__is_number_equal__ = __webpack_require__(658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_36__is_number_equal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__is_odd__ = __webpack_require__(659);
/* unused harmony reexport isOdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__is_positive__ = __webpack_require__(660);
/* unused harmony reexport isPositive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__max__ = __webpack_require__(253);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__max_by__ = __webpack_require__(661);
/* unused harmony reexport maxBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__min__ = __webpack_require__(254);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__min_by__ = __webpack_require__(662);
/* unused harmony reexport minBy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__mod__ = __webpack_require__(663);
/* unused harmony reexport mod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__to_degree__ = __webpack_require__(664);
/* unused harmony reexport toDegree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__to_integer__ = __webpack_require__(665);
/* unused harmony reexport toInteger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__to_radian__ = __webpack_require__(666);
/* unused harmony reexport toRadian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__for_in__ = __webpack_require__(667);
/* unused harmony reexport forIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__has__ = __webpack_require__(260);
/* unused harmony reexport has */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__has_key__ = __webpack_require__(668);
/* unused harmony reexport hasKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__has_value__ = __webpack_require__(669);
/* unused harmony reexport hasValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__keys__ = __webpack_require__(252);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__is_match__ = __webpack_require__(251);
/* unused harmony reexport isMatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__values__ = __webpack_require__(176);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__lower_case__ = __webpack_require__(670);
/* unused harmony reexport lowerCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__lower_first__ = __webpack_require__(671);
/* unused harmony reexport lowerFirst */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__substitute__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_56__substitute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__upper_case__ = __webpack_require__(673);
/* unused harmony reexport upperCase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__upper_first__ = __webpack_require__(674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_58__upper_first__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__get_type__ = __webpack_require__(261);
/* unused harmony reexport getType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__is_arguments__ = __webpack_require__(675);
/* unused harmony reexport isArguments */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__is_array__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_61__is_array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__is_array_like__ = __webpack_require__(66);
/* unused harmony reexport isArrayLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__is_boolean__ = __webpack_require__(676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_63__is_boolean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__is_date__ = __webpack_require__(677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_64__is_date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__is_error__ = __webpack_require__(678);
/* unused harmony reexport isError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__is_function__ = __webpack_require__(67);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_66__is_function__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__is_finite__ = __webpack_require__(679);
/* unused harmony reexport isFinite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__is_nil__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_68__is_nil__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__is_null__ = __webpack_require__(680);
/* unused harmony reexport isNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__is_number__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_70__is_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__is_object__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_71__is_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__is_object_like__ = __webpack_require__(175);
/* unused harmony reexport isObjectLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__is_plain_object__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_73__is_plain_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__is_prototype__ = __webpack_require__(262);
/* unused harmony reexport isPrototype */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__is_reg_exp__ = __webpack_require__(681);
/* unused harmony reexport isRegExp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__is_string__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_76__is_string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__is_type__ = __webpack_require__(70);
/* unused harmony reexport isType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__is_undefined__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_78__is_undefined__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__is_element__ = __webpack_require__(683);
/* unused harmony reexport isElement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__request_animation_frame__ = __webpack_require__(684);
/* unused harmony reexport requestAnimationFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__clear_animation_frame__ = __webpack_require__(685);
/* unused harmony reexport clearAnimationFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__augment__ = __webpack_require__(686);
/* unused harmony reexport augment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__clone__ = __webpack_require__(687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_83__clone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__debounce__ = __webpack_require__(688);
/* unused harmony reexport debounce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__memoize__ = __webpack_require__(263);
/* unused harmony reexport memoize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__deep_mix__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_86__deep_mix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__each__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_87__each__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__extend__ = __webpack_require__(690);
/* unused harmony reexport extend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__index_of__ = __webpack_require__(691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_89__index_of__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__is_empty__ = __webpack_require__(692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_90__is_empty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__is_equal__ = __webpack_require__(264);
/* unused harmony reexport isEqual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__is_equal_with__ = __webpack_require__(693);
/* unused harmony reexport isEqualWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__map__ = __webpack_require__(694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_93__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__map_values__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_94__map_values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__mix__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_95__mix__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_95__mix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__get__ = __webpack_require__(696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_96__get__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__set__ = __webpack_require__(697);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__pick__ = __webpack_require__(698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_98__pick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__omit__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_99__omit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__throttle__ = __webpack_require__(700);
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__to_array__ = __webpack_require__(701);
/* unused harmony reexport toArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__to_string__ = __webpack_require__(104);
/* unused harmony reexport toString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__unique_id__ = __webpack_require__(702);
/* unused harmony reexport uniqueId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__noop__ = __webpack_require__(703);
/* unused harmony reexport noop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__identity__ = __webpack_require__(704);
/* unused harmony reexport identity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__size__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_106__size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__measure_text_width__ = __webpack_require__(265);
/* unused harmony reexport measureTextWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__get_ellipsis_text__ = __webpack_require__(707);
/* unused harmony reexport getEllipsisText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__cache__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_109__cache__["a"]; });
// array


























// event


// format


// math

















// object







// string





// type























// other

























// text


// 不知道为什么，需要把这个 export，不然 ts 会报类型错误

//# sourceMappingURL=index.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(356)();
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var $forEach = __webpack_require__(99)(0);
var STRICT = __webpack_require__(94)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(97);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsx_classic__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fragment__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__render__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__renderJSXElement__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compareRenderTree__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elementStatus__ = __webpack_require__(142);
/* unused harmony reexport render */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__renderJSXElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__compareRenderTree__["a"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__elementStatus__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__jsx_classic__["a"]; });
/* unused harmony reexport Fragment */








/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(63).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(56) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(30);

$export($export.P, 'Function', { bind: __webpack_require__(214) });


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var has = __webpack_require__(84);
var cof = __webpack_require__(85);
var inheritIfRequired = __webpack_require__(208);
var toPrimitive = __webpack_require__(126);
var fails = __webpack_require__(55);
var gOPN = __webpack_require__(119).f;
var gOPD = __webpack_require__(117).f;
var dP = __webpack_require__(63).f;
var $trim = __webpack_require__(211).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(120)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(56) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(69)(global, NUMBER, $Number);
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(627);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__ = __webpack_require__(248);



function _createSuper(Derived) {
  var hasNativeReflectConstruct = Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])();
  return function _createSuperInternal() {
    var Super = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2__possibleConstructorReturn_js__["a" /* default */])(this, result);
  };
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var $indexOf = __webpack_require__(154)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(94)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(112);
var global = __webpack_require__(52);
var ctx = __webpack_require__(91);
var classof = __webpack_require__(130);
var $export = __webpack_require__(30);
var isObject = __webpack_require__(64);
var aFunction = __webpack_require__(92);
var anInstance = __webpack_require__(321);
var forOf = __webpack_require__(322);
var speciesConstructor = __webpack_require__(201);
var task = __webpack_require__(202).set;
var microtask = __webpack_require__(323)();
var newPromiseCapabilityModule = __webpack_require__(204);
var perform = __webpack_require__(324);
var userAgent = __webpack_require__(325);
var promiseResolve = __webpack_require__(326);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(49)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(327)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(133)($Promise, PROMISE);
__webpack_require__(205)(PROMISE);
Wrapper = __webpack_require__(90)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(206)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var $filter = __webpack_require__(99)(2);

$export($export.P + $export.F * !__webpack_require__(94)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var html = __webpack_require__(158);
var cof = __webpack_require__(85);
var toAbsoluteIndex = __webpack_require__(128);
var toLength = __webpack_require__(68);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(55)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var core = __webpack_require__(90);
var hide = __webpack_require__(83);
var redefine = __webpack_require__(69);
var ctx = __webpack_require__(91);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(75);
var $keys = __webpack_require__(95);

__webpack_require__(166)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(74);
var $getOwnPropertyDescriptor = __webpack_require__(117).f;

__webpack_require__(166)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(30);
var ownKeys = __webpack_require__(344);
var toIObject = __webpack_require__(74);
var gOPD = __webpack_require__(117);
var createProperty = __webpack_require__(216);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(56), 'Object', { defineProperties: __webpack_require__(212) });


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (function(e) {
	var t = {};
	function r(n) {
		if (t[n]) return t[n].exports;
		var o = (t[n] = { i: n, l: !1, exports: {} });
		return e[n].call(o.exports, o, o.exports, r), (o.l = !0), o.exports;
	}
	return (
		(r.m = e),
		(r.c = t),
		(r.d = function(e, t, n) {
			r.o(e, t) ||
				Object.defineProperty(e, t, { enumerable: !0, get: n });
		}),
		(r.r = function(e) {
			'undefined' != typeof Symbol &&
				Symbol.toStringTag &&
				Object.defineProperty(e, Symbol.toStringTag, {
					value: 'Module',
				}),
				Object.defineProperty(e, '__esModule', { value: !0 });
		}),
		(r.t = function(e, t) {
			if ((1 & t && (e = r(e)), 8 & t)) return e;
			if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
			var n = Object.create(null);
			if (
				(r.r(n),
				Object.defineProperty(n, 'default', {
					enumerable: !0,
					value: e,
				}),
				2 & t && 'string' != typeof e)
			)
				for (var o in e)
					r.d(
						n,
						o,
						function(t) {
							return e[t];
						}.bind(null, o)
					);
			return n;
		}),
		(r.n = function(e) {
			var t =
				e && e.__esModule
					? function() {
							return e.default;
					  }
					: function() {
							return e;
					  };
			return r.d(t, 'a', t), t;
		}),
		(r.o = function(e, t) {
			return Object.prototype.hasOwnProperty.call(e, t);
		}),
		(r.p = ''),
		r((r.s = 8))
	);
})([
	function(e, t) {
		e.exports = __webpack_require__(0);
	},
	function(e, t, r) {
		e.exports = r(10)();
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 }),
			(t.default = function() {
				return (
					'undefined' != typeof window &&
					'IntersectionObserver' in window &&
					'isIntersecting' in
						window.IntersectionObserverEntry.prototype
				);
			});
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 });
		var n = (function() {
				function e(e, t) {
					for (var r = 0; r < t.length; r++) {
						var n = t[r];
						(n.enumerable = n.enumerable || !1),
							(n.configurable = !0),
							'value' in n && (n.writable = !0),
							Object.defineProperty(e, n.key, n);
					}
				}
				return function(t, r, n) {
					return r && e(t.prototype, r), n && e(t, n), t;
				};
			})(),
			o = u(r(0)),
			i = r(1),
			a = u(r(4)),
			s = u(r(12)),
			l = u(r(2));
		function u(e) {
			return e && e.__esModule ? e : { default: e };
		}
		var c = (function(e) {
			function t(e) {
				!(function(e, t) {
					if (!(e instanceof t))
						throw new TypeError(
							'Cannot call a class as a function'
						);
				})(this, t);
				var r = (function(e, t) {
						if (!e)
							throw new ReferenceError(
								"this hasn't been initialised - super() hasn't been called"
							);
						return !t ||
							('object' != typeof t && 'function' != typeof t)
							? e
							: t;
					})(
						this,
						(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
					),
					n = e.afterLoad,
					o = e.beforeLoad,
					i = e.scrollPosition,
					a = e.visibleByDefault;
				return (
					(r.state = { visible: a }),
					a && (o(), n()),
					(r.onVisible = r.onVisible.bind(r)),
					(r.isScrollTracked = Boolean(
						i &&
							Number.isFinite(i.x) &&
							i.x >= 0 &&
							Number.isFinite(i.y) &&
							i.y >= 0
					)),
					r
				);
			}
			return (
				(function(e, t) {
					if ('function' != typeof t && null !== t)
						throw new TypeError(
							'Super expression must either be null or a function, not ' +
								typeof t
						);
					(e.prototype = Object.create(t && t.prototype, {
						constructor: {
							value: e,
							enumerable: !1,
							writable: !0,
							configurable: !0,
						},
					})),
						t &&
							(Object.setPrototypeOf
								? Object.setPrototypeOf(e, t)
								: (e.__proto__ = t));
				})(t, e),
				n(t, [
					{
						key: 'componentDidUpdate',
						value: function(e, t) {
							t.visible !== this.state.visible &&
								this.props.afterLoad();
						},
					},
					{
						key: 'onVisible',
						value: function() {
							this.props.beforeLoad(),
								this.setState({ visible: !0 });
						},
					},
					{
						key: 'render',
						value: function() {
							if (this.state.visible) return this.props.children;
							var e = this.props,
								t = e.className,
								r = e.delayMethod,
								n = e.delayTime,
								i = e.height,
								u = e.placeholder,
								c = e.scrollPosition,
								f = e.style,
								p = e.threshold,
								d = e.useIntersectionObserver,
								y = e.width;
							return this.isScrollTracked ||
								(d && (0, l.default)())
								? o.default.createElement(a.default, {
										className: t,
										height: i,
										onVisible: this.onVisible,
										placeholder: u,
										scrollPosition: c,
										style: f,
										threshold: p,
										useIntersectionObserver: d,
										width: y,
								  })
								: o.default.createElement(s.default, {
										className: t,
										delayMethod: r,
										delayTime: n,
										height: i,
										onVisible: this.onVisible,
										placeholder: u,
										style: f,
										threshold: p,
										width: y,
								  });
						},
					},
				]),
				t
			);
		})(o.default.Component);
		(c.propTypes = {
			afterLoad: i.PropTypes.func,
			beforeLoad: i.PropTypes.func,
			useIntersectionObserver: i.PropTypes.bool,
			visibleByDefault: i.PropTypes.bool,
		}),
			(c.defaultProps = {
				afterLoad: function() {
					return {};
				},
				beforeLoad: function() {
					return {};
				},
				useIntersectionObserver: !0,
				visibleByDefault: !1,
			}),
			(t.default = c);
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 });
		var n =
				Object.assign ||
				function(e) {
					for (var t = 1; t < arguments.length; t++) {
						var r = arguments[t];
						for (var n in r)
							Object.prototype.hasOwnProperty.call(r, n) &&
								(e[n] = r[n]);
					}
					return e;
				},
			o = (function() {
				function e(e, t) {
					for (var r = 0; r < t.length; r++) {
						var n = t[r];
						(n.enumerable = n.enumerable || !1),
							(n.configurable = !0),
							'value' in n && (n.writable = !0),
							Object.defineProperty(e, n.key, n);
					}
				}
				return function(t, r, n) {
					return r && e(t.prototype, r), n && e(t, n), t;
				};
			})(),
			i = u(r(0)),
			a = u(r(5)),
			s = r(1),
			l = u(r(2));
		function u(e) {
			return e && e.__esModule ? e : { default: e };
		}
		var c = function(e) {
				e.forEach(function(e) {
					e.isIntersecting && e.target.onVisible();
				});
			},
			f = {},
			p = function(e) {
				return (
					(f[e] =
						f[e] ||
						new IntersectionObserver(c, { rootMargin: e + 'px' })),
					f[e]
				);
			},
			d = (function(e) {
				function t(e) {
					!(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, t);
					var r = (function(e, t) {
						if (!e)
							throw new ReferenceError(
								"this hasn't been initialised - super() hasn't been called"
							);
						return !t ||
							('object' != typeof t && 'function' != typeof t)
							? e
							: t;
					})(
						this,
						(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
					);
					if (
						((r.supportsObserver =
							!e.scrollPosition &&
							e.useIntersectionObserver &&
							(0, l.default)()),
						r.supportsObserver)
					) {
						var n = e.threshold;
						r.observer = p(n);
					}
					return r;
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(t, e),
					o(t, [
						{
							key: 'componentDidMount',
							value: function() {
								this.placeholder &&
									this.observer &&
									((this.placeholder.onVisible = this.props.onVisible),
									this.observer.observe(this.placeholder)),
									this.supportsObserver ||
										this.updateVisibility();
							},
						},
						{
							key: 'componentWillUnmount',
							value: function() {
								this.observer &&
									this.observer.unobserve(this.placeholder);
							},
						},
						{
							key: 'componentDidUpdate',
							value: function() {
								this.supportsObserver ||
									this.updateVisibility();
							},
						},
						{
							key: 'getPlaceholderBoundingBox',
							value: function() {
								var e =
										arguments.length > 0 &&
										void 0 !== arguments[0]
											? arguments[0]
											: this.props.scrollPosition,
									t = this.placeholder.getBoundingClientRect(),
									r = a.default.findDOMNode(this.placeholder)
										.style,
									n = {
										left:
											parseInt(
												r.getPropertyValue(
													'margin-left'
												),
												10
											) || 0,
										top:
											parseInt(
												r.getPropertyValue(
													'margin-top'
												),
												10
											) || 0,
									};
								return {
									bottom: e.y + t.bottom + n.top,
									left: e.x + t.left + n.left,
									right: e.x + t.right + n.left,
									top: e.y + t.top + n.top,
								};
							},
						},
						{
							key: 'isPlaceholderInViewport',
							value: function() {
								if (
									'undefined' == typeof window ||
									!this.placeholder
								)
									return !1;
								var e = this.props,
									t = e.scrollPosition,
									r = e.threshold,
									n = this.getPlaceholderBoundingBox(t),
									o = t.y + window.innerHeight,
									i = t.x,
									a = t.x + window.innerWidth,
									s = t.y;
								return Boolean(
									s - r <= n.bottom &&
										o + r >= n.top &&
										i - r <= n.right &&
										a + r >= n.left
								);
							},
						},
						{
							key: 'updateVisibility',
							value: function() {
								this.isPlaceholderInViewport() &&
									this.props.onVisible();
							},
						},
						{
							key: 'render',
							value: function() {
								var e = this,
									t = this.props,
									r = t.className,
									o = t.height,
									a = t.placeholder,
									s = t.style,
									l = t.width;
								if (a && 'function' != typeof a.type)
									return i.default.cloneElement(a, {
										ref: function(t) {
											return (e.placeholder = t);
										},
									});
								var u = n({ display: 'inline-block' }, s);
								return (
									void 0 !== l && (u.width = l),
									void 0 !== o && (u.height = o),
									i.default.createElement(
										'span',
										{
											className: r,
											ref: function(t) {
												return (e.placeholder = t);
											},
											style: u,
										},
										a
									)
								);
							},
						},
					]),
					t
				);
			})(i.default.Component);
		(d.propTypes = {
			onVisible: s.PropTypes.func.isRequired,
			className: s.PropTypes.string,
			height: s.PropTypes.oneOfType([
				s.PropTypes.number,
				s.PropTypes.string,
			]),
			placeholder: s.PropTypes.element,
			threshold: s.PropTypes.number,
			useIntersectionObserver: s.PropTypes.bool,
			scrollPosition: s.PropTypes.shape({
				x: s.PropTypes.number.isRequired,
				y: s.PropTypes.number.isRequired,
			}),
			width: s.PropTypes.oneOfType([
				s.PropTypes.number,
				s.PropTypes.string,
			]),
		}),
			(d.defaultProps = {
				className: '',
				placeholder: null,
				threshold: 100,
				useIntersectionObserver: !0,
			}),
			(t.default = d);
	},
	function(e, t) {
		e.exports = __webpack_require__(115);
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 });
		var n =
				Object.assign ||
				function(e) {
					for (var t = 1; t < arguments.length; t++) {
						var r = arguments[t];
						for (var n in r)
							Object.prototype.hasOwnProperty.call(r, n) &&
								(e[n] = r[n]);
					}
					return e;
				},
			o = (function() {
				function e(e, t) {
					for (var r = 0; r < t.length; r++) {
						var n = t[r];
						(n.enumerable = n.enumerable || !1),
							(n.configurable = !0),
							'value' in n && (n.writable = !0),
							Object.defineProperty(e, n.key, n);
					}
				}
				return function(t, r, n) {
					return r && e(t.prototype, r), n && e(t, n), t;
				};
			})(),
			i = p(r(0)),
			a = p(r(5)),
			s = r(1),
			l = p(r(13)),
			u = p(r(14)),
			c = p(r(2)),
			f = p(r(15));
		function p(e) {
			return e && e.__esModule ? e : { default: e };
		}
		function d(e, t) {
			if (!e)
				throw new ReferenceError(
					"this hasn't been initialised - super() hasn't been called"
				);
			return !t || ('object' != typeof t && 'function' != typeof t)
				? e
				: t;
		}
		var y = function() {
				return 'undefined' == typeof window
					? 0
					: window.scrollX || window.pageXOffset;
			},
			h = function() {
				return 'undefined' == typeof window
					? 0
					: window.scrollY || window.pageYOffset;
			};
		t.default = function(e) {
			var t = (function(t) {
				function r(e) {
					!(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, r);
					var t = d(
						this,
						(r.__proto__ || Object.getPrototypeOf(r)).call(this, e)
					);
					if (
						((t.useIntersectionObserver =
							e.useIntersectionObserver && (0, c.default)()),
						t.useIntersectionObserver)
					)
						return d(t);
					var n = t.onChangeScroll.bind(t);
					return (
						'debounce' === e.delayMethod
							? (t.delayedScroll = (0, l.default)(n, e.delayTime))
							: 'throttle' === e.delayMethod &&
							  (t.delayedScroll = (0, u.default)(
									n,
									e.delayTime
							  )),
						(t.state = { scrollPosition: { x: y(), y: h() } }),
						(t.baseComponentRef = i.default.createRef()),
						t
					);
				}
				return (
					(function(e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError(
								'Super expression must either be null or a function, not ' +
									typeof t
							);
						(e.prototype = Object.create(t && t.prototype, {
							constructor: {
								value: e,
								enumerable: !1,
								writable: !0,
								configurable: !0,
							},
						})),
							t &&
								(Object.setPrototypeOf
									? Object.setPrototypeOf(e, t)
									: (e.__proto__ = t));
					})(r, t),
					o(r, [
						{
							key: 'componentDidMount',
							value: function() {
								this.addListeners();
							},
						},
						{
							key: 'componentWillUnmount',
							value: function() {
								this.removeListeners();
							},
						},
						{
							key: 'componentDidUpdate',
							value: function() {
								'undefined' == typeof window ||
									this.useIntersectionObserver ||
									((0, f.default)(
										a.default.findDOMNode(
											this.baseComponentRef.current
										)
									) !== this.scrollElement &&
										(this.removeListeners(),
										this.addListeners()));
							},
						},
						{
							key: 'addListeners',
							value: function() {
								'undefined' == typeof window ||
									this.useIntersectionObserver ||
									((this.scrollElement = (0, f.default)(
										a.default.findDOMNode(
											this.baseComponentRef.current
										)
									)),
									this.scrollElement.addEventListener(
										'scroll',
										this.delayedScroll,
										{ passive: !0 }
									),
									window.addEventListener(
										'resize',
										this.delayedScroll,
										{ passive: !0 }
									),
									this.scrollElement !== window &&
										window.addEventListener(
											'scroll',
											this.delayedScroll,
											{ passive: !0 }
										));
							},
						},
						{
							key: 'removeListeners',
							value: function() {
								'undefined' == typeof window ||
									this.useIntersectionObserver ||
									(this.scrollElement.removeEventListener(
										'scroll',
										this.delayedScroll
									),
									window.removeEventListener(
										'resize',
										this.delayedScroll
									),
									this.scrollElement !== window &&
										window.removeEventListener(
											'scroll',
											this.delayedScroll
										));
							},
						},
						{
							key: 'onChangeScroll',
							value: function() {
								this.useIntersectionObserver ||
									this.setState({
										scrollPosition: { x: y(), y: h() },
									});
							},
						},
						{
							key: 'render',
							value: function() {
								var t = this.props,
									r =
										(t.delayMethod,
										t.delayTime,
										(function(e, t) {
											var r = {};
											for (var n in e)
												t.indexOf(n) >= 0 ||
													(Object.prototype.hasOwnProperty.call(
														e,
														n
													) &&
														(r[n] = e[n]));
											return r;
										})(t, ['delayMethod', 'delayTime'])),
									o = this.useIntersectionObserver
										? null
										: this.state.scrollPosition;
								return i.default.createElement(
									e,
									n(
										{
											ref: this.baseComponentRef,
											scrollPosition: o,
										},
										r
									)
								);
							},
						},
					]),
					r
				);
			})(i.default.Component);
			return (
				(t.propTypes = {
					delayMethod: s.PropTypes.oneOf(['debounce', 'throttle']),
					delayTime: s.PropTypes.number,
					useIntersectionObserver: s.PropTypes.bool,
				}),
				(t.defaultProps = {
					delayMethod: 'throttle',
					delayTime: 300,
					useIntersectionObserver: !0,
				}),
				t
			);
		};
	},
	function(e, t) {
		var r;
		r = (function() {
			return this;
		})();
		try {
			r = r || new Function('return this')();
		} catch (e) {
			'object' == typeof window && (r = window);
		}
		e.exports = r;
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 }),
			(t.trackWindowScroll = t.LazyLoadComponent = t.LazyLoadImage = void 0);
		var n = a(r(9)),
			o = a(r(3)),
			i = a(r(6));
		function a(e) {
			return e && e.__esModule ? e : { default: e };
		}
		(t.LazyLoadImage = n.default),
			(t.LazyLoadComponent = o.default),
			(t.trackWindowScroll = i.default);
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 });
		var n =
				Object.assign ||
				function(e) {
					for (var t = 1; t < arguments.length; t++) {
						var r = arguments[t];
						for (var n in r)
							Object.prototype.hasOwnProperty.call(r, n) &&
								(e[n] = r[n]);
					}
					return e;
				},
			o = (function() {
				function e(e, t) {
					for (var r = 0; r < t.length; r++) {
						var n = t[r];
						(n.enumerable = n.enumerable || !1),
							(n.configurable = !0),
							'value' in n && (n.writable = !0),
							Object.defineProperty(e, n.key, n);
					}
				}
				return function(t, r, n) {
					return r && e(t.prototype, r), n && e(t, n), t;
				};
			})(),
			i = l(r(0)),
			a = r(1),
			s = l(r(3));
		function l(e) {
			return e && e.__esModule ? e : { default: e };
		}
		var u = (function(e) {
			function t(e) {
				!(function(e, t) {
					if (!(e instanceof t))
						throw new TypeError(
							'Cannot call a class as a function'
						);
				})(this, t);
				var r = (function(e, t) {
					if (!e)
						throw new ReferenceError(
							"this hasn't been initialised - super() hasn't been called"
						);
					return !t ||
						('object' != typeof t && 'function' != typeof t)
						? e
						: t;
				})(
					this,
					(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
				);
				return (r.state = { loaded: !1 }), r;
			}
			return (
				(function(e, t) {
					if ('function' != typeof t && null !== t)
						throw new TypeError(
							'Super expression must either be null or a function, not ' +
								typeof t
						);
					(e.prototype = Object.create(t && t.prototype, {
						constructor: {
							value: e,
							enumerable: !1,
							writable: !0,
							configurable: !0,
						},
					})),
						t &&
							(Object.setPrototypeOf
								? Object.setPrototypeOf(e, t)
								: (e.__proto__ = t));
				})(t, e),
				o(t, [
					{
						key: 'onImageLoad',
						value: function() {
							var e = this;
							return this.state.loaded
								? null
								: function() {
										e.props.afterLoad(),
											e.setState({ loaded: !0 });
								  };
						},
					},
					{
						key: 'getImg',
						value: function() {
							var e = this.props,
								t =
									(e.afterLoad,
									e.beforeLoad,
									e.delayMethod,
									e.delayTime,
									e.effect,
									e.placeholder,
									e.placeholderSrc,
									e.scrollPosition,
									e.threshold,
									e.useIntersectionObserver,
									e.visibleByDefault,
									e.wrapperClassName,
									e.wrapperProps,
									(function(e, t) {
										var r = {};
										for (var n in e)
											t.indexOf(n) >= 0 ||
												(Object.prototype.hasOwnProperty.call(
													e,
													n
												) &&
													(r[n] = e[n]));
										return r;
									})(e, [
										'afterLoad',
										'beforeLoad',
										'delayMethod',
										'delayTime',
										'effect',
										'placeholder',
										'placeholderSrc',
										'scrollPosition',
										'threshold',
										'useIntersectionObserver',
										'visibleByDefault',
										'wrapperClassName',
										'wrapperProps',
									]));
							return i.default.createElement(
								'img',
								n({ onLoad: this.onImageLoad() }, t)
							);
						},
					},
					{
						key: 'getLazyLoadImage',
						value: function() {
							var e = this.props,
								t = e.beforeLoad,
								r = e.className,
								n = e.delayMethod,
								o = e.delayTime,
								a = e.height,
								l = e.placeholder,
								u = e.scrollPosition,
								c = e.style,
								f = e.threshold,
								p = e.useIntersectionObserver,
								d = e.visibleByDefault,
								y = e.width;
							return i.default.createElement(
								s.default,
								{
									beforeLoad: t,
									className: r,
									delayMethod: n,
									delayTime: o,
									height: a,
									placeholder: l,
									scrollPosition: u,
									style: c,
									threshold: f,
									useIntersectionObserver: p,
									visibleByDefault: d,
									width: y,
								},
								this.getImg()
							);
						},
					},
					{
						key: 'getWrappedLazyLoadImage',
						value: function(e) {
							var t = this.props,
								r = t.effect,
								o = t.height,
								a = t.placeholderSrc,
								s = t.width,
								l = t.wrapperClassName,
								u = t.wrapperProps,
								c = this.state.loaded,
								f = c ? ' lazy-load-image-loaded' : '';
							return i.default.createElement(
								'span',
								n(
									{
										className:
											l +
											' lazy-load-image-background ' +
											r +
											f,
										style: {
											backgroundImage:
												c || !a ? '' : 'url(' + a + ')',
											backgroundSize:
												c || !a ? '' : '100% 100%',
											display: 'inline-block',
											height: o,
											width: s,
										},
									},
									u
								),
								e
							);
						},
					},
					{
						key: 'render',
						value: function() {
							var e = this.props,
								t = e.effect,
								r = e.placeholderSrc,
								n = e.visibleByDefault,
								o = e.wrapperClassName,
								i = e.wrapperProps,
								a = this.getLazyLoadImage();
							return ((t || r) && !n) || o || i
								? this.getWrappedLazyLoadImage(a)
								: a;
						},
					},
				]),
				t
			);
		})(i.default.Component);
		(u.propTypes = {
			afterLoad: a.PropTypes.func,
			beforeLoad: a.PropTypes.func,
			delayMethod: a.PropTypes.string,
			delayTime: a.PropTypes.number,
			effect: a.PropTypes.string,
			placeholderSrc: a.PropTypes.string,
			threshold: a.PropTypes.number,
			useIntersectionObserver: a.PropTypes.bool,
			visibleByDefault: a.PropTypes.bool,
			wrapperClassName: a.PropTypes.string,
			wrapperProps: a.PropTypes.object,
		}),
			(u.defaultProps = {
				afterLoad: function() {
					return {};
				},
				beforeLoad: function() {
					return {};
				},
				delayMethod: 'throttle',
				delayTime: 300,
				effect: '',
				placeholderSrc: null,
				threshold: 100,
				useIntersectionObserver: !0,
				visibleByDefault: !1,
				wrapperClassName: '',
			}),
			(t.default = u);
	},
	function(e, t, r) {
		'use strict';
		var n = r(11);
		function o() {}
		function i() {}
		(i.resetWarningCache = o),
			(e.exports = function() {
				function e(e, t, r, o, i, a) {
					if (a !== n) {
						var s = new Error(
							'Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types'
						);
						throw ((s.name = 'Invariant Violation'), s);
					}
				}
				function t() {
					return e;
				}
				e.isRequired = e;
				var r = {
					array: e,
					bool: e,
					func: e,
					number: e,
					object: e,
					string: e,
					symbol: e,
					any: e,
					arrayOf: t,
					element: e,
					elementType: e,
					instanceOf: t,
					node: e,
					objectOf: t,
					oneOf: t,
					oneOfType: t,
					shape: t,
					exact: t,
					checkPropTypes: i,
					resetWarningCache: o,
				};
				return (r.PropTypes = r), r;
			});
	},
	function(e, t, r) {
		'use strict';
		e.exports = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 });
		var n = (function() {
				function e(e, t) {
					for (var r = 0; r < t.length; r++) {
						var n = t[r];
						(n.enumerable = n.enumerable || !1),
							(n.configurable = !0),
							'value' in n && (n.writable = !0),
							Object.defineProperty(e, n.key, n);
					}
				}
				return function(t, r, n) {
					return r && e(t.prototype, r), n && e(t, n), t;
				};
			})(),
			o = s(r(0)),
			i = s(r(4)),
			a = s(r(6));
		function s(e) {
			return e && e.__esModule ? e : { default: e };
		}
		var l = (function(e) {
			function t(e) {
				return (
					(function(e, t) {
						if (!(e instanceof t))
							throw new TypeError(
								'Cannot call a class as a function'
							);
					})(this, t),
					(function(e, t) {
						if (!e)
							throw new ReferenceError(
								"this hasn't been initialised - super() hasn't been called"
							);
						return !t ||
							('object' != typeof t && 'function' != typeof t)
							? e
							: t;
					})(
						this,
						(t.__proto__ || Object.getPrototypeOf(t)).call(this, e)
					)
				);
			}
			return (
				(function(e, t) {
					if ('function' != typeof t && null !== t)
						throw new TypeError(
							'Super expression must either be null or a function, not ' +
								typeof t
						);
					(e.prototype = Object.create(t && t.prototype, {
						constructor: {
							value: e,
							enumerable: !1,
							writable: !0,
							configurable: !0,
						},
					})),
						t &&
							(Object.setPrototypeOf
								? Object.setPrototypeOf(e, t)
								: (e.__proto__ = t));
				})(t, e),
				n(t, [
					{
						key: 'render',
						value: function() {
							return o.default.createElement(
								i.default,
								this.props
							);
						},
					},
				]),
				t
			);
		})(o.default.Component);
		t.default = (0, a.default)(l);
	},
	function(e, t, r) {
		(function(t) {
			var r = 'Expected a function',
				n = NaN,
				o = '[object Symbol]',
				i = /^\s+|\s+$/g,
				a = /^[-+]0x[0-9a-f]+$/i,
				s = /^0b[01]+$/i,
				l = /^0o[0-7]+$/i,
				u = parseInt,
				c = 'object' == typeof t && t && t.Object === Object && t,
				f =
					'object' == typeof self &&
					self &&
					self.Object === Object &&
					self,
				p = c || f || Function('return this')(),
				d = Object.prototype.toString,
				y = Math.max,
				h = Math.min,
				b = function() {
					return p.Date.now();
				};
			function v(e) {
				var t = typeof e;
				return !!e && ('object' == t || 'function' == t);
			}
			function m(e) {
				if ('number' == typeof e) return e;
				if (
					(function(e) {
						return (
							'symbol' == typeof e ||
							((function(e) {
								return !!e && 'object' == typeof e;
							})(e) &&
								d.call(e) == o)
						);
					})(e)
				)
					return n;
				if (v(e)) {
					var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
					e = v(t) ? t + '' : t;
				}
				if ('string' != typeof e) return 0 === e ? e : +e;
				e = e.replace(i, '');
				var r = s.test(e);
				return r || l.test(e)
					? u(e.slice(2), r ? 2 : 8)
					: a.test(e)
					? n
					: +e;
			}
			e.exports = function(e, t, n) {
				var o,
					i,
					a,
					s,
					l,
					u,
					c = 0,
					f = !1,
					p = !1,
					d = !0;
				if ('function' != typeof e) throw new TypeError(r);
				function w(t) {
					var r = o,
						n = i;
					return (o = i = void 0), (c = t), (s = e.apply(n, r));
				}
				function O(e) {
					var r = e - u;
					return void 0 === u || r >= t || r < 0 || (p && e - c >= a);
				}
				function g() {
					var e = b();
					if (O(e)) return P(e);
					l = setTimeout(
						g,
						(function(e) {
							var r = t - (e - u);
							return p ? h(r, a - (e - c)) : r;
						})(e)
					);
				}
				function P(e) {
					return (l = void 0), d && o ? w(e) : ((o = i = void 0), s);
				}
				function T() {
					var e = b(),
						r = O(e);
					if (((o = arguments), (i = this), (u = e), r)) {
						if (void 0 === l)
							return (function(e) {
								return (
									(c = e),
									(l = setTimeout(g, t)),
									f ? w(e) : s
								);
							})(u);
						if (p) return (l = setTimeout(g, t)), w(u);
					}
					return void 0 === l && (l = setTimeout(g, t)), s;
				}
				return (
					(t = m(t) || 0),
					v(n) &&
						((f = !!n.leading),
						(a = (p = 'maxWait' in n)
							? y(m(n.maxWait) || 0, t)
							: a),
						(d = 'trailing' in n ? !!n.trailing : d)),
					(T.cancel = function() {
						void 0 !== l && clearTimeout(l),
							(c = 0),
							(o = u = i = l = void 0);
					}),
					(T.flush = function() {
						return void 0 === l ? s : P(b());
					}),
					T
				);
			};
		}.call(this, r(7)));
	},
	function(e, t, r) {
		(function(t) {
			var r = 'Expected a function',
				n = NaN,
				o = '[object Symbol]',
				i = /^\s+|\s+$/g,
				a = /^[-+]0x[0-9a-f]+$/i,
				s = /^0b[01]+$/i,
				l = /^0o[0-7]+$/i,
				u = parseInt,
				c = 'object' == typeof t && t && t.Object === Object && t,
				f =
					'object' == typeof self &&
					self &&
					self.Object === Object &&
					self,
				p = c || f || Function('return this')(),
				d = Object.prototype.toString,
				y = Math.max,
				h = Math.min,
				b = function() {
					return p.Date.now();
				};
			function v(e, t, n) {
				var o,
					i,
					a,
					s,
					l,
					u,
					c = 0,
					f = !1,
					p = !1,
					d = !0;
				if ('function' != typeof e) throw new TypeError(r);
				function v(t) {
					var r = o,
						n = i;
					return (o = i = void 0), (c = t), (s = e.apply(n, r));
				}
				function O(e) {
					var r = e - u;
					return void 0 === u || r >= t || r < 0 || (p && e - c >= a);
				}
				function g() {
					var e = b();
					if (O(e)) return P(e);
					l = setTimeout(
						g,
						(function(e) {
							var r = t - (e - u);
							return p ? h(r, a - (e - c)) : r;
						})(e)
					);
				}
				function P(e) {
					return (l = void 0), d && o ? v(e) : ((o = i = void 0), s);
				}
				function T() {
					var e = b(),
						r = O(e);
					if (((o = arguments), (i = this), (u = e), r)) {
						if (void 0 === l)
							return (function(e) {
								return (
									(c = e),
									(l = setTimeout(g, t)),
									f ? v(e) : s
								);
							})(u);
						if (p) return (l = setTimeout(g, t)), v(u);
					}
					return void 0 === l && (l = setTimeout(g, t)), s;
				}
				return (
					(t = w(t) || 0),
					m(n) &&
						((f = !!n.leading),
						(a = (p = 'maxWait' in n)
							? y(w(n.maxWait) || 0, t)
							: a),
						(d = 'trailing' in n ? !!n.trailing : d)),
					(T.cancel = function() {
						void 0 !== l && clearTimeout(l),
							(c = 0),
							(o = u = i = l = void 0);
					}),
					(T.flush = function() {
						return void 0 === l ? s : P(b());
					}),
					T
				);
			}
			function m(e) {
				var t = typeof e;
				return !!e && ('object' == t || 'function' == t);
			}
			function w(e) {
				if ('number' == typeof e) return e;
				if (
					(function(e) {
						return (
							'symbol' == typeof e ||
							((function(e) {
								return !!e && 'object' == typeof e;
							})(e) &&
								d.call(e) == o)
						);
					})(e)
				)
					return n;
				if (m(e)) {
					var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
					e = m(t) ? t + '' : t;
				}
				if ('string' != typeof e) return 0 === e ? e : +e;
				e = e.replace(i, '');
				var r = s.test(e);
				return r || l.test(e)
					? u(e.slice(2), r ? 2 : 8)
					: a.test(e)
					? n
					: +e;
			}
			e.exports = function(e, t, n) {
				var o = !0,
					i = !0;
				if ('function' != typeof e) throw new TypeError(r);
				return (
					m(n) &&
						((o = 'leading' in n ? !!n.leading : o),
						(i = 'trailing' in n ? !!n.trailing : i)),
					v(e, t, { leading: o, maxWait: t, trailing: i })
				);
			};
		}.call(this, r(7)));
	},
	function(e, t, r) {
		'use strict';
		Object.defineProperty(t, '__esModule', { value: !0 });
		var n = function(e, t) {
				return 'undefined' == typeof getComputedStyle
					? e.style[t]
					: getComputedStyle(e, null).getPropertyValue(t);
			},
			o = function(e) {
				return (
					n(e, 'overflow') + n(e, 'overflow-y') + n(e, 'overflow-x')
				);
			};
		t.default = function(e) {
			if (!(e instanceof HTMLElement)) return window;
			for (
				var t = e;
				t &&
				t !== document.body &&
				t !== document.documentElement &&
				t.parentNode;

			) {
				if (/(scroll|auto)/.test(o(t))) return t;
				t = t.parentNode;
			}
			return window;
		};
	},
]);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(30);
var $find = __webpack_require__(99)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(116)(KEY);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(7);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}var Request=/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _ref2,url,_ref2$method,method,_ref2$params,params,_ref2$data,data,_ref2$headers,headers,options,_args=arguments;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_ref2=_args.length>0&&_args[0]!==undefined?_args[0]:{},url=_ref2.url,_ref2$method=_ref2.method,method=_ref2$method===void 0?'get':_ref2$method,_ref2$params=_ref2.params,params=_ref2$params===void 0?{}:_ref2$params,_ref2$data=_ref2.data,data=_ref2$data===void 0?{}:_ref2$data,_ref2$headers=_ref2.headers,headers=_ref2$headers===void 0?{}:_ref2$headers;if(!__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].isShihuo()){_context.next=5;break;}return _context.abrupt("return",new Promise(function(resolve,reject){window.Jockey.send('request',{url:url,type:method==='get'?'GET':'POST',header:_objectSpread({'Content-Type':'application/json','User-Agent':navigator.userAgent},headers),withCookie:true,data:method==='get'?params:data},function(res){if(!__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].isAndroid()){res.data=JSON.parse(res.response.body);}else{res.data=res.response.body;}resolve(res);});}));case 5:options={url:url,method:method,headers:headers,withCredentials:true};if(method==='get'){Object.assign(options,{params:params});}else if(method==='post'){Object.assign(options,{data:data});}_context.next=9;return __WEBPACK_IMPORTED_MODULE_12_axios_dist_axios_min_js___default()(options);case 9:return _context.abrupt("return",_context.sent);case 10:case"end":return _context.stop();}}},_callee);}));return function Request(){return _ref.apply(this,arguments);};}();/* harmony default export */ __webpack_exports__["a"] = (Request);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/* axios v0.21.1 | (c) 2020 by Matt Zabriskie */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.axios=t():e.axios=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";function r(e){var t=new i(e),n=s(i.prototype.request,t);return o.extend(n,i.prototype,t),o.extend(n,t),n}var o=n(2),s=n(3),i=n(4),a=n(22),u=n(10),c=r(u);c.Axios=i,c.create=function(e){return r(a(c.defaults,e))},c.Cancel=n(23),c.CancelToken=n(24),c.isCancel=n(9),c.all=function(e){return Promise.all(e)},c.spread=n(25),c.isAxiosError=n(26),e.exports=c,e.exports.default=c},function(e,t,n){"use strict";function r(e){return"[object Array]"===R.call(e)}function o(e){return"undefined"==typeof e}function s(e){return null!==e&&!o(e)&&null!==e.constructor&&!o(e.constructor)&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}function i(e){return"[object ArrayBuffer]"===R.call(e)}function a(e){return"undefined"!=typeof FormData&&e instanceof FormData}function u(e){var t;return t="undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer&&e.buffer instanceof ArrayBuffer}function c(e){return"string"==typeof e}function f(e){return"number"==typeof e}function p(e){return null!==e&&"object"==typeof e}function d(e){if("[object Object]"!==R.call(e))return!1;var t=Object.getPrototypeOf(e);return null===t||t===Object.prototype}function l(e){return"[object Date]"===R.call(e)}function h(e){return"[object File]"===R.call(e)}function m(e){return"[object Blob]"===R.call(e)}function y(e){return"[object Function]"===R.call(e)}function g(e){return p(e)&&y(e.pipe)}function v(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function x(e){return e.replace(/^\s*/,"").replace(/\s*$/,"")}function w(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product&&"NativeScript"!==navigator.product&&"NS"!==navigator.product)&&("undefined"!=typeof window&&"undefined"!=typeof document)}function b(e,t){if(null!==e&&"undefined"!=typeof e)if("object"!=typeof e&&(e=[e]),r(e))for(var n=0,o=e.length;n<o;n++)t.call(null,e[n],n,e);else for(var s in e)Object.prototype.hasOwnProperty.call(e,s)&&t.call(null,e[s],s,e)}function E(){function e(e,n){d(t[n])&&d(e)?t[n]=E(t[n],e):d(e)?t[n]=E({},e):r(e)?t[n]=e.slice():t[n]=e}for(var t={},n=0,o=arguments.length;n<o;n++)b(arguments[n],e);return t}function j(e,t,n){return b(t,function(t,r){n&&"function"==typeof t?e[r]=S(t,n):e[r]=t}),e}function C(e){return 65279===e.charCodeAt(0)&&(e=e.slice(1)),e}var S=n(3),R=Object.prototype.toString;e.exports={isArray:r,isArrayBuffer:i,isBuffer:s,isFormData:a,isArrayBufferView:u,isString:c,isNumber:f,isObject:p,isPlainObject:d,isUndefined:o,isDate:l,isFile:h,isBlob:m,isFunction:y,isStream:g,isURLSearchParams:v,isStandardBrowserEnv:w,forEach:b,merge:E,extend:j,trim:x,stripBOM:C}},function(e,t){"use strict";e.exports=function(e,t){return function(){for(var n=new Array(arguments.length),r=0;r<n.length;r++)n[r]=arguments[r];return e.apply(t,n)}}},function(e,t,n){"use strict";function r(e){this.defaults=e,this.interceptors={request:new i,response:new i}}var o=n(2),s=n(5),i=n(6),a=n(7),u=n(22);r.prototype.request=function(e){"string"==typeof e?(e=arguments[1]||{},e.url=arguments[0]):e=e||{},e=u(this.defaults,e),e.method?e.method=e.method.toLowerCase():this.defaults.method?e.method=this.defaults.method.toLowerCase():e.method="get";var t=[a,void 0],n=Promise.resolve(e);for(this.interceptors.request.forEach(function(e){t.unshift(e.fulfilled,e.rejected)}),this.interceptors.response.forEach(function(e){t.push(e.fulfilled,e.rejected)});t.length;)n=n.then(t.shift(),t.shift());return n},r.prototype.getUri=function(e){return e=u(this.defaults,e),s(e.url,e.params,e.paramsSerializer).replace(/^\?/,"")},o.forEach(["delete","get","head","options"],function(e){r.prototype[e]=function(t,n){return this.request(u(n||{},{method:e,url:t,data:(n||{}).data}))}}),o.forEach(["post","put","patch"],function(e){r.prototype[e]=function(t,n,r){return this.request(u(r||{},{method:e,url:t,data:n}))}}),e.exports=r},function(e,t,n){"use strict";function r(e){return encodeURIComponent(e).replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var o=n(2);e.exports=function(e,t,n){if(!t)return e;var s;if(n)s=n(t);else if(o.isURLSearchParams(t))s=t.toString();else{var i=[];o.forEach(t,function(e,t){null!==e&&"undefined"!=typeof e&&(o.isArray(e)?t+="[]":e=[e],o.forEach(e,function(e){o.isDate(e)?e=e.toISOString():o.isObject(e)&&(e=JSON.stringify(e)),i.push(r(t)+"="+r(e))}))}),s=i.join("&")}if(s){var a=e.indexOf("#");a!==-1&&(e=e.slice(0,a)),e+=(e.indexOf("?")===-1?"?":"&")+s}return e}},function(e,t,n){"use strict";function r(){this.handlers=[]}var o=n(2);r.prototype.use=function(e,t){return this.handlers.push({fulfilled:e,rejected:t}),this.handlers.length-1},r.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r.prototype.forEach=function(e){o.forEach(this.handlers,function(t){null!==t&&e(t)})},e.exports=r},function(e,t,n){"use strict";function r(e){e.cancelToken&&e.cancelToken.throwIfRequested()}var o=n(2),s=n(8),i=n(9),a=n(10);e.exports=function(e){r(e),e.headers=e.headers||{},e.data=s(e.data,e.headers,e.transformRequest),e.headers=o.merge(e.headers.common||{},e.headers[e.method]||{},e.headers),o.forEach(["delete","get","head","post","put","patch","common"],function(t){delete e.headers[t]});var t=e.adapter||a.adapter;return t(e).then(function(t){return r(e),t.data=s(t.data,t.headers,e.transformResponse),t},function(t){return i(t)||(r(e),t&&t.response&&(t.response.data=s(t.response.data,t.response.headers,e.transformResponse))),Promise.reject(t)})}},function(e,t,n){"use strict";var r=n(2);e.exports=function(e,t,n){return r.forEach(n,function(n){e=n(e,t)}),e}},function(e,t){"use strict";e.exports=function(e){return!(!e||!e.__CANCEL__)}},function(e,t,n){"use strict";function r(e,t){!s.isUndefined(e)&&s.isUndefined(e["Content-Type"])&&(e["Content-Type"]=t)}function o(){var e;return"undefined"!=typeof XMLHttpRequest?e=n(12):"undefined"!=typeof process&&"[object process]"===Object.prototype.toString.call(process)&&(e=n(12)),e}var s=n(2),i=n(11),a={"Content-Type":"application/x-www-form-urlencoded"},u={adapter:o(),transformRequest:[function(e,t){return i(t,"Accept"),i(t,"Content-Type"),s.isFormData(e)||s.isArrayBuffer(e)||s.isBuffer(e)||s.isStream(e)||s.isFile(e)||s.isBlob(e)?e:s.isArrayBufferView(e)?e.buffer:s.isURLSearchParams(e)?(r(t,"application/x-www-form-urlencoded;charset=utf-8"),e.toString()):s.isObject(e)?(r(t,"application/json;charset=utf-8"),JSON.stringify(e)):e}],transformResponse:[function(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,maxBodyLength:-1,validateStatus:function(e){return e>=200&&e<300}};u.headers={common:{Accept:"application/json, text/plain, */*"}},s.forEach(["delete","get","head"],function(e){u.headers[e]={}}),s.forEach(["post","put","patch"],function(e){u.headers[e]=s.merge(a)}),e.exports=u},function(e,t,n){"use strict";var r=n(2);e.exports=function(e,t){r.forEach(e,function(n,r){r!==t&&r.toUpperCase()===t.toUpperCase()&&(e[t]=n,delete e[r])})}},function(e,t,n){"use strict";var r=n(2),o=n(13),s=n(16),i=n(5),a=n(17),u=n(20),c=n(21),f=n(14);e.exports=function(e){return new Promise(function(t,n){var p=e.data,d=e.headers;r.isFormData(p)&&delete d["Content-Type"];var l=new XMLHttpRequest;if(e.auth){var h=e.auth.username||"",m=e.auth.password?unescape(encodeURIComponent(e.auth.password)):"";d.Authorization="Basic "+btoa(h+":"+m)}var y=a(e.baseURL,e.url);if(l.open(e.method.toUpperCase(),i(y,e.params,e.paramsSerializer),!0),l.timeout=e.timeout,l.onreadystatechange=function(){if(l&&4===l.readyState&&(0!==l.status||l.responseURL&&0===l.responseURL.indexOf("file:"))){var r="getAllResponseHeaders"in l?u(l.getAllResponseHeaders()):null,s=e.responseType&&"text"!==e.responseType?l.response:l.responseText,i={data:s,status:l.status,statusText:l.statusText,headers:r,config:e,request:l};o(t,n,i),l=null}},l.onabort=function(){l&&(n(f("Request aborted",e,"ECONNABORTED",l)),l=null)},l.onerror=function(){n(f("Network Error",e,null,l)),l=null},l.ontimeout=function(){var t="timeout of "+e.timeout+"ms exceeded";e.timeoutErrorMessage&&(t=e.timeoutErrorMessage),n(f(t,e,"ECONNABORTED",l)),l=null},r.isStandardBrowserEnv()){var g=(e.withCredentials||c(y))&&e.xsrfCookieName?s.read(e.xsrfCookieName):void 0;g&&(d[e.xsrfHeaderName]=g)}if("setRequestHeader"in l&&r.forEach(d,function(e,t){"undefined"==typeof p&&"content-type"===t.toLowerCase()?delete d[t]:l.setRequestHeader(t,e)}),r.isUndefined(e.withCredentials)||(l.withCredentials=!!e.withCredentials),e.responseType)try{l.responseType=e.responseType}catch(t){if("json"!==e.responseType)throw t}"function"==typeof e.onDownloadProgress&&l.addEventListener("progress",e.onDownloadProgress),"function"==typeof e.onUploadProgress&&l.upload&&l.upload.addEventListener("progress",e.onUploadProgress),e.cancelToken&&e.cancelToken.promise.then(function(e){l&&(l.abort(),n(e),l=null)}),p||(p=null),l.send(p)})}},function(e,t,n){"use strict";var r=n(14);e.exports=function(e,t,n){var o=n.config.validateStatus;n.status&&o&&!o(n.status)?t(r("Request failed with status code "+n.status,n.config,null,n.request,n)):e(n)}},function(e,t,n){"use strict";var r=n(15);e.exports=function(e,t,n,o,s){var i=new Error(e);return r(i,t,n,o,s)}},function(e,t){"use strict";e.exports=function(e,t,n,r,o){return e.config=t,n&&(e.code=n),e.request=r,e.response=o,e.isAxiosError=!0,e.toJSON=function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code}},e}},function(e,t,n){"use strict";var r=n(2);e.exports=r.isStandardBrowserEnv()?function(){return{write:function(e,t,n,o,s,i){var a=[];a.push(e+"="+encodeURIComponent(t)),r.isNumber(n)&&a.push("expires="+new Date(n).toGMTString()),r.isString(o)&&a.push("path="+o),r.isString(s)&&a.push("domain="+s),i===!0&&a.push("secure"),document.cookie=a.join("; ")},read:function(e){var t=document.cookie.match(new RegExp("(^|;\\s*)("+e+")=([^;]*)"));return t?decodeURIComponent(t[3]):null},remove:function(e){this.write(e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()},function(e,t,n){"use strict";var r=n(18),o=n(19);e.exports=function(e,t){return e&&!r(t)?o(e,t):t}},function(e,t){"use strict";e.exports=function(e){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)}},function(e,t){"use strict";e.exports=function(e,t){return t?e.replace(/\/+$/,"")+"/"+t.replace(/^\/+/,""):e}},function(e,t,n){"use strict";var r=n(2),o=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];e.exports=function(e){var t,n,s,i={};return e?(r.forEach(e.split("\n"),function(e){if(s=e.indexOf(":"),t=r.trim(e.substr(0,s)).toLowerCase(),n=r.trim(e.substr(s+1)),t){if(i[t]&&o.indexOf(t)>=0)return;"set-cookie"===t?i[t]=(i[t]?i[t]:[]).concat([n]):i[t]=i[t]?i[t]+", "+n:n}}),i):i}},function(e,t,n){"use strict";var r=n(2);e.exports=r.isStandardBrowserEnv()?function(){function e(e){var t=e;return n&&(o.setAttribute("href",t),t=o.href),o.setAttribute("href",t),{href:o.href,protocol:o.protocol?o.protocol.replace(/:$/,""):"",host:o.host,search:o.search?o.search.replace(/^\?/,""):"",hash:o.hash?o.hash.replace(/^#/,""):"",hostname:o.hostname,port:o.port,pathname:"/"===o.pathname.charAt(0)?o.pathname:"/"+o.pathname}}var t,n=/(msie|trident)/i.test(navigator.userAgent),o=document.createElement("a");return t=e(window.location.href),function(n){var o=r.isString(n)?e(n):n;return o.protocol===t.protocol&&o.host===t.host}}():function(){return function(){return!0}}()},function(e,t,n){"use strict";var r=n(2);e.exports=function(e,t){function n(e,t){return r.isPlainObject(e)&&r.isPlainObject(t)?r.merge(e,t):r.isPlainObject(t)?r.merge({},t):r.isArray(t)?t.slice():t}function o(o){r.isUndefined(t[o])?r.isUndefined(e[o])||(s[o]=n(void 0,e[o])):s[o]=n(e[o],t[o])}t=t||{};var s={},i=["url","method","data"],a=["headers","auth","proxy","params"],u=["baseURL","transformRequest","transformResponse","paramsSerializer","timeout","timeoutMessage","withCredentials","adapter","responseType","xsrfCookieName","xsrfHeaderName","onUploadProgress","onDownloadProgress","decompress","maxContentLength","maxBodyLength","maxRedirects","transport","httpAgent","httpsAgent","cancelToken","socketPath","responseEncoding"],c=["validateStatus"];r.forEach(i,function(e){r.isUndefined(t[e])||(s[e]=n(void 0,t[e]))}),r.forEach(a,o),r.forEach(u,function(o){r.isUndefined(t[o])?r.isUndefined(e[o])||(s[o]=n(void 0,e[o])):s[o]=n(void 0,t[o])}),r.forEach(c,function(r){r in t?s[r]=n(e[r],t[r]):r in e&&(s[r]=n(void 0,e[r]))});var f=i.concat(a).concat(u).concat(c),p=Object.keys(e).concat(Object.keys(t)).filter(function(e){return f.indexOf(e)===-1});return r.forEach(p,o),s}},function(e,t){"use strict";function n(e){this.message=e}n.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},n.prototype.__CANCEL__=!0,e.exports=n},function(e,t,n){"use strict";function r(e){if("function"!=typeof e)throw new TypeError("executor must be a function.");var t;this.promise=new Promise(function(e){t=e});var n=this;e(function(e){n.reason||(n.reason=new o(e),t(n.reason))})}var o=n(23);r.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r.source=function(){var e,t=new r(function(t){e=t});return{token:t,cancel:e}},e.exports=r},function(e,t){"use strict";e.exports=function(e){return function(t){return e.apply(null,t)}}},function(e,t){"use strict";e.exports=function(e){return"object"==typeof e&&e.isAxiosError===!0}}])});
//# sourceMappingURL=axios.min.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(162);
var anObject = __webpack_require__(54);
var speciesConstructor = __webpack_require__(201);
var advanceStringIndex = __webpack_require__(156);
var toLength = __webpack_require__(68);
var callRegExpExec = __webpack_require__(129);
var regexpExec = __webpack_require__(157);
var fails = __webpack_require__(55);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(131)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(54);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(68);
var toInteger = __webpack_require__(113);
var advanceStringIndex = __webpack_require__(156);
var regExpExec = __webpack_require__(129);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(131)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = px2rem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_device_detect__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_device_detect__);
function px2rem(pxValue){var toRem=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;// toRem为false时，不进行rem转换, 使用原尺寸
if(!toRem){return pxValue;}if(typeof window!=='undefined'&&window.templateName==='search'){// 搜索模板根据设备类型进行等比缩放
if(!__WEBPACK_IMPORTED_MODULE_2_react_device_detect__["isTablet"]){var ratio=37.5;// 根据项目配置比例的方式自行设定
// 针对template literals
if(Array.isArray(pxValue)){pxValue=pxValue[0];}if(pxValue.indexOf('%')!==-1){return pxValue;}pxValue=parseInt(pxValue,10);return pxValue/ratio+'rem';}else{// 平板设备不进行等比缩放，使用原尺寸
return pxValue;}}else{// 其他模板全量等比缩放
var _ratio=37.5;// 根据项目配置比例的方式自行设定
// 针对template literals
if(Array.isArray(pxValue)){pxValue=pxValue[0];}if(pxValue.indexOf('%')!==-1){return pxValue;}pxValue=parseInt(pxValue,10);return pxValue/_ratio+'rem';}}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(30);

$export($export.S, 'Array', { isArray: __webpack_require__(159) });


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(347)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__superPropBase_js__ = __webpack_require__(718);

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = Object(__WEBPACK_IMPORTED_MODULE_0__superPropBase_js__["a" /* default */])(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _toConsumableArray(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}var _slicedToArray=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var a,u=t[Symbol.iterator]();!(r=(a=u.next()).done)&&(n.push(a.value),!e||n.length!==e);r=!0);}catch(c){o=!0,i=c}finally{try{!r&&u["return"]&&u["return"]()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_typeof4="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(t,e){if("object"===( false?"undefined":_typeof4(exports))&&"object"===( false?"undefined":_typeof4(module)))module.exports=e();else if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else{var n=e();for(var r in n)("object"===("undefined"==typeof exports?"undefined":_typeof4(exports))?exports:t)[r]=n[r]}}(void 0,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="/",e(0)}([function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.initPti=e.navigateWithTrack=e.uploadPcTrack=e.uploadTrack=e.Exposure=void 0;var o=n(67),i=r(o),a=n(70),u=n(26),c={Exposure:i["default"],uploadTrack:a.uploadTrack,uploadPcTrack:a.uploadPcTrack,navigateWithTrack:a.navigateWithTrack,initPti:u.initPti};"undefined"!=typeof window&&window.Vue&&(window.shihuo=c),e["default"]=c,e.Exposure=i["default"],e.uploadTrack=a.uploadTrack,e.uploadPcTrack=a.uploadPcTrack,e.navigateWithTrack=a.navigateWithTrack,e.initPti=u.initPti},function(t,e){var n=t.exports={version:"2.6.12"};"number"==typeof __e&&(__e=n)},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var r=n(34)("wks"),o=n(25),i=n(2).Symbol,a="function"==typeof i,u=t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))};u.store=r},function(t,e,n){t.exports=!n(12)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(2),o=n(1),i=n(15),a=n(9),u=n(8),c="prototype",s=function f(t,e,n){var s,l,d,p=t&f.F,h=t&f.G,v=t&f.S,g=t&f.P,m=t&f.B,y=t&f.W,w=h?o:o[e]||(o[e]={}),_=w[c],b=h?r:v?r[e]:(r[e]||{})[c];h&&(n=e);for(s in n)l=!p&&b&&void 0!==b[s],l&&u(w,s)||(d=l?b[s]:n[s],w[s]=h&&"function"!=typeof b[s]?n[s]:m&&l?i(d,r):y&&b[s]==d?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e[c]=t[c],e}(d):g&&"function"==typeof d?i(Function.call,d):d,g&&((w.virtual||(w.virtual={}))[s]=d,t&f.R&&_&&!_[s]&&a(_,s,d)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,t.exports=s},function(t,e,n){var r=n(7),o=n(48),i=n(37),a=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(u){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(10);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(6),o=n(19);t.exports=n(4)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){t.exports=function(t){return"object"===("undefined"==typeof t?"undefined":_typeof4(t))?null!==t:"function"==typeof t}},function(t,e,n){t.exports={"default":n(81),__esModule:!0}},function(t,e){t.exports=function(t){try{return!!t()}catch(e){return!0}}},function(t,e,n){var r=n(49),o=n(28);t.exports=function(t){return r(o(t))}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){var r=n(22);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports={}},function(t,e){t.exports=!0},function(t,e,n){var r=n(56),o=n(30);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var r=n(28);t.exports=function(t){return Object(r(t))}},function(t,e,n){t.exports={"default":n(82),__esModule:!0}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(6).f,o=n(8),i=n(3)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.getExposurePtiRefer=e.handleNavigateUrl=e.handleTrackPti=e.initPti=void 0;var o=n(21),i=r(o),a=n(79),u=r(a),c=n(11),s=r(c),f=n(127),l=r(f),d=n(132),p=void 0,h=void 0,v=void 0,g=void 0,m=void 0,y=function(){return{id:"",name:"",biz:"",pageId:"",nextPid:"",root:{id:"",name:"",biz:"",pageId:""},parent:{id:"",name:"",biz:"",pageId:""}}},w=function(){var t=(0,d.v4)()+window.navigator.userAgent;return(0,l["default"])(t)},_=function(t,e){var n=new RegExp("(^|&)"+e+"=([^&]*)(&|$)","i"),r=t.substr(1).match(n);return null!=r?unescape(r[2]).split("#")[0]:null},b=function(t){sessionStorage.setItem("pageStack",(0,s["default"])(t))},x=function(){p=[],h=null,v=-1,g=!1,m=null};x();var O=function(t){var e=t.pageName,n=t.forceAsRoot,r=g;if(x(),!n){var o=void 0;try{o=JSON.parse(sessionStorage.getItem("pageStack")||"[]")}catch(i){o=[]}if("[object Array]"===Object.prototype.toString.call(o)){var a;(a=p).push.apply(a,(0,u["default"])(o))}r?p.length>0&&(m=p[0].pti.nextPid):m=_(window.location.href,"pageKey")}m||(m=w(),p=[]),g=0==p.length;var c=e+"_"+m,s=y();return g?(s.pageId=c,h={pti:s,pageKey:m},v=0,p.push(h)):(p.forEach(function(t,e){h||m!==t.pageKey||(h=t,v=e)}),h?(c=h.pti.pageId,p.splice(v+1,p.length)):(s.pageId=c,h={pti:s,pageKey:m},v=p.length,p.push(h))),b(p),{pageId:c}},k=function(t){if(!h||!t)return y();var e=h,n=e.pti,r=n.pageId,o=t.id,a=t.name,u=t.biz,c=w(),s=p[v-1];if(g)(0,i["default"])(n.root,{id:o,name:a,biz:u,pageId:r});else if(s){var f=s.pti,l=f.id,d=f.name,m=f.biz,_=f.pageId;(0,i["default"])(n.parent,{id:l,name:d,biz:m,pageId:_}),(0,i["default"])(n.root,s.pti.root)}return(0,i["default"])(n,{id:o,name:a,biz:u,pageId:r,nextPid:c}),b(p),n},S=function(t){if(!h)return t;var e=h,n=e.pti,r="&pageKey="+n.nextPid;return t.indexOf("?")==-1&&(r="?"+r),t+=r},T=function(){if(!h)return{};var t=void 0,e=void 0,n=h,r=n.pti,o=p[v-1];if(g){var i={id:"",name:"",biz:"",pageId:r.pageId};t=i,e=i}else if(o){t=o.pti.root;var a=o.pti,u=a.id,c=a.name,s=a.biz,f=a.pageId;e={id:u,name:c,biz:s,pageId:f}}return{pageId:r.pageId,root:t,parent:e}};e.initPti=O,e.handleTrackPti=k,e.handleNavigateUrl=S,e.getExposurePtiRefer=T},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}var o=n(11),i=r(o);!function(){if("undefined"==typeof window)return!0;for(var t=window.location.host,e={callbacks:{},send:function(t,e){this.dispatchMessage("event",t,e)},sendCallback:function(t,e){var r=n.createEnvelope(t,"return",{returnStr:e});this.dispatchMessage("callback",r,function(t){})},triggerCallback:function(t,e){var n=this;setTimeout(function(){n.callbacks[t](e)},0)},dispatchMessage:function(t,e,n){var r=this;this.callbacks[e.id]=function(t){n(t),delete r.callbacks[e.id]};var o="jockey://"+t+"/"+e.id+"?"+encodeURIComponent((0,i["default"])(e)),a=document.createElement("iframe");a.setAttribute("src",o),document.documentElement.appendChild(a),a.parentNode.removeChild(a),a=null}},n={listeners:{},dispatcher:null,messageCount:0,on:function(t,e){(!this.listeners.hasOwnProperty(t)||!this.listeners[t]instanceof Array)&&(this.listeners[t]=[]),this.listeners[t].push(e)},off:function(t){(!this.listeners.hasOwnProperty(t)||!this.listeners[t]instanceof Array)&&(this.listeners[t]=[]),this.listeners[t]=[]},send:function(t,e,n){e instanceof Function&&(n=e,e=null),e=e||{},n=n||function(){};var r=this.createEnvelope(this.messageCount,t,e);this.dispatcher.send(r,n),this.messageCount+=1},trigger:function(t,e,n){for(var r=this,o=this.listeners[t]||[],i=0,a=function(t){i+=1,i>=o.length&&r.dispatcher.sendCallback(e,t)},u=0;u<o.length;u++){var c=o[u];c.length<=1?(c(n),a()):c(n,a)}},triggerCallback:function(t,e){this.dispatcher.triggerCallback(t,e)},createEnvelope:function(e,n,r,o){return{id:e,type:n,host:t,payload:r,returnStr:o}},createCallbackEnvelope:function(t,e){return{id:t,returnStr:e}}},r={send:function(t,e){e()},triggerCallback:function(){},sendCallback:function(){}},o=0,a=!1,u=["iPad","iPhone","iPod"];o<u.length;o++)if("undefined"!=typeof navigator&&navigator.platform.indexOf(u[o])>=0){a=!0;break}var c=/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent),s="undefined"!=typeof navigator?navigator.userAgent.toLowerCase().indexOf("android")>-1:"";a&&c||s?n.dispatcher=e:n.dispatcher=r,window.Jockey=n}()},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var r=n(10),o=n(2).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){function r(t){var e,n;this.promise=new t(function(t,r){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=r}),this.resolve=o(e),this.reject=o(n)}var o=n(22);t.exports.f=function(t){return new r(t)}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(34)("keys"),o=n(25);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(1),o=n(2),i="__core-js_shared__",a=o[i]||(o[i]={});(t.exports=function(t,e){return a[t]||(a[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(17)?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"})},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(35),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(10);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(2),o=n(1),i=n(17),a=n(39),u=n(6).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||u(e,t,{value:a.f(t)})}},function(t,e,n){e.f=n(3)},function(t,e,n){var r=n(108)(!0);n(52)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e){t.exports={getRaw:function(t,e){if("undefined"==typeof window)return"";if(this._isValidKey(t)){var n=new RegExp("(^| )"+t+"=([^;]*)(;|$)"),r=e||document.cookie,o=n.exec(r);if(o)return o[2]||""}return""},setRaw:function(t,e,n){if(this._isValidKey(t)){n=n||{};var r=n.expires;"number"==typeof n.expires&&(r=new Date,r.setTime(r.getTime()+n.expires)),document.cookie=t+"="+e+(n.path?"; path="+n.path:"")+(r?"; expires="+r.toGMTString():"")+(n.domain?"; domain="+n.domain:"")+(n.secure?"; secure":"")}},remove:function(t,e){e=e||{},e.expires=new Date(0),this.setRaw(t,"",e)},_isValidKey:function(t){return new RegExp('^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$').test(t)}}},function(t,e){t.exports={getVersion:function(){var t="undefined"!=typeof navigator?navigator.userAgent:"",e=/\s(shihuo\/.*?)\s/,n=e.exec(t),r=n?n[1].split("/")[1]:null;return r},isShihuo:function(){if("undefined"==typeof window)return!0;var t="undefined"!=typeof navigator?navigator.userAgent.toLowerCase():"";return t.indexOf("shihuo")>-1},isAndroid:function n(){var n="undefined"!=typeof navigator?navigator.userAgent.toLowerCase().indexOf("android")>-1:"";return n},get_android_version:function(){var t=navigator.userAgent.toLowerCase(),e=t.match(/android\s([0-9\.]*)/);return console.log("==version=match=",e),!!e&&e[1]},SHDiffVersion:function(t,e){if(!t||!e)return null;for(var n=t.split("."),r=e.split("."),o=Math.min(n.length,r.length),i=0,a=0;a<o&&(i=parseInt(n[a])-parseInt(r[a]),0==i);)a++;return i>=0},isJSON:function(t){try{JSON.parse(t)}catch(e){return!1}return!0}}},function(t,e,n){t.exports={"default":n(84),__esModule:!0}},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(76),i=r(o),a=n(75),u=r(a),c="function"==typeof u["default"]&&"symbol"===_typeof4(i["default"])?function(t){return"undefined"==typeof t?"undefined":_typeof4(t)}:function(t){return t&&"function"==typeof u["default"]&&t.constructor===u["default"]&&t!==u["default"].prototype?"symbol":"undefined"==typeof t?"undefined":_typeof4(t)};e["default"]="function"==typeof u["default"]&&"symbol"===c(i["default"])?function(t){return"undefined"==typeof t?"undefined":c(t)}:function(t){return t&&"function"==typeof u["default"]&&t.constructor===u["default"]&&t!==u["default"].prototype?"symbol":"undefined"==typeof t?"undefined":c(t)}},function(t,e){var n={utf8:{stringToBytes:function(t){return n.bin.stringToBytes(unescape(encodeURIComponent(t)))},bytesToString:function(t){return decodeURIComponent(escape(n.bin.bytesToString(t)))}},bin:{stringToBytes:function(t){for(var e=[],n=0;n<t.length;n++)e.push(255&t.charCodeAt(n));return e},bytesToString:function(t){for(var e=[],n=0;n<t.length;n++)e.push(String.fromCharCode(t[n]));return e.join("")}}};t.exports=n},function(t,e,n){var r=n(14),o=n(3)("toStringTag"),i="Arguments"==r(function(){return arguments}()),a=function(t,e){try{return t[e]}catch(n){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=a(e=Object(t),o))?n:i?r(e):"Object"==(u=r(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){var r=n(2).document;t.exports=r&&r.documentElement},function(t,e,n){t.exports=!n(4)&&!n(12)(function(){return 7!=Object.defineProperty(n(29)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(14);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(16),o=n(3)("iterator"),i=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||i[o]===t)}},function(t,e,n){var r=n(7);t.exports=function(t,e,n,o){try{return o?e(r(n)[0],n[1]):e(n)}catch(i){var a=t["return"];throw void 0!==a&&r(a.call(t)),i}}},function(t,e,n){var r=n(17),o=n(5),i=n(59),a=n(9),u=n(16),c=n(96),s=n(24),f=n(104),l=n(3)("iterator"),d=!([].keys&&"next"in[].keys()),p="@@iterator",h="keys",v="values",g=function(){return this};t.exports=function(t,e,n,m,y,w,_){c(n,e,m);var b,x,O,k=function(t){if(!d&&t in E)return E[t];switch(t){case h:return function(){return new n(this,t)};case v:return function(){return new n(this,t)}}return function(){return new n(this,t)}},S=e+" Iterator",T=y==v,I=!1,E=t.prototype,A=E[l]||E[p]||y&&E[y],j=A||k(y),R=y?T?k("entries"):j:void 0,M="Array"==e?E.entries||A:A;if(M&&(O=f(M.call(new t)),O!==Object.prototype&&O.next&&(s(O,S,!0),r||"function"==typeof O[l]||a(O,l,g))),T&&A&&A.name!==v&&(I=!0,j=function(){return A.call(this)}),r&&!_||!d&&!I&&E[l]||a(E,l,j),u[e]=j,u[S]=g,y)if(b={values:T?j:k(v),keys:w?j:k(h),entries:R},_)for(x in b)x in E||i(E,x,b[x]);else o(o.P+o.F*(d||I),e,b);return b}},function(t,e,n){var r=n(3)("iterator"),o=!1;try{var i=[7][r]();i["return"]=function(){o=!0},Array.from(i,function(){throw 2})}catch(a){}t.exports=function(t,e){if(!e&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},t(i)}catch(u){}return n}},function(t,e,n){var r=n(7),o=n(101),i=n(30),a=n(33)("IE_PROTO"),u=function(){},c="prototype",s=function(){var t,e=n(29)("iframe"),r=i.length,o="<",a=">";for(e.style.display="none",n(47).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write(o+"script"+a+"document.F=Object"+o+"/script"+a),t.close(),s=t.F;r--;)delete s[c][i[r]];return s()};t.exports=Object.create||function(t,e){var n;return null!==t?(u[c]=r(t),n=new u,u[c]=null,n[a]=t):n=s(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(56),o=n(30).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e,n){var r=n(8),o=n(13),i=n(90)(!1),a=n(33)("IE_PROTO");t.exports=function(t,e){var n,u=o(t),c=0,s=[];for(n in u)n!=a&&r(u,n)&&s.push(n);for(;e.length>c;)r(u,n=e[c++])&&(~i(s,n)||s.push(n));return s}},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(e){return{e:!0,v:e}}}},function(t,e,n){var r=n(7),o=n(10),i=n(31);t.exports=function(t,e){if(r(t),o(e)&&e.constructor===t)return e;var n=i.f(t),a=n.resolve;return a(e),n.promise}},function(t,e,n){t.exports=n(9)},function(t,e,n){var r=n(7),o=n(22),i=n(3)("species");t.exports=function(t,e){var n,a=r(t).constructor;return void 0===a||void 0==(n=r(a)[i])?e:o(n)}},function(t,e,n){var r,o,i,a=n(15),u=n(94),c=n(47),s=n(29),f=n(2),l=f.process,d=f.setImmediate,p=f.clearImmediate,h=f.MessageChannel,v=f.Dispatch,g=0,m={},y="onreadystatechange",w=function(){var t=+this;if(m.hasOwnProperty(t)){var e=m[t];delete m[t],e()}},_=function(t){w.call(t.data)};d&&p||(d=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return m[++g]=function(){u("function"==typeof t?t:Function(t),e)},r(g),g},p=function(t){delete m[t]},"process"==n(14)(l)?r=function(t){l.nextTick(a(w,t,1))}:v&&v.now?r=function(t){v.now(a(w,t,1))}:h?(o=new h,i=o.port2,o.port1.onmessage=_,r=a(i.postMessage,i,1)):f.addEventListener&&"function"==typeof postMessage&&!f.importScripts?(r=function(t){f.postMessage(t+"","*")},f.addEventListener("message",_,!1)):r=y in s("script")?function(t){c.appendChild(s("script"))[y]=function(){c.removeChild(this),w.call(t)}}:function(t){setTimeout(a(w,t,1),0)}),t.exports={set:d,clear:p}},function(t,e,n){var r=n(46),o=n(3)("iterator"),i=n(16);t.exports=n(1).getIteratorMethod=function(t){if(void 0!=t)return t[o]||t["@@iterator"]||i[r(t)]}},function(t,e){},function(t,e,n){n(112);for(var r=n(2),o=n(9),i=n(16),a=n(3)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),c=0;c<u.length;c++){var s=u[c],f=r[s],l=f&&f.prototype;l&&!l[a]&&o(l,a,s),i[s]=i.Array}},function(t,e){function n(t,e){var n=e||0,o=r;return[o[t[n++]],o[t[n++]],o[t[n++]],o[t[n++]],"-",o[t[n++]],o[t[n++]],"-",o[t[n++]],o[t[n++]],"-",o[t[n++]],o[t[n++]],"-",o[t[n++]],o[t[n++]],o[t[n++]],o[t[n++]],o[t[n++]],o[t[n++]]].join("")}for(var r=[],o=0;o<256;++o)r[o]=(o+256).toString(16).substr(1);t.exports=n},function(t,e){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var r=new Uint8Array(16);t.exports=function(){return n(r),r}}else{var o=new Array(16);t.exports=function(){for(var t,e=0;e<16;e++)0===(3&e)&&(t=4294967296*Math.random()),o[e]=t>>>((3&e)<<3)&255;return o}}},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(69),i=r(o);e["default"]=i["default"]},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}function o(t){if(t&&0!==t.length)if(g["default"].isShihuo()){if(g["default"].SHDiffVersion(O.version,"6.79.0")){var e=!0;if(g["default"].isAndroid()&&!g["default"].SHDiffVersion(O.version,"6.88.0")){var n=g["default"].get_android_version();n&&!g["default"].SHDiffVersion(n,"6.0.1")&&(e=!1)}if(e){var r=[],o=[];t.forEach(function(t){var e=t.st,n=t.et,i=t.value;if("string"==typeof i)try{i=JSON.parse(i)}catch(a){return{}}var u=i,c=u.exposekey,s=u.id,f=u.name;r.push({st:String(e),et:String(n),expose_key:c,id:s,name:f}),o.push(c)}),console.log("uploadExposures=list,old=",o,"new",r,"undefined"!=typeof Jockey,x),"undefined"!=typeof Jockey&&x&&Jockey.send("uploadExposures",{list:o,exposureList:r},function(t){console.log("uploadExposures==上报结束",t)})}}}else{var i={};t.forEach(function(t){var e=t.pti_refer,n=e||{},r=n.pageId,o=r||"extras";i[o]?i[o].push(t):i[o]=[t]}),(0,f["default"])(i).forEach(function(t){var e=i[t],n="",r=[],o={};e.forEach(function(t,i){var a=t.st,u=t.et,c=t.value;t.extra;if("string"==typeof c)try{c=JSON.parse(c)}catch(s){return{}}var f=c,l=f.exposekey,d=f.id,p=f.name,h=f.biz;l&&(n=n+l+".@"+a+"_"+u+(i===e.length-1?"":"#")),r.push({id:d,biz:h,name:p,time:{st:a,et:u}}),!o&&t.pti_refer&&(o=t.pti_refer)});var u=(new Date).getTime(),s=(0,c["default"])(O,{exposure_time:u,action_time:u,exposure_str:n,pti:(0,a["default"])({pti_refer:o,ptis:r})}),f=b+d["default"].stringify(s);(new Image).src=f})}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(11),a=r(i),u=n(21),c=r(u),s=n(43),f=r(s),l=n(129),d=r(l),p=n(41),h=r(p);n(27);var v=n(42),g=r(v),m="undefined"!=typeof window?window.localStorage.getItem("m_device_id"):"",y=function(){var t=function(){for(var t=1*new Date,e=0;t==1*new Date;)e++;return t.toString(16)+e.toString(16)},e=function(){return Math.random().toString(16).replace(".","")},n=function(t){function e(t,e){var n,r=0;for(n=0;n<e.length;n++)r|=i[n]<<8*n;return t^r}var n,r,o="undefined"!=typeof navigator?navigator.userAgent:"",i=[],a=0;for(n=0;n<o.length;n++)r=o.charCodeAt(n),i.unshift(255&r),i.length>=4&&(a=e(a,i),i=[]);return i.length>0&&(a=e(a,i)),a.toString(16)};return function(){var r=String(screen.height*screen.width);r=r&&/\d{5,}/.test(r)?r.toString(16):String(31242*Math.random()).replace(".","").slice(0,8);var o=t()+"-"+e()+"-"+n()+"-"+r+"-"+t();return o?o:(String(Math.random())+String(Math.random())+String(Math.random())).slice(2,15)}}(),w="undefined"!=typeof navigator?navigator.userAgent:"",_={ios:/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(w),android:/android|Android/i.test(w)||/Linux/i.test(w),wechat:/micromessenger/i.test(w)||"undefined"!=typeof navigator&&"undefined"!=typeof navigator.wxuserAgent,weibo:/WeiBo/i.test(w)},b="https://shihuo-new.cn-hangzhou.log.aliyuncs.com/logstores/frontend_exposure/track.gif?APIVersion=0.6.0&",x=w.match(/sc\((.+?)\)/i),O={app_type:_.android?1:_.ios?2:null,channel:x?"H5-"+x[1].split(",")[1]:"H5-"+encodeURIComponent(w),exposure_time:null,device_id:m,exposure_str:"",pti:"",extra:"",idfa:"",is_login:null,ss_id:"",uid:h["default"].getRaw("sh_u"),version:g["default"].getVersion(),abtest_tag:"",action_time:(new Date).getTime(),user_agent:"undefined"!=typeof navigator?navigator.userAgent:""};_.wechat&&(O.channel="H5-exposure_wechat"),_.weibo&&(O.channel="H5-exposure_weibo"),e["default"]=function(t){t=t.map(function(t){if("string"==typeof str)try{return JSON.parse(str)}catch(e){return{}}return t}),O.device_id?o(t):(m||(m=y(),"undefined"!=typeof window&&window.localStorage.setItem("m_device_id",m)),O.device_id=m,o(t))}},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(77),u=r(a),c=n(78),s=r(c);n(125);var f=n(26),l=n(68),d=r(l);"undefined"!=typeof IntersectionObserver&&(IntersectionObserver.prototype.THROTTLE_TIMEOUT=300);var p=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:10;(0,u["default"])(this,t),this.dotDataArr=[],this.maxNum=e,this._timer=0,this.init()}return(0,s["default"])(t,[{key:"init",value:function(){if("undefined"!=typeof IntersectionObserver){var t=this;this.dotFromLocalStorage(),this.beforeLeaveWebview(),this._observer=new IntersectionObserver(function(e,n){var r=(new Date).getTime();e.forEach(function(e){var n=e.target.attributes["data-dot"].value,o=-1;if(t.dotDataArr&&t.dotDataArr.map&&t.dotDataArr.map(function(t,e){t.value==n&&(o=e)}),e.isIntersecting&&e.intersectionRatio>0){if(o==-1&&n){var i=(0,f.getExposurePtiRefer)();t.dotDataArr.push({value:n,st:r,pti_refer:i})}}else{if(clearTimeout(t._timer),o!=-1){var a=t.dotDataArr[o];t.dotDataArr.splice(o,1,{value:a.value,st:a.st,et:r,pti_refer:a.pti_refer})}t.dotDataArr.length>=t.maxNum?t.dot():(t.storeIntoLocalstorage(t.dotDataArr),"undefined"!=typeof window&&t.dotDataArr.length>0&&(t._timer=window.setTimeout(function(){t.dot()},2e3)))}})},{root:null,rootMargin:"0px",threshold:.1})}}},{key:"add",value:function(t){this._observer&&this._observer.observe(t.el)}},{key:"dot",value:function(){var t=[],e=[];this.dotDataArr.forEach(function(n,r){var o=n.et,i=n.st;o&&i&&o>i?t.push(n):e.push(n)}),this.dotDataArr=e,(0,d["default"])(t),this.storeIntoLocalstorage(this.dotDataArr)}},{key:"storeIntoLocalstorage",value:function(t){"undefined"!=typeof window&&window.localStorage&&window.localStorage.setItem("dotDataArr",(0,i["default"])(t))}},{key:"dotFromLocalStorage",value:function(){if("undefined"!=typeof window&&window.localStorage){var t=window.localStorage.getItem("dotDataArr");if(t){var e=JSON.parse(t)||[];e.forEach(function(t,n){e[n].et=(new Date).getTime()}),e&&e.length>0&&((0,d["default"])(e),this.storeIntoLocalstorage([]))}}}},{key:"beforeLeaveWebview",value:function(){this.dotDataArr.length>0&&(0,d["default"])(this.dotDataArr)}}]),t}();e["default"]=p},function(t,e,n){(function(t){function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.navigateWithTrack=e.uploadPcTrack=e.uploadTrack=void 0;var o=n(43),i=r(o),a=n(11),u=r(a),c=n(21),s=r(c),f=n(44),l=r(f);n(27);var d=n(42),p=r(d),h=n(71),v=n(26),g=function(){var t=function(){for(var t=1*new Date,e=0;t==1*new Date;)e++;return t.toString(16)+e.toString(16)},e=function(){return Math.random().toString(16).replace(".","")},n=function(t){function e(t,e){var n,r=0;for(n=0;n<e.length;n++)r|=i[n]<<8*n;return t^r}var n,r,o="undefined"!==navigator?navigator.userAgent:"",i=[],a=0;for(n=0;n<o.length;n++)r=o.charCodeAt(n),i.unshift(255&r),i.length>=4&&(a=e(a,i),i=[]);return i.length>0&&(a=e(a,i)),a.toString(16)};return function(){var r=String(screen.height*screen.width);r=r&&/\d{5,}/.test(r)?r.toString(16):String(31242*Math.random()).replace(".","").slice(0,8);var o=t()+"-"+e()+"-"+n()+"-"+r+"-"+t();return o?o:(String(Math.random())+String(Math.random())+String(Math.random())).slice(2,15)}}(),m=function(t,e,n){t.pti=(0,v.handleTrackPti)(t.pti);var r="undefined"!=typeof window?window.localStorage.getItem("m_device_id"):"";r||(r=g(),"undefined"!=typeof window&&window.localStorage.setItem("m_device_id",r)),"object"!==("undefined"==typeof t?"undefined":(0,l["default"])(t))&&(t={}),"object"!==("undefined"==typeof n?"undefined":(0,l["default"])(n))&&(n={});var o=t,a=o.pti,c=void 0===a?{}:a;delete t.pti,e||(e="shihuo://www.shihuo.cn?route=action");var f=(0,s["default"])({},n,{pti:c,urlinfo:e.split("#")[0]+"#"+encodeURIComponent((0,u["default"])(t)),abtest_tag:"",device_id:r,action_time:(new Date).getTime(),user_agent:"undefined"!=typeof navigator?navigator.userAgent:"",APIVersion:"0.6.0"}),d="undefined"!=typeof window&&window.HW_MANAGED_JS&&window.HW_MANAGED_JS.getOaid?window.HW_MANAGED_JS.getOaid():"";d&&(f.clientCode="oaid-"+d);var p="";(0,i["default"])(f).forEach(function(t){var e=f[t];"object"===("undefined"==typeof e?"undefined":(0,l["default"])(e))?e=(0,u["default"])(e):"string"!=typeof e&&(e+=""),p+=""+(p?"&":"")+t+"="+encodeURIComponent(e)}),(new Image).src="https://shihuo-new.cn-hangzhou.log.aliyuncs.com/logstores/frontend_appclick/track.gif?"+p},y=function(t){var e="undefined"!=typeof window?window.localStorage.getItem("pc_device_id"):"";e||(e=g(),"undefined"!=typeof window&&window.localStorage.setItem("pc_device_id",e)),"object"!==("undefined"==typeof t?"undefined":(0,l["default"])(t))&&(t={});var n=t,r=n.pti,o=void 0===r?{}:r,a=n.client_code,c=void 0===a?"":a,f=n.channel,d=void 0===f?"":f,p=n.urlinfo,h=void 0===p?"":p,v=(0,s["default"])({},t,{pti:o,urlinfo:h,abtest_tag:"",device_id:e,client_code:c,channel:d,action_time:(new Date).getTime(),user_agent:"undefined"!=typeof navigator?navigator.userAgent:"",APIVersion:"0.6.0"}),m="";(0,i["default"])(v).forEach(function(t){var e=v[t];"object"===("undefined"==typeof e?"undefined":(0,l["default"])(e))?e=(0,u["default"])(e):"string"!=typeof e&&(e+=""),m+=""+(m?"&":"")+t+"="+encodeURIComponent(e)}),(new Image).src="https://shihuo-new.cn-hangzhou.log.aliyuncs.com/logstores/pc_appclick/track.gif?"+m},w=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{id:"",name:"",key:key,positions:positions},r=e?"shihuo://www.shihuo.cn?route="+e:"shihuo://www.shihuo.cn?route=action";"object"!==("undefined"==typeof t?"undefined":(0,l["default"])(t))&&(t={});var o=(0,s["default"])({},t,{from:t.from||"",block:t.block||"",extra:t.extra||"",lspm:t.lspm||"",dspm:t.dspm||""});Jockey.send("sendDace",{url:r+"#"+encodeURIComponent((0,u["default"])(o)),pti:n})},_=function(t,e,n){if(p["default"].isShihuo()){var r=t?t.pti:null;Object.hasOwnProperty.call(t,"pti")&&delete t.pti,p["default"].SHDiffVersion(p["default"].getVersion(),"6.71.0")?w(t,e,r):(0,h.uploadTrackOldVersion)(e,t,r)}else m(t,e,n)},b=function(t){var e=t.url,n=t.pageOptions,r=t.pti,o=void 0===r?{id:"",name:"",key:key,positions:positions}:r,i=e.split("#");!p["default"].isAndroid()||0!==i[0].indexOf("http://")&&0!==i[0].indexOf("https://")||(i[0]="shihuo://www.shihuo.cn?route=fastWebview&url="+i[0]);var a=decodeURIComponent(i[1]);if(n&&i.length>1&&p["default"].isJSON(a)){var c=JSON.parse(a);c instanceof Object&&((0,s["default"])(c,n),e=i[0]+"#"+encodeURIComponent((0,u["default"])(c)))}else n&&1===i.length&&(e=i[0]+"#"+encodeURIComponent((0,u["default"])(n)));console.log("url===",e),Jockey.send("action",{url:e,pti:o})},x=function(t){var e=t.url,n=t.pageOptions,r=t.pti,o=t.otherApp;if(e&&"string"==typeof e)if(p["default"].isShihuo())console.log("客户端跳转"),b({url:e,pageOptions:n,pti:r});else{console.log("站外跳转");var i=(0,s["default"])({},n,{pti:r}),a=void 0;if(a=o?"shihuo://www.shihuo.cn?route=go&url="+encodeURIComponent(e):"shihuo://www.shihuo.cn?route=h5&url="+encodeURIComponent(e),_(i,a),e=(0,v.handleNavigateUrl)(e),"undefined"!=typeof window){window.location.href=e}}};e.uploadTrack=_,e.uploadPcTrack=y,e.navigateWithTrack=x}).call(e,n(128))},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.uploadTrackOldVersion=void 0;var o=n(21),i=r(o),a=n(74),u=r(a),c=n(11),s=r(c),f=n(44),l=r(f),d=n(41),p=r(d);n(27);var h="__dacevid3",v="__dacemvst",g="ukn",m="undefined"!=typeof window&&window.navigator,y=(m&&(m.language||m.browserLanguage)||"-").toLowerCase(),w={"m.hupu.com":"WL_tch_m","m.shihuo.cn":"WL_biz_sh_m","m.aicai.com":"WL_biz_accp_m","kanqiu.hupu.com":"wl_tch_kq_m","socialmedia.hupu.com":"wl_tch_mini_sm","yangzhoumarathon.hupu.com":"wl_tch_mini_yangma","shanghaimarathon2015.hupu.com":"wl_tch_mini_shangma",
"m.nflchina.com":"wl_tch_mini_nfl","webtoyota.hupu.com":"wl_tch_mini_toyota","www.thearenacapital.com":"wl_tch_pub_arena","suarez.hupu.com":"wl_tch_mini_suarez","www.fcbayern.cn":"wl_tch_mini_bayern","equipmentday2015.hupu.com":"wl_tch_mini_ed2015","sundownmarathon2015.hupu.com":"wl_tch_mini_sdm2015","lspj.hupu.com":"wl_tch_mini_lspj","passport.hupu.com":"wl_tch_pspt","m.smartcourt.cn":"wl_biz_smartcourt_m","m.ledong100.com":"wl_ec_hz_chulian","du.hupu.com":"web_biz_du","bbs.mobileapi.hupu.com":"wl_tch_kqbbs","m.kaluli.com":"wl_biz_kll_m","t.shihuo.cn":"wl_biz_sh_m","games.mobileapi.hupu.com":"wl_tch_kq_games","lite.hupu.com":"wl_tch_kq_m","fantasy.hupu.com":"wl_tch_kq_fantasy"},_=["m.shihuo.cn","aicai.com","nflchina.com","thearenacapital.com","fcbayern.cn","smartcourt.cn","ledong100.com","kaluli.com","t.shihuo.cn"];g="undefined"!=typeof window&&w[window.location.host]||g;var b="http://shihuo.cn-hangzhou.log.aliyuncs.com/logstores",x="undefined"!=typeof navigator?navigator.userAgent.toLowerCase():"",O={version:(x.match(/.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/)||[])[1],chrome:/chrome/.test(x),safari:/webkit/.test(x),opera:/opera/.test(x),msie:/msie/.test(x)&&!/opera/.test(x),mozilla:/mozilla/.test(x)&&!/(compatible|webkit)/.test(x),mobile:/Mobile/i.test(x),ios:/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(x),iphone:/iphone/i.test(x),ipad:/ipad/i.test(x),android:/android|Android/i.test(x)||/Linux/i.test(x),app:/hupush|prokanqiu|shihuo/i.test(x),shihuo:/shihuo/i.test(x),hupu:/hupush/i.test(+x)},k=["www.google.com.hk","www.google.com","www.baidu.com","www.so.com","www.sogou.com","www.soso.com","cn.bing.com","glb.uc.cn","so.360.cn","www.youdao.com","search.cn.yahoo.com","www.jike.com","pad.easou.com","www.zhongsou.com","image.baidu.com","images.baidu.com","m.baidu.com","images.google.com","images.google.com.hk","m.sm.cn","www.haosou.com"],S={},T="/shihuo_dace",I="",E=!1,A=function(t,e){return t.onload=e},j=function(t){var e=new RegExp("(^[\\s\\t\\xa0\\u3000]+)|([\\u3000\\xa0\\s\\t]+$)","g");return t.replace(e,"")},R=function(){if("undefined"==typeof window)return!0;var t={},e=(window.navigator,window.screen);return t.crs=e?e.width+"x"+e.height:"-",t},M=function(){return(65536*(1+Math.random())|0).toString(16).substring(1)},C=function(){return M()+M()+"."+M()+M()},P=(C(),function(){var t=C(),e=p["default"].getRaw(v),n=new Date,r=n.getTime();n.setUTCMinutes(n.getUTCMinutes()+30);var o=n.getTime();e&&(o<=r?p["default"].remove(v):(p["default"].remove(v),t=e.split("|")[0]));for(var i=_.length,a=0;a<i;a++){var u=new RegExp("/"+_[a]+"/i");if("undefined"!=typeof window&&u.exec(window.location.host))var c="."+_[a]+".com"}return p["default"].setRaw(v,t+"|"+o,{expires:18e5,domain:c,path:"/"}),t}),L=function(){var t=t||{},e=document.referrer,n=e?e.split("/")[2]:"";if(e&&n)for(var r=function(t){var n=t+"=([^&|/]*)",r=new RegExp(n,"gi");r.exec(e);var o=RegExp.$1;return o?o:""},o=function(t){if(!t)return!1;var e="";if(t.indexOf("baidu.com")>=0){var n=r("wd"),o=r("kw"),i=r("word"),a=r("w");return j(n)?n:j(o)?o:j(i)?i:j(a)?a:e}return t.indexOf("so.360.cn")>=0||t.indexOf("pad.easou.com")>=0||t.indexOf("jike.com")>=0||t.indexOf("yahoo.com")>=0||t.indexOf("youdao.com")>=0||t.indexOf("bing.com")>=0||t.indexOf("google")>=0||t.indexOf("www.so.com")>=0||t.indexOf("m.sm.cn")>=0||t.indexOf("www.haosou.com")>=0?e=j(r("q")):t.indexOf("sogou.com")>=0?e=j(r("query")):t.indexOf("zhongsou.com")>=0||t.indexOf("www.soso.com")>=0?e=j(r("w")):t.indexOf("uc.cn")>=0&&(e=j(r("keyword"))),t.indexOf("baidu.com")<0&&!e?"ukn":e},i=0;i<k.length;i++){if(n==k[i]||n.indexOf("google")>=0){var a=o(n);t.rnm="",t.rurl=n,"m.baidu.com"==n?(t.rkw="",t.mrkw=a):(t.rkw=a,t.mrkw=a);break}t.rnm="",t.rurl=n,t.rkw="",t.ref=e}return t},N=function(t,e,n){if("undefined"==typeof window)return!0;var r=new Date,o=L();if("i"===t){var i=[];if("object"==("undefined"==typeof o?"undefined":(0,l["default"])(o)))for(var a in o){var u=o[a].replace(new RegExp("\r","g"),"",o[a]);u=u.replace(new RegExp("\n","g"),"",u),i.push(a+"="+("rkw"!=a?encodeURIComponent(u):u))}else i.push("rurl="),i.push("rkw=");var c=R();for(var f in c)i.push(f+"="+c[f]);window.__isNewUser||1==window.inu?i.push("inu=1"):i.push("inu=0");var d=i.join("&"),v=d+"&et=wap&sid="+g+"&vid="+p["default"].getRaw(h)+"&vst="+P()+"&cbl="+y+"&path="+encodeURIComponent(window.location.href)+"&utmn="+1e6*Math.random()}else var v="et=wap_event&act="+t+"&sid="+g+"&vid="+p["default"].getRaw(h)+"&vst="+P()+"&cbl="+y+"&link="+encodeURIComponent(e)+"&url="+encodeURIComponent(window.location.href)+"&vtm="+r.getTime()+"&q="+1e6*Math.random();return p["default"].getRaw("_kanqiu")&&(v+="&kqc="+p["default"].getRaw("_kanqiu")),window.__daceDataNameOfChannel&&(v+="&chv="+__daceDataNameOfChannel),window.__daceDataNameOfForum&&(v+="&bbs="+__daceDataNameOfForum),window.__dacePageGroup&&(v+="&grp="+__dacePageGroup),window.__daceDataNameOfPage&&(v+="&ptp="+__daceDataNameOfPage),p["default"].getRaw("__dacecid")&&(v+="&cid="+p["default"].getRaw("__dacecid")),"object"===("undefined"==typeof n?"undefined":(0,l["default"])(n))&&(v+="&action="+(0,s["default"])(n)),v},F=function(t,e){var n="";for(var r in t)"undefined"!=typeof e[r]&&(t[r]=e[r]),n+="&"+r+"="+t[r];return{data:t,uri:n}},D=function(t){return new u["default"](function(e,n){var r={},o=t.split("&"),a={uid:"",app_type:"",urlinfo:"",device_id:"",version:"",channel:"",click_time:"",idfa:"",abtest_tag:"",sh_session:""};U().then(function(t){if(t&&"object"==("undefined"==typeof t?"undefined":(0,l["default"])(t))&&(0,i["default"])(S,t),O.app){for(var n=0;n<o.length;n++)r[o[n].split("=")[0]]=o[n].split("=")[1];r.url||(r.url="shihuo://www.shihuo.cn?route=action"),r.app_type=I;var u={from:r.from||r.url,block:r.link};r.action&&(u=(0,i["default"])(u,JSON.parse(r.action))),r.urlinfo=encodeURIComponent("shihuo://www.shihuo.cn?route=action#"+encodeURIComponent((0,s["default"])(u))),r.channel=S.channel,r.version=S.version,r.click_time=r.vtm,r.uid=p["default"].getRaw("sh_u")||"",1!=I&&0!=I||!t.idfa?r.device_id=S.device_id:r.device_id=t.idfa,r.abtest_tag=S.abtest_tag||"",r.sh_session=S.sh_session||""}else{for(var n=0;n<o.length;n++)r[o[n].split("=")[0]]=o[n].split("=")[1];r.url=r.path}"undefined"==typeof r.act&&(r.act="i"),window.location.href.indexOf("shihuo.hupu.com")>-1?"undefined"!=typeof Jockey?setTimeout(function(){Jockey.send("fetchCookies",{url:"//m.poizon.com"},function(t){0==t.status&&(r.uid=p["default"].getRaw("ua",t.data.str.split(";").join("; "))||""),a=F(a,r),e(a.uri)})},500):(a=F(a,r),e(a.uri)):"undefined"!=typeof Jockey&&1==I?Jockey.send("fetchCookies",{url:"//www.shihuo.cn"},function(t){if(0==t.status&&t.data&&t.data.str){var n=t.data.str.split(";").join("; "),o=p["default"].getRaw("u",n);r.uid=o?o.split("|")[0]:""}a=F(a,r),e(a.uri)}):(a=F(a,r),e(a.uri))})})},U=function(){return new u["default"](function(t,e){Jockey.send("device",{},function(e){t(e)})})},z=function(t){if("undefined"!=typeof Jockey){var e=b+T+"/track?APIVersion=0.6.0"+t;Jockey.send("request",{type:"GET",url:e},function(t){})}else{var n=b+T+"/track.gif?APIVersion=0.6.0",r=new Image(1,1);r.src=n+t,A(r,function(){A(r,"")})}},V=function(t){var e="//shihuo-new.cn-hangzhou.log.aliyuncs.com/logstores/frontend-log/track.gif?APIVersion=0.6.0&evt=web_frontend",n=new Image(1,1);n.src=e+t,A(n,function(){A(n,"")})},B=function(t,e){if("undefined"==typeof window)return!0;var n={},r=(t.split("&"),{uid:"",app_type:"",url:"",device_id:"",param:"",sh_session:""});return n.app_type=I,n.url=window.location.href,n.device_id=S.device_id,n.uid=n.lgn,n.param=e?encodeURIComponent((0,s["default"])(e)):"",n.sh_session=S.sh_session||"",r=F(r,n),r.uri},J=function(){var t=[];if("undefined"!=typeof window.performance&&"undefined"!=typeof window.performance.getEntriesByType)for(var e=window.performance.getEntriesByType("resource"),n=0;n<e.length;n++)if("img"!=e[n].initiatorType&&e[n].name.match(hostreg)){var r=e[n].name.match(hostreg)[0].slice(e[n].name.match(hostreg)[0].indexOf(".")+1,e[n].name.match(hostreg)[0].length-1);csphost.indexOf(r)<0&&t.push(e[n].name)}return t},W=function(t){for(var e={},n=t.split("&"),r=0;r<n.length;r++)e[n[r].split("=")[0]]=n[r].split("=")[1];if("undefined"!=typeof sa){var o=e.action?JSON.parse(e.action):{},a={name:e.link};(0,i["default"])(a,o),sa.track("webClickEvent",a)}},q=function(t,e){if("undefined"!=typeof window){t=N("e",t,e);/^https/i.test(location.href)?"//ccdace.hupu.com":"//cc.dace.hupu.com",new Image(1,1);if(t&&t.match(/rd_e_wap_event|wap_event/i)){for(var n=t.split("&"),r="",o=0;o<n.length;o++)"link"==n[o].split("=")[0]&&(r=n[o].split("=")[1]);O.app?D(t+"&clk="+r).then(function(t){z(t)}):W(t)}else O.app&&(E||"undefined"==typeof window||(window.onload=function(){E=!0;var e=J();"undefined"!=typeof window.performance&&"undefined"!=typeof window.performance.getEntriesByType&&e.length>0&&(t=B(t,e),V(t))}))}};e.uploadTrackOldVersion=q},function(t,e,n){t.exports={"default":n(80),__esModule:!0}},function(t,e,n){t.exports={"default":n(83),__esModule:!0}},function(t,e,n){t.exports={"default":n(85),__esModule:!0}},function(t,e,n){t.exports={"default":n(86),__esModule:!0}},function(t,e,n){t.exports={"default":n(87),__esModule:!0}},function(t,e){e.__esModule=!0,e["default"]=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(73),i=r(o);e["default"]=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,i["default"])(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}()},function(t,e,n){function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(72),i=r(o);e["default"]=function(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return(0,i["default"])(t)}},function(t,e,n){n(40),n(111),t.exports=n(1).Array.from},function(t,e,n){var r=n(1),o=r.JSON||(r.JSON={stringify:JSON.stringify});t.exports=function(t){return o.stringify.apply(o,arguments)}},function(t,e,n){n(113),t.exports=n(1).Object.assign},function(t,e,n){n(114);var r=n(1).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){n(115),t.exports=n(1).Object.keys},function(t,e,n){n(63),n(40),n(64),n(116),n(118),n(119),t.exports=n(1).Promise},function(t,e,n){n(117),n(63),n(120),n(121),t.exports=n(1).Symbol},function(t,e,n){n(40),n(64),t.exports=n(39).f("iterator")},function(t,e){t.exports=function(){}},function(t,e){t.exports=function(t,e,n,r){if(!(t instanceof e)||void 0!==r&&r in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var r=n(13),o=n(36),i=n(109);t.exports=function(t){return function(e,n,a){var u,c=r(e),s=o(c.length),f=i(a,s);if(t&&n!=n){for(;s>f;)if(u=c[f++],u!=u)return!0}else for(;s>f;f++)if((t||f in c)&&c[f]===n)return t||f||0;return!t&&-1}}},function(t,e,n){var r=n(6),o=n(19);t.exports=function(t,e,n){e in t?r.f(t,e,o(0,n)):t[e]=n}},function(t,e,n){var r=n(18),o=n(32),i=n(23);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,u=n(t),c=i.f,s=0;u.length>s;)c.call(t,a=u[s++])&&e.push(a);return e}},function(t,e,n){var r=n(15),o=n(51),i=n(50),a=n(7),u=n(36),c=n(62),s={},f={},e=t.exports=function(t,e,n,l,d){var p,h,v,g,m=d?function(){return t}:c(t),y=r(n,l,e?2:1),w=0;if("function"!=typeof m)throw TypeError(t+" is not iterable!");if(i(m)){for(p=u(t.length);p>w;w++)if(g=e?y(a(h=t[w])[0],h[1]):y(t[w]),g===s||g===f)return g}else for(v=m.call(t);!(h=v.next()).done;)if(g=o(v,y,h.value,e),g===s||g===f)return g};e.BREAK=s,e.RETURN=f},function(t,e){t.exports=function(t,e,n){var r=void 0===n;switch(e.length){case 0:return r?t():t.call(n);case 1:return r?t(e[0]):t.call(n,e[0]);case 2:return r?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return r?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return r?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var r=n(14);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){var r=n(54),o=n(19),i=n(24),a={};n(9)(a,n(3)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(25)("meta"),o=n(10),i=n(8),a=n(6).f,u=0,c=Object.isExtensible||function(){return!0},s=!n(12)(function(){return c(Object.preventExtensions({}))}),f=function(t){a(t,r,{value:{i:"O"+ ++u,w:{}}})},l=function(t,e){if(!o(t))return"symbol"==("undefined"==typeof t?"undefined":_typeof4(t))?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!c(t))return"F";if(!e)return"E";f(t)}return t[r].i},d=function(t,e){if(!i(t,r)){if(!c(t))return!0;if(!e)return!1;f(t)}return t[r].w},p=function(t){return s&&h.NEED&&c(t)&&!i(t,r)&&f(t),t},h=t.exports={KEY:r,NEED:!1,fastKey:l,getWeak:d,onFreeze:p}},function(t,e,n){var r=n(2),o=n(61).set,i=r.MutationObserver||r.WebKitMutationObserver,a=r.process,u=r.Promise,c="process"==n(14)(a);t.exports=function(){var t,e,n,s=function(){var r,o;for(c&&(r=a.domain)&&r.exit();t;){o=t.fn,t=t.next;try{o()}catch(i){throw t?n():e=void 0,i}}e=void 0,r&&r.enter()};if(c)n=function(){a.nextTick(s)};else if(!i||r.navigator&&r.navigator.standalone)if(u&&u.resolve){var f=u.resolve(void 0);n=function(){f.then(s)}}else n=function(){o.call(r,s)};else{var l=!0,d=document.createTextNode("");new i(s).observe(d,{characterData:!0}),n=function(){d.data=l=!l}}return function(r){var o={fn:r,next:void 0};e&&(e.next=o),t||(t=o,n()),e=o}}},function(t,e,n){var r=n(4),o=n(18),i=n(32),a=n(23),u=n(20),c=n(49),s=Object.assign;t.exports=!s||n(12)(function(){var t={},e={},n=Symbol(),r="abcdefghijklmnopqrst";return t[n]=7,r.split("").forEach(function(t){e[t]=t}),7!=s({},t)[n]||Object.keys(s({},e)).join("")!=r})?function(t,e){for(var n=u(t),s=arguments.length,f=1,l=i.f,d=a.f;s>f;)for(var p,h=c(arguments[f++]),v=l?o(h).concat(l(h)):o(h),g=v.length,m=0;g>m;)p=v[m++],r&&!d.call(h,p)||(n[p]=h[p]);return n}:s},function(t,e,n){var r=n(6),o=n(7),i=n(18);t.exports=n(4)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),u=a.length,c=0;u>c;)r.f(t,n=a[c++],e[n]);return t}},function(t,e,n){var r=n(23),o=n(19),i=n(13),a=n(37),u=n(8),c=n(48),s=Object.getOwnPropertyDescriptor;e.f=n(4)?s:function(t,e){if(t=i(t),e=a(e,!0),c)try{return s(t,e)}catch(n){}if(u(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(13),o=n(55).f,i={}.toString,a="object"==("undefined"==typeof window?"undefined":_typeof4(window))&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(t){try{return o(t)}catch(e){return a.slice()}};t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?u(t):o(r(t))}},function(t,e,n){var r=n(8),o=n(20),i=n(33)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){var r=n(5),o=n(1),i=n(12);t.exports=function(t,e){var n=(o.Object||{})[t]||Object[t],a={};a[t]=e(n),r(r.S+r.F*i(function(){n(1)}),"Object",a)}},function(t,e,n){var r=n(9);t.exports=function(t,e,n){for(var o in e)n&&t[o]?t[o]=e[o]:r(t,o,e[o]);return t}},function(t,e,n){var r=n(2),o=n(1),i=n(6),a=n(4),u=n(3)("species");t.exports=function(t){var e="function"==typeof o[t]?o[t]:r[t];a&&e&&!e[u]&&i.f(e,u,{configurable:!0,get:function(){return this}})}},function(t,e,n){var r=n(35),o=n(28);t.exports=function(t){return function(e,n){var i,a,u=String(o(e)),c=r(n),s=u.length;return c<0||c>=s?t?"":void 0:(i=u.charCodeAt(c),i<55296||i>56319||c+1===s||(a=u.charCodeAt(c+1))<56320||a>57343?t?u.charAt(c):i:t?u.slice(c,c+2):(i-55296<<10)+(a-56320)+65536)}}},function(t,e,n){var r=n(35),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(2),o=r.navigator;t.exports=o&&o.userAgent||""},function(t,e,n){var r=n(15),o=n(5),i=n(20),a=n(51),u=n(50),c=n(36),s=n(91),f=n(62);o(o.S+o.F*!n(53)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,o,l,d=i(t),p="function"==typeof this?this:Array,h=arguments.length,v=h>1?arguments[1]:void 0,g=void 0!==v,m=0,y=f(d);if(g&&(v=r(v,h>2?arguments[2]:void 0,2)),void 0==y||p==Array&&u(y))for(e=c(d.length),n=new p(e);e>m;m++)s(n,m,g?v(d[m],m):d[m]);else for(l=y.call(d),n=new p;!(o=l.next()).done;m++)s(n,m,g?a(l,v,[o.value,m],!0):o.value);return n.length=m,n}})},function(t,e,n){var r=n(88),o=n(97),i=n(16),a=n(13);t.exports=n(52)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):"keys"==e?o(0,n):"values"==e?o(0,t[n]):o(0,[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e,n){var r=n(5);r(r.S+r.F,"Object",{assign:n(100)})},function(t,e,n){var r=n(5);r(r.S+r.F*!n(4),"Object",{defineProperty:n(6).f})},function(t,e,n){var r=n(20),o=n(18);n(105)("keys",function(){return function(t){return o(r(t))}})},function(t,e,n){var r,o,i,a,u=n(17),c=n(2),s=n(15),f=n(46),l=n(5),d=n(10),p=n(22),h=n(89),v=n(93),g=n(60),m=n(61).set,y=n(99)(),w=n(31),_=n(57),b=n(110),x=n(58),O="Promise",k=c.TypeError,S=c.process,T=S&&S.versions,I=T&&T.v8||"",E=c[O],A="process"==f(S),j=function(){},R=o=w.f,M=!!function(){try{var t=E.resolve(1),e=(t.constructor={})[n(3)("species")]=function(t){t(j,j)};return(A||"function"==typeof PromiseRejectionEvent)&&t.then(j)instanceof e&&0!==I.indexOf("6.6")&&b.indexOf("Chrome/66")===-1}catch(r){}}(),C=function(t){var e;return!(!d(t)||"function"!=typeof(e=t.then))&&e},P=function(t,e){if(!t._n){t._n=!0;var n=t._c;y(function(){for(var r=t._v,o=1==t._s,i=0,a=function(e){var n,i,a,u=o?e.ok:e.fail,c=e.resolve,s=e.reject,f=e.domain;try{u?(o||(2==t._h&&F(t),t._h=1),u===!0?n=r:(f&&f.enter(),n=u(r),f&&(f.exit(),a=!0)),n===e.promise?s(k("Promise-chain cycle")):(i=C(n))?i.call(n,c,s):c(n)):s(r)}catch(l){f&&!a&&f.exit(),s(l)}};n.length>i;)a(n[i++]);t._c=[],t._n=!1,e&&!t._h&&L(t)})}},L=function(t){m.call(c,function(){var e,n,r,o=t._v,i=N(t);if(i&&(e=_(function(){A?S.emit("unhandledRejection",o,t):(n=c.onunhandledrejection)?n({promise:t,reason:o}):(r=c.console)&&r.error&&r.error("Unhandled promise rejection",o)}),t._h=A||N(t)?2:1),t._a=void 0,i&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},F=function(t){m.call(c,function(){var e;A?S.emit("rejectionHandled",t):(e=c.onrejectionhandled)&&e({promise:t,reason:t._v})})},D=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),P(e,!0))},U=function z(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw k("Promise can't be resolved itself");(e=C(t))?y(function(){var r={_w:n,_d:!1};try{e.call(t,s(z,r,1),s(D,r,1))}catch(o){D.call(r,o)}}):(n._v=t,n._s=1,P(n,!1))}catch(r){D.call({_w:n,_d:!1},r)}}};M||(E=function(t){h(this,E,O,"_h"),p(t),r.call(this);try{t(s(U,this,1),s(D,this,1))}catch(e){D.call(this,e)}},r=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=n(106)(E.prototype,{then:function(t,e){var n=R(g(this,E));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=A?S.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&P(this,!1),n.promise},"catch":function(t){return this.then(void 0,t)}}),i=function(){var t=new r;this.promise=t,this.resolve=s(U,t,1),this.reject=s(D,t,1)},w.f=R=function(t){return t===E||t===a?new i(t):o(t)}),l(l.G+l.W+l.F*!M,{Promise:E}),n(24)(E,O),n(107)(O),a=n(1)[O],l(l.S+l.F*!M,O,{reject:function(t){var e=R(this),n=e.reject;return n(t),e.promise}}),l(l.S+l.F*(u||!M),O,{resolve:function(t){return x(u&&this===a?E:this,t)}}),l(l.S+l.F*!(M&&n(53)(function(t){E.all(t)["catch"](j)})),O,{all:function(t){var e=this,n=R(e),r=n.resolve,o=n.reject,i=_(function(){var n=[],i=0,a=1;v(t,!1,function(t){var u=i++,c=!1;n.push(void 0),a++,e.resolve(t).then(function(t){c||(c=!0,n[u]=t,--a||r(n))},o)}),--a||r(n)});return i.e&&o(i.v),n.promise},race:function(t){var e=this,n=R(e),r=n.reject,o=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,r)})});return o.e&&r(o.v),n.promise}})},function(t,e,n){var r=n(2),o=n(8),i=n(4),a=n(5),u=n(59),c=n(98).KEY,s=n(12),f=n(34),l=n(24),d=n(25),p=n(3),h=n(39),v=n(38),g=n(92),m=n(95),y=n(7),w=n(10),_=n(20),b=n(13),x=n(37),O=n(19),k=n(54),S=n(103),T=n(102),I=n(32),E=n(6),A=n(18),j=T.f,R=E.f,M=S.f,C=r.Symbol,P=r.JSON,L=P&&P.stringify,N="prototype",F=p("_hidden"),D=p("toPrimitive"),U={}.propertyIsEnumerable,z=f("symbol-registry"),V=f("symbols"),B=f("op-symbols"),J=Object[N],W="function"==typeof C&&!!I.f,q=r.QObject,H=!q||!q[N]||!q[N].findChild,G=i&&s(function(){return 7!=k(R({},"a",{get:function(){return R(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=j(J,e);r&&delete J[e],R(t,e,n),r&&t!==J&&R(J,e,r)}:R,K=function(t){var e=V[t]=k(C[N]);return e._k=t,e},$=W&&"symbol"==_typeof4(C.iterator)?function(t){return"symbol"==("undefined"==typeof t?"undefined":_typeof4(t))}:function(t){return t instanceof C},X=function(t,e,n){return t===J&&X(B,e,n),y(t),e=x(e,!0),y(n),o(V,e)?(n.enumerable?(o(t,F)&&t[F][e]&&(t[F][e]=!1),n=k(n,{enumerable:O(0,!1)})):(o(t,F)||R(t,F,O(1,{})),t[F][e]=!0),G(t,e,n)):R(t,e,n)},Y=function(t,e){y(t);for(var n,r=g(e=b(e)),o=0,i=r.length;i>o;)X(t,n=r[o++],e[n]);return t},Q=function(t,e){return void 0===e?k(t):Y(k(t),e)},Z=function(t){var e=U.call(this,t=x(t,!0));return!(this===J&&o(V,t)&&!o(B,t))&&(!(e||!o(this,t)||!o(V,t)||o(this,F)&&this[F][t])||e)},tt=function(t,e){if(t=b(t),e=x(e,!0),t!==J||!o(V,e)||o(B,e)){var n=j(t,e);return!n||!o(V,e)||o(t,F)&&t[F][e]||(n.enumerable=!0),n}},et=function(t){for(var e,n=M(b(t)),r=[],i=0;n.length>i;)o(V,e=n[i++])||e==F||e==c||r.push(e);return r},nt=function(t){for(var e,n=t===J,r=M(n?B:b(t)),i=[],a=0;r.length>a;)!o(V,e=r[a++])||n&&!o(J,e)||i.push(V[e]);return i};W||(C=function(){if(this instanceof C)throw TypeError("Symbol is not a constructor!");var t=d(arguments.length>0?arguments[0]:void 0),e=function n(e){this===J&&n.call(B,e),o(this,F)&&o(this[F],t)&&(this[F][t]=!1),G(this,t,O(1,e))};return i&&H&&G(J,t,{configurable:!0,set:e}),K(t)},u(C[N],"toString",function(){return this._k}),T.f=tt,E.f=X,n(55).f=S.f=et,n(23).f=Z,I.f=nt,i&&!n(17)&&u(J,"propertyIsEnumerable",Z,!0),h.f=function(t){return K(p(t))}),a(a.G+a.W+a.F*!W,{Symbol:C});for(var rt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),ot=0;rt.length>ot;)p(rt[ot++]);for(var it=A(p.store),at=0;it.length>at;)v(it[at++]);a(a.S+a.F*!W,"Symbol",{"for":function(t){return o(z,t+="")?z[t]:z[t]=C(t)},keyFor:function(t){if(!$(t))throw TypeError(t+" is not a symbol!");for(var e in z)if(z[e]===t)return e},useSetter:function(){H=!0},useSimple:function(){H=!1}}),a(a.S+a.F*!W,"Object",{create:Q,defineProperty:X,defineProperties:Y,getOwnPropertyDescriptor:tt,getOwnPropertyNames:et,getOwnPropertySymbols:nt});var ut=s(function(){I.f(1)});a(a.S+a.F*ut,"Object",{getOwnPropertySymbols:function(t){return I.f(_(t))}}),P&&a(a.S+a.F*(!W||s(function(){var t=C();return"[null]"!=L([t])||"{}"!=L({a:t})||"{}"!=L(Object(t))})),"JSON",{stringify:function(t){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=e=r[1],(w(e)||void 0!==t)&&!$(t))return m(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!$(e))return e}),r[1]=e,L.apply(P,r)}}),C[N][D]||n(9)(C[N],D,C[N].valueOf),l(C,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(t,e,n){var r=n(5),o=n(1),i=n(2),a=n(60),u=n(58);r(r.P+r.R,"Promise",{"finally":function(t){var e=a(this,o.Promise||i.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){var r=n(5),o=n(31),i=n(57);r(r.S,"Promise",{"try":function(t){var e=o.f(this),n=i(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},function(t,e,n){n(38)("asyncIterator")},function(t,e,n){n(38)("observable")},function(t,e){!function(){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",n={rotl:function(t,e){return t<<e|t>>>32-e},rotr:function(t,e){return t<<32-e|t>>>e},endian:function(t){if(t.constructor==Number)return 16711935&n.rotl(t,8)|4278255360&n.rotl(t,24);for(var e=0;e<t.length;e++)t[e]=n.endian(t[e]);return t},randomBytes:function(t){for(var e=[];t>0;t--)e.push(Math.floor(256*Math.random()));return e},bytesToWords:function(t){for(var e=[],n=0,r=0;n<t.length;n++,r+=8)e[r>>>5]|=t[n]<<24-r%32;return e},wordsToBytes:function(t){for(var e=[],n=0;n<32*t.length;n+=8)e.push(t[n>>>5]>>>24-n%32&255);return e},bytesToHex:function(t){for(var e=[],n=0;n<t.length;n++)e.push((t[n]>>>4).toString(16)),e.push((15&t[n]).toString(16));return e.join("")},hexToBytes:function(t){for(var e=[],n=0;n<t.length;n+=2)e.push(parseInt(t.substr(n,2),16));return e},bytesToBase64:function(t){for(var n=[],r=0;r<t.length;r+=3)for(var o=t[r]<<16|t[r+1]<<8|t[r+2],i=0;i<4;i++)8*r+6*i<=8*t.length?n.push(e.charAt(o>>>6*(3-i)&63)):n.push("=");return n.join("")},base64ToBytes:function(t){t=t.replace(/[^A-Z0-9+\/]/gi,"");for(var n=[],r=0,o=0;r<t.length;o=++r%4)0!=o&&n.push((e.indexOf(t.charAt(r-1))&Math.pow(2,-2*o+8)-1)<<2*o|e.indexOf(t.charAt(r))>>>6-2*o);return n}};t.exports=n}()},function(t,e){function n(t,e){try{return decodeURIComponent(t.join(""))}catch(r){}if(1===t.length)return t;e=e||1;var o=t.slice(0,e),i=t.slice(e);return Array.prototype.concat.call([],n(o),n(i))}function r(t){try{return decodeURIComponent(t)}catch(e){for(var r=t.match(a),o=1;o<r.length;o++)t=n(r,o).join(""),r=t.match(a);return t}}function o(t){for(var e={"%FE%FF":"��","%FF%FE":"��"},n=u.exec(t);n;){try{e[n[0]]=decodeURIComponent(n[0])}catch(o){var i=r(n[0]);i!==n[0]&&(e[n[0]]=i)}n=u.exec(t)}e["%C2"]="�";for(var a=Object.keys(e),c=0;c<a.length;c++){var s=a[c];t=t.replace(new RegExp(s,"g"),e[s])}return t}var i="%[a-f0-9]{2}",a=new RegExp(i,"gi"),u=new RegExp("("+i+")+","gi");t.exports=function(t){if("string"!=typeof t)throw new TypeError("Expected `encodedURI` to be of type `string`, got `"+("undefined"==typeof t?"undefined":_typeof4(t))+"`");try{return t=t.replace(/\+/g," "),decodeURIComponent(t)}catch(e){return o(t)}}},function(t,e){t.exports=function(t,e){for(var n={},r=Object.keys(t),o=Array.isArray(e),i=0;i<r.length;i++){var a=r[i],u=t[a];(o?e.indexOf(a)!==-1:e(a,u,t))&&(n[a]=u)}return n}},function(t,e){!function(){function t(t){this.time=t.time,this.target=t.target,this.rootBounds=t.rootBounds,this.boundingClientRect=t.boundingClientRect,this.intersectionRect=t.intersectionRect||c(),this.isIntersecting=!!t.intersectionRect;var e=this.boundingClientRect,n=e.width*e.height,r=this.intersectionRect,o=r.width*r.height;n?this.intersectionRatio=Number((o/n).toFixed(4)):this.intersectionRatio=this.isIntersecting?1:0}function e(t,e){var n=e||{};if("function"!=typeof t)throw new Error("callback must be a function");if(n.root&&1!=n.root.nodeType)throw new Error("root must be an Element");this._checkForIntersections=r(this._checkForIntersections.bind(this),this.THROTTLE_TIMEOUT),this._callback=t,this._observationTargets=[],this._queuedEntries=[],this._rootMarginValues=this._parseRootMargin(n.rootMargin),this.thresholds=this._initThresholds(n.threshold),this.root=n.root||null,this.rootMargin=this._rootMarginValues.map(function(t){return t.value+t.unit}).join(" ")}function n(){return window.performance&&performance.now&&performance.now()}function r(t,e){var n=null;return function(){n||(n=setTimeout(function(){t(),n=null},e))}}function o(t,e,n,r){"function"==typeof t.addEventListener?t.addEventListener(e,n,r||!1):"function"==typeof t.attachEvent&&t.attachEvent("on"+e,n)}function i(t,e,n,r){"function"==typeof t.removeEventListener?t.removeEventListener(e,n,r||!1):"function"==typeof t.detatchEvent&&t.detatchEvent("on"+e,n)}function a(t,e){var n=Math.max(t.top,e.top),r=Math.min(t.bottom,e.bottom),o=Math.max(t.left,e.left),i=Math.min(t.right,e.right),a=i-o,u=r-n;return a>=0&&u>=0&&{top:n,bottom:r,left:o,right:i,width:a,height:u}}function u(t){var e;try{e=t.getBoundingClientRect()}catch(n){}return e?(e.width&&e.height||(e={top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:e.right-e.left,height:e.bottom-e.top}),e):c()}function c(){return{top:0,bottom:0,left:0,right:0,width:0,height:0}}function s(t,e){for(var n=e;n;){if(n==t)return!0;n=f(n)}return!1}function f(t){var e=t.parentNode;return e&&11==e.nodeType&&e.host?e.host:e&&e.assignedSlot?e.assignedSlot.parentNode:e}if("object"===("undefined"==typeof window?"undefined":_typeof4(window))){if("IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype)return void("isIntersecting"in window.IntersectionObserverEntry.prototype||Object.defineProperty(window.IntersectionObserverEntry.prototype,"isIntersecting",{get:function(){return this.intersectionRatio>0}}));var l=window.document,d=[];e.prototype.THROTTLE_TIMEOUT=100,e.prototype.POLL_INTERVAL=null,e.prototype.USE_MUTATION_OBSERVER=!0,e.prototype.observe=function(t){var e=this._observationTargets.some(function(e){return e.element==t});if(!e){if(!t||1!=t.nodeType)throw new Error("target must be an Element");this._registerInstance(),this._observationTargets.push({element:t,entry:null}),this._monitorIntersections(),this._checkForIntersections()}},e.prototype.unobserve=function(t){this._observationTargets=this._observationTargets.filter(function(e){return e.element!=t}),this._observationTargets.length||(this._unmonitorIntersections(),this._unregisterInstance())},e.prototype.disconnect=function(){this._observationTargets=[],this._unmonitorIntersections(),this._unregisterInstance()},e.prototype.takeRecords=function(){var t=this._queuedEntries.slice();return this._queuedEntries=[],t},e.prototype._initThresholds=function(t){var e=t||[0];return Array.isArray(e)||(e=[e]),e.sort().filter(function(t,e,n){if("number"!=typeof t||isNaN(t)||t<0||t>1)throw new Error("threshold must be a number between 0 and 1 inclusively");return t!==n[e-1]})},e.prototype._parseRootMargin=function(t){var e=t||"0px",n=e.split(/\s+/).map(function(t){var e=/^(-?\d*\.?\d+)(px|%)$/.exec(t);if(!e)throw new Error("rootMargin must be specified in pixels or percent");return{value:parseFloat(e[1]),unit:e[2]}});return n[1]=n[1]||n[0],n[2]=n[2]||n[0],n[3]=n[3]||n[1],n},e.prototype._monitorIntersections=function(){this._monitoringIntersections||(this._monitoringIntersections=!0,this.POLL_INTERVAL?this._monitoringInterval=setInterval(this._checkForIntersections,this.POLL_INTERVAL):(o(window,"resize",this._checkForIntersections,!0),o(l,"scroll",this._checkForIntersections,!0),this.USE_MUTATION_OBSERVER&&"MutationObserver"in window&&(this._domObserver=new MutationObserver(this._checkForIntersections),this._domObserver.observe(l,{attributes:!0,childList:!0,characterData:!0,subtree:!0}))))},e.prototype._unmonitorIntersections=function(){this._monitoringIntersections&&(this._monitoringIntersections=!1,clearInterval(this._monitoringInterval),this._monitoringInterval=null,i(window,"resize",this._checkForIntersections,!0),i(l,"scroll",this._checkForIntersections,!0),this._domObserver&&(this._domObserver.disconnect(),this._domObserver=null))},e.prototype._checkForIntersections=function(){var e=this._rootIsInDom(),r=e?this._getRootRect():c();this._observationTargets.forEach(function(o){var i=o.element,a=u(i),c=this._rootContainsTarget(i),s=o.entry,f=e&&c&&this._computeTargetAndRootIntersection(i,r),l=o.entry=new t({time:n(),target:i,boundingClientRect:a,rootBounds:r,intersectionRect:f});s?e&&c?this._hasCrossedThreshold(s,l)&&this._queuedEntries.push(l):s&&s.isIntersecting&&this._queuedEntries.push(l):this._queuedEntries.push(l)},this),this._queuedEntries.length&&this._callback(this.takeRecords(),this)},e.prototype._computeTargetAndRootIntersection=function(t,e){if("none"!=window.getComputedStyle(t).display){for(var n=u(t),r=n,o=f(t),i=!1;!i;){var c=null,s=1==o.nodeType?window.getComputedStyle(o):{};
if("none"==s.display)return;if(o==this.root||o==l?(i=!0,c=e):o!=l.body&&o!=l.documentElement&&"visible"!=s.overflow&&(c=u(o)),c&&(r=a(c,r),!r))break;o=f(o)}return r}},e.prototype._getRootRect=function(){var t;if(this.root)t=u(this.root);else{var e=l.documentElement,n=l.body;t={top:0,left:0,right:e.clientWidth||n.clientWidth,width:e.clientWidth||n.clientWidth,bottom:e.clientHeight||n.clientHeight,height:e.clientHeight||n.clientHeight}}return this._expandRectByRootMargin(t)},e.prototype._expandRectByRootMargin=function(t){var e=this._rootMarginValues.map(function(e,n){return"px"==e.unit?e.value:e.value*(n%2?t.width:t.height)/100}),n={top:t.top-e[0],right:t.right+e[1],bottom:t.bottom+e[2],left:t.left-e[3]};return n.width=n.right-n.left,n.height=n.bottom-n.top,n},e.prototype._hasCrossedThreshold=function(t,e){var n=t&&t.isIntersecting?t.intersectionRatio||0:-1,r=e.isIntersecting?e.intersectionRatio||0:-1;if(n!==r)for(var o=0;o<this.thresholds.length;o++){var i=this.thresholds[o];if(i==n||i==r||i<n!=i<r)return!0}},e.prototype._rootIsInDom=function(){return!this.root||s(l,this.root)},e.prototype._rootContainsTarget=function(t){return s(this.root||l,t)},e.prototype._registerInstance=function(){d.indexOf(this)<0&&d.push(this)},e.prototype._unregisterInstance=function(){var t=d.indexOf(this);t!=-1&&d.splice(t,1)},window.IntersectionObserver=e,window.IntersectionObserverEntry=t}}()},function(t,e){function n(t){return!!t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}function r(t){return"function"==typeof t.readFloatLE&&"function"==typeof t.slice&&n(t.slice(0,0))}/*!
    * Determine if an object is a Buffer
    *
    * @author   Feross Aboukhadijeh <https://feross.org>
    * @license  MIT
    */
t.exports=function(t){return null!=t&&(n(t)||r(t)||!!t._isBuffer)}},function(t,e,n){!function(){var e=n(122),r=n(45).utf8,o=n(126),i=n(45).bin,a=function u(t,n){t.constructor==String?t=n&&"binary"===n.encoding?i.stringToBytes(t):r.stringToBytes(t):o(t)?t=Array.prototype.slice.call(t,0):Array.isArray(t)||t.constructor===Uint8Array||(t=t.toString());for(var a=e.bytesToWords(t),c=8*t.length,s=1732584193,f=-271733879,l=-1732584194,d=271733878,p=0;p<a.length;p++)a[p]=16711935&(a[p]<<8|a[p]>>>24)|4278255360&(a[p]<<24|a[p]>>>8);a[c>>>5]|=128<<c%32,a[(c+64>>>9<<4)+14]=c;for(var h=u._ff,v=u._gg,g=u._hh,m=u._ii,p=0;p<a.length;p+=16){var y=s,w=f,_=l,b=d;s=h(s,f,l,d,a[p+0],7,-680876936),d=h(d,s,f,l,a[p+1],12,-389564586),l=h(l,d,s,f,a[p+2],17,606105819),f=h(f,l,d,s,a[p+3],22,-1044525330),s=h(s,f,l,d,a[p+4],7,-176418897),d=h(d,s,f,l,a[p+5],12,1200080426),l=h(l,d,s,f,a[p+6],17,-1473231341),f=h(f,l,d,s,a[p+7],22,-45705983),s=h(s,f,l,d,a[p+8],7,1770035416),d=h(d,s,f,l,a[p+9],12,-1958414417),l=h(l,d,s,f,a[p+10],17,-42063),f=h(f,l,d,s,a[p+11],22,-1990404162),s=h(s,f,l,d,a[p+12],7,1804603682),d=h(d,s,f,l,a[p+13],12,-40341101),l=h(l,d,s,f,a[p+14],17,-1502002290),f=h(f,l,d,s,a[p+15],22,1236535329),s=v(s,f,l,d,a[p+1],5,-165796510),d=v(d,s,f,l,a[p+6],9,-1069501632),l=v(l,d,s,f,a[p+11],14,643717713),f=v(f,l,d,s,a[p+0],20,-373897302),s=v(s,f,l,d,a[p+5],5,-701558691),d=v(d,s,f,l,a[p+10],9,38016083),l=v(l,d,s,f,a[p+15],14,-660478335),f=v(f,l,d,s,a[p+4],20,-405537848),s=v(s,f,l,d,a[p+9],5,568446438),d=v(d,s,f,l,a[p+14],9,-1019803690),l=v(l,d,s,f,a[p+3],14,-187363961),f=v(f,l,d,s,a[p+8],20,1163531501),s=v(s,f,l,d,a[p+13],5,-1444681467),d=v(d,s,f,l,a[p+2],9,-51403784),l=v(l,d,s,f,a[p+7],14,1735328473),f=v(f,l,d,s,a[p+12],20,-1926607734),s=g(s,f,l,d,a[p+5],4,-378558),d=g(d,s,f,l,a[p+8],11,-2022574463),l=g(l,d,s,f,a[p+11],16,1839030562),f=g(f,l,d,s,a[p+14],23,-35309556),s=g(s,f,l,d,a[p+1],4,-1530992060),d=g(d,s,f,l,a[p+4],11,1272893353),l=g(l,d,s,f,a[p+7],16,-155497632),f=g(f,l,d,s,a[p+10],23,-1094730640),s=g(s,f,l,d,a[p+13],4,681279174),d=g(d,s,f,l,a[p+0],11,-358537222),l=g(l,d,s,f,a[p+3],16,-722521979),f=g(f,l,d,s,a[p+6],23,76029189),s=g(s,f,l,d,a[p+9],4,-640364487),d=g(d,s,f,l,a[p+12],11,-421815835),l=g(l,d,s,f,a[p+15],16,530742520),f=g(f,l,d,s,a[p+2],23,-995338651),s=m(s,f,l,d,a[p+0],6,-198630844),d=m(d,s,f,l,a[p+7],10,1126891415),l=m(l,d,s,f,a[p+14],15,-1416354905),f=m(f,l,d,s,a[p+5],21,-57434055),s=m(s,f,l,d,a[p+12],6,1700485571),d=m(d,s,f,l,a[p+3],10,-1894986606),l=m(l,d,s,f,a[p+10],15,-1051523),f=m(f,l,d,s,a[p+1],21,-2054922799),s=m(s,f,l,d,a[p+8],6,1873313359),d=m(d,s,f,l,a[p+15],10,-30611744),l=m(l,d,s,f,a[p+6],15,-1560198380),f=m(f,l,d,s,a[p+13],21,1309151649),s=m(s,f,l,d,a[p+4],6,-145523070),d=m(d,s,f,l,a[p+11],10,-1120210379),l=m(l,d,s,f,a[p+2],15,718787259),f=m(f,l,d,s,a[p+9],21,-343485551),s=s+y>>>0,f=f+w>>>0,l=l+_>>>0,d=d+b>>>0}return e.endian([s,f,l,d])};a._ff=function(t,e,n,r,o,i,a){var u=t+(e&n|~e&r)+(o>>>0)+a;return(u<<i|u>>>32-i)+e},a._gg=function(t,e,n,r,o,i,a){var u=t+(e&r|n&~r)+(o>>>0)+a;return(u<<i|u>>>32-i)+e},a._hh=function(t,e,n,r,o,i,a){var u=t+(e^n^r)+(o>>>0)+a;return(u<<i|u>>>32-i)+e},a._ii=function(t,e,n,r,o,i,a){var u=t+(n^(e|~r))+(o>>>0)+a;return(u<<i|u>>>32-i)+e},a._blocksize=16,a._digestsize=16,t.exports=function(t,n){if(void 0===t||null===t)throw new Error("Illegal argument "+t);var r=e.wordsToBytes(a(t,n));return n&&n.asBytes?r:n&&n.asString?i.bytesToString(r):e.bytesToHex(r)}}()},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(t){if(f===setTimeout)return setTimeout(t,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(t,0);try{return f(t,0)}catch(e){try{return f.call(null,t,0)}catch(e){return f.call(this,t,0)}}}function i(t){if(l===clearTimeout)return clearTimeout(t);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(t);try{return l(t)}catch(e){try{return l.call(null,t)}catch(e){return l.call(this,t)}}}function a(){v&&p&&(v=!1,p.length?h=p.concat(h):g=-1,h.length&&u())}function u(){if(!v){var t=o(a);v=!0;for(var e=h.length;e;){for(p=h,h=[];++g<e;)p&&p[g].run();g=-1,e=h.length}p=null,v=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function s(){}var f,l,d=t.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(t){f=n}try{l="function"==typeof clearTimeout?clearTimeout:r}catch(t){l=r}}();var p,h=[],v=!1,g=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];h.push(new c(t,e)),1!==h.length||v||o(u)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=s,d.addListener=s,d.once=s,d.off=s,d.removeListener=s,d.removeAllListeners=s,d.emit=s,d.prependListener=s,d.prependOnceListener=s,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){function r(t){switch(t.arrayFormat){case"index":return function(e){return function(n,r){var o=n.length;return void 0===r||t.skipNull&&null===r||t.skipEmptyString&&""===r?n:null===r?[].concat(_toConsumableArray(n),[[a(e,t),"[",o,"]"].join("")]):[].concat(_toConsumableArray(n),[[a(e,t),"[",a(o,t),"]=",a(r,t)].join("")])}};case"bracket":return function(e){return function(n,r){return void 0===r||t.skipNull&&null===r||t.skipEmptyString&&""===r?n:null===r?[].concat(_toConsumableArray(n),[[a(e,t),"[]"].join("")]):[].concat(_toConsumableArray(n),[[a(e,t),"[]=",a(r,t)].join("")])}};case"comma":case"separator":return function(e){return function(n,r){return null===r||void 0===r||0===r.length?n:0===n.length?[[a(e,t),"=",a(r,t)].join("")]:[[n,a(r,t)].join(t.arrayFormatSeparator)]}};default:return function(e){return function(n,r){return void 0===r||t.skipNull&&null===r||t.skipEmptyString&&""===r?n:null===r?[].concat(_toConsumableArray(n),[a(e,t)]):[].concat(_toConsumableArray(n),[[a(e,t),"=",a(r,t)].join("")])}}}}function o(t){var e=void 0;switch(t.arrayFormat){case"index":return function(t,n,r){return e=/\[(\d*)\]$/.exec(t),t=t.replace(/\[\d*\]$/,""),e?(void 0===r[t]&&(r[t]={}),void(r[t][e[1]]=n)):void(r[t]=n)};case"bracket":return function(t,n,r){return e=/(\[\])$/.exec(t),t=t.replace(/\[\]$/,""),e?void 0===r[t]?void(r[t]=[n]):void(r[t]=[].concat(r[t],n)):void(r[t]=n)};case"comma":case"separator":return function(e,n,r){var o="string"==typeof n&&n.includes(t.arrayFormatSeparator),i="string"==typeof n&&!o&&u(n,t).includes(t.arrayFormatSeparator);n=i?u(n,t):n;var a=o||i?n.split(t.arrayFormatSeparator).map(function(e){return u(e,t)}):null===n?n:u(n,t);r[e]=a};default:return function(t,e,n){return void 0===n[t]?void(n[t]=e):void(n[t]=[].concat(n[t],e))}}}function i(t){if("string"!=typeof t||1!==t.length)throw new TypeError("arrayFormatSeparator must be single character string")}function a(t,e){return e.encode?e.strict?h(t):encodeURIComponent(t):t}function u(t,e){return e.decode?v(t):t}function c(t){return Array.isArray(t)?t.sort():"object"===("undefined"==typeof t?"undefined":_typeof4(t))?c(Object.keys(t)).sort(function(t,e){return Number(t)-Number(e)}).map(function(e){return t[e]}):t}function s(t){var e=t.indexOf("#");return e!==-1&&(t=t.slice(0,e)),t}function f(t){var e="",n=t.indexOf("#");return n!==-1&&(e=t.slice(n)),e}function l(t){t=s(t);var e=t.indexOf("?");return e===-1?"":t.slice(e+1)}function d(t,e){return e.parseNumbers&&!Number.isNaN(Number(t))&&"string"==typeof t&&""!==t.trim()?t=Number(t):!e.parseBooleans||null===t||"true"!==t.toLowerCase()&&"false"!==t.toLowerCase()||(t="true"===t.toLowerCase()),t}function p(t,e){e=Object.assign({decode:!0,sort:!0,arrayFormat:"none",arrayFormatSeparator:",",parseNumbers:!1,parseBooleans:!1},e),i(e.arrayFormatSeparator);var n=o(e),r=Object.create(null);if("string"!=typeof t)return r;if(t=t.trim().replace(/^[?#&]/,""),!t)return r;var a=!0,s=!1,f=void 0;try{for(var l,p=t.split("&")[Symbol.iterator]();!(a=(l=p.next()).done);a=!0){var h=l.value;if(""!==h){var v=g(e.decode?h.replace(/\+/g," "):h,"="),m=_slicedToArray(v,2),y=m[0],w=m[1];w=void 0===w?null:["comma","separator"].includes(e.arrayFormat)?w:u(w,e),n(u(y,e),w,r)}}}catch(_){s=!0,f=_}finally{try{!a&&p["return"]&&p["return"]()}finally{if(s)throw f}}var b=!0,x=!1,O=void 0;try{for(var k,S=Object.keys(r)[Symbol.iterator]();!(b=(k=S.next()).done);b=!0){var T=k.value,w=r[T];if("object"===("undefined"==typeof w?"undefined":_typeof4(w))&&null!==w){var I=!0,E=!1,A=void 0;try{for(var j,R=Object.keys(w)[Symbol.iterator]();!(I=(j=R.next()).done);I=!0){var M=j.value;w[M]=d(w[M],e)}}catch(_){E=!0,A=_}finally{try{!I&&R["return"]&&R["return"]()}finally{if(E)throw A}}}else r[T]=d(w,e)}}catch(_){x=!0,O=_}finally{try{!b&&S["return"]&&S["return"]()}finally{if(x)throw O}}return e.sort===!1?r:(e.sort===!0?Object.keys(r).sort():Object.keys(r).sort(e.sort)).reduce(function(t,e){var n=r[e];return Boolean(n)&&"object"===("undefined"==typeof n?"undefined":_typeof4(n))&&!Array.isArray(n)?t[e]=c(n):t[e]=n,t},Object.create(null))}var h=n(131),v=n(123),g=n(130),m=n(124),y=function(t){return null===t||void 0===t};e.extract=l,e.parse=p,e.stringify=function(t,e){if(!t)return"";e=Object.assign({encode:!0,strict:!0,arrayFormat:"none",arrayFormatSeparator:","},e),i(e.arrayFormatSeparator);var n=function(n){return e.skipNull&&y(t[n])||e.skipEmptyString&&""===t[n]},o=r(e),u={},c=!0,s=!1,f=void 0;try{for(var l,d=Object.keys(t)[Symbol.iterator]();!(c=(l=d.next()).done);c=!0){var p=l.value;n(p)||(u[p]=t[p])}}catch(h){s=!0,f=h}finally{try{!c&&d["return"]&&d["return"]()}finally{if(s)throw f}}var v=Object.keys(u);return e.sort!==!1&&v.sort(e.sort),v.map(function(n){var r=t[n];return void 0===r?"":null===r?a(n,e):Array.isArray(r)?r.reduce(o(n),[]).join("&"):a(n,e)+"="+a(r,e)}).filter(function(t){return t.length>0}).join("&")},e.parseUrl=function(t,e){e=Object.assign({decode:!0},e);var n=g(t,"#"),r=_slicedToArray(n,2),o=r[0],i=r[1];return Object.assign({url:o.split("?")[0]||"",query:p(l(t),e)},e&&e.parseFragmentIdentifier&&i?{fragmentIdentifier:u(i,e)}:{})},e.stringifyUrl=function(t,n){n=Object.assign({encode:!0,strict:!0},n);var r=s(t.url).split("?")[0]||"",o=e.extract(t.url),i=e.parse(o,{sort:!1}),u=Object.assign(i,t.query),c=e.stringify(u,n);c&&(c="?"+c);var l=f(t.url);return t.fragmentIdentifier&&(l="#"+a(t.fragmentIdentifier,n)),""+r+c+l},e.pick=function(t,n,r){r=Object.assign({parseFragmentIdentifier:!0},r);var o=e.parseUrl(t,r),i=o.url,a=o.query,u=o.fragmentIdentifier;return e.stringifyUrl({url:i,query:m(a,n),fragmentIdentifier:u},r)},e.exclude=function(t,n,r){var o=Array.isArray(n)?function(t){return!n.includes(t)}:function(t,e){return!n(t,e)};return e.pick(t,o,r)}},function(t,e){t.exports=function(t,e){if("string"!=typeof t||"string"!=typeof e)throw new TypeError("Expected the arguments to be of type `string`");if(""===e)return[t];var n=t.indexOf(e);return n===-1?[t]:[t.slice(0,n),t.slice(n+e.length)]}},function(t,e){t.exports=function(t){return encodeURIComponent(t).replace(/[!'()*]/g,function(t){return"%"+t.charCodeAt(0).toString(16).toUpperCase()})}},function(t,e,n){var r=n(133),o=n(134),i=o;i.v1=r,i.v4=o,t.exports=i},function(t,e,n){function r(t,e,n){var r=e&&n||0,f=e||[];t=t||{};var l=t.node||o,d=void 0!==t.clockseq?t.clockseq:i;if(null==l||null==d){var p=a();null==l&&(l=o=[1|p[0],p[1],p[2],p[3],p[4],p[5]]),null==d&&(d=i=16383&(p[6]<<8|p[7]))}var h=void 0!==t.msecs?t.msecs:(new Date).getTime(),v=void 0!==t.nsecs?t.nsecs:s+1,g=h-c+(v-s)/1e4;if(g<0&&void 0===t.clockseq&&(d=d+1&16383),(g<0||h>c)&&void 0===t.nsecs&&(v=0),v>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");c=h,s=v,i=d,h+=122192928e5;var m=(1e4*(268435455&h)+v)%4294967296;f[r++]=m>>>24&255,f[r++]=m>>>16&255,f[r++]=m>>>8&255,f[r++]=255&m;var y=h/4294967296*1e4&268435455;f[r++]=y>>>8&255,f[r++]=255&y,f[r++]=y>>>24&15|16,f[r++]=y>>>16&255,f[r++]=d>>>8|128,f[r++]=255&d;for(var w=0;w<6;++w)f[r+w]=l[w];return e?e:u(f)}var o,i,a=n(66),u=n(65),c=0,s=0;t.exports=r},function(t,e,n){function r(t,e,n){var r=e&&n||0;"string"==typeof t&&(e="binary"===t?new Array(16):null,t=null),t=t||{};var a=t.random||(t.rng||o)();if(a[6]=15&a[6]|64,a[8]=63&a[8]|128,e)for(var u=0;u<16;++u)e[r+u]=a[u];return e||i(a)}var o=n(66),i=n(65);t.exports=r}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(223)(module)))

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
    return Array.isArray ?
        Array.isArray(value) :
        Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Array');
});
//# sourceMappingURL=is-array.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(127)('wks');
var uid = __webpack_require__(111);
var Symbol = __webpack_require__(52).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 6.8.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 23, 2021
 */

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Swiper=t()}(this,(function(){"use strict";function e(e,t){for(var a=0;a<t.length;a++){var i=t[a];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function t(){return(t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var i in a)Object.prototype.hasOwnProperty.call(a,i)&&(e[i]=a[i])}return e}).apply(this,arguments)}function a(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function i(e,t){void 0===e&&(e={}),void 0===t&&(t={}),Object.keys(t).forEach((function(s){void 0===e[s]?e[s]=t[s]:a(t[s])&&a(e[s])&&Object.keys(t[s]).length>0&&i(e[s],t[s])}))}var s={body:{},addEventListener:function(){},removeEventListener:function(){},activeElement:{blur:function(){},nodeName:""},querySelector:function(){return null},querySelectorAll:function(){return[]},getElementById:function(){return null},createEvent:function(){return{initEvent:function(){}}},createElement:function(){return{children:[],childNodes:[],style:{},setAttribute:function(){},getElementsByTagName:function(){return[]}}},createElementNS:function(){return{}},importNode:function(){return null},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function r(){var e="undefined"!=typeof document?document:{};return i(e,s),e}var n={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState:function(){},pushState:function(){},go:function(){},back:function(){}},CustomEvent:function(){return this},addEventListener:function(){},removeEventListener:function(){},getComputedStyle:function(){return{getPropertyValue:function(){return""}}},Image:function(){},Date:function(){},screen:{},setTimeout:function(){},clearTimeout:function(){},matchMedia:function(){return{}},requestAnimationFrame:function(e){return"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0)},cancelAnimationFrame:function(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function l(){var e="undefined"!=typeof window?window:{};return i(e,n),e}function o(e){return(o=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function d(e,t){return(d=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function p(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}function u(e,t,a){return(u=p()?Reflect.construct:function(e,t,a){var i=[null];i.push.apply(i,t);var s=new(Function.bind.apply(e,i));return a&&d(s,a.prototype),s}).apply(null,arguments)}function c(e){var t="function"==typeof Map?new Map:void 0;return(c=function(e){if(null===e||(a=e,-1===Function.toString.call(a).indexOf("[native code]")))return e;var a;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,i)}function i(){return u(e,arguments,o(this).constructor)}return i.prototype=Object.create(e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),d(i,e)})(e)}var h=function(e){var t,a;function i(t){var a,i,s;return a=e.call.apply(e,[this].concat(t))||this,i=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(a),s=i.__proto__,Object.defineProperty(i,"__proto__",{get:function(){return s},set:function(e){s.__proto__=e}}),a}return a=e,(t=i).prototype=Object.create(a.prototype),t.prototype.constructor=t,t.__proto__=a,i}(c(Array));function v(e){void 0===e&&(e=[]);var t=[];return e.forEach((function(e){Array.isArray(e)?t.push.apply(t,v(e)):t.push(e)})),t}function f(e,t){return Array.prototype.filter.call(e,t)}function m(e,t){var a=l(),i=r(),s=[];if(!t&&e instanceof h)return e;if(!e)return new h(s);if("string"==typeof e){var n=e.trim();if(n.indexOf("<")>=0&&n.indexOf(">")>=0){var o="div";0===n.indexOf("<li")&&(o="ul"),0===n.indexOf("<tr")&&(o="tbody"),0!==n.indexOf("<td")&&0!==n.indexOf("<th")||(o="tr"),0===n.indexOf("<tbody")&&(o="table"),0===n.indexOf("<option")&&(o="select");var d=i.createElement(o);d.innerHTML=n;for(var p=0;p<d.childNodes.length;p+=1)s.push(d.childNodes[p])}else s=function(e,t){if("string"!=typeof e)return[e];for(var a=[],i=t.querySelectorAll(e),s=0;s<i.length;s+=1)a.push(i[s]);return a}(e.trim(),t||i)}else if(e.nodeType||e===a||e===i)s.push(e);else if(Array.isArray(e)){if(e instanceof h)return e;s=e}return new h(function(e){for(var t=[],a=0;a<e.length;a+=1)-1===t.indexOf(e[a])&&t.push(e[a]);return t}(s))}m.fn=h.prototype;var g,b,w,y={addClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return this.forEach((function(e){var t;(t=e.classList).add.apply(t,i)})),this},removeClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return this.forEach((function(e){var t;(t=e.classList).remove.apply(t,i)})),this},hasClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));return f(this,(function(e){return i.filter((function(t){return e.classList.contains(t)})).length>0})).length>0},toggleClass:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=v(t.map((function(e){return e.split(" ")})));this.forEach((function(e){i.forEach((function(t){e.classList.toggle(t)}))}))},attr:function(e,t){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(var a=0;a<this.length;a+=1)if(2===arguments.length)this[a].setAttribute(e,t);else for(var i in e)this[a][i]=e[i],this[a].setAttribute(i,e[i]);return this},removeAttr:function(e){for(var t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},transform:function(e){for(var t=0;t<this.length;t+=1)this[t].style.transform=e;return this},transition:function(e){for(var t=0;t<this.length;t+=1)this[t].style.transitionDuration="string"!=typeof e?e+"ms":e;return this},on:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];function l(e){var t=e.target;if(t){var a=e.target.dom7EventData||[];if(a.indexOf(e)<0&&a.unshift(e),m(t).is(s))r.apply(t,a);else for(var i=m(t).parents(),n=0;n<i.length;n+=1)m(i[n]).is(s)&&r.apply(i[n],a)}}function o(e){var t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),r.apply(this,t)}"function"==typeof t[1]&&(i=t[0],r=t[1],n=t[2],s=void 0),n||(n=!1);for(var d,p=i.split(" "),u=0;u<this.length;u+=1){var c=this[u];if(s)for(d=0;d<p.length;d+=1){var h=p[d];c.dom7LiveListeners||(c.dom7LiveListeners={}),c.dom7LiveListeners[h]||(c.dom7LiveListeners[h]=[]),c.dom7LiveListeners[h].push({listener:r,proxyListener:l}),c.addEventListener(h,l,n)}else for(d=0;d<p.length;d+=1){var v=p[d];c.dom7Listeners||(c.dom7Listeners={}),c.dom7Listeners[v]||(c.dom7Listeners[v]=[]),c.dom7Listeners[v].push({listener:r,proxyListener:o}),c.addEventListener(v,o,n)}}return this},off:function(){for(var e=arguments.length,t=new Array(e),a=0;a<e;a++)t[a]=arguments[a];var i=t[0],s=t[1],r=t[2],n=t[3];"function"==typeof t[1]&&(i=t[0],r=t[1],n=t[2],s=void 0),n||(n=!1);for(var l=i.split(" "),o=0;o<l.length;o+=1)for(var d=l[o],p=0;p<this.length;p+=1){var u=this[p],c=void 0;if(!s&&u.dom7Listeners?c=u.dom7Listeners[d]:s&&u.dom7LiveListeners&&(c=u.dom7LiveListeners[d]),c&&c.length)for(var h=c.length-1;h>=0;h-=1){var v=c[h];r&&v.listener===r||r&&v.listener&&v.listener.dom7proxy&&v.listener.dom7proxy===r?(u.removeEventListener(d,v.proxyListener,n),c.splice(h,1)):r||(u.removeEventListener(d,v.proxyListener,n),c.splice(h,1))}}return this},trigger:function(){for(var e=l(),t=arguments.length,a=new Array(t),i=0;i<t;i++)a[i]=arguments[i];for(var s=a[0].split(" "),r=a[1],n=0;n<s.length;n+=1)for(var o=s[n],d=0;d<this.length;d+=1){var p=this[d];if(e.CustomEvent){var u=new e.CustomEvent(o,{detail:r,bubbles:!0,cancelable:!0});p.dom7EventData=a.filter((function(e,t){return t>0})),p.dispatchEvent(u),p.dom7EventData=[],delete p.dom7EventData}}return this},transitionEnd:function(e){var t=this;return e&&t.on("transitionend",(function a(i){i.target===this&&(e.call(this,i),t.off("transitionend",a))})),this},outerWidth:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetWidth+parseFloat(t.getPropertyValue("margin-right"))+parseFloat(t.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){var t=this.styles();return this[0].offsetHeight+parseFloat(t.getPropertyValue("margin-top"))+parseFloat(t.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},styles:function(){var e=l();return this[0]?e.getComputedStyle(this[0],null):{}},offset:function(){if(this.length>0){var e=l(),t=r(),a=this[0],i=a.getBoundingClientRect(),s=t.body,n=a.clientTop||s.clientTop||0,o=a.clientLeft||s.clientLeft||0,d=a===e?e.scrollY:a.scrollTop,p=a===e?e.scrollX:a.scrollLeft;return{top:i.top+d-n,left:i.left+p-o}}return null},css:function(e,t){var a,i=l();if(1===arguments.length){if("string"!=typeof e){for(a=0;a<this.length;a+=1)for(var s in e)this[a].style[s]=e[s];return this}if(this[0])return i.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(a=0;a<this.length;a+=1)this[a].style[e]=t;return this}return this},each:function(e){return e?(this.forEach((function(t,a){e.apply(t,[t,a])})),this):this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:null;for(var t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(var t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){var t,a,i=l(),s=r(),n=this[0];if(!n||void 0===e)return!1;if("string"==typeof e){if(n.matches)return n.matches(e);if(n.webkitMatchesSelector)return n.webkitMatchesSelector(e);if(n.msMatchesSelector)return n.msMatchesSelector(e);for(t=m(e),a=0;a<t.length;a+=1)if(t[a]===n)return!0;return!1}if(e===s)return n===s;if(e===i)return n===i;if(e.nodeType||e instanceof h){for(t=e.nodeType?[e]:e,a=0;a<t.length;a+=1)if(t[a]===n)return!0;return!1}return!1},index:function(){var e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;var t=this.length;if(e>t-1)return m([]);if(e<0){var a=t+e;return m(a<0?[]:[this[a]])}return m([this[e]])},append:function(){for(var e,t=r(),a=0;a<arguments.length;a+=1){e=a<0||arguments.length<=a?void 0:arguments[a];for(var i=0;i<this.length;i+=1)if("string"==typeof e){var s=t.createElement("div");for(s.innerHTML=e;s.firstChild;)this[i].appendChild(s.firstChild)}else if(e instanceof h)for(var n=0;n<e.length;n+=1)this[i].appendChild(e[n]);else this[i].appendChild(e)}return this},prepend:function(e){var t,a,i=r();for(t=0;t<this.length;t+=1)if("string"==typeof e){var s=i.createElement("div");for(s.innerHTML=e,a=s.childNodes.length-1;a>=0;a-=1)this[t].insertBefore(s.childNodes[a],this[t].childNodes[0])}else if(e instanceof h)for(a=0;a<e.length;a+=1)this[t].insertBefore(e[a],this[t].childNodes[0]);else this[t].insertBefore(e,this[t].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&m(this[0].nextElementSibling).is(e)?m([this[0].nextElementSibling]):m([]):this[0].nextElementSibling?m([this[0].nextElementSibling]):m([]):m([])},nextAll:function(e){var t=[],a=this[0];if(!a)return m([]);for(;a.nextElementSibling;){var i=a.nextElementSibling;e?m(i).is(e)&&t.push(i):t.push(i),a=i}return m(t)},prev:function(e){if(this.length>0){var t=this[0];return e?t.previousElementSibling&&m(t.previousElementSibling).is(e)?m([t.previousElementSibling]):m([]):t.previousElementSibling?m([t.previousElementSibling]):m([])}return m([])},prevAll:function(e){var t=[],a=this[0];if(!a)return m([]);for(;a.previousElementSibling;){var i=a.previousElementSibling;e?m(i).is(e)&&t.push(i):t.push(i),a=i}return m(t)},parent:function(e){for(var t=[],a=0;a<this.length;a+=1)null!==this[a].parentNode&&(e?m(this[a].parentNode).is(e)&&t.push(this[a].parentNode):t.push(this[a].parentNode));return m(t)},parents:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].parentNode;i;)e?m(i).is(e)&&t.push(i):t.push(i),i=i.parentNode;return m(t)},closest:function(e){var t=this;return void 0===e?m([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].querySelectorAll(e),s=0;s<i.length;s+=1)t.push(i[s]);return m(t)},children:function(e){for(var t=[],a=0;a<this.length;a+=1)for(var i=this[a].children,s=0;s<i.length;s+=1)e&&!m(i[s]).is(e)||t.push(i[s]);return m(t)},filter:function(e){return m(f(this,e))},remove:function(){for(var e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this}};function E(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function x(){return Date.now()}function T(e,t){void 0===t&&(t="x");var a,i,s,r=l(),n=function(e){var t,a=l();return a.getComputedStyle&&(t=a.getComputedStyle(e,null)),!t&&e.currentStyle&&(t=e.currentStyle),t||(t=e.style),t}(e);return r.WebKitCSSMatrix?((i=n.transform||n.webkitTransform).split(",").length>6&&(i=i.split(", ").map((function(e){return e.replace(",",".")})).join(", ")),s=new r.WebKitCSSMatrix("none"===i?"":i)):a=(s=n.MozTransform||n.OTransform||n.MsTransform||n.msTransform||n.transform||n.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,")).toString().split(","),"x"===t&&(i=r.WebKitCSSMatrix?s.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=r.WebKitCSSMatrix?s.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function C(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function S(e){return"undefined"!=typeof window&&void 0!==window.HTMLElement?e instanceof HTMLElement:e&&(1===e.nodeType||11===e.nodeType)}function M(){for(var e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"],a=1;a<arguments.length;a+=1){var i=a<0||arguments.length<=a?void 0:arguments[a];if(null!=i&&!S(i))for(var s=Object.keys(Object(i)).filter((function(e){return t.indexOf(e)<0})),r=0,n=s.length;r<n;r+=1){var l=s[r],o=Object.getOwnPropertyDescriptor(i,l);void 0!==o&&o.enumerable&&(C(e[l])&&C(i[l])?i[l].__swiper__?e[l]=i[l]:M(e[l],i[l]):!C(e[l])&&C(i[l])?(e[l]={},i[l].__swiper__?e[l]=i[l]:M(e[l],i[l])):e[l]=i[l])}}return e}function z(e,t){Object.keys(t).forEach((function(a){C(t[a])&&Object.keys(t[a]).forEach((function(i){"function"==typeof t[a][i]&&(t[a][i]=t[a][i].bind(e))})),e[a]=t[a]}))}function P(e){return void 0===e&&(e=""),"."+e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}function k(e,t,a,i){var s=r();return a&&Object.keys(i).forEach((function(a){if(!t[a]&&!0===t.auto){var r=s.createElement("div");r.className=i[a],e.append(r),t[a]=r}})),t}function $(){return g||(g=function(){var e=l(),t=r();return{touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch),pointerEvents:!!e.PointerEvent&&"maxTouchPoints"in e.navigator&&e.navigator.maxTouchPoints>=0,observer:"MutationObserver"in e||"WebkitMutationObserver"in e,passiveListener:function(){var t=!1;try{var a=Object.defineProperty({},"passive",{get:function(){t=!0}});e.addEventListener("testPassiveListener",null,a)}catch(e){}return t}(),gestures:"ongesturestart"in e}}()),g}function L(e){return void 0===e&&(e={}),b||(b=function(e){var t=(void 0===e?{}:e).userAgent,a=$(),i=l(),s=i.navigator.platform,r=t||i.navigator.userAgent,n={ios:!1,android:!1},o=i.screen.width,d=i.screen.height,p=r.match(/(Android);?[\s\/]+([\d.]+)?/),u=r.match(/(iPad).*OS\s([\d_]+)/),c=r.match(/(iPod)(.*OS\s([\d_]+))?/),h=!u&&r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),v="Win32"===s,f="MacIntel"===s;return!u&&f&&a.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(o+"x"+d)>=0&&((u=r.match(/(Version)\/([\d.]+)/))||(u=[0,1,"13_0_0"]),f=!1),p&&!v&&(n.os="android",n.android=!0),(u||h||c)&&(n.os="ios",n.ios=!0),n}(e)),b}function I(){return w||(w=function(){var e,t=l();return{isEdge:!!t.navigator.userAgent.match(/Edge/g),isSafari:(e=t.navigator.userAgent.toLowerCase(),e.indexOf("safari")>=0&&e.indexOf("chrome")<0&&e.indexOf("android")<0),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)}}()),w}Object.keys(y).forEach((function(e){Object.defineProperty(m.fn,e,{value:y[e],writable:!0})}));var O={name:"resize",create:function(){var e=this;M(e,{resize:{observer:null,createObserver:function(){e&&!e.destroyed&&e.initialized&&(e.resize.observer=new ResizeObserver((function(t){var a=e.width,i=e.height,s=a,r=i;t.forEach((function(t){var a=t.contentBoxSize,i=t.contentRect,n=t.target;n&&n!==e.el||(s=i?i.width:(a[0]||a).inlineSize,r=i?i.height:(a[0]||a).blockSize)})),s===a&&r===i||e.resize.resizeHandler()})),e.resize.observer.observe(e.el))},removeObserver:function(){e.resize.observer&&e.resize.observer.unobserve&&e.el&&(e.resize.observer.unobserve(e.el),e.resize.observer=null)},resizeHandler:function(){e&&!e.destroyed&&e.initialized&&(e.emit("beforeResize"),e.emit("resize"))},orientationChangeHandler:function(){e&&!e.destroyed&&e.initialized&&e.emit("orientationchange")}}})},on:{init:function(e){var t=l();e.params.resizeObserver&&void 0!==l().ResizeObserver?e.resize.createObserver():(t.addEventListener("resize",e.resize.resizeHandler),t.addEventListener("orientationchange",e.resize.orientationChangeHandler))},destroy:function(e){var t=l();e.resize.removeObserver(),t.removeEventListener("resize",e.resize.resizeHandler),t.removeEventListener("orientationchange",e.resize.orientationChangeHandler)}}},A={attach:function(e,t){void 0===t&&(t={});var a=l(),i=this,s=new(a.MutationObserver||a.WebkitMutationObserver)((function(e){if(1!==e.length){var t=function(){i.emit("observerUpdate",e[0])};a.requestAnimationFrame?a.requestAnimationFrame(t):a.setTimeout(t,0)}else i.emit("observerUpdate",e[0])}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),i.observer.observers.push(s)},init:function(){var e=this;if(e.support.observer&&e.params.observer){if(e.params.observeParents)for(var t=e.$el.parents(),a=0;a<t.length;a+=1)e.observer.attach(t[a]);e.observer.attach(e.$el[0],{childList:e.params.observeSlideChildren}),e.observer.attach(e.$wrapperEl[0],{attributes:!1})}},destroy:function(){this.observer.observers.forEach((function(e){e.disconnect()})),this.observer.observers=[]}},D={name:"observer",params:{observer:!1,observeParents:!1,observeSlideChildren:!1},create:function(){z(this,{observer:t({},A,{observers:[]})})},on:{init:function(e){e.observer.init()},destroy:function(e){e.observer.destroy()}}};function N(e){var t=this,a=r(),i=l(),s=t.touchEventsData,n=t.params,o=t.touches;if(t.enabled&&(!t.animating||!n.preventInteractionOnTransition)){var d=e;d.originalEvent&&(d=d.originalEvent);var p=m(d.target);if(("wrapper"!==n.touchEventsTarget||p.closest(t.wrapperEl).length)&&(s.isTouchEvent="touchstart"===d.type,(s.isTouchEvent||!("which"in d)||3!==d.which)&&!(!s.isTouchEvent&&"button"in d&&d.button>0||s.isTouched&&s.isMoved))){!!n.noSwipingClass&&""!==n.noSwipingClass&&d.target&&d.target.shadowRoot&&e.path&&e.path[0]&&(p=m(e.path[0]));var u=n.noSwipingSelector?n.noSwipingSelector:"."+n.noSwipingClass,c=!(!d.target||!d.target.shadowRoot);if(n.noSwiping&&(c?function(e,t){return void 0===t&&(t=this),function t(a){return a&&a!==r()&&a!==l()?(a.assignedSlot&&(a=a.assignedSlot),a.closest(e)||t(a.getRootNode().host)):null}(t)}(u,d.target):p.closest(u)[0]))t.allowClick=!0;else if(!n.swipeHandler||p.closest(n.swipeHandler)[0]){o.currentX="touchstart"===d.type?d.targetTouches[0].pageX:d.pageX,o.currentY="touchstart"===d.type?d.targetTouches[0].pageY:d.pageY;var h=o.currentX,v=o.currentY,f=n.edgeSwipeDetection||n.iOSEdgeSwipeDetection,g=n.edgeSwipeThreshold||n.iOSEdgeSwipeThreshold;if(f&&(h<=g||h>=i.innerWidth-g)){if("prevent"!==f)return;e.preventDefault()}if(M(s,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=h,o.startY=v,s.touchStartTime=x(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,n.threshold>0&&(s.allowThresholdMove=!1),"touchstart"!==d.type){var b=!0;p.is(s.focusableElements)&&(b=!1),a.activeElement&&m(a.activeElement).is(s.focusableElements)&&a.activeElement!==p[0]&&a.activeElement.blur();var w=b&&t.allowTouchMove&&n.touchStartPreventDefault;!n.touchStartForcePreventDefault&&!w||p[0].isContentEditable||d.preventDefault()}t.emit("touchStart",d)}}}}function G(e){var t=r(),a=this,i=a.touchEventsData,s=a.params,n=a.touches,l=a.rtlTranslate;if(a.enabled){var o=e;if(o.originalEvent&&(o=o.originalEvent),i.isTouched){if(!i.isTouchEvent||"touchmove"===o.type){var d="touchmove"===o.type&&o.targetTouches&&(o.targetTouches[0]||o.changedTouches[0]),p="touchmove"===o.type?d.pageX:o.pageX,u="touchmove"===o.type?d.pageY:o.pageY;if(o.preventedByNestedSwiper)return n.startX=p,void(n.startY=u);if(!a.allowTouchMove)return a.allowClick=!1,void(i.isTouched&&(M(n,{startX:p,startY:u,currentX:p,currentY:u}),i.touchStartTime=x()));if(i.isTouchEvent&&s.touchReleaseOnEdges&&!s.loop)if(a.isVertical()){if(u<n.startY&&a.translate<=a.maxTranslate()||u>n.startY&&a.translate>=a.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(p<n.startX&&a.translate<=a.maxTranslate()||p>n.startX&&a.translate>=a.minTranslate())return;if(i.isTouchEvent&&t.activeElement&&o.target===t.activeElement&&m(o.target).is(i.focusableElements))return i.isMoved=!0,void(a.allowClick=!1);if(i.allowTouchCallbacks&&a.emit("touchMove",o),!(o.targetTouches&&o.targetTouches.length>1)){n.currentX=p,n.currentY=u;var c=n.currentX-n.startX,h=n.currentY-n.startY;if(!(a.params.threshold&&Math.sqrt(Math.pow(c,2)+Math.pow(h,2))<a.params.threshold)){var v;if(void 0===i.isScrolling)a.isHorizontal()&&n.currentY===n.startY||a.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:c*c+h*h>=25&&(v=180*Math.atan2(Math.abs(h),Math.abs(c))/Math.PI,i.isScrolling=a.isHorizontal()?v>s.touchAngle:90-v>s.touchAngle);if(i.isScrolling&&a.emit("touchMoveOpposite",o),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling)i.isTouched=!1;else if(i.startMoving){a.allowClick=!1,!s.cssMode&&o.cancelable&&o.preventDefault(),s.touchMoveStopPropagation&&!s.nested&&o.stopPropagation(),i.isMoved||(s.loop&&a.loopFix(),i.startTranslate=a.getTranslate(),a.setTransition(0),a.animating&&a.$wrapperEl.trigger("webkitTransitionEnd transitionend"),i.allowMomentumBounce=!1,!s.grabCursor||!0!==a.allowSlideNext&&!0!==a.allowSlidePrev||a.setGrabCursor(!0),a.emit("sliderFirstMove",o)),a.emit("sliderMove",o),i.isMoved=!0;var f=a.isHorizontal()?c:h;n.diff=f,f*=s.touchRatio,l&&(f=-f),a.swipeDirection=f>0?"prev":"next",i.currentTranslate=f+i.startTranslate;var g=!0,b=s.resistanceRatio;if(s.touchReleaseOnEdges&&(b=0),f>0&&i.currentTranslate>a.minTranslate()?(g=!1,s.resistance&&(i.currentTranslate=a.minTranslate()-1+Math.pow(-a.minTranslate()+i.startTranslate+f,b))):f<0&&i.currentTranslate<a.maxTranslate()&&(g=!1,s.resistance&&(i.currentTranslate=a.maxTranslate()+1-Math.pow(a.maxTranslate()-i.startTranslate-f,b))),g&&(o.preventedByNestedSwiper=!0),!a.allowSlideNext&&"next"===a.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!a.allowSlidePrev&&"prev"===a.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),a.allowSlidePrev||a.allowSlideNext||(i.currentTranslate=i.startTranslate),s.threshold>0){if(!(Math.abs(f)>s.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=a.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}s.followFinger&&!s.cssMode&&((s.freeMode||s.watchSlidesProgress||s.watchSlidesVisibility)&&(a.updateActiveIndex(),a.updateSlidesClasses()),s.freeMode&&(0===i.velocities.length&&i.velocities.push({position:n[a.isHorizontal()?"startX":"startY"],time:i.touchStartTime}),i.velocities.push({position:n[a.isHorizontal()?"currentX":"currentY"],time:x()})),a.updateProgress(i.currentTranslate),a.setTranslate(i.currentTranslate))}}}}}else i.startMoving&&i.isScrolling&&a.emit("touchMoveOpposite",o)}}function B(e){var t=this,a=t.touchEventsData,i=t.params,s=t.touches,r=t.rtlTranslate,n=t.$wrapperEl,l=t.slidesGrid,o=t.snapGrid;if(t.enabled){var d=e;if(d.originalEvent&&(d=d.originalEvent),a.allowTouchCallbacks&&t.emit("touchEnd",d),a.allowTouchCallbacks=!1,!a.isTouched)return a.isMoved&&i.grabCursor&&t.setGrabCursor(!1),a.isMoved=!1,void(a.startMoving=!1);i.grabCursor&&a.isMoved&&a.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);var p,u=x(),c=u-a.touchStartTime;if(t.allowClick&&(t.updateClickedSlide(d),t.emit("tap click",d),c<300&&u-a.lastClickTime<300&&t.emit("doubleTap doubleClick",d)),a.lastClickTime=x(),E((function(){t.destroyed||(t.allowClick=!0)})),!a.isTouched||!a.isMoved||!t.swipeDirection||0===s.diff||a.currentTranslate===a.startTranslate)return a.isTouched=!1,a.isMoved=!1,void(a.startMoving=!1);if(a.isTouched=!1,a.isMoved=!1,a.startMoving=!1,p=i.followFinger?r?t.translate:-t.translate:-a.currentTranslate,!i.cssMode)if(i.freeMode){if(p<-t.minTranslate())return void t.slideTo(t.activeIndex);if(p>-t.maxTranslate())return void(t.slides.length<o.length?t.slideTo(o.length-1):t.slideTo(t.slides.length-1));if(i.freeModeMomentum){if(a.velocities.length>1){var h=a.velocities.pop(),v=a.velocities.pop(),f=h.position-v.position,m=h.time-v.time;t.velocity=f/m,t.velocity/=2,Math.abs(t.velocity)<i.freeModeMinimumVelocity&&(t.velocity=0),(m>150||x()-h.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=i.freeModeMomentumVelocityRatio,a.velocities.length=0;var g=1e3*i.freeModeMomentumRatio,b=t.velocity*g,w=t.translate+b;r&&(w=-w);var y,T,C=!1,S=20*Math.abs(t.velocity)*i.freeModeMomentumBounceRatio;if(w<t.maxTranslate())i.freeModeMomentumBounce?(w+t.maxTranslate()<-S&&(w=t.maxTranslate()-S),y=t.maxTranslate(),C=!0,a.allowMomentumBounce=!0):w=t.maxTranslate(),i.loop&&i.centeredSlides&&(T=!0);else if(w>t.minTranslate())i.freeModeMomentumBounce?(w-t.minTranslate()>S&&(w=t.minTranslate()+S),y=t.minTranslate(),C=!0,a.allowMomentumBounce=!0):w=t.minTranslate(),i.loop&&i.centeredSlides&&(T=!0);else if(i.freeModeSticky){for(var M,z=0;z<o.length;z+=1)if(o[z]>-w){M=z;break}w=-(w=Math.abs(o[M]-w)<Math.abs(o[M-1]-w)||"next"===t.swipeDirection?o[M]:o[M-1])}if(T&&t.once("transitionEnd",(function(){t.loopFix()})),0!==t.velocity){if(g=r?Math.abs((-w-t.translate)/t.velocity):Math.abs((w-t.translate)/t.velocity),i.freeModeSticky){var P=Math.abs((r?-w:w)-t.translate),k=t.slidesSizesGrid[t.activeIndex];g=P<k?i.speed:P<2*k?1.5*i.speed:2.5*i.speed}}else if(i.freeModeSticky)return void t.slideToClosest();i.freeModeMomentumBounce&&C?(t.updateProgress(y),t.setTransition(g),t.setTranslate(w),t.transitionStart(!0,t.swipeDirection),t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&a.allowMomentumBounce&&(t.emit("momentumBounce"),t.setTransition(i.speed),setTimeout((function(){t.setTranslate(y),n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(t.updateProgress(w),t.setTransition(g),t.setTranslate(w),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,n.transitionEnd((function(){t&&!t.destroyed&&t.transitionEnd()})))):(t.emit("_freeModeNoMomentumRelease"),t.updateProgress(w)),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(i.freeModeSticky)return void t.slideToClosest();i.freeMode&&t.emit("_freeModeNoMomentumRelease")}(!i.freeModeMomentum||c>=i.longSwipesMs)&&(t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}else{for(var $=0,L=t.slidesSizesGrid[0],I=0;I<l.length;I+=I<i.slidesPerGroupSkip?1:i.slidesPerGroup){var O=I<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;void 0!==l[I+O]?p>=l[I]&&p<l[I+O]&&($=I,L=l[I+O]-l[I]):p>=l[I]&&($=I,L=l[l.length-1]-l[l.length-2])}var A=(p-l[$])/L,D=$<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;if(c>i.longSwipesMs){if(!i.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(A>=i.longSwipesRatio?t.slideTo($+D):t.slideTo($)),"prev"===t.swipeDirection&&(A>1-i.longSwipesRatio?t.slideTo($+D):t.slideTo($))}else{if(!i.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(d.target===t.navigation.nextEl||d.target===t.navigation.prevEl)?d.target===t.navigation.nextEl?t.slideTo($+D):t.slideTo($):("next"===t.swipeDirection&&t.slideTo($+D),"prev"===t.swipeDirection&&t.slideTo($))}}}}function H(){var e=this,t=e.params,a=e.el;if(!a||0!==a.offsetWidth){t.breakpoints&&e.setBreakpoint();var i=e.allowSlideNext,s=e.allowSlidePrev,r=e.snapGrid;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses(),("auto"===t.slidesPerView||t.slidesPerView>1)&&e.isEnd&&!e.isBeginning&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=s,e.allowSlideNext=i,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}}function R(e){var t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function X(){var e=this,t=e.wrapperEl,a=e.rtlTranslate;if(e.enabled){e.previousTranslate=e.translate,e.isHorizontal()?e.translate=a?t.scrollWidth-t.offsetWidth-t.scrollLeft:-t.scrollLeft:e.translate=-t.scrollTop,-0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();var i=e.maxTranslate()-e.minTranslate();(0===i?0:(e.translate-e.minTranslate())/i)!==e.progress&&e.updateProgress(a?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}}var Y=!1;function V(){}var W={init:!0,direction:"horizontal",touchEventsTarget:"container",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!1,nested:!1,createElements:!1,enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,freeMode:!1,freeModeMomentum:!0,freeModeMomentumRatio:1,freeModeMomentumBounce:!0,freeModeMomentumBounceRatio:1,freeModeMomentumVelocityRatio:1,freeModeSticky:!1,freeModeMinimumVelocity:.02,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerColumn:1,slidesPerColumnFill:"column",slidesPerGroup:1,slidesPerGroupSkip:0,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!1,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,watchSlidesVisibility:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,loopPreventsSlide:!0,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,containerModifierClass:"swiper-container-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0,_emitClasses:!1},F={modular:{useParams:function(e){var t=this;t.modules&&Object.keys(t.modules).forEach((function(a){var i=t.modules[a];i.params&&M(e,i.params)}))},useModules:function(e){void 0===e&&(e={});var t=this;t.modules&&Object.keys(t.modules).forEach((function(a){var i=t.modules[a],s=e[a]||{};i.on&&t.on&&Object.keys(i.on).forEach((function(e){t.on(e,i.on[e])})),i.create&&i.create.bind(t)(s)}))}},eventsEmitter:{on:function(e,t,a){var i=this;if("function"!=typeof t)return i;var s=a?"unshift":"push";return e.split(" ").forEach((function(e){i.eventsListeners[e]||(i.eventsListeners[e]=[]),i.eventsListeners[e][s](t)})),i},once:function(e,t,a){var i=this;if("function"!=typeof t)return i;function s(){i.off(e,s),s.__emitterProxy&&delete s.__emitterProxy;for(var a=arguments.length,r=new Array(a),n=0;n<a;n++)r[n]=arguments[n];t.apply(i,r)}return s.__emitterProxy=t,i.on(e,s,a)},onAny:function(e,t){var a=this;if("function"!=typeof e)return a;var i=t?"unshift":"push";return a.eventsAnyListeners.indexOf(e)<0&&a.eventsAnyListeners[i](e),a},offAny:function(e){var t=this;if(!t.eventsAnyListeners)return t;var a=t.eventsAnyListeners.indexOf(e);return a>=0&&t.eventsAnyListeners.splice(a,1),t},off:function(e,t){var a=this;return a.eventsListeners?(e.split(" ").forEach((function(e){void 0===t?a.eventsListeners[e]=[]:a.eventsListeners[e]&&a.eventsListeners[e].forEach((function(i,s){(i===t||i.__emitterProxy&&i.__emitterProxy===t)&&a.eventsListeners[e].splice(s,1)}))})),a):a},emit:function(){var e,t,a,i=this;if(!i.eventsListeners)return i;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(e=r[0],t=r.slice(1,r.length),a=i):(e=r[0].events,t=r[0].data,a=r[0].context||i),t.unshift(a);var l=Array.isArray(e)?e:e.split(" ");return l.forEach((function(e){i.eventsAnyListeners&&i.eventsAnyListeners.length&&i.eventsAnyListeners.forEach((function(i){i.apply(a,[e].concat(t))})),i.eventsListeners&&i.eventsListeners[e]&&i.eventsListeners[e].forEach((function(e){e.apply(a,t)}))})),i}},update:{updateSize:function(){var e,t,a=this,i=a.$el;e=void 0!==a.params.width&&null!==a.params.width?a.params.width:i[0].clientWidth,t=void 0!==a.params.height&&null!==a.params.height?a.params.height:i[0].clientHeight,0===e&&a.isHorizontal()||0===t&&a.isVertical()||(e=e-parseInt(i.css("padding-left")||0,10)-parseInt(i.css("padding-right")||0,10),t=t-parseInt(i.css("padding-top")||0,10)-parseInt(i.css("padding-bottom")||0,10),Number.isNaN(e)&&(e=0),Number.isNaN(t)&&(t=0),M(a,{width:e,height:t,size:a.isHorizontal()?e:t}))},updateSlides:function(){var e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function a(e,a){return parseFloat(e.getPropertyValue(t(a))||0)}var i=e.params,s=e.$wrapperEl,r=e.size,n=e.rtlTranslate,l=e.wrongRTL,o=e.virtual&&i.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,p=s.children("."+e.params.slideClass),u=o?e.virtual.slides.length:p.length,c=[],h=[],v=[],f=i.slidesOffsetBefore;"function"==typeof f&&(f=i.slidesOffsetBefore.call(e));var m=i.slidesOffsetAfter;"function"==typeof m&&(m=i.slidesOffsetAfter.call(e));var g=e.snapGrid.length,b=e.slidesGrid.length,w=i.spaceBetween,y=-f,E=0,x=0;if(void 0!==r){var T,C;"string"==typeof w&&w.indexOf("%")>=0&&(w=parseFloat(w.replace("%",""))/100*r),e.virtualSize=-w,n?p.css({marginLeft:"",marginBottom:"",marginTop:""}):p.css({marginRight:"",marginBottom:"",marginTop:""}),i.slidesPerColumn>1&&(T=Math.floor(u/i.slidesPerColumn)===u/e.params.slidesPerColumn?u:Math.ceil(u/i.slidesPerColumn)*i.slidesPerColumn,"auto"!==i.slidesPerView&&"row"===i.slidesPerColumnFill&&(T=Math.max(T,i.slidesPerView*i.slidesPerColumn)));for(var S,z,P,k=i.slidesPerColumn,$=T/k,L=Math.floor(u/i.slidesPerColumn),I=0;I<u;I+=1){C=0;var O=p.eq(I);if(i.slidesPerColumn>1){var A=void 0,D=void 0,N=void 0;if("row"===i.slidesPerColumnFill&&i.slidesPerGroup>1){var G=Math.floor(I/(i.slidesPerGroup*i.slidesPerColumn)),B=I-i.slidesPerColumn*i.slidesPerGroup*G,H=0===G?i.slidesPerGroup:Math.min(Math.ceil((u-G*k*i.slidesPerGroup)/k),i.slidesPerGroup);A=(D=B-(N=Math.floor(B/H))*H+G*i.slidesPerGroup)+N*T/k,O.css({"-webkit-box-ordinal-group":A,"-moz-box-ordinal-group":A,"-ms-flex-order":A,"-webkit-order":A,order:A})}else"column"===i.slidesPerColumnFill?(N=I-(D=Math.floor(I/k))*k,(D>L||D===L&&N===k-1)&&(N+=1)>=k&&(N=0,D+=1)):D=I-(N=Math.floor(I/$))*$;O.css(t("margin-top"),0!==N?i.spaceBetween&&i.spaceBetween+"px":"")}if("none"!==O.css("display")){if("auto"===i.slidesPerView){var R=getComputedStyle(O[0]),X=O[0].style.transform,Y=O[0].style.webkitTransform;if(X&&(O[0].style.transform="none"),Y&&(O[0].style.webkitTransform="none"),i.roundLengths)C=e.isHorizontal()?O.outerWidth(!0):O.outerHeight(!0);else{var V=a(R,"width"),W=a(R,"padding-left"),F=a(R,"padding-right"),_=a(R,"margin-left"),q=a(R,"margin-right"),j=R.getPropertyValue("box-sizing");if(j&&"border-box"===j)C=V+_+q;else{var U=O[0],K=U.clientWidth;C=V+W+F+_+q+(U.offsetWidth-K)}}X&&(O[0].style.transform=X),Y&&(O[0].style.webkitTransform=Y),i.roundLengths&&(C=Math.floor(C))}else C=(r-(i.slidesPerView-1)*w)/i.slidesPerView,i.roundLengths&&(C=Math.floor(C)),p[I]&&(p[I].style[t("width")]=C+"px");p[I]&&(p[I].swiperSlideSize=C),v.push(C),i.centeredSlides?(y=y+C/2+E/2+w,0===E&&0!==I&&(y=y-r/2-w),0===I&&(y=y-r/2-w),Math.abs(y)<.001&&(y=0),i.roundLengths&&(y=Math.floor(y)),x%i.slidesPerGroup==0&&c.push(y),h.push(y)):(i.roundLengths&&(y=Math.floor(y)),(x-Math.min(e.params.slidesPerGroupSkip,x))%e.params.slidesPerGroup==0&&c.push(y),h.push(y),y=y+C+w),e.virtualSize+=C+w,E=C,x+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+m,n&&l&&("slide"===i.effect||"coverflow"===i.effect)&&s.css({width:e.virtualSize+i.spaceBetween+"px"}),i.setWrapperSize)s.css(((z={})[t("width")]=e.virtualSize+i.spaceBetween+"px",z));if(i.slidesPerColumn>1)if(e.virtualSize=(C+i.spaceBetween)*T,e.virtualSize=Math.ceil(e.virtualSize/i.slidesPerColumn)-i.spaceBetween,s.css(((P={})[t("width")]=e.virtualSize+i.spaceBetween+"px",P)),i.centeredSlides){S=[];for(var Z=0;Z<c.length;Z+=1){var J=c[Z];i.roundLengths&&(J=Math.floor(J)),c[Z]<e.virtualSize+c[0]&&S.push(J)}c=S}if(!i.centeredSlides){S=[];for(var Q=0;Q<c.length;Q+=1){var ee=c[Q];i.roundLengths&&(ee=Math.floor(ee)),c[Q]<=e.virtualSize-r&&S.push(ee)}c=S,Math.floor(e.virtualSize-r)-Math.floor(c[c.length-1])>1&&c.push(e.virtualSize-r)}if(0===c.length&&(c=[0]),0!==i.spaceBetween){var te,ae=e.isHorizontal()&&n?"marginLeft":t("marginRight");p.filter((function(e,t){return!i.cssMode||t!==p.length-1})).css(((te={})[ae]=w+"px",te))}if(i.centeredSlides&&i.centeredSlidesBounds){var ie=0;v.forEach((function(e){ie+=e+(i.spaceBetween?i.spaceBetween:0)}));var se=(ie-=i.spaceBetween)-r;c=c.map((function(e){return e<0?-f:e>se?se+m:e}))}if(i.centerInsufficientSlides){var re=0;if(v.forEach((function(e){re+=e+(i.spaceBetween?i.spaceBetween:0)})),(re-=i.spaceBetween)<r){var ne=(r-re)/2;c.forEach((function(e,t){c[t]=e-ne})),h.forEach((function(e,t){h[t]=e+ne}))}}M(e,{slides:p,snapGrid:c,slidesGrid:h,slidesSizesGrid:v}),u!==d&&e.emit("slidesLengthChange"),c.length!==g&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==b&&e.emit("slidesGridLengthChange"),(i.watchSlidesProgress||i.watchSlidesVisibility)&&e.updateSlidesOffset()}},updateAutoHeight:function(e){var t,a=this,i=[],s=a.virtual&&a.params.virtual.enabled,r=0;"number"==typeof e?a.setTransition(e):!0===e&&a.setTransition(a.params.speed);var n=function(e){return s?a.slides.filter((function(t){return parseInt(t.getAttribute("data-swiper-slide-index"),10)===e}))[0]:a.slides.eq(e)[0]};if("auto"!==a.params.slidesPerView&&a.params.slidesPerView>1)if(a.params.centeredSlides)a.visibleSlides.each((function(e){i.push(e)}));else for(t=0;t<Math.ceil(a.params.slidesPerView);t+=1){var l=a.activeIndex+t;if(l>a.slides.length&&!s)break;i.push(n(l))}else i.push(n(a.activeIndex));for(t=0;t<i.length;t+=1)if(void 0!==i[t]){var o=i[t].offsetHeight;r=o>r?o:r}r&&a.$wrapperEl.css("height",r+"px")},updateSlidesOffset:function(){for(var e=this.slides,t=0;t<e.length;t+=1)e[t].swiperSlideOffset=this.isHorizontal()?e[t].offsetLeft:e[t].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);var t=this,a=t.params,i=t.slides,s=t.rtlTranslate;if(0!==i.length){void 0===i[0].swiperSlideOffset&&t.updateSlidesOffset();var r=-e;s&&(r=e),i.removeClass(a.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(var n=0;n<i.length;n+=1){var l=i[n],o=(r+(a.centeredSlides?t.minTranslate():0)-l.swiperSlideOffset)/(l.swiperSlideSize+a.spaceBetween);if(a.watchSlidesVisibility||a.centeredSlides&&a.autoHeight){var d=-(r-l.swiperSlideOffset),p=d+t.slidesSizesGrid[n];(d>=0&&d<t.size-1||p>1&&p<=t.size||d<=0&&p>=t.size)&&(t.visibleSlides.push(l),t.visibleSlidesIndexes.push(n),i.eq(n).addClass(a.slideVisibleClass))}l.progress=s?-o:o}t.visibleSlides=m(t.visibleSlides)}},updateProgress:function(e){var t=this;if(void 0===e){var a=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*a||0}var i=t.params,s=t.maxTranslate()-t.minTranslate(),r=t.progress,n=t.isBeginning,l=t.isEnd,o=n,d=l;0===s?(r=0,n=!0,l=!0):(n=(r=(e-t.minTranslate())/s)<=0,l=r>=1),M(t,{progress:r,isBeginning:n,isEnd:l}),(i.watchSlidesProgress||i.watchSlidesVisibility||i.centeredSlides&&i.autoHeight)&&t.updateSlidesProgress(e),n&&!o&&t.emit("reachBeginning toEdge"),l&&!d&&t.emit("reachEnd toEdge"),(o&&!n||d&&!l)&&t.emit("fromEdge"),t.emit("progress",r)},updateSlidesClasses:function(){var e,t=this,a=t.slides,i=t.params,s=t.$wrapperEl,r=t.activeIndex,n=t.realIndex,l=t.virtual&&i.virtual.enabled;a.removeClass(i.slideActiveClass+" "+i.slideNextClass+" "+i.slidePrevClass+" "+i.slideDuplicateActiveClass+" "+i.slideDuplicateNextClass+" "+i.slideDuplicatePrevClass),(e=l?t.$wrapperEl.find("."+i.slideClass+'[data-swiper-slide-index="'+r+'"]'):a.eq(r)).addClass(i.slideActiveClass),i.loop&&(e.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+n+'"]').addClass(i.slideDuplicateActiveClass));var o=e.nextAll("."+i.slideClass).eq(0).addClass(i.slideNextClass);i.loop&&0===o.length&&(o=a.eq(0)).addClass(i.slideNextClass);var d=e.prevAll("."+i.slideClass).eq(0).addClass(i.slidePrevClass);i.loop&&0===d.length&&(d=a.eq(-1)).addClass(i.slidePrevClass),i.loop&&(o.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+o.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicateNextClass),d.hasClass(i.slideDuplicateClass)?s.children("."+i.slideClass+":not(."+i.slideDuplicateClass+')[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass):s.children("."+i.slideClass+"."+i.slideDuplicateClass+'[data-swiper-slide-index="'+d.attr("data-swiper-slide-index")+'"]').addClass(i.slideDuplicatePrevClass)),t.emitSlidesClasses()},updateActiveIndex:function(e){var t,a=this,i=a.rtlTranslate?a.translate:-a.translate,s=a.slidesGrid,r=a.snapGrid,n=a.params,l=a.activeIndex,o=a.realIndex,d=a.snapIndex,p=e;if(void 0===p){for(var u=0;u<s.length;u+=1)void 0!==s[u+1]?i>=s[u]&&i<s[u+1]-(s[u+1]-s[u])/2?p=u:i>=s[u]&&i<s[u+1]&&(p=u+1):i>=s[u]&&(p=u);n.normalizeSlideIndex&&(p<0||void 0===p)&&(p=0)}if(r.indexOf(i)>=0)t=r.indexOf(i);else{var c=Math.min(n.slidesPerGroupSkip,p);t=c+Math.floor((p-c)/n.slidesPerGroup)}if(t>=r.length&&(t=r.length-1),p!==l){var h=parseInt(a.slides.eq(p).attr("data-swiper-slide-index")||p,10);M(a,{snapIndex:t,realIndex:h,previousIndex:l,activeIndex:p}),a.emit("activeIndexChange"),a.emit("snapIndexChange"),o!==h&&a.emit("realIndexChange"),(a.initialized||a.params.runCallbacksOnInit)&&a.emit("slideChange")}else t!==d&&(a.snapIndex=t,a.emit("snapIndexChange"))},updateClickedSlide:function(e){var t,a=this,i=a.params,s=m(e.target).closest("."+i.slideClass)[0],r=!1;if(s)for(var n=0;n<a.slides.length;n+=1)if(a.slides[n]===s){r=!0,t=n;break}if(!s||!r)return a.clickedSlide=void 0,void(a.clickedIndex=void 0);a.clickedSlide=s,a.virtual&&a.params.virtual.enabled?a.clickedIndex=parseInt(m(s).attr("data-swiper-slide-index"),10):a.clickedIndex=t,i.slideToClickedSlide&&void 0!==a.clickedIndex&&a.clickedIndex!==a.activeIndex&&a.slideToClickedSlide()}},translate:{getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");var t=this,a=t.params,i=t.rtlTranslate,s=t.translate,r=t.$wrapperEl;if(a.virtualTranslate)return i?-s:s;if(a.cssMode)return s;var n=T(r[0],e);return i&&(n=-n),n||0},setTranslate:function(e,t){var a=this,i=a.rtlTranslate,s=a.params,r=a.$wrapperEl,n=a.wrapperEl,l=a.progress,o=0,d=0;a.isHorizontal()?o=i?-e:e:d=e,s.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),s.cssMode?n[a.isHorizontal()?"scrollLeft":"scrollTop"]=a.isHorizontal()?-o:-d:s.virtualTranslate||r.transform("translate3d("+o+"px, "+d+"px, 0px)"),a.previousTranslate=a.translate,a.translate=a.isHorizontal()?o:d;var p=a.maxTranslate()-a.minTranslate();(0===p?0:(e-a.minTranslate())/p)!==l&&a.updateProgress(e),a.emit("setTranslate",a.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,a,i,s){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0),void 0===i&&(i=!0);var r=this,n=r.params,l=r.wrapperEl;if(r.animating&&n.preventInteractionOnTransition)return!1;var o,d=r.minTranslate(),p=r.maxTranslate();if(o=i&&e>d?d:i&&e<p?p:e,r.updateProgress(o),n.cssMode){var u,c=r.isHorizontal();if(0===t)l[c?"scrollLeft":"scrollTop"]=-o;else if(l.scrollTo)l.scrollTo(((u={})[c?"left":"top"]=-o,u.behavior="smooth",u));else l[c?"scrollLeft":"scrollTop"]=-o;return!0}return 0===t?(r.setTransition(0),r.setTranslate(o),a&&(r.emit("beforeTransitionStart",t,s),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(o),a&&(r.emit("beforeTransitionStart",t,s),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.$wrapperEl[0].removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].removeEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,a&&r.emit("transitionEnd"))}),r.$wrapperEl[0].addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.$wrapperEl[0].addEventListener("webkitTransitionEnd",r.onTranslateToWrapperTransitionEnd))),!0}},transition:{setTransition:function(e,t){var a=this;a.params.cssMode||a.$wrapperEl.transition(e),a.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.params,r=a.previousIndex;if(!s.cssMode){s.autoHeight&&a.updateAutoHeight();var n=t;if(n||(n=i>r?"next":i<r?"prev":"reset"),a.emit("transitionStart"),e&&i!==r){if("reset"===n)return void a.emit("slideResetTransitionStart");a.emit("slideChangeTransitionStart"),"next"===n?a.emit("slideNextTransitionStart"):a.emit("slidePrevTransitionStart")}}},transitionEnd:function(e,t){void 0===e&&(e=!0);var a=this,i=a.activeIndex,s=a.previousIndex,r=a.params;if(a.animating=!1,!r.cssMode){a.setTransition(0);var n=t;if(n||(n=i>s?"next":i<s?"prev":"reset"),a.emit("transitionEnd"),e&&i!==s){if("reset"===n)return void a.emit("slideResetTransitionEnd");a.emit("slideChangeTransitionEnd"),"next"===n?a.emit("slideNextTransitionEnd"):a.emit("slidePrevTransitionEnd")}}}},slide:{slideTo:function(e,t,a,i,s){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0),"number"!=typeof e&&"string"!=typeof e)throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. ["+typeof e+"] given.");if("string"==typeof e){var r=parseInt(e,10);if(!isFinite(r))throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. ["+e+"] given.");e=r}var n=this,l=e;l<0&&(l=0);var o=n.params,d=n.snapGrid,p=n.slidesGrid,u=n.previousIndex,c=n.activeIndex,h=n.rtlTranslate,v=n.wrapperEl,f=n.enabled;if(n.animating&&o.preventInteractionOnTransition||!f&&!i&&!s)return!1;var m=Math.min(n.params.slidesPerGroupSkip,l),g=m+Math.floor((l-m)/n.params.slidesPerGroup);g>=d.length&&(g=d.length-1),(c||o.initialSlide||0)===(u||0)&&a&&n.emit("beforeSlideChangeStart");var b,w=-d[g];if(n.updateProgress(w),o.normalizeSlideIndex)for(var y=0;y<p.length;y+=1){var E=-Math.floor(100*w),x=Math.floor(100*p[y]),T=Math.floor(100*p[y+1]);void 0!==p[y+1]?E>=x&&E<T-(T-x)/2?l=y:E>=x&&E<T&&(l=y+1):E>=x&&(l=y)}if(n.initialized&&l!==c){if(!n.allowSlideNext&&w<n.translate&&w<n.minTranslate())return!1;if(!n.allowSlidePrev&&w>n.translate&&w>n.maxTranslate()&&(c||0)!==l)return!1}if(b=l>c?"next":l<c?"prev":"reset",h&&-w===n.translate||!h&&w===n.translate)return n.updateActiveIndex(l),o.autoHeight&&n.updateAutoHeight(),n.updateSlidesClasses(),"slide"!==o.effect&&n.setTranslate(w),"reset"!==b&&(n.transitionStart(a,b),n.transitionEnd(a,b)),!1;if(o.cssMode){var C,S=n.isHorizontal(),M=-w;if(h&&(M=v.scrollWidth-v.offsetWidth-M),0===t)v[S?"scrollLeft":"scrollTop"]=M;else if(v.scrollTo)v.scrollTo(((C={})[S?"left":"top"]=M,C.behavior="smooth",C));else v[S?"scrollLeft":"scrollTop"]=M;return!0}return 0===t?(n.setTransition(0),n.setTranslate(w),n.updateActiveIndex(l),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(a,b),n.transitionEnd(a,b)):(n.setTransition(t),n.setTranslate(w),n.updateActiveIndex(l),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(a,b),n.animating||(n.animating=!0,n.onSlideToWrapperTransitionEnd||(n.onSlideToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd),n.onSlideToWrapperTransitionEnd=null,delete n.onSlideToWrapperTransitionEnd,n.transitionEnd(a,b))}),n.$wrapperEl[0].addEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd))),!0},slideToLoop:function(e,t,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===a&&(a=!0);var s=this,r=e;return s.params.loop&&(r+=s.loopedSlides),s.slideTo(r,t,a,i)},slideNext:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating;if(!i.enabled)return i;var n=i.activeIndex<s.slidesPerGroupSkip?1:s.slidesPerGroup;if(s.loop){if(r&&s.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}return i.slideTo(i.activeIndex+n,e,t,a)},slidePrev:function(e,t,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);var i=this,s=i.params,r=i.animating,n=i.snapGrid,l=i.slidesGrid,o=i.rtlTranslate;if(!i.enabled)return i;if(s.loop){if(r&&s.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}function d(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}var p,u=d(o?i.translate:-i.translate),c=n.map((function(e){return d(e)})),h=n[c.indexOf(u)-1];return void 0===h&&s.cssMode&&n.forEach((function(e){!h&&u>=e&&(h=e)})),void 0!==h&&(p=l.indexOf(h))<0&&(p=i.activeIndex-1),i.slideTo(p,e,t,a)},slideReset:function(e,t,a){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,a)},slideToClosest:function(e,t,a,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===i&&(i=.5);var s=this,r=s.activeIndex,n=Math.min(s.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/s.params.slidesPerGroup),o=s.rtlTranslate?s.translate:-s.translate;if(o>=s.snapGrid[l]){var d=s.snapGrid[l];o-d>(s.snapGrid[l+1]-d)*i&&(r+=s.params.slidesPerGroup)}else{var p=s.snapGrid[l-1];o-p<=(s.snapGrid[l]-p)*i&&(r-=s.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,s.slidesGrid.length-1),s.slideTo(r,e,t,a)},slideToClickedSlide:function(){var e,t=this,a=t.params,i=t.$wrapperEl,s="auto"===a.slidesPerView?t.slidesPerViewDynamic():a.slidesPerView,r=t.clickedIndex;if(a.loop){if(t.animating)return;e=parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"),10),a.centeredSlides?r<t.loopedSlides-s/2||r>t.slides.length-t.loopedSlides+s/2?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),E((function(){t.slideTo(r)}))):t.slideTo(r):r>t.slides.length-s?(t.loopFix(),r=i.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]:not(.'+a.slideDuplicateClass+")").eq(0).index(),E((function(){t.slideTo(r)}))):t.slideTo(r)}else t.slideTo(r)}},loop:{loopCreate:function(){var e=this,t=r(),a=e.params,i=e.$wrapperEl;i.children("."+a.slideClass+"."+a.slideDuplicateClass).remove();var s=i.children("."+a.slideClass);if(a.loopFillGroupWithBlank){var n=a.slidesPerGroup-s.length%a.slidesPerGroup;if(n!==a.slidesPerGroup){for(var l=0;l<n;l+=1){var o=m(t.createElement("div")).addClass(a.slideClass+" "+a.slideBlankClass);i.append(o)}s=i.children("."+a.slideClass)}}"auto"!==a.slidesPerView||a.loopedSlides||(a.loopedSlides=s.length),e.loopedSlides=Math.ceil(parseFloat(a.loopedSlides||a.slidesPerView,10)),e.loopedSlides+=a.loopAdditionalSlides,e.loopedSlides>s.length&&(e.loopedSlides=s.length);var d=[],p=[];s.each((function(t,a){var i=m(t);a<e.loopedSlides&&p.push(t),a<s.length&&a>=s.length-e.loopedSlides&&d.push(t),i.attr("data-swiper-slide-index",a)}));for(var u=0;u<p.length;u+=1)i.append(m(p[u].cloneNode(!0)).addClass(a.slideDuplicateClass));for(var c=d.length-1;c>=0;c-=1)i.prepend(m(d[c].cloneNode(!0)).addClass(a.slideDuplicateClass))},loopFix:function(){var e=this;e.emit("beforeLoopFix");var t,a=e.activeIndex,i=e.slides,s=e.loopedSlides,r=e.allowSlidePrev,n=e.allowSlideNext,l=e.snapGrid,o=e.rtlTranslate;e.allowSlidePrev=!0,e.allowSlideNext=!0;var d=-l[a]-e.getTranslate();if(a<s)t=i.length-3*s+a,t+=s,e.slideTo(t,0,!1,!0)&&0!==d&&e.setTranslate((o?-e.translate:e.translate)-d);else if(a>=i.length-s){t=-i.length+a+s,t+=s,e.slideTo(t,0,!1,!0)&&0!==d&&e.setTranslate((o?-e.translate:e.translate)-d)}e.allowSlidePrev=r,e.allowSlideNext=n,e.emit("loopFix")},loopDestroy:function(){var e=this,t=e.$wrapperEl,a=e.params,i=e.slides;t.children("."+a.slideClass+"."+a.slideDuplicateClass+",."+a.slideClass+"."+a.slideBlankClass).remove(),i.removeAttr("data-swiper-slide-index")}},grabCursor:{setGrabCursor:function(e){var t=this;if(!(t.support.touch||!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)){var a=t.el;a.style.cursor="move",a.style.cursor=e?"-webkit-grabbing":"-webkit-grab",a.style.cursor=e?"-moz-grabbin":"-moz-grab",a.style.cursor=e?"grabbing":"grab"}},unsetGrabCursor:function(){var e=this;e.support.touch||e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e.el.style.cursor="")}},manipulation:{appendSlide:function(e){var t=this,a=t.$wrapperEl,i=t.params;if(i.loop&&t.loopDestroy(),"object"==typeof e&&"length"in e)for(var s=0;s<e.length;s+=1)e[s]&&a.append(e[s]);else a.append(e);i.loop&&t.loopCreate(),i.observer&&t.support.observer||t.update()},prependSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&t.loopDestroy();var r=s+1;if("object"==typeof e&&"length"in e){for(var n=0;n<e.length;n+=1)e[n]&&i.prepend(e[n]);r=s+e.length}else i.prepend(e);a.loop&&t.loopCreate(),a.observer&&t.support.observer||t.update(),t.slideTo(r,0,!1)},addSlide:function(e,t){var a=this,i=a.$wrapperEl,s=a.params,r=a.activeIndex;s.loop&&(r-=a.loopedSlides,a.loopDestroy(),a.slides=i.children("."+s.slideClass));var n=a.slides.length;if(e<=0)a.prependSlide(t);else if(e>=n)a.appendSlide(t);else{for(var l=r>e?r+1:r,o=[],d=n-1;d>=e;d-=1){var p=a.slides.eq(d);p.remove(),o.unshift(p)}if("object"==typeof t&&"length"in t){for(var u=0;u<t.length;u+=1)t[u]&&i.append(t[u]);l=r>e?r+t.length:r}else i.append(t);for(var c=0;c<o.length;c+=1)i.append(o[c]);s.loop&&a.loopCreate(),s.observer&&a.support.observer||a.update(),s.loop?a.slideTo(l+a.loopedSlides,0,!1):a.slideTo(l,0,!1)}},removeSlide:function(e){var t=this,a=t.params,i=t.$wrapperEl,s=t.activeIndex;a.loop&&(s-=t.loopedSlides,t.loopDestroy(),t.slides=i.children("."+a.slideClass));var r,n=s;if("object"==typeof e&&"length"in e){for(var l=0;l<e.length;l+=1)r=e[l],t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides.eq(r).remove(),r<n&&(n-=1),n=Math.max(n,0);a.loop&&t.loopCreate(),a.observer&&t.support.observer||t.update(),a.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)},removeAllSlides:function(){for(var e=[],t=0;t<this.slides.length;t+=1)e.push(t);this.removeSlide(e)}},events:{attachEvents:function(){var e=this,t=r(),a=e.params,i=e.touchEvents,s=e.el,n=e.wrapperEl,l=e.device,o=e.support;e.onTouchStart=N.bind(e),e.onTouchMove=G.bind(e),e.onTouchEnd=B.bind(e),a.cssMode&&(e.onScroll=X.bind(e)),e.onClick=R.bind(e);var d=!!a.nested;if(!o.touch&&o.pointerEvents)s.addEventListener(i.start,e.onTouchStart,!1),t.addEventListener(i.move,e.onTouchMove,d),t.addEventListener(i.end,e.onTouchEnd,!1);else{if(o.touch){var p=!("touchstart"!==i.start||!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};s.addEventListener(i.start,e.onTouchStart,p),s.addEventListener(i.move,e.onTouchMove,o.passiveListener?{passive:!1,capture:d}:d),s.addEventListener(i.end,e.onTouchEnd,p),i.cancel&&s.addEventListener(i.cancel,e.onTouchEnd,p),Y||(t.addEventListener("touchstart",V),Y=!0)}(a.simulateTouch&&!l.ios&&!l.android||a.simulateTouch&&!o.touch&&l.ios)&&(s.addEventListener("mousedown",e.onTouchStart,!1),t.addEventListener("mousemove",e.onTouchMove,d),t.addEventListener("mouseup",e.onTouchEnd,!1))}(a.preventClicks||a.preventClicksPropagation)&&s.addEventListener("click",e.onClick,!0),a.cssMode&&n.addEventListener("scroll",e.onScroll),a.updateOnWindowResize?e.on(l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",H,!0):e.on("observerUpdate",H,!0)},detachEvents:function(){var e=this,t=r(),a=e.params,i=e.touchEvents,s=e.el,n=e.wrapperEl,l=e.device,o=e.support,d=!!a.nested;if(!o.touch&&o.pointerEvents)s.removeEventListener(i.start,e.onTouchStart,!1),t.removeEventListener(i.move,e.onTouchMove,d),t.removeEventListener(i.end,e.onTouchEnd,!1);else{if(o.touch){var p=!("onTouchStart"!==i.start||!o.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};s.removeEventListener(i.start,e.onTouchStart,p),s.removeEventListener(i.move,e.onTouchMove,d),s.removeEventListener(i.end,e.onTouchEnd,p),i.cancel&&s.removeEventListener(i.cancel,e.onTouchEnd,p)}(a.simulateTouch&&!l.ios&&!l.android||a.simulateTouch&&!o.touch&&l.ios)&&(s.removeEventListener("mousedown",e.onTouchStart,!1),t.removeEventListener("mousemove",e.onTouchMove,d),t.removeEventListener("mouseup",e.onTouchEnd,!1))}(a.preventClicks||a.preventClicksPropagation)&&s.removeEventListener("click",e.onClick,!0),a.cssMode&&n.removeEventListener("scroll",e.onScroll),e.off(l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",H)}},breakpoints:{setBreakpoint:function(){var e=this,t=e.activeIndex,a=e.initialized,i=e.loopedSlides,s=void 0===i?0:i,r=e.params,n=e.$el,l=r.breakpoints;if(l&&(!l||0!==Object.keys(l).length)){var o=e.getBreakpoint(l,e.params.breakpointsBase,e.el);if(o&&e.currentBreakpoint!==o){var d=o in l?l[o]:void 0;d&&["slidesPerView","spaceBetween","slidesPerGroup","slidesPerGroupSkip","slidesPerColumn"].forEach((function(e){var t=d[e];void 0!==t&&(d[e]="slidesPerView"!==e||"AUTO"!==t&&"auto"!==t?"slidesPerView"===e?parseFloat(t):parseInt(t,10):"auto")}));var p=d||e.originalParams,u=r.slidesPerColumn>1,c=p.slidesPerColumn>1,h=r.enabled;u&&!c?(n.removeClass(r.containerModifierClass+"multirow "+r.containerModifierClass+"multirow-column"),e.emitContainerClasses()):!u&&c&&(n.addClass(r.containerModifierClass+"multirow"),(p.slidesPerColumnFill&&"column"===p.slidesPerColumnFill||!p.slidesPerColumnFill&&"column"===r.slidesPerColumnFill)&&n.addClass(r.containerModifierClass+"multirow-column"),e.emitContainerClasses());var v=p.direction&&p.direction!==r.direction,f=r.loop&&(p.slidesPerView!==r.slidesPerView||v);v&&a&&e.changeDirection(),M(e.params,p);var m=e.params.enabled;M(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),h&&!m?e.disable():!h&&m&&e.enable(),e.currentBreakpoint=o,e.emit("_beforeBreakpoint",p),f&&a&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-s+e.loopedSlides,0,!1)),e.emit("breakpoint",p)}}},getBreakpoint:function(e,t,a){if(void 0===t&&(t="window"),e&&("container"!==t||a)){var i=!1,s=l(),r="window"===t?s.innerHeight:a.clientHeight,n=Object.keys(e).map((function(e){if("string"==typeof e&&0===e.indexOf("@")){var t=parseFloat(e.substr(1));return{value:r*t,point:e}}return{value:e,point:e}}));n.sort((function(e,t){return parseInt(e.value,10)-parseInt(t.value,10)}));for(var o=0;o<n.length;o+=1){var d=n[o],p=d.point,u=d.value;"window"===t?s.matchMedia("(min-width: "+u+"px)").matches&&(i=p):u<=a.clientWidth&&(i=p)}return i||"max"}}},checkOverflow:{checkOverflow:function(){var e=this,t=e.params,a=e.isLocked,i=e.slides.length>0&&t.slidesOffsetBefore+t.spaceBetween*(e.slides.length-1)+e.slides[0].offsetWidth*e.slides.length;t.slidesOffsetBefore&&t.slidesOffsetAfter&&i?e.isLocked=i<=e.size:e.isLocked=1===e.snapGrid.length,e.allowSlideNext=!e.isLocked,e.allowSlidePrev=!e.isLocked,a!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock"),a&&a!==e.isLocked&&(e.isEnd=!1,e.navigation&&e.navigation.update())}},classes:{addClasses:function(){var e,t,a,i=this,s=i.classNames,r=i.params,n=i.rtl,l=i.$el,o=i.device,d=i.support,p=(e=["initialized",r.direction,{"pointer-events":d.pointerEvents&&!d.touch},{"free-mode":r.freeMode},{autoheight:r.autoHeight},{rtl:n},{multirow:r.slidesPerColumn>1},{"multirow-column":r.slidesPerColumn>1&&"column"===r.slidesPerColumnFill},{android:o.android},{ios:o.ios},{"css-mode":r.cssMode}],t=r.containerModifierClass,a=[],e.forEach((function(e){"object"==typeof e?Object.keys(e).forEach((function(i){e[i]&&a.push(t+i)})):"string"==typeof e&&a.push(t+e)})),a);s.push.apply(s,p),l.addClass([].concat(s).join(" ")),i.emitContainerClasses()},removeClasses:function(){var e=this,t=e.$el,a=e.classNames;t.removeClass(a.join(" ")),e.emitContainerClasses()}},images:{loadImage:function(e,t,a,i,s,r){var n,o=l();function d(){r&&r()}m(e).parent("picture")[0]||e.complete&&s?d():t?((n=new o.Image).onload=d,n.onerror=d,i&&(n.sizes=i),a&&(n.srcset=a),t&&(n.src=t)):d()},preloadImages:function(){var e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(var a=0;a<e.imagesToLoad.length;a+=1){var i=e.imagesToLoad[a];e.loadImage(i,i.currentSrc||i.getAttribute("src"),i.srcset||i.getAttribute("srcset"),i.sizes||i.getAttribute("sizes"),!0,t)}}}},_={},q=function(){function t(){for(var e,a,i=arguments.length,s=new Array(i),r=0;r<i;r++)s[r]=arguments[r];if(1===s.length&&s[0].constructor&&"Object"===Object.prototype.toString.call(s[0]).slice(8,-1)?a=s[0]:(e=s[0],a=s[1]),a||(a={}),a=M({},a),e&&!a.el&&(a.el=e),a.el&&m(a.el).length>1){var n=[];return m(a.el).each((function(e){var i=M({},a,{el:e});n.push(new t(i))})),n}var l=this;l.__swiper__=!0,l.support=$(),l.device=L({userAgent:a.userAgent}),l.browser=I(),l.eventsListeners={},l.eventsAnyListeners=[],void 0===l.modules&&(l.modules={}),Object.keys(l.modules).forEach((function(e){var t=l.modules[e];if(t.params){var i=Object.keys(t.params)[0],s=t.params[i];if("object"!=typeof s||null===s)return;if(["navigation","pagination","scrollbar"].indexOf(i)>=0&&!0===a[i]&&(a[i]={auto:!0}),!(i in a)||!("enabled"in s))return;!0===a[i]&&(a[i]={enabled:!0}),"object"!=typeof a[i]||"enabled"in a[i]||(a[i].enabled=!0),a[i]||(a[i]={enabled:!1})}}));var o,d,p=M({},W);return l.useParams(p),l.params=M({},p,_,a),l.originalParams=M({},l.params),l.passedParams=M({},a),l.params&&l.params.on&&Object.keys(l.params.on).forEach((function(e){l.on(e,l.params.on[e])})),l.params&&l.params.onAny&&l.onAny(l.params.onAny),l.$=m,M(l,{enabled:l.params.enabled,el:e,classNames:[],slides:m(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:function(){return"horizontal"===l.params.direction},isVertical:function(){return"vertical"===l.params.direction},activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEvents:(o=["touchstart","touchmove","touchend","touchcancel"],d=["mousedown","mousemove","mouseup"],l.support.pointerEvents&&(d=["pointerdown","pointermove","pointerup"]),l.touchEventsTouch={start:o[0],move:o[1],end:o[2],cancel:o[3]},l.touchEventsDesktop={start:d[0],move:d[1],end:d[2]},l.support.touch||!l.params.simulateTouch?l.touchEventsTouch:l.touchEventsDesktop),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:l.params.focusableElements,lastClickTime:x(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.useModules(),l.emit("_swiper"),l.params.init&&l.init(),l}var a,i,s,n=t.prototype;return n.enable=function(){var e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))},n.disable=function(){var e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))},n.setProgress=function(e,t){var a=this;e=Math.min(Math.max(e,0),1);var i=a.minTranslate(),s=(a.maxTranslate()-i)*e+i;a.translateTo(s,void 0===t?0:t),a.updateActiveIndex(),a.updateSlidesClasses()},n.emitContainerClasses=function(){var e=this;if(e.params._emitClasses&&e.el){var t=e.el.className.split(" ").filter((function(t){return 0===t.indexOf("swiper-container")||0===t.indexOf(e.params.containerModifierClass)}));e.emit("_containerClasses",t.join(" "))}},n.getSlideClasses=function(e){var t=this;return e.className.split(" ").filter((function(e){return 0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass)})).join(" ")},n.emitSlidesClasses=function(){var e=this;if(e.params._emitClasses&&e.el){var t=[];e.slides.each((function(a){var i=e.getSlideClasses(a);t.push({slideEl:a,classNames:i}),e.emit("_slideClass",a,i)})),e.emit("_slideClasses",t)}},n.slidesPerViewDynamic=function(){var e=this,t=e.params,a=e.slides,i=e.slidesGrid,s=e.size,r=e.activeIndex,n=1;if(t.centeredSlides){for(var l,o=a[r].swiperSlideSize,d=r+1;d<a.length;d+=1)a[d]&&!l&&(n+=1,(o+=a[d].swiperSlideSize)>s&&(l=!0));for(var p=r-1;p>=0;p-=1)a[p]&&!l&&(n+=1,(o+=a[p].swiperSlideSize)>s&&(l=!0))}else for(var u=r+1;u<a.length;u+=1)i[u]-i[r]<s&&(n+=1);return n},n.update=function(){var e=this;if(e&&!e.destroyed){var t=e.snapGrid,a=e.params;a.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode?(i(),e.params.autoHeight&&e.updateAutoHeight()):(("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0))||i(),a.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}function i(){var t=e.rtlTranslate?-1*e.translate:e.translate,a=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(a),e.updateActiveIndex(),e.updateSlidesClasses()}},n.changeDirection=function(e,t){void 0===t&&(t=!0);var a=this,i=a.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e||(a.$el.removeClass(""+a.params.containerModifierClass+i).addClass(""+a.params.containerModifierClass+e),a.emitContainerClasses(),a.params.direction=e,a.slides.each((function(t){"vertical"===e?t.style.width="":t.style.height=""})),a.emit("changeDirection"),t&&a.update()),a},n.mount=function(e){var t=this;if(t.mounted)return!0;var a=m(e||t.params.el);if(!(e=a[0]))return!1;e.swiper=t;var i=function(){return"."+(t.params.wrapperClass||"").trim().split(" ").join(".")},s=function(){if(e&&e.shadowRoot&&e.shadowRoot.querySelector){var t=m(e.shadowRoot.querySelector(i()));return t.children=function(e){return a.children(e)},t}return a.children(i())}();if(0===s.length&&t.params.createElements){var n=r().createElement("div");s=m(n),n.className=t.params.wrapperClass,a.append(n),a.children("."+t.params.slideClass).each((function(e){s.append(e)}))}return M(t,{$el:a,el:e,$wrapperEl:s,wrapperEl:s[0],mounted:!0,rtl:"rtl"===e.dir.toLowerCase()||"rtl"===a.css("direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===e.dir.toLowerCase()||"rtl"===a.css("direction")),wrongRTL:"-webkit-box"===s.css("display")}),!0},n.init=function(e){var t=this;return t.initialized||!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.params.loop&&t.loopCreate(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.preloadImages&&t.preloadImages(),t.params.loop?t.slideTo(t.params.initialSlide+t.loopedSlides,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.attachEvents(),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t},n.destroy=function(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);var a,i=this,s=i.params,r=i.$el,n=i.$wrapperEl,l=i.slides;return void 0===i.params||i.destroyed||(i.emit("beforeDestroy"),i.initialized=!1,i.detachEvents(),s.loop&&i.loopDestroy(),t&&(i.removeClasses(),r.removeAttr("style"),n.removeAttr("style"),l&&l.length&&l.removeClass([s.slideVisibleClass,s.slideActiveClass,s.slideNextClass,s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),i.emit("destroy"),Object.keys(i.eventsListeners).forEach((function(e){i.off(e)})),!1!==e&&(i.$el[0].swiper=null,a=i,Object.keys(a).forEach((function(e){try{a[e]=null}catch(e){}try{delete a[e]}catch(e){}}))),i.destroyed=!0),null},t.extendDefaults=function(e){M(_,e)},t.installModule=function(e){t.prototype.modules||(t.prototype.modules={});var a=e.name||Object.keys(t.prototype.modules).length+"_"+x();t.prototype.modules[a]=e},t.use=function(e){return Array.isArray(e)?(e.forEach((function(e){return t.installModule(e)})),t):(t.installModule(e),t)},a=t,s=[{key:"extendedDefaults",get:function(){return _}},{key:"defaults",get:function(){return W}}],(i=null)&&e(a.prototype,i),s&&e(a,s),t}();Object.keys(F).forEach((function(e){Object.keys(F[e]).forEach((function(t){q.prototype[t]=F[e][t]}))})),q.use([O,D]);var j={update:function(e){var t=this,a=t.params,i=a.slidesPerView,s=a.slidesPerGroup,r=a.centeredSlides,n=t.params.virtual,l=n.addSlidesBefore,o=n.addSlidesAfter,d=t.virtual,p=d.from,u=d.to,c=d.slides,h=d.slidesGrid,v=d.renderSlide,f=d.offset;t.updateActiveIndex();var m,g,b,w=t.activeIndex||0;m=t.rtlTranslate?"right":t.isHorizontal()?"left":"top",r?(g=Math.floor(i/2)+s+o,b=Math.floor(i/2)+s+l):(g=i+(s-1)+o,b=s+l);var y=Math.max((w||0)-b,0),E=Math.min((w||0)+g,c.length-1),x=(t.slidesGrid[y]||0)-(t.slidesGrid[0]||0);function T(){t.updateSlides(),t.updateProgress(),t.updateSlidesClasses(),t.lazy&&t.params.lazy.enabled&&t.lazy.load()}if(M(t.virtual,{from:y,to:E,offset:x,slidesGrid:t.slidesGrid}),p===y&&u===E&&!e)return t.slidesGrid!==h&&x!==f&&t.slides.css(m,x+"px"),void t.updateProgress();if(t.params.virtual.renderExternal)return t.params.virtual.renderExternal.call(t,{offset:x,from:y,to:E,slides:function(){for(var e=[],t=y;t<=E;t+=1)e.push(c[t]);return e}()}),void(t.params.virtual.renderExternalUpdate&&T());var C=[],S=[];if(e)t.$wrapperEl.find("."+t.params.slideClass).remove();else for(var z=p;z<=u;z+=1)(z<y||z>E)&&t.$wrapperEl.find("."+t.params.slideClass+'[data-swiper-slide-index="'+z+'"]').remove();for(var P=0;P<c.length;P+=1)P>=y&&P<=E&&(void 0===u||e?S.push(P):(P>u&&S.push(P),P<p&&C.push(P)));S.forEach((function(e){t.$wrapperEl.append(v(c[e],e))})),C.sort((function(e,t){return t-e})).forEach((function(e){t.$wrapperEl.prepend(v(c[e],e))})),t.$wrapperEl.children(".swiper-slide").css(m,x+"px"),T()},renderSlide:function(e,t){var a=this,i=a.params.virtual;if(i.cache&&a.virtual.cache[t])return a.virtual.cache[t];var s=i.renderSlide?m(i.renderSlide.call(a,e,t)):m('<div class="'+a.params.slideClass+'" data-swiper-slide-index="'+t+'">'+e+"</div>");return s.attr("data-swiper-slide-index")||s.attr("data-swiper-slide-index",t),i.cache&&(a.virtual.cache[t]=s),s},appendSlide:function(e){var t=this;if("object"==typeof e&&"length"in e)for(var a=0;a<e.length;a+=1)e[a]&&t.virtual.slides.push(e[a]);else t.virtual.slides.push(e);t.virtual.update(!0)},prependSlide:function(e){var t=this,a=t.activeIndex,i=a+1,s=1;if(Array.isArray(e)){for(var r=0;r<e.length;r+=1)e[r]&&t.virtual.slides.unshift(e[r]);i=a+e.length,s=e.length}else t.virtual.slides.unshift(e);if(t.params.virtual.cache){var n=t.virtual.cache,l={};Object.keys(n).forEach((function(e){var t=n[e],a=t.attr("data-swiper-slide-index");a&&t.attr("data-swiper-slide-index",parseInt(a,10)+1),l[parseInt(e,10)+s]=t})),t.virtual.cache=l}t.virtual.update(!0),t.slideTo(i,0)},removeSlide:function(e){var t=this;if(null!=e){var a=t.activeIndex;if(Array.isArray(e))for(var i=e.length-1;i>=0;i-=1)t.virtual.slides.splice(e[i],1),t.params.virtual.cache&&delete t.virtual.cache[e[i]],e[i]<a&&(a-=1),a=Math.max(a,0);else t.virtual.slides.splice(e,1),t.params.virtual.cache&&delete t.virtual.cache[e],e<a&&(a-=1),a=Math.max(a,0);t.virtual.update(!0),t.slideTo(a,0)}},removeAllSlides:function(){var e=this;e.virtual.slides=[],e.params.virtual.cache&&(e.virtual.cache={}),e.virtual.update(!0),e.slideTo(0,0)}},U={name:"virtual",params:{virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}},create:function(){z(this,{virtual:t({},j,{slides:this.params.virtual.slides,cache:{}})})},on:{beforeInit:function(e){if(e.params.virtual.enabled){e.classNames.push(e.params.containerModifierClass+"virtual");var t={watchSlidesProgress:!0};M(e.params,t),M(e.originalParams,t),e.params.initialSlide||e.virtual.update()}},setTranslate:function(e){e.params.virtual.enabled&&e.virtual.update()}}},K={handle:function(e){var t=this;if(t.enabled){var a=l(),i=r(),s=t.rtlTranslate,n=e;n.originalEvent&&(n=n.originalEvent);var o=n.keyCode||n.charCode,d=t.params.keyboard.pageUpDown,p=d&&33===o,u=d&&34===o,c=37===o,h=39===o,v=38===o,f=40===o;if(!t.allowSlideNext&&(t.isHorizontal()&&h||t.isVertical()&&f||u))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&c||t.isVertical()&&v||p))return!1;if(!(n.shiftKey||n.altKey||n.ctrlKey||n.metaKey||i.activeElement&&i.activeElement.nodeName&&("input"===i.activeElement.nodeName.toLowerCase()||"textarea"===i.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(p||u||c||h||v||f)){var m=!1;if(t.$el.parents("."+t.params.slideClass).length>0&&0===t.$el.parents("."+t.params.slideActiveClass).length)return;var g=t.$el,b=g[0].clientWidth,w=g[0].clientHeight,y=a.innerWidth,E=a.innerHeight,x=t.$el.offset();s&&(x.left-=t.$el[0].scrollLeft);for(var T=[[x.left,x.top],[x.left+b,x.top],[x.left,x.top+w],[x.left+b,x.top+w]],C=0;C<T.length;C+=1){var S=T[C];if(S[0]>=0&&S[0]<=y&&S[1]>=0&&S[1]<=E){if(0===S[0]&&0===S[1])continue;m=!0}}if(!m)return}t.isHorizontal()?((p||u||c||h)&&(n.preventDefault?n.preventDefault():n.returnValue=!1),((u||h)&&!s||(p||c)&&s)&&t.slideNext(),((p||c)&&!s||(u||h)&&s)&&t.slidePrev()):((p||u||v||f)&&(n.preventDefault?n.preventDefault():n.returnValue=!1),(u||f)&&t.slideNext(),(p||v)&&t.slidePrev()),t.emit("keyPress",o)}}},enable:function(){var e=this,t=r();e.keyboard.enabled||(m(t).on("keydown",e.keyboard.handle),e.keyboard.enabled=!0)},disable:function(){var e=this,t=r();e.keyboard.enabled&&(m(t).off("keydown",e.keyboard.handle),e.keyboard.enabled=!1)}},Z={name:"keyboard",params:{keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}},create:function(){z(this,{keyboard:t({enabled:!1},K)})},on:{init:function(e){e.params.keyboard.enabled&&e.keyboard.enable()},destroy:function(e){e.keyboard.enabled&&e.keyboard.disable()}}};var J={lastScrollTime:x(),lastEventBeforeSnap:void 0,recentWheelEvents:[],event:function(){return l().navigator.userAgent.indexOf("firefox")>-1?"DOMMouseScroll":function(){var e=r(),t="onwheel",a=t in e;if(!a){var i=e.createElement("div");i.setAttribute(t,"return;"),a="function"==typeof i.onwheel}return!a&&e.implementation&&e.implementation.hasFeature&&!0!==e.implementation.hasFeature("","")&&(a=e.implementation.hasFeature("Events.wheel","3.0")),a}()?"wheel":"mousewheel"},normalize:function(e){var t=0,a=0,i=0,s=0;return"detail"in e&&(a=e.detail),"wheelDelta"in e&&(a=-e.wheelDelta/120),"wheelDeltaY"in e&&(a=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=a,a=0),i=10*t,s=10*a,"deltaY"in e&&(s=e.deltaY),"deltaX"in e&&(i=e.deltaX),e.shiftKey&&!i&&(i=s,s=0),(i||s)&&e.deltaMode&&(1===e.deltaMode?(i*=40,s*=40):(i*=800,s*=800)),i&&!t&&(t=i<1?-1:1),s&&!a&&(a=s<1?-1:1),{spinX:t,spinY:a,pixelX:i,pixelY:s}},handleMouseEnter:function(){this.enabled&&(this.mouseEntered=!0)},handleMouseLeave:function(){this.enabled&&(this.mouseEntered=!1)},handle:function(e){var t=e,a=this;if(a.enabled){var i=a.params.mousewheel;a.params.cssMode&&t.preventDefault();var s=a.$el;if("container"!==a.params.mousewheel.eventsTarget&&(s=m(a.params.mousewheel.eventsTarget)),!a.mouseEntered&&!s[0].contains(t.target)&&!i.releaseOnEdges)return!0;t.originalEvent&&(t=t.originalEvent);var r=0,n=a.rtlTranslate?-1:1,l=J.normalize(t);if(i.forceToAxis)if(a.isHorizontal()){if(!(Math.abs(l.pixelX)>Math.abs(l.pixelY)))return!0;r=-l.pixelX*n}else{if(!(Math.abs(l.pixelY)>Math.abs(l.pixelX)))return!0;r=-l.pixelY}else r=Math.abs(l.pixelX)>Math.abs(l.pixelY)?-l.pixelX*n:-l.pixelY;if(0===r)return!0;i.invert&&(r=-r);var o=a.getTranslate()+r*i.sensitivity;if(o>=a.minTranslate()&&(o=a.minTranslate()),o<=a.maxTranslate()&&(o=a.maxTranslate()),(!!a.params.loop||!(o===a.minTranslate()||o===a.maxTranslate()))&&a.params.nested&&t.stopPropagation(),a.params.freeMode){var d={time:x(),delta:Math.abs(r),direction:Math.sign(r)},p=a.mousewheel.lastEventBeforeSnap,u=p&&d.time<p.time+500&&d.delta<=p.delta&&d.direction===p.direction;if(!u){a.mousewheel.lastEventBeforeSnap=void 0,a.params.loop&&a.loopFix();var c=a.getTranslate()+r*i.sensitivity,h=a.isBeginning,v=a.isEnd;if(c>=a.minTranslate()&&(c=a.minTranslate()),c<=a.maxTranslate()&&(c=a.maxTranslate()),a.setTransition(0),a.setTranslate(c),a.updateProgress(),a.updateActiveIndex(),a.updateSlidesClasses(),(!h&&a.isBeginning||!v&&a.isEnd)&&a.updateSlidesClasses(),a.params.freeModeSticky){clearTimeout(a.mousewheel.timeout),a.mousewheel.timeout=void 0;var f=a.mousewheel.recentWheelEvents;f.length>=15&&f.shift();var g=f.length?f[f.length-1]:void 0,b=f[0];if(f.push(d),g&&(d.delta>g.delta||d.direction!==g.direction))f.splice(0);else if(f.length>=15&&d.time-b.time<500&&b.delta-d.delta>=1&&d.delta<=6){var w=r>0?.8:.2;a.mousewheel.lastEventBeforeSnap=d,f.splice(0),a.mousewheel.timeout=E((function(){a.slideToClosest(a.params.speed,!0,void 0,w)}),0)}a.mousewheel.timeout||(a.mousewheel.timeout=E((function(){a.mousewheel.lastEventBeforeSnap=d,f.splice(0),a.slideToClosest(a.params.speed,!0,void 0,.5)}),500))}if(u||a.emit("scroll",t),a.params.autoplay&&a.params.autoplayDisableOnInteraction&&a.autoplay.stop(),c===a.minTranslate()||c===a.maxTranslate())return!0}}else{var y={time:x(),delta:Math.abs(r),direction:Math.sign(r),raw:e},T=a.mousewheel.recentWheelEvents;T.length>=2&&T.shift();var C=T.length?T[T.length-1]:void 0;if(T.push(y),C?(y.direction!==C.direction||y.delta>C.delta||y.time>C.time+150)&&a.mousewheel.animateSlider(y):a.mousewheel.animateSlider(y),a.mousewheel.releaseScroll(y))return!0}return t.preventDefault?t.preventDefault():t.returnValue=!1,!1}},animateSlider:function(e){var t=this,a=l();return!(this.params.mousewheel.thresholdDelta&&e.delta<this.params.mousewheel.thresholdDelta)&&(!(this.params.mousewheel.thresholdTime&&x()-t.mousewheel.lastScrollTime<this.params.mousewheel.thresholdTime)&&(e.delta>=6&&x()-t.mousewheel.lastScrollTime<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),t.emit("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),t.emit("scroll",e.raw)),t.mousewheel.lastScrollTime=(new a.Date).getTime(),!1)))},releaseScroll:function(e){var t=this,a=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&a.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&a.releaseOnEdges)return!0;return!1},enable:function(){var e=this,t=J.event();if(e.params.cssMode)return e.wrapperEl.removeEventListener(t,e.mousewheel.handle),!0;if(!t)return!1;if(e.mousewheel.enabled)return!1;var a=e.$el;return"container"!==e.params.mousewheel.eventsTarget&&(a=m(e.params.mousewheel.eventsTarget)),a.on("mouseenter",e.mousewheel.handleMouseEnter),a.on("mouseleave",e.mousewheel.handleMouseLeave),a.on(t,e.mousewheel.handle),e.mousewheel.enabled=!0,!0},disable:function(){var e=this,t=J.event();if(e.params.cssMode)return e.wrapperEl.addEventListener(t,e.mousewheel.handle),!0;if(!t)return!1;if(!e.mousewheel.enabled)return!1;var a=e.$el;return"container"!==e.params.mousewheel.eventsTarget&&(a=m(e.params.mousewheel.eventsTarget)),a.off(t,e.mousewheel.handle),e.mousewheel.enabled=!1,!0}},Q={toggleEl:function(e,t){e[t?"addClass":"removeClass"](this.params.navigation.disabledClass),e[0]&&"BUTTON"===e[0].tagName&&(e[0].disabled=t)},update:function(){var e=this,t=e.params.navigation,a=e.navigation.toggleEl;if(!e.params.loop){var i=e.navigation,s=i.$nextEl,r=i.$prevEl;r&&r.length>0&&(e.isBeginning?a(r,!0):a(r,!1),e.params.watchOverflow&&e.enabled&&r[e.isLocked?"addClass":"removeClass"](t.lockClass)),s&&s.length>0&&(e.isEnd?a(s,!0):a(s,!1),e.params.watchOverflow&&e.enabled&&s[e.isLocked?"addClass":"removeClass"](t.lockClass))}},onPrevClick:function(e){var t=this;e.preventDefault(),t.isBeginning&&!t.params.loop||t.slidePrev()},onNextClick:function(e){var t=this;e.preventDefault(),t.isEnd&&!t.params.loop||t.slideNext()},init:function(){var e,t,a=this,i=a.params.navigation;(a.params.navigation=k(a.$el,a.params.navigation,a.params.createElements,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),i.nextEl||i.prevEl)&&(i.nextEl&&(e=m(i.nextEl),a.params.uniqueNavElements&&"string"==typeof i.nextEl&&e.length>1&&1===a.$el.find(i.nextEl).length&&(e=a.$el.find(i.nextEl))),i.prevEl&&(t=m(i.prevEl),a.params.uniqueNavElements&&"string"==typeof i.prevEl&&t.length>1&&1===a.$el.find(i.prevEl).length&&(t=a.$el.find(i.prevEl))),e&&e.length>0&&e.on("click",a.navigation.onNextClick),t&&t.length>0&&t.on("click",a.navigation.onPrevClick),M(a.navigation,{$nextEl:e,nextEl:e&&e[0],$prevEl:t,prevEl:t&&t[0]}),a.enabled||(e&&e.addClass(i.lockClass),t&&t.addClass(i.lockClass)))},destroy:function(){var e=this,t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a.length&&(a.off("click",e.navigation.onNextClick),a.removeClass(e.params.navigation.disabledClass)),i&&i.length&&(i.off("click",e.navigation.onPrevClick),i.removeClass(e.params.navigation.disabledClass))}},ee={update:function(){var e=this,t=e.rtl,a=e.params.pagination;if(a.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var i,s=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,r=e.pagination.$el,n=e.params.loop?Math.ceil((s-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;if(e.params.loop?((i=Math.ceil((e.activeIndex-e.loopedSlides)/e.params.slidesPerGroup))>s-1-2*e.loopedSlides&&(i-=s-2*e.loopedSlides),i>n-1&&(i-=n),i<0&&"bullets"!==e.params.paginationType&&(i=n+i)):i=void 0!==e.snapIndex?e.snapIndex:e.activeIndex||0,"bullets"===a.type&&e.pagination.bullets&&e.pagination.bullets.length>0){var l,o,d,p=e.pagination.bullets;if(a.dynamicBullets&&(e.pagination.bulletSize=p.eq(0)[e.isHorizontal()?"outerWidth":"outerHeight"](!0),r.css(e.isHorizontal()?"width":"height",e.pagination.bulletSize*(a.dynamicMainBullets+4)+"px"),a.dynamicMainBullets>1&&void 0!==e.previousIndex&&(e.pagination.dynamicBulletIndex+=i-e.previousIndex,e.pagination.dynamicBulletIndex>a.dynamicMainBullets-1?e.pagination.dynamicBulletIndex=a.dynamicMainBullets-1:e.pagination.dynamicBulletIndex<0&&(e.pagination.dynamicBulletIndex=0)),l=i-e.pagination.dynamicBulletIndex,d=((o=l+(Math.min(p.length,a.dynamicMainBullets)-1))+l)/2),p.removeClass(a.bulletActiveClass+" "+a.bulletActiveClass+"-next "+a.bulletActiveClass+"-next-next "+a.bulletActiveClass+"-prev "+a.bulletActiveClass+"-prev-prev "+a.bulletActiveClass+"-main"),r.length>1)p.each((function(e){var t=m(e),s=t.index();s===i&&t.addClass(a.bulletActiveClass),a.dynamicBullets&&(s>=l&&s<=o&&t.addClass(a.bulletActiveClass+"-main"),s===l&&t.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),s===o&&t.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next"))}));else{var u=p.eq(i),c=u.index();if(u.addClass(a.bulletActiveClass),a.dynamicBullets){for(var h=p.eq(l),v=p.eq(o),f=l;f<=o;f+=1)p.eq(f).addClass(a.bulletActiveClass+"-main");if(e.params.loop)if(c>=p.length-a.dynamicMainBullets){for(var g=a.dynamicMainBullets;g>=0;g-=1)p.eq(p.length-g).addClass(a.bulletActiveClass+"-main");p.eq(p.length-a.dynamicMainBullets-1).addClass(a.bulletActiveClass+"-prev")}else h.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),v.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next");else h.prev().addClass(a.bulletActiveClass+"-prev").prev().addClass(a.bulletActiveClass+"-prev-prev"),v.next().addClass(a.bulletActiveClass+"-next").next().addClass(a.bulletActiveClass+"-next-next")}}if(a.dynamicBullets){var b=Math.min(p.length,a.dynamicMainBullets+4),w=(e.pagination.bulletSize*b-e.pagination.bulletSize)/2-d*e.pagination.bulletSize,y=t?"right":"left";p.css(e.isHorizontal()?y:"top",w+"px")}}if("fraction"===a.type&&(r.find(P(a.currentClass)).text(a.formatFractionCurrent(i+1)),r.find(P(a.totalClass)).text(a.formatFractionTotal(n))),"progressbar"===a.type){var E;E=a.progressbarOpposite?e.isHorizontal()?"vertical":"horizontal":e.isHorizontal()?"horizontal":"vertical";var x=(i+1)/n,T=1,C=1;"horizontal"===E?T=x:C=x,r.find(P(a.progressbarFillClass)).transform("translate3d(0,0,0) scaleX("+T+") scaleY("+C+")").transition(e.params.speed)}"custom"===a.type&&a.renderCustom?(r.html(a.renderCustom(e,i+1,n)),e.emit("paginationRender",r[0])):e.emit("paginationUpdate",r[0]),e.params.watchOverflow&&e.enabled&&r[e.isLocked?"addClass":"removeClass"](a.lockClass)}},render:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.virtual&&e.params.virtual.enabled?e.virtual.slides.length:e.slides.length,i=e.pagination.$el,s="";if("bullets"===t.type){var r=e.params.loop?Math.ceil((a-2*e.loopedSlides)/e.params.slidesPerGroup):e.snapGrid.length;e.params.freeMode&&!e.params.loop&&r>a&&(r=a);for(var n=0;n<r;n+=1)t.renderBullet?s+=t.renderBullet.call(e,n,t.bulletClass):s+="<"+t.bulletElement+' class="'+t.bulletClass+'"></'+t.bulletElement+">";i.html(s),e.pagination.bullets=i.find(P(t.bulletClass))}"fraction"===t.type&&(s=t.renderFraction?t.renderFraction.call(e,t.currentClass,t.totalClass):'<span class="'+t.currentClass+'"></span> / <span class="'+t.totalClass+'"></span>',i.html(s)),"progressbar"===t.type&&(s=t.renderProgressbar?t.renderProgressbar.call(e,t.progressbarFillClass):'<span class="'+t.progressbarFillClass+'"></span>',i.html(s)),"custom"!==t.type&&e.emit("paginationRender",e.pagination.$el[0])}},init:function(){var e=this;e.params.pagination=k(e.$el,e.params.pagination,e.params.createElements,{el:"swiper-pagination"});var t=e.params.pagination;if(t.el){var a=m(t.el);0!==a.length&&(e.params.uniqueNavElements&&"string"==typeof t.el&&a.length>1&&(a=e.$el.find(t.el)),"bullets"===t.type&&t.clickable&&a.addClass(t.clickableClass),a.addClass(t.modifierClass+t.type),"bullets"===t.type&&t.dynamicBullets&&(a.addClass(""+t.modifierClass+t.type+"-dynamic"),e.pagination.dynamicBulletIndex=0,t.dynamicMainBullets<1&&(t.dynamicMainBullets=1)),"progressbar"===t.type&&t.progressbarOpposite&&a.addClass(t.progressbarOppositeClass),t.clickable&&a.on("click",P(t.bulletClass),(function(t){t.preventDefault();var a=m(this).index()*e.params.slidesPerGroup;e.params.loop&&(a+=e.loopedSlides),e.slideTo(a)})),M(e.pagination,{$el:a,el:a[0]}),e.enabled||a.addClass(t.lockClass))}},destroy:function(){var e=this,t=e.params.pagination;if(t.el&&e.pagination.el&&e.pagination.$el&&0!==e.pagination.$el.length){var a=e.pagination.$el;a.removeClass(t.hiddenClass),a.removeClass(t.modifierClass+t.type),e.pagination.bullets&&e.pagination.bullets.removeClass(t.bulletActiveClass),t.clickable&&a.off("click",P(t.bulletClass))}}},te={setTranslate:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=e.rtlTranslate,i=e.progress,s=t.dragSize,r=t.trackSize,n=t.$dragEl,l=t.$el,o=e.params.scrollbar,d=s,p=(r-s)*i;a?(p=-p)>0?(d=s-p,p=0):-p+s>r&&(d=r+p):p<0?(d=s+p,p=0):p+s>r&&(d=r-p),e.isHorizontal()?(n.transform("translate3d("+p+"px, 0, 0)"),n[0].style.width=d+"px"):(n.transform("translate3d(0px, "+p+"px, 0)"),n[0].style.height=d+"px"),o.hide&&(clearTimeout(e.scrollbar.timeout),l[0].style.opacity=1,e.scrollbar.timeout=setTimeout((function(){l[0].style.opacity=0,l.transition(400)}),1e3))}},setTransition:function(e){var t=this;t.params.scrollbar.el&&t.scrollbar.el&&t.scrollbar.$dragEl.transition(e)},updateSize:function(){var e=this;if(e.params.scrollbar.el&&e.scrollbar.el){var t=e.scrollbar,a=t.$dragEl,i=t.$el;a[0].style.width="",a[0].style.height="";var s,r=e.isHorizontal()?i[0].offsetWidth:i[0].offsetHeight,n=e.size/e.virtualSize,l=n*(r/e.size);s="auto"===e.params.scrollbar.dragSize?r*n:parseInt(e.params.scrollbar.dragSize,10),e.isHorizontal()?a[0].style.width=s+"px":a[0].style.height=s+"px",i[0].style.display=n>=1?"none":"",e.params.scrollbar.hide&&(i[0].style.opacity=0),M(t,{trackSize:r,divider:n,moveDivider:l,dragSize:s}),e.params.watchOverflow&&e.enabled&&t.$el[e.isLocked?"addClass":"removeClass"](e.params.scrollbar.lockClass)}},getPointerPosition:function(e){return this.isHorizontal()?"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientX:e.clientX:"touchstart"===e.type||"touchmove"===e.type?e.targetTouches[0].clientY:e.clientY},setDragPosition:function(e){var t,a=this,i=a.scrollbar,s=a.rtlTranslate,r=i.$el,n=i.dragSize,l=i.trackSize,o=i.dragStartPos;t=(i.getPointerPosition(e)-r.offset()[a.isHorizontal()?"left":"top"]-(null!==o?o:n/2))/(l-n),t=Math.max(Math.min(t,1),0),s&&(t=1-t);var d=a.minTranslate()+(a.maxTranslate()-a.minTranslate())*t;a.updateProgress(d),a.setTranslate(d),a.updateActiveIndex(),a.updateSlidesClasses()},onDragStart:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el,n=i.$dragEl;t.scrollbar.isTouched=!0,t.scrollbar.dragStartPos=e.target===n[0]||e.target===n?i.getPointerPosition(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),s.transition(100),n.transition(100),i.setDragPosition(e),clearTimeout(t.scrollbar.dragTimeout),r.transition(0),a.hide&&r.css("opacity",1),t.params.cssMode&&t.$wrapperEl.css("scroll-snap-type","none"),t.emit("scrollbarDragStart",e)},onDragMove:function(e){var t=this,a=t.scrollbar,i=t.$wrapperEl,s=a.$el,r=a.$dragEl;t.scrollbar.isTouched&&(e.preventDefault?e.preventDefault():e.returnValue=!1,a.setDragPosition(e),i.transition(0),s.transition(0),r.transition(0),t.emit("scrollbarDragMove",e))},onDragEnd:function(e){var t=this,a=t.params.scrollbar,i=t.scrollbar,s=t.$wrapperEl,r=i.$el;t.scrollbar.isTouched&&(t.scrollbar.isTouched=!1,t.params.cssMode&&(t.$wrapperEl.css("scroll-snap-type",""),s.transition("")),a.hide&&(clearTimeout(t.scrollbar.dragTimeout),t.scrollbar.dragTimeout=E((function(){r.css("opacity",0),r.transition(400)}),1e3)),t.emit("scrollbarDragEnd",e),a.snapOnRelease&&t.slideToClosest())},enableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=r(),a=e.scrollbar,i=e.touchEventsTouch,s=e.touchEventsDesktop,n=e.params,l=e.support,o=a.$el[0],d=!(!l.passiveListener||!n.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!n.passiveListeners)&&{passive:!0,capture:!1};o&&(l.touch?(o.addEventListener(i.start,e.scrollbar.onDragStart,d),o.addEventListener(i.move,e.scrollbar.onDragMove,d),o.addEventListener(i.end,e.scrollbar.onDragEnd,p)):(o.addEventListener(s.start,e.scrollbar.onDragStart,d),t.addEventListener(s.move,e.scrollbar.onDragMove,d),t.addEventListener(s.end,e.scrollbar.onDragEnd,p)))}},disableDraggable:function(){var e=this;if(e.params.scrollbar.el){var t=r(),a=e.scrollbar,i=e.touchEventsTouch,s=e.touchEventsDesktop,n=e.params,l=e.support,o=a.$el[0],d=!(!l.passiveListener||!n.passiveListeners)&&{passive:!1,capture:!1},p=!(!l.passiveListener||!n.passiveListeners)&&{passive:!0,capture:!1};o&&(l.touch?(o.removeEventListener(i.start,e.scrollbar.onDragStart,d),o.removeEventListener(i.move,e.scrollbar.onDragMove,d),o.removeEventListener(i.end,e.scrollbar.onDragEnd,p)):(o.removeEventListener(s.start,e.scrollbar.onDragStart,d),t.removeEventListener(s.move,e.scrollbar.onDragMove,d),t.removeEventListener(s.end,e.scrollbar.onDragEnd,p)))}},init:function(){var e=this,t=e.scrollbar,a=e.$el;e.params.scrollbar=k(a,e.params.scrollbar,e.params.createElements,{el:"swiper-scrollbar"});var i=e.params.scrollbar;if(i.el){var s=m(i.el);e.params.uniqueNavElements&&"string"==typeof i.el&&s.length>1&&1===a.find(i.el).length&&(s=a.find(i.el));var r=s.find("."+e.params.scrollbar.dragClass);0===r.length&&(r=m('<div class="'+e.params.scrollbar.dragClass+'"></div>'),s.append(r)),M(t,{$el:s,el:s[0],$dragEl:r,dragEl:r[0]}),i.draggable&&t.enableDraggable(),s&&s[e.enabled?"removeClass":"addClass"](e.params.scrollbar.lockClass)}},destroy:function(){this.scrollbar.disableDraggable()}},ae={setTransform:function(e,t){var a=this.rtl,i=m(e),s=a?-1:1,r=i.attr("data-swiper-parallax")||"0",n=i.attr("data-swiper-parallax-x"),l=i.attr("data-swiper-parallax-y"),o=i.attr("data-swiper-parallax-scale"),d=i.attr("data-swiper-parallax-opacity");if(n||l?(n=n||"0",l=l||"0"):this.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*t*s+"%":n*t*s+"px",l=l.indexOf("%")>=0?parseInt(l,10)*t+"%":l*t+"px",null!=d){var p=d-(d-1)*(1-Math.abs(t));i[0].style.opacity=p}if(null==o)i.transform("translate3d("+n+", "+l+", 0px)");else{var u=o-(o-1)*(1-Math.abs(t));i.transform("translate3d("+n+", "+l+", 0px) scale("+u+")")}},setTranslate:function(){var e=this,t=e.$el,a=e.slides,i=e.progress,s=e.snapGrid;t.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){e.parallax.setTransform(t,i)})),a.each((function(t,a){var r=t.progress;e.params.slidesPerGroup>1&&"auto"!==e.params.slidesPerView&&(r+=Math.ceil(a/2)-i*(s.length-1)),r=Math.min(Math.max(r,-1),1),m(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){e.parallax.setTransform(t,r)}))}))},setTransition:function(e){void 0===e&&(e=this.params.speed);this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((function(t){var a=m(t),i=parseInt(a.attr("data-swiper-parallax-duration"),10)||e;0===e&&(i=0),a.transition(i)}))}},ie={getDistanceBetweenTouches:function(e){if(e.targetTouches.length<2)return 1;var t=e.targetTouches[0].pageX,a=e.targetTouches[0].pageY,i=e.targetTouches[1].pageX,s=e.targetTouches[1].pageY;return Math.sqrt(Math.pow(i-t,2)+Math.pow(s-a,2))},onGestureStart:function(e){var t=this,a=t.support,i=t.params.zoom,s=t.zoom,r=s.gesture;if(s.fakeGestureTouched=!1,s.fakeGestureMoved=!1,!a.gestures){if("touchstart"!==e.type||"touchstart"===e.type&&e.targetTouches.length<2)return;s.fakeGestureTouched=!0,r.scaleStart=ie.getDistanceBetweenTouches(e)}r.$slideEl&&r.$slideEl.length||(r.$slideEl=m(e.target).closest("."+t.params.slideClass),0===r.$slideEl.length&&(r.$slideEl=t.slides.eq(t.activeIndex)),r.$imageEl=r.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),r.$imageWrapEl=r.$imageEl.parent("."+i.containerClass),r.maxRatio=r.$imageWrapEl.attr("data-swiper-zoom")||i.maxRatio,0!==r.$imageWrapEl.length)?(r.$imageEl&&r.$imageEl.transition(0),t.zoom.isScaling=!0):r.$imageEl=void 0},onGestureChange:function(e){var t=this,a=t.support,i=t.params.zoom,s=t.zoom,r=s.gesture;if(!a.gestures){if("touchmove"!==e.type||"touchmove"===e.type&&e.targetTouches.length<2)return;s.fakeGestureMoved=!0,r.scaleMove=ie.getDistanceBetweenTouches(e)}r.$imageEl&&0!==r.$imageEl.length?(a.gestures?s.scale=e.scale*s.currentScale:s.scale=r.scaleMove/r.scaleStart*s.currentScale,s.scale>r.maxRatio&&(s.scale=r.maxRatio-1+Math.pow(s.scale-r.maxRatio+1,.5)),s.scale<i.minRatio&&(s.scale=i.minRatio+1-Math.pow(i.minRatio-s.scale+1,.5)),r.$imageEl.transform("translate3d(0,0,0) scale("+s.scale+")")):"gesturechange"===e.type&&s.onGestureStart(e)},onGestureEnd:function(e){var t=this,a=t.device,i=t.support,s=t.params.zoom,r=t.zoom,n=r.gesture;if(!i.gestures){if(!r.fakeGestureTouched||!r.fakeGestureMoved)return;if("touchend"!==e.type||"touchend"===e.type&&e.changedTouches.length<2&&!a.android)return;r.fakeGestureTouched=!1,r.fakeGestureMoved=!1}n.$imageEl&&0!==n.$imageEl.length&&(r.scale=Math.max(Math.min(r.scale,n.maxRatio),s.minRatio),n.$imageEl.transition(t.params.speed).transform("translate3d(0,0,0) scale("+r.scale+")"),r.currentScale=r.scale,r.isScaling=!1,1===r.scale&&(n.$slideEl=void 0))},onTouchStart:function(e){var t=this.device,a=this.zoom,i=a.gesture,s=a.image;i.$imageEl&&0!==i.$imageEl.length&&(s.isTouched||(t.android&&e.cancelable&&e.preventDefault(),s.isTouched=!0,s.touchesStart.x="touchstart"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesStart.y="touchstart"===e.type?e.targetTouches[0].pageY:e.pageY))},onTouchMove:function(e){var t=this,a=t.zoom,i=a.gesture,s=a.image,r=a.velocity;if(i.$imageEl&&0!==i.$imageEl.length&&(t.allowClick=!1,s.isTouched&&i.$slideEl)){s.isMoved||(s.width=i.$imageEl[0].offsetWidth,s.height=i.$imageEl[0].offsetHeight,s.startX=T(i.$imageWrapEl[0],"x")||0,s.startY=T(i.$imageWrapEl[0],"y")||0,i.slideWidth=i.$slideEl[0].offsetWidth,i.slideHeight=i.$slideEl[0].offsetHeight,i.$imageWrapEl.transition(0));var n=s.width*a.scale,l=s.height*a.scale;if(!(n<i.slideWidth&&l<i.slideHeight)){if(s.minX=Math.min(i.slideWidth/2-n/2,0),s.maxX=-s.minX,s.minY=Math.min(i.slideHeight/2-l/2,0),s.maxY=-s.minY,s.touchesCurrent.x="touchmove"===e.type?e.targetTouches[0].pageX:e.pageX,s.touchesCurrent.y="touchmove"===e.type?e.targetTouches[0].pageY:e.pageY,!s.isMoved&&!a.isScaling){if(t.isHorizontal()&&(Math.floor(s.minX)===Math.floor(s.startX)&&s.touchesCurrent.x<s.touchesStart.x||Math.floor(s.maxX)===Math.floor(s.startX)&&s.touchesCurrent.x>s.touchesStart.x))return void(s.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(s.minY)===Math.floor(s.startY)&&s.touchesCurrent.y<s.touchesStart.y||Math.floor(s.maxY)===Math.floor(s.startY)&&s.touchesCurrent.y>s.touchesStart.y))return void(s.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),s.isMoved=!0,s.currentX=s.touchesCurrent.x-s.touchesStart.x+s.startX,s.currentY=s.touchesCurrent.y-s.touchesStart.y+s.startY,s.currentX<s.minX&&(s.currentX=s.minX+1-Math.pow(s.minX-s.currentX+1,.8)),s.currentX>s.maxX&&(s.currentX=s.maxX-1+Math.pow(s.currentX-s.maxX+1,.8)),s.currentY<s.minY&&(s.currentY=s.minY+1-Math.pow(s.minY-s.currentY+1,.8)),s.currentY>s.maxY&&(s.currentY=s.maxY-1+Math.pow(s.currentY-s.maxY+1,.8)),r.prevPositionX||(r.prevPositionX=s.touchesCurrent.x),r.prevPositionY||(r.prevPositionY=s.touchesCurrent.y),r.prevTime||(r.prevTime=Date.now()),r.x=(s.touchesCurrent.x-r.prevPositionX)/(Date.now()-r.prevTime)/2,r.y=(s.touchesCurrent.y-r.prevPositionY)/(Date.now()-r.prevTime)/2,Math.abs(s.touchesCurrent.x-r.prevPositionX)<2&&(r.x=0),Math.abs(s.touchesCurrent.y-r.prevPositionY)<2&&(r.y=0),r.prevPositionX=s.touchesCurrent.x,r.prevPositionY=s.touchesCurrent.y,r.prevTime=Date.now(),i.$imageWrapEl.transform("translate3d("+s.currentX+"px, "+s.currentY+"px,0)")}}},onTouchEnd:function(){var e=this.zoom,t=e.gesture,a=e.image,i=e.velocity;if(t.$imageEl&&0!==t.$imageEl.length){if(!a.isTouched||!a.isMoved)return a.isTouched=!1,void(a.isMoved=!1);a.isTouched=!1,a.isMoved=!1;var s=300,r=300,n=i.x*s,l=a.currentX+n,o=i.y*r,d=a.currentY+o;0!==i.x&&(s=Math.abs((l-a.currentX)/i.x)),0!==i.y&&(r=Math.abs((d-a.currentY)/i.y));var p=Math.max(s,r);a.currentX=l,a.currentY=d;var u=a.width*e.scale,c=a.height*e.scale;a.minX=Math.min(t.slideWidth/2-u/2,0),a.maxX=-a.minX,a.minY=Math.min(t.slideHeight/2-c/2,0),a.maxY=-a.minY,a.currentX=Math.max(Math.min(a.currentX,a.maxX),a.minX),a.currentY=Math.max(Math.min(a.currentY,a.maxY),a.minY),t.$imageWrapEl.transition(p).transform("translate3d("+a.currentX+"px, "+a.currentY+"px,0)")}},onTransitionEnd:function(){var e=this,t=e.zoom,a=t.gesture;a.$slideEl&&e.previousIndex!==e.activeIndex&&(a.$imageEl&&a.$imageEl.transform("translate3d(0,0,0) scale(1)"),a.$imageWrapEl&&a.$imageWrapEl.transform("translate3d(0,0,0)"),t.scale=1,t.currentScale=1,a.$slideEl=void 0,a.$imageEl=void 0,a.$imageWrapEl=void 0)},toggle:function(e){var t=this.zoom;t.scale&&1!==t.scale?t.out():t.in(e)},in:function(e){var t,a,i,s,r,n,o,d,p,u,c,h,v,f,g,b,w=this,y=l(),E=w.zoom,x=w.params.zoom,T=E.gesture,C=E.image;(T.$slideEl||(e&&e.target&&(T.$slideEl=m(e.target).closest("."+w.params.slideClass)),T.$slideEl||(w.params.virtual&&w.params.virtual.enabled&&w.virtual?T.$slideEl=w.$wrapperEl.children("."+w.params.slideActiveClass):T.$slideEl=w.slides.eq(w.activeIndex)),T.$imageEl=T.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),T.$imageWrapEl=T.$imageEl.parent("."+x.containerClass)),T.$imageEl&&0!==T.$imageEl.length&&T.$imageWrapEl&&0!==T.$imageWrapEl.length)&&(T.$slideEl.addClass(""+x.zoomedSlideClass),void 0===C.touchesStart.x&&e?(t="touchend"===e.type?e.changedTouches[0].pageX:e.pageX,a="touchend"===e.type?e.changedTouches[0].pageY:e.pageY):(t=C.touchesStart.x,a=C.touchesStart.y),E.scale=T.$imageWrapEl.attr("data-swiper-zoom")||x.maxRatio,E.currentScale=T.$imageWrapEl.attr("data-swiper-zoom")||x.maxRatio,e?(g=T.$slideEl[0].offsetWidth,b=T.$slideEl[0].offsetHeight,i=T.$slideEl.offset().left+y.scrollX+g/2-t,s=T.$slideEl.offset().top+y.scrollY+b/2-a,o=T.$imageEl[0].offsetWidth,d=T.$imageEl[0].offsetHeight,p=o*E.scale,u=d*E.scale,v=-(c=Math.min(g/2-p/2,0)),f=-(h=Math.min(b/2-u/2,0)),(r=i*E.scale)<c&&(r=c),r>v&&(r=v),(n=s*E.scale)<h&&(n=h),n>f&&(n=f)):(r=0,n=0),T.$imageWrapEl.transition(300).transform("translate3d("+r+"px, "+n+"px,0)"),T.$imageEl.transition(300).transform("translate3d(0,0,0) scale("+E.scale+")"))},out:function(){var e=this,t=e.zoom,a=e.params.zoom,i=t.gesture;i.$slideEl||(e.params.virtual&&e.params.virtual.enabled&&e.virtual?i.$slideEl=e.$wrapperEl.children("."+e.params.slideActiveClass):i.$slideEl=e.slides.eq(e.activeIndex),i.$imageEl=i.$slideEl.find("img, svg, canvas, picture, .swiper-zoom-target"),i.$imageWrapEl=i.$imageEl.parent("."+a.containerClass)),i.$imageEl&&0!==i.$imageEl.length&&i.$imageWrapEl&&0!==i.$imageWrapEl.length&&(t.scale=1,t.currentScale=1,i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),i.$slideEl.removeClass(""+a.zoomedSlideClass),i.$slideEl=void 0)},toggleGestures:function(e){var t=this,a=t.zoom,i=a.slideSelector,s=a.passiveListener;t.$wrapperEl[e]("gesturestart",i,a.onGestureStart,s),t.$wrapperEl[e]("gesturechange",i,a.onGestureChange,s),t.$wrapperEl[e]("gestureend",i,a.onGestureEnd,s)},enableGestures:function(){this.zoom.gesturesEnabled||(this.zoom.gesturesEnabled=!0,this.zoom.toggleGestures("on"))},disableGestures:function(){this.zoom.gesturesEnabled&&(this.zoom.gesturesEnabled=!1,this.zoom.toggleGestures("off"))},enable:function(){var e=this,t=e.support,a=e.zoom;if(!a.enabled){a.enabled=!0;var i=!("touchstart"!==e.touchEvents.start||!t.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1},s=!t.passiveListener||{passive:!1,capture:!0},r="."+e.params.slideClass;e.zoom.passiveListener=i,e.zoom.slideSelector=r,t.gestures?(e.$wrapperEl.on(e.touchEvents.start,e.zoom.enableGestures,i),e.$wrapperEl.on(e.touchEvents.end,e.zoom.disableGestures,i)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.on(e.touchEvents.start,r,a.onGestureStart,i),e.$wrapperEl.on(e.touchEvents.move,r,a.onGestureChange,s),e.$wrapperEl.on(e.touchEvents.end,r,a.onGestureEnd,i),e.touchEvents.cancel&&e.$wrapperEl.on(e.touchEvents.cancel,r,a.onGestureEnd,i)),e.$wrapperEl.on(e.touchEvents.move,"."+e.params.zoom.containerClass,a.onTouchMove,s)}},disable:function(){var e=this,t=e.zoom;if(t.enabled){var a=e.support;e.zoom.enabled=!1;var i=!("touchstart"!==e.touchEvents.start||!a.passiveListener||!e.params.passiveListeners)&&{passive:!0,capture:!1},s=!a.passiveListener||{passive:!1,capture:!0},r="."+e.params.slideClass;a.gestures?(e.$wrapperEl.off(e.touchEvents.start,e.zoom.enableGestures,i),e.$wrapperEl.off(e.touchEvents.end,e.zoom.disableGestures,i)):"touchstart"===e.touchEvents.start&&(e.$wrapperEl.off(e.touchEvents.start,r,t.onGestureStart,i),e.$wrapperEl.off(e.touchEvents.move,r,t.onGestureChange,s),e.$wrapperEl.off(e.touchEvents.end,r,t.onGestureEnd,i),e.touchEvents.cancel&&e.$wrapperEl.off(e.touchEvents.cancel,r,t.onGestureEnd,i)),e.$wrapperEl.off(e.touchEvents.move,"."+e.params.zoom.containerClass,t.onTouchMove,s)}}},se={loadInSlide:function(e,t){void 0===t&&(t=!0);var a=this,i=a.params.lazy;if(void 0!==e&&0!==a.slides.length){var s=a.virtual&&a.params.virtual.enabled?a.$wrapperEl.children("."+a.params.slideClass+'[data-swiper-slide-index="'+e+'"]'):a.slides.eq(e),r=s.find("."+i.elementClass+":not(."+i.loadedClass+"):not(."+i.loadingClass+")");!s.hasClass(i.elementClass)||s.hasClass(i.loadedClass)||s.hasClass(i.loadingClass)||r.push(s[0]),0!==r.length&&r.each((function(e){var r=m(e);r.addClass(i.loadingClass);var n=r.attr("data-background"),l=r.attr("data-src"),o=r.attr("data-srcset"),d=r.attr("data-sizes"),p=r.parent("picture");a.loadImage(r[0],l||n,o,d,!1,(function(){if(null!=a&&a&&(!a||a.params)&&!a.destroyed){if(n?(r.css("background-image",'url("'+n+'")'),r.removeAttr("data-background")):(o&&(r.attr("srcset",o),r.removeAttr("data-srcset")),d&&(r.attr("sizes",d),r.removeAttr("data-sizes")),p.length&&p.children("source").each((function(e){var t=m(e);t.attr("data-srcset")&&(t.attr("srcset",t.attr("data-srcset")),t.removeAttr("data-srcset"))})),l&&(r.attr("src",l),r.removeAttr("data-src"))),r.addClass(i.loadedClass).removeClass(i.loadingClass),s.find("."+i.preloaderClass).remove(),a.params.loop&&t){var e=s.attr("data-swiper-slide-index");if(s.hasClass(a.params.slideDuplicateClass)){var u=a.$wrapperEl.children('[data-swiper-slide-index="'+e+'"]:not(.'+a.params.slideDuplicateClass+")");a.lazy.loadInSlide(u.index(),!1)}else{var c=a.$wrapperEl.children("."+a.params.slideDuplicateClass+'[data-swiper-slide-index="'+e+'"]');a.lazy.loadInSlide(c.index(),!1)}}a.emit("lazyImageReady",s[0],r[0]),a.params.autoHeight&&a.updateAutoHeight()}})),a.emit("lazyImageLoad",s[0],r[0])}))}},load:function(){var e=this,t=e.$wrapperEl,a=e.params,i=e.slides,s=e.activeIndex,r=e.virtual&&a.virtual.enabled,n=a.lazy,l=a.slidesPerView;function o(e){if(r){if(t.children("."+a.slideClass+'[data-swiper-slide-index="'+e+'"]').length)return!0}else if(i[e])return!0;return!1}function d(e){return r?m(e).attr("data-swiper-slide-index"):m(e).index()}if("auto"===l&&(l=0),e.lazy.initialImageLoaded||(e.lazy.initialImageLoaded=!0),e.params.watchSlidesVisibility)t.children("."+a.slideVisibleClass).each((function(t){var a=r?m(t).attr("data-swiper-slide-index"):m(t).index();e.lazy.loadInSlide(a)}));else if(l>1)for(var p=s;p<s+l;p+=1)o(p)&&e.lazy.loadInSlide(p);else e.lazy.loadInSlide(s);if(n.loadPrevNext)if(l>1||n.loadPrevNextAmount&&n.loadPrevNextAmount>1){for(var u=n.loadPrevNextAmount,c=l,h=Math.min(s+c+Math.max(u,c),i.length),v=Math.max(s-Math.max(c,u),0),f=s+l;f<h;f+=1)o(f)&&e.lazy.loadInSlide(f);for(var g=v;g<s;g+=1)o(g)&&e.lazy.loadInSlide(g)}else{var b=t.children("."+a.slideNextClass);b.length>0&&e.lazy.loadInSlide(d(b));var w=t.children("."+a.slidePrevClass);w.length>0&&e.lazy.loadInSlide(d(w))}},checkInViewOnLoad:function(){var e=l(),t=this;if(t&&!t.destroyed){var a=t.params.lazy.scrollingElement?m(t.params.lazy.scrollingElement):m(e),i=a[0]===e,s=i?e.innerWidth:a[0].offsetWidth,r=i?e.innerHeight:a[0].offsetHeight,n=t.$el.offset(),o=!1;t.rtlTranslate&&(n.left-=t.$el[0].scrollLeft);for(var d=[[n.left,n.top],[n.left+t.width,n.top],[n.left,n.top+t.height],[n.left+t.width,n.top+t.height]],p=0;p<d.length;p+=1){var u=d[p];if(u[0]>=0&&u[0]<=s&&u[1]>=0&&u[1]<=r){if(0===u[0]&&0===u[1])continue;o=!0}}var c=!("touchstart"!==t.touchEvents.start||!t.support.passiveListener||!t.params.passiveListeners)&&{passive:!0,capture:!1};o?(t.lazy.load(),a.off("scroll",t.lazy.checkInViewOnLoad,c)):t.lazy.scrollHandlerAttached||(t.lazy.scrollHandlerAttached=!0,a.on("scroll",t.lazy.checkInViewOnLoad,c))}}},re={LinearSpline:function(e,t){var a,i,s,r,n,l=function(e,t){for(i=-1,a=e.length;a-i>1;)e[s=a+i>>1]<=t?i=s:a=s;return a};return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(n=l(this.x,e),r=n-1,(e-this.x[r])*(this.y[n]-this.y[r])/(this.x[n]-this.x[r])+this.y[r]):0},this},getInterpolateFunction:function(e){var t=this;t.controller.spline||(t.controller.spline=t.params.loop?new re.LinearSpline(t.slidesGrid,e.slidesGrid):new re.LinearSpline(t.snapGrid,e.snapGrid))},setTranslate:function(e,t){var a,i,s=this,r=s.controller.control,n=s.constructor;function l(e){var t=s.rtlTranslate?-s.translate:s.translate;"slide"===s.params.controller.by&&(s.controller.getInterpolateFunction(e),i=-s.controller.spline.interpolate(-t)),i&&"container"!==s.params.controller.by||(a=(e.maxTranslate()-e.minTranslate())/(s.maxTranslate()-s.minTranslate()),i=(t-s.minTranslate())*a+e.minTranslate()),s.params.controller.inverse&&(i=e.maxTranslate()-i),e.updateProgress(i),e.setTranslate(i,s),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(r))for(var o=0;o<r.length;o+=1)r[o]!==t&&r[o]instanceof n&&l(r[o]);else r instanceof n&&t!==r&&l(r)},setTransition:function(e,t){var a,i=this,s=i.constructor,r=i.controller.control;function n(t){t.setTransition(e,i),0!==e&&(t.transitionStart(),t.params.autoHeight&&E((function(){t.updateAutoHeight()})),t.$wrapperEl.transitionEnd((function(){r&&(t.params.loop&&"slide"===i.params.controller.by&&t.loopFix(),t.transitionEnd())})))}if(Array.isArray(r))for(a=0;a<r.length;a+=1)r[a]!==t&&r[a]instanceof s&&n(r[a]);else r instanceof s&&t!==r&&n(r)}},ne={getRandomNumber:function(e){void 0===e&&(e=16);return"x".repeat(e).replace(/x/g,(function(){return Math.round(16*Math.random()).toString(16)}))},makeElFocusable:function(e){return e.attr("tabIndex","0"),e},makeElNotFocusable:function(e){return e.attr("tabIndex","-1"),e},addElRole:function(e,t){return e.attr("role",t),e},addElRoleDescription:function(e,t){return e.attr("aria-roledescription",t),e},addElControls:function(e,t){return e.attr("aria-controls",t),e},addElLabel:function(e,t){return e.attr("aria-label",t),e},addElId:function(e,t){return e.attr("id",t),e},addElLive:function(e,t){return e.attr("aria-live",t),e},disableEl:function(e){return e.attr("aria-disabled",!0),e},enableEl:function(e){return e.attr("aria-disabled",!1),e},onEnterOrSpaceKey:function(e){if(13===e.keyCode||32===e.keyCode){var t=this,a=t.params.a11y,i=m(e.target);t.navigation&&t.navigation.$nextEl&&i.is(t.navigation.$nextEl)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?t.a11y.notify(a.lastSlideMessage):t.a11y.notify(a.nextSlideMessage)),t.navigation&&t.navigation.$prevEl&&i.is(t.navigation.$prevEl)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?t.a11y.notify(a.firstSlideMessage):t.a11y.notify(a.prevSlideMessage)),t.pagination&&i.is(P(t.params.pagination.bulletClass))&&i[0].click()}},notify:function(e){var t=this.a11y.liveRegion;0!==t.length&&(t.html(""),t.html(e))},updateNavigation:function(){var e=this;if(!e.params.loop&&e.navigation){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;i&&i.length>0&&(e.isBeginning?(e.a11y.disableEl(i),e.a11y.makeElNotFocusable(i)):(e.a11y.enableEl(i),e.a11y.makeElFocusable(i))),a&&a.length>0&&(e.isEnd?(e.a11y.disableEl(a),e.a11y.makeElNotFocusable(a)):(e.a11y.enableEl(a),e.a11y.makeElFocusable(a)))}},updatePagination:function(){var e=this,t=e.params.a11y;e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.bullets.each((function(a){var i=m(a);e.a11y.makeElFocusable(i),e.params.pagination.renderBullet||(e.a11y.addElRole(i,"button"),e.a11y.addElLabel(i,t.paginationBulletMessage.replace(/\{\{index\}\}/,i.index()+1)))}))},init:function(){var e=this,t=e.params.a11y;e.$el.append(e.a11y.liveRegion);var a=e.$el;t.containerRoleDescriptionMessage&&e.a11y.addElRoleDescription(a,t.containerRoleDescriptionMessage),t.containerMessage&&e.a11y.addElLabel(a,t.containerMessage);var i=e.$wrapperEl,s=i.attr("id")||"swiper-wrapper-"+e.a11y.getRandomNumber(16),r=e.params.autoplay&&e.params.autoplay.enabled?"off":"polite";e.a11y.addElId(i,s),e.a11y.addElLive(i,r),t.itemRoleDescriptionMessage&&e.a11y.addElRoleDescription(m(e.slides),t.itemRoleDescriptionMessage),e.a11y.addElRole(m(e.slides),t.slideRole);var n,l,o=e.params.loop?e.slides.filter((function(t){return!t.classList.contains(e.params.slideDuplicateClass)})).length:e.slides.length;e.slides.each((function(a,i){var s=m(a),r=e.params.loop?parseInt(s.attr("data-swiper-slide-index"),10):i,n=t.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,o);e.a11y.addElLabel(s,n)})),e.navigation&&e.navigation.$nextEl&&(n=e.navigation.$nextEl),e.navigation&&e.navigation.$prevEl&&(l=e.navigation.$prevEl),n&&n.length&&(e.a11y.makeElFocusable(n),"BUTTON"!==n[0].tagName&&(e.a11y.addElRole(n,"button"),n.on("keydown",e.a11y.onEnterOrSpaceKey)),e.a11y.addElLabel(n,t.nextSlideMessage),e.a11y.addElControls(n,s)),l&&l.length&&(e.a11y.makeElFocusable(l),"BUTTON"!==l[0].tagName&&(e.a11y.addElRole(l,"button"),l.on("keydown",e.a11y.onEnterOrSpaceKey)),e.a11y.addElLabel(l,t.prevSlideMessage),e.a11y.addElControls(l,s)),e.pagination&&e.params.pagination.clickable&&e.pagination.bullets&&e.pagination.bullets.length&&e.pagination.$el.on("keydown",P(e.params.pagination.bulletClass),e.a11y.onEnterOrSpaceKey)},destroy:function(){var e,t,a=this;a.a11y.liveRegion&&a.a11y.liveRegion.length>0&&a.a11y.liveRegion.remove(),a.navigation&&a.navigation.$nextEl&&(e=a.navigation.$nextEl),a.navigation&&a.navigation.$prevEl&&(t=a.navigation.$prevEl),e&&e.off("keydown",a.a11y.onEnterOrSpaceKey),t&&t.off("keydown",a.a11y.onEnterOrSpaceKey),a.pagination&&a.params.pagination.clickable&&a.pagination.bullets&&a.pagination.bullets.length&&a.pagination.$el.off("keydown",P(a.params.pagination.bulletClass),a.a11y.onEnterOrSpaceKey)}},le={init:function(){var e=this,t=l();if(e.params.history){if(!t.history||!t.history.pushState)return e.params.history.enabled=!1,void(e.params.hashNavigation.enabled=!0);var a=e.history;a.initialized=!0,a.paths=le.getPathValues(e.params.url),(a.paths.key||a.paths.value)&&(a.scrollToSlide(0,a.paths.value,e.params.runCallbacksOnInit),e.params.history.replaceState||t.addEventListener("popstate",e.history.setHistoryPopState))}},destroy:function(){var e=l();this.params.history.replaceState||e.removeEventListener("popstate",this.history.setHistoryPopState)},setHistoryPopState:function(){var e=this;e.history.paths=le.getPathValues(e.params.url),e.history.scrollToSlide(e.params.speed,e.history.paths.value,!1)},getPathValues:function(e){var t=l(),a=(e?new URL(e):t.location).pathname.slice(1).split("/").filter((function(e){return""!==e})),i=a.length;return{key:a[i-2],value:a[i-1]}},setHistory:function(e,t){var a=this,i=l();if(a.history.initialized&&a.params.history.enabled){var s;s=a.params.url?new URL(a.params.url):i.location;var r=a.slides.eq(t),n=le.slugify(r.attr("data-history"));if(a.params.history.root.length>0){var o=a.params.history.root;"/"===o[o.length-1]&&(o=o.slice(0,o.length-1)),n=o+"/"+e+"/"+n}else s.pathname.includes(e)||(n=e+"/"+n);var d=i.history.state;d&&d.value===n||(a.params.history.replaceState?i.history.replaceState({value:n},null,n):i.history.pushState({value:n},null,n))}},slugify:function(e){return e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,"")},scrollToSlide:function(e,t,a){var i=this;if(t)for(var s=0,r=i.slides.length;s<r;s+=1){var n=i.slides.eq(s);if(le.slugify(n.attr("data-history"))===t&&!n.hasClass(i.params.slideDuplicateClass)){var l=n.index();i.slideTo(l,e,a)}}else i.slideTo(0,e,a)}},oe={onHashChange:function(){var e=this,t=r();e.emit("hashChange");var a=t.location.hash.replace("#","");if(a!==e.slides.eq(e.activeIndex).attr("data-hash")){var i=e.$wrapperEl.children("."+e.params.slideClass+'[data-hash="'+a+'"]').index();if(void 0===i)return;e.slideTo(i)}},setHash:function(){var e=this,t=l(),a=r();if(e.hashNavigation.initialized&&e.params.hashNavigation.enabled)if(e.params.hashNavigation.replaceState&&t.history&&t.history.replaceState)t.history.replaceState(null,null,"#"+e.slides.eq(e.activeIndex).attr("data-hash")||""),e.emit("hashSet");else{var i=e.slides.eq(e.activeIndex),s=i.attr("data-hash")||i.attr("data-history");a.location.hash=s||"",e.emit("hashSet")}},init:function(){var e=this,t=r(),a=l();if(!(!e.params.hashNavigation.enabled||e.params.history&&e.params.history.enabled)){e.hashNavigation.initialized=!0;var i=t.location.hash.replace("#","");if(i)for(var s=0,n=e.slides.length;s<n;s+=1){var o=e.slides.eq(s);if((o.attr("data-hash")||o.attr("data-history"))===i&&!o.hasClass(e.params.slideDuplicateClass)){var d=o.index();e.slideTo(d,0,e.params.runCallbacksOnInit,!0)}}e.params.hashNavigation.watchState&&m(a).on("hashchange",e.hashNavigation.onHashChange)}},destroy:function(){var e=l();this.params.hashNavigation.watchState&&m(e).off("hashchange",this.hashNavigation.onHashChange)}},de={run:function(){var e=this,t=e.slides.eq(e.activeIndex),a=e.params.autoplay.delay;t.attr("data-swiper-autoplay")&&(a=t.attr("data-swiper-autoplay")||e.params.autoplay.delay),clearTimeout(e.autoplay.timeout),e.autoplay.timeout=E((function(){var t;e.params.autoplay.reverseDirection?e.params.loop?(e.loopFix(),t=e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.isBeginning?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(t=e.slideTo(e.slides.length-1,e.params.speed,!0,!0),e.emit("autoplay")):(t=e.slidePrev(e.params.speed,!0,!0),e.emit("autoplay")):e.params.loop?(e.loopFix(),t=e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")):e.isEnd?e.params.autoplay.stopOnLastSlide?e.autoplay.stop():(t=e.slideTo(0,e.params.speed,!0,!0),e.emit("autoplay")):(t=e.slideNext(e.params.speed,!0,!0),e.emit("autoplay")),(e.params.cssMode&&e.autoplay.running||!1===t)&&e.autoplay.run()}),a)},start:function(){var e=this;return void 0===e.autoplay.timeout&&(!e.autoplay.running&&(e.autoplay.running=!0,e.emit("autoplayStart"),e.autoplay.run(),!0))},stop:function(){var e=this;return!!e.autoplay.running&&(void 0!==e.autoplay.timeout&&(e.autoplay.timeout&&(clearTimeout(e.autoplay.timeout),e.autoplay.timeout=void 0),e.autoplay.running=!1,e.emit("autoplayStop"),!0))},pause:function(e){var t=this;t.autoplay.running&&(t.autoplay.paused||(t.autoplay.timeout&&clearTimeout(t.autoplay.timeout),t.autoplay.paused=!0,0!==e&&t.params.autoplay.waitForTransition?["transitionend","webkitTransitionEnd"].forEach((function(e){t.$wrapperEl[0].addEventListener(e,t.autoplay.onTransitionEnd)})):(t.autoplay.paused=!1,t.autoplay.run())))},onVisibilityChange:function(){var e=this,t=r();"hidden"===t.visibilityState&&e.autoplay.running&&e.autoplay.pause(),"visible"===t.visibilityState&&e.autoplay.paused&&(e.autoplay.run(),e.autoplay.paused=!1)},onTransitionEnd:function(e){var t=this;t&&!t.destroyed&&t.$wrapperEl&&e.target===t.$wrapperEl[0]&&(["transitionend","webkitTransitionEnd"].forEach((function(e){t.$wrapperEl[0].removeEventListener(e,t.autoplay.onTransitionEnd)})),t.autoplay.paused=!1,t.autoplay.running?t.autoplay.run():t.autoplay.stop())},onMouseEnter:function(){var e=this;e.params.autoplay.disableOnInteraction?e.autoplay.stop():e.autoplay.pause(),["transitionend","webkitTransitionEnd"].forEach((function(t){e.$wrapperEl[0].removeEventListener(t,e.autoplay.onTransitionEnd)}))},onMouseLeave:function(){var e=this;e.params.autoplay.disableOnInteraction||(e.autoplay.paused=!1,e.autoplay.run())},attachMouseEvents:function(){var e=this;e.params.autoplay.pauseOnMouseEnter&&(e.$el.on("mouseenter",e.autoplay.onMouseEnter),e.$el.on("mouseleave",e.autoplay.onMouseLeave))},detachMouseEvents:function(){var e=this;e.$el.off("mouseenter",e.autoplay.onMouseEnter),e.$el.off("mouseleave",e.autoplay.onMouseLeave)}},pe={setTranslate:function(){for(var e=this,t=e.slides,a=0;a<t.length;a+=1){var i=e.slides.eq(a),s=-i[0].swiperSlideOffset;e.params.virtualTranslate||(s-=e.translate);var r=0;e.isHorizontal()||(r=s,s=0);var n=e.params.fadeEffect.crossFade?Math.max(1-Math.abs(i[0].progress),0):1+Math.min(Math.max(i[0].progress,-1),0);i.css({opacity:n}).transform("translate3d("+s+"px, "+r+"px, 0px)")}},setTransition:function(e){var t=this,a=t.slides,i=t.$wrapperEl;if(a.transition(e),t.params.virtualTranslate&&0!==e){var s=!1;a.transitionEnd((function(){if(!s&&t&&!t.destroyed){s=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],a=0;a<e.length;a+=1)i.trigger(e[a])}}))}}},ue={setTranslate:function(){var e,t=this,a=t.$el,i=t.$wrapperEl,s=t.slides,r=t.width,n=t.height,l=t.rtlTranslate,o=t.size,d=t.browser,p=t.params.cubeEffect,u=t.isHorizontal(),c=t.virtual&&t.params.virtual.enabled,h=0;p.shadow&&(u?(0===(e=i.find(".swiper-cube-shadow")).length&&(e=m('<div class="swiper-cube-shadow"></div>'),i.append(e)),e.css({height:r+"px"})):0===(e=a.find(".swiper-cube-shadow")).length&&(e=m('<div class="swiper-cube-shadow"></div>'),a.append(e)));for(var v=0;v<s.length;v+=1){var f=s.eq(v),g=v;c&&(g=parseInt(f.attr("data-swiper-slide-index"),10));var b=90*g,w=Math.floor(b/360);l&&(b=-b,w=Math.floor(-b/360));var y=Math.max(Math.min(f[0].progress,1),-1),E=0,x=0,T=0;g%4==0?(E=4*-w*o,T=0):(g-1)%4==0?(E=0,T=4*-w*o):(g-2)%4==0?(E=o+4*w*o,T=o):(g-3)%4==0&&(E=-o,T=3*o+4*o*w),l&&(E=-E),u||(x=E,E=0);var C="rotateX("+(u?0:-b)+"deg) rotateY("+(u?b:0)+"deg) translate3d("+E+"px, "+x+"px, "+T+"px)";if(y<=1&&y>-1&&(h=90*g+90*y,l&&(h=90*-g-90*y)),f.transform(C),p.slideShadows){var S=u?f.find(".swiper-slide-shadow-left"):f.find(".swiper-slide-shadow-top"),M=u?f.find(".swiper-slide-shadow-right"):f.find(".swiper-slide-shadow-bottom");0===S.length&&(S=m('<div class="swiper-slide-shadow-'+(u?"left":"top")+'"></div>'),f.append(S)),0===M.length&&(M=m('<div class="swiper-slide-shadow-'+(u?"right":"bottom")+'"></div>'),f.append(M)),S.length&&(S[0].style.opacity=Math.max(-y,0)),M.length&&(M[0].style.opacity=Math.max(y,0))}}if(i.css({"-webkit-transform-origin":"50% 50% -"+o/2+"px","-moz-transform-origin":"50% 50% -"+o/2+"px","-ms-transform-origin":"50% 50% -"+o/2+"px","transform-origin":"50% 50% -"+o/2+"px"}),p.shadow)if(u)e.transform("translate3d(0px, "+(r/2+p.shadowOffset)+"px, "+-r/2+"px) rotateX(90deg) rotateZ(0deg) scale("+p.shadowScale+")");else{var z=Math.abs(h)-90*Math.floor(Math.abs(h)/90),P=1.5-(Math.sin(2*z*Math.PI/360)/2+Math.cos(2*z*Math.PI/360)/2),k=p.shadowScale,$=p.shadowScale/P,L=p.shadowOffset;e.transform("scale3d("+k+", 1, "+$+") translate3d(0px, "+(n/2+L)+"px, "+-n/2/$+"px) rotateX(-90deg)")}var I=d.isSafari||d.isWebView?-o/2:0;i.transform("translate3d(0px,0,"+I+"px) rotateX("+(t.isHorizontal()?0:h)+"deg) rotateY("+(t.isHorizontal()?-h:0)+"deg)")},setTransition:function(e){var t=this,a=t.$el;t.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.cubeEffect.shadow&&!t.isHorizontal()&&a.find(".swiper-cube-shadow").transition(e)}},ce={setTranslate:function(){for(var e=this,t=e.slides,a=e.rtlTranslate,i=0;i<t.length;i+=1){var s=t.eq(i),r=s[0].progress;e.params.flipEffect.limitRotation&&(r=Math.max(Math.min(s[0].progress,1),-1));var n=-180*r,l=0,o=-s[0].swiperSlideOffset,d=0;if(e.isHorizontal()?a&&(n=-n):(d=o,o=0,l=-n,n=0),s[0].style.zIndex=-Math.abs(Math.round(r))+t.length,e.params.flipEffect.slideShadows){var p=e.isHorizontal()?s.find(".swiper-slide-shadow-left"):s.find(".swiper-slide-shadow-top"),u=e.isHorizontal()?s.find(".swiper-slide-shadow-right"):s.find(".swiper-slide-shadow-bottom");0===p.length&&(p=m('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"left":"top")+'"></div>'),s.append(p)),0===u.length&&(u=m('<div class="swiper-slide-shadow-'+(e.isHorizontal()?"right":"bottom")+'"></div>'),s.append(u)),p.length&&(p[0].style.opacity=Math.max(-r,0)),u.length&&(u[0].style.opacity=Math.max(r,0))}s.transform("translate3d("+o+"px, "+d+"px, 0px) rotateX("+l+"deg) rotateY("+n+"deg)")}},setTransition:function(e){var t=this,a=t.slides,i=t.activeIndex,s=t.$wrapperEl;if(a.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e),t.params.virtualTranslate&&0!==e){var r=!1;a.eq(i).transitionEnd((function(){if(!r&&t&&!t.destroyed){r=!0,t.animating=!1;for(var e=["webkitTransitionEnd","transitionend"],a=0;a<e.length;a+=1)s.trigger(e[a])}}))}}},he={setTranslate:function(){for(var e=this,t=e.width,a=e.height,i=e.slides,s=e.slidesSizesGrid,r=e.params.coverflowEffect,n=e.isHorizontal(),l=e.translate,o=n?t/2-l:a/2-l,d=n?r.rotate:-r.rotate,p=r.depth,u=0,c=i.length;u<c;u+=1){var h=i.eq(u),v=s[u],f=(o-h[0].swiperSlideOffset-v/2)/v*r.modifier,g=n?d*f:0,b=n?0:d*f,w=-p*Math.abs(f),y=r.stretch;"string"==typeof y&&-1!==y.indexOf("%")&&(y=parseFloat(r.stretch)/100*v);var E=n?0:y*f,x=n?y*f:0,T=1-(1-r.scale)*Math.abs(f);Math.abs(x)<.001&&(x=0),Math.abs(E)<.001&&(E=0),Math.abs(w)<.001&&(w=0),Math.abs(g)<.001&&(g=0),Math.abs(b)<.001&&(b=0),Math.abs(T)<.001&&(T=0);var C="translate3d("+x+"px,"+E+"px,"+w+"px)  rotateX("+b+"deg) rotateY("+g+"deg) scale("+T+")";if(h.transform(C),h[0].style.zIndex=1-Math.abs(Math.round(f)),r.slideShadows){var S=n?h.find(".swiper-slide-shadow-left"):h.find(".swiper-slide-shadow-top"),M=n?h.find(".swiper-slide-shadow-right"):h.find(".swiper-slide-shadow-bottom");0===S.length&&(S=m('<div class="swiper-slide-shadow-'+(n?"left":"top")+'"></div>'),h.append(S)),0===M.length&&(M=m('<div class="swiper-slide-shadow-'+(n?"right":"bottom")+'"></div>'),h.append(M)),S.length&&(S[0].style.opacity=f>0?f:0),M.length&&(M[0].style.opacity=-f>0?-f:0)}}},setTransition:function(e){this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)}},ve={init:function(){var e=this,t=e.params.thumbs;if(e.thumbs.initialized)return!1;e.thumbs.initialized=!0;var a=e.constructor;return t.swiper instanceof a?(e.thumbs.swiper=t.swiper,M(e.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),M(e.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1})):C(t.swiper)&&(e.thumbs.swiper=new a(M({},t.swiper,{watchSlidesVisibility:!0,watchSlidesProgress:!0,slideToClickedSlide:!1})),e.thumbs.swiperCreated=!0),e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),e.thumbs.swiper.on("tap",e.thumbs.onThumbClick),!0},onThumbClick:function(){var e=this,t=e.thumbs.swiper;if(t){var a=t.clickedIndex,i=t.clickedSlide;if(!(i&&m(i).hasClass(e.params.thumbs.slideThumbActiveClass)||null==a)){var s;if(s=t.params.loop?parseInt(m(t.clickedSlide).attr("data-swiper-slide-index"),10):a,e.params.loop){var r=e.activeIndex;e.slides.eq(r).hasClass(e.params.slideDuplicateClass)&&(e.loopFix(),e._clientLeft=e.$wrapperEl[0].clientLeft,r=e.activeIndex);var n=e.slides.eq(r).prevAll('[data-swiper-slide-index="'+s+'"]').eq(0).index(),l=e.slides.eq(r).nextAll('[data-swiper-slide-index="'+s+'"]').eq(0).index();s=void 0===n?l:void 0===l?n:l-r<r-n?l:n}e.slideTo(s)}}},update:function(e){var t=this,a=t.thumbs.swiper;if(a){var i="auto"===a.params.slidesPerView?a.slidesPerViewDynamic():a.params.slidesPerView,s=t.params.thumbs.autoScrollOffset,r=s&&!a.params.loop;if(t.realIndex!==a.realIndex||r){var n,l,o=a.activeIndex;if(a.params.loop){a.slides.eq(o).hasClass(a.params.slideDuplicateClass)&&(a.loopFix(),a._clientLeft=a.$wrapperEl[0].clientLeft,o=a.activeIndex);var d=a.slides.eq(o).prevAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index(),p=a.slides.eq(o).nextAll('[data-swiper-slide-index="'+t.realIndex+'"]').eq(0).index();n=void 0===d?p:void 0===p?d:p-o==o-d?a.params.slidesPerGroup>1?p:o:p-o<o-d?p:d,l=t.activeIndex>t.previousIndex?"next":"prev"}else l=(n=t.realIndex)>t.previousIndex?"next":"prev";r&&(n+="next"===l?s:-1*s),a.visibleSlidesIndexes&&a.visibleSlidesIndexes.indexOf(n)<0&&(a.params.centeredSlides?n=n>o?n-Math.floor(i/2)+1:n+Math.floor(i/2)-1:n>o&&a.params.slidesPerGroup,a.slideTo(n,e?0:void 0))}var u=1,c=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(u=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(u=1),u=Math.floor(u),a.slides.removeClass(c),a.params.loop||a.params.virtual&&a.params.virtual.enabled)for(var h=0;h<u;h+=1)a.$wrapperEl.children('[data-swiper-slide-index="'+(t.realIndex+h)+'"]').addClass(c);else for(var v=0;v<u;v+=1)a.slides.eq(t.realIndex+v).addClass(c)}}},fe=[U,Z,{name:"mousewheel",params:{mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}},create:function(){z(this,{mousewheel:{enabled:!1,lastScrollTime:x(),lastEventBeforeSnap:void 0,recentWheelEvents:[],enable:J.enable,disable:J.disable,handle:J.handle,handleMouseEnter:J.handleMouseEnter,handleMouseLeave:J.handleMouseLeave,animateSlider:J.animateSlider,releaseScroll:J.releaseScroll}})},on:{init:function(e){!e.params.mousewheel.enabled&&e.params.cssMode&&e.mousewheel.disable(),e.params.mousewheel.enabled&&e.mousewheel.enable()},destroy:function(e){e.params.cssMode&&e.mousewheel.enable(),e.mousewheel.enabled&&e.mousewheel.disable()}}},{name:"navigation",params:{navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock"}},create:function(){z(this,{navigation:t({},Q)})},on:{init:function(e){e.navigation.init(),e.navigation.update()},toEdge:function(e){e.navigation.update()},fromEdge:function(e){e.navigation.update()},destroy:function(e){e.navigation.destroy()},"enable disable":function(e){var t=e.navigation,a=t.$nextEl,i=t.$prevEl;a&&a[e.enabled?"removeClass":"addClass"](e.params.navigation.lockClass),i&&i[e.enabled?"removeClass":"addClass"](e.params.navigation.lockClass)},click:function(e,t){var a=e.navigation,i=a.$nextEl,s=a.$prevEl,r=t.target;if(e.params.navigation.hideOnClick&&!m(r).is(s)&&!m(r).is(i)){if(e.pagination&&e.params.pagination&&e.params.pagination.clickable&&(e.pagination.el===r||e.pagination.el.contains(r)))return;var n;i?n=i.hasClass(e.params.navigation.hiddenClass):s&&(n=s.hasClass(e.params.navigation.hiddenClass)),!0===n?e.emit("navigationShow"):e.emit("navigationHide"),i&&i.toggleClass(e.params.navigation.hiddenClass),s&&s.toggleClass(e.params.navigation.hiddenClass)}}}},{name:"pagination",params:{pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:function(e){return e},formatFractionTotal:function(e){return e},bulletClass:"swiper-pagination-bullet",bulletActiveClass:"swiper-pagination-bullet-active",modifierClass:"swiper-pagination-",currentClass:"swiper-pagination-current",totalClass:"swiper-pagination-total",hiddenClass:"swiper-pagination-hidden",progressbarFillClass:"swiper-pagination-progressbar-fill",progressbarOppositeClass:"swiper-pagination-progressbar-opposite",clickableClass:"swiper-pagination-clickable",lockClass:"swiper-pagination-lock"}},create:function(){z(this,{pagination:t({dynamicBulletIndex:0},ee)})},on:{init:function(e){e.pagination.init(),e.pagination.render(),e.pagination.update()},activeIndexChange:function(e){(e.params.loop||void 0===e.snapIndex)&&e.pagination.update()},snapIndexChange:function(e){e.params.loop||e.pagination.update()},slidesLengthChange:function(e){e.params.loop&&(e.pagination.render(),e.pagination.update())},snapGridLengthChange:function(e){e.params.loop||(e.pagination.render(),e.pagination.update())},destroy:function(e){e.pagination.destroy()},"enable disable":function(e){var t=e.pagination.$el;t&&t[e.enabled?"removeClass":"addClass"](e.params.pagination.lockClass)},click:function(e,t){var a=t.target;if(e.params.pagination.el&&e.params.pagination.hideOnClick&&e.pagination.$el.length>0&&!m(a).hasClass(e.params.pagination.bulletClass)){if(e.navigation&&(e.navigation.nextEl&&a===e.navigation.nextEl||e.navigation.prevEl&&a===e.navigation.prevEl))return;!0===e.pagination.$el.hasClass(e.params.pagination.hiddenClass)?e.emit("paginationShow"):e.emit("paginationHide"),e.pagination.$el.toggleClass(e.params.pagination.hiddenClass)}}}},{name:"scrollbar",params:{scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag"}},create:function(){z(this,{scrollbar:t({isTouched:!1,timeout:null,dragTimeout:null},te)})},on:{init:function(e){e.scrollbar.init(),e.scrollbar.updateSize(),e.scrollbar.setTranslate()},update:function(e){e.scrollbar.updateSize()},resize:function(e){e.scrollbar.updateSize()},observerUpdate:function(e){e.scrollbar.updateSize()},setTranslate:function(e){e.scrollbar.setTranslate()},setTransition:function(e,t){e.scrollbar.setTransition(t)},"enable disable":function(e){var t=e.scrollbar.$el;t&&t[e.enabled?"removeClass":"addClass"](e.params.scrollbar.lockClass)},destroy:function(e){e.scrollbar.destroy()}}},{name:"parallax",params:{parallax:{enabled:!1}},create:function(){z(this,{parallax:t({},ae)})},on:{beforeInit:function(e){e.params.parallax.enabled&&(e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},init:function(e){e.params.parallax.enabled&&e.parallax.setTranslate()},setTranslate:function(e){e.params.parallax.enabled&&e.parallax.setTranslate()},setTransition:function(e,t){e.params.parallax.enabled&&e.parallax.setTransition(t)}}},{name:"zoom",params:{zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}},create:function(){var e=this;z(e,{zoom:t({enabled:!1,scale:1,currentScale:1,isScaling:!1,gesture:{$slideEl:void 0,slideWidth:void 0,slideHeight:void 0,$imageEl:void 0,$imageWrapEl:void 0,maxRatio:3},image:{isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},velocity:{x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0}},ie)});var a=1;Object.defineProperty(e.zoom,"scale",{get:function(){return a},set:function(t){if(a!==t){var i=e.zoom.gesture.$imageEl?e.zoom.gesture.$imageEl[0]:void 0,s=e.zoom.gesture.$slideEl?e.zoom.gesture.$slideEl[0]:void 0;e.emit("zoomChange",t,i,s)}a=t}})},on:{init:function(e){e.params.zoom.enabled&&e.zoom.enable()},destroy:function(e){e.zoom.disable()},touchStart:function(e,t){e.zoom.enabled&&e.zoom.onTouchStart(t)},touchEnd:function(e,t){e.zoom.enabled&&e.zoom.onTouchEnd(t)},doubleTap:function(e,t){!e.animating&&e.params.zoom.enabled&&e.zoom.enabled&&e.params.zoom.toggle&&e.zoom.toggle(t)},transitionEnd:function(e){e.zoom.enabled&&e.params.zoom.enabled&&e.zoom.onTransitionEnd()},slideChange:function(e){e.zoom.enabled&&e.params.zoom.enabled&&e.params.cssMode&&e.zoom.onTransitionEnd()}}},{name:"lazy",params:{lazy:{checkInView:!1,enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,scrollingElement:"",elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}},create:function(){z(this,{lazy:t({initialImageLoaded:!1},se)})},on:{beforeInit:function(e){e.params.lazy.enabled&&e.params.preloadImages&&(e.params.preloadImages=!1)},init:function(e){e.params.lazy.enabled&&!e.params.loop&&0===e.params.initialSlide&&(e.params.lazy.checkInView?e.lazy.checkInViewOnLoad():e.lazy.load())},scroll:function(e){e.params.freeMode&&!e.params.freeModeSticky&&e.lazy.load()},"scrollbarDragMove resize _freeModeNoMomentumRelease":function(e){e.params.lazy.enabled&&e.lazy.load()},transitionStart:function(e){e.params.lazy.enabled&&(e.params.lazy.loadOnTransitionStart||!e.params.lazy.loadOnTransitionStart&&!e.lazy.initialImageLoaded)&&e.lazy.load()},transitionEnd:function(e){e.params.lazy.enabled&&!e.params.lazy.loadOnTransitionStart&&e.lazy.load()},slideChange:function(e){var t=e.params,a=t.lazy,i=t.cssMode,s=t.watchSlidesVisibility,r=t.watchSlidesProgress,n=t.touchReleaseOnEdges,l=t.resistanceRatio;a.enabled&&(i||(s||r)&&(n||0===l))&&e.lazy.load()}}},{name:"controller",params:{controller:{control:void 0,inverse:!1,by:"slide"}},create:function(){z(this,{controller:t({control:this.params.controller.control},re)})},on:{update:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},resize:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},observerUpdate:function(e){e.controller.control&&e.controller.spline&&(e.controller.spline=void 0,delete e.controller.spline)},setTranslate:function(e,t,a){e.controller.control&&e.controller.setTranslate(t,a)},setTransition:function(e,t,a){e.controller.control&&e.controller.setTransition(t,a)}}},{name:"a11y",params:{a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group"}},create:function(){z(this,{a11y:t({},ne,{liveRegion:m('<span class="'+this.params.a11y.notificationClass+'" aria-live="assertive" aria-atomic="true"></span>')})})},on:{afterInit:function(e){e.params.a11y.enabled&&(e.a11y.init(),e.a11y.updateNavigation())},toEdge:function(e){e.params.a11y.enabled&&e.a11y.updateNavigation()},fromEdge:function(e){e.params.a11y.enabled&&e.a11y.updateNavigation()},paginationUpdate:function(e){e.params.a11y.enabled&&e.a11y.updatePagination()},destroy:function(e){e.params.a11y.enabled&&e.a11y.destroy()}}},{name:"history",params:{history:{enabled:!1,root:"",replaceState:!1,key:"slides"}},create:function(){z(this,{history:t({},le)})},on:{init:function(e){e.params.history.enabled&&e.history.init()},destroy:function(e){e.params.history.enabled&&e.history.destroy()},"transitionEnd _freeModeNoMomentumRelease":function(e){e.history.initialized&&e.history.setHistory(e.params.history.key,e.activeIndex)},slideChange:function(e){e.history.initialized&&e.params.cssMode&&e.history.setHistory(e.params.history.key,e.activeIndex)}}},{name:"hash-navigation",params:{hashNavigation:{enabled:!1,replaceState:!1,watchState:!1}},create:function(){z(this,{hashNavigation:t({initialized:!1},oe)})},on:{init:function(e){e.params.hashNavigation.enabled&&e.hashNavigation.init()},destroy:function(e){e.params.hashNavigation.enabled&&e.hashNavigation.destroy()},"transitionEnd _freeModeNoMomentumRelease":function(e){e.hashNavigation.initialized&&e.hashNavigation.setHash()},slideChange:function(e){e.hashNavigation.initialized&&e.params.cssMode&&e.hashNavigation.setHash()}}},{name:"autoplay",params:{autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}},create:function(){z(this,{autoplay:t({},de,{running:!1,paused:!1})})},on:{init:function(e){e.params.autoplay.enabled&&(e.autoplay.start(),r().addEventListener("visibilitychange",e.autoplay.onVisibilityChange),e.autoplay.attachMouseEvents())},beforeTransitionStart:function(e,t,a){e.autoplay.running&&(a||!e.params.autoplay.disableOnInteraction?e.autoplay.pause(t):e.autoplay.stop())},sliderFirstMove:function(e){e.autoplay.running&&(e.params.autoplay.disableOnInteraction?e.autoplay.stop():e.autoplay.pause())},touchEnd:function(e){e.params.cssMode&&e.autoplay.paused&&!e.params.autoplay.disableOnInteraction&&e.autoplay.run()},destroy:function(e){e.autoplay.detachMouseEvents(),e.autoplay.running&&e.autoplay.stop(),r().removeEventListener("visibilitychange",e.autoplay.onVisibilityChange)}}},{name:"effect-fade",params:{fadeEffect:{crossFade:!1}},create:function(){z(this,{fadeEffect:t({},pe)})},on:{beforeInit:function(e){if("fade"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"fade");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};M(e.params,t),M(e.originalParams,t)}},setTranslate:function(e){"fade"===e.params.effect&&e.fadeEffect.setTranslate()},setTransition:function(e,t){"fade"===e.params.effect&&e.fadeEffect.setTransition(t)}}},{name:"effect-cube",params:{cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}},create:function(){z(this,{cubeEffect:t({},ue)})},on:{beforeInit:function(e){if("cube"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"cube"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0};M(e.params,t),M(e.originalParams,t)}},setTranslate:function(e){"cube"===e.params.effect&&e.cubeEffect.setTranslate()},setTransition:function(e,t){"cube"===e.params.effect&&e.cubeEffect.setTransition(t)}}},{name:"effect-flip",params:{flipEffect:{slideShadows:!0,limitRotation:!0}},create:function(){z(this,{flipEffect:t({},ce)})},on:{beforeInit:function(e){if("flip"===e.params.effect){e.classNames.push(e.params.containerModifierClass+"flip"),e.classNames.push(e.params.containerModifierClass+"3d");var t={slidesPerView:1,slidesPerColumn:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!0};M(e.params,t),M(e.originalParams,t)}},setTranslate:function(e){"flip"===e.params.effect&&e.flipEffect.setTranslate()},setTransition:function(e,t){"flip"===e.params.effect&&e.flipEffect.setTransition(t)}}},{name:"effect-coverflow",params:{coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}},create:function(){z(this,{coverflowEffect:t({},he)})},on:{beforeInit:function(e){"coverflow"===e.params.effect&&(e.classNames.push(e.params.containerModifierClass+"coverflow"),e.classNames.push(e.params.containerModifierClass+"3d"),e.params.watchSlidesProgress=!0,e.originalParams.watchSlidesProgress=!0)},setTranslate:function(e){"coverflow"===e.params.effect&&e.coverflowEffect.setTranslate()},setTransition:function(e,t){"coverflow"===e.params.effect&&e.coverflowEffect.setTransition(t)}}},{name:"thumbs",params:{thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-container-thumbs"}},create:function(){z(this,{thumbs:t({swiper:null,initialized:!1},ve)})},on:{beforeInit:function(e){var t=e.params.thumbs;t&&t.swiper&&(e.thumbs.init(),e.thumbs.update(!0))},slideChange:function(e){e.thumbs.swiper&&e.thumbs.update()},update:function(e){e.thumbs.swiper&&e.thumbs.update()},resize:function(e){e.thumbs.swiper&&e.thumbs.update()},observerUpdate:function(e){e.thumbs.swiper&&e.thumbs.update()},setTransition:function(e,t){var a=e.thumbs.swiper;a&&a.setTransition(t)},beforeDestroy:function(e){var t=e.thumbs.swiper;t&&e.thumbs.swiperCreated&&t&&t.destroy()}}}];return q.use(fe),q}));
//# sourceMappingURL=swiper-bundle.min.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(91);
var $export = __webpack_require__(30);
var toObject = __webpack_require__(75);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(199);
var toLength = __webpack_require__(68);
var createProperty = __webpack_require__(216);
var getIterFn = __webpack_require__(200);

$export($export.S + $export.F * !__webpack_require__(206)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(55)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(30);
var $includes = __webpack_require__(154)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(116)('includes');


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);



var Component = /*#__PURE__*/function () {
  function Component(props, context, updater) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Component);

    this.destroyed = false;
    this.props = props;
    this.state = {};
    this.context = context;
    this.updater = updater;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Component, [{
    key: "willMount",
    value: function willMount() {}
  }, {
    key: "didMount",
    value: function didMount() {}
  }, {
    key: "willReceiveProps",
    value: function willReceiveProps(_props, context) {}
  }, {
    key: "willUpdate",
    value: function willUpdate() {}
  }, {
    key: "didUpdate",
    value: function didUpdate() {}
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "didUnmount",
    value: function didUnmount() {}
  }, {
    key: "setState",
    value: function setState(partialState, callback) {
      this.updater.enqueueSetState(this, partialState, callback);
    }
  }, {
    key: "forceUpdate",
    value: function forceUpdate(callback) {
      this.updater.enqueueForceUpdate(this, {}, callback);
    }
  }, {
    key: "setAnimate",
    value: function setAnimate(animate) {
      this.animate = animate;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed = true;
    }
  }]);

  return Component;
}(); // 标识是否是组件
// @ts-ignore


Component.prototype.isF2Component = true;
/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(54);
var toLength = __webpack_require__(68);
var advanceStringIndex = __webpack_require__(156);
var regExpExec = __webpack_require__(129);

// @@match logic
__webpack_require__(131)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var aFunction = __webpack_require__(92);
var toObject = __webpack_require__(75);
var fails = __webpack_require__(55);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(94)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var inheritIfRequired = __webpack_require__(208);
var dP = __webpack_require__(63).f;
var gOPN = __webpack_require__(119).f;
var isRegExp = __webpack_require__(162);
var $flags = __webpack_require__(132);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(56) && (!CORRECT_NEW || __webpack_require__(55)(function () {
  re2[__webpack_require__(49)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(69)(global, 'RegExp', $RegExp);
}

__webpack_require__(205)('RegExp');


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(54);
var IE8_DOM_DEFINE = __webpack_require__(196);
var toPrimitive = __webpack_require__(126);
var dP = Object.defineProperty;

exports.f = __webpack_require__(56) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(234);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isArrayLike = function (value) {
    /**
     * isArrayLike([1, 2, 3]) => true
     * isArrayLike(document.body.children) => true
     * isArrayLike('abc') => true
     * isArrayLike(Function) => false
     */
    return value !== null && typeof value !== 'function' && isFinite(value.length);
};
/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);
//# sourceMappingURL=is-array-like.js.map

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);
/**
 * 是否为函数
 * @param  {*} fn 对象
 * @return {Boolean}  是否函数
 */

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Function');
});
//# sourceMappingURL=is-function.js.map

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(113);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var hide = __webpack_require__(83);
var has = __webpack_require__(84);
var SRC = __webpack_require__(111)('src');
var $toString = __webpack_require__(319);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(90).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toString = {}.toString;
var isType = function (value, type) { return toString.call(value) === '[object ' + type + ']'; };
/* harmony default export */ __webpack_exports__["a"] = (isType);
//# sourceMappingURL=is-type.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__element__ = __webpack_require__(716);








var Shape = /*#__PURE__*/function (_Element) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Shape, _Element);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Shape);

  function Shape() {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Shape);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Shape, [{
    key: "_initProperties",
    value:
    /* eslint-enable */
    function _initProperties() {
      this._attrs = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this._attrs), {}, {
        zIndex: 0,
        visible: true,
        destroyed: false,
        isShape: true,
        attrs: {}
      });
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._attrs.type;
    }
  }, {
    key: "drawInner",
    value: function drawInner(context) {
      var attrs = this.get('attrs');
      this.createPath(context);
      var originOpacity = context.globalAlpha;

      if (this.hasFill()) {
        var fillOpacity = attrs.fillOpacity;

        if (!Object(__WEBPACK_IMPORTED_MODULE_5__antv_util__["w" /* isNil */])(fillOpacity) && fillOpacity !== 1) {
          context.globalAlpha = fillOpacity;
          context.fill();
          context.globalAlpha = originOpacity;
        } else {
          context.fill();
        }
      }

      if (this.hasStroke()) {
        var lineWidth = attrs.lineWidth;

        if (lineWidth > 0) {
          var strokeOpacity = attrs.strokeOpacity;

          if (!Object(__WEBPACK_IMPORTED_MODULE_5__antv_util__["w" /* isNil */])(strokeOpacity) && strokeOpacity !== 1) {
            context.globalAlpha = strokeOpacity;
          }

          context.stroke();
        }
      }
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      var bbox = this._attrs.bbox;

      if (!bbox) {
        bbox = this.calculateBox();

        if (bbox) {
          bbox.x = bbox.minX;
          bbox.y = bbox.minY;
          bbox.width = bbox.maxX - bbox.minX;
          bbox.height = bbox.maxY - bbox.minY;
        }

        this._attrs.bbox = bbox;
      }

      return bbox;
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      return null;
    }
  }, {
    key: "createPath",
    value: function createPath(_context) {}
  }]);

  return Shape;
}(__WEBPACK_IMPORTED_MODULE_6__element__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Shape);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(748);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spreadArrays;
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(155);
var defined = __webpack_require__(93);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(93);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = px2dp;
/* harmony export (immutable) */ __webpack_exports__["c"] = px2dpSmall;
/* harmony export (immutable) */ __webpack_exports__["d"] = pxdp;
/* harmony export (immutable) */ __webpack_exports__["a"] = aiDp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
var isAndroid=__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isAndroid();function px2dp(uiElementPx){return uiElementPx*1/2;}function px2dpSmall(uiElementPx){return uiElementPx;}//一倍像素图,
function pxdp(uiElementPx){return uiElementPx;}// Android原值适配，iOS比例适配，向下取整。
function aiDp(dp){if(isAndroid){return dp;}return Math.floor(dp);}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(30);
var $find = __webpack_require__(99)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(116)(KEY);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);

/* harmony default export */ __webpack_exports__["a"] = (function (str) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(str, 'String');
});
//# sourceMappingURL=is-string.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);
/**
 * 判断是否数字
 * @return {Boolean} 是否数字
 */

var isNumber = function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Number');
};
/* harmony default export */ __webpack_exports__["a"] = (isNumber);
//# sourceMappingURL=is-number.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);



function objToString(obj) {
  return Object.prototype.toString.call(obj);
}

function objectKeys(obj) {
  return Object.keys(obj);
}

function equal(a, b) {
  if (a === b) return true;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) !== Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(b)) {
    return false;
  } // null 和 undefined


  if (a == null || b == null) {
    return false;
  } // 特殊处理NaN


  if (Number.isNaN(a) && Number.isNaN(b)) {
    return true;
  }

  if (objToString(a) !== objToString(b)) {
    return false;
  } // 如果是function， 则认为是相对


  if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["v" /* isFunction */])(a)) {
    return true;
  } // 值类型，Number String Boolean


  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) !== 'object') {
    return false;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(a)) {
    if (a.length !== b.length) {
      return false;
    }

    for (var i = a.length - 1; i >= 0; i--) {
      if (!equal(a[i], b[i])) {
        return false;
      }
    }

    return true;
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["A" /* isPlainObject */])(a)) {
    return false;
  }

  var ka = objectKeys(a);
  var kb = objectKeys(b); // having the same number of owned properties (keys incorporates hasOwnProperty)

  if (ka.length !== kb.length) {
    return false;
  } // the same set of keys (although not necessarily the same order),


  ka.sort();
  kb.sort(); // ~~~cheap key test

  for (var _i = ka.length - 1; _i >= 0; _i--) {
    if (ka[_i] != kb[_i]) {
      return false;
    }
  } // equivalent values for every corresponding key, and ~~~possibly expensive deep test


  for (var _i2 = ka.length - 1; _i2 >= 0; _i2--) {
    var key = ka[_i2];

    if (!equal(a[key], b[key])) {
      return false;
    }
  }

  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (equal);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(63);
var createDesc = __webpack_require__(110);
module.exports = __webpack_require__(56) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(30);
var context = __webpack_require__(164);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(165)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// isFinite,
var isNil = function (value) {
    /**
     * isNil(null) => true
     * isNil() => true
     */
    return value === null || value === undefined;
};
/* harmony default export */ __webpack_exports__["a"] = (isNil);
//# sourceMappingURL=is-nil.js.map

/***/ }),
/* 90 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(92);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(55);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(210);
var enumBugKeys = __webpack_require__(161);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(211)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return px2hd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return batch2hd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extendMap; });
/* unused harmony export parsePadding */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toTimeStamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isInBBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getElementsByClassName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
 // 默认设置50

var ONE_REM;

try {
  // xgraph下这段会抛错
  ONE_REM = parseInt(document.documentElement.style.fontSize, 10) || 50;
} catch (e) {
  ONE_REM = 50;
}

var SCALE = ONE_REM / 100;
/**
 * 像素转换
 * @param {Number} px - 750视觉稿像素
 * @return {Number} 屏幕上实际像素
 */

function defaultPx2hd(px) {
  if (!px) {
    return 0;
  }

  return Number((px * SCALE).toFixed(1));
}

function parsePadding(padding) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(padding)) {
    return [padding, padding, padding, padding];
  }

  var top = padding[0];
  var right = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(padding[1]) ? padding[1] : padding[0];
  var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(padding[2]) ? padding[2] : top;
  var left = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(padding[3]) ? padding[3] : right;
  return [top, right, bottom, left];
}

function batch2hd(px2hd) {
  var batchPx2hd = function batchPx2hd(value) {
    // 处理带px的数据
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["B" /* isString */])(value) && /^-?\d+px$/.test(value)) {
      var num = value.substr(0, value.length - 2);
      return px2hd(Number(num));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["r" /* isArray */])(value)) {
      return value.map(function (v) {
        return batchPx2hd(v);
      });
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["A" /* isPlainObject */])(value)) {
      var result = {};

      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          var rst = batchPx2hd(value[key]);

          if (!rst) {
            result[key] = rst;
            continue;
          }

          if (key === 'padding' || key === 'margin') {
            var paddingArray = parsePadding(rst);
            result[key] = paddingArray;
            result["".concat(key, "Top")] = paddingArray[0];
            result["".concat(key, "Right")] = paddingArray[1];
            result["".concat(key, "Bottom")] = paddingArray[2];
            result["".concat(key, "Left")] = paddingArray[3];
            continue;
          }

          result[key] = rst;
        }
      }

      return result;
    } // 默认直接返回


    return value;
  };

  return batchPx2hd;
} // 展开数组


function extendMap(arr, fn) {
  if (!arr) {
    return arr;
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["r" /* isArray */])(arr)) {
    return [fn(arr)];
  }

  var newArray = [];

  for (var i = 0; i < arr.length; i++) {
    var element = arr[i];

    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["r" /* isArray */])(element)) {
      newArray = newArray.concat(extendMap(element, fn));
    } else if (element) {
      newArray.push(fn(element));
    }
  }

  return newArray;
}

function toTimeStamp(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["B" /* isString */])(value)) {
    if (value.indexOf('T') > 0) {
      value = new Date(value).getTime();
    } else {
      // new Date('2010/01/10') 和 new Date('2010-01-10') 的差别在于:
      // 如果仅有年月日时，前者是带有时区的: Fri Jan 10 2020 02:40:13 GMT+0800 (中国标准时间)
      // 后者会格式化成 Sun Jan 10 2010 08:00:00 GMT+0800 (中国标准时间)
      value = new Date(value.replace(/-/gi, '/')).getTime();
    }
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["t" /* isDate */])(value)) {
    value = value.getTime();
  }

  return value;
}

function isInBBox(bbox, point) {
  var minX = bbox.minX,
      maxX = bbox.maxX,
      minY = bbox.minY,
      maxY = bbox.maxY;
  var x = point.x,
      y = point.y;
  return minX <= x && maxX >= x && minY <= y && maxY >= y;
}

function getElementsByClassName(className, element) {
  if (!element || !className) return [];
  var rst = [];

  if (element.get('className') === className) {
    rst.push(element);
  }

  var children = element.get('children');

  if (children && children.length) {
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      rst = rst.concat(getElementsByClassName(className, child));
    }
  }

  return rst;
}

var px2hd = batch2hd(defaultPx2hd);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(91);
var IObject = __webpack_require__(155);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(68);
var asc = __webpack_require__(334);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(69)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(345);
var anObject = __webpack_require__(54);
var $flags = __webpack_require__(132);
var DESCRIPTORS = __webpack_require__(56);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(69)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(55)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);



function cloneElement(element, props) {
  if (!element) return element;
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, element), {}, {
    props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, element.props), props)
  });
}

function map(children, fn) {
  if (!children) {
    return fn(children);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(children)) {
    return children.map(function (child) {
      return map(child, fn);
    });
  }

  return fn(children);
}

function compareArray(nextElements, lastElements, callback) {
  var keyed = {};
  var nextLength = nextElements.length;
  var lastLength = lastElements.length;

  for (var i = 0, len = lastLength; i < len; i++) {
    var element = lastElements[i];

    if (element && !Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(element.key)) {
      var key = element.key;
      keyed[key] = element;
    }
  } // 比较元素


  for (var _i = 0, _len = Math.max(nextLength, lastLength); _i < _len; _i++) {
    var _element = nextElements[_i];

    if (!_element) {
      compare(_element, lastElements[_i], callback);
      continue;
    }

    var _key = _element.key; // 有key值定义

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(_element.key)) {
      var lastElement = keyed[_key];
      if (lastElement) delete keyed[_key];
      compare(_element, lastElement, callback);
      continue;
    }

    compare(_element, lastElements[_i], callback);
  } // 说明是删除的元素


  Object.keys(keyed).forEach(function (key) {
    compare(null, keyed[key], callback);
  });
} // 比较2棵树


function compare(nextElement, lastElement, callback) {
  // 有一个为空
  if (!nextElement || !lastElement) {
    callback(nextElement, lastElement);
    return;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(nextElement) || Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(lastElement)) {
    var nextElementArray = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(nextElement) ? nextElement : [nextElement];
    var lastElementArray = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(lastElement) ? lastElement : [lastElement];
    compareArray(nextElementArray, lastElementArray, callback);
    return;
  }

  callback(nextElement, lastElement);
}

function toArray(element) {
  if (!element) {
    return element;
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(element)) {
    return [element];
  }

  var newArray = [];

  for (var i = 0, len = element.length; i < len; i++) {
    var item = element[i];

    if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(item)) {
      // @ts-ignore
      newArray = newArray.concat(toArray(item));
    } else {
      newArray.push(item);
    }
  }

  return newArray;
}

var Children = {
  cloneElement: cloneElement,
  map: map,
  toArray: toArray,
  compare: compare
};
/* harmony default export */ __webpack_exports__["a"] = (Children);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_object__ = __webpack_require__(139);


function each(elements, func) {
    if (!elements) {
        return;
    }
    var rst;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(elements)) {
        for (var i = 0, len = elements.length; i < len; i++) {
            rst = func(elements[i], i);
            if (rst === false) {
                break;
            }
        }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__is_object__["a" /* default */])(elements)) {
        for (var k in elements) {
            if (elements.hasOwnProperty(k)) {
                rst = func(elements[k], k);
                if (rst === false) {
                    break;
                }
            }
        }
    }
}
/* harmony default export */ __webpack_exports__["a"] = (each);
//# sourceMappingURL=each.js.map

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_nil__ = __webpack_require__(89);

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_nil__["a" /* default */])(value))
        return '';
    return value.toString();
});
//# sourceMappingURL=to-string.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerEngine */
/* unused harmony export getEngine */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createCanvas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_matrix__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_vector2__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_smooth__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_bbox__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__engine__ = __webpack_require__(712);
/* unused harmony reexport Canvas */
/* unused harmony reexport Group */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__engine__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__util_matrix__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__util_vector2__["a"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__util_smooth__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__util_bbox__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(732);
/* unused harmony reexport Types */





var engines = {};

function registerEngine(name, engine) {
  engines[name] = engine;
}

function getEngine(name) {
  var G = engines[name];

  if (G) {
    return G;
  }

  return {
    Canvas: __WEBPACK_IMPORTED_MODULE_4__engine__["a" /* Canvas */],
    Group: __WEBPACK_IMPORTED_MODULE_4__engine__["b" /* Group */],
    Shape: __WEBPACK_IMPORTED_MODULE_4__engine__["c" /* Shape */]
  };
}

function createCanvas(cfg) {
  var renderer = cfg.renderer;
  var G = getEngine(renderer);
  return new G.Canvas(cfg);
}





/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBBoxFromPoints", function() { return getBBoxFromPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBBoxFromLine", function() { return getBBoxFromLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBBoxFromArc", function() { return getBBoxFromArc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBBoxFromBezierGroup", function() { return getBBoxFromBezierGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vector2__ = __webpack_require__(122);

var start = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].create();
var end = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].create();
var extremity = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].create();

function getCubicBezierXYatT(startPt, controlPt1, controlPt2, endPt, T) {
  var x = CubicN(T, startPt.x, controlPt1.x, controlPt2.x, endPt.x);
  var y = CubicN(T, startPt.y, controlPt1.y, controlPt2.y, endPt.y);
  return {
    x: x,
    y: y
  };
} // cubic helper formula at T distance


function CubicN(T, a, b, c, d) {
  var t2 = T * T;
  var t3 = t2 * T;
  return a + (-a * 3 + T * (3 * a - a * T)) * T + (3 * b + T * (-6 * b + b * 3 * T)) * T + (c * 3 - c * 3 * T) * t2 + d * t3;
}

function cubicBezierBounds(c) {
  var minX = Infinity;
  var maxX = -Infinity;
  var minY = Infinity;
  var maxY = -Infinity;
  var s = {
    x: c[0],
    y: c[1]
  };
  var c1 = {
    x: c[2],
    y: c[3]
  };
  var c2 = {
    x: c[4],
    y: c[5]
  };
  var e = {
    x: c[6],
    y: c[7]
  };

  for (var t = 0; t < 100; t++) {
    var pt = getCubicBezierXYatT(s, c1, c2, e, t / 100);

    if (pt.x < minX) {
      minX = pt.x;
    }

    if (pt.x > maxX) {
      maxX = pt.x;
    }

    if (pt.y < minY) {
      minY = pt.y;
    }

    if (pt.y > maxY) {
      maxY = pt.y;
    }
  }

  return {
    minX: minX,
    minY: minY,
    maxX: maxX,
    maxY: maxY
  };
}

function getBBoxFromPoints(points, lineWidth) {
  if (points.length === 0) {
    return;
  }

  var p = points[0];
  var left = p.x;
  var right = p.x;
  var top = p.y;
  var bottom = p.y;
  var len = points.length;

  for (var i = 1; i < len; i++) {
    p = points[i];
    left = Math.min(left, p.x);
    right = Math.max(right, p.x);
    top = Math.min(top, p.y);
    bottom = Math.max(bottom, p.y);
  }

  lineWidth = lineWidth / 2 || 0;
  return {
    minX: left - lineWidth,
    minY: top - lineWidth,
    maxX: right + lineWidth,
    maxY: bottom + lineWidth
  };
}

function getBBoxFromLine(x0, y0, x1, y1, lineWidth) {
  lineWidth = lineWidth / 2 || 0;
  return {
    minX: Math.min(x0, x1) - lineWidth,
    minY: Math.min(y0, y1) - lineWidth,
    maxX: Math.max(x0, x1) + lineWidth,
    maxY: Math.max(y0, y1) + lineWidth
  };
}

function getBBoxFromArc(x, y, r, startAngle, endAngle, anticlockwise) {
  var diff = Math.abs(startAngle - endAngle);

  if (diff % (Math.PI * 2) < 1e-4 && diff > 1e-4) {
    // Is a circle
    return {
      minX: x - r,
      minY: y - r,
      maxX: x + r,
      maxY: y + r
    };
  }

  start[0] = Math.cos(startAngle) * r + x;
  start[1] = Math.sin(startAngle) * r + y;
  end[0] = Math.cos(endAngle) * r + x;
  end[1] = Math.sin(endAngle) * r + y;
  var min = [0, 0];
  var max = [0, 0];
  __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].min(min, start, end);
  __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].max(max, start, end); // Thresh to [0, Math.PI * 2]

  startAngle = startAngle % (Math.PI * 2);

  if (startAngle < 0) {
    startAngle = startAngle + Math.PI * 2;
  }

  endAngle = endAngle % (Math.PI * 2);

  if (endAngle < 0) {
    endAngle = endAngle + Math.PI * 2;
  }

  if (startAngle > endAngle && !anticlockwise) {
    endAngle += Math.PI * 2;
  } else if (startAngle < endAngle && anticlockwise) {
    startAngle += Math.PI * 2;
  }

  if (anticlockwise) {
    var tmp = endAngle;
    endAngle = startAngle;
    startAngle = tmp;
  }

  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
    if (angle > startAngle) {
      extremity[0] = Math.cos(angle) * r + x;
      extremity[1] = Math.sin(angle) * r + y;
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].min(min, extremity, min);
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].max(max, extremity, max);
    }
  }

  return {
    minX: min[0],
    minY: min[1],
    maxX: max[0],
    maxY: max[1]
  };
}

function getBBoxFromBezierGroup(points, lineWidth) {
  var minX = Infinity;
  var maxX = -Infinity;
  var minY = Infinity;
  var maxY = -Infinity;

  for (var i = 0, len = points.length; i < len; i++) {
    var bbox = cubicBezierBounds(points[i]);

    if (bbox.minX < minX) {
      minX = bbox.minX;
    }

    if (bbox.maxX > maxX) {
      maxX = bbox.maxX;
    }

    if (bbox.minY < minY) {
      minY = bbox.minY;
    }

    if (bbox.maxY > maxY) {
      maxY = bbox.maxY;
    }
  }

  lineWidth = lineWidth / 2 || 0;
  return {
    minX: minX - lineWidth,
    minY: minY - lineWidth,
    maxX: maxX + lineWidth,
    maxY: maxY + lineWidth
  };
}



/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab_js__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__ = __webpack_require__(756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"]; });




/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(279);


function linear(a, d) {
  return function (t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(191);


var Adjust = /** @class */ (function () {
    function Adjust(cfg) {
        var xField = cfg.xField, yField = cfg.yField, _a = cfg.adjustNames, adjustNames = _a === void 0 ? ['x', 'y'] : _a, dimValuesMap = cfg.dimValuesMap;
        this.adjustNames = adjustNames;
        this.xField = xField;
        this.yField = yField;
        this.dimValuesMap = dimValuesMap;
    }
    /**
     * 查看维度是否是 adjust 字段
     * @param dim
     */
    Adjust.prototype.isAdjust = function (dim) {
        return this.adjustNames.indexOf(dim) >= 0;
    };
    Adjust.prototype.getAdjustRange = function (dim, dimValue, values) {
        var yField = this.yField;
        var index = values.indexOf(dimValue);
        var length = values.length;
        var pre;
        var next;
        // 没有 y 字段，但是需要根据 y 调整
        if (!yField && this.isAdjust('y')) {
            pre = 0;
            next = 1;
        }
        else if (length > 1) {
            // 如果以其开头，则取之，否则取他前面一个
            pre = values[index === 0 ? 0 : index - 1];
            // 如果以其结尾，则取之，否则取他后面一个
            next = values[index === length - 1 ? length - 1 : index + 1];
            if (index !== 0) {
                pre += (dimValue - pre) / 2;
            }
            else {
                pre -= (next - dimValue) / 2;
            }
            if (index !== length - 1) {
                next -= (next - dimValue) / 2;
            }
            else {
                next += (dimValue - values[length - 2]) / 2;
            }
        }
        else {
            pre = dimValue === 0 ? 0 : dimValue - 0.5;
            next = dimValue === 0 ? 1 : dimValue + 0.5;
        }
        return {
            pre: pre,
            next: next,
        };
    };
    Adjust.prototype.adjustData = function (groupedDataArray, mergedData) {
        var _this = this;
        // 所有调整维度的值数组
        var dimValuesMap = this.getDimValues(mergedData);
        // 按照每一个分组来进行调整
        __WEBPACK_IMPORTED_MODULE_0__antv_util__["e" /* each */](groupedDataArray, function (dataArray, index) {
            // 遍历所有数据集合
            // 每个分组中，分别按照不同的 dim 进行调整
            __WEBPACK_IMPORTED_MODULE_0__antv_util__["e" /* each */](dimValuesMap, function (values, dim) {
                // 根据不同的度量分别调整位置
                _this.adjustDim(dim, values, dataArray, index);
            });
        });
    };
    /**
     * 对数据进行分组adjustData
     * @param data 数据
     * @param dim 分组的字段
     * @return 分组结果
     */
    Adjust.prototype.groupData = function (data, dim) {
        // 补齐数据空数据为默认值
        __WEBPACK_IMPORTED_MODULE_0__antv_util__["e" /* each */](data, function (record) {
            if (record[dim] === undefined) {
                record[dim] = __WEBPACK_IMPORTED_MODULE_1__constant__["a" /* DEFAULT_Y */];
            }
        });
        // 按照 dim 维度分组
        return __WEBPACK_IMPORTED_MODULE_0__antv_util__["n" /* groupBy */](data, dim);
    };
    /** @override */
    Adjust.prototype.adjustDim = function (dim, values, data, index) { };
    /**
     * 获取可调整度量对应的值
     * @param mergedData 数据
     * @return 值的映射
     */
    Adjust.prototype.getDimValues = function (mergedData) {
        var _a = this, xField = _a.xField, yField = _a.yField;
        var dimValuesMap = __WEBPACK_IMPORTED_MODULE_0__antv_util__["b" /* assign */]({}, this.dimValuesMap);
        // 所有的维度
        var dims = [];
        if (xField && this.isAdjust('x')) {
            dims.push(xField);
        }
        if (yField && this.isAdjust('y')) {
            dims.push(yField);
        }
        dims.forEach(function (dim) {
            if (dimValuesMap && dimValuesMap[dim]) {
                return;
            }
            // 在每个维度上，所有的值
            dimValuesMap[dim] = __WEBPACK_IMPORTED_MODULE_0__antv_util__["M" /* valuesOfKey */](mergedData, dim).sort(function (v1, v2) { return v1 - v2; });
        });
        // 只有一维的情况下，同时调整 y，赋予默认值
        if (!yField && this.isAdjust('y')) {
            var dim = 'y';
            dimValuesMap[dim] = [__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* DEFAULT_Y */], 1]; // 默认分布在 y 轴的 0 与 1 之间
        }
        return dimValuesMap;
    };
    return Adjust;
}());
/* harmony default export */ __webpack_exports__["a"] = (Adjust);
//# sourceMappingURL=adjust.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(329);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(49)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(83)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(118);
var createDesc = __webpack_require__(110);
var toIObject = __webpack_require__(74);
var toPrimitive = __webpack_require__(126);
var has = __webpack_require__(84);
var IE8_DOM_DEFINE = __webpack_require__(196);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(56) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(210);
var hiddenKeys = __webpack_require__(161).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(54);
var dPs = __webpack_require__(212);
var enumBugKeys = __webpack_require__(161);
var IE_PROTO = __webpack_require__(160)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(153)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(158).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_object_like__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_type__ = __webpack_require__(70);


var isPlainObject = function (value) {
    /**
     * isObjectLike(new Foo) => false
     * isObjectLike([1, 2, 3]) => false
     * isObjectLike({ x: 0, y: 0 }) => true
     * isObjectLike(Object.create(null)) => true
     */
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_object_like__["a" /* default */])(value) || !Object(__WEBPACK_IMPORTED_MODULE_1__is_type__["a" /* default */])(value, 'Object')) {
        return false;
    }
    if (Object.getPrototypeOf(value) === null) {
        return true;
    }
    var proto = value;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(value) === proto;
};
/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);
//# sourceMappingURL=is-plain-object.js.map

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 2 Dimensional Vector
 * @module vector2
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Creates a new, empty vector2
   *
   * @return {vector2} a new 2D vector
   */
  create: function create() {
    return [0, 0];
  },

  /**
   * Calculates the length of a vector2
   *
   * @param {vector2} v vector to calculate length of
   * @return {Number} length of v
   */
  length: function length(v) {
    var x = v[0];
    var y = v[1];
    return Math.sqrt(x * x + y * y);
  },

  /**
   * Normalize a vector2
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v vector to normalize
   * @return {vector2} out
   */
  normalize: function normalize(out, v) {
    var len = this.length(v);

    if (len === 0) {
      out[0] = 0;
      out[1] = 0;
    } else {
      out[0] = v[0] / len;
      out[1] = v[1] / len;
    }

    return out;
  },

  /**
   * Adds two vector2's
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {vector2} out
   */
  add: function add(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
  },

  /**
   * Subtracts vector v2 from vector v1
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {vector2} out
   */
  sub: function sub(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
  },

  /**
   * Scales a vector2 by a scalar number
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v the vector to scale
   * @param {Number} s amount to scale the vector by
   * @return {vector2} out
   */
  scale: function scale(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
  },

  /**
   * Calculates the dot product of two vector2's
   *
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {Number} dot product of v1 and v2
   */
  dot: function dot(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
  },

  /**
   * Calculates the direction of two vector2's
   *
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {Boolean} the direction of v1 and v2
   */
  direction: function direction(v1, v2) {
    return v1[0] * v2[1] - v2[0] * v1[1];
  },

  /**
   * Calculates the angle of two vector2's
   *
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {Number} angle of v1 and v2
   */
  angle: function angle(v1, v2) {
    var theta = this.dot(v1, v2) / (this.length(v1) * this.length(v2));
    return Math.acos(theta);
  },

  /**
   * Calculates the angle of two vector2's with direction
   *
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @param {Boolean} direction the direction of two vector2's
   * @return {Number} angle of v1 and v2
   */
  angleTo: function angleTo(v1, v2, direction) {
    var angle = this.angle(v1, v2);
    var angleLargeThanPI = this.direction(v1, v2) >= 0;

    if (direction) {
      if (angleLargeThanPI) {
        return Math.PI * 2 - angle;
      }

      return angle;
    }

    if (angleLargeThanPI) {
      return angle;
    }

    return Math.PI * 2 - angle;
  },

  /**
   * whether a vector2 is zero vector
   *
   * @param  {vector2} v vector to calculate
   * @return {Boolean}   is or not a zero vector
   */
  zero: function zero(v) {
    return v[0] === 0 && v[1] === 0;
  },

  /**
   * Calculates the euclidian distance between two vector2's
   *
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {Number} distance between a and b
   */
  distance: function distance(v1, v2) {
    var x = v2[0] - v1[0];
    var y = v2[1] - v1[1];
    return Math.sqrt(x * x + y * y);
  },

  /**
   * Creates a new vector2 initialized with values from an existing vector
   *
   * @param {vector2} v vector to clone
   * @return {Array} a new 2D vector
   */
  clone: function clone(v) {
    return [v[0], v[1]];
  },

  /**
   * Return the minimum of two vector2's
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {vector2} out
   */
  min: function min(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
  },

  /**
   * Return the maximum of two vector2's
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v1 the first operand
   * @param {vector2} v2 the second operand
   * @return {vector2} out
   */
  max: function max(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
  },

  /**
   * Transforms the vector2 with a mat2d
   *
   * @param {vector2} out the receiving vector
   * @param {vector2} v the vector to transform
   * @param {mat2d} m matrix to transform with
   * @return {vector2} out
   */
  transformMat2d: function transformMat2d(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__category_base__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_time__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__continuous_linear__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous_log__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous_pow__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__continuous_time__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__continuous_quantize__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__continuous_quantile__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__factory__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__identity_index__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__tick_method_index__ = __webpack_require__(786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__category_base__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__identity_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__continuous_linear__["a"]; });
/* unused harmony reexport Log */
/* unused harmony reexport Pow */
/* unused harmony reexport Time */
/* unused harmony reexport TimeCat */
/* unused harmony reexport Quantile */
/* unused harmony reexport Quantize */
/* unused harmony reexport Scale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__factory__["a"]; });
/* unused harmony reexport registerScale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__tick_method_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__tick_method_index__["b"]; });












Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('cat', __WEBPACK_IMPORTED_MODULE_1__category_base__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('category', __WEBPACK_IMPORTED_MODULE_1__category_base__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('identity', __WEBPACK_IMPORTED_MODULE_10__identity_index__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('linear', __WEBPACK_IMPORTED_MODULE_3__continuous_linear__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('log', __WEBPACK_IMPORTED_MODULE_4__continuous_log__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('pow', __WEBPACK_IMPORTED_MODULE_5__continuous_pow__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('time', __WEBPACK_IMPORTED_MODULE_6__continuous_time__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('timeCat', __WEBPACK_IMPORTED_MODULE_2__category_time__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('quantize', __WEBPACK_IMPORTED_MODULE_7__continuous_quantize__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_9__factory__["b" /* registerScale */])('quantile', __WEBPACK_IMPORTED_MODULE_8__continuous_quantile__["a" /* default */]);

//# sourceMappingURL=index.js.map

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tick_method_register__ = __webpack_require__(284);


var Scale = /** @class */ (function () {
    function Scale(cfg) {
        /**
         * 度量的类型
         */
        this.type = 'base';
        /**
         * 是否分类类型的度量
         */
        this.isCategory = false;
        /**
         * 是否线性度量，有linear, time 度量
         */
        this.isLinear = false;
        /**
         * 是否连续类型的度量，linear,time,log, pow, quantile, quantize 都支持
         */
        this.isContinuous = false;
        /**
         * 是否是常量的度量，传入和传出一致
         */
        this.isIdentity = false;
        this.values = [];
        this.range = [0, 1];
        this.ticks = [];
        this.__cfg__ = cfg;
        this.initCfg();
        this.init();
    }
    // 对于原始值的必要转换，如分类、时间字段需转换成数值，用transform/map命名可能更好
    Scale.prototype.translate = function (v) {
        return v;
    };
    /** 重新初始化 */
    Scale.prototype.change = function (cfg) {
        // 覆盖配置项，而不替代
        Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["b" /* assign */])(this.__cfg__, cfg);
        this.init();
    };
    Scale.prototype.clone = function () {
        return this.constructor(this.__cfg__);
    };
    /** 获取坐标轴需要的ticks */
    Scale.prototype.getTicks = function () {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["E" /* map */])(this.ticks, function (tick, idx) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["z" /* isObject */])(tick)) {
                // 仅当符合Tick类型时才有意义
                return tick;
            }
            return {
                text: _this.getText(tick, idx),
                tickValue: tick,
                value: _this.scale(tick),
            };
        });
    };
    /** 获取Tick的格式化结果 */
    Scale.prototype.getText = function (value, key) {
        var formatter = this.formatter;
        var res = formatter ? formatter(value, key) : value;
        if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(res) || !Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["v" /* isFunction */])(res.toString)) {
            return '';
        }
        return res.toString();
    };
    // 获取配置项中的值，当前 scale 上的值可能会被修改
    Scale.prototype.getConfig = function (key) {
        return this.__cfg__[key];
    };
    // scale初始化
    Scale.prototype.init = function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["b" /* assign */])(this, this.__cfg__);
        this.setDomain();
        if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["u" /* isEmpty */])(this.getConfig('ticks'))) {
            this.ticks = this.calculateTicks();
        }
    };
    // 子类上覆盖某些属性，不能直接在类上声明，否则会被覆盖
    Scale.prototype.initCfg = function () { };
    Scale.prototype.setDomain = function () { };
    Scale.prototype.calculateTicks = function () {
        var tickMethod = this.tickMethod;
        var ticks = [];
        if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["B" /* isString */])(tickMethod)) {
            var method = Object(__WEBPACK_IMPORTED_MODULE_1__tick_method_register__["a" /* getTickMethod */])(tickMethod);
            if (!method) {
                throw new Error('There is no method to to calculate ticks!');
            }
            ticks = method(this);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["v" /* isFunction */])(tickMethod)) {
            ticks = tickMethod(this);
        }
        return ticks;
    };
    // range 的最小值
    Scale.prototype.rangeMin = function () {
        return this.range[0];
    };
    // range 的最大值
    Scale.prototype.rangeMax = function () {
        return this.range[1];
    };
    /** 定义域转 0~1 */
    Scale.prototype.calcPercent = function (value, min, max) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(value)) {
            return (value - min) / (max - min);
        }
        return NaN;
    };
    /** 0~1转定义域 */
    Scale.prototype.calcValue = function (percent, min, max) {
        return min + percent * (max - min);
    };
    return Scale;
}());
/* harmony default export */ __webpack_exports__["a"] = (Scale);
//# sourceMappingURL=base.js.map

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(64);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(90);
var global = __webpack_require__(52);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(112) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(113);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(130);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(85);
var TAG = __webpack_require__(49)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(320);
var redefine = __webpack_require__(69);
var hide = __webpack_require__(83);
var fails = __webpack_require__(55);
var defined = __webpack_require__(93);
var wks = __webpack_require__(49);
var regexpExec = __webpack_require__(157);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(54);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(63).f;
var has = __webpack_require__(84);
var TAG = __webpack_require__(49)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(223)(module)))

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array
/*: Array<any> | TouchList*/
, callback
/*: Function*/
)
/*: any*/
{
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func
/*: any*/
)
/*: boolean %checks*/
{
  // $FlowIgnore[method-unbinding]
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num
/*: any*/
)
/*: boolean %checks*/
{
  return typeof num === 'number' && !isNaN(num);
}

function int(a
/*: string*/
)
/*: number*/
{
  return parseInt(a, 10);
}

function dontSetMe(props
/*: Object*/
, propName
/*: string*/
, componentName
/*: string*/
)
/*: ?Error*/
{
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var $some = __webpack_require__(99)(3);

$export($export.P + $export.F * !__webpack_require__(94)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
    /**
     * isObject({}) => true
     * isObject([1, 2, 3]) => true
     * isObject(Function) => true
     * isObject(null) => false
     */
    var type = typeof value;
    return value !== null && type === 'object' || type === 'function';
});
//# sourceMappingURL=is-object.js.map

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderChildren; });
/* unused harmony export diff */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return renderShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return destroyElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__children__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsx_render__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__equal__ = __webpack_require__(82);

var _excluded = ["transformFrom"];







function pickElement(element) {
  if (!element) return element;
  return __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(element, function (item) {
    if (!item) return item; // 只需要这几个元素就可以了

    return Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["I" /* pick */])(item, ['key', 'ref', 'type', 'props']);
  });
}

function renderShape(component, children, animate) {
  var container = component.container,
      context = component.context,
      updater = component.updater,
      __lastElement = component.__lastElement,
      transformFrom = component.transformFrom,
      componentAnimate = component.animate; // 先清空绘制内容

  container.clear();
  animate = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["s" /* isBoolean */])(animate) ? animate : componentAnimate;
  var px2hd = context.px2hd;
  var lastElement = __lastElement || transformFrom && transformFrom.__lastElement; // children 是 shape 的 jsx 结构, component.render() 返回的结构

  var shapeElement = Object(__WEBPACK_IMPORTED_MODULE_3__jsx__["d" /* renderJSXElement */])(children, context, updater); // @ts-ignore

  component.__lastElement = shapeElement;
  var renderElement = animate !== false ? Object(__WEBPACK_IMPORTED_MODULE_3__jsx__["b" /* compareRenderTree */])(shapeElement, lastElement) : shapeElement;
  if (!renderElement) return null; // 生成G的节点树, 存在数组的情况是根节点有变化，之前的树删除，新的树创建

  if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(renderElement)) {
    return renderElement.map(function (element) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__jsx_render__["a" /* render */])(element, container, animate, px2hd);
    });
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_4__jsx_render__["a" /* render */])(renderElement, container, animate, px2hd);
  }
}

function setComponentAnimate(child, parent) {
  var parentAnimate = parent.animate; // 如果父组件不需要动画，子组件全不不执行动画

  if (parentAnimate === false) {
    child.animate = false;
    return;
  }

  var childProps = child.props;
  var childAnimate = childProps.animate;
  child.animate = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["s" /* isBoolean */])(childAnimate) ? childAnimate : parentAnimate;
}

function getTransformComponent(component) {
  if (!component) return null; // @ts-ignore

  var __lastElement = component.__lastElement,
      children = component.children;

  if (__lastElement) {
    return component;
  }

  if (!children) {
    return null;
  }

  var componentFromChildren = null;
  __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(children, function (item) {
    if (componentFromChildren) return;
    if (!item) return;
    var component = getTransformComponent(item.component);

    if (component) {
      componentFromChildren = component;
    }
  });
  return componentFromChildren;
}

function getTransformFromComponentRef(transformFromRef) {
  if (!transformFromRef || !transformFromRef.current) {
    return null;
  }

  var transformFromComponent = transformFromRef.current;
  return getTransformComponent(transformFromComponent);
}

function createComponent(parent, element) {
  var type = element.type,
      props = element.props,
      ref = element.ref;
  var container = parent.container,
      context = parent.context,
      updater = parent.updater,
      transformFrom = parent.transformFrom;

  var transformFromRef = props.transformFrom,
      receiveProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);

  var component; // @ts-ignore

  if (type.prototype && type.prototype.isF2Component) {
    // @ts-ignore
    component = new type(receiveProps, context, updater);
  } else {
    component = new __WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */](receiveProps, context, updater);

    component.render = function () {
      // @ts-ignore
      return type(this.props, context, updater);
    };
  } // 设置ref


  if (ref) {
    ref.current = component;
  } // 因为view 可能在子组件，所以这里要透传到子组件


  if (transformFrom) {
    // @ts-ignore
    component.transformFrom = transformFrom;
  }

  if (transformFromRef) {
    var transformFromComponent = transformFromRef ? getTransformFromComponentRef(transformFromRef) : null; // @ts-ignore

    component.transformFrom = transformFromComponent;
  }

  var zIndex = props.zIndex; // 每个组件都新建一个独立容器

  component.container = container.addGroup({
    zIndex: zIndex
  });
  component.context = context;
  component.updater = updater;
  return component;
}

function renderComponent(component) {
  __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(component, function (item) {
    var lastChildren = item.children;
    var mount = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["C" /* isUndefined */])(lastChildren);

    if (mount) {
      if (item.willMount) item.willMount();
    } else if (item.willUpdate) {
      item.willUpdate();
    }
  });
  __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(component, function (item) {
    var lastChildren = item.children;
    var mount = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["C" /* isUndefined */])(lastChildren);
    var newChildren = item.render();
    renderChildren(item, newChildren, lastChildren);

    if (mount) {
      if (item.didMount) item.didMount();
    } else if (item.didUpdate) {
      item.didUpdate();
    }
  });
}

function destroyElement(elements) {
  __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(elements, function (element) {
    if (!element) return;
    var component = element.component;

    if (!component) {
      return;
    }

    if (component.willUnmount) {
      component.willUnmount();
    }

    destroyElement(component.children);
    var container = component.container;
    container.remove(true);

    if (component.didUnmount) {
      component.didUnmount();
    }

    component.destroy();
  });
}

function diffElement(parent, nextElement, lastElement) {
  if (!nextElement && !lastElement) {
    return null;
  } // 删除


  if (!nextElement && lastElement) {
    destroyElement(lastElement);
    return null;
  } // 新建


  if (nextElement && !lastElement) {
    return nextElement;
  } // diff


  var nextType = nextElement.type,
      nextProps = nextElement.props;
  var lastType = lastElement.type,
      lastProps = lastElement.props,
      lastComponent = lastElement.component;

  if (nextType !== lastType) {
    destroyElement(lastElement);
    return nextElement;
  } // 保留component， 等下一阶段处理


  nextElement.component = lastComponent;

  if (Object(__WEBPACK_IMPORTED_MODULE_6__equal__["a" /* default */])(nextProps, lastProps) && lastComponent.context === parent.context) {
    return null;
  }

  return nextElement;
}

function diff(parent, nextChildren, lastChildren) {
  // destroy
  // 生命周期的几个阶段
  // should create / update
  // create / Receive props
  // willMount / willUpdate
  // render
  // didMount / didUpdate
  var childrenArray = []; // 1. 第一轮比较， 直接destroy的元素处理掉，destroy 的元素不需要进入下一阶段

  __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].compare(nextChildren, lastChildren, function (next, last) {
    var element = diffElement(parent, next, last);

    if (element) {
      childrenArray = childrenArray.concat(__WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].toArray(element).filter(Boolean));
    }
  }); // 2. 处理 shouldCreate 和 shouldUpdate

  var shouldProcessChildren = childrenArray.filter(function (element) {
    var component = element.component,
        props = element.props; // 说明是新增的元素，需要新建

    if (!component) return true; // 不需要更新

    if (component.shouldUpdate && component.shouldUpdate(props) === false) {
      return false;
    }

    return true;
  }); // 3. 处理 create 和 Receive props

  var shouldRenderComponent = shouldProcessChildren.map(function (element) {
    var component = element.component;

    if (!component) {
      component = createComponent(parent, element);
    } else {
      var props = element.props;

      if (component.willReceiveProps) {
        component.willReceiveProps(props, parent.context);
      }

      var zIndex = props.zIndex;
      component.container.set('zIndex', zIndex);
      component.props = props;
      component.context = parent.context;
    }

    element.component = component;
    setComponentAnimate(component, parent);
    return component;
  }); // 4. 处理 render

  renderComponent(shouldRenderComponent); // 按子组件顺序渲染内容

  childrenArray.forEach(function (element) {
    var component = element.component;
    var parentGroup = parent.container;
    parentGroup.add(component.container);
  });
  return nextChildren;
}

function isContainer(children) {
  if (!children) return false;

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(children)) {
    var type = children.type;
    return typeof type === 'function';
  }

  for (var i = 0, len = children.length; i < len; i++) {
    if (isContainer(children[i])) {
      return true;
    }
  }

  return false;
}

function renderChildren(parent, nextChildren, lastChildren) {
  // react 生成的 element 是 not extensible 的，这里新建一个新对象，并把需要的内容pick 出来
  nextChildren = pickElement(nextChildren);
  parent.children = nextChildren;

  if (isContainer(nextChildren)) {
    nextChildren = diff(parent, nextChildren, lastChildren);
  } else {
    renderShape(parent, nextChildren);
  }

  return nextChildren;
}



/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(733);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEMENT_APPEAR", function() { return ELEMENT_APPEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEMENT_UPDATE", function() { return ELEMENT_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEMENT_DELETE", function() { return ELEMENT_DELETE; });
var ELEMENT_APPEAR = 'appear'; // 标识元素更新

var ELEMENT_UPDATE = 'update'; // 标识是删除的元素

var ELEMENT_DELETE = 'delete';

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__d3_color_src__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rgb_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__array_js__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__number_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object_js__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string_js__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant_js__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__numberArray_js__ = __webpack_require__(186);










/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var t = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(b),
      c;

  return b == null || t === 'boolean' ? Object(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(b) : (t === 'number' ? __WEBPACK_IMPORTED_MODULE_5__number_js__["a" /* default */] : t === 'string' ? (c = Object(__WEBPACK_IMPORTED_MODULE_1__d3_color_src__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_2__rgb_js__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_7__string_js__["a" /* default */] : b instanceof __WEBPACK_IMPORTED_MODULE_1__d3_color_src__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_2__rgb_js__["a" /* default */] : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_4__date_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_9__numberArray_js__["b" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_9__numberArray_js__["a" /* default */] : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_3__array_js__["a" /* genericArray */] : typeof b.valueOf !== 'function' && typeof b.toString !== 'function' || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_6__object_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__number_js__["a" /* default */])(a, b);
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = timeFormat;
/* harmony export (immutable) */ __webpack_exports__["i"] = toTimeStamp;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return YEAR; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getTickInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fecha__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(779);




var FORMAT_METHOD = 'format';
function timeFormat(time, mask) {
    var method = __WEBPACK_IMPORTED_MODULE_1_fecha__[FORMAT_METHOD] || __WEBPACK_IMPORTED_MODULE_1_fecha__["default"][FORMAT_METHOD];
    return method(time, mask);
}
/**
 * 转换成时间戳
 * @param value 时间值
 */
function toTimeStamp(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["B" /* isString */])(value)) {
        if (value.indexOf('T') > 0) {
            value = new Date(value).getTime();
        }
        else {
            // new Date('2010/01/10') 和 new Date('2010-01-10') 的差别在于:
            // 如果仅有年月日时，前者是带有时区的: Fri Jan 10 2020 02:40:13 GMT+0800 (中国标准时间)
            // 后者会格式化成 Sun Jan 10 2010 08:00:00 GMT+0800 (中国标准时间)
            value = new Date(value.replace(/-/gi, '/')).getTime();
        }
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["t" /* isDate */])(value)) {
        value = value.getTime();
    }
    return value;
}
var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var MONTH = DAY * 31;
var YEAR = DAY * 365;

var intervals = [
    ['HH:mm:ss', SECOND],
    ['HH:mm:ss', SECOND * 10],
    ['HH:mm:ss', SECOND * 30],
    ['HH:mm', MINUTE],
    ['HH:mm', MINUTE * 10],
    ['HH:mm', MINUTE * 30],
    ['HH', HOUR],
    ['HH', HOUR * 6],
    ['HH', HOUR * 12],
    ['YYYY-MM-DD', DAY],
    ['YYYY-MM-DD', DAY * 4],
    ['YYYY-WW', DAY * 7],
    ['YYYY-MM', MONTH],
    ['YYYY-MM', MONTH * 4],
    ['YYYY-MM', MONTH * 6],
    ['YYYY', DAY * 380],
];
function getTickInterval(min, max, tickCount) {
    var target = (max - min) / tickCount;
    var idx = Object(__WEBPACK_IMPORTED_MODULE_2__bisector__["a" /* default */])(function (o) { return o[1]; })(intervals, target) - 1;
    var interval = intervals[idx];
    if (idx < 0) {
        interval = intervals[0];
    }
    else if (idx >= intervals.length) {
        interval = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(intervals);
    }
    return interval;
}
//# sourceMappingURL=time.js.map

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(124);



/**
 * 连续度量的基类
 * @class
 */
var Continuous = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Continuous, _super);
    function Continuous() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isContinuous = true;
        return _this;
    }
    Continuous.prototype.scale = function (value) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(value)) {
            return NaN;
        }
        var rangeMin = this.rangeMin();
        var rangeMax = this.rangeMax();
        var max = this.max;
        var min = this.min;
        if (max === min) {
            return rangeMin;
        }
        var percent = this.getScalePercent(value);
        return rangeMin + percent * (rangeMax - rangeMin);
    };
    Continuous.prototype.init = function () {
        _super.prototype.init.call(this);
        // init 完成后保证 min, max 包含 ticks 的范围
        var ticks = this.ticks;
        var firstTick = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["p" /* head */])(ticks);
        var lastTick = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["D" /* last */])(ticks);
        if (firstTick < this.min) {
            this.min = firstTick;
        }
        if (lastTick > this.max) {
            this.max = lastTick;
        }
        // strict-limit 方式
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(this.minLimit)) {
            this.min = firstTick;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(this.maxLimit)) {
            this.max = lastTick;
        }
    };
    Continuous.prototype.setDomain = function () {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["l" /* getRange */])(this.values), min = _a.min, max = _a.max;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(this.min)) {
            this.min = min;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(this.max)) {
            this.max = max;
        }
        if (this.min > this.max) {
            this.min = min;
            this.max = max;
        }
    };
    Continuous.prototype.calculateTicks = function () {
        var _this = this;
        var ticks = _super.prototype.calculateTicks.call(this);
        if (!this.nice) {
            ticks = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["f" /* filter */])(ticks, function (tick) {
                return tick >= _this.min && tick <= _this.max;
            });
        }
        return ticks;
    };
    // 计算原始值值占的百分比
    Continuous.prototype.getScalePercent = function (value) {
        var max = this.max;
        var min = this.min;
        return (value - min) / (max - min);
    };
    Continuous.prototype.getInvertPercent = function (value) {
        return (value - this.rangeMin()) / (this.rangeMax() - this.rangeMin());
    };
    return Continuous;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Continuous);
//# sourceMappingURL=base.js.map

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calBase;
/* harmony export (immutable) */ __webpack_exports__["c"] = log;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLogPositiveMin;
/* unused harmony export precisionAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);

// 求以a为次幂，结果为b的基数，如 x^^a = b;求x
// 虽然数学上 b 不支持负数，但是这里需要支持 负数
function calBase(a, b) {
    var e = Math.E;
    var value;
    if (b >= 0) {
        value = Math.pow(e, Math.log(b) / a); // 使用换底公式求底
    }
    else {
        value = Math.pow(e, Math.log(-b) / a) * -1; // 使用换底公式求底
    }
    return value;
}
function log(a, b) {
    if (a === 1) {
        return 1;
    }
    return Math.log(b) / Math.log(a);
}
function getLogPositiveMin(values, base, max) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(max)) {
        max = Math.max.apply(null, values);
    }
    var positiveMin = max;
    Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["e" /* each */])(values, function (value) {
        if (value > 0 && value < positiveMin) {
            positiveMin = value;
        }
    });
    if (positiveMin === max) {
        positiveMin = max / base;
    }
    if (positiveMin > 1) {
        positiveMin = 1;
    }
    return positiveMin;
}
function digitLength(num) {
    // Get digit length of e
    var eSplit = num.toString().split(/[eE]/);
    var len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
    return len > 0 ? len : 0;
}
/**
 * 高精度加法，解决 0.1 + 0.2 !== 0.3 的经典问题
 *
 * @param num1 加数
 * @param num2 被加数
 * @return {number} 返回值
 */
function precisionAdd(num1, num2) {
    var num1Digits = digitLength(num1);
    var num2Digits = digitLength(num2);
    var baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
}
//# sourceMappingURL=math.js.map

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selection__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__antv_adjust__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_index__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__controller_attr__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__base_equal__ = __webpack_require__(82);










var _excluded = ["field"];





 // 保留原始数据的字段

var FIELD_ORIGIN = 'origin';

var Geometry = /*#__PURE__*/function (_Selection) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Geometry, _Selection);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Geometry);

  function Geometry(props, context) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Geometry);

    _this = _super.call(this, props, context);
    _this.isGeometry = true; // x 轴居中

    _this.justifyContent = false; // y 轴是否从0开始

    _this.startOnZero = false; // 是否连接空值

    _this.connectNulls = false; // 是否需要排序

    _this.sortable = false;
    Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["G" /* mix */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), _this.getDefaultCfg());
    var chart = props.chart,
        coord = props.coord;

    var attrsRange = _this._getThemeAttrsRange();

    _this.attrController = new __WEBPACK_IMPORTED_MODULE_14__controller_attr__["a" /* default */](chart.scale, attrsRange);

    var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
        attrController = _assertThisInitialize.attrController,
        justifyContent = _assertThisInitialize.justifyContent;

    var attrOptions = attrController.getAttrOptions(props, !coord.isCyclic() || justifyContent);
    attrController.create(attrOptions);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Geometry, [{
    key: "getDefaultCfg",
    value: function getDefaultCfg() {
      return {};
    }
  }, {
    key: "willReceiveProps",
    value: function willReceiveProps(nextProps) {
      Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Geometry.prototype), "willReceiveProps", this).call(this, nextProps);

      var lastProps = this.props,
          attrController = this.attrController,
          justifyContent = this.justifyContent;
      var nextData = nextProps.data,
          nextAdjust = nextProps.adjust,
          nextZoomRange = nextProps.zoomRange,
          coord = nextProps.coord;
      var lastData = lastProps.data,
          lastAdjust = lastProps.adjust,
          lastZoomRange = lastProps.zoomRange;
      var justifyContentCenter = !coord.isCyclic() || justifyContent;
      var nextAttrOptions = attrController.getAttrOptions(nextProps, justifyContentCenter);
      var lastAttrOptions = attrController.getAttrOptions(lastProps, justifyContentCenter);

      if (!Object(__WEBPACK_IMPORTED_MODULE_15__base_equal__["a" /* default */])(nextAttrOptions, lastAttrOptions)) {
        attrController.update(nextAttrOptions);
        this.records = null;
      } // 重新处理数据


      if (nextData !== lastData) {
        this.records = null;
      } // 重新处理数据


      if (nextAdjust !== lastAdjust) {
        this.records = null;
      } // zoomRange发生变化,records也需要重新计算


      if (!Object(__WEBPACK_IMPORTED_MODULE_15__base_equal__["a" /* default */])(nextZoomRange, lastZoomRange)) {
        this.records = null;
      }
    }
  }, {
    key: "willMount",
    value: function willMount() {
      this._createAttrs();

      if (!this.records) {
        this._processData();
      }
    }
  }, {
    key: "willUpdate",
    value: function willUpdate() {
      this._createAttrs();

      if (!this.records) {
        this._processData();
      }
    }
  }, {
    key: "didMount",
    value: function didMount() {
      Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Geometry.prototype), "didMount", this).call(this);

      this._initEvent();
    }
  }, {
    key: "_createAttrs",
    value: function _createAttrs() {
      var attrController = this.attrController;
      attrController.attrs = {};
      this.attrs = attrController.getAttrs();
    }
  }, {
    key: "_getThemeAttrsRange",
    value: function _getThemeAttrsRange() {
      var context = this.context,
          props = this.props,
          geomType = this.geomType;
      var coord = props.coord;
      var theme = context.theme;
      var colors = theme.colors,
          sizes = theme.sizes,
          shapes = theme.shapes;
      return {
        x: coord.x,
        y: coord.y,
        color: colors,
        size: sizes,
        shape: shapes[geomType]
      };
    }
  }, {
    key: "_adjustScales",
    value: function _adjustScales() {
      var attrs = this.attrs,
          props = this.props,
          defaultStartOnZero = this.startOnZero;
      var chart = props.chart,
          _props$startOnZero = props.startOnZero,
          startOnZero = _props$startOnZero === void 0 ? defaultStartOnZero : _props$startOnZero,
          coord = props.coord,
          adjust = props.adjust;
      var isPolar = coord.isPolar,
          transposed = coord.transposed;
      var y = attrs.y;
      var yField = y.field; // 如果从 0 开始，只调整 y 轴 scale

      if (startOnZero) {
        var _y = attrs.y;
        chart.scale.adjustStartZero(_y.scale);
      } // 饼图的scale调整，关闭nice


      if (isPolar && transposed && (adjust === 'stack' || (adjust === null || adjust === void 0 ? void 0 : adjust.type) === 'stack')) {
        var _y2 = attrs.y;
        chart.scale.adjustPieScale(_y2.scale);
      }

      if (adjust === 'stack' || (adjust === null || adjust === void 0 ? void 0 : adjust.type) === 'stack') {
        this._updateStackRange(yField, y.scale, this.dataArray);
      }
    }
  }, {
    key: "_groupData",
    value: function _groupData(data) {
      var attrController = this.attrController;
      var groupScales = attrController.getGroupScales();

      if (!groupScales.length) {
        return [{
          children: data
        }];
      }

      var names = [];
      groupScales.forEach(function (scale) {
        var field = scale.field;
        names.push(field);
      });
      var groups = Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["o" /* groupToMap */])(data, names);
      var records = [];

      for (var key in groups) {
        records.push({
          key: key.replace(/^_/, ''),
          children: groups[key]
        });
      }

      return records;
    }
  }, {
    key: "_saveOrigin",
    value: function _saveOrigin(originData) {
      var len = originData.length;
      var data = new Array(len);

      for (var i = 0; i < len; i++) {
        var record = originData[i];
        data[i] = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, record), {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, FIELD_ORIGIN, record));
      }

      return data;
    }
  }, {
    key: "_numberic",
    value: function _numberic(data) {
      var attrs = this.attrs;
      var scales = [attrs.x.scale, attrs.y.scale];

      for (var j = 0, len = data.length; j < len; j++) {
        var obj = data[j];
        var count = scales.length;

        for (var i = 0; i < count; i++) {
          var scale = scales[i];

          if (scale.isCategory) {
            var field = scale.field;
            obj[field] = scale.translate(obj[field]);
          }
        }
      }
    }
  }, {
    key: "_adjustData",
    value: function _adjustData(records) {
      var attrs = this.attrs,
          props = this.props;
      var adjust = props.adjust; // groupedArray 是二维数组

      var groupedArray = records.map(function (record) {
        return record.children;
      });

      if (!adjust) {
        return groupedArray;
      }

      var adjustCfg = typeof adjust === 'string' ? {
        type: adjust
      } : adjust;
      var adjustType = Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["L" /* upperFirst */])(adjustCfg.type);
      var AdjustConstructor = Object(__WEBPACK_IMPORTED_MODULE_12__antv_adjust__["getAdjust"])(adjustType);

      if (!AdjustConstructor) {
        throw new Error('not support such adjust : ' + adjust);
      }

      if (adjustType === 'Dodge') {
        for (var i = 0, len = groupedArray.length; i < len; i++) {
          // 如果是dodge, 需要处理数字再处理
          this._numberic(groupedArray[i]);
        }

        adjustCfg.adjustNames = ['x'];
      }

      var x = attrs.x,
          y = attrs.y;
      adjustCfg.xField = x.field;
      adjustCfg.yField = y.field;
      var adjustInstance = new AdjustConstructor(adjustCfg);
      var adjustData = adjustInstance.process(groupedArray);
      this.adjust = {
        type: adjustCfg.type,
        adjust: adjustInstance
      }; // process 返回的是新数组，所以要修改 records

      records.forEach(function (record, index) {
        record.children = adjustData[index];
      });
      return adjustData;
    }
  }, {
    key: "_updateStackRange",
    value: function _updateStackRange(field, scale, dataArray) {
      var flattenArray = Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["j" /* flatten */])(dataArray);
      var min = Infinity;
      var max = -Infinity;

      for (var i = 0, len = flattenArray.length; i < len; i++) {
        var obj = flattenArray[i];
        var tmpMin = Math.min.apply(null, obj[field]);
        var tmpMax = Math.max.apply(null, obj[field]);

        if (tmpMin < min) {
          min = tmpMin;
        }

        if (tmpMax > max) {
          max = tmpMax;
        }
      }

      if (min !== scale.min || max !== scale.max) {
        scale.change({
          min: min,
          max: max
        });
      }
    }
  }, {
    key: "_processData",
    value: function _processData() {
      var props = this.props;
      var originData = props.data;

      var data = this._saveOrigin(originData); // 根据分类度量进行数据分组


      var records = this._groupData(data); // 根据adjust分组


      var dataArray = this._adjustData(records);

      this.dataArray = dataArray; // scale适配调整，主要是调整 y 轴是否从 0 开始 以及 饼图

      this._adjustScales(); // 数据排序（非必须）


      if (this.sortable) {
        this._sortData(records);
      }

      this.records = records;
    }
  }, {
    key: "_sortData",
    value: function _sortData(records) {
      var xScale = this.getXScale();
      var field = xScale.field,
          type = xScale.type;

      if (type !== 'identity' && xScale.values.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["e" /* each */])(records, function (_ref) {
          var children = _ref.children;
          children.sort(function (record1, record2) {
            if (type === 'timeCat') {
              return Object(__WEBPACK_IMPORTED_MODULE_13__util_index__["f" /* toTimeStamp */])(record1[FIELD_ORIGIN][field]) - Object(__WEBPACK_IMPORTED_MODULE_13__util_index__["f" /* toTimeStamp */])(record2[FIELD_ORIGIN][field]);
            }

            return xScale.translate(record1[FIELD_ORIGIN][field]) - xScale.translate(record2[FIELD_ORIGIN][field]);
          });
        });
      }
    }
  }, {
    key: "_initEvent",
    value: function _initEvent() {
      var _this2 = this;

      var container = this.container,
          props = this.props;
      var canvas = container.get('canvas');
      ['onPressStart', 'onPress', 'onPressEnd', 'onPan', 'onPanStart', 'onPanEnd'].forEach(function (eventName) {
        if (props[eventName]) {
          canvas.on(eventName.substr(2).toLowerCase(), function (ev) {
            ev.geometry = _this2;
            props[eventName](ev);
          });
        }
      });
    }
  }, {
    key: "getY0Value",
    value: function getY0Value() {
      var attrs = this.attrs,
          props = this.props;
      var chart = props.chart;
      var field = attrs.y.field;
      var scale = chart.getScale(field);
      return chart.scale.getZeroValue(scale);
    } // 根据各属性映射的值域来获取真正的绘图属性

  }, {
    key: "_getShapeStyle",
    value: function _getShapeStyle(shape, origin) {
      var context = this.context,
          props = this.props,
          geomType = this.geomType;
      var theme = context.theme;
      var shapeTheme = theme.shape[geomType] || {};
      var defaultShapeStyle = shapeTheme.default;
      var shapeThemeStyle = shapeTheme[shape];
      var style = props.style;

      var shapeStyle = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultShapeStyle), shapeThemeStyle);

      if (!style || !Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["z" /* isObject */])(style)) {
        return shapeStyle;
      } // @ts-ignore


      var field = style.field,
          styles = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(style, _excluded);

      var value = field ? origin[field] : origin;
      Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["e" /* each */])(styles, function (attr, key) {
        if (Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["v" /* isFunction */])(attr)) {
          shapeStyle[key] = attr(value);
        } else {
          shapeStyle[key] = attr;
        }
      });
      return shapeStyle;
    }
    /**
     * 数据映射到视图属性核心逻辑
     * x、y 每个元素走 normalize 然后 convertPoint
     * color、size、shape
     *  如果是Linear，则每个元素 走 mapping
     *  如果是Category/Identity 则第一个元素走 mapping
     */

  }, {
    key: "_mapping",
    value: function _mapping(records) {
      var attrs = this.attrs,
          props = this.props,
          attrController = this.attrController;
      var coord = props.coord;

      var _attrController$getAt = attrController.getAttrsByLinear(),
          linearAttrs = _attrController$getAt.linearAttrs,
          nonlinearAttrs = _attrController$getAt.nonlinearAttrs;

      var defaultAttrValues = attrController.getDefaultAttrValues();

      for (var i = 0, len = records.length; i < len; i++) {
        var record = records[i];
        var children = record.children;

        var attrValues = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultAttrValues);

        var firstChild = children[0];

        if (children.length === 0) {
          continue;
        } // 非线性映射


        for (var k = 0, _len = nonlinearAttrs.length; k < _len; k++) {
          var attrName = nonlinearAttrs[k];
          var attr = attrs[attrName]; // 非线性映射只用映射第一项就可以了

          attrValues[attrName] = attr.mapping(firstChild[attr.field]);
        } // 线性属性映射


        for (var j = 0, childrenLen = children.length; j < childrenLen; j++) {
          var child = children[j];
          var normalized = {};

          for (var _k = 0; _k < linearAttrs.length; _k++) {
            var _attrName = linearAttrs[_k];
            var _attr = attrs[_attrName]; // 分类属性的线性映射

            if (attrController.isGroupAttr(_attrName)) {
              attrValues[_attrName] = _attr.mapping(child[_attr.field], child);
            } else {
              normalized[_attrName] = _attr.normalize(child[_attr.field]);
            }
          }

          var _coord$convertPoint = coord.convertPoint({
            x: normalized.x,
            y: normalized.y
          }),
              x = _coord$convertPoint.x,
              y = _coord$convertPoint.y; // 获取 shape 的 style


          var shapeName = attrValues.shape;

          var shape = this._getShapeStyle(shapeName, child.origin);

          var selected = this.isSelected(child);
          Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["G" /* mix */])(child, attrValues, {
            normalized: normalized,
            x: x,
            y: y,
            shapeName: shapeName,
            shape: shape,
            selected: selected
          });
        }
      }

      return records;
    } // 数据映射

  }, {
    key: "mapping",
    value: function mapping() {
      var records = this.records; // 数据映射

      this._mapping(records);

      return records;
    }
  }, {
    key: "getClip",
    value: function getClip() {
      var _this$props = this.props,
          coord = _this$props.coord,
          viewClip = _this$props.viewClip;
      var contentWidth = coord.width,
          contentHeight = coord.height,
          left = coord.left,
          top = coord.top;

      if (viewClip) {
        return {
          type: 'rect',
          attrs: {
            x: left,
            y: top,
            width: contentWidth,
            height: contentHeight
          }
        };
      }

      return null;
    }
  }, {
    key: "getAttr",
    value: function getAttr(attrName) {
      return this.attrController.getAttr(attrName);
    }
  }, {
    key: "getXScale",
    value: function getXScale() {
      return this.getAttr('x').scale;
    }
  }, {
    key: "getYScale",
    value: function getYScale() {
      return this.getAttr('y').scale;
    }
  }, {
    key: "_getXSnap",
    value: function _getXSnap(invertPointX) {
      var xScale = this.getXScale();

      if (xScale.isCategory) {
        return xScale.invert(invertPointX);
      } // linear 类型


      var invertValue = xScale.invert(invertPointX);
      var values = xScale.values;
      var len = values.length; // 如果只有1个点直接返回第1个点

      if (len === 1) {
        return values[0];
      } // 第1个点和第2个点之间


      if ((values[0] + values[1]) / 2 > invertValue) {
        return values[0];
      } // 最后2个点


      if ((values[len - 2] + values[len - 1]) / 2 <= invertValue) {
        return values[len - 1];
      }

      for (var i = 1; i < len; i++) {
        // 中间的点
        if ((values[i - 1] + values[i]) / 2 <= invertValue && (values[i + 1] + values[i]) / 2 > invertValue) {
          return values[i];
        }
      }

      return null;
    }
  }, {
    key: "_getYSnapRecords",
    value: function _getYSnapRecords(invertPointY, records) {
      var yScale = this.getYScale();
      var yField = yScale.field;
      var yValue = yScale.invert(invertPointY); // category

      if (yScale.isCategory) {
        return records.filter(function (record) {
          return record[FIELD_ORIGIN][yField] === yValue;
        });
      } // linear


      return records.filter(function (record) {
        var rangeY = record[yField];

        if (rangeY[0] <= yValue && rangeY[1] >= yValue) {
          return true;
        }

        return false;
      });
    } // 把 records 拍平

  }, {
    key: "flatRecords",
    value: function flatRecords() {
      var records = this.records;
      return records.reduce(function (prevRecords, record) {
        return prevRecords.concat(record.children);
      }, []);
    }
  }, {
    key: "getSnapRecords",
    value: function getSnapRecords(point, inCoordRange) {
      var props = this.props;
      var coord = props.coord,
          adjust = props.adjust;
      var invertPoint = coord.invertPoint(point);
      var xScale = this.getXScale();
      var yScale = this.getYScale(); // 如果不在coord坐标范围内，直接返回空
      // if (invertPoint.x < 0 || invertPoint.y < 0) {
      //   return [];
      // }
      // 是否调整 point，默认为不调整

      if (inCoordRange) {
        var xRange = xScale.range;
        var yRange = yScale.range; // 如果 inCoordRange=true，当 point 不在 coord 坐标范围内时，调整到 range 内

        invertPoint.x = Math.min(Math.max(invertPoint.x, xRange[0]), xRange[1]);
        invertPoint.y = Math.min(Math.max(invertPoint.y, yRange[0]), yRange[1]);
      }

      var records = this.flatRecords(); // 处理饼图

      if (adjust === 'stack' && coord.isPolar && coord.transposed) {
        // 弧度在半径范围内
        if (invertPoint.x >= 0 && invertPoint.x <= 1) {
          var snapRecords = this._getYSnapRecords(invertPoint.y, records);

          return snapRecords;
        }
      }

      var rst = [];

      var value = this._getXSnap(invertPoint.x);

      if (!value) {
        return rst;
      }

      var xField = xScale.field;
      var yField = yScale.field;

      for (var i = 0, len = records.length; i < len; i++) {
        var record = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, records[i]), {}, {
          xField: xField,
          yField: yField
        });

        var originValue = record[FIELD_ORIGIN][xField];

        if (xScale.type === 'timeCat' && Object(__WEBPACK_IMPORTED_MODULE_13__util_index__["f" /* toTimeStamp */])(originValue) === value) {
          rst.push(record);
        } else if (originValue === value) {
          rst.push(record);
        }
      }

      return rst;
    }
  }, {
    key: "getLegendItems",
    value: function getLegendItems() {
      var attrController = this.attrController;
      var colorAttr = attrController.getAttr('color');
      if (!colorAttr) return null;
      var scale = colorAttr.scale;
      if (!scale.isCategory) return null;
      var ticks = scale.getTicks();
      var items = ticks.map(function (tick) {
        var text = tick.text,
            tickValue = tick.tickValue;
        var color = colorAttr.mapping(tickValue);
        return {
          field: scale.field,
          color: color,
          name: text,
          tickValue: tickValue
        };
      });
      return items;
    }
  }]);

  return Geometry;
}(__WEBPACK_IMPORTED_MODULE_11__selection__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Geometry);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);




var Base = /*#__PURE__*/function () {
  function Base(options) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Base);

    Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["G" /* mix */])(this, options);
    var scale = this.scale,
        field = this.field,
        data = this.data;

    if (!scale && data) {
      var values = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["M" /* valuesOfKey */])(data, field);
      this.scale = this.createScale({
        values: values,
        field: field
      });
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Base, [{
    key: "createScale",
    value: function createScale(_scaleConfig) {
      return null;
    } // 数据映射方法

  }, {
    key: "_mapping",
    value: function _mapping(value) {
      return value;
    }
  }, {
    key: "update",
    value: function update(options) {
      Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["G" /* mix */])(this, options);
    }
  }, {
    key: "setRange",
    value: function setRange(range) {
      this.range = range;
    } // 归一化，参数是原始数据，返回是归一化的数据

  }, {
    key: "normalize",
    value: function normalize(value) {
      var scale = this.scale;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["r" /* isArray */])(value)) {
        return value.map(function (v) {
          return scale.scale(v);
        });
      }

      return scale.scale(value);
    } // convert 参数是归一化的数据，返回定义域的值

  }, {
    key: "convert",
    value: function convert(value) {
      return value;
    } // 等于 normalize + convert， 参数是原始数据，返回是定义域的值

  }, {
    key: "mapping",
    value: function mapping(value) {
      var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rst = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["v" /* isFunction */])(this.callback) ? this.callback(value, child) : null;

      if (!Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["w" /* isNil */])(rst)) {
        return rst;
      }

      return this._mapping(value);
    }
  }]);

  return Base;
}();

/* harmony default export */ __webpack_exports__["a"] = (Base);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
var document = __webpack_require__(52).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(74);
var toLength = __webpack_require__(68);
var toAbsoluteIndex = __webpack_require__(128);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(85);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(197)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(132);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(52).document;
module.exports = document && document.documentElement;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(85);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(127)('keys');
var uid = __webpack_require__(111);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(64);
var cof = __webpack_require__(85);
var MATCH = __webpack_require__(49)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(30);
var toLength = __webpack_require__(68);
var context = __webpack_require__(164);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(165)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(162);
var defined = __webpack_require__(93);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(49)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(30);
var core = __webpack_require__(90);
var fails = __webpack_require__(55);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(54);
var sameValue = __webpack_require__(346);
var regExpExec = __webpack_require__(129);

// @@search logic
__webpack_require__(131)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineModal=/*#__PURE__*/function(_React$Component){_inherits(PipelineModal,_React$Component);var _super=_createSuper(PipelineModal);function PipelineModal(props){var _this;_classCallCheck(this,PipelineModal);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){_this.setVisible(false);__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:'^legoDialog:button:'+index,pageOptions:_this.pageOptions}});if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){return;}var options={link:item.link,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);_this.setVisible(false);});_defineProperty(_assertThisInitialized(_this),"handleImgClick",function(imgLink){__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:'^legoDialog:image',pageOptions:_this.pageOptions}});if(!imgLink){return;}_this.setVisible(false);if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].handleToufangClick({link:imgLink,props:_this.props});return;}var options={link:imgLink};var convertUrl=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].convertHref(imgLink);__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,imgLink,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"setVisible",function(visible){var _this$props=_this.props,customAttributes=_this$props.customAttributes,config=_this$props.config,triggerId=_this$props.triggerId;var _config$baseConfig=config.baseConfig,popTimes=_config$baseConfig.popTimes,triggerType=_config$baseConfig.triggerType;if(visible&&popTimes!=''){var key=customAttributes['data-component-id'];if(triggerType==='点击后唤起'){key="".concat(triggerId,"_").concat(key);}var times=+(window.localStorage.getItem(key)||0);if(times>=popTimes){return;}localStorage.setItem(key,"".concat(times+1));}if(triggerType==='点击后唤起'){if(!visible){_this.props.onClose&&_this.props.onClose();}}else{_this.setState({visible:visible},function(){if(!visible){_this.props.onClose&&_this.props.onClose();}});}if(visible){__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:'^legoDialog:show',pageOptions:_this.pageOptions}});}});_defineProperty(_assertThisInitialized(_this),"handleClose",function(){_this.setVisible(false);__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:'^legoDialog:close',pageOptions:_this.pageOptions}});});_this.state={visible:false};if(typeof window!=='undefined'){var pathArr=window.location.pathname.split('/');var legoPageId=+pathArr[pathArr.length-2];_this.pageOptions={id:props['customAttributes']['data-component-id'],legoPageId:legoPageId,legoPageTitle:document.title};}return _this;}_createClass(PipelineModal,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.visible){this.setVisible(true);}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.visible!==nextProps.visible){this.setVisible(nextProps.visible);}}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,_this$props$config$bu=_this$props$config.buttonList,buttonList=_this$props$config$bu===void 0?[]:_this$props$config$bu;var img=baseConfig.img,imgLink=baseConfig.imgLink,triggerType=baseConfig.triggerType;var _ref=triggerType==='点击后唤起'?this.props:this.state,visible=_ref.visible;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({className:visible?"pipeline-modal show":"pipeline-modal"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:visible?"modal-content show":"modal-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:"modal-img",alt:"",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(img,this.props.webpSupport),onClick:this.handleImgClick.bind(this,imgLink)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"bottom-btns"},buttonList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{key:"btn_".concat(index),className:"btn-item",onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{alt:"",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(item.btnImg,_this2.props.webpSupport),style:{width:item.height?'auto':'100%',height:item.height?Object(__WEBPACK_IMPORTED_MODULE_19__utils_px2rem__["a" /* default */])("".concat(item.height,"px")):'auto'}}));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"close",onClick:this.handleClose})));}}]);return PipelineModal;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineModal.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineModal);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["anchor-link"] = factory(require("react"));
	else
		root["anchor-link"] = factory(root["react"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _anchorLink = __webpack_require__(1);

var _anchorLink2 = _interopRequireDefault(_anchorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _anchorLink2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnchorLink = function (_Component) {
  _inherits(AnchorLink, _Component);

  function AnchorLink(props) {
    _classCallCheck(this, AnchorLink);

    var _this = _possibleConstructorReturn(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).call(this, props));

    _this.smoothScroll = _this.smoothScroll.bind(_this);
    return _this;
  }

  _createClass(AnchorLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __webpack_require__(3).polyfill();
    }
  }, {
    key: 'smoothScroll',
    value: function smoothScroll(e) {
      var _this2 = this;

      e.preventDefault();
      var offset = function offset() {
        return 0;
      };
      if (typeof this.props.offset !== 'undefined') {
        if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
          offset = this.props.offset;
        } else {
          offset = function offset() {
            return parseInt(_this2.props.offset);
          };
        }
      }
      var id = e.currentTarget.getAttribute('href').slice(1);
      var $anchor = document.getElementById(id);
      var offsetTop = $anchor.getBoundingClientRect().top + window.pageYOffset;
      window.scroll({
        top: offsetTop - offset(),
        behavior: 'smooth'
      });
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          offset = _props.offset,
          rest = _objectWithoutProperties(_props, ['offset']);

      return _react2.default.createElement('a', _extends({}, rest, { onClick: this.smoothScroll }));
    }
  }]);

  return AnchorLink;
}(_react.Component);

exports.default = AnchorLink;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.0 - 2018 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ })
/******/ ]);
});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(409);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(427),
    Draggable = _require.default,
    DraggableCore = _require.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266


module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = DraggableCore;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTranslation = getTranslation;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(137);

var _getPrefix = _interopRequireWildcard(__webpack_require__(429));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var matchesSelectorFunc = '';

function matchesSelector(el
/*: Node*/
, selector
/*: string*/
)
/*: boolean*/
{
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  } // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable


  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable

  return el[matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.


function matchesSelectorAndParentsTo(el
/*: Node*/
, selector
/*: string*/
, baseNode
/*: Node*/
)
/*: boolean*/
{
  var node = el;

  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el
/*: ?Node*/
, event
/*: string*/
, handler
/*: Function*/
, inputOptions
/*: Object*/
)
/*: void*/
{
  if (!el) return;

  var options = _objectSpread({
    capture: true
  }, inputOptions); // $FlowIgnore[method-unbinding]


  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}

function innerHeight(node
/*: HTMLElement*/
)
/*: number*/
{
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node
/*: HTMLElement*/
)
/*: number*/
{
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/


// Get from offsetParent
function offsetXYFromParent(evt
/*: EventWithOffset*/
, offsetParent
/*: HTMLElement*/
, scale
/*: number*/
)
/*: ControlPosition*/
{
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();
  var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
  return {
    x: x,
    y: y
  };
}

function createCSSTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: Object*/
{
  var translation = getTranslation(controlPos, positionOffset, 'px');
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default), translation);
}

function createSVGTransform(controlPos
/*: ControlPosition*/
, positionOffset
/*: PositionOffsetControlPosition*/
)
/*: string*/
{
  var translation = getTranslation(controlPos, positionOffset, '');
  return translation;
}

function getTranslation(_ref2, positionOffset
/*: PositionOffsetControlPosition*/
, unitSuffix
/*: string*/
)
/*: string*/
{
  var x = _ref2.x,
      y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");

  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }

  return translation;
}

function getTouch(e
/*: MouseTouchEvent*/
, identifier
/*: number*/
)
/*: ?{clientX: number, clientY: number}*/
{
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e
/*: MouseTouchEvent*/
)
/*: ?number*/
{
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed


function addUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');

  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }

  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc
/*: ?Document*/
) {
  if (!doc) return;

  try {
    if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection'); // $FlowIgnore: IE

    if (doc.selection) {
      // $FlowIgnore: IE
      doc.selection.empty();
    } else {
      // Remove selection caused by scroll, unless it's a focused input
      // (we use doc.defaultView in case we're in an iframe)
      var selection = (doc.defaultView || window).getSelection();

      if (selection && selection.type !== 'Caret') {
        selection.removeAllRanges();
      }
    }
  } catch (e) {// probably IE
  }
}

function addClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}

function removeClassName(el
/*: HTMLElement*/
, className
/*: string*/
) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
  }
}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

var contains = function (arr, value) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(arr)) {
        return false;
    }
    return arr.indexOf(value) > -1;
};
/* harmony default export */ __webpack_exports__["a"] = (contains);
//# sourceMappingURL=contains.js.map

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isObjectLike = function (value) {
    /**
     * isObjectLike({}) => true
     * isObjectLike([1, 2, 3]) => true
     * isObjectLike(Function) => false
     * isObjectLike(null) => false
     */
    return typeof value === 'object' && value !== null;
};
/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);
//# sourceMappingURL=is-object-like.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__each__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


// @ts-ignore
var values = Object.values ? function (obj) { return Object.values(obj); } : function (obj) {
    var result = [];
    Object(__WEBPACK_IMPORTED_MODULE_0__each__["a" /* default */])(obj, function (value, key) {
        if (!(Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(obj) && key === 'prototype')) {
            result.push(value);
        }
    });
    return result;
};
/* harmony default export */ __webpack_exports__["a"] = (values);
//# sourceMappingURL=values.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mix;
// FIXME: Mutable param should be forbidden in static lang.
function _mix(dist, obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && key !== 'constructor' && obj[key] !== undefined) {
            dist[key] = obj[key];
        }
    }
}
function mix(dist, src1, src2, src3) {
    if (src1)
        _mix(dist, src1);
    if (src2)
        _mix(dist, src2);
    if (src3)
        _mix(dist, src3);
    return dist;
}
//# sourceMappingURL=mix.js.map

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export isWx */
/* unused harmony export isMy */
/* unused harmony export isNode */
/* unused harmony export isBrowser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCanvasElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPixelRatio; });
/* unused harmony export getStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDomById; });
/* unused harmony export getRelativePosition */
/* unused harmony export addEventListener */
/* unused harmony export removeEventListener */
/* unused harmony export createEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return measureText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);


/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */

var supportsEventListenerOptions = function () {
  var supports = false;

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        supports = true;
      }
    });
    window.addEventListener('e', null, options);
  } catch (e) {// continue regardless of error
  }

  return supports;
}(); // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287


var eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;
/* global wx, my */
// weixin miniprogram
// @ts-ignore

var isWx = (typeof wx === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(wx)) === 'object' && typeof wx.getSystemInfoSync === 'function'; // ant miniprogram
// @ts-ignore

var isMy = (typeof my === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(my)) === 'object' && typeof my.getSystemInfoSync === 'function'; // in node
// @ts-ignore

var isNode = (typeof global === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(global)) && !(typeof window === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(window)); // in browser

var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.sessionStorage !== 'undefined';

function isCanvasElement(el) {
  if (!el || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(el) !== 'object') return false;

  if (el.nodeType === 1 && el.nodeName) {
    // HTMLCanvasElement
    return true;
  } // CanvasElement


  return !!el.isCanvasElement;
}

function getPixelRatio() {
  return window && window.devicePixelRatio || 1;
}

function getStyle(el, property) {
  return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
}

function getWidth(el) {
  var width = getStyle(el, 'width');

  if (width === 'auto') {
    width = el.offsetWidth;
  }

  return parseFloat(width);
}

function getHeight(el) {
  var height = getStyle(el, 'height');

  if (height === 'auto') {
    height = el.offsetHeight;
  }

  return parseFloat(height);
}

function getDomById(id) {
  if (!id) {
    return null;
  }

  return document.getElementById(id);
}

function getRelativePosition(point, canvas) {
  var canvasDom = canvas.get('el');
  if (!canvasDom) return point;

  var _canvasDom$getBoundin = canvasDom.getBoundingClientRect(),
      top = _canvasDom$getBoundin.top,
      left = _canvasDom$getBoundin.left;

  var paddingLeft = parseFloat(getStyle(canvasDom, 'padding-left'));
  var paddingTop = parseFloat(getStyle(canvasDom, 'padding-top'));
  var mouseX = point.x - left - paddingLeft;
  var mouseY = point.y - top - paddingTop;
  return {
    x: mouseX,
    y: mouseY
  };
}

function addEventListener(source, type, listener) {
  source.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(source, type, listener) {
  source.removeEventListener(type, listener, eventListenerOptions);
}

function landscapePoint(point, canvas) {
  var landscape = canvas.get('landscape');

  if (!landscape) {
    return point;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["v" /* isFunction */])(landscape)) {
    return landscape(point, canvas);
  } // 默认顺时针旋转90度


  var height = canvas.get('height');
  var x = point.y;
  var y = height - point.x;
  return {
    x: x,
    y: y
  };
}

function convertPoints(ev, canvas) {
  var touches = ev.touches; // 认为是mouse事件

  if (!touches) {
    var point = getRelativePosition({
      x: ev.clientX,
      y: ev.clientY
    }, canvas);
    return [landscapePoint(point, canvas)];
  } // 单指 touchend 后，touchs 会变空，最后的触点要从changedTouches里拿


  if (!touches.length) {
    // 为了防止万一，加个空逻辑
    touches = ev.changedTouches || [];
  }

  var points = [];

  for (var i = 0, len = touches.length; i < len; i++) {
    var touch = touches[i]; // x, y: 相对canvas原点的位置，clientX, clientY 相对于可视窗口的位置

    var x = touch.x,
        y = touch.y,
        clientX = touch.clientX,
        clientY = touch.clientY;

    var _point = void 0; // 小程序环境会有x,y


    if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(x) || Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(y)) {
      _point = {
        x: x,
        y: y
      };
    } else {
      // 浏览器环境再计算下canvas的相对位置
      _point = getRelativePosition({
        x: clientX,
        y: clientY
      }, canvas);
    }

    points.push(landscapePoint(_point, canvas));
  }

  return points;
}

function createEvent(event, chart) {
  var canvas = chart.get('canvas');
  var points = convertPoints(event, canvas); // touchend会没有points

  var point = points[0] || {};
  return {
    type: event.type,
    chart: chart,
    native: event,
    x: point.x,
    y: point.y
  };
}

function measureText(text, font, ctx) {
  if (!ctx) {
    ctx = document.createElement('canvas').getContext('2d');
  }

  ctx.font = font || '12px sans-serif';
  return ctx.measureText(text);
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(173)))

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_util__ = __webpack_require__(14);









function parsePadding(padding) {
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["x" /* isNumber */])(padding)) {
    top = bottom = left = right = padding;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["r" /* isArray */])(padding)) {
    top = padding[0];
    right = !Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["w" /* isNil */])(padding[1]) ? padding[1] : padding[0];
    bottom = !Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["w" /* isNil */])(padding[2]) ? padding[2] : padding[0];
    left = !Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["w" /* isNil */])(padding[3]) ? padding[3] : right;
  }

  return [top, right, bottom, left];
} // 为了处理radius 大于 width 或 height 的场景


function parseRadius(radius, width, height) {
  radius = parsePadding(radius); // 都为0

  if (!radius[0] && !radius[1] && !radius[2] && !radius[3]) {
    return radius;
  }

  var minWidth = Math.max(radius[0] + radius[1], radius[2] + radius[3]);
  var minHeight = Math.max(radius[0] + radius[3], radius[1] + radius[2]);
  var scale = Math.min(width / minWidth, height / minHeight);

  if (scale < 1) {
    return radius.map(function (r) {
      return r * scale;
    });
  }

  return radius;
}

var Rect = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Rect, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Rect);

  function Rect() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Rect);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Rect, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Rect.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'rect';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        radius: 0,
        lineWidth: 0
      };
    }
  }, {
    key: "createRadiusPath",
    value: function createRadiusPath(context, x, y, width, height, radius) {
      radius = parseRadius(radius, width, height);
      context.moveTo(x + radius[0], y);
      context.lineTo(x + width - radius[1], y);
      context.arc(x + width - radius[1], y + radius[1], radius[1], -Math.PI / 2, 0, false);
      context.lineTo(x + width, y + height - radius[2]);
      context.arc(x + width - radius[2], y + height - radius[2], radius[2], 0, Math.PI / 2, false);
      context.lineTo(x + radius[3], y + height);
      context.arc(x + radius[3], y + height - radius[3], radius[3], Math.PI / 2, Math.PI, false);
      context.lineTo(x, y + radius[0]);
      context.arc(x + radius[0], y + radius[0], radius[0], Math.PI, Math.PI * 3 / 2, false);
      context.closePath();
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          width = attrs.width,
          height = attrs.height,
          radius = attrs.radius;
      context.beginPath();

      if (!radius || !(width * height)) {
        context.rect(x, y, width, height);
      } else {
        this.createRadiusPath(context, x, y, width, height, radius);
      }
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          width = attrs.width,
          height = attrs.height;
      return {
        minX: x,
        minY: y,
        maxX: x + width,
        maxY: y + height
      };
    }
  }]);

  return Rect;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Rect);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_util__ = __webpack_require__(14);





var Layout = /*#__PURE__*/function () {
  function Layout(layout) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Layout);

    this.left = 0;
    this.top = 0;
    this.width = 0;
    this.height = 0;
    this.update(layout);
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Layout, [{
    key: "update",
    value: function update(layout) {
      Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["G" /* mix */])(this, layout);
      var left = this.left,
          top = this.top,
          width = this.width,
          height = this.height;
      this.right = left + width;
      this.bottom = top + height;
      return this;
    }
  }, {
    key: "padding",
    value: function padding(style) {
      if (!style) {
        return this;
      }

      var _style$top = style.top,
          paddingTop = _style$top === void 0 ? 0 : _style$top,
          _style$right = style.right,
          paddingRight = _style$right === void 0 ? 0 : _style$right,
          _style$bottom = style.bottom,
          paddingBottom = _style$bottom === void 0 ? 0 : _style$bottom,
          _style$left = style.left,
          paddingLeft = _style$left === void 0 ? 0 : _style$left;
      var top = this.top,
          right = this.right,
          bottom = this.bottom,
          left = this.left;
      this.top = top + paddingTop;
      this.right = right - paddingRight;
      this.bottom = bottom - paddingBottom;
      this.left = left + paddingLeft;
      this.width = this.right - this.left;
      this.height = this.bottom - this.top;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      var left = this.left,
          top = this.top,
          width = this.width,
          height = this.height;
      return new Layout({
        left: left,
        top: top,
        width: width,
        height: height
      });
    }
  }], [{
    key: "fromStyle",
    value: function fromStyle(style) {
      var left = style.left,
          top = style.top,
          width = style.width,
          height = style.height,
          padding = style.padding;

      var _padding = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(padding, 4),
          paddingTop = _padding[0],
          paddingRight = _padding[1],
          paddingBottom = _padding[2],
          paddingLeft = _padding[3];

      return new Layout({
        left: left + paddingLeft,
        top: top + paddingTop,
        width: width - paddingLeft - paddingRight,
        height: height - paddingTop - paddingBottom
      });
    }
  }]);

  return Layout;
}();

/* harmony default export */ __webpack_exports__["a"] = (Layout);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(275);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__value_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(280);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis_js__ = __webpack_require__(185);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed_js__ = __webpack_require__(278);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_js__ = __webpack_require__(281);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete_js__ = __webpack_require__(757);
/* unused harmony reexport interpolateDiscrete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue_js__ = __webpack_require__(758);
/* unused harmony reexport interpolateHue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number_js__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__number_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__numberArray_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__object_js__ = __webpack_require__(282);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__object_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__round_js__ = __webpack_require__(759);
/* unused harmony reexport interpolateRound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__string_js__ = __webpack_require__(283);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transform_index_js__ = __webpack_require__(760);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zoom_js__ = __webpack_require__(763);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rgb_js__ = __webpack_require__(277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_14__rgb_js__["a"]; });
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hsl_js__ = __webpack_require__(764);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lab_js__ = __webpack_require__(765);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hcl_js__ = __webpack_require__(766);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__ = __webpack_require__(767);
/* unused harmony reexport interpolateCubehelix */
/* unused harmony reexport interpolateCubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__piecewise_js__ = __webpack_require__(768);
/* unused harmony reexport piecewise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__quantize_js__ = __webpack_require__(769);
/* unused harmony reexport quantize */






















/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(184);

function Color() {}
var _darker = 0.7;


var _brighter = 1 / _darker;


var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Color, color, {
  copy: function copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
  : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity;
  a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;

  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }

  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function brighter(k) {
    k = k == null ? _brighter : Math.pow(_brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? _darker : Math.pow(_darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
  }
}));
/* From FvD 13.37, CSS Color Module Level 3 */

function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);

  for (var key in definition) {
    prototype[key] = definition[key];
  }

  return prototype;
}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
      t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
/* harmony default export */ __webpack_exports__["b"] = (function (values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isNumberArray;
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function (t) {
    for (i = 0; i < n; ++i) {
      c[i] = a[i] * (1 - t) + b[i] * t;
    }

    return c;
  };
});
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__coord__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__antv_util__ = __webpack_require__(14);





var coordMap = {
  rect: __WEBPACK_IMPORTED_MODULE_3__coord__["b" /* Rect */],
  polar: __WEBPACK_IMPORTED_MODULE_3__coord__["a" /* Polar */]
};

var coordController = /*#__PURE__*/function () {
  function coordController() {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, coordController);
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(coordController, [{
    key: "getOption",
    value: function getOption(cfg) {
      if (Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["B" /* isString */])(cfg)) {
        return {
          type: coordMap[cfg] || __WEBPACK_IMPORTED_MODULE_3__coord__["b" /* Rect */]
        };
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["v" /* isFunction */])(cfg)) {
        return {
          type: cfg
        };
      }

      var _ref = cfg || {},
          type = _ref.type;

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, cfg), {}, {
        // 默认直角坐标系
        type: Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["v" /* isFunction */])(type) ? type : coordMap[type] || __WEBPACK_IMPORTED_MODULE_3__coord__["b" /* Rect */]
      });
    }
  }, {
    key: "create",
    value: function create(cfg, layout) {
      var option = this.getOption(cfg);
      var type = option.type;
      var coord = new type(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, option), layout));
      this.coord = coord;
      return coord;
    }
  }, {
    key: "updateLayout",
    value: function updateLayout(layout) {
      this.coord.update(layout);
    }
  }, {
    key: "update",
    value: function update() {}
  }]);

  return coordController;
}();

/* harmony default export */ __webpack_exports__["a"] = (coordController);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__antv_util__ = __webpack_require__(14);











function transposedRect(_ref) {
  var xMin = _ref.xMin,
      xMax = _ref.xMax,
      yMin = _ref.yMin,
      yMax = _ref.yMax;
  return {
    xMin: yMin,
    xMax: yMax,
    yMin: xMin,
    yMax: xMax
  };
}

function _convertRect(_ref2) {
  var x = _ref2.x,
      y = _ref2.y,
      size = _ref2.size,
      y0 = _ref2.y0;
  var xMin;
  var xMax;

  if (Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["r" /* isArray */])(x)) {
    xMin = x[0];
    xMax = x[1];
  } else {
    xMin = x - size / 2;
    xMax = x + size / 2;
  }

  var yMin;
  var yMax;

  if (Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["r" /* isArray */])(y)) {
    yMin = y[0];
    yMax = y[1];
  } else {
    yMin = Math.min(y0, y);
    yMax = Math.max(y0, y);
  }

  return {
    xMin: xMin,
    xMax: xMax,
    yMin: yMin,
    yMax: yMax
  };
}
/**
 * 直角坐标系
 * convert相关的方法，涉及将标准坐标系映射到实际坐标系内
 * transform相关的方法，是仅将某一种关键点转换成另一种关键点 (比如将x/y/size/y0转换成yMin/yMax/..)
 */


var Base = /*#__PURE__*/function (_Layout) {
  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(Base, _Layout);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Base);

  function Base(option) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Base);

    _this = _super.call(this, option); // x y 调换

    _this.transposed = false; // x，y 的值域，在极坐标中对应的就是弧度和半径

    _this.x = [0, 1];
    _this.y = [0, 1];

    _this.update(option);

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Base, [{
    key: "update",
    value: function update(option) {
      Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Base.prototype), "update", this).call(this, option);

      var left = this.left,
          top = this.top,
          width = this.width,
          height = this.height;
      this.center = {
        x: left + width / 2,
        y: top + height / 2
      };
      return this;
    } // 是循环， 比如极坐标是以 2π 循环的

  }, {
    key: "isCyclic",
    value: function isCyclic() {
      return false;
    }
  }, {
    key: "_zoomVal",
    value: function _zoomVal(val, func) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["r" /* isArray */])(val) ? val.map(function (v) {
        return func(v);
      }) : func(val);
    }
    /**
     * 把归一后的值映射到对应的定义域
     * @param point
     */

  }, {
    key: "convert",
    value: function convert(point) {
      var transposed = this.transposed,
          x = this.x,
          y = this.y;
      var xDim = transposed ? 'y' : 'x';
      var yDim = transposed ? 'x' : 'y';
      var pointX = point[xDim];
      var pointY = point[yDim]; // 超出边界不绘制

      if (pointX < 0 || pointX > 1 || pointY < 0 || pointY > 1) {
        return {
          x: NaN,
          y: NaN
        };
      }

      return {
        x: this._zoomVal(point[xDim], function (v) {
          return x[0] + (x[1] - x[0]) * v;
        }),
        y: this._zoomVal(point[yDim], function (v) {
          return y[0] + (y[1] - y[0]) * v;
        })
      };
    }
    /**
     * convert 的反处理，把定义域的值，反处理到归一的值
     */

  }, {
    key: "invert",
    value: function invert(point) {
      var _ref3;

      var transposed = this.transposed,
          x = this.x,
          y = this.y;
      var xDim = transposed ? 'y' : 'x';
      var yDim = transposed ? 'x' : 'y';
      return _ref3 = {}, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, xDim, this._zoomVal(point.x, function (v) {
        return (v - x[0]) / (x[1] - x[0]);
      })), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, yDim, this._zoomVal(point.y, function (v) {
        return (v - y[0]) / (y[1] - y[0]);
      })), _ref3;
    }
    /**
     * 把归一化的值映射到 canvas 的坐标点
     * @param point
     * @returns
     */

  }, {
    key: "convertPoint",
    value: function convertPoint(point) {
      return this.convert(point);
    }
    /**
     * 把canvas坐标的点位映射回归一的值
     */

  }, {
    key: "invertPoint",
    value: function invertPoint(point) {
      return this.invert(point);
    } // 将标准坐标系下的矩形绘制关键点映射成实际绘制的坐标点

  }, {
    key: "convertRect",
    value: function convertRect(rectPoint) {
      var xRange = this.x,
          yRange = this.y,
          transposed = this.transposed;

      var _xRange = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(xRange, 2),
          xStart = _xRange[0],
          xEnd = _xRange[1];

      var _yRange = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(yRange, 2),
          yStart = _yRange[0],
          yEnd = _yRange[1];

      var rect = _convertRect(rectPoint);

      var _ref4 = transposed ? transposedRect(rect) : rect,
          xMin = _ref4.xMin,
          xMax = _ref4.xMax,
          yMin = _ref4.yMin,
          yMax = _ref4.yMax;

      var x0 = xStart + (xEnd - xStart) * xMin;
      var x1 = xStart + (xEnd - xStart) * xMax;
      var y0 = yStart + (yEnd - yStart) * yMin;
      var y1 = yStart + (yEnd - yStart) * yMax;
      return {
        xMin: Math.min(x0, x1),
        xMax: Math.max(x0, x1),
        yMin: Math.min(y0, y1),
        yMax: Math.max(y0, y1)
      };
    } // 将已经映射好的矩形绘制关键点转换成实际绘制的坐标点

  }, {
    key: "transformToRect",
    value: function transformToRect(rectPoint) {
      var x = rectPoint.x,
          y = rectPoint.y,
          y0 = rectPoint.y0,
          size = rectPoint.size;
      var coordOrigin = this.convertPoint({
        x: 0,
        y: y0
      });
      var transposed = this.transposed;
      var _rectPoint = {
        size: size,
        x: transposed ? y : x,
        y: transposed ? x : y,
        y0: transposed ? coordOrigin.x : coordOrigin.y
      };

      var rect = _convertRect(_rectPoint);

      var _ref5 = transposed ? transposedRect(rect) : rect,
          xMin = _ref5.xMin,
          xMax = _ref5.xMax,
          yMin = _ref5.yMin,
          yMax = _ref5.yMax;

      return {
        xMin: xMin,
        xMax: xMax,
        yMin: yMin,
        yMax: yMax
      };
    }
  }]);

  return Base;
}(__WEBPACK_IMPORTED_MODULE_8__base_layout__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Base);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = intervalTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);

function snapMultiple(v, base, snapType) {
    var div;
    if (snapType === 'ceil') {
        div = Math.ceil(v / base);
    }
    else if (snapType === 'floor') {
        div = Math.floor(v / base);
    }
    else {
        div = Math.round(v / base);
    }
    return div * base;
}
function intervalTicks(min, max, interval) {
    // 变成 interval 的倍数
    var minTick = snapMultiple(min, interval, 'floor');
    var maxTick = snapMultiple(max, interval, 'ceil');
    // 统一小数位数
    minTick = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["i" /* fixedBase */])(minTick, interval);
    maxTick = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["i" /* fixedBase */])(maxTick, interval);
    var ticks = [];
    // https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Errors/Invalid_array_length
    var availableInterval = Math.max((maxTick - minTick) / (Math.pow(2, 12) - 1), interval);
    for (var i = minTick; i <= maxTick; i = i + availableInterval) {
        var tickValue = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["i" /* fixedBase */])(i, availableInterval); // 防止浮点数加法出现问题
        ticks.push(tickValue);
    }
    return {
        min: minTick,
        max: maxTick,
        ticks: ticks
    };
}
//# sourceMappingURL=interval.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = strictLimit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);

/**
 * 按照给定的 minLimit/maxLimit/tickCount 均匀计算出刻度 ticks
 *
 * @param cfg Scale 配置项
 * @return ticks
 */
function strictLimit(cfg, defaultMin, defaultMax) {
    var _a;
    var minLimit = cfg.minLimit, maxLimit = cfg.maxLimit, min = cfg.min, max = cfg.max, _b = cfg.tickCount, tickCount = _b === void 0 ? 5 : _b;
    var tickMin = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(minLimit) ? (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(defaultMin) ? min : defaultMin) : minLimit;
    var tickMax = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(maxLimit) ? (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(defaultMax) ? max : defaultMax) : maxLimit;
    if (tickMin > tickMax) {
        _a = [tickMin, tickMax], tickMax = _a[0], tickMin = _a[1];
    }
    if (tickCount <= 2) {
        return [tickMin, tickMax];
    }
    var step = (tickMax - tickMin) / (tickCount - 1);
    var ticks = [];
    for (var i = 0; i < tickCount; i++) {
        ticks.push(tickMin + step * i);
    }
    return ticks;
}
//# sourceMappingURL=strict-limit.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MARGIN_RATIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DODGE_RATIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GAP; });
var DEFAULT_Y = 0; // 默认的 y 的值
// 偏移之后，间距
var MARGIN_RATIO = 1 / 2;
var DODGE_RATIO = 1 / 2;
// 散点分开之后，距离边界的距离
var GAP = 0.05;
//# sourceMappingURL=constant.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__identity__ = __webpack_require__(811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Attr", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Linear", function() { return __WEBPACK_IMPORTED_MODULE_1__linear__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Category", function() { return __WEBPACK_IMPORTED_MODULE_2__category__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Identity", function() { return __WEBPACK_IMPORTED_MODULE_3__identity__["a"]; });






/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__count_js__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__each_js__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachBefore_js__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eachAfter_js__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__find_js__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sum_js__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sort_js__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__path_js__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ancestors_js__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__descendants_js__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__leaves_js__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__links_js__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__iterator_js__ = __webpack_require__(869);














function hierarchy(data, children) {
  if (data instanceof Map) {
    data = [undefined, data];
    if (children === undefined) children = mapChildren;
  } else if (children === undefined) {
    children = objectChildren;
  }

  var root = new Node(data),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  while (node = nodes.pop()) {
    if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
      node.children = childs;

      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function objectChildren(d) {
  return d.children;
}

function mapChildren(d) {
  return Array.isArray(d) ? d[1] : null;
}

function copyData(node) {
  if (node.data.value !== undefined) node.value = node.data.value;
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;

  do {
    node.height = height;
  } while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
  this.data = data;
  this.depth = this.height = 0;
  this.parent = null;
}
Node.prototype = hierarchy.prototype = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_1__count_js__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_2__each_js__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_4__eachAfter_js__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_3__eachBefore_js__["a" /* default */],
  find: __WEBPACK_IMPORTED_MODULE_5__find_js__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_6__sum_js__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_7__sort_js__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_8__path_js__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_9__ancestors_js__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_10__descendants_js__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_11__leaves_js__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_12__links_js__["a" /* default */],
  copy: node_copy
}, Symbol.iterator, __WEBPACK_IMPORTED_MODULE_13__iterator_js__["a" /* default */]);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}
function required(f) {
  if (typeof f !== "function") throw new Error();
  return f;
}

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(151);


var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx,
      dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0; // Find the next non-empty node.

    do {
      sumValue = nodes[i1++].value;
    } while (!sumValue && i1 < n);

    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue); // Keep adding nodes while the aspect ratio maintains or improves.

    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);

      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }

      minRatio = newRatio;
    } // Position and record the row orientation.


    rows.push(row = {
      value: sumValue,
      dice: dx < dy,
      children: nodes.slice(i0, i1)
    });
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice_js__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);else Object(__WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}
/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {
  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(56) && !__webpack_require__(55)(function () {
  return Object.defineProperty(__webpack_require__(153)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(113);
var defined = __webpack_require__(93);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(54);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(114);
var ITERATOR = __webpack_require__(49)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(130);
var ITERATOR = __webpack_require__(49)('iterator');
var Iterators = __webpack_require__(114);
module.exports = __webpack_require__(90).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(54);
var aFunction = __webpack_require__(92);
var SPECIES = __webpack_require__(49)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(91);
var invoke = __webpack_require__(203);
var html = __webpack_require__(158);
var cel = __webpack_require__(153);
var global = __webpack_require__(52);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(85)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(92);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var dP = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(56);
var SPECIES = __webpack_require__(49)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(49)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
var setPrototypeOf = __webpack_require__(209).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(64);
var anObject = __webpack_require__(54);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(91)(Function.call, __webpack_require__(117).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(84);
var toIObject = __webpack_require__(74);
var arrayIndexOf = __webpack_require__(154)(false);
var IE_PROTO = __webpack_require__(160)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
var defined = __webpack_require__(93);
var fails = __webpack_require__(55);
var spaces = __webpack_require__(336);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(63);
var anObject = __webpack_require__(54);
var getKeys = __webpack_require__(95);

module.exports = __webpack_require__(56) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(84);
var toObject = __webpack_require__(75);
var IE_PROTO = __webpack_require__(160)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(92);
var isObject = __webpack_require__(64);
var invoke = __webpack_require__(203);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(49);


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(63);
var createDesc = __webpack_require__(110);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(112);
var $export = __webpack_require__(30);
var redefine = __webpack_require__(69);
var hide = __webpack_require__(83);
var Iterators = __webpack_require__(114);
var $iterCreate = __webpack_require__(342);
var setToStringTag = __webpack_require__(133);
var getPrototypeOf = __webpack_require__(213);
var ITERATOR = __webpack_require__(49)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(30);
var toIObject = __webpack_require__(74);
var toInteger = __webpack_require__(113);
var toLength = __webpack_require__(68);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(94)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(30);
var $values = __webpack_require__(220)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(56);
var getKeys = __webpack_require__(95);
var toIObject = __webpack_require__(74);
var isEnum = __webpack_require__(118).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(348),
      utf8 = __webpack_require__(222).utf8,
      isBuffer = __webpack_require__(349),
      bin = __webpack_require__(222).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 222 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(351);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getSelectorsByUserAgent = getSelectorsByUserAgent;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isEmbedded = isEmbedded;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.parseUserAgent = parseUserAgent;
exports.setUserAgent = setUserAgent;
exports.useDeviceData = useDeviceData;
exports.useDeviceSelectors = useDeviceSelectors;
exports.useMobileOrientation = useMobileOrientation;
exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__);
/* harmony default export */ __webpack_exports__["a"] = (function(obj){var str='';Object.keys(obj).forEach(function(item,index,arr){str+=(index!==0?'&':'')+item+'='+obj[item];});return str;});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent',
};
var defaultThreshold = {
    unit: ThresholdUnits.Percent,
    value: 0.8,
};
function parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') {
        return {
            unit: ThresholdUnits.Percent,
            value: scrollThreshold * 100,
        };
    }
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
            return {
                unit: ThresholdUnits.Pixel,
                value: parseFloat(scrollThreshold),
            };
        }
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
            return {
                unit: ThresholdUnits.Percent,
                value: parseFloat(scrollThreshold),
            };
        }
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return defaultThreshold;
}

var InfiniteScroll = /** @class */ (function (_super) {
    __extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function () {
            if (_this.props.scrollableTarget instanceof HTMLElement)
                return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') {
                return document.getElementById(_this.props.scrollableTarget);
            }
            if (_this.props.scrollableTarget === null) {
                console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            }
            return null;
        };
        _this.onStart = function (evt) {
            if (_this.lastScrollTop)
                return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) {
                _this.startY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.startY = evt.touches[0].pageY;
            }
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function (evt) {
            if (!_this.dragging)
                return;
            if (evt instanceof MouseEvent) {
                _this.currentY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.currentY = evt.touches[0].pageY;
            }
            // user is scrolling down to up
            if (_this.currentY < _this.startY)
                return;
            if (_this.currentY - _this.startY >=
                Number(_this.props.pullDownToRefreshThreshold)) {
                _this.setState({
                    pullToRefreshThresholdBreached: true,
                });
            }
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5)
                return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY -
                    _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function () {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false,
                });
            }
            requestAnimationFrame(function () {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function (event) {
            if (typeof _this.props.onScroll === 'function') {
                // Execute this callback in next tick so that it does not affect the
                // functionality of the library.
                setTimeout(function () { return _this.props.onScroll && _this.props.onScroll(event); }, 0);
            }
            var target = _this.props.height || _this._scrollableNode
                ? event.target
                : document.documentElement.scrollTop
                    ? document.documentElement
                    : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered)
                return;
            var atBottom = _this.props.inverse
                ? _this.isElementAtTop(target, _this.props.scrollThreshold)
                : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({ showLoader: true });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength,
        };
        _this.throttledOnScrollListener = throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function () {
        if (typeof this.props.dataLength === 'undefined') {
            throw new Error("mandatory prop \"dataLength\" is missing. The prop is needed" +
                " when loading more content. Check README.md for usage");
        }
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height
            ? this._infScroll
            : this._scrollableNode || window;
        if (this.el) {
            this.el.addEventListener('scroll', this
                .throttledOnScrollListener);
        }
        if (typeof this.props.initialScrollY === 'number' &&
            this.el &&
            this.el instanceof HTMLElement &&
            this.el.scrollHeight > this.props.initialScrollY) {
            this.el.scrollTo(0, this.props.initialScrollY);
        }
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance =
                (this._pullDown &&
                    this._pullDown.firstChild &&
                    this._pullDown.firstChild.getBoundingClientRect()
                        .height) ||
                    0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') {
                throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
            }
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function () {
        if (this.el) {
            this.el.removeEventListener('scroll', this
                .throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function (prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength)
            return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false,
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function (nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) {
            return __assign(__assign({}, prevState), { prevDataLength: nextProps.dataLength });
        }
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop <=
                threshold.value + clientHeight - target.scrollHeight + 1);
        }
        return (target.scrollTop <=
            threshold.value / 100 + clientHeight - target.scrollHeight + 1);
    };
    InfiniteScroll.prototype.isElementAtBottom = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop + clientHeight >= target.scrollHeight - threshold.value);
        }
        return (target.scrollTop + clientHeight >=
            (threshold.value / 100) * target.scrollHeight);
    };
    InfiniteScroll.prototype.render = function () {
        var _this = this;
        var style = __assign({ height: this.props.height || 'auto', overflow: 'auto', WebkitOverflowScrolling: 'touch' }, this.props.style);
        var hasChildren = this.props.hasChildren ||
            !!(this.props.children &&
                this.props.children instanceof Array &&
                this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height
            ? { overflow: 'auto' }
            : {};
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: outerDivStyle, className: "infinite-scroll-component__outerdiv" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "infinite-scroll-component " + (this.props.className || ''), ref: function (infScroll) { return (_this._infScroll = infScroll); }, style: style },
                this.props.pullDownToRefresh && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { position: 'relative' }, ref: function (pullDown) { return (_this._pullDown = pullDown); } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: -1 * this.maxPullDownDistance,
                        } }, this.state.pullToRefreshThresholdBreached
                        ? this.props.releaseToRefreshContent
                        : this.props.pullDownToRefreshContent))),
                this.props.children,
                !this.state.showLoader &&
                    !hasChildren &&
                    this.props.hasMore &&
                    this.props.loader,
                this.state.showLoader && this.props.hasMore && this.props.loader,
                !this.props.hasMore && this.props.endMessage)));
    };
    return InfiniteScroll;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (InfiniteScroll);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SHCardPriceView__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}var _goodsCardSkuImgText,_goodsCardSkuText;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NumberOrText=__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.number]);// Web 版 A8 扁平商品卡，实现与 RN 版尽量一致的逻辑
var isAndroid=__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].isAndroid();var shihuo=typeof window!=='undefined'&&window.shihuo;var screen=typeof window!=='undefined'&&window.screen;var innerWidth=typeof window!=='undefined'&&window.innerWidth;var innerHeight=typeof window!=='undefined'&&window.innerHeight;var vCardWidth=typeof window!=='undefined'&&(innerWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["c" /* px2dpSmall */])(12)*2-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["c" /* px2dpSmall */])(9))/2;var kCharacter=' | ';var baseStyle={containerMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(18),imgMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),bottomWordsHeight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(36),bottomWordsWidth:vCardWidth,bottomTagsHeight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),bottomTagsMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),bottomTagsMarginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(32),bottomTagsWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(302),bottomTagsRankMarginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),nameMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)};var styles=pageStyles;function getImgHeight(item,cardWidth){var img_w=item.img_w,img_h=item.img_h;var cw=cardWidth||180;var imgWidth=cw*2;var imgHeight=imgWidth;if(img_w&&img_h&&+img_w>0&&+img_h>0){imgHeight=imgWidth*(+img_h/+img_w);}return imgHeight;}function calculateWords(name,spec_name){var sh_scale_factor=innerWidth/375;var maxWordLength=Math.floor(40*sh_scale_factor);var blackWord='...';var blankLength=getByteCount(blackWord);var kCharacterLength=getByteCount(kCharacter);var desc=name;if(spec_name&&spec_name.length>0){var nameLength=getByteCount(name);var specLength=getByteCount(kCharacter+spec_name);var currentMaxLength=nameLength+kCharacterLength+specLength;if(currentMaxLength<=maxWordLength){desc=name+kCharacter+spec_name;}else{var cNameLength=maxWordLength-specLength-blankLength-kCharacterLength<0?0:maxWordLength-specLength-blankLength-kCharacterLength;if(nameLength>maxWordLength&&specLength>maxWordLength){desc=handleName(name,18)+blackWord+kCharacter+handleName(spec_name,22);}else if(nameLength>maxWordLength){// 会出现相加的结果还是展示不下,则给name多截取一个字段
var subStringCName=cNameLength>1?cNameLength-1:cNameLength;desc=handleName(name,subStringCName)+blackWord+kCharacter+spec_name;}else if(specLength>maxWordLength){desc=handleName(name,cNameLength)+blackWord+kCharacter+handleName(spec_name,maxWordLength);}else{desc=handleName(name,cNameLength)+blackWord+kCharacter+spec_name;}}}return desc;}function getTags(dataSource){var _dataSource$labels=dataSource.labels,labels=_dataSource$labels===void 0?[]:_dataSource$labels,_dataSource$v_datas=dataSource.v_datas,v_datas=_dataSource$v_datas===void 0?[]:_dataSource$v_datas;var bottomTagList=[];var totalWidth=0;for(var i in labels){var item=labels[i];var activityImageWidth=0.0;if(item.type=='ACTIVITY'){if(item.activity_img&&item.activity_img.length>0){if(item.activity_img_ratio&&parseFloat(item.activity_img_ratio)>0){activityImageWidth=baseStyle.bottomTagsHeight*parseFloat(item.activity_img_ratio);}else{continue;}}}totalWidth+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)+(getByteCount(item.text)*Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10)+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8))+activityImageWidth;if(totalWidth<=baseStyle.bottomTagsWidth){bottomTagList.push(item);}}var label_types=bottomTagList.map(function(it,index){return it.type||'';}).join(',');var label_text=bottomTagList.map(function(it,index){return it.text||'';}).join(',');var rec_word_types='';var rec_word_text='';var wordsData={};var vDatas0=v_datas&&v_datas!=null&&v_datas.length>0?v_datas[0]:{};var item_datas=vDatas0.item_datas&&vDatas0.item_datas!=null&&vDatas0.item_datas.length>0?vDatas0.item_datas:[];if(v_datas&&v_datas!=null&&v_datas.length>0){if(item_datas&&item_datas!=null&&item_datas.length>0){wordsData=item_datas[0];rec_word_types=vDatas0.type||'';rec_word_text=wordsData.text||'';}}return{label_types:label_types,label_text:label_text,rec_word_text:rec_word_text,rec_word_types:rec_word_types};}function getContainerHeight(item){var cardWidth=arguments.length>1&&arguments[1]!==undefined?arguments[1]:vCardWidth;var _item$formatN=item.formatN,formatN=_item$formatN===void 0?'':_item$formatN,_item$style_img_list=item.style_img_list,style_img_list=_item$style_img_list===void 0?[]:_item$style_img_list,spec_name=item.spec_name,benefits=item.benefits,name=item.name,attrLabels=item.attrLabels,labels=item.labels,_item$v_datas=item.v_datas,v_datas=_item$v_datas===void 0?[]:_item$v_datas,isBlackBgImg=item.isBlackBgImg,cateType=item.cateType,whiteBgImgFlag=item.whiteBgImgFlag,beltImg=item.beltImg,_item$nameLineBreak=item.nameLineBreak,nameLineBreak=_item$nameLineBreak===void 0?false:_item$nameLineBreak;var imgHeight=getImgHeight(item,cardWidth);// 图片背景图上间距
// const imgMarginTop = parseInt(cateType) == 3 && parseInt(whiteBgImgFlag) == 1 ? baseStyle.imgMarginTop : 0;
// let containerHeight = imgMarginTop + px2dp(imgHeight);
var containerHeight=imgHeight/2;// 文字上间距是否置空
var nameTopHasData=false;if(formatN&&parseInt(formatN)==3){if(style_img_list&&style_img_list.length>0){var _style_img_list$0$for=style_img_list[0].formatNType,formatNType=_style_img_list$0$for===void 0?0:_style_img_list$0$for;if(formatNType==2){// 口红一行3
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(90+8);nameTopHasData=true;}else if(formatNType==3){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88+8);nameTopHasData=true;}else{// 一行3
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88+8);nameTopHasData=true;}}}else if(formatN&&parseInt(formatN)==5&&style_img_list&&style_img_list.length>0){// 一行5
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56+8);nameTopHasData=true;}// 是否有腰带
if(beltImg&&beltImg.length>0){nameTopHasData=true;}if(whiteBgImgFlag==false){nameTopHasData=true;}// 标题高度
var desc=calculateWords(name,spec_name);var nameLength=getByteCount(desc);if(nameLength>22&&nameLineBreak){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(40)*2+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8);}else{containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(40)+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8);}// 文字顶部只是白底图则减少文字上边距
// if (nameTopHasData == false) {
//     containerHeight -= baseStyle.nameMarginTop;
// }
// 标签高度
// if (getSplitAttributeTagStr(attrLabels).length > 0) {
//     containerHeight += px2dp(36);
// }
//价格距离上边模块2
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2);// 价格高度
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(50);if(v_datas&&v_datas!=null&&v_datas.length>0){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1);containerHeight+=baseStyle.bottomWordsHeight;}else if(labels&&labels.length>0){// 标签高度
var tags=[];for(var i in labels){var _item=labels[i];if(_item.type=='ACTIVITY'){if(_item.activity_img&&_item.activity_img.length>0){if(_item.activity_img_ratio&&parseFloat(_item.activity_img_ratio)>0){}else{continue;}}}tags.push(_item);}if(tags.length>0){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1);containerHeight+=baseStyle.bottomWordsHeight;}}// 最底部间距
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4);return containerHeight;}function getWidgetHeight(item,widgetWidth){return getContainerHeight(item,widgetWidth)+baseStyle.containerMarginTop;}function getByteCount(str){if(!str||!str.length){return 0;}var count=0;for(var i=0;i<str.length;i++){var c=str.charAt(i);if(c==='1'){count+=0.46;}else if(c==='.'){count+=0.29;}else if(c===' '){count+=0.25;}else if(/^[\u0000-\u00ff]$/.test(c)){count+=1;}else{count+=2;}}return count;}function handleName(str,num){var count=0;var i=0;for(;i<str.length;i++){var c=str.charAt(i);if(c==='1'){count+=0.46;}else if(c==='.'){count+=0.29;}else if(c===' '){count+=0.5;}else if(/^[\u0000-\u00ff]$/.test(c)){if(/[A-Z]/.test(c)){count+=1.2;}else{count+=1;}}else{count+=2;}if(count>num){break;}}return str.substring(0,i);}function getStyle3Imgs(){var style_imgs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var item=arguments.length>1?arguments[1]:undefined;// 截取四个配色，第一个配色作为主图（大图），剩下三个作为配色图
var result=style_imgs.slice(0,4);// 一个配色都没有是异常情况
if(result.length==0){result.push(_objectSpread({},item));}return result;}function getStyleImgs(){var style_imgs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var item=arguments.length>1?arguments[1]:undefined;// 截取5个配色，第一个配色作为主图（大图），剩下三个作为配色图
var result=style_imgs.slice(0,6);if(result.length==0){result.push(_objectSpread({},item));}return result;}function getSplitAttributeTagStr(attributeList){var attributeModelList=attributeList;// 如果数组是空则返回空字符
if(!attributeModelList||attributeModelList.length===0){return'';}var attributeTagStr='';for(var i=0;i<3;i++){var item=attributeModelList[i];if(item){attributeTagStr=attributeTagStr+item+' | ';}}var attributeTagStr2=attributeTagStr.substring(0,attributeTagStr.length-3);var count=attributeTagStr2.split(' | ').length;var lastAttributeTagStr=attributeTagStr2;switch(count){case 1:lastAttributeTagStr=attributeTagStr2.substring(0,14);break;case 2:lastAttributeTagStr=attributeTagStr2.substring(0,16);break;case 3:lastAttributeTagStr=attributeTagStr2.substring(0,18);break;default:break;}return lastAttributeTagStr;}var GoodsImage=/*#__PURE__*/function(_Component){_inherits(GoodsImage,_Component);var _super=_createSuper(GoodsImage);function GoodsImage(props){var _this;_classCallCheck(this,GoodsImage);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"setImgVisible",function(imgVisible){_this.setState({imgVisible:imgVisible});});_this.state={imgVisible:true};return _this;}_createClass(GoodsImage,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props=this.props,styles=_this$props.styles,img=_this$props.img,imgHeight=_this$props.imgHeight,beltImg=_this$props.beltImg,beltFrameImg=_this$props.beltFrameImg,isBlackBgImg=_this$props.isBlackBgImg,cateType=_this$props.cateType,whiteBgImgFlag=_this$props.whiteBgImgFlag,_this$props$goodsImgF=_this$props.goodsImgFadeDuration,goodsImgFadeDuration=_this$props$goodsImgF===void 0?-1:_this$props$goodsImgF,_this$props$img_w=_this$props.img_w,img_w=_this$props$img_w===void 0?'':_this$props$img_w,_this$props$img_h=_this$props.img_h,img_h=_this$props$img_h===void 0?'':_this$props$img_h;var imgVisible=this.state.imgVisible;var isRatio5_4=parseFloat(img_w)/parseFloat(img_h)==5.0/4.0;var defaultStyle=!(parseInt(cateType)!=3||isBlackBgImg==1);var containerStyle={width:'100%',height:imgHeight/2,overflow:'hidden'};var imgStyle=defaultStyle?styles.img:isRatio5_4?styles.ratio5_4Img:styles.blackImg;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:containerStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__["LazyLoadImage"],{key:this.props.key,style:_objectSpread(_objectSpread({},imgStyle),{},{display:'block'}),src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,imgHeight):'',effect:"opacity",wrapperProps:{style:{transitionDuration:'700ms'}}}),beltFrameImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.beltFrameImg,src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(beltFrameImg),alt:"belt-frame"}):null,beltImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.blackBeltImg,src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(beltImg),alt:"belt"}):null);}}]);return GoodsImage;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 3：图片 + 文本
var GoodsStyle3ImageView=/*#__PURE__*/function(_Component2){_inherits(GoodsStyle3ImageView,_Component2);var _super2=_createSuper(GoodsStyle3ImageView);function GoodsStyle3ImageView(props){var _this2;_classCallCheck(this,GoodsStyle3ImageView);_this2=_super2.call(this,props);_defineProperty(_assertThisInitialized(_this2),"setImgVisible",function(imgVisible){_this2.setState({imgVisible:imgVisible});});_this2.state={imgVisible:true};return _this2;}_createClass(GoodsStyle3ImageView,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props2=this.props,styles=_this$props2.styles,showingStyleImgs=_this$props2.showingStyleImgs,cardWidth=_this$props2.cardWidth;var imgVisible=this.state.imgVisible;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku3ImgTextView},showingStyleImgs.map(function(item,index){var _item$name=item.name,name=_item$name===void 0?'':_item$name,_item$img=item.img,img=_item$img===void 0?'':_item$img,_item$newProductIcon=item.newProductIcon,newProductIcon=_item$newProductIcon===void 0?'':_item$newProductIcon;var text=handleName(name,8);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorder3),{},{marginHorizontal:index===1?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88*3)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48))/2:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuImgT,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,88):'',alt:"style"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.goodsCardSkuImgText),{},{lineClamp:1})},text),newProductIcon&&newProductIcon.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuLogoImage,src:newProductIcon,alt:"new"}):null);}));}}]);return GoodsStyle3ImageView;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 3：色块 + 文本
var GoodsStyle3View=/*#__PURE__*/function(_Component3){_inherits(GoodsStyle3View,_Component3);var _super3=_createSuper(GoodsStyle3View);function GoodsStyle3View(props){_classCallCheck(this,GoodsStyle3View);return _super3.call(this,props);}_createClass(GoodsStyle3View,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props3=this.props,styles=_this$props3.styles,showingStyleImgs=_this$props3.showingStyleImgs,cardWidth=_this$props3.cardWidth;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku3View},showingStyleImgs.map(function(item,index){var _item$name2=item.name,name=_item$name2===void 0?'':_item$name2,_item$color_hex=item.color_hex,color_hex=_item$color_hex===void 0?'':_item$color_hex,_item$newProductIcon2=item.newProductIcon,newProductIcon=_item$newProductIcon2===void 0?'':_item$newProductIcon2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorderV3),{},{marginHorizontal:index===1?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88*3)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48))/2:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},styles.goodsCardSkuColor),{},{backgroundColor:color_hex})}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:styles.goodsCardSkuText},name),newProductIcon&&newProductIcon.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuLogoImage,src:newProductIcon,alt:"new"}):null);}));}}]);return GoodsStyle3View;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 3：纯图片
var GoodsStyle3Image=/*#__PURE__*/function(_Component4){_inherits(GoodsStyle3Image,_Component4);var _super4=_createSuper(GoodsStyle3Image);function GoodsStyle3Image(props){var _this3;_classCallCheck(this,GoodsStyle3Image);_this3=_super4.call(this,props);_defineProperty(_assertThisInitialized(_this3),"setImgVisible",function(imgVisible){_this3.setState({imgVisible:imgVisible});});_this3.state={imgVisible:true};return _this3;}_createClass(GoodsStyle3Image,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props4=this.props,styles=_this$props4.styles,showingStyleList=_this$props4.showingStyleList,cardWidth=_this$props4.cardWidth;var imgVisible=this.state.imgVisible;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku3},showingStyleList.map(function(item,index){var _item$img2=item.img,img=_item$img2===void 0?'':_item$img2,_item$newProductIcon3=item.newProductIcon,newProductIcon=_item$newProductIcon3===void 0?'':_item$newProductIcon3;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorder3),{},{marginHorizontal:index===1?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88*3)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48))/2:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuImage3,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,88):'',alt:"style"}),newProductIcon&&newProductIcon.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuLogoImage,src:newProductIcon,alt:"new"}):null);}));}}]);return GoodsStyle3Image;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 5：小图
var GoodsStyleImage=/*#__PURE__*/function(_Component5){_inherits(GoodsStyleImage,_Component5);var _super5=_createSuper(GoodsStyleImage);function GoodsStyleImage(props){var _this4;_classCallCheck(this,GoodsStyleImage);_this4=_super5.call(this,props);_defineProperty(_assertThisInitialized(_this4),"setImgVisible",function(imgVisible){_this4.setState({imgVisible:imgVisible});});_this4.state={imgVisible:true};return _this4;}_createClass(GoodsStyleImage,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props5=this.props,styles=_this$props5.styles,showingStyleImgs=_this$props5.showingStyleImgs,onStyleItemPress=_this$props5.onStyleItemPress,cardWidth=_this$props5.cardWidth;var imgVisible=this.state.imgVisible;var gap=(cardWidth-56*5-(32+16))/4;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku},showingStyleImgs.map(function(item,index){var _item$img3=item.img,img=_item$img3===void 0?'':_item$img3;var itemStyle={overflow:'hidden',width:56,height:56,border:'1px solid #f1f1f1',borderRadius:4,marginLeft:index===0?0:gap,boxSizing:'border-box'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorder),{},{marginHorizontal:index===1||index===2||index===3?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56*5)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(32+16))/4:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuImage,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,56):'',alt:"style"}));}));}}]);return GoodsStyleImage;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);var SHGoodsCommonVertFlatStyle8Widget=/*#__PURE__*/function(_Component6){_inherits(SHGoodsCommonVertFlatStyle8Widget,_Component6);var _super6=_createSuper(SHGoodsCommonVertFlatStyle8Widget);function SHGoodsCommonVertFlatStyle8Widget(props){var _this5;_classCallCheck(this,SHGoodsCommonVertFlatStyle8Widget);_this5=_super6.call(this,props);_defineProperty(_assertThisInitialized(_this5),"setImgVisible",function(imgVisible){_this5.goodsImgRef&&_this5.goodsImgRef.setImgVisible(imgVisible);_this5.goodsStyleImgRef&&_this5.goodsStyleImgRef.setImgVisible(imgVisible);});_defineProperty(_assertThisInitialized(_this5),"_updateParentWidth",function(){if(!_this5.bottomRef||!_this5.bottomRef.getBoundingClientRect){return;}var rect=_this5.bottomRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({parentWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_updatePriceViewWidth",function(){if(!_this5.priceViewRef||!_this5.priceViewRef.getBoundingClientRect){return;}var rect=_this5.priceViewRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({priceViewWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_updateInfoViewWidth",function(){if(!_this5.infoViewRef||!_this5.infoViewRef.getBoundingClientRect){return;}var rect=_this5.infoViewRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({infoViewWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_updateHotViewWidth",function(){if(!_this5.hotViewRef||!_this5.hotViewRef.getBoundingClientRect){return;}var rect=_this5.hotViewRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({hotViewWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_renderRecommendView",function(data,count,index){var _data$dsl=data.dsl,dsl=_data$dsl===void 0?'':_data$dsl;switch(dsl){case'HOT_LIST':return _this5._renderHostList(data,count,index);case'NORMAL_TEXT':return _this5._renderNormalText(data,count,index);case'NORMAL_TEXT_ONE':return _this5._renderNormalText(data,count,index);default:return null;}});_defineProperty(_assertThisInitialized(_this5),"_renderHostList",function(data,count,index,isDark){var _data$href=data.href,href=_data$href===void 0?'':_data$href,_data$borderColor=data.borderColor,borderColor=_data$borderColor===void 0?'#FFFFFF':_data$borderColor,_data$backgroundColor=data.backgroundColor,backgroundColor=_data$backgroundColor===void 0?'#FFFFFF':_data$backgroundColor,_data$borderColor_dar=data.borderColor_dark,borderColor_dark=_data$borderColor_dar===void 0?'#242424':_data$borderColor_dar,_data$backgroundColor2=data.backgroundColor_dark,backgroundColor_dark=_data$backgroundColor2===void 0?'#242424':_data$backgroundColor2,_data$item_datas=data.item_datas,item_datas=_data$item_datas===void 0?[]:_data$item_datas;var firstItem={};var secondItem={};var thirdItem={};if(item_datas&&item_datas.length>=3){firstItem=item_datas[0]||{};secondItem=item_datas[1]||{};thirdItem=item_datas[2]||{};}var textStyle=index===0?{maxWidth:125}:{};var containerStyle=_defineProperty({height:'100%',borderRadius:2,border:"1px solid ".concat(isDark?borderColor_dark:borderColor),backgroundColor:isDark?backgroundColor_dark:backgroundColor,display:'flex',flexDirection:'row',alignItems:'center',marginLeft:index>0?4:0,padding:'0 4px',boxSizing:'border-box',overflow:'hidden',cursor:href?'pointer':'default'},"boxSizing",'border-box');var handleClick=function handleClick(){if(href){window.location.href=href;}};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"hot_".concat(index),style:containerStyle,onClick:handleClick},firstItem.img?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:{width:12,height:14,marginRight:2},src:firstItem.img,alt:"hot-left"}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{style:_objectSpread({marginLeft:2,color:isDark?firstItem.textColor_dark||'#666666':firstItem.textColor||'#666666',fontSize:secondItem.fontSize||11,fontFamily:'PingFangSC-Regular',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},textStyle)},secondItem.text||''),thirdItem.img?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:{marginLeft:4,width:6,height:14},src:thirdItem.img,alt:"hot-right"}):null);});_defineProperty(_assertThisInitialized(_this5),"_renderNormalText",function(data,count,index,isDark){var _data$borderColor2=data.borderColor,borderColor=_data$borderColor2===void 0?'#FFFFFF':_data$borderColor2,_data$backgroundColor3=data.backgroundColor,backgroundColor=_data$backgroundColor3===void 0?'#FFFFFF':_data$backgroundColor3,_data$borderColor_dar2=data.borderColor_dark,borderColor_dark=_data$borderColor_dar2===void 0?'#242424':_data$borderColor_dar2,_data$backgroundColor4=data.backgroundColor_dark,backgroundColor_dark=_data$backgroundColor4===void 0?'#242424':_data$backgroundColor4,_data$item_datas2=data.item_datas,item_datas=_data$item_datas2===void 0?[]:_data$item_datas2;var firstItem={};if(item_datas&&item_datas.length>=1){firstItem=item_datas[0]||{};}var _firstItem=firstItem,_firstItem$textColor=_firstItem.textColor,textColor=_firstItem$textColor===void 0?'#666666':_firstItem$textColor,_firstItem$textColor_=_firstItem.textColor_dark,textColor_dark=_firstItem$textColor_===void 0?'#666666':_firstItem$textColor_,_firstItem$fontSize=_firstItem.fontSize,fontSize=_firstItem$fontSize===void 0?11:_firstItem$fontSize,_firstItem$text=_firstItem.text,text=_firstItem$text===void 0?'':_firstItem$text;var spanStyle={marginLeft:index>0?4:0,color:isDark?textColor_dark:textColor,fontSize:fontSize,fontFamily:'PingFangSC-Regular',backgroundColor:isDark?backgroundColor_dark:backgroundColor,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{key:"normal_".concat(index),style:spanStyle},text);});_defineProperty(_assertThisInitialized(_this5),"_renderNormalTexts",function(data,count,index,fontSizeExp){var _data$item_datas3=data.item_datas,item_datas=_data$item_datas3===void 0?[]:_data$item_datas3,_data$backgroundColor5=data.backgroundColor,backgroundColor=_data$backgroundColor5===void 0?'#FFFFFF':_data$backgroundColor5;var firstItem={};if(item_datas&&item_datas.length>=1){firstItem=item_datas[0]||{};}var _firstItem2=firstItem,_firstItem2$textColor=_firstItem2.textColor,textColor=_firstItem2$textColor===void 0?'#666666':_firstItem2$textColor,_firstItem2$fontSize=_firstItem2.fontSize,fontSize=_firstItem2$fontSize===void 0?11:_firstItem2$fontSize,_firstItem2$text=_firstItem2.text,text=_firstItem2$text===void 0?'':_firstItem2$text;var textFontSize=fontSizeExp?11:12;var spanStyle={marginLeft:index>0?4:0,color:textColor,fontSize:textFontSize,fontFamily:'PingFangSC-Regular',backgroundColor:backgroundColor,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{key:"normal_extra_".concat(index),style:spanStyle},text);});_this5.state={priceViewWidth:0,infoViewWidth:0,hotViewWidth:0,parentWidth:0};_this5.cardWidth=props.cardWidth||vCardWidth;return _this5;}_createClass(SHGoodsCommonVertFlatStyle8Widget,[{key:"componentDidMount",value:function componentDidMount(){this._updatePriceViewWidth();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(!prevState.parentWidth){this._updateParentWidth();}if(!prevState.priceViewWidth){this._updatePriceViewWidth();}if(!prevState.infoViewWidth){this._updateInfoViewWidth();}if(!prevState.hotViewWidth){this._updateHotViewWidth();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){if(JSON.stringify(this.state)!=JSON.stringify(nextState)){return true;}if(JSON.stringify(this.props)!=JSON.stringify(nextProps)){return true;}return false;}},{key:"render",value:function render(){var _this6=this;var _this$props6=this.props,_this$props6$goodsImg=_this$props6.goodsImgFadeDuration,goodsImgFadeDuration=_this$props6$goodsImg===void 0?-1:_this$props6$goodsImg,_this$props6$dataSour=_this$props6.dataSource,dataSource=_this$props6$dataSour===void 0?{}:_this$props6$dataSour,_this$props6$onPress=_this$props6.onPress,onPress=_this$props6$onPress===void 0?function(){}:_this$props6$onPress,_this$props6$onStyleI=_this$props6.onStyleItemPress,onStyleItemPress=_this$props6$onStyleI===void 0?function(){}:_this$props6$onStyleI,_this$props6$onDataIt=_this$props6.onDataItemPress,onDataItemPress=_this$props6$onDataIt===void 0?function(){}:_this$props6$onDataIt,_this$props6$isDark=_this$props6.isDark,isDark=_this$props6$isDark===void 0?false:_this$props6$isDark,_this$props6$h5_expos=_this$props6.h5_exposure_object,h5_exposure_object=_this$props6$h5_expos===void 0?{}:_this$props6$h5_expos;styles=Object(__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["b" /* getColorSchemeStyle */])(pageStyles,isDark);var _dataSource$labels2=dataSource.labels,labels=_dataSource$labels2===void 0?[]:_dataSource$labels2,img=dataSource.img,goods_color_num=dataSource.goods_color_num,model_count=dataSource.model_count,isBlackBgImg=dataSource.isBlackBgImg,whiteBgImgFlag=dataSource.whiteBgImgFlag,cateType=dataSource.cateType,name=dataSource.name,_dataSource$sales_inf=dataSource.sales_info_text,sales_info_text=_dataSource$sales_inf===void 0?'':_dataSource$sales_inf,_dataSource$sales_inf2=dataSource.sales_info_num,sales_info_num=_dataSource$sales_inf2===void 0?'':_dataSource$sales_inf2,_dataSource$price=dataSource.price,price=_dataSource$price===void 0?'--':_dataSource$price,discount=dataSource.discount,_dataSource$formatN=dataSource.formatN,formatN=_dataSource$formatN===void 0?'':_dataSource$formatN,_dataSource$img_w=dataSource.img_w,img_w=_dataSource$img_w===void 0?'':_dataSource$img_w,_dataSource$img_h=dataSource.img_h,img_h=_dataSource$img_h===void 0?'':_dataSource$img_h,_dataSource$style_img=dataSource.style_img_list,style_img_list=_dataSource$style_img===void 0?[]:_dataSource$style_img,_dataSource$benefits=dataSource.benefits,benefits=_dataSource$benefits===void 0?[]:_dataSource$benefits,attrLabels=dataSource.attrLabels,salestyle=dataSource.salestyle,official_price=dataSource.official_price,actCornerImg=dataSource.actCornerImg,_dataSource$beltImg=dataSource.beltImg,beltImg=_dataSource$beltImg===void 0?null:_dataSource$beltImg,_dataSource$beltFrame=dataSource.beltFrameImg,beltFrameImg=_dataSource$beltFrame===void 0?null:_dataSource$beltFrame,_dataSource$spec_name=dataSource.spec_name,spec_name=_dataSource$spec_name===void 0?'':_dataSource$spec_name,_dataSource$v_datas2=dataSource.v_datas,v_datas=_dataSource$v_datas2===void 0?[]:_dataSource$v_datas2,_dataSource$nameLineB=dataSource.nameLineBreak,nameLineBreak=_dataSource$nameLineB===void 0?false:_dataSource$nameLineB,_dataSource$promotion=dataSource.promotion_icon,promotion_icon=_dataSource$promotion===void 0?{}:_dataSource$promotion,_dataSource$price_dat=dataSource.price_datas,price_datas=_dataSource$price_dat===void 0?[]:_dataSource$price_dat,_dataSource$fontSizeE=dataSource.fontSizeExp,fontSizeExp=_dataSource$fontSizeE===void 0?false:_dataSource$fontSizeE;var _promotion_icon$ratio=promotion_icon.ratio,activity_ratio=_promotion_icon$ratio===void 0?1:_promotion_icon$ratio,_promotion_icon$icon=promotion_icon.icon,activity_icon=_promotion_icon$icon===void 0?'':_promotion_icon$icon;var tag={text:discount,tcolor:'#999999',bcolor:'#FFFFFF',bgcolor:'#FFFFFF'};var officialPrice=official_price;var canChooseTxt='';if(+goods_color_num>1){canChooseTxt="".concat(goods_color_num,"\u8272\u53EF\u9009");}else if(+model_count>1){canChooseTxt="".concat(model_count,"\u578B\u53EF\u9009");}var rx='';if(sales_info_text&&sales_info_text.length>0){rx=sales_info_text;}if(sales_info_num&&sales_info_num.length>0){rx+=sales_info_num;}var isIOS=/ios|iphone|ipad/i.test(navigator.userAgent);var sku_type=-1;if(formatN&&parseInt(formatN)==3&&style_img_list&&style_img_list.length>0){var _style_img_list$0$for2=style_img_list[0].formatNType,formatNType=_style_img_list$0$for2===void 0?0:_style_img_list$0$for2;if(formatNType==2){sku_type=2;}else if(formatNType==3){sku_type=3;}else{sku_type=1;}}else if(formatN&&parseInt(formatN)==5&&style_img_list&&style_img_list.length>0){sku_type=5;}var bottomTagList=[];var totalWidth=0;if(labels&&labels.length>0){for(var i=0;i<labels.length;i++){var item=labels[i];var activityImageWidth=0.0;if(item.type=='ACTIVITY'){if(item.activity_img&&item.activity_img.length>0){if(item.activity_img_ratio&&parseFloat(item.activity_img_ratio)>0){activityImageWidth=baseStyle.bottomTagsHeight*parseFloat(item.activity_img_ratio);}}}totalWidth+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)+(getByteCount(item.text)*Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10)+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8))+activityImageWidth;if(totalWidth<=baseStyle.bottomTagsWidth){bottomTagList.push(item);}}}var wordsData={};var vDatas0=v_datas&&v_datas!=null&&v_datas.length>0?v_datas[0]:{};var item_datas=vDatas0.item_datas&&vDatas0.item_datas!=null&&vDatas0.item_datas.length>0?vDatas0.item_datas:[];if(v_datas&&v_datas!=null&&v_datas.length>0){if(item_datas&&item_datas!=null&&item_datas.length>0){wordsData=item_datas[0];}}var imgHeight=getImgHeight(dataSource,this.cardWidth);var containerHeight=getContainerHeight(dataSource,this.cardWidth);var desc=calculateWords(name,spec_name);var nameLength=getByteCount(desc);var sh_scale_factor=innerWidth/375;var descWordNum=Math.floor(21*sh_scale_factor);if(activity_icon&&activity_icon.length>0){descWordNum=descWordNum-Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*activity_ratio/Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(13));}// 文字上间距是否置空
var nameTopHasData=false;if(sku_type==2||sku_type==3||sku_type==1||sku_type==5){// 一拖三
nameTopHasData=true;}else if(whiteBgImgFlag==false){// 黑底图
nameTopHasData=true;}// 文字顶部间距
// const nameMarginTop = nameTopHasData ? baseStyle.nameMarginTop : 0;
var nameMarginTop=baseStyle.nameMarginTop;// 图片背景图高度
var imageBottomH=parseInt(cateType)==3&&parseInt(whiteBgImgFlag)==1?baseStyle.imgMarginTop:0;var priceFamliy=shihuo.useNewPriceFontFamily?shihuo.priceMediumFontFamily:'PingFangSC-Medium';var numberFamliy='SHIHUOSans-Medium';var onlyOneLine=nameLength<=descWordNum||!nameLineBreak;var hasActivityIcon=activity_icon.length>0;var useTrickPadding=onlyOneLine;var textPaddingRight=useTrickPadding?isIOS?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["c" /* px2dpSmall */])(12):0:0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this6.props.exp&&_this6.props.exp(ele);}},"data-dot":JSON.stringify(h5_exposure_object),className:"goods-card",style:_objectSpread(_objectSpread({},styles.goodsCard),{},{height:containerHeight,width:this.cardWidth}),onClick:onPress},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"goods-card-image-body",style:_objectSpread(_objectSpread({},styles.goodsCardImageBody),{},{height:imgHeight/2})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:{position:'absolute',left:0,top:0,width:'100%',height:'100%',backgroundColor:'#00000005',borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),zIndex:9}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsImage,{ref:function ref(_ref){return _this6.goodsImgRef=_ref;},styles:styles,img:img,goodsImgFadeDuration:goodsImgFadeDuration,beltImg:beltImg,beltFrameImg:beltFrameImg,imgHeight:imgHeight,cardWidth:this.cardWidth,isBlackBgImg:isBlackBgImg,whiteBgImgFlag:whiteBgImgFlag,cateType:cateType,img_w:img_w,img_h:img_h}),actCornerImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{className:"act-img",style:styles.actImg,src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(actCornerImg,64),alt:"act"}):null,canChooseTxt?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"image-tag",style:styles.goodsCardImageTag},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{className:"image-tag-icon",style:styles.goodsCardImageTagIcon,src:"http://static.shihuocdn.cn/admin/files/20200914/102d10c19b6f6a6da07aab18460e0d9d.png",alt:"multi"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{className:"goods-card-image-tag-text",style:styles.goodsCardImageTagText},canChooseTxt)):null),sku_type==1?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyle3Image,{ref:function ref(_ref2){return _this6.goodsStyleImgRef=_ref2;},styles:styles,cardWidth:this.cardWidth,showingStyleList:style_img_list,onStyleItemPress:onStyleItemPress}):sku_type==5?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyleImage,{ref:function ref(_ref3){return _this6.goodsStyleImgRef=_ref3;},styles:styles,cardWidth:this.cardWidth,showingStyleImgs:style_img_list,onStyleItemPress:onStyleItemPress}):sku_type==2?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyle3View,{styles:styles,cardWidth:this.cardWidth,showingStyleImgs:style_img_list,onStyleItemPress:onStyleItemPress}):sku_type==3?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyle3ImageView,{ref:function ref(_ref4){return _this6.goodsStyleImgRef=_ref4;},styles:styles,cardWidth:this.cardWidth,showingStyleImgs:style_img_list,onStyleItemPress:onStyleItemPress}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:{width:'100%',paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),display:'flex',flexDirection:'row',boxSizing:'border-box'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"goods-name",style:_objectSpread(_objectSpread({},styles.name),{},{marginTop:nameMarginTop,// paddingRight: textPaddingRight,
boxSizing:'border-box',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),height:onlyOneLine?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(20):Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(40),lineHeight:'20px',overflow:'hidden',wordBreak:'break-all',textAlign:'left'})},hasActivityIcon?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{style:{display:'inline-block',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*activity_ratio+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14),position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2)}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(activity_icon),alt:"promo",style:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*activity_ratio,height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)}})):null,onlyOneLine?useTrickPadding?desc:handleName(desc,descWordNum):desc)),bottomTagList&&bottomTagList.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.bottomTags},bottomTagList.map(function(tag,index){if(tag.type=='ACTIVITY'){var hasTagImg=tag.activity_img&&tag.activity_img.length>0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:index,style:_objectSpread(_objectSpread({},styles.bottomTagActivityNormal),{},{backgroundColor:tag.bgcolor,borderColor:tag.bcolor,marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)})},tag.activity_img&&tag.activity_img.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{key:index+'ACTIVITY',src:tag.activity_img.indexOf('http')!=-1?tag.activity_img:'http://static.shihuocdn.cn/admin/files/20210823/05e993be26fe39e149f1cccc7492c271.png',alt:"activity",style:_objectSpread(_objectSpread({},styles.bottomTagActivityImg),{},{width:parseFloat(tag.activity_img_ratio)*baseStyle.bottomTagsHeight})}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},hasTagImg?styles.bottomTagActivityTxtContainer:styles.bottomTagActivityNorTxtContainer),{},{borderColor:tag.bcolor||'#ffffff'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.bottomTagActivityTxt),{},{color:tag.tcolor})},tag.text)));}else if(tag.routineImg&&tag.routineImg.length>0){var imgW=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*tag.routineRatio;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},styles.fanBGView),{},{marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},styles.fanContentView),{},{borderColor:tag.bcolor||'#ffffff'})},tag.routineImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:_objectSpread(_objectSpread({},styles.fanIconView),{},{width:imgW}),src:tag.routineImg}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.fanTxtBGView},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.fanTxt),{},{color:tag.tcolor||'#ff4338'})},tag.text))));}else if(tag.bgcolor&&tag.bgcolor.indexOf('http')!=-1){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:index+'NEW_GOODS',style:_objectSpread(_objectSpread({},styles.bottomTagNormal),{},{borderRadius:0,borderWidth:0,backgroundColor:tag.bgcolor||'#ffffff',borderColor:tag.bcolor||'#ffffff',marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),backgroundImage:"url(".concat(tag.bgcolor.indexOf('http')!=-1?tag.bgcolor:'http://static.shihuocdn.cn/admin/files/20210823/05e993be26fe39e149f1cccc7492c271.png',")"),backgroundSize:'cover',backgroundRepeat:'no-repeat'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.bottomTagNormalTxt),{},{color:tag.tcolor||'#333333'})},tag.text));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:index,style:_objectSpread(_objectSpread({},styles.bottomTagNormal),{},{backgroundColor:tag.bgcolor,borderColor:tag.bcolor,marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.bottomTagNormalTxt),{},{color:tag.tcolor})},tag.text));}})):v_datas&&v_datas!=null&&v_datas.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.bottomWords},v_datas.map(function(item,index){return _this6._renderRecommendView(item,v_datas.length,index);})):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref9){return _this6.bottomRef=_ref9;},style:styles.bottom},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref5){return _this6.priceViewRef=_ref5;},className:"price-view-wrap",style:{display:'flex',flexDirection:'row',alignItems:'center',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__SHCardPriceView__["a" /* default */],{isDark:isDark,price:price,mainPriceStyle:{fontFamily:numberFamliy},symbolStyle:{fontFamily:numberFamliy},dotPriceStyle:{fontFamily:numberFamliy},unitPirceStyle:{fontFamily:priceFamliy}})),function(){var _ref6=_this6.state||{},_ref6$priceViewWidth=_ref6.priceViewWidth,priceViewWidth=_ref6$priceViewWidth===void 0?0:_ref6$priceViewWidth,_ref6$infoViewWidth=_ref6.infoViewWidth,infoViewWidth=_ref6$infoViewWidth===void 0?0:_ref6$infoViewWidth,_ref6$hotViewWidth=_ref6.hotViewWidth,hotViewWidth=_ref6$hotViewWidth===void 0?0:_ref6$hotViewWidth,_ref6$parentWidth=_ref6.parentWidth,parentWidth=_ref6$parentWidth===void 0?0:_ref6$parentWidth;var showInfo=false;var showHot=false;if(priceViewWidth+infoViewWidth+hotViewWidth<parentWidth){showInfo=true;showHot=true;}else if(priceViewWidth+hotViewWidth<parentWidth){showHot=true;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null,showInfo&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref7){return _this6.infoViewRef=_ref7;},className:"info-view",style:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2),display:'flex',flexDirection:'row',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2)}},price_datas.map(function(item,index){return _this6._renderNormalTexts(item,price_datas.length,index);})),showHot&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{ref:function ref(_ref8){return _this6.hotViewRef=_ref8;},className:"hot-view",style:_objectSpread(_objectSpread({},styles.hot),{},{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2),fontSize:fontSizeExp?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(11):Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(12),whiteSpace:'nowrap',textOverflow:'ellipsis',lineClamp:1})},rx));}())));}}]);return SHGoodsCommonVertFlatStyle8Widget;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);_defineProperty(SHGoodsCommonVertFlatStyle8Widget,"propTypes",{dataSource:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({labels:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({type:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签类型，取值范围如下，活动标签:ACTIVITY, 描述:DESC, 折扣:DISCOUNT, 入选排行榜:HOTLIST
text_list:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//标签内容列表
text:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签内容
tcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签文字颜色
bgcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签背景颜色
bcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签边框颜色
activity_img:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,// 标签图片链接
activity_img_ratio:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string// 标签图片比例
})),salestyle:NumberOrText,//2为显示折扣，3为显示原价
img:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//商品图
goods_color_num:NumberOrText,//商品配色数目
model_count:NumberOrText,//商品型号数目
isBlackBgImg:NumberOrText,// 0:白底图  1:黑底图
whiteBgImgFlag:NumberOrText,// 1:白底图 0:黑底图
// isCommonCate: NumberOrText, // 1通用类目 0:非通用
cateType:NumberOrText,// 3: 通用 1: 服 2: 鞋
name:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//商品名称
sales_info_text:NumberOrText,//销量、热度文案
sales_info_num:NumberOrText,//销量、热度数值
official_price:NumberOrText,//原价、官方价
price:NumberOrText,//价格
discount:NumberOrText,//原价、官方价
actCornerImg:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//左上角角标
img_w:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//图片宽比
img_h:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//图片高比
benefits:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({type:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签类型
text:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签内容
text_list:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//利益点标签内容列表
amount:NumberOrText,//利益点标签金额
tcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签文字颜色
bgcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签背景颜色
bcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string//利益点标签边框颜色
})),spec_name:NumberOrText,// SUK描述
attrLabels:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//商品属性标签内容列表
formatN:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,// 一拖n    3 一拖3    5 一拖5
style_imgs:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//商品小款式图
style_img_list:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({style_id:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,newProductIcon:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,color_hex:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,formatNType:NumberOrText,img:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string}))}),onPress:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,onStyleItemPress:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,onDataItemPress:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,isDark:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool});_defineProperty(SHGoodsCommonVertFlatStyle8Widget,"defaultProps",{dataSource:{labels:[],img:'',goods_color_num:0,model_count:0,isBlackBgImg:0,whiteBgImgFlag:0,cateType:1,name:'',sales_info_text:'',price:'',discount:'',formatN:'',style_img_list:[],benefits:[],spec_name:'',attrLabels:[],salestyle:'',sales_info_num:'',official_price:'',actCornerImg:'',img_w:'',img_h:''},onPress:function onPress(){},onStyleItemPress:function onStyleItemPress(){},onDataItemPress:function onDataItemPress(){},isDark:false});var pageStyles={goodsCard:{overflow:'hidden',marginBottom:baseStyle.containerMarginTop,backgroundColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ffffff_fg,borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12)},goodsCardImageBody:{position:'relative',width:'100%',borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),overflow:'hidden',backgroundColor:'#ffffff'},goodsCardImageTag:{position:'absolute',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),right:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderColor:'#DEDEDE',borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(17),paddingVertical:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),backgroundColor:'rgba(255,255,255,0.8)',boxSizing:'border-box'},goodsCardImageTagText:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},ratio5_4Img:{position:'absolute',width:'100%',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),bottom:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16)},blackImg:{width:'100%',height:'100%',marginTop:0,marginHorizontal:0},img:{width:'100%',height:'100%',// marginTop: px2dp(20),
marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),flex:1},goodsCardSku:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(14),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),boxSizing:'border-box'},goodsCardSku3:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),boxSizing:'border-box'},goodsCardSku3View:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(90),boxSizing:'border-box'},goodsCardSku3ImgTextView:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),boxSizing:'border-box'},goodsCardSkuBorder:{overflow:'hidden',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),borderColor:'#F1F1F1',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},goodsCardSkuImage:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56)},goodsCardSkuBorder3:{overflow:'hidden',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),borderColor:'#F1F1F1',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},goodsCardSkuBorderV3:{overflow:'hidden',display:'flex',alignItems:'center',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(90),borderColor:'#F1F1F1',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},goodsCardSkuImage3:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88)},goodsCardSkuLogoImage:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),position:'absolute',left:-1,top:-1},goodsCardSkuColor:{display:'flex',justifyContent:'center',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48),marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),overflow:'hidden'},goodsCardSkuImgT:{display:'flex',justifyContent:'center',position:'absolute',left:0,top:0,right:0,bottom:0,overflow:'hidden'},goodsCardSkuImgText:(_goodsCardSkuImgText={position:'absolute',left:0,right:0,bottom:0,height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),backgroundColor:'rgba(255,255,255,0.85)',paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),display:'flex',justifyContent:'center',color:'#333333',fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16)},_defineProperty(_goodsCardSkuImgText,"color",'#333333'),_defineProperty(_goodsCardSkuImgText,"textAlign",'center'),_defineProperty(_goodsCardSkuImgText,"boxSizing",'border-box'),_goodsCardSkuImgText),goodsCardSkuText:(_goodsCardSkuText={display:'flex',justifyContent:'center',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),color:'#333333',fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),// lineHeight: px2dp(22),
width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(80)},_defineProperty(_goodsCardSkuText,"color",'#333333'),_defineProperty(_goodsCardSkuText,"textAlign",'center'),_goodsCardSkuText),goodsCardInfo:{display:'flex',justifyContent:'space-between',paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),boxSizing:'border-box'},goodsCardTop:{display:'flex',justifyContent:'space-between',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(72)},name:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(26),fontFamily:isAndroid?'PingFangSC-Regular':'PingFangSC-Medium',color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,// lineHeight: px2dp(40),
marginTop:baseStyle.nameMarginTop},goodsCardBottom:{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)},goodsCardBottomLeft:{display:'flex',flexDirection:'row',alignItems:'center'},goodsCardTag:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),boxSizing:'border-box'},goodsCardImageTagIcon:{marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20)},goodsCardTagText:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},goodsCardSymbol:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},goodsCardNum:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),//fontFamily: 'HelveticaNeue-CondensedBold',
fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(36),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},goodsCardOriginalPrice:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(6),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(26),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_999999,marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),textDecorationLine:'line-through',fontFamily:'PingFangSC-Regular'},goodsCardAmount:{position:'relative',bottom:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(14),fontFamily:'PingFangSC-Light',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_999999},bottomWords:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1),height:baseStyle.bottomWordsHeight,lineHeight:"".concat(baseStyle.bottomWordsHeight,"px"),display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',overflow:'hidden',marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4)},vDataItemsView:{paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginTop:0,height:baseStyle.bottomWordsHeight,flex:1,display:'flex',flexDirection:'row',alignItems:'center',boxSizing:'border-box'},vDataLeftImg:{marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(26)},vDataLeftHead:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(14),overflow:'hidden'},vDataText:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),maxWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(255),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),boxSizing:'border-box'},vDataCommentContainer:{paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),maxWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(250),overflow:'hidden',paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},vDataComment:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},vDataYinHao:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
minWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(18),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},vDataRightImg:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingBottom:0,marginBottom:0},bottomTags:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:baseStyle.bottomWordsHeight,display:'flex',flexDirection:'row',width:baseStyle.bottomTagsWidth,alignItems:'center'},bottomTagActivityNormal:{borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),height:baseStyle.bottomTagsHeight,display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',backgroundColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ff4338,overflow:'hidden'},bottomTagActivityImg:{height:baseStyle.bottomTagsHeight,marginHorizontal:0,marginLeft:0},bottomTagActivityTxtContainer:{borderTopRightRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderBottomRightRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:baseStyle.bottomTagsHeight,borderLeftColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ffffff_fg,display:'flex',justifyContent:'center',alignItems:'center'},bottomTagActivityNorTxtContainer:{borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:baseStyle.bottomTagsHeight,display:'flex',justifyContent:'center',alignItems:'center'},bottomTagActivityTxt:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:'#ffffff',fontFamily:'PingFangSC-Regular',height:baseStyle.bottomTagsHeight,// lineHeight: baseStyle.bottomTagsHeight,
maxWidth:baseStyle.bottomTagsWidth,marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},bottomTagNormal:{borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ff4338,marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),height:baseStyle.bottomTagsHeight,display:'flex',flexDirection:'row',alignItems:'center',backgroundColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ff4338,boxSizing:'border-box'},bottomTagNormalTxt:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:'#ffffff',fontFamily:'PingFangSC-Regular',// lineHeight: baseStyle.bottomTagsHeight,
height:baseStyle.bottomTagsHeight,paddingBottom:isAndroid?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1):0,maxWidth:baseStyle.bottomTagsWidth,boxSizing:'border-box'},cave:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:baseStyle.bottomTagsHeight,overflow:'hidden'},caveCircle:{position:'absolute',left:0,borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),backgroundColor:'#ffffff'},caveDotLine:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(18)},caveDot:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2)},bottomTagsRankContainer:{display:'flex',flexDirection:'row',alignItems:'center',height:baseStyle.bottomTagsHeight,marginBottom:baseStyle.bottomTagsRankMarginBottom},bottom:{height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(50),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),marginTop:isAndroid?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2),display:'flex',flexDirection:'row',alignItems:'center'},priceSymbol:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),fontFamily:'PingFangSC-Medium',color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,paddingRight:0},priceSymbolIOS:{paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),boxSizing:'border-box'},priceStyle:{fontFamily:'PingFangSC-Medium'},price:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(36),fontFamily:'PingFangSC-Medium',color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333// lineHeight: px2dp(42),
},priceIOS:{// lineHeight: px2dp(40),
},tag:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),display:'flex',flexDirection:'row',alignItems:'center',backgroundColor:'#ffffff'},tagTxt:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),color:'#999999',fontFamily:'PingFangSC-Regular'// lineHeight: px2dp(27),
},officialPrice:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(6),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),color:'#999999',fontFamily:'PingFangSC-Regular',textDecorationLine:'line-through',// lineHeight: px2dp(26),
position:'absolute',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},hotContainer:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},hot:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(6),color:'#666666',fontFamily:'PingFangSC-Regular',textAlign:'right'// lineHeight: px2dp(32),
},hotIOS:{// lineHeight: px2dp(39),
paddingTop:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},actImg:{position:'absolute',left:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(64),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(40)},beltImg:{position:'absolute',left:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),bottom:0,width:'100%',aspectRatio:171/42},blackBeltImg:{position:'absolute',left:0,bottom:0,width:'100%',aspectRatio:171/42},beltFrameImg:{position:'absolute',left:0,top:0,width:'100%',aspectRatio:1/1.333},fanBGView:{display:'flex',flexDirection:'row',width:baseStyle.bottomTagsWidth},fanContentView:{display:'flex',flexDirection:'row',borderWidth:StyleSheet.hairlineWidth,borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(2),borderColor:'#FFB4B3',backgroundColor:'transparent',overflow:'hidden'},fanIconView:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(33),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(14)},fanTxtBGView:{height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(14),paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(2),paddingRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(2),display:'flex',justifyContent:'center',alignItems:'center',boxSizing:'border-box'},fanTxt:{color:'#FF4338',fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(11)},imageCover:{width:'100%',height:'100%',backgroundColor:'red'}};/* harmony default export */ __webpack_exports__["default"] = ({widget:SHGoodsCommonVertFlatStyle8Widget,getWidgetHeight:getWidgetHeight,showStyleList:false,getTags:getTags});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicColorValue; });
/* unused harmony export DYColorMapper */
/* harmony export (immutable) */ __webpack_exports__["b"] = getColorSchemeStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}// 为了在 Web React 环境中兼容 __DEV__ 判断，这里自定义一个 __DEV__ 标志
// 如果打包工具（如 webpack、Vite）提供了 process.env.NODE_ENV，会按其判断
// 否则默认认为是开发环境（true），以保留调试告警能力
var __DEV__=typeof process!=='undefined'&&Object({"NODE_ENV":"production","PUBLIC_URL":"."})&&"production"?"production"!=='production':true;// 动态颜色值：根据 isDark 选择 light 或 dark
var DynamicColorValue=/*#__PURE__*/function(){function DynamicColorValue(light,dark){_classCallCheck(this,DynamicColorValue);this.light=light;this.dark=dark;}_createClass(DynamicColorValue,[{key:"current",value:function current(isDark){return isDark?this.dark:this.light;}}]);return DynamicColorValue;}();// 原来类里的静态方法改为类外赋值，避免使用 static 关键字
DynamicColorValue.dyc=function(light,dark){return new DynamicColorValue(light,dark);};DynamicColorValue.dyCurrentImage=function(imageInfo,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('注意 dyCurrentImage isDark没有传值');}if(!isDark){return imageInfo.light;}if(!imageInfo.dark){return imageInfo.light;}return imageInfo.dark;};// 使用 ES5 兼容的方式挂载静态字段，避免使用 class fields 语法
DynamicColorValue.dyc_ff4338=new DynamicColorValue('#ff4338','#ff564d');DynamicColorValue.dyc_f4f5f7_bg=new DynamicColorValue('#f4f5f7','#121212');DynamicColorValue.dyc_f4f5f7_fg=new DynamicColorValue('#f4f5f7','#242424');DynamicColorValue.dyc_111111=new DynamicColorValue('#111111','#f0f0f0');DynamicColorValue.dyc_f7f7f7=new DynamicColorValue('#f7f7f7','#2e2e2e');DynamicColorValue.dyc_ffffff_fg=new DynamicColorValue('#ffffff','#242424');DynamicColorValue.dyc_ffffff_bg=new DynamicColorValue('#ffffff','#121212');DynamicColorValue.dyc_333333=new DynamicColorValue('#333333','#e0e0e0');DynamicColorValue.dyc_555555=new DynamicColorValue('#555555','#d4d4d4');DynamicColorValue.dyc_444444=new DynamicColorValue('#444444','#d4d4d4');DynamicColorValue.dyc_666666=new DynamicColorValue('#666666','#a8a8a8');DynamicColorValue.dyc_888888=new DynamicColorValue('#888888','#e0e0e0');DynamicColorValue.dyc_999999=new DynamicColorValue('#999999','#808080');DynamicColorValue.dyc_cacaca=new DynamicColorValue('#cacaca','#4f4f4f');DynamicColorValue.dyc_eaeaea=new DynamicColorValue('#eaeaea','#424242');DynamicColorValue.dyc_f0f0f0=new DynamicColorValue('#f0f0f0','rgba(255, 255, 255, 0.06)');DynamicColorValue.dyc_f7f7f9=new DynamicColorValue('#f7f7f9','#222222');DynamicColorValue.dyc_fafafa=new DynamicColorValue('#fafafa','#1f1f1f');DynamicColorValue.dyc_test_red=new DynamicColorValue('red','blue');DynamicColorValue.dyc_000000=new DynamicColorValue('#000000','#e0e0e0');DynamicColorValue.dyc_4f87c4=new DynamicColorValue('#4f87c4','#7693B9');DynamicColorValue.dyc_b16724=new DynamicColorValue('#b16724','#d5b186');DynamicColorValue.dyc_f7f8fa=new DynamicColorValue('#F7F8FA','#242424');var DYColorMapper=/*#__PURE__*/_createClass(function DYColorMapper(){_classCallCheck(this,DYColorMapper);});// 将原来的静态方法改为类外赋值，避免使用 static 关键字
DYColorMapper.dyc=function(key,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('注意 DYColorMapper.dyc isDark没有传值');}if(!key){return key;}var upperKey=String(key).toUpperCase();var value=DYColorMapper.__map[upperKey];if(!value){if(__DEV__){console.warn('DYColorMapper do not contain this key',upperKey);}return upperKey;}return isDark?value.dark:value.light;};DYColorMapper.dyCurrentImage=function(imageInfo,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('注意 dyCurrentImage isDark没有传值');}if(!isDark){return imageInfo.light;}if(!imageInfo.dark){return imageInfo.light;}return imageInfo.dark;};// 使用 ES5 方式定义 __map，避免 class field 语法
DYColorMapper.__map={'#000000':DynamicColorValue.dyc_000000,'#F7F7F9':DynamicColorValue.dyc_f7f7f9,'#FF4338':DynamicColorValue.dyc_ff4338,'#F4F5F7_BG':DynamicColorValue.dyc_f4f5f7_bg,'#F4F5F7_FG':DynamicColorValue.dyc_f4f5f7_fg,'#111111':DynamicColorValue.dyc_111111,'#F7F7F7':DynamicColorValue.dyc_f7f7f7,'#FFFFFF_BG':DynamicColorValue.dyc_ffffff_bg,'#FFFFFF_FG':DynamicColorValue.dyc_ffffff_fg,'#333333':DynamicColorValue.dyc_333333,'#555555':DynamicColorValue.dyc_555555,'#444444':DynamicColorValue.dyc_444444,'#666666':DynamicColorValue.dyc_666666,'#888888':DynamicColorValue.dyc_888888,'#999999':DynamicColorValue.dyc_999999,'#CACACA':DynamicColorValue.dyc_cacaca,'#EAEAEA':DynamicColorValue.dyc_eaeaea,'#F0F0F0':DynamicColorValue.dyc_f0f0f0,'#4F87C4':DynamicColorValue.dyc_4f87c4,'#B16724':DynamicColorValue.dyc_b16724,'#F7F8FA':DynamicColorValue.dyc_f7f8fa,red:DynamicColorValue.dyc_test_red};// Web 版本的 getColorSchemeStyle：不再依赖 React Native 的 StyleSheet.create
// 直接返回普通 JS 对象形式的样式，同时保持原来按 light/dark 缓存结果的行为
function getColorSchemeStyle(dynamicStyleSheet,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('getColorSchemeStyle isDark没有传值');}if(isDark){if(!dynamicStyleSheet.__dark){dynamicStyleSheet.__dark=parseStylesFor(dynamicStyleSheet,'dark');if(__DEV__){console.log('parseStylesFor dark');}}return dynamicStyleSheet.__dark;}else{if(!dynamicStyleSheet.__light){dynamicStyleSheet.__light=parseStylesFor(dynamicStyleSheet,'light');if(__DEV__){console.log('parseStylesFor light');}}return dynamicStyleSheet.__light;}}function parseStylesFor(styles,mode){var newStyles={};var containsDynamicColorValues=false;for(var key in styles){if(!Object.prototype.hasOwnProperty.call(styles,key))continue;var style=styles[key];// 跳过内部缓存字段，避免无限递归或污染
if(key==='__dark'||key==='__light'){continue;}var newStyle={};for(var prop in style){if(!Object.prototype.hasOwnProperty.call(style,prop))continue;var value=style[prop];if(value instanceof DynamicColorValue){containsDynamicColorValues=true;newStyle[prop]=value[mode];}else{newStyle[prop]=value;}}newStyles[key]=newStyle;}if(!containsDynamicColorValues&&__DEV__){console.warn('A DYCStyleSheet was used without any DynamicColorValues. Consider replacing with a regular StyleSheet.');}return newStyles;}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(135)))

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__BytesCount__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}/*
 * @Author: Miaoz
 * @Date: 2025-06-20 18:35:08
 * @LastEditors: Miaoz
 * @LastEditTime: 2025-06-24 11:08:54
 * @Description: 
 */var play_icon='http://static.shihuocdn.cn/admin/files/20230822/bec2fa4227fc27ff96840b74b80d8b0c.png';var bottom_bg_icon='http://static.shihuocdn.cn/admin/files/20230807/03a59277acc673321aeb626eeba330c6.png';var article_icon='http://static.shihuocdn.cn/admin/files/20230807/cdad47a3f86850e6156c087ae7ab7c53.png';var praised_icon='http://static.shihuocdn.cn/app/res/dsgn/363d7402c5a1407f9e72d8077d158720.png';var un_praised_icon='http://static.shihuocdn.cn/app/res/dsgn/79577cabf39d4dc09af2d48b42a7c267.png';var praised_animated='http://static.shihuocdn.cn/admin/files/20220826/03074265e9e14ae2b18229bf516dfbd9.webp';var animated_svga='http://static.shihuocdn.cn/app/res/dsgn/ab45f0ee9d5b454badb02fe85a29c256.svga';var user_level_1='http://static.shihuocdn.cn/admin/files/20220830/1dc074021fc6b5f706de782042fed04e.png';var user_level_2='http://static.shihuocdn.cn/admin/files/20220830/7f4f3d0a182686e5766946afa122a3f7.png';var user_level_3='http://static.shihuocdn.cn/admin/files/20220830/0a1a00fa186d88222513a22d12e474bc.png';var screen=typeof window!=='undefined'&&window.screen;var isIOS=typeof window!=='undefined'&&/ios|iphone|ipad/i.test(navigator.userAgent);var vCardWidth=typeof window!=='undefined'&&(window.innerWidth-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(12)*2-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9))/2;var requestNotePraised=/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id,channel_type,is_praised){var url,params;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:url='http://apps.shihuo.cn/app_swoole_common/praise';params={id:id,channel_type:channel_type,status:is_praised?'1':'2'};console.log('requestNotePraised',params);return _context.abrupt("return",new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_26__utils_request__["a" /* default */])({url:url,method:'GET',params:params}).then(function(value){resolve(value);})["catch"](function(err){reject(err);});}));case 4:case"end":return _context.stop();}}},_callee);}));return function requestNotePraised(_x,_x2,_x3){return _ref.apply(this,arguments);};}();function getUserLevelImg(level){switch(level){case 1:return user_level_1;case 2:return user_level_2;case 3:return user_level_3;default:return user_level_1;}}function getNoteNumberOfLines(item,widgetWidth){var _item$name=item.name,name=_item$name===void 0?'':_item$name;var lineWidth=widgetWidth-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10)*2;return getNumberOfLines(name,lineWidth,Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(13));}function getNumberOfLines(title,widgetWidth,fontSize){var isContainSpace=title.indexOf('\n');if(isContainSpace<0){isContainSpace=title.indexOf('\r');}if(isContainSpace>-1){return 2;}var nameLength=Object(__WEBPACK_IMPORTED_MODULE_25__BytesCount__["a" /* getByteCount */])(title);var totalWidth=nameLength/2.0*fontSize;if(totalWidth<=widgetWidth){return 1;}else{return 2;}}function getWidgetHeight(item,widgetWidth){var numberOfLines=getNoteNumberOfLines(item,widgetWidth);var data=item;var _data$title=data.title,title=_data$title===void 0?'':_data$title,_data$img_w=data.img_w,img_w=_data$img_w===void 0?1:_data$img_w,_data$img_h=data.img_h,img_h=_data$img_h===void 0?1:_data$img_h;var ratio=(img_h>0?img_h:1)/(img_w>0?img_w:1);ratio=Math.min(ratio,4.0/3.0);ratio=Math.max(ratio,3.0/4.0);var cardHeight=widgetWidth*ratio+Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9);cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8);// 图片和标题的间隔
if(numberOfLines==1){cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18);}if(numberOfLines==2){cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18)*2;}cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8)+Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18);return cardHeight;}var SHNoteCommonVertFlatStyle3Widget=/*#__PURE__*/function(_Component){_inherits(SHNoteCommonVertFlatStyle3Widget,_Component);var _super=_createSuper(SHNoteCommonVertFlatStyle3Widget);function SHNoteCommonVertFlatStyle3Widget(props){var _this;_classCallCheck(this,SHNoteCommonVertFlatStyle3Widget);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"_isShowTip",function(is_video,show_type,type,format_duration){var show=false;var icon='';var text='';if(is_video==1){show=true;icon=play_icon;text=format_duration;}else if(show_type=='single28'){show=true;icon=article_icon;text='文章';}else if(type==1){show=true;icon=article_icon;text='攻略';}return{show:show,icon:icon,text:text};});_defineProperty(_assertThisInitialized(_this),"_onLogin",function(){window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});});_defineProperty(_assertThisInitialized(_this),"_onPress",function(){_this.props.onPress&&_this.props.onPress();});_defineProperty(_assertThisInitialized(_this),"_onZanPress",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var isLogin,_this$props$itemIndex,itemIndex,dataSource,_dataSource$note_id,note_id,_dataSource$channel_t,channel_type,_dataSource$is_praise,is_praise,_dataSource$praiseNum,praiseNum;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:isLogin=_this.props.isLogin;if(isLogin){_context2.next=4;break;}_this._onLogin();return _context2.abrupt("return");case 4:_this$props$itemIndex=_this.props.itemIndex,itemIndex=_this$props$itemIndex===void 0?0:_this$props$itemIndex;dataSource=_this.props.dataSource;_dataSource$note_id=dataSource.note_id,note_id=_dataSource$note_id===void 0?'':_dataSource$note_id,_dataSource$channel_t=dataSource.channel_type,channel_type=_dataSource$channel_t===void 0?'4':_dataSource$channel_t,_dataSource$is_praise=dataSource.is_praise,is_praise=_dataSource$is_praise===void 0?false:_dataSource$is_praise,_dataSource$praiseNum=dataSource.praiseNum,praiseNum=_dataSource$praiseNum===void 0?0:_dataSource$praiseNum;praiseNum=parseInt(praiseNum);dataSource.is_praise=!is_praise;praiseNum+=!is_praise?1:-1;dataSource.praiseNum=praiseNum;_this.setState({animated:!is_praise},function(){var _this$state$animated=_this.state.animated,animated=_this$state$animated===void 0?false:_this$state$animated;if(animated){setTimeout(function(){_this.setState({animated:false});},400);}});requestNotePraised(note_id,channel_type,!is_praise).then(function(value){})["catch"](function(err){});case 13:case"end":return _context2.stop();}}},_callee2);})));_this.state={animated:false// dataSource: {}
};_this.cardWidth=props.cardWidth||vCardWidth;return _this;}_createClass(SHNoteCommonVertFlatStyle3Widget,[{key:"componentDidMount",value:function componentDidMount(){// this.setState({
//     dataSource: this.props.dataSource || {}
// })
}},{key:"render",value:function render(){var _this2=this;var _this$props$dataSourc=this.props.dataSource,_this$props$dataSourc2=_this$props$dataSourc.img,img=_this$props$dataSourc2===void 0?'':_this$props$dataSourc2,_this$props$dataSourc3=_this$props$dataSourc.profilePic,profilePic=_this$props$dataSourc3===void 0?'':_this$props$dataSourc3,_this$props$dataSourc4=_this$props$dataSourc.nickname,nickname=_this$props$dataSourc4===void 0?'':_this$props$dataSourc4,_this$props$dataSourc5=_this$props$dataSourc.praiseNum,praiseNum=_this$props$dataSourc5===void 0?'':_this$props$dataSourc5,_this$props$dataSourc6=_this$props$dataSourc.img_w,img_w=_this$props$dataSourc6===void 0?1:_this$props$dataSourc6,_this$props$dataSourc7=_this$props$dataSourc.img_h,img_h=_this$props$dataSourc7===void 0?1:_this$props$dataSourc7,_this$props$dataSourc8=_this$props$dataSourc.praise,praise=_this$props$dataSourc8===void 0?0:_this$props$dataSourc8,_this$props$dataSourc9=_this$props$dataSourc.is_praise,is_praise=_this$props$dataSourc9===void 0?false:_this$props$dataSourc9,_this$props$dataSourc10=_this$props$dataSourc.is_video,is_video=_this$props$dataSourc10===void 0?0:_this$props$dataSourc10,_this$props$dataSourc11=_this$props$dataSourc.video,video=_this$props$dataSourc11===void 0?{}:_this$props$dataSourc11,_this$props$dataSourc12=_this$props$dataSourc.name,name=_this$props$dataSourc12===void 0?'':_this$props$dataSourc12,_this$props$dataSourc13=_this$props$dataSourc.format_duration,format_duration=_this$props$dataSourc13===void 0?'00:00':_this$props$dataSourc13,_this$props$dataSourc14=_this$props$dataSourc.show_type,show_type=_this$props$dataSourc14===void 0?'':_this$props$dataSourc14,_this$props$dataSourc15=_this$props$dataSourc.type,type=_this$props$dataSourc15===void 0?0:_this$props$dataSourc15,_this$props$dataSourc16=_this$props$dataSourc.level,level=_this$props$dataSourc16===void 0?0:_this$props$dataSourc16;var numberOfLines=getNoteNumberOfLines(this.props.dataSource,this.cardWidth);var ratio=(img_h>0?img_h:1)/(img_w>0?img_w:1);ratio=Math.min(ratio,4.0/3.0);ratio=Math.max(ratio,3.0/4.0);var _this$state$animated2=this.state.animated,animated=_this$state$animated2===void 0?false:_this$state$animated2;img=img.split('#keepOn').join('');if(is_video==1){var videoImg=video.img||'';if(videoImg.length>0){img=videoImg.split('#keepOn').join('');}}var tipObj=this._isShowTip(is_video,show_type,type,format_duration);var containerHeight=getWidgetHeight(this.props.dataSource,this.cardWidth);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-card",style:_objectSpread(_objectSpread({},styles.container),{},{width:this.cardWidth,height:containerHeight-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9)})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"note-content",style:styles.content,onClick:function onClick(){return _this2._onPress();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-img-wrap",style:_objectSpread(_objectSpread({},styles.img),{},{height:this.cardWidth*ratio,position:'relative'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__["LazyLoadImage"],{key:this.props.key,className:"node-img",src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img),effect:"opacity",wrapperProps:{style:{transitionDuration:'700ms'}},style:{width:'100%',height:'100%',objectFit:'cover',borderRadius:styles.img.borderRadius,display:'block'}// onClick={() => {
//     if (isIOS) {
//         this._onPress();
//     }
// }}
}),tipObj.show?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-video",style:_objectSpread(_objectSpread({},styles.video),{},{backgroundImage:"url(".concat(bottom_bg_icon,")"),backgroundSize:'cover',backgroundPosition:'center',backgroundRepeat:'no-repeat'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-video-text",style:{display:'flex',flexDirection:'row',alignItems:'center',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(16),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),width:'100%',boxSizing:'border-box'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"node-video-icon",src:tipObj.icon,alt:"tip-icon",style:is_video==1?styles.video_icon:styles.article_icon}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{style:styles.video_text,className:"node-video-tip"},tipObj.text))):null),name.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"node-title",style:_objectSpread(_objectSpread({},styles.title),{},{height:numberOfLines*Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),lineHeight:'18px',display:'-webkit-box',WebkitLineClamp:numberOfLines,WebkitBoxOrient:'vertical',overflow:'hidden'})},name):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-bottom",style:styles.bottom},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-avatar-wrap",style:styles.avatar},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"node-avatar",src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(profilePic,Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(40)),alt:"avatar",style:{width:'100%',height:'100%',borderRadius:styles.avatar.borderRadius,objectFit:'cover',display:'block'}}),level!=0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"node-avatar-level",src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(getUserLevelImg(level),Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(16)),alt:"level",style:styles.avatar_level}):null),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{className:"node-author-name",style:_objectSpread(_objectSpread({},styles.author_name),{},{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}),title:nickname},nickname),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-zan-container",style:styles.zanContainer,onClick:function onClick(e){e.stopPropagation();_this2._onZanPress();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:animated?praised_animated:is_praise?praised_icon:un_praised_icon,alt:"like",style:styles.zan}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:!is_praise?praised_icon:un_praised_icon,alt:"",style:styles.zanPreload}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{style:styles.zanNum},"".concat(praiseNum)))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{style:{width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4)}})));}}]);return SHNoteCommonVertFlatStyle3Widget;}(__WEBPACK_IMPORTED_MODULE_22_react__["Component"]);SHNoteCommonVertFlatStyle3Widget.propTypes={dataSource:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,itemIndex:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.number,onZanPress:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func};SHNoteCommonVertFlatStyle3Widget.defaultProps={dataSource:{},itemIndex:0,onZanPress:function onZanPress(){}};var styles={container:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9),overflow:'hidden'},content:{width:'100%',borderRadius:6,backgroundColor:'#ffffff',overflow:'hidden',flex:1},img:{width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(233),overflow:'hidden',borderRadius:6},video:{position:'absolute',bottom:0,left:0,display:'flex',flexDirection:'row',alignItems:'flex-end',// alignItems: 'center',
// alignContent: 'flex-end',
width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(28)},video_icon:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10),width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(12),marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(1)},article_icon:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10),width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(11),marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(2)},video_text:{fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(11),color:'white',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(3)},title:{fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(13),color:'#333333',marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),textAlign:'left'},bottom:{display:'flex',flexDirection:'row',alignItems:'center',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4)},avatar:{width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18)/2.0},avatar_level:{width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8),position:'absolute',right:-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(2),bottom:0},author_name:{fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(11),color:'#666666',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(5),flex:1},zanContainer:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(0),height:'100%',display:'flex',flexDirection:'row',alignItems:'center'},zan:{width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20)},zanPreload:{position:'absolute',opacity:0,backgroundColor:'red',width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20)},zanNum:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(0),fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(12),color:'#666666',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(16)}};/* harmony default export */ __webpack_exports__["default"] = ({widget:SHNoteCommonVertFlatStyle3Widget,getWidgetHeight:getWidgetHeight,showStyleList:false});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CountDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__px2rem__ = __webpack_require__(42);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */String.prototype.colorRgb=function(){var sColor=this.toLowerCase();//十六进制颜色值的正则表达式
var reg=/^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;// 如果是16进制颜色
if(sColor&&reg.test(sColor)){if(sColor.length===4){var sColorNew="#";for(var i=1;i<4;i+=1){sColorNew+=sColor.slice(i,i+1).concat(sColor.slice(i,i+1));}sColor=sColorNew;}//处理六位的颜色值
var sColorChange=[];for(var i=1;i<7;i+=2){sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));}return"rgba("+sColorChange.join(",")+', 0.5'+")";}return sColor;};var CountDown=/*#__PURE__*/function(_React$Component){_inherits(CountDown,_React$Component);var _super=_createSuper(CountDown);function CountDown(props){var _this;_classCallCheck(this,CountDown);_this=_super.call(this,props);_this.state={count_down:{d:"00",h:"00",m:"00",s:"00"}};_this.isEnded=false;_this.timer=null;return _this;}_createClass(CountDown,[{key:"componentDidMount",value:function componentDidMount(){var countDownTime=this.props.countDownTime;if(countDownTime){countDownTime=countDownTime.replace('T',' ');this.startCountDown(countDownTime);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.timer=null;this.isEnded=false;}},{key:"renderCountDown",value:function renderCountDown(){var _this$props=this.props,countDownTextColor=_this$props.countDownTextColor,countDownBgColor=_this$props.countDownBgColor;var _this$state$count_dow=this.state.count_down,d=_this$state$count_dow.d,h=_this$state$count_dow.h,m=_this$state$count_dow.m,s=_this$state$count_dow.s;countDownBgColor=countDownBgColor.colorRgb();if(!this.isEnded){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].isIphoneX()?'count-down iphoneX':'count-down',style:{color:countDownTextColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("span",{style:{marginRight:Object(__WEBPACK_IMPORTED_MODULE_14__px2rem__["a" /* default */])('-5px')}},"\u8DDD\u7ED3\u675F\uFF1A"),d!=="00"?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("span",null,(String(d).length>=3?'99':d)+'天'):'',/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"square",style:{backgroundColor:countDownBgColor}},h),":",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"square",style:{backgroundColor:countDownBgColor}},m),":",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"square",style:{backgroundColor:countDownBgColor}},s));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* default */].isIphoneX()?'count-down iphoneX':'count-down',style:{color:countDownTextColor}},"\u6D3B\u52A8\u5DF2\u7ED3\u675F");}}},{key:"render",value:function render(){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,this.renderCountDown());}},{key:"startCountDown",value:function startCountDown(end_time){var _this2=this;if(this.timer){clearInterval(this.timer);this.timer=null;}var timestramp=end_time.replace(/-/g,"/");var finish_time=new Date(timestramp).getTime();var count_down=this.countDown(finish_time);this.setState({count_down:count_down});this.timer=setInterval(function(){// 计算倒计时
finish_time=new Date(timestramp).getTime();count_down=_this2.countDown(finish_time);_this2.setState({count_down:count_down});},1000);}},{key:"countDown",value:function countDown(t){var n=new Date().getTime(),c=t-n,d,h,m,s;// 结束执行
if(c<=0){this.isEnded=true;return{d:"00",h:"00",m:"00",s:"00"};}d=parseInt(c/1000/60/60/24);h=parseInt(c/1000/60/60-24*d);m=parseInt(c/1000/60-24*60*d-60*h);s=parseInt(c/1000-24*60*60*d-60*60*h-60*m);if(s<10){s="0"+s;}if(m<10){m="0"+m;}if(h<10){h="0"+h;}if(d<10){d="0"+d;}return{d:d,h:h,m:m,s:s};}}]);return CountDown;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CountDown);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SHCardPriceView__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}var _goodsCardSkuImgText,_goodsCardSkuText;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NumberOrText=__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.number]);// Web 版 A8 扁平商品卡，实现与 RN 版尽量一致的逻辑
var isAndroid=__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].isAndroid();var shihuo=typeof window!=='undefined'&&window.shihuo;var screen=typeof window!=='undefined'&&window.screen;var innerWidth=typeof window!=='undefined'&&window.innerWidth;var innerHeight=typeof window!=='undefined'&&window.innerHeight;var vCardWidth=typeof window!=='undefined'&&(innerWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["c" /* px2dpSmall */])(12)*2-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["c" /* px2dpSmall */])(9))/2;var kCharacter=' | ';var baseStyle={containerMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(18),imgMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),bottomWordsHeight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(36),bottomWordsWidth:vCardWidth,bottomTagsHeight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),bottomTagsMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),bottomTagsMarginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(32),bottomTagsWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(302),bottomTagsRankMarginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),nameMarginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)};var styles=pageStyles;function getImgHeight(item,cardWidth){var img_w=item.img_w,img_h=item.img_h;var cw=cardWidth||180;var imgWidth=cw*2;var imgHeight=imgWidth;if(img_w&&img_h&&+img_w>0&&+img_h>0){imgHeight=imgWidth*(+img_h/+img_w);}return imgHeight;}function calculateWords(name,spec_name){var sh_scale_factor=innerWidth/375;var maxWordLength=Math.floor(40*sh_scale_factor);var blackWord='...';var blankLength=getByteCount(blackWord);var kCharacterLength=getByteCount(kCharacter);var desc=name;if(spec_name&&spec_name.length>0){var nameLength=getByteCount(name);var specLength=getByteCount(kCharacter+spec_name);var currentMaxLength=nameLength+kCharacterLength+specLength;if(currentMaxLength<=maxWordLength){desc=name+kCharacter+spec_name;}else{var cNameLength=maxWordLength-specLength-blankLength-kCharacterLength<0?0:maxWordLength-specLength-blankLength-kCharacterLength;if(nameLength>maxWordLength&&specLength>maxWordLength){desc=handleName(name,18)+blackWord+kCharacter+handleName(spec_name,22);}else if(nameLength>maxWordLength){// 会出现相加的结果还是展示不下,则给name多截取一个字段
var subStringCName=cNameLength>1?cNameLength-1:cNameLength;desc=handleName(name,subStringCName)+blackWord+kCharacter+spec_name;}else if(specLength>maxWordLength){desc=handleName(name,cNameLength)+blackWord+kCharacter+handleName(spec_name,maxWordLength);}else{desc=handleName(name,cNameLength)+blackWord+kCharacter+spec_name;}}}return desc;}function getTags(dataSource){var _dataSource$labels=dataSource.labels,labels=_dataSource$labels===void 0?[]:_dataSource$labels,_dataSource$v_datas=dataSource.v_datas,v_datas=_dataSource$v_datas===void 0?[]:_dataSource$v_datas;var bottomTagList=[];var totalWidth=0;for(var i in labels){var item=labels[i];var activityImageWidth=0.0;if(item.type=='ACTIVITY'){if(item.activity_img&&item.activity_img.length>0){if(item.activity_img_ratio&&parseFloat(item.activity_img_ratio)>0){activityImageWidth=baseStyle.bottomTagsHeight*parseFloat(item.activity_img_ratio);}else{continue;}}}totalWidth+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)+(getByteCount(item.text)*Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10)+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8))+activityImageWidth;if(totalWidth<=baseStyle.bottomTagsWidth){bottomTagList.push(item);}}var label_types=bottomTagList.map(function(it,index){return it.type||'';}).join(',');var label_text=bottomTagList.map(function(it,index){return it.text||'';}).join(',');var rec_word_types='';var rec_word_text='';var wordsData={};var vDatas0=v_datas&&v_datas!=null&&v_datas.length>0?v_datas[0]:{};var item_datas=vDatas0.item_datas&&vDatas0.item_datas!=null&&vDatas0.item_datas.length>0?vDatas0.item_datas:[];if(v_datas&&v_datas!=null&&v_datas.length>0){if(item_datas&&item_datas!=null&&item_datas.length>0){wordsData=item_datas[0];rec_word_types=vDatas0.type||'';rec_word_text=wordsData.text||'';}}return{label_types:label_types,label_text:label_text,rec_word_text:rec_word_text,rec_word_types:rec_word_types};}function getContainerHeight(item){var cardWidth=arguments.length>1&&arguments[1]!==undefined?arguments[1]:vCardWidth;var _item$formatN=item.formatN,formatN=_item$formatN===void 0?'':_item$formatN,_item$style_img_list=item.style_img_list,style_img_list=_item$style_img_list===void 0?[]:_item$style_img_list,spec_name=item.spec_name,benefits=item.benefits,name=item.name,attrLabels=item.attrLabels,labels=item.labels,_item$v_datas=item.v_datas,v_datas=_item$v_datas===void 0?[]:_item$v_datas,isBlackBgImg=item.isBlackBgImg,cateType=item.cateType,whiteBgImgFlag=item.whiteBgImgFlag,beltImg=item.beltImg,_item$nameLineBreak=item.nameLineBreak,nameLineBreak=_item$nameLineBreak===void 0?false:_item$nameLineBreak;var imgHeight=getImgHeight(item,cardWidth);// 图片背景图上间距
// const imgMarginTop = parseInt(cateType) == 3 && parseInt(whiteBgImgFlag) == 1 ? baseStyle.imgMarginTop : 0;
// let containerHeight = imgMarginTop + px2dp(imgHeight);
var containerHeight=imgHeight/2;// 文字上间距是否置空
var nameTopHasData=false;if(formatN&&parseInt(formatN)==3){if(style_img_list&&style_img_list.length>0){var _style_img_list$0$for=style_img_list[0].formatNType,formatNType=_style_img_list$0$for===void 0?0:_style_img_list$0$for;if(formatNType==2){// 口红一行3
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(90+8);nameTopHasData=true;}else if(formatNType==3){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88+8);nameTopHasData=true;}else{// 一行3
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88+8);nameTopHasData=true;}}}else if(formatN&&parseInt(formatN)==5&&style_img_list&&style_img_list.length>0){// 一行5
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56+8);nameTopHasData=true;}// 是否有腰带
if(beltImg&&beltImg.length>0){nameTopHasData=true;}if(whiteBgImgFlag==false){nameTopHasData=true;}// 标题高度
var desc=calculateWords(name,spec_name);var nameLength=getByteCount(desc);if(nameLength>22&&nameLineBreak){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(40)*2+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8);}else{containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(40)+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8);}// 文字顶部只是白底图则减少文字上边距
// if (nameTopHasData == false) {
//     containerHeight -= baseStyle.nameMarginTop;
// }
// 标签高度
// if (getSplitAttributeTagStr(attrLabels).length > 0) {
//     containerHeight += px2dp(36);
// }
//价格距离上边模块2
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2);// 价格高度
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(50);if(v_datas&&v_datas!=null&&v_datas.length>0){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1);containerHeight+=baseStyle.bottomWordsHeight;}else if(labels&&labels.length>0){// 标签高度
var tags=[];for(var i in labels){var _item=labels[i];if(_item.type=='ACTIVITY'){if(_item.activity_img&&_item.activity_img.length>0){if(_item.activity_img_ratio&&parseFloat(_item.activity_img_ratio)>0){}else{continue;}}}tags.push(_item);}if(tags.length>0){containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1);containerHeight+=baseStyle.bottomWordsHeight;}}// 最底部间距
containerHeight+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4);return containerHeight;}function getWidgetHeight(item,widgetWidth){return getContainerHeight(item,widgetWidth)+baseStyle.containerMarginTop;}function getByteCount(str){if(!str||!str.length){return 0;}var count=0;for(var i=0;i<str.length;i++){var c=str.charAt(i);if(c==='1'){count+=0.46;}else if(c==='.'){count+=0.29;}else if(c===' '){count+=0.25;}else if(/^[\u0000-\u00ff]$/.test(c)){count+=1;}else{count+=2;}}return count;}function handleName(str,num){var count=0;var i=0;for(;i<str.length;i++){var c=str.charAt(i);if(c==='1'){count+=0.46;}else if(c==='.'){count+=0.29;}else if(c===' '){count+=0.5;}else if(/^[\u0000-\u00ff]$/.test(c)){if(/[A-Z]/.test(c)){count+=1.2;}else{count+=1;}}else{count+=2;}if(count>num){break;}}return str.substring(0,i);}function getStyle3Imgs(){var style_imgs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var item=arguments.length>1?arguments[1]:undefined;// 截取四个配色，第一个配色作为主图（大图），剩下三个作为配色图
var result=style_imgs.slice(0,4);// 一个配色都没有是异常情况
if(result.length==0){result.push(_objectSpread({},item));}return result;}function getStyleImgs(){var style_imgs=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var item=arguments.length>1?arguments[1]:undefined;// 截取5个配色，第一个配色作为主图（大图），剩下三个作为配色图
var result=style_imgs.slice(0,6);if(result.length==0){result.push(_objectSpread({},item));}return result;}function getSplitAttributeTagStr(attributeList){var attributeModelList=attributeList;// 如果数组是空则返回空字符
if(!attributeModelList||attributeModelList.length===0){return'';}var attributeTagStr='';for(var i=0;i<3;i++){var item=attributeModelList[i];if(item){attributeTagStr=attributeTagStr+item+' | ';}}var attributeTagStr2=attributeTagStr.substring(0,attributeTagStr.length-3);var count=attributeTagStr2.split(' | ').length;var lastAttributeTagStr=attributeTagStr2;switch(count){case 1:lastAttributeTagStr=attributeTagStr2.substring(0,14);break;case 2:lastAttributeTagStr=attributeTagStr2.substring(0,16);break;case 3:lastAttributeTagStr=attributeTagStr2.substring(0,18);break;default:break;}return lastAttributeTagStr;}var GoodsImage=/*#__PURE__*/function(_Component){_inherits(GoodsImage,_Component);var _super=_createSuper(GoodsImage);function GoodsImage(props){var _this;_classCallCheck(this,GoodsImage);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"setImgVisible",function(imgVisible){_this.setState({imgVisible:imgVisible});});_this.state={imgVisible:true};return _this;}_createClass(GoodsImage,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props=this.props,styles=_this$props.styles,img=_this$props.img,imgHeight=_this$props.imgHeight,beltImg=_this$props.beltImg,beltFrameImg=_this$props.beltFrameImg,isBlackBgImg=_this$props.isBlackBgImg,cateType=_this$props.cateType,whiteBgImgFlag=_this$props.whiteBgImgFlag,_this$props$goodsImgF=_this$props.goodsImgFadeDuration,goodsImgFadeDuration=_this$props$goodsImgF===void 0?-1:_this$props$goodsImgF,_this$props$img_w=_this$props.img_w,img_w=_this$props$img_w===void 0?'':_this$props$img_w,_this$props$img_h=_this$props.img_h,img_h=_this$props$img_h===void 0?'':_this$props$img_h;var imgVisible=this.state.imgVisible;var isRatio5_4=parseFloat(img_w)/parseFloat(img_h)==5.0/4.0;var defaultStyle=!(parseInt(cateType)!=3||isBlackBgImg==1);var containerStyle={width:'100%',height:imgHeight/2,overflow:'hidden'};var imgStyle=defaultStyle?styles.img:isRatio5_4?styles.ratio5_4Img:styles.blackImg;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:containerStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__["LazyLoadImage"],{key:this.props.key,style:imgStyle,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,imgHeight):'',effect:"opacity",wrapperProps:{style:{transitionDuration:'700ms'}}}),beltFrameImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.beltFrameImg,src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(beltFrameImg),alt:"belt-frame"}):null,beltImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.blackBeltImg,src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(beltImg),alt:"belt"}):null);}}]);return GoodsImage;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 3：图片 + 文本
var GoodsStyle3ImageView=/*#__PURE__*/function(_Component2){_inherits(GoodsStyle3ImageView,_Component2);var _super2=_createSuper(GoodsStyle3ImageView);function GoodsStyle3ImageView(props){var _this2;_classCallCheck(this,GoodsStyle3ImageView);_this2=_super2.call(this,props);_defineProperty(_assertThisInitialized(_this2),"setImgVisible",function(imgVisible){_this2.setState({imgVisible:imgVisible});});_this2.state={imgVisible:true};return _this2;}_createClass(GoodsStyle3ImageView,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props2=this.props,styles=_this$props2.styles,showingStyleImgs=_this$props2.showingStyleImgs,cardWidth=_this$props2.cardWidth;var imgVisible=this.state.imgVisible;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku3ImgTextView},showingStyleImgs.map(function(item,index){var _item$name=item.name,name=_item$name===void 0?'':_item$name,_item$img=item.img,img=_item$img===void 0?'':_item$img,_item$newProductIcon=item.newProductIcon,newProductIcon=_item$newProductIcon===void 0?'':_item$newProductIcon;var text=handleName(name,8);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorder3),{},{marginHorizontal:index===1?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88*3)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48))/2:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuImgT,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,88):'',alt:"style"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.goodsCardSkuImgText),{},{lineClamp:1})},text),newProductIcon&&newProductIcon.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuLogoImage,src:newProductIcon,alt:"new"}):null);}));}}]);return GoodsStyle3ImageView;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 3：色块 + 文本
var GoodsStyle3View=/*#__PURE__*/function(_Component3){_inherits(GoodsStyle3View,_Component3);var _super3=_createSuper(GoodsStyle3View);function GoodsStyle3View(props){_classCallCheck(this,GoodsStyle3View);return _super3.call(this,props);}_createClass(GoodsStyle3View,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props3=this.props,styles=_this$props3.styles,showingStyleImgs=_this$props3.showingStyleImgs,cardWidth=_this$props3.cardWidth;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku3View},showingStyleImgs.map(function(item,index){var _item$name2=item.name,name=_item$name2===void 0?'':_item$name2,_item$color_hex=item.color_hex,color_hex=_item$color_hex===void 0?'':_item$color_hex,_item$newProductIcon2=item.newProductIcon,newProductIcon=_item$newProductIcon2===void 0?'':_item$newProductIcon2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorderV3),{},{marginHorizontal:index===1?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88*3)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48))/2:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},styles.goodsCardSkuColor),{},{backgroundColor:color_hex})}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:styles.goodsCardSkuText},name),newProductIcon&&newProductIcon.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuLogoImage,src:newProductIcon,alt:"new"}):null);}));}}]);return GoodsStyle3View;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 3：纯图片
var GoodsStyle3Image=/*#__PURE__*/function(_Component4){_inherits(GoodsStyle3Image,_Component4);var _super4=_createSuper(GoodsStyle3Image);function GoodsStyle3Image(props){var _this3;_classCallCheck(this,GoodsStyle3Image);_this3=_super4.call(this,props);_defineProperty(_assertThisInitialized(_this3),"setImgVisible",function(imgVisible){_this3.setState({imgVisible:imgVisible});});_this3.state={imgVisible:true};return _this3;}_createClass(GoodsStyle3Image,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props4=this.props,styles=_this$props4.styles,showingStyleList=_this$props4.showingStyleList,cardWidth=_this$props4.cardWidth;var imgVisible=this.state.imgVisible;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku3},showingStyleList.map(function(item,index){var _item$img2=item.img,img=_item$img2===void 0?'':_item$img2,_item$newProductIcon3=item.newProductIcon,newProductIcon=_item$newProductIcon3===void 0?'':_item$newProductIcon3;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorder3),{},{marginHorizontal:index===1?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88*3)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48))/2:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuImage3,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,88):'',alt:"style"}),newProductIcon&&newProductIcon.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuLogoImage,src:newProductIcon,alt:"new"}):null);}));}}]);return GoodsStyle3Image;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);// 一拖 5：小图
var GoodsStyleImage=/*#__PURE__*/function(_Component5){_inherits(GoodsStyleImage,_Component5);var _super5=_createSuper(GoodsStyleImage);function GoodsStyleImage(props){var _this4;_classCallCheck(this,GoodsStyleImage);_this4=_super5.call(this,props);_defineProperty(_assertThisInitialized(_this4),"setImgVisible",function(imgVisible){_this4.setState({imgVisible:imgVisible});});_this4.state={imgVisible:true};return _this4;}_createClass(GoodsStyleImage,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){return JSON.stringify(this.state)!=JSON.stringify(nextState)||JSON.stringify(this.props)!=JSON.stringify(nextProps);}},{key:"render",value:function render(){var _this$props5=this.props,styles=_this$props5.styles,showingStyleImgs=_this$props5.showingStyleImgs,onStyleItemPress=_this$props5.onStyleItemPress,cardWidth=_this$props5.cardWidth;var imgVisible=this.state.imgVisible;var gap=(cardWidth-56*5-(32+16))/4;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.goodsCardSku},showingStyleImgs.map(function(item,index){var _item$img3=item.img,img=_item$img3===void 0?'':_item$img3;var itemStyle={overflow:'hidden',width:56,height:56,border:'1px solid #f1f1f1',borderRadius:4,marginLeft:index===0?0:gap,boxSizing:'border-box'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"sku_".concat(index),style:_objectSpread(_objectSpread({},styles.goodsCardSkuBorder),{},{marginHorizontal:index===1||index===2||index===3?(cardWidth-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56*5)-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(32+16))/4:0})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:styles.goodsCardSkuImage,src:imgVisible?Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img,56):'',alt:"style"}));}));}}]);return GoodsStyleImage;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);var SHGoodsCommonVertFlatStyle8Widget=/*#__PURE__*/function(_Component6){_inherits(SHGoodsCommonVertFlatStyle8Widget,_Component6);var _super6=_createSuper(SHGoodsCommonVertFlatStyle8Widget);function SHGoodsCommonVertFlatStyle8Widget(props){var _this5;_classCallCheck(this,SHGoodsCommonVertFlatStyle8Widget);_this5=_super6.call(this,props);_defineProperty(_assertThisInitialized(_this5),"setImgVisible",function(imgVisible){_this5.goodsImgRef&&_this5.goodsImgRef.setImgVisible(imgVisible);_this5.goodsStyleImgRef&&_this5.goodsStyleImgRef.setImgVisible(imgVisible);});_defineProperty(_assertThisInitialized(_this5),"_updateParentWidth",function(){if(!_this5.bottomRef||!_this5.bottomRef.getBoundingClientRect){return;}var rect=_this5.bottomRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({parentWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_updatePriceViewWidth",function(){if(!_this5.priceViewRef||!_this5.priceViewRef.getBoundingClientRect){return;}var rect=_this5.priceViewRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({priceViewWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_updateInfoViewWidth",function(){if(!_this5.infoViewRef||!_this5.infoViewRef.getBoundingClientRect){return;}var rect=_this5.infoViewRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({infoViewWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_updateHotViewWidth",function(){if(!_this5.hotViewRef||!_this5.hotViewRef.getBoundingClientRect){return;}var rect=_this5.hotViewRef.getBoundingClientRect();var width=rect&&rect.width?rect.width:0;_this5.setState({hotViewWidth:width});});_defineProperty(_assertThisInitialized(_this5),"_renderRecommendView",function(data,count,index){var _data$dsl=data.dsl,dsl=_data$dsl===void 0?'':_data$dsl;switch(dsl){case'HOT_LIST':return _this5._renderHostList(data,count,index);case'NORMAL_TEXT':return _this5._renderNormalText(data,count,index);case'NORMAL_TEXT_ONE':return _this5._renderNormalText(data,count,index);default:return null;}});_defineProperty(_assertThisInitialized(_this5),"_renderHostList",function(data,count,index,isDark){var _data$href=data.href,href=_data$href===void 0?'':_data$href,_data$borderColor=data.borderColor,borderColor=_data$borderColor===void 0?'#FFFFFF':_data$borderColor,_data$backgroundColor=data.backgroundColor,backgroundColor=_data$backgroundColor===void 0?'#FFFFFF':_data$backgroundColor,_data$borderColor_dar=data.borderColor_dark,borderColor_dark=_data$borderColor_dar===void 0?'#242424':_data$borderColor_dar,_data$backgroundColor2=data.backgroundColor_dark,backgroundColor_dark=_data$backgroundColor2===void 0?'#242424':_data$backgroundColor2,_data$item_datas=data.item_datas,item_datas=_data$item_datas===void 0?[]:_data$item_datas;var firstItem={};var secondItem={};var thirdItem={};if(item_datas&&item_datas.length>=3){firstItem=item_datas[0]||{};secondItem=item_datas[1]||{};thirdItem=item_datas[2]||{};}var textStyle=index===0?{maxWidth:125}:{};var containerStyle=_defineProperty({height:'100%',borderRadius:2,border:"1px solid ".concat(isDark?borderColor_dark:borderColor),backgroundColor:isDark?backgroundColor_dark:backgroundColor,display:'flex',flexDirection:'row',alignItems:'center',marginLeft:index>0?4:0,padding:'0 4px',boxSizing:'border-box',overflow:'hidden',cursor:href?'pointer':'default'},"boxSizing",'border-box');var handleClick=function handleClick(){if(href){window.location.href=href;}};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"hot_".concat(index),style:containerStyle,onClick:handleClick},firstItem.img?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:{width:12,height:14,marginRight:2},src:firstItem.img,alt:"hot-left"}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{style:_objectSpread({marginLeft:2,color:isDark?firstItem.textColor_dark||'#666666':firstItem.textColor||'#666666',fontSize:secondItem.fontSize||11,fontFamily:'PingFangSC-Regular',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},textStyle)},secondItem.text||''),thirdItem.img?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:{marginLeft:4,width:6,height:14},src:thirdItem.img,alt:"hot-right"}):null);});_defineProperty(_assertThisInitialized(_this5),"_renderNormalText",function(data,count,index,isDark){var _data$borderColor2=data.borderColor,borderColor=_data$borderColor2===void 0?'#FFFFFF':_data$borderColor2,_data$backgroundColor3=data.backgroundColor,backgroundColor=_data$backgroundColor3===void 0?'#FFFFFF':_data$backgroundColor3,_data$borderColor_dar2=data.borderColor_dark,borderColor_dark=_data$borderColor_dar2===void 0?'#242424':_data$borderColor_dar2,_data$backgroundColor4=data.backgroundColor_dark,backgroundColor_dark=_data$backgroundColor4===void 0?'#242424':_data$backgroundColor4,_data$item_datas2=data.item_datas,item_datas=_data$item_datas2===void 0?[]:_data$item_datas2;var firstItem={};if(item_datas&&item_datas.length>=1){firstItem=item_datas[0]||{};}var _firstItem=firstItem,_firstItem$textColor=_firstItem.textColor,textColor=_firstItem$textColor===void 0?'#666666':_firstItem$textColor,_firstItem$textColor_=_firstItem.textColor_dark,textColor_dark=_firstItem$textColor_===void 0?'#666666':_firstItem$textColor_,_firstItem$fontSize=_firstItem.fontSize,fontSize=_firstItem$fontSize===void 0?11:_firstItem$fontSize,_firstItem$text=_firstItem.text,text=_firstItem$text===void 0?'':_firstItem$text;var spanStyle={marginLeft:index>0?4:0,color:isDark?textColor_dark:textColor,fontSize:fontSize,fontFamily:'PingFangSC-Regular',backgroundColor:isDark?backgroundColor_dark:backgroundColor,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{key:"normal_".concat(index),style:spanStyle},text);});_defineProperty(_assertThisInitialized(_this5),"_renderNormalTexts",function(data,count,index,fontSizeExp){var _data$item_datas3=data.item_datas,item_datas=_data$item_datas3===void 0?[]:_data$item_datas3,_data$backgroundColor5=data.backgroundColor,backgroundColor=_data$backgroundColor5===void 0?'#FFFFFF':_data$backgroundColor5;var firstItem={};if(item_datas&&item_datas.length>=1){firstItem=item_datas[0]||{};}var _firstItem2=firstItem,_firstItem2$textColor=_firstItem2.textColor,textColor=_firstItem2$textColor===void 0?'#666666':_firstItem2$textColor,_firstItem2$fontSize=_firstItem2.fontSize,fontSize=_firstItem2$fontSize===void 0?11:_firstItem2$fontSize,_firstItem2$text=_firstItem2.text,text=_firstItem2$text===void 0?'':_firstItem2$text;var textFontSize=fontSizeExp?11:12;var spanStyle={marginLeft:index>0?4:0,color:textColor,fontSize:textFontSize,fontFamily:'PingFangSC-Regular',backgroundColor:backgroundColor,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{key:"normal_extra_".concat(index),style:spanStyle},text);});_this5.state={priceViewWidth:0,infoViewWidth:0,hotViewWidth:0,parentWidth:0};_this5.cardWidth=props.cardWidth||vCardWidth;return _this5;}_createClass(SHGoodsCommonVertFlatStyle8Widget,[{key:"componentDidMount",value:function componentDidMount(){this._updatePriceViewWidth();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(!prevState.parentWidth){this._updateParentWidth();}if(!prevState.priceViewWidth){this._updatePriceViewWidth();}if(!prevState.infoViewWidth){this._updateInfoViewWidth();}if(!prevState.hotViewWidth){this._updateHotViewWidth();}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){if(JSON.stringify(this.state)!=JSON.stringify(nextState)){return true;}if(JSON.stringify(this.props)!=JSON.stringify(nextProps)){return true;}return false;}},{key:"render",value:function render(){var _this6=this;var _this$props6=this.props,_this$props6$goodsImg=_this$props6.goodsImgFadeDuration,goodsImgFadeDuration=_this$props6$goodsImg===void 0?-1:_this$props6$goodsImg,_this$props6$dataSour=_this$props6.dataSource,dataSource=_this$props6$dataSour===void 0?{}:_this$props6$dataSour,_this$props6$onPress=_this$props6.onPress,onPress=_this$props6$onPress===void 0?function(){}:_this$props6$onPress,_this$props6$onStyleI=_this$props6.onStyleItemPress,onStyleItemPress=_this$props6$onStyleI===void 0?function(){}:_this$props6$onStyleI,_this$props6$onDataIt=_this$props6.onDataItemPress,onDataItemPress=_this$props6$onDataIt===void 0?function(){}:_this$props6$onDataIt,_this$props6$isDark=_this$props6.isDark,isDark=_this$props6$isDark===void 0?false:_this$props6$isDark,_this$props6$h5_expos=_this$props6.h5_exposure_object,h5_exposure_object=_this$props6$h5_expos===void 0?{}:_this$props6$h5_expos;styles=Object(__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["b" /* getColorSchemeStyle */])(pageStyles,isDark);var _dataSource$labels2=dataSource.labels,labels=_dataSource$labels2===void 0?[]:_dataSource$labels2,img=dataSource.img,goods_color_num=dataSource.goods_color_num,model_count=dataSource.model_count,isBlackBgImg=dataSource.isBlackBgImg,whiteBgImgFlag=dataSource.whiteBgImgFlag,cateType=dataSource.cateType,name=dataSource.name,_dataSource$sales_inf=dataSource.sales_info_text,sales_info_text=_dataSource$sales_inf===void 0?'':_dataSource$sales_inf,_dataSource$sales_inf2=dataSource.sales_info_num,sales_info_num=_dataSource$sales_inf2===void 0?'':_dataSource$sales_inf2,_dataSource$price=dataSource.price,price=_dataSource$price===void 0?'--':_dataSource$price,discount=dataSource.discount,_dataSource$formatN=dataSource.formatN,formatN=_dataSource$formatN===void 0?'':_dataSource$formatN,_dataSource$img_w=dataSource.img_w,img_w=_dataSource$img_w===void 0?'':_dataSource$img_w,_dataSource$img_h=dataSource.img_h,img_h=_dataSource$img_h===void 0?'':_dataSource$img_h,_dataSource$style_img=dataSource.style_img_list,style_img_list=_dataSource$style_img===void 0?[]:_dataSource$style_img,_dataSource$benefits=dataSource.benefits,benefits=_dataSource$benefits===void 0?[]:_dataSource$benefits,attrLabels=dataSource.attrLabels,salestyle=dataSource.salestyle,official_price=dataSource.official_price,actCornerImg=dataSource.actCornerImg,_dataSource$beltImg=dataSource.beltImg,beltImg=_dataSource$beltImg===void 0?null:_dataSource$beltImg,_dataSource$beltFrame=dataSource.beltFrameImg,beltFrameImg=_dataSource$beltFrame===void 0?null:_dataSource$beltFrame,_dataSource$spec_name=dataSource.spec_name,spec_name=_dataSource$spec_name===void 0?'':_dataSource$spec_name,_dataSource$v_datas2=dataSource.v_datas,v_datas=_dataSource$v_datas2===void 0?[]:_dataSource$v_datas2,_dataSource$nameLineB=dataSource.nameLineBreak,nameLineBreak=_dataSource$nameLineB===void 0?false:_dataSource$nameLineB,_dataSource$promotion=dataSource.promotion_icon,promotion_icon=_dataSource$promotion===void 0?{}:_dataSource$promotion,_dataSource$price_dat=dataSource.price_datas,price_datas=_dataSource$price_dat===void 0?[]:_dataSource$price_dat,_dataSource$fontSizeE=dataSource.fontSizeExp,fontSizeExp=_dataSource$fontSizeE===void 0?false:_dataSource$fontSizeE;var _promotion_icon$ratio=promotion_icon.ratio,activity_ratio=_promotion_icon$ratio===void 0?1:_promotion_icon$ratio,_promotion_icon$icon=promotion_icon.icon,activity_icon=_promotion_icon$icon===void 0?'':_promotion_icon$icon;var tag={text:discount,tcolor:'#999999',bcolor:'#FFFFFF',bgcolor:'#FFFFFF'};var officialPrice=official_price;var canChooseTxt='';if(+goods_color_num>1){canChooseTxt="".concat(goods_color_num,"\u8272\u53EF\u9009");}else if(+model_count>1){canChooseTxt="".concat(model_count,"\u578B\u53EF\u9009");}var rx='';if(sales_info_text&&sales_info_text.length>0){rx=sales_info_text;}if(sales_info_num&&sales_info_num.length>0){rx+=sales_info_num;}var isIOS=/ios|iphone|ipad/i.test(navigator.userAgent);var sku_type=-1;if(formatN&&parseInt(formatN)==3&&style_img_list&&style_img_list.length>0){var _style_img_list$0$for2=style_img_list[0].formatNType,formatNType=_style_img_list$0$for2===void 0?0:_style_img_list$0$for2;if(formatNType==2){sku_type=2;}else if(formatNType==3){sku_type=3;}else{sku_type=1;}}else if(formatN&&parseInt(formatN)==5&&style_img_list&&style_img_list.length>0){sku_type=5;}var bottomTagList=[];var totalWidth=0;if(labels&&labels.length>0){for(var i=0;i<labels.length;i++){var item=labels[i];var activityImageWidth=0.0;if(item.type=='ACTIVITY'){if(item.activity_img&&item.activity_img.length>0){if(item.activity_img_ratio&&parseFloat(item.activity_img_ratio)>0){activityImageWidth=baseStyle.bottomTagsHeight*parseFloat(item.activity_img_ratio);}}}totalWidth+=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)+(getByteCount(item.text)*Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10)+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8))+activityImageWidth;if(totalWidth<=baseStyle.bottomTagsWidth){bottomTagList.push(item);}}}var wordsData={};var vDatas0=v_datas&&v_datas!=null&&v_datas.length>0?v_datas[0]:{};var item_datas=vDatas0.item_datas&&vDatas0.item_datas!=null&&vDatas0.item_datas.length>0?vDatas0.item_datas:[];if(v_datas&&v_datas!=null&&v_datas.length>0){if(item_datas&&item_datas!=null&&item_datas.length>0){wordsData=item_datas[0];}}var imgHeight=getImgHeight(dataSource,this.cardWidth);var containerHeight=getContainerHeight(dataSource,this.cardWidth);var desc=calculateWords(name,spec_name);var nameLength=getByteCount(desc);var sh_scale_factor=innerWidth/375;var descWordNum=Math.floor(21*sh_scale_factor);if(activity_icon&&activity_icon.length>0){descWordNum=descWordNum-Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*activity_ratio/Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(13));}// 文字上间距是否置空
var nameTopHasData=false;if(sku_type==2||sku_type==3||sku_type==1||sku_type==5){// 一拖三
nameTopHasData=true;}else if(whiteBgImgFlag==false){// 黑底图
nameTopHasData=true;}// 文字顶部间距
// const nameMarginTop = nameTopHasData ? baseStyle.nameMarginTop : 0;
var nameMarginTop=baseStyle.nameMarginTop;// 图片背景图高度
var imageBottomH=parseInt(cateType)==3&&parseInt(whiteBgImgFlag)==1?baseStyle.imgMarginTop:0;var priceFamliy=shihuo.useNewPriceFontFamily?shihuo.priceMediumFontFamily:'PingFangSC-Medium';var numberFamliy='SHIHUOSans-Medium';var onlyOneLine=nameLength<=descWordNum||!nameLineBreak;var hasActivityIcon=activity_icon.length>0;var useTrickPadding=onlyOneLine;var textPaddingRight=useTrickPadding?isIOS?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["c" /* px2dpSmall */])(12):0:0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this6.props.exp&&_this6.props.exp(ele);}},"data-dot":JSON.stringify(h5_exposure_object),className:"goods-card",style:_objectSpread(_objectSpread({},styles.goodsCard),{},{height:containerHeight,width:this.cardWidth}),onClick:onPress},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"goods-card-image-body",style:_objectSpread(_objectSpread({},styles.goodsCardImageBody),{},{height:imgHeight/2})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:{position:'absolute',left:0,top:0,width:'100%',height:'100%',backgroundColor:'#00000005',borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),zIndex:9}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsImage,{ref:function ref(_ref){return _this6.goodsImgRef=_ref;},styles:styles,img:img,goodsImgFadeDuration:goodsImgFadeDuration,beltImg:beltImg,beltFrameImg:beltFrameImg,imgHeight:imgHeight,cardWidth:this.cardWidth,isBlackBgImg:isBlackBgImg,whiteBgImgFlag:whiteBgImgFlag,cateType:cateType,img_w:img_w,img_h:img_h}),actCornerImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{className:"act-img",style:styles.actImg,src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(actCornerImg,64),alt:"act"}):null,canChooseTxt?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"image-tag",style:styles.goodsCardImageTag},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{className:"image-tag-icon",style:styles.goodsCardImageTagIcon,src:"http://static.shihuocdn.cn/admin/files/20200914/102d10c19b6f6a6da07aab18460e0d9d.png",alt:"multi"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{className:"goods-card-image-tag-text",style:styles.goodsCardImageTagText},canChooseTxt)):null),sku_type==1?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyle3Image,{ref:function ref(_ref2){return _this6.goodsStyleImgRef=_ref2;},styles:styles,cardWidth:this.cardWidth,showingStyleList:style_img_list,onStyleItemPress:onStyleItemPress}):sku_type==5?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyleImage,{ref:function ref(_ref3){return _this6.goodsStyleImgRef=_ref3;},styles:styles,cardWidth:this.cardWidth,showingStyleImgs:style_img_list,onStyleItemPress:onStyleItemPress}):sku_type==2?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyle3View,{styles:styles,cardWidth:this.cardWidth,showingStyleImgs:style_img_list,onStyleItemPress:onStyleItemPress}):sku_type==3?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(GoodsStyle3ImageView,{ref:function ref(_ref4){return _this6.goodsStyleImgRef=_ref4;},styles:styles,cardWidth:this.cardWidth,showingStyleImgs:style_img_list,onStyleItemPress:onStyleItemPress}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:{width:'100%',paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),paddingRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),display:'flex',flexDirection:'row',boxSizing:'border-box'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"goods-name",style:_objectSpread(_objectSpread({},styles.name),{},{marginTop:nameMarginTop,// paddingRight: textPaddingRight,
boxSizing:'border-box',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),height:onlyOneLine?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(20):Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(40),lineHeight:'20px',overflow:'hidden',wordBreak:'break-all'})},hasActivityIcon?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",{style:{display:'inline-block',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*activity_ratio+Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14),position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2)}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(activity_icon),alt:"promo",style:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*activity_ratio,height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)}})):null,onlyOneLine?useTrickPadding?desc:handleName(desc,descWordNum):desc)),bottomTagList&&bottomTagList.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.bottomTags},bottomTagList.map(function(tag,index){if(tag.type=='ACTIVITY'){var hasTagImg=tag.activity_img&&tag.activity_img.length>0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:index,style:_objectSpread(_objectSpread({},styles.bottomTagActivityNormal),{},{backgroundColor:tag.bgcolor,borderColor:tag.bcolor,marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)})},tag.activity_img&&tag.activity_img.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{key:index+'ACTIVITY',src:tag.activity_img.indexOf('http')!=-1?tag.activity_img:'http://static.shihuocdn.cn/admin/files/20210823/05e993be26fe39e149f1cccc7492c271.png',alt:"activity",style:_objectSpread(_objectSpread({},styles.bottomTagActivityImg),{},{width:parseFloat(tag.activity_img_ratio)*baseStyle.bottomTagsHeight})}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},hasTagImg?styles.bottomTagActivityTxtContainer:styles.bottomTagActivityNorTxtContainer),{},{borderColor:tag.bcolor||'#ffffff'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.bottomTagActivityTxt),{},{color:tag.tcolor})},tag.text)));}else if(tag.routineImg&&tag.routineImg.length>0){var imgW=Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(14)*tag.routineRatio;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},styles.fanBGView),{},{marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},styles.fanContentView),{},{borderColor:tag.bcolor||'#ffffff'})},tag.routineImg?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{style:_objectSpread(_objectSpread({},styles.fanIconView),{},{width:imgW}),src:tag.routineImg}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.fanTxtBGView},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.fanTxt),{},{color:tag.tcolor||'#ff4338'})},tag.text))));}else if(tag.bgcolor&&tag.bgcolor.indexOf('http')!=-1){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:index+'NEW_GOODS',style:_objectSpread(_objectSpread({},styles.bottomTagNormal),{},{borderRadius:0,borderWidth:0,backgroundColor:tag.bgcolor||'#ffffff',borderColor:tag.bcolor||'#ffffff',marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),backgroundImage:"url(".concat(tag.bgcolor.indexOf('http')!=-1?tag.bgcolor:'http://static.shihuocdn.cn/admin/files/20210823/05e993be26fe39e149f1cccc7492c271.png',")"),backgroundSize:'cover',backgroundRepeat:'no-repeat'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.bottomTagNormalTxt),{},{color:tag.tcolor||'#333333'})},tag.text));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:index,style:_objectSpread(_objectSpread({},styles.bottomTagNormal),{},{backgroundColor:tag.bgcolor,borderColor:tag.bcolor,marginLeft:index==0?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{style:_objectSpread(_objectSpread({},styles.bottomTagNormalTxt),{},{color:tag.tcolor})},tag.text));}})):v_datas&&v_datas!=null&&v_datas.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:styles.bottomWords},v_datas.map(function(item,index){return _this6._renderRecommendView(item,v_datas.length,index);})):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref9){return _this6.bottomRef=_ref9;},style:styles.bottom},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref5){return _this6.priceViewRef=_ref5;},className:"price-view-wrap",style:{display:'flex',flexDirection:'row',alignItems:'center',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__SHCardPriceView__["a" /* default */],{isDark:isDark,price:price,mainPriceStyle:{fontFamily:numberFamliy},symbolStyle:{fontFamily:numberFamliy},dotPriceStyle:{fontFamily:numberFamliy},unitPirceStyle:{fontFamily:priceFamliy}})),function(){var _ref6=_this6.state||{},_ref6$priceViewWidth=_ref6.priceViewWidth,priceViewWidth=_ref6$priceViewWidth===void 0?0:_ref6$priceViewWidth,_ref6$infoViewWidth=_ref6.infoViewWidth,infoViewWidth=_ref6$infoViewWidth===void 0?0:_ref6$infoViewWidth,_ref6$hotViewWidth=_ref6.hotViewWidth,hotViewWidth=_ref6$hotViewWidth===void 0?0:_ref6$hotViewWidth,_ref6$parentWidth=_ref6.parentWidth,parentWidth=_ref6$parentWidth===void 0?0:_ref6$parentWidth;var showInfo=false;var showHot=false;if(priceViewWidth+infoViewWidth+hotViewWidth<parentWidth){showInfo=true;showHot=true;}else if(priceViewWidth+hotViewWidth<parentWidth){showHot=true;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react__["Fragment"],null,showInfo&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref7){return _this6.infoViewRef=_ref7;},className:"info-view",style:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2),display:'flex',flexDirection:'row',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2)}},price_datas.map(function(item,index){return _this6._renderNormalTexts(item,price_datas.length,index);})),showHot&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{ref:function ref(_ref8){return _this6.hotViewRef=_ref8;},className:"hot-view",style:_objectSpread(_objectSpread({},styles.hot),{},{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2),fontSize:fontSizeExp?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(11):Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(12),whiteSpace:'nowrap',textOverflow:'ellipsis',lineClamp:1})},rx));}())));}}]);return SHGoodsCommonVertFlatStyle8Widget;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);_defineProperty(SHGoodsCommonVertFlatStyle8Widget,"propTypes",{dataSource:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({labels:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({type:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签类型，取值范围如下，活动标签:ACTIVITY, 描述:DESC, 折扣:DISCOUNT, 入选排行榜:HOTLIST
text_list:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//标签内容列表
text:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签内容
tcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签文字颜色
bgcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签背景颜色
bcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//标签边框颜色
activity_img:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,// 标签图片链接
activity_img_ratio:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string// 标签图片比例
})),salestyle:NumberOrText,//2为显示折扣，3为显示原价
img:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//商品图
goods_color_num:NumberOrText,//商品配色数目
model_count:NumberOrText,//商品型号数目
isBlackBgImg:NumberOrText,// 0:白底图  1:黑底图
whiteBgImgFlag:NumberOrText,// 1:白底图 0:黑底图
// isCommonCate: NumberOrText, // 1通用类目 0:非通用
cateType:NumberOrText,// 3: 通用 1: 服 2: 鞋
name:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//商品名称
sales_info_text:NumberOrText,//销量、热度文案
sales_info_num:NumberOrText,//销量、热度数值
official_price:NumberOrText,//原价、官方价
price:NumberOrText,//价格
discount:NumberOrText,//原价、官方价
actCornerImg:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//左上角角标
img_w:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//图片宽比
img_h:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//图片高比
benefits:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({type:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签类型
text:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签内容
text_list:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//利益点标签内容列表
amount:NumberOrText,//利益点标签金额
tcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签文字颜色
bgcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,//利益点标签背景颜色
bcolor:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string//利益点标签边框颜色
})),spec_name:NumberOrText,// SUK描述
attrLabels:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//商品属性标签内容列表
formatN:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,// 一拖n    3 一拖3    5 一拖5
style_imgs:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string),//商品小款式图
style_img_list:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.shape({style_id:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,newProductIcon:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,color_hex:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,formatNType:NumberOrText,img:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string}))}),onPress:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,onStyleItemPress:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,onDataItemPress:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,isDark:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool});_defineProperty(SHGoodsCommonVertFlatStyle8Widget,"defaultProps",{dataSource:{labels:[],img:'',goods_color_num:0,model_count:0,isBlackBgImg:0,whiteBgImgFlag:0,cateType:1,name:'',sales_info_text:'',price:'',discount:'',formatN:'',style_img_list:[],benefits:[],spec_name:'',attrLabels:[],salestyle:'',sales_info_num:'',official_price:'',actCornerImg:'',img_w:'',img_h:''},onPress:function onPress(){},onStyleItemPress:function onStyleItemPress(){},onDataItemPress:function onDataItemPress(){},isDark:false});var pageStyles={goodsCard:{overflow:'hidden',marginBottom:baseStyle.containerMarginTop,backgroundColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ffffff_fg,borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12)},goodsCardImageBody:{position:'relative',width:'100%',borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),overflow:'hidden',backgroundColor:'#ffffff'},goodsCardImageTag:{position:'absolute',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),right:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderColor:'#DEDEDE',borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(17),paddingVertical:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),backgroundColor:'rgba(255,255,255,0.8)',boxSizing:'border-box'},goodsCardImageTagText:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},ratio5_4Img:{position:'absolute',width:'100%',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),bottom:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16)},blackImg:{width:'100%',height:'100%',marginTop:0,marginHorizontal:0},img:{width:'100%',height:'100%',// marginTop: px2dp(20),
marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),flex:1},goodsCardSku:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(14),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),boxSizing:'border-box'},goodsCardSku3:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),boxSizing:'border-box'},goodsCardSku3View:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(90),boxSizing:'border-box'},goodsCardSku3ImgTextView:{display:'flex',flexDirection:'row',flexWrap:'nowrap',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),boxSizing:'border-box'},goodsCardSkuBorder:{overflow:'hidden',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),borderColor:'#F1F1F1',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},goodsCardSkuImage:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(56)},goodsCardSkuBorder3:{overflow:'hidden',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),borderColor:'#F1F1F1',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},goodsCardSkuBorderV3:{overflow:'hidden',display:'flex',alignItems:'center',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(90),borderColor:'#F1F1F1',borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},goodsCardSkuImage3:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(88)},goodsCardSkuLogoImage:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),position:'absolute',left:-1,top:-1},goodsCardSkuColor:{display:'flex',justifyContent:'center',width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(48),marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),overflow:'hidden'},goodsCardSkuImgT:{display:'flex',justifyContent:'center',position:'absolute',left:0,top:0,right:0,bottom:0,overflow:'hidden'},goodsCardSkuImgText:(_goodsCardSkuImgText={position:'absolute',left:0,right:0,bottom:0,height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),backgroundColor:'rgba(255,255,255,0.85)',paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),display:'flex',justifyContent:'center',color:'#333333',fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16)},_defineProperty(_goodsCardSkuImgText,"color",'#333333'),_defineProperty(_goodsCardSkuImgText,"textAlign",'center'),_defineProperty(_goodsCardSkuImgText,"boxSizing",'border-box'),_goodsCardSkuImgText),goodsCardSkuText:(_goodsCardSkuText={display:'flex',justifyContent:'center',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),color:'#333333',fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),// lineHeight: px2dp(22),
width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(80)},_defineProperty(_goodsCardSkuText,"color",'#333333'),_defineProperty(_goodsCardSkuText,"textAlign",'center'),_goodsCardSkuText),goodsCardInfo:{display:'flex',justifyContent:'space-between',paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(16),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),boxSizing:'border-box'},goodsCardTop:{display:'flex',justifyContent:'space-between',height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(72)},name:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(26),fontFamily:isAndroid?'PingFangSC-Regular':'PingFangSC-Medium',color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,// lineHeight: px2dp(40),
marginTop:baseStyle.nameMarginTop},goodsCardBottom:{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between',marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8)},goodsCardBottomLeft:{display:'flex',flexDirection:'row',alignItems:'center'},goodsCardTag:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),boxSizing:'border-box'},goodsCardImageTagIcon:{marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20)},goodsCardTagText:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},goodsCardSymbol:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},goodsCardNum:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),//fontFamily: 'HelveticaNeue-CondensedBold',
fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(36),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,fontFamily:'PingFangSC-Regular'},goodsCardOriginalPrice:{position:'relative',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(6),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(26),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_999999,marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),textDecorationLine:'line-through',fontFamily:'PingFangSC-Regular'},goodsCardAmount:{position:'relative',bottom:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(14),fontFamily:'PingFangSC-Light',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_999999},bottomWords:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1),height:baseStyle.bottomWordsHeight,lineHeight:"".concat(baseStyle.bottomWordsHeight,"px"),display:'flex',flexDirection:'row',flexWrap:'wrap',alignItems:'center',overflow:'hidden',marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4)},vDataItemsView:{paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginTop:0,height:baseStyle.bottomWordsHeight,flex:1,display:'flex',flexDirection:'row',alignItems:'center',boxSizing:'border-box'},vDataLeftImg:{marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(26)},vDataLeftHead:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(14),overflow:'hidden'},vDataText:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),maxWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(255),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),boxSizing:'border-box'},vDataCommentContainer:{paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),maxWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(250),overflow:'hidden',paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},vDataComment:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},vDataYinHao:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),fontFamily:'PingFangSC-Regular',// lineHeight: px2dp(28),
minWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(18),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},vDataRightImg:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(12),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingBottom:0,marginBottom:0},bottomTags:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(1),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),height:baseStyle.bottomWordsHeight,display:'flex',flexDirection:'row',width:baseStyle.bottomTagsWidth,alignItems:'center'},bottomTagActivityNormal:{borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),height:baseStyle.bottomTagsHeight,display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'flex-start',backgroundColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ff4338,overflow:'hidden'},bottomTagActivityImg:{height:baseStyle.bottomTagsHeight,marginHorizontal:0,marginLeft:0},bottomTagActivityTxtContainer:{borderTopRightRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderBottomRightRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:baseStyle.bottomTagsHeight,borderLeftColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ffffff_fg,display:'flex',justifyContent:'center',alignItems:'center'},bottomTagActivityNorTxtContainer:{borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:baseStyle.bottomTagsHeight,display:'flex',justifyContent:'center',alignItems:'center'},bottomTagActivityTxt:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:'#ffffff',fontFamily:'PingFangSC-Regular',height:baseStyle.bottomTagsHeight,// lineHeight: baseStyle.bottomTagsHeight,
maxWidth:baseStyle.bottomTagsWidth,marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},bottomTagNormal:{borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),borderColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ff4338,marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),paddingHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),height:baseStyle.bottomTagsHeight,display:'flex',flexDirection:'row',alignItems:'center',backgroundColor:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_ff4338,boxSizing:'border-box'},bottomTagNormalTxt:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),color:'#ffffff',fontFamily:'PingFangSC-Regular',// lineHeight: baseStyle.bottomTagsHeight,
height:baseStyle.bottomTagsHeight,paddingBottom:isAndroid?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1):0,maxWidth:baseStyle.bottomTagsWidth,boxSizing:'border-box'},cave:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),marginHorizontal:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:baseStyle.bottomTagsHeight,overflow:'hidden'},caveCircle:{position:'absolute',left:0,borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),borderWidth:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(1),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),backgroundColor:'#ffffff'},caveDotLine:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(18)},caveDot:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2)},bottomTagsRankContainer:{display:'flex',flexDirection:'row',alignItems:'center',height:baseStyle.bottomTagsHeight,marginBottom:baseStyle.bottomTagsRankMarginBottom},bottom:{height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(50),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(20),marginTop:isAndroid?0:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(2),display:'flex',flexDirection:'row',alignItems:'center'},priceSymbol:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["a" /* aiDp */])(4),fontFamily:'PingFangSC-Medium',color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333,paddingRight:0},priceSymbolIOS:{paddingTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(8),boxSizing:'border-box'},priceStyle:{fontFamily:'PingFangSC-Medium'},price:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(36),fontFamily:'PingFangSC-Medium',color:__WEBPACK_IMPORTED_MODULE_26__ColorSchemeV2_index__["a" /* DynamicColorValue */].dyc_333333// lineHeight: px2dp(42),
},priceIOS:{// lineHeight: px2dp(40),
},tag:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(28),display:'flex',flexDirection:'row',alignItems:'center',backgroundColor:'#ffffff'},tagTxt:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),color:'#999999',fontFamily:'PingFangSC-Regular'// lineHeight: px2dp(27),
},officialPrice:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(6),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(22),color:'#999999',fontFamily:'PingFangSC-Regular',textDecorationLine:'line-through',// lineHeight: px2dp(26),
position:'absolute',top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},hotContainer:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(4)},hot:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(6),color:'#666666',fontFamily:'PingFangSC-Regular',textAlign:'right'// lineHeight: px2dp(32),
},hotIOS:{// lineHeight: px2dp(39),
paddingTop:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(2),boxSizing:'border-box'},actImg:{position:'absolute',left:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),top:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(10),width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(64),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(40)},beltImg:{position:'absolute',left:-Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["b" /* default */])(5),bottom:0,width:'100%',aspectRatio:171/42},blackBeltImg:{position:'absolute',left:0,bottom:0,width:'100%',aspectRatio:171/42},beltFrameImg:{position:'absolute',left:0,top:0,width:'100%',aspectRatio:1/1.333},fanBGView:{display:'flex',flexDirection:'row',width:baseStyle.bottomTagsWidth},fanContentView:{display:'flex',flexDirection:'row',borderWidth:StyleSheet.hairlineWidth,borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(2),borderColor:'#FFB4B3',backgroundColor:'transparent',overflow:'hidden'},fanIconView:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(33),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(14)},fanTxtBGView:{height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(14),paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(2),paddingRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(2),display:'flex',justifyContent:'center',alignItems:'center',boxSizing:'border-box'},fanTxt:{color:'#FF4338',fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2dp__["d" /* pxdp */])(11)},imageCover:{width:'100%',height:'100%',backgroundColor:'red'}};/* harmony default export */ __webpack_exports__["default"] = ({widget:SHGoodsCommonVertFlatStyle8Widget,getWidgetHeight:getWidgetHeight,showStyleList:false,getTags:getTags});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicColorValue; });
/* unused harmony export DYColorMapper */
/* harmony export (immutable) */ __webpack_exports__["b"] = getColorSchemeStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}// 为了在 Web React 环境中兼容 __DEV__ 判断，这里自定义一个 __DEV__ 标志
// 如果打包工具（如 webpack、Vite）提供了 process.env.NODE_ENV，会按其判断
// 否则默认认为是开发环境（true），以保留调试告警能力
var __DEV__=typeof process!=='undefined'&&Object({"NODE_ENV":"production","PUBLIC_URL":"."})&&"production"?"production"!=='production':true;// 动态颜色值：根据 isDark 选择 light 或 dark
var DynamicColorValue=/*#__PURE__*/function(){function DynamicColorValue(light,dark){_classCallCheck(this,DynamicColorValue);this.light=light;this.dark=dark;}_createClass(DynamicColorValue,[{key:"current",value:function current(isDark){return isDark?this.dark:this.light;}}]);return DynamicColorValue;}();// 原来类里的静态方法改为类外赋值，避免使用 static 关键字
DynamicColorValue.dyc=function(light,dark){return new DynamicColorValue(light,dark);};DynamicColorValue.dyCurrentImage=function(imageInfo,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('注意 dyCurrentImage isDark没有传值');}if(!isDark){return imageInfo.light;}if(!imageInfo.dark){return imageInfo.light;}return imageInfo.dark;};// 使用 ES5 兼容的方式挂载静态字段，避免使用 class fields 语法
DynamicColorValue.dyc_ff4338=new DynamicColorValue('#ff4338','#ff564d');DynamicColorValue.dyc_f4f5f7_bg=new DynamicColorValue('#f4f5f7','#121212');DynamicColorValue.dyc_f4f5f7_fg=new DynamicColorValue('#f4f5f7','#242424');DynamicColorValue.dyc_111111=new DynamicColorValue('#111111','#f0f0f0');DynamicColorValue.dyc_f7f7f7=new DynamicColorValue('#f7f7f7','#2e2e2e');DynamicColorValue.dyc_ffffff_fg=new DynamicColorValue('#ffffff','#242424');DynamicColorValue.dyc_ffffff_bg=new DynamicColorValue('#ffffff','#121212');DynamicColorValue.dyc_333333=new DynamicColorValue('#333333','#e0e0e0');DynamicColorValue.dyc_555555=new DynamicColorValue('#555555','#d4d4d4');DynamicColorValue.dyc_444444=new DynamicColorValue('#444444','#d4d4d4');DynamicColorValue.dyc_666666=new DynamicColorValue('#666666','#a8a8a8');DynamicColorValue.dyc_888888=new DynamicColorValue('#888888','#e0e0e0');DynamicColorValue.dyc_999999=new DynamicColorValue('#999999','#808080');DynamicColorValue.dyc_cacaca=new DynamicColorValue('#cacaca','#4f4f4f');DynamicColorValue.dyc_eaeaea=new DynamicColorValue('#eaeaea','#424242');DynamicColorValue.dyc_f0f0f0=new DynamicColorValue('#f0f0f0','rgba(255, 255, 255, 0.06)');DynamicColorValue.dyc_f7f7f9=new DynamicColorValue('#f7f7f9','#222222');DynamicColorValue.dyc_fafafa=new DynamicColorValue('#fafafa','#1f1f1f');DynamicColorValue.dyc_test_red=new DynamicColorValue('red','blue');DynamicColorValue.dyc_000000=new DynamicColorValue('#000000','#e0e0e0');DynamicColorValue.dyc_4f87c4=new DynamicColorValue('#4f87c4','#7693B9');DynamicColorValue.dyc_b16724=new DynamicColorValue('#b16724','#d5b186');DynamicColorValue.dyc_f7f8fa=new DynamicColorValue('#F7F8FA','#242424');var DYColorMapper=/*#__PURE__*/_createClass(function DYColorMapper(){_classCallCheck(this,DYColorMapper);});// 将原来的静态方法改为类外赋值，避免使用 static 关键字
DYColorMapper.dyc=function(key,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('注意 DYColorMapper.dyc isDark没有传值');}if(!key){return key;}var upperKey=String(key).toUpperCase();var value=DYColorMapper.__map[upperKey];if(!value){if(__DEV__){console.warn('DYColorMapper do not contain this key',upperKey);}return upperKey;}return isDark?value.dark:value.light;};DYColorMapper.dyCurrentImage=function(imageInfo,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('注意 dyCurrentImage isDark没有传值');}if(!isDark){return imageInfo.light;}if(!imageInfo.dark){return imageInfo.light;}return imageInfo.dark;};// 使用 ES5 方式定义 __map，避免 class field 语法
DYColorMapper.__map={'#000000':DynamicColorValue.dyc_000000,'#F7F7F9':DynamicColorValue.dyc_f7f7f9,'#FF4338':DynamicColorValue.dyc_ff4338,'#F4F5F7_BG':DynamicColorValue.dyc_f4f5f7_bg,'#F4F5F7_FG':DynamicColorValue.dyc_f4f5f7_fg,'#111111':DynamicColorValue.dyc_111111,'#F7F7F7':DynamicColorValue.dyc_f7f7f7,'#FFFFFF_BG':DynamicColorValue.dyc_ffffff_bg,'#FFFFFF_FG':DynamicColorValue.dyc_ffffff_fg,'#333333':DynamicColorValue.dyc_333333,'#555555':DynamicColorValue.dyc_555555,'#444444':DynamicColorValue.dyc_444444,'#666666':DynamicColorValue.dyc_666666,'#888888':DynamicColorValue.dyc_888888,'#999999':DynamicColorValue.dyc_999999,'#CACACA':DynamicColorValue.dyc_cacaca,'#EAEAEA':DynamicColorValue.dyc_eaeaea,'#F0F0F0':DynamicColorValue.dyc_f0f0f0,'#4F87C4':DynamicColorValue.dyc_4f87c4,'#B16724':DynamicColorValue.dyc_b16724,'#F7F8FA':DynamicColorValue.dyc_f7f8fa,red:DynamicColorValue.dyc_test_red};// Web 版本的 getColorSchemeStyle：不再依赖 React Native 的 StyleSheet.create
// 直接返回普通 JS 对象形式的样式，同时保持原来按 light/dark 缓存结果的行为
function getColorSchemeStyle(dynamicStyleSheet,isDark){if(__DEV__&&typeof isDark==='undefined'){throw new Error('getColorSchemeStyle isDark没有传值');}if(isDark){if(!dynamicStyleSheet.__dark){dynamicStyleSheet.__dark=parseStylesFor(dynamicStyleSheet,'dark');if(__DEV__){console.log('parseStylesFor dark');}}return dynamicStyleSheet.__dark;}else{if(!dynamicStyleSheet.__light){dynamicStyleSheet.__light=parseStylesFor(dynamicStyleSheet,'light');if(__DEV__){console.log('parseStylesFor light');}}return dynamicStyleSheet.__light;}}function parseStylesFor(styles,mode){var newStyles={};var containsDynamicColorValues=false;for(var key in styles){if(!Object.prototype.hasOwnProperty.call(styles,key))continue;var style=styles[key];// 跳过内部缓存字段，避免无限递归或污染
if(key==='__dark'||key==='__light'){continue;}var newStyle={};for(var prop in style){if(!Object.prototype.hasOwnProperty.call(style,prop))continue;var value=style[prop];if(value instanceof DynamicColorValue){containsDynamicColorValues=true;newStyle[prop]=value[mode];}else{newStyle[prop]=value;}}newStyles[key]=newStyle;}if(!containsDynamicColorValues&&__DEV__){console.warn('A DYCStyleSheet was used without any DynamicColorValues. Consider replacing with a regular StyleSheet.');}return newStyles;}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(135)))

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__BytesCount__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component_src_effects_opacity_css__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}/*
 * @Author: Miaoz
 * @Date: 2025-06-20 18:35:08
 * @LastEditors: Miaoz
 * @LastEditTime: 2025-06-24 11:08:54
 * @Description: 
 */var play_icon='http://static.shihuocdn.cn/admin/files/20230822/bec2fa4227fc27ff96840b74b80d8b0c.png';var bottom_bg_icon='http://static.shihuocdn.cn/admin/files/20230807/03a59277acc673321aeb626eeba330c6.png';var article_icon='http://static.shihuocdn.cn/admin/files/20230807/cdad47a3f86850e6156c087ae7ab7c53.png';var praised_icon='http://static.shihuocdn.cn/app/res/dsgn/363d7402c5a1407f9e72d8077d158720.png';var un_praised_icon='http://static.shihuocdn.cn/app/res/dsgn/79577cabf39d4dc09af2d48b42a7c267.png';var praised_animated='http://static.shihuocdn.cn/admin/files/20220826/03074265e9e14ae2b18229bf516dfbd9.webp';var animated_svga='http://static.shihuocdn.cn/app/res/dsgn/ab45f0ee9d5b454badb02fe85a29c256.svga';var user_level_1='http://static.shihuocdn.cn/admin/files/20220830/1dc074021fc6b5f706de782042fed04e.png';var user_level_2='http://static.shihuocdn.cn/admin/files/20220830/7f4f3d0a182686e5766946afa122a3f7.png';var user_level_3='http://static.shihuocdn.cn/admin/files/20220830/0a1a00fa186d88222513a22d12e474bc.png';var screen=typeof window!=='undefined'&&window.screen;var isIOS=typeof window!=='undefined'&&/ios|iphone|ipad/i.test(navigator.userAgent);var vCardWidth=typeof window!=='undefined'&&(window.innerWidth-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(12)*2-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9))/2;var requestNotePraised=/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id,channel_type,is_praised){var url,params;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:url='http://apps.shihuo.cn/app_swoole_common/praise';params={id:id,channel_type:channel_type,status:is_praised?'1':'2'};console.log('requestNotePraised',params);return _context.abrupt("return",new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_26__utils_request__["a" /* default */])({url:url,method:'GET',params:params}).then(function(value){resolve(value);})["catch"](function(err){reject(err);});}));case 4:case"end":return _context.stop();}}},_callee);}));return function requestNotePraised(_x,_x2,_x3){return _ref.apply(this,arguments);};}();function getUserLevelImg(level){switch(level){case 1:return user_level_1;case 2:return user_level_2;case 3:return user_level_3;default:return user_level_1;}}function getNoteNumberOfLines(item,widgetWidth){var _item$name=item.name,name=_item$name===void 0?'':_item$name;var lineWidth=widgetWidth-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10)*2;return getNumberOfLines(name,lineWidth,Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(13));}function getNumberOfLines(title,widgetWidth,fontSize){var isContainSpace=title.indexOf('\n');if(isContainSpace<0){isContainSpace=title.indexOf('\r');}if(isContainSpace>-1){return 2;}var nameLength=Object(__WEBPACK_IMPORTED_MODULE_25__BytesCount__["a" /* getByteCount */])(title);var totalWidth=nameLength/2.0*fontSize;if(totalWidth<=widgetWidth){return 1;}else{return 2;}}function getWidgetHeight(item,widgetWidth){var numberOfLines=getNoteNumberOfLines(item,widgetWidth);var data=item;var _data$title=data.title,title=_data$title===void 0?'':_data$title,_data$img_w=data.img_w,img_w=_data$img_w===void 0?1:_data$img_w,_data$img_h=data.img_h,img_h=_data$img_h===void 0?1:_data$img_h;var ratio=(img_h>0?img_h:1)/(img_w>0?img_w:1);ratio=Math.min(ratio,4.0/3.0);ratio=Math.max(ratio,3.0/4.0);var cardHeight=widgetWidth*ratio+Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9);cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8);// 图片和标题的间隔
if(numberOfLines==1){cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18);}if(numberOfLines==2){cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18)*2;}cardHeight+=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8)+Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18);return cardHeight;}var SHNoteCommonVertFlatStyle3Widget=/*#__PURE__*/function(_Component){_inherits(SHNoteCommonVertFlatStyle3Widget,_Component);var _super=_createSuper(SHNoteCommonVertFlatStyle3Widget);function SHNoteCommonVertFlatStyle3Widget(props){var _this;_classCallCheck(this,SHNoteCommonVertFlatStyle3Widget);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"_isShowTip",function(is_video,show_type,type,format_duration){var show=false;var icon='';var text='';if(is_video==1){show=true;icon=play_icon;text=format_duration;}else if(show_type=='single28'){show=true;icon=article_icon;text='文章';}else if(type==1){show=true;icon=article_icon;text='攻略';}return{show:show,icon:icon,text:text};});_defineProperty(_assertThisInitialized(_this),"_onLogin",function(){window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});});_defineProperty(_assertThisInitialized(_this),"_onPress",function(){_this.props.onPress&&_this.props.onPress();});_defineProperty(_assertThisInitialized(_this),"_onZanPress",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var isLogin,_this$props$itemIndex,itemIndex,dataSource,_dataSource$note_id,note_id,_dataSource$channel_t,channel_type,_dataSource$is_praise,is_praise,_dataSource$praiseNum,praiseNum;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:isLogin=_this.props.isLogin;if(isLogin){_context2.next=4;break;}_this._onLogin();return _context2.abrupt("return");case 4:_this$props$itemIndex=_this.props.itemIndex,itemIndex=_this$props$itemIndex===void 0?0:_this$props$itemIndex;dataSource=_this.props.dataSource;_dataSource$note_id=dataSource.note_id,note_id=_dataSource$note_id===void 0?'':_dataSource$note_id,_dataSource$channel_t=dataSource.channel_type,channel_type=_dataSource$channel_t===void 0?'4':_dataSource$channel_t,_dataSource$is_praise=dataSource.is_praise,is_praise=_dataSource$is_praise===void 0?false:_dataSource$is_praise,_dataSource$praiseNum=dataSource.praiseNum,praiseNum=_dataSource$praiseNum===void 0?0:_dataSource$praiseNum;praiseNum=parseInt(praiseNum);dataSource.is_praise=!is_praise;praiseNum+=!is_praise?1:-1;dataSource.praiseNum=praiseNum;_this.setState({animated:!is_praise},function(){var _this$state$animated=_this.state.animated,animated=_this$state$animated===void 0?false:_this$state$animated;if(animated){setTimeout(function(){_this.setState({animated:false});},400);}});requestNotePraised(note_id,channel_type,!is_praise).then(function(value){})["catch"](function(err){});case 13:case"end":return _context2.stop();}}},_callee2);})));_this.state={animated:false// dataSource: {}
};_this.cardWidth=props.cardWidth||vCardWidth;return _this;}_createClass(SHNoteCommonVertFlatStyle3Widget,[{key:"componentDidMount",value:function componentDidMount(){// this.setState({
//     dataSource: this.props.dataSource || {}
// })
}},{key:"render",value:function render(){var _this2=this;var _this$props$dataSourc=this.props.dataSource,_this$props$dataSourc2=_this$props$dataSourc.img,img=_this$props$dataSourc2===void 0?'':_this$props$dataSourc2,_this$props$dataSourc3=_this$props$dataSourc.profilePic,profilePic=_this$props$dataSourc3===void 0?'':_this$props$dataSourc3,_this$props$dataSourc4=_this$props$dataSourc.nickname,nickname=_this$props$dataSourc4===void 0?'':_this$props$dataSourc4,_this$props$dataSourc5=_this$props$dataSourc.praiseNum,praiseNum=_this$props$dataSourc5===void 0?'':_this$props$dataSourc5,_this$props$dataSourc6=_this$props$dataSourc.img_w,img_w=_this$props$dataSourc6===void 0?1:_this$props$dataSourc6,_this$props$dataSourc7=_this$props$dataSourc.img_h,img_h=_this$props$dataSourc7===void 0?1:_this$props$dataSourc7,_this$props$dataSourc8=_this$props$dataSourc.praise,praise=_this$props$dataSourc8===void 0?0:_this$props$dataSourc8,_this$props$dataSourc9=_this$props$dataSourc.is_praise,is_praise=_this$props$dataSourc9===void 0?false:_this$props$dataSourc9,_this$props$dataSourc10=_this$props$dataSourc.is_video,is_video=_this$props$dataSourc10===void 0?0:_this$props$dataSourc10,_this$props$dataSourc11=_this$props$dataSourc.video,video=_this$props$dataSourc11===void 0?{}:_this$props$dataSourc11,_this$props$dataSourc12=_this$props$dataSourc.name,name=_this$props$dataSourc12===void 0?'':_this$props$dataSourc12,_this$props$dataSourc13=_this$props$dataSourc.format_duration,format_duration=_this$props$dataSourc13===void 0?'00:00':_this$props$dataSourc13,_this$props$dataSourc14=_this$props$dataSourc.show_type,show_type=_this$props$dataSourc14===void 0?'':_this$props$dataSourc14,_this$props$dataSourc15=_this$props$dataSourc.type,type=_this$props$dataSourc15===void 0?0:_this$props$dataSourc15,_this$props$dataSourc16=_this$props$dataSourc.level,level=_this$props$dataSourc16===void 0?0:_this$props$dataSourc16;var numberOfLines=getNoteNumberOfLines(this.props.dataSource,this.cardWidth);var ratio=(img_h>0?img_h:1)/(img_w>0?img_w:1);ratio=Math.min(ratio,4.0/3.0);ratio=Math.max(ratio,3.0/4.0);var _this$state$animated2=this.state.animated,animated=_this$state$animated2===void 0?false:_this$state$animated2;img=img.split('#keepOn').join('');if(is_video==1){var videoImg=video.img||'';if(videoImg.length>0){img=videoImg.split('#keepOn').join('');}}var tipObj=this._isShowTip(is_video,show_type,type,format_duration);var containerHeight=getWidgetHeight(this.props.dataSource,this.cardWidth);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-card",style:_objectSpread(_objectSpread({},styles.container),{},{width:this.cardWidth,height:containerHeight-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9)})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"note-content",style:styles.content,onClick:function onClick(){return _this2._onPress();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-img-wrap",style:_objectSpread(_objectSpread({},styles.img),{},{height:this.cardWidth*ratio,position:'relative'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__["LazyLoadImage"],{key:this.props.key,className:"node-img",src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(img),effect:"opacity",wrapperProps:{style:{transitionDuration:'700ms'}},style:{width:'100%',height:'100%',objectFit:'cover',borderRadius:styles.img.borderRadius,display:'block'}// onClick={() => {
//     if (isIOS) {
//         this._onPress();
//     }
// }}
}),tipObj.show?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-video",style:_objectSpread(_objectSpread({},styles.video),{},{backgroundImage:"url(".concat(bottom_bg_icon,")"),backgroundSize:'cover',backgroundPosition:'center',backgroundRepeat:'no-repeat'})},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-video-text",style:{display:'flex',flexDirection:'row',alignItems:'center',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(16),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),width:'100%',boxSizing:'border-box'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"node-video-icon",src:tipObj.icon,alt:"tip-icon",style:is_video==1?styles.video_icon:styles.article_icon}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{style:styles.video_text,className:"node-video-tip"},tipObj.text))):null),name.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"node-title",style:_objectSpread(_objectSpread({},styles.title),{},{height:numberOfLines*Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),lineHeight:'18px',display:'-webkit-box',WebkitLineClamp:numberOfLines,WebkitBoxOrient:'vertical',overflow:'hidden'})},name):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-bottom",style:styles.bottom},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-avatar-wrap",style:styles.avatar},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"node-avatar",src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(profilePic,Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(40)),alt:"avatar",style:{width:'100%',height:'100%',borderRadius:styles.avatar.borderRadius,objectFit:'cover',display:'block'}}),level!=0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"node-avatar-level",src:Object(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["c" /* shortImageSize */])(getUserLevelImg(level),Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(16)),alt:"level",style:styles.avatar_level}):null),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{className:"node-author-name",style:_objectSpread(_objectSpread({},styles.author_name),{},{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}),title:nickname},nickname),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"node-zan-container",style:styles.zanContainer,onClick:function onClick(e){e.stopPropagation();_this2._onZanPress();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:animated?praised_animated:is_praise?praised_icon:un_praised_icon,alt:"like",style:styles.zan}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:!is_praise?praised_icon:un_praised_icon,alt:"",style:styles.zanPreload}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{style:styles.zanNum},"".concat(praiseNum)))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{style:{width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4)}})));}}]);return SHNoteCommonVertFlatStyle3Widget;}(__WEBPACK_IMPORTED_MODULE_22_react__["Component"]);SHNoteCommonVertFlatStyle3Widget.propTypes={dataSource:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,itemIndex:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.number,onZanPress:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func};SHNoteCommonVertFlatStyle3Widget.defaultProps={dataSource:{},itemIndex:0,onZanPress:function onZanPress(){}};var styles={container:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9),overflow:'hidden'},content:{width:'100%',borderRadius:6,backgroundColor:'#ffffff',overflow:'hidden',flex:1},img:{width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(233),overflow:'hidden',borderRadius:6},video:{position:'absolute',bottom:0,left:0,display:'flex',flexDirection:'row',alignItems:'flex-end',// alignItems: 'center',
// alignContent: 'flex-end',
width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(28)},video_icon:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10),width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(12),marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(1)},article_icon:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10),width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(10),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(11),marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(2)},video_text:{fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(11),color:'white',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(3)},title:{fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(13),color:'#333333',marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),textAlign:'left'},bottom:{display:'flex',flexDirection:'row',alignItems:'center',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),marginTop:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(4)},avatar:{width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(18)/2.0},avatar_level:{width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(9),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(8),position:'absolute',right:-Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(2),bottom:0},author_name:{fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(11),color:'#666666',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(5),flex:1},zanContainer:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(0),height:'100%',display:'flex',flexDirection:'row',alignItems:'center'},zan:{width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20)},zanPreload:{position:'absolute',opacity:0,backgroundColor:'red',width:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20),height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(20)},zanNum:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(0),fontFamily:'PingFangSC-Regular',fontSize:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(12),color:'#666666',height:Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2dp__["c" /* px2dpSmall */])(16)}};/* harmony default export */ __webpack_exports__["default"] = ({widget:SHNoteCommonVertFlatStyle3Widget,getWidgetHeight:getWidgetHeight,showStyleList:false});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(65);
var normalizeHeaderName = __webpack_require__(414);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(238);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(238);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var settle = __webpack_require__(415);
var cookies = __webpack_require__(417);
var buildURL = __webpack_require__(235);
var buildFullPath = __webpack_require__(418);
var parseHeaders = __webpack_require__(421);
var isURLSameOrigin = __webpack_require__(422);
var createError = __webpack_require__(239);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(416);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(137);

var _domFns = __webpack_require__(172);

function getBoundPosition(draggable
/*: Draggable*/
, x
/*: number*/
, y
/*: number*/
)
/*: [number, number]*/
{
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y]; // Clone new bounds

  var bounds = draggable.props.bounds;
  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;

    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }

    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }

    var boundNodeEl
    /*: HTMLElement*/
    = boundNode; // for Flow, can't seem to refine correctly

    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.

    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  } // Keep x and y below right and bottom limits...


  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.

  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
  return [x, y];
}

function snapToGrid(grid
/*: [number, number]*/
, pendingX
/*: number*/
, pendingY
/*: number*/
)
/*: [number, number]*/
{
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable
/*: Draggable*/
)
/*: boolean*/
{
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
} // Get {x, y} positions from event.


function getControlPosition(e
/*: MouseTouchEvent*/
, touchIdentifier
/*: ?number*/
, draggableCore
/*: DraggableCore*/
)
/*: ?ControlPosition*/
{
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch

  var node = findDOMNode(draggableCore); // User can provide an offsetParent if desired.

  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events


function createCoreData(draggable
/*: DraggableCore*/
, x
/*: number*/
, y
/*: number*/
)
/*: DraggableData*/
{
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x: x,
      y: y
    };
  }
} // Create an data exposed by <Draggable>'s events


function createDraggableData(draggable
/*: Draggable*/
, coreData
/*: DraggableData*/
)
/*: DraggableData*/
{
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
} // A lot faster than stringify/parse


function cloneBounds(bounds
/*: Bounds*/
)
/*: Bounds*/
{
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable
/*: Draggable | DraggableCore*/
)
/*: HTMLElement*/
{
  var node = draggable.findDOMNode();

  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  } // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME


  return node;
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var CountDown=/*#__PURE__*/function(_PureComponent){_inherits(CountDown,_PureComponent);var _super=_createSuper(CountDown);function CountDown(props){var _this;_classCallCheck(this,CountDown);_this=_super.call(this,props);_this.state={count_down:{d:"0",h:"0",m:"0",s:"0"}};_this.timer=null;return _this;}_createClass(CountDown,[{key:"componentDidMount",value:function componentDidMount(){var end_time=this.props.end_time;this.startCountDown(end_time);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.end_time!==nextProps.end_time){this.startCountDown(nextProps.end_time);}}},{key:"render",value:function render(){var _this$state$count_dow=this.state.count_down,d=_this$state$count_dow.d,h=_this$state$count_dow.h,m=_this$state$count_dow.m,s=_this$state$count_dow.s;if(d=='00'&&h=='00'&&m=='00'&&s=='00'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",null,"\u5DF2\u8FC7\u671F");}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",null,d,"\u5929",h,":",m,":",s,"\u540E\u8FC7\u671F");}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.timer=null;}},{key:"countDown",value:function countDown(t){var n=new Date().getTime(),c=t-n,d,h,m,s;// 结束执行
if(c<=0){return{d:"00",h:"00",m:"00",s:"00"};}d=parseInt(c/1000/60/60/24);h=parseInt(c/1000/60/60-24*d);m=parseInt(c/1000/60-24*60*d-60*h);s=parseInt(c/1000-24*60*60*d-60*60*h-60*m);if(s<10){s="0"+s;}if(m<10){m="0"+m;}if(h<10){h="0"+h;}if(d<10){d="0"+d;}return{d:d,h:h,m:m,s:s};}},{key:"startCountDown",value:function startCountDown(end_time){var _this2=this;if(this.timer){clearInterval(this.timer);this.timer=null;}var timestramp=end_time*1000;this.timer=setInterval(function(){// 计算倒计时
var finish_time=new Date(timestramp).getTime();var count_down=_this2.countDown(finish_time);_this2.setState({count_down:count_down});},1000);}}]);return CountDown;}(__WEBPACK_IMPORTED_MODULE_10_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (CountDown);

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./pipeline-brand/package.json": 507,
	"./pipeline-btnRadioText/package.json": 508,
	"./pipeline-button/package.json": 509,
	"./pipeline-cashBack/package.json": 510,
	"./pipeline-cashBackAct/package.json": 511,
	"./pipeline-cashBackActNew/package.json": 512,
	"./pipeline-checkAppDetail/package.json": 513,
	"./pipeline-checkAppProduct/package.json": 514,
	"./pipeline-community/package.json": 515,
	"./pipeline-communityActImage/package.json": 516,
	"./pipeline-communityActText/package.json": 517,
	"./pipeline-communityArticle/package.json": 518,
	"./pipeline-communityArticleScroll/package.json": 519,
	"./pipeline-communityCustom/package.json": 520,
	"./pipeline-communityShaiwu/package.json": 521,
	"./pipeline-communityVote/package.json": 522,
	"./pipeline-completion/package.json": 523,
	"./pipeline-cutPriceGoodsList/package.json": 524,
	"./pipeline-date-range/package.json": 525,
	"./pipeline-depreciateTop/package.json": 526,
	"./pipeline-double11Floor/package.json": 527,
	"./pipeline-floor/package.json": 528,
	"./pipeline-floorBarTitle/package.json": 529,
	"./pipeline-free-subsidy/package.json": 530,
	"./pipeline-games/package.json": 531,
	"./pipeline-goodsHorizontal/package.json": 532,
	"./pipeline-goodsInfoPreview/package.json": 533,
	"./pipeline-goodsRecommend/package.json": 534,
	"./pipeline-headlines/package.json": 535,
	"./pipeline-hintStatement/package.json": 536,
	"./pipeline-hotSellRankList/package.json": 537,
	"./pipeline-hotspots/package.json": 538,
	"./pipeline-image/package.json": 539,
	"./pipeline-imageText/package.json": 540,
	"./pipeline-imgAnimate/package.json": 541,
	"./pipeline-imgHotMap/package.json": 542,
	"./pipeline-imgList/package.json": 543,
	"./pipeline-imgListScroll/package.json": 544,
	"./pipeline-imgSwiper/package.json": 545,
	"./pipeline-imgs/package.json": 546,
	"./pipeline-inteligenceDetail/package.json": 547,
	"./pipeline-inteligenceOverview/package.json": 548,
	"./pipeline-intelligent/package.json": 549,
	"./pipeline-interactMessage/package.json": 550,
	"./pipeline-inventoryHorizontal/package.json": 551,
	"./pipeline-lottery/package.json": 552,
	"./pipeline-matrixScaleQuestion/package.json": 553,
	"./pipeline-menuBar/package.json": 554,
	"./pipeline-modal/package.json": 555,
	"./pipeline-multipleChoiceQuestion/package.json": 556,
	"./pipeline-navBar/package.json": 557,
	"./pipeline-navigation/package.json": 558,
	"./pipeline-npsQuestion/package.json": 559,
	"./pipeline-paging/package.json": 560,
	"./pipeline-paragraph/package.json": 561,
	"./pipeline-pkRank/package.json": 562,
	"./pipeline-priceTrend/package.json": 563,
	"./pipeline-product/package.json": 564,
	"./pipeline-productCollection/package.json": 565,
	"./pipeline-productCustomize/package.json": 566,
	"./pipeline-productGather/package.json": 567,
	"./pipeline-productLayout3/package.json": 568,
	"./pipeline-productList/package.json": 569,
	"./pipeline-productSwiper/package.json": 570,
	"./pipeline-rank/package.json": 571,
	"./pipeline-rankCollection/package.json": 572,
	"./pipeline-rankList/package.json": 573,
	"./pipeline-recommend-feeds/package.json": 574,
	"./pipeline-recommend/package.json": 575,
	"./pipeline-recommendTopGoods/package.json": 576,
	"./pipeline-regionalSelect/package.json": 577,
	"./pipeline-scaleQuestion/package.json": 578,
	"./pipeline-schoolLottery/package.json": 579,
	"./pipeline-searchCard/package.json": 580,
	"./pipeline-searchProduct/package.json": 581,
	"./pipeline-searchSlogan/package.json": 582,
	"./pipeline-searchSwiper/package.json": 583,
	"./pipeline-sence-floor/package.json": 584,
	"./pipeline-sence-swiper/package.json": 585,
	"./pipeline-sence-tab/package.json": 586,
	"./pipeline-sequenceQuestion/package.json": 587,
	"./pipeline-sideBar/package.json": 588,
	"./pipeline-singleChoiceQuestion/package.json": 589,
	"./pipeline-spikeProduct/package.json": 590,
	"./pipeline-springFestivalFloor/package.json": 591,
	"./pipeline-square/package.json": 592,
	"./pipeline-subsidy/package.json": 593,
	"./pipeline-subsidyList/package.json": 594,
	"./pipeline-suctionBottomBtns/package.json": 595,
	"./pipeline-tab/package.json": 596,
	"./pipeline-telephone/package.json": 597,
	"./pipeline-textarea/package.json": 598,
	"./pipeline-timedLottery/package.json": 599,
	"./pipeline-uploadImages/package.json": 600,
	"./pipeline-video/package.json": 601,
	"./pipeline-vote/package.json": 602
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(77);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__children__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timeline__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__canvas__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_diff__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(800);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__components__["e"]; });
/* unused harmony reexport jsx */
/* unused harmony reexport render */
/* unused harmony reexport Fragment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createRef__ = __webpack_require__(299);
/* unused harmony reexport createRef */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__children__["a"]; });
/* unused harmony reexport createElement */
/* unused harmony reexport Component */
/* unused harmony reexport Timeline */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__canvas__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__chart__["a"]; });
/* unused harmony reexport renderShape */
// import * as attr from './attr';
// import * as util from './util';












/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

var filter = function (arr, func) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(arr)) {
        return arr;
    }
    var result = [];
    for (var index = 0; index < arr.length; index++) {
        var value = arr[index];
        if (func(value, index)) {
            result.push(value);
        }
    }
    return result;
};
/* harmony default export */ __webpack_exports__["a"] = (filter);
//# sourceMappingURL=filter.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_nil__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys__ = __webpack_require__(252);


function isMatch(obj, attrs) {
    var _keys = Object(__WEBPACK_IMPORTED_MODULE_1__keys__["a" /* default */])(attrs);
    var length = _keys.length;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_nil__["a" /* default */])(obj))
        return !length;
    for (var i = 0; i < length; i += 1) {
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) {
            return false;
        }
    }
    return true;
}
/* harmony default export */ __webpack_exports__["a"] = (isMatch);
//# sourceMappingURL=is-match.js.map

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__each__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


var keys = Object.keys ? function (obj) { return Object.keys(obj); } : function (obj) {
    var result = [];
    Object(__WEBPACK_IMPORTED_MODULE_0__each__["a" /* default */])(obj, function (value, key) {
        if (!(Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(obj) && key === 'prototype')) {
            result.push(key);
        }
    });
    return result;
};
/* harmony default export */ __webpack_exports__["a"] = (keys);
//# sourceMappingURL=keys.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);

/**
 * @param {Array} arr The array to iterate over.
 * @return {*} Returns the maximum value.
 * @example
 *
 * max([1, 2]);
 * // => 2
 *
 * max([]);
 * // => undefined
 *
 * const data = new Array(1250010).fill(1).map((d,idx) => idx);
 *
 * max(data);
 * // => 1250010
 * // Math.max(...data) will encounter "Maximum call stack size exceeded" error
 */
/* harmony default export */ __webpack_exports__["a"] = (function (arr) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr)) {
        return undefined;
    }
    return arr.reduce(function (prev, curr) {
        return Math.max(prev, curr);
    }, arr[0]);
});
//# sourceMappingURL=max.js.map

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);

/**
 * @param {Array} arr The array to iterate over.
 * @return {*} Returns the minimum value.
 * @example
 *
 * min([1, 2]);
 * // => 1
 *
 * min([]);
 * // => undefined
 *
 * const data = new Array(1250010).fill(1).map((d,idx) => idx);
 *
 * min(data);
 * // => 1250010
 * // Math.min(...data) will encounter "Maximum call stack size exceeded" error
 */
/* harmony default export */ __webpack_exports__["a"] = (function (arr) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr)) {
        return undefined;
    }
    return arr.reduce(function (prev, curr) {
        return Math.min(prev, curr);
    }, arr[0]);
});
//# sourceMappingURL=min.js.map

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

var splice = Array.prototype.splice;
var pullAt = function pullAt(arr, indexes) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(arr)) {
        return [];
    }
    var length = arr ? indexes.length : 0;
    var last = length - 1;
    while (length--) {
        var previous = void 0;
        var index = indexes[length];
        if (length === last || index !== previous) {
            previous = index;
            splice.call(arr, index, 1);
        }
    }
    return arr;
};
/* harmony default export */ __webpack_exports__["a"] = (pullAt);
//# sourceMappingURL=pull-at.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__each__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_plain_object__ = __webpack_require__(121);



var reduce = function (arr, fn, init) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__is_array__["a" /* default */])(arr) && !Object(__WEBPACK_IMPORTED_MODULE_2__is_plain_object__["a" /* default */])(arr)) {
        return arr;
    }
    var result = init;
    Object(__WEBPACK_IMPORTED_MODULE_0__each__["a" /* default */])(arr, function (data, i) {
        result = fn(result, data, i);
    });
    return result;
};
/* harmony default export */ __webpack_exports__["a"] = (reduce);
//# sourceMappingURL=reduce.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uniq;
function uniq(arr, cache) {
    if (cache === void 0) { cache = new Map(); }
    var r = [];
    if (Array.isArray(arr)) {
        for (var i = 0, len = arr.length; i < len; i++) {
            var item = arr[i];
            // 加一个 cache，提升性能
            if (!cache.has(item)) {
                r.push(item);
                cache.set(item, true);
            }
        }
    }
    return r;
}
//# sourceMappingURL=uniq.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = groupToMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__group_by__ = __webpack_require__(259);



/**
 * 将数据分组成 map
 * @param data
 * @param condition
 */
function groupToMap(data, condition) {
    if (!condition) {
        return {
            0: data,
        };
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(condition)) {
        // 如果是字符串，则按照 a*b 风格成数组
        var paramscondition_1 = Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(condition) ? condition : condition.replace(/\s+/g, '').split('*');
        condition = function (row) {
            var unique = '_'; // 避免出现数字作为Key的情况，会进行按照数字的排序
            // 根据字段列表的值，拼接成 key
            for (var i = 0, l = paramscondition_1.length; i < l; i++) {
                unique += row[paramscondition_1[i]] && row[paramscondition_1[i]].toString();
            }
            return unique;
        };
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__group_by__["a" /* default */])(data, condition);
}
//# sourceMappingURL=group-to-map.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


var hasOwnProperty = Object.prototype.hasOwnProperty;
function groupBy(data, condition) {
    if (!condition || !Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(data)) {
        return {};
    }
    var result = {};
    // 兼容方法和 字符串的写法
    var predicate = Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(condition) ? condition : function (item) { return item[condition]; };
    var key;
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        key = predicate(item);
        if (hasOwnProperty.call(result, key)) {
            result[key].push(item);
        }
        else {
            result[key] = [item];
        }
    }
    return result;
}
/* harmony default export */ __webpack_exports__["a"] = (groupBy);
//# sourceMappingURL=group-by.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (obj, key) { return obj.hasOwnProperty(key); });
//# sourceMappingURL=has.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var toString = {}.toString;
var getType = function (value) {
    return toString.call(value).replace(/^\[object /, '').replace(/]$/, '');
};
/* harmony default export */ __webpack_exports__["a"] = (getType);
//# sourceMappingURL=get-type.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var objectProto = Object.prototype;
var isPrototype = function (value) {
    var Ctor = value && value.constructor;
    var proto = (typeof Ctor === 'function' && Ctor.prototype) || objectProto;
    return value === proto;
};
/* harmony default export */ __webpack_exports__["a"] = (isPrototype);
//# sourceMappingURL=is-prototype.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_function__ = __webpack_require__(67);

/**
 * _.memoize(calColor);
 * _.memoize(calColor, (...args) => args[0]);
 * @param f
 * @param resolver
 */
/* harmony default export */ __webpack_exports__["a"] = (function (f, resolver) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_function__["a" /* default */])(f)) {
        throw new TypeError('Expected a function');
    }
    var memoized = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // 使用方法构造 key，如果不存在 resolver，则直接取第一个参数作为 key
        var key = resolver ? resolver.apply(this, args) : args[0];
        var cache = memoized.cache;
        if (cache.has(key)) {
            return cache.get(key);
        }
        var result = f.apply(this, args);
        // 缓存起来
        cache.set(key, result);
        return result;
    };
    memoized.cache = new Map();
    return memoized;
});
//# sourceMappingURL=memoize.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_object_like__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_array_like__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_string__ = __webpack_require__(80);



var isEqual = function (value, other) {
    if (value === other) {
        return true;
    }
    if (!value || !other) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is_string__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__is_string__["a" /* default */])(other)) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is_array_like__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__is_array_like__["a" /* default */])(other)) {
        if (value.length !== other.length) {
            return false;
        }
        var rst = true;
        for (var i = 0; i < value.length; i++) {
            rst = isEqual(value[i], other[i]);
            if (!rst) {
                break;
            }
        }
        return rst;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_object_like__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__is_object_like__["a" /* default */])(other)) {
        var valueKeys = Object.keys(value);
        var otherKeys = Object.keys(other);
        if (valueKeys.length !== otherKeys.length) {
            return false;
        }
        var rst = true;
        for (var i = 0; i < valueKeys.length; i++) {
            rst = isEqual(value[valueKeys[i]], other[valueKeys[i]]);
            if (!rst) {
                break;
            }
        }
        return rst;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["a"] = (isEqual);
//# sourceMappingURL=is-equal.js.map

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__memoize__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_string__ = __webpack_require__(80);




var ctx;
/**
 * 计算文本的宽度
 */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__memoize__["a" /* default */])(function (text, font) {
    if (font === void 0) { font = {}; }
    var fontSize = font.fontSize, fontFamily = font.fontFamily, fontWeight = font.fontWeight, fontStyle = font.fontStyle, fontVariant = font.fontVariant;
    if (!ctx) {
        ctx = document.createElement('canvas').getContext('2d');
    }
    ctx.font = [fontStyle, fontVariant, fontWeight, fontSize + "px", fontFamily].join(' ');
    return ctx.measureText(Object(__WEBPACK_IMPORTED_MODULE_3__is_string__["a" /* default */])(text) ? text : '').width;
}, function (text, font) {
    if (font === void 0) { font = {}; }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __spreadArrays */])([text], Object(__WEBPACK_IMPORTED_MODULE_1__values__["a" /* default */])(font)).join('');
}));
//# sourceMappingURL=measure-text-width.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Matrix = {
  generateDefault: function generateDefault() {
    return [1, 0, 0, 1, 0, 0];
  },
  isChanged: function isChanged(m) {
    return m[0] !== 1 || m[1] !== 0 || m[2] !== 0 || m[3] !== 1 || m[4] !== 0 || m[5] !== 0;
  },
  multiply: function multiply(m1, m2) {
    var m11 = m1[0] * m2[0] + m1[2] * m2[1];
    var m12 = m1[1] * m2[0] + m1[3] * m2[1];
    var m21 = m1[0] * m2[2] + m1[2] * m2[3];
    var m22 = m1[1] * m2[2] + m1[3] * m2[3];
    var dx = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var dy = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    return [m11, m12, m21, m22, dx, dy];
  },
  scale: function scale(out, m, v) {
    out[0] = m[0] * v[0];
    out[1] = m[1] * v[0];
    out[2] = m[2] * v[1];
    out[3] = m[3] * v[1];
    out[4] = m[4];
    out[5] = m[5];
    return out;
  },
  rotate: function rotate(out, m, radian) {
    var c = Math.cos(radian);
    var s = Math.sin(radian);
    var m11 = m[0] * c + m[2] * s;
    var m12 = m[1] * c + m[3] * s;
    var m21 = m[0] * -s + m[2] * c;
    var m22 = m[1] * -s + m[3] * c;
    out[0] = m11;
    out[1] = m12;
    out[2] = m21;
    out[3] = m22;
    out[4] = m[4];
    out[5] = m[5];
    return out;
  },
  translate: function translate(out, m, v) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4] + m[0] * v[0] + m[2] * v[1];
    out[5] = m[5] + m[1] * v[0] + m[3] * v[1];
    return out;
  },
  transform: function transform(m, actions) {
    var out = [].concat(m);

    for (var i = 0, len = actions.length; i < len; i++) {
      var action = actions[i];

      switch (action[0]) {
        case 't':
          Matrix.translate(out, out, [action[1], action[2]]);
          break;

        case 's':
          Matrix.scale(out, out, [action[1], action[2]]);
          break;

        case 'r':
          Matrix.rotate(out, out, action[1]);
          break;

        default:
          break;
      }
    }

    return out;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Matrix);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smooth", function() { return catmullRom2bezier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vector2__ = __webpack_require__(122);
/**
 * @fileOverview convert the line to curve
 * @author dxq613@gmail.com
 */


function getPoint(v) {
  return [v.x, v.y];
}

function smoothBezier(points, smooth, isLoop, constraint) {
  var cps = [];
  var prevPoint;
  var nextPoint;
  var hasConstraint = !!constraint;
  var min;
  var max;
  var point;
  var len;
  var l;
  var i;

  if (hasConstraint) {
    min = [Infinity, Infinity];
    max = [-Infinity, -Infinity];

    for (i = 0, l = points.length; i < l; i++) {
      point = getPoint(points[i]);
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].min(min, min, point);
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].max(max, max, point);
    }

    __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].min(min, min, constraint[0]);
    __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].max(max, max, constraint[1]);
  }

  for (i = 0, len = points.length; i < len; i++) {
    point = getPoint(points[i]);

    if (isLoop) {
      prevPoint = getPoint(points[i ? i - 1 : len - 1]);
      nextPoint = getPoint(points[(i + 1) % len]);
    } else {
      if (i === 0 || i === len - 1) {
        cps.push([point[0], point[1]]);
        continue;
      } else {
        prevPoint = getPoint(points[i - 1]);
        nextPoint = getPoint(points[i + 1]);
      }
    }

    var v = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].sub([], nextPoint, prevPoint);
    __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].scale(v, v, smooth);
    var d0 = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].distance(point, prevPoint);
    var d1 = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].distance(point, nextPoint);
    var sum = d0 + d1;

    if (sum !== 0) {
      d0 /= sum;
      d1 /= sum;
    }

    var v1 = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].scale([], v, -d0);
    var v2 = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].scale([], v, d1);
    var cp0 = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].add([], point, v1);
    var cp1 = __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].add([], point, v2);

    if (hasConstraint) {
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].max(cp0, cp0, min);
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].min(cp0, cp0, max);
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].max(cp1, cp1, min);
      __WEBPACK_IMPORTED_MODULE_0__vector2__["a" /* default */].min(cp1, cp1, max);
    }

    cps.push([cp0[0], cp0[1]]);
    cps.push([cp1[0], cp1[1]]);
  }

  if (isLoop) {
    cps.push(cps.shift());
  }

  return cps;
}

function catmullRom2bezier(pointList, z, constraint) {
  var isLoop = !!z;
  var controlPointList = smoothBezier(pointList, 0.4, isLoop, constraint);
  var len = pointList.length;
  var d1 = [];
  var cp1;
  var cp2;
  var p;

  for (var i = 0; i < len - 1; i++) {
    cp1 = controlPointList[i * 2];
    cp2 = controlPointList[i * 2 + 1];
    p = pointList[i + 1];
    d1.push(['C', cp1[0], cp1[1], cp2[0], cp2[1], p.x, p.y]);
  }

  if (isLoop) {
    cp1 = controlPointList[len];
    cp2 = controlPointList[len + 1];
    p = pointList[0];
    d1.push(['C', cp1[0], cp1[1], cp2[0], cp2[1], p.x, p.y]);
  }

  return d1;
}



/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);


// 实现简单的事件机制


var EventEmit = /*#__PURE__*/function () {
  function EventEmit() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EventEmit);

    this.__events = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(EventEmit, [{
    key: "on",
    value: function on(type, listener) {
      if (!type || !listener) {
        return;
      }

      var events = this.__events[type] || [];
      events.push(listener);
      this.__events[type] = events;
    }
  }, {
    key: "emit",
    value: function emit(type, e) {
      var _this = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["z" /* isObject */])(type)) {
        e = type;
        type = e && e.type;
      }

      if (!type) {
        return;
      }

      var events = this.__events[type];

      if (!events || !events.length) {
        return;
      }

      events.forEach(function (listener) {
        listener.call(_this, e);
      });
    }
  }, {
    key: "off",
    value: function off(type, listener) {
      var __events = this.__events;
      var events = __events[type];

      if (!events || !events.length) {
        return;
      } // 如果没有指定方法，则删除所有项


      if (!listener) {
        delete __events[type];
        return;
      } // 删除指定的 listener


      for (var i = 0, len = events.length; i < len; i++) {
        if (events[i] === listener) {
          events.splice(i, 1);
          i--;
        }
      }
    }
  }]);

  return EventEmit;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmit);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_array__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shape__ = __webpack_require__(271);



var SHAPE_MAP = {};
var INDEX = '_INDEX';

function getComparer(compare) {
  return function (left, right) {
    var result = compare(left, right);
    return result === 0 ? left[INDEX] - right[INDEX] : result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getGroupClass: function getGroupClass() {},
  getChildren: function getChildren() {
    return this.get('children');
  },
  addShape: function addShape(type) {
    var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var shapeType = SHAPE_MAP[type];

    if (!shapeType) {
      shapeType = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["L" /* upperFirst */])(type);
      SHAPE_MAP[type] = shapeType;
    }

    var shape = new __WEBPACK_IMPORTED_MODULE_2__shape__["a" /* default */][shapeType](cfg);
    this.add(shape);
    return shape;
  },
  addGroup: function addGroup(cfg) {
    var groupClass = this.getGroupClass();
    var rst = new groupClass(cfg);
    this.add(rst);
    return rst;
  },
  contain: function contain(item) {
    var children = this.get('children');
    return children.indexOf(item) > -1;
  },
  sort: function sort() {
    var children = this.get('children');

    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      child[INDEX] = i;
    }

    children.sort(getComparer(function (obj1, obj2) {
      return obj1.get('zIndex') - obj2.get('zIndex');
    }));
    return this;
  },
  drawChildren: function drawChildren(context) {
    this.sort();
    var children = this.get('children');

    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      child.draw(context);
    }

    return this;
  },
  clear: function clear() {
    var children = this.get('children') || [];

    while (children.length !== 0) {
      children[children.length - 1].remove(true);
    }

    return this;
  },
  add: function add(items) {
    var children = this.get('children');

    if (!children) {
      children = [];
      this.set('children', children);
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["r" /* isArray */])(items)) {
      items = [items];
    }

    for (var i = 0, len = items.length; i < len; i++) {
      var item = items[i];
      var parent = item.get('parent');

      if (parent) {
        var descendants = parent.get('children');
        Object(__WEBPACK_IMPORTED_MODULE_1__util_array__["a" /* remove */])(descendants, item);
      }

      this._setEvn(item);

      children.push(item);
    }

    return this;
  },
  _setEvn: function _setEvn(item) {
    var _item$_attrs$attrs, _item$_attrs$attrs2;

    var _this$_attrs = this._attrs,
        context = _this$_attrs.context,
        canvas = _this$_attrs.canvas,
        aria = _this$_attrs.aria;
    var _item$_attrs = item._attrs,
        isGroup = _item$_attrs.isGroup,
        type = _item$_attrs.type;
    item._attrs.parent = this;
    item._attrs.context = context;
    item._attrs.canvas = canvas; // 是否需要无障碍处理

    if (aria && item._attrs.aria !== false) {
      item._attrs.aria = aria;
    }

    if (type === 'text' && canvas && canvas.get('fontFamily') && !((_item$_attrs$attrs = item._attrs.attrs) === null || _item$_attrs$attrs === void 0 ? void 0 : _item$_attrs$attrs.fontFamily)) {
      item.attr('fontFamily', canvas.get('fontFamily'));
    }

    var clip = (_item$_attrs$attrs2 = item._attrs.attrs) === null || _item$_attrs$attrs2 === void 0 ? void 0 : _item$_attrs$attrs2.clip;

    if (clip) {
      clip._attrs.parent = this;
      clip._attrs.context = context;
      clip._attrs.canvas = canvas;
    }

    if (isGroup) {
      var children = item._attrs.children;

      for (var i = 0, len = children.length; i < len; i++) {
        item._setEvn(children[i]);
      }
    }
  },
  _getAriaLabel: function _getAriaLabel() {
    var _this$_attrs2 = this._attrs,
        aria = _this$_attrs2.aria,
        ariaLabel = _this$_attrs2.ariaLabel,
        children = _this$_attrs2.children; // 主动关闭

    if (!aria) return;
    var childAriaLabels = [];

    if (children && children.length) {
      for (var i = 0, len = children.length; i < len; i++) {
        var _childAriaLabel = children[i].getAriaLabel();

        if (_childAriaLabel) {
          childAriaLabels.push(_childAriaLabel);
        }
      }
    }

    var childAriaLabel = childAriaLabels.join(' '); // 2个都有时拼接成完整句子

    if (ariaLabel && childAriaLabel) {
      return "".concat(ariaLabel, " ").concat(childAriaLabel, " ");
    } // 只有1个，或者都没有


    return ariaLabel || childAriaLabel;
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return remove; });
function remove(arr, obj) {
  if (!arr) {
    return;
  }

  var index = arr.indexOf(obj);

  if (index !== -1) {
    arr.splice(index, 1);
  }
}



/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__circle__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__line__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polygon__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyline__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arc__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sector__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__text__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__custom__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__marker__ = __webpack_require__(729);












__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Rect = __WEBPACK_IMPORTED_MODULE_1__rect__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Image = __WEBPACK_IMPORTED_MODULE_2__image__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Circle = __WEBPACK_IMPORTED_MODULE_3__circle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Line = __WEBPACK_IMPORTED_MODULE_4__line__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Polygon = __WEBPACK_IMPORTED_MODULE_5__polygon__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Polyline = __WEBPACK_IMPORTED_MODULE_6__polyline__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Arc = __WEBPACK_IMPORTED_MODULE_7__arc__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Sector = __WEBPACK_IMPORTED_MODULE_8__sector__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Text = __WEBPACK_IMPORTED_MODULE_9__text__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Custom = __WEBPACK_IMPORTED_MODULE_10__custom__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */].Marker = __WEBPACK_IMPORTED_MODULE_11__marker__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__shape__["a" /* default */]);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_rect__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_vector2__ = __webpack_require__(122);











var Group = /*#__PURE__*/function (_Rect) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Group, _Rect);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Group);

  function Group() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Group);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Group, [{
    key: "_initProperties",
    value:
    /* eslint-enable */
    function _initProperties() {
      this._attrs = {
        type: 'group',
        zIndex: 0,
        visible: true,
        destroyed: false,
        isGroup: true,
        canFill: true,
        canStroke: true,
        children: [],
        attrs: {
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          radius: 0,
          lineWidth: 0
        }
      };
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      var minX = Infinity;
      var maxX = -Infinity;
      var minY = Infinity;
      var maxY = -Infinity;
      var children = this.get('children');

      for (var i = 0, length = children.length; i < length; i++) {
        var child = children[i];

        if (child.get('visible')) {
          var box = child.getBBox();

          if (!box) {
            continue;
          }

          var leftTop = [box.minX, box.minY];
          var leftBottom = [box.minX, box.maxY];
          var rightTop = [box.maxX, box.minY];
          var rightBottom = [box.maxX, box.maxY];
          var matrix = child.attr('matrix');
          __WEBPACK_IMPORTED_MODULE_9__util_vector2__["a" /* default */].transformMat2d(leftTop, leftTop, matrix);
          __WEBPACK_IMPORTED_MODULE_9__util_vector2__["a" /* default */].transformMat2d(leftBottom, leftBottom, matrix);
          __WEBPACK_IMPORTED_MODULE_9__util_vector2__["a" /* default */].transformMat2d(rightTop, rightTop, matrix);
          __WEBPACK_IMPORTED_MODULE_9__util_vector2__["a" /* default */].transformMat2d(rightBottom, rightBottom, matrix);
          minX = Math.min(leftTop[0], leftBottom[0], rightTop[0], rightBottom[0], minX);
          maxX = Math.max(leftTop[0], leftBottom[0], rightTop[0], rightBottom[0], maxX);
          minY = Math.min(leftTop[1], leftBottom[1], rightTop[1], rightBottom[1], minY);
          maxY = Math.max(leftTop[1], leftBottom[1], rightTop[1], rightBottom[1], maxY);
        }
      }

      return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY,
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs'); // 只有在有fillStyle或strokeStyle 时才需要绘制

      if (!attrs.fillStyle && !attrs.strokeStyle) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Group.prototype), "createPath", this).call(this, context);
    }
  }, {
    key: "drawInner",
    value: function drawInner(context) {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Group.prototype), "drawInner", this).call(this, context);

      this.drawChildren(context);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.get('destroyed')) {
        return;
      }

      this.clear();

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Group.prototype), "destroy", this).call(this);
    }
  }]);

  return Group;
}(__WEBPACK_IMPORTED_MODULE_7__shape_rect__["a" /* default */]); // @ts-ignore


Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["G" /* mix */])(Group.prototype, __WEBPACK_IMPORTED_MODULE_8__container__["a" /* default */], {
  getGroupClass: function getGroupClass() {
    return Group;
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Group);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_layout__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shape__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animation__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elementStatus__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__createClipElement__ = __webpack_require__(274);







 // 转换成布局所需要的布局树

function createNodeTree(element, container, px2hd) {
  var key = element.key,
      ref = element.ref,
      _cache = element._cache,
      type = element.type,
      props = element.props,
      status = element.status,
      animation = element.animation;
  var children = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* extendMap */])(props.children, function (child) {
    return createNodeTree(child, container, px2hd);
  }); // const { style, attrs } = props;

  var style = px2hd(props.style);
  var attrs = px2hd(props.attrs); // 文本要自动计算文本的宽高, TODO, 后面再优化

  if (type === 'text') {
    var shape = container.addShape(type, {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: 0,
        y: 0
      }, attrs)
    });

    var _shape$getBBox = shape.getBBox(),
        width = _shape$getBBox.width,
        height = _shape$getBBox.height;

    style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      width: width,
      height: height
    }, style); // 无用，销毁掉

    shape.remove(true);
  }

  return {
    key: key,
    ref: ref,
    _cache: _cache,
    type: type,
    props: props,
    children: children,
    status: status,
    animation: animation,
    // 处理px2hd之后的配置
    style: style,
    attrs: attrs
  };
}

function mergeLayout(parent, layout) {
  if (!parent || !layout) return layout;
  var parentLeft = parent.left,
      parentTop = parent.top;
  var left = layout.left,
      top = layout.top;
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, layout), {}, {
    left: parentLeft + left,
    top: parentTop + top
  });
}

function createElement(node, container, parentLayout, animate) {
  var _node$_cache = node._cache,
      _cache = _node$_cache === void 0 ? {} : _node$_cache,
      ref = node.ref,
      type = node.type,
      props = node.props,
      attrs = node.attrs,
      originLayout = node.layout,
      renderChildren = node.renderChildren,
      nodeChildren = node.children,
      status = node.status,
      animation = node.animation;

  var layout = mergeLayout(parentLayout, originLayout); // 该元素上一次的attrs

  var lastAttrs = _cache.attrs;

  var elementAttrs = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__shape__["a" /* default */])(type, layout)), status === __WEBPACK_IMPORTED_MODULE_6__elementStatus__["ELEMENT_DELETE"] ? lastAttrs : null), attrs); // 缓存这次新的attrs


  _cache.attrs = elementAttrs;

  if (elementAttrs.clip) {
    var clip = elementAttrs.clip;
    var clipConfig = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["v" /* isFunction */])(clip) ? clip(elementAttrs) : clip;
    elementAttrs.clip = Object(__WEBPACK_IMPORTED_MODULE_7__createClipElement__["a" /* default */])(clipConfig.type, clipConfig);
  }

  var element;

  if (type === 'group') {
    element = container.addGroup(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["H" /* omit */])(props, ['children'])), {}, {
      status: status,
      attrs: elementAttrs
    })); // 如果元素被删除了，就不会有renderChildren， 直接拿node.children渲染

    var children = renderChildren ? renderChildren : nodeChildren; // 只有group才需要处理children

    if (children && children.length) {
      for (var i = 0, len = children.length; i < len; i++) {
        createElement(children[i], element, layout, animate);
      }
    }
  } else {
    element = container.addShape(type, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
      status: status,
      attrs: elementAttrs
    }));
  }

  if (animate !== false) {
    element.set('animation', Object(__WEBPACK_IMPORTED_MODULE_5__animation__["a" /* default */])(element, animation, elementAttrs, lastAttrs));
  }

  if (ref) {
    ref.current = element;
  }

  return element;
} // 过滤删除的元素，让其不参与布局计算


function filterDeleteElement(node) {
  var status = node.status,
      children = node.children;

  if (status === __WEBPACK_IMPORTED_MODULE_6__elementStatus__["ELEMENT_DELETE"]) {
    return null;
  }

  if (!children || !children.length) {
    return node;
  }

  var newChildren = children.filter(function (child) {
    return !!filterDeleteElement(child);
  }); // 要保留引用

  node.children = newChildren;
  node.renderChildren = children;
  return node;
}

function render(element, container, animate) {
  var px2hd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1__util__["e" /* px2hd */];

  if (!element) {
    return;
  }

  var nodeTree = createNodeTree(element, container, px2hd);
  var computeLayoutTree = filterDeleteElement(nodeTree);
  Object(__WEBPACK_IMPORTED_MODULE_3__css_layout__["a" /* default */])(computeLayoutTree);
  return createElement(nodeTree, container, null, animate);
}


/* unused harmony default export */ var _unused_webpack_default_export = (function (element, container, animate) {
  return render(element, container, animate);
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_f2_graphic__ = __webpack_require__(105);



function createClipElement(type, config) {
  return new __WEBPACK_IMPORTED_MODULE_1__antv_f2_graphic__["c" /* Shape */][Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["L" /* upperFirst */])(type)](config);
}

/* harmony default export */ __webpack_exports__["a"] = (createClipElement);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return degrees; });
var radians = Math.PI / 180;
var degrees = 180 / Math.PI;

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__d3_color_src__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color_js__ = __webpack_require__(108);




/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color_js__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + '';
    };
  }

  rgb.gamma = rgbGamma;
  return rgb;
})(1));

function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i,
        color;

    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }

    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + '';
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis_js__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed_js__["a" /* default */]);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(185);

/* harmony default export */ __webpack_exports__["a"] = (function (values) {
  var n = values.length;
  return function (t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genericArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberArray_js__ = __webpack_require__(186);


/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  return (Object(__WEBPACK_IMPORTED_MODULE_1__numberArray_js__["b" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_1__numberArray_js__["a" /* default */] : genericArray)(a, b);
});
function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) {
    x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[i], b[i]);
  }

  for (; i < nb; ++i) {
    c[i] = b[i];
  }

  return function (t) {
    for (i = 0; i < na; ++i) {
      c[i] = x[i](t);
    }

    return c;
  };
}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__value_js__ = __webpack_require__(143);


/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var i = {},
      c = {},
      k;
  if (a === null || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) !== "object") a = {};
  if (b === null || Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_1__value_js__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) {
      c[k] = i[k](t);
    }

    return c;
  };
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(144);

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function () {
    return b;
  };
}

function one(b) {
  return function (t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      // scan index for next number in b
  am,
      // current match in a
  bm,
      // current match in b
  bs,
      // string preceding current number in b, if any
  i = -1,
      // index in s
  s = [],
      // string constants and placeholders
  q = []; // number interpolators
  // Coerce inputs to strings.

  a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.

  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }

    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({
        i: i,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(am, bm)
      });
    }

    bi = reB.lastIndex;
  } // Add remains of b.


  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  } // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.


  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) {
      s[(o = q[i]).i] = o.x(t);
    }

    return s.join("");
  });
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTickMethod;
/* harmony export (immutable) */ __webpack_exports__["b"] = registerTickMethod;
var methodCache = {};
/**
 * 获取计算 ticks 的方法
 * @param key 键值
 * @returns 计算 ticks 的方法
 */
function getTickMethod(key) {
    return methodCache[key];
}
/**
 * 注册计算 ticks 的方法
 * @param key 键值
 * @param method 方法
 */
function registerTickMethod(key, method) {
    methodCache[key] = method;
}
//# sourceMappingURL=register.js.map

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(124);



/**
 * 分类度量
 * @class
 */
var Category = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Category, _super);
    function Category() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cat';
        _this.isCategory = true;
        return _this;
    }
    Category.prototype.buildIndexMap = function () {
        if (!this.translateIndexMap) {
            this.translateIndexMap = new Map();
            // 重新构建缓存
            for (var i = 0; i < this.values.length; i++) {
                this.translateIndexMap.set(this.values[i], i);
            }
        }
    };
    Category.prototype.translate = function (value) {
        // 按需构建 map
        this.buildIndexMap();
        // 找得到
        var idx = this.translateIndexMap.get(value);
        if (idx === undefined) {
            idx = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(value) ? value : NaN;
        }
        return idx;
    };
    Category.prototype.scale = function (value) {
        var order = this.translate(value);
        // 分类数据允许 0.5 范围内调整
        // if (order < this.min - 0.5 || order > this.max + 0.5) {
        //   return NaN;
        // }
        var percent = this.calcPercent(order, this.min, this.max);
        return this.calcValue(percent, this.rangeMin(), this.rangeMax());
    };
    Category.prototype.invert = function (scaledValue) {
        var domainRange = this.max - this.min;
        var percent = this.calcPercent(scaledValue, this.rangeMin(), this.rangeMax());
        var idx = Math.round(domainRange * percent) + this.min;
        if (idx < this.min || idx > this.max) {
            return NaN;
        }
        return this.values[idx];
    };
    Category.prototype.getText = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var v = value;
        // value为index
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(value) && !this.values.includes(value)) {
            v = this.values[v];
        }
        return _super.prototype.getText.apply(this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spreadArrays */])([v], args));
    };
    // 复写属性
    Category.prototype.initCfg = function () {
        this.tickMethod = 'cat';
    };
    // 设置 min, max
    Category.prototype.setDomain = function () {
        // 用户有可能设置 min
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(this.getConfig('min'))) {
            this.min = 0;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(this.getConfig('max'))) {
            var size = this.values.length;
            this.max = size > 1 ? size - 1 : size;
        }
        // scale.init 的时候清除缓存
        if (this.translateIndexMap) {
            this.translateIndexMap = undefined;
        }
    };
    return Category;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Category);
//# sourceMappingURL=base.js.map

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultI18n", function() { return defaultI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGlobalDateI18n", function() { return setGlobalDateI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGlobalDateMasks", function() { return setGlobalDateMasks; });
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ __webpack_exports__["default"] = (fecha);

//# sourceMappingURL=fecha.js.map


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(146);


/**
 * 线性度量
 * @class
 */
var Linear = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Linear, _super);
    function Linear() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'linear';
        _this.isLinear = true;
        return _this;
    }
    Linear.prototype.invert = function (value) {
        var percent = this.getInvertPercent(value);
        return this.min + percent * (this.max - this.min);
    };
    Linear.prototype.initCfg = function () {
        this.tickMethod = 'wilkinson-extended';
        this.nice = false;
    };
    return Linear;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Linear);
//# sourceMappingURL=linear.js.map

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(146);



/**
 * 分段度量
 */
var Quantize = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Quantize, _super);
    function Quantize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'quantize';
        return _this;
    }
    Quantize.prototype.invert = function (value) {
        var ticks = this.ticks;
        var length = ticks.length;
        var percent = this.getInvertPercent(value);
        var minIndex = Math.floor(percent * (length - 1));
        // 最后一个
        if (minIndex >= length - 1) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["D" /* last */])(ticks);
        }
        // 超出左边界， 则取第一个
        if (minIndex < 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["p" /* head */])(ticks);
        }
        var minTick = ticks[minIndex];
        var nextTick = ticks[minIndex + 1];
        // 比当前值小的 tick 在度量上的占比
        var minIndexPercent = minIndex / (length - 1);
        var maxIndexPercent = (minIndex + 1) / (length - 1);
        return minTick + (percent - minIndexPercent) / (maxIndexPercent - minIndexPercent) * (nextTick - minTick);
    };
    Quantize.prototype.initCfg = function () {
        this.tickMethod = 'r-pretty';
        this.tickCount = 5;
        this.nice = true;
    };
    Quantize.prototype.calculateTicks = function () {
        var ticks = _super.prototype.calculateTicks.call(this);
        if (!this.nice) { // 如果 nice = false ,补充 min, max
            if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["D" /* last */])(ticks) !== this.max) {
                ticks.push(this.max);
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["p" /* head */])(ticks) !== this.min) {
                ticks.unshift(this.min);
            }
        }
        return ticks;
    };
    // 计算当前值在刻度中的占比
    Quantize.prototype.getScalePercent = function (value) {
        var ticks = this.ticks;
        // 超出左边界
        if (value < Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["p" /* head */])(ticks)) {
            return 0;
        }
        // 超出右边界
        if (value > Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["D" /* last */])(ticks)) {
            return 1;
        }
        var minIndex = 0;
        Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */])(ticks, function (tick, index) {
            if (value >= tick) {
                minIndex = index;
            }
            else {
                return false;
            }
        });
        return minIndex / (ticks.length - 1);
    };
    return Quantize;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Quantize);
//# sourceMappingURL=quantize.js.map

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateCatTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);

/**
 * 计算分类 ticks
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function calculateCatTicks(cfg) {
    var values = cfg.values, tickInterval = cfg.tickInterval, tickCount = cfg.tickCount, showLast = cfg.showLast;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(tickInterval)) {
        var ticks_1 = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["f" /* filter */])(values, function (__, i) { return i % tickInterval === 0; });
        var lastValue = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(values);
        if (showLast && Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(ticks_1) !== lastValue) {
            ticks_1.push(lastValue);
        }
        return ticks_1;
    }
    var len = values.length;
    var min = cfg.min, max = cfg.max;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(min)) {
        min = 0;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(max)) {
        max = values.length - 1;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["x" /* isNumber */])(tickCount) || tickCount >= len)
        return values.slice(min, max + 1);
    if (tickCount <= 0 || max <= 0)
        return [];
    var interval = tickCount === 1 ? len : Math.floor(len / (tickCount - 1));
    var ticks = [];
    var idx = min;
    for (var i = 0; i < tickCount; i++) {
        if (idx >= max)
            break;
        idx = Math.min(min + i * interval, max);
        if (i === tickCount - 1 && showLast)
            ticks.push(values[max]);
        else
            ticks.push(values[idx]);
    }
    return ticks;
}
//# sourceMappingURL=cat.js.map

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prettyNumber;
// 为了解决 js 运算的精度问题
function prettyNumber(n) {
    return Math.abs(n) < 1e-15 ? n : parseFloat(n.toFixed(15));
}
//# sourceMappingURL=pretty-number.js.map

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pretty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pretty_number__ = __webpack_require__(290);

function pretty(min, max, m) {
    if (m === void 0) { m = 5; }
    if (min === max) {
        return {
            max: max,
            min: min,
            ticks: [min],
        };
    }
    var n = m < 0 ? 0 : Math.round(m);
    if (n === 0)
        return { max: max, min: min, ticks: [] };
    /*
      R pretty:
      https://svn.r-project.org/R/trunk/src/appl/pretty.c
      https://www.rdocumentation.org/packages/base/versions/3.5.2/topics/pretty
      */
    var h = 1.5; // high.u.bias
    var h5 = 0.5 + 1.5 * h; // u5.bias
    // 反正我也不会调参，跳过所有判断步骤
    var d = max - min;
    var c = d / n;
    // 当d非常小的时候触发，但似乎没什么用
    // const min_n = Math.floor(n / 3);
    // const shrink_sml = Math.pow(2, 5);
    // if (Math.log10(d) < -2) {
    //   c = (_.max([ Math.abs(max), Math.abs(min) ]) * shrink_sml) / min_n;
    // }
    var base = Math.pow(10, Math.floor(Math.log10(c)));
    var unit = base;
    if (2 * base - c < h * (c - unit)) {
        unit = 2 * base;
        if (5 * base - c < h5 * (c - unit)) {
            unit = 5 * base;
            if (10 * base - c < h * (c - unit)) {
                unit = 10 * base;
            }
        }
    }
    var nu = Math.ceil(max / unit);
    var ns = Math.floor(min / unit);
    var hi = Math.max(nu * unit, max);
    var lo = Math.min(ns * unit, min);
    var size = Math.floor((hi - lo) / unit) + 1;
    var ticks = new Array(size);
    for (var i = 0; i < size; i++) {
        ticks[i] = Object(__WEBPACK_IMPORTED_MODULE_0__pretty_number__["a" /* prettyNumber */])(lo + i * unit);
    }
    return {
        min: lo,
        max: hi,
        ticks: ticks,
    };
}
//# sourceMappingURL=pretty.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports) {

//# sourceMappingURL=interface.js.map

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__geometry__ = __webpack_require__(148);












/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Geometry) {
    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(Line, _Geometry);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Line);

    function Line() {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Line);

      return _super.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Line, [{
      key: "getDefaultCfg",
      value: function getDefaultCfg() {
        return {
          geomType: 'line',
          sortable: true
        };
      }
    }, {
      key: "splitPoints",
      value: function splitPoints(points) {
        var topPoints = [];
        var bottomPoints = [];

        for (var i = 0, len = points.length; i < len; i++) {
          var point = points[i];
          var x = point.x,
              y = point.y;
          topPoints.push(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, point), {}, {
            x: x,
            y: y[1]
          }));
          bottomPoints.push(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, point), {}, {
            x: x,
            y: y[0]
          }));
        }

        return [topPoints, bottomPoints];
      }
    }, {
      key: "splitNulls",
      value: function splitNulls(points, connectNulls) {
        if (connectNulls) {
          var _tmpPoints = [];

          for (var i = 0, len = points.length; i < len; i++) {
            var point = points[i];
            var y = point.y;

            if (Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["r" /* isArray */])(y)) {
              if (isNaN(y[0])) {
                continue;
              }

              _tmpPoints.push(point);

              continue;
            }

            if (isNaN(y)) {
              continue;
            }

            _tmpPoints.push(point);
          }

          if (_tmpPoints.length) {
            return [_tmpPoints];
          }

          return [];
        }

        var result = [];
        var tmpPoints = [];

        for (var _i = 0, _len = points.length; _i < _len; _i++) {
          var _point = points[_i];
          var _y = _point.y;

          if (Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["r" /* isArray */])(_y)) {
            if (isNaN(_y[0])) {
              if (tmpPoints.length) {
                result.push(tmpPoints);
                tmpPoints = [];
              }

              continue;
            }

            tmpPoints.push(_point);
            continue;
          }

          if (isNaN(_y)) {
            if (tmpPoints.length) {
              result.push(tmpPoints);
              tmpPoints = [];
            }

            continue;
          }

          tmpPoints.push(_point);
        }

        if (tmpPoints.length) {
          result.push(tmpPoints);
        }

        return result;
      }
    }, {
      key: "mapping",
      value: function mapping() {
        var _this = this;

        var records = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Line.prototype), "mapping", this).call(this);

        var props = this.props,
            defaultConnectNulls = this.connectNulls;
        var coord = props.coord,
            _props$connectNulls = props.connectNulls,
            connectNulls = _props$connectNulls === void 0 ? defaultConnectNulls : _props$connectNulls;
        return records.map(function (record) {
          var children = record.children; // children 有可能为空

          var _ref = children[0] || {},
              size = _ref.size,
              color = _ref.color,
              shape = _ref.shape,
              y = _ref.y; // 极坐标时，需加入起点，从而闭合所绘图形


          var points = coord.isPolar ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(children), [children[0]]) : children;

          var splitPoints = _this.splitNulls(points, connectNulls);

          var newChildren = splitPoints.map(function (points) {
            var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_10__antv_util__["r" /* isArray */])(y) ? _this.splitPoints(points) : [points, undefined],
                _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref2, 2),
                topPoints = _ref3[0],
                bottomPoints = _ref3[1];

            return {
              size: size,
              color: color,
              shape: shape,
              points: topPoints,
              bottomPoints: bottomPoints
            };
          });
          return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, record), {}, {
            children: newChildren
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        var coord = props.coord;
        var records = this.mapping();
        var clip = this.getClip();
        return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          coord: coord,
          records: records,
          clip: clip
        }));
      }
    }]);

    return Line;
  }(__WEBPACK_IMPORTED_MODULE_11__geometry__["a" /* default */]);
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(815);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LabelView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_coord__ = __webpack_require__(296);



var DEFAULT_LABEL_CFG = {
  textBaseline: 'middle',
  fill: '#808080'
};
function LabelView(props) {
  var record = props.record,
      offsetX = props.offsetX,
      offsetY = props.offsetY,
      points = props.points,
      label = props.label,
      guide = props.guide;
  var origin = record.origin,
      color = record.color;
  var labelAttrs, guideAttrs;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["v" /* isFunction */])(label)) {
    var point = points.length === 4 // 如果是金字塔图，顶部只有 3 个点
    ? Object(__WEBPACK_IMPORTED_MODULE_2__util_coord__["a" /* getMiddlePoint */])(points[1], points[2]) : Object(__WEBPACK_IMPORTED_MODULE_2__util_coord__["a" /* getMiddlePoint */])(points[0], points[1]);
    labelAttrs = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["G" /* mix */])({
      x: point.x + offsetX,
      y: point.y + offsetY
    }, DEFAULT_LABEL_CFG, label(origin, color));
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["v" /* isFunction */])(guide)) {
    var _points$;

    var _point = Object(__WEBPACK_IMPORTED_MODULE_2__util_coord__["a" /* getMiddlePoint */])(points.length === 4 ? Object(__WEBPACK_IMPORTED_MODULE_2__util_coord__["a" /* getMiddlePoint */])(points[0], points[1]) : points[0], Object(__WEBPACK_IMPORTED_MODULE_2__util_coord__["a" /* getMiddlePoint */])(points[2], (_points$ = points[3]) !== null && _points$ !== void 0 ? _points$ : points[1]));

    guideAttrs = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["G" /* mix */])({
      x: _point.x,
      y: _point.y,
      textBaseline: 'middle',
      textAlign: 'center'
    }, DEFAULT_LABEL_CFG, guide(origin, color));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, labelAttrs && Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
    attrs: labelAttrs
  }), guideAttrs && Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
    attrs: guideAttrs
  }));
}

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMiddlePoint; });
/**
 * 计算两个坐标的中点坐标
 * @param start 起始点{x:number, y:number}
 * @param end 结束点{x:number, y:number}
 * @returns 中点坐标{x:number, y:number}
 */
function getMiddlePoint(start, end) {
  var x = (end.x - start.x) / 2 + start.x;
  var y = (end.y - start.y) / 2 + start.y;
  return {
    x: x,
    y: y
  };
}



/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rect__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar__ = __webpack_require__(825);




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var coord = props.coord;
  var coordType = coord.type; // 直角坐标系

  if (coordType === 'rect') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_2__rect__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  } // 极坐标系


  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_3__polar__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_coord__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(826);



 // 金字塔图和漏斗图的View

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var records = props.records,
      shape = props.shape,
      showLabel = props.showLabel,
      labelCfg = props.labelCfg,
      LabelView = props.LabelView; // 是否倒置

  var overturn = false;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, records.map(function (record, index) {
    var key = record.key,
        children = record.children;
    var isLastRecord = index === records.length - 1;
    var nextRecord = isLastRecord ? record : records[index + 1];
    var nextChildren = nextRecord.children;
    var nextFirstPoint = Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* convertToPoints */])(nextChildren[0]);
    var nextLastPoints = Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* convertToPoints */])(nextChildren[nextChildren.length - 1]);

    if (!overturn) {
      overturn = nextChildren[0].yMax > children[0].yMax;
    }

    if (overturn) {
      nextFirstPoint.reverse();
      nextLastPoints.reverse();
    }

    var polygonPoints = children.map(function (child, childIndex) {
      var points = Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* convertToPoints */])(child);

      if (overturn) {
        points.reverse();
      }

      if (isLastRecord) {
        if (shape === 'pyramid') {
          points = [Object(__WEBPACK_IMPORTED_MODULE_2__util_coord__["a" /* getMiddlePoint */])(points[0], points[1]), points[2], points[3]];
        }
      } else {
        if (childIndex === 0) {
          points[0] = nextFirstPoint[3];
        }

        if (childIndex === children.length - 1) {
          points[1] = nextLastPoints[2];
        }
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, child), {}, {
        points: points
      });
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
      key: key
    }, polygonPoints.map(function (child) {
      var points = child.points,
          color = child.color,
          shape = child.shape;
      return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("polygon", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          points: points,
          fill: color
        }, shape)
      }), showLabel && LabelView ? Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(LabelView, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        record: child,
        points: points
      }, labelCfg)) : null);
    }));
  }));
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRef;
function createRef() {
  var ref = {
    current: null
  };
  return ref;
}

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cluster_js__ = __webpack_require__(856);
/* unused harmony reexport cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pack_index_js__ = __webpack_require__(872);
/* unused harmony reexport pack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack_siblings_js__ = __webpack_require__(302);
/* unused harmony reexport packSiblings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pack_enclose_js__ = __webpack_require__(304);
/* unused harmony reexport packEnclose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partition_js__ = __webpack_require__(873);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__partition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stratify_js__ = __webpack_require__(874);
/* unused harmony reexport stratify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_js__ = __webpack_require__(875);
/* unused harmony reexport tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treemap_index_js__ = __webpack_require__(876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__treemap_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treemap_binary_js__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__treemap_binary_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__treemap_dice_js__ = __webpack_require__(125);
/* unused harmony reexport treemapDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__treemap_slice_js__ = __webpack_require__(151);
/* unused harmony reexport treemapSlice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice_js__ = __webpack_require__(878);
/* unused harmony reexport treemapSliceDice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__treemap_squarify_js__ = __webpack_require__(195);
/* unused harmony reexport treemapSquarify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify_js__ = __webpack_require__(879);
/* unused harmony reexport treemapResquarify */
















/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createForOfIteratorHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unsupportedIterableToArray_js__ = __webpack_require__(181);

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = Object(__WEBPACK_IMPORTED_MODULE_0__unsupportedIterableToArray_js__["a" /* default */])(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enclose_js__ = __webpack_require__(304);



function place(b, a, c) {
  var dx = b.x - a.x,
      x,
      a2,
      dy = b.y - a.y,
      y,
      b2,
      d2 = dx * dx + dy * dy;

  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;

    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6,
      dx = b.x - a.x,
      dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* default */])(circles)).length)) return 0;
  var a, b, c, n, aa, ca, i, j, k, sj, sk; // Place the first circle.

  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r; // Place the second circle.

  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r; // Place the third circle.

  place(b, a, c = circles[2]); // Initialize the front-chain using the first three circles a, b and c.

  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a; // Attempt to place each remaining circle…

  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c); // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.

    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;

    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }

        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }

        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next); // Success! Insert the new circle c between a and b.


    c.previous = a, c.next = b, a.next = b.previous = b = c; // Compute the new closest circle pair to the centroid.

    aa = score(a);

    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }

    b = a.next;
  } // Compute the enclosing circle of the front chain.


  a = [b._], c = b;

  while ((c = c.next) !== b) {
    a.push(c._);
  }

  c = Object(__WEBPACK_IMPORTED_MODULE_1__enclose_js__["a" /* default */])(a); // Translate the circles to put the enclosing circle around the origin.

  for (i = 0; i < n; ++i) {
    a = circles[i], a.x -= c.x, a.y -= c.y;
  }

  return c.r;
}
/* unused harmony default export */ var _unused_webpack_default_export = (function (circles) {
  packEnclose(circles);
  return circles;
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shuffle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);

/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(x) === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
  : Array.from(x); // Map, Set, iterable, string, or anything else
});
function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array_js__ = __webpack_require__(303);

/* harmony default export */ __webpack_exports__["a"] = (function (circles) {
  var i = 0,
      n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array_js__["b" /* shuffle */])(Array.from(circles))).length,
      B = [],
      p,
      e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;
  if (enclosesWeakAll(p, B)) return [p]; // If we get here then B must have at least one element.

  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  } // If we get here then B must have at least two elements.


  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  } // If we get here then something is very wrong.


  throw new Error();
}

function enclosesNot(a, b) {
  var dr = a.r - b.r,
      dx = b.x - a.x,
      dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9,
      dx = b.x - a.x,
      dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }

  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1:
      return encloseBasis1(B[0]);

    case 2:
      return encloseBasis2(B[0], B[1]);

    case 3:
      return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x,
      y1 = a.y,
      r1 = a.r,
      x2 = b.x,
      y2 = b.y,
      r2 = b.r,
      x21 = x2 - x1,
      y21 = y2 - y1,
      r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x,
      y1 = a.y,
      r1 = a.r,
      x2 = b.x,
      y2 = b.y,
      r2 = b.r,
      x3 = c.x,
      y3 = c.y,
      r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}
/* harmony default export */ __webpack_exports__["b"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsx__ = __webpack_require__(20);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var coord = props.coord,
      node = props.node;
  var children = node.children;
  var _coord$center = coord.center,
      x = _coord$center.x,
      y = _coord$center.y;

  var renderNodes = function renderNodes(nodes) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, nodes.map(function (node) {
      var xMin = node.xMin,
          xMax = node.xMax,
          yMin = node.yMin,
          yMax = node.yMax,
          color = node.color,
          children = node.children;
      return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("sector", {
        attrs: {
          x: x,
          y: y,
          lineWidth: '1px',
          stroke: '#fff',
          startAngle: xMin,
          endAngle: xMax,
          r0: yMin,
          r: yMax,
          anticlockwise: false,
          fill: color
        }
      }), children && children.length ? renderNodes(children) : null);
    }));
  };

  return renderNodes(children);
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsx__ = __webpack_require__(20);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var node = props.node;
  var children = node.children;

  var renderNodes = function renderNodes(nodes) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, nodes.map(function (node) {
      var xMin = node.xMin,
          xMax = node.xMax,
          yMin = node.yMin,
          yMax = node.yMax,
          color = node.color,
          children = node.children;
      return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("rect", {
        attrs: {
          x: xMin,
          y: yMin,
          width: xMax - xMin,
          height: yMax - yMin,
          lineWidth: '1px',
          stroke: '#fff',
          fill: color
        }
      }), children && children.length ? renderNodes(children) : null);
    }));
  };

  return renderNodes(children);
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zoomUtil__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_equal__ = __webpack_require__(82);












function lerp(min, max, fraction) {
  return (max - min) * fraction + min;
}

function isEqual(aRange, bRange) {
  for (var i in aRange) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["y" /* isNumberEqual */])(aRange[i], bRange[i])) return false;
  }

  return true;
}

function cloneScale(scale, scaleConfig) {
  // @ts-ignore
  return new scale.constructor(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, scale.__cfg__), scaleConfig));
} // 缩放


var Zoom = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Zoom, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Zoom);

  function Zoom(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Zoom);

    var defaultProps = {
      onPanStart: function onPanStart() {},
      onPinchStart: function onPinchStart() {},
      onPan: function onPan() {},
      onPinch: function onPinch() {},
      onInit: function onInit() {},
      onPanEnd: function onPanEnd() {},
      onPinchEnd: function onPinchEnd() {},
      minCount: 10
    };
    _this = _super.call(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultProps), props));
    _this.scale = {};
    _this.originScale = {}; //swipe end x y

    _this.swipeEnd = {
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0
    };

    _this.onStart = function () {
      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          state = _assertThisInitialize.state;

      var range = state.range;
      _this.startRange = range;
      _this.loop && cancelAnimationFrame(_this.loop);
    };

    _this.onPan = function (ev) {
      var _assertThisInitialize2 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          dims = _assertThisInitialize2.dims;

      var range = {};
      Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["e" /* each */])(dims, function (dim) {
        if (dim === 'x') {
          range['x'] = _this._doXPan(ev);
          return;
        }

        if (dim === 'y') {
          range['y'] = _this._doYPan(ev);
          return;
        }
      });
      if (isEqual(range, _this.state.range)) return;

      _this.setState({
        range: range
      }); // console.log('pan range', range);

    };

    _this.onSwipe = function (ev) {
      var swipe = _this.props.swipe;
      if (_this.props.mode.length < 2 || !swipe) return;
      var _ev$velocityX = ev.velocityX,
          velocityX = _ev$velocityX === void 0 ? 0 : _ev$velocityX,
          _ev$velocityY = ev.velocityY,
          velocityY = _ev$velocityY === void 0 ? 0 : _ev$velocityY,
          points = ev.points;
      var range = _this.state.range;
      var _points$ = points[0],
          x = _points$.x,
          y = _points$.y; // 边界处理

      if (Math.abs((range === null || range === void 0 ? void 0 : range.x[0]) - 0) < 0.0005 && velocityX > 0) return;
      if (Math.abs((range === null || range === void 0 ? void 0 : range.x[1]) - 1) < 0.0005 && velocityX < 0) return;
      if (Math.abs((range === null || range === void 0 ? void 0 : range.y[0]) - 0) < 0.0005 && velocityY < 0) return;
      if (Math.abs((range === null || range === void 0 ? void 0 : range.x[1]) - 1) < 0.0005 && velocityY > 0) return;
      _this.swipeEnd = {
        startX: x,
        startY: y,
        endX: x + velocityX * 50,
        endY: y - velocityY * 50
      };

      _this.onStart();

      _this.update();
    };

    _this.onPinch = function (ev) {
      var _assertThisInitialize3 = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          dims = _assertThisInitialize3.dims;

      var range = {};
      Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["e" /* each */])(dims, function (dim) {
        if (dim === 'x') {
          range['x'] = _this._doXPinch(ev);
          return;
        }

        if (dim === 'y') {
          range['y'] = _this._doYPinch(ev);
          return;
        }
      });
      if (isEqual(range, _this.state.range)) return;

      _this.setState({
        range: range
      });
    };

    _this.onEnd = function () {
      _this.startRange = null;
    };

    var _props$range = props.range,
        range = _props$range === void 0 ? [0, 1] : _props$range,
        mode = props.mode;
    _this.dims = mode instanceof Array ? mode : [mode];
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Zoom, [{
    key: "didMount",
    value: function didMount() {
      this._bindEvents();
    }
  }, {
    key: "willReceiveProps",
    value: function willReceiveProps(nextProps) {
      var nextRange = nextProps.range;
      var lastRange = this.props.range;

      if (!Object(__WEBPACK_IMPORTED_MODULE_10__base_equal__["a" /* default */])(nextRange, lastRange)) {
        var cacheRange = {};
        Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["e" /* each */])(this.dims, function (dim) {
          cacheRange[dim] = nextRange;
        });
        this.state = {
          range: cacheRange
        };
      }
    }
  }, {
    key: "willMount",
    value: function willMount() {
      var _this2 = this;

      var props = this.props,
          dims = this.dims,
          state = this.state;
      var minCount = props.minCount,
          range = props.range; // const { range } = state;

      var valueLength = Number.MIN_VALUE;
      var cacheRange = {};
      Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["e" /* each */])(dims, function (dim) {
        var scale = _this2._getScale(dim);

        var values = scale.values;
        valueLength = values.length > valueLength ? values.length : valueLength;
        _this2.scale[dim] = scale;
        _this2.originScale[dim] = cloneScale(scale);

        _this2.updateRange(range, dim);

        cacheRange[dim] = range;
      }); // 图表上最少显示 MIN_COUNT 个数据

      this.minScale = minCount / valueLength;
      this.state = {
        range: cacheRange
      };
    }
  }, {
    key: "didUnmount",
    value: function didUnmount() {
      this.loop && cancelAnimationFrame(this.loop);

      this._clearEvents();
    }
  }, {
    key: "update",
    value: function update() {
      var _this3 = this;

      var _this$swipeEnd = this.swipeEnd,
          startX = _this$swipeEnd.startX,
          startY = _this$swipeEnd.startY,
          endX = _this$swipeEnd.endX,
          endY = _this$swipeEnd.endY;
      var x = lerp(startX, endX, 0.05);
      var y = lerp(startY, endY, 0.05);
      this.swipeEnd = {
        startX: x,
        startY: y,
        endX: endX,
        endY: endY
      };
      var props = this.props;
      var coord = props.coord;
      var coordWidth = coord.width,
          coordHeight = coord.height;
      var range = {};
      range['x'] = this._doPan((x - startX) / coordWidth, 'x');
      range['y'] = this._doPan((y - startY) / coordHeight, 'y');
      this.setState({
        range: range
      });
      this.startRange = range;
      this.loop = requestAnimationFrame(function () {
        return _this3.update();
      });

      if (Math.abs(x - endX) < 0.0005 && Math.abs(y - endY) < 0.0005) {
        this.onEnd();
        cancelAnimationFrame(this.loop);
      }
    }
  }, {
    key: "_doXPan",
    value: function _doXPan(ev) {
      var direction = ev.direction,
          deltaX = ev.deltaX;

      if (this.props.mode.length === 1 && (direction === 'up' || direction === 'down')) {
        return this.state.range['x'];
      }

      ev.preventDefault && ev.preventDefault();
      var props = this.props;
      var coord = props.coord,
          _props$panSensitive = props.panSensitive,
          panSensitive = _props$panSensitive === void 0 ? 1 : _props$panSensitive;
      var coordWidth = coord.width;
      var ratio = deltaX / coordWidth * panSensitive;

      var newRange = this._doPan(ratio, 'x');

      return newRange;
    }
  }, {
    key: "_doYPan",
    value: function _doYPan(ev) {
      var direction = ev.direction,
          deltaY = ev.deltaY;

      if (this.props.mode.length === 1 && (direction === 'left' || direction === 'right')) {
        return this.state.range['y'];
      }

      ev.preventDefault && ev.preventDefault();
      var props = this.props;
      var coord = props.coord,
          _props$panSensitive2 = props.panSensitive,
          panSensitive = _props$panSensitive2 === void 0 ? 1 : _props$panSensitive2;
      var coordHeight = coord.height;
      var ratio = -deltaY / coordHeight * panSensitive;

      var newRange = this._doPan(ratio, 'y');

      return newRange;
    }
  }, {
    key: "_doPan",
    value: function _doPan(ratio, dim) {
      var startRange = this.startRange;

      var _startRange$dim = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(startRange[dim], 2),
          start = _startRange$dim[0],
          end = _startRange$dim[1];

      var rangeLen = end - start;
      var rangeOffset = rangeLen * ratio;
      var newStart = start - rangeOffset;
      var newEnd = end - rangeOffset;
      var newRange = this.updateRange([newStart, newEnd], dim);
      return newRange;
    }
  }, {
    key: "_doXPinch",
    value: function _doXPinch(ev) {
      ev.preventDefault && ev.preventDefault();
      var zoom = ev.zoom,
          center = ev.center;
      var props = this.props;
      var coord = props.coord;
      var coordWidth = coord.width,
          left = coord.left,
          right = coord.right;
      var leftLen = Math.abs(center.x - left);
      var rightLen = Math.abs(right - center.x); // 计算左右缩放的比例

      var leftZoom = leftLen / coordWidth;
      var rightZoom = rightLen / coordWidth;

      var newRange = this._doPinch(leftZoom, rightZoom, zoom, 'x');

      return newRange;
    }
  }, {
    key: "_doYPinch",
    value: function _doYPinch(ev) {
      ev.preventDefault && ev.preventDefault();
      var zoom = ev.zoom,
          center = ev.center;
      var props = this.props;
      var coord = props.coord;
      var coordHeight = coord.height,
          top = coord.top,
          bottom = coord.bottom;
      var topLen = Math.abs(center.y - top);
      var bottomLen = Math.abs(bottom - center.y); // 计算左右缩放的比例

      var topZoom = topLen / coordHeight;
      var bottomZoom = bottomLen / coordHeight;

      var newRange = this._doPinch(topZoom, bottomZoom, zoom, 'y');

      return newRange;
    }
  }, {
    key: "_doPinch",
    value: function _doPinch(startRatio, endRatio, zoom, dim) {
      var startRange = this.startRange,
          minScale = this.minScale,
          props = this.props;
      var _props$pinchSensitive = props.pinchSensitive,
          pinchSensitive = _props$pinchSensitive === void 0 ? 1 : _props$pinchSensitive;

      var _startRange$dim2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(startRange[dim], 2),
          start = _startRange$dim2[0],
          end = _startRange$dim2[1];

      var zoomOffset = zoom < 1 ? (1 / zoom - 1) * pinchSensitive : (1 - zoom) * pinchSensitive;
      var rangeLen = end - start;
      var rangeOffset = rangeLen * zoomOffset;
      var startOffset = rangeOffset * startRatio;
      var endOffset = rangeOffset * endRatio;
      var newStart = Math.max(0, start - startOffset);
      var newEnd = Math.min(1, end + endOffset);
      var newRange = [newStart, newEnd]; // 如果已经到了最小比例，则不能再继续再放大

      if (newEnd - newStart < minScale) {
        return this.state.range[dim];
      }

      return this.updateRange(newRange, dim);
    }
  }, {
    key: "updateRange",
    value: function updateRange(originalRange, dim) {
      if (!originalRange) return;

      var _originalRange = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(originalRange, 2),
          start = _originalRange[0],
          end = _originalRange[1];

      var rangeLength = end - start; // 处理边界值

      var newRange;

      if (start < 0) {
        newRange = [0, rangeLength];
      } else if (end > 1) {
        newRange = [1 - rangeLength, 1];
      } else {
        newRange = originalRange;
      }

      var props = this.props,
          scale = this.scale,
          originScale = this.originScale,
          state = this.state;
      var chart = props.chart,
          data = props.data,
          autoFit = props.autoFit;
      var range = state.range;
      if (range && isEqual(newRange, range[dim])) return newRange; // 更新主 scale

      Object(__WEBPACK_IMPORTED_MODULE_8__zoomUtil__["b" /* updateRange */])(scale[dim], originScale[dim], newRange);

      if (autoFit) {
        var followScale = this._getFollowScales(dim);

        this.updateFollow(followScale, scale[dim], data);
      } // 手势变化不执行动画


      var animate = chart.animate;
      chart.setAnimate(false);
      chart.forceUpdate(function () {
        chart.setAnimate(animate);
      });
      return newRange;
    }
  }, {
    key: "updateFollow",
    value: function updateFollow(scales, mainScale, data) {
      Object(__WEBPACK_IMPORTED_MODULE_8__zoomUtil__["a" /* updateFollow */])(scales, mainScale, data);
    }
  }, {
    key: "_getScale",
    value: function _getScale(dim) {
      var _this$props = this.props,
          coord = _this$props.coord,
          chart = _this$props.chart;

      if (dim === 'x') {
        return coord.transposed ? chart.getYScales()[0] : chart.getXScales()[0];
      } else {
        return coord.transposed ? chart.getXScales()[0] : chart.getYScales()[0];
      }
    }
  }, {
    key: "_getFollowScales",
    value: function _getFollowScales(dim) {
      var _this$props2 = this.props,
          coord = _this$props2.coord,
          chart = _this$props2.chart;

      if (dim === 'x') {
        return coord.transposed ? chart.getXScales() : chart.getYScales();
      }

      if (dim === 'y') {
        return coord.transposed ? chart.getYScales() : chart.getXScales();
      }
    }
  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      var _this4 = this;

      var context = this.context,
          props = this.props,
          scale = this.scale;
      var canvas = context.canvas;
      var onPinchStart = props.onPinchStart,
          onPanStart = props.onPanStart,
          onPanEnd = props.onPanEnd,
          pan = props.pan,
          pinch = props.pinch,
          swipe = props.swipe,
          onInit = props.onInit,
          onPan = props.onPan,
          onPinch = props.onPinch,
          onPinchEnd = props.onPinchEnd; // 统一绑定事件

      if (pan !== false) {
        canvas.on('panstart', function () {
          _this4.onStart();

          onPanStart({
            scale: scale
          });
        });
        canvas.on('pan', function (ev) {
          _this4.onPan(ev);

          onPan(ev);
        });
        canvas.on('panend', function () {
          _this4.onEnd();

          onPanEnd({
            scale: scale
          });
        });
      }

      if (pinch !== false) {
        canvas.on('pinchstart', function () {
          _this4.onStart();

          onPinchStart();
        });
        canvas.on('pinch', function (ev) {
          _this4.onPinch(ev);

          onPinch(ev);
        });
        canvas.on('pinchend', function () {
          _this4.onEnd();

          onPinchEnd({
            scale: scale
          });
        });
      }

      if (swipe !== false) {
        canvas.on('swipe', this.onSwipe);
      }

      onInit({
        scale: scale
      });
    }
  }, {
    key: "_clearEvents",
    value: function _clearEvents() {
      var _this5 = this;

      var context = this.context,
          props = this.props,
          scale = this.scale;
      var canvas = context.canvas;
      var onPinchEnd = props.onPinchEnd,
          onPanEnd = props.onPanEnd,
          onPinchStart = props.onPinchStart,
          pan = props.pan,
          pinch = props.pinch,
          onPan = props.onPan,
          onPinch = props.onPinch,
          swipe = props.swipe; // 统一解绑事件

      if (pan !== false) {
        canvas.off('panstart', function () {
          _this5.onStart();

          onPinchStart();
        });
        canvas.off('pan', function (ev) {
          _this5.onPan(ev);

          onPan(ev);
        });
        canvas.off('panend', function () {
          _this5.onEnd();

          onPanEnd({
            scale: scale
          });
        });
      }

      if (pinch !== false) {
        canvas.off('pinchstart', function () {
          _this5.onStart();

          onPinchStart();
        });
        canvas.off('pinch', function (ev) {
          _this5.onPinch(ev);

          onPinch(ev);
        });
        canvas.off('pinchend', function () {
          _this5.onEnd();

          onPinchEnd({
            scale: scale
          });
        });
      }

      if (swipe !== false) {
        canvas.off('swipe', this.onSwipe);
      }
    }
  }]);

  return Zoom;
}(__WEBPACK_IMPORTED_MODULE_7__base_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Zoom);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper__ = __webpack_require__(311);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var WrapperStyle={padding:'.4em 1em',border:'2px solid #fff',borderRadius:'2.2em',position:'relative',boxShadow:'0 0 .8em rgba(0, 0, 0, 0.5)',wordBreak:'keep-all',whiteSpace:'pre-wrap'};var MsgStyle={fontSize:'1.8em',fontWeight:'800',lineHeight:'1.4'};var HeadStyle={position:'absolute',left:'-4.6em',top:'50%',transform:'translateY(-50%)',width:'4em',height:'4em',borderRadius:'50%',border:'2px solid #eee',boxShadow:'0 0 .8em rgba(0, 0, 0, 0.8)'};var ImageStyle={borderRadius:'50%',width:'100%',height:'100%'};var sizes={small:'10px',normal:'12px',large:'14px',huge:'16px'};var StyledBullet=function StyledBullet(_ref){var msg=_ref.msg,head=_ref.head,_ref$size=_ref.size,size=_ref$size===void 0?'normal':_ref$size,color=_ref.color,_ref$backgroundColor=_ref.backgroundColor,backgroundColor=_ref$backgroundColor===void 0?'#fff':_ref$backgroundColor;var finalColor=color||Object(__WEBPACK_IMPORTED_MODULE_9__helper__["c" /* getCorrectTextColor */])(backgroundColor);var fontSize=sizes[size]||size;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},WrapperStyle),{},{backgroundColor:backgroundColor,fontSize:fontSize})},head&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:_objectSpread({},HeadStyle)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{src:head,style:ImageStyle,alt:"msg head"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{style:_objectSpread(_objectSpread({},MsgStyle),{},{color:finalColor})},msg));};/* harmony default export */ __webpack_exports__["a"] = (StyledBullet);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initBulletAnimate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPlainObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCorrectTextColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_date_to_string_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_date_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_date_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_to_string_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_color_convert__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_color_convert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_color_convert__);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}var initBulletAnimate=function initBulletAnimate(screen){if(!screen){return;}var animateClass='BULLET_ANIMATE';var style=document.createElement('style');style.classList.add(animateClass);document.head.appendChild(style);var _screen$getBoundingCl=screen.getBoundingClientRect(),width=_screen$getBoundingCl.width;var from="from { visibility: visible; transform: translateX(".concat(width,"px); }");var to="to { visibility: visible; transform: translateX(-100%); }";style.sheet.insertRule("@keyframes RightToLeft { ".concat(from," ").concat(to," }"),0);};var isPlainObject=function isPlainObject(val){if(val===null){return false;}return typeof val==='function'||_typeof(val)==='object';};var getContainer=function getContainer(opts){var currScreen=opts.currScreen,pauseOnHover=opts.pauseOnHover,pauseOnClick=opts.pauseOnClick,animate=opts.animate,loopCount=opts.loopCount,direction=opts.direction,delay=opts.delay,duration=opts.duration,animateTimeFun=opts.animateTimeFun;// 创建单条弹幕的容器
var bulletContainer=document.createElement('div');// 随机ID
bulletContainer.id=Math.random().toString(36).substring(2);// 设置弹幕容器的初始样式
bulletContainer.style.transitionProperty='opacity';bulletContainer.style.transitionDuration='0.5s';bulletContainer.style.cursor='pointer';bulletContainer.style.position='absolute';bulletContainer.style.left=0;// bulletContainer.style.zIndex = zIndex;
bulletContainer.style.visibility='hidden';bulletContainer.style.animationName=animate;bulletContainer.style.animationIterationCount=loopCount;bulletContainer.style.animationDelay=isNaN(delay)?delay:"".concat(delay,"s");bulletContainer.style.animationDirection=direction;bulletContainer.style.animationDuration=isNaN(duration)?duration:"".concat(duration,"s");bulletContainer.style.animationTimingFunction=animateTimeFun;// 性能小优化
bulletContainer.style.willChange='transform';// 隐藏
if(currScreen.allHide){bulletContainer.style.opacity=0;}// pause on hover
if(pauseOnHover){bulletContainer.addEventListener('mouseenter',function(){console.log('enter');bulletContainer.style.animationPlayState='paused';},false);bulletContainer.addEventListener('mouseleave',function(){console.log('leave');if(!currScreen.allPaused&&!bulletContainer.dataset.clicked){bulletContainer.style.animationPlayState='running';}},false);}// pauseonClick
if(pauseOnClick){bulletContainer.addEventListener('click',function(evt){console.log(evt);var currStatus=bulletContainer.style.animationPlayState;if(currStatus=='paused'&&bulletContainer.dataset.clicked){bulletContainer.dataset.clicked='';bulletContainer.style.animationPlayState='running';}else{bulletContainer.dataset.clicked='true';bulletContainer.style.animationPlayState='paused';}},false);}return bulletContainer;};function getRGB(str){var match=str.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);return match?[match[1],match[2],match[3]]:[0,0,0];}function getCorrectTextColor(){var rgb=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[0,0,0];/*
  From this W3C document: https://www.webmasterworld.com/r.cgi?f=88&d=9769&url=https://www.w3.org/TR/AERT#color-contrast

  Color brightness is determined by the following formula:
  ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

  I know this could be more compact, but I think this is easier to read/explain.

  */if((typeof rgb==='string'||rgb instanceof String)&&rgb.indexOf('#')>-1){console.log('rgb is hex');rgb=__WEBPACK_IMPORTED_MODULE_13_color_convert___default.a.hex.rgb(rgb);}else if(typeof rgb==='string'){console.log('rgb string',rgb);rgb=getRGB(rgb);console.log('rgb converted',rgb);}console.log({rgb:rgb});var threshold=130;/* about half of 256. Lower threshold equals more dark text on dark background  */var _rgb=rgb,_rgb2=_slicedToArray(_rgb,3),hRed=_rgb2[0],hGreen=_rgb2[1],hBlue=_rgb2[2];var cBrightness=(hRed*299+hGreen*587+hBlue*114)/1000;if(cBrightness>threshold){return'#50616d';}else{return'#e9f1f6';}}var defaultOptions={// 跑道高度
trackHeight:50,// 弹幕之间的间距
gap:'-10px',animate:'RightToLeft',pauseOnHover:false,pauseOnClick:false,onStart:null,onEnd:null,loopCount:1,duration:10,delay:0,direction:'normal',animateTimeFun:'linear'};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(906);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};



/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(316);

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(318);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aegis_web_sdk__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_aegis_web_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_aegis_web_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_lib_flexible_js__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getOfflineWebData__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_utils_js__ = __webpack_require__(7);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}/*
 * @Author: songxiaoqiang
 * @Date: 2020-08-10 11:33:26
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */var aegis=new __WEBPACK_IMPORTED_MODULE_10_aegis_web_sdk___default.a({id:'vq6qDu47L2vRo3l8XD',//应用ID，即上报key   
uin:'',// 用户唯一 ID（可选）    
reportApiSpeed:true,// 接口测速    
reportAssetSpeed:true,// 静态资源测速    
spa:true,// spa 应用页面跳转的时候开启 pv 计算
beforeRequest:function beforeRequest(data){if(typeof window!=='undefined'){var pageScene=window.pageScene;var h5Url=window.location.href;if(pageScene==='app首页'||h5Url.indexOf('offlineWeb/page')>=0){var logType=data.logType,_data$logs=data.logs,logs=_data$logs===void 0?{}:_data$logs;if(logType==='performance'||logType==='vitals'){var pageId='';if(h5Url.indexOf('offlineWeb/page')>=0){var match=h5Url.match(/page\/(\d+)\/version/);if(match){pageId=match[1];}else{pageId='';}}else{pageId=__WEBPACK_IMPORTED_MODULE_13__utils_utils_js__["a" /* default */].getPageId();}var ua=navigator.userAgent;var options={h5Url:h5Url,pageId:pageId,ua:ua,logType:logType,logs:logs};Object(__WEBPACK_IMPORTED_MODULE_9_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:'lego-sales:performance',name:'性能指标数据',biz:JSON.stringify(options),pageOptions:options}});window.Jockey.send('relayPerformanceData',{logType:logType,logs:logs});}}}return data;}});window.aegis=aegis;// 先加载数据，再渲染应用
function initApp(){return _initApp.apply(this,arguments);}function _initApp(){_initApp=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(typeof window!=='undefined')){_context.next=3;break;}_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_12__utils_getOfflineWebData__["a" /* default */])();case 3:__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.render(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */],null),document.getElementById('root'));case 4:case"end":return _context.stop();}}},_callee);}));return _initApp.apply(this,arguments);}initApp();

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(127)('native-function-to-string', Function.toString);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(157);
__webpack_require__(30)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(91);
var call = __webpack_require__(198);
var isArrayIter = __webpack_require__(199);
var anObject = __webpack_require__(54);
var toLength = __webpack_require__(68);
var getIterFn = __webpack_require__(200);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var macrotask = __webpack_require__(202).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(85)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(54);
var isObject = __webpack_require__(64);
var newPromiseCapability = __webpack_require__(204);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(69);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(207),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(207),r=__webpack_require__(330);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(331);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_ends_with_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_ends_with_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_ends_with_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__App_css__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__utils_callAppLib__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__baseComponents_navigation_bar__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__baseComponents_navigation_bar_popover__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__baseComponents_comment__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_comp__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_interveneTest__ = __webpack_require__(948);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _createForOfIteratorHelper(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return{s:F,n:function n(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};},e:function e(_e){throw _e;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return{s:function s(){it=it.call(o);},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e2){didErr=true;err=_e2;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-08-10 11:33:26
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var isDev="production"==='development';var baseConfig=isDev?__webpack_require__(949):__webpack_require__(950);var mycomponents=isDev?__webpack_require__(951):__webpack_require__(952);var TEMPLATE_NAME='zhuanti';var pageId=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getPageId()||'';var isCommunityTab=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getParams('community_tab')=='1';var App=/*#__PURE__*/function(_React$Component){_inherits(App,_React$Component);var _super=_createSuper(App);function App(props){var _this;_classCallCheck(this,App);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"loadWxOpenLaunchAppTag",function(){if(window.WxOpenLaunchApp){var _ref=isDev?baseConfig:window,navigatorBarTranslucent=_ref.navigatorBarTranslucent;var pathname=window.location.pathname.replace('/zt-public','');var href=encodeURIComponent('https://zt-public.shihuo.cn'+pathname);var targetUrl="shihuo://www.shihuo.cn?route=fastWebview&url=".concat(href,"&navigationBar=").concat(navigatorBarTranslucent!=='是');var pageOptions={lego_page_id:pageId,legoAb:_this.state.abValue};var commonStyle={position:'absolute',left:0,top:0,zIndex:10001,width:'100%',height:'100%'};var _this$shareInfo=_this.shareInfo,shareTitle=_this$shareInfo.shareTitle,shareContent=_this$shareInfo.shareContent,shareImage=_this$shareInfo.shareImage,shareUrl=_this$shareInfo.shareUrl;var shareInfo={title:shareTitle,desc:shareContent,imgUrl:shareImage,link:shareUrl};var wxOpenLaunchApp=new window.WxOpenLaunchApp({options:{targetUrl:targetUrl,kouling:_this.kouling,scene:'h5Lego',shareInfo:shareInfo,pageOptions:pageOptions},containers:[{element:'.open-app',style:commonStyle,clickEvent:function clickEvent(){var kouling=typeof window!=="undefined"&&"1http://shihuo.cn".concat(_this.kouling,"##").concat(window.localStorage.getItem('m_device_id'),"##h5Lego");Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"lego:goApp",name:'',biz:JSON.stringify({lego_page_id:pageId,legoAb:_this.state.abValue,h5Url:window.location.href,pageId:pageId,command:kouling,deviceId:window.localStorage.getItem('m_device_id')}),pageOptions:{lego_page_id:pageId,legoAb:_this.state.abValue}}});}}]});// 初始化配置
wxOpenLaunchApp.initConfig();}});_defineProperty(_assertThisInitialized(_this),"handleExtraEvent",function(){// 页面进入埋点
if(typeof window!=='undefined'){Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["initPti"])({pageName:pageId});var pageOptions={lego_page_id:pageId,h5Url:window.location.href,legoAb:_this.state.abValue};Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:'lego-specialTopic:show',name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});// 页面停留时长埋点上报
__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].pageStayTrack('lego-specialTopic',pageOptions);}// 在iframe中打开，获取组件尺寸并发送后台编辑器
if(typeof window!=='undefined'&&window.parent&&_this.iframe){__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].postComponentSizeToEditor();}});_defineProperty(_assertThisInitialized(_this),"registerShare",function(){/**
     * 分享到微信内页面域名使用www.shihuo.cn,因为微信开档标签域名只支持www.shihuo.cn，
     * nginx会将www.shihuo.cn/zt-public转发到zt-public.shihuo.cn,
     * app内则正常使用zt-public.shihuo.cn域名
     */if(typeof window!=='undefined'){window.Jockey.send("register:share",{url:_this.shareInfo.shareUrl,title:_this.shareInfo.shareTitle,content:_this.shareInfo.shareContent,img:_this.shareInfo.shareImage});}});_defineProperty(_assertThisInitialized(_this),"communityTabLogic",function(){if(typeof window!=="undefined"&&isCommunityTab){var timer=setTimeout(function(){var pageOptions={lego_page_id:pageId,h5Url:window.location.href,legoAb:_this.state.abValue};window.Jockey.on("onPageVisibleStateChange",function(e){if(e&&e.pageState==='visible'&&e.appState==='foreground'){var jumpSubPage=localStorage.getItem('jumpSubPage');if(jumpSubPage){localStorage.removeItem('jumpSubPage');}else{// 上报埋点
Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"lego-specialTopic:show",name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}if(_this.state.pipelineComponents.find(function(comp){return comp.name==='pipeline-video'||comp.name==='pipeline-interactMessage';})){// 播放视频
_this.setState({playerState:'play'});}_this.pageVisiable=true;// 页面可见时，重置页面停留开始时间
localStorage.setItem('stayStart',String(new Date().getTime()));}else{// 上报埋点
if(_this.state.pipelineComponents.find(function(comp){return comp.name==='pipeline-video'||comp.name==='pipeline-interactMessage';})){// 暂停播放
_this.setState({playerState:'pause'});}// 页面隐藏时，停留时长埋点上报
if(_this.pageVisiable){_this.pageVisiable=false;__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].pageStayUpload('lego-specialTopic',pageOptions);}}});window.Jockey.send("onPageVisibleStateChange",{},function(){});clearTimeout(timer);},1000);}});_defineProperty(_assertThisInitialized(_this),"querySupportWebp",function(){window.Jockey.send("device",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(device){var platform,osVersion,deviceId,osMainVersion,abtest_tag,group,pipelineComponents;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(device){platform=device.platform;osVersion=device.os_version||'';deviceId=device.idfa||device.deviceId;osMainVersion=Number(osVersion.split('.')[0]);abtest_tag=device.abtest_tag;group='';abtest_tag.split(';').forEach(function(item){if(item&&item.indexOf('BG=')>-1){var value=item.split('=')[1];group=value==3?'B':'A';}});pipelineComponents=JSON.parse(JSON.stringify(_this.state.pipelineComponents));if(['17675052474380033'].includes(pageId)){pipelineComponents=Object(__WEBPACK_IMPORTED_MODULE_42__utils_interveneTest__["a" /* interveneTest */])(pipelineComponents,pageId,group);}if(platform==='ios'&&osMainVersion<14){_this.setState({webpSupport:false,osVersion:osVersion,group:group,legoAb:group,pipelineComponents:pipelineComponents},function(){_this.handleExtraEvent();});}else{_this.setState({webpSupport:true,osVersion:osVersion,group:group,abValue:group,pipelineComponents:pipelineComponents},function(){_this.handleExtraEvent();});}if(window.aegis){window.aegis.setConfig({uin:deviceId});}}case 1:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref2.apply(this,arguments);};}());});_defineProperty(_assertThisInitialized(_this),"handleBrowserInApp",function(){var kouling=typeof window!=="undefined"&&"1http://shihuo.cn".concat(_this.kouling,"##").concat(window.localStorage.getItem('m_device_id'),"##h5Lego");Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"lego:goApp",name:'',biz:JSON.stringify({lego_page_id:pageId,legoAb:_this.state.abValue,h5Url:typeof window!=="undefined"&&window.location.href,pageId:pageId,command:kouling,deviceId:typeof window!=="undefined"&&window.localStorage.getItem('m_device_id')}),pageOptions:{lego_page_id:pageId,legoAb:_this.state.abValue}}});var _ref3=isDev?baseConfig:window,navigatorBarTranslucent=_ref3.navigatorBarTranslucent;var pathname,href;if(typeof window!=="undefined"){if(['lego-api.shihuo.cn','lego-api-tst.shihuo.cn'].indexOf(window.location.host)>=0){href=window.location.href;}else{pathname=window.location.pathname.replace('/zt-public','');href=encodeURIComponent('https://zt-public.shihuo.cn'+pathname);}}var targetUrl="shihuo://www.shihuo.cn?route=fastWebview&url=".concat(href,"&navigationBar=").concat(navigatorBarTranslucent!=='是');var pageOptions={template:'lego-specialTopic'};Object(__WEBPACK_IMPORTED_MODULE_37__utils_callAppLib__["a" /* callAppTrigger */])(targetUrl,_this.kouling,'h5Lego',pageOptions);});_defineProperty(_assertThisInitialized(_this),"ruleEntryJump",function(href){window.Jockey.send('action',{url:href});});_defineProperty(_assertThisInitialized(_this),"updateCommunityVoteState",function(status){_this.setState({communityVoteState:status});});_defineProperty(_assertThisInitialized(_this),"updateLotteryState",function(status){_this.setState({lotteryState:status});});_this.exp=typeof window!=="undefined"&&window.shihuo?new window.shihuo.Exposure():null;var _ref4=typeof window!=="undefined"&&!isDev?window:baseConfig,title=_ref4.title,_shareTitle=_ref4.shareTitle,_shareContent=_ref4.shareContent,shareImg=_ref4.shareImg,_navigatorBarTranslucent=_ref4.navigatorBarTranslucent,navigatorBarTheme=_ref4.navigatorBarTheme,searchBoxDisplay=_ref4.searchBoxDisplay,searchWords=_ref4.searchWords,searchGuideText=_ref4.searchGuideText,searchGuideColor=_ref4.searchGuideColor,abTestEnable=_ref4.abTestEnable,abPreviewValue=_ref4.abPreviewValue,abPercent=_ref4.abPercent,ruleEntryShow=_ref4.ruleEntryShow,ruleEntryHref=_ref4.ruleEntryHref,_ref4$dataSourceStr=_ref4.dataSourceStr,dataSourceStr=_ref4$dataSourceStr===void 0?"":_ref4$dataSourceStr,_ref4$createTime=_ref4.createTime,createTime=_ref4$createTime===void 0?"":_ref4$createTime;var _shareUrl=typeof window!=="undefined"&&window.location.href.replace('zt-public.shihuo.cn','m.shihuo.cn/zt-public');var _shareInfo={shareUrl:_shareUrl||"https://m.shihuo.cn",shareTitle:_shareTitle||title||"来自识货App的分享",shareContent:_shareContent||"识货App：实物鉴别，严选正品优质店铺，购物之前要识货",shareImage:shareImg||"http://static.shihuocdn.cn/admin/files/20200701/802cc61ad724a6f194befc52a80807ea.jpeg"};var isShihuo=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].isShihuo();var isAndroid=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].isAndroid();var _pipelineComponents=typeof window!=="undefined"?window.INIT_DATA||mycomponents:mycomponents;var abValue='';if(abTestEnable=='是'&&typeof window!=='undefined'){var isPipelineAbExist=false;// 先判断页面中是否存在AB实验的组件，只有存在AB实验的组件时再进行流量分配
var _iterator=_createForOfIteratorHelper(_pipelineComponents),_step;try{for(_iterator.s();!(_step=_iterator.n()).done;){var comp=_step.value;if(comp.name==='pipeline-ab'){isPipelineAbExist=true;break;}if(comp.name==='pipeline-tabItem'){var _iterator2=_createForOfIteratorHelper(comp.data),_step2;try{for(_iterator2.s();!(_step2=_iterator2.n()).done;){var tabItemcomp=_step2.value;if(tabItemcomp.name==='pipeline-ab'){isPipelineAbExist=true;break;}}}catch(err){_iterator2.e(err);}finally{_iterator2.f();}}}}catch(err){_iterator.e(err);}finally{_iterator.f();}if(isPipelineAbExist){if(['lego-api.shihuo.cn','lego-api-tst.shihuo.cn'].indexOf(window.location.host)>=0){// 代表是预览环境
abValue=abPreviewValue;}else{var cacheKey="pipeline_ab_".concat(pageId);var abCacheValue=localStorage.getItem(cacheKey);var abPercentCacheKey="ab_percent_".concat(pageId);var abPercentCacheValue=localStorage.getItem(abPercentCacheKey);if(abCacheValue&&abPercentCacheValue==abPercent){abValue=abCacheValue;}else{var arr=[{value:'A',percent:abPercent},{value:'B',percent:100-abPercent}];var randomItem=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getWeightRandom(arr);abValue=randomItem.value;localStorage.setItem(cacheKey,abValue);localStorage.setItem(abPercentCacheKey,abPercent);}}}}var downloadUrl=typeof window!=="undefined"?{ios:window.iphone_url,android:window.android_url}:{ios:baseConfig.iphone_url,android:baseConfig.android_url};var from=typeof window!=="undefined"?window.from:baseConfig.from;// 从链接获取下载链接和kolid
if(typeof window!=="undefined"&&__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getParams("longurl")){var longurl=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getParams("longurl");longurl=decodeURIComponent(longurl);var queryArray=longurl.split("?")[1].split("&");var queryObj={};queryArray.forEach(function(item){var itemObj=item.split("=");queryObj[itemObj[0]]=itemObj[1];});// 取出longurl上的参数作为配置数据
from=queryObj.from;downloadUrl.ios=queryObj.iphone_url;downloadUrl.android=queryObj.android_url;}// 从url中获取口令参数，默认为空
var _kouling="";if(typeof window!=="undefined"&&__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getQueryString("kl")){_kouling=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getQueryString("kl");_kouling=decodeURIComponent(_kouling);}var backgroundColor=typeof window!=="undefined"?window.backgroundColor:baseConfig.backgroundColor;var baseComponents={};var basePipelineComponents=[];var navigationBarPaddingTop=0;var navigationBarHeight=0;var allModals=JSON.parse(JSON.stringify(_pipelineComponents.filter(function(item){return item.name==='pipeline-modal';})));var autoModals=allModals.filter(function(item){if(typeof window!=="undefined"&&item.data.baseConfig.triggerType==='进页面唤起'){var times=+(window.localStorage.getItem(item.id)||0);var popTimes=item.data.baseConfig.popTimes;if(times<popTimes||popTimes===''){return true;}}return false;}).sort(function(a,b){return a.data.baseConfig.level<b.data.baseConfig.level?-1:1;});if(isShihuo&&_navigatorBarTranslucent==='是'&&!isCommunityTab){baseComponents['navigation-bar']=__WEBPACK_IMPORTED_MODULE_38__baseComponents_navigation_bar__["a" /* default */];basePipelineComponents.push({id:"navigation-bar",name:"navigation-bar",data:{baseConfig:_objectSpread({navigatorBarTheme:navigatorBarTheme,searchBoxDisplay:searchBoxDisplay,searchWords:searchWords,searchGuideText:searchGuideText,searchGuideColor:searchGuideColor},_shareInfo)}});}_this.state={pipelineComponents:[].concat(_toConsumableArray(_pipelineComponents),basePipelineComponents),autoModals:autoModals,allModals:allModals,goodsList:[],components:_objectSpread(_objectSpread({},__WEBPACK_IMPORTED_MODULE_41_comp__["a" /* default */]),baseComponents),from:from,downloadUrl:"http://www.shihuo.cn/shihuo/qrcodeRedirect?iphone_url=".concat(downloadUrl.ios,"&android_url=").concat(downloadUrl.android,"&from=").concat(from),kouling:_kouling,navigationBarHeight:navigationBarHeight,navigationBarPaddingTop:navigationBarPaddingTop,backgroundColor:backgroundColor,dataSourceStr:dataSourceStr,routeParams:null,abValue:'',navigatorBarTheme:'黑',webpSupport:true,osVersion:'',createTime:createTime,playerState:'',ruleEntryShow:ruleEntryShow,ruleEntryHref:ruleEntryHref,lotteryState:false,communityVoteState:false,group:''};_this.scrollTime="";_this.isScrolling=false;_this.scrollTimeout=null;_this.pageVisiable=true;_this.iframe=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getParams('isIframe')=='1';_this.isShihuo=isShihuo;_this.isAndroid=isAndroid;_this.kouling=_kouling;_this.shareInfo=_shareInfo;_this.isWx=typeof window!=="undefined"?window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=='micromessenger':false;_this.isQQ=typeof window!=="undefined"?/MQQBrowser/i.test(window.navigator.userAgent)&&/\sQQ/i.test(window.navigator.userAgent.split('MQQBrowser')):false;_this.isWeibo=typeof window!=="undefined"?window.navigator.userAgent.toLowerCase().match(/WeiBo/i)=='weibo':false;_this.hideCallAppBtn=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getParams('hideCallAppBtn');return _this;}_createClass(App,[{key:"componentWillMount",value:function(){var _componentWillMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(typeof window!=="undefined"){this.querySupportWebp();}case 1:case"end":return _context2.stop();}}},_callee2,this);}));function componentWillMount(){return _componentWillMount.apply(this,arguments);}return componentWillMount;}()},{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var _this2=this;var timeout,_this$state,components,pipelineComponents,_ref6,commentEnable;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(typeof window!=="undefined")){_context3.next=14;break;}if(!this.isShihuo){_context3.next=5;break;}window.Jockey.send("getRouteParams",{},function(value){var _this2$state=_this2.state,components=_this2$state.components,pipelineComponents=_this2$state.pipelineComponents;var _ref5=isDev?baseConfig:window,navigatorBarTranslucent=_ref5.navigatorBarTranslucent,navigatorBarTheme=_ref5.navigatorBarTheme,commentEnable=_ref5.commentEnable,searchBoxDisplay=_ref5.searchBoxDisplay,searchWords=_ref5.searchWords,searchGuideText=_ref5.searchGuideText,searchGuideColor=_ref5.searchGuideColor;var navigationBarPaddingTop=0,navigationBarHeight=0;window.Jockey.send('setStatusbarStyle',{barStyle:navigatorBarTheme==='黑'?'dark-content':'light-content'});// 如果是在华为智慧搜素或华为生活服务App打开，则不显示沉浸式导航
if(window.HW_MANAGED_JS||window.lives&&typeof window.lives.getAppExists=='function'){navigatorBarTranslucent='否';}if(value&&(value.navigationBar==='false'||value.navigationBar===false)&&value.openType!=='modal'&&value.modalStyle!=='popOver'&&navigatorBarTranslucent=='是'){var navigationBarInfo=__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getNavigationBarInfo();if(navigationBarInfo){navigationBarPaddingTop=navigationBarInfo.navigationBarPaddingTop;navigationBarHeight=navigationBarInfo.navigationBarHeight;}if(isCommunityTab){navigationBarHeight=0;navigationBarPaddingTop=0;}}if(value&&value.openType==='modal'&&value.modalStyle==='popOver'){navigationBarPaddingTop=0;navigationBarHeight=48;// 页面通过原生弹板形式打开
components['navigation-bar-popover']=__WEBPACK_IMPORTED_MODULE_39__baseComponents_navigation_bar_popover__["a" /* default */];pipelineComponents.unshift({id:"navigation-bar-popover",name:"navigation-bar-popover",data:{baseConfig:_objectSpread({navigatorBarTheme:navigatorBarTheme,searchBoxDisplay:searchBoxDisplay,searchWords:searchWords,searchGuideText:searchGuideText,searchGuideColor:searchGuideColor},_this2.shareInfo)}});// 过滤掉常规沉浸式导航
pipelineComponents=pipelineComponents.filter(function(item){return item.name!=='navigation-bar';});}if(__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].SHDiffVersion(__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].getVersion(),'7.72.0')&&commentEnable==='是'){// v7.72.0及以上版本 才能展示评论区
components['comment']=__WEBPACK_IMPORTED_MODULE_40__baseComponents_comment__["a" /* default */];pipelineComponents.push({id:'comment',name:'comment',data:{}});}_this2.setState({routeParams:value,navigatorBarTheme:navigatorBarTheme,navigationBarPaddingTop:navigationBarPaddingTop,navigationBarHeight:navigationBarHeight,pipelineComponents:pipelineComponents,components:components});});_context3.next=14;break;case 5:if(!(this.isAndroid&&this.isWx)){_context3.next=10;break;}_context3.next=8;return __WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].loadWeixinJsSdk();case 8:// 站外访问埋点
Object(__WEBPACK_IMPORTED_MODULE_37__utils_callAppLib__["b" /* pageShowTrack */])('h5Lego:show:',{kouling:this.kouling,lego_page_id:pageId,legoAb:this.state.abValue});timeout=setTimeout(function(){_this2.loadWxOpenLaunchAppTag();clearTimeout(timeout);},500);case 10:_this$state=this.state,components=_this$state.components,pipelineComponents=_this$state.pipelineComponents;_ref6=isDev?baseConfig:window,commentEnable=_ref6.commentEnable;if(commentEnable==='是'){components['comment']=__WEBPACK_IMPORTED_MODULE_40__baseComponents_comment__["a" /* default */];pipelineComponents.push({id:'comment',name:'comment',data:{}});}this.setState({components:components,pipelineComponents:pipelineComponents});case 14:this.registerShare();this.communityTabLogic();window.Jockey.send("hideNavigationBar",function(){});case 17:case"end":return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"componentWillUnmount",value:function componentWillUnmount(){}// 加载微信开放标签
},{key:"renderBrowserInApp",value:// 在App内查看详情按钮
function renderBrowserInApp(){var _this3=this;if(typeof window!=='undefined'&&window.parent&&this.iframe){// 在iframe中打开，不展示在App内查看详情按钮
return null;}if(['16721084081180003','17144598318590047','17060774329760034','16969957160610015','16926141014140017','16799015532440085','16890597986400025','17248335524800036','17097071136750084'].indexOf(pageId)>=0){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div",{className:"open-app"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].formatImgUrl('https://static.shihuocdn.cn/admin/files/20220313/c1247a0d14f693b5d1a18820132752da.png'),alt:"",className:"btn",onClick:function onClick(){return _this3.handleBrowserInApp();}}));}},{key:"render",value:function render(){var _this4=this;var _this$state2=this.state,_this$state2$from=_this$state2.from,from=_this$state2$from===void 0?"":_this$state2$from,_this$state2$download=_this$state2.downloadUrl,downloadUrl=_this$state2$download===void 0?"":_this$state2$download,_this$state2$kouling=_this$state2.kouling,kouling=_this$state2$kouling===void 0?"":_this$state2$kouling,routeParams=_this$state2.routeParams,_this$state2$navigati=_this$state2.navigationBarHeight,navigationBarHeight=_this$state2$navigati===void 0?0:_this$state2$navigati,_this$state2$navigati2=_this$state2.navigationBarPaddingTop,navigationBarPaddingTop=_this$state2$navigati2===void 0?0:_this$state2$navigati2,_this$state2$navigato=_this$state2.navigatorBarTheme,navigatorBarTheme=_this$state2$navigato===void 0?"黑":_this$state2$navigato,_this$state2$backgrou=_this$state2.backgroundColor,backgroundColor=_this$state2$backgrou===void 0?"":_this$state2$backgrou,abValue=_this$state2.abValue,_this$state2$autoModa=_this$state2.autoModals,autoModals=_this$state2$autoModa===void 0?[]:_this$state2$autoModa,_this$state2$allModal=_this$state2.allModals,allModals=_this$state2$allModal===void 0?[]:_this$state2$allModal,_this$state2$dataSour=_this$state2.dataSourceStr,dataSourceStr=_this$state2$dataSour===void 0?'':_this$state2$dataSour,_this$state2$osVersio=_this$state2.osVersion,osVersion=_this$state2$osVersio===void 0?'':_this$state2$osVersio,_this$state2$createTi=_this$state2.createTime,createTime=_this$state2$createTi===void 0?'':_this$state2$createTi,ruleEntryShow=_this$state2.ruleEntryShow,ruleEntryHref=_this$state2.ruleEntryHref,lotteryState=_this$state2.lotteryState,communityVoteState=_this$state2.communityVoteState;var navList=[];var hasNavigation=false;var showCompMarginBottom=true;this.state.pipelineComponents.forEach(function(item,idx){if(item.name==='pipeline-modal'){// 将组件名置空，不进行渲染，在allModals统一处理
item.name='';return;}if(item.name=='pipeline-ab'){// if (!abValue || typeof window == 'undefined') {
//   // 将组件名置空，不进行渲染
//   item.name = ''
//   return
// }
var list=item.data||[];list.forEach(function(comp){if(comp.id.endsWith("TEST_".concat(abValue))){_this4.state.pipelineComponents[idx]=comp;item=comp;}});}if(item.name&&item.id&&!item.blockName){item.blockName=item.id;var json=null;try{json=__webpack_require__(247)("./".concat(item.name,"/package.json"));}catch(e){console.log('not found');}if(json&&json.pipeline){item.blockName+="-".concat(json.pipeline.title);if(item.data&&item.data.baseConfig&&item.data.baseConfig.title){item.blockName+="_".concat(item.data.baseConfig.title);}}}if(['pipeline-product','pipeline-goodsRecommend','pipeline-rank','pipeline-imgHotMap','pipeline-community','pipeline-communityArticle','pipeline-pkRank','pipeline-product-customize','pipeline-productCollection','pipeline-productGather','pipeline-productLayout3','pipeline-hotSellRankList'].includes(item.name)&&item.data&&item.data.baseConfig&&item.data.baseConfig.addToNav&&item.data.baseConfig.title){navList.push({id:item.id,title:item.data.baseConfig.title});}if(item.name==='pipeline-imgList'&&item.data&&item.data.baseConfig&&item.data.baseConfig.addToNav&&item.data.baseConfig.title){navList.push({id:item.id,title:item.data.baseConfig.title});}if(item.name=='pipeline-navigation'){hasNavigation=true;}});if(autoModals[0]){autoModals[0].visible=true;}if(createTime&&Number(createTime)<1683820800000){// 乐高组件默认间距优化上线，2023-05-12 00:00:00 之前创建的页面视为历史页面，历史页面不展示组件默认10px的下边距
showCompMarginBottom=false;}var allComponents=this.state.pipelineComponents.concat(autoModals);var Components=allComponents.map(function(oneComponent,index){var OneComponent=_this4.state.components[oneComponent.name];var otherProps={templatePti:'lego-specialTopic',allComponents:allComponents,baseAllComponents:_this4.state.components,legoAb:abValue,osVersion:osVersion,isLastComponent:index===allComponents.length-1,showCompMarginBottom:showCompMarginBottom,playerState:_this4.state.playerState,createTime:createTime,exp:_this4.exp};if(typeof window!=="undefined"&&(window.HW_MANAGED_JS||window.lives&&typeof window.lives.getAppExists=='function')){Object.assign(otherProps,{specialApiFrom:'huawei'});}if(oneComponent.name==='pipeline-modal'){otherProps.visible=oneComponent.visible;otherProps.onClose=function(){autoModals.splice(0,1);setTimeout(function(){_this4.setState({autoModals:autoModals});},200);};}var componentSize=oneComponent.data.componentSize;var containerStyle={};// if (componentSize && componentSize.height !== "" && FixedHeightComps.indexOf(oneComponent.name) >= 0 && !this.iframe) {
//   Object.assign(containerStyle, {
//     minHeight: oneComponent.name != 'pipeline-navigation' ? px2rem(`${componentSize.height}px`) : px2rem('40px')
//   })
//   if (oneComponent.name === 'pipeline-imgHotMap' && oneComponent.data.baseConfig.isFixedBottom) {
//     Object.assign(containerStyle, {
//       minHeight: ''
//     });
//     // typeof window !== "undefined" && (document.querySelector("#root").style.paddingBottom = '54px');
//   }
// }
return OneComponent&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div",{className:"component-wrapper",style:_objectSpread({},containerStyle),key:"OneComponent-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(OneComponent,_extends({componentIndex:index,componentLength:_this4.state.pipelineComponents.length,key:oneComponent.id,from:from,downloadUrl:downloadUrl,kouling:kouling,navList:navList,hasNavigation:hasNavigation,customAttributes:{"data-component-id":oneComponent.id,"data-component-name":oneComponent.name,"data-component-block":oneComponent.blockName},config:oneComponent.data,dataSourceStr:dataSourceStr,navigatorBarTheme:navigatorBarTheme,navigationBarHeight:navigationBarHeight,navigationBarPaddingTop:navigationBarPaddingTop,routeParams:routeParams,webpSupport:_this4.state.webpSupport,backgroundColor:backgroundColor,templateName:TEMPLATE_NAME,allModals:allModals,componentSize:componentSize,lotteryState:lotteryState,communityVoteState:communityVoteState,designIntent:oneComponent.designIntent,updateLotteryState:_this4.updateLotteryState,updateCommunityVoteState:_this4.updateCommunityVoteState},otherProps,{exp:function exp(ele){if(ele){_this4.exp.add({el:ele});}}})));});return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div",{className:"App"},typeof window!=="undefined"&&window.document.documentElement&&window.document.documentElement.getAttribute('style')&&Components,ruleEntryShow==='是'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("div",{className:"rule-entry-area",style:{top:navigationBarHeight+4},onClick:function onClick(){return _this4.ruleEntryJump(ruleEntryHref);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement("p",null,"\u6D3B\u52A8\u89C4\u5219")),!this.isShihuo&&this.hideCallAppBtn!='1'&&this.renderBrowserInApp());}}]);return App;}(__WEBPACK_IMPORTED_MODULE_33_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(335);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(64);
var isArray = __webpack_require__(159);
var SPECIES = __webpack_require__(49)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(56);
var getKeys = __webpack_require__(95);
var gOPS = __webpack_require__(134);
var pIE = __webpack_require__(118);
var toObject = __webpack_require__(75);
var IObject = __webpack_require__(155);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(55)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(111)('meta');
var isObject = __webpack_require__(64);
var has = __webpack_require__(84);
var setDesc = __webpack_require__(63).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(55)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var core = __webpack_require__(90);
var LIBRARY = __webpack_require__(112);
var wksExt = __webpack_require__(215);
var defineProperty = __webpack_require__(63).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(95);
var gOPS = __webpack_require__(134);
var pIE = __webpack_require__(118);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(74);
var gOPN = __webpack_require__(119).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(120);
var descriptor = __webpack_require__(110);
var setToStringTag = __webpack_require__(133);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(83)(IteratorPrototype, __webpack_require__(49)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(119);
var gOPS = __webpack_require__(134);
var anObject = __webpack_require__(54);
var Reflect = __webpack_require__(52).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(56) && /./g.flags != 'g') __webpack_require__(63).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(132)
});


/***/ }),
/* 346 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
var fails = __webpack_require__(55);
var defined = __webpack_require__(93);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 348 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function clipboardCopy(text){var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref$target=_ref.target,target=_ref$target===void 0?document.body:_ref$target;var element=document.createElement('textarea');var previouslyFocusedElement=document.activeElement;element.value=text;// Prevent keyboard from showing on mobile
element.setAttribute('readonly','');element.style.contain='strict';element.style.position='absolute';element.style.left='-9999px';element.style.fontSize='12pt';// Prevent zooming on iOS
var selection=document.getSelection();var originalRange=selection.rangeCount>0&&selection.getRangeAt(0);target.append(element);element.select();// Explicit selection workaround for iOS
element.selectionStart=0;element.selectionEnd=text.length;var isSuccess=false;try{isSuccess=document.execCommand('copy');}catch(error){}element.remove();if(originalRange){selection.removeAllRanges();selection.addRange(originalRange);}// Get the focus back on the previously focused element, if any
if(previouslyFocusedElement){previouslyFocusedElement.focus();}return isSuccess;}/* harmony default export */ __webpack_exports__["a"] = (clipboardCopy);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.41",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HONOR="Honor",HUAWEI="Huawei",LENOVO="Lenovo",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",NVIDIA="Nvidia",ONEPLUS="OnePlus",OPERA="Opera",OPPO="OPPO",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/(daum)apps[\/ ]([\w\.]+)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/\b(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i,/\b((i[346]|x)86)(pc)?\b/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],[[ARCHITECTURE,"arm"]],[/((ppc|powerpc)(64)?)( mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/ sun4\w[;\)]/i],[[ARCHITECTURE,"sparc"]],[/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],[MODEL,[VENDOR,HONOR],[TYPE,TABLET]],[/honor([-\w ]+)[;\)]/i],[MODEL,[VENDOR,HONOR],[TYPE,MOBILE]],[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,/\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,/ ([\w ]+) miui\/v?\d/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,OPPO],[TYPE,MOBILE]],[/\b(opd2(\d{3}a?))(?: bui|\))/i],[MODEL,[VENDOR,strMapper,{OnePlus:["304","403","203"],"*":OPPO}],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,/lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],[MODEL,[VENDOR,LENOVO],[TYPE,TABLET]],[/(nokia) (t[12][01])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,/nokia[-_ ]?(([-\w\. ]*))/i],[[MODEL,/_/g," "],[TYPE,MOBILE],[VENDOR,"Nokia"]],[/(pixel (c|tablet))\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,/archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,TABLET]],[/archos ([\w ]+)( b|\))/i,/; (ac[3-6]\d\w{2,8})( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(infinix) (x1101b?)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (hmd|imo) ([\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/(shield \w+ tv)/i],[MODEL,[VENDOR,NVIDIA],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mi(tv|box)-?\w+) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],[MODEL,[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield)( bui|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,CONSOLE]],[/(playstation \w+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i,/(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(ow(?:19|20)?we?[1-3]{1,3})/i],[MODEL,[VENDOR,OPPO],[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/(opwwe\d{3})/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,WEARABLE]],[/(moto 360)/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,WEARABLE]],[/(smartwatch 3)/i],[MODEL,[VENDOR,SONY],[TYPE,WEARABLE]],[/(g watch r)/i],[MODEL,[VENDOR,LG],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/(homepod).+mac os/i],[MODEL,[VENDOR,APPLE],[TYPE,EMBEDDED]],[/windows iot/i],[[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/droid .+?; ([\w\. -]+)( bui|\))/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/ladybird\//i],[[NAME,"LibWeb"]],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(ubuntu) ([\w\.]+) like android/i],[[NAME,/(.+)/,"$1 Touch"],VERSION],[/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(352)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 352 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return callAppTrigger; });
/* unused harmony export callAppSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pageShowTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_search_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_search_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_search_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_date_to_string_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_date_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_date_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_to_string_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var hidden;var visibilityChange;var awaitTimer=null;var isSussTrigger=false;var lock=false;function isAndroidFunc(){if(typeof window==='undefined'){return true;}return window.navigator.userAgent.indexOf("Android")>-1||window.navigator.userAgent.indexOf("Adr")>-1;}var isAndroid=isAndroidFunc();var isWx=typeof window!=='undefined'?window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=='micromessenger':false;var isQQ=typeof window!=='undefined'?/MQQBrowser/i.test(window.navigator.userAgent)&&/\sQQ/i.test(window.navigator.userAgent.split('MQQBrowser')):false;var isWeibo=typeof window!=='undefined'?window.navigator.userAgent.toLowerCase().match(/WeiBo/i)=='weibo':false;var browser=isWx?'weixin':isQQ?'qq':isWeibo?'weibo':'default';var platform=isAndroid?'android':'ios';// App分享的原始口令
var source_kouling=getQueryString('source_kouling')||'';var guide_from=getQueryString('guide_from')||'';// 不同场景使用不同的统一链接
var downloadUrlMap={share:{downloadUrlAndroid:'https://m.malink.cn/s/YBJjim',downloadUrlIOS:'https://apps.apple.com/app/apple-store/id875177200?pt=122618757&ct=m-share&mt=8'},seo:{downloadUrlAndroid:'https://m.malink.cn/s/EzAjIn',downloadUrlIOS:'https://apps.apple.com/app/apple-store/id875177200?pt=122618757&ct=seo-25&mt=8'}};// 获取url参数
function getQueryString(name){if(typeof window=='undefined')return null;var reg=new RegExp("(^|&)"+name+"=([^&]*)(&|$)","i");var r=window.location.search.substr(1).match(reg);if(r!=null)return decodeURI(r[2]);return null;}/**
 * 页面可见性API兼容不同浏览器
 */function getSupportedProperty(){if(typeof document==='undefined')return;if(typeof document.hidden!=='undefined'){// Opera 12.10 and Firefox 18 and later support
hidden='hidden';visibilityChange='visibilitychange';}else if(typeof document.msHidden!=='undefined'){hidden='msHidden';visibilityChange='msvisibilitychange';}else if(typeof document.webkitHidden!=='undefined'){hidden='webkitHidden';visibilityChange='webkitvisibilitychange';}}getSupportedProperty();/**
 * 判断页面是否隐藏（进入后台）
 */function isPageHidden(){if(typeof hidden==='undefined')return false;return document[hidden];}/** 判断唤端是否成功
 * @param success - 唤端成功回调函数
 * @param failure - 唤端失败回调函数
 * @param error - 唤端异常函数
 * @param timeout - hack 失败检测延时 - 一般会触发下载
 */function checkOpen(){var pageOptions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var success=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){};var failure=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(){};var error=arguments.length>3&&arguments[3]!==undefined?arguments[3]:function(){};var timeout=arguments.length>4&&arguments[4]!==undefined?arguments[4]:2500;var _pageOptions$scene=pageOptions.scene,scene=_pageOptions$scene===void 0?'':_pageOptions$scene;var haveChanged=false;// 页面被卸载前（此时指的是未安装App跳转下载页时）
var pageHideFunc=function pageHideFunc(e){haveChanged=true;// 唤端失败埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":arouseFail:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});if(!isAndroid&&!isWx&&!isQQ&&!isWeibo){// IOS端且浏览器环境为非微信、非QQ、非微博时，会跳转下载页，此时进行endDownload埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":endDownload:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}failure();if(!isAndroid){window.removeEventListener('pagehide',pageHideFunc,false);}document.removeEventListener(visibilityChange,pageChange,false);};// 页面被切入后台运行（此时指的是已安装App，直接唤起App时）
var pageChange=function pageChange(e){haveChanged=true;if(document.hidden||e.hidden||document.visibilityState=='hidden'){isSussTrigger=true;if(!isAndroid){Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":arouseSuss:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}else{// Andorid 在微信、QQ、微博浏览器中，页面重定向到引导去浏览器打开时，重定向操作也会触发pageChange方法，误认为是唤端成功，这里要进行纠正，上报唤端失败的埋点
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:isWx||isQQ||isWeibo?"".concat(scene,":arouseFail:"):"".concat(scene,":arouseSuss:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}success();}else{error();}if(!isAndroid){window.removeEventListener('pagehide',pageHideFunc,false);}document.removeEventListener(visibilityChange,pageChange,false);};var timer=setTimeout(function(){clearTimeout(timer);if(haveChanged){lock=false;if(!isAndroid&&isWx){// IOS的微信浏览器唤端时有二次确认弹窗，页面增加了全局loading，此时需要移除全局loading
removeGlobalLoading();}return;}if(!isAndroid){window.removeEventListener('pagehide',pageHideFunc,false);}document.removeEventListener(visibilityChange,pageChange,false);// 判断页面是否隐藏（进入后台）
var pageHidden=isPageHidden();if(!pageHidden){// 唤端失败埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":arouseFail:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});if(!isAndroid&&!isWx&&!isQQ&&!isWeibo){// IOS端且浏览器环境为非微信、非QQ、非微博时，结束下载埋点上报
// 原因是IOS在微信、QQ、微博中无法正常打开下载页面
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":endDownload:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}failure();}else{error();}lock=false;haveChanged=true;if(!isAndroid&&isWx){// IOS的微信浏览器唤端时有二次确认弹窗，页面增加了全局loading，此时需要移除全局loading
removeGlobalLoading();}},timeout);if(!isAndroid){// IOS端未安装App时，location.href跳转通用下载页时，会触发pagehide事件，通过此监听进行唤端失败时相关埋点的上报
window.addEventListener('pagehide',pageHideFunc,false);}document.addEventListener(visibilityChange,pageChange,false);}/*剪切板复制*/function copyToClipBoard(input){var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref$target=_ref.target,target=_ref$target===void 0?document.body:_ref$target;var element=document.createElement('textarea');var previouslyFocusedElement=document.activeElement;element.value=input;// Prevent keyboard from showing on mobile
element.setAttribute('readonly','');element.style.contain='strict';element.style.position='absolute';element.style.left='-9999px';element.style.fontSize='12pt';// Prevent zooming on iOS
var selection=document.getSelection();var originalRange=selection.rangeCount>0&&selection.getRangeAt(0);target.append(element);element.select();// Explicit selection workaround for iOS
element.selectionStart=0;element.selectionEnd=input.length;var isSuccess=false;try{isSuccess=document.execCommand('copy');}catch(error){}element.remove();if(originalRange){selection.removeAllRanges();selection.addRange(originalRange);}// Get the focus back on the previously focused element, if any
if(previouslyFocusedElement){previouslyFocusedElement.focus();}return isSuccess;}/**
 * 微信/QQ/微博中打开时，引导去浏览器打开
 */function guideToBrowser(){var dataDpr=document.documentElement.getAttribute('data-dpr');// 页面缩放倍数
var body=document.getElementsByTagName("body")[0];var mask=document.createElement("div");mask.style.width='100%';mask.style.height='100%';mask.style.backgroundColor='rgba(0, 0, 0, 0.85)';mask.style.position='fixed';mask.style.top=0;mask.style.left=0;mask.style.zIndex=1000000;mask.style.display='flex';mask.style.justifyContent='flex-end';var imgW=220,imgH=152,margR=12;if(dataDpr==='2'){imgW=440;imgH=304;margR=24;}else if(dataDpr==='3'){imgW=660;imgH=456;margR=36;}mask.innerHTML="<img src='https://static.shihuocdn.cn/admin/files/20211223/af3850c69567261cdea1b7dfdca61578.png' width='".concat(imgW,"' height='").concat(imgH,"' style='margin: 0 ").concat(margR,"px 0 0' />");body.appendChild(mask);mask.onclick=function(){body.removeChild(mask);};}/**
 * 自动展示引导去浏览器打开浮层
 */function showGuideToBrowser(){if(typeof window!=='undefined'){var url=new URL(window.location.href);var guide=url.searchParams.get('guide');if(guide&&guide==='1'&&(isWx||isQQ||isWeibo)){guideToBrowser();}}}showGuideToBrowser();/**
 * 安卓新用户跳转下载前的增加全局loading
 */function addGlobalLoading(){var body=document.getElementsByTagName("body")[0];var style=document.createElement('style');style.innerHTML="\n      @keyframes rotate {\n          from {\n              transform: rotate(0deg);  \n          }\n          to {\n              transform: rotate(360deg);  \n          }\n      }  \n      .call-app-loading {\n          animation: rotate 1s linear infinite;\n      }\n  ";document.head.appendChild(style);// 将样式添加到头部  
var img=document.createElement("img");img.className='call-app-loading';img.src='https://static.shihuocdn.cn/admin/files/20241210/5fd8d7d32725a589d5cab9c4ff99960d.png';img.style.width='38px';img.style.height='38px';img.style.position='fixed';img.style.top='50%';img.style.left='50%';img.style.zIndex=1000000;img.style.marginLeft='-19px';img.style.marginTop='-19px';body.appendChild(img);}/**
 * 移除全局loading
 */function removeGlobalLoading(){var globalLoading=document.querySelector('.call-app-loading');if(globalLoading){var body=document.getElementsByTagName("body")[0];body.removeChild(globalLoading);}}// 等待跳转下载埋点上报
function awaitEndDownloadTrack(scene,pageOptions){return new Promise(function(resolve){// 结束下载埋点上报
if(!isSussTrigger){try{Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":endDownload:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}catch(error){}if(awaitTimer){clearTimeout(awaitTimer);awaitTimer=null;}awaitTimer=setTimeout(function(){resolve(true);},500);}else{resolve(true);}});}/**
 * 当前页面重定向，展示引导浮层，引导去浏览器打开
 */function getrReloadUrl(){// 获取当前页面的 URL  
if(typeof window!=='undefined'){var url=new URL(window.location.href);// 获取现有的查询参数  
var params=url.searchParams;// 添加或更新 guide 参数  
params.set('guide','1');params.set('guide_from',browser);// 更新 URL 中的查询字符串  
url.search=params.toString();// 给页面重定向，保留 hash 部分  
var reloadUrl=url.toString();return reloadUrl;}else{return'https://apps.apple.com/app/apple-store/id875177200?pt=122618757&ct=m-share&mt=8';}}/**
 * 场景还原方法
 * @param {*必填} targetUrl 唤端成功后，要打开的页面路由地址
 * @param {*必填} kouling 场景还原所用到的原始口令，一般通过带在页面query上或由服务端接口下发
 * @param {*选填} scene 场景，用于区分来源页面
 * @param {*选填} biz 埋点扩展字段
 * @param {*选填} timeout hack 失败检测延时
 * @param {*选填} from 来源，默认来源为分享，主要用于针对不同的来源使用对应的统一链接和营销链接
 * @param {*选填} callbackSuccess 唤端成功的回调
 * @param {*选填} callbackFailure 唤端失败的回调
 * @param {*选填} callbackError 唤端异常回调
 */function callAppTrigger(targetUrl,kouling,scene){var biz=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var timeout=arguments.length>4&&arguments[4]!==undefined?arguments[4]:2500;var from=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'share';var callbackSuccess=arguments.length>6&&arguments[6]!==undefined?arguments[6]:function(){};var callbackFailure=arguments.length>7&&arguments[7]!==undefined?arguments[7]:function(){};var callbackError=arguments.length>8&&arguments[8]!==undefined?arguments[8]:function(){};if(lock){return;}lock=true;isSussTrigger=false;// 定义变量
var timestamp=new Date().getTime();var m_device_id=window.localStorage.getItem('m_device_id')||'';var trace_id=m_device_id?"".concat(m_device_id,"-").concat(timestamp):'';var downloadUrlAndroid='',downloadUrlIOS='';if(kouling){kouling="1http://shihuo.cn".concat(kouling,"##").concat(trace_id,"##").concat(scene);}downloadUrlAndroid=downloadUrlMap[from].downloadUrlAndroid;if(isWx||isQQ||isWeibo){// IOS的微信、QQ、微博中因为无法直接打开统一链接，这里要对当前页面进行一次重定向，reload当前页面，同时让该页面展示引导至系统浏览器的浮层
downloadUrlIOS=getrReloadUrl();}else{downloadUrlIOS=downloadUrlMap[from].downloadUrlIOS;}var pageOptions={ua:window.navigator.userAgent,trace_id:trace_id,m_device_id:m_device_id,kouling:kouling,scene:scene,platform:platform,browser:browser,is_wx_tag:0,mode:'click'};// 初次分享时的原始口令存在时，一次上报，方便溯源
if(source_kouling){pageOptions['source_kouling']=source_kouling;}// 从微信或QQ引导至系统浏览器时会携带该参数，value为wx或qq
if(guide_from&&guide_from!==browser){pageOptions['guide_from']=guide_from;}if(!isAndroid&&isWx){// IOS微信或QQ浏览器里，深度链接唤端会有二次确认拦截，在此把timeout延长至4.5s
timeout=4500;}if(biz){Object.assign(pageOptions,_objectSpread({},biz));}// 开始下载埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":beginDownload:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});// 检测唤端是否成功
checkOpen(pageOptions,callbackSuccess,callbackFailure,callbackError,timeout);// 处理场景还原
kouling&&copyToClipBoard(kouling);// 口令存在时，复制口令到剪切板
var schemaBizData={ua:window.navigator.userAgent,trace_id:trace_id,kouling:kouling,scene:scene};if(isAndroid){if(isWx||isQQ||isWeibo){// Android中当页面是在微信 / QQ / 微博中打开时，引导去浏览器打开（用页面重定向的方式，因为需要在地址上携带guide和guide_from参数）
var reloadUrl=getrReloadUrl();window.location.href=reloadUrl;}else{addGlobalLoading();var schemaRoute="shihuo://www.shihuo.cn?route=index&source=".concat(encodeURIComponent(targetUrl),"&kl=").concat(encodeURIComponent(kouling),"#").concat(encodeURIComponent(JSON.stringify(schemaBizData)));window.location.href=schemaRoute;// 安卓通过URL Schema 唤起App， 口令存在时，只唤起首页；口令不存在时，唤起传入的路由地址
setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var awaitTrack;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return awaitEndDownloadTrack(scene,pageOptions);case 2:awaitTrack=_context.sent;window.location.href=downloadUrlAndroid;removeGlobalLoading();case 5:case"end":return _context.stop();}}},_callee);})),2500);}}else{if(isQQ||isWeibo){// IOS中 当页面是在微博中打开时，引导去浏览器打开
guideToBrowser();}else{if(isWx){// IOS微信浏览器里，深度链接唤端会有二次确认拦截，imeout延长至了4.5s，等待时间较久，增加全局loading
addGlobalLoading();}var deeplinkDomain='www.shihuo.cn';switch(window.location.host){case'm-share.shihuo.cn':deeplinkDomain='m.shihuo.cn';break;case'www.shihuo.cn':deeplinkDomain='m.shihuo.cn';break;case'm.shihuo.cn':deeplinkDomain='www.shihuo.cn';break;default:break;}if(kouling){var transitHref="http://".concat(deeplinkDomain,"/api/transit?source=").concat(encodeURIComponent(targetUrl),"&target=").concat(encodeURIComponent(downloadUrlIOS),"&kl=").concat(encodeURIComponent(kouling),"#").concat(encodeURIComponent(JSON.stringify(schemaBizData)));window.location.href=transitHref;}else{var _transitHref="http://".concat(deeplinkDomain,"/api/transit?source=").concat(encodeURIComponent(targetUrl),"&target=").concat(encodeURIComponent(downloadUrlIOS),"#").concat(encodeURIComponent(JSON.stringify(schemaBizData)));window.location.href=_transitHref;}}}}/**
 * 场景还原方法
 * @param {*必填} targetUrl 唤端成功后，要打开的页面路由地址
 * @param {*必填} kouling 场景还原所用到的原始口令，一般通过带在页面query上或由服务端接口下发
 * @param {*选填} scene 场景，用于区分来源页面
 * @param {*选填} timeout hack 失败检测延时
 * @param {*选填} callbackSuccess 唤端成功的回调
 * @param {*选填} callbackFailure 唤端失败的回调
 * @param {*选填} callbackError 唤端异常回调
 */function callAppSchema(targetUrl,kouling,scene){var biz=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var timeout=arguments.length>4&&arguments[4]!==undefined?arguments[4]:5000;var callbackSuccess=arguments.length>5&&arguments[5]!==undefined?arguments[5]:function(){};var callbackFailure=arguments.length>6&&arguments[6]!==undefined?arguments[6]:function(){};var callbackError=arguments.length>7&&arguments[7]!==undefined?arguments[7]:function(){};if(!isAndroid||isWx||isQQ||isWeibo){// IOS因为在未安装识货App时，通过schema唤端safari浏览器会提示打开的是一个无效地址，体验较差，因此不做自动唤端处理
// 微信、QQ、微博里由于平台限制，均无法直接通过schema唤端，因此不做自动唤端处理
return;}// 定义变量
var timestamp=new Date().getTime();var m_device_id=window.localStorage.getItem('m_device_id')||'';var trace_id=m_device_id?"".concat(m_device_id,"-").concat(timestamp):'';if(kouling){kouling="1http://shihuo.cn".concat(kouling,"##").concat(trace_id,"##").concat(scene);}var pageOptions={ua:window.navigator.userAgent,trace_id:trace_id,m_device_id:m_device_id,kouling:kouling,scene:scene,platform:platform,browser:browser,is_wx_tag:0,mode:'auto'};// 初次分享时的原始口令存在时，一次上报，方便溯源
if(source_kouling){pageOptions['source_kouling']=source_kouling;}// 从微信或QQ引导至系统浏览器时会携带该参数，value为wx或qq
if(guide_from&&guide_from!==browser){pageOptions['guide_from']=guide_from;}if(biz){Object.assign(pageOptions,_objectSpread({},biz));}// 非微信、非QQ、非微博浏览器里，Android自动触发一次schema路由唤端，提高唤端成功率
// 开始下载埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(scene,":beginDownload:"),name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});// 检测唤端是否成功
checkOpen(pageOptions,callbackSuccess,callbackFailure,callbackError,timeout);window.location.href=targetUrl;}/**
 * 页面展示埋点上报
 * @param {*必填} ptiId 埋点ID
 * @param {*选填} biz 埋点扩展字段
 */function pageShowTrack(){var ptiId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var biz=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var timestamp=new Date().getTime();var m_device_id=typeof window!=="undefined"&&window.localStorage.getItem('m_device_id')||'';var trace_id=m_device_id?"".concat(m_device_id,"-").concat(timestamp):'';var scene=ptiId?ptiId.split(':')[0]:'';var pageOptions={ua:typeof window!=="undefined"&&window.navigator.userAgent,trace_id:trace_id,m_device_id:m_device_id,scene:scene,platform:platform,browser:browser};// 初次分享时的原始口令存在时，一次上报，方便溯源
if(source_kouling){pageOptions['source_kouling']=source_kouling;}// 从微信或QQ引导至系统浏览器时会携带该参数，value为wx或qq
if(guide_from&&guide_from!==browser){pageOptions['guide_from']=guide_from;}Object.assign(pageOptions,_objectSpread({},biz));Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:ptiId,name:'',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});}/**
 * 以下为微信开放标签相关代码封装
 */var WxOpenLaunchApp=/*#__PURE__*/function(){function WxOpenLaunchApp(_ref3){var _ref3$options=_ref3.options,options=_ref3$options===void 0?{}:_ref3$options,_ref3$containers=_ref3.containers,containers=_ref3$containers===void 0?[]:_ref3$containers,clickEvent=_ref3.clickEvent;_classCallCheck(this,WxOpenLaunchApp);this.options=options;this.containers=containers;this.shareInfo=options.shareInfo;this.clickEvent=clickEvent;// 埋点上报基础字段
this.pageOptions={m_device_id:typeof window!=='undefined'&&window.localStorage.getItem('m_device_id')||'',ua:typeof window!=='undefined'&&window.navigator.userAgent,scene:options.scene,trace_id:'',kouling:'',platform:platform,browser:browser,is_wx_tag:1,mode:'click'};// 点击时间（用于拼接在trace_id的后面）
this.clickTime=new Date().getTime();}// wx-open-launch-app 初始化配置
_createClass(WxOpenLaunchApp,[{key:"initConfig",value:function(){var _initConfig=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this=this;var wxKeyInfo,_yield$this$getWxKeyI,status,data,_wxKeyInfo,appId,timestamp,nonceStr,signature;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(typeof window==='undefined')){_context2.next=2;break;}return _context2.abrupt("return");case 2:if(window.wx){_context2.next=4;break;}throw new Error('未获取到微信JS-SDK');case 4:_context2.prev=4;_context2.next=7;return this.getWxKeyInfo();case 7:_yield$this$getWxKeyI=_context2.sent;status=_yield$this$getWxKeyI.status;data=_yield$this$getWxKeyI.data;if(!(status!==0)){_context2.next=12;break;}return _context2.abrupt("return");case 12:wxKeyInfo=data;_context2.next=18;break;case 15:_context2.prev=15;_context2.t0=_context2["catch"](4);return _context2.abrupt("return");case 18:_wxKeyInfo=wxKeyInfo,appId=_wxKeyInfo.appId,timestamp=_wxKeyInfo.timestamp,nonceStr=_wxKeyInfo.nonceStr,signature=_wxKeyInfo.signature;window.wx.config({debug:false,appId:appId,timestamp:timestamp,nonceStr:nonceStr,signature:signature,jsApiList:['checkJsApi','updateAppMessageShareData','updateTimelineShareData'],openTagList:['wx-open-launch-app']});window.wx.ready(function(){window.wx.checkJsApi({jsApiList:['wx-open-launch-app'],// 需要检测的JS接口列表，所有JS接口列表见附录2,
success:function success(res){},fail:function fail(err){}});if(_this.shareInfo&&typeof window!=='undefined'){// 自定义二次分享给好友的卡片信息
window.wx.updateAppMessageShareData(_this.shareInfo);// 自定义二次分享到朋友圈的卡片信息
window.wx.updateTimelineShareData(_this.shareInfo);}_this.createWxOpenLaunchAppTag();});case 21:case"end":return _context2.stop();}}},_callee2,this,[[4,15]]);}));function initConfig(){return _initConfig.apply(this,arguments);}return initConfig;}()// 批量创建 wx-open-launch-app 标签
},{key:"createWxOpenLaunchAppTag",value:function createWxOpenLaunchAppTag(){if(!this.containers||this.containers.length<0){throw new Error('必须通过containers给wx-open-launch-app指定容器元素');}for(var index=0;index<this.containers.length;index++){var item=this.containers[index];if(item&&item.element){// 获取 wx-open-launch-app 的父级容器元素
var container=document.querySelector("".concat(item.element));if(!container){// 若指定的容器元素不存在，跳出，继续遍历下一个
continue;}// 创建一个 wx-open-launch-app 标签，并添加属性
var wxtag=document.createElement('wx-open-launch-app');// 设置 wx-open-launch-app 标签的唯一ID
var elementId="wx-open-launch-app-".concat(index+1);// 设置要还原的路由地址
var m_device_id=typeof window!=='undefined'&&window.localStorage.getItem('m_device_id')||'';var trace_id=m_device_id?"".concat(m_device_id,"-").concat(this.clickTime):'';var _this$options=this.options,kouling=_this$options.kouling,scene=_this$options.scene,targetUrl=_this$options.targetUrl;if(kouling){kouling="1http://shihuo.cn".concat(kouling,"##").concat(trace_id,"##").concat(scene);}var schemaBizData={ua:typeof window!=='undefined'&&window.navigator.userAgent,trace_id:trace_id,kouling:kouling,scene:scene};var schemaRoute="shihuo://www.shihuo.cn?route=index&source=".concat(encodeURIComponent(targetUrl),"&kl=").concat(encodeURIComponent(kouling),"#").concat(encodeURIComponent(JSON.stringify(schemaBizData)));// 设置 wx-open-launch-app 标签的其他属性
wxtag.setAttribute('id',elementId);wxtag.setAttribute('appid','wx84d36ea0d36f05ec');wxtag.setAttribute('extinfo',schemaRoute);if(item.style){// 设置 wx-open-launch-app 标签的样式
Object.assign(wxtag.style,_objectSpread({},item.style));}// 获取开放标签父节点的实际渲染宽高，作为开放标签的实际宽高
var _container$getBoundin=container.getBoundingClientRect(),width=_container$getBoundin.width,height=_container$getBoundin.height;// 创建内部模板
var template=document.createElement('script');template.type='text/wxtag-template';template.innerHTML="\n          <style>.btn { width: ".concat(width,"px; height: ").concat(height,"px; background-color: transparent; border: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }</style>\n          <button class=\"btn\"></button>\n        ");// 内部模版添加到 wx-open-launch-app 标签元素中
wxtag.appendChild(template);// 将 wx-open-launch-app 元素添加到容器元素中
container.appendChild(wxtag);// 给 wx-open-launch-app 标签添加事件监听
this.wxTagAddEventListener(elementId,item);}}}// 批量给 wx-open-launch-app 标签添加事件监听
},{key:"wxTagAddEventListener",value:function wxTagAddEventListener(elementId,element){var _this2=this;var btn=document.getElementById(elementId);btn.addEventListener('ready',function(e){});btn.addEventListener('launch',function(e){var bizData=_this2.getTrackBizData();Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(bizData.scene,":arouseSuss:"),name:'',biz:JSON.stringify(bizData),pageOptions:bizData}});});btn.addEventListener('error',function(e){var bizData=_this2.getTrackBizData();// 唤端失败埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(bizData.scene,":arouseFail:"),name:'',biz:JSON.stringify(bizData),pageOptions:bizData}});// 唤端失败，引导去浏览器打开（用页面重定向的方式，因为需要在地址上携带guide和guide_from参数）
var reloadUrl=getrReloadUrl();window.location.href=reloadUrl;});btn.addEventListener('click',function(e){// 自定义点击事件触发
e.stopPropagation();copyToClipBoard(_this2.options.kouling);// 执行复制
element.clickEvent&&element.clickEvent();_this2.clickEvent&&_this2.clickEvent();var bizData=_this2.getTrackBizData();// 开始下载埋点上报
Object(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"".concat(bizData.scene,":beginDownload:"),name:'',biz:JSON.stringify(bizData),pageOptions:bizData}});});}// 获取埋点上报字段信息
},{key:"getTrackBizData",value:function getTrackBizData(){var _this$options2=this.options,kouling=_this$options2.kouling,scene=_this$options2.scene,pageOptions=_this$options2.pageOptions;var m_device_id=typeof window!=='undefined'&&window.localStorage.getItem('m_device_id')||'';var trace_id=m_device_id?"".concat(m_device_id,"-").concat(this.clickTime):'';if(kouling){kouling="1http://shihuo.cn".concat(kouling,"##").concat(trace_id,"##").concat(scene);copyToClipBoard(kouling);// 执行复制 
}var bizData=JSON.parse(JSON.stringify(this.pageOptions));bizData['trace_id']=trace_id;bizData['kouling']=kouling;if(pageOptions){Object.assign(bizData,_objectSpread({},pageOptions));}return bizData;}// 获取微信开放标签注入配置所需要的配置信息
},{key:"getWxKeyInfo",value:function(){var _getWxKeyInfo=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var response;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return window.fetch("//sh-gateway.shihuo.cn/v4/services/sh-advertiseapi/wx/key_info?url=".concat(encodeURIComponent(window.location.href)),{method:'GET',headers:{'Content-Type':'application/json'}});case 3:response=_context3.sent;if(response.ok){_context3.next=6;break;}throw new Error("HTTP error! status: ".concat(response.status));case 6:_context3.next=8;return response.json();case 8:return _context3.abrupt("return",_context3.sent);case 11:_context3.prev=11;_context3.t0=_context3["catch"](0);throw _context3.t0;case 14:case"end":return _context3.stop();}}},_callee3,null,[[0,11]]);}));function getWxKeyInfo(){return _getWxKeyInfo.apply(this,arguments);}return getWxKeyInfo;}()}]);return WxOpenLaunchApp;}();if(typeof window!=='undefined'){window.WxOpenLaunchApp=WxOpenLaunchApp;}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineNavigationBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */var isTabletDevice=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].judgeIsTabletDevice();var PipelineNavigationBar=/*#__PURE__*/function(_React$Component){_inherits(PipelineNavigationBar,_React$Component);var _super=_createSuper(PipelineNavigationBar);function PipelineNavigationBar(props){var _this;_classCallCheck(this,PipelineNavigationBar);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"searchClick",function(keywords){var url="shihuo://www.shihuo.cn?route=homeSearch&placeholder=".concat(encodeURIComponent(keywords||'搜索品牌 商品名'));var pageOptions={component_id:_this.props.customAttributes['data-component-id'],lego_page_id:_this.pageId,legoAb:_this.props.legoAb};__WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib___default.a.navigateWithTrack({url:url,pageOptions:pageOptions,pti:{id:'lego-specialTopic:searchInput',name:'导航栏搜索',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});});_defineProperty(_assertThisInitialized(_this),"backClick",function(){if(typeof window!=='undefined'){if(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isShihuo()){window.Jockey.send('windowClose');}else{window.history.back();}}});_defineProperty(_assertThisInitialized(_this),"shareClick",function(){// 分享埋点
var pageOptions={component_id:_this.props.customAttributes['data-component-id'],lego_page_id:_this.pageId,legoAb:_this.props.legoAb};__WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:'lego-specialTopic:share',name:'导航栏分享',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});// 分享交互
var _this$props$config$ba=_this.props.config.baseConfig,shareUrl=_this$props$config$ba.shareUrl,shareTitle=_this$props$config$ba.shareTitle,shareContent=_this$props$config$ba.shareContent,shareImage=_this$props$config$ba.shareImage;var isStage=window.location.href.indexOf('/stage/page')>=0;var pageRoute='';if(!isStage){pageRoute="shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=".concat(encodeURIComponent('https://zt-public.shihuo.cn/page/'+_this.pageId+'/index.html'));}else{pageRoute="shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=".concat(encodeURIComponent('https://zt-public.shihuo.cn/stage/page/'+_this.pageId+'/index.html'));}Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/share/get?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{page_id:_this.pageId,title:shareTitle,desc:shareContent,url:pageRoute,img:shareImage}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){window.Jockey.send("share",{url:"".concat(shareUrl).concat(shareUrl.indexOf('?')<0?'?':'&',"kl=").concat(encodeURIComponent(data.kl)),title:shareTitle,content:shareContent,img:shareImage});}});});_this.state={searchWords:[]};var _utils$getNavigationB=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getNavigationBarInfo(),navigationBarPaddingTop=_utils$getNavigationB.navigationBarPaddingTop,navigationBarHeight=_utils$getNavigationB.navigationBarHeight;_this.pageId=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId();_this.ref=null;_this.backRef=null;_this.shareRef=null;_this.backDarkRef=null;_this.shareDarkRef=null;_this.backLightRef=null;_this.shareLightRef=null;_this.searchSwiper=null;_this.searchGuideRef=null;_this.navigationRef=null;_this.navigationBarHeight=navigationBarHeight;_this.navigationBarPaddingTop=navigationBarPaddingTop;return _this;}_createClass(PipelineNavigationBar,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;window&&window.addEventListener('scroll',function(){var y=document.documentElement.scrollTop||document.body.scrollTop;y=y<0?0:y;if(_this2.ref){var opacity=y>20?1:(y/20).toFixed(2);_this2.ref.style.opacity=opacity;if(_this2.searchGuideRef){_this2.searchGuideRef.style.opacity=1-opacity;}var _baseConfig=_this2.props.config.baseConfig;if(_baseConfig.navigatorBarTheme=='黑'){_this2.backDarkRef.style.opacity=opacity;_this2.shareDarkRef.style.opacity=opacity;_this2.backLightRef.style.opacity=1-opacity;_this2.shareLightRef.style.opacity=1-opacity;}}if(_this2.backRef){var _opacity=y>20?0:(1-(y/20).toFixed(2))*0.2;_this2.backRef.style.backgroundColor="rgba(0, 0, 0, ".concat(_opacity,")");_this2.shareRef.style.backgroundColor="rgba(0, 0, 0, ".concat(_opacity,")");}});var baseConfig=this.props.config.baseConfig;var searchWords=baseConfig.searchWords?baseConfig.searchWords.trim():'';if(searchWords){this.setState({searchWords:searchWords.split(',').filter(function(item){return item!=='';})},function(){if(_this2.state.searchWords.length>1){_this2.searchSwiper=new __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js___default.a('.search-swiper',{direction:'vertical',autoplay:true,speed:500,loop:true});}});}if(this.navigationRef){window.navigationBarHeight=this.navigationRef.clientHeight-1;}}},{key:"render",value:function render(){var _this3=this;var backgroundColor=this.props.backgroundColor;var baseConfig=this.props.config.baseConfig;var _this$state$searchWor=this.state.searchWords,searchWords=_this$state$searchWor===void 0?[]:_this$state$searchWor;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"navigation-bar-wrapper",style:{transform:"translate3d(0, -1px, 0)"},ref:function ref(_ref9){return _this3.navigationRef=_ref9;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({ref:function ref(_ref){return _this3.ref=_ref;},className:"navigation-bar"},this.props['customAttributes'],{style:{paddingTop:this.navigationBarPaddingTop,height:this.navigationBarHeight+1,backgroundColor:backgroundColor}}),baseConfig.searchBoxDisplay==='否'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"main-title ".concat(isTabletDevice?'isTablet':''),style:{color:baseConfig.navigatorBarTheme=='白'?'#fff':'#333'}},window.document.title)),baseConfig.searchBoxDisplay==='是'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-bar-wrap ".concat(isTabletDevice?'isTablet':'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-input-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20230719/b0f07e5bb669d06d8af1960fb2de96fc.png",alt:"",className:"search-icon"}),searchWords.length<=1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"search-input ".concat(isTabletDevice?'isTablet':''),onClick:function onClick(){return _this3.searchClick(searchWords[0]);}},searchWords.length<=0?'搜索品牌 商品名':searchWords[0]),searchWords.length>1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-swiper swiper-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-lottery-all swiper-wrapper"},searchWords.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-lottery-item swiper-slide",key:index,onClick:function onClick(){var url="shihuo://www.shihuo.cn?route=homeSearch&placeholder=".concat(encodeURIComponent(item));__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,url,url,{},-1,_this3.props,false);}},item);})))),baseConfig.searchGuideText&&baseConfig.searchGuideText.indexOf('<!--')<0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{ref:function ref(_ref2){return _this3.searchGuideRef=_ref2;},className:"search-guide ".concat(isTabletDevice?'isTablet':''),style:{color:baseConfig.searchGuideColor}},baseConfig.searchGuideText)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"back-icon-wrap ".concat(isTabletDevice?'isTablet':''),onClick:this.backClick},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"back-icon-bg",ref:function ref(_ref5){return _this3.backRef=_ref5;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1657000722526",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"1696",width:"24",height:"24",className:"back-icon-light",ref:function ref(_ref3){return _this3.backLightRef=_ref3;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M609.877333 97.962667A42.666667 42.666667 0 0 1 673.706667 154.453333l-3.541334 4.010667-353.792 352.426667 353.877334 355.242666a42.666667 42.666667 0 0 1-56.405334 63.786667l-4.010666-3.541333-353.92-355.285334a85.333333 85.333333 0 0 1-4.736-115.285333l4.992-5.418667 353.749333-352.384z","p-id":"1697",fill:"#ffffff"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1657000722526",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"1696",width:"24",height:"24",className:"back-icon-dark",ref:function ref(_ref4){return _this3.backDarkRef=_ref4;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M609.877333 97.962667A42.666667 42.666667 0 0 1 673.706667 154.453333l-3.541334 4.010667-353.792 352.426667 353.877334 355.242666a42.666667 42.666667 0 0 1-56.405334 63.786667l-4.010666-3.541333-353.92-355.285334a85.333333 85.333333 0 0 1-4.736-115.285333l4.992-5.418667 353.749333-352.384z","p-id":"1697",fill:"#000000"})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"share-icon-wrap ".concat(isTabletDevice?'isTablet':''),onClick:this.shareClick},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"share-icon-bg",ref:function ref(_ref8){return _this3.shareRef=_ref8;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1657000501157",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"1529",width:"24",height:"24",className:"share-icon-light",ref:function ref(_ref6){return _this3.shareLightRef=_ref6;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z","p-id":"1530",fill:"#ffffff"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1657000501157",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"1529",width:"24",height:"24",className:"share-icon-dark",ref:function ref(_ref7){return _this3.shareDarkRef=_ref7;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z","p-id":"1530",fill:"#000000"})))));}}]);return PipelineNavigationBar;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);PipelineNavigationBar.propTypes={config:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineNavigationBar);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(357);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineNavigationBarPopover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */var PipelineNavigationBarPopover=/*#__PURE__*/function(_React$Component){_inherits(PipelineNavigationBarPopover,_React$Component);var _super=_createSuper(PipelineNavigationBarPopover);function PipelineNavigationBarPopover(props){var _this;_classCallCheck(this,PipelineNavigationBarPopover);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"searchClick",function(keywords){var url="shihuo://www.shihuo.cn?route=homeSearch&placeholder=".concat(encodeURIComponent(keywords||'搜索品牌 商品名'));var pageOptions={component_id:_this.props.customAttributes['data-component-id'],lego_page_id:_this.pageId,legoAb:_this.props.legoAb};__WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib___default.a.navigateWithTrack({url:url,pageOptions:pageOptions,pti:{id:'lego-specialTopic:searchInput',name:'导航栏搜索',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});});_defineProperty(_assertThisInitialized(_this),"backClick",function(){if(typeof window!=='undefined'){if(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isShihuo()){window.Jockey.send('windowClose');}else{window.history.back();}}});_defineProperty(_assertThisInitialized(_this),"shareClick",function(){// 分享埋点
var pageOptions={component_id:_this.props.customAttributes['data-component-id'],lego_page_id:_this.pageId,legoAb:_this.props.legoAb};__WEBPACK_IMPORTED_MODULE_18_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({pti:{id:'lego-specialTopic:share',name:'导航栏分享',biz:JSON.stringify(pageOptions),pageOptions:pageOptions}});// 分享交互
var _this$props$config$ba=_this.props.config.baseConfig,shareUrl=_this$props$config$ba.shareUrl,shareTitle=_this$props$config$ba.shareTitle,shareContent=_this$props$config$ba.shareContent,shareImage=_this$props$config$ba.shareImage;var isStage=window.location.href.indexOf('/stage/page')>=0;var pageRoute='';if(!isStage){pageRoute="shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=".concat(encodeURIComponent('https://zt-public.shihuo.cn/page/'+_this.pageId+'/index.html'));}else{pageRoute="shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=".concat(encodeURIComponent('https://zt-public.shihuo.cn/stage/page/'+_this.pageId+'/index.html'));}Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/share/get?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{page_id:_this.pageId,title:shareTitle,desc:shareContent,url:pageRoute,img:shareImage}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){window.Jockey.send("share",{url:"".concat(shareUrl).concat(shareUrl.indexOf('?')<0?'?':'&',"kl=").concat(encodeURIComponent(data.kl)),title:shareTitle,content:shareContent,img:shareImage});}});});_this.state={searchWords:[]};_this.pageId=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId();_this.ref=null;_this.backRef=null;_this.shareRef=null;_this.backDarkRef=null;_this.shareDarkRef=null;_this.backLightRef=null;_this.shareLightRef=null;_this.searchSwiper=null;_this.searchGuideRef=null;_this.navigationRef=null;return _this;}_createClass(PipelineNavigationBarPopover,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;window&&window.addEventListener('scroll',function(){var y=document.documentElement.scrollTop||document.body.scrollTop;y=y<0?0:y;if(_this2.ref){var opacity=y>20?1:(y/20).toFixed(2);_this2.ref.style.opacity=opacity;if(_this2.searchGuideRef){_this2.searchGuideRef.style.opacity=1-opacity;}var _baseConfig=_this2.props.config.baseConfig;if(_baseConfig.navigatorBarTheme=='黑'){_this2.backDarkRef.style.opacity=opacity;_this2.shareDarkRef.style.opacity=opacity;_this2.backLightRef.style.opacity=1-opacity;_this2.shareLightRef.style.opacity=1-opacity;}}if(_this2.backRef){var _opacity=y>20?0:(1-(y/20).toFixed(2))*0.2;_this2.backRef.style.backgroundColor="rgba(0, 0, 0, ".concat(_opacity,")");_this2.shareRef.style.backgroundColor="rgba(0, 0, 0, ".concat(_opacity,")");}});var baseConfig=this.props.config.baseConfig;var searchWords=baseConfig.searchWords?baseConfig.searchWords.trim():'';if(searchWords){this.setState({searchWords:searchWords.split(',').filter(function(item){return item!=='';})},function(){if(_this2.state.searchWords.length>1){_this2.searchSwiper=new __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js___default.a('.search-swiper',{direction:'vertical',autoplay:true,speed:500,loop:true});}});}if(typeof window!=='undefined'){if(this.navigationRef){window.navigationBarHeight=this.navigationRef.clientHeight-1;}}}},{key:"render",value:function render(){var _this3=this;var _this$props=this.props,navigationBarHeight=_this$props.navigationBarHeight,navigationBarPaddingTop=_this$props.navigationBarPaddingTop,backgroundColor=_this$props.backgroundColor;var baseConfig=this.props.config.baseConfig;var _this$state$searchWor=this.state.searchWords,searchWords=_this$state$searchWor===void 0?[]:_this$state$searchWor;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"navigation-bar-popover",style:{transform:"translate3d(0, -1px, 0)"},ref:function ref(_ref9){return _this3.navigationRef=_ref9;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({ref:function ref(_ref){return _this3.ref=_ref;},className:"navigation-bar"},this.props['customAttributes'],{style:{paddingTop:navigationBarPaddingTop,height:navigationBarHeight,backgroundColor:backgroundColor}}),baseConfig.searchBoxDisplay==='否'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"main-title",style:{color:baseConfig.navigatorBarTheme=='白'?'#fff':'#333'}},window.document.title)),baseConfig.searchBoxDisplay==='是'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-bar-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-input-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20230719/b0f07e5bb669d06d8af1960fb2de96fc.png",alt:"",className:"search-icon"}),searchWords.length<=1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"search-input",onClick:function onClick(){return _this3.searchClick(searchWords[0]);}},searchWords.length<=0?'搜索品牌 商品名':searchWords[0]),searchWords.length>1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-swiper swiper-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-lottery-all swiper-wrapper"},searchWords.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"search-lottery-item swiper-slide",key:index,onClick:function onClick(){var url="shihuo://www.shihuo.cn?route=homeSearch&placeholder=".concat(encodeURIComponent(item));__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,url,url,{},-1,_this3.props,false);}},item);})))),baseConfig.searchGuideText&&baseConfig.searchGuideText.indexOf('<!--')<0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{ref:function ref(_ref2){return _this3.searchGuideRef=_ref2;},className:"search-guide",style:{color:baseConfig.searchGuideColor}},baseConfig.searchGuideText)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"share-icon-wrap",onClick:this.shareClick},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"share-icon-bg",ref:function ref(_ref5){return _this3.shareRef=_ref5;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1657000501157",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"1529",width:"24",height:"24",className:"share-icon-light",ref:function ref(_ref3){return _this3.shareLightRef=_ref3;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z","p-id":"1530",fill:"#ffffff"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1657000501157",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"1529",width:"24",height:"24",className:"share-icon-dark",ref:function ref(_ref4){return _this3.shareDarkRef=_ref4;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z","p-id":"1530",fill:"#000000"})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"back-icon-wrap",onClick:this.backClick},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"back-icon-bg",ref:function ref(_ref8){return _this3.backRef=_ref8;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1718692157427","class":"back-icon-light",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"2761",width:"24",height:"24",ref:function ref(_ref6){return _this3.backLightRef=_ref6;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M853.504 170.752a42.666667 42.666667 0 0 1 3.498667 56.32l-3.541334 4.010667-281.6 281.386666 281.6 280.917334a42.666667 42.666667 0 0 1-56.277333 63.957333l-4.010667-3.541333-281.685333-281.002667-281.173333 280.96a42.666667 42.666667 0 0 1-63.829334-56.32l3.541334-4.053333 281.045333-280.874667-281.002667-280.32a42.666667 42.666667 0 0 1 56.234667-64l4.010667 3.584 281.130666 280.448L793.130667 170.666667a42.666667 42.666667 0 0 1 60.373333 0z",fill:"#ffffff","p-id":"2762"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{t:"1718692157427","class":"back-icon-dark",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"2761",width:"24",height:"24",ref:function ref(_ref7){return _this3.backDarkRef=_ref7;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{d:"M853.504 170.752a42.666667 42.666667 0 0 1 3.498667 56.32l-3.541334 4.010667-281.6 281.386666 281.6 280.917334a42.666667 42.666667 0 0 1-56.277333 63.957333l-4.010667-3.541333-281.685333-281.002667-281.173333 280.96a42.666667 42.666667 0 0 1-63.829334-56.32l3.541334-4.053333 281.045333-280.874667-281.002667-280.32a42.666667 42.666667 0 0 1 56.234667-64l4.010667 3.584 281.130666 280.448L793.130667 170.666667a42.666667 42.666667 0 0 1 60.373333 0z",fill:"#000000","p-id":"2762"})))));}}]);return PipelineNavigationBarPopover;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);PipelineNavigationBarPopover.propTypes={config:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineNavigationBarPopover);

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_from_code_point_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_from_code_point_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_from_code_point_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: cuixinming
 * @Date: 2024-03-06 13:30:46
 * @Last Modified by: cuixinming
 * @Last Modified time: Do not edit
 * @Description: 
 */var PipelineComment=/*#__PURE__*/function(_React$Component){_inherits(PipelineComment,_React$Component);var _super=_createSuper(PipelineComment);function PipelineComment(props){var _this;_classCallCheck(this,PipelineComment);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getLoginStatus",function(){var u=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie("u");var ua=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie("ua");return new Promise(function(resolve){Promise.all([u,ua]).then(function(values){if(values[0]&&values[1]){resolve(true);}else{resolve(false);}});});});_defineProperty(_assertThisInitialized(_this),"handleLogin",function(){window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});});_defineProperty(_assertThisInitialized(_this),"inputKeyboardFocus",function(e){e.preventDefault();_this.maskRef.style.display='block';_this.keyboardInputRef.style.zIndex=2;_this.keyboardInputRef.style.opacity=1;setTimeout(function(){_this.keyboardInputRef.scrollIntoView({behavior:"smooth",block:"end",inline:"nearest"});_this.inputRef.scrollIntoView({behavior:"smooth",block:"end",inline:"nearest"});},300);});_defineProperty(_assertThisInitialized(_this),"inputKeyboardBlur",function(){_this.maskRef.style.display='none';_this.keyboardInputRef.style.zIndex=-100;_this.keyboardInputRef.style.opacity=0;_this.setState({message:''});});_defineProperty(_assertThisInitialized(_this),"handleAwakeKeyboard",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var loginStatus;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.getLoginStatus();case 2:loginStatus=_context.sent;if(loginStatus){_context.next=6;break;}_this.handleLogin();return _context.abrupt("return");case 6:if(_this.NativeCommentSupport){window.Jockey.send('showCommentView',{placeHolder:'快来讨论吧～',content:'',emoji:_this.state.commentData.emojis},function(payload){if(typeof payload==='string'){payload=JSON.parse(payload);}_this.handleAddComment(payload.content);});}else{_this.inputRef.focus();}case 7:case"end":return _context.stop();}}},_callee);})));_defineProperty(_assertThisInitialized(_this),"handleEmojiClick",function(e,emoji){e.preventDefault();_this.setState({message:_this.state.message+emoji});});_defineProperty(_assertThisInitialized(_this),"onTextAreaChange",function(e){_this.setState({message:e.target.value});});_defineProperty(_assertThisInitialized(_this),"handleKeyboardPress",function(e){if(e.keyCode===13){e.preventDefault();if(_this.state.message){_this.handleAddComment(_this.state.message);}else{window.Jockey.send('toast',{text:'评论内容不能为空'});}}});_defineProperty(_assertThisInitialized(_this),"handleAddComment",function(message){if(message){Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v3/apps/app_swoole_comment/addComment',method:'post',withCredentials:true,data:{product_id:_this.pageId,content:message,type:'22'}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data,msg=_res$data.msg;if(status===0){var commentData=_this.state.commentData;var all_comment_href=data.all_comment_href,comment_id=data.comment_id,content=data.content,created_at=data.created_at,id=data.id,ip_name=data.ip_name,is_praise=data.is_praise,num=data.num,personal_href=data.personal_href,praise=data.praise,product_id=data.product_id,reply_count=data.reply_count,reply_remain_num=data.reply_remain_num,self_flag=data.self_flag,type_id=data.type_id,user_avatar=data.user_avatar,user_name=data.user_name,userid=data.userid,widget=data.widget;var addComment={comment_id:comment_id,content:content,created_at:created_at,high_light:0,id:id,ip_name:ip_name,is_praise:is_praise,num:num,personal_href:personal_href,praise:praise,praise_text:String(praise),product_id:product_id,reply:[],reply_count:reply_count,reply_remain_num:reply_remain_num,self_flag:self_flag,type_id:type_id,user_avatar:user_avatar,user_id:userid,user_name:user_name,widget:widget};commentData.comment.unshift(addComment);commentData.all_comment_href=all_comment_href;_this.setState({commentData:commentData},function(){_this.inputRef&&_this.inputRef.blur();});}else{window.Jockey.send('toast',{text:msg});}});}});_defineProperty(_assertThisInitialized(_this),"handleCommentPraiseClick",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(comment){var loginStatus,isPraise;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.getLoginStatus();case 2:loginStatus=_context2.sent;if(loginStatus){_context2.next=6;break;}_this.handleLogin();return _context2.abrupt("return");case 6:isPraise=_this.handlePraiseStyle('comment',comment.comment_id,null);isPraise==='false'?_this.handleCommentPraise(comment):_this.handleCommentPraiseCancel(comment);case 8:case"end":return _context2.stop();}}},_callee2);}));return function(_x){return _ref2.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleCommentPraise",function(comment){Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v3/apps/app_swoole_general/commentPraise',method:"get",withCredentials:true,params:{id:_this.pageId,comment_id:String(comment.comment_id),status:1}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data,msg=_res$data2.msg;if(status===0){}else{window.Jockey.send('toast',{text:msg});}});});_defineProperty(_assertThisInitialized(_this),"handleCommentPraiseCancel",function(comment){Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v3/apps/app_swoole_general/deleteCommentPraise',method:"get",withCredentials:true,params:{id:_this.pageId,comment_id:String(comment.comment_id)}}).then(function(res){var _res$data3=res.data,status=_res$data3.status,data=_res$data3.data,msg=_res$data3.msg;if(status===0){}else{window.Jockey.send('toast',{text:msg});}});});_defineProperty(_assertThisInitialized(_this),"handleReplyPraise",/*#__PURE__*/function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(comment,reply){var loginStatus,isPraise;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.getLoginStatus();case 2:loginStatus=_context3.sent;if(loginStatus){_context3.next=6;break;}_this.handleLogin();return _context3.abrupt("return");case 6:isPraise=_this.handlePraiseStyle('reply',comment.comment_id,reply.id);Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-behaviorapi/app_swoole_general/reply-praise',method:"get",withCredentials:true,params:{product_id:_this.pageId,comment_id:String(comment.comment_id),cluster_id:String(reply.id),status:isPraise==='true'?2:1}}).then(function(res){var _res$data4=res.data,status=_res$data4.status,data=_res$data4.data,msg=_res$data4.msg;if(status===0){}else{window.Jockey.send('toast',{text:msg});}});case 8:case"end":return _context3.stop();}}},_callee3);}));return function(_x2,_x3){return _ref3.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handlePraiseStyle",function(){var commentType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'comment';var comment_id=arguments.length>1?arguments[1]:undefined;var reply_id=arguments.length>2?arguments[2]:undefined;var praiseTarget=null;if(commentType==='comment'){praiseTarget=document.querySelector("[comment-id=\"".concat(comment_id,"\"]"));}else{praiseTarget=document.querySelector("[reply-id=\"".concat(reply_id,"\"]"));}var praiseNum=Number(praiseTarget.getAttribute('praise-num'))||0;if(praiseNum<0){praiseNum=0;}var isPraise=praiseTarget.getAttribute('is-praise');if(isPraise==='false'){praiseTarget.querySelector('.has-not-praise').style.opacity=0;praiseTarget.querySelector('.has-praise').style.opacity=1;praiseTarget.querySelector('.praise-num').innerHTML=_this.formatPraiseNum(praiseNum+1);praiseTarget.querySelector('.praise-num').style.opacity=1;praiseTarget.setAttribute('praise-num',praiseNum+1);praiseTarget.setAttribute('is-praise','true');}else{praiseTarget.querySelector('.has-not-praise').style.opacity=1;praiseTarget.querySelector('.has-praise').style.opacity=0;praiseTarget.querySelector('.praise-num').innerHTML=praiseNum-1<=0?0:_this.formatPraiseNum(praiseNum-1);praiseTarget.querySelector('.praise-num').style.opacity=praiseNum-1<=0?0:1;praiseTarget.setAttribute('praise-num',praiseNum-1<=0?0:praiseNum-1);praiseTarget.setAttribute('is-praise','false');}return isPraise;});_defineProperty(_assertThisInitialized(_this),"handleJumpCommentList",function(){var comment=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var reply=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'comment';var all_comment_href=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'';var jumpUrl='';if(type==='comment'){jumpUrl="".concat(comment.personal_href,"&status=0");}else if(type==='reply'){jumpUrl="".concat(reply.personal_href,"&status=1");}else if(type==='allReply'){jumpUrl="".concat(comment.personal_href,"&status=2&comment_id=").concat(comment.comment_id);}else if(type==='allComment'){jumpUrl=all_comment_href;}jumpUrl&&window.Jockey.send('action',{url:jumpUrl});});_defineProperty(_assertThisInitialized(_this),"formatPraiseNum",function(num){if(num>9999){num=parseFloat((num/10000).toFixed(1))+'w';}return num;});_defineProperty(_assertThisInitialized(_this),"transformEmoji",function(unicode){return String.fromCodePoint(parseInt(unicode.replace("U+",""),16));});_defineProperty(_assertThisInitialized(_this),"throttle",function(func,delay){var inThrottle;return function(event){if(!inThrottle){inThrottle=true;for(var _len=arguments.length,args=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}func.apply(this,args);setTimeout(function(){return inThrottle=false;},delay);}event.stopPropagation();};});_this.state={commentData:{all_comment_href:'',comment:[],dialog_title:'',emojis:[],has_next:false,num:0,num_str:'',time:'',tips:'',user:{avatar:'',uid:null}},message:''};_this.pageId=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getPageId();_this.high_light_comment_id=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('high_light_comment_id')||'';_this.high_light_reply_id=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('high_light_reply_id')||'';_this.extra_comment_id=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('extra_comment_id')||'';_this.extra_reply_id=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('extra_reply_id')||'';_this.comment_id=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('comment_id')||'';_this.drop_top=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('drop_top')||'';_this.keyboardInputRef=null;_this.updateTimeout=null;_this.commentRef=null;_this.inputRef=null;_this.maskRef=null;// 原生键盘输入事件是否支持
_this.NativeCommentSupport=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].SHDiffVersion(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getVersion(),'7.81.0');_this.defaultAvatar='https://static.shihuocdn.cn/admin/imgs/20230731/78f9e02595c8ff96f1b01cbd9bcf216d_216x216.png';_this.handleCommentPraiseClickThrottled=_this.throttle(_this.handleCommentPraiseClick,500);_this.handleReplyPraiseClickThrottled=_this.throttle(_this.handleReplyPraise,500);return _this;}_createClass(PipelineComment,[{key:"componentDidMount",value:function componentDidMount(){this.getCommentList();this.focusWebview();if(!this.NativeCommentSupport){this.inputRef.addEventListener('focus',this.inputKeyboardFocus);this.inputRef.addEventListener('blur',this.inputKeyboardBlur);}// window.visualViewport.addEventListener("resize", (e) => {
//   // 返回可视视口的顶部边缘与布局视口的顶部边缘之间的偏移量（以 CSS 像素为单位）。
//   const keyboardHeight = window.visualViewport.offsetTop;
// });
}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!this.NativeCommentSupport){this.inputRef.removeEventListener('focus',this.inputKeyboardFocus);this.inputRef.removeEventListener('blur',this.inputKeyboardBlur);}}// 获取登录状态
},{key:"focusWebview",value:function focusWebview(){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].isAndroid()){window.Jockey.on("focus:webview",function(){// 刷新秒杀状态
_this2.getCommentList();});}else{document.addEventListener("visibilitychange",function(){if(document.hidden){return;}else{// 刷新秒杀状态
_this2.getCommentList();return;}},false);}}},{key:"commentReplyHighLight",value:// 评论或恢复高亮和置顶
function commentReplyHighLight(){var activeComment=document.querySelector("[comment-id=\"".concat(this.high_light_comment_id,"\"]"));var activeReply=document.querySelector("[reply-id=\"".concat(this.high_light_reply_id,"\"]"));var highlightElement=null,highlightType='';if(activeComment&&!activeReply){highlightElement=activeComment;highlightType='comment';}else if(activeComment&&activeReply){highlightElement=activeReply;highlightType='reply';}if(highlightElement){var offsetTop=this.commentRef.offsetTop;window.scrollTo({top:offsetTop,behavior:'smooth'});setTimeout(function(){if(highlightType==='comment'){highlightElement.setAttribute('class','comment-wrap active');}else{highlightElement.setAttribute('class','reply-item active');}},800);}}},{key:"getCommentList",value:function getCommentList(){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-behaviorapi/coupon/getComment/enter',method:"get",withCredentials:true,params:{high_light_comment_id:Number(this.high_light_comment_id),high_light_reply_id:Number(this.high_light_reply_id),extra_comment_id:Number(this.extra_comment_id),extra_reply_id:Number(this.extra_reply_id),drop_top:Number(this.drop_top),comment_id:this.comment_id,product_id:this.pageId,sort:'1',type:'22',page:'1',page_size:'2'}}).then(function(res){var _res$data5=res.data,status=_res$data5.status,data=_res$data5.data;if(status===0){_this3.setState({commentData:data,message:''},function(){_this3.commentReplyHighLight();});}})["catch"](function(){});}},{key:"renderEmptyState",value:// 空态
function renderEmptyState(){var _this4=this;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"empty-state",onClick:function onClick(){return _this4.handleAwakeKeyboard();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240306/67a6ac78d31fb8f3aa4409ab30b13f92.png",alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",null,"\u6682\u65F6\u8FD8\u6CA1\u6709\u8BC4\u8BBA\u54E6",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",null,"\u70B9\u51FB\u8BC4\u8BBA")));}// 发送评论区域
},{key:"renderCommentInput",value:function renderCommentInput(){var _this5=this;var _this$state$commentDa=this.state.commentData.user,user=_this$state$commentDa===void 0?{}:_this$state$commentDa;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"coment-entry"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:user.avatar||this.defaultAvatar,alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"input-wrap",onClick:function onClick(){return _this5.handleAwakeKeyboard();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240307/b779cd0072f18da1ff12b64e65c61077.png",alt:"",className:"icon"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"placeholder"},"\u5FEB\u6765\u8BA8\u8BBA\u5427\uFF5E")));}// 评论列表
},{key:"renderCommentList",value:function renderCommentList(){var _this6=this;var _this$state$commentDa2=this.state.commentData,_this$state$commentDa3=_this$state$commentDa2.comment,comment=_this$state$commentDa3===void 0?[]:_this$state$commentDa3,all_comment_href=_this$state$commentDa2.all_comment_href;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",{className:"comment-list"},comment.slice(0,2).map(function(item,index){return _this6.renderComment(item,index);})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"all-comments",onClick:function onClick(){return _this6.handleJumpCommentList(null,null,'allComment',all_comment_href);}},"\u5168\u90E8\u8BC4\u8BBA",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240307/e9767a4de94e9244924f113137697b84.png",alt:""})));}// 回复列表
},{key:"renderReplyList",value:function renderReplyList(){var _this7=this;var comment=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _comment$reply=comment.reply,reply=_comment$reply===void 0?[]:_comment$reply,reply_count=comment.reply_count,reply_remain_num=comment.reply_remain_num;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",{className:"reply-list"},reply.map(function(item,index){return _this7.renderCommentReply(item,index,comment);})),reply_remain_num>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"reply-num",onClick:function onClick(){return _this7.handleJumpCommentList(comment,null,'allReply');}},"\u5171",reply_remain_num,"\u6761\u56DE\u590D"));}// 评论
},{key:"renderComment",value:function renderComment(item,index){var _this8=this;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("li",{key:"comment-".concat(index),className:"comment-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"comment-wrap","comment-id":item.id,"praise-num":item.praise,"is-praise":item.is_praise?'true':'false',onClick:function onClick(){return _this8.handleJumpCommentList(item,null,'comment');}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:item.user_avatar||this.defaultAvatar,alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"username"},item.user_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"content"},item.content),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"date"},item.created_at),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"ip"},item.ip_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"reply-btn"},"\u56DE\u590D"))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"praise",onClick:function onClick(event){return _this8.handleCommentPraiseClickThrottled(event,item);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240417/a318772ad067b6bcbef835a68688dcc4.png",alt:"",className:"praise-img has-not-praise",style:{opacity:item.is_praise?0:1}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240417/d745722ff745be8c2b59e5b902fb2b62.png",alt:"",className:"praise-img has-praise",style:{opacity:item.is_praise?1:0}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"praise-num",style:{opacity:item.praise>0?1:0}},item.praise_text))),item.reply&&item.reply.length>0&&this.renderReplyList(item));}// 评论回复
},{key:"renderCommentReply",value:function renderCommentReply(item,index,comment){var _this9=this;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("li",{key:"reply-".concat(index),className:"reply-item","reply-id":item.id,"praise-num":item.praise,"is-praise":item.is_praise?'true':'false',onClick:function onClick(){return _this9.handleJumpCommentList(comment,item,'reply');}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"reply-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:item.user_avatar||this.defaultAvatar,alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"username"},item.user_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"content"},item.id?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"reply-obj"},"\u56DE\u590D",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"to-username"},item.to_username),"\uFF1A"):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"content-text"},item.content)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"date"},item.created_at),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"ip"},item.ip_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"reply-btn"},"\u56DE\u590D"))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"praise",onClick:function onClick(event){return _this9.handleReplyPraiseClickThrottled(event,comment,item);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240417/a318772ad067b6bcbef835a68688dcc4.png",alt:"",className:"praise-img has-not-praise",style:{opacity:item.is_praise?0:1}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"http://static.shihuocdn.cn/admin/files/20240417/d745722ff745be8c2b59e5b902fb2b62.png",alt:"",className:"praise-img has-praise",style:{opacity:item.is_praise?1:0}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"praise-num",style:{opacity:item.praise>0?1:0}},item.praise_text))));}// 自定义文本键盘输入
},{key:"renderKeyboardInput",value:function renderKeyboardInput(){var _this10=this;var placeholder=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'快来讨论吧～';var _this$state$commentDa4=this.state.commentData.emojis,emojis=_this$state$commentDa4===void 0?[]:_this$state$commentDa4;emojis=emojis.map(function(item){return _this10.transformEmoji(item);});return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"comment-mask",ref:function ref(_ref4){return _this10.maskRef=_ref4;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"keyboard-input",ref:function ref(_ref6){return _this10.keyboardInputRef=_ref6;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",{className:"emojis"},emojis.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("li",{key:"emoji-".concat(index),onMouseDown:function onMouseDown(e){return _this10.handleEmojiClick(e,item);}},item);})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"textarea-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("textarea",{ref:function ref(_ref5){return _this10.inputRef=_ref5;},type:"text",enterkeyhint:"send",placeholder:placeholder,value:this.state.message,onChange:function onChange(e){return _this10.onTextAreaChange(e);},onKeyDown:function onKeyDown(e){return _this10.handleKeyboardPress(e);}}))));}},{key:"render",value:function render(){var _this11=this;var _this$state$commentDa5=this.state.commentData,_this$state$commentDa6=_this$state$commentDa5.comment,comment=_this$state$commentDa6===void 0?[]:_this$state$commentDa6,num=_this$state$commentDa5.num;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"comment-block",ref:function ref(_ref7){return _this11.commentRef=_ref7;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"title"},"\u8BC4\u8BBA",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",null,num>0?num:'')),this.renderCommentInput(),comment.length===0&&this.renderEmptyState(),comment.length>0&&this.renderCommentList(),!this.NativeCommentSupport&&this.renderKeyboardInput());}}]);return PipelineComment;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineComment);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(30);
var toAbsoluteIndex = __webpack_require__(128);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pipeline_brand__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pipeline_cashBack__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pipeline_free_subsidy__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pipeline_goodsHorizontal__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pipeline_goodsRecommend__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pipeline_hotspots__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pipeline_image__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pipeline_imgList__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pipeline_navigation__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pipeline_product__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pipeline_productCustomize__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pipeline_rank__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pipeline_recommend__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pipeline_recommendTopGoods__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pipeline_subsidy__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pipeline_video__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pipeline_vote__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pipeline_imgAnimate__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pipeline_imgHotMap__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pipeline_productSwiper__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pipeline_community__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pipeline_cashBackAct__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pipeline_cashBackActNew__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pipeline_imgs__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pipeline_navBar__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pipeline_productList__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pipeline_rankList__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pipeline_subsidyList__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pipeline_communityArticle__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pipeline_communityArticleScroll__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pipeline_pkRank__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pipeline_imgListScroll__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pipeline_suctionBottomBtns__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pipeline_square__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pipeline_spikeProduct__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pipeline_games__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pipeline_imgSwiper__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pipeline_searchCard__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pipeline_searchSwiper__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pipeline_searchSlogan__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pipeline_searchProduct__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pipeline_springFestivalFloor__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pipeline_sence_floor__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pipeline_sence_swiper__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pipeline_sence_tab__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pipeline_recommend_feeds__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pipeline_modal__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pipeline_lottery__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pipeline_communityShaiwu__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pipeline_tab__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pipeline_rankCollection__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pipeline_floor__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pipeline_date_range__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pipeline_menuBar__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pipeline_checkAppProduct__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pipeline_cutPriceGoodsList__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pipeline_depreciateTop__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pipeline_double11Floor__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pipeline_button__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pipeline_priceTrend__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pipeline_checkAppDetail__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__pipeline_textarea__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__pipeline_imageText__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__pipeline_interactMessage__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__pipeline_intelligent__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__pipeline_goodsInfoPreview__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__pipeline_communityCustom__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__pipeline_headlines__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__pipeline_productCollection__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__pipeline_productGather__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__pipeline_schoolLottery__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__pipeline_communityVote__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__pipeline_productLayout3__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__pipeline_sideBar__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__pipeline_timedLottery__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__pipeline_hotSellRankList__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__pipeline_floorBarTitle__ = __webpack_require__(946);
/* harmony default export */ __webpack_exports__["a"] = ({'pipeline-brand':__WEBPACK_IMPORTED_MODULE_0__pipeline_brand__["a" /* default */],'pipeline-cashBack':__WEBPACK_IMPORTED_MODULE_1__pipeline_cashBack__["a" /* default */],'pipeline-free-subsidy':__WEBPACK_IMPORTED_MODULE_2__pipeline_free_subsidy__["a" /* default */],'pipeline-goodsHorizontal':__WEBPACK_IMPORTED_MODULE_3__pipeline_goodsHorizontal__["a" /* default */],'pipeline-goodsRecommend':__WEBPACK_IMPORTED_MODULE_4__pipeline_goodsRecommend__["a" /* default */],'pipeline-hotspots':__WEBPACK_IMPORTED_MODULE_5__pipeline_hotspots__["a" /* default */],'pipeline-image':__WEBPACK_IMPORTED_MODULE_6__pipeline_image__["a" /* default */],'pipeline-imgList':__WEBPACK_IMPORTED_MODULE_7__pipeline_imgList__["a" /* default */],'pipeline-navigation':__WEBPACK_IMPORTED_MODULE_8__pipeline_navigation__["a" /* default */],'pipeline-product':__WEBPACK_IMPORTED_MODULE_9__pipeline_product__["a" /* default */],'pipeline-productCustomize':__WEBPACK_IMPORTED_MODULE_10__pipeline_productCustomize__["a" /* default */],'pipeline-rank':__WEBPACK_IMPORTED_MODULE_11__pipeline_rank__["a" /* default */],'pipeline-recommend':__WEBPACK_IMPORTED_MODULE_12__pipeline_recommend__["a" /* default */],'pipeline-recommendTopGoods':__WEBPACK_IMPORTED_MODULE_13__pipeline_recommendTopGoods__["a" /* default */],'pipeline-subsidy':__WEBPACK_IMPORTED_MODULE_14__pipeline_subsidy__["a" /* default */],'pipeline-video':__WEBPACK_IMPORTED_MODULE_15__pipeline_video__["a" /* default */],'pipeline-vote':__WEBPACK_IMPORTED_MODULE_16__pipeline_vote__["a" /* default */],'pipeline-imgAnimate':__WEBPACK_IMPORTED_MODULE_17__pipeline_imgAnimate__["a" /* default */],'pipeline-imgHotMap':__WEBPACK_IMPORTED_MODULE_18__pipeline_imgHotMap__["a" /* default */],'pipeline-productSwiper':__WEBPACK_IMPORTED_MODULE_19__pipeline_productSwiper__["a" /* default */],'pipeline-community':__WEBPACK_IMPORTED_MODULE_20__pipeline_community__["a" /* default */],'pipeline-cashBackAct':__WEBPACK_IMPORTED_MODULE_21__pipeline_cashBackAct__["a" /* default */],'pipeline-cashBackActNew':__WEBPACK_IMPORTED_MODULE_22__pipeline_cashBackActNew__["a" /* default */],'pipeline-imgs':__WEBPACK_IMPORTED_MODULE_23__pipeline_imgs__["a" /* default */],'pipeline-navBar':__WEBPACK_IMPORTED_MODULE_24__pipeline_navBar__["a" /* default */],'pipeline-productList':__WEBPACK_IMPORTED_MODULE_25__pipeline_productList__["a" /* default */],'pipeline-rankList':__WEBPACK_IMPORTED_MODULE_26__pipeline_rankList__["a" /* default */],'pipeline-subsidyList':__WEBPACK_IMPORTED_MODULE_27__pipeline_subsidyList__["a" /* default */],'pipeline-communityArticle':__WEBPACK_IMPORTED_MODULE_28__pipeline_communityArticle__["a" /* default */],'pipeline-communityArticleScroll':__WEBPACK_IMPORTED_MODULE_29__pipeline_communityArticleScroll__["a" /* default */],'pipeline-pkRank':__WEBPACK_IMPORTED_MODULE_30__pipeline_pkRank__["a" /* default */],'pipeline-imgListScroll':__WEBPACK_IMPORTED_MODULE_31__pipeline_imgListScroll__["a" /* default */],'pipeline-suctionBottomBtns':__WEBPACK_IMPORTED_MODULE_32__pipeline_suctionBottomBtns__["a" /* default */],'pipeline-square':__WEBPACK_IMPORTED_MODULE_33__pipeline_square__["a" /* default */],'pipeline-spikeProduct':__WEBPACK_IMPORTED_MODULE_34__pipeline_spikeProduct__["a" /* default */],'pipeline-games':__WEBPACK_IMPORTED_MODULE_35__pipeline_games__["a" /* default */],'pipeline-imgSwiper':__WEBPACK_IMPORTED_MODULE_36__pipeline_imgSwiper__["a" /* default */],'pipeline-searchCard':__WEBPACK_IMPORTED_MODULE_37__pipeline_searchCard__["a" /* default */],'pipeline-searchSwiper':__WEBPACK_IMPORTED_MODULE_38__pipeline_searchSwiper__["a" /* default */],'pipeline-searchSlogan':__WEBPACK_IMPORTED_MODULE_39__pipeline_searchSlogan__["a" /* default */],'pipeline-searchProduct':__WEBPACK_IMPORTED_MODULE_40__pipeline_searchProduct__["a" /* default */],'pipeline-springFestivalFloor':__WEBPACK_IMPORTED_MODULE_41__pipeline_springFestivalFloor__["a" /* default */],'pipeline-sence-floor':__WEBPACK_IMPORTED_MODULE_42__pipeline_sence_floor__["a" /* default */],'pipeline-sence-swiper':__WEBPACK_IMPORTED_MODULE_43__pipeline_sence_swiper__["a" /* default */],'pipeline-sence-tab':__WEBPACK_IMPORTED_MODULE_44__pipeline_sence_tab__["a" /* default */],'pipeline-recommend-feeds':__WEBPACK_IMPORTED_MODULE_45__pipeline_recommend_feeds__["a" /* default */],'pipeline-modal':__WEBPACK_IMPORTED_MODULE_46__pipeline_modal__["a" /* default */],'pipeline-lottery':__WEBPACK_IMPORTED_MODULE_47__pipeline_lottery__["a" /* default */],'pipeline-communityShaiwu':__WEBPACK_IMPORTED_MODULE_48__pipeline_communityShaiwu__["a" /* default */],'pipeline-tab':__WEBPACK_IMPORTED_MODULE_49__pipeline_tab__["a" /* default */],'pipeline-rankCollection':__WEBPACK_IMPORTED_MODULE_50__pipeline_rankCollection__["a" /* default */],'pipeline-floor':__WEBPACK_IMPORTED_MODULE_51__pipeline_floor__["a" /* default */],'pipeline-date-range':__WEBPACK_IMPORTED_MODULE_52__pipeline_date_range__["a" /* default */],'pipeline-menuBar':__WEBPACK_IMPORTED_MODULE_53__pipeline_menuBar__["a" /* default */],'pipeline-checkAppProduct':__WEBPACK_IMPORTED_MODULE_54__pipeline_checkAppProduct__["a" /* default */],'pipeline-cutPriceGoodsList':__WEBPACK_IMPORTED_MODULE_55__pipeline_cutPriceGoodsList__["a" /* default */],'pipeline-depreciateTop':__WEBPACK_IMPORTED_MODULE_56__pipeline_depreciateTop__["a" /* default */],'pipeline-double11Floor':__WEBPACK_IMPORTED_MODULE_57__pipeline_double11Floor__["a" /* default */],'pipeline-button':__WEBPACK_IMPORTED_MODULE_58__pipeline_button__["a" /* default */],'pipeline-priceTrend':__WEBPACK_IMPORTED_MODULE_59__pipeline_priceTrend__["a" /* default */],'pipeline-checkAppDetail':__WEBPACK_IMPORTED_MODULE_60__pipeline_checkAppDetail__["a" /* default */],'pipeline-textarea':__WEBPACK_IMPORTED_MODULE_61__pipeline_textarea__["a" /* default */],'pipeline-imageText':__WEBPACK_IMPORTED_MODULE_62__pipeline_imageText__["a" /* default */],'pipeline-interactMessage':__WEBPACK_IMPORTED_MODULE_63__pipeline_interactMessage__["a" /* default */],'pipeline-intelligent':__WEBPACK_IMPORTED_MODULE_64__pipeline_intelligent__["a" /* default */],'pipeline-goodsInfoPreview':__WEBPACK_IMPORTED_MODULE_65__pipeline_goodsInfoPreview__["a" /* default */],'pipeline-communityCustom':__WEBPACK_IMPORTED_MODULE_66__pipeline_communityCustom__["a" /* default */],'pipeline-headlines':__WEBPACK_IMPORTED_MODULE_67__pipeline_headlines__["a" /* default */],'pipeline-productCollection':__WEBPACK_IMPORTED_MODULE_68__pipeline_productCollection__["a" /* default */],'pipeline-productGather':__WEBPACK_IMPORTED_MODULE_69__pipeline_productGather__["a" /* default */],'pipeline-schoolLottery':__WEBPACK_IMPORTED_MODULE_70__pipeline_schoolLottery__["a" /* default */],'pipeline-communityVote':__WEBPACK_IMPORTED_MODULE_71__pipeline_communityVote__["a" /* default */],'pipeline-productLayout3':__WEBPACK_IMPORTED_MODULE_72__pipeline_productLayout3__["a" /* default */],'pipeline-sideBar':__WEBPACK_IMPORTED_MODULE_73__pipeline_sideBar__["a" /* default */],'pipeline-timedLottery':__WEBPACK_IMPORTED_MODULE_74__pipeline_timedLottery__["a" /* default */],'pipeline-hotSellRankList':__WEBPACK_IMPORTED_MODULE_75__pipeline_hotSellRankList__["a" /* default */],'pipeline-floorBarTitle':__WEBPACK_IMPORTED_MODULE_76__pipeline_floorBarTitle__["a" /* default */]});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_less__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineBrand=/*#__PURE__*/function(_Component){_inherits(PipelineBrand,_Component);var _super=_createSuper(PipelineBrand);function PipelineBrand(props){var _this;_classCallCheck(this,PipelineBrand);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"productBannerGo",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var options={link:item.link,title:4,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_this.state={};return _this;}// 图片跳转
_createClass(PipelineBrand,[{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,comBgColor=_this$props$config.comBgColor,comBodyColor=_this$props$config.comBodyColor;var componentDivideLine=this.props.componentDivideLine;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",_extends({className:"pipeline-brand",style:{backgroundColor:comBgColor}},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"title-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].formatImgUrl(this.props.config.titleImage,this.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"brand-body",style:{backgroundColor:comBodyColor}},this.props.config.itemRows.map(function(rowItems,rowIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{key:"brand-row-".concat(rowIndex),className:"brand-content"},rowItems.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"img-item",key:"brand-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].formatImgUrl(item.img,_this2.props.webpSupport),onClick:_this2.productBannerGo.bind(_this2,item,index)}));}));})),this.props.notLastItem&&componentDivideLine&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("img",{className:"component-divide-line",src:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].formatImgUrl(componentDivideLine,this.props.webpSupport)}));}}]);return PipelineBrand;}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelineBrand);

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCashBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _createForOfIteratorHelper(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return{s:F,n:function n(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};},e:function e(_e){throw _e;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return{s:function s(){it=it.call(o);},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e2){didErr=true;err=_e2;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineCashBack=/*#__PURE__*/function(_React$Component){_inherits(PipelineCashBack,_React$Component);var _super=_createSuper(PipelineCashBack);function PipelineCashBack(props){var _this;_classCallCheck(this,PipelineCashBack);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick({props:_this.props});return;}__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].uploadTrack(_this.props);var u=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getCookie("u");var ua=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getCookie("ua");Promise.all([u,ua]).then(function(values){if(values[0]&&values[1]){_this.cashBackSend();}else{window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});});_defineProperty(_assertThisInitialized(_this),"cashBackSend",function(){var imgsList=_this.props.config.imgsList;var activity_code;var _iterator=_createForOfIteratorHelper(imgsList),_step;try{for(_iterator.s();!(_step=_iterator.n()).done;){var item=_step.value;var code=item.cashBackConfig.activity_code;if(code){activity_code=code;break;}}}catch(err){_iterator.e(err);}finally{_iterator.f();}__WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-laxincommonapi/cash_back/send?access_token=2322TizdV3pjw8CBsy',method:'post',withCredentials:true,data:{activity_code:activity_code}}).then(function(res){var _res$data=res.data,status=_res$data.status,msg=_res$data.msg;if(status===0||status==200){_this.setState({getCouponsResult:status});}else{_this.setState({show_toast:true,toast_text:msg});}});});_defineProperty(_assertThisInitialized(_this),"renderCashBackPopup",function(){var _this$state=_this.state,getCouponsResult=_this$state.getCouponsResult,getCouponsSuccess=_this$state.getCouponsSuccess,couponRepeatGet=_this$state.couponRepeatGet;if(!getCouponsResult&&getCouponsResult!==0){return null;}else if(getCouponsResult===0){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"popup"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"mask",onClick:_this.resultImageClick.bind(_assertThisInitialized(_this),false)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"result-image",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(getCouponsSuccess.src,_this.props.webpSupport),style:{width:getCouponsSuccess.imageWidth},onClick:_this.resultImageClick.bind(_assertThisInitialized(_this),true)}));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"popup"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"mask",onClick:_this.resultImageClick.bind(_assertThisInitialized(_this),false)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"result-image",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(couponRepeatGet.src,_this.props.webpSupport),style:{width:couponRepeatGet.imageWidth},onClick:_this.resultImageClick.bind(_assertThisInitialized(_this),true)}));}});_defineProperty(_assertThisInitialized(_this),"resultImageClick",function(isAnchor){_this.setState({getCouponsResult:null},function(){isAnchor&&setTimeout(function(){var navOffsetTop=window.document.querySelector('.navigation-container-static').offsetTop-_this.props.navigationBarHeight;window.scrollTo(0,navOffsetTop);},300);});});_defineProperty(_assertThisInitialized(_this),"renderToast",function(){var _this$state2=_this.state,show_toast=_this$state2.show_toast,toast_text=_this$state2.toast_text;if(show_toast){_this.interval&&clearTimeout(_this.interval);_this.interval=setTimeout(function(){_this.setState({show_toast:false,toast_text:''});},3000);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("p",{className:"toast"},toast_text);}else{return null;}});_this.state={getCouponsSuccess:{},couponRepeatGet:{},getCouponsResult:null,show_toast:false,toast_text:''};_this.interval=null;return _this;}_createClass(PipelineCashBack,[{key:"componentDidMount",value:function componentDidMount(){var imgsList=this.props.config.imgsList;imgsList[0]&&this.setState({getCouponsSuccess:imgsList[0].cashBackConfig.getCouponsSuccess,couponRepeatGet:imgsList[0].cashBackConfig.couponRepeatGet});}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;// 判断不同布局方式下的间距取值
if(baseConfig.sortType==="一行一图"){Object.assign(baseConfig,baseConfig.layout_1);}else if(baseConfig.sortType==="一行二图"){Object.assign(baseConfig,baseConfig.layout_2);}else if(baseConfig.sortType==="一行三图"){Object.assign(baseConfig,baseConfig.layout_3);}else if(baseConfig.sortType==="banner"){Object.assign(baseConfig,baseConfig.layout_banner);}// 转为数字处理，后续参与计算
baseConfig.imgMarginHorizon=isNaN(Number(baseConfig.imgMarginHorizon))?0:Number(baseConfig.imgMarginHorizon);baseConfig.imgMarginVertical=isNaN(Number(baseConfig.imgMarginVertical))?0:Number(baseConfig.imgMarginVertical);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",_extends({className:"pipeline-cashBack"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"img-list"},imgsList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(baseConfig.sortType==="一行一图"||baseConfig.sortType==="banner"){rowItemNumber=1;}else if(baseConfig.sortType==="一行二图"){rowItemNumber=2;}else if(baseConfig.sortType==="一行三图"){rowItemNumber=3;}var isFirstRow=Boolean(index<rowItemNumber);// 该项是否在首行
var isLasthRow=Boolean(imgsList.length-index<rowItemNumber);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.imgMarginHorizon;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,minHeight:10,marginTop:isFirstRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px")};// 判断图片圆角值
var imgBorderRadius="6px";if(baseConfig.sortType==="banner"||baseConfig.noImgRadius){// banner图片或者选择不添加圆角情况，值为0
imgBorderRadius="0";}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react__["Fragment"],{key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"img-item",key:index,style:itemStyle,onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"img",style:{borderRadius:imgBorderRadius},src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport)})),_this2.renderCashBackPopup());})),this.renderToast());}}]);return PipelineCashBack;}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);PipelineCashBack.propTypes={config:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCashBack);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineFreeSubsidy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_parseParams__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_parseToken__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_less__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineFreeSubsidy=/*#__PURE__*/function(_React$Component){_inherits(PipelineFreeSubsidy,_React$Component);var _super=_createSuper(PipelineFreeSubsidy);function PipelineFreeSubsidy(props){var _this;_classCallCheck(this,PipelineFreeSubsidy);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"productClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={title:1,name:item.title,sort:index};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.url,item.url,options,-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"onTabClick",function(tabIndex){_this.setState({tabIndex:tabIndex});});_this.state={list:[],tabIndex:0};return _this;}_createClass(PipelineFreeSubsidy,[{key:"componentDidMount",value:function componentDidMount(){this.getProductData();}},{key:"getProductData",value:function getProductData(){var _this2=this;var tabList=this.props.config.tabList;var idList=[];tabList.forEach(function(tabItems){tabItems.forEach(function(item){idList.push(isNaN(Number(item.id))?0:Number(item.id));});});var reqUrl="";if(this.props.config.baseConfig.type==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else{reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}__WEBPACK_IMPORTED_MODULE_20_axios_dist_axios_min_js___default()({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var dataList=res.data.data.List;tabList.forEach(function(tabItems){tabItems.forEach(function(item){var itemData=dataList.find(function(dataItem){return dataItem.id===item.id;});if(itemData){Object.assign(item,itemData);}});});_this2.setState({list:tabList});}});}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,_this$props$config$ta=_this$props$config.tabList,tabList=_this$props$config$ta===void 0?[]:_this$props$config$ta;console.log('baseConfig',this.props);var _this$state=this.state,tabIndex=_this$state.tabIndex,_this$state$list=_this$state.list,list=_this$state$list===void 0?[]:_this$state$list;var itemList=list[tabIndex]||[];var tabs=[1,2];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",_extends({className:"pipeline-free-subsidy",style:{backgroundColor:baseConfig.comBgColor}},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"title-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(baseConfig.titleImg,this.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"tab-list"},tabs.map(function(tab,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",_defineProperty({className:"bg",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(index==0?baseConfig.tab1Img:baseConfig.tab2Img,_this3.props.webpSupport)},"className",tabIndex==index?'bg':'bg-hidden'));}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"tab-btns"},tabs.map(function(tab,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn-tab",onClick:function onClick(){return _this3.onTabClick(index);}});})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"list"},itemList.map(function(item,index){// 计算折扣差价
var discount=Number(item.original_price)-Number(item.price);discount=parseInt(discount);if(discount<0||isNaN(discount)){discount=0;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"item",key:index,onClick:_this3.productClick.bind(_this3,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"product-img",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport)}),item.desc&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"price-tip",style:{backgroundColor:baseConfig.discountBg,color:baseConfig.discountTextColor}},item.desc),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"name"},item.name||item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor,fontStyle:baseConfig.priceFontStyle}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",{className:"rmb-icon"},"\uFFE5"),item.price,item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",{className:"origin-price",style:{fontStyle:baseConfig.priceFontStyle}},"\uFFE5",item.original_price))));})))));}}]);return PipelineFreeSubsidy;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);PipelineFreeSubsidy.propTypes={config:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineFreeSubsidy);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseTokenIgnoreArrayKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_date_to_string_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_date_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_date_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_to_string_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_md5__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_md5__);
/* unused harmony default export */ var _unused_webpack_default_export = (function(obj){var paramsToken='';Object.keys(obj).sort().forEach(function(item){if(obj[item]){paramsToken+=obj[item].toString();}});paramsToken+='123456';return __WEBPACK_IMPORTED_MODULE_7_md5___default()(paramsToken);});var parseTokenIgnoreArrayKey=function parseTokenIgnoreArrayKey(obj){var paramsToken='';Object.keys(obj).sort().forEach(function(item){if(obj[item]&&item.indexOf('[')===-1&&item.indexOf(']')===-1){paramsToken+=obj[item].toString();}});paramsToken+='123456';return __WEBPACK_IMPORTED_MODULE_7_md5___default()(paramsToken);};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelinegoodsHorizontal=/*#__PURE__*/function(_Component){_inherits(PipelinegoodsHorizontal,_Component);var _super=_createSuper(PipelinegoodsHorizontal);function PipelinegoodsHorizontal(props){var _this;_classCallCheck(this,PipelinegoodsHorizontal);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleMoreClick",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}var options={};__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,url,url,options,-1,_this.props,false,{blockName:'more'});});_this.state={list:[]};return _this;}_createClass(PipelinegoodsHorizontal,[{key:"componentDidMount",value:function componentDidMount(){this.getgoodsHorizontalList();}},{key:"getgoodsHorizontalList",value:function getgoodsHorizontalList(){var _this2=this;var itemList=this.props.config.itemList;var idList=itemList.map(function(item){return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";if(this.props.config.baseConfig.productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else{reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}__WEBPACK_IMPORTED_MODULE_23_axios_dist_axios_min_js___default()({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:this.props.config.baseConfig.sortType==='销量'?4:0,filter_subsidy:this.props.config.baseConfig.shihuoSubsidy==='是'?1:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;// 插入定制化内容
list.forEach(function(product){var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem){product.custom_title=customItem.name;product.custom_recommend=customItem.recommend;}});_this2.setState({list:list});}});}// 更多跳转
},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:this.props,index:index});return;}var baseConfig=this.props.config.baseConfig;var options={title:6,type:baseConfig.productStyle,sort:index,name:item.title};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}console.log(this.props);__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.url,item.url,options,-1,this.props);}},{key:"render",value:function render(){var _this3=this;var list=this.state.list;var componentDivideLine=this.props.componentDivideLine;var _this$props$config$ba=this.props.config.baseConfig,titleBg=_this$props$config$ba.titleBg,titleBgColor=_this$props$config$ba.titleBgColor,titleImage=_this$props$config$ba.titleImage,goodsBodyBg=_this$props$config$ba.goodsBodyBg,arrowIcon=_this$props$config$ba.arrowIcon,arrowIcon2=_this$props$config$ba.arrowIcon2,txtColor=_this$props$config$ba.txtColor,moreTxtBg=_this$props$config$ba.moreTxtBg,moreTxtBgColor=_this$props$config$ba.moreTxtBgColor,priceTxtColor=_this$props$config$ba.priceTxtColor,comBg=_this$props$config$ba.comBg,comBgColor=_this$props$config$ba.comBgColor,titlePrefix=_this$props$config$ba.titlePrefix,moreLink=_this$props$config$ba.moreLink,goodsIcon=_this$props$config$ba.goodsIcon;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",_extends({className:"pipeline-goodsHorizontal",style:{backgroundColor:comBgColor}},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"title-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(titleImage,this.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goodsHorizontal-body",style:comBg?{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(comBg,this.props.webpSupport),") no-repeat"),backgroundSize:'cover'}:{}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goodsHorizontal-title",style:_objectSpread({color:txtColor},titleBg?{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(titleBg,this.props.webpSupport),")"),backgroundSize:'cover'}:{backgroundColor:titleBgColor})},titlePrefix,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(arrowIcon,this.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goodsHorizontal-more",style:_objectSpread({color:txtColor},moreTxtBg?{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(moreTxtBg,this.props.webpSupport),")"),backgroundSize:'cover',boxShadow:'none'}:{backgroundColor:moreTxtBgColor}),onClick:this.handleMoreClick.bind(this,moreLink)},"\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(arrowIcon2,this.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-body",style:{backgroundColor:!comBg?goodsBodyBg:'transparent'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-scroll"},list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-item",key:"goods-".concat(index),onClick:_this3.handleItemClick.bind(_this3,item,index)},goodsIcon?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-icon"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{width:"100%",src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(goodsIcon,_this3.props.webpSupport)})):"",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-item-title"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-item-bottom"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-item-originalprice"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",null,"\u5230\u624B\u4EF7:")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"goods-item-price",style:{color:priceTxtColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",null,"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",null,parseInt(item.price)))));})))),this.props.notLastItem&&componentDivideLine&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"component-divide-line",src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(componentDivideLine,this.props.webpSupport)}));}}]);return PipelinegoodsHorizontal;}(__WEBPACK_IMPORTED_MODULE_22_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelinegoodsHorizontal);

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_infinite_scroll_component__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_SHCard_SHCard__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_SHCard_widgets_BottomLoading__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lib_SHCard_widgets_Empty__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_less__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var innerWidth=typeof window!=='undefined'?window.innerWidth:375;var legoBackStag=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].getParams('isIframe')=='1';// url参数携带isIframe=1时，表示后台预览模式
var page_id=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].getPageId();var PipelineGoodsRecommend=/*#__PURE__*/function(_Component){_inherits(PipelineGoodsRecommend,_Component);var _super=_createSuper(PipelineGoodsRecommend);function PipelineGoodsRecommend(props){var _this;_classCallCheck(this,PipelineGoodsRecommend);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getRecommendFeedsData",/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(params){var _yield$_this$getRecom,status,data,_ref2,_ref2$lists,lists;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.getRecommendFeedsApi(params);case 2:_yield$_this$getRecom=_context.sent;status=_yield$_this$getRecom.status;data=_yield$_this$getRecom.data;if(status===0){_ref2=data||{},_ref2$lists=_ref2.lists,lists=_ref2$lists===void 0?[]:_ref2$lists;_this.setState({recommends:_this.page===1?lists:[].concat(_toConsumableArray(_this.state.recommends),_toConsumableArray(lists)),showEmpty:_this.page===1&&lists.length===0,hasMore:lists.length>0,hasInitLoaded:true},function(){_this.page++;_this.isLoading=false;if(lists.length>0){_this.updateMasonryLayout(true,lists.length);}});}case 6:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"getRecommendFeedsApi",function(params){return new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_29__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v3/sh-api/daga/lego/feed/v1',method:"post",withCredentials:true,headers:_this.isShihuo?{'ptiBizMap':'1'}:{},data:params}).then(function(res){resolve(res.data);})["catch"](function(){resolve({});});});});_defineProperty(_assertThisInitialized(_this),"updateMasonryLayout",function(){var isRefreshing=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var addedCount=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(!_this.scrollerViewRef){return;}var doLayout=function doLayout(){if(!_this.masonry){_this.masonry=new _this.MasonryClass(_this.scrollerViewRef,{itemSelector:'.goods-card',// 要布局的网格元素
fitWidth:true,// 设置网格容器宽度等于网格宽度
gutter:9,transitionDuration:0});if(_this.scrollerViewRef){_this.scrollerViewRef.style.opacity=1;}}else{if(isRefreshing||!addedCount){_this.masonry.reloadItems();_this.masonry.layout();}else{var allItems=_this.scrollerViewRef.querySelectorAll('.goods-card');var newElems=Array.prototype.slice.call(allItems,-addedCount);if(newElems&&newElems.length){_this.masonry.appended(newElems);}_this.masonry.layout();}}};if(_this.MasonryClass){doLayout();return;}__webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 152)).then(function(Masonry){_this.MasonryClass=Masonry;doLayout();});});_defineProperty(_assertThisInitialized(_this),"updateListHeight",function(){if(_this.containerRef){var height=_this.containerRef.clientHeight;if(height&&height!==_this.state.listHeight){_this.setState({listHeight:height});}}else if(typeof window!=='undefined'){var _height=window.innerHeight;if(_height&&_height!==_this.state.listHeight){_this.setState({listHeight:_height});}}});_this.state={recommends:[],hasMore:true,listHeight:600,hasInitLoaded:false,showEmpty:false};_this.page=1;_this.refreshHideTimer=null;_this.masonry=null;_this.MasonryClass=null;_this.containerRef=null;_this.scrollerViewRef=null;_this.isLoading=false;_this.isAndroid=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].isAndroid();_this.isShihuo=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].isShihuo();_this.baseParams={recType:'',vcId:'',childCategoryId:'',page:_this.page,pageSize:10,page_id:page_id,legoBackStag:legoBackStag};return _this;}_createClass(PipelineGoodsRecommend,[{key:"componentDidMount",value:function componentDidMount(){if(typeof window!=='undefined'){var _ref3=this.props.config||{},_ref3$categories=_ref3.categories,categories=_ref3$categories===void 0?{}:_ref3$categories,_ref3$filter_ids=_ref3.filter_ids,filter_ids=_ref3$filter_ids===void 0?[]:_ref3$filter_ids;if(categories){var dataRange=categories.dataRange,verticalIds=categories.verticalIds,childIds=categories.childIds,type=categories.type;var vcId='',childCategoryId='';switch(dataRange){case'0':vcId='';childCategoryId='';break;case'1':vcId=verticalIds.join(',');childCategoryId='';break;case'2':vcId='';childCategoryId=childIds.join(',');break;default:break;}// 获取推荐信息流需要过滤的商品
this.baseParams=_objectSpread(_objectSpread({},this.baseParams),{},{recType:type,vcId:vcId,childCategoryId:childCategoryId,filter_ids:filter_ids});this.getRecommendFeedsData(this.baseParams);}window.addEventListener('resize',this.updateListHeight,false);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(typeof window!=='undefined'){window.removeEventListener('resize',this.updateListHeight,false);}if(this.refreshHideTimer){clearTimeout(this.refreshHideTimer);this.refreshHideTimer=null;}if(this.masonry){this.masonry.destroy();this.masonry=null;}}// 获取推荐商品列表
},{key:"loadMore",value:function loadMore(){if(this.isLoading)return;this.isLoading=true;var params=_objectSpread(_objectSpread({},this.baseParams),{},{page:this.page});this.getRecommendFeedsData(params);}},{key:"getTrackData",value:function getTrackData(item,index){var goods_id=item.goods_id,style_id=item.style_id,sku_id=item.sku_id,goods_sku_id=item.goods_sku_id;var options={sort:index,name:item.name,goods_id:goods_id,style_id:style_id,sku_id:sku_id,goods_sku_id:goods_sku_id};return options;}},{key:"render",value:function render(){var _this2=this;var _this$state=this.state,recommends=_this$state.recommends,hasMore=_this$state.hasMore,hasInitLoaded=_this$state.hasInitLoaded;var _this$props=this.props,isLogin=_this$props.isLogin,showEmpty=_this$props.showEmpty,_this$props$pageOptio=_this$props.pageOptions,pageOptions=_this$props$pageOptio===void 0?{}:_this$props$pageOptio;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"pipeline-goodsRecommend",ref:function ref(_ref5){_this2.containerRef=_ref5;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_infinite_scroll_component__["a" /* default */],{dataLength:recommends.length,next:this.loadMore.bind(this),hasMore:hasMore,scrollThreshold:this.isAndroid?0.8:0.5,className:"scroller-view",style:{width:innerWidth},loader:hasInitLoaded?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__lib_SHCard_widgets_BottomLoading__["a" /* default */],{hasMore:hasMore}):null,endMessage:hasInitLoaded?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__lib_SHCard_widgets_BottomLoading__["a" /* default */],{hasMore:hasMore}):null},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{ref:function ref(_ref4){return _this2.scrollerViewRef=_ref4;},className:"scroller-container",style:{margin:showEmpty?"0":'0 12px'}},recommends&&recommends.length>0&&recommends.map(function(item,index){var component=item.component,item_type=item.item_type,_item$price_datas=item.price_datas,price_datas=_item$price_datas===void 0?[]:_item$price_datas,_item$v_datas=item.v_datas,v_datas=_item$v_datas===void 0?[]:_item$v_datas;var price_label_text=price_datas.map(function(item){return item&&item.item_datas&&item.item_datas[0]&&item.item_datas[0].text;}).filter(Boolean).join(',')||'';var tag_label_text=v_datas.map(function(item){return item&&item.item_datas&&item.item_datas[0]&&item.item_datas[0].text;}).filter(Boolean).join(',')||'';var biz={goods_id:item.goods_id,style_id:item.style_id,sku_id:item.sku_id||item.goods_sku_id,goods_sku_id:item.sku_id||item.goods_sku_id,set_id:pageOptions['collectionId'],type:item_type=='COLLECTION_NOTE_CARD'?'note':'goods',component:component,price_label_text:price_label_text,tag_label_text:tag_label_text,model_block:'recommend-feeds-card'};var h5_exposure_object={id:"".concat(_this2.props.templatePti,":recommend-feeds:").concat(index+1),name:'',href:item.href,pageOptions:_objectSpread(_objectSpread({},pageOptions),biz),biz:JSON.stringify(_objectSpread(_objectSpread({},pageOptions),biz)),exposekey:"".concat(_this2.props.templatePti,":recommend-feeds:").concat(index+1),exposekey_self:item.expose_key||''};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{key:"list-".concat(index+1),style:{position:'relative'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__lib_SHCard_SHCard__["a" /* SHCard */],{key:"list-".concat(index+1,"-").concat(item.goods_id),type:component,isDark:false,isLogin:isLogin,dataSource:item,h5_exposure_object:h5_exposure_object,exp:_this2.props.exp,onPress:function onPress(){var ptiID="".concat(_this2.props.templatePti,":recommend-feeds:").concat(index+1);// if (isCardShowStyleList(item)) {
//   ptiID = `${this.props.templatePti}:recommend-feeds:${index + 1}_0`
// }
var ptiOptions={ptiId:ptiID,ptiName:'',bizExtra:_objectSpread(_objectSpread({},pageOptions),biz)};var options=_this2.getTrackData(item,index);var convertUrl=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].convertHref(item.href);__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,convertUrl,convertUrl,options,-1,_this2.props,false,ptiOptions);}}));}),showEmpty&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__lib_SHCard_widgets_Empty__["a" /* default */],null))));}}]);return PipelineGoodsRecommend;}(__WEBPACK_IMPORTED_MODULE_24_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelineGoodsRecommend);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isCardShowStyleList */
/* unused harmony export getCardHeight */
/* unused harmony export getTags */
/* unused harmony export getVertHoriStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_px2dp_js__ = __webpack_require__(76);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var vCardWidth=typeof window!=='undefined'&&(window.innerWidth-Object(__WEBPACK_IMPORTED_MODULE_13__utils_px2dp_js__["c" /* px2dpSmall */])(12)*2-Object(__WEBPACK_IMPORTED_MODULE_13__utils_px2dp_js__["c" /* px2dpSmall */])(9))/2;function getCardComponentForName(name){switch(name){case'goods_common_vert_style_8':return{registeredWidgetObj:__webpack_require__(227)["default"],layoutType:2};// 新品频道新增A8卡片样式扁平卡
case'note_common_vert_style_3':return{registeredWidgetObj:__webpack_require__(229)["default"],layoutType:2};// 笔记流扁平卡卡片
case'goods_common_vert_flat_style_8':return{registeredWidgetObj:__webpack_require__(227)["default"],layoutType:2};// 新品频道新增A8卡片样式扁平卡
case'note_common_vert_flat_style_3':return{registeredWidgetObj:__webpack_require__(229)["default"],layoutType:2};// 笔记流扁平卡卡片
default:return{};}}var getCardHeight=function getCardHeight(data){var widgetWidth=arguments.length>1&&arguments[1]!==undefined?arguments[1]:vCardWidth;var _data$component=data.component,component=_data$component===void 0?'':_data$component;// 通用获取卡片高度方式
var registeredWidgetObj=getCardComponentForName(component).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.getWidgetHeight){return registeredWidgetObj.getWidgetHeight(data,widgetWidth);}console.log("getCardHeight 不支持的组件名: ",component);return 0;};var getTags=function getTags(dataSource){var _dataSource$component=dataSource.component,component=_dataSource$component===void 0?'':_dataSource$component;// 获取标签数据
var registeredWidgetObj=getCardComponentForName(component).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.getTags){return registeredWidgetObj.getTags(dataSource);}return{};};/// 获取卡片是一行一还是一行二    1: 一行一  2: 一行二
var getVertHoriStatus=function getVertHoriStatus(dataSource){var _dataSource$component2=dataSource.component,component=_dataSource$component2===void 0?'':_dataSource$component2;// 获取标签数据
var layoutType=getCardComponentForName(component);return layoutType?layoutType:0;};// 该卡片是否显示多配色
var isCardShowStyleList=function isCardShowStyleList(data){var _data$component2=data.component,component=_data$component2===void 0?'':_data$component2;// 通用获取卡片高度方式
var registeredWidgetObj=getCardComponentForName(component).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.showStyleList!=='undefined'){return registeredWidgetObj.showStyleList;}return false;};var SHCard=/*#__PURE__*/function(_Component){_inherits(SHCard,_Component);var _super=_createSuper(SHCard);function SHCard(props){_classCallCheck(this,SHCard);return _super.call(this,props);}_createClass(SHCard,[{key:"render",value:function render(){var _this$props=this.props,type=_this$props.type,icon=_this$props.icon,onPress=_this$props.onPress,getItemRef=_this$props.getItemRef;var view=null;var registeredWidgetObj=getCardComponentForName(type).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.widget){var Widget=registeredWidgetObj.widget;view=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Widget,_extends({ref:function ref(_ref){return getItemRef&&getItemRef(_ref);}},this.props));return view;}return null;}}]);return SHCard;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);SHCard.propTypes={type:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//卡片类型
icon:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number]),//标题前的Icon
onPress:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片点击事件
onLongPress:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片长按
onlayout:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片layout
containRef:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片ref
image:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number]),//主图片
imageDesc:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//主图片上右下角的描述
title:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//标题
subTitle:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//副标题
price:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number]),//价格
couponTxt:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//优惠信息
discountTxt:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//折扣信息
desc:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//右下角其他描述信息
goodsImgFadeDuration:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number// 图片展示是否需要渐变默认需要-1 不需要0
};SHCard.defaultProps={type:'goods_common_vert_flat_style_8',icon:null,onPress:function onPress(){},onlayout:function onlayout(){},onLongPress:function onLongPress(){},containRef:function containRef(){},image:null,imageDesc:'',title:'',subTitle:'',price:'',couponTxt:'',discountTxt:'',desc:'',goodsImgFadeDuration:-1};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__ = __webpack_require__(228);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// 纯 Web 版价格视图组件，对齐 RN 版 SHCardPriceView 的 props 和逻辑
var styles=pageStyles;var SHCardPriceView=function SHCardPriceView(props){var isDark=props.isDark,price=props.price,kern=props.kern,_props$style=props.style,style=_props$style===void 0?{}:_props$style,_props$symbolStyle=props.symbolStyle,symbolStyle=_props$symbolStyle===void 0?{}:_props$symbolStyle,_props$mainPriceStyle=props.mainPriceStyle,mainPriceStyle=_props$mainPriceStyle===void 0?{}:_props$mainPriceStyle,_props$dotPriceStyle=props.dotPriceStyle,dotPriceStyle=_props$dotPriceStyle===void 0?{}:_props$dotPriceStyle,_props$unitPirceStyle=props.unitPirceStyle,unitPirceStyle=_props$unitPirceStyle===void 0?{}:_props$unitPirceStyle;var _handlePrice=Object(__WEBPACK_IMPORTED_MODULE_11__utils_utils__["b" /* handlePrice */])(price),_handlePrice$symbol=_handlePrice.symbol,symbol=_handlePrice$symbol===void 0?'¥':_handlePrice$symbol,_handlePrice$mainPric=_handlePrice.mainPrice,mainPrice=_handlePrice$mainPric===void 0?'':_handlePrice$mainPric,_handlePrice$dotPrice=_handlePrice.dotPrice,dotPrice=_handlePrice$dotPrice===void 0?'':_handlePrice$dotPrice,_handlePrice$unitPric=_handlePrice.unitPrice,unitPrice=_handlePrice$unitPric===void 0?'':_handlePrice$unitPric;styles=Object(__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["b" /* getColorSchemeStyle */])(pageStyles,isDark);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"price-view",style:_objectSpread(_objectSpread({},styles.main),style)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"symbol",style:_objectSpread(_objectSpread({},styles.symbol),symbolStyle)},symbol),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"main-price",style:_objectSpread(_objectSpread(_objectSpread({},styles.mainPrice),mainPriceStyle),{},{marginLeft:kern})},mainPrice),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"dot-price",style:_objectSpread(_objectSpread({},styles.dotPrice),dotPriceStyle)},dotPrice),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"unit-price",style:_objectSpread(_objectSpread({},styles.unitPirce),unitPirceStyle)},unitPrice));};var pageStyles={main:{flexDirection:'row'},symbol:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(12),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333},mainPrice:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(18),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333},dotPrice:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(13),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333},unitPirce:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(12),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333}};SHCardPriceView.propTypes={price:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,fontSize:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,// 兼容 RN 版的 prop，当前未直接使用
symbolFontSize:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,// 兼容 RN 版
kern:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number};SHCardPriceView.defaultProps={price:'--',fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(18),symbolFontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(12),kern:1};/* harmony default export */ __webpack_exports__["a"] = (SHCardPriceView);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getByteCount;
var tinyChar={" ":0.56,".":0.62,"f":0.68,"i":0.68,"j":0.68,"l":0.68,"r":0.66,"t":0.68};function getByteCount(str){var count=0;for(var i=0;i<str.length;i++){var c=str.charAt(i);var value=tinyChar[c];if(value!==undefined){count+=value;}else if(/^[\u0000-\u00ff]$/.test(c)){count+=1;}else{count+=2;}}return Math.ceil(count);}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(7);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var K_BLACK_THEME_IMG='http://static.shihuocdn.cn/admin/files/20230612/32466d3f9e1219bf5332cdee726f1ace.webp';var K_NORMAL_THEME_IMG='http://static.shihuocdn.cn/admin/files/20220622/60c4ccd1c3763097cfa5e67c1ca3fc24.webp';var BottomLoading=function BottomLoading(props){var hasMore=props.hasMore;if(hasMore){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:_defineProperty({width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(68),marginBottom:__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].isIphoneX()?34:0,display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'},"flexDirection",'row')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:K_NORMAL_THEME_IMG,alt:"refresh",style:{width:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(16),height:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(16),marginRight:4}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{style:{color:'#999',fontSize:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(12),fontFamily:'PingFangSC-Regular'}},"\u52A0\u8F7D\u4E2D..."));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:'100%',height:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(68),marginBottom:__WEBPACK_IMPORTED_MODULE_3__utils_utils__["a" /* default */].isIphoneX()?34:0,display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(20),height:1,backgroundImage:'linear-gradient(to right, rgba(153,153,153,0), #999999)'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{style:{color:'#999',fontSize:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(12),fontFamily:'PingFangSC-Regular',marginLeft:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(4),marginRight:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(4),textAlign:'center'}},"\u6CA1\u6709\u66F4\u591A\u4E86"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{style:{width:Object(__WEBPACK_IMPORTED_MODULE_2__utils_px2dp__["a" /* aiDp */])(20),height:1,backgroundImage:'linear-gradient(to right, #999999, rgba(153,153,153,0))'}}));}};/* harmony default export */ __webpack_exports__["a"] = (BottomLoading);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_px2dp__ = __webpack_require__(76);
var height=typeof window!=='undefined'&&window.innerHeight;var Empty=function Empty(){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:'flex',alignItems:'center',justifyContent:'center',height:height/3,color:'#999',fontSize:Object(__WEBPACK_IMPORTED_MODULE_1__utils_px2dp__["b" /* default */])(32),textAlign:'center',boxSizing:'border-box'}},"\u62B1\u6B49\uFF0C\u6CA1\u6709\u627E\u5230\u76F8\u5173\u5546\u54C1");};/* harmony default export */ __webpack_exports__["a"] = (Empty);

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineHotspots */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineHotspots=/*#__PURE__*/function(_React$Component){_inherits(PipelineHotspots,_React$Component);var _super=_createSuper(PipelineHotspots);function PipelineHotspots(props){var _this;_classCallCheck(this,PipelineHotspots);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){var jumpUrl='';if(item.productType==='商品库'){jumpUrl="shihuo://www.shihuo.cn?route=goodsDetail&id=".concat(item.id,"&styleId=").concat(item.styleId);}else{jumpUrl=item.link;}if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].handleToufangClick({link:jumpUrl,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={link:jumpUrl,type:baseConfig.sortType,sort:index};if(item.productType==="商品库"){options.goods_id=item.id;options.style_id=item.styleId;}__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,jumpUrl,'',options,-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"imageLoadedAll",function(){var itemList=_this.props.config.itemList;var mulitImg=itemList.map(function(item,index){return item.src;});var promiseAll=[],img=[],imgTotal=mulitImg.length;var _loop=function _loop(i){promiseAll[i]=new Promise(function(resolve,reject){img[i]=new Image();img[i].src=mulitImg[i];img[i].onload=function(){//第i张加载完成
resolve(img[i]);};});};for(var i=0;i<imgTotal;i++){_loop(i);}Promise.all(promiseAll).then(function(img){//全部加载完成
_this.setState({imageShow:true});});});_this.state={imageShow:false};_this.bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:750;return _this;}_createClass(PipelineHotspots,[{key:"componentDidMount",value:function componentDidMount(){this.imageLoadedAll();}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var sortType=baseConfig.sortType,backgroundImage=baseConfig.backgroundImage,backgroundTitleImage=baseConfig.backgroundTitleImage;var className="",classNameTitle="";switch(sortType){case"热区排列一":className="display-type1 item-pro";classNameTitle="background-title1-image";break;case"热区排列二":className="display-type2 item-pro";classNameTitle="background-title2-image";break;case"热区排列三":className="display-type3 item-pro";classNameTitle="background-title3-image";break;default:break;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({className:"pipeline-hotspots"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:"background-image",src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(backgroundImage,this.props.webpSupport)}),backgroundTitleImage?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:classNameTitle,src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(backgroundTitleImage,this.props.webpSupport)}):null,itemList.map(function(item,index){return _this2.state.imageShow?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:className,key:index,onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),alt:"",className:"image",style:{width:_this2.bodyWidth*0.26}})):null;}));}// 图片全部加载完成
}]);return PipelineHotspots;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineHotspots.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineHotspots);

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_last_index_of_js__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_last_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_last_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_countDown__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_px2rem__ = __webpack_require__(42);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineImage=/*#__PURE__*/function(_React$Component){_inherits(PipelineImage,_React$Component);var _super=_createSuper(PipelineImage);function PipelineImage(props){var _this;_classCallCheck(this,PipelineImage);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"imgClick",function(){if(_this.props.templateName==='toufang'){var m_device_id=window.localStorage.getItem('m_device_id')||'';__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({from:'dyPlacing',block:'download',command:_this.props.kouling,deviceId:m_device_id,pti:{id:'dyPlacing:download',name:'',biz:JSON.stringify({h5Url:typeof window!=="undefined"&&window.location.href,pageId:_this.pageId,legoAb:_this.props.legoAb,command:_this.props.kouling,deviceId:m_device_id}),pageOptions:{lego_page_id:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId(),legoAb:_this.props.legoAb}}},"shihuo://www.shihuo.cn?route=h5&url=".concat(encodeURIComponent(window.location.href)));var _this$props$config$li=_this.props.config.link,link=_this$props$config$li===void 0?"":_this$props$config$li;__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].handleToufangClick({link:link,props:_this.props});return;}});_this.pageId=typeof window!=="undefined"&&window.location.host==="www.shihuo.cn"?window.location.href.indexOf('zt-public/stage')>-1?window.location.pathname.split("/")[4]:window.location.pathname.split("/")[3]:0;return _this;}_createClass(PipelineImage,[{key:"render",value:function render(){var _this$props$config=this.props.config,_this$props$config$sr=_this$props$config.src,src=_this$props$config$sr===void 0?"":_this$props$config$sr,_this$props$config$bo=_this$props$config.bounceTime,bounceTime=_this$props$config$bo===void 0?"0.6s":_this$props$config$bo,fixBottom=_this$props$config.fixBottom,width=_this$props$config.width,bounce=_this$props$config.bounce,isDownload=_this$props$config.isDownload,marginTop=_this$props$config.marginTop,marginBottom=_this$props$config.marginBottom,openCountDown=_this$props$config.openCountDown,countDownTime=_this$props$config.countDownTime,countDownTextColor=_this$props$config.countDownTextColor,countDownBgColor=_this$props$config.countDownBgColor;if(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isShihuo()&&isDownload){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",null);}if(fixBottom){var fixedBottom=fixBottom;if(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isIphoneX()){if(fixedBottom.indexOf('vw')>=0){fixedBottom=fixedBottom.replace('vw','');fixedBottom=Number(fixedBottom)+5+'vw';}else if(fixedBottom.indexOf('px')>=0){fixedBottom=fixedBottom.replace('px','');fixedBottom=Number(fixedBottom)+20+'px';fixedBottom=Object(__WEBPACK_IMPORTED_MODULE_23__utils_px2rem__["a" /* default */])(fixedBottom);}else{fixedBottom=Number(fixedBottom)+23;}}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-image fixed",style:{position:'fixed',bottom:fixedBottom,zIndex:99}},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:[bounce?'bounce':''],onClick:this.imgClick},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{style:{width:width,marginTop:marginTop,marginBottom:marginBottom,animationDuration:bounceTime},src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(src,this.props.webpSupport),alt:""}),openCountDown&&countDownTime&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__utils_countDown__["a" /* default */],{fixed:true,countDownTime:countDownTime,countDownTextColor:countDownTextColor,countDownBgColor:countDownBgColor})));}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-image"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:[bounce?'bounce':''],onClick:this.imgClick},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{style:{width:width,marginTop:marginTop,marginBottom:marginBottom,animationDuration:bounceTime},src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(src,this.props.webpSupport),alt:""}),openCountDown&&countDownTime&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__utils_countDown__["a" /* default */],{fixed:false,countDownTime:countDownTime,countDownTextColor:countDownTextColor,countDownBgColor:countDownBgColor})));}},{key:"removeURLParameter",value:function removeURLParameter(url,parameter){var urlparts=url.split('?');if(urlparts.length>=2){//参数名前缀
var prefix=encodeURIComponent(parameter)+'=';var pars=urlparts[1].split(/[&;]/g);//循环查找匹配参数
for(var i=pars.length;i-->0;){if(pars[i].lastIndexOf(prefix,0)!==-1){//存在则删除
pars.splice(i,1);}}return urlparts[0]+(pars.length>0?'?'+pars.join('&'):'');}return url;}}]);return PipelineImage;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineImage.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImage);

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pipeline_modal__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_countDown__ = __webpack_require__(230);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineImgList=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgList,_React$Component);var _super=_createSuper(PipelineImgList);function PipelineImgList(props){var _this;_classCallCheck(this,PipelineImgList);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"showImg",function(){if(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].isShihuo()){if(!__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].isAndroid()&&__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].SHDiffVersion(_this.app_version,'7.14.0'))return true;if(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].isAndroid()&&__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].SHDiffVersion(_this.app_version,'7.17.0'))return true;return false;}return true;});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){// 当选择的点击事件是扫码
if(item.behaviorType==='点击扫码(IOS >= 7.14 Android >= 7.17 可用)'){if(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].isShihuo()&&_this.showImg()){window.Jockey.send("scanCode",{from:'h5-imgList',promptText:'扫描二维码/条码',authText:'识货请求使用相机权限，以便完成扫码验证功能',timeout:10,codeType:'all'},function(data){var _ref=data||{},_ref$code=_ref.code,code=_ref$code===void 0?'':_ref$code,_ref$msg=_ref.msg,msg=_ref$msg===void 0?'':_ref$msg;if(code==0){if(msg.indexOf("http")==0){var _baseConfig=_this.props.config.baseConfig;var _options={link:msg,type:_baseConfig.sortType,sort:index};var _convertUrl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].convertHref(msg);__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,_convertUrl,msg,_options,-1,_this.props,false);}else{__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].toast('非有效网页链接');}}else{__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].toast(msg);}});}return;}// 当选择的点击事件是弹窗
if(item.behaviorType==='唤起弹窗'){var modalVisibles=_this.state.modalVisibles;modalVisibles[index]=true;_this.setState({modalVisibles:modalVisibles});return;}if(_this.props.templateName==='toufang'){var params={link:item.link||"",props:_this.props,index:index};if(item.behaviorType==='唤起下载APP弹窗'){Object.assign(params,{clickType:'openModal'});_this.setState({showDownloadModal:true});}__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick(params);return;}if(!item.link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:item.link,type:baseConfig.sortType,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handleDownloadModalClick",function(){__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick({link:"https://wwww.shihuo.cn",props:_this.props,clickType:'modalClick'});});_defineProperty(_assertThisInitialized(_this),"handleCloseDownloadModal",function(){var longurl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getParams('longurl')||'';var from=longurl?__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getUrlParams(longurl,'from'):'';var block=_this.props.customAttributes["data-component-block"];window.sa&&window.sa.track('pcClick',{env:'toufang',version:'1.0.0',extra:from,action:"".concat(block),page:window.location.href,data:JSON.stringify({clickType:'closeModal'})});_this.setState({showDownloadModal:false});});_this.state={modalVisibles:[],showDownloadModal:false};_this.app_version='';_this.is_iframe=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getParams('isIframe')==1;return _this;}_createClass(PipelineImgList,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.app_version=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getVersion();var imgsList=this.props.config.imgsList;var showView=true;imgsList&&imgsList.map(function(item){if(item.src&&item.behaviorType==='点击扫码(IOS >= 7.14 Android >= 7.17 可用)'){showView=_this2.showImg();}else if(!item.src){showView=false;}});if(imgsList&&imgsList.length==1&&!showView&&this.ref){this.ref.parentNode.style.minHeight=0;this.ref.parentNode.style.height=0;}}},{key:"render",value:function render(){var _this3=this;var _this$state=this.state,modalVisibles=_this$state.modalVisibles,showDownloadModal=_this$state.showDownloadModal;var _this$props=this.props,_this$props$allModals=_this$props.allModals,allModals=_this$props$allModals===void 0?[]:_this$props$allModals,designIntent=_this$props.designIntent;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;var marginLeft="".concat(baseConfig.moduleMarginHorizon,"px");var marginRight="".concat(baseConfig.moduleMarginHorizon,"px");var imgListPadding="".concat(baseConfig.moduleMarginHorizon,"px");if(this.props.templateName==='toufang'){// 投放模版，图片组件满足以下情形时，不展示左右边距
var sortType=baseConfig.sortType,_baseConfig$layout_=baseConfig.layout_1,layout_1=_baseConfig$layout_===void 0?{}:_baseConfig$layout_;if(sortType==='一行一图'&&layout_1.imgMarginHorizon=='12'&&layout_1.imgMarginVertical=='0'&&layout_1.moduleMarginHorizon=='12'&&layout_1.moduleMarginTop=='0'){marginLeft=0;marginRight=0;}}// 判断不同布局方式下的间距取值
if(baseConfig.sortType==="一行一图"){Object.assign(baseConfig,baseConfig.layout_1);}else if(baseConfig.sortType==="一行二图"){Object.assign(baseConfig,baseConfig.layout_2);}else if(baseConfig.sortType==="一行三图"){Object.assign(baseConfig,baseConfig.layout_3);}else if(baseConfig.sortType==="一行多图"){Object.assign(baseConfig,baseConfig.layout_multiple);marginLeft='0px';marginRight='0px';}else if(baseConfig.sortType==="banner"){Object.assign(baseConfig,baseConfig.layout_banner);}// 转为数字处理，后续参与计算
baseConfig.imgMarginHorizon=isNaN(Number(baseConfig.imgMarginHorizon))?0:Number(baseConfig.imgMarginHorizon);baseConfig.imgMarginVertical=isNaN(Number(baseConfig.imgMarginVertical))?0:Number(baseConfig.imgMarginVertical);if(designIntent&&(baseConfig.title||baseConfig.subTitle)&&imgsList.length>0&&imgsList[0].src.indexOf('51663af5c613f3514e365ad71478ac4a')>=0){// 当组件包含设计意图，且存在住标题或副标题，且存在占位图片时，渲染自定义占位元素
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",_extends({className:"pipeline-imgList design-intent",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:marginLeft,marginRight:marginRight}}),baseConfig.title&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"main-title"},baseConfig.title),baseConfig.subTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"sub-title"},baseConfig.subTitle));}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",_extends({ref:function ref(_ref2){return _this3.ref=_ref2;},className:"pipeline-imgList",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:marginLeft,marginRight:marginRight}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:baseConfig.sortType==='一行多图'?'img-list multiple':'img-list',style:{paddingLeft:baseConfig.sortType==='一行多图'&&imgListPadding,paddingRight:baseConfig.sortType==='一行多图'&&imgListPadding}},imgsList.map(function(item,index){var rowItemNumber=1;// 每行排列数量
if(baseConfig.sortType==="一行一图"||baseConfig.sortType==="banner"){rowItemNumber=1;}else if(baseConfig.sortType==="一行二图"){rowItemNumber=2;}else if(baseConfig.sortType==="一行三图"){rowItemNumber=3;}var targetModal=allModals.find(function(value){return value.id===item.targetModal;});var isFirstRow=Boolean(index<rowItemNumber);// 该项是否在首行
var isLasthRow=Boolean(imgsList.length-index<=rowItemNumber);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.imgMarginHorizon;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");// 判断图片圆角值
var imgBorderRadius="6px";if(baseConfig.sortType==="banner"||baseConfig.noImgRadius){// banner图片或者选择不添加圆角情况，值为0
imgBorderRadius="0";}if(baseConfig.sortType==="一行多图"){itemWidth=Object(__WEBPACK_IMPORTED_MODULE_24__utils_px2rem__["a" /* default */])("".concat(baseConfig.layout_multiple.imgWidth||100,"px"));}// const { height } = utils.getAdaptImageSize(item.size);
var itemStyle={width:itemWidth,// height: height,
borderRadius:imgBorderRadius,marginTop:isFirstRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginLeft:isFirstColumn&&baseConfig.sortType!="一行多图"?"0":"".concat(baseConfig.imgMarginHorizon/2,"px"),marginRight:isLastColumn&&baseConfig.sortType!="一行多图"?"0":"".concat(baseConfig.imgMarginHorizon/2,"px")};var imgItem;if(item.src){imgItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],{key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getExposureData(_this3.props,{link:item.link,type:baseConfig.sortType,sort:index})),className:baseConfig.sortType==='一行多图'?'img-item multiple':'img-item',key:index,style:itemStyle,onClick:_this3.handleItemClick.bind(_this3,item,index)},item.openCountDown&&item.countDownTime&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__utils_countDown__["a" /* default */],{countDownTime:item.countDownTime,countDownTextColor:item.countDownTextColor,countDownBgColor:item.countDownBgColor}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_lazy_load_image_component__["LazyLoadImage"],{src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.src,_this3.props.webpSupport),style:{width:itemWidth// height: height
},effect:"opacity",visibleByDefault:true})),targetModal&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pipeline_modal__["a" /* default */],{customAttributes:{"data-component-id":targetModal.id,"data-component-name":targetModal.name,"data-component-block":targetModal.blockName},config:targetModal.data,triggerId:_this3.props['customAttributes']["data-component-id"],visible:modalVisibles[index],onClose:function onClose(){modalVisibles[index]=false;_this3.setState({modalVisibles:modalVisibles});}}));if(item.behaviorType==='点击扫码(IOS >= 7.14 Android >= 7.17 可用)'){if(!_this3.showImg()){imgItem=null;}}}else{imgItem=null;}return imgItem;})),this.props.templateName==='toufang'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:showDownloadModal?"pipeline-downloadModal show":"pipeline-downloadModal"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:showDownloadModal?"modal-content show":"modal-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"modal-img",alt:"",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl("https://static.shihuocdn.cn/admin/files/20230227/54917266bd550bf120101644116385fb.png",this.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"bottom-btns",style:{width:Object(__WEBPACK_IMPORTED_MODULE_24__utils_px2rem__["a" /* default */])('215px'),height:"40px"},onClick:this.handleDownloadModalClick.bind(this)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",null,"\u7ACB\u5373\u4E0B\u8F7D"))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"close",onClick:this.handleCloseDownloadModal},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{alt:"",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl("https://static.shihuocdn.cn/admin/files/20230227/3824f46f10ed91f4d71e53c141c9ebf4.png",this.props.webpSupport),style:{width:Object(__WEBPACK_IMPORTED_MODULE_24__utils_px2rem__["a" /* default */])('24px'),height:'auto'}})))));}}]);return PipelineImgList;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);PipelineImgList.propTypes={config:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgList);

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_anchor_link_smooth_scroll__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_anchor_link_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_anchor_link_smooth_scroll__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function debounce(fn,delay){var timer=null;//借助闭包
return function(){if(timer){clearTimeout(timer);}timer=setTimeout(fn,delay);// 简化写法
};}function hexColorToRgba(hexColor,opacity){if(!hexColor){return hexColor;}var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}var PipelineNavigation=/*#__PURE__*/function(_React$Component){_inherits(PipelineNavigation,_React$Component);var _super=_createSuper(PipelineNavigation);function PipelineNavigation(props){var _this;_classCallCheck(this,PipelineNavigation);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"isScrollStart",function(){clearTimeout(_this.scrollTimer);_this.scrollTimer=setTimeout(_this.isScrollEnd,200);_this.t1=document.documentElement.scrollTop||document.body.scrollTop;});_defineProperty(_assertThisInitialized(_this),"isScrollEnd",function(){_this.t2=document.documentElement.scrollTop||document.body.scrollTop;if(_this.t2==_this.t1){console.log('滚动结束了');_this.updateNavPostion(_this.checkedNav,_this.checkedTitle);}});_defineProperty(_assertThisInitialized(_this),"handleBodyScroll",function(){if(_this.props.tabActive!=_this.props.tabIndex){console.log('当前锚点Tab组件所在切换Tab为被选中，阻止监听');return;}if(!_this.navigationTab){return;}if(!_this.state.navList||_this.state.navList.length<=0){return;}if(!_this.state.tabExpand){_this.navigationContentHeight=_this.navigationTab.clientHeight;}var navigationBarHeight=window.navigationBarHeight>0?_this.props.navigationBarHeight:_this.props.navigationBarHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navClientHeight=0;var navOffsetTop=0;var navFixed=false;var _this$state$navList=_this.state.navList,navList=_this$state$navList===void 0?[]:_this$state$navList;var productComList=[];var productComNotInTabList=[];var checkedNav='',checkedIndex=0,checkedTitle='';if(!_this.isAnchorInSwitchTab){// 锚点Tab不被切换Tab所包含
navClientHeight=_this.navigationStaticRef.clientHeight;navOffsetTop=_this.navigationStaticRef.offsetTop-navigationBarHeight;productComList=window.document.querySelectorAll('.pipeline-product,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-communityArticle,.pipeline-pkRank,.pipeline-product-customize,.pipeline-productCollection,.pipeline-productGather,.pipeline-productLayout3,.pipeline-hotSellRankList')||[];var _loop=function _loop(i){if(productComList[i].getAttribute('data-component-belong')){// 如果当前组件属于Tab组件的子组件，则跳过，继续往下遍历
return"continue";}if(productComList[i].getAttribute('data-component-name')==='pipeline-imgHotMap'&&productComList[i].getAttribute('class').indexOf('fixed')>=0){// 如果当前组件是热区组件，且是底部浮层展示，则跳过，继续往下遍历
return"continue";}var findItem=navList.find(function(item){return item.id===productComList[i].getAttribute('id');});if(findItem){// 获取加入到锚点Tab中的所有组件
productComNotInTabList.push(productComList[i]);}// 模块偏移量小于 滚动偏移 + 导航栏高度，导航栏高度暂定为 this.navigationContentHeight
if(scrollHeight+_this.navigationContentHeight+navigationBarHeight+1>=productComList[i].offsetTop){checkedNav=productComList[i].getAttribute('id');checkedTitle=productComList[i].getAttribute('name');checkedIndex=i;}if(!checkedTitle){checkedTitle=navList[0]&&navList[0].title;}};for(var i=0;i<productComList.length;i+=1){var _ret=_loop(i);if(_ret==="continue")continue;}}else{// 切换Tab包含锚点Tab
var targetTabContainer=window.document.querySelectorAll('.tab-container')[_this.props.tabIndex];navClientHeight=targetTabContainer.querySelector('.navigation-container-static-wrap').clientHeight;navOffsetTop=targetTabContainer&&targetTabContainer.querySelector('.navigation-container-static-wrap').offsetTop-navigationBarHeight;productComList=targetTabContainer&&targetTabContainer.querySelectorAll('.pipeline-product,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-communityArticle,.pipeline-pkRank,.pipeline-product-customize,.pipeline-productCollection,.pipeline-productGather,.pipeline-productLayout3,.pipeline-hotSellRankList')||[];var _loop2=function _loop2(_i){if(productComList[_i].getAttribute('data-component-name')==='pipeline-imgHotMap'&&productComList[_i].getAttribute('class').indexOf('fixed')>=0){// 如果当前组件是热区组件，且是底部浮层展示，则跳过，继续往下遍历
return"continue";}var findItem=navList.find(function(item){return item.id===productComList[_i].getAttribute('id');});if(findItem){// 获取加入到锚点Tab中的所有组件
productComNotInTabList.push(productComList[_i]);}// 模块偏移量小于 滚动偏移 + 导航栏高度，导航栏高度暂定为 this.navigationContentHeight
if(scrollHeight+_this.navigationContentHeight+navigationBarHeight+1>=productComList[_i].offsetTop){checkedNav=productComList[_i].getAttribute('id');checkedTitle=productComList[_i].getAttribute('name');checkedIndex=_i;}if(!checkedTitle){checkedTitle=navList[0]&&navList[0].title;}};for(var _i=0;_i<productComList.length;_i+=1){var _ret2=_loop2(_i);if(_ret2==="continue")continue;}}// 查询当前展示的商品组件
var lastNavCompBottomOffsetTop=0;if(productComNotInTabList&&productComNotInTabList[navList.length-1]){_this.lastNavCompOffsetTop=productComNotInTabList[navList.length-1].offsetTop;// 锚点Tab中最后一个Tab对应组件距离页面顶部的距离
lastNavCompBottomOffsetTop=_this.lastNavCompOffsetTop+productComNotInTabList[navList.length-1].clientHeight;}var isScrollAreaUnEnd=scrollHeight+navigationBarHeight+navClientHeight<lastNavCompBottomOffsetTop;if(scrollHeight-navOffsetTop>=0){if(_this.state.checkedNav!=navList[navList.length-1].id||_this.state.checkedNav==navList[navList.length-1].id&&isScrollAreaUnEnd){navFixed=true;_this.navPosition=0;}else{navFixed=false;_this.navPosition=lastNavCompBottomOffsetTop-navClientHeight-navigationBarHeight;}}else{navFixed=false;_this.state.tabExpand&&_this.setState({tabExpand:false});}if(!_this.isAnchorInSwitchTab){var height=lastNavCompBottomOffsetTop-_this.pipelineNavigation.offsetTop;var navigationTabHeight=_this.navigationTab?_this.navigationTab.clientHeight:0;_this.pipelineNavigation.style.height="".concat(height,"px");_this.pipelineNavigation.style.marginBottom="".concat(-(height-navigationTabHeight),"px");}else{var tabItemHeight=document.querySelector('.tab-item-content')?document.querySelector('.tab-item-content').clientHeight:0;var tabItemOffsetTop=document.querySelector('.tab-item-content')?document.querySelector('.tab-item-content').offsetTop:0;var _navigationTabHeight=_this.navigationTab?_this.navigationTab.clientHeight:0;var navigationTabOffsetTop=_this.navigationTab?_this.navigationTab.offsetTop:0;if(!navFixed&&isScrollAreaUnEnd){_this.distance=navigationTabOffsetTop-tabItemOffsetTop;}_this.pipelineNavigation.style.height="".concat(tabItemHeight-_this.distance,"px");_this.pipelineNavigation.style.marginBottom="".concat(-(tabItemHeight-_this.distance-_navigationTabHeight),"px");}_this.checkedNav=checkedNav;_this.checkedTitle=checkedTitle;_this.setState({navFixed:navFixed,checkedNav:checkedNav,checkedTitle:checkedTitle,checkedIndex:checkedIndex,navPosition:_this.navPosition});// 对导航滚动防抖
if(_this.debounceTimer){clearTimeout(_this.debounceTimer);_this.debounceTimer=null;}_this.debounceTimer=setTimeout(function(){_this.updateNavPostion(checkedNav,checkedTitle);},60);});_defineProperty(_assertThisInitialized(_this),"navClick",function(item,index){__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].uploadTrack(_this.props,{sort:index});// 导航跳转
_this.setState({checkedNav:item.id,tabExpand:false,hideMask:true});if(typeof window!=='undefined'){// window.location.href = `#${item}`;
// 使用replace代替href跳转，避免在history中留下记录
window.location.replace("#".concat(item.id));}setTimeout(function(){var navigationBarHeight=window.navigationBarHeight>0?_this.props.navigationBarHeight:_this.props.navigationBarHeight;var scrollTop=(document.documentElement.scrollTop||document.body.scrollTop)-(_this.navigationContentHeight-1)-navigationBarHeight;window.scrollTo(0,scrollTop);},60);});_defineProperty(_assertThisInitialized(_this),"expandClick",function(){var navigationBarHeight=window.navigationBarHeight>0?_this.props.navigationBarHeight:_this.props.navigationBarHeight;var offsetTop=0;if(!_this.isAnchorInSwitchTab){offsetTop=window.document.querySelector('.navigation-container-static-wrap').offsetTop-navigationBarHeight;}else{var targetTabContainer=window.document.querySelectorAll('.tab-container')[_this.props.tabIndex];offsetTop=targetTabContainer.querySelector('.navigation-container-static-wrap').offsetTop;}!_this.state.navFixed&&window.scrollTo(0,offsetTop+1);var tabExpand=!_this.state.tabExpand;_this.setState({tabExpand:tabExpand,hideMask:false});setTimeout(function(){_this.setState({hideMask:!tabExpand});},250);});_defineProperty(_assertThisInitialized(_this),"updateNavPostion",function(checkedNav,checkedTitle){// 导航条切换选中后，调整当前导航到居中位置
var navigationBar,checkedNavItem,targetTabContainer;if(!_this.isAnchorInSwitchTab){navigationBar=document.querySelector('.navigation-container-fixed');checkedNavItem=document.querySelector(".navigation-container-fixed a[name=\"".concat(checkedTitle,"\"]"));// 当前选中的导航item
}else{targetTabContainer=window.document.querySelectorAll('.tab-container')[_this.props.tabIndex];navigationBar=targetTabContainer&&targetTabContainer.querySelector('.navigation-container-fixed');checkedNavItem=targetTabContainer&&targetTabContainer.querySelector(".navigation-container-fixed a[name=\"".concat(checkedTitle,"\"]"));// 当前选中的导航item
}if(!checkedNav||!checkedNavItem){// navigationBar.scrollTo(0, 0);
_this.scrollSmoothTo(navigationBar,0);// navigationBar.scroll({
//   top: 0,
//   left: 0,
//   behavior: 'smooth',
// });
return;}var navWidth=navigationBar.offsetWidth;// 导航栏宽度
var checkedItemOffsetLeft=checkedNavItem.offsetLeft;// 元素距离左边距离
var checkedItemWidth=checkedNavItem.offsetWidth;// 需要滚动的距离
var shouldUpdateScroll=checkedItemOffsetLeft-(navWidth/2-checkedItemWidth/2)-16;if(navigationBar.scrollWidth>navWidth){// 如果导航条可以滚动，执行滚动操作
// navigationBar.scrollTo(shouldUpdateScroll, 0);
// navigationBar.scroll({
//   top: 0,
//   left: shouldUpdateScroll,
//   behavior: 'smooth',
// });
_this.scrollSmoothTo(navigationBar,shouldUpdateScroll);}});_defineProperty(_assertThisInitialized(_this),"scrollSmoothTo",function(ele,position){if(!ele){return;}if(!window.requestAnimationFrame){window.requestAnimationFrame=function(callback,element){return setTimeout(callback,17);};}// 当前滚动高度
var scrollLeft=ele.scrollLeft;// 滚动step方法
var step=function step(){// 距离目标滚动距离
var distance=position-scrollLeft;// 目标滚动位置
scrollLeft=scrollLeft+distance/5;if(Math.abs(distance)<1){ele.scrollTo(position,0);}else{ele.scrollTo(scrollLeft,0);requestAnimationFrame(step);}};step();});_this.state={anchorIndex:__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getParams('anchorIndex'),checkedNav:'',checkedTitle:'',navFixed:false,tabExpand:false,hideMask:true,navList:[],navListFilter:[],navPosition:0,isAndroid:__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].isAndroid()};_this.navigationContentHeight=40;// 导航条的高度值
_this.debounceTimer='';_this.lastNavCompOffsetTop=0;_this.navPosition=0;_this.distance=0;_this.navigationTab=null;_this.isAnchorInSwitchTab=false;_this.t1=0;_this.t2=0;_this.scrollTimer=null;// 滚动事件监听
if(typeof window!=='undefined'){window.addEventListener('scroll',function(e){_this.handleBodyScroll();// this.isScrollStart();
});}return _this;}_createClass(PipelineNavigation,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.isAnchorInSwitchTab=this.props['customAttributes']["data-component-belong"]==='tab';var _this$state$anchorInd=this.state.anchorIndex,anchorIndex=_this$state$anchorInd===void 0?0:_this$state$anchorInd;var _this$props$navList=this.props.navList,navList=_this$props$navList===void 0?[]:_this$props$navList;var checkedTitle='',anchorComponent=null,componentId='';if(!this.isAnchorInSwitchTab){var navListFilter=[];navList.forEach(function(item){var findItem=navListFilter.find(function(value){return value.title===item.title;});if(!findItem){navListFilter.push(item);}});if(anchorIndex){checkedTitle=navList[anchorIndex]&&navList[anchorIndex].title;anchorComponent=navListFilter.find(function(item,index){return index==anchorIndex;});componentId=anchorComponent&&anchorComponent.id;}else{checkedTitle=navList[0]&&navList[0].title;}this.setState({navList:navList,navListFilter:navListFilter,checkedTitle:checkedTitle},function(){if(componentId){setTimeout(function(){var navigationBarHeight=window.navigationBarHeight>0?_this2.props.navigationBarHeight:_this2.props.navigationBarHeight;var scrollTo=document.querySelector("#".concat(componentId)).offsetTop-_this2.navigationContentHeight-navigationBarHeight;window.scrollTo({top:scrollTo,behavior:"smooth"});},600);}});}else{var targetTabContainer=window.document.querySelectorAll('.tab-container')[this.props.tabIndex];var currentNavList=[],_navListFilter=[];if(targetTabContainer){(function(){var productComList=targetTabContainer.querySelectorAll('.pipeline-product,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-communityArticle,.pipeline-pkRank,.pipeline-product-customize,.pipeline-productCollection,.pipeline-productGather,.pipeline-productLayout3,.pipeline-hotSellRankList')||[];var _loop3=function _loop3(i){var findItem=navList.find(function(item){return item.id===productComList[i].getAttribute('id');});if(findItem){currentNavList.push({id:findItem.id,title:findItem.title});}};for(var i=0;i<productComList.length;i+=1){_loop3(i);}currentNavList.forEach(function(item){var findItem=_navListFilter.find(function(value){return value.title===item.title;});if(!findItem){_navListFilter.push(item);}});_this2.setState({navList:currentNavList,navListFilter:_navListFilter,checkedTitle:navList[0]&&navList[0].title});})();}}document.querySelector('.nav-mask').addEventListener('touchmove',function(e){e.preventDefault();},false);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.isAnchorInSwitchTab&&nextProps.tabActive!=nextProps.tabIndex){this.navigationContainerStatic&&this.navigationContainerStatic.scroll({top:0,left:0});this.navigationContainerFixed&&this.navigationContainerFixed.scroll({top:0,left:0});this.setState({checkedNav:'',checkedTitle:''});}if(this.isAnchorInSwitchTab&&!nextProps.tabFixed&&this.state.navFixed){this.setState({navFixed:false});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.debounceTimer){clearTimeout(this.debounceTimer);this.debounceTimer=null;}}},{key:"render",value:function render(){var _this3=this;var baseConfig=this.props.config.baseConfig;var _this$props$osVersion=this.props.osVersion,osVersion=_this$props$osVersion===void 0?'':_this$props$osVersion;var _this$state=this.state,isAndroid=_this$state.isAndroid,navFixed=_this$state.navFixed,_this$state$navListFi=_this$state.navListFilter,navListFilter=_this$state$navListFi===void 0?[]:_this$state$navListFi,tabExpand=_this$state.tabExpand,hideMask=_this$state.hideMask,navPosition=_this$state.navPosition;var hasMore=navListFilter.length>3;var navigationBarHeight=window.navigationBarHeight>0?this.props.navigationBarHeight:this.props.navigationBarHeight;var navigationWrapperClass='pipeline-navigation';var maskClass=tabExpand?"nav-mask show":"nav-mask hide";var adaptive={};var position='sticky';if(!isAndroid&&(osVersion=='15.1'||osVersion=='15.2')){adaptive={position:navFixed?navPosition>0?'sticky':'fixed':'sticky',top:navPosition<=0?navigationBarHeight-1:navPosition+navigationBarHeight-1};}if(hideMask){maskClass+=' hide-mask';}if(this.isAnchorInSwitchTab&&!navFixed){position='static';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",_extends({className:navigationWrapperClass},this.props['customAttributes'],{ref:function ref(_ref4){return _this3.pipelineNavigation=_ref4;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:maskClass,onTouchEnd:this.expandClick}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(_ref){return _this3.navigationStaticRef=_ref;},className:"navigation-container-static-wrap"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"navigation-container-fixed-wrap",ref:function ref(_ref3){return _this3.navigationTab=_ref3;},style:_objectSpread({// position: position,
backgroundColor:this.props.backgroundColor,top:navPosition<=0?navigationBarHeight-2:navPosition+navigationBarHeight-2,zIndex:navPosition<=0?999:-1},adaptive)},tabExpand&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"all-classify",style:{color:baseConfig.fontColor,fontFamily:'PingFangSC-Regular'}},"\u5168\u90E8\u5206\u7C7B"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(_ref2){return _this3.navigationContainerFixed=_ref2;},className:"navigation-container-fixed ".concat(tabExpand?'expand ':'').concat(hasMore?'has-more':'not-more')},navListFilter.map(function(item,index){if(!_this3.state.navFixed){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getExposureData(_this3.props,{sort:index})),className:navListFilter.length<=4?"nav-item auto-width":"nav-item fixed-width",key:index,onClick:function onClick(){return _this3.navClick(item,index);},style:{color:_this3.state.checkedTitle===item.title?baseConfig.fontColor:baseConfig.fontColor,fontFamily:_this3.state.checkedTitle===item.title?'PingFangSC-Medium':'PingFangSC-Regular',opacity:_this3.state.checkedTitle===item.title?1:.7,fontWeight:__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].isAndroid()?_this3.state.checkedTitle===item.title?'500':'normal':'normal'}},item.title);}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_anchor_link_smooth_scroll___default.a,{key:"anchorlink_".concat(index),offset:function offset(){__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].uploadTrack(_this3.props,{sort:index});_this3.setState({tabExpand:false,hideMask:true});return navigationBarHeight+_this3.navigationContentHeight-1;},href:"#".concat(item.id),name:item.title,className:navListFilter.length<=4?"nav-item auto-width":"nav-item fixed-width",style:{color:_this3.state.checkedTitle===item.title?baseConfig.fontColor:baseConfig.fontColor,fontFamily:_this3.state.checkedTitle===item.title?'PingFangSC-Medium':'PingFangSC-Regular',opacity:_this3.state.checkedTitle===item.title?1:.7,fontWeight:__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].isAndroid()?_this3.state.checkedTitle===item.title?'500':'normal':'normal',textDecoration:'none'}},item.title);}})),hasMore&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"expand-bar",onClick:this.expandClick,style:{backgroundImage:"linear-gradient(to right, ".concat(hexColorToRgba(this.props.backgroundColor,0)," 0%, ").concat(hexColorToRgba(this.props.backgroundColor,1)," 30%, ").concat(hexColorToRgba(this.props.backgroundColor,1)," 100%)")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("svg",{className:"arrow ".concat(tabExpand?'on':''),width:"16px",height:"16px",viewBox:"0 0 16 16",version:"1.1",xmlns:"https://www.w3.org/2000/svg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("g",{id:"lego_open",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("g",{id:"",transform:"translate(2.500000, 5.000000)",fill:baseConfig.fontColor,fillRule:"nonzero"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("path",{d:"M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L5.5,4.793 L10.1464466,0.146446609 C10.320013,-0.0271197425 10.5894374,-0.0464048927 10.7843055,0.0885911588 L10.8535534,0.146446609 C11.0271197,0.320012961 11.0464049,0.589437362 10.9114088,0.784305503 L10.8535534,0.853553391 L5.85355339,5.85355339 C5.67998704,6.02711974 5.41056264,6.04640489 5.2156945,5.91140884 L5.14644661,5.85355339 L0.146446609,0.853553391 C-0.0488155365,0.658291245 -0.0488155365,0.341708755 0.146446609,0.146446609 Z",id:"\u8DEF\u5F84"})))))));}}]);return PipelineNavigation;}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);PipelineNavigation.propTypes={config:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineNavigation);

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__style_less__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */// 商品维度字段映射关系
var PRODUCT_GOODS_INFO_FIELDS_MAP={"id":"goods_id","goods_id":"goods_id","name":"goods_name","title":"goods_name","url":"url","image":"pic","price":"price","original_price":"official_price","recommend":"recommend","sell_point":"real_sales_num","real_gmv":"real_gmv_30","beltImg":"beltImg","unit_price_text":"unit_price_text","productImageCustom":"pic"};// 配色维度字段映射关系
var PRODUCT_STYLE_INFO_FIELDS_MAP={"id":"style_id","goods_id":"goods_id","name":"goods_name","title":"goods_name","url":"url","image":"pic","price":"price","original_price":"official_price","recommend":"recommend","sell_point":"real_sales_num_30","real_gmv":"real_gmv","beltImg":"beltImg","unit_price_text":"unit_price_text","productImageCustom":"pic"};// 乐高页面类目和类目新人补贴类目对应关系
var CategoryNewcomer={"鞋类":1,"服饰":2,"运动":3,"数码":4,"美妆":5,"潮玩":6,"配饰":7,"手表":8,"箱包":9,"酒水":10,"居家":12,"/":12,"母婴":13,"宠物":14,"营养保健":15,"电器":16,"个护":17,"生活服务":18};var custonLabels=['https://static.shihuocdn.cn/admin/files/20231214/34551b970dd81b98178802d32a0a113e.png','https://static.shihuocdn.cn/admin/files/20231214/d182a910641e15ab35010c70ed6b8435.png','https://static.shihuocdn.cn/admin/files/20231214/e0e61451038ad18153d03627c8d9e152.png','https://static.shihuocdn.cn/admin/files/20231214/f46f599a05df691f749b2b767427f0a4.png','https://static.shihuocdn.cn/admin/files/20231214/7a7183ee677fb38aa210c94f008598e5.png','https://static.shihuocdn.cn/admin/files/20231214/8027eea558b6615b6d94f96654a3b0d1.png','https://static.shihuocdn.cn/admin/files/20231214/a00823f49882862349eb0fd001654c4f.png','https://static.shihuocdn.cn/admin/files/20231214/0da687bf0139def6dbc69a1da20807d0.png','https://static.shihuocdn.cn/admin/files/20231214/dd92a4aa625e2d5faaa1f92b1548283a.png','http://static.shihuocdn.cn/admin/files/20231214/34551b970dd81b98178802d32a0a113e.png','http://static.shihuocdn.cn/admin/files/20231214/d182a910641e15ab35010c70ed6b8435.png','http://static.shihuocdn.cn/admin/files/20231214/e0e61451038ad18153d03627c8d9e152.png','http://static.shihuocdn.cn/admin/files/20231214/f46f599a05df691f749b2b767427f0a4.png','http://static.shihuocdn.cn/admin/files/20231214/7a7183ee677fb38aa210c94f008598e5.png','http://static.shihuocdn.cn/admin/files/20231214/8027eea558b6615b6d94f96654a3b0d1.png','http://static.shihuocdn.cn/admin/files/20231214/a00823f49882862349eb0fd001654c4f.png','http://static.shihuocdn.cn/admin/files/20231214/0da687bf0139def6dbc69a1da20807d0.png','http://static.shihuocdn.cn/admin/files/20231214/dd92a4aa625e2d5faaa1f92b1548283a.png'];var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;function sleep(ms){return new Promise(function(resolve){return setTimeout(resolve,ms);});}var PipelineProduct=/*#__PURE__*/function(_React$Component){_inherits(PipelineProduct,_React$Component);var _super=_createSuper(PipelineProduct);function PipelineProduct(props){var _this;_classCallCheck(this,PipelineProduct);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"onScroll",function(){var scrollTop=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop;var scrollHeight=document.documentElement.scrollHeight||document.body.scrollHeight;var height=document.documentElement.clientHeight||document.body.clientHeight;if(scrollTop+height>scrollHeight-500&&_this.hasNext&&!_this.isLoading){_this.isLoading=true;_this.page=_this.page+1;_this.dataSourcePageLoad(_this.page);}});_defineProperty(_assertThisInitialized(_this),"onPageScroll",function(event){var element=_this.goodsBodyRef;if(event.target===document&&element){var _this$isElementInView=_this.isElementInViewport(element),verticalVisible=_this$isElementInView.verticalVisible,visibilityRatio=_this$isElementInView.visibilityRatio;if(verticalVisible&&visibilityRatio>=0.5){// 进去可视区，切露出超过一半时，开始自动轮播
_this.inViewArea=true;_this.startScrolling();}else{// 停止轮播
_this.inViewArea=false;_this.stopScrolling();}}});_defineProperty(_assertThisInitialized(_this),"onScrollLayoutRow",function(){if(_this.props.config.cardBaseConfig.isAutoCarousel==='否'){return;}if(_this.initLayoutRowScroll){return;}_this.initLayoutRowScroll=true;var goodsBody=_this.goodsBodyRef;var progressBg=_this.carouselBgRef;var progress=_this.progressRef;if(goodsBody&&progressBg&&progress){var goodsScrollWidth=goodsBody.scrollWidth-goodsBody.clientWidth;var progressWidth=progressBg.clientWidth-progress.clientWidth;goodsBody.addEventListener('scroll',function(){if(goodsBody.scrollLeft>=goodsScrollWidth){_this.isScrollEnd=true;}var progressLeft=goodsBody.scrollLeft/goodsScrollWidth*progressWidth;progress.style.left=progressLeft+'px';});}_this.handleScrollEvent();});_defineProperty(_assertThisInitialized(_this),"setGoodsBodyScrollLeft",function(){var transformStyle=window.getComputedStyle(_this.goodsScrollRef).getPropertyValue('transform');var matrix=new window.WebKitCSSMatrix(transformStyle);var pausePosition=matrix.m41;var goodsScrollLeft=_this.goodsBodyRef.scrollLeft;if(pausePosition!=0){_this.goodsBodyRef.scrollTo({top:0,left:-pausePosition+goodsScrollLeft});}});_defineProperty(_assertThisInitialized(_this),"startScrolling",function(){if(_this.scrollState==='paused'){_this.scrollState='running';if(!_this.isScrollEnd){var animationDuration=_this.getAnimationDuration();var animation="scrollAnimation ".concat(animationDuration,"s linear 1s forwards");_this.goodsScrollRef.style.animation=animation;_this.scrollAnimation=requestAnimationFrame(_this.requestAnimationFrameScroll);}}});_defineProperty(_assertThisInitialized(_this),"stopScrolling",function(){_this.scrollState='paused';cancelAnimationFrame(_this.scrollAnimation);_this.scrollAnimation=null;_this.goodsScrollRef.style.animationPlayState='paused';if(_this.isScrollEnd){// 滚动到底部时，移除css animaton
_this.goodsBodyRef.scrollTo({top:0,left:_this.goodsScrollRef.clientWidth-window.screen.width});_this.goodsScrollRef.style.animation='none';}else{_this.setGoodsBodyScrollLeft();_this.goodsScrollRef.style.animation='none';}});_defineProperty(_assertThisInitialized(_this),"handleScrollEvent",function(){_this.goodsScrollRef.addEventListener('touchstart',function(){if(_this.goodsScrollRef.style.animationPlayState=='paused'||!_this.inViewArea){return;}_this.goodsScrollRef.style.animationPlayState='paused';_this.setGoodsBodyScrollLeft();_this.goodsScrollRef.style.animation='none';});_this.goodsScrollRef.addEventListener('touchend',function(){if(!_this.inViewArea){return;}if(_this.delayTimeout){clearTimeout(_this.delayTimeout);_this.delayTimeout=null;}_this.delayTimeout=setTimeout(function(){if(!_this.isScrollEnd){var animationDuration=_this.getAnimationDuration();var animation="scrollAnimation ".concat(animationDuration,"s linear 0s forwards");_this.goodsScrollRef.style.animation=animation;}},1500);});});_defineProperty(_assertThisInitialized(_this),"getScrollPosition",function(){if(!_this.isScrollEnd){var elementRect=_this.goodsScrollRef.getBoundingClientRect();var viewportWidth=window.innerWidth||document.documentElement.clientWidth;var rightEdgeVisible=elementRect.right<=viewportWidth;if(rightEdgeVisible){_this.isScrollEnd=true;}else{var progressWidth=_this.carouselBgRef.clientWidth-_this.progressRef.clientWidth;var progressLeft=(_this.goodsScrollRef.clientWidth-elementRect.right)/(_this.goodsScrollRef.clientWidth-viewportWidth)*progressWidth;_this.progressRef.style.left=progressLeft+'px';}return _this.isScrollEnd;}else{return true;}});_defineProperty(_assertThisInitialized(_this),"requestAnimationFrameScroll",function(){var isScrollEnd=_this.getScrollPosition();// 处理实时滚动位置的逻辑
if(!isScrollEnd){_this.scrollAnimation=requestAnimationFrame(_this.requestAnimationFrameScroll);}else{// 滚动到底了
cancelAnimationFrame(_this.scrollAnimation);_this.scrollAnimation=null;_this.goodsScrollRef.style.animationPlayState='paused';_this.goodsBodyRef.scrollTo({top:0,left:_this.goodsScrollRef.clientWidth-window.screen.width});_this.goodsScrollRef.style.animation='none';}});_defineProperty(_assertThisInitialized(_this),"getAnimationDuration",function(){var duration=_this.goodsScrollRef.clientWidth/(1316/40);return parseInt(duration);});_defineProperty(_assertThisInitialized(_this),"getIfNewUser",function(params){Object(__WEBPACK_IMPORTED_MODULE_38__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/activity/cate_new_status',method:"get",withCredentials:true,params:params}).then(function(res){var _res$data=res.data,status=_res$data.status,_res$data$data=_res$data.data,data=_res$data$data===void 0?{}:_res$data$data;if(status===0){_this.setState({isCateNewUser:data.cate_new_user});}});});_defineProperty(_assertThisInitialized(_this),"dataSourcePageLoad",function(){var page=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var _this$props$config=_this.props.config,baseConfig=_this$props$config.baseConfig,cardBaseConfig=_this$props$config.cardBaseConfig;var _this$props$isLastCom=_this.props.isLastComponent,isLastComponent=_this$props$isLastCom===void 0?false:_this$props$isLastCom;var _this$dataSourceConfi=_this.dataSourceConfig.dataConfig,searchId=_this$dataSourceConfi.searchId,totalNum=_this$dataSourceConfi.totalNum;var params={page:page,search_id:searchId};if(!isLastComponent){Object.assign(params,{page_size:totalNum});}var productStyle=baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle;var firstPageNum=0,addBaseNum=0;if(productStyle==='一行一个'){firstPageNum=6;addBaseNum=20;}else if(productStyle==='一行两个'){firstPageNum=6;addBaseNum=40;}else if(productStyle==='一行三个'){firstPageNum=12;addBaseNum=60;}else{firstPageNum=0;addBaseNum=0;}__WEBPACK_IMPORTED_MODULE_37_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/lego_data/page_list',method:"get",withCredentials:true,params:params}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){if(data.list&&data.list.length>0){var originalData=data.list;var list=_this.componentFieldsMap(originalData);if(_this.page<=1){_this.setState({productList:list,visiable:true,pageSize:Math.ceil((list.length-firstPageNum)/addBaseNum)+1},function(){if(_this.state.productList.length>0&&productStyle==='多个商品，自动适配'){_this.onScrollLayoutRow();}});}else{var listAll=[].concat(_toConsumableArray(_this.state.productList),_toConsumableArray(list));_this.setState({productList:listAll,visiable:true,pageSize:Math.ceil((listAll.length-firstPageNum)/addBaseNum)+1},function(){if(_this.state.productList.length>0&&productStyle==='多个商品，自动适配'){_this.onScrollLayoutRow();}});}_this.isLoading=false;}else{_this.hasNext=false;}}});});_defineProperty(_assertThisInitialized(_this),"componentFieldsMap",function(){var dataSource=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var fieldMap=_this.fieldMap||[];var mapResult=[];dataSource.length>0&&dataSource.forEach(function(item,index){mapResult[index]={id:'',name:'',useCustomName:false,recommendType:'推荐理由',recommend:'',shoppersLabel:'单位价格',shoppersLabelText:'',productImageCustom:'',markIconCustom:'',actionButtonCustom:''};for(var key in item){if(Object.hasOwnProperty.call(item,key)){var findKey=_this.findKey(_this.fieldMapTable,key);if(findKey){mapResult[index][findKey]=item[key];if(findKey==='sell_point'){var sell_point_str='';if(item[key]>9999){sell_point_str=item[key]/10000;sell_point_str=Math.floor(sell_point_str*10)/10+'w';}else{sell_point_str=String(item[key]);}mapResult[index]['sell_point_str']=sell_point_str;}if(_this.formType==='goods'){mapResult[index]['title']=item['goods_name'];}else{mapResult[index]['title']="".concat(item['goods_name']," ").concat(item['style_name']);}}}}});return mapResult;});_defineProperty(_assertThisInitialized(_this),"productBannerGo",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}// 商品banner跳转
if(url){var options={};var convertUrl=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false);}});_defineProperty(_assertThisInitialized(_this),"handleExpandMore",function(){var _this$state=_this.state,showPage=_this$state.showPage,pageSize=_this$state.pageSize;if(showPage===1){// 记录初识点击展开时页面的滚动位置
_this.currentPosition=document.documentElement.scrollTop;}if(showPage+1>pageSize){// 收起时回到最初记录的位置
window.scrollTo(0,_this.currentPosition);}_this.setState({showPage:showPage+1>pageSize?1:showPage+1});});_defineProperty(_assertThisInitialized(_this),"getDiscount",function(price,original_price){var discountRate=price/original_price;if(discountRate>1||isNaN(discountRate)||original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));return discountRate<10?"".concat(discountRate,"\u6298"):'';});_defineProperty(_assertThisInitialized(_this),"getClassRowColumn",function(className,rowItemNumber,length,index){var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
if(isFirstRow){className+=' first-row';}if(isLasthRow){className+=' lasth-row';}if(isFirstColumn){className+=' first-column';}if(isLastColumn){className+=' last-column';}return className;});_defineProperty(_assertThisInitialized(_this),"setSalesVisiable",function(){var _this$props$config$ca=_this.props.config.cardInfoConfig,cardInfoConfig=_this$props$config$ca===void 0?{}:_this$props$config$ca;if(cardInfoConfig.priceInfo==='无'&&cardInfoConfig.saleNum==='销量'&&_this.pipelineProductRef){var rowThreeItems=_this.pipelineProductRef.querySelectorAll('.row-three-item');if(rowThreeItems&&rowThreeItems.length>0){rowThreeItems.forEach(function(item,index){var goodsItemBottom=item.querySelector('.sale');var goodsItemPrice=item.querySelector('.price-container');var priceInfoW=goodsItemBottom?Math.floor(goodsItemBottom.clientWidth):0;var priceW=goodsItemPrice?Math.ceil(goodsItemPrice.clientWidth):0;var sales=item.querySelector('.num');if(sales){var salesW=Math.ceil(sales.clientWidth);if(salesW+priceW<priceInfoW){sales.style.visibility='visible';}}});}}});_defineProperty(_assertThisInitialized(_this),"renderPromotionSpareNewUserPriceView",function(price,type){var sparePrice=null;if(price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var sparePriceList=sparePrice.list;var typeSize={1:{symbol:'12px',price:'18px',decimal:'13px'},2:{symbol:'11px',price:'16px',decimal:'12px'},3:{symbol:'10px',price:'10px',decimal:'10px'}};_this.renderPriceLength=sparePriceList[0].length+(sparePriceList[1]?sparePriceList[1].length:0);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:'price'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].symbol||'10px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].price||'10px')}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].decimal||'10px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].symbol||'10px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},sparePrice.unit));}else{_this.renderPriceLength=0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),price);}});_defineProperty(_assertThisInitialized(_this),"renderPriceDom",function(){var price=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var priceDom=null,decimals='',suffix='';if(price>9999){price=parseFloat((price/10000).toFixed(1))+'万';}else{price=String(price);}if(price.indexOf('.')>=0){price=price.split('.');}if(Array.isArray(price)){if(price[1]&&price[1].indexOf('万')>=0){decimals=price[1].replace('万','');suffix='万';}else{decimals=price[1];}priceDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"price ".concat(_this.isAndroid?'android':'ios'," ").concat(_this.isIphone14ProMax?'iphone14ProMax':'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"symbol"},"\xA5"),price[0],".",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"decimals"},decimals),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"suffix"},suffix));}else{if(price.indexOf('万')>=0){price=price.replace('万','');priceDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"price ".concat(_this.isAndroid?'android':'ios'," ").concat(_this.isIphone14ProMax?'iphone14ProMax':'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"symbol"},"\xA5"),price,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"suffix"},"\u4E07"));}else{priceDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"price ".concat(_this.isAndroid?'android':'ios'," ").concat(_this.isIphone14ProMax?'iphone14ProMax':'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"symbol"},"\xA5"),price);}}return priceDom;});var _props$config$cardBas=props.config.cardBaseConfig,_cardBaseConfig=_props$config$cardBas===void 0?{}:_props$config$cardBas;var sortType=_cardBaseConfig.sortType;// 初始化商品id列表数据
var initList=sortType==='自定义排序'?props.config.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{title:item.name,url:item.productHref,image:item.productImageCustom||'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'});}):props.config.itemList.map(function(item){return{image:'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'// 空白占位图
};});_this.initList=initList;_this.state={productList:initList,isFold:false,showPage:1,pageSize:0,visiable:false,mask_show:false,noticeVersionShow:false,backCount:3,isCateNewUser:false,selectedItem:{},selectedIndex:'',showRectImg:false};_this.countDownInterVal=null;_this.sortTypeMap={'自定义排序':0,'销量':4,'GMV':6,'上新时间':8,'热度':18};_this.saleTypeMap={'默认':4,'近1天':10,'近7天':12,'近14天':14,'近30天':16},_this.formTable=false;_this.formType='';_this.page=1;_this.hasNext=true;_this.isLoading=false;_this.dataSourceConfig={};// 自定义表单数据源配置信息
_this.fieldMapTable={};// 当前选用的字段映射表
_this.initLayoutRowScroll=false;_this.speed=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].isAndroid()?0.5:1;// 滚动速度，每次增加的值
_this.scrollState='paused';_this.scrollAnimation=null;_this.isScrollEnd=false;_this.delayTimeout=null;_this.isAndroid=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].isAndroid();_this.isIphone14ProMax=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].isIphone14ProMax();_this.inViewArea=false;_this.currentPosition=0;_this.pipelineProductRef=null;_this.isIframe=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getParams('isIframe')=='1';_this.pageId=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getPageId();_this.top_id=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getParams('top_id');return _this;}_createClass(PipelineProduct,[{key:"componentDidMount",value:function componentDidMount(){var _this$props=this.props,_this$props$dataSourc=_this$props.dataSourceStr,dataSourceStr=_this$props$dataSourc===void 0?'':_this$props$dataSourc,_this$props$isLastCom2=_this$props.isLastComponent,isLastComponent=_this$props$isLastCom2===void 0?false:_this$props$isLastCom2;var _this$props$config$ca2=this.props.config.cardInfoConfig,cardInfoConfig=_this$props$config$ca2===void 0?{}:_this$props$config$ca2;if(cardInfoConfig&&cardInfoConfig.newUserPrice==='新人价'){var verticals=window.classifyName;this.getIfNewUser({verticals:CategoryNewcomer[verticals]});}var dataSource=[];if(dataSourceStr&&dataSourceStr.indexOf('dataSourceStr')<0){dataSource=JSON.parse(decodeURIComponent(dataSourceStr));}var componentId=this.props['customAttributes']['data-component-id'];var findOne=dataSource.find(function(item){return item.componentId==componentId;});var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,cardBaseConfig=_this$props$config2.cardBaseConfig;var productStyle=baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle;if(!findOne){// 通过手动配置导入的数据源 走默认逻辑
var productType=baseConfig.productType||cardBaseConfig&&cardBaseConfig.productType;if(productType==="商品id"||productType==="配色id"||productType==="skuId"){this.getProductListData();}if(productType==="商品集合id"||productType==="配色集合id"){this.getProductCollectionData();}}else{// 通过自定义表单导入的数据源 走分页加载逻辑
this.formTable=true;this.dataSourceConfig=findOne;this.fieldMap=findOne.dataConfig.fieldMap;this.formType=findOne.dataConfig.formType;this.fieldMapTable=this.formType==='goods'?PRODUCT_GOODS_INFO_FIELDS_MAP:PRODUCT_STYLE_INFO_FIELDS_MAP;this.dataSourcePageLoad();if(productStyle!=='一行一排'&&productStyle!=='多个商品，自动适配'&&isLastComponent){window.addEventListener('scroll',this.onScroll,true);}}if(productStyle==='多个商品，自动适配'&&cardBaseConfig.isAutoCarousel==='是'){window.addEventListener('scroll',this.onPageScroll,true);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(this.state.productList!==prevState.productList&&this.pipelineProductRef){// 数据已渲染完成
if(this.isIframe){__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].SyncComponentsSizeAsync(this.pipelineProductRef);}// this.pipelineProductRef.parentNode.style.minHeight = 0;
}}// 滚动监听
},{key:"getProductListData",value:function getProductListData(){var _this2=this;var itemList={};var _this$props$config3=this.props.config,baseConfig=_this$props$config3.baseConfig,cardBaseConfig=_this$props$config3.cardBaseConfig;var productType=baseConfig.productType||cardBaseConfig&&cardBaseConfig.productType;var sortType=baseConfig.sortType||cardBaseConfig&&cardBaseConfig.sortType;var dateRange=cardBaseConfig.dateRange;var shihuoSubsidy=baseConfig.shihuoSubsidy||cardBaseConfig&&cardBaseConfig.shihuoSubsidy;var productStyle=baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle;if(sortType==='自定义排序'){itemList=JSON.parse(JSON.stringify(this.initList));}else{itemList=this.props.config.itemList;}var itemDataObj={};var idList=itemList.map(function(item){if(item.id){itemDataObj[item.id]=item;}return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="",firstPageNum=0,addBaseNum=0;if(productStyle==='一行一个'){firstPageNum=6;addBaseNum=20;}else if(productStyle==='一行两个'){firstPageNum=6;addBaseNum=40;}else if(productStyle==='一行三个'){firstPageNum=12;addBaseNum=60;}else{firstPageNum=0;addBaseNum=0;}if(productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="配色id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="skuId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";}var sort_tag=0;if(sortType==='销量'){if(!dateRange||dateRange==='默认'){sort_tag=4;}else{sort_tag=this.saleTypeMap[dateRange];}}else{sort_tag=this.sortTypeMap[sortType];}Object(__WEBPACK_IMPORTED_MODULE_38__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:sort_tag,filter_subsidy:shihuoSubsidy==='是'?1:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;var notFoundList=res.data.data.NotFound||[];if(sortType==='自定义排序'){itemList.forEach(function(item,index){if(item.id=='0'){var _element;// 无渠道商品，插入列表中
var element=(_element={id:item.id,image:item.productImageCustom,price:item.productPrice,title:item.name,url:item.productHref,useCustomName:item.useCustomName},_defineProperty(_element,"title",item.name),_defineProperty(_element,"recommendType",item.recommendType),_defineProperty(_element,"shoppersLabel",item.shoppersLabel),_defineProperty(_element,"recommend",item.recommend),_defineProperty(_element,"pocket",'超值好物'),_defineProperty(_element,"custom_unitPrice",item.shoppersLabelText),_defineProperty(_element,"image",item.productImageCustom),_defineProperty(_element,"markIcon",item.markIconCustom||cardBaseConfig.markIcon),_defineProperty(_element,"custom_actionButton",item.actionButtonCustom),_element);list.splice(index,0,element);}});// 插入定制化内容
var rectImgs=0,showRectImg=false;itemList.forEach(function(product){try{var customItem=list.find(function(item){return item.id==product.id;});if(cardBaseConfig.sortType==='销量'){switch(cardBaseConfig.dateRange){case'近1天':customItem.sell_point=customItem.realSaleNum;customItem.sell_point_str=String(customItem.realSaleNum);break;case'近7天':customItem.sell_point=customItem.realSaleNum7;customItem.sell_point_str=String(customItem.realSaleNum7);break;case'近14天':customItem.sell_point=customItem.realSaleNum14;customItem.sell_point_str=String(customItem.realSaleNum14);break;case'近30天':customItem.sell_point=customItem.realSaleNum30;customItem.sell_point_str=String(customItem.realSaleNum30);break;default:break;}}if(customItem&&customItem.id!='0'){Object.assign(product,_objectSpread(_objectSpread({},customItem),{},{image:productType!=='商品id'?product.image&&product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2')<0?product.image:customItem.image:customItem.image,title:product.useCustomName?product.name:customItem.title,price:productType!=='商品id'?product.productPrice||customItem.price:customItem.price,recommend:product.recommendType==='自定义'?product.recommend:customItem.recommend,markIcon:product.markIconCustom||cardBaseConfig.markIcon,custom_actionButton:product.actionButtonCustom,url:product.productHref||customItem.url,custom_unitPrice:product.shoppersLabel==='自定义'?product.shoppersLabelText:customItem.unit_price_text,pocket:'超值好物'}));}if(product.rectImg){rectImgs++;}}catch(error){var customItem_beta=itemDataObj[product.id];if(customItem_beta){product.useCustomName=customItem_beta.useCustomName;product.title=customItem_beta.name;product.recommend=customItem_beta.recommend;}}});if(cardBaseConfig.showRectImg==='是'&&rectImgs==itemList.length){showRectImg=true;}if(notFoundList.length>0){// 删除 notFoundList 中存在的商品
itemList=itemList.filter(function(product){var notFound=notFoundList.find(function(item){return item==product.id;});return notFound?false:true;});}if(_this2.pageId==='17719878667110076'&&_this2.props['customAttributes']['data-component-id']=='pipeline-product-1772017119946'&&_this2.top_id){// 2026情人节会场指定页面，指定组件ID，顶部商品置顶（基于配色ID）
var topGoodsIdx=itemList.findIndex(function(item){return item.id==_this2.top_id;});if(topGoodsIdx>=0){var topGoods=itemList[topGoodsIdx];itemList.splice(topGoodsIdx,1);itemList.unshift(topGoods);}}_this2.setState({visiable:true,showRectImg:showRectImg,productList:itemList,pageSize:Math.ceil((itemList.length-firstPageNum)/addBaseNum)+1},/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(_this2.state.productList.length>0&&productStyle==='多个商品，自动适配'){_this2.onScrollLayoutRow();}if(!(cardBaseConfig.productCardType==='常规样式'&&productStyle==='一行三个')){_context.next=5;break;}_context.next=4;return sleep(100);case 4:_this2.setSalesVisiable();case 5:case"end":return _context.stop();}}},_callee);})));}else{// 非自定义排序，以实时抓取的数据顺序展示
itemList.forEach(function(item,index){if(item.id=='0'){var _element2;// 无渠道商品，插入列表中
var element=(_element2={id:item.id,image:item.productImageCustom,price:item.productPrice,title:item.name,url:item.productHref,useCustomName:item.useCustomName},_defineProperty(_element2,"title",item.name),_defineProperty(_element2,"recommendType",item.recommendType),_defineProperty(_element2,"shoppersLabel",item.shoppersLabel),_defineProperty(_element2,"recommend",item.recommend),_defineProperty(_element2,"pocket",'超值好物'),_defineProperty(_element2,"custom_unitPrice",item.shoppersLabelText),_defineProperty(_element2,"image",item.productImageCustom),_defineProperty(_element2,"markIcon",item.markIconCustom||cardBaseConfig.markIcon),_defineProperty(_element2,"custom_actionButton",item.actionButtonCustom),_element2);list.splice(index,0,element);}});// 插入定制化内容
var _rectImgs=0,_showRectImg=false;list.forEach(function(product){if(cardBaseConfig.sortType==='销量'){switch(cardBaseConfig.dateRange){case'近1天':product.sell_point=product.realSaleNum;product.sell_point_str=String(product.realSaleNum);break;case'近7天':product.sell_point=product.realSaleNum7;product.sell_point_str=String(product.realSaleNum7);break;case'近14天':product.sell_point=product.realSaleNum14;product.sell_point_str=String(product.realSaleNum14);break;case'近30天':product.sell_point=product.realSaleNum30;product.sell_point_str=String(product.realSaleNum30);break;default:break;}}try{var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem&&customItem.id!='0'){product.useCustomName=customItem.useCustomName;product.recommendType=customItem.recommendType;product.shoppersLabel=customItem.shoppersLabel;product.custom_unitPrice=customItem.shoppersLabelText;product.markIcon=customItem.markIconCustom||cardBaseConfig.markIcon;product.custom_actionButton=customItem.actionButtonCustom;product.title=customItem.useCustomName?customItem.name:product.title;product.recommend=customItem.recommendType==='自定义'?customItem.recommend:product.recommend;product.pocket='超值好物';// 商品维度，商品图片、价格、跳转地址均要实时获取
if(productType!=='商品id'){product.url=customItem.productHref||product.url;product.price=customItem.productPrice||product.price;product.image=customItem.productImageCustom||product.image;}}if(product.rectImg){_rectImgs++;}}catch(error){var customItem_beta=itemDataObj[product.id];if(customItem_beta){product.useCustomName=customItem_beta.useCustomName;product.title=customItem_beta.name;product.recommend=customItem_beta.recommend;}}});if(cardBaseConfig.showRectImg==='是'&&_rectImgs==list.length){_showRectImg=true;}if(_this2.pageId==='17719878667110076'&&_this2.props['customAttributes']['data-component-id']=='pipeline-product-1772017119946'&&_this2.top_id){// 2026情人节会场指定页面，指定组件ID，顶部商品置顶（基于配色ID）
var _topGoodsIdx=list.findIndex(function(item){return item.id==_this2.top_id;});if(_topGoodsIdx>=0){var _topGoods=list[_topGoodsIdx];list.splice(_topGoodsIdx,1);list.unshift(_topGoods);}}_this2.setState({visiable:true,productList:list,showRectImg:_showRectImg,pageSize:Math.ceil((list.length-firstPageNum)/addBaseNum)+1},/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(_this2.state.productList.length>0&&productStyle==='多个商品，自动适配'){_this2.onScrollLayoutRow();}if(!(cardBaseConfig.productCardType==='常规样式'&&productStyle==='一行三个')){_context2.next=5;break;}_context2.next=4;return sleep(100);case 4:_this2.setSalesVisiable();case 5:case"end":return _context2.stop();}}},_callee2);})));}_this2.isLoading=false;}});}},{key:"findKey",value:function findKey(obj,value){var compare=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(a,b){return a===b;};return Object.keys(obj).find(function(k){return compare(obj[k],value);});}},{key:"getProductCollectionData",value:function getProductCollectionData(){var _this3=this;var _this$props$config4=this.props.config,baseConfig=_this$props$config4.baseConfig,cardBaseConfig=_this$props$config4.cardBaseConfig,itemCollectionList=_this$props$config4.itemCollectionList;var itemList=itemCollectionList||[];var collectionIdList=[];var productType=baseConfig.productType||cardBaseConfig&&cardBaseConfig.productType;var productStyle=baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle;itemList.forEach(function(item){if(item.id){collectionIdList.push({id:Number(item.id),limit:isNaN(item.limit)?20:Number(item.limit),source:productType==='商品集合id'?1:2});}});var firstPageNum=0,addBaseNum=0;if(productStyle==='一行一个'){firstPageNum=6;addBaseNum=20;}else if(productStyle==='一行两个'){firstPageNum=6;addBaseNum=40;}else if(productStyle==='一行三个'){firstPageNum=12;addBaseNum=60;}else{firstPageNum=0;addBaseNum=0;}Object(__WEBPACK_IMPORTED_MODULE_38__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-goodssetapi/set/lego?token=7a08a813-faf1-03e5-d547-cf6bdd1c9ddb&client_name=theme',method:"post",withCredentials:true,data:{idList:collectionIdList}}).then(function(collectionRes){if(collectionRes.data.status===0){var collectionList=collectionRes.data.data||[];var productIdList=[];var reqUrl;if(productType==="商品集合id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";collectionList.forEach(function(collectionItem){var list=collectionItem.list||[];list.forEach(function(item){var id=item.goods_id;if(!productIdList.includes(id)){productIdList.push(id);}});});}else if(productType==="配色集合id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";collectionList.forEach(function(collectionItem){var list=collectionItem.list||[];list.forEach(function(item){var id=item.style_id;if(!productIdList.includes(id)){productIdList.push(id);}});});}var sortType=baseConfig.sortType||cardBaseConfig&&cardBaseConfig.sortType;var shihuoSubsidy=baseConfig.shihuoSubsidy||cardBaseConfig&&cardBaseConfig.shihuoSubsidy;Object(__WEBPACK_IMPORTED_MODULE_38__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:productIdList,sort_tag:_this3.sortTypeMap[sortType]||0,filter_subsidy:shihuoSubsidy==='是'?1:0,from:_this3.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;// 插入定制化内容
list.forEach(function(product){product.useCustomName=false;product.custom_title=product.name;product.custom_recommend=product.recommend;});_this3.setState({visiable:true,productList:list,pageSize:Math.ceil((list.length-firstPageNum)/addBaseNum)+1},function(){if(_this3.state.productList.length>0&&productStyle==='多个商品，自动适配'){_this3.onScrollLayoutRow();}});}});}});}//判断版本号
},{key:"appVersion",value:function appVersion(){return __WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].SHDiffVersion(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getVersion(),'7.28.0');// 前面版本号大
}},{key:"linkClick",value:function linkClick(){var _this$state2=this.state,isCateNewUser=_this$state2.isCateNewUser,selectedItem=_this$state2.selectedItem,selectetIndex=_this$state2.selectetIndex;if(isCateNewUser&&!this.appVersion()){if(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].isAndroid()){window.location.href='https://www.shihuo.cn/app3/download';}else{window.location.href='itms-apps://itunes.apple.com/app/id875177200?mt=8';}// window.Jockey.send("action", {
//   url: "https://www.shihuo.cn/webview/upgrade?v=2.2#",
// });
}else{if(this.countDownInterVal){clearInterval(this.countDownInterVal);this.countDownInterVal=null;this.setState({mask_show:false,noticeVersionShow:false,backCount:3});}this.handleItemClick(selectedItem,selectetIndex);}}//新人类目价
},{key:"handleItemPerNewUserClick",value:function handleItemPerNewUserClick(item,index){var _this4=this;var isCateNewUser=this.state.isCateNewUser;var _this$formatProductDa=this.formatProductData(this.props.config),_this$formatProductDa2=_this$formatProductDa.cardInfoConfig,cardInfoConfig=_this$formatProductDa2===void 0?{}:_this$formatProductDa2;if(cardInfoConfig.newUserPrice==='新人价'){if(!isCateNewUser||isCateNewUser&&!this.appVersion()){this.setState({mask_show:true,noticeVersionShow:true,selectedItem:item,selectetIndex:index// backCount: 3
});if(!isCateNewUser){clearInterval(this.countDownInterVal);this.countDownInterVal=setInterval(function(){if(_this4.state.backCount<=1){clearInterval(_this4.countDownInterVal);_this4.countDownInterVal=null;_this4.setState({mask_show:false,noticeVersionShow:false,backCount:3});_this4.handleItemClick(item,index);}else{_this4.setState({backCount:_this4.state.backCount-1});}},1000);}}else{this.handleItemClick(item,index);}}else{this.handleItemClick(item,index);}}// 关闭弹窗
},{key:"closeNewUserDialog",value:function closeNewUserDialog(){if(this.countDownInterVal){clearInterval(this.countDownInterVal);this.countDownInterVal=null;}this.setState({mask_show:false,noticeVersionShow:false,backCount:3});}},{key:"getTrackData",value:function getTrackData(item,index){var _this$props$config5=this.props.config,baseConfig=_this$props$config5.baseConfig,cardBaseConfig=_this$props$config5.cardBaseConfig;var options={title:baseConfig.title,type:baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle,sort:index,name:item.title};if(baseConfig.productType==="商品id"||cardBaseConfig&&cardBaseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}return options;}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:this.props,index:index});return;}var options=this.getTrackData(item,index);var convertUrl=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].convertHref(item.url);__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,convertUrl,convertUrl,options,item.id,this.props);}},{key:"formatProductData",value:// 因商品组件优化，调整了schema结构并增加了配置项，这里对老的商品组件数据进行格式化
function formatProductData(dataSource){if(dataSource.cardBaseConfig){if(dataSource.cardInfoConfig&&!dataSource.cardInfoConfig.priority||dataSource.promotionCardInfoConfig&&!dataSource.promotionCardInfoConfig.priority){var _dataSource$baseConfi=dataSource.baseConfig,_baseConfig=_dataSource$baseConfi===void 0?{}:_dataSource$baseConfi,_dataSource$cardBaseC=dataSource.cardBaseConfig,cardBaseConfig=_dataSource$cardBaseC===void 0?{}:_dataSource$cardBaseC,_dataSource$cardInfoC=dataSource.cardInfoConfig,cardInfoConfig=_dataSource$cardInfoC===void 0?{}:_dataSource$cardInfoC,_dataSource$promotion=dataSource.promotionCardInfoConfig,promotionCardInfoConfig=_dataSource$promotion===void 0?{}:_dataSource$promotion,_dataSource$itemList=dataSource.itemList,_itemList=_dataSource$itemList===void 0?[]:_dataSource$itemList,_dataSource$itemColle=dataSource.itemCollectionList,_itemCollectionList=_dataSource$itemColle===void 0?[]:_dataSource$itemColle,_dataSource$component=dataSource.componentSize,_componentSize=_dataSource$component===void 0?{}:_dataSource$component;var _result={baseConfig:_baseConfig,cardBaseConfig:cardBaseConfig,cardInfoConfig:{priceInfo:cardInfoConfig.priceInfo,saleNum:"销量",newUserPrice:"无",benefitLabel:"",slogen:cardInfoConfig.slogen,unitPrice:cardInfoConfig.unitPrice,priority:"优先展示推荐理由",unitPriceReplacePrice:cardInfoConfig.unitPriceReplacePrice},promotionCardInfoConfig:{priceInfo:promotionCardInfoConfig.priceInfo,saleNum:"销量",benefitLabel:"",slogen:promotionCardInfoConfig.slogen,unitPrice:promotionCardInfoConfig.unitPrice,benefit:promotionCardInfoConfig.benefit,priority:"优先展示推荐理由"},itemList:_itemList,itemCollectionList:_itemCollectionList,componentSize:_componentSize};for(var key in cardInfoConfig){if(Object.hasOwnProperty.call(cardInfoConfig,key)){var value=cardInfoConfig[key];if(key==='originPrice'&&typeof value==='boolean'){if(value){_result.cardInfoConfig.priceInfo='原价';}}else if(key==='discount'&&typeof value==='boolean'){if(value){_result.cardInfoConfig.priceInfo='折扣';}}else if(key==='saleNum'&&typeof value==='boolean'){if(value){if(cardBaseConfig.productStyle!=='多个商品，自动适配'){_result.cardInfoConfig.saleNum='销量';}else{_result.cardInfoConfig.priceInfo==='销量';}}else{if(cardBaseConfig.productStyle!=='多个商品，自动适配'){_result.cardInfoConfig.saleNum='无';}}}else if(key==='newUserPrice'&&typeof value==='boolean'){_result.cardInfoConfig.newUserPrice=value?'新人价':'无';}}}for(var _key in promotionCardInfoConfig){if(Object.hasOwnProperty.call(promotionCardInfoConfig,_key)){var _value=promotionCardInfoConfig[_key];if(_key==='saleNum'&&typeof _value==='boolean'){_result.promotionCardInfoConfig.saleNum=_value?'销量':'无';}}}if(typeof promotionCardInfoConfig.saleNum==='boolean'){_result.promotionCardInfoConfig.saleNum=promotionCardInfoConfig.saleNum===true?'销量':'无';}return _result;}return dataSource;};var baseConfig=dataSource.baseConfig,componentSize=dataSource.componentSize,itemCollectionList=dataSource.itemCollectionList,itemList=dataSource.itemList;var result={baseConfig:{showTitle:baseConfig.showTitle,showSubTitle:baseConfig.showSubTitle,addToNav:baseConfig.addToNav,showFoldBtn:false,title:baseConfig.title,subTitle:baseConfig.subTitle,titleColor:baseConfig.titleColor,priceColor:"",priceInfoColor:""},cardBaseConfig:{productStyle:baseConfig.productStyle,layout_1:baseConfig.layout_1,layout_2:baseConfig.layout_2,layout_3:baseConfig.layout_3,layout_row:baseConfig.layout_row,layout_adapt:{},productType:baseConfig.productType,sortType:baseConfig.sortType,shihuoSubsidy:baseConfig.shihuoSubsidy,imgUrl:baseConfig.imgUrl,imgLink:baseConfig.imgLink,priceIcon:baseConfig.priceIcon,productNameColor:"#333",productTagColor:"#C28A58",cardBackground:"",actionButton:""},cardInfoConfig:{originPrice:baseConfig.originPrice,discount:baseConfig.discount,saleNum:baseConfig.saleNum,markIcon:false,actionButton:false,slogen:baseConfig.slogen,unitPrice:baseConfig.unitPrice},componentSize:componentSize,itemCollectionList:itemCollectionList,itemList:itemList};return result;}},{key:"formatUnitPrice",value:// 格式化单位价
function formatUnitPrice(price,type){var match=price.match(/^([^\d]*)(\d+)(\.\d+)?(.*)$/);if(!match)return price;var _match=_slicedToArray(match,5),symbol=_match[1],integer=_match[2],_match$=_match[3],decimal=_match$===void 0?"":_match$,_match$2=_match[4],unit=_match$2===void 0?"":_match$2;var decimalFontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('10px');if(type==1||type==2){decimalFontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('16px')}},integer),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:decimalFontSize}},decimal,unit));}},{key:"render",value:function render(){var _this5=this;var _this$state3=this.state,showPage=_this$state3.showPage,pageSize=_this$state3.pageSize,visiable=_this$state3.visiable,mask_show=_this$state3.mask_show,noticeVersionShow=_this$state3.noticeVersionShow,backCount=_this$state3.backCount,isCateNewUser=_this$state3.isCateNewUser;var _this$formatProductDa3=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa3.baseConfig,cardBaseConfig=_this$formatProductDa3.cardBaseConfig;if(cardBaseConfig.productStyle==="一行一个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_1);}else if(cardBaseConfig.productStyle==="一行两个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_2);}else if(cardBaseConfig.productStyle==="一行三个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_3);}else if(cardBaseConfig.productStyle==="一行一排"){Object.assign(cardBaseConfig,cardBaseConfig.layout_row);}else if(cardBaseConfig.productStyle==="多个商品，自动适配"){Object.assign(cardBaseConfig,cardBaseConfig.layout_adapt);}if(!visiable){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",_extends({ref:function ref(_ref3){return _this5.pipelineProductRef=_ref3;},className:"pipeline-product",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:cardBaseConfig.moduleMarginTop>=0?"".concat(cardBaseConfig.moduleMarginTop,"px"):'0px',marginTop:cardBaseConfig.moduleMarginTop<0?"".concat(cardBaseConfig.moduleMarginTop,"px"):'0px',marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}));}var renderProduct=null;switch(cardBaseConfig.productCardType){case'常规样式':renderProduct=this.renderNormalType();break;case'促销样式':renderProduct=this.renderPromotionType();break;case'主题促销样式':renderProduct=this.renderThemeSaleType();break;default:renderProduct=this.renderNormalType();break;}var _utils$getAdaptImageS=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getAdaptImageSize(cardBaseConfig.titleImageSize),width=_utils$getAdaptImageS.width,height=_utils$getAdaptImageS.height;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",_extends({ref:function ref(_ref4){return _this5.pipelineProductRef=_ref4;},className:"pipeline-product",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:cardBaseConfig.moduleMarginTop>=0?"".concat(cardBaseConfig.moduleMarginTop,"px"):'0px',marginTop:cardBaseConfig.moduleMarginTop<0?"".concat(cardBaseConfig.moduleMarginTop,"px"):'0px',marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),(baseConfig.showTitle&&baseConfig.title||baseConfig.showSubTitle&&baseConfig.subTitle)&&cardBaseConfig.productStyle!=="一行一排"&&cardBaseConfig.productStyle!=="多个商品，自动适配"&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-area"},baseConfig.showTitle&&baseConfig.title&&['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title.slice(0,16)),baseConfig.showSubTitle&&baseConfig.subTitle&&['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sub-title",style:{color:baseConfig.titleColor},dangerouslySetInnerHTML:{__html:baseConfig.subTitle}})),cardBaseConfig.imgUrl&&['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"product-banner",onClick:this.productBannerGo.bind(this,cardBaseConfig.imgLink),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.imgUrl,this.props.webpSupport),alt:"",style:{width:width,height:height}}),renderProduct,baseConfig.showFoldBtn&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"fold-btn",style:{color:baseConfig.titleColor,borderColor:baseConfig.titleColor?this.hexColorToRgba(baseConfig.titleColor,0.8):baseConfig.titleColor},onClick:function onClick(){return _this5.handleExpandMore();}},showPage>=pageSize?'收起':'展开更多',showPage>=pageSize?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("svg",{t:"1664182775303",className:"icon up",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2222"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("path",{d:"M169.344 694.656a32 32 0 0 0 40.832 3.648l4.48-3.648L512 397.248l297.344 297.408a32 32 0 0 0 40.832 3.648l4.48-3.648a32 32 0 0 0 3.648-40.832l-3.648-4.48-320-320a32 32 0 0 0-40.832-3.648l-4.48 3.648-320 320a32 32 0 0 0 0 45.312z","p-id":"2223",fill:baseConfig.titleColor})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("svg",{t:"1664182701343",className:"icon down",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2002"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("path",{d:"M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z","p-id":"2003",fill:baseConfig.titleColor}))),mask_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"pipeline-product-mask"}),noticeVersionShow&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:["pipeline-product-notice-version","".concat(!isCateNewUser?"pipeline-product-notice-version2":null)].join(" ")},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"pipeline-product-notice-version-title"},!isCateNewUser?"\u6D3B\u52A8\u4EC5\u9650".concat(window.classifyName,"\u65B0\u7528\u6237"):'当前版本过低'),!isCateNewUser?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"pipeline-product-notice-version-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",null,"\u62B1\u6B49\uFF0C\u4F60\u65E0\u6CD5\u4EAB\u53D7\u65B0\u4EBA\u4EF7"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",null,"\u53EF\u7EE7\u7EED\u67E5\u770B\u5168\u7F51\u5E95\u4EF7")):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"pipeline-product-notice-version-content"},"\u8BF7\u5347\u7EA7\u6700\u65B0\u7248\u672C\uFF0C\u4EAB\u53D7\u8865\u8D34"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"pipeline-product-notice-version-button",onClick:this.linkClick.bind(this)},!isCateNewUser?"\u53BB\u67E5\u770B\uFF08".concat(backCount,"s\uFF09"):'去升级'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221226/ceab8c8de1a6373675898799f28e1e0d.png",alt:"",className:"pipeline-product-notice-version-close",onClick:this.closeNewUserDialog.bind(this)})));}},{key:"rederSparePriceView",value:function rederSparePriceView(baseConfig,price,type){var unitPriceReplacePrice=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var sparePrice=null;if(price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var typeSize={1:{symbol:'12px',price:'18px',decimal:'13px'},2:{symbol:'11px',price:'16px',decimal:'12px'},3:{symbol:'10px',price:'15px',decimal:'11px'}};var sparePriceList=sparePrice.list;this.renderPriceLength=sparePriceList[0].length+(sparePriceList[1]?sparePriceList[1].length:0);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].symbol),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].price)}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].decimal),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].symbol),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},sparePrice.unit));}else{this.renderPriceLength=0;var priceStyle={color:baseConfig.priceColor};var rmbStyle={};if(unitPriceReplacePrice){if(type===1){priceStyle.fontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('16px');rmbStyle.fontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('11px');}else if(type===2){priceStyle.fontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('17px');rmbStyle.fontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');}else if(type===3){priceStyle.fontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('14px');rmbStyle.fontSize=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('10px');}price=this.formatUnitPrice(String(price),type);}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price",style:priceStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon",style:rmbStyle},"\xA5"),price);}}},{key:"rederSparePriceOneLineView",value:function rederSparePriceOneLineView(baseConfig,price){var sparePrice=null;if(price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var sparePriceList=sparePrice.list;this.renderPriceLength=sparePriceList[0].length+(sparePriceList[1]?sparePriceList[1].length:0);var pricefontSize='12px';if(sparePriceList[0]>100){pricefontSize='11px';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(pricefontSize)}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(pricefontSize)}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(pricefontSize)}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(pricefontSize)}},sparePrice.unit));}else{this.renderPriceLength=0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:String(parseFloat(price)).length>5?'long':'small'},price&&parseFloat(price)));}}},{key:"renderPromotionSparePriceView",value:function renderPromotionSparePriceView(price,type){var sparePrice=null;if(price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var sparePriceList=sparePrice.list;var smallSize=sparePriceList[0]>100&&sparePrice.unit&&sparePriceList.length>1;var minSize=sparePriceList[0]>1000&&sparePrice.unit&&sparePriceList.length>1;var typeSize={1:{symbol:'12px',price:'18px',decimal:'13px'},2:{symbol:smallSize?'10px':'10px',price:smallSize?'10px':'15px',decimal:smallSize?'10px':'11px'},3:{symbol:minSize?'8px':smallSize?'9px':'10px',price:minSize?'8px':smallSize?'9px':'10px',decimal:minSize?'8px':smallSize?'9px':'10px'}};this.renderPriceLength=sparePriceList[0].length+(sparePriceList[1]?sparePriceList[1].length:0);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:'price small'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].symbol||'8px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].price||'8px')}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].decimal||'8px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(typeSize[type].symbol||'8px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('2px')}},sparePrice.unit));}else{this.renderPriceLength=0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:String(parseFloat(price)).length>=5?'price large':'price small'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:String(parseFloat(price)).length>=5?'large':'small'},price));}}},{key:"rederLayoutRowPromotionOneLineView",value:function rederLayoutRowPromotionOneLineView(price,type){var sparePrice=null;if(price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var smallSize=price>1000000&&sparePrice.unit!='亿';var sparePriceList=sparePrice.list;this.renderPriceLength=sparePriceList[0].length+(sparePriceList[1]?sparePriceList[1].length:0);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(smallSize?'7px':'9px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(smallSize?'7px':'9px')}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(smallSize?'7px':'9px')}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])(smallSize?'7px':'9px')}},sparePrice.unit));}else{this.renderPriceLength=0;if(type=='new'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:String(parseFloat(price)).length>=5?'goods-item-price large':'goods-item-price small'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:String(parseFloat(price)).length>=5?'large':'small'},price&&parseFloat(price)));}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:String(parseFloat(price)).length>=5?'large':'small'},price&&parseFloat(price)));}}// 优先展示单位价
},{key:"renderPriceView",value:function renderPriceView(item,baseConfig,cardInfoConfig,type){var price=item.price,unit_price_text=item.unit_price_text,custom_unitPrice=item.custom_unitPrice,shoppersLabel=item.shoppersLabel;var unitPriceReplacePrice=cardInfoConfig.unitPriceReplacePrice,newUserPrice=cardInfoConfig.newUserPrice;var priceView=null,showTotalPrice=true;if(unitPriceReplacePrice){// 商品价格优先展示为单位价
if(shoppersLabel==='单位价格'){priceView=this.rederSparePriceView(baseConfig,unit_price_text?unit_price_text.replace('¥',''):price,type,true);showTotalPrice=Boolean(unit_price_text);}else{priceView=this.rederSparePriceView(baseConfig,custom_unitPrice?custom_unitPrice.replace('¥',''):price,type,true);showTotalPrice=Boolean(custom_unitPrice);}if(type===1){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"unitPrice-priority"},priceView,showTotalPrice&&price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"total-price",style:{color:'#FF6000'}},"\u603B\u4EF7\xA5",price));}else if(type===2){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"unitPrice-priority"},priceView);}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"unitPrice-priority"},priceView);}}else{// 商品价格正常展示
if((price||price===0)&&(!newUserPrice||newUserPrice==='无')){priceView=this.rederSparePriceView(baseConfig,price,type);}else{priceView=null;}return priceView;}}// 常规卡片一行一
},{key:"renderNorMalLayout_1",value:function renderNorMalLayout_1(){var _this6=this;var baseConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cardBaseConfig=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var cardInfoConfig=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var item=arguments.length>3?arguments[3]:undefined;var index=arguments.length>4?arguments[4]:undefined;var discountRate=arguments.length>5?arguments[5]:undefined;var itemStyle=arguments.length>6?arguments[6]:undefined;// 三个展示都存在时，隐藏销量
if(cardInfoConfig.priceInfo!=='无'&&cardInfoConfig.saleNum==='销量'&&cardInfoConfig.priceIcon){cardInfoConfig.saleNum='无';}var labelOrRecommend=null;if(cardInfoConfig.slogen){if(cardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=this.renderLabels(item.labels);}else{labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.labels&&item.labels.length>0){labelOrRecommend=this.renderLabels(item.labels);}else{labelOrRecommend=item.title&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var options=this.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this6.props.exp&&_this6.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(this.props,options)),className:"product-item row-one-item",key:index,style:itemStyle,onClick:this.handleItemPerNewUserClick.bind(this,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('108px'),height:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('108px'),effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:108,height:108}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.image,this.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardInfoConfig.slogen&&cardInfoConfig.unitPrice&&!cardInfoConfig.unitPriceReplacePrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,!cardInfoConfig.unitPriceReplacePrice&&item.shoppersLabel==='单位价格'&&cardInfoConfig.unitPrice&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),!cardInfoConfig.unitPriceReplacePrice&&item.shoppersLabel==='自定义'&&cardInfoConfig.unitPrice&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,this.props.webpSupport)}),this.renderPriceView(item,baseConfig,cardInfoConfig,1),cardInfoConfig.priceInfo==='原价'&&!cardInfoConfig.unitPriceReplacePrice&&item.original_price>item.price&&item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),cardInfoConfig.priceInfo==='折扣'&&discountRate!=10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298")),cardInfoConfig.saleNum==='销量'&&item.id&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,this.props.webpSupport)}),(item.custom_actionButton||cardBaseConfig.actionButton)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"action-button",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.custom_actionButton||cardBaseConfig.actionButton,this.props.webpSupport,'card')}));}// 常规卡片一行二
},{key:"renderNorMalLayout_2",value:function renderNorMalLayout_2(){var _this7=this;var baseConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cardBaseConfig=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var cardInfoConfig=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var item=arguments.length>3?arguments[3]:undefined;var index=arguments.length>4?arguments[4]:undefined;var discountRate=arguments.length>5?arguments[5]:undefined;var itemStyle=arguments.length>6?arguments[6]:undefined;var showRectImg=this.state.showRectImg;// 四个展示都存在是，隐藏销量
if(cardInfoConfig.priceInfo!=='无'&&cardInfoConfig.saleNum==='销量'&&cardBaseConfig.priceIcon){cardInfoConfig.saleNum='无';}// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin))/2-8;var itemClass='product-item row-two-item';if(showRectImg){itemClass+=' category-shoes';}if(cardInfoConfig.slogen||cardInfoConfig.unitPrice){itemClass+=' has-benefit';}else{itemClass+=' no-benefit';}var labelOrRecommend=null;if(cardInfoConfig.slogen){if(cardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=this.renderLabels(item.labels);}else{labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.labels&&item.labels.length>0){labelOrRecommend=this.renderLabels(item.labels);}else{labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}if(cardInfoConfig.unitPrice&&cardInfoConfig.unitPriceReplacePrice&&item.unit_price_text){// 设置优先展示单位价格时，不展示标签和推荐语
labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:'#FF6000'}},"\u603B\u4EF7\xA5",item.price);}var options=this.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this7.props.exp&&_this7.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(this.props,options)),className:itemClass,key:index,style:itemStyle,onClick:this.handleItemPerNewUserClick.bind(this,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showRectImg?'product-img-panel shoes':'product-img-panel',style:{marginTop:4,marginBottom:4,paddingLeft:4,paddingRight:4}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:!showRectImg?productImgWidth:'',className:"img",effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:productImgWidth,height:productImgWidth}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(!showRectImg?item.image:item.rectImg,this.props.webpSupport,'card')}),item.beltImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.beltImg,this.props.webpSupport,'card'),alt:"",className:"beltImg"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"mask"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardInfoConfig.slogen&&cardInfoConfig.unitPrice&&!cardInfoConfig.unitPriceReplacePrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,!cardInfoConfig.unitPriceReplacePrice&&item.shoppersLabel==='单位价格'&&cardInfoConfig.unitPrice&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),!cardInfoConfig.unitPriceReplacePrice&&item.shoppersLabel==='自定义'&&cardInfoConfig.unitPrice&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,this.props.webpSupport)}),this.renderPriceView(item,baseConfig,cardInfoConfig,2),!cardInfoConfig.unitPriceReplacePrice&&cardInfoConfig.priceInfo==='原价'&&item.original_price>0&&item.original_price>item.price&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(this.renderPriceLength,item.original_price,13)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),!cardInfoConfig.unitPriceReplacePrice&&cardInfoConfig.priceInfo==='折扣'&&discountRate!=10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298")),cardInfoConfig.saleNum==='销量'&&item.id&&item.sell_point>0&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(this.renderPriceLength,item.sell_point_str,10)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,this.props.webpSupport)}));}// 常规卡片一行三
},{key:"renderNorMalLayout_3",value:function renderNorMalLayout_3(){var _this8=this;var baseConfig=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cardBaseConfig=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var cardInfoConfig=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var item=arguments.length>3?arguments[3]:undefined;var index=arguments.length>4?arguments[4]:undefined;var discountRate=arguments.length>5?arguments[5]:undefined;var itemStyle=arguments.length>6?arguments[6]:undefined;var showRectImg=this.state.showRectImg;// 四个展示都存在是，隐藏销量
if((cardBaseConfig.priceIcon||cardInfoConfig.priceInfo!=='无')&&cardInfoConfig.saleNum==='销量'){cardInfoConfig.saleNum='无';}// 计算一行三商品图片宽度
var productImgWidth=(bodyWidth-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin)*2)/3-8;var itemClass='product-item row-three-item';if(showRectImg){itemClass+=' category-shoes';}if(cardInfoConfig.slogen||cardInfoConfig.unitPrice){itemClass+=' has-benefit';}else{itemClass+=' no-benefit';}var labelOrRecommend=null;if(cardInfoConfig.slogen){if(cardInfoConfig.priority==='优先展示配色'){if(item.style_name){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.style_name);}else{if(item.recommend&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=this.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}else if(cardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=this.renderLabels(item.labels);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=this.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}if(cardInfoConfig.unitPrice&&cardInfoConfig.unitPriceReplacePrice&&item.unit_price_text){// 设置优先展示单位价格时，不展示标签和推荐语
labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:'#FF6000'}},"\u603B\u4EF7\xA5",item.price);}var options=this.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this8.props.exp&&_this8.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(this.props,options)),className:itemClass,key:index,style:itemStyle,onClick:this.handleItemPerNewUserClick.bind(this,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showRectImg?'product-img-panel shoes':'product-img-panel'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:!showRectImg?productImgWidth:'',className:"img",effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:productImgWidth,height:productImgWidth}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(!showRectImg?item.image:item.rectImg,this.props.webpSupport,'card')}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"mask"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].isAndroid()?'product-info android':'product-info'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardInfoConfig.slogen&&cardInfoConfig.unitPrice&&!cardInfoConfig.unitPriceReplacePrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,!cardInfoConfig.unitPriceReplacePrice&&item.shoppersLabel==='单位价格'&&cardInfoConfig.unitPrice&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),!cardInfoConfig.unitPriceReplacePrice&&item.shoppersLabel==='自定义'&&cardInfoConfig.unitPrice&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,this.props.webpSupport)}),this.renderPriceView(item,baseConfig,cardInfoConfig,3),!cardInfoConfig.unitPriceReplacePrice&&!cardBaseConfig.priceIcon&&cardInfoConfig.priceInfo==='原价'&&item.original_price>item.price&&item.original_price>0&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(this.renderPriceLength,item.original_price,9)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),!cardInfoConfig.unitPriceReplacePrice&&!cardBaseConfig.priceIcon&&cardInfoConfig.priceInfo==='折扣'&&discountRate!=10&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(this.renderPriceLength,discountRate,8)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298")),!cardBaseConfig.priceIcon&&cardInfoConfig.saleNum==='销量'&&cardInfoConfig.priceInfo==='无'&&item.sell_point>0&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(this.renderPriceLength,item.sell_point_str,5)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,this.props.webpSupport)}));}// 常规样式
},{key:"renderNormalType",value:function renderNormalType(){var _this9=this;var _this$state4=this.state,_this$state4$productL=_this$state4.productList,productList=_this$state4$productL===void 0?[]:_this$state4$productL,showPage=_this$state4.showPage,showRectImg=_this$state4.showRectImg;var _this$formatProductDa4=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa4.baseConfig,cardBaseConfig=_this$formatProductDa4.cardBaseConfig,_this$formatProductDa5=_this$formatProductDa4.cardInfoConfig,cardInfoConfig=_this$formatProductDa5===void 0?{}:_this$formatProductDa5;// 判断不同布局方式下的间距取值
if(cardBaseConfig.productStyle==="一行一个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_1);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,6):productList.slice(0,6+20*(showPage-1)):productList;}else if(cardBaseConfig.productStyle==="一行两个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_2);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,6):productList.slice(0,6+40*(showPage-1)):productList;}else if(cardBaseConfig.productStyle==="一行三个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_3);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,12):productList.slice(0,12+60*(showPage-1)):productList;}else if(cardBaseConfig.productStyle==="一行一排"){Object.assign(cardBaseConfig,cardBaseConfig.layout_row);productList=productList;}else if(cardBaseConfig.productStyle==="多个商品，自动适配"){Object.assign(cardBaseConfig,cardBaseConfig.layout_adapt);productList=productList;}// 转为数字处理，后续参与计算
cardBaseConfig.itemMargin=isNaN(Number(cardBaseConfig.itemMargin))?0:Number(cardBaseConfig.itemMargin);if(['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-list product-list-normal"},productList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(cardBaseConfig.productStyle==="一行一个"){rowItemNumber=1;}else if(cardBaseConfig.productStyle==="一行两个"){rowItemNumber=2;}else if(cardBaseConfig.productStyle==="一行三个"){rowItemNumber=3;}// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*cardBaseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginBottom:isLasthRow?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginLeft:isFirstColumn?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginRight:isLastColumn?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),backgroundColor:cardBaseConfig.cardBackgroundColor};if(!cardBaseConfig.cardBackgroundColor){cardBaseConfig.cardBackground&&Object.assign(itemStyle,{backgroundImage:"url(".concat(cardBaseConfig.cardBackground,")"),backgroundSize:"100% 100%",backgroundColor:"transparent",backgroundRepeat:"no-repeat",borderRadius:"inherit"});}else{Object.assign(itemStyle,{backgroundColor:cardBaseConfig.cardBackgroundColor});}var productItem;if(cardBaseConfig.productStyle==="一行一个"){productItem=_this9.renderNorMalLayout_1(baseConfig,cardBaseConfig,cardInfoConfig,item,index,discountRate,itemStyle);}else if(cardBaseConfig.productStyle==="一行两个"){productItem=_this9.renderNorMalLayout_2(baseConfig,cardBaseConfig,cardInfoConfig,item,index,discountRate,itemStyle);}else if(cardBaseConfig.productStyle==="一行三个"){productItem=_this9.renderNorMalLayout_3(baseConfig,cardBaseConfig,cardInfoConfig,item,index,discountRate,itemStyle);}return productItem;}));}else if(cardBaseConfig.productStyle==='一行一排'){return this.renderLayoutRowNormal();}else{return this.renderLayoutAdaptNormal();}}// 促销样式
},{key:"renderPromotionType",value:function renderPromotionType(){var _this10=this;var _this$state5=this.state,_this$state5$productL=_this$state5.productList,productList=_this$state5$productL===void 0?[]:_this$state5$productL,showPage=_this$state5.showPage,showRectImg=_this$state5.showRectImg;var _this$formatProductDa6=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa6.baseConfig,cardBaseConfig=_this$formatProductDa6.cardBaseConfig,_this$formatProductDa7=_this$formatProductDa6.cardInfoConfig,cardInfoConfig=_this$formatProductDa7===void 0?{}:_this$formatProductDa7,_this$formatProductDa8=_this$formatProductDa6.promotionCardInfoConfig,promotionCardInfoConfig=_this$formatProductDa8===void 0?{}:_this$formatProductDa8;var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;var itemMargin=0;// 判断不同布局方式下的间距取值
if(cardBaseConfig.productStyle==="一行一个"){itemMargin=8;Object.assign(cardBaseConfig,cardBaseConfig.layout_1);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,6):productList.slice(0,6+20*(showPage-1)):productList;}else if(cardBaseConfig.productStyle==="一行两个"){itemMargin=8;Object.assign(cardBaseConfig,cardBaseConfig.layout_2);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,6):productList.slice(0,6+40*(showPage-1)):productList;}else if(cardBaseConfig.productStyle==="一行三个"){itemMargin=4;Object.assign(cardBaseConfig,cardBaseConfig.layout_3);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,12):productList.slice(0,12+60*(showPage-1)):productList;}else if(cardBaseConfig.productStyle==="一行一排"){itemMargin=4;Object.assign(cardBaseConfig,cardBaseConfig.layout_row);productList=productList;}else if(cardBaseConfig.productStyle==="多个商品，自动适配"){itemMargin=4;Object.assign(cardBaseConfig,cardBaseConfig.layout_adapt);productList=productList;}// 转为数字处理，后续参与计算
cardBaseConfig.itemMargin=itemMargin;if(['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-list product-list-promotion"},productList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(cardBaseConfig.productStyle==="一行一个"){rowItemNumber=1;}else if(cardBaseConfig.productStyle==="一行两个"){rowItemNumber=2;}else if(cardBaseConfig.productStyle==="一行三个"){rowItemNumber=3;}// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));// 直降计算
var plummet=0;if(item.original_price&&item.original_price>item.price){plummet=Math.floor(item.original_price-item.price);}// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 是否展示销量
var showSaleNum=promotionCardInfoConfig.saleNum==='销量'&&item.sell_point>0;// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*cardBaseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginBottom:isLasthRow?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginLeft:isFirstColumn?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginRight:isLastColumn?"0":"".concat(cardBaseConfig.itemMargin/2,"px")};var productItem;if(cardBaseConfig.productStyle==="一行一个"){var labelOrRecommend=null;if(promotionCardInfoConfig.slogen){if(promotionCardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=_this10.renderLabels(item.labels);}else{labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.labels&&item.labels.length>0){labelOrRecommend=_this10.renderLabels(item.labels);}else{labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var options=_this10.getTrackData(item,index);productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this10.props.exp&&_this10.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this10.props,options)),className:"product-item row-one-item",key:index,style:itemStyle,onClick:_this10.handleItemPerNewUserClick.bind(_this10,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('108px'),height:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('108px'),effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:108,height:108}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.image,_this10.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:promotionCardInfoConfig.slogen&&promotionCardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,promotionCardInfoConfig.unitPrice&&item.shoppersLabel==='单位价格'&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),promotionCardInfoConfig.unitPrice&&item.shoppersLabel==='自定义'&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice),!promotionCardInfoConfig.slogen&&!promotionCardInfoConfig.unitPrice&&promotionCardInfoConfig.saleNum==='销量'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sale-num"},item.sell_point>0?"".concat(item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"):'火热抢购中')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,_this10.props.webpSupport)}),item.price?(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this10.renderPromotionSparePriceView(item.price,1):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price small"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"small"},"0")),cardInfoConfig.newUserPrice==='新人价'&&_this10.renderPromotionSparePriceView(item.new_user_price||item.price,1),promotionCardInfoConfig.priceInfo==='原价'&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this10.renderPriceLength,item.original_price,12)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"origin-price",style:{textDecoration:item.original_price>0&&item.original_price!=item.price?'line-through':'none'}},item.original_price&&item.original_price>0&&item.original_price!=item.price?"\xA5".concat(item.original_price):'爆款好价'),promotionCardInfoConfig.priceInfo==='折扣'&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this10.renderPriceLength,discountRate,11)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"discount"},discountRate!=10?"".concat(discountRate,"\u6298"):'爆款好价'),promotionCardInfoConfig.priceInfo==='直降'&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this10.renderPriceLength,plummet,11)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"plummet"},plummet>0?"\u76F4\u964D\xA5".concat(plummet):'爆款好价')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"action-btn"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:(promotionCardInfoConfig.slogen||promotionCardInfoConfig.unitPrice)&&showSaleNum?'scramble show-sale-num':'scramble'},"\u62A2"),(promotionCardInfoConfig.slogen||promotionCardInfoConfig.unitPrice)&&showSaleNum&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sale-num"},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E")))),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this10.props.webpSupport)}));}else if(cardBaseConfig.productStyle==="一行两个"){// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin))/2-8;var priceExtra='';if(promotionCardInfoConfig.priceInfo==='原价'){priceExtra=item.original_price>0&&item.original_price>item.price&&"\xA5".concat(item.original_price);}else if(promotionCardInfoConfig.priceInfo==='折扣'){priceExtra=discountRate!=10&&"".concat(discountRate,"\u6298");}else if(promotionCardInfoConfig.priceInfo==='直降'){priceExtra=plummet>0&&"\u76F4\u964D\xA5".concat(plummet);}if(item.hasOwnProperty('id')&&!priceExtra){priceExtra='爆款好价';}var itemClass='product-item row-two-item';if(showRectImg){itemClass+=' category-shoes';}if(promotionCardInfoConfig.benefit!=="无"){itemClass+=' has-benefit';}else{itemClass+=' no-benefit';}var _labelOrRecommend=null;if(promotionCardInfoConfig.benefit==='标签&推荐理由'){if(promotionCardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){_labelOrRecommend=_this10.renderLabels(item.labels);}else{_labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}else{if(item.recommend){_labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.labels&&item.labels.length>0){_labelOrRecommend=_this10.renderLabels(item.labels);}else{_labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var _options=_this10.getTrackData(item,index);productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this10.props.exp&&_this10.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this10.props,_options)),className:itemClass,key:index,style:itemStyle,onClick:_this10.handleItemPerNewUserClick.bind(_this10,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showRectImg?'product-img-panel shoes':'product-img-panel'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:!showRectImg?productImgWidth:'',className:"img",effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:productImgWidth,height:productImgWidth}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(!showRectImg?item.image:item.rectImg,_this10.props.webpSupport,'card')}),item.beltImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.beltImg,_this10.props.webpSupport,'card'),alt:"",className:"beltImg"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:promotionCardInfoConfig.slogen&&promotionCardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),_labelOrRecommend,promotionCardInfoConfig.benefit==='单位价格'&&item.shoppersLabel==='单位价格'&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),promotionCardInfoConfig.benefit==='单位价格'&&item.shoppersLabel==='自定义'&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sale"},item.price?(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this10.renderPromotionSparePriceView(item.price,2):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price small"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"small"},"0")),cardInfoConfig.newUserPrice==='新人价'&&_this10.renderPromotionSpareNewUserPriceView(item.new_user_price||item.price,2),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"origin-price",style:{textDecoration:'none'}},priceExtra),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"num"},item.sell_point>0?"".concat(item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"):'热卖中'))),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this10.props.webpSupport)}));}else if(cardBaseConfig.productStyle==="一行三个"){// 计算一行三商品图片宽度
var _productImgWidth=(bodyWidth-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin)*2)/3-8;var _priceExtra='';if(promotionCardInfoConfig.priceInfo==='原价'){_priceExtra=item.original_price>0&&item.original_price>item.price&&"\xA5".concat(item.original_price);}else if(promotionCardInfoConfig.priceInfo==='折扣'){_priceExtra=discountRate!=10&&"".concat(discountRate,"\u6298");}else if(promotionCardInfoConfig.priceInfo==='直降'){_priceExtra=plummet>0&&"\u76F4\u964D\xA5".concat(plummet);}if(item.hasOwnProperty('id')&&!_priceExtra){_priceExtra='爆款好价';}var _itemClass='product-item row-three-item';if(showRectImg){_itemClass+=' category-shoes';}if(promotionCardInfoConfig.benefit!=="无"){_itemClass+=' has-benefit';}else{_itemClass+=' no-benefit';}var _labelOrRecommend2=null;if(promotionCardInfoConfig.benefit==='标签&推荐理由'||promotionCardInfoConfig.benefit==='标签&推荐理由&配色'){if(promotionCardInfoConfig.priority==='优先展示配色'){if(item.style_name){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.style_name);}else{if(item.recommend){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!_labelOrRecommend2){_labelOrRecommend2=_this10.renderLabels(item.labels);}if(!_labelOrRecommend2){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}else if(promotionCardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){_labelOrRecommend2=_this10.renderLabels(item.labels);}else{if(item.style_name&&!_labelOrRecommend2){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(!_labelOrRecommend2){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}}else{if(item.recommend){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.style_name&&!_labelOrRecommend2){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!_labelOrRecommend2){_labelOrRecommend2=_this10.renderLabels(item.labels);}if(!_labelOrRecommend2){_labelOrRecommend2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var _options2=_this10.getTrackData(item,index);productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this10.props.exp&&_this10.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this10.props,_options2)),className:_itemClass,key:index,style:itemStyle,onClick:_this10.handleItemPerNewUserClick.bind(_this10,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showRectImg?'product-img-panel shoes':'product-img-panel'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:_productImgWidth,height:!showRectImg?_productImgWidth:'',className:"img",effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:_productImgWidth,height:_productImgWidth}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(!showRectImg?item.image:item.rectImg,_this10.props.webpSupport,'card')}),item.beltImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.beltImg,_this10.props.webpSupport,'card'),alt:"",className:"beltImg"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:promotionCardInfoConfig.slogen&&promotionCardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),_labelOrRecommend2,promotionCardInfoConfig.benefit==='单位价格'&&item.shoppersLabel==='单位价格'&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),promotionCardInfoConfig.benefit==='单位价格'&&item.shoppersLabel==='自定义'&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"sale"},item.price?(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this10.renderPromotionSparePriceView(item.price,3):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"price small"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"small"},"0")),cardInfoConfig.newUserPrice==='新人价'&&_this10.renderPromotionSparePriceView(item.price||item.new_user_price,3),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"origin-price",style:{textDecoration:'none'}},_priceExtra),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"num"},item.sell_point>0?"".concat(item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"):'热卖中'))),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this10.props.webpSupport)}));}return productItem;}));}else if(cardBaseConfig.productStyle==='一行一排'){return this.renderLayoutRowPromotion();}else{return this.renderLayoutAdaptPromotion();}}// 主题促销样式
},{key:"renderThemeSaleType",value:function renderThemeSaleType(){var _this11=this;var _this$state6=this.state,_this$state6$productL=_this$state6.productList,productList=_this$state6$productL===void 0?[]:_this$state6$productL,showPage=_this$state6.showPage,showRectImg=_this$state6.showRectImg;var _this$formatProductDa9=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa9.baseConfig,cardBaseConfig=_this$formatProductDa9.cardBaseConfig,_this$formatProductDa10=_this$formatProductDa9.themeSaleCardInfoConfig,themeSaleCardInfoConfig=_this$formatProductDa10===void 0?{}:_this$formatProductDa10;var _cardBaseConfig$theme=cardBaseConfig.themeStyle,themeStyle=_cardBaseConfig$theme===void 0?'':_cardBaseConfig$theme,_cardBaseConfig$price=cardBaseConfig.priceBgTheme_1,priceBgTheme_1=_cardBaseConfig$price===void 0?'':_cardBaseConfig$price,_cardBaseConfig$price2=cardBaseConfig.priceBgTheme_2,priceBgTheme_2=_cardBaseConfig$price2===void 0?'':_cardBaseConfig$price2,_cardBaseConfig$produ=cardBaseConfig.productNameColor,productNameColor=_cardBaseConfig$produ===void 0?'':_cardBaseConfig$produ,_cardBaseConfig$produ2=cardBaseConfig.productTagColor,productTagColor=_cardBaseConfig$produ2===void 0?'':_cardBaseConfig$produ2,_cardBaseConfig$cardB=cardBaseConfig.cardBackgroundColor,cardBackgroundColor=_cardBaseConfig$cardB===void 0?'':_cardBaseConfig$cardB;var _themeSaleCardInfoCon=themeSaleCardInfoConfig.benefit,benefit=_themeSaleCardInfoCon===void 0?'':_themeSaleCardInfoCon,_themeSaleCardInfoCon2=themeSaleCardInfoConfig.priority,priority=_themeSaleCardInfoCon2===void 0?'':_themeSaleCardInfoCon2;// 判断不同布局方式下的间距取值
if(cardBaseConfig.productStyle==="一行三个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_3);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,12):productList.slice(0,12+60*(showPage-1)):productList;}if(['一行三个'].indexOf(cardBaseConfig.productStyle)>=0){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-themeSale ".concat(this.isAndroid?'android':'ios')},productList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(cardBaseConfig.productStyle==="一行三个"){rowItemNumber=3;}// 折扣计算
var discountRate=_this11.getDiscount(item.price,item.original_price);var productItem;if(cardBaseConfig.productStyle==="一行三个"){// 四个展示都存在是，隐藏销量
var itemClass="row-three-item ".concat(themeStyle==='样式一'?'theme-1':'theme-2');if(showRectImg){itemClass+=' category-shoes';}if(benefit!=='无'){itemClass+=' has-benefit';}else{itemClass+=' no-benefit';}itemClass=_this11.getClassRowColumn(itemClass,rowItemNumber,productList.length,index);var renderBenefit="";switch(benefit){case'原价':renderBenefit=item.original_price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor,textDecoration:'line-through'}},"\xA5",item.original_price);break;case'折扣':renderBenefit=discountRate&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},discountRate);break;case'销量':renderBenefit=item.sell_point_str&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},"".concat(item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"));break;case'标签&推荐理由':case'标签&推荐理由&配色':if(priority==='优先展示配色'){if(item.style_name){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.style_name);}else{if(item.recommend&&!renderBenefit){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!renderBenefit){renderBenefit=_this11.renderLabels(item.labels);}if(!renderBenefit){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.pocket);}}}else if(priority==='优先展示标签'){if(item.labels&&item.labels.length>0){renderBenefit=_this11.renderLabels(item.labels);}else{if(item.style_name&&!renderBenefit){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.style_name);}if(!renderBenefit){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.recommend||item.pocket);}}}else{if(item.recommend){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.recommend);}else{if(item.style_name&&!renderBenefit){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!renderBenefit){renderBenefit=_this11.renderLabels(item.labels);}if(!renderBenefit){renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.pocket);}}}break;case'单位价格':renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},item.unit_price_text);break;default:break;}if((benefit==='标签&推荐理由'||benefit==='标签&推荐理由&配色')&&!renderBenefit&&item.id)renderBenefit=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"benefit",style:{color:productTagColor}},"\u7206\u6B3E\u70ED\u5356");var options=_this11.getTrackData(item,index);productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this11.props.exp&&_this11.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this11.props,options)),className:itemClass,key:index,style:{backgroundColor:cardBackgroundColor},onClick:_this11.handleItemPerNewUserClick.bind(_this11,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showRectImg?'product-img-panel shoes':'product-img-panel'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('114px'),height:!showRectImg?Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('114px'):'',className:"img",effect:"opacity",placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:114,height:114}}),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(!showRectImg?item.image:item.rectImg,_this11.props.webpSupport,'card')}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].isAndroid()?'product-info android':'product-info'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical",color:productNameColor}},item.title),renderBenefit),themeStyle==='样式一'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-btn",style:{backgroundImage:"url(".concat(priceBgTheme_1,")"),backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"label"}),_this11.renderPriceDom(item.price)):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-btn",style:{backgroundImage:"url(".concat(priceBgTheme_2,")"),backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}},_this11.renderPriceDom(item.price)),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this11.props.webpSupport)}));}return productItem;}));}}// 多个商品自动适配（常规卡片模块）
},{key:"renderLayoutAdaptNormal",value:function renderLayoutAdaptNormal(){var _this12=this;var _this$state$productLi=this.state.productList,productList=_this$state$productLi===void 0?[]:_this$state$productLi;var _this$formatProductDa11=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa11.baseConfig,cardBaseConfig=_this$formatProductDa11.cardBaseConfig,_this$formatProductDa12=_this$formatProductDa11.cardInfoConfig,cardInfoConfig=_this$formatProductDa12===void 0?{}:_this$formatProductDa12;Object.assign(cardBaseConfig,cardBaseConfig.layout_adapt);var titleSize='module-title';var showTitleArea=true;productList=productList.slice(0,40);if(cardBaseConfig.titleBgImage){if(baseConfig.showSubTitle){titleSize+=' big';}else{titleSize+=' small';}}else{if(baseConfig.showSubTitle&&baseConfig.subTitle){titleSize+=' big';}else{titleSize+=' small';}}if(!baseConfig.title&&!baseConfig.subTitle||!baseConfig.showTitle&&!baseConfig.showSubTitle){showTitleArea=false;}var midIndex=0;if(productList.length>=16&&productList.length<=40){midIndex=Math.ceil(productList.length/2);}var scrollMarginHorizon=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');var shopCardMarginBottom=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');// if (cardBaseConfig.shopCardMarginHorizon || cardBaseConfig.shopCardMarginHorizon == '0') {
//   scrollMarginHorizon = px2rem(`${cardBaseConfig.shopCardMarginHorizon}px`);
// }
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-layout-adapt-normal",style:{backgroundColor:cardBaseConfig.moduleBgColor,borderRadius:cardBaseConfig.moduleBgColor?Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('7px'):0}},showTitleArea&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:titleSize},cardBaseConfig.titleBgImage&&this.renderTitleImage(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardBaseConfig.titleBgImage?'title-content absolute':'title-content static'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-info"},cardBaseConfig.titlePrefixImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.titlePrefixImage,this.props.webpSupport,'card'),alt:"",className:"prefix-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-wrap"},baseConfig.showTitle&&baseConfig.title&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"main-title",style:{color:baseConfig.titleColorRow}},baseConfig.title),baseConfig.showSubTitle&&baseConfig.subTitle&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sub-title",style:{color:baseConfig.titleColorRow}},baseConfig.subTitle))),cardBaseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"more",style:{color:baseConfig.titleColorRow},onClick:this.productBannerGo.bind(this,cardBaseConfig.browserMoreHref)},"\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("svg",{t:"1658131192314",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1187",className:"more-icon"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"1188",fill:baseConfig.titleColorRow}))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showTitleArea?"goods-body":"goods-body no-title-area",style:{paddingTop:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])("".concat(cardBaseConfig.shopCardMarginTop,"px")),paddingBottom:cardBaseConfig.moduleBgColor?shopCardMarginBottom:0},ref:function ref(_ref6){return _this12.goodsBodyRef=_ref6;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-scroll",ref:function ref(_ref5){return _this12.goodsScrollRef=_ref5;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"scroll-list list-1",style:{marginLeft:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0,marginRight:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0}},this.renderLayoutAdaptScrollNormal(productList.slice(0,midIndex<=0?productList.length:midIndex))),midIndex>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"scroll-list list-2",style:{marginLeft:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0,marginRight:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0}},this.renderLayoutAdaptScrollNormal(productList.slice(midIndex,productList.length))))),cardBaseConfig.isAutoCarousel==='是'&&this.renderCarouselBar());}// 多个商品自动适配（常规卡片）
},{key:"renderLayoutAdaptScrollNormal",value:function renderLayoutAdaptScrollNormal(){var _this13=this;var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _this$formatProductDa13=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa13.baseConfig,cardBaseConfig=_this$formatProductDa13.cardBaseConfig,_this$formatProductDa14=_this$formatProductDa13.cardInfoConfig,cardInfoConfig=_this$formatProductDa14===void 0?{}:_this$formatProductDa14;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_react__["Fragment"],null,list.map(function(item,index){// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));var itemClass='goods-item';if(cardInfoConfig.slogen||cardInfoConfig.unitPrice){itemClass+=' has-benefit';}else{itemClass+=' no-benefit';}var labelOrRecommend=null;if(cardInfoConfig.slogen){if(cardInfoConfig.priority==='优先展示配色'){if(item.style_name){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.style_name);}else{if(item.recommend&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this13.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}else if(cardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=_this13.renderLabels(item.labels);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this13.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var options=_this13.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this13.props.exp&&_this13.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this13.props,options)),className:itemClass,key:"goods-".concat(index),style:{backgroundImage:!cardBaseConfig.cardBackgroundColor?cardBaseConfig.cardBackground?"url(".concat(cardBaseConfig.cardBackground,")"):'none':'none',border:cardBaseConfig.cardBackground&&'none',backgroundColor:cardBaseConfig.cardBackgroundColor},onClick:_this13.handleItemPerNewUserClick.bind(_this13,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.image,_this13.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-title",style:{color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-bottom",style:{justifyContent:['原价','折扣'].indexOf(cardInfoConfig.priceInfo)>=0?'flex-start':'space-between'}},(item.price||item.price===0)&&(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this13.rederSparePriceOneLineView(baseConfig,item.price),cardInfoConfig.newUserPrice==='新人价'&&_this13.rederSparePriceOneLineView(baseConfig,item.new_user_price||item.price),cardInfoConfig.priceInfo==='原价'&&item.original_price>0&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this13.renderPriceLength,item.original_price,8)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),cardInfoConfig.priceInfo==='折扣'&&discountRate!=10&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this13.renderPriceLength,discountRate,8)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298"),cardInfoConfig.priceInfo==='销量'&&item.sell_point>0&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this13.renderPriceLength,item.sell_point_str,7)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sales",style:{color:baseConfig.priceInfoColor}},"\u9500\u91CF",item.sell_point_str)),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this13.props.webpSupport)}));}));}// 多个商品自动适配（促销卡片模块）
},{key:"renderLayoutAdaptPromotion",value:function renderLayoutAdaptPromotion(){var _this14=this;var _this$state$productLi2=this.state.productList,productList=_this$state$productLi2===void 0?[]:_this$state$productLi2;var _this$formatProductDa15=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa15.baseConfig,cardBaseConfig=_this$formatProductDa15.cardBaseConfig,_this$formatProductDa16=_this$formatProductDa15.cardInfoConfig,cardInfoConfig=_this$formatProductDa16===void 0?{}:_this$formatProductDa16,_this$formatProductDa17=_this$formatProductDa15.promotionCardInfoConfig,promotionCardInfoConfig=_this$formatProductDa17===void 0?{}:_this$formatProductDa17;Object.assign(cardBaseConfig,cardBaseConfig.layout_adapt);var titleSize='module-title';var showTitleArea=true;productList=productList.slice(0,40);if(cardBaseConfig.titleBgImage){if(baseConfig.showSubTitle){titleSize+=' big';}else{titleSize+=' small';}}else{if(baseConfig.showSubTitle&&baseConfig.subTitle){titleSize+=' big';}else{titleSize+=' small';}}if(!baseConfig.title&&!baseConfig.subTitle||!baseConfig.showTitle&&!baseConfig.showSubTitle){showTitleArea=false;}var midIndex=0;if(productList.length>=16&&productList.length<=40){midIndex=Math.ceil(productList.length/2);}var scrollMarginHorizon=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');var shopCardMarginBottom=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');// if (cardBaseConfig.shopCardMarginHorizon || cardBaseConfig.shopCardMarginHorizon == '0') {
//   scrollMarginHorizon = px2rem(`${cardBaseConfig.shopCardMarginHorizon}px`);
// }
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-layout-adapt-promotion",style:{backgroundColor:cardBaseConfig.moduleBgColor,borderRadius:cardBaseConfig.moduleBgColor?Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('7px'):0}},showTitleArea&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:titleSize},cardBaseConfig.titleBgImage&&this.renderTitleImage(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardBaseConfig.titleBgImage?'title-content absolute':'title-content static'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-info"},cardBaseConfig.titlePrefixImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.titlePrefixImage,this.props.webpSupport,'card'),alt:"",className:"prefix-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-wrap"},baseConfig.showTitle&&baseConfig.title&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"main-title",style:{color:baseConfig.titleColorRow}},baseConfig.title),baseConfig.showSubTitle&&baseConfig.subTitle&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sub-title",style:{color:baseConfig.titleColorRow}},baseConfig.subTitle))),cardBaseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"more",style:{color:baseConfig.titleColorRow},onClick:this.productBannerGo.bind(this,cardBaseConfig.browserMoreHref)},"\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("svg",{t:"1658131192314",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1187",className:"more-icon"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"1188",fill:baseConfig.titleColorRow}))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showTitleArea?"goods-body":"goods-body no-title-area",style:{paddingTop:"".concat(cardBaseConfig.shopCardMarginTop,"px"),paddingBottom:cardBaseConfig.moduleBgColor?shopCardMarginBottom:0},ref:function ref(_ref8){return _this14.goodsBodyRef=_ref8;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-scroll",ref:function ref(_ref7){return _this14.goodsScrollRef=_ref7;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"scroll-list list-1",style:{marginLeft:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0,marginRight:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0}},this.renderLayoutAdaptScrollPromotion(productList.slice(0,midIndex<=0?productList.length:midIndex))),midIndex>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"scroll-list list-2",style:{marginLeft:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0,marginRight:cardBaseConfig.moduleBgColor?scrollMarginHorizon:0}},this.renderLayoutAdaptScrollPromotion(productList.slice(midIndex,productList.length))))),cardBaseConfig.isAutoCarousel==='是'&&this.renderCarouselBar());}// 多个商品自动适配（促销卡片）
},{key:"renderLayoutAdaptScrollPromotion",value:function renderLayoutAdaptScrollPromotion(){var _this15=this;var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var _this$formatProductDa18=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa18.baseConfig,cardBaseConfig=_this$formatProductDa18.cardBaseConfig,_this$formatProductDa19=_this$formatProductDa18.cardInfoConfig,cardInfoConfig=_this$formatProductDa19===void 0?{}:_this$formatProductDa19,_this$formatProductDa20=_this$formatProductDa18.promotionCardInfoConfig,promotionCardInfoConfig=_this$formatProductDa20===void 0?{}:_this$formatProductDa20;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_react__["Fragment"],null,list.map(function(item,index){// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));// 直降计算
var plummet=0;if(item.original_price&&item.original_price>item.price){plummet=Math.floor(item.original_price-item.price);}// 价格信息展示
var priceExtra='';if(promotionCardInfoConfig.priceInfo==='原价'){priceExtra=item.original_price>0&&item.original_price>item.price&&"\xA5".concat(item.original_price);}else if(promotionCardInfoConfig.priceInfo==='折扣'){priceExtra=discountRate!=10&&"".concat(discountRate,"\u6298");}else if(promotionCardInfoConfig.priceInfo==='直降'){priceExtra=plummet>0&&"\u76F4\u964D\xA5".concat(plummet);}if(item.hasOwnProperty('id')&&!priceExtra){priceExtra='爆款好价';}var labelOrRecommend=null;if(promotionCardInfoConfig.benefit==='标签&推荐理由'||promotionCardInfoConfig.benefit==='标签&推荐理由&配色'){if(promotionCardInfoConfig.priority==='优先展示配色'){if(item.style_name){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.style_name);}else{if(item.recommend&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this15.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}else if(promotionCardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=_this15.renderLabels(item.labels);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this15.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var options=_this15.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this15.props.exp&&_this15.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this15.props,options)),className:promotionCardInfoConfig.benefit!=="无"?'goods-item has-benefit':'goods-item no-benefit',key:"goods-".concat(index),onClick:_this15.handleItemPerNewUserClick.bind(_this15,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.image,_this15.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-title",style:{color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,promotionCardInfoConfig.benefit==='单位价格'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-bottom"},item.price?(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this15.rederLayoutRowPromotionOneLineView(item.price):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"small"},"0")),cardInfoConfig.newUserPrice==='新人价'&&_this15.rederLayoutRowPromotionOneLineView(item.new_user_price||item.price,'new'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"origin-price",style:{textDecoration:'none'}},priceExtra),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sales"},item.sell_point>0?"".concat(item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"):'热卖中')),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this15.props.webpSupport)}));}));}// 一行一排（常规样式）
},{key:"renderLayoutRowNormal",value:function renderLayoutRowNormal(){var _this16=this;var _this$state$productLi3=this.state.productList,productList=_this$state$productLi3===void 0?[]:_this$state$productLi3;var _this$formatProductDa21=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa21.baseConfig,cardBaseConfig=_this$formatProductDa21.cardBaseConfig,_this$formatProductDa22=_this$formatProductDa21.cardInfoConfig,cardInfoConfig=_this$formatProductDa22===void 0?{}:_this$formatProductDa22;Object.assign(cardBaseConfig,cardBaseConfig.layout_row);var titleSize='module-title';var showTitleArea=true;if(cardBaseConfig.titleBgImage){if(baseConfig.showSubTitle){titleSize+=' big';}else{titleSize+=' small';}}else{if(baseConfig.showSubTitle&&baseConfig.subTitle){titleSize+=' big';}else{titleSize+=' small';}}if(!baseConfig.title&&!baseConfig.subTitle||!baseConfig.showTitle&&!baseConfig.showSubTitle){showTitleArea=false;}this.renderPriceLength=this.renderPriceLength||0;//一行一 价格长度
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-layout-row-normal",style:{backgroundColor:cardBaseConfig.moduleBgColor}},showTitleArea&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:titleSize},cardBaseConfig.titleBgImage&&this.renderTitleImage(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardBaseConfig.titleBgImage?'title-content absolute':'title-content static'},!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-info"},cardBaseConfig.titlePrefixImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.titlePrefixImage,this.props.webpSupport,'card'),alt:"",className:"prefix-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-wrap"},baseConfig.showTitle&&baseConfig.title&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"main-title",style:{color:baseConfig.titleColorRow}},baseConfig.title),baseConfig.showSubTitle&&baseConfig.subTitle&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sub-title",style:{color:baseConfig.titleColorRow}},baseConfig.subTitle))),cardBaseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"more-hot",onClick:this.productBannerGo.bind(this,cardBaseConfig.browserMoreHref)},!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"more",style:{color:baseConfig.titleColorRow}},"\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("svg",{t:"1658131192314",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1187",className:"more-icon"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"1188",fill:baseConfig.titleColorRow})))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showTitleArea?"goods-body":"goods-body no-title-area"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-scroll"},productList.slice(0,20).map(function(item,index){// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));var itemClass='goods-item';if(cardInfoConfig.slogen||cardInfoConfig.unitPrice){itemClass+=' has-benefit';}else{itemClass+=' no-benefit';}var labelOrRecommend=null;if(cardInfoConfig.slogen){if(cardInfoConfig.priority==='优先展示配色'){if(item.style_name){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.style_name);}else{if(item.recommend&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this16.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.pocket);}}}else if(cardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=_this16.renderLabels(item.labels);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.style_name);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.recommend||item.pocket);}}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.recommend);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this16.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:cardBaseConfig.productNameColor!="#333333"&&cardBaseConfig.productNameColor!="#333"&&cardBaseConfig.productNameColor}},item.pocket);}}}}var scrollMarginHorizon=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');if(cardBaseConfig.shopCardMarginHorizon||cardBaseConfig.shopCardMarginHorizon=='0'){scrollMarginHorizon=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])("".concat(cardBaseConfig.shopCardMarginHorizon,"px"));}var options=_this16.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this16.props.exp&&_this16.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this16.props,options)),className:itemClass,key:"goods-".concat(index),style:{marginLeft:index===0?scrollMarginHorizon:0,marginRight:index===productList.slice(0,20).length-1?scrollMarginHorizon:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('4px')},onClick:_this16.handleItemPerNewUserClick.bind(_this16,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('91px'),height:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('91px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.image,_this16.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-title",style:{color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-bottom",style:{justifyContent:['原价','折扣'].indexOf(cardInfoConfig.priceInfo)>=0?'flex-start':'space-between'}},(item.price||item.price===0)&&(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this16.rederSparePriceOneLineView(baseConfig,item.price),cardInfoConfig.newUserPrice==='新人价'&&_this16.rederSparePriceOneLineView(baseConfig,item.new_user_price||item.price),cardInfoConfig.priceInfo==='原价'&&item.original_price>0&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this16.renderPriceLength,item.original_price,7)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),cardInfoConfig.priceInfo==='折扣'&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this16.renderPriceLength,discountRate,7)&&discountRate!=10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298"),cardInfoConfig.priceInfo==='销量'&&__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].showRightPrice(_this16.renderPriceLength,item.sell_point_str,5)&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sales",style:{color:baseConfig.priceInfoColor}},"\u9500\u91CF",item.sell_point_str)),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this16.props.webpSupport)}));}),cardBaseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:cardInfoConfig.slogen||cardInfoConfig.unitPrice?'browser-more has-benefit':'browser-more no-benefit',style:{backgroundColor:cardBaseConfig.browserMoreBgColor,color:cardBaseConfig.browserMoreTxtColor},onClick:this.productBannerGo.bind(this,cardBaseConfig.browserMoreHref)},"\u67E5\u770B\u66F4\u591A"))));}// 一行一排（促销样式）
},{key:"renderLayoutRowPromotion",value:function renderLayoutRowPromotion(){var _this17=this;var _this$state$productLi4=this.state.productList,productList=_this$state$productLi4===void 0?[]:_this$state$productLi4;var _this$formatProductDa23=this.formatProductData(this.props.config),baseConfig=_this$formatProductDa23.baseConfig,cardBaseConfig=_this$formatProductDa23.cardBaseConfig,_this$formatProductDa24=_this$formatProductDa23.cardInfoConfig,cardInfoConfig=_this$formatProductDa24===void 0?{}:_this$formatProductDa24,_this$formatProductDa25=_this$formatProductDa23.promotionCardInfoConfig,promotionCardInfoConfig=_this$formatProductDa25===void 0?{}:_this$formatProductDa25;Object.assign(cardBaseConfig,cardBaseConfig.layout_row);var titleSize='module-title';var showTitleArea=true;if(cardBaseConfig.titleBgImage){if(baseConfig.showSubTitle){titleSize+=' big';}else{titleSize+=' small';}}else{if(baseConfig.showSubTitle&&baseConfig.subTitle){titleSize+=' big';}else{titleSize+=' small';}}if(!baseConfig.title&&!baseConfig.subTitle||!baseConfig.showTitle&&!baseConfig.showSubTitle){showTitleArea=false;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"product-layout-row-promotion",style:{backgroundColor:cardBaseConfig.moduleBgColor}},showTitleArea&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:titleSize},cardBaseConfig.titleBgImage&&this.renderTitleImage(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:cardBaseConfig.titleBgImage?'title-content absolute':'title-content static'},!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-info"},cardBaseConfig.titlePrefixImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.titlePrefixImage,this.props.webpSupport,'card'),alt:"",className:"prefix-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"title-wrap"},baseConfig.showTitle&&baseConfig.title&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"main-title",style:{color:baseConfig.titleColorRow}},baseConfig.title),baseConfig.showSubTitle&&baseConfig.subTitle&&!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sub-title",style:{color:baseConfig.titleColorRow}},baseConfig.subTitle))),cardBaseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"more-hot",onClick:this.productBannerGo.bind(this,cardBaseConfig.browserMoreHref)},!cardBaseConfig.titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"more",style:{color:baseConfig.titleColorRow}},"\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("svg",{t:"1658131192314",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1187",className:"more-icon"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"1188",fill:baseConfig.titleColorRow})))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:showTitleArea?"goods-body":"goods-body no-title-area"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-scroll"},productList.slice(0,20).map(function(item,index){// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));// 直降计算
var plummet=0;if(item.original_price&&item.original_price>item.price){plummet=Math.floor(item.original_price-item.price);}// 价格信息展示
var priceExtra='';if(promotionCardInfoConfig.priceInfo==='原价'){priceExtra=item.original_price>0&&item.original_price>item.price&&"\xA5".concat(item.original_price);}else if(promotionCardInfoConfig.priceInfo==='折扣'){priceExtra=discountRate!=10&&"".concat(discountRate,"\u6298");}else if(promotionCardInfoConfig.priceInfo==='直降'){priceExtra=plummet>0&&"\u76F4\u964D\xA5".concat(plummet);}if(item.hasOwnProperty('id')&&!priceExtra){priceExtra='爆款好价';}var labelOrRecommend=null;if(promotionCardInfoConfig.benefit==='标签&推荐理由'||promotionCardInfoConfig.benefit==='标签&推荐理由&配色'){// 默认展示优先级 配色 > 推荐理由 > 标签
if(promotionCardInfoConfig.priority==='优先展示配色'){if(item.style_name){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.style_name);}else{if(item.recommend&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.recommend);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this17.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}else if(promotionCardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){labelOrRecommend=_this17.renderLabels(item.labels);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.recommend||item.pocket);}}}else{if(item.recommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.recommend);}else{if(item.style_name&&!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.style_name);}if(item.labels&&item.labels.length>0&&!labelOrRecommend){labelOrRecommend=_this17.renderLabels(item.labels);}if(!labelOrRecommend){labelOrRecommend=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit recommend",style:{color:cardBaseConfig.productTagColor}},item.pocket);}}}}var scrollMarginHorizon=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('12px');if(cardBaseConfig.shopCardMarginHorizon||cardBaseConfig.shopCardMarginHorizon=='0'){scrollMarginHorizon=Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])("".concat(cardBaseConfig.shopCardMarginHorizon,"px"));}var options=_this17.getTrackData(item,index);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this17.props.exp&&_this17.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getExposureData(_this17.props,options)),className:promotionCardInfoConfig.benefit!=="无"?'goods-item has-benefit':'goods-item no-benefit',key:"goods-".concat(index),style:{marginLeft:index===0?scrollMarginHorizon:0,marginRight:index===productList.slice(0,20).length-1?scrollMarginHorizon:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('4px')},onClick:_this17.handleItemPerNewUserClick.bind(_this17,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_40__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.image,_this17.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-title",style:{color:cardBaseConfig.productNameColor}},item.title),labelOrRecommend,promotionCardInfoConfig.benefit==='单位价格'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"goods-item-benefit unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-bottom"},item.price?(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')&&_this17.rederLayoutRowPromotionOneLineView(item.price):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"goods-item-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"small"},"0")),cardInfoConfig.newUserPrice==='新人价'&&_this17.rederLayoutRowPromotionOneLineView(item.new_user_price||item.price,'new'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"origin-price",style:{textDecoration:'none'}},priceExtra),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:"sales"},item.sell_point>0?"".concat(item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"):'热卖中')),item.markIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{className:"mark-icon ".concat(custonLabels.includes(item.markIcon)?'style-2':'style-1'),src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(item.markIcon,_this17.props.webpSupport)}));}),cardBaseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{className:promotionCardInfoConfig.benefit!=="无"?'browser-more has-benefit':'browser-more no-benefit',style:{backgroundColor:cardBaseConfig.browserMoreBgColor,color:cardBaseConfig.browserMoreTxtColor},onClick:this.productBannerGo.bind(this,cardBaseConfig.browserMoreHref)},"\u67E5\u770B\u66F4\u591A"))));}// 渲染标题背景图片
},{key:"renderTitleImage",value:function renderTitleImage(){var _this$formatProductDa26=this.formatProductData(this.props.config),cardBaseConfig=_this$formatProductDa26.cardBaseConfig;var _utils$getAdaptImageS2=__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].getAdaptImageSize(cardBaseConfig.titleImageSize),width=_utils$getAdaptImageS2.width,height=_utils$getAdaptImageS2.height;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_39__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.titleBgImage,this.props.webpSupport),alt:"",className:"title-image",style:{width:width,height:height}});}// 轮播条
},{key:"renderCarouselBar",value:function renderCarouselBar(){var _this18=this;var cardBaseConfig=this.props.config.cardBaseConfig;var carouselBgColor,progressColor;switch(cardBaseConfig.carouselBarColor){case'白色':carouselBgColor='rgba(255, 255, 255, 0.3)';progressColor='#fff';break;case'黑色':carouselBgColor='rgba(202, 202, 202, 0.3)';progressColor='#CACACA';break;default:carouselBgColor='rgba(255, 255, 255, 0.3)';progressColor='#fff';break;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"carousel-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"carousel-bg",style:{backgroundColor:carouselBgColor},ref:function ref(_ref9){return _this18.carouselBgRef=_ref9;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"carousel-progress",style:{backgroundColor:progressColor},ref:function ref(_ref10){return _this18.progressRef=_ref10;}}));}},{key:"renderLabels",value:// 标签
function renderLabels(){var _this19=this;var labels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("div",{className:"labels"},labels.map(function(item,index){var color='',borderColor='',backgroundColor='';if(item.type==='NEW_GOODS'){color='#3E455E';borderColor='#C8CEE4';backgroundColor='transparent';}else{color='#FF4338';borderColor='#FFB4B3';backgroundColor='transparent';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_34_react___default.a.createElement("p",{key:"label-".concat(index),className:_this19.isAndroid?'android':'ios',style:{color:color,borderColor:borderColor,backgroundColor:backgroundColor}},item.text);}));}},{key:"isElementInViewport",value:function isElementInViewport(element){var rect=element.getBoundingClientRect();var windowHeight=window.innerHeight||document.documentElement.clientHeight;var windowWidth=window.innerWidth||document.documentElement.clientWidth;// 判断元素是否垂直方向上可见
var verticalVisible=rect.top<=windowHeight&&rect.bottom>=0;// 判断元素是否水平方向上可见
var horizontalVisible=rect.left<=windowWidth&&rect.right>=0;// 计算已经暴露在可视区的比例
var visibleArea=Math.max(0,Math.min(rect.right,windowWidth)-Math.max(rect.left,0))*Math.max(0,Math.min(rect.bottom,windowHeight)-Math.max(rect.top,0));var totalArea=rect.width*rect.height;var visibilityRatio=visibleArea/totalArea;return{verticalVisible:verticalVisible,horizontalVisible:horizontalVisible,visibilityRatio:visibilityRatio};}},{key:"hexColorToRgba",value:function hexColorToRgba(hexColor,opacity){var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}}]);return PipelineProduct;}(__WEBPACK_IMPORTED_MODULE_34_react___default.a.Component);PipelineProduct.propTypes={config:__WEBPACK_IMPORTED_MODULE_35_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProduct);

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProductCustomize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineProductCustomize=/*#__PURE__*/function(_React$Component){_inherits(PipelineProductCustomize,_React$Component);var _super=_createSuper(PipelineProductCustomize);function PipelineProductCustomize(props){var _this;_classCallCheck(this,PipelineProductCustomize);_this=_super.call(this,props);// 初始化商品id列表数据
var initList=props.config.itemList.map(function(item){return{image:'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'// 空白占位图
};});_this.state={list:initList};return _this;}_createClass(PipelineProductCustomize,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"handleItemClick",value:function handleItemClick(linkUrl,index,event){event.stopPropagation();// 停止事件传播
if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].handleToufangClick({link:linkUrl,props:this.props,index:index});return;}var baseConfig=this.props.config.baseConfig;var options={link:linkUrl,title:baseConfig.title,type:baseConfig.productStyle,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].convertHref(linkUrl);__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,convertUrl,linkUrl,options,'',this.props);}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var productList=itemList||[];var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;// 判断不同布局方式下的间距取值
if(baseConfig.productStyle==="一行一个"){Object.assign(baseConfig,baseConfig.layout_1);}else if(baseConfig.productStyle==="一行两个"){Object.assign(baseConfig,baseConfig.layout_2);}else if(baseConfig.productStyle==="一行三个"){Object.assign(baseConfig,baseConfig.layout_3);}else if(baseConfig.productStyle==="一行一排"){Object.assign(baseConfig,baseConfig.layout_row);}// 转为数字处理，后续参与计算
baseConfig.itemMargin=isNaN(Number(baseConfig.itemMargin))?0:Number(baseConfig.itemMargin);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",_extends({className:"pipeline-product-customize",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:baseConfig.productStyle==="一行一排"?0:"".concat(baseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),baseConfig.showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title),baseConfig.showSubTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"sub-title",style:{color:baseConfig.titleColor},dangerouslySetInnerHTML:{__html:baseConfig.subTitle}}),baseConfig.productStyle!=="一行一排"?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-list"},productList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(baseConfig.productStyle==="一行一个"){rowItemNumber=1;}else if(baseConfig.productStyle==="一行两个"){rowItemNumber=2;}else if(baseConfig.productStyle==="一行三个"){rowItemNumber=3;}// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLastRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(baseConfig.itemMargin/2,"px"),marginBottom:isLastRow?"0":"".concat(baseConfig.itemMargin/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.itemMargin/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.itemMargin/2,"px")};var productItem;if(baseConfig.productStyle==="一行一个"){productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-item row-one-item",key:index,style:itemStyle,onClick:_this2.handleItemClick.bind(_this2,item.productUrl,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component__["LazyLoadImage"],{width:110,height:110,placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:110,height:110}}),src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.image,_this2.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),baseConfig.slogan&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"tag",onClick:_this2.handleItemClick.bind(_this2,item.recommendUrl,index)},item.recommend&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"tag-text"},item.recommend))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),baseConfig.originPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.originPrice)))));}else if(baseConfig.productStyle==="一行两个"){// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-Number(baseConfig.moduleMarginHorizon)*2-Number(baseConfig.itemMargin))/2-6;productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-item row-two-item",key:index,style:itemStyle,onClick:_this2.handleItemClick.bind(_this2,item.productUrl,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-img-panel",style:{margin:3}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:productImgWidth,src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.image,_this2.props.webpSupport),placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:productImgWidth,height:productImgWidth}})})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),baseConfig.slogan&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"tag",onClick:_this2.handleItemClick.bind(_this2,item.recommendUrl,index)},item.recommend&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"tag-text"},item.recommend))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),baseConfig.originPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.originPrice)))));}else if(baseConfig.productStyle==="一行三个"){// 计算一行三商品图片宽度
var _productImgWidth=(bodyWidth-Number(baseConfig.moduleMarginHorizon)*2-Number(baseConfig.itemMargin)*2)/3;productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-item row-three-item",key:index,style:itemStyle,onClick:_this2.handleItemClick.bind(_this2,item.productUrl,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component__["LazyLoadImage"],{width:_productImgWidth,height:_productImgWidth,src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.image,_this2.props.webpSupport),placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:_productImgWidth,height:_productImgWidth}})})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),baseConfig.slogan&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"tag",onClick:_this2.handleItemClick.bind(_this2,item.recommendUrl,index)},item.recommend&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"tag-text"},item.recommend))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),baseConfig.originPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.originPrice))));}return productItem;})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-swiper-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"swiper-list"},productList.map(function(item,index){var itemStyle={paddingLeft:index===0?"".concat(baseConfig.itemMargin,"px"):"".concat(baseConfig.itemMargin/2,"px"),paddingRight:index===productList.length-1?"".concat(baseConfig.itemMargin,"px"):"".concat(baseConfig.itemMargin/2,"px")};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-item",key:index,onClick:_this2.handleItemClick.bind(_this2,item.productUrl,index),style:itemStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_lazy_load_image_component__["LazyLoadImage"],{width:90,height:90,src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.image,_this2.props.webpSupport),placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:90,height:90}})})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"product-name"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"rmb-icon"},"\uFFE5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"price-num"},item.price)));}))));}}]);return PipelineProductCustomize;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);PipelineProductCustomize.propTypes={config:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProductCustomize);

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_less__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineRank=/*#__PURE__*/function(_Component){_inherits(PipelineRank,_Component);var _super=_createSuper(PipelineRank);function PipelineRank(props){var _this;_classCallCheck(this,PipelineRank);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getRankList",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$props$config,componentTemplate,rankProductList_layout_more,rankProductList_layout_3,rankCollectList_layout_2,rankCollectList_layout_3,itemList,rankList,createTime;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props$config=_this.props.config,componentTemplate=_this$props$config.componentTemplate,rankProductList_layout_more=_this$props$config.rankProductList_layout_more,rankProductList_layout_3=_this$props$config.rankProductList_layout_3,rankCollectList_layout_2=_this$props$config.rankCollectList_layout_2,rankCollectList_layout_3=_this$props$config.rankCollectList_layout_3;itemList=[];_context.t0=componentTemplate.templateSelect;_context.next=_context.t0==='商品榜单一行多'?5:_context.t0==='商品榜单一行三'?7:_context.t0==='榜单集合一行二'?9:_context.t0==='榜单集合一行三'?11:13;break;case 5:itemList=rankProductList_layout_more;return _context.abrupt("break",14);case 7:itemList=rankProductList_layout_3;return _context.abrupt("break",14);case 9:itemList=rankCollectList_layout_2;return _context.abrupt("break",14);case 11:itemList=rankCollectList_layout_3;return _context.abrupt("break",14);case 13:return _context.abrupt("break",14);case 14:rankList=[];createTime=_this.props.createTime;// 新版排行榜上线时间是 2025-01-23
if(!(!createTime||createTime>=1737561600000)){_context.next=22;break;}_context.next=19;return _this.getRankListNewApi(itemList);case 19:rankList=_context.sent;_context.next=25;break;case 22:_context.next=24;return _this.getRankListOldApi(itemList);case 24:rankList=_context.sent;case 25:// 插入定制化内容
rankList.forEach(function(product){var customItem=itemList.find(function(item){return item.id==product.top_id;});if(customItem){if(customItem.title.trim()){product.top_name=customItem.top_name||customItem.title;}if(['商品榜单一行多'].indexOf(componentTemplate.templateSelect)>=0){product.titleIconImage=customItem.titleIconImage;}if(['商品榜单一行三'].indexOf(componentTemplate.templateSelect)>=0){product.titleIconImage=customItem.titleIconImage;Number(customItem.showNumber)&&(product.showNumber=customItem.showNumber);}if(['榜单集合一行二','榜单集合一行三'].indexOf(componentTemplate.templateSelect)>=0){product.benefit=customItem.benefit;product.rankImage=customItem.rankImage;product.rankTagImage=customItem.rankTagImage;}}});_this.setState({rankList:rankList});case 27:case"end":return _context.stop();}}},_callee);})));_defineProperty(_assertThisInitialized(_this),"getRankListOldApi",function(itemList){var idList=itemList.map(function(item){return item.id?item.id:'0';});return new Promise(function(resolve){Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-goodsinnerapi/api/inner/top/info?access_token=WphjwI564K8kzs5JQZ',method:"post",withCredentials:true,data:{topListIds:idList}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var list=data||[];// 老排行榜的字段转换成新排行榜的字段用于渲染
var rankList=list.map(function(item){var id=item.id,name=item.name,href=item.href;return{top_id:id,top_name:name,href:href,good_list:item.top_detail?item.top_detail.map(function(val){var name=val.name,price=val.price,sale=val.sale,pic=val.pic,goods_id=val.goods_id,style_id=val.style_id,href=val.href;return{good_title:name,price_text:price,sell_number:sale,img:pic,GoodsId:goods_id,StyleId:style_id,Href:href};}):[]};});resolve(rankList);}else{resolve([]);}})["catch"](function(err){resolve([]);});});});_defineProperty(_assertThisInitialized(_this),"getRankListNewApi",function(itemList){var idList=itemList.map(function(item){return item.id?Number(item.id):0;});return new Promise(function(resolve){Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-topapi/saletop/top-info',method:"post",withCredentials:true,data:{topListIds:idList}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0&&data){var rankList=data||[];resolve(rankList);}else{resolve([]);}})["catch"](function(err){resolve([]);});});});_defineProperty(_assertThisInitialized(_this),"handleMoreClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:_this.props,index:index});return;}var url=item.href;var options={title:item.top_name,topic_id:item.top_id,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false,{blockName:'more'});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(topic,item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].handleToufangClick({link:item.Href,props:_this.props,index:index});return;}var options={title:item.good_title,sort:index,goods_id:item.GoodsId,style_id:item.StyleId,topic_id:topic.top_id};__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.Href,item.Href,options,item.GoodsId,_this.props);});_defineProperty(_assertThisInitialized(_this),"productBannerGo",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}// banner跳转
var options={};var convertUrl=__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false);});_this.state={rankList:[]};_this.isAndroid=__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].isAndroid();return _this;}_createClass(PipelineRank,[{key:"componentDidMount",value:function componentDidMount(){this.getRankList();}},{key:"renderProductLayoutMore",value:// 商品榜单一行多
function renderProductLayoutMore(){var _this2=this;var rankList=this.state.rankList;var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,rankProductConfig_layout_more=_this$props$config2.rankProductConfig_layout_more;var _baseConfig$layout=baseConfig.layout,layout=_baseConfig$layout===void 0?{}:_baseConfig$layout;var rankTitleBgColorType=rankProductConfig_layout_more.rankTitleBgColorType,rankOnlyTitleBg=rankProductConfig_layout_more.rankOnlyTitleBg,rankTitleBgColorFrom=rankProductConfig_layout_more.rankTitleBgColorFrom,rankTitleBgColorTo=rankProductConfig_layout_more.rankTitleBgColorTo,rankTitleBg=rankProductConfig_layout_more.rankTitleBg,titleTxtColor=rankProductConfig_layout_more.titleTxtColor,productNameColor=rankProductConfig_layout_more.productNameColor,priceNumColor=rankProductConfig_layout_more.priceNumColor,priceTxt=rankProductConfig_layout_more.priceTxt,priceTxtColor=rankProductConfig_layout_more.priceTxtColor,originalPriceColor=rankProductConfig_layout_more.originalPriceColor,moreTxtBg=rankProductConfig_layout_more.moreTxtBg,rankBgImage=rankProductConfig_layout_more.rankBgImage,titleBgImage=rankProductConfig_layout_more.titleBgImage,productBgImage=rankProductConfig_layout_more.productBgImage,rankTagTop1=rankProductConfig_layout_more.rankTagTop1,rankTagTop2=rankProductConfig_layout_more.rankTagTop2,rankTagTop3=rankProductConfig_layout_more.rankTagTop3,rankTagCommon=rankProductConfig_layout_more.rankTagCommon,titleImageSize=rankProductConfig_layout_more.titleImageSize,showSales=rankProductConfig_layout_more.showSales;var _utils$getAdaptImageS=__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].getAdaptImageSize(titleImageSize),width=_utils$getAdaptImageS.width,height=_utils$getAdaptImageS.height;var titleStyle=rankTitleBgColorType=="纯色背景"?{backgroundColor:rankTitleBgColorType=="纯色背景"?rankOnlyTitleBg:'transparent'}:{background:rankTitleBgColorType=="渐变色背景"?"linear-gradient(180deg, ".concat(__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].hexColorToRgba(rankTitleBgColorFrom,1)," 0%, ").concat(__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].hexColorToRgba(rankTitleBgColorTo,1)," 100%), #FFFFFF"):'transparent'};return rankList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-product-layout-more",key:"rank-".concat(index),style:{marginBottom:index===rankList.length-1?0:"".concat(layout.itemMargin,"px"),backgroundColor:rankTitleBg,backgroundImage:rankBgImage?"url(".concat(rankBgImage,")"):'none'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-title",style:_objectSpread({color:titleTxtColor||'#333'},titleStyle)},rankTitleBgColorType=="图片背景"&&titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].formatImgUrl(titleBgImage,_this2.props.webpSupport),alt:"",className:"title-image"// style={{
//   height
// }}
}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"title-content ".concat(rankTitleBgColorType=="图片背景"&&titleBgImage?'absolute':'static'," ").concat(baseConfig.showTitle?'show':'hide')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"icon-name"},item.titleIconImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:item.titleIconImage,alt:"",className:"icon"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"name"},item.top_name)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"more",onClick:_this2.handleMoreClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null,"\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("svg",{t:"1658131192314",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1187",className:_this2.isAndroid?'more-icon android':'more-icon ios'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"1188",fill:titleTxtColor||'#333333'})))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-body"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-scroll"},item.good_list&&item.good_list.map(function(item2,index2){if(index2<=6){var rankTagIcon='',sell_number='';if(index2===0){rankTagIcon=rankTagTop1||rankTagCommon;}else if(index2===1){rankTagIcon=rankTagTop2||rankTagCommon;}else if(index2===2){rankTagIcon=rankTagTop3||rankTagCommon;}else{rankTagIcon=rankTagCommon;}if(showSales){if(item2.sell_number){sell_number=item2.sell_number>9999?"\u6708\u9500".concat((item2.sell_number/10000).toFixed(1),"w"):"\u6708\u9500".concat(item2.sell_number);}else{sell_number='爆品热卖';}}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this2.props.exp&&_this2.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].getExposureData(_this2.props,{title:item2.good_title,sort:index2,goods_id:item2.GoodsId,style_id:item2.StyleId,topic_id:item.top_id})),className:"goods-item",key:"goods-".concat(index2),style:{backgroundImage:productBgImage?"url(".concat(productBgImage,")"):'none',border:productBgImage&&'none',backgroundColor:productBgImage&&"transparent"},onClick:_this2.handleItemClick.bind(_this2,item,item2,index2)},rankTagIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:rankTagIcon,alt:"",className:"rank-tag"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])('92px'),height:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])('92px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].formatImgUrl(item2.img,_this2.props.webpSupport,'card')}),showSales&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"sales"},sell_number)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"goods-item-title",style:{color:productNameColor}},item2.good_title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-item-bottom"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-item-originalprice",style:{color:priceTxtColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",null,"\u5230\u624B\u4EF7:")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-item-price ".concat(_this2.isAndroid?'android':'ios'),style:{color:priceNumColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:String(parseFloat(item2.price_text)).length>5?'long':'small'},parseFloat(item2.price_text)))));}}))));});}// 商品榜单一行三
},{key:"renderProductLayoutThree",value:function renderProductLayoutThree(){var _this3=this;var rankList=this.state.rankList;var _this$props$config3=this.props.config,baseConfig=_this$props$config3.baseConfig,rankProductConfig_layout_3=_this$props$config3.rankProductConfig_layout_3;var _baseConfig$layout2=baseConfig.layout,layout=_baseConfig$layout2===void 0?{}:_baseConfig$layout2;var rankTitleBgColorType=rankProductConfig_layout_3.rankTitleBgColorType,rankOnlyTitleBg=rankProductConfig_layout_3.rankOnlyTitleBg,rankTitleBgColorFrom=rankProductConfig_layout_3.rankTitleBgColorFrom,rankTitleBgColorTo=rankProductConfig_layout_3.rankTitleBgColorTo,rankTitleBg=rankProductConfig_layout_3.rankTitleBg,titleTxtColor=rankProductConfig_layout_3.titleTxtColor,productNameColor=rankProductConfig_layout_3.productNameColor,benefitTxtColor=rankProductConfig_layout_3.benefitTxtColor,showNumber=rankProductConfig_layout_3.showNumber,rankBgImage=rankProductConfig_layout_3.rankBgImage,titleBgImage=rankProductConfig_layout_3.titleBgImage,productBgImage=rankProductConfig_layout_3.productBgImage,rankTagTop1=rankProductConfig_layout_3.rankTagTop1,rankTagTop2=rankProductConfig_layout_3.rankTagTop2,rankTagTop3=rankProductConfig_layout_3.rankTagTop3,rankTagCommon=rankProductConfig_layout_3.rankTagCommon;var titleStyle=rankTitleBgColorType=="纯色背景"?{backgroundColor:rankTitleBgColorType=="纯色背景"?rankOnlyTitleBg:'transparent'}:{background:rankTitleBgColorType=="渐变色背景"?"linear-gradient(180deg, ".concat(__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].hexColorToRgba(rankTitleBgColorFrom,1)," 0%, ").concat(__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].hexColorToRgba(rankTitleBgColorTo,1)," 100%), #FFFFFF"):'transparent'};return rankList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-product-layout-three",key:"rank-".concat(index),style:{marginBottom:index===rankList.length-1?0:"".concat(layout.itemMargin,"px"),backgroundColor:rankTitleBg,backgroundImage:rankBgImage?"url(".concat(rankBgImage,")"):'none'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-title",style:_objectSpread({color:titleTxtColor||'#333'},titleStyle)},rankTitleBgColorType=="图片背景"&&titleBgImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].formatImgUrl(titleBgImage,_this3.props.webpSupport),alt:"",className:"title-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:rankTitleBgColorType=="图片背景"&&titleBgImage?'title-content absolute':'title-content static'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"icon-name"},item.titleIconImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:item.titleIconImage,alt:"",className:"icon"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"name"},item.top_name)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"more",onClick:_this3.handleMoreClick.bind(_this3,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null,"\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("svg",{t:"1658131192314",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1187",className:"more-icon"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"1188",fill:titleTxtColor||'#333333'})))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("ul",{className:"rank-body"},item.good_list&&item.good_list.map(function(item2,index2){showNumber=Number(item.showNumber)||showNumber;if(index2<showNumber){var rankTagIcon='';if(index2===0){rankTagIcon=rankTagTop1||rankTagCommon;}else if(index2===1){rankTagIcon=rankTagTop2||rankTagCommon;}else if(index2===2){rankTagIcon=rankTagTop3||rankTagCommon;}else{rankTagIcon=rankTagCommon;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].getExposureData(_this3.props,{title:item2.good_title,sort:index2,goods_id:item2.GoodsId,style_id:item2.StyleId,topic_id:item.top_id})),className:"goods-item",key:"goods-".concat(index2),style:{backgroundImage:productBgImage?"url(".concat(productBgImage,")"):'none',border:productBgImage&&'none',backgroundColor:productBgImage&&"transparent"},onClick:_this3.handleItemClick.bind(_this3,item,item2,index2)},rankTagIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:rankTagIcon,alt:"",className:"rank-tag"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])('92px'),height:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])('92px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].formatImgUrl(item2.img,_this3.props.webpSupport,'card')})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"goods-item-title",style:{color:productNameColor}},item2.good_title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"goods-item-desc",style:{color:benefitTxtColor}},item2.description));}})));});}// 集合榜单一行二
},{key:"renderCollectLayoutTwo",value:function renderCollectLayoutTwo(){var _this4=this;var rankList=this.state.rankList;var _this$props$config4=this.props.config,baseConfig=_this$props$config4.baseConfig,rankCollectConfig_layout_2=_this$props$config4.rankCollectConfig_layout_2;var _baseConfig$layout3=baseConfig.layout,layout=_baseConfig$layout3===void 0?{}:_baseConfig$layout3;var rankTitleBg=rankCollectConfig_layout_2.rankTitleBg,titleTxtColor=rankCollectConfig_layout_2.titleTxtColor,benefitTxtColor=rankCollectConfig_layout_2.benefitTxtColor,productBgImage=rankCollectConfig_layout_2.productBgImage,productBtnImage=rankCollectConfig_layout_2.productBtnImage;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-collect-layout-two"},rankList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("li",{className:"rank-item",key:"rank-".concat(index),style:{backgroundImage:productBgImage?"url(".concat(productBgImage,")"):"url(//static.shihuocdn.cn/admin/files/20220715/d9c2fb5aaebf9889c7cc3c711321d32b.png)"},onClick:_this4.handleMoreClick.bind(_this4,item,index)},item.rankTagImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:item.rankTagImage,alt:"",className:"rank-tag"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:item.rankImage,alt:"",className:"rank-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"rank-title",style:{color:titleTxtColor}},item.top_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"rank-desc",style:{color:benefitTxtColor}},item.benefit),productBtnImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{className:"rank-btn",src:productBtnImage})));}));}// 集合榜单一行三
},{key:"renderCollectLayoutThree",value:function renderCollectLayoutThree(){var _this5=this;var rankList=this.state.rankList;var _this$props$config5=this.props.config,baseConfig=_this$props$config5.baseConfig,rankCollectConfig_layout_3=_this$props$config5.rankCollectConfig_layout_3;var _baseConfig$layout4=baseConfig.layout,layout=_baseConfig$layout4===void 0?{}:_baseConfig$layout4;var rankTitleBg=rankCollectConfig_layout_3.rankTitleBg,titleTxtColor=rankCollectConfig_layout_3.titleTxtColor,benefitTxtColor=rankCollectConfig_layout_3.benefitTxtColor,productBgImage=rankCollectConfig_layout_3.productBgImage,productBtnImage=rankCollectConfig_layout_3.productBtnImage;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-collect-layout-three"},rankList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("li",{className:"rank-item",key:"rank-".concat(index),style:{backgroundImage:productBgImage?"url(".concat(productBgImage,")"):"url(//static.shihuocdn.cn/admin/files/20220715/6668f880553e31aba9bbe3eeb66cfee0.png)"},onClick:_this5.handleMoreClick.bind(_this5,item,index)},item.rankTagImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:item.rankTagImage,alt:"",className:"rank-tag"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:item.rankImage,alt:"",className:"rank-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"rank-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"rank-title",style:{color:titleTxtColor}},item.top_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"rank-desc",style:{color:benefitTxtColor}},item.benefit),productBtnImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{className:"rank-btn",src:productBtnImage})));}));}},{key:"render",value:function render(){var _this$props$config6=this.props.config,componentTemplate=_this$props$config6.componentTemplate,baseConfig=_this$props$config6.baseConfig;var showTitle=baseConfig.showTitle,title=baseConfig.title,subTitle=baseConfig.subTitle,titleColor=baseConfig.titleColor,_baseConfig$layout5=baseConfig.layout,layout=_baseConfig$layout5===void 0?{}:_baseConfig$layout5,rankTitleBgImage=baseConfig.rankTitleBgImage;if(!componentTemplate){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",_extends({className:"pipeline-rank",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:layout.moduleMarginTop>=0?"".concat(layout.moduleMarginTop,"px"):0,marginTop:layout.moduleMarginTop<0?"".concat(layout.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),baseConfig.imgUrl&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{className:"rank-banner",onClick:this.productBannerGo.bind(this,baseConfig.imgLink),src:__WEBPACK_IMPORTED_MODULE_29__utils_utils__["a" /* default */].formatImgUrl(baseConfig.imgUrl,this.props.webpSupport)}),componentTemplate.templateSelect==='商品榜单一行多'&&this.renderProductLayoutMore(),componentTemplate.templateSelect==='商品榜单一行三'&&this.renderProductLayoutThree(),componentTemplate.templateSelect==='榜单集合一行二'&&this.renderCollectLayoutTwo(),componentTemplate.templateSelect==='榜单集合一行三'&&this.renderCollectLayoutThree());}}]);return PipelineRank;}(__WEBPACK_IMPORTED_MODULE_26_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelineRank);

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_SHCard_SHCard__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineRecommend=/*#__PURE__*/function(_Component){_inherits(PipelineRecommend,_Component);var _super=_createSuper(PipelineRecommend);function PipelineRecommend(props){var _this;_classCallCheck(this,PipelineRecommend);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"updateMasonryLayout",function(){var isRefreshing=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var addedCount=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;if(!_this.scrollerViewRef){return;}var doLayout=function doLayout(){if(!_this.masonry){_this.masonry=new _this.MasonryClass(_this.scrollerViewRef,{itemSelector:'.goods-card',// 要布局的网格元素
fitWidth:true,// 设置网格容器宽度等于网格宽度
gutter:9,transitionDuration:0});if(_this.scrollerViewRef){_this.scrollerViewRef.style.opacity=1;}}else{if(isRefreshing||!addedCount){_this.masonry.reloadItems();_this.masonry.layout();}else{var allItems=_this.scrollerViewRef.querySelectorAll('.goods-card');var newElems=Array.prototype.slice.call(allItems,-addedCount);if(newElems&&newElems.length){_this.masonry.appended(newElems);}_this.masonry.layout();}}};if(_this.MasonryClass){doLayout();return;}__webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 152)).then(function(Masonry){_this.MasonryClass=Masonry;doLayout();});});_defineProperty(_assertThisInitialized(_this),"updateListHeight",function(){if(_this.containerRef){var height=_this.containerRef.clientHeight;if(height&&height!==_this.state.listHeight){_this.setState({listHeight:height});}}else if(typeof window!=='undefined'){var _height=window.innerHeight;if(_height&&_height!==_this.state.listHeight){_this.setState({listHeight:_height});}}});_this.state={recommends:[],hasMore:true,listHeight:600};_this.refreshHideTimer=null;_this.masonry=null;_this.MasonryClass=null;_this.containerRef=null;_this.scrollerViewRef=null;_this.isAndroid=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].isAndroid();return _this;}_createClass(PipelineRecommend,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(typeof window!=='undefined'){var recommends=this.props.recommends;this.setState({recommends:recommends},function(){if(_this2.state.recommends.length>0){_this2.updateMasonryLayout(true,_this2.state.recommends.length);}});window.addEventListener('resize',this.updateListHeight,false);}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;if(JSON.stringify(nextProps.recommends)!==JSON.stringify(this.props.recommends)){var addedCount=Array.isArray(nextProps.recommends)?nextProps.recommends.length:0;var newRecommends=nextProps.isRefreshing?nextProps.recommends:[].concat(_toConsumableArray(this.state.recommends),_toConsumableArray(nextProps.recommends));this.setState(function(prevState){return{recommends:newRecommends};},function(){if(_this3.state.recommends.length>0){_this3.updateMasonryLayout(nextProps.isRefreshing,addedCount);}});}if(!nextProps.hasMore){var opacity=this.scrollerViewRef.style.opacity;if(opacity==0){this.scrollerViewRef.style.opacity=1;}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(typeof window!=='undefined'){window.removeEventListener('resize',this.updateListHeight,false);}if(this.refreshHideTimer){clearTimeout(this.refreshHideTimer);this.refreshHideTimer=null;}if(this.masonry){this.masonry.destroy();this.masonry=null;}}},{key:"getTrackData",value:function getTrackData(item,index){var goods_id=item.goods_id,style_id=item.style_id,sku_id=item.sku_id,goods_sku_id=item.goods_sku_id;var options={sort:index,name:item.name,goods_id:goods_id,style_id:style_id,sku_id:sku_id,goods_sku_id:goods_sku_id};return options;}},{key:"render",value:function render(){var _this4=this;var recommends=this.state.recommends;var _this$props=this.props,isLogin=_this$props.isLogin,showEmpty=_this$props.showEmpty,_this$props$pageOptio=_this$props.pageOptions,pageOptions=_this$props$pageOptio===void 0?{}:_this$props$pageOptio;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"pipeline-recommend",ref:function ref(_ref2){_this4.containerRef=_ref2;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{ref:function ref(_ref){return _this4.scrollerViewRef=_ref;},className:"scroller-container",style:{margin:showEmpty?"0":'0 12px'}},recommends&&recommends.length>0&&recommends.map(function(item,index){var component=item.component,item_type=item.item_type,_item$price_datas=item.price_datas,price_datas=_item$price_datas===void 0?[]:_item$price_datas,_item$v_datas=item.v_datas,v_datas=_item$v_datas===void 0?[]:_item$v_datas;var price_label_text=price_datas.map(function(item){return item&&item.item_datas&&item.item_datas[0]&&item.item_datas[0].text;}).filter(Boolean).join(',')||'';var tag_label_text=v_datas.map(function(item){return item&&item.item_datas&&item.item_datas[0]&&item.item_datas[0].text;}).filter(Boolean).join(',')||'';var biz={goods_id:item.goods_id,style_id:item.style_id,set_id:pageOptions['collectionId'],type:item_type=='COLLECTION_NOTE_CARD'?'note':'goods',component:component,price_label_text:price_label_text,tag_label_text:tag_label_text};var track_fields={};if(item.track_fields&&item.track_fields instanceof Object){track_fields=item.track_fields;}var h5_exposure_object={id:"goodsSet:list:".concat(index+1),name:'',href:item.href,pageOptions:_objectSpread(_objectSpread({},pageOptions),biz),biz:JSON.stringify(_objectSpread(_objectSpread(_objectSpread({},pageOptions),biz),track_fields)),exposekey:"goodsSet:list:".concat(index+1),exposekey_self:item.expose_key||''};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{key:"list-".concat(index+1),style:{position:'relative'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__lib_SHCard_SHCard__["a" /* SHCard */],{key:"list-".concat(index+1,"-").concat(item.goods_id),type:component,isDark:false,isLogin:isLogin,dataSource:item,h5_exposure_object:h5_exposure_object,exp:_this4.props.exp,onPress:function onPress(){var ptiID="goodsSet:list:".concat(index+1);if(Object(__WEBPACK_IMPORTED_MODULE_22__lib_SHCard_SHCard__["b" /* isCardShowStyleList */])(item)){ptiID="goodsSet:list:".concat(index+1,"_0");}var ptiOptions={ptiId:ptiID,ptiName:'',bizExtra:_objectSpread(_objectSpread({},pageOptions),biz)};var options=_this4.getTrackData(item,index);__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,item.href,item.href,options,-1,_this4.props,false,ptiOptions);}}));})));}}]);return PipelineRecommend;}(__WEBPACK_IMPORTED_MODULE_21_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelineRecommend);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCardShowStyleList; });
/* unused harmony export getCardHeight */
/* unused harmony export getTags */
/* unused harmony export getVertHoriStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_px2dp_js__ = __webpack_require__(76);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var vCardWidth=typeof window!=='undefined'&&(window.innerWidth-Object(__WEBPACK_IMPORTED_MODULE_13__utils_px2dp_js__["c" /* px2dpSmall */])(12)*2-Object(__WEBPACK_IMPORTED_MODULE_13__utils_px2dp_js__["c" /* px2dpSmall */])(9))/2;function getCardComponentForName(name){switch(name){case'goods_common_vert_style_8':return{registeredWidgetObj:__webpack_require__(231)["default"],layoutType:2};// 新品频道新增A8卡片样式扁平卡
case'note_common_vert_style_3':return{registeredWidgetObj:__webpack_require__(233)["default"],layoutType:2};// 笔记流扁平卡卡片
case'goods_common_vert_flat_style_8':return{registeredWidgetObj:__webpack_require__(231)["default"],layoutType:2};// 新品频道新增A8卡片样式扁平卡
case'note_common_vert_flat_style_3':return{registeredWidgetObj:__webpack_require__(233)["default"],layoutType:2};// 笔记流扁平卡卡片
default:return{};}}var getCardHeight=function getCardHeight(data){var widgetWidth=arguments.length>1&&arguments[1]!==undefined?arguments[1]:vCardWidth;var _data$component=data.component,component=_data$component===void 0?'':_data$component;// 通用获取卡片高度方式
var registeredWidgetObj=getCardComponentForName(component).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.getWidgetHeight){return registeredWidgetObj.getWidgetHeight(data,widgetWidth);}console.log("getCardHeight 不支持的组件名: ",component);return 0;};var getTags=function getTags(dataSource){var _dataSource$component=dataSource.component,component=_dataSource$component===void 0?'':_dataSource$component;// 获取标签数据
var registeredWidgetObj=getCardComponentForName(component).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.getTags){return registeredWidgetObj.getTags(dataSource);}return{};};/// 获取卡片是一行一还是一行二    1: 一行一  2: 一行二
var getVertHoriStatus=function getVertHoriStatus(dataSource){var _dataSource$component2=dataSource.component,component=_dataSource$component2===void 0?'':_dataSource$component2;// 获取标签数据
var layoutType=getCardComponentForName(component);return layoutType?layoutType:0;};// 该卡片是否显示多配色
var isCardShowStyleList=function isCardShowStyleList(data){var _data$component2=data.component,component=_data$component2===void 0?'':_data$component2;// 通用获取卡片高度方式
var registeredWidgetObj=getCardComponentForName(component).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.showStyleList!=='undefined'){return registeredWidgetObj.showStyleList;}return false;};var SHCard=/*#__PURE__*/function(_Component){_inherits(SHCard,_Component);var _super=_createSuper(SHCard);function SHCard(props){_classCallCheck(this,SHCard);return _super.call(this,props);}_createClass(SHCard,[{key:"render",value:function render(){var _this$props=this.props,type=_this$props.type,icon=_this$props.icon,onPress=_this$props.onPress,getItemRef=_this$props.getItemRef;var view=null;var registeredWidgetObj=getCardComponentForName(type).registeredWidgetObj;if(registeredWidgetObj&&registeredWidgetObj.widget){var Widget=registeredWidgetObj.widget;view=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Widget,_extends({ref:function ref(_ref){return getItemRef&&getItemRef(_ref);}},this.props));return view;}return null;}}]);return SHCard;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);SHCard.propTypes={type:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//卡片类型
icon:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number]),//标题前的Icon
onPress:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片点击事件
onLongPress:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片长按
onlayout:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片layout
containRef:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,//卡片ref
image:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number]),//主图片
imageDesc:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//主图片上右下角的描述
title:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//标题
subTitle:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//副标题
price:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number]),//价格
couponTxt:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//优惠信息
discountTxt:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//折扣信息
desc:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,//右下角其他描述信息
goodsImgFadeDuration:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number// 图片展示是否需要渐变默认需要-1 不需要0
};SHCard.defaultProps={type:'goods_common_vert_flat_style_8',icon:null,onPress:function onPress(){},onlayout:function onlayout(){},onLongPress:function onLongPress(){},containRef:function containRef(){},image:null,imageDesc:'',title:'',subTitle:'',price:'',couponTxt:'',discountTxt:'',desc:'',goodsImgFadeDuration:-1};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_px2dp__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__ = __webpack_require__(232);
function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// 纯 Web 版价格视图组件，对齐 RN 版 SHCardPriceView 的 props 和逻辑
var styles=pageStyles;var SHCardPriceView=function SHCardPriceView(props){var isDark=props.isDark,price=props.price,kern=props.kern,_props$style=props.style,style=_props$style===void 0?{}:_props$style,_props$symbolStyle=props.symbolStyle,symbolStyle=_props$symbolStyle===void 0?{}:_props$symbolStyle,_props$mainPriceStyle=props.mainPriceStyle,mainPriceStyle=_props$mainPriceStyle===void 0?{}:_props$mainPriceStyle,_props$dotPriceStyle=props.dotPriceStyle,dotPriceStyle=_props$dotPriceStyle===void 0?{}:_props$dotPriceStyle,_props$unitPirceStyle=props.unitPirceStyle,unitPirceStyle=_props$unitPirceStyle===void 0?{}:_props$unitPirceStyle;var _handlePrice=Object(__WEBPACK_IMPORTED_MODULE_11__utils_utils__["b" /* handlePrice */])(price),_handlePrice$symbol=_handlePrice.symbol,symbol=_handlePrice$symbol===void 0?'¥':_handlePrice$symbol,_handlePrice$mainPric=_handlePrice.mainPrice,mainPrice=_handlePrice$mainPric===void 0?'':_handlePrice$mainPric,_handlePrice$dotPrice=_handlePrice.dotPrice,dotPrice=_handlePrice$dotPrice===void 0?'':_handlePrice$dotPrice,_handlePrice$unitPric=_handlePrice.unitPrice,unitPrice=_handlePrice$unitPric===void 0?'':_handlePrice$unitPric;styles=Object(__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["b" /* getColorSchemeStyle */])(pageStyles,isDark);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"price-view",style:_objectSpread(_objectSpread({},styles.main),style)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"symbol",style:_objectSpread(_objectSpread({},styles.symbol),symbolStyle)},symbol),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"main-price",style:_objectSpread(_objectSpread(_objectSpread({},styles.mainPrice),mainPriceStyle),{},{marginLeft:kern})},mainPrice),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"dot-price",style:_objectSpread(_objectSpread({},styles.dotPrice),dotPriceStyle)},dotPrice),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"unit-price",style:_objectSpread(_objectSpread({},styles.unitPirce),unitPirceStyle)},unitPrice));};var pageStyles={main:{flexDirection:'row'},symbol:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(12),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333},mainPrice:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(18),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333},dotPrice:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(13),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333},unitPirce:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(12),fontFamily:'HelveticaNeue-CondensedBold',color:__WEBPACK_IMPORTED_MODULE_12__ColorSchemeV2__["a" /* DynamicColorValue */].dyc_333333}};SHCardPriceView.propTypes={price:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,fontSize:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,// 兼容 RN 版的 prop，当前未直接使用
symbolFontSize:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,// 兼容 RN 版
kern:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number};SHCardPriceView.defaultProps={price:'--',fontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(18),symbolFontSize:Object(__WEBPACK_IMPORTED_MODULE_10__utils_px2dp__["a" /* aiDp */])(12),kern:1};/* harmony default export */ __webpack_exports__["a"] = (SHCardPriceView);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getByteCount;
var tinyChar={" ":0.56,".":0.62,"f":0.68,"i":0.68,"j":0.68,"l":0.68,"r":0.66,"t":0.68};function getByteCount(str){var count=0;for(var i=0;i<str.length;i++){var c=str.charAt(i);var value=tinyChar[c];if(value!==undefined){count+=value;}else if(/^[\u0000-\u00ff]$/.test(c)){count+=1;}else{count+=2;}}return Math.ceil(count);}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineRecommendTopGoods=/*#__PURE__*/function(_Component){_inherits(PipelineRecommendTopGoods,_Component);var _super=_createSuper(PipelineRecommendTopGoods);function PipelineRecommendTopGoods(props){var _this;_classCallCheck(this,PipelineRecommendTopGoods);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getRankList",function(){var itemList=_this.props.config.itemList;var idList=itemList.map(function(item){return item.id?item.id:'0';});__WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-goodsinnerapi/api/inner/top/info?access_token=WphjwI564K8kzs5JQZ',method:"post",withCredentials:true,data:{topListIds:idList}}).then(function(res){if(res.data.status===0){var list=res.data.data||[];// 插入定制化内容
list.forEach(function(product){var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem){product.custom_title=customItem.name;product.custom_recommend=customItem.recommend;}});_this.setState({recommendList:list});}});});_defineProperty(_assertThisInitialized(_this),"getProductListData",function(){var itemList=_this.props.config.itemList;var idList=itemList.map(function(item){return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";if(_this.props.config.baseConfig.productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else{reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}__WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js___default()({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:_this.props.config.baseConfig.sortType==='销量'?4:0,filter_subsidy:_this.props.config.baseConfig.shihuoSubsidy==='是'?1:0,from:_this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;// 插入定制化内容
list.forEach(function(product){var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem){product.custom_title=customItem.name;product.custom_recommend=customItem.recommend;}});_this.setState({recommendList:list});}});});_defineProperty(_assertThisInitialized(_this),"productBannerGo",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}var options={title:3};var convertUrl=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={title:3,sort:index,name:item.title};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.url,item.url,options,-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"handleRankClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={title:5,topic_id:item.id,sort:index};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.href,item.href,options,-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"lookMore",function(){_this.setState({more:true});});_defineProperty(_assertThisInitialized(_this),"renderGoods",function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{key:"recommend-goods-".concat(index),className:"goods-item",onClick:_this.handleItemClick.bind(_assertThisInitialized(_this),item,index),style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(_this.props.config.baseConfig.cardImage,_this.props.webpSupport),")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"goods-item-img",src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(item.image,_this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"goods-item-title"},item.custom_title||item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"goods-item-recommend"},item.custom_recommend||item.recommend,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210514/51ea82dcd9eb63f505155f9f4b78dbc4.png"})));});_defineProperty(_assertThisInitialized(_this),"renderRanks",function(item,index){var img=item.top_detail&&item.top_detail.length>0?item.top_detail[0].pic:'';return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{key:"recommend-ranks-".concat(index),className:"ranks-item",onClick:_this.handleRankClick.bind(_assertThisInitialized(_this),item,index),style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(_this.props.config.baseConfig.cardImage,_this.props.webpSupport),")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"ranks-item-img",src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(img,_this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"ranks-item-title"},item.custom_title||item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"ranks-item-recommend"},item.custom_recommend||''));});_this.state={recommendList:[],more:false};return _this;}_createClass(PipelineRecommendTopGoods,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.config.baseConfig.recommendType==='商品'){this.getProductListData();}if(this.props.config.baseConfig.recommendType==='榜单'){this.getRankList();}}// 获取排行榜信息
},{key:"render",value:function render(){var _this2=this;var baseConfig=this.props.config.baseConfig;var _this$state=this.state,recommendList=_this$state.recommendList,more=_this$state.more;var componentDivideLine=this.props.componentDivideLine;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({id:this.props.config.baseConfig.moduleId,className:"pipeline-recommendTopGoods",style:{backgroundColor:baseConfig.bgColor}},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"title-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(this.props.config.baseConfig.titleImage,this.props.webpSupport),onClick:this.productBannerGo.bind(this,this.props.config.baseConfig.titleLink),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"recommend-body"},recommendList.map(function(item,index){if(!more){if(index<6){if(_this2.props.config.baseConfig.recommendType==='榜单'){return _this2.renderRanks(item,index);}if(_this2.props.config.baseConfig.recommendType==='商品'){return _this2.renderGoods(item,index);}}}else{if(_this2.props.config.baseConfig.recommendType==='榜单'){return _this2.renderRanks(item,index);}if(_this2.props.config.baseConfig.recommendType==='商品'){return _this2.renderGoods(item,index);}}})),!more&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"look-more",onClick:this.lookMore.bind(this)},"\u70B9\u51FB\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210514/77e488d1fb694f98dd76af9139fad6b4.png"})));}}]);return PipelineRecommendTopGoods;}(__WEBPACK_IMPORTED_MODULE_17_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelineRecommendTopGoods);

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSubsidy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSubsidy=/*#__PURE__*/function(_React$Component){_inherits(PipelineSubsidy,_React$Component);var _super=_createSuper(PipelineSubsidy);function PipelineSubsidy(props){var _this;_classCallCheck(this,PipelineSubsidy);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"productClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={name:item.title,sort:index};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}console.log(_this.props);__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.url,item.url,options,-1,_this.props);});_this.state={list:[]};return _this;}_createClass(PipelineSubsidy,[{key:"componentDidMount",value:function componentDidMount(){this.getProductData();}},{key:"getProductData",value:function getProductData(){var _this2=this;var itemList=this.props.config.itemList;var itemObjData={};var idList=itemList.map(function(item){if(item.id){itemObjData[item.id]=item;}return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";var productType=this.props.config.baseConfig.type;if(productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="配色id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="skuId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";}Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var dataList=res.data.data.List||[];dataList.forEach(function(product){try{var itemData=itemList.find(function(dataItem){return dataItem.id===product.id;});if(itemData){product.useCustomName=itemData.useCustomName;product.name=itemData.name;}}catch(error){var itemDataBeta=itemObjData[product.id];if(itemDataBeta){product.useCustomName=itemDataBeta.useCustomName;product.name=itemDataBeta.name;}}});_this2.setState({list:dataList});}});}},{key:"render",value:function render(){var _this3=this;var baseConfig=this.props.config.baseConfig;baseConfig.itemMargin=isNaN(Number(baseConfig.itemMargin))?0:Number(baseConfig.itemMargin);var rowItemNumber=3;// 每行数量个数
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-subsidy"},this.props['customAttributes'],{style:{paddingTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"title-wrapper"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"sub-title",style:{color:baseConfig.titleColor}},baseConfig.subTitle)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"subsidy-list"},this.state.list.map(function(item,index){// 计算折扣差价
var discount=Number(item.original_price)-Number(item.price);discount=parseInt(discount);if(discount<0||isNaN(discount)){discount=0;}// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(_this3.state.list.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(baseConfig.itemMargin/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.itemMargin/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.itemMargin/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.itemMargin/2,"px")};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"subsidy-item",key:index,onClick:_this3.productClick.bind(_this3,item,index),style:itemStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"img-container",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport),")")}}),Boolean(discount)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price-tip"},"\u76F4\u964D",discount,"\u5143"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"name"},item.useCustomName?item.name:item.title,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"fade-mask"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"price-addon"},"\u8865\u8D34\u4EF7"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price)));})));}}]);return PipelineSubsidy;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineSubsidy.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSubsidy);

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// import videojs from 'video.js/dist/video.min.js';
// import 'video.js/dist/video-js.css';
var PipelineVideo=/*#__PURE__*/function(_React$Component){_inherits(PipelineVideo,_React$Component);var _super=_createSuper(PipelineVideo);function PipelineVideo(props){var _this;_classCallCheck(this,PipelineVideo);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"loadVeplayerCss",function(){var link=document.createElement('link');link.rel='stylesheet';link.href='https://sh1.shihuocdn.cn/app/css/veplayer/veplayer.min.css';document.head.appendChild(link);});_defineProperty(_assertThisInitialized(_this),"loadVeplayerScript",function(url,callback){var script=document.createElement('script');script.src=url;// 添加加载完成的回调函数
script.onload=callback;document.body.appendChild(script);});_defineProperty(_assertThisInitialized(_this),"getPlayAuthToken",function(vid){return new Promise(function(resolve){// 调用您的接口获取新的 playAuthToken
Object(__WEBPACK_IMPORTED_MODULE_16__utils_request__["a" /* default */])({url:"https://upload.shihuo.cn/v1/media/getPlayToken",method:'get',withCredentials:true,headers:{platform:'h5'},params:{vid:vid,expire:300}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){resolve({playAuthToken:data.play_token// 新的 playAuthToken
});}});});});_this.state={isFullScreen:false};_this.playerSdk=null;_this.isFirstPlay=true;return _this;}_createClass(PipelineVideo,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(!window.VePlayer){this.loadVeplayerCss();this.loadVeplayerScript('https://sh1.shihuocdn.cn/app/js/veplayer/veplayer.min.js',function(){_this2.initVideo();});}else{this.initVideo();}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.playerState==='pause'){// 暂停播放
this.handleVideoPause();}else if(nextProps.playerState==='play'){if(this.playerSdk&&this.playerSdk.player&&this.playerSdk.player.state==6){// 继续播放
this.handleVideoPlay();}}}// 加载字节播放器css文件
},{key:"initVideo",value:// 初始化播放器
function(){var _initVideo=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this3=this;var videoInfo,_videoInfo$url,url,_videoInfo$poster,poster,_videoInfo$vid,vid,videoId,playOption,_yield$this$getPlayAu,playAuthToken;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:videoInfo=this.props.config.video;_videoInfo$url=videoInfo.url,url=_videoInfo$url===void 0?'':_videoInfo$url,_videoInfo$poster=videoInfo.poster,poster=_videoInfo$poster===void 0?'':_videoInfo$poster,_videoInfo$vid=videoInfo.vid,vid=_videoInfo$vid===void 0?'':_videoInfo$vid;videoId="".concat(this.props['customAttributes']['data-component-id']);playOption={};if(vid){_context.next=8;break;}Object.assign(playOption,{id:videoId,url:url,poster:"".concat(poster,"?imageslim|imageMogr2/interlace/1"),streamType:'mp4',autoplay:false,loop:false,fullscreen:{useCssFullscreen:true}});_context.next=13;break;case 8:_context.next=10;return this.getPlayAuthToken(vid);case 10:_yield$this$getPlayAu=_context.sent;playAuthToken=_yield$this$getPlayAu.playAuthToken;Object.assign(playOption,{id:videoId,poster:"".concat(poster,"?imageslim|imageMogr2/interlace/1"),streamType:'mp4',autoplay:false,loop:false,fullscreen:{useCssFullscreen:true},getVideoByToken:{playAuthToken:playAuthToken},onTokenExpired:function onTokenExpired(){return new Promise(function(resolve){// 调用您的接口获取新的 playAuthToken
Object(__WEBPACK_IMPORTED_MODULE_16__utils_request__["a" /* default */])({url:"https://upload.shihuo.cn/v1/media/getPlayToken",method:'get',withCredentials:true,headers:{platform:'h5'},params:{vid:vid,expire:300}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){resolve({playAuthToken:data.play_token// 新的 playAuthToken
});}});});}});case 13:this.playerSdk=new window.VePlayer(playOption);this.playerSdk.on('play',function(){// 视频开始播放埋点
if(_this3.isFirstPlay){var pageId=0;if(window.location.host==='zt-public.shihuo.cn'){pageId=window.location.pathname.split('/')[2];}// eslint-disable-next-line no-undef
__dace.sendEvent("pipeline-video",{id:pageId});__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].uploadTrack(_this3.props);_this3.isFirstPlay=false;}});case 15:case"end":return _context.stop();}}},_callee,this);}));function initVideo(){return _initVideo.apply(this,arguments);}return initVideo;}()// 获取PlayAuthToken
},{key:"disableFullScreenAuto",value:// 禁用自动全屏
function disableFullScreenAuto(){var videoTag=document.querySelector("#".concat(this.props['customAttributes']['data-component-id'])).getElementsByTagName('video');var video=videoTag&&videoTag[0];if(video){video.setAttribute('playsinline',true);video.setAttribute('x5-playsinline',true);video.setAttribute('webkit-playsinline',true);video.setAttribute('x5-video-player-type','h5-page');}}// 暂停播放
},{key:"handleVideoPause",value:function handleVideoPause(){var videoTag=document.querySelector("#".concat(this.props['customAttributes']['data-component-id'])).getElementsByTagName('video');var video=videoTag&&videoTag[0];if(video){video.pause();}}// 继续播放
},{key:"handleVideoPlay",value:function handleVideoPlay(){var videoTag=document.querySelector("#".concat(this.props['customAttributes']['data-component-id'])).getElementsByTagName('video');var video=videoTag&&videoTag[0];if(video){video.play();}}},{key:"render",value:function render(){var _this4=this;var baseConfig=this.props.config.baseConfig;var videoInfo=this.props.config.video;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",_extends({ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].getExposureData(this.props)),className:"pipeline-video"},this.props['customAttributes'],{style:{paddingTop:this.state.isFullScreen?'0':"".concat(Object(__WEBPACK_IMPORTED_MODULE_18__utils_px2rem__["a" /* default */])(baseConfig.moduleMarginTop+'px')),marginTop:baseConfig.moduleMarginTop<0?"".concat(Object(__WEBPACK_IMPORTED_MODULE_18__utils_px2rem__["a" /* default */])(baseConfig.moduleMarginTop+'px')):0,marginLeft:'auto',marginRight:'auto',marginBottom:this.props.showCompMarginBottom?'8px':'0px',width:baseConfig.width,height:baseConfig.height,overflow:'hidden'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"video-wrap",id:this.props['customAttributes']['data-component-id']}));}}]);return PipelineVideo;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);PipelineVideo.propTypes={config:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineVideo);

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_less__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;var voteStorageName='h5_localStorageVoteListMessage';var curDate=__WEBPACK_IMPORTED_MODULE_28_moment___default()(new Date().getTime()).format('YYYY/MM/DD');var PipelineImgList=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgList,_React$Component);var _super=_createSuper(PipelineImgList);function PipelineImgList(props){var _this;_classCallCheck(this,PipelineImgList);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getVoteResult",function(){var waitPromise=null;var options={url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',method:'get',withCredentials:true,params:{special_id:_this.pageId,vote_name:_this.props.customAttributes["data-component-id"]}};if(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()){waitPromise=__WEBPACK_IMPORTED_MODULE_25_axios___default()(options);}else{waitPromise=Object(__WEBPACK_IMPORTED_MODULE_26__utils_request__["a" /* default */])(options);}waitPromise.then(function(res){_this.voting=false;res=res.data;if(res.status==0){var _ref=res.data||{},has_vote=_ref.has_vote,_ref$vote_id=_ref.vote_id,vote_id=_ref$vote_id===void 0?[]:_ref$vote_id,_ref$count=_ref.count,count=_ref$count===void 0?{}:_ref$count;_this.setState({visible:true});if(!has_vote){return;}var _count$list=count.list,list=_count$list===void 0?[]:_count$list;var _this$props$config$co=_this.props.config.contentConfig,contentConfig=_this$props$config$co===void 0?{}:_this$props$config$co;var _ref2=contentConfig||{},_ref2$textType=_ref2.textType,textType=_ref2$textType===void 0?{}:_ref2$textType;var _ref3=textType||{},_ref3$optionList=_ref3.optionList,optionList=_ref3$optionList===void 0?[]:_ref3$optionList;optionList&&optionList.forEach(function(option,index){var cnt=0;list.forEach(function(item){if(index==item.vote_id){cnt=item.cnt;}});option.cnt=cnt;});_this.setState({has_vote:has_vote,vote_ids:vote_id});}});});_defineProperty(_assertThisInitialized(_this),"select",function(item,vote_id){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({props:_this.props});return;}var _this$state=_this.state,has_vote=_this$state.has_vote,vote_ids=_this$state.vote_ids;if(has_vote){return;}if(_this.voting){return;}var contentConfig=_this.props.config.contentConfig;var _ref4=contentConfig||{},_ref4$textType=_ref4.textType,textType=_ref4$textType===void 0?{}:_ref4$textType;var mode=textType.mode;var index=vote_ids.indexOf(vote_id);if(mode=='单选'){vote_ids=[vote_id];}else{if(index>=0){vote_ids.splice(index,1);}else{vote_ids.push(vote_id);}}_this.setState({vote_ids:vote_ids});});_defineProperty(_assertThisInitialized(_this),"vote",function(){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({props:_this.props});return;}__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this.props);var _this$state2=_this.state,has_vote=_this$state2.has_vote,vote_ids=_this$state2.vote_ids;if(has_vote){return;}if(_this.voting){return;}if(vote_ids.length==0){return;}_this.voting=true;var options={url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{special_id:_this.pageId,vote_id:vote_ids,vote_name:_this.props.customAttributes["data-component-id"]}};var waitPromise=null;if(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()){waitPromise=__WEBPACK_IMPORTED_MODULE_25_axios___default()(options);}else{waitPromise=Object(__WEBPACK_IMPORTED_MODULE_26__utils_request__["a" /* default */])(options);}waitPromise.then(function(res){if(res.data.status===0){_this.getVoteResult();}else{_this.voting=false;}});});_defineProperty(_assertThisInitialized(_this),"searchCurDataByPageId",function(){var curItem={pageId:_this.pageId,vote_name:_this.props.customAttributes["data-component-id"],vote_list:[{vote_id:[],//对应日期的已投的id
date:curDate,//投票的日期
nums:0//对应日期的投票的总次数
}]//按活动总周期：仅以 nums总和 作为判断 是否可继续投票的 标准，超出则不可继续投票
//按日：以 date + nums 作为判断 当天是否可继续投票，当天超出则不可继续投票
};_this.localVoteList&&_this.localVoteList.map(function(item){if(item.pageId==_this.pageId&&item.vote_name==_this.props.customAttributes["data-component-id"]){curItem=item;}});_this.curVoteData=curItem;});_defineProperty(_assertThisInitialized(_this),"getLocalStorage",function(){window&&window.Jockey.send("localstorage",{type:"get",data:{key:voteStorageName}},function(data){_this.localVoteList=data&&data[voteStorageName]?JSON.parse(data[voteStorageName]):[];// alert(JSON.stringify(this.localVoteList))
_this.searchCurDataByPageId();});var _this$props$config$co2=_this.props.config.contentConfig,contentConfig=_this$props$config$co2===void 0?{}:_this$props$config$co2;var _ref5=contentConfig||{},_ref5$imgType=_ref5.imgType,imgType=_ref5$imgType===void 0?{}:_ref5$imgType;var _ref6=imgType||{},_ref6$optionList=_ref6.optionList,optionList=_ref6$optionList===void 0?[]:_ref6$optionList,type=_ref6.type,nums=_ref6.nums;var time=_this.dealTime()||{};var start_ts=time.start_ts,end_ts=time.end_ts;var options={url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/count/v1?access_token=znSnA7pxO35wtPBaur',method:'get',withCredentials:true,params:{special_id:_this.pageId,vote_name:_this.props.customAttributes["data-component-id"],vote_type:type=='按活动总周期'?1:2,limit:nums,start_ts:start_ts,end_ts:end_ts}};var waitPromise=null;if(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()){waitPromise=__WEBPACK_IMPORTED_MODULE_25_axios___default()(options);}else{waitPromise=Object(__WEBPACK_IMPORTED_MODULE_26__utils_request__["a" /* default */])(options);}waitPromise.then(function(res){_this.voting=false;res=res.data;if(res.status==0){var _ref7=res.data||{},_ref7$list=_ref7.list,list=_ref7$list===void 0?[]:_ref7$list,can_vote=_ref7.can_vote,status=_ref7.status;// can_vote: 1 可投；0 不可投
// status: 0 正常可投；1 还未开始；2已经结束
optionList&&optionList.forEach(function(option,index){var cnt=0;var has_vote=0;list.forEach(function(item){var _item$vote_id=item.vote_id,vote_id=_item$vote_id===void 0?'':_item$vote_id;if(index==vote_id){cnt=item.cnt;has_vote=item.has_vote;//has_vote: 1已投；0未投
}});option.cnt=cnt;option.has_vote=has_vote;});// alert('optionList' + JSON.stringify(optionList))
_this.setState({visible:true,can_vote:can_vote,vote_status:status,optionList:optionList});}});});_defineProperty(_assertThisInitialized(_this),"setLocalStorage",function(value,vote_id){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({props:_this.props});return;}__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this.props);if(_this.voting){return;}var _this$props$config$co3=_this.props.config.contentConfig,contentConfig=_this$props$config$co3===void 0?{}:_this$props$config$co3;var _ref8=contentConfig||{},_ref8$imgType=_ref8.imgType,imgType=_ref8$imgType===void 0?{}:_ref8$imgType;var _ref9=imgType||{},type=_ref9.type,nums=_ref9.nums;_this.voting=true;var time=_this.dealTime()||{};var start_ts=time.start_ts,end_ts=time.end_ts;var options={url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/v1?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{special_id:_this.pageId,vote_id:vote_id,vote_name:_this.props.customAttributes["data-component-id"],vote_type:type=='按活动总周期'?1:2,limit:nums,start_ts:start_ts,end_ts:end_ts}};var waitPromise=null;if(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()){waitPromise=__WEBPACK_IMPORTED_MODULE_25_axios___default()(options);}else{waitPromise=Object(__WEBPACK_IMPORTED_MODULE_26__utils_request__["a" /* default */])(options);}waitPromise.then(function(res){if(res.data.status===0){// alert(JSON.stringify(value))
window&&window.Jockey.send("localstorage",{type:"set",data:_defineProperty({},voteStorageName,JSON.stringify(value))});_this.getLocalStorage();}else{_this.voting=false;window&&window.Jockey.send('toast',{text:res.data.msg});}});});var _props$config$content=props.config.contentConfig,showType=_props$config$content.showType,_props$config$content2=_props$config$content.imgType,_imgType=_props$config$content2===void 0?{}:_props$config$content2,_props$config$content3=_props$config$content.textType,_textType=_props$config$content3===void 0?{}:_props$config$content3;_this.state={has_vote:false,vote_ids:[],visible:!__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isShihuo(),//以下仅支持 图片形式投票
can_vote:0,//是否可投票: 0 不可，1 可
optionList:showType==='图片形式'?_imgType.optionList:_textType};_this.voting=false;_this.pageId='';_this.localVoteList=[];//本地存储的投票列表
_this.curVoteData={};return _this;}_createClass(PipelineImgList,[{key:"componentDidMount",value:function componentDidMount(){if(window&&window.location.host==='zt-public.shihuo.cn'){var arr=window.location.pathname.split('/');this.pageId=arr[arr.length-2];}var contentConfig=this.props.config.contentConfig;// 转为数字处理，后续参与计算
var isTextType=!contentConfig||contentConfig.showType=='文案形式';if(isTextType){this.getVoteResult();}else{this.getLocalStorage();}}},{key:"dealTime",value:function dealTime(){var _this$props$config$co4=this.props.config.contentConfig,contentConfig=_this$props$config$co4===void 0?{}:_this$props$config$co4;var _ref10=contentConfig||{},_ref10$imgType=_ref10.imgType,imgType=_ref10$imgType===void 0?{}:_ref10$imgType;var _ref11=imgType||{},startTime=_ref11.startTime,endTime=_ref11.endTime;if(!startTime||!endTime)return{};var startTimeStamp=null,endTimeStamp=null;startTime=startTime.replace('T',' ');endTime=endTime.replace('T',' ');startTimeStamp=Math.floor(new Date(startTime.replace(/-/g,'/')).getTime()/1000);endTimeStamp=Math.floor(new Date(endTime.replace(/-/g,'/')).getTime()/1000);var now=Math.floor(new Date().getTime()/1000);var time={now:now,start_ts:startTimeStamp,end_ts:endTimeStamp};if(startTime&&endTime&&now>=startTimeStamp&&now<=endTimeStamp){time.can_vote=1;}else if(startTime&&now<startTimeStamp){time.can_vote=2;}else if(endTime&&now>endTimeStamp){time.can_vote=3;}else{time.can_vote=4;}return time;}},{key:"renderTextTypeView",value:function renderTextTypeView(){var _this2=this;var _this$state3=this.state,has_vote=_this$state3.has_vote,vote_ids=_this$state3.vote_ids,visible=_this$state3.visible;if(!visible){return null;}var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,contentConfig=_this$props$config.contentConfig;if(!contentConfig&&baseConfig&&baseConfig.mode){contentConfig={showType:'文案形式',question:baseConfig.question,textType:{optionMargin:baseConfig.optionMargin,textColor:baseConfig.textColor,mode:baseConfig.mode,optionList:this.props.config.optionList||[]}};this.props.config.contentConfig=contentConfig;}var _ref12=baseConfig||{},moduleMarginTop=_ref12.moduleMarginTop,moduleMarginHorizon=_ref12.moduleMarginHorizon;var _ref13=contentConfig||{},_ref13$textType=_ref13.textType,textType=_ref13$textType===void 0?{}:_ref13$textType,question=_ref13.question;var _textType$optionList=textType.optionList,optionList=_textType$optionList===void 0?[]:_textType$optionList,textColor=textType.textColor,optionMargin=textType.optionMargin,mode=textType.mode;// 转为数字处理，后续参与计算
var isSingle=mode=='单选';var maxVoteNumItem=_toConsumableArray(optionList||[]).sort(function(item1,item2){return item2.cnt-item1.cnt;})[0]||{};var maxVoteNum=maxVoteNumItem.cnt||0;console.log('optionList',optionList);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",_extends({className:"pipeline-vote"},this.props['customAttributes'],{style:{paddingTop:moduleMarginTop>=0?"".concat(moduleMarginTop,"px"):0,marginTop:moduleMarginTop<0?"".concat(moduleMarginTop,"px"):0,marginLeft:"".concat(moduleMarginHorizon,"px"),marginRight:"".concat(moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),question&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"question",style:{color:textColor}},question),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"option-block"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"mode",style:{color:textColor}},"*",isSingle?'单选':'可多选'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"option-list"},optionList&&optionList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{onClick:_this2.select.bind(_this2,item,index),key:index,className:"option",style:{marginTop:+optionMargin-4+'px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"radio ".concat(isSingle?'single':''," ").concat(vote_ids.indexOf(index)>=0?'selected':'')}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"text",style:{color:textColor}},item.option),has_vote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"result"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"progress-content"},maxVoteNum>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"progress",style:{width:"".concat(item.cnt*100/maxVoteNum,"%")}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"num",style:{color:textColor}},item.cnt,"\u7968"))));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"vote-btn ".concat(has_vote?'voted':''),style:{margin:"".concat(optionMargin,"px auto 0 auto")},onClick:this.vote},has_vote?'已投票':'投票查看结果')));}},{key:"renderImgTypeView",value:function renderImgTypeView(){var _this3=this;var _this$state4=this.state,visible=_this$state4.visible,vote_status=_this$state4.vote_status,_this$state4$optionLi=_this$state4.optionList,optionList=_this$state4$optionLi===void 0?[]:_this$state4$optionLi;if(!visible){return null;}var _ref14=this.curVoteData||{},_ref14$vote_list=_ref14.vote_list,vote_list=_ref14$vote_list===void 0?[]:_ref14$vote_list;var backgroundColor=this.props.backgroundColor;var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,contentConfig=_this$props$config2.contentConfig;var _ref15=baseConfig||{},moduleMarginTop=_ref15.moduleMarginTop,moduleMarginHorizon=_ref15.moduleMarginHorizon;var _ref16=contentConfig||{},_ref16$imgType=_ref16.imgType,imgType=_ref16$imgType===void 0?{}:_ref16$imgType,question=_ref16.question;var _ref17=imgType||{},initShow=_ref17.initShow,textColor=_ref17.textColor,cardBgColor=_ref17.cardBgColor,btnBGColor=_ref17.btnBGColor,btnTextColor=_ref17.btnTextColor,type=_ref17.type,nums=_ref17.nums;var showVoteNum=true;//显示票数
var btnStatus=this.state.can_vote;//1 所有都可以点击，0投票已达到上限(所有按钮置灰)
var time=this.dealTime()||{};var afterTime=vote_status==2||time&&time.can_vote==3;//本机时间是否超出活动结束时间
// 转为数字处理，后续参与计算
if(type=='按活动总周期'){var total=0;vote_list&&vote_list.map(function(item){total+=item.nums;});if(total>=nums&&btnStatus==1){btnStatus=0;}if(initShow=='不显示'&&total==0){showVoteNum=afterTime;}}else if(type=='按日'){var curTotal=0;var _total=0;if(vote_list){for(var i=0;i<vote_list.length;i++){if(vote_list[i].date==curDate){curTotal=vote_list[i].nums;}_total+=vote_list[i].nums;}}if(curTotal>=nums&&btnStatus==1){btnStatus=0;}if(initShow=='不显示'&&_total==0){showVoteNum=afterTime;}}// if (initShow == '不显示' && (!vote_list || vote_list.length == 0)) {
//   showVoteNum = false
// }
var showCenter=!showVoteNum||afterTime;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",_extends({className:"pipeline-vote"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(moduleMarginHorizon,"px"),marginRight:"".concat(moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),question&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"question",style:{color:textColor}},question),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"option-list2"},optionList&&optionList.map(function(item,index){var img=item.img,updateNum=item.updateNum,has_vote=item.has_vote,_item$cnt=item.cnt,cnt=_item$cnt===void 0?0:_item$cnt;var num=(cnt||0)*1;if(updateNum&&updateNum*1!=0){num+=updateNum;}if(num<0){num=0;}var imgScale=1;//宽高比
var len=(img.split('_')||[]).length;var imgItem=len>0?img.split('_')[len-1].split('.')[0].split('x'):[];if(imgItem&&imgItem.length==2){var w=imgItem[0];var h=imgItem[1];if(w&&h){imgScale=w/h;}}var imgWidth=Math.floor((bodyWidth-9-moduleMarginHorizon*2)/2);var imgHeight=imgWidth/imgScale;var hasVoteStatus=has_vote||0;//当前选项是否已投票:0-未投；1-已投
if(type=='按活动总周期'&&vote_list&&hasVoteStatus==0){for(var _i=0;_i<vote_list.length;_i++){if(vote_list[_i].vote_id.indexOf(index)!=-1){hasVoteStatus=1;break;}}}else if(type=='按日'&&vote_list&&hasVoteStatus==0){for(var _i2=0;_i2<vote_list.length;_i2++){if(vote_list[_i2].date==curDate&&vote_list[_i2].vote_id.indexOf(index)!=-1){hasVoteStatus=1;break;}}}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"option-item",key:index,style:{backgroundColor:cardBgColor||backgroundColor,marginRight:index%2==0?'9px':0,width:imgWidth+'px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{className:"img",src:img,style:{height:imgHeight+'px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"bottom-container ".concat(showCenter?showVoteNum?'div4':'div1':!afterTime&&hasVoteStatus==0?'div2':'div3')},showVoteNum&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"num",style:{color:textColor||'#FFF'}},num,"\u7968"),afterTime?null:hasVoteStatus==0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"btn ".concat(showCenter?'big':'small'," ").concat(btnStatus==0?'selected':''),style:{backgroundColor:btnBGColor,color:btnTextColor||backgroundColor},onClick:function onClick(){if(btnStatus==0){if(vote_status==1){window&&window.Jockey.send('toast',{text:'投票尚未开始，请耐心等待～'});return;}if(vote_status==2){window&&window.Jockey.send('toast',{text:'投票已结束'});return;}window&&window.Jockey.send('toast',{text:'投票次数已用完哦~'});return;}var needAdd=true;if(_this3.curVoteData&&_this3.curVoteData.vote_list){for(var _i3=0;_i3<_this3.curVoteData.vote_list.length;_i3++){if(_this3.curVoteData.vote_list[_i3].date==curDate){needAdd=false;_this3.curVoteData.vote_list[_i3].vote_id.push(index);_this3.curVoteData.vote_list[_i3].nums=_this3.curVoteData.vote_list[_i3].nums+1;break;}}}if(needAdd){_this3.curVoteData={pageId:_this3.pageId,vote_name:_this3.props.customAttributes["data-component-id"],vote_list:[{vote_id:[index],//对应日期的已投的id
date:curDate,//投票的日期
nums:1//对应日期的投票的总次数
}]};}var isExit=false;_this3.localVoteList&&_this3.localVoteList.map(function(item,i){if(item.pageId==_this3.pageId&&item.vote_name==_this3.props.customAttributes["data-component-id"]){isExit=true;_this3.localVoteList[i]=_this3.curVoteData;}});if(!isExit){_this3.localVoteList.push(_this3.curVoteData);}_this3.setLocalStorage(_this3.localVoteList,index);}},vote_status==1?'即将开始':'投票'):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"voted"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("svg",{t:"1701262809645","class":"icon",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"4768",fill:textColor||'#FFF'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("path",{d:"M122.709333 492.032a51.2 51.2 0 0 1 66.218667-2.133333l6.144 5.717333 197.205333 217.941333 424.533334-442.965333a51.2 51.2 0 0 1 65.877333-6.826667l6.485333 5.290667a51.2 51.2 0 0 1 6.826667 65.877333l-5.290667 6.485334L428.373333 824.149333a51.2 51.2 0 0 1-69.12 4.437334l-5.802666-5.461334-234.24-258.730666a51.2 51.2 0 0 1 3.584-72.362667z","p-id":"4769"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("span",{className:"text",style:{color:textColor||'#FFF'}},"\u5DF2\u6295"))));})));}},{key:"render",value:function render(){var visible=this.state.visible;if(!visible){return null;}var contentConfig=this.props.config.contentConfig;// 转为数字处理，后续参与计算
var isTextType=!contentConfig||contentConfig.showType=='文案形式';if(isTextType)return this.renderTextTypeView();return this.renderImgTypeView();}}]);return PipelineImgList;}(__WEBPACK_IMPORTED_MODULE_22_react___default.a.Component);PipelineImgList.propTypes={config:__WEBPACK_IMPORTED_MODULE_23_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgList);

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var bind = __webpack_require__(234);
var Axios = __webpack_require__(410);
var mergeConfig = __webpack_require__(240);
var defaults = __webpack_require__(237);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(241);
axios.CancelToken = __webpack_require__(423);
axios.isCancel = __webpack_require__(236);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(424);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(425);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var buildURL = __webpack_require__(235);
var InterceptorManager = __webpack_require__(411);
var dispatchRequest = __webpack_require__(412);
var mergeConfig = __webpack_require__(240);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var transformData = __webpack_require__(413);
var isCancel = __webpack_require__(236);
var defaults = __webpack_require__(237);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(239);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(419);
var combineURLs = __webpack_require__(420);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(241);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgAnimate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_draggable__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_draggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineImgAnimate=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgAnimate,_React$Component);var _super=_createSuper(PipelineImgAnimate);function PipelineImgAnimate(props){var _this;_classCallCheck(this,PipelineImgAnimate);var clientWidth=375;if(typeof window!=='undefined'){clientWidth=window.document.body.clientWidth;}var screenRatio=clientWidth/375;_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"receivePostMessageFromEditor",function(event){var data=event.data||{};var msgType=data.msgType;if(msgType==='checkToBaseConfig'){_this.setState({dragMode:false});}if(msgType==='componentSelect'){var currentComponent=data.currentComponent;if(!currentComponent){return;}// 编辑器切换组件之后，根据postMessage返回id，确认是否当前组件来切换模式
if(currentComponent.id&&_this.props.customAttributes["data-component-block"].indexOf(currentComponent.id)>-1){_this.setState({dragMode:true});}else{_this.setState({dragMode:false});}}});_defineProperty(_assertThisInitialized(_this),"handleDragEnd",function(index,event,position){// 拖拽结束，将位置信息发送到编辑器
var data={left:String(position.x),top:String(position.y)};_this.updateDragItemMessage(data,index);});_defineProperty(_assertThisInitialized(_this),"handleItemResize",function(index,event){var itemEl=event.currentTarget;var data={width:String(itemEl.clientWidth),height:String(itemEl.clientHeight)};_this.updateDragItemMessage(data,index);});_defineProperty(_assertThisInitialized(_this),"updateDragItemMessage",function(data,index){if(typeof window!=='undefined'&&window.parent){try{window.parent.postMessage({componentId:_this.props.customAttributes["data-component-id"],msgType:'updateDrag',index:index,data:data},'*');}catch(err){console.log(err);}}});_defineProperty(_assertThisInitialized(_this),"transformPx",function(num){// 对单位进行转换
num=Number(num);if(isNaN(num)){num=0;}var realNum=Math.round(num*_this.screenRatio);return realNum;});_this.state={listHrefConfig:{},dragMode:false,// 当前模式，包括编辑和展示两种模式
isIframe:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getParams('isIframe')==1,inSwitchTabIndex:props.tabIndex||0};_this.screenRatio=screenRatio;_this.isIphoneX=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].isIphoneX();_this.dragEditorRef=null;// preloadImages(props);
return _this;}_createClass(PipelineImgAnimate,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(typeof window!=='undefined'&&window.self!==window.top){window.addEventListener('message',this.receivePostMessageFromEditor);}var _this$props$config$it=this.props.config.itemList,itemList=_this$props$config$it===void 0?[]:_this$props$config$it;__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){itemList.forEach(function(item,index){var svgaContainer=_this2.dragEditorRef&&_this2.dragEditorRef.querySelector(".svgaCanvas-".concat(index+1));if(svgaContainer){var player=new SVGA.Player(svgaContainer);var parser=new SVGA.Parser(svgaContainer);parser.load(item.src,function(videoItem){player.setVideoItem(videoItem);player.startAnimation();});}});});}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(typeof window!=='undefined'&&window.self!==window.top){window.removeEventListener('message',this.receivePostMessageFromEditor);}}},{key:"render",value:function render(){var _this3=this;var _this$state=this.state,isIframe=_this$state.isIframe,inSwitchTabIndex=_this$state.inSwitchTabIndex;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList,_this$props$config$co=_this$props$config.componentSize,componentSize=_this$props$config$co===void 0?{}:_this$props$config$co;var _utils$getAdaptImageS=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getAdaptImageSize(componentSize),width=_utils$getAdaptImageS.width,height=_utils$getAdaptImageS.height;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getExposureData(this.props)),className:"pipeline-imgAnimate",id:this.props['customAttributes']['data-component-id']},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"hot-map-editor"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component__["LazyLoadImage"],{className:"bg-img",width:"100%",style:{width:width,height:'auto'},visibleByDefault:isIframe,src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(baseConfig.backgroundImage,this.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"drag-editor-container",ref:function ref(_ref){return _this3.dragEditorRef=_ref;}},itemList.map(function(item,index){var imgSuffix=item.src&&item.src.split('.').pop().toLowerCase();var width=_this3.transformPx(item.width);var height=_this3.transformPx(item.height);var left=_this3.transformPx(item.left);var top=_this3.transformPx(item.top);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{key:"item_".concat(index),style:{width:'100%',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_draggable___default.a,{disabled:!_this3.state.dragMode,defaultPosition:{x:Number(left),y:Number(top)},bounds:"parent",handle:".handle",onStop:_this3.handleDragEnd.bind(_this3,index)},_this3.state.dragMode?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"edit-drag-item",style:{width:"".concat(width,"px"),height:"".concat(height,"px"),zIndex:index+100,borderColor:baseConfig.dragFrameColor},onClick:_this3.handleItemResize.bind(_this3,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"handle"}),imgSuffix==='svga'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"svgaCanvas-".concat(index+1),style:{width:"".concat(width,"px"),height:"".concat(height,"px")}}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"item-img",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.src,_this3.props.webpSupport),alt:""})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"preview-drag-item hide-border",style:{width:"".concat(width,"px"),height:"".concat(height,"px"),zIndex:index+100}},item.src&&(imgSuffix==='svga'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"svgaCanvas-".concat(index+1),style:{width:"".concat(width,"px"),height:"".concat(height,"px")}}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"item-img",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.src,_this3.props.webpSupport),alt:""})))));}))));}}]);return PipelineImgAnimate;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineImgAnimate.propTypes={config:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgAnimate);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DraggableCore", {
  enumerable: true,
  get: function get() {
    return _DraggableCore.default;
  }
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(15));

var _reactDom = _interopRequireDefault(__webpack_require__(115));

var _clsx2 = _interopRequireDefault(__webpack_require__(428));

var _domFns = __webpack_require__(172);

var _positionFns = __webpack_require__(242);

var _shims = __webpack_require__(137);

var _DraggableCore = _interopRequireDefault(__webpack_require__(430));

var _log = _interopRequireDefault(__webpack_require__(243));

var _excluded = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// Define <Draggable>
//
var Draggable = /*#__PURE__*/function (_React$Component) {
  _inherits(Draggable, _React$Component);

  var _super = _createSuper(Draggable);

  function Draggable(props
  /*: DraggableProps*/
  ) {
    var _this;

    _classCallCheck(this, Draggable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e, coreData) {
      (0, _log.default)('Draggable: onDragStart: %j', coreData); // Short-circuit if user's callback killed it.

      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.


      if (shouldStart === false) return false;

      _this.setState({
        dragging: true,
        dragged: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDrag", function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log.default)('Draggable: onDrag: %j', coreData);
      var uiData = (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        x: uiData.x,
        y: uiData.y
      }; // Keep within bounds.

      if (_this.props.bounds) {
        // Save original x and y.
        var x = newState.x,
            y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_assertThisInitialized(_this), newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.

        newState.slackX = _this.state.slackX + (x - newState.x);
        newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.

        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      } // Short-circuit if user's callback killed it.


      var shouldUpdate = _this.props.onDrag(e, uiData);

      if (shouldUpdate === false) return false;

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStop", function (e, coreData) {
      if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.

      var shouldContinue = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_assertThisInitialized(_this), coreData));

      if (shouldContinue === false) return false;
      (0, _log.default)('Draggable: onDragStop: %j', coreData);
      var newState
      /*: $Shape<DraggableState>*/
      = {
        dragging: false,
        slackX: 0,
        slackY: 0
      }; // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.

      var controlled = Boolean(_this.props.position);

      if (controlled) {
        var _this$props$position = _this.props.position,
            x = _this$props$position.x,
            y = _this$props$position.y;
        newState.x = x;
        newState.y = y;
      }

      _this.setState(newState);
    });

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,
      // Whether or not we have been dragged before.
      dragged: false,
      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,
      prevPropsPosition: _objectSpread({}, props.position),
      // Used for compensating for out-of-bounds drags
      slackX: 0,
      slackY: 0,
      // Can only determine if SVG after mounting
      isElementSVG: false
    };

    if (props.position && !(props.onDrag || props.onStop)) {
      // eslint-disable-next-line no-console
      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
    }

    return _this;
  }

  _createClass(Draggable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) {
        this.setState({
          isElementSVG: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: false
      }); // prevents invariant if unmounted while dragging
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: ReactElement<any>*/
    {
      var _clsx;

      var _this$props2 = this.props,
          axis = _this$props2.axis,
          bounds = _this$props2.bounds,
          children = _this$props2.children,
          defaultPosition = _this$props2.defaultPosition,
          defaultClassName = _this$props2.defaultClassName,
          defaultClassNameDragging = _this$props2.defaultClassNameDragging,
          defaultClassNameDragged = _this$props2.defaultClassNameDragged,
          position = _this$props2.position,
          positionOffset = _this$props2.positionOffset,
          scale = _this$props2.scale,
          draggableCoreProps = _objectWithoutProperties(_this$props2, _excluded);

      var style = {};
      var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.

      var controlled = Boolean(position);
      var draggable = !controlled || this.state.dragging;
      var validPosition = position || defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
      }; // If this element was SVG, we use the `transform` attribute.

      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
      } // Mark with class while dragging


      var className = (0, _clsx2.default)(children.props.className || '', defaultClassName, (_clsx = {}, _defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), _defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)

      return /*#__PURE__*/React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /*#__PURE__*/React.cloneElement(React.Children.only(children), {
        className: className,
        style: _objectSpread(_objectSpread({}, children.props.style), style),
        transform: svgTransform
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: // React 16.3+
    // Arity (props, state)
    function getDerivedStateFromProps(_ref, _ref2)
    /*: ?$Shape<DraggableState>*/
    {
      var position = _ref.position;
      var prevPropsPosition = _ref2.prevPropsPosition;

      // Set x/y if a new position is provided in props that is different than the previous.
      if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
        (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
          position: position,
          prevPropsPosition: prevPropsPosition
        });
        return {
          x: position.x,
          y: position.y,
          prevPropsPosition: _objectSpread({}, position)
        };
      }

      return null;
    }
  }]);

  return Draggable;
}(React.Component);

exports.default = Draggable;

_defineProperty(Draggable, "displayName", 'Draggable');

_defineProperty(Draggable, "propTypes", _objectSpread(_objectSpread({}, _DraggableCore.default.propTypes), {}, {
  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes.default.oneOfType([_propTypes.default.shape({
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    bottom: _propTypes.default.number
  }), _propTypes.default.string, _propTypes.default.oneOf([false])]),
  defaultClassName: _propTypes.default.string,
  defaultClassNameDragging: _propTypes.default.string,
  defaultClassNameDragged: _propTypes.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),
  positionOffset: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
}));

_defineProperty(Draggable, "defaultProps", _objectSpread(_objectSpread({}, _DraggableCore.default.defaultProps), {}, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: {
    x: 0,
    y: 0
  },
  scale: 1
}));

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["default"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports.default = void 0;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];

function getPrefix()
/*: string*/
{
  var _window$document, _window$document$docu;

  var prop
  /*: string*/
  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
  // Ensure we're running in an environment where there is actually a global
  // `window` obj
  if (typeof window === 'undefined') return ''; // If we're in a pseudo-browser server-side environment, this access
  // path may not exist, so bail out if it doesn't.

  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style) return '';
  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}

function browserPrefixToStyle(prop
/*: string*/
, prefix
/*: string*/
)
/*: string*/
{
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}

function kebabToTitleCase(str
/*: string*/
)
/*: string*/
{
  var out = '';
  var shouldCapitalize = true;

  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }

  return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`


var _default = (getPrefix()
/*: string*/
);

exports.default = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(15));

var _reactDom = _interopRequireDefault(__webpack_require__(115));

var _domFns = __webpack_require__(172);

var _positionFns = __webpack_require__(242);

var _shims = __webpack_require__(137);

var _log = _interopRequireDefault(__webpack_require__(243));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Simple abstraction for dragging events names.
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
}; // Default to mouse events.

var dragEventFor = eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/

/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/

/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/

/*:: export type ControlPosition = {x: number, y: number};*/

/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/

/*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/

/*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/

//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var DraggableCore = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  var _super = _createSuper(DraggableCore);

  function DraggableCore() {
    var _this;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e); // Only accept left-clicks.


      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)

      var thisNode = _this.findDOMNode();

      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }

      var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      } // Prevent scrolling on mobile devices, like ipad/iphone.
      // Important that this is after handle/cancel.


      if (e.type === 'touchstart') e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.

      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);

      _this.setState({
        touchIdentifier: touchIdentifier
      }); // Get the current drag point from the event. This is used as the offset.


      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return; // not possible but satisfies flow

      var x = position.x,
          y = position.y; // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent); // Call event handler. If it returns explicit false, cancel.

      (0, _log.default)('calling', _this.props.onStart);

      var shouldUpdate = _this.props.onStart(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.

      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.

      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.


      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrag", function (e) {
      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y; // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX,
            deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY) return; // skip useless drag

        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y);
      (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent); // Call event handler. If it returns explicit false, trigger end.

      var shouldUpdate = _this.props.onDrag(e, coreEvent);

      if (shouldUpdate === false || _this.mounted === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents')
          /*: any*/
          )
          /*: MouseTouchEvent*/
          ); // I see why this insanity was deprecated
          // $FlowIgnore

          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

          _this.handleDragStop(event);
        }

        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragStop", function (e) {
      if (!_this.state.dragging) return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized(_this));
      if (position == null) return;
      var x = position.x,
          y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized(_this), x, y); // Call event handler

      var shouldContinue = _this.props.onStop(e, coreEvent);

      if (shouldContinue === false || _this.mounted === false) return false;

      var thisNode = _this.findDOMNode();

      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent); // Reset the el.

      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      if (thisNode) {
        // Remove event handlers
        (0, _log.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function (e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });

    return _this;
  }

  _createClass(DraggableCore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention

      var thisNode = this.findDOMNode();

      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.

      var thisNode = this.findDOMNode();

      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.

  }, {
    key: "findDOMNode",
    value: function findDOMNode()
    /*: ?HTMLElement*/
    {
      var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;

      return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render()
    /*: React.Element<any>*/
    {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return /*#__PURE__*/React.cloneElement(React.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(React.Component);

exports.default = DraggableCore;

_defineProperty(DraggableCore, "displayName", 'DraggableCore');

_defineProperty(DraggableCore, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props
  /*: DraggableCoreProps*/
  , propName
  /*: $Keys<DraggableCoreProps>*/
  ) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes.default.string,

  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: _propTypes.default.object,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes.default.func,

  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: _propTypes.default.number,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});

_defineProperty(DraggableCore, "defaultProps", {
  allowAnyClick: false,
  // by default only accept left click
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {},
  scale: 1
});

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgHotMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_draggable__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_draggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pipeline_modal__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__style_less__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_px2rem__ = __webpack_require__(42);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */// import { LazyLoadImage } from 'react-lazy-load-image-component';
var PipelineImgHotMap=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgHotMap,_React$Component);var _super=_createSuper(PipelineImgHotMap);function PipelineImgHotMap(props){var _this;_classCallCheck(this,PipelineImgHotMap);var clientWidth=375;if(typeof window!=='undefined'){clientWidth=window.document.body.clientWidth;}var screenRatio=clientWidth/375;_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"receivePostMessageFromEditor",function(event){var data=event.data||{};var msgType=data.msgType;if(msgType==='checkToBaseConfig'){_this.setState({dragMode:false});}if(msgType==='componentSelect'){var currentComponent=data.currentComponent;if(!currentComponent){return;}// 编辑器切换组件之后，根据postMessage返回id，确认是否当前组件来切换模式
if(currentComponent.id&&_this.props.customAttributes["data-component-block"].indexOf(currentComponent.id)>-1){_this.setState({dragMode:true});}else{_this.setState({dragMode:false});}}});_defineProperty(_assertThisInitialized(_this),"getProductInfo",function(){var promiseList=_this.props.config.itemList.map(function(item,index){var promiseItem;if(item.linkType==='链接跳转'){promiseItem={index:index,href:item.link};}else{var reqUrl='';if(item.linkType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else if(item.linkType==="配色id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}else if(item.linkType==="skuId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";}promiseItem=new Promise(function(resolve){var id=Number(item.id);var linkType=item.linkType;__WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js___default()({url:reqUrl,method:'post',withCredentials:true,data:{ids:[id],from:_this.props.specialApiFrom}}).then(function(res){var productItem={linkType:linkType,index:index};if(res.data.status===0&&res.data.data.List&&res.data.data.List[0]){Object.assign(productItem,{id:res.data.data.List[0].id,href:res.data.data.List[0].url});}resolve(productItem);});});}return promiseItem;});// 记录返回的商品url
Promise.all(promiseList).then(function(resList){var listHrefConfig=_this.state.listHrefConfig;resList.forEach(function(item){listHrefConfig[item.index]=item;});_this.setState({listHrefConfig:listHrefConfig});});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(index,item){// 当选择的点击事件是弹窗
if(item.linkType==='唤起弹窗'){var modalVisibles=_this.state.modalVisibles;modalVisibles[index]=true;_this.setState({modalVisibles:modalVisibles});return;}else if(item.linkType==='发布笔记'){if(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].SHDiffVersion(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getVersion(),'7.88.0')){var publishRoute="shihuo://www.shihuo.cn?route=attendColumn&column_id=".concat(item.id,"&&column_name=").concat(encodeURIComponent(item.topicName),"&from=10&need_login=true&needInterceptor=true");window.Jockey.send('action',{url:publishRoute});}else{var jumpUrl="shihuo://www.shihuo.cn?route=topicList&column_id=".concat(item.id,"&sort=1");__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,jumpUrl,jumpUrl,{},-1,_this.props,false);}return;}var href=_this.state.listHrefConfig[index].href;if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({link:href,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={link:href,type:baseConfig.sortType,name:item.title,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].convertHref(href);__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,href,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"productBannerGo",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}// 商品banner跳转
var options={};var convertUrl=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"initImgHotMapSwiper",function(){if(_this.swiper){_this.swiper.destroy();}if(_this.swiperRef){var baseConfig=_this.props.config.baseConfig;var options={spaceBetween:54,centeredSlides:true,autoplay:{disableOnInteraction:false,delay:2000},loop:true,allowTouchMove:false,simulateTouch:true,touchStartPreventDefault:false,on:{click:function click(){var listHrefConfig=_this.state.listHrefConfig;var realIndex=_this.swiper.realIndex;var target=listHrefConfig[realIndex];var url=target.href;if(url){var _options={link:url,type:'swiper',sort:realIndex};var ptiOptions={bizExtra:{goods_id:target.linkType==='商品id'?target.id:'',style_id:target.linkType==='配色id'?target.id:'',sku_id:target.linkType==='skuId'?target.id:''}};var convertUrl=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,_options,-1,_this.props,false,ptiOptions);}}}};if(baseConfig.direction==='垂直方向'){options['direction']='vertical';}if(baseConfig.effect==='淡入淡出'){options['effect']='fade';options['fadeEffect']={crossFade:true// 启用交叉淡入淡出
};}_this.swiper=new __WEBPACK_IMPORTED_MODULE_25_swiper_swiper_bundle_min_js___default.a(_this.swiperRef,options);}});_defineProperty(_assertThisInitialized(_this),"handleDragEnd",function(type,index,event,position){// 拖拽结束，将位置信息发送到编辑器
var data={left:String(position.x),top:String(position.y)};_this.updateDragItemMessage(data,type,index);});_defineProperty(_assertThisInitialized(_this),"handleItemResize",function(type,index,event){var itemEl=event.currentTarget;var data={width:String(itemEl.clientWidth),height:String(itemEl.clientHeight)};_this.updateDragItemMessage(data,type,index);if(_this.props.config.baseConfig.openSwiper==='是'){_this.initImgHotMapSwiper();}});_defineProperty(_assertThisInitialized(_this),"updateDragItemMessage",function(data,type,index){if(typeof window!=='undefined'&&window.parent){try{window.parent.postMessage({componentId:_this.props.customAttributes["data-component-id"],msgType:'updateDrag',type:type,index:index,data:data},'*');}catch(err){console.log(err);}}});_defineProperty(_assertThisInitialized(_this),"transformPx",function(num){// 对单位进行转换
num=Number(num);if(isNaN(num)){num=0;}var realNum=Math.round(num*_this.screenRatio);return realNum;});_this.state={listHrefConfig:{},dragMode:false,// 当前模式，包括编辑和展示两种模式
modalVisibles:[],isIframe:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getParams('isIframe')==1,inSwitchTabIndex:props.tabIndex||0};_this.swiper=null;_this.screenRatio=screenRatio;_this.isIphoneX=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isIphoneX();return _this;}_createClass(PipelineImgHotMap,[{key:"componentDidMount",value:function componentDidMount(){var baseConfig=this.props.config.baseConfig;this.getProductInfo();if(baseConfig.openSwiper==='是'){this.initImgHotMapSwiper();}if(typeof window!=='undefined'&&window.self!==window.top){window.addEventListener('message',this.receivePostMessageFromEditor);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(this.state.dragMode!==prevState.dragMode){this.initImgHotMapSwiper();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(typeof window!=='undefined'&&window.self!==window.top){window.removeEventListener('message',this.receivePostMessageFromEditor);}}},{key:"renderNormalHotMap",value:// 常规热区
function renderNormalHotMap(){var _this2=this;var modalVisibles=this.state.modalVisibles;var _this$props$allModals=this.props.allModals,allModals=_this$props$allModals===void 0?[]:_this$props$allModals;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,_this$props$config$it=_this$props$config.itemList,itemList=_this$props$config$it===void 0?[]:_this$props$config$it;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"drag-editor-container"},itemList.map(function(item,index){var width=_this2.transformPx(item.width);var height=_this2.transformPx(item.height);var left=_this2.transformPx(item.left);var top=_this2.transformPx(item.top);// 当点击事件选择的是弹窗
var targetModal=allModals.find(function(value){return value.id===item.targetModal;});return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{key:"item_".concat(index),style:{width:'100%',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_draggable___default.a,{disabled:!_this2.state.dragMode,defaultPosition:{x:Number(left),y:Number(top)},bounds:"parent",handle:".handle",onStop:_this2.handleDragEnd.bind(_this2,'normal',index)},_this2.state.dragMode?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"edit-drag-item",style:{width:"".concat(width,"px"),height:"".concat(height,"px"),zIndex:index+100,borderColor:baseConfig.dragFrameColor},onClick:_this2.handleItemResize.bind(_this2,'normal',index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"handle"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("img",{className:"item-img",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),alt:""})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this2.props.exp&&_this2.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getExposureData(_this2.props,{link:item.href,type:baseConfig.sortType,name:item.title,sort:index})),className:"preview-drag-item",onClick:_this2.handleItemClick.bind(_this2,index,item),style:{width:"".concat(width,"px"),height:"".concat(height,"px"),zIndex:index+100}},item.src&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("img",{className:"item-img",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),alt:""}))),targetModal&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pipeline_modal__["a" /* default */],{customAttributes:{"data-component-id":targetModal.id,"data-component-name":targetModal.name,"data-component-block":targetModal.blockName},config:targetModal.data,triggerId:_this2.props['customAttributes']["data-component-id"],visible:modalVisibles[index],onClose:function onClose(){modalVisibles[index]=false;_this2.setState({modalVisibles:modalVisibles});}}));}));}// 轮播热区
},{key:"renderSwiperHotMap",value:function renderSwiperHotMap(){var screenW=typeof window!=='undefined'&&window.innerWidth;var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,_this$props$config2$s=_this$props$config2.swiperDrag,swiperDrag=_this$props$config2$s===void 0?{}:_this$props$config2$s;var width=swiperDrag.width,height=swiperDrag.height,left=swiperDrag.left,top=swiperDrag.top;left=left/375*screenW;top=top/375*screenW;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"drag-editor-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{style:{width:'100%',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_draggable___default.a,{disabled:!this.state.dragMode,defaultPosition:{x:Number(left),y:Number(top)},bounds:"parent",handle:".handle",onStop:this.handleDragEnd.bind(this,'swiper',null)},this.state.dragMode?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"edit-drag-item",style:{width:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])("".concat(width,"px")),height:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])("".concat(height,"px")),zIndex:100,borderColor:baseConfig.dragFrameColor},onClick:this.handleItemResize.bind(this,'swiper',null)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"handle"}),this.renderSwiper()):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"preview-drag-item",style:{width:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])("".concat(width,"px")),height:Object(__WEBPACK_IMPORTED_MODULE_30__utils_px2rem__["a" /* default */])("".concat(height,"px")),zIndex:100}},this.renderSwiper()))));}// 图片轮播
},{key:"renderSwiper",value:function renderSwiper(){var _this3=this;var itemList=this.props.config.itemList;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"swiper-container",ref:function ref(_ref){return _this3.swiperRef=_ref;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"swiper-wrapper"},itemList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"swiper-slide",key:"slide-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("img",{src:item.src,alt:""}));})));}},{key:"render",value:function render(){var isIframe=this.state.isIframe;var _this$props$config3=this.props.config,baseConfig=_this$props$config3.baseConfig,_this$props$config3$c=_this$props$config3.componentSize,componentSize=_this$props$config3$c===void 0?{}:_this$props$config3$c;var _utils$getAdaptImageS=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getAdaptImageSize(componentSize),width=_utils$getAdaptImageS.width,height=_utils$getAdaptImageS.height;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",_extends({className:baseConfig.isFixedBottom?this.isIphoneX?"pipeline-imgHotMap fixed iphoneX":"pipeline-imgHotMap fixed":"pipeline-imgHotMap",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),baseConfig.showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title)),baseConfig.bannerImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("img",{className:"banner-img",onClick:this.productBannerGo.bind(this,baseConfig.bannerLink),src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bannerImg,this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"hot-map-editor"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__["LazyLoadImage"],{className:"bg-img",width:"100%",style:{width:"100%",height:'auto'},visibleByDefault:isIframe,src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bgImg,this.props.webpSupport)}),baseConfig.openSwiper==='是'?this.renderSwiperHotMap():this.renderNormalHotMap()));}}]);return PipelineImgHotMap;}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);PipelineImgHotMap.propTypes={config:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgHotMap);

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProductSwiper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_draggable__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_draggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_draggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_swiper_swiper_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineProductSwiper=/*#__PURE__*/function(_React$Component){_inherits(PipelineProductSwiper,_React$Component);var _super=_createSuper(PipelineProductSwiper);function PipelineProductSwiper(props){var _this;_classCallCheck(this,PipelineProductSwiper);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"receivePostMessageFromEditor",function(event){var data=event.data||{};var msgType=data.msgType;if(msgType==='checkToBaseConfig'){_this.setState({dragMode:false});}if(msgType==='componentSelect'){var currentComponent=data.currentComponent;if(!currentComponent){return;}// 编辑器切换组件之后，根据postMessage返回id，确认是否当前组件来切换模式
if(currentComponent.id&&_this.props.customAttributes["data-component-block"].indexOf(currentComponent.id)>-1){_this.setState({dragMode:true});_this.handleTagsPosition();}else{_this.setState({dragMode:false});}}});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].isShihuo()&&item.link){var options={link:item.link,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);}});_defineProperty(_assertThisInitialized(_this),"handleSlideChange",function(swiper){var itemList=_this.props.config.itemList;var activeIndex=swiper.realIndex;var activeItem=itemList[activeIndex];_this.setState({activeIndex:activeIndex,activeItem:activeItem},function(){if(!_this.isIframe){setTimeout(function(){_this.productSwiperRef.querySelectorAll('.swiper-slide').forEach(function(item,index){if(item.classList.contains('swiper-slide-active')){item.querySelector('.drag-editor-container').setAttribute('class','drag-editor-container show');}else{item.querySelector('.drag-editor-container').setAttribute('class','drag-editor-container hide');}});},0);}});});_defineProperty(_assertThisInitialized(_this),"slideClick",function(clickIndex){_this.setState({activeIndex:clickIndex});if(clickIndex===_this.state.activeIndex){_this.handleItemClick(clickIndex);}});_defineProperty(_assertThisInitialized(_this),"transformPx",function(num){// 对单位进行转换
num=Number(num);if(isNaN(num)){num=0;}var realNum=Math.round(num*_this.screenRatio);return realNum;});_defineProperty(_assertThisInitialized(_this),"handleOnDrag",function(event){event.stopPropagation();_this.mySwiper.update({allowTouchMove:false});});_defineProperty(_assertThisInitialized(_this),"handleDragEnd",function(index,key,event,position){// 拖拽结束，将位置信息发送到编辑器
event.stopPropagation();_this.mySwiper.update({allowTouchMove:true});var id=_this.state.activeItem.id;var data={left:String(position.x),top:String(position.y)};_this.updateDragItemMessage(data,index,key,id);_this.handleTagsPosition();});_defineProperty(_assertThisInitialized(_this),"updateDragItemMessage",function(data,index,key,id){if(typeof window!=='undefined'&&window.parent){try{window.parent.postMessage({componentId:_this.props.customAttributes["data-component-id"],msgType:'updateDrag',index:index,key:key,data:data,id:id},'*');}catch(err){console.log(err);}}});_defineProperty(_assertThisInitialized(_this),"getTagPosition",function(value,key,length){var left=_this.transformPx(value.left);var top=_this.transformPx(value.top);if(length===2){key=key+1;}switch(key){case 0:if(left==0){left=-10;}if(top==0){top=130;}break;case 1:if(left==0){left=202;}if(top==0){top=94;}break;case 2:if(left==0){left=182;}if(top==0){top=158;}break;default:break;}return{left:left,top:top};});_defineProperty(_assertThisInitialized(_this),"handleTagsPosition",function(){clearTimeout(_this.tagsPositionInterval);_this.tagsPositionInterval=null;_this.tagsPositionInterval=setTimeout(function(){var dragEditorRef=null;if(_this.isIframe){dragEditorRef=_this.productSwiperRef.querySelector('.drag-editor-container.show');}else{dragEditorRef=_this.productSwiperRef.querySelector('.swiper-slide-active').querySelector('.drag-editor-container');}if(dragEditorRef){dragEditorRef.querySelectorAll('.item-tag').forEach(function(tagItem){var dragEditorRect=dragEditorRef.getBoundingClientRect();var tagRect=tagItem.getBoundingClientRect();var dragEditorRectCenterX=dragEditorRect.left+dragEditorRect.width/2;var tagRectCenterX=tagRect.left+tagRect.width/2;if(tagRectCenterX<dragEditorRectCenterX){tagItem.classList.remove('show-left-dot');tagItem.classList.add('show-right-dot');}else if(tagRectCenterX>dragEditorRectCenterX){tagItem.classList.remove('show-right-dot');tagItem.classList.add('show-left-dot');}else{tagItem.classList.remove('show-left-dot','show-right-dot');tagItem.classList.add('show-not-dot');}});}},0);});var clientWidth=375;if(typeof window!=='undefined'){clientWidth=window.document.body.clientWidth;}var screenRatio=clientWidth/375;_this.state={activeIndex:0,activeItem:{},dragMode:false};_this.screenRatio=screenRatio;_this.productSwiperRef=null;_this.mySwiper=null;_this.swiperRef=null;_this.swiperPaginationRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_17_react__["createRef"])();_this.tagsPositionInterval=null;_this.isIframe=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].getParams('isIframe')==1;return _this;}_createClass(PipelineProductSwiper,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;// 轮播组件初始化
this.mySwiper=new __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js___default.a(this.swiperRef,{slidesPerView:2,spaceBetween:0,centeredSlides:true,pagination:{el:this.swiperPaginationRef.current,clickable:true},autoplay:this.isIframe?false:{disableOnInteraction:false,delay:2000},loop:true,allowTouchMove:true,simulateTouch:true,touchStartPreventDefault:false,on:{slideChange:function slideChange(swiper){_this2.handleSlideChange(swiper);_this2.handleTagsPosition();}}});this.handleSlideChange({realIndex:0});this.handleTagsPosition();if(typeof window!=='undefined'&&window.self!==window.top){window.addEventListener('message',this.receivePostMessageFromEditor);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(typeof window!=='undefined'&&window.self!==window.top){window.removeEventListener('message',this.receivePostMessageFromEditor);}if(this.mySwiper){this.mySwiper.destroy();this.mySwiper=null;}if(this.tagsPositionInterval){clearTimeout(this.tagsPositionInterval);this.tagsPositionInterval=null;}}},{key:"truncateString",value:// 字符串截取指定长度的字符
function truncateString(){var str=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var maxLength=arguments.length>1?arguments[1]:undefined;var truncatedString='';var currentLength=0;for(var i=0;i<str.length;i++){var currentChar=str.charAt(i);// 如果是中文字符，计数加2
if(/[\u4e00-\u9fa5]/.test(currentChar)){currentLength+=2;}else{// 非中文字符，计数加1
currentLength++;}// 如果当前长度未超过最大长度，将字符添加到截断字符串中
if(currentLength<=maxLength){truncatedString+=currentChar;}else{// 如果超过最大长度，结束循环
break;}}return truncatedString;}},{key:"rederSparePriceOneLineView",value:function rederSparePriceOneLineView(price){var sparePrice=null;if(price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var sparePriceList=sparePrice.list;this.renderPriceLength=sparePriceList[0].length+(sparePriceList[1]?sparePriceList[1].length:0);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price",style:{display:'flex',flexDirection:'row',alignItems:'center'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('11px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('2px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('16px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('4px')}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('12px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('2px')}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('11px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('2px')}},sparePrice.unit));}else{this.renderPriceLength=0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",null,"\xA5"),price);}}},{key:"render",value:function render(){var _this3=this;var _this$props$navigator=this.props.navigatorBarTheme,navigatorBarTheme=_this$props$navigator===void 0?"黑":_this$props$navigator;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var _this$state=this.state,_this$state$activeIte=_this$state.activeItem,activeItem=_this$state$activeIte===void 0?{}:_this$state$activeIte,activeIndex=_this$state.activeIndex,dragMode=_this$state.dragMode;var titleColor=baseConfig.titleColor||(navigatorBarTheme=="黑"?'rgba(0, 0, 0, 1)':'rgba(255, 255, 255, 1)');return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({ref:function ref(_ref2){return _this3.productSwiperRef=_ref2;},className:"pipeline-productSwiper"},this.props['customAttributes'],{style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bgImg,this.props.webpSupport),")")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"swiper-container",ref:function ref(_ref){return _this3.swiperRef=_ref;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"swiper-wrapper"},itemList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"swiper-slide",key:"slide-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"product-detail"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"product-img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"product-img",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.goodsImg,_this3.props.webpSupport),alt:""})),itemList[activeIndex]&&itemList[activeIndex].tagImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:itemList[activeIndex].tagImg,alt:"",className:"tag-img"})),!_this3.isIframe&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"drag-editor-container ".concat(activeIndex===index?'show':'hide'),key:"slide-drag-editor-".concat(index),onClick:_this3.handleItemClick.bind(_this3,activeItem,activeIndex)},item.tagList&&item.tagList.map(function(value,key){var _this3$getTagPosition=_this3.getTagPosition(value,key,item.tagList.length),_this3$getTagPosition2=_this3$getTagPosition.left,left=_this3$getTagPosition2===void 0?0:_this3$getTagPosition2,_this3$getTagPosition3=_this3$getTagPosition.top,top=_this3$getTagPosition3===void 0?0:_this3$getTagPosition3;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{key:"value_".concat(key),style:{width:'100%',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_draggable___default.a,{disabled:!dragMode,defaultPosition:{x:Number(left),y:Number(top)},bounds:"parent",handle:".handle",onDrag:function onDrag(event){return _this3.handleOnDrag(event);},onStop:_this3.handleDragEnd.bind(_this3,index,key)},dragMode?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"edit-drag-item",style:{zIndex:key+100}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"handle"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"item-tag tag".concat(key+(item.tagList.length!==2?1:2))},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"left-dot"}),value.text,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"right-dot"}))):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"preview-drag-item",style:{zIndex:key+100}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"item-tag tag".concat(key+(item.tagList.length!==2?1:2))},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"left-dot"}),value.text,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"right-dot"})))));})));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"product-info ".concat(navigatorBarTheme==='黑'?'dark':'light'),style:{color:titleColor,borderColor:titleColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"name"},this.truncateString(activeItem.title,22)),!baseConfig.hidePriceModal&&activeItem.price>0&&this.rederSparePriceOneLineView(activeItem.price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("svg",{t:"1700563482095",className:"more",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2285",width:"16",height:"16"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("path",{d:"M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m-35.2 247.232a48 48 0 0 0-63.04 4.288l-4.288 4.864a48 48 0 0 0 4.288 62.976L606.08 511.68 413.76 704l-4.288 4.928a48 48 0 0 0 72.192 62.912l226.24-226.24 4.352-4.928a48 48 0 0 0-4.352-62.976L481.664 251.52z","p-id":"2286",fill:titleColor}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"swiper-pagination ".concat(navigatorBarTheme==='黑'?'dark':'light'),ref:this.swiperPaginationRef}),this.isIframe&&itemList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"drag-editor-container ".concat(activeIndex===index?'show':'hide'),key:"drag-editor-".concat(index),onClick:_this3.handleItemClick.bind(_this3,activeItem,activeIndex)},item.tagList&&item.tagList.map(function(value,key){var _this3$getTagPosition4=_this3.getTagPosition(value,key,item.tagList.length),_this3$getTagPosition5=_this3$getTagPosition4.left,left=_this3$getTagPosition5===void 0?0:_this3$getTagPosition5,_this3$getTagPosition6=_this3$getTagPosition4.top,top=_this3$getTagPosition6===void 0?0:_this3$getTagPosition6;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{key:"value_".concat(key),style:{width:'100%',height:'100%'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_draggable___default.a,{disabled:!dragMode,defaultPosition:{x:Number(left),y:Number(top)},bounds:"parent",handle:".handle",onDrag:function onDrag(event){return _this3.handleOnDrag(event);},onStop:_this3.handleDragEnd.bind(_this3,index,key)},dragMode?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"edit-drag-item",style:{zIndex:key+100}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"handle"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"item-tag tag".concat(key+(item.tagList.length!==2?1:2))},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"left-dot"}),value.text,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"right-dot"}))):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"preview-drag-item",style:{zIndex:key+100}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"item-tag tag".concat(key+(item.tagList.length!==2?1:2))},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"left-dot"}),value.text,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"right-dot"})))));}));})));}}]);return PipelineProductSwiper;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineProductSwiper.propTypes={config:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProductSwiper);

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCommunity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__better_scroll_core__ = __webpack_require__(438);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineCommunity=/*#__PURE__*/function(_React$Component){_inherits(PipelineCommunity,_React$Component);var _super=_createSuper(PipelineCommunity);function PipelineCommunity(props){var _this;_classCallCheck(this,PipelineCommunity);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"measureBannerImg",function(){// 测量banner图高度
var bodyWidth=375;if(typeof window!=='undefined'){bodyWidth=window.document.body.clientWidth;}var imageEl=new Image();imageEl.src=_this.props.config.baseConfig.bannerImg;imageEl.onload=function(){var bannerImgHeight=0;bannerImgHeight=parseInt(imageEl.height/imageEl.width*bodyWidth,10);_this.setState({bannerImgHeight:bannerImgHeight});};});_defineProperty(_assertThisInitialized(_this),"getBaseListData",function(){Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/hot?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{page:1,page_size:50,pos:_this.pageId}}).then(function(res){if(res.data.status===0){_this.setState({baseList:res.data.data.list||[]},function(){// 初始化轮播组件
if(_this.state.baseList.length<5){return;}var swiper=new __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_bundle_min_js___default.a(_this.baseSwiperRef.current,{slidesPerView:'auto',spaceBetween:0,allowTouchMove:false,direction:'vertical',loop:true,autoHeight:true,centeredSlides:true,pagination:false,navigation:false,loopAdditionalSlides:10,speed:500,autoplay:{delay:1500,disableOnInteraction:false}});});}});});_defineProperty(_assertThisInitialized(_this),"fetchMoreCommentData",function(){if(!_this.state.hasMore){return;}var sortType=_this.state.sortType;var page=_this.state.page;var reqUrl='';if(sortType==='hot'){reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/hot?access_token=znSnA7pxO35wtPBaur';}else{reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/latest?access_token=znSnA7pxO35wtPBaur';}Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:reqUrl,method:"get",withCredentials:true,params:{page:page.pageNum,page_size:page.pageSize,pos:_this.pageId}}).then(function(res){if(res.data.status===0){var allList=_this.state.allList;var currentList=res.data.data.list||[];allList=allList.concat(currentList);page.pageNum+=1;_this.setState({hasMore:currentList.length>0,allList:allList,page:page},function(){// 数据渲染完毕之后释放锁定
_this.scrollLock=false;});}else{_this.setState({hasMore:false});_this.scrollLock=false;}});});_defineProperty(_assertThisInitialized(_this),"handleShowGlobalView",function(){_this.setState({showGlobalView:true});setTimeout(function(){_this.fixedCommunityBody.current.style.transform='translateY(0)';},10);_this.fetchMoreCommentData();document.querySelector("body").style.touchAction='none';});_defineProperty(_assertThisInitialized(_this),"handleToggleSortType",function(sortType){var page=_this.state.page;page.pageNum=1;_this.setState({sortType:sortType,page:page,allList:[],hasMore:true},_this.fetchMoreCommentData);});_defineProperty(_assertThisInitialized(_this),"handleSendMsg",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var userCookie;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');case 2:userCookie=_context.sent;console.log(userCookie,'用户cookie');if(userCookie){// 发布留言
Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/save?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{comment:_this.state.commentVal,pos:_this.pageId}}).then(function(res){if(res.data.status===0){_this.setState({commentVal:''});// 将新发布的一条消息推入列表
var newComment=res.data.data.comment||{};if(_this.state.showGlobalView){var allList=_this.state.allList;allList.push(newComment);_this.setState({allList:allList});}else{var baseList=_this.state.baseList;baseList.push(newComment);_this.setState({baseList:baseList});}}else{}});}else if(typeof window!=='undefined'){window.Jockey.send('login');}case 5:case"end":return _context.stop();}}},_callee);})));_defineProperty(_assertThisInitialized(_this),"handleToggleBaseLikeStatus",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(baseIndex){var baseList,toggleStatus,userCookie;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:baseList=_this.state.baseList;toggleStatus=baseList[baseIndex].self_like?0:1;// 切换状态
baseList[baseIndex].self_like=Boolean(toggleStatus);if(toggleStatus===1){baseList[baseIndex].like_cnt+=1;}else{baseList[baseIndex].like_cnt-=1;}_context2.next=6;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');case 6:userCookie=_context2.sent;if(userCookie){// 点赞与取消
_this.setState({baseList:baseList});Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/like?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{comment_id:baseList[baseIndex].id,status:toggleStatus}}).then(function(res){if(res.data.status===0){console.log('操作成功');}});}else if(typeof window!=='undefined'){window.Jockey.send('login');}case 8:case"end":return _context2.stop();}}},_callee2);}));return function(_x){return _ref2.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleToggleLikeStatus",/*#__PURE__*/function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(index){var allList,toggleStatus,userCookie;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:allList=_this.state.allList;toggleStatus=allList[index].self_like?0:1;// 切换状态
allList[index].self_like=Boolean(toggleStatus);if(toggleStatus===1){allList[index].like_cnt+=1;}else{allList[index].like_cnt-=1;}_context3.next=6;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');case 6:userCookie=_context3.sent;if(userCookie){// 点赞与取消
_this.setState({allList:allList});Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/like?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{comment_id:allList[index].id,status:toggleStatus}}).then(function(res){if(res.data.status===0){console.log('操作成功');}});}else if(typeof window!=='undefined'){window.Jockey.send('login');}case 8:case"end":return _context3.stop();}}},_callee3);}));return function(_x2){return _ref3.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleCloseFixedCommunity",function(){_this.setState({showGlobalView:false});setTimeout(function(){_this.fixedCommunityBody.current.style.transform='translateY(100%)';},10);document.querySelector("body").style.touchAction='auto';});_defineProperty(_assertThisInitialized(_this),"handleCommentValChange",function(event){var val=event.target.value;_this.setState({commentVal:val});});_defineProperty(_assertThisInitialized(_this),"handleCommentListScroll",function(event){if(!_this.state.hasMore){return;}if(_this.scrollLock){// 滚动锁定情况不再请求下一页
return;}var maxScrollHeight=document.querySelector('.scroll-content').clientHeight-_this.scrollRef.current.clientHeight;var currentScrollTop=event.y;// 滚动条距离底部小于100，加载下一页
if(maxScrollHeight+currentScrollTop<100&&currentScrollTop!==0){console.log(maxScrollHeight,currentScrollTop,'加载下一页');_this.scrollLock=true;_this.fetchMoreCommentData();}});_this.state={showGlobalView:false,sortType:'hot',commentVal:'',baseList:[],// 初始数据
allList:[],page:{pageNum:1,pageSize:20},hasMore:true,bannerImgHeight:0};_this.pageId=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getPageId();_this.bodyScrollTop=0;_this.scrollLock=false;// 滚动计算锁定
_this.scrollRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])();_this.baseSwiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])();_this.fixedCommunityBody=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])();_this.screenRatio=1;if(typeof window!=='undefined'){_this.screenRatio=window.document.body.clientWidth/375;}return _this;}_createClass(PipelineCommunity,[{key:"componentDidMount",value:function componentDidMount(){this.getBaseListData();this.measureBannerImg();this.commentScroll=new __WEBPACK_IMPORTED_MODULE_23__better_scroll_core__["a" /* default */](this.scrollRef.current,{// 配置项，更多可参考官方文档
probeType:3,click:true,tap:'tap',momentum:true,momentumLimitDistance:30,deceleration:0.003,preventDefaultException:{className:/(^|\s)like-container(\s|$)/}});this.commentScroll.on('scroll',this.handleCommentListScroll);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){// 内容更新时，需要重新刷新滚动容器
if(prevState.allList.length!==this.state.allList.length){this.commentScroll.refresh();}}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var allList=this.state.allList;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({className:"pipeline-community",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),baseConfig.showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title),baseConfig.showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"sub-title",style:{color:baseConfig.titleColor}},baseConfig.subTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"content-panel",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bgImg,this.props.webpSupport),")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"comment-list comment-swiper-container",ref:this.baseSwiperRef},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"swiper-wrapper"},this.state.baseList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"comment-item swiper-slide",key:item.id},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"avatar",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(item.avatar,_this2.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"comment-detail-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"user-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"username"},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"like-container",onClick:_this2.handleToggleBaseLikeStatus.bind(_this2,index)},item.like_cnt,item.self_like?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"like-icon",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.likeIcon,_this2.props.webpSupport),alt:""}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"like-icon",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.unlikeIcon,_this2.props.webpSupport),alt:""}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"ballon-content",style:{color:baseConfig.contentColor,backgroundColor:baseConfig.contentBgColor}},item.comment)));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"swiper-pagination"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"input-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("input",{className:"input-text",value:this.state.commentVal,onChange:this.handleCommentValChange,placeholder:baseConfig.inputPlaceholder}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"submit-btn",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.sendBtnImg,this.props.webpSupport),onClick:this.handleSendMsg,alt:"\u53D1\u9001"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"view-more-btn",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.viewMoreImg,this.props.webpSupport),onClick:this.handleShowGlobalView,style:{height:this.screenRatio*40},alt:"\u67E5\u770B\u66F4\u591A"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"fixed-community-panel",style:{display:this.state.showGlobalView?'block':'none'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"community-mask"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"community-body",ref:this.fixedCommunityBody},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:baseConfig.bannerImg?'close-btn hasBanerImg':'close-btn',onClick:this.handleCloseFixedCommunity,src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl('https://static.shihuocdn.cn/admin/files/20210716/1fbcc8f984b89ec2a1dd2cacfec88900.png',this.props.webpSupport),alt:""}),baseConfig.bannerImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"banner-img",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bannerImg,this.props.webpSupport),style:{height:this.screenRatio*100},alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"header"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"community-title"},"\u7559\u8A00\u677F"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"toggle-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"hot-btn",onClick:this.handleToggleSortType.bind(this,'hot'),style:{color:this.state.sortType==='hot'?baseConfig.checkedTabColor:baseConfig.uncheckedTabColor}},"\u6700\u70ED"),"|",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"new-btn",onClick:this.handleToggleSortType.bind(this,'new'),style:{color:this.state.sortType==='new'?baseConfig.checkedTabColor:baseConfig.uncheckedTabColor}},"\u6700\u65B0"))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"content-panel",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.subPageBgImg,this.props.webpSupport),")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"scroll-comment-container",ref:this.scrollRef,style:{height:"calc(100vh - 292px - ".concat(this.screenRatio*(baseConfig.bannerImg?100:0),"px)")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"scroll-content"},allList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"comment-item",key:item.id},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"avatar",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(item.avatar,_this2.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"comment-detail-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"user-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"username"},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"like-container",onClick:_this2.handleToggleLikeStatus.bind(_this2,index)},item.like_cnt,item.self_like?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"like-icon",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.likeIcon,_this2.props.webpSupport),alt:""}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"like-icon",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.unlikeIcon,_this2.props.webpSupport),alt:""}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"ballon-content",style:{color:baseConfig.contentColor,backgroundColor:baseConfig.contentBgColor}},item.comment)));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"input-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("input",{className:"input-text",value:this.state.commentVal,onChange:this.handleCommentValChange,placeholder:baseConfig.inputPlaceholder}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"submit-btn",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(baseConfig.sendBtnImg,this.props.webpSupport),onClick:this.handleSendMsg,alt:"\u53D1\u9001"}))))));}}]);return PipelineCommunity;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);PipelineCommunity.propTypes={config:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCommunity);

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Behavior */
/* unused harmony export CustomOptions */
/* unused harmony export createBScroll */
/*!
 * better-scroll / core
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var propertiesConfig = [
    {
        sourceKey: 'scroller.scrollBehaviorX.currentPos',
        key: 'x'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.currentPos',
        key: 'y'
    },
    {
        sourceKey: 'scroller.scrollBehaviorX.hasScroll',
        key: 'hasHorizontalScroll'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.hasScroll',
        key: 'hasVerticalScroll'
    },
    {
        sourceKey: 'scroller.scrollBehaviorX.contentSize',
        key: 'scrollerWidth'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.contentSize',
        key: 'scrollerHeight'
    },
    {
        sourceKey: 'scroller.scrollBehaviorX.maxScrollPos',
        key: 'maxScrollX'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.maxScrollPos',
        key: 'maxScrollY'
    },
    {
        sourceKey: 'scroller.scrollBehaviorX.minScrollPos',
        key: 'minScrollX'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.minScrollPos',
        key: 'minScrollY'
    },
    {
        sourceKey: 'scroller.scrollBehaviorX.movingDirection',
        key: 'movingDirectionX'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.movingDirection',
        key: 'movingDirectionY'
    },
    {
        sourceKey: 'scroller.scrollBehaviorX.direction',
        key: 'directionX'
    },
    {
        sourceKey: 'scroller.scrollBehaviorY.direction',
        key: 'directionY'
    },
    {
        sourceKey: 'scroller.actions.enabled',
        key: 'enabled'
    },
    {
        sourceKey: 'scroller.animater.pending',
        key: 'pending'
    },
    {
        sourceKey: 'scroller.animater.stop',
        key: 'stop'
    },
    {
        sourceKey: 'scroller.scrollTo',
        key: 'scrollTo'
    },
    {
        sourceKey: 'scroller.scrollBy',
        key: 'scrollBy'
    },
    {
        sourceKey: 'scroller.scrollToElement',
        key: 'scrollToElement'
    },
    {
        sourceKey: 'scroller.resetPosition',
        key: 'resetPosition'
    }
];

function warn(msg) {
    console.error("[BScroll warn]: " + msg);
}

// ssr support
var inBrowser = typeof window !== 'undefined';
var ua = inBrowser && navigator.userAgent.toLowerCase();
var isWeChatDevTools = !!(ua && /wechatdevtools/.test(ua));
var isAndroid = ua && ua.indexOf('android') > 0;
/* istanbul ignore next */
var isIOSBadVersion = (function () {
    if (typeof ua === 'string') {
        var regex = /os (\d\d?_\d(_\d)?)/;
        var matches = regex.exec(ua);
        if (!matches)
            return false;
        var parts = matches[1].split('_').map(function (item) {
            return parseInt(item, 10);
        });
        // ios version >= 13.4 issue 982
        return !!(parts[0] === 13 && parts[1] >= 4);
    }
    return false;
})();
/* istanbul ignore next */
var supportsPassive = false;
/* istanbul ignore next */
if (inBrowser) {
    var EventName = 'test-passive';
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                supportsPassive = true;
            },
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener(EventName, function () { }, opts);
    }
    catch (e) { }
}

function getNow() {
    return window.performance &&
        window.performance.now &&
        window.performance.timing
        ? window.performance.now() + window.performance.timing.navigationStart
        : +new Date();
}
var extend = function (target, source) {
    for (var key in source) {
        target[key] = source[key];
    }
    return target;
};
function isUndef(v) {
    return v === undefined || v === null;
}
function between(x, min, max) {
    if (x < min) {
        return min;
    }
    if (x > max) {
        return max;
    }
    return x;
}

var elementStyle = (inBrowser &&
    document.createElement('div').style);
var vendor = (function () {
    /* istanbul ignore if  */
    if (!inBrowser) {
        return false;
    }
    var transformNames = [
        {
            key: 'standard',
            value: 'transform',
        },
        {
            key: 'webkit',
            value: 'webkitTransform',
        },
        {
            key: 'Moz',
            value: 'MozTransform',
        },
        {
            key: 'O',
            value: 'OTransform',
        },
        {
            key: 'ms',
            value: 'msTransform',
        },
    ];
    for (var _i = 0, transformNames_1 = transformNames; _i < transformNames_1.length; _i++) {
        var obj = transformNames_1[_i];
        if (elementStyle[obj.value] !== undefined) {
            return obj.key;
        }
    }
    /* istanbul ignore next  */
    return false;
})();
/* istanbul ignore next  */
function prefixStyle(style) {
    if (vendor === false) {
        return style;
    }
    if (vendor === 'standard') {
        if (style === 'transitionEnd') {
            return 'transitionend';
        }
        return style;
    }
    return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}
function getElement(el) {
    return (typeof el === 'string'
        ? document.querySelector(el)
        : el);
}
function addEvent(el, type, fn, capture) {
    var useCapture = supportsPassive
        ? {
            passive: false,
            capture: !!capture,
        }
        : !!capture;
    el.addEventListener(type, fn, useCapture);
}
function removeEvent(el, type, fn, capture) {
    el.removeEventListener(type, fn, {
        capture: !!capture,
    });
}
function offset(el) {
    var left = 0;
    var top = 0;
    while (el) {
        left -= el.offsetLeft;
        top -= el.offsetTop;
        el = el.offsetParent;
    }
    return {
        left: left,
        top: top,
    };
}
vendor && vendor !== 'standard' ? '-' + vendor.toLowerCase() + '-' : '';
var transform = prefixStyle('transform');
var transition = prefixStyle('transition');
var hasPerspective = inBrowser && prefixStyle('perspective') in elementStyle;
// fix issue #361
var hasTouch = inBrowser && ('ontouchstart' in window || isWeChatDevTools);
var hasTransition = inBrowser && transition in elementStyle;
var style = {
    transform: transform,
    transition: transition,
    transitionTimingFunction: prefixStyle('transitionTimingFunction'),
    transitionDuration: prefixStyle('transitionDuration'),
    transitionDelay: prefixStyle('transitionDelay'),
    transformOrigin: prefixStyle('transformOrigin'),
    transitionEnd: prefixStyle('transitionEnd'),
    transitionProperty: prefixStyle('transitionProperty'),
};
var eventTypeMap = {
    touchstart: 1,
    touchmove: 1,
    touchend: 1,
    touchcancel: 1,
    mousedown: 2,
    mousemove: 2,
    mouseup: 2,
};
function getRect(el) {
    /* istanbul ignore if  */
    if (el instanceof window.SVGElement) {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
        };
    }
    else {
        return {
            top: el.offsetTop,
            left: el.offsetLeft,
            width: el.offsetWidth,
            height: el.offsetHeight,
        };
    }
}
function preventDefaultExceptionFn(el, exceptions) {
    for (var i in exceptions) {
        if (exceptions[i].test(el[i])) {
            return true;
        }
    }
    return false;
}
var tagExceptionFn = preventDefaultExceptionFn;
function tap(e, eventName) {
    var ev = document.createEvent('Event');
    ev.initEvent(eventName, true, true);
    ev.pageX = e.pageX;
    ev.pageY = e.pageY;
    e.target.dispatchEvent(ev);
}
function click(e, event) {
    if (event === void 0) { event = 'click'; }
    var eventSource;
    if (e.type === 'mouseup') {
        eventSource = e;
    }
    else if (e.type === 'touchend' || e.type === 'touchcancel') {
        eventSource = e.changedTouches[0];
    }
    var posSrc = {};
    if (eventSource) {
        posSrc.screenX = eventSource.screenX || 0;
        posSrc.screenY = eventSource.screenY || 0;
        posSrc.clientX = eventSource.clientX || 0;
        posSrc.clientY = eventSource.clientY || 0;
    }
    var ev;
    var bubbles = true;
    var cancelable = true;
    var ctrlKey = e.ctrlKey, shiftKey = e.shiftKey, altKey = e.altKey, metaKey = e.metaKey;
    var pressedKeysMap = {
        ctrlKey: ctrlKey,
        shiftKey: shiftKey,
        altKey: altKey,
        metaKey: metaKey,
    };
    if (typeof MouseEvent !== 'undefined') {
        try {
            ev = new MouseEvent(event, extend(__assign({ bubbles: bubbles,
                cancelable: cancelable }, pressedKeysMap), posSrc));
        }
        catch (e) {
            /* istanbul ignore next */
            createEvent();
        }
    }
    else {
        createEvent();
    }
    function createEvent() {
        ev = document.createEvent('Event');
        ev.initEvent(event, bubbles, cancelable);
        extend(ev, posSrc);
    }
    // forwardedTouchEvent set to true in case of the conflict with fastclick
    ev.forwardedTouchEvent = true;
    ev._constructed = true;
    e.target.dispatchEvent(ev);
}
function dblclick(e) {
    click(e, 'dblclick');
}

var ease = {
    // easeOutQuint
    swipe: {
        style: 'cubic-bezier(0.23, 1, 0.32, 1)',
        fn: function (t) {
            return 1 + --t * t * t * t * t;
        }
    },
    // easeOutQuard
    swipeBounce: {
        style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        fn: function (t) {
            return t * (2 - t);
        }
    },
    // easeOutQuart
    bounce: {
        style: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
        fn: function (t) {
            return 1 - --t * t * t * t;
        }
    }
};

var DEFAULT_INTERVAL = 1000 / 60;
var windowCompat = inBrowser && window;
/* istanbul ignore next */
function noop$1() { }
var requestAnimationFrame = (function () {
    /* istanbul ignore if  */
    if (!inBrowser) {
        return noop$1;
    }
    return (windowCompat.requestAnimationFrame ||
        windowCompat.webkitRequestAnimationFrame ||
        windowCompat.mozRequestAnimationFrame ||
        windowCompat.oRequestAnimationFrame ||
        // if all else fails, use setTimeout
        function (callback) {
            return window.setTimeout(callback, callback.interval || DEFAULT_INTERVAL); // make interval as precise as possible.
        });
})();
var cancelAnimationFrame = (function () {
    /* istanbul ignore if  */
    if (!inBrowser) {
        return noop$1;
    }
    return (windowCompat.cancelAnimationFrame ||
        windowCompat.webkitCancelAnimationFrame ||
        windowCompat.mozCancelAnimationFrame ||
        windowCompat.oCancelAnimationFrame ||
        function (id) {
            window.clearTimeout(id);
        });
})();

/* istanbul ignore next */
var noop = function (val) { };
var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop,
};
var getProperty = function (obj, key) {
    var keys = key.split('.');
    for (var i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
        if (typeof obj !== 'object' || !obj)
            return;
    }
    var lastKey = keys.pop();
    if (typeof obj[lastKey] === 'function') {
        return function () {
            return obj[lastKey].apply(obj, arguments);
        };
    }
    else {
        return obj[lastKey];
    }
};
var setProperty = function (obj, key, value) {
    var keys = key.split('.');
    var temp;
    for (var i = 0; i < keys.length - 1; i++) {
        temp = keys[i];
        if (!obj[temp])
            obj[temp] = {};
        obj = obj[temp];
    }
    obj[keys.pop()] = value;
};
function propertiesProxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return getProperty(this, sourceKey);
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        setProperty(this, sourceKey, val);
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}

var EventEmitter = /** @class */ (function () {
    function EventEmitter(names) {
        this.events = {};
        this.eventTypes = {};
        this.registerType(names);
    }
    EventEmitter.prototype.on = function (type, fn, context) {
        if (context === void 0) { context = this; }
        this.hasType(type);
        if (!this.events[type]) {
            this.events[type] = [];
        }
        this.events[type].push([fn, context]);
        return this;
    };
    EventEmitter.prototype.once = function (type, fn, context) {
        var _this = this;
        if (context === void 0) { context = this; }
        this.hasType(type);
        var magic = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.off(type, magic);
            var ret = fn.apply(context, args);
            if (ret === true) {
                return ret;
            }
        };
        magic.fn = fn;
        this.on(type, magic);
        return this;
    };
    EventEmitter.prototype.off = function (type, fn) {
        if (!type && !fn) {
            this.events = {};
            return this;
        }
        if (type) {
            this.hasType(type);
            if (!fn) {
                this.events[type] = [];
                return this;
            }
            var events = this.events[type];
            if (!events) {
                return this;
            }
            var count = events.length;
            while (count--) {
                if (events[count][0] === fn ||
                    (events[count][0] && events[count][0].fn === fn)) {
                    events.splice(count, 1);
                }
            }
            return this;
        }
    };
    EventEmitter.prototype.trigger = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.hasType(type);
        var events = this.events[type];
        if (!events) {
            return;
        }
        var len = events.length;
        var eventsCopy = __spreadArrays(events);
        var ret;
        for (var i = 0; i < len; i++) {
            var event_1 = eventsCopy[i];
            var fn = event_1[0], context = event_1[1];
            if (fn) {
                ret = fn.apply(context, args);
                if (ret === true) {
                    return ret;
                }
            }
        }
    };
    EventEmitter.prototype.registerType = function (names) {
        var _this = this;
        names.forEach(function (type) {
            _this.eventTypes[type] = type;
        });
    };
    EventEmitter.prototype.destroy = function () {
        this.events = {};
        this.eventTypes = {};
    };
    EventEmitter.prototype.hasType = function (type) {
        var types = this.eventTypes;
        var isType = types[type] === type;
        if (!isType) {
            warn("EventEmitter has used unknown event type: \"" + type + "\", should be oneof [" +
                ("" + Object.keys(types).map(function (_) { return JSON.stringify(_); })) +
                "]");
        }
    };
    return EventEmitter;
}());
var EventRegister = /** @class */ (function () {
    function EventRegister(wrapper, events) {
        this.wrapper = wrapper;
        this.events = events;
        this.addDOMEvents();
    }
    EventRegister.prototype.destroy = function () {
        this.removeDOMEvents();
        this.events = [];
    };
    EventRegister.prototype.addDOMEvents = function () {
        this.handleDOMEvents(addEvent);
    };
    EventRegister.prototype.removeDOMEvents = function () {
        this.handleDOMEvents(removeEvent);
    };
    EventRegister.prototype.handleDOMEvents = function (eventOperation) {
        var _this = this;
        var wrapper = this.wrapper;
        this.events.forEach(function (event) {
            eventOperation(wrapper, event.name, _this, !!event.capture);
        });
    };
    EventRegister.prototype.handleEvent = function (e) {
        var eventType = e.type;
        this.events.some(function (event) {
            if (event.name === eventType) {
                event.handler(e);
                return true;
            }
            return false;
        });
    };
    return EventRegister;
}());

var CustomOptions = /** @class */ (function () {
    function CustomOptions() {
    }
    return CustomOptions;
}());
var OptionsConstructor = /** @class */ (function (_super) {
    __extends(OptionsConstructor, _super);
    function OptionsConstructor() {
        var _this = _super.call(this) || this;
        _this.startX = 0;
        _this.startY = 0;
        _this.scrollX = false;
        _this.scrollY = true;
        _this.freeScroll = false;
        _this.directionLockThreshold = 0;
        _this.eventPassthrough = "" /* None */;
        _this.click = false;
        _this.dblclick = false;
        _this.tap = '';
        _this.bounce = {
            top: true,
            bottom: true,
            left: true,
            right: true,
        };
        _this.bounceTime = 800;
        _this.momentum = true;
        _this.momentumLimitTime = 300;
        _this.momentumLimitDistance = 15;
        _this.swipeTime = 2500;
        _this.swipeBounceTime = 500;
        _this.deceleration = 0.0015;
        _this.flickLimitTime = 200;
        _this.flickLimitDistance = 100;
        _this.resizePolling = 60;
        _this.probeType = 0 /* Default */;
        _this.stopPropagation = false;
        _this.preventDefault = true;
        _this.preventDefaultException = {
            tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO)$/,
        };
        _this.tagException = {
            tagName: /^TEXTAREA$/,
        };
        _this.HWCompositing = true;
        _this.useTransition = true;
        _this.bindToWrapper = false;
        _this.bindToTarget = false;
        _this.disableMouse = hasTouch;
        _this.disableTouch = !hasTouch;
        _this.autoBlur = true;
        _this.autoEndDistance = 5;
        _this.outOfBoundaryDampingFactor = 1 / 3;
        _this.specifiedIndexAsContent = 0;
        _this.quadrant = 1 /* First */;
        return _this;
    }
    OptionsConstructor.prototype.merge = function (options) {
        if (!options)
            return this;
        for (var key in options) {
            if (key === 'bounce') {
                this.bounce = this.resolveBounce(options[key]);
                continue;
            }
            this[key] = options[key];
        }
        return this;
    };
    OptionsConstructor.prototype.process = function () {
        this.translateZ =
            this.HWCompositing && hasPerspective ? ' translateZ(1px)' : '';
        this.useTransition = this.useTransition && hasTransition;
        this.preventDefault = !this.eventPassthrough && this.preventDefault;
        // If you want eventPassthrough I have to lock one of the axes
        this.scrollX =
            this.eventPassthrough === "horizontal" /* Horizontal */
                ? false
                : this.scrollX;
        this.scrollY =
            this.eventPassthrough === "vertical" /* Vertical */ ? false : this.scrollY;
        // With eventPassthrough we also need lockDirection mechanism
        this.freeScroll = this.freeScroll && !this.eventPassthrough;
        // force true when freeScroll is true
        this.scrollX = this.freeScroll ? true : this.scrollX;
        this.scrollY = this.freeScroll ? true : this.scrollY;
        this.directionLockThreshold = this.eventPassthrough
            ? 0
            : this.directionLockThreshold;
        return this;
    };
    OptionsConstructor.prototype.resolveBounce = function (bounceOptions) {
        var DEFAULT_BOUNCE = {
            top: true,
            right: true,
            bottom: true,
            left: true,
        };
        var NEGATED_BOUNCE = {
            top: false,
            right: false,
            bottom: false,
            left: false,
        };
        var ret;
        if (typeof bounceOptions === 'object') {
            ret = extend(DEFAULT_BOUNCE, bounceOptions);
        }
        else {
            ret = bounceOptions ? DEFAULT_BOUNCE : NEGATED_BOUNCE;
        }
        return ret;
    };
    return OptionsConstructor;
}(CustomOptions));

var ActionsHandler = /** @class */ (function () {
    function ActionsHandler(wrapper, options) {
        this.wrapper = wrapper;
        this.options = options;
        this.hooks = new EventEmitter([
            'beforeStart',
            'start',
            'move',
            'end',
            'click',
        ]);
        this.handleDOMEvents();
    }
    ActionsHandler.prototype.handleDOMEvents = function () {
        var _a = this.options, bindToWrapper = _a.bindToWrapper, disableMouse = _a.disableMouse, disableTouch = _a.disableTouch, click = _a.click;
        var wrapper = this.wrapper;
        var target = bindToWrapper ? wrapper : window;
        var wrapperEvents = [];
        var targetEvents = [];
        var shouldRegisterTouch = !disableTouch;
        var shouldRegisterMouse = !disableMouse;
        if (click) {
            wrapperEvents.push({
                name: 'click',
                handler: this.click.bind(this),
                capture: true,
            });
        }
        if (shouldRegisterTouch) {
            wrapperEvents.push({
                name: 'touchstart',
                handler: this.start.bind(this),
            });
            targetEvents.push({
                name: 'touchmove',
                handler: this.move.bind(this),
            }, {
                name: 'touchend',
                handler: this.end.bind(this),
            }, {
                name: 'touchcancel',
                handler: this.end.bind(this),
            });
        }
        if (shouldRegisterMouse) {
            wrapperEvents.push({
                name: 'mousedown',
                handler: this.start.bind(this),
            });
            targetEvents.push({
                name: 'mousemove',
                handler: this.move.bind(this),
            }, {
                name: 'mouseup',
                handler: this.end.bind(this),
            });
        }
        this.wrapperEventRegister = new EventRegister(wrapper, wrapperEvents);
        this.targetEventRegister = new EventRegister(target, targetEvents);
    };
    ActionsHandler.prototype.beforeHandler = function (e, type) {
        var _a = this.options, preventDefault = _a.preventDefault, stopPropagation = _a.stopPropagation, preventDefaultException = _a.preventDefaultException;
        var preventDefaultConditions = {
            start: function () {
                return (preventDefault &&
                    !preventDefaultExceptionFn(e.target, preventDefaultException));
            },
            end: function () {
                return (preventDefault &&
                    !preventDefaultExceptionFn(e.target, preventDefaultException));
            },
            move: function () {
                return preventDefault;
            },
        };
        if (preventDefaultConditions[type]()) {
            e.preventDefault();
        }
        if (stopPropagation) {
            e.stopPropagation();
        }
    };
    ActionsHandler.prototype.setInitiated = function (type) {
        if (type === void 0) { type = 0; }
        this.initiated = type;
    };
    ActionsHandler.prototype.start = function (e) {
        var _eventType = eventTypeMap[e.type];
        if (this.initiated && this.initiated !== _eventType) {
            return;
        }
        this.setInitiated(_eventType);
        // if textarea or other html tags in options.tagException is manipulated
        // do not make bs scroll
        if (tagExceptionFn(e.target, this.options.tagException)) {
            this.setInitiated();
            return;
        }
        // only allow mouse left button
        if (_eventType === 2 /* Mouse */ && e.button !== 0 /* Left */)
            return;
        if (this.hooks.trigger(this.hooks.eventTypes.beforeStart, e)) {
            return;
        }
        this.beforeHandler(e, 'start');
        var point = (e.touches ? e.touches[0] : e);
        this.pointX = point.pageX;
        this.pointY = point.pageY;
        this.hooks.trigger(this.hooks.eventTypes.start, e);
    };
    ActionsHandler.prototype.move = function (e) {
        if (eventTypeMap[e.type] !== this.initiated) {
            return;
        }
        this.beforeHandler(e, 'move');
        var point = (e.touches ? e.touches[0] : e);
        var deltaX = point.pageX - this.pointX;
        var deltaY = point.pageY - this.pointY;
        this.pointX = point.pageX;
        this.pointY = point.pageY;
        if (this.hooks.trigger(this.hooks.eventTypes.move, {
            deltaX: deltaX,
            deltaY: deltaY,
            e: e,
        })) {
            return;
        }
        // auto end when out of viewport
        var scrollLeft = document.documentElement.scrollLeft ||
            window.pageXOffset ||
            document.body.scrollLeft;
        var scrollTop = document.documentElement.scrollTop ||
            window.pageYOffset ||
            document.body.scrollTop;
        var pX = this.pointX - scrollLeft;
        var pY = this.pointY - scrollTop;
        var autoEndDistance = this.options.autoEndDistance;
        if (pX > document.documentElement.clientWidth - autoEndDistance ||
            pY > document.documentElement.clientHeight - autoEndDistance ||
            pX < autoEndDistance ||
            pY < autoEndDistance) {
            this.end(e);
        }
    };
    ActionsHandler.prototype.end = function (e) {
        if (eventTypeMap[e.type] !== this.initiated) {
            return;
        }
        this.setInitiated();
        this.beforeHandler(e, 'end');
        this.hooks.trigger(this.hooks.eventTypes.end, e);
    };
    ActionsHandler.prototype.click = function (e) {
        this.hooks.trigger(this.hooks.eventTypes.click, e);
    };
    ActionsHandler.prototype.setContent = function (content) {
        if (content !== this.wrapper) {
            this.wrapper = content;
            this.rebindDOMEvents();
        }
    };
    ActionsHandler.prototype.rebindDOMEvents = function () {
        this.wrapperEventRegister.destroy();
        this.targetEventRegister.destroy();
        this.handleDOMEvents();
    };
    ActionsHandler.prototype.destroy = function () {
        this.wrapperEventRegister.destroy();
        this.targetEventRegister.destroy();
        this.hooks.destroy();
    };
    return ActionsHandler;
}());

var translaterMetaData = {
    x: ['translateX', 'px'],
    y: ['translateY', 'px'],
};
var Translater = /** @class */ (function () {
    function Translater(content) {
        this.setContent(content);
        this.hooks = new EventEmitter(['beforeTranslate', 'translate']);
    }
    Translater.prototype.getComputedPosition = function () {
        var cssStyle = window.getComputedStyle(this.content, null);
        var matrix = cssStyle[style.transform].split(')')[0].split(', ');
        var x = +(matrix[12] || matrix[4]) || 0;
        var y = +(matrix[13] || matrix[5]) || 0;
        return {
            x: x,
            y: y,
        };
    };
    Translater.prototype.translate = function (point) {
        var transformStyle = [];
        Object.keys(point).forEach(function (key) {
            if (!translaterMetaData[key]) {
                return;
            }
            var transformFnName = translaterMetaData[key][0];
            if (transformFnName) {
                var transformFnArgUnit = translaterMetaData[key][1];
                var transformFnArg = point[key];
                transformStyle.push(transformFnName + "(" + transformFnArg + transformFnArgUnit + ")");
            }
        });
        this.hooks.trigger(this.hooks.eventTypes.beforeTranslate, transformStyle, point);
        this.style[style.transform] = transformStyle.join(' ');
        this.hooks.trigger(this.hooks.eventTypes.translate, point);
    };
    Translater.prototype.setContent = function (content) {
        if (this.content !== content) {
            this.content = content;
            this.style = content.style;
        }
    };
    Translater.prototype.destroy = function () {
        this.hooks.destroy();
    };
    return Translater;
}());

var Base = /** @class */ (function () {
    function Base(content, translater, options) {
        this.translater = translater;
        this.options = options;
        this.timer = 0;
        this.hooks = new EventEmitter([
            'move',
            'end',
            'beforeForceStop',
            'forceStop',
            'callStop',
            'time',
            'timeFunction',
        ]);
        this.setContent(content);
    }
    Base.prototype.translate = function (endPoint) {
        this.translater.translate(endPoint);
    };
    Base.prototype.setPending = function (pending) {
        this.pending = pending;
    };
    Base.prototype.setForceStopped = function (forceStopped) {
        this.forceStopped = forceStopped;
    };
    Base.prototype.setCallStop = function (called) {
        this.callStopWhenPending = called;
    };
    Base.prototype.setContent = function (content) {
        if (this.content !== content) {
            this.content = content;
            this.style = content.style;
            this.stop();
        }
    };
    Base.prototype.clearTimer = function () {
        if (this.timer) {
            cancelAnimationFrame(this.timer);
            this.timer = 0;
        }
    };
    Base.prototype.destroy = function () {
        this.hooks.destroy();
        cancelAnimationFrame(this.timer);
    };
    return Base;
}());

// iOS 13.6 - 14.x, window.getComputedStyle sometimes will get wrong transform value
// when bs use transition mode
// eg: translateY -100px -> -200px, when the last frame which is about to scroll to -200px
// window.getComputedStyle(this.content) will calculate transformY to be -100px(startPoint)
// it is weird
// so we should validate position caculated by 'window.getComputedStyle'
var isValidPostion = function (startPoint, endPoint, currentPos, prePos) {
    var computeDirection = function (endValue, startValue) {
        var delta = endValue - startValue;
        var direction = delta > 0
            ? -1 /* Negative */
            : delta < 0
                ? 1 /* Positive */
                : 0 /* Default */;
        return direction;
    };
    var directionX = computeDirection(endPoint.x, startPoint.x);
    var directionY = computeDirection(endPoint.y, startPoint.y);
    var deltaX = currentPos.x - prePos.x;
    var deltaY = currentPos.y - prePos.y;
    return directionX * deltaX <= 0 && directionY * deltaY <= 0;
};

var Transition = /** @class */ (function (_super) {
    __extends(Transition, _super);
    function Transition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Transition.prototype.startProbe = function (startPoint, endPoint) {
        var _this = this;
        var prePos = startPoint;
        var probe = function () {
            var pos = _this.translater.getComputedPosition();
            if (isValidPostion(startPoint, endPoint, pos, prePos)) {
                _this.hooks.trigger(_this.hooks.eventTypes.move, pos);
            }
            // call bs.stop() should not dispatch end hook again.
            // forceStop hook will do this.
            /* istanbul ignore if  */
            if (!_this.pending) {
                if (_this.callStopWhenPending) {
                    _this.callStopWhenPending = false;
                }
                else {
                    // transition ends should dispatch end hook.
                    _this.hooks.trigger(_this.hooks.eventTypes.end, pos);
                }
            }
            prePos = pos;
            if (_this.pending) {
                _this.timer = requestAnimationFrame(probe);
            }
        };
        // when manually call bs.stop(), then bs.scrollTo()
        // we should reset callStopWhenPending to dispatch end hook
        if (this.callStopWhenPending) {
            this.setCallStop(false);
        }
        cancelAnimationFrame(this.timer);
        probe();
    };
    Transition.prototype.transitionTime = function (time) {
        if (time === void 0) { time = 0; }
        this.style[style.transitionDuration] = time + 'ms';
        this.hooks.trigger(this.hooks.eventTypes.time, time);
    };
    Transition.prototype.transitionTimingFunction = function (easing) {
        this.style[style.transitionTimingFunction] = easing;
        this.hooks.trigger(this.hooks.eventTypes.timeFunction, easing);
    };
    Transition.prototype.transitionProperty = function () {
        this.style[style.transitionProperty] = style.transform;
    };
    Transition.prototype.move = function (startPoint, endPoint, time, easingFn) {
        this.setPending(time > 0);
        this.transitionTimingFunction(easingFn);
        this.transitionProperty();
        this.transitionTime(time);
        this.translate(endPoint);
        var isRealtimeProbeType = this.options.probeType === 3 /* Realtime */;
        if (time && isRealtimeProbeType) {
            this.startProbe(startPoint, endPoint);
        }
        // if we change content's transformY in a tick
        // such as: 0 -> 50px -> 0
        // transitionend will not be triggered
        // so we forceupdate by reflow
        if (!time) {
            this._reflow = this.content.offsetHeight;
            if (isRealtimeProbeType) {
                this.hooks.trigger(this.hooks.eventTypes.move, endPoint);
            }
            this.hooks.trigger(this.hooks.eventTypes.end, endPoint);
        }
    };
    Transition.prototype.doStop = function () {
        var pending = this.pending;
        this.setForceStopped(false);
        this.setCallStop(false);
        // still in transition
        if (pending) {
            this.setPending(false);
            cancelAnimationFrame(this.timer);
            var _a = this.translater.getComputedPosition(), x = _a.x, y = _a.y;
            this.transitionTime();
            this.translate({ x: x, y: y });
            this.setForceStopped(true);
            this.setCallStop(true);
            this.hooks.trigger(this.hooks.eventTypes.forceStop, { x: x, y: y });
        }
        return pending;
    };
    Transition.prototype.stop = function () {
        var stopFromTransition = this.doStop();
        if (stopFromTransition) {
            this.hooks.trigger(this.hooks.eventTypes.callStop);
        }
    };
    return Transition;
}(Base));

var Animation = /** @class */ (function (_super) {
    __extends(Animation, _super);
    function Animation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Animation.prototype.move = function (startPoint, endPoint, time, easingFn) {
        // time is 0
        if (!time) {
            this.translate(endPoint);
            if (this.options.probeType === 3 /* Realtime */) {
                this.hooks.trigger(this.hooks.eventTypes.move, endPoint);
            }
            this.hooks.trigger(this.hooks.eventTypes.end, endPoint);
            return;
        }
        this.animate(startPoint, endPoint, time, easingFn);
    };
    Animation.prototype.animate = function (startPoint, endPoint, duration, easingFn) {
        var _this = this;
        var startTime = getNow();
        var destTime = startTime + duration;
        var isRealtimeProbeType = this.options.probeType === 3 /* Realtime */;
        var step = function () {
            var now = getNow();
            // js animation end
            if (now >= destTime) {
                _this.translate(endPoint);
                if (isRealtimeProbeType) {
                    _this.hooks.trigger(_this.hooks.eventTypes.move, endPoint);
                }
                _this.hooks.trigger(_this.hooks.eventTypes.end, endPoint);
                return;
            }
            now = (now - startTime) / duration;
            var easing = easingFn(now);
            var newPoint = {};
            Object.keys(endPoint).forEach(function (key) {
                var startValue = startPoint[key];
                var endValue = endPoint[key];
                newPoint[key] = (endValue - startValue) * easing + startValue;
            });
            _this.translate(newPoint);
            if (isRealtimeProbeType) {
                _this.hooks.trigger(_this.hooks.eventTypes.move, newPoint);
            }
            if (_this.pending) {
                _this.timer = requestAnimationFrame(step);
            }
            // call bs.stop() should not dispatch end hook again.
            // forceStop hook will do this.
            /* istanbul ignore if  */
            if (!_this.pending) {
                if (_this.callStopWhenPending) {
                    _this.callStopWhenPending = false;
                }
                else {
                    // raf ends should dispatch end hook.
                    _this.hooks.trigger(_this.hooks.eventTypes.end, endPoint);
                }
            }
        };
        this.setPending(true);
        // when manually call bs.stop(), then bs.scrollTo()
        // we should reset callStopWhenPending to dispatch end hook
        if (this.callStopWhenPending) {
            this.setCallStop(false);
        }
        cancelAnimationFrame(this.timer);
        step();
    };
    Animation.prototype.doStop = function () {
        var pending = this.pending;
        this.setForceStopped(false);
        this.setCallStop(false);
        // still in requestFrameAnimation
        if (pending) {
            this.setPending(false);
            cancelAnimationFrame(this.timer);
            var pos = this.translater.getComputedPosition();
            this.setForceStopped(true);
            this.setCallStop(true);
            this.hooks.trigger(this.hooks.eventTypes.forceStop, pos);
        }
        return pending;
    };
    Animation.prototype.stop = function () {
        var stopFromAnimation = this.doStop();
        if (stopFromAnimation) {
            this.hooks.trigger(this.hooks.eventTypes.callStop);
        }
    };
    return Animation;
}(Base));

function createAnimater(element, translater, options) {
    var useTransition = options.useTransition;
    var animaterOptions = {};
    Object.defineProperty(animaterOptions, 'probeType', {
        enumerable: true,
        configurable: false,
        get: function () {
            return options.probeType;
        },
    });
    if (useTransition) {
        return new Transition(element, translater, animaterOptions);
    }
    else {
        return new Animation(element, translater, animaterOptions);
    }
}

var Behavior = /** @class */ (function () {
    function Behavior(wrapper, content, options) {
        this.wrapper = wrapper;
        this.options = options;
        this.hooks = new EventEmitter([
            'beforeComputeBoundary',
            'computeBoundary',
            'momentum',
            'end',
            'ignoreHasScroll'
        ]);
        this.refresh(content);
    }
    Behavior.prototype.start = function () {
        this.dist = 0;
        this.setMovingDirection(0 /* Default */);
        this.setDirection(0 /* Default */);
    };
    Behavior.prototype.move = function (delta) {
        delta = this.hasScroll ? delta : 0;
        this.setMovingDirection(delta);
        return this.performDampingAlgorithm(delta, this.options.outOfBoundaryDampingFactor);
    };
    Behavior.prototype.setMovingDirection = function (delta) {
        this.movingDirection =
            delta > 0
                ? -1 /* Negative */
                : delta < 0
                    ? 1 /* Positive */
                    : 0 /* Default */;
    };
    Behavior.prototype.setDirection = function (delta) {
        this.direction =
            delta > 0
                ? -1 /* Negative */
                : delta < 0
                    ? 1 /* Positive */
                    : 0 /* Default */;
    };
    Behavior.prototype.performDampingAlgorithm = function (delta, dampingFactor) {
        var newPos = this.currentPos + delta;
        // Slow down or stop if outside of the boundaries
        if (newPos > this.minScrollPos || newPos < this.maxScrollPos) {
            if ((newPos > this.minScrollPos && this.options.bounces[0]) ||
                (newPos < this.maxScrollPos && this.options.bounces[1])) {
                newPos = this.currentPos + delta * dampingFactor;
            }
            else {
                newPos =
                    newPos > this.minScrollPos ? this.minScrollPos : this.maxScrollPos;
            }
        }
        return newPos;
    };
    Behavior.prototype.end = function (duration) {
        var momentumInfo = {
            duration: 0
        };
        var absDist = Math.abs(this.currentPos - this.startPos);
        // start momentum animation if needed
        if (this.options.momentum &&
            duration < this.options.momentumLimitTime &&
            absDist > this.options.momentumLimitDistance) {
            var wrapperSize = (this.direction === -1 /* Negative */ && this.options.bounces[0]) ||
                (this.direction === 1 /* Positive */ && this.options.bounces[1])
                ? this.wrapperSize
                : 0;
            momentumInfo = this.hasScroll
                ? this.momentum(this.currentPos, this.startPos, duration, this.maxScrollPos, this.minScrollPos, wrapperSize, this.options)
                : { destination: this.currentPos, duration: 0 };
        }
        else {
            this.hooks.trigger(this.hooks.eventTypes.end, momentumInfo);
        }
        return momentumInfo;
    };
    Behavior.prototype.momentum = function (current, start, time, lowerMargin, upperMargin, wrapperSize, options) {
        if (options === void 0) { options = this.options; }
        var distance = current - start;
        var speed = Math.abs(distance) / time;
        var deceleration = options.deceleration, swipeBounceTime = options.swipeBounceTime, swipeTime = options.swipeTime;
        var duration = Math.min(swipeTime, (speed * 2) / deceleration);
        var momentumData = {
            destination: current + ((speed * speed) / deceleration) * (distance < 0 ? -1 : 1),
            duration: duration,
            rate: 15
        };
        this.hooks.trigger(this.hooks.eventTypes.momentum, momentumData, distance);
        if (momentumData.destination < lowerMargin) {
            momentumData.destination = wrapperSize
                ? Math.max(lowerMargin - wrapperSize / 4, lowerMargin - (wrapperSize / momentumData.rate) * speed)
                : lowerMargin;
            momentumData.duration = swipeBounceTime;
        }
        else if (momentumData.destination > upperMargin) {
            momentumData.destination = wrapperSize
                ? Math.min(upperMargin + wrapperSize / 4, upperMargin + (wrapperSize / momentumData.rate) * speed)
                : upperMargin;
            momentumData.duration = swipeBounceTime;
        }
        momentumData.destination = Math.round(momentumData.destination);
        return momentumData;
    };
    Behavior.prototype.updateDirection = function () {
        var absDist = this.currentPos - this.absStartPos;
        this.setDirection(absDist);
    };
    Behavior.prototype.refresh = function (content) {
        var _a = this.options.rect, size = _a.size, position = _a.position;
        var isWrapperStatic = window.getComputedStyle(this.wrapper, null).position === 'static';
        // Force reflow
        var wrapperRect = getRect(this.wrapper);
        // use client is more fair than offset
        this.wrapperSize = this.wrapper[size === 'width' ? 'clientWidth' : 'clientHeight'];
        this.setContent(content);
        var contentRect = getRect(this.content);
        this.contentSize = contentRect[size];
        this.relativeOffset = contentRect[position];
        /* istanbul ignore if  */
        if (isWrapperStatic) {
            this.relativeOffset -= wrapperRect[position];
        }
        this.computeBoundary();
        this.setDirection(0 /* Default */);
    };
    Behavior.prototype.setContent = function (content) {
        if (content !== this.content) {
            this.content = content;
            this.resetState();
        }
    };
    Behavior.prototype.resetState = function () {
        this.currentPos = 0;
        this.startPos = 0;
        this.dist = 0;
        this.setDirection(0 /* Default */);
        this.setMovingDirection(0 /* Default */);
        this.resetStartPos();
    };
    Behavior.prototype.computeBoundary = function () {
        this.hooks.trigger(this.hooks.eventTypes.beforeComputeBoundary);
        var boundary = {
            minScrollPos: 0,
            maxScrollPos: this.wrapperSize - this.contentSize
        };
        if (boundary.maxScrollPos < 0) {
            boundary.maxScrollPos -= this.relativeOffset;
            if (this.options.specifiedIndexAsContent === 0) {
                boundary.minScrollPos = -this.relativeOffset;
            }
        }
        this.hooks.trigger(this.hooks.eventTypes.computeBoundary, boundary);
        this.minScrollPos = boundary.minScrollPos;
        this.maxScrollPos = boundary.maxScrollPos;
        this.hasScroll =
            this.options.scrollable && this.maxScrollPos < this.minScrollPos;
        if (!this.hasScroll && this.minScrollPos < this.maxScrollPos) {
            this.maxScrollPos = this.minScrollPos;
            this.contentSize = this.wrapperSize;
        }
    };
    Behavior.prototype.updatePosition = function (pos) {
        this.currentPos = pos;
    };
    Behavior.prototype.getCurrentPos = function () {
        return this.currentPos;
    };
    Behavior.prototype.checkInBoundary = function () {
        var position = this.adjustPosition(this.currentPos);
        var inBoundary = position === this.getCurrentPos();
        return {
            position: position,
            inBoundary: inBoundary
        };
    };
    // adjust position when out of boundary
    Behavior.prototype.adjustPosition = function (pos) {
        if (!this.hasScroll &&
            !this.hooks.trigger(this.hooks.eventTypes.ignoreHasScroll)) {
            pos = this.minScrollPos;
        }
        else if (pos > this.minScrollPos) {
            pos = this.minScrollPos;
        }
        else if (pos < this.maxScrollPos) {
            pos = this.maxScrollPos;
        }
        return pos;
    };
    Behavior.prototype.updateStartPos = function () {
        this.startPos = this.currentPos;
    };
    Behavior.prototype.updateAbsStartPos = function () {
        this.absStartPos = this.currentPos;
    };
    Behavior.prototype.resetStartPos = function () {
        this.updateStartPos();
        this.updateAbsStartPos();
    };
    Behavior.prototype.getAbsDist = function (delta) {
        this.dist += delta;
        return Math.abs(this.dist);
    };
    Behavior.prototype.destroy = function () {
        this.hooks.destroy();
    };
    return Behavior;
}());

var _a, _b, _c, _d;
var PassthroughHandlers = (_a = {},
    _a["yes" /* Yes */] = function (e) {
        return true;
    },
    _a["no" /* No */] = function (e) {
        e.preventDefault();
        return false;
    },
    _a);
var DirectionMap = (_b = {},
    _b["horizontal" /* Horizontal */] = (_c = {},
        _c["yes" /* Yes */] = "horizontal" /* Horizontal */,
        _c["no" /* No */] = "vertical" /* Vertical */,
        _c),
    _b["vertical" /* Vertical */] = (_d = {},
        _d["yes" /* Yes */] = "vertical" /* Vertical */,
        _d["no" /* No */] = "horizontal" /* Horizontal */,
        _d),
    _b);
var DirectionLockAction = /** @class */ (function () {
    function DirectionLockAction(directionLockThreshold, freeScroll, eventPassthrough) {
        this.directionLockThreshold = directionLockThreshold;
        this.freeScroll = freeScroll;
        this.eventPassthrough = eventPassthrough;
        this.reset();
    }
    DirectionLockAction.prototype.reset = function () {
        this.directionLocked = "" /* Default */;
    };
    DirectionLockAction.prototype.checkMovingDirection = function (absDistX, absDistY, e) {
        this.computeDirectionLock(absDistX, absDistY);
        return this.handleEventPassthrough(e);
    };
    DirectionLockAction.prototype.adjustDelta = function (deltaX, deltaY) {
        if (this.directionLocked === "horizontal" /* Horizontal */) {
            deltaY = 0;
        }
        else if (this.directionLocked === "vertical" /* Vertical */) {
            deltaX = 0;
        }
        return {
            deltaX: deltaX,
            deltaY: deltaY
        };
    };
    DirectionLockAction.prototype.computeDirectionLock = function (absDistX, absDistY) {
        // If you are scrolling in one direction, lock it
        if (this.directionLocked === "" /* Default */ && !this.freeScroll) {
            if (absDistX > absDistY + this.directionLockThreshold) {
                this.directionLocked = "horizontal" /* Horizontal */; // lock horizontally
            }
            else if (absDistY >= absDistX + this.directionLockThreshold) {
                this.directionLocked = "vertical" /* Vertical */; // lock vertically
            }
            else {
                this.directionLocked = "none" /* None */; // no lock
            }
        }
    };
    DirectionLockAction.prototype.handleEventPassthrough = function (e) {
        var handleMap = DirectionMap[this.directionLocked];
        if (handleMap) {
            if (this.eventPassthrough === handleMap["yes" /* Yes */]) {
                return PassthroughHandlers["yes" /* Yes */](e);
            }
            else if (this.eventPassthrough === handleMap["no" /* No */]) {
                return PassthroughHandlers["no" /* No */](e);
            }
        }
        return false;
    };
    return DirectionLockAction;
}());

var applyQuadrantTransformation = function (deltaX, deltaY, quadrant) {
    if (quadrant === 2 /* Second */) {
        return [deltaY, -deltaX];
    }
    else if (quadrant === 3 /* Third */) {
        return [-deltaX, -deltaY];
    }
    else if (quadrant === 4 /* Forth */) {
        return [-deltaY, deltaX];
    }
    else {
        return [deltaX, deltaY];
    }
};
var ScrollerActions = /** @class */ (function () {
    function ScrollerActions(scrollBehaviorX, scrollBehaviorY, actionsHandler, animater, options) {
        this.hooks = new EventEmitter([
            'start',
            'beforeMove',
            'scrollStart',
            'scroll',
            'beforeEnd',
            'end',
            'scrollEnd',
            'contentNotMoved',
            'detectMovingDirection',
            'coordinateTransformation',
        ]);
        this.scrollBehaviorX = scrollBehaviorX;
        this.scrollBehaviorY = scrollBehaviorY;
        this.actionsHandler = actionsHandler;
        this.animater = animater;
        this.options = options;
        this.directionLockAction = new DirectionLockAction(options.directionLockThreshold, options.freeScroll, options.eventPassthrough);
        this.enabled = true;
        this.bindActionsHandler();
    }
    ScrollerActions.prototype.bindActionsHandler = function () {
        var _this = this;
        // [mouse|touch]start event
        this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.start, function (e) {
            if (!_this.enabled)
                return true;
            return _this.handleStart(e);
        });
        // [mouse|touch]move event
        this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.move, function (_a) {
            var deltaX = _a.deltaX, deltaY = _a.deltaY, e = _a.e;
            if (!_this.enabled)
                return true;
            var _b = applyQuadrantTransformation(deltaX, deltaY, _this.options.quadrant), transformateDeltaX = _b[0], transformateDeltaY = _b[1];
            var transformateDeltaData = {
                deltaX: transformateDeltaX,
                deltaY: transformateDeltaY,
            };
            _this.hooks.trigger(_this.hooks.eventTypes.coordinateTransformation, transformateDeltaData);
            return _this.handleMove(transformateDeltaData.deltaX, transformateDeltaData.deltaY, e);
        });
        // [mouse|touch]end event
        this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.end, function (e) {
            if (!_this.enabled)
                return true;
            return _this.handleEnd(e);
        });
        // click
        this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.click, function (e) {
            // handle native click event
            if (_this.enabled && !e._constructed) {
                _this.handleClick(e);
            }
        });
    };
    ScrollerActions.prototype.handleStart = function (e) {
        var timestamp = getNow();
        this.fingerMoved = false;
        this.contentMoved = false;
        this.startTime = timestamp;
        this.directionLockAction.reset();
        this.scrollBehaviorX.start();
        this.scrollBehaviorY.start();
        // force stopping last transition or animation
        this.animater.doStop();
        this.scrollBehaviorX.resetStartPos();
        this.scrollBehaviorY.resetStartPos();
        this.hooks.trigger(this.hooks.eventTypes.start, e);
    };
    ScrollerActions.prototype.handleMove = function (deltaX, deltaY, e) {
        if (this.hooks.trigger(this.hooks.eventTypes.beforeMove, e)) {
            return;
        }
        var absDistX = this.scrollBehaviorX.getAbsDist(deltaX);
        var absDistY = this.scrollBehaviorY.getAbsDist(deltaY);
        var timestamp = getNow();
        // We need to move at least momentumLimitDistance pixels
        // for the scrolling to initiate
        if (this.checkMomentum(absDistX, absDistY, timestamp)) {
            return true;
        }
        if (this.directionLockAction.checkMovingDirection(absDistX, absDistY, e)) {
            this.actionsHandler.setInitiated();
            return true;
        }
        var delta = this.directionLockAction.adjustDelta(deltaX, deltaY);
        var prevX = this.scrollBehaviorX.getCurrentPos();
        var newX = this.scrollBehaviorX.move(delta.deltaX);
        var prevY = this.scrollBehaviorY.getCurrentPos();
        var newY = this.scrollBehaviorY.move(delta.deltaY);
        if (this.hooks.trigger(this.hooks.eventTypes.detectMovingDirection)) {
            return;
        }
        if (!this.fingerMoved) {
            this.fingerMoved = true;
        }
        var positionChanged = newX !== prevX || newY !== prevY;
        if (!this.contentMoved && !positionChanged) {
            this.hooks.trigger(this.hooks.eventTypes.contentNotMoved);
        }
        if (!this.contentMoved && positionChanged) {
            this.contentMoved = true;
            this.hooks.trigger(this.hooks.eventTypes.scrollStart);
        }
        if (this.contentMoved && positionChanged) {
            this.animater.translate({
                x: newX,
                y: newY,
            });
            this.dispatchScroll(timestamp);
        }
    };
    ScrollerActions.prototype.dispatchScroll = function (timestamp) {
        // dispatch scroll in interval time
        if (timestamp - this.startTime > this.options.momentumLimitTime) {
            // refresh time and starting position to initiate a momentum
            this.startTime = timestamp;
            this.scrollBehaviorX.updateStartPos();
            this.scrollBehaviorY.updateStartPos();
            if (this.options.probeType === 1 /* Throttle */) {
                this.hooks.trigger(this.hooks.eventTypes.scroll, this.getCurrentPos());
            }
        }
        // dispatch scroll all the time
        if (this.options.probeType > 1 /* Throttle */) {
            this.hooks.trigger(this.hooks.eventTypes.scroll, this.getCurrentPos());
        }
    };
    ScrollerActions.prototype.checkMomentum = function (absDistX, absDistY, timestamp) {
        return (timestamp - this.endTime > this.options.momentumLimitTime &&
            absDistY < this.options.momentumLimitDistance &&
            absDistX < this.options.momentumLimitDistance);
    };
    ScrollerActions.prototype.handleEnd = function (e) {
        if (this.hooks.trigger(this.hooks.eventTypes.beforeEnd, e)) {
            return;
        }
        var currentPos = this.getCurrentPos();
        this.scrollBehaviorX.updateDirection();
        this.scrollBehaviorY.updateDirection();
        if (this.hooks.trigger(this.hooks.eventTypes.end, e, currentPos)) {
            return true;
        }
        currentPos = this.ensureIntegerPos(currentPos);
        this.animater.translate(currentPos);
        this.endTime = getNow();
        var duration = this.endTime - this.startTime;
        this.hooks.trigger(this.hooks.eventTypes.scrollEnd, currentPos, duration);
    };
    ScrollerActions.prototype.ensureIntegerPos = function (currentPos) {
        this.ensuringInteger = true;
        var x = currentPos.x, y = currentPos.y;
        var _a = this.scrollBehaviorX, minScrollPosX = _a.minScrollPos, maxScrollPosX = _a.maxScrollPos;
        var _b = this.scrollBehaviorY, minScrollPosY = _b.minScrollPos, maxScrollPosY = _b.maxScrollPos;
        x = x > 0 ? Math.ceil(x) : Math.floor(x);
        y = y > 0 ? Math.ceil(y) : Math.floor(y);
        x = between(x, maxScrollPosX, minScrollPosX);
        y = between(y, maxScrollPosY, minScrollPosY);
        return { x: x, y: y };
    };
    ScrollerActions.prototype.handleClick = function (e) {
        if (!preventDefaultExceptionFn(e.target, this.options.preventDefaultException)) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    ScrollerActions.prototype.getCurrentPos = function () {
        return {
            x: this.scrollBehaviorX.getCurrentPos(),
            y: this.scrollBehaviorY.getCurrentPos(),
        };
    };
    ScrollerActions.prototype.refresh = function () {
        this.endTime = 0;
    };
    ScrollerActions.prototype.destroy = function () {
        this.hooks.destroy();
    };
    return ScrollerActions;
}());

function createActionsHandlerOptions(bsOptions) {
    var options = [
        'click',
        'bindToWrapper',
        'disableMouse',
        'disableTouch',
        'preventDefault',
        'stopPropagation',
        'tagException',
        'preventDefaultException',
        'autoEndDistance',
    ].reduce(function (prev, cur) {
        prev[cur] = bsOptions[cur];
        return prev;
    }, {});
    return options;
}
function createBehaviorOptions(bsOptions, extraProp, bounces, rect) {
    var options = [
        'momentum',
        'momentumLimitTime',
        'momentumLimitDistance',
        'deceleration',
        'swipeBounceTime',
        'swipeTime',
        'outOfBoundaryDampingFactor',
        'specifiedIndexAsContent',
    ].reduce(function (prev, cur) {
        prev[cur] = bsOptions[cur];
        return prev;
    }, {});
    // add extra property
    options.scrollable = !!bsOptions[extraProp];
    options.bounces = bounces;
    options.rect = rect;
    return options;
}

function bubbling(source, target, events) {
    events.forEach(function (event) {
        var sourceEvent;
        var targetEvent;
        if (typeof event === 'string') {
            sourceEvent = targetEvent = event;
        }
        else {
            sourceEvent = event.source;
            targetEvent = event.target;
        }
        source.on(sourceEvent, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return target.trigger.apply(target, __spreadArrays([targetEvent], args));
        });
    });
}

function isSamePoint(startPoint, endPoint) {
    // keys of startPoint and endPoint should be equal
    var keys = Object.keys(startPoint);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (startPoint[key] !== endPoint[key])
            return false;
    }
    return true;
}

var MIN_SCROLL_DISTANCE = 1;
var Scroller = /** @class */ (function () {
    function Scroller(wrapper, content, options) {
        this.wrapper = wrapper;
        this.content = content;
        this.resizeTimeout = 0;
        this.hooks = new EventEmitter([
            'beforeStart',
            'beforeMove',
            'beforeScrollStart',
            'scrollStart',
            'scroll',
            'beforeEnd',
            'scrollEnd',
            'resize',
            'touchEnd',
            'end',
            'flick',
            'scrollCancel',
            'momentum',
            'scrollTo',
            'minDistanceScroll',
            'scrollToElement',
            'beforeRefresh',
        ]);
        this.options = options;
        var _a = this.options.bounce, left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom;
        // direction X
        this.scrollBehaviorX = new Behavior(wrapper, content, createBehaviorOptions(options, 'scrollX', [left, right], {
            size: 'width',
            position: 'left',
        }));
        // direction Y
        this.scrollBehaviorY = new Behavior(wrapper, content, createBehaviorOptions(options, 'scrollY', [top, bottom], {
            size: 'height',
            position: 'top',
        }));
        this.translater = new Translater(this.content);
        this.animater = createAnimater(this.content, this.translater, this.options);
        this.actionsHandler = new ActionsHandler(this.options.bindToTarget ? this.content : wrapper, createActionsHandlerOptions(this.options));
        this.actions = new ScrollerActions(this.scrollBehaviorX, this.scrollBehaviorY, this.actionsHandler, this.animater, this.options);
        var resizeHandler = this.resize.bind(this);
        this.resizeRegister = new EventRegister(window, [
            {
                name: 'orientationchange',
                handler: resizeHandler,
            },
            {
                name: 'resize',
                handler: resizeHandler,
            },
        ]);
        this.registerTransitionEnd();
        this.init();
    }
    Scroller.prototype.init = function () {
        var _this = this;
        this.bindTranslater();
        this.bindAnimater();
        this.bindActions();
        // enable pointer events when scrolling ends
        this.hooks.on(this.hooks.eventTypes.scrollEnd, function () {
            _this.togglePointerEvents(true);
        });
    };
    Scroller.prototype.registerTransitionEnd = function () {
        this.transitionEndRegister = new EventRegister(this.content, [
            {
                name: style.transitionEnd,
                handler: this.transitionEnd.bind(this),
            },
        ]);
    };
    Scroller.prototype.bindTranslater = function () {
        var _this = this;
        var hooks = this.translater.hooks;
        hooks.on(hooks.eventTypes.beforeTranslate, function (transformStyle) {
            if (_this.options.translateZ) {
                transformStyle.push(_this.options.translateZ);
            }
        });
        // disable pointer events when scrolling
        hooks.on(hooks.eventTypes.translate, function (pos) {
            var prevPos = _this.getCurrentPos();
            _this.updatePositions(pos);
            // scrollEnd will dispatch when scroll is force stopping in touchstart handler
            // so in touchend handler, don't toggle pointer-events
            if (_this.actions.ensuringInteger === true) {
                _this.actions.ensuringInteger = false;
                return;
            }
            // a valid translate
            if (pos.x !== prevPos.x || pos.y !== prevPos.y) {
                _this.togglePointerEvents(false);
            }
        });
    };
    Scroller.prototype.bindAnimater = function () {
        var _this = this;
        // reset position
        this.animater.hooks.on(this.animater.hooks.eventTypes.end, function (pos) {
            if (!_this.resetPosition(_this.options.bounceTime)) {
                _this.animater.setPending(false);
                _this.hooks.trigger(_this.hooks.eventTypes.scrollEnd, pos);
            }
        });
        bubbling(this.animater.hooks, this.hooks, [
            {
                source: this.animater.hooks.eventTypes.move,
                target: this.hooks.eventTypes.scroll,
            },
            {
                source: this.animater.hooks.eventTypes.forceStop,
                target: this.hooks.eventTypes.scrollEnd,
            },
        ]);
    };
    Scroller.prototype.bindActions = function () {
        var _this = this;
        var actions = this.actions;
        bubbling(actions.hooks, this.hooks, [
            {
                source: actions.hooks.eventTypes.start,
                target: this.hooks.eventTypes.beforeStart,
            },
            {
                source: actions.hooks.eventTypes.start,
                target: this.hooks.eventTypes.beforeScrollStart,
            },
            {
                source: actions.hooks.eventTypes.beforeMove,
                target: this.hooks.eventTypes.beforeMove,
            },
            {
                source: actions.hooks.eventTypes.scrollStart,
                target: this.hooks.eventTypes.scrollStart,
            },
            {
                source: actions.hooks.eventTypes.scroll,
                target: this.hooks.eventTypes.scroll,
            },
            {
                source: actions.hooks.eventTypes.beforeEnd,
                target: this.hooks.eventTypes.beforeEnd,
            },
        ]);
        actions.hooks.on(actions.hooks.eventTypes.end, function (e, pos) {
            _this.hooks.trigger(_this.hooks.eventTypes.touchEnd, pos);
            if (_this.hooks.trigger(_this.hooks.eventTypes.end, pos)) {
                return true;
            }
            // check if it is a click operation
            if (!actions.fingerMoved) {
                _this.hooks.trigger(_this.hooks.eventTypes.scrollCancel);
                if (_this.checkClick(e)) {
                    return true;
                }
            }
            // reset if we are outside of the boundaries
            if (_this.resetPosition(_this.options.bounceTime, ease.bounce)) {
                _this.animater.setForceStopped(false);
                return true;
            }
        });
        actions.hooks.on(actions.hooks.eventTypes.scrollEnd, function (pos, duration) {
            var deltaX = Math.abs(pos.x - _this.scrollBehaviorX.startPos);
            var deltaY = Math.abs(pos.y - _this.scrollBehaviorY.startPos);
            if (_this.checkFlick(duration, deltaX, deltaY)) {
                _this.animater.setForceStopped(false);
                _this.hooks.trigger(_this.hooks.eventTypes.flick);
                return;
            }
            if (_this.momentum(pos, duration)) {
                _this.animater.setForceStopped(false);
                return;
            }
            if (actions.contentMoved) {
                _this.hooks.trigger(_this.hooks.eventTypes.scrollEnd, pos);
            }
            if (_this.animater.forceStopped) {
                _this.animater.setForceStopped(false);
            }
        });
    };
    Scroller.prototype.checkFlick = function (duration, deltaX, deltaY) {
        var flickMinMovingDistance = 1; // distinguish flick from click
        if (this.hooks.events.flick.length > 1 &&
            duration < this.options.flickLimitTime &&
            deltaX < this.options.flickLimitDistance &&
            deltaY < this.options.flickLimitDistance &&
            (deltaY > flickMinMovingDistance || deltaX > flickMinMovingDistance)) {
            return true;
        }
    };
    Scroller.prototype.momentum = function (pos, duration) {
        var meta = {
            time: 0,
            easing: ease.swiper,
            newX: pos.x,
            newY: pos.y,
        };
        // start momentum animation if needed
        var momentumX = this.scrollBehaviorX.end(duration);
        var momentumY = this.scrollBehaviorY.end(duration);
        meta.newX = isUndef(momentumX.destination)
            ? meta.newX
            : momentumX.destination;
        meta.newY = isUndef(momentumY.destination)
            ? meta.newY
            : momentumY.destination;
        meta.time = Math.max(momentumX.duration, momentumY.duration);
        this.hooks.trigger(this.hooks.eventTypes.momentum, meta, this);
        // when x or y changed, do momentum animation now!
        if (meta.newX !== pos.x || meta.newY !== pos.y) {
            // change easing function when scroller goes out of the boundaries
            if (meta.newX > this.scrollBehaviorX.minScrollPos ||
                meta.newX < this.scrollBehaviorX.maxScrollPos ||
                meta.newY > this.scrollBehaviorY.minScrollPos ||
                meta.newY < this.scrollBehaviorY.maxScrollPos) {
                meta.easing = ease.swipeBounce;
            }
            this.scrollTo(meta.newX, meta.newY, meta.time, meta.easing);
            return true;
        }
    };
    Scroller.prototype.checkClick = function (e) {
        var cancelable = {
            preventClick: this.animater.forceStopped,
        };
        // we scrolled less than momentumLimitDistance pixels
        if (this.hooks.trigger(this.hooks.eventTypes.checkClick)) {
            this.animater.setForceStopped(false);
            return true;
        }
        if (!cancelable.preventClick) {
            var _dblclick = this.options.dblclick;
            var dblclickTrigged = false;
            if (_dblclick && this.lastClickTime) {
                var _a = _dblclick.delay, delay = _a === void 0 ? 300 : _a;
                if (getNow() - this.lastClickTime < delay) {
                    dblclickTrigged = true;
                    dblclick(e);
                }
            }
            if (this.options.tap) {
                tap(e, this.options.tap);
            }
            if (this.options.click &&
                !preventDefaultExceptionFn(e.target, this.options.preventDefaultException)) {
                click(e);
            }
            this.lastClickTime = dblclickTrigged ? null : getNow();
            return true;
        }
        return false;
    };
    Scroller.prototype.resize = function () {
        var _this = this;
        if (!this.actions.enabled) {
            return;
        }
        // fix a scroll problem under Android condition
        /* istanbul ignore if  */
        if (isAndroid) {
            this.wrapper.scrollTop = 0;
        }
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(function () {
            _this.hooks.trigger(_this.hooks.eventTypes.resize);
        }, this.options.resizePolling);
    };
    /* istanbul ignore next */
    Scroller.prototype.transitionEnd = function (e) {
        if (e.target !== this.content || !this.animater.pending) {
            return;
        }
        var animater = this.animater;
        animater.transitionTime();
        if (!this.resetPosition(this.options.bounceTime, ease.bounce)) {
            this.animater.setPending(false);
            if (this.options.probeType !== 3 /* Realtime */) {
                this.hooks.trigger(this.hooks.eventTypes.scrollEnd, this.getCurrentPos());
            }
        }
    };
    Scroller.prototype.togglePointerEvents = function (enabled) {
        if (enabled === void 0) { enabled = true; }
        var el = this.content.children.length
            ? this.content.children
            : [this.content];
        var pointerEvents = enabled ? 'auto' : 'none';
        for (var i = 0; i < el.length; i++) {
            var node = el[i];
            // ignore BetterScroll instance's wrapper DOM
            /* istanbul ignore if  */
            if (node.isBScrollContainer) {
                continue;
            }
            node.style.pointerEvents = pointerEvents;
        }
    };
    Scroller.prototype.refresh = function (content) {
        var contentChanged = this.setContent(content);
        this.hooks.trigger(this.hooks.eventTypes.beforeRefresh);
        this.scrollBehaviorX.refresh(content);
        this.scrollBehaviorY.refresh(content);
        if (contentChanged) {
            this.translater.setContent(content);
            this.animater.setContent(content);
            this.transitionEndRegister.destroy();
            this.registerTransitionEnd();
            if (this.options.bindToTarget) {
                this.actionsHandler.setContent(content);
            }
        }
        this.actions.refresh();
        this.wrapperOffset = offset(this.wrapper);
    };
    Scroller.prototype.setContent = function (content) {
        var contentChanged = content !== this.content;
        if (contentChanged) {
            this.content = content;
        }
        return contentChanged;
    };
    Scroller.prototype.scrollBy = function (deltaX, deltaY, time, easing) {
        if (time === void 0) { time = 0; }
        var _a = this.getCurrentPos(), x = _a.x, y = _a.y;
        easing = !easing ? ease.bounce : easing;
        deltaX += x;
        deltaY += y;
        this.scrollTo(deltaX, deltaY, time, easing);
    };
    Scroller.prototype.scrollTo = function (x, y, time, easing, extraTransform) {
        if (time === void 0) { time = 0; }
        if (easing === void 0) { easing = ease.bounce; }
        if (extraTransform === void 0) { extraTransform = {
            start: {},
            end: {},
        }; }
        var easingFn = this.options.useTransition ? easing.style : easing.fn;
        var currentPos = this.getCurrentPos();
        var startPoint = __assign({ x: currentPos.x, y: currentPos.y }, extraTransform.start);
        var endPoint = __assign({ x: x,
            y: y }, extraTransform.end);
        this.hooks.trigger(this.hooks.eventTypes.scrollTo, endPoint);
        // it is an useless move
        if (isSamePoint(startPoint, endPoint))
            return;
        var deltaX = Math.abs(endPoint.x - startPoint.x);
        var deltaY = Math.abs(endPoint.y - startPoint.y);
        // considering of browser compatibility for decimal transform value
        // force translating immediately
        if (deltaX < MIN_SCROLL_DISTANCE && deltaY < MIN_SCROLL_DISTANCE) {
            time = 0;
            this.hooks.trigger(this.hooks.eventTypes.minDistanceScroll);
        }
        this.animater.move(startPoint, endPoint, time, easingFn);
    };
    Scroller.prototype.scrollToElement = function (el, time, offsetX, offsetY, easing) {
        var targetEle = getElement(el);
        var pos = offset(targetEle);
        var getOffset = function (offset, size, wrapperSize) {
            if (typeof offset === 'number') {
                return offset;
            }
            // if offsetX/Y are true we center the element to the screen
            return offset ? Math.round(size / 2 - wrapperSize / 2) : 0;
        };
        offsetX = getOffset(offsetX, targetEle.offsetWidth, this.wrapper.offsetWidth);
        offsetY = getOffset(offsetY, targetEle.offsetHeight, this.wrapper.offsetHeight);
        var getPos = function (pos, wrapperPos, offset, scrollBehavior) {
            pos -= wrapperPos;
            pos = scrollBehavior.adjustPosition(pos - offset);
            return pos;
        };
        pos.left = getPos(pos.left, this.wrapperOffset.left, offsetX, this.scrollBehaviorX);
        pos.top = getPos(pos.top, this.wrapperOffset.top, offsetY, this.scrollBehaviorY);
        if (this.hooks.trigger(this.hooks.eventTypes.scrollToElement, targetEle, pos)) {
            return;
        }
        this.scrollTo(pos.left, pos.top, time, easing);
    };
    Scroller.prototype.resetPosition = function (time, easing) {
        if (time === void 0) { time = 0; }
        if (easing === void 0) { easing = ease.bounce; }
        var _a = this.scrollBehaviorX.checkInBoundary(), x = _a.position, xInBoundary = _a.inBoundary;
        var _b = this.scrollBehaviorY.checkInBoundary(), y = _b.position, yInBoundary = _b.inBoundary;
        if (xInBoundary && yInBoundary) {
            return false;
        }
        /* istanbul ignore if  */
        if (isIOSBadVersion) {
            // fix ios 13.4 bouncing
            // see it in issues 982
            this.reflow();
        }
        // out of boundary
        this.scrollTo(x, y, time, easing);
        return true;
    };
    /* istanbul ignore next */
    Scroller.prototype.reflow = function () {
        this._reflow = this.content.offsetHeight;
    };
    Scroller.prototype.updatePositions = function (pos) {
        this.scrollBehaviorX.updatePosition(pos.x);
        this.scrollBehaviorY.updatePosition(pos.y);
    };
    Scroller.prototype.getCurrentPos = function () {
        return this.actions.getCurrentPos();
    };
    Scroller.prototype.enable = function () {
        this.actions.enabled = true;
    };
    Scroller.prototype.disable = function () {
        cancelAnimationFrame(this.animater.timer);
        this.actions.enabled = false;
    };
    Scroller.prototype.destroy = function () {
        var _this = this;
        var keys = [
            'resizeRegister',
            'transitionEndRegister',
            'actionsHandler',
            'actions',
            'hooks',
            'animater',
            'translater',
            'scrollBehaviorX',
            'scrollBehaviorY',
        ];
        keys.forEach(function (key) { return _this[key].destroy(); });
    };
    return Scroller;
}());

var BScrollConstructor = /** @class */ (function (_super) {
    __extends(BScrollConstructor, _super);
    function BScrollConstructor(el, options) {
        var _this = _super.call(this, [
            'refresh',
            'contentChanged',
            'enable',
            'disable',
            'beforeScrollStart',
            'scrollStart',
            'scroll',
            'scrollEnd',
            'scrollCancel',
            'touchEnd',
            'flick',
            'destroy'
        ]) || this;
        var wrapper = getElement(el);
        if (!wrapper) {
            warn('Can not resolve the wrapper DOM.');
            return _this;
        }
        _this.plugins = {};
        _this.options = new OptionsConstructor().merge(options).process();
        if (!_this.setContent(wrapper).valid) {
            return _this;
        }
        _this.hooks = new EventEmitter([
            'refresh',
            'enable',
            'disable',
            'destroy',
            'beforeInitialScrollTo',
            'contentChanged'
        ]);
        _this.init(wrapper);
        return _this;
    }
    BScrollConstructor.use = function (ctor) {
        var name = ctor.pluginName;
        var installed = BScrollConstructor.plugins.some(function (plugin) { return ctor === plugin.ctor; });
        if (installed)
            return BScrollConstructor;
        if (isUndef(name)) {
            warn("Plugin Class must specify plugin's name in static property by 'pluginName' field.");
            return BScrollConstructor;
        }
        BScrollConstructor.pluginsMap[name] = true;
        BScrollConstructor.plugins.push({
            name: name,
            applyOrder: ctor.applyOrder,
            ctor: ctor
        });
        return BScrollConstructor;
    };
    BScrollConstructor.prototype.setContent = function (wrapper) {
        var contentChanged = false;
        var valid = true;
        var content = wrapper.children[this.options.specifiedIndexAsContent];
        if (!content) {
            warn('The wrapper need at least one child element to be content element to scroll.');
            valid = false;
        }
        else {
            contentChanged = this.content !== content;
            if (contentChanged) {
                this.content = content;
            }
        }
        return {
            valid: valid,
            contentChanged: contentChanged
        };
    };
    BScrollConstructor.prototype.init = function (wrapper) {
        var _this = this;
        this.wrapper = wrapper;
        // mark wrapper to recognize bs instance by DOM attribute
        wrapper.isBScrollContainer = true;
        this.scroller = new Scroller(wrapper, this.content, this.options);
        this.scroller.hooks.on(this.scroller.hooks.eventTypes.resize, function () {
            _this.refresh();
        });
        this.eventBubbling();
        this.handleAutoBlur();
        this.enable();
        this.proxy(propertiesConfig);
        this.applyPlugins();
        // maybe boundary has changed, should refresh
        this.refreshWithoutReset(this.content);
        var _a = this.options, startX = _a.startX, startY = _a.startY;
        var position = {
            x: startX,
            y: startY
        };
        // maybe plugins want to control scroll position
        if (this.hooks.trigger(this.hooks.eventTypes.beforeInitialScrollTo, position)) {
            return;
        }
        this.scroller.scrollTo(position.x, position.y);
    };
    BScrollConstructor.prototype.applyPlugins = function () {
        var _this = this;
        var options = this.options;
        BScrollConstructor.plugins
            .sort(function (a, b) {
            var _a;
            var applyOrderMap = (_a = {},
                _a["pre" /* Pre */] = -1,
                _a["post" /* Post */] = 1,
                _a);
            var aOrder = a.applyOrder ? applyOrderMap[a.applyOrder] : 0;
            var bOrder = b.applyOrder ? applyOrderMap[b.applyOrder] : 0;
            return aOrder - bOrder;
        })
            .forEach(function (item) {
            var ctor = item.ctor;
            if (options[item.name] && typeof ctor === 'function') {
                _this.plugins[item.name] = new ctor(_this);
            }
        });
    };
    BScrollConstructor.prototype.handleAutoBlur = function () {
        /* istanbul ignore if  */
        if (this.options.autoBlur) {
            this.on(this.eventTypes.beforeScrollStart, function () {
                var activeElement = document.activeElement;
                if (activeElement &&
                    (activeElement.tagName === 'INPUT' ||
                        activeElement.tagName === 'TEXTAREA')) {
                    activeElement.blur();
                }
            });
        }
    };
    BScrollConstructor.prototype.eventBubbling = function () {
        bubbling(this.scroller.hooks, this, [
            this.eventTypes.beforeScrollStart,
            this.eventTypes.scrollStart,
            this.eventTypes.scroll,
            this.eventTypes.scrollEnd,
            this.eventTypes.scrollCancel,
            this.eventTypes.touchEnd,
            this.eventTypes.flick
        ]);
    };
    BScrollConstructor.prototype.refreshWithoutReset = function (content) {
        this.scroller.refresh(content);
        this.hooks.trigger(this.hooks.eventTypes.refresh, content);
        this.trigger(this.eventTypes.refresh, content);
    };
    BScrollConstructor.prototype.proxy = function (propertiesConfig) {
        var _this = this;
        propertiesConfig.forEach(function (_a) {
            var key = _a.key, sourceKey = _a.sourceKey;
            propertiesProxy(_this, sourceKey, key);
        });
    };
    BScrollConstructor.prototype.refresh = function () {
        var _a = this.setContent(this.wrapper), contentChanged = _a.contentChanged, valid = _a.valid;
        if (valid) {
            var content = this.content;
            this.refreshWithoutReset(content);
            if (contentChanged) {
                this.hooks.trigger(this.hooks.eventTypes.contentChanged, content);
                this.trigger(this.eventTypes.contentChanged, content);
            }
            this.scroller.resetPosition();
        }
    };
    BScrollConstructor.prototype.enable = function () {
        this.scroller.enable();
        this.hooks.trigger(this.hooks.eventTypes.enable);
        this.trigger(this.eventTypes.enable);
    };
    BScrollConstructor.prototype.disable = function () {
        this.scroller.disable();
        this.hooks.trigger(this.hooks.eventTypes.disable);
        this.trigger(this.eventTypes.disable);
    };
    BScrollConstructor.prototype.destroy = function () {
        this.hooks.trigger(this.hooks.eventTypes.destroy);
        this.trigger(this.eventTypes.destroy);
        this.scroller.destroy();
    };
    BScrollConstructor.prototype.eventRegister = function (names) {
        this.registerType(names);
    };
    BScrollConstructor.plugins = [];
    BScrollConstructor.pluginsMap = {};
    return BScrollConstructor;
}(EventEmitter));
function createBScroll(el, options) {
    var bs = new BScrollConstructor(el, options);
    return bs;
}
createBScroll.use = BScrollConstructor.use;
createBScroll.plugins = BScrollConstructor.plugins;
createBScroll.pluginsMap = BScrollConstructor.pluginsMap;
var BScroll = createBScroll;

/* harmony default export */ __webpack_exports__["a"] = (BScroll);



/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCashBackAct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__countdown__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_utils__ = __webpack_require__(7);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineCashBackAct=/*#__PURE__*/function(_React$Component){_inherits(PipelineCashBackAct,_React$Component);var _super=_createSuper(PipelineCashBackAct);function PipelineCashBackAct(props){var _this;_classCallCheck(this,PipelineCashBackAct);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"judgeIsLogin",function(){_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=setInterval(function(){var isLogin=_this.state.isLogin;if(!isLogin){var CookieUA=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getCookie('u');if(CookieUA&&CookieU){Promise.all([CookieUA,CookieU]).then(function(result){_this.setState({isLogin:result&&result[0]&&result[1]});});}}else{_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=null;}},500);});_defineProperty(_assertThisInitialized(_this),"handleLogin",function(){if(__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].isShihuo()){// 未登陆，请先进行微信登陆
if(_this.loginInterVal){return;}if(!__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].isAndroid()&&__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].SHDiffVersion(_this.app_version,'6.86.0')){_this.judgeIsLogin();}else{window.Jockey.send("subscribe",{},function(publishData){if(publishData.type==="loginSuccess"){_this.loginInterVal=setInterval(function(){_this.queryLoginStatus();},500);}setTimeout(function(){_this.loginInterVal&&clearInterval(_this.loginInterVal);_this.loginInterVal=null;},15000);});}window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});_defineProperty(_assertThisInitialized(_this),"queryLoginStatus",function(){try{Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:"https://sh-gateway.shihuo.cn/v4/services/sh-user/user/baseInfo?from=".concat(_this.pageId,"&need_wechat_info=false&complicate=true"),method:'get',withCredentials:true}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){if(data.user_info&&data.user_info.uid){_this.loginInterVal&&clearInterval(_this.loginInterVal);_this.loginInterVal=null;_this.setState({isLogin:true},function(){_this.queryCouponsStatus();});}}else{_this.setState({isLogin:false},function(){_this.queryCouponsStatus();});}});}catch(error){_this.queryCouponsStatus();}});_defineProperty(_assertThisInitialized(_this),"queryCouponsStatus",function(){var couponsConfig=_this.props.config.couponsConfig;Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/couponInfo?access_token=2322TizdV3pjw8CBsy&activity_code='+couponsConfig.activityCode,method:'get',withCredentials:true}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){var list=data.list;_this.setState({coupons_show:true,coupon_list:list,is_rec:list&&list.length>0?true:false,expire_time:list&&list[0]&&list[0].end_time.replace(/-/g,'/')});}else{_this.setState({coupons_show:true});}});});_defineProperty(_assertThisInitialized(_this),"getCashbackCoupons",function(){var couponsConfig=_this.props.config.couponsConfig;Object(__WEBPACK_IMPORTED_MODULE_20__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/recCoupon?access_token=2322TizdV3pjw8CBsy',method:'post',withCredentials:true,data:{activity_code:couponsConfig.activityCode}}).then(function(res){var _res$data3=res.data,status=_res$data3.status,msg=_res$data3.msg;if(status!==0){window.Jockey.send('toast',{text:msg});}else{window.Jockey.send('toast',{text:'领取成功'});_this.queryCouponsStatus();}});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(){__WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({from:typeof window!=="undefined"?window.location.href:"",block:_this.props.customAttributes?_this.props.customAttributes['data-component-block']:"",pageId:_this.pageId,pti:{id:'',name:'',pageId:_this.pageId,biz:'',root:{id:'',pageId:'',name:'',biz:''},parent:{id:'',pageId:'',name:'',biz:''}}});__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].uploadTrack(_this.props);if(!_this.state.isLogin){_this.handleLogin();return;}if(!_this.state.is_rec){_this.getCashbackCoupons();}});_defineProperty(_assertThisInitialized(_this),"handleRuleClick",function(){if(_this.isNewVersionUI){var ruleUrl='shihuo://www.shihuo.cn?route=RNProgram&page=MyActivityShow&miniId=Shihuo_Category';__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,ruleUrl,ruleUrl,{},-1,_this.props);}else{_this.setState({popupShow:true});}});_defineProperty(_assertThisInitialized(_this),"closePopup",function(){_this.setState({popupShow:false});});_defineProperty(_assertThisInitialized(_this),"renderCouponsList",function(){var _this$state=_this.state,coupon_list=_this$state.coupon_list,expire_time=_this$state.expire_time;var couponsConfig=_this.props.config.couponsConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"coupons-info",style:{backgroundColor:couponsConfig.couponBackgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"title"},couponsConfig.couponTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"rule",onClick:function onClick(){return _this.handleRuleClick();}},'使用规则 >'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"coupon-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"scroll"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",null,coupon_list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"coupon-item",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:couponsConfig.couponBackgroundImage,alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"money"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",null,"\uFFE5"),parseFloat(item.cash_back)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"desc"},parseFloat(item.start_amount)>0?"\u6EE1".concat(parseFloat(item.start_amount),"\u8FD4"):'无门槛')));})))),!couponsConfig.noCountDown&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"count-down"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__countdown__["a" /* default */],{end_time:expire_time,isNewVersionUI:_this.isNewVersionUI})));});_defineProperty(_assertThisInitialized(_this),"renderPopup",function(){var _this$props$config$ba=_this.props.config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba;var popupShow=_this.state.popupShow;if(popupShow){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"mask"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"popup"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("h3",{className:"title"},"\u8FD4\u73B0\u5238\u4F7F\u7528\u8BF4\u660E"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"rule-txt",dangerouslySetInnerHTML:{__html:baseConfig.ruleTxt}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210513/a46af66b3552cc3cc5cbc82929448a96.png",alt:"",className:"image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"btn",onClick:function onClick(){return _this.closePopup();}},"\u7ACB\u5373\u4F7F\u7528"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png",alt:"",className:"close",onClick:function onClick(){return _this.closePopup();}}))));}else{return null;}});_this.state={isLogin:false,coupon_list:[],is_rec:false,expire_time:'',popupShow:false,coupons_show:false};_this.interval=null;_this.loginInterVal=null;_this.isNewVersionUI=props.config.couponsConfig.couponNumber?true:false;_this.pageId=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getPageId();_this.app_version=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getVersion();return _this;}_createClass(PipelineCashBackAct,[{key:"componentDidMount",value:function componentDidMount(){this.queryLoginStatus();}// 轮询判断是否登陆成功
},{key:"renderSingleCoupon",value:// 单张券
function renderSingleCoupon(){var _this2=this;var _this$props$config$co=this.props.config.couponsConfig,couponsConfig=_this$props$config$co===void 0?{}:_this$props$config$co;var _couponsConfig$single=couponsConfig.singleCouponMaterial,singleCouponMaterial=_couponsConfig$single===void 0?{}:_couponsConfig$single,_couponsConfig$single2=couponsConfig.singleCoupon,singleCoupon=_couponsConfig$single2===void 0?[{}]:_couponsConfig$single2;var _singleCouponMaterial=singleCouponMaterial.couponPackageBackgroundImage,couponPackageBackgroundImage=_singleCouponMaterial===void 0?'':_singleCouponMaterial,_singleCouponMaterial2=singleCouponMaterial.unReceivedBtnImage,unReceivedBtnImage=_singleCouponMaterial2===void 0?'':_singleCouponMaterial2,_singleCouponMaterial3=singleCouponMaterial.hasReceivedBtnImage,hasReceivedBtnImage=_singleCouponMaterial3===void 0?'':_singleCouponMaterial3,_singleCouponMaterial4=singleCouponMaterial.textColor,textColor=_singleCouponMaterial4===void 0?'':_singleCouponMaterial4;var is_rec=this.state.is_rec;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"single-coupon",style:{backgroundImage:"url(".concat(couponPackageBackgroundImage||'https://static.shihuocdn.cn/admin/files/20231129/e96dcc238cf4e2bd80ca1ba1314dec42.png',")"),backgroundRepeat:'no-repeat',backgroundSize:'contain'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price",style:{color:textColor}},singleCoupon[0]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",null,"\xA5"),singleCoupon[0].price)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"coupon-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"coupon-name",style:{color:textColor}},singleCoupon[0]&&singleCoupon[0].title.slice(0,10)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"coupon-desc",style:{color:textColor}},singleCoupon[0]&&singleCoupon[0].subTitle.slice(0,12)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:!is_rec?unReceivedBtnImage||'https://static.shihuocdn.cn/admin/files/20231129/3dd88e1a8d5703f615bcd6fc66e9740e.png':hasReceivedBtnImage||'https://static.shihuocdn.cn/admin/files/20231129/db23ba752aa4442308107dcd2ef76953.png',alt:"",className:"btn",onClick:function onClick(){return _this2.handleItemClick();}})));}// 多张券
},{key:"renderMultipleCoupon",value:function renderMultipleCoupon(){var _this3=this;var _this$props$config$co2=this.props.config.couponsConfig,couponsConfig=_this$props$config$co2===void 0?{}:_this$props$config$co2;var _couponsConfig$multip=couponsConfig.multipleCouponMaterial,multipleCouponMaterial=_couponsConfig$multip===void 0?{}:_couponsConfig$multip,_couponsConfig$multip2=couponsConfig.multipleCoupon,multipleCoupon=_couponsConfig$multip2===void 0?[]:_couponsConfig$multip2;var _multipleCouponMateri=multipleCouponMaterial.couponPackageBackgroundImage,couponPackageBackgroundImage=_multipleCouponMateri===void 0?'':_multipleCouponMateri,_multipleCouponMateri2=multipleCouponMaterial.unReceivedBtnImage,unReceivedBtnImage=_multipleCouponMateri2===void 0?'':_multipleCouponMateri2,_multipleCouponMateri3=multipleCouponMaterial.hasReceivedBtnImage,hasReceivedBtnImage=_multipleCouponMateri3===void 0?'':_multipleCouponMateri3,_multipleCouponMateri4=multipleCouponMaterial.couponBackgroundImage,couponBackgroundImage=_multipleCouponMateri4===void 0?'':_multipleCouponMateri4,_multipleCouponMateri5=multipleCouponMaterial.textColor,textColor=_multipleCouponMateri5===void 0?'':_multipleCouponMateri5;var is_rec=this.state.is_rec;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"multiple-coupon",style:{backgroundImage:"url(".concat(couponPackageBackgroundImage||'https://static.shihuocdn.cn/admin/files/20231129/321e1f014fe60f8b4960f367aea3c76d.png',")"),backgroundRepeat:'no-repeat',backgroundSize:'contain'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"scroll"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",null,multipleCoupon.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("li",{className:"coupon-item",key:index,style:{backgroundImage:"url(".concat(couponBackgroundImage||'https://static.shihuocdn.cn/admin/files/20231129/82e618e51107a8f0f3dcd0ff93792c62.png',")"),backgroundRepeat:'no-repeat',backgroundSize:'contain'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"price",style:{color:textColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",null,"\xA5"),item.price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"coupon-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"coupon-name",style:{color:textColor}},item.title.slice(0,5)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"coupon-desc",style:{color:textColor}},item.subTitle.slice(0,6))));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:!is_rec?unReceivedBtnImage||'https://static.shihuocdn.cn/admin/files/20231129/8305322ae5b9a24d8776aff27a472436.png':hasReceivedBtnImage||'https://static.shihuocdn.cn/admin/files/20231129/f46f299697fe64ad67f6ff2148dc0b8d.png',alt:"",className:"btn",onClick:function onClick(){return _this3.handleItemClick();}}));}},{key:"render",value:function render(){var baseConfig=this.props.config.baseConfig;var coupons_show=this.state.coupons_show;if(!coupons_show){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-cashBackAct ".concat(this.isNewVersionUI?'new-version-ui':'old-version-ui')},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),this.isNewVersionUI?this.renderNewVersionUI():this.renderOldVersionUI());}},{key:"renderNewVersionUI",value:function renderNewVersionUI(){var _this4=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,couponsConfig=_this$props$config.couponsConfig;var _this$state2=this.state,is_rec=_this$state2.is_rec,expire_time=_this$state2.expire_time;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"modlue-title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"main-title",style:{color:baseConfig.titleColor}},baseConfig.title&&baseConfig.title.slice(0,8)),is_rec&&!couponsConfig.noCountDown?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"count-down",style:{color:baseConfig.titleColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__countdown__["a" /* default */],{end_time:expire_time,isNewVersionUI:this.isNewVersionUI})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"sub-title",style:{color:baseConfig.titleColor}},baseConfig.subTitle&&baseConfig.subTitle.slice(0,12))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"rule",style:{color:baseConfig.titleColor},onClick:function onClick(){return _this4.handleRuleClick();}},"\u89C4\u5219",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("svg",{t:"1699620535441",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2255",width:"9",height:"9"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("path",{d:"M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z","p-id":"2256",fill:baseConfig.titleColor||'#111111'})))),couponsConfig.couponNumber==='单张券'?this.renderSingleCoupon():this.renderMultipleCoupon());}},{key:"renderOldVersionUI",value:function renderOldVersionUI(){var _this5=this;var is_rec=this.state.is_rec;var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,imgsList=_this$props$config2.imgsList;// 判断不同布局方式下的间距取值
if(baseConfig.sortType==="一行一图"){Object.assign(baseConfig,baseConfig.layout_1);}else if(baseConfig.sortType==="一行二图"){Object.assign(baseConfig,baseConfig.layout_2);}else if(baseConfig.sortType==="一行三图"){Object.assign(baseConfig,baseConfig.layout_3);}else if(baseConfig.sortType==="banner"){Object.assign(baseConfig,baseConfig.layout_banner);}// 转为数字处理，后续参与计算
baseConfig.imgMarginHorizon=isNaN(Number(baseConfig.imgMarginHorizon))?0:Number(baseConfig.imgMarginHorizon);baseConfig.imgMarginVertical=isNaN(Number(baseConfig.imgMarginVertical))?0:Number(baseConfig.imgMarginVertical);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,!is_rec?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"img-list"},imgsList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(baseConfig.sortType==="一行一图"||baseConfig.sortType==="banner"){rowItemNumber=1;}else if(baseConfig.sortType==="一行二图"){rowItemNumber=2;}else if(baseConfig.sortType==="一行三图"){rowItemNumber=3;}var isFirstRow=Boolean(index<rowItemNumber);// 该项是否在首行
var isLasthRow=Boolean(imgsList.length-index<rowItemNumber);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.imgMarginHorizon;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px")};// 判断图片圆角值
var imgBorderRadius="6px";if(baseConfig.sortType==="banner"||baseConfig.noImgRadius){// banner图片或者选择不添加圆角情况，值为0
imgBorderRadius="0";}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"img-item",key:index,style:itemStyle,onClick:_this5.handleItemClick.bind(_this5,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"img",style:{borderRadius:imgBorderRadius},src:item.src+"?imageslim|imageMogr2/interlace/1"}));})):this.renderCouponsList(),this.renderPopup());}}]);return PipelineCashBackAct;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineCashBackAct.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCashBackAct);

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var CountDown=/*#__PURE__*/function(_PureComponent){_inherits(CountDown,_PureComponent);var _super=_createSuper(CountDown);function CountDown(props){var _this;_classCallCheck(this,CountDown);_this=_super.call(this,props);_this.state={count_down:{d:"00",h:"00",m:"00",s:"00"}};_this.timer=null;return _this;}_createClass(CountDown,[{key:"componentDidMount",value:function componentDidMount(){var end_time=this.props.end_time;this.startCountDown(end_time);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.end_time!==nextProps.end_time){this.startCountDown(nextProps.end_time);}}},{key:"render",value:function render(){var isNewVersionUI=this.props.isNewVersionUI;var _this$state$count_dow=this.state.count_down,d=_this$state$count_dow.d,h=_this$state$count_dow.h,m=_this$state$count_dow.m,s=_this$state$count_dow.s;if(isNewVersionUI){if(d=='00'){if(d=='00'&&h=='00'&&m=='00'&&s=='00'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p",null,"\u4F18\u60E0\u5238\u5DF2\u8FC7\u671F");}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p",null,"\u4F18\u60E0\u4E8E",h,":",m,":",s,"\u540E\u5931\u6548");}}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p",null,"\u4F18\u60E0\u4E8E",d,"\u5929",h,":",m,":",s,"\u540E\u5931\u6548");}}else{if(d=='00'&&h=='00'&&m=='00'&&s=='00'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p",null,"\u4F18\u60E0\u5238\u5DF2\u8FC7\u671F");}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p",null,"\u8DDD\u79BB\u5931\u6548\u8FD8\u5269",d,"\u5929",h,"\u5C0F\u65F6",m,"\u5206",s,"\u79D2");}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.timer=null;}},{key:"countDown",value:function countDown(t){var n=new Date().getTime(),c=t-n,d,h,m,s;// 结束执行
if(c<=0){return{d:"00",h:"00",m:"00",s:"00"};}d=parseInt(c/1000/60/60/24);h=parseInt(c/1000/60/60-24*d);m=parseInt(c/1000/60-24*60*d-60*h);s=parseInt(c/1000-24*60*60*d-60*60*h-60*m);if(s<10){s="0"+s;}if(m<10){m="0"+m;}if(h<10){h="0"+h;}if(d<10){d="0"+d;}return{d:d,h:h,m:m,s:s};}},{key:"startCountDown",value:function startCountDown(end_time){var _this2=this;if(this.timer){clearInterval(this.timer);this.timer=null;}var timestramp=end_time.replace(/-/g,"/");var finish_time=new Date(timestramp).getTime();var count_down=this.countDown(finish_time);this.setState({count_down:count_down});this.timer=setInterval(function(){// 计算倒计时
var count_down=_this2.countDown(finish_time);_this2.setState({count_down:count_down});},1000);}}]);return CountDown;}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (CountDown);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCashBackActNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__countdown__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_shihuo_lib_dist_shihuo_lib__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineCashBackActNew=/*#__PURE__*/function(_React$Component){_inherits(PipelineCashBackActNew,_React$Component);var _super=_createSuper(PipelineCashBackActNew);function PipelineCashBackActNew(props){var _this;_classCallCheck(this,PipelineCashBackActNew);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"judgeIsLogin",function(){_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=setInterval(function(){var isLogin=_this.state.isLogin;if(!isLogin){var CookieUA=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getCookie('u');if(CookieUA&&CookieU){Promise.all([CookieUA,CookieU]).then(function(result){_this.setState({isLogin:result&&result[0]&&result[1]});});}}else{_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=null;}},500);});_defineProperty(_assertThisInitialized(_this),"handleLogin",function(){if(__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].isShihuo()){// 未登陆，请先进行微信登陆
if(_this.loginInterVal){return;}if(!__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].isAndroid()&&__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].SHDiffVersion(_this.app_version,'6.86.0')){_this.judgeIsLogin();}else{window.Jockey.send("subscribe",{},function(publishData){if(publishData.type==="loginSuccess"){_this.loginInterVal=setInterval(function(){_this.queryLoginStatus();},500);}setTimeout(function(){_this.loginInterVal&&clearInterval(_this.loginInterVal);_this.loginInterVal=null;},15000);});}window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});_defineProperty(_assertThisInitialized(_this),"queryLoginStatus",function(){try{Object(__WEBPACK_IMPORTED_MODULE_21__utils_request__["a" /* default */])({url:"https://sh-gateway.shihuo.cn/v4/services/sh-user/user/baseInfo?from=".concat(_this.pageId,"&need_wechat_info=false&complicate=true"),method:'get',withCredentials:true}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){if(data.user_info&&data.user_info.uid){_this.loginInterVal&&clearInterval(_this.loginInterVal);_this.loginInterVal=null;_this.setState({isLogin:true},function(){_this.queryCouponsStatus();});}}else{_this.setState({isLogin:false},function(){_this.queryCouponsStatus();});}});}catch(error){_this.queryCouponsStatus();}});_defineProperty(_assertThisInitialized(_this),"queryCouponsStatus",function(){var showCouponsPopup=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var couponsConfig=_this.props.config.couponsConfig;Object(__WEBPACK_IMPORTED_MODULE_21__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/couponInfo?access_token=2322TizdV3pjw8CBsy&activity_code='+couponsConfig.activityCode,method:'get',withCredentials:true}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){var list=data.list;_this.setState({coupons_show:true,coupon_list:list,is_rec:list&&list.length>0?true:false,end_time:list&&list[0]&&list[0].end_time.replace(/-/g,'/'),sharePopupShow:false,couponsPopupShow:showCouponsPopup});}else{_this.setState({coupons_show:true});}});});_defineProperty(_assertThisInitialized(_this),"getCashbackCoupons",function(){var couponsConfig=_this.props.config.couponsConfig;Object(__WEBPACK_IMPORTED_MODULE_21__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/recCoupon?access_token=2322TizdV3pjw8CBsy',method:'post',withCredentials:true,data:{activity_code:couponsConfig.activityCode}}).then(function(res){var _res$data3=res.data,status=_res$data3.status,msg=_res$data3.msg;if(status!==0){_this.setState({show_toast:true,toast_text:msg,sharePopupShow:false});}else{_this.queryCouponsStatus(true);}});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(){__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'get'});if(!_this.state.isLogin){_this.handleLogin();return;}var baseConfig=_this.props.config.baseConfig;if(baseConfig.needShare==='是'){_this.setState({sharePopupShow:true});}else{_this.getCashbackCoupons();}});_defineProperty(_assertThisInitialized(_this),"renderCouponsList",function(){var _this$state=_this.state,coupon_list=_this$state.coupon_list,end_time=_this$state.end_time;var couponsConfig=_this.props.config.couponsConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"coupons-info",style:{backgroundImage:"url(".concat(couponsConfig.couponBackgroundImage,")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn",style:{backgroundImage:"url(".concat(couponsConfig.couponBtnImage,")")},onClick:function onClick(){return _this.handleUse(couponsConfig.btnHref||'shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Category&page=TopIndex','toUse');}},!couponsConfig.noCountDown&&end_time&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"count-down",style:{color:couponsConfig.countDownTextColor||"#FFF"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__countdown__["a" /* default */],{end_time:end_time}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"coupon-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"scroll"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("ul",null,coupon_list&&coupon_list.length>0&&coupon_list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"coupon-item",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].formatImgUrl(couponsConfig.couponItemImage,_this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"money",style:{color:couponsConfig.couponTextColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",null,"\uFFE5"),parseFloat(item.cash_back)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"desc",style:{color:couponsConfig.couponTextColor}},parseFloat(item.start_amount)>0?"\u6EE1".concat(parseFloat(item.start_amount),"\u53EF\u8FD4"):'无门槛')));})))));});_defineProperty(_assertThisInitialized(_this),"handleShare",function(){if(_this.isShareDisabled){return;}__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'share'});_this.isShareDisabled=true;var kouling=_this.props.config.sharePopupConfig.kouling;if(_this.isShareNativeExit){window.Jockey.send("shareNative",{type:"text",text:kouling});}else{window.Jockey.send("copy",{display:false,content:kouling});var wxSchema="weixin://";var iframe=document.createElement("iframe");iframe.src=wxSchema;iframe.style.display="none";iframe.onload=function(){iframe.parentNode.removeChild(iframe);};document.body.appendChild(iframe);}setTimeout(function(){_this.isShareDisabled=false;_this.getCashbackCoupons();},2000);});_defineProperty(_assertThisInitialized(_this),"handleUse",function(url,blockName){var options={};url&&__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,url,url,options,-1,_this.props,false,{blockName:blockName});});_defineProperty(_assertThisInitialized(_this),"renderRulePopup",function(){var rulePopupShow=_this.state.rulePopupShow;if(rulePopupShow){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"mask"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"popup"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("h3",{className:"title"},"\u8FD4\u73B0\u5238\u4F7F\u7528\u8BF4\u660E"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",null,"1.\u8BE5\u8FD4\u73B0\u5238\u9002\u7528\u4E8E\u672C\u5E73\u53F0\u6240\u6709\u54C1\u7C7B(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u978B\u3001\u670D\u9970\u3001\u7F8E\u5986\u54C1\u7C7B)\u7684\u5546\u54C1"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",null,"2.\u8BE5\u8FD4\u73B0\u5238\u76EE\u524D\u53EA\u652F\u6301\u5728\u6DD8\u5B9D\u6E20\u9053\u4E0B\u5355\u4F7F\u7528"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",null,"3.\u8FD4\u73B0\u5238\u4F7F\u7528\u6D41\u7A0B\u5982\u4E0B\uFF1A"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210513/a46af66b3552cc3cc5cbc82929448a96.png",alt:"",className:"image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn",onClick:function onClick(){return _this.closePopup();}},"\u7ACB\u5373\u4F7F\u7528"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png",alt:"",className:"close",onClick:function onClick(){return _this.closePopup();}}))));}else{return null;}});_defineProperty(_assertThisInitialized(_this),"renderSharePopup",function(){var sharePopupConfig=_this.props.config.sharePopupConfig;var sharePopupShow=_this.state.sharePopupShow;if(sharePopupShow){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"mask"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"share-popup",style:{backgroundImage:"url(".concat(sharePopupConfig.sharePopupImage,")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn",onClick:function onClick(){return _this.handleShare();}},"\u7ACB\u5373\u5206\u4EAB"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png",alt:"",className:"close",onClick:function onClick(){return _this.closePopup();}}))));}else{return null;}});_defineProperty(_assertThisInitialized(_this),"renderCouponsPopup",function(){var couponsPopupConfig=_this.props.config.couponsPopupConfig;var _this$state2=_this.state,coupon_list=_this$state2.coupon_list,couponsPopupShow=_this$state2.couponsPopupShow;if(couponsPopupShow){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"mask"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"coupons-popup",style:{backgroundImage:"url(".concat(couponsPopupConfig.backgroundImage,")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("h3",null,"\u606D\u559C\u83B7\u5F97"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("ul",{className:"list"},coupon_list&&coupon_list.length>0&&coupon_list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("li",{key:"item_".concat(index),style:{backgroundImage:"url(".concat(couponsPopupConfig.couponBgImage,")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"amount"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"cash_back"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",null,"\uFFE5"),item.cash_back),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"start_amount"},parseFloat(item.start_amount)>0?"\u6EE1".concat(parseFloat(item.start_amount),"\u53EF\u8FD4"):'无门槛')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"title"},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"expire-time"},"\u6709\u6548\u671F\u81F3 ",item.end_time&&item.end_time.split(" ")&&item.end_time.split(" ")[0]&&item.end_time.split(" ")[0].replace(/-/g,"."))));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn",style:{backgroundImage:"url(".concat(couponsPopupConfig.popupBtnImage,")")},onClick:function onClick(){return _this.handleUse(couponsPopupConfig.popupBtnHref,'dialogToUse');}},"\u53BB\u4F7F\u7528"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png",alt:"",className:"close",onClick:function onClick(){return _this.closePopup();}}))));}else{return null;}});_defineProperty(_assertThisInitialized(_this),"renderToast",function(){var _this$state3=_this.state,show_toast=_this$state3.show_toast,toast_text=_this$state3.toast_text;if(show_toast){_this.interval&&clearTimeout(_this.interval);_this.interval=setTimeout(function(){_this.setState({show_toast:false,toast_text:''});},3000);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"toast"},toast_text);}else{return null;}});_defineProperty(_assertThisInitialized(_this),"handleRuleClick",function(){_this.setState({rulePopupShow:true});});_defineProperty(_assertThisInitialized(_this),"closePopup",function(){_this.setState({rulePopupShow:false,sharePopupShow:false,couponsPopupShow:false});});_this.exp=new __WEBPACK_IMPORTED_MODULE_24_shihuo_lib_dist_shihuo_lib__["Exposure"]();// 曝光
_this.state={isLogin:false,coupon_list:[],is_rec:false,end_time:'',show_toast:false,toast_text:'',coupons_show:false,rulePopupShow:false,sharePopupShow:false,couponsPopupShow:false};_this.interval=null;_this.loginInterVal=null;_this.isShareDisabled=false;_this.app_version='';_this.isShareNativeExit=true;_this.pageId=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getPageId();return _this;}_createClass(PipelineCashBackActNew,[{key:"componentDidMount",value:function componentDidMount(){this.queryLoginStatus();this.app_version=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getVersion();if(__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].isAndroid()){this.isShareNativeExit=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].SHDiffVersion(this.app_version,'6.67.2');}else{this.isShareNativeExit=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].SHDiffVersion(this.app_version,'6.65.0');}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.loginInterVal&&clearInterval(this.loginInterVal);this.interval&&clearInterval(this.interval);this.loginInterVal=null;this.interval=null;}// 轮询判断是否登陆成功
},{key:"render",value:function render(){var _this2=this;var _this$state4=this.state,is_rec=_this$state4.is_rec,coupons_show=_this$state4.coupons_show;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;// 判断不同布局方式下的间距取值
if(baseConfig.sortType==="一行一图"){Object.assign(baseConfig,baseConfig.layout_1);}else if(baseConfig.sortType==="一行二图"){Object.assign(baseConfig,baseConfig.layout_2);}else if(baseConfig.sortType==="一行三图"){Object.assign(baseConfig,baseConfig.layout_3);}else if(baseConfig.sortType==="banner"){Object.assign(baseConfig,baseConfig.layout_banner);}// 转为数字处理，后续参与计算
baseConfig.imgMarginHorizon=isNaN(Number(baseConfig.imgMarginHorizon))?0:Number(baseConfig.imgMarginHorizon);baseConfig.imgMarginVertical=isNaN(Number(baseConfig.imgMarginVertical))?0:Number(baseConfig.imgMarginVertical);if(!coupons_show){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",_extends({className:"pipeline-cashBackAct-new"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),!is_rec?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"img-list"},imgsList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(baseConfig.sortType==="一行一图"||baseConfig.sortType==="banner"){rowItemNumber=1;}else if(baseConfig.sortType==="一行二图"){rowItemNumber=2;}else if(baseConfig.sortType==="一行三图"){rowItemNumber=3;}var isFirstRow=Boolean(index<rowItemNumber);// 该项是否在首行
var isLasthRow=Boolean(imgsList.length-index<rowItemNumber);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.imgMarginHorizon;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px")};// 判断图片圆角值
var imgBorderRadius="6px";if(baseConfig.sortType==="banner"||baseConfig.noImgRadius){// banner图片或者选择不添加圆角情况，值为0
imgBorderRadius="0";}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"img-item",key:index,style:itemStyle,onClick:_this2.handleItemClick.bind(_this2,item,index),"data-dot":JSON.stringify({id:"".concat(_this2.props.templatePti,":cashBackAct-get"),name:'返现券活动组件',pageId:_this2.pageId,biz:JSON.stringify({lego_page_id:_this2.pageId,component_id:_this2.props.customAttributes['data-component-id']}),exposekey:'em.',pti_refer:{pageId:'',root:{id:'',pageId:'',name:'',biz:''},parent:{id:'',pageId:'',name:'',biz:''}}}),ref:function ref(ele){if(ele){_this2.exp.add({el:ele});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"img",style:{borderRadius:imgBorderRadius},src:__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport)}));})):this.renderCouponsList(),this.renderToast(),this.renderRulePopup(),this.renderSharePopup(),this.renderCouponsPopup());}// 规则弹窗
}]);return PipelineCashBackActNew;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);PipelineCashBackActNew.propTypes={config:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCashBackActNew);

/***/ }),
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var CountDown=/*#__PURE__*/function(_PureComponent){_inherits(CountDown,_PureComponent);var _super=_createSuper(CountDown);function CountDown(props){var _this;_classCallCheck(this,CountDown);_this=_super.call(this,props);_this.state={count_down:{d:"00",h:"00",m:"00",s:"00"},show_count_down:false};_this.timer=null;return _this;}_createClass(CountDown,[{key:"componentDidMount",value:function componentDidMount(){var end_time=this.props.end_time;this.startCountDown(end_time);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.end_time!==nextProps.end_time){this.startCountDown(nextProps.end_time);}}},{key:"render",value:function render(){var _this$state$count_dow=this.state.count_down,d=_this$state$count_dow.d,h=_this$state$count_dow.h,m=_this$state$count_dow.m,s=_this$state$count_dow.s;if(!this.state.show_count_down){return null;}if(d=='00'&&h=='00'&&m=='00'&&s=='00'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p",{className:"expire"},"\u5DF2\u8FC7\u671F");}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"effect"},"".concat(d,"\u5929").concat(h,":").concat(m,":").concat(s," \u540E\u8FC7\u671F"));}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.timer=null;}},{key:"countDown",value:function countDown(t){var n=new Date().getTime(),c=t-n,d,h,m,s;// 结束执行
if(c<=0){return{d:"00",h:"00",m:"00",s:"00"};}d=parseInt(c/1000/60/60/24);h=parseInt(c/1000/60/60-24*d);m=parseInt(c/1000/60-24*60*d-60*h);s=parseInt(c/1000-24*60*60*d-60*60*h-60*m);if(s<10){s="0"+s;}if(m<10){m="0"+m;}if(h<10){h="0"+h;}if(d<10){d="0"+d;}return{d:d,h:h,m:m,s:s};}},{key:"startCountDown",value:function startCountDown(end_time){var _this2=this;if(!end_time){return;}if(this.timer){clearInterval(this.timer);this.timer=null;}var timestramp=end_time.replace(/-/g,"/");var finish_time=new Date(timestramp).getTime();var count_down=this.countDown(finish_time);this.setState({show_count_down:true,count_down:count_down});this.timer=setInterval(function(){// 计算倒计时
finish_time=new Date(timestramp).getTime();count_down=_this2.countDown(finish_time);_this2.setState({count_down:count_down});},1000);}}]);return CountDown;}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (CountDown);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineImgs=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgs,_React$Component);var _super=_createSuper(PipelineImgs);function PipelineImgs(props){var _this;_classCallCheck(this,PipelineImgs);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:item.link,type:baseConfig.sortType,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_this.state={};return _this;}_createClass(PipelineImgs,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;// 判断不同布局方式下的间距取值
if(baseConfig.sortType==="一行一图"){Object.assign(baseConfig,baseConfig.layout_1);}else if(baseConfig.sortType==="一行二图"){Object.assign(baseConfig,baseConfig.layout_2);}else if(baseConfig.sortType==="一行三图"){Object.assign(baseConfig,baseConfig.layout_3);}else if(baseConfig.sortType==="banner"){Object.assign(baseConfig,baseConfig.layout_banner);}// 转为数字处理，后续参与计算
baseConfig.imgMarginHorizon=isNaN(Number(baseConfig.imgMarginHorizon))?0:Number(baseConfig.imgMarginHorizon);baseConfig.imgMarginVertical=isNaN(Number(baseConfig.imgMarginVertical))?0:Number(baseConfig.imgMarginVertical);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({id:baseConfig.moduleId,className:"pipeline-imgs"},this.props['customAttributes'],{style:{paddingTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"img-list"},imgsList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(baseConfig.sortType==="一行一图"||baseConfig.sortType==="banner"){rowItemNumber=1;}else if(baseConfig.sortType==="一行二图"){rowItemNumber=2;}else if(baseConfig.sortType==="一行三图"){rowItemNumber=3;}var isFirstRow=Boolean(index<rowItemNumber);// 该项是否在首行
var isLasthRow=Boolean(imgsList.length-index<rowItemNumber);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.imgMarginHorizon;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.imgMarginVertical/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.imgMarginHorizon/2,"px")};// 判断图片圆角值
var imgBorderRadius="6px";if(baseConfig.sortType==="banner"||baseConfig.noImgRadius){// banner图片或者选择不添加圆角情况，值为0
imgBorderRadius="0";}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"img-item",key:index,style:itemStyle,onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:"img",style:{borderRadius:imgBorderRadius},src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport)}));})));}}]);return PipelineImgs;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineImgs.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgs);

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineNavBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_anchor_link_smooth_scroll__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_anchor_link_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_anchor_link_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utils__ = __webpack_require__(7);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function debounce(fn,delay){var timer=null;//借助闭包
return function(){if(timer){clearTimeout(timer);}timer=setTimeout(fn,delay);// 简化写法
};}var PipelineNavBar=/*#__PURE__*/function(_React$Component){_inherits(PipelineNavBar,_React$Component);var _super=_createSuper(PipelineNavBar);function PipelineNavBar(props){var _this;_classCallCheck(this,PipelineNavBar);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleBodyScroll",function(){var navList=_this.state.navList;var _this$props$config=_this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var navigationBarHeight=_this.props.navigationBarHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;if(baseConfig.navigationStyle==='图片导航'){// 图片导航栏 滚动交互
for(var index=0;index<navList.length;index++){var item=navList[index];var navComp=window.document.querySelector("#".concat(item.id));if(_this.navigationWrapRef&&navComp&&scrollHeight>navComp.offsetTop-_this.navigationWrapRef.clientHeight-navigationBarHeight){_this.setState({select:index});}}}else{// 默认导航栏 滚动交互
var navOffsetTop=window.document.querySelector(baseConfig.navigationType==="模块"?'.navigation-container-static-two':'.navigation-container-static').offsetTop-navigationBarHeight;var navMarginTop=Number(_this.props.config.baseConfig.moduleMarginTop);// 导航模块上边距
if(scrollHeight-navOffsetTop>navMarginTop){_this.setState({navFixed:true});}else{_this.setState({navFixed:false});}var checkedNav='';if(baseConfig.navigationType==='模块'){checkedNav=itemList[0];itemList.map(function(item){var productComList=window.document.querySelector("#".concat(item.id));if(scrollHeight+_this.navigationContentHeight+navigationBarHeight>productComList.offsetTop){checkedNav=item;}});}else{// 查询当前展示的商品组件
var productComList=window.document.querySelectorAll('.pipeline-product,.pipeline-productList,.pipeline-goodsRecommend,.pipeline-imgList,.pipeline-image,.pipeline-rank,.pipeline-imgHotMap,.pipeline-community,.pipeline-imgListScroll,.pipeline-imgs')||[];for(var i=0;i<productComList.length;i+=1){// console.log(productComList[i].offsetTop);
// 模块偏移量小于 滚动偏移 + 导航栏高度，导航栏高度暂定为 45
if(scrollHeight+_this.navigationContentHeight+navigationBarHeight>productComList[i].offsetTop){checkedNav=productComList[i].getAttribute('id');}}}_this.setState({checkedNav:checkedNav});}});_defineProperty(_assertThisInitialized(_this),"defaultNavClick",function(item,index){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].uploadTrack(_this.props,{sort:index});var _this$props$config2=_this.props.config,baseConfig=_this$props$config2.baseConfig,itemList=_this$props$config2.itemList;// 导航跳转
_this.setState({checkedNav:item});if(baseConfig.navigationType==='模块'){var productComList=window.document.querySelector("#".concat(item.id));//window.scrollTo(0, productComList.offsetTop - 42);
window.scrollTo({top:productComList.offsetTop-_this.props.navigationBarHeight-(_this.navigationContentHeight-3),behavior:"smooth"});}else{// if (typeof window !== 'undefined') {
//   window.location.href = `#${item}`;
// }
var _productComList=window.document.querySelector("#".concat(item));window.scrollTo({top:_productComList.offsetTop-_this.props.navigationBarHeight-(_this.navigationContentHeight-3),behavior:"smooth"});// 向下继续滚动42单位
// setTimeout(() => {
//   const scrollTop = (document.documentElement.scrollTop || document.body.scrollTop) - 42;
//   window.scrollTo(0, scrollTop);
// }, 40);
}});_defineProperty(_assertThisInitialized(_this),"imgNavClick",function(item,index){var navList=_this.state.navList;var findItem=navList.find(function(value){return value.title===item.navigationTo;});if(findItem){var id=findItem.id;var scrollTo=window.document.querySelector("#".concat(id));window.scrollTo({top:scrollTo.offsetTop-_this.props.navigationBarHeight-_this.navigationWrapRef.clientHeight+3,behavior:"smooth"});}});_defineProperty(_assertThisInitialized(_this),"renderDefaultNavList",function(){var _this$props$config3=_this.props.config,baseConfig=_this$props$config3.baseConfig,_this$props$config3$i=_this$props$config3.itemList,itemList=_this$props$config3$i===void 0?[]:_this$props$config3$i;var navList=_this.props.navList;if(baseConfig.navigationType==='模块'){navList=itemList;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:baseConfig.navigationType==="模块"?"navigation-container-static-two":"navigation-container-static",style:{paddingTop:"".concat(baseConfig.moduleMarginTop,"px"),backgroundColor:baseConfig.bgColor}},navList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"nav-item",key:index,onClick:_this.defaultNavClick.bind(_assertThisInitialized(_this),item,index),style:{width:baseConfig.bgImage?'85px':'auto',height:baseConfig.bgImage?'28px':'auto',lineHeight:baseConfig.bgImage?'28px':'auto',margin:baseConfig.bgImage?'2px 8px 12px 8px':'12px 16px',backgroundImage:baseConfig.bgImage?"url(".concat(_this.state.checkedNav===item?baseConfig.bgCheckedImage:baseConfig.bgImage,")"):'none',color:_this.state.checkedNav===item?baseConfig.fontCheckedColor:baseConfig.fontColor,fontFamily:_this.state.checkedNav===item?'PingFangSC-Medium':'PingFangSC-Regular',opacity:_this.state.checkedNav===item?1:.7,fontSize:baseConfig.fontSize}},baseConfig.navigationType==='模块'?item.title:item,item.badgeIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"badge-icon",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(item.badgeIcon,_this.props.webpSupport),alt:""}));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:baseConfig.navigationType==="模块"?"navigation-container-fixed-two":"navigation-container-fixed",style:{backgroundColor:baseConfig.bgColor,display:_this.state.navFixed?baseConfig.navigationType==='模块'?'flex':'block':'none',top:_this.props.navigationBarHeight}},navList.map(function(item,index){return/*#__PURE__*/ (// offset值为 导航栏高度（45）- 3，暂定为42
__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_anchor_link_smooth_scroll___default.a,{key:index,offset:function offset(){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].uploadTrack(_this.props,{sort:index});return _this.props.navigationBarHeight+(_this.navigationContentHeight-3);},href:baseConfig.navigationType==='模块'?"#".concat(item.id):"#".concat(item)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"nav-item",key:index//onClick={this.defaultNavClick.bind(this, item)}
,style:{width:baseConfig.bgImage?'88px':'auto',height:baseConfig.bgImage?'28px':'28px',lineHeight:baseConfig.bgImage?'28px':'28px',margin:baseConfig.bgImage?'12px 2px 12px 2px':'12px 16px',backgroundImage:baseConfig.bgImage?"url(".concat(_this.state.checkedNav===item?baseConfig.bgCheckedImage:baseConfig.bgImage,")"):'none',color:_this.state.checkedNav===item?baseConfig.fontCheckedColor:baseConfig.fontColor,fontFamily:_this.state.checkedNav===item?'PingFangSC-Medium':'PingFangSC-Regular',opacity:_this.state.checkedNav===item?1:.7,fontSize:baseConfig.fontSize}},baseConfig.navigationType==='模块'?item.title:item,item.badgeIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"badge-icon",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(item.badgeIcon,_this.props.webpSupport),alt:""}))));})));});_defineProperty(_assertThisInitialized(_this),"renderImgNavList",function(){var _this$props$config4=_this.props.config,baseConfig=_this$props$config4.baseConfig,_this$props$config4$i=_this$props$config4.itemImgList,itemImgList=_this$props$config4$i===void 0?[]:_this$props$config4$i;var _this$props=_this.props,navigationBarHeight=_this$props.navigationBarHeight,backgroundColor=_this$props.backgroundColor;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{ref:function ref(_ref){return _this.navigationWrapRef=_ref;},className:"navigation-wrap",style:{top:navigationBarHeight-1,backgroundColor:backgroundColor,paddingLeft:"".concat(baseConfig.moduleMarginHorizontal,"px"),paddingRight:"".concat(baseConfig.moduleMarginHorizontal,"px")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",{className:"img-list"},itemImgList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{key:index,className:"img-item",onClick:function onClick(){return _this.imgNavClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:index===_this.state.select?item.tabActiveImg:item.tabUnActiveImg,alt:""}));})));});_this.state={checkedNav:'',navFixed:false,select:0,navList:[]};_this.navigationContentHeight=52;// 滚动事件监听
if(typeof window!=='undefined'){window.addEventListener('scroll',function(e){_this.handleBodyScroll();});}return _this;}_createClass(PipelineNavBar,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _this$props$config5=this.props.config,baseConfig=_this$props$config5.baseConfig,itemList=_this$props$config5.itemList;if(baseConfig.navigationStyle==='图片导航'){var _this$props$navList=this.props.navList,navList=_this$props$navList===void 0?[]:_this$props$navList;var navListFilter=[];navList.forEach(function(item){var findItem=navListFilter.find(function(value){return value.title===item.title;});if(!findItem){navListFilter.push(item);}});this.setState({navList:navListFilter},function(){setTimeout(function(){var lastNavComp=navListFilter[navListFilter.length-1];var lastNavCompOffsetTop=document.querySelector("#".concat(lastNavComp.id)).offsetTop;var height=lastNavCompOffsetTop-_this2.navRef.offsetTop;var navRefHeight=_this2.navRef.clientHeight;_this2.navRef.style.height="".concat(height,"px");_this2.navRef.style.marginBottom="".concat(-(height-navRefHeight),"px");},1000);});}else{if(baseConfig.navigationType==="模块"){this.setState({checkedNav:itemList[0]});}}// this.handleBodyScroll();
}},{key:"render",value:function render(){var _this3=this;var baseConfig=this.props.config.baseConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({ref:function ref(_ref2){return _this3.navRef=_ref2;},className:"pipeline-navBar"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px")}}),baseConfig.navigationStyle==='图片导航'?this.renderImgNavList():this.renderDefaultNavList());}}]);return PipelineNavBar;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);PipelineNavBar.propTypes={config:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineNavBar);

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProductList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineProductList=/*#__PURE__*/function(_React$Component){_inherits(PipelineProductList,_React$Component);var _super=_createSuper(PipelineProductList);function PipelineProductList(props){var _this;_classCallCheck(this,PipelineProductList);_this=_super.call(this,props);_this.state={list:[]};return _this;}_createClass(PipelineProductList,[{key:"componentDidMount",value:function componentDidMount(){this.getProductListData();}},{key:"getProductListData",value:function getProductListData(){var _this2=this;var itemList=this.props.config.itemList;var idList=itemList.map(function(item){return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";if(this.props.config.baseConfig.productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else{reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default()({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:this.props.config.baseConfig.sortType==='销量'?4:0,filter_subsidy:this.props.config.baseConfig.shihuoSubsidy==='是'?1:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;// 插入定制化内容
list.forEach(function(product){var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem){product.custom_title=customItem.name;product.custom_recommend=customItem.recommend;}});_this2.setState({list:list});}});}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:this.props,index:index});return;}var baseConfig=this.props.config.baseConfig;var options={title:6,type:baseConfig.productStyle,sort:index,name:item.title};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var componentDivideLine=this.props.componentDivideLine;var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:750;var productList=this.state.list;// 转为数字处理，后续参与计算
baseConfig.itemMargin=6;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",_extends({className:"pipeline-productList",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{backgroundColor:baseConfig.bgColor}}),baseConfig.showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"sub-title",style:{color:baseConfig.titleColor}},baseConfig.subTitle)),baseConfig.titleImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"title-img",src:__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(baseConfig.titleImg,this.props.webpSupport),alt:"\u6807\u9898\u56FE"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-list"},productList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(baseConfig.productStyle==="一行一个"){rowItemNumber=1;}else if(baseConfig.productStyle==="一行两个"){rowItemNumber=2;}else if(baseConfig.productStyle==="一行三个"){rowItemNumber=3;}// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*baseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(baseConfig.itemMargin/2,"px"),marginBottom:isLasthRow?"0":"".concat(baseConfig.itemMargin/2,"px"),marginLeft:isFirstColumn?"0":"".concat(baseConfig.itemMargin/2,"px"),marginRight:isLastColumn?"0":"".concat(baseConfig.itemMargin/2,"px")};var productItem;if(baseConfig.productStyle==="一行两个"){// 四个展示都存在是，隐藏销量
if(baseConfig.originPrice&&baseConfig.saleNum&&baseConfig.priceIcon){baseConfig.saleNum=false;}// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-12*2-Number(baseConfig.itemMargin))/2-6;productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-item row-two-item",key:index,style:itemStyle,onClick:_this3.handleItemClick.bind(_this3,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-img-panel",style:{width:productImgWidth,height:productImgWidth,margin:3}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"product-img",src:__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.custom_title||item.title),baseConfig.slogen&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"tag"},(item.custom_recommend||item.recommend)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"tag-text"},item.custom_recommend||item.recommend))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"price-container"},baseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(baseConfig.priceIcon,_this3.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),baseConfig.originPrice&&item.original_price>item.price&&item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.original_price)),baseConfig.saleNum&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"num"},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))));}else if(baseConfig.productStyle==="一行三个"){// 四个展示都存在是，隐藏销量
if(baseConfig.originPrice&&baseConfig.saleNum){baseConfig.saleNum=false;}// 计算一行三商品图片宽度
var _productImgWidth=(bodyWidth-12*2-Number(baseConfig.itemMargin)*2)/3;// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=discountRate.toFixed(1);productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-item row-three-item",key:index,style:itemStyle,onClick:_this3.handleItemClick.bind(_this3,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-img-panel",style:{width:_productImgWidth,height:_productImgWidth}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"product-img",src:__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.custom_title||item.title),baseConfig.slogen&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"tag"},(item.custom_recommend||item.recommend)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"tag-text"},item.custom_recommend||item.recommend))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),baseConfig.originPrice&&item.original_price>item.price&&item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.original_price),baseConfig.saleNum&&!baseConfig.originPrice&&!baseConfig.discount&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"num"},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),baseConfig.discount&&discountRate!=="10.0"&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"discount-panel",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(baseConfig.discountBg,_this3.props.webpSupport),")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{className:"num"},discountRate),"\u6298"));}return productItem;})),this.props.notLastItem&&componentDivideLine&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"component-divide-line",src:__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(componentDivideLine,this.props.webpSupport)}));}}]);return PipelineProductList;}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);PipelineProductList.propTypes={config:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProductList);

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineRankList=/*#__PURE__*/function(_Component){_inherits(PipelineRankList,_Component);var _super=_createSuper(PipelineRankList);function PipelineRankList(props){var _this;_classCallCheck(this,PipelineRankList);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getRankList",function(){var itemList=_this.props.config.rankConfig;var idList=itemList.map(function(item){return item.id?item.id:'0';});__WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-goodsinnerapi/api/inner/top/info?access_token=WphjwI564K8kzs5JQZ',method:"post",withCredentials:true,data:{topListIds:idList}}).then(function(res){if(res.data.status===0){var list=res.data.data||[];// 插入定制化内容
list.forEach(function(product){var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem){product.name=customItem.title;}});_this.setState({rankList:list});}});});_defineProperty(_assertThisInitialized(_this),"handleMoreClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:_this.props,index:index});return;}var url=item.href;var options={title:5,topic_id:item.id};var convertUrl=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false,{blockName:'more'});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(topic,item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={title:5,sort:index,goods_id:item.goods_id,style_id:item.style_id,topic_id:topic.id};__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.href,item.href,options,item.id,_this.props);});_this.state={rankList:[]};return _this;}_createClass(PipelineRankList,[{key:"componentDidMount",value:function componentDidMount(){this.getRankList();}},{key:"render",value:function render(){var _this2=this;var rankList=this.state.rankList;var componentDivideLine=this.props.componentDivideLine;var _this$props$config=this.props.config,rankTitleBg=_this$props$config.rankTitleBg,goodsBodyBg=_this$props$config.goodsBodyBg,arrowIcon=_this$props$config.arrowIcon,arrowIcon2=_this$props$config.arrowIcon2,txtColor=_this$props$config.txtColor,moreTxtBg=_this$props$config.moreTxtBg,priceTxtColor=_this$props$config.priceTxtColor,comBgColor=_this$props$config.comBgColor,priceBackgroundImage=_this$props$config.priceBackgroundImage;var priceBgImage=priceBackgroundImage||"https://static.shihuocdn.cn/admin/files/20210328/79d63b36465d81102489beca5744a012.png";return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({className:"pipeline-rankList",style:{backgroundColor:comBgColor}},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"title-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(this.props.config.titleImage,this.props.webpSupport)})),rankList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"rank-body",key:"rank-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"rank-title",style:{backgroundColor:rankTitleBg,color:txtColor}},item.name,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(arrowIcon,_this2.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"rank-more",style:{color:txtColor,backgroundColor:moreTxtBg},onClick:_this2.handleMoreClick.bind(_this2,item,index)},"\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(arrowIcon2,_this2.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-body",style:{backgroundColor:goodsBodyBg}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-scroll"},item.top_detail&&item.top_detail.map(function(item2,index2){if(index2<=6){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-item",key:"goods-".concat(index2),onClick:_this2.handleItemClick.bind(_this2,item,item2,index2)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-item-title"},item2.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(item2.pic,_this2.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-item-bottom",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(priceBgImage,_this2.props.webpSupport),")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-item-originalprice"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\u5230\u624B\u4EF7:")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"goods-item-price",style:{color:priceTxtColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,parseInt(item2.price)))));}}))));}),this.props.notLastItem&&componentDivideLine&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"component-divide-line",src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(componentDivideLine,this.props.webpSupport)}));}}]);return PipelineRankList;}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PipelineRankList);

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSubsidyList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSubsidyList=/*#__PURE__*/function(_React$Component){_inherits(PipelineSubsidyList,_React$Component);var _super=_createSuper(PipelineSubsidyList);function PipelineSubsidyList(props){var _this;_classCallCheck(this,PipelineSubsidyList);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"productClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:_this.props,index:index});return;}var baseConfig=_this.props.config.baseConfig;var options={title:1,name:item.title,sort:index};if(baseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}console.log(_this.props);__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.url,item.url,options,-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"handleViewMore",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}var options={};var convertUrl=__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props);});_this.state={list:[]};return _this;}_createClass(PipelineSubsidyList,[{key:"componentDidMount",value:function componentDidMount(){this.getProductData();}},{key:"getProductData",value:function getProductData(){var _this2=this;var itemList=this.props.config.itemList;var idList=itemList.map(function(item){return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";if(this.props.config.baseConfig.type==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else{reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}__WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js___default()({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var dataList=res.data.data.List;itemList.forEach(function(item){var itemData=dataList.find(function(dataItem){return dataItem.id===item.id;});if(itemData){Object.assign(item,itemData);}});_this2.setState({list:itemList});}});}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,itemList=_this$props$config.itemList;var componentDivideLine=this.props.componentDivideLine;var totalItemMargin=6*2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-subsidyList"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"banner-img",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bannerImg,this.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"subsidy-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"more-btn",onClick:this.handleViewMore.bind(this,baseConfig.moreUrl)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"subsidy-img",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(baseConfig.titleImg,this.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"subsidy-list"},this.state.list.map(function(item,index){// 计算折扣差价
var discount=Number(item.original_price)-Number(item.price);discount=parseInt(discount);if(discount<0||isNaN(discount)){discount=0;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{key:index,className:"subsidy-item",onClick:_this3.productClick.bind(_this3,item,index),style:{width:"calc((100% - ".concat(totalItemMargin,"px) / 3)")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"product-img",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport)}),Boolean(discount)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price-tip",style:{backgroundColor:baseConfig.discountBg,color:baseConfig.discountTextColor}},"\u76F4\u964D",discount,"\u5143"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"name"},item.name||item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor,fontStyle:baseConfig.priceFontStyle}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{className:"rmb-icon"},"\uFFE5"),item.price)));}))),this.props.notLastItem&&componentDivideLine&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"component-divide-line",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(componentDivideLine,this.props.webpSupport)}));}}]);return PipelineSubsidyList;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineSubsidyList.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSubsidyList);

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCommunityArticle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_infinite_scroll_component__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__itemView__ = __webpack_require__(456);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineCommunityArticle=/*#__PURE__*/function(_React$Component){_inherits(PipelineCommunityArticle,_React$Component);var _super=_createSuper(PipelineCommunityArticle);function PipelineCommunityArticle(props){var _this;_classCallCheck(this,PipelineCommunityArticle);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"cardBannerGo",function(url){// 商品banner跳转
if(!url){return;}if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}var baseConfig=_this.props.config.baseConfig;var options={title:baseConfig.title,sort:0};__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,url,url,options,'',_this.props);});_this.state={list:[],hasMore:false,page:{pageNum:1,pageSize:20}};_this.sortTypeMap={'自定义排序':0,'点赞数降序':1};_this.ref=null;return _this;}_createClass(PipelineCommunityArticle,[{key:"componentDidMount",value:function componentDidMount(){this.getCardListData();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nexProps){if(this.props.tabActive!=nexProps.tabActive){this.updateList();}}},{key:"getCardListData",value:function getCardListData(){var _this2=this;var page=this.state.page;var itemList=this.props.config.itemList;var itemDataObj={};var idList=itemList.map(function(item){if(item.id){itemDataObj[item.id]=item;}return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-gocommunity/x/v1/note/specially-list?test=skip";Object(__WEBPACK_IMPORTED_MODULE_23__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort:this.sortTypeMap[this.props.config.baseConfig.sortType]||0,page:page.pageNum,page_size:page.pageSize}}).then(function(res){if(res.data.status===0){var list=res.data.data.list||[];// 插入定制化内容
list.forEach(function(card){try{var customItem=itemList.find(function(item){return item.id==card.id;});if(customItem){card.title=customItem.name||card.title;card.markText=customItem.markText;}}catch(error){console.log('笔记组件数据遍历错误');var customItem_beta=itemDataObj[card.id];if(customItem_beta){card.title=customItem_beta.name||card.title;card.markText=customItem_beta.markText;}}});var that=_this2;if(page.pageNum===1){_this2.setState({list:list,page:page},function(){that.updateList();});}else{_this2.setState({list:[].concat(_toConsumableArray(_this2.state.list),_toConsumableArray(list)),page:page},function(){that.updateList();});}page.pageNum+=1;// 判断是否还有下一页
if(list.length>=page.pageSize){_this2.setState({hasMore:true});}else{_this2.setState({hasMore:false});}}});}},{key:"updateList",value:function updateList(){var _this3=this;this.isAnchorInSwitchTab=this.props['customAttributes']["data-component-belong"]==='tab';var baseConfig=this.props.config.baseConfig;// 转为数字处理，后续参与计算
baseConfig.itemMargin=isNaN(Number(baseConfig.itemMargin))?0:Number(baseConfig.itemMargin);if(typeof window!=="undefined"){if(!this.isAnchorInSwitchTab){__webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 152)).then(function(Masonry){_this3.ref&&new Masonry(_this3.ref,{itemSelector:'.card-item',// 要布局的网格元素
fitWidth:true,// 设置网格容器宽度等于网格宽度
gutter:baseConfig.itemMargin});});}else{var targetTabContainer=window.document.querySelectorAll('.tab-container')[this.props.tabIndex];targetTabContainer&&__webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 152)).then(function(Masonry){_this3.ref&&new Masonry(_this3.ref,{itemSelector:'.card-item',// 要布局的网格元素
fitWidth:true,// 设置网格容器宽度等于网格宽度
gutter:baseConfig.itemMargin});});}}}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:this.props,index:index});return;}var baseConfig=this.props.config.baseConfig;var options={title:baseConfig.title,sort:index};__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.href,item.href,options,item.id,this.props);}},{key:"render",value:function render(){var _this4=this;var baseConfig=this.props.config.baseConfig;var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;var articleList=this.state.list;// 转为数字处理，后续参与计算
baseConfig.itemMargin=isNaN(Number(baseConfig.itemMargin))?0:Number(baseConfig.itemMargin);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",_extends({className:"pipeline-communityArticle",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),baseConfig.showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title),baseConfig.bannerImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("img",{className:"card-banner",onClick:this.cardBannerGo.bind(this,baseConfig.bannerLink),src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bannerImg,this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_infinite_scroll_component__["a" /* default */],{dataLength:articleList.length,next:this.getCardListData.bind(this),hasMore:this.state.hasMore,className:"list-1-container",style:{width:bodyWidth-Number(baseConfig.moduleMarginHorizon)*2}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"list-1",ref:function ref(_ref){return _this4.ref=_ref;}},articleList.map(function(item,index){// 计算卡片宽度
var cardImgWidth=(bodyWidth-Number(baseConfig.moduleMarginHorizon)*2-Number(baseConfig.itemMargin))/2;var width=item.width,height=item.height;var cardImgHeight=cardImgWidth;var ratio=height/width;ratio=Math.max(ratio,3/4.0);ratio=Math.min(ratio,4/3.0);cardImgHeight=cardImgWidth*ratio;var itemStyle={// width: itemWidth,
width:cardImgWidth,marginTop:index>1?"".concat(baseConfig.itemMargin,"px"):'0px',marginBottom:"".concat(baseConfig.itemMargin/2,"px")};// console.log('itemWidth', item.title, height / width, ratio);
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__itemView__["a" /* default */],{ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].getExposureData(_this4.props,{title:baseConfig.title,sort:index})),key:'item-'+index,handleItemClick:function handleItemClick(){_this4.handleItemClick(item,index);},index:index,itemStyle:itemStyle,item:item,cardImgHeight:cardImgHeight});}))));}}]);return PipelineCommunityArticle;}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);PipelineCommunityArticle.propTypes={config:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCommunityArticle);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_less__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_request__ = __webpack_require__(38);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var praised_icon='https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png';//选中后
var un_praised_icon='https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png';//未点赞
var praised_animated='https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga';//点赞动效
var cancel_praised_animated='https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga';//取消点赞
var ItemView=/*#__PURE__*/function(_React$Component){_inherits(ItemView,_React$Component);var _super=_createSuper(ItemView);function ItemView(props){var _this;_classCallCheck(this,ItemView);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"peloadingSvg",function(url){//预加载图片资源
if(_this.praiseHiddenRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){var player=new SVGA.Player(_this.praiseHiddenRef);var parser=new SVGA.Parser(_this.praiseHiddenRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(url,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){player.stopAnimation(true);if(url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')){_this.peloadingSvg(cancel_praised_animated);}});});});}});_defineProperty(_assertThisInitialized(_this),"showPraiseSvga",function(svgaUrl){if(_this.praiseRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){_this.praiseRef.style.display="flex";_this.praiseImgRef.style.display="none";var player=new SVGA.Player(_this.praiseRef);var parser=new SVGA.Parser(_this.praiseRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(svgaUrl,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){_this.praiseRef.style.display="none";_this.praiseImgRef.style.display="flex";player.stopAnimation(true);});});});}});_this.state={showAnimated:false,item:props.item||{}};return _this;}_createClass(ItemView,[{key:"componentDidMount",value:function componentDidMount(){this.peloadingSvg(praised_animated);}},{key:"praisePress",value:function praisePress(id,channel_type,status){var reqUrl="https://sh-gateway.shihuo.cn/v3/apps/app_swoole_common/praise";var that=this;Object(__WEBPACK_IMPORTED_MODULE_15__utils_request__["a" /* default */])({url:reqUrl,method:"get",withCredentials:true,params:{id:id,channel_type:channel_type,status:status}}).then(function(res){var _res$data=res.data,data=_res$data===void 0?{}:_res$data;if(data.status==0){var _that$state$item=that.state.item,item=_that$state$item===void 0?{}:_that$state$item;if(item.is_praise){item.is_praise=false;item.praise=item.praise*1-1;that.showPraiseSvga(cancel_praised_animated);that.setState({item:item});}else{item.is_praise=true;item.praise=item.praise*1+1;that.showPraiseSvga(praised_animated);that.setState({item:item});}}else if(data.status==3){window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,itemStyle=_this$props.itemStyle,key=_this$props.key,cardImgHeight=_this$props.cardImgHeight,handleItemClick=_this$props.handleItemClick;var _this$state=this.state,showAnimated=_this$state.showAnimated,item=_this$state.item;var userInfo=item.user_info||{};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"card-item",key:key,style:itemStyle,onClick:function onClick(){handleItemClick&&handleItemClick();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"card-item-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"card-img-panel",style:{height:cardImgHeight,width:'100%',backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* default */].formatImgUrl(item.img,this.props.webpSupport),")")}},item.duration?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"play-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{className:"play-icon",src:'https://static.shihuocdn.cn/admin/files/20230830/e862052a617f5580b4e5a62c40a1ae09.png'}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"play-text"},item.duration)):null),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"card-title",style:{WebkitBoxOrient:"vertical"}},item.title||item.content),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"card-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{className:"avatar",src:__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* default */].formatImgUrl(userInfo.avatar,this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"username"},userInfo.hupu_username),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"praise-view",onClick:function onClick(e){_this2.praisePress(item.id,item.channel_type,item.is_praise?2:1);e.stopPropagation();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"praise-icon-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{className:"praise-icon",ref:function ref(_ref){return _this2.praiseImgRef=_ref;},src:item.is_praise?praised_icon:un_praised_icon,alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"praise-icon-svga"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{style:{width:0,height:0,overflow:'hidden',position:'absolute',left:0,top:0},ref:function ref(_ref2){return _this2.praiseHiddenRef=_ref2;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{style:{width:'100%',height:'100%',alignItems:'center',justifyContent:'center'},ref:function ref(_ref3){return _this2.praiseRef=_ref3;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"praise-num",style:{marginTop:__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* default */].isAndroid()?1:-1}},item.praise))),item.markText?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"mark-bg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"mark-icon"},item.markText)):null));}}]);return ItemView;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCommunityArticleScroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var praised_icon='https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png';//选中后
var un_praised_icon='https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png';//未点赞
var praised_animated='https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga';//点赞动效
var cancel_praised_animated='https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga';//取消点赞
var PipelineCommunityArticleScroll=/*#__PURE__*/function(_React$Component){_inherits(PipelineCommunityArticleScroll,_React$Component);var _super=_createSuper(PipelineCommunityArticleScroll);function PipelineCommunityArticleScroll(props){var _this;_classCallCheck(this,PipelineCommunityArticleScroll);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"peloadingSvg",function(url){//预加载图片资源
if(_this.praiseHiddenRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){var player=new SVGA.Player(_this.praiseHiddenRef);var parser=new SVGA.Parser(_this.praiseHiddenRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(url,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){player.stopAnimation(true);if(url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')){_this.peloadingSvg(cancel_praised_animated);}});});});}});_defineProperty(_assertThisInitialized(_this),"showPraiseSvga",function(svgaUrl,id){var praiseRef=_this.praiseRefMap[id];var praiseIconRef=_this.praiseImgRefMap[id];if(praiseRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){console.log('---showPraiseSvga1-',praiseRef,praiseIconRef,praiseRef.clientWidth);praiseRef.style.display="flex";praiseIconRef.style.display="none";var player=new SVGA.Player(praiseRef);var parser=new SVGA.Parser(praiseRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(svgaUrl,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){praiseRef.style.display="none";praiseIconRef.style.display="flex";player.stopAnimation(true);});});});}});_defineProperty(_assertThisInitialized(_this),"handleBrowserMoreClick",function(url){// 商品banner跳转
if(!url){return;}__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,url,url,{},-1,_this.props,{bizExtra:{model_block:'查看更多'}});});_defineProperty(_assertThisInitialized(_this),"formatPraiseNum",function(praise){if(typeof praise==='number'&&praise>9999){praise=parseFloat((praise/10000).toFixed(1))+'w';}return praise;});_this.state={list:[],showAnimated:false};_this.praiseTimer=null;_this.isAndroid=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isAndroid();_this.isIphone14ProMax=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isIphone14ProMax();_this.praiseRefMap={};_this.praiseImgRefMap={};return _this;}_createClass(PipelineCommunityArticleScroll,[{key:"componentDidMount",value:function componentDidMount(){this.getCardListData();this.peloadingSvg(praised_animated);}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.praiseTimer){clearTimeout(this.praiseTimer);this.praiseTimer=null;}}},{key:"getCardListData",value:function getCardListData(){var _this2=this;var itemList=this.props.config.itemList;var itemDataObj={};var idList=itemList.map(function(item){if(item.id){itemDataObj[item.id]=item;}return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-gocommunity/x/v1/note/specially-list?test=skip";Object(__WEBPACK_IMPORTED_MODULE_18__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort:0,page:1,page_size:idList.length}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var list=data.list||[];_this2.setState({list:list});}});}},{key:"handlePraiseClick",value:function handlePraiseClick(event,id,channel_type,status,item,index){var _this3=this;var list=this.state.list;event.stopPropagation();var reqUrl="https://sh-gateway.shihuo.cn/v3/apps/app_swoole_common/praise";Object(__WEBPACK_IMPORTED_MODULE_18__utils_request__["a" /* default */])({url:reqUrl,method:"get",withCredentials:true,params:{id:id,channel_type:channel_type,status:status}}).then(function(res){var _res$data2=res.data,data=_res$data2===void 0?{}:_res$data2;if(data.status==0){if(item.is_praise){item.is_praise=false;item.praise=item.praise-1;item.praise_text=_this3.formatPraiseNum(item.praise);list[index]=item;_this3.setState({list:list});_this3.showPraiseSvga(cancel_praised_animated,id);}else{item.is_praise=true;item.praise=item.praise+1;item.praise_text=_this3.formatPraiseNum(item.praise);list[index]=item;_this3.setState({list:list});_this3.showPraiseSvga(praised_animated,id);}}else if(data.status==3){window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:this.props,index:index});return;}var baseConfig=this.props.config.baseConfig;var options={title:baseConfig.title,sort:index};__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.href,item.href,options,item.id,this.props);}},{key:"renderCardType1",value:function renderCardType1(){var _this4=this;var _this$props$config$ba=this.props.config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba;var _this$state=this.state,_this$state$list=_this$state.list,list=_this$state$list===void 0?[]:_this$state$list,showAnimated=_this$state.showAnimated;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"scroll-type-1"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("ul",null,list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getExposureData(_this4.props,{title:baseConfig.title,sort:index})),key:"note-".concat(index),onClick:function onClick(){return _this4.handleItemClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"note-img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__["LazyLoadImage"],{src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(item.img,_this4.props.webpSupport),alt:"",className:"note-img",effect:"opacity"}),item.duration&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240506/37c435801c77b97c25a32861a0e26148.png",alt:"",className:"video-logo"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"note-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:"note-title"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"note-author"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"user-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"avatar-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__["LazyLoadImage"],{src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(item.user_info.avatar,_this4.props.webpSupport,'card'),alt:"\u5934\u50CF",className:"avatar",effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:_this4.isAndroid?'username android':'username ios'},item.user_info.hupu_username)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"praise-info",onClick:function onClick(event){return _this4.handlePraiseClick(event,item.id,item.channel_type,item.is_praise?2:1,item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"praise-icon-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:"praise-icon",src:item.is_praise?praised_icon:un_praised_icon,alt:"",id:"praise-icon-".concat(item.id),ref:function ref(r){_this4.praiseImgRefMap[item.id]=r;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"praise-icon-svga"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{style:{width:'100%',height:'100%',alignItems:'center',justifyContent:'center'},id:"praise-icon-svga-".concat(item.id),ref:function ref(r){_this4.praiseRefMap[item.id]=r;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:_this4.isAndroid?'praise-num android':'praise-num ios'},item.praise_text||_this4.formatPraiseNum(item.praise))))));})));}},{key:"renderCardType2",value:function renderCardType2(){var _this5=this;var _this$props$config$ba2=this.props.config.baseConfig,baseConfig=_this$props$config$ba2===void 0?{}:_this$props$config$ba2;var mainTitle=baseConfig.mainTitle,subTitle=baseConfig.subTitle,browserMoreHref=baseConfig.browserMoreHref,backgroundColor=baseConfig.backgroundColor,titleBgColorType=baseConfig.titleBgColorType,titleBgColor=baseConfig.titleBgColor,titleBgColorFrom=baseConfig.titleBgColorFrom,titleBgColorTo=baseConfig.titleBgColorTo;var _this$state2=this.state,_this$state2$list=_this$state2.list,list=_this$state2$list===void 0?[]:_this$state2$list,showAnimated=_this$state2.showAnimated;var titleStyle=titleBgColorType=="纯色背景"?{backgroundColor:titleBgColorType=="纯色背景"?titleBgColor:'transparent'}:{background:titleBgColorType=="渐变色背景"?"linear-gradient(180deg, ".concat(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].hexColorToRgba(titleBgColorFrom,1)," 0%, ").concat(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].hexColorToRgba(titleBgColorTo,1)," 100%), #FFFFFF"):'transparent'};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"scroll-type-2",style:{backgroundColor:backgroundColor||'#FFF'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"scroll-header",style:titleStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"title-area"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:"main-title"},mainTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:"sub-title"},subTitle)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"browser-more",onClick:function onClick(){return _this5.handleBrowserMoreClick(browserMoreHref);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("span",null,"\u66F4\u591A"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("svg",{t:"1714284720403",className:"icon ".concat(this.isAndroid?'android':'ios'," ").concat(this.isIphone14ProMax?'iphone14promax':''),viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2761",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"2762",fill:"#333333"})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"scroll-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("ul",null,list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this5.props.exp&&_this5.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getExposureData(_this5.props,{title:baseConfig.title,sort:index})),key:"note-".concat(index),onClick:function onClick(){return _this5.handleItemClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"note-img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__["LazyLoadImage"],{src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(item.img,_this5.props.webpSupport),alt:"",className:"note-img",effect:"opacity"}),item.duration&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240506/37c435801c77b97c25a32861a0e26148.png",alt:"",className:"video-logo"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"note-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:"note-title"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"note-author"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"user-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"avatar-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__["LazyLoadImage"],{src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(item.user_info.avatar,_this5.props.webpSupport,'card'),alt:"\u5934\u50CF",className:"avatar",effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:_this5.isAndroid?'username android':'username ios'},item.user_info.hupu_username)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"praise-info",onClick:function onClick(event){return _this5.handlePraiseClick(event,item.id,item.channel_type,item.is_praise?2:1,item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"praise-icon-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:"praise-icon",src:item.is_praise?praised_icon:un_praised_icon,alt:"",id:"praise-icon-".concat(item.id),ref:function ref(r){_this5.praiseImgRefMap[item.id]=r;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"praise-icon-svga"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{style:{width:'100%',height:'100%',alignItems:'center',justifyContent:'center'},id:"praise-icon-svga-".concat(item.id),ref:function ref(r){_this5.praiseRefMap[item.id]=r;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("p",{className:_this5.isAndroid?'praise-num android':'praise-num ios'},item.praise_text||_this5.formatPraiseNum(item.praise))))));}))));}},{key:"render",value:function render(){var _this6=this;var baseConfig=this.props.config.baseConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({className:"pipeline-communityArticleScroll",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),!baseConfig.mainTitle&&!baseConfig.subTitle?this.renderCardType1():this.renderCardType2(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{style:{width:0,height:0,overflow:'hidden',position:'absolute',left:0,top:0},ref:function ref(_ref){return _this6.praiseHiddenRef=_ref;}}));}}]);return PipelineCommunityArticleScroll;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineCommunityArticleScroll.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCommunityArticleScroll);

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelinePkRank */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__getStaticUsers__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__style_less__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */function hexColorToRgba(hexColor,opacity){if(!hexColor){return hexColor;}var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}var PipelinePkRank=/*#__PURE__*/function(_React$Component){_inherits(PipelinePkRank,_React$Component);var _super=_createSuper(PipelinePkRank);function PipelinePkRank(props){var _this;_classCallCheck(this,PipelinePkRank);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getUserVote",function(){Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{special_id:_this.pageId,vote_name:_this.voteName}}).then(function(res){if(res.data.status===0){var pkData=_this.state.pkData;// 设置用户是否投票信息
if(res.data.data.has_vote){var voteId=res.data.data.vote_id&&res.data.data.vote_id[0];pkData.left.hasVote=pkData.left.id==voteId;pkData.right.hasVote=pkData.right.id==voteId;_this.setState({userHasVote:true,pkData:pkData,compShow:true},function(){_this.getVoteCountData();_this.praiseRef.style.display="none";});}else{_this.setState({compShow:true},function(){_this.getVoteCountData();});}}else{_this.setState({compShow:true},function(){_this.getVoteCountData();});}})["catch"](function(){_this.setState({compShow:true},function(){_this.getVoteCountData();});});});_defineProperty(_assertThisInitialized(_this),"getVoteCountData",function(){Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/count?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{special_id:_this.pageId,vote_name:_this.voteName}}).then(function(res){if(res.data.status===0){var pkData=_this.state.pkData;var list=res.data.data.list||[];// 计算pk支持人数，附加基础值
list.forEach(function(item){if(pkData.left.id==item.vote_id){pkData.left.voteCount=item.cnt+pkData.left.voteCount;}if(pkData.right.id==item.vote_id){pkData.right.voteCount=item.cnt+pkData.right.voteCount;}});// 计算左右比例
var leftRate=pkData.left.voteCount/(pkData.left.voteCount+pkData.right.voteCount);leftRate=parseInt(leftRate*10000,10);var rightRate=10000-leftRate;leftRate=leftRate/100+'%';rightRate=rightRate/100+'%';pkData.left.rate=leftRate;pkData.right.rate=rightRate;_this.setState({pkData:pkData},function(){if(_this.state.userHasVote){_this.progressLeftRef.style.width=leftRate;_this.progressRightRef.style.width=rightRate;}});}});});_defineProperty(_assertThisInitialized(_this),"getVoteUserListData",function(){Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote/last?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{special_id:_this.pageId,vote_name:_this.voteName,limit:10}}).then(function(res){if(res.data.status===0){var voteNameObj={};_this.props.config.itemList.forEach(function(item){voteNameObj[item.id]=item.name;});var list=res.data.data.list||[];if(list.length<10){var randomData=_this.getVoteDataRandom(10-list.length);list=[].concat(_toConsumableArray(list),_toConsumableArray(randomData));}// 获取投票名称
list=list.filter(function(item){if(voteNameObj[item.vote_id]){item.vote_name=voteNameObj[item.vote_id];item.user_name=_this.getUserName(item.user_name);return item;}});_this.setState({voteUserList:list},function(){if(_this.state.voteUserList.length>0){_this.swiper=new __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js___default.a(_this.voteSwiperRef,{allowTouchMove:true,direction:'vertical',loop:true,pagination:false,navigation:false,loopAdditionalSlides:10,slidesPerView:'auto',autoplay:{delay:3000,disableOnInteraction:false}});}});}});});_defineProperty(_assertThisInitialized(_this),"handleVoteAction",/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(voteSide){var userCookie,pkData,leftRate,rightRate,voteIds;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].uploadTrack(_this.props);_context.next=3;return __WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].getCookie('u');case 3:userCookie=_context.sent;if(!userCookie){_context.next=23;break;}if(!_this.state.userHasVote){_context.next=8;break;}__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].toast('已经投过了',3000);return _context.abrupt("return");case 8:pkData=_this.state.pkData;pkData[voteSide].hasVote=true;pkData[voteSide].voteCount+=1;// 计算左右比例
leftRate=pkData.left.voteCount/(pkData.left.voteCount+pkData.right.voteCount);leftRate=parseInt(leftRate*10000,10);rightRate=10000-leftRate;leftRate=leftRate/100+'%';rightRate=rightRate/100+'%';pkData.left.rate=leftRate;pkData.right.rate=rightRate;_this.setState({userHasVote:true,pkData:pkData,voteSide:voteSide},function(){_this.progressLeftRef.style.width=leftRate;_this.progressRightRef.style.width=rightRate;__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){var player=new SVGA.Player(_this.praiseRef);var parser=new SVGA.Parser(_this.praiseRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load('https://static.shihuocdn.cn/admin/files/20240105/f82ca224fbf224ba941d2aa8bec6b969.svga',function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){_this.praiseRef.style.display="none";});});});});voteIds=[Number(pkData[voteSide].id)];Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/vote?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{special_id:_this.pageId,vote_name:_this.voteName,vote_id:voteIds}}).then(function(res){if(res.data.status===0){var voteNameObj={};_this.props.config.itemList.forEach(function(item){voteNameObj[item.id]=item.name;});// 新增一条投票数据
var voteResData=res.data.data||{};var newItem={id:new Date().valueOf(),avatar:voteResData.avatar,vote_name:voteNameObj[voteResData.vote_id[0]],user_name:_this.getUserName(voteResData.user_name)};_this.swiper.appendSlide("\n            <div class=\"support-item swiper-slide\">\n              <img class=\"user-avatar\" src=\"".concat(__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].formatImgUrl(newItem.avatar,_this.props.webpSupport),"\" alt=\"\" />\n              <div class=\"vote-content\">\n                ").concat(newItem.user_name,"\u6295\u7ED9\u4E86").concat(newItem.vote_name,"\n              </div>\n            </div>\n          "));_this.swiper.update();}});_context.next=24;break;case 23:if(typeof window!=='undefined'){window.Jockey.send('login');}case 24:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(voteSide,index){var link=_this.state.pkData[voteSide].href;if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].handleToufangClick({link:link,props:_this.props});return;}if(link){var baseConfig=_this.props.config.baseConfig;var options={title:baseConfig.title,sort:index};__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,link,link,options,_this.state.pkData[voteSide].id,_this.props);}});_defineProperty(_assertThisInitialized(_this),"getVoteDataRandom",function(){var num=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;var _this$props$config=_this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$it=_this$props$config.itemList,itemList=_this$props$config$it===void 0?[]:_this$props$config$it;var ids=[];itemList.forEach(function(item,index){if(item.id){ids.push(item.id);}else{ids.push(index===0?1:2);}});var staticUsers=Object(__WEBPACK_IMPORTED_MODULE_31__getStaticUsers__["a" /* default */])();staticUsers=staticUsers.sort(function(){return Math.random()-0.5;}).slice(0,num);staticUsers=staticUsers.map(function(item,index){var randomIdx=Math.floor(Math.random()*ids.length);var randomVal=ids[randomIdx];var temp={id:item.id,special_id:_this.pageId,vote_name:_this.voteName,vote_id:randomVal,user_name:item.name,avatar:item.avatar,client_str:"",create_at:"",update_at:""};return temp;});return staticUsers;});_this.state={pkData:{left:{voteCount:0,hasVote:false},right:{voteCount:0,hasVote:false}},voteSide:'',userHasVote:false,voteUserList:[],compShow:false};_this.pageId=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].getPageId();_this.voteName=_this.props.createTime>1709899200000?_this.props['customAttributes']['data-component-id']:_this.props.config.baseConfig.title;_this.screenRatio=1;if(typeof window!=='undefined'){_this.screenRatio=window.document.body.clientWidth/375;}_this.voteSwiperRef=null;_this.progressLeftRef=null;_this.progressRightRef=null;_this.swiper=null;return _this;}_createClass(PipelinePkRank,[{key:"componentDidMount",value:function componentDidMount(){this.initPkData();this.getVoteUserListData();}},{key:"initPkData",value:function initPkData(){var _this2=this;var itemList=this.props.config.itemList;var pkData=this.state.pkData;Object.assign(pkData.left,{},{id:itemList[0].id,voteCount:Number(itemList[0].baseNum),href:itemList[0].href});Object.assign(pkData.right,{},{id:itemList[1].id,voteCount:Number(itemList[1].baseNum),href:itemList[1].href});this.setState({pkData:pkData},function(){_this2.getUserVote();});}},{key:"getUserName",value:function getUserName(username){if(username.length<=1){return username;// 如果昵称长度小于等于1，直接返回原昵称  
}var firstChar=username.charAt(0);// 获取第一个字符  
var lastChar=username.charAt(username.length-1);// 获取最后一个字符  
var middleChars=username.slice(1,-1);// 获取中间的所有字符  
// 使用*替换中间的所有字符  
// const maskedName = firstChar + '*'.repeat(middleChars.length) + lastChar;  
var maskedName=firstChar+'*'+lastChar;return maskedName;}// 随机获取指定数量的投票信息（假数据）
},{key:"renderSenceType",value:function renderSenceType(){var _this$props$config2=this.props.config,_this$props$config2$b=_this$props$config2.baseConfig,baseConfig=_this$props$config2$b===void 0?{}:_this$props$config2$b,_this$props$config2$i=_this$props$config2.itemList,itemList=_this$props$config2$i===void 0?[]:_this$props$config2$i;var _this$state=this.state,pkData=_this$state.pkData,userHasVote=_this$state.userHasVote;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"title",style:{backgroundColor:hexColorToRgba(this.props.backgroundColor,0.4),color:baseConfig.backgroundColor==='深色'?'#FFF':'#000'}},baseConfig.title.slice(0,17)),this.renderSupportList(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"pk-area"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"pk-content left",onClick:this.handleItemClick.bind(this,'left',0)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/f543d6ecce154eccf718ede9c1aabc75.png",alt:"",className:"gradient-img"}),itemList[0]&&itemList[0].img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:itemList[0].img,alt:"\u7EA2\u65B9\u56FE\u7247",className:"product-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"name"},itemList[0]?itemList[0].name||'红方':'红方'),userHasVote&&pkData.left.hasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/8da25070c6e478d8d163fbc4984b919c.png",alt:"",className:"vote-icon"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"pk-content right",onClick:this.handleItemClick.bind(this,'right',1)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/06f163b9633900a8a6093bacedd93257.png",alt:"",className:"gradient-img"}),itemList[1]&&itemList[1].img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:itemList[1].img,alt:"\u84DD\u65B9\u56FE\u7247",className:"product-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"name"},itemList[1]?itemList[1].name||'蓝方':'蓝方'),userHasVote&&pkData.right.hasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/45a0841742a0587598c9ff127ca2ab4b.png",alt:"",className:"vote-icon"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20231228/a3887e5b94b9fc2611c75fbe0ff8ec75.png",alt:"",className:"pk-logo"})));}},{key:"renderLogoType",value:function renderLogoType(){var _this$props$config3=this.props.config,_this$props$config3$b=_this$props$config3.baseConfig,baseConfig=_this$props$config3$b===void 0?{}:_this$props$config3$b,_this$props$config3$i=_this$props$config3.itemList,itemList=_this$props$config3$i===void 0?[]:_this$props$config3$i;var _this$state2=this.state,pkData=_this$state2.pkData,userHasVote=_this$state2.userHasVote;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"title",style:{backgroundColor:hexColorToRgba(this.props.backgroundColor,0.4),color:baseConfig.backgroundColor==='深色'?'#FFF':'#000'}},baseConfig.title.slice(0,17)),this.renderSupportList(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"pk-area"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"pk-content left",onClick:this.handleItemClick.bind(this,'left',0)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"content-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/a34ea34f9d4a720545c21583c6b9c3c6.png",alt:"",className:"gradient-img"}),itemList[0]&&itemList[0].img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:itemList[0].img,alt:"\u7EA2\u65B9Logo",className:"product-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"name",style:{color:baseConfig.backgroundColor==='深色'?'#FFF':'#000'}},itemList[0]?itemList[0].name||'红方':'红方')),userHasVote&&pkData.left.hasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/8da25070c6e478d8d163fbc4984b919c.png",alt:"",className:"vote-icon"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"pk-content right",onClick:this.handleItemClick.bind(this,'right',1)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"content-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/ccaddc02462320461715c5773b104a9a.png",alt:"",className:"gradient-img"}),itemList[1]&&itemList[1].img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:itemList[1].img,alt:"\u84DD\u65B9Logo",className:"product-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"name",style:{color:baseConfig.backgroundColor==='深色'?'#FFF':'#000'}},itemList[1]?itemList[1].name||'蓝方':'蓝方')),userHasVote&&pkData.right.hasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240124/45a0841742a0587598c9ff127ca2ab4b.png",alt:"",className:"vote-icon"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20231228/a3887e5b94b9fc2611c75fbe0ff8ec75.png",alt:"",className:"pk-logo"})));}},{key:"renderSupportList",value:function renderSupportList(){var _this3=this;var _this$props$config$ba2=this.props.config.baseConfig,baseConfig=_this$props$config$ba2===void 0?{}:_this$props$config$ba2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"support-list swiper-no-swiping",ref:function ref(_ref2){return _this3.voteSwiperRef=_ref2;},style:{color:baseConfig.backgroundColor==='深色'?'#CACACA':'#000'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"swiper-wrapper"},this.state.voteUserList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"support-item swiper-slide",key:item.id,style:{backgroundColor:baseConfig.backgroundColor==='深色'?'rgba(255, 255, 255, 0.1)':'rgba(255, 255, 255, 0.8)'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{className:"user-avatar",src:__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].formatImgUrl(item.avatar,_this3.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"vote-content"},item.user_name,"\u6295\u7ED9\u4E86",item.vote_name));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"swiper-pagination"}));}},{key:"render",value:function render(){var _this4=this;var baseConfig=this.props.config.baseConfig;var _this$state3=this.state,pkData=_this$state3.pkData,userHasVote=_this$state3.userHasVote,voteSide=_this$state3.voteSide,compShow=_this$state3.compShow;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",_extends({className:"pipeline-pkRank ".concat(baseConfig.pkType==='logo'?'logo-type':'sence-type'," ").concat(baseConfig.backgroundColor==='深色'?'bg-black':'bg-white'),id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px',visibility:compShow?'visible':'hidden'}}),baseConfig.pkType==='logo'?this.renderLogoType():this.renderSenceType(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"contrast"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"progress left",ref:function ref(_ref3){return _this4.progressLeftRef=_ref3;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"progress right",ref:function ref(_ref4){return _this4.progressRightRef=_ref4;}})),userHasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"vote-result"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"result-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"number"},pkData.left.voteCount,"\u7968")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"result-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"number"},pkData.right.voteCount,"\u7968"))),!userHasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"vote-btns"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:baseConfig.backgroundColor==='深色'?'https://static.shihuocdn.cn/admin/files/20240123/8123b1056835d0b42b7de6429fdbc9f8.png':'https://static.shihuocdn.cn/admin/files/20240105/a7d8e7f3826dcc14e8d924ad3247abf9.png',alt:"",className:"btn left",onClick:this.handleVoteAction.bind(this,'left')}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:baseConfig.backgroundColor==='深色'?'https://static.shihuocdn.cn/admin/files/20240123/b7c015091bea97072845f747ecadaaf1.png':'https://static.shihuocdn.cn/admin/files/20240105/982eb92d823430c496a0939b3cd943c7.png',alt:"",className:"btn right",onClick:this.handleVoteAction.bind(this,'right')})),!userHasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"not-vote-tip",style:{color:baseConfig.backgroundColor==='深色'?'#fff':'#333'}},"\u6295\u7968\u540E\u53EF\u67E5\u770B\u7ED3\u679C"),userHasVote&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"thanks",style:{color:baseConfig.backgroundColor==='深色'?'#fff':'#333'}},"\u611F\u8C22\u4F60\u7684\u53C2\u4E0E\uFF01"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{id:"praise",className:voteSide,ref:function ref(_ref5){return _this4.praiseRef=_ref5;}}));}}]);return PipelinePkRank;}(__WEBPACK_IMPORTED_MODULE_26_react___default.a.Component);PipelinePkRank.propTypes={config:__WEBPACK_IMPORTED_MODULE_27_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelinePkRank);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getStaticUsers(){var staticUsers=[{"id":113206,"uid":4963424227950833,"name":"GerO26","avatar":"https://static.shihuocdn.cn/r_avatar/9d4d450cc563600355e87fc36eed1e58.png","comment":"361飞燃2.5海绵宝宝39码还会有货吗","like_cnt":16,"self_like":false,"is_self":0,"create_at":"2023-10-27 13:55:37"},{"id":113202,"uid":18989229,"name":"蓝上了","avatar":"https://static.shihuocdn.cn/app/avatar/156264186610312.jpg","comment":"近一年的国产实战鞋，只买一双，买哪双？","like_cnt":15,"self_like":false,"is_self":0,"create_at":"2023-10-26 18:39:29"},{"id":113204,"uid":4077697501036699,"name":"老式卫生纸","avatar":"https://static.shihuocdn.cn/third_avatar/9NSd9cMch6c44413f8748c5065d7f41ffbb3e30e47","comment":"双十一韦德之道10最低多少","like_cnt":13,"self_like":false,"is_self":0,"create_at":"2023-10-27 10:20:40"},{"id":113277,"uid":4712900251451559,"name":"54455454","avatar":"https://static.shihuocdn.cn/photo/20230628/1000x1000_80c6a07e-3980-4fac-856c-672ca0cfaa65.jpeg","comment":"鞋子推荐","like_cnt":8,"self_like":false,"is_self":0,"create_at":"2023-10-29 20:31:59"},{"id":113487,"uid":4499326372217003,"name":"J-36","avatar":"https://static.shihuocdn.cn/user/avatar/photo/20231001/1036x1036_a127d920-790e-4b05-b6d3-43c7335ea6f7.jpeg","comment":"李宁闪击9TD卯兔会降价嘛？","like_cnt":3,"self_like":false,"is_self":0,"create_at":"2023-11-03 23:46:49"},{"id":113334,"uid":5341950864752827,"name":"勇敢的心V7Z","avatar":"https://static.shihuocdn.cn/r_avatar/8f6d2cd41de1d838dd0f555c0c074517.png","comment":"【双十一必抢】Air Jordan Legacy 312  气垫缓震 休闲鞋 GS/灰色/蓝色双11会降价吗","like_cnt":3,"self_like":false,"is_self":0,"create_at":"2023-10-31 20:51:44"},{"id":113620,"uid":4790241454424153,"name":"墨海马I4i","avatar":"https://static.shihuocdn.cn/r_avatar/d17ebc8985408f95283752f5ae38597d.png","comment":"利刃4手高有券吗","like_cnt":2,"self_like":false,"is_self":0,"create_at":"2023-11-10 22:12:34"},{"id":113262,"uid":5273434773389416,"name":"虚空恐惧i5D","avatar":"https://static.shihuocdn.cn/r_avatar/c3729e0be83fad9d85340a81023da0de.png","comment":"买乔丹篮球鞋300以内有啥","like_cnt":2,"self_like":false,"is_self":0,"create_at":"2023-10-29 08:43:38"},{"id":113241,"uid":4974127306014841,"name":"穿山王37s","avatar":"https://static.shihuocdn.cn/r_avatar/917d9df1f8aa5ce6187f5412e7ab629a.png","comment":"双十一买鞋1400能优惠多少？","like_cnt":2,"self_like":false,"is_self":0,"create_at":"2023-10-28 15:06:14"},{"id":113203,"uid":4210504300265656,"name":"徐酒岁","avatar":"https://static.shihuocdn.cn//20230908/287x287_689C8F80-95D2-4304-B472-15B878F00ED4.jpg","comment":"有没有便宜的美白面霜推荐","like_cnt":2,"self_like":false,"is_self":0,"create_at":"2023-10-27 10:03:44"},{"id":113694,"uid":5371950750498838,"name":"kyrie142","avatar":"https://static.shihuocdn.cn/third_avatar/92rLl8FAA0e7a66942731b77b0f986dad08594179a","comment":"双十一活动什么时候结束","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-11 22:40:33"},{"id":113687,"uid":5289907274023009,"name":"JulieN16","avatar":"https://static.shihuocdn.cn/r_avatar/eea244345485e26f86d442922f8ad9e3.png","comment":"打底衫","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-11 21:08:23"},{"id":113682,"uid":4977412455268495,"name":"北奕w","avatar":"https://static.shihuocdn.cn/user/avatar/photo/20231111/1307x1307_68f4d0d6-6dc2-49f9-9f4d-4339aeddf9e0.jpeg","comment":"利刃3V2","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-11 19:12:43"},{"id":113641,"uid":5276253337387233,"name":"world214","avatar":"https://static.shihuocdn.cn/third_avatar/T91F0FyNmD2de1345fed077f293c6d805cedd7ef9b","comment":"361飞燃2鸳鸯在双十一能降到四百吗","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-11 07:31:38"},{"id":113617,"uid":4409647165472931,"name":"腌鲜鳜鱼I0X","avatar":"https://static.shihuocdn.cn/app/avatarbg/20230116/450e6d05-e1de-4b18-bd02-ff6af573368c.jpg","comment":"跑鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-10 21:54:33"},{"id":113610,"uid":5312066478211206,"name":"倒带e5g","avatar":"https://static.shihuocdn.cn/r_avatar/725555e49ed46985ddec29dd09d33425.png","comment":"38.5码的板鞋可以穿多少码的跑鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-10 18:49:44"},{"id":113557,"uid":5339354360643606,"name":"身骑白马q1Q","avatar":"https://static.shihuocdn.cn/r_avatar/5be71ab39981a5b9ba6b71fde117939b.png","comment":"150篮球鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-06 22:10:36"},{"id":113519,"uid":4877112288313386,"name":"赛车蓝841","avatar":"https://static.shihuocdn.cn/third_avatar/0sPBvtIDTX3cc69876325a7932a175651c3d9f7a2a","comment":"双11韦德之道8083代u最低多少钱","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-05 07:28:55"},{"id":113509,"uid":4879548387754156,"name":"玛奇朵39m","avatar":"https://static.shihuocdn.cn/r_avatar/a01e86d4486d1839baecfea2cd944584.png","comment":"跑鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-04 21:02:04"},{"id":113493,"uid":5351757556219913,"name":"解救66a","avatar":"https://static.shihuocdn.cn/r_avatar/24bf248e27f66550a64cd9589c5e58bb.png","comment":"识货什么时候买便宜","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-04 11:10:45"},{"id":113478,"uid":4039500239994910,"name":"purpB3Y","avatar":"https://static.shihuocdn.cn/third_avatar/MHPXnLM5SV9bb32672e84b9e5074e3d0610cdbff46","comment":"羽毛球拍100左右","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-03 22:12:26"},{"id":113442,"uid":82318839,"name":"Ki___11","avatar":"https://static.shihuocdn.cn/wx_user/avatar/1603898759/f1db4527ea6f30e186f561f103f240ea","comment":"冬季鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-03 14:32:07"},{"id":113437,"uid":5347348560969750,"name":"白雾zL1","avatar":"https://static.shihuocdn.cn/third_avatar/0LVajLtxGG1012677334ba7e7bcbbf606ec6963d43","comment":"碳板跑鞋买哪双","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-03 12:25:58"},{"id":113436,"uid":5347348560969750,"name":"白雾zL1","avatar":"https://static.shihuocdn.cn/third_avatar/0LVajLtxGG1012677334ba7e7bcbbf606ec6963d43","comment":"碳板跑鞋买哪双","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-03 12:25:56"},{"id":113418,"uid":3989539601875122,"name":"你说我笨幼稚","avatar":"https://static.shihuocdn.cn/user/avatar/photo/20231105/997x997_c660adf5-9119-4cb0-975e-357513f7a24e.jpeg","comment":"飞燃哪个系列好","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-02 22:37:12"},{"id":113404,"uid":5141627667939380,"name":"信使鸟g2t","avatar":"https://static.shihuocdn.cn/r_avatar/056e4b9fb5a603202e74e3439621983b.png","comment":"冬天穿小码推荐","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-02 20:20:38"},{"id":113398,"uid":3854637217218665,"name":"earthQ9u","avatar":"https://static.shihuocdn.cn/third_avatar/QMSGUy7wkU53c5914b925ee4261dd75394576213aa","comment":"李宁板鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-02 18:16:37"},{"id":113393,"uid":3708896448741489,"name":"果冻茄","avatar":"https://static.shihuocdn.cn/photo/20230407/962x962_ea0fa03c-9eb8-4625-8879-18a0322fe01f.jpeg","comment":"护肤品","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-11-02 12:51:28"},{"id":113275,"uid":4802166735077502,"name":"七姐gQ3","avatar":"https://static.shihuocdn.cn/third_avatar/cXFKAVk3by13e718226b6c1228bcdafcce7ee39ac8","comment":"二手手机","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-29 19:40:52"},{"id":113251,"uid":4939673212092577,"name":"火焰鸟31d","avatar":"https://static.shihuocdn.cn/r_avatar/e929815760001e6a20e288c101f29796.png","comment":"350买什么跑步鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-28 19:46:25"},{"id":113247,"uid":5140855129735278,"name":"狂潮86D","avatar":"https://static.shihuocdn.cn/r_avatar/87b3bd8819707c85db9f8d8d494fbd41.png","comment":"碳板路跑鞋","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-28 18:18:12"},{"id":113226,"uid":5239121308483808,"name":"武林萌娃rG4","avatar":"https://static.shihuocdn.cn/third_avatar/8VKUn52hYsd249c06d5b979981096bc3f38b3a3202","comment":"飞电3c","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-27 22:48:38"},{"id":113224,"uid":4232074838343755,"name":"樱花宝c4n","avatar":"https://static.shihuocdn.cn/r_avatar/3288d63ac05feee7312858049e45cecc.png","comment":"毒牙2.0怎么样","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-27 22:30:19"},{"id":113210,"uid":4218087308099659,"name":"懒人翁o6P","avatar":"https://static.shihuocdn.cn/r_avatar/f58cc023ce4ced3dd731e144ea724445.png","comment":"312","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-27 18:06:43"},{"id":113205,"uid":67820559,"name":"ccc32","avatar":"https://static.shihuocdn.cn/wx_user/avatar/1585584248/f0c5712a01178bccec4820ea831b4b62","comment":"有无性价比高点的护头皮洗发水 痒死了","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-27 10:31:01"},{"id":113201,"uid":87414294,"name":"精致君君","avatar":"https://proxy.shihuocdn.cn/aHR0cHM6Ly90aGlyZHd4LnFsb2dvLmNuL21tb3Blbi92aV8zMi9mSUtHZ2xpYklIemJGbXBpYWljUFlqTXo2V0RzM09pY2ZCWWF0dzd3ektZbXkzQTZXRE9LUE9jS1RuM0lZWDlIWWljc1VHZll5Smx5VlRuQmtNVk5PZUlGakx3LzEzMg..","comment":"不知道买啥衣服","like_cnt":1,"self_like":false,"is_self":0,"create_at":"2023-10-26 15:23:16"},{"id":113698,"uid":5358420086390982,"name":"manrS6","avatar":"https://static.shihuocdn.cn/third_avatar/4qRojZFy2Qc6e3f956698d4ac634583771c67b6a99","comment":"aj买那个","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 23:56:34"},{"id":113697,"uid":61757746,"name":"gqs12834","avatar":"https://static.shihuocdn.cn/qqlogin/avatar/1579328745/1f1a3094d9430c0a6fa2b0936eba186f","comment":"卫衣","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 23:55:31"},{"id":113696,"uid":3575027306070048,"name":"叁拾N","avatar":"https://static.shihuocdn.cn/photo/20230208/1016x1016_4b0bb157-1712-43ce-b158-d3b26a57b2cc.jpeg","comment":"百元跑鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 23:08:23"},{"id":113695,"uid":5371669516746989,"name":"墨海马H8b","avatar":"https://static.shihuocdn.cn/r_avatar/fad66207b103781e6c9f7d0a2258d440.png","comment":"飚速2.5pro和强风st哪个好","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 22:43:26"},{"id":113693,"uid":70157375,"name":"虎扑JR1331795617","avatar":"https://static.shihuocdn.cn/app/avatarbg/20200717/8d556609-b94d-4740-a454-656012b287f7.jpg","comment":"篮球鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 22:31:11"},{"id":113692,"uid":5313848283496560,"name":"迷糊uD5","avatar":"https://static.shihuocdn.cn/third_avatar/nVqJnFoqKK86b7a2b53fad3e2bd455d2498b493760","comment":"200至210，篮球鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 21:47:20"},{"id":113691,"uid":4507289093046328,"name":"勾勾手f79","avatar":"https://static.shihuocdn.cn/third_avatar/1fYKAj3Olrc120872f6e7db8c56fbe1e92e6434c00","comment":"羽绒服","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 21:37:46"},{"id":113690,"uid":93972921,"name":"虎扑JR1163377499","avatar":"https://static.shihuocdn.cn/user/avatar//20231105/1029x1029_9090BBEF-06D6-4B45-96F3-D83EE8DF698E.jpg","comment":"2开nike休闲鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 21:24:15"},{"id":113689,"uid":93972921,"name":"虎扑JR1163377499","avatar":"https://static.shihuocdn.cn/user/avatar//20231105/1029x1029_9090BBEF-06D6-4B45-96F3-D83EE8DF698E.jpg","comment":"2开nike休闲鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 21:24:13"},{"id":113688,"uid":5345048479858875,"name":"阿飞d0C","avatar":"https://static.shihuocdn.cn/third_avatar/66KYV7GK4213192b28c983351ab292da4d821a583b","comment":"外套","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 21:10:18"},{"id":113686,"uid":82934192,"name":"虎扑JR1193105585","avatar":"https://static.shihuocdn.cn/app/avatarbg/20220724/5ac2537c-8f4b-4b37-9378-bd5a5fe0413c.jpg","comment":"毛衣","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 19:44:13"},{"id":113685,"uid":5082652021686369,"name":"当爱靠近50H","avatar":"https://static.shihuocdn.cn/r_avatar/e813733120fa5cd333f37f5af713f72c.png","comment":"2开篮球鞋推荐","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 19:38:50"},{"id":113684,"uid":5271916535873540,"name":"楚叔rN0","avatar":"https://static.shihuocdn.cn/third_avatar/SiDdN6IiZp636fde9175a9b9a6e25cb8da7baa0b30","comment":"后卫篮球鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 19:38:33"},{"id":113683,"uid":5371588814012659,"name":"大名A38","avatar":"https://static.shihuocdn.cn/r_avatar/598a821316823a681a334b38022b7861.png","comment":"体重200的人可以穿什么跑鞋","like_cnt":0,"self_like":false,"is_self":0,"create_at":"2023-11-11 19:29:00"}];return staticUsers;}/* harmony default export */ __webpack_exports__["a"] = (getStaticUsers);

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgListScroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineImgListScroll=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgListScroll,_React$Component);var _super=_createSuper(PipelineImgListScroll);function PipelineImgListScroll(props){var _this;_classCallCheck(this,PipelineImgListScroll);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:item.link,type:baseConfig.sortType,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_this.state={};return _this;}_createClass(PipelineImgListScroll,[{key:"componentDidMount",value:function componentDidMount(){var _this$props$config$ba=this.props.config.baseConfig,moduleId=_this$props$config$ba.moduleId,loop=_this$props$config$ba.loop,autoplay=_this$props$config$ba.autoplay,slidesPerView=_this$props$config$ba.slidesPerView,spaceBetween=_this$props$config$ba.spaceBetween;new __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_bundle_min_js___default.a(moduleId?".swiper-container-".concat(moduleId):'.swiper-container',{loop:loop,autoplay:!autoplay?false:{disableOnInteraction:false,delay:2000},slidesPerView:Number(slidesPerView),spaceBetween:Number(spaceBetween)});}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;var moduleId=baseConfig.moduleId,marginTop=baseConfig.marginTop,marginBottom=baseConfig.marginBottom,paddingLeft=baseConfig.paddingLeft;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({className:"pipeline-imgListScroll"},this.props['customAttributes'],{style:{marginTop:marginTop+"px",marginBottom:marginBottom+"px"}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:moduleId?"swiper-container swiper-container-".concat(moduleId):'swiper-container',style:{paddingLeft:paddingLeft+"px"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"swiper-wrapper"},imgsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"swiper-slide",key:index,onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),alt:""}));}))));}}]);return PipelineImgListScroll;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineImgListScroll.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgListScroll);

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSuctionBottomBtns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_less__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSuctionBottomBtns=/*#__PURE__*/function(_React$Component){_inherits(PipelineSuctionBottomBtns,_React$Component);var _super=_createSuper(PipelineSuctionBottomBtns);function PipelineSuctionBottomBtns(props){var _this;_classCallCheck(this,PipelineSuctionBottomBtns);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var options={link:item.link,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_this.state={isIphoneX:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].isIphoneX()||__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].isIphone14ProMax()};_this.isShihuo=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].isShihuo();return _this;}_createClass(PipelineSuctionBottomBtns,[{key:"componentDidMount",value:function componentDidMount(){this.setPadding();}},{key:"render",value:function render(){var _this2=this;var isIphoneX=this.state.isIphoneX;var btnsList=this.props.config.btnsList;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({className:"pipeline-suctionBottomBtns"},this.props['customAttributes'],{style:{paddingBottom:this.isShihuo&&isIphoneX?"34px":0}}),btnsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"btn-item",key:index,onClick:function onClick(){return _this2.handleItemClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),alt:""}));}));}},{key:"setPadding",value:function setPadding(){if(this.state.isIphoneX){document.getElementsByTagName("body")[0].style.paddingBottom="120px";}else{document.getElementsByTagName("body")[0].style.paddingBottom="70px";}}}]);return PipelineSuctionBottomBtns;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);PipelineSuctionBottomBtns.propTypes={config:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSuctionBottomBtns);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_some_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_some_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_some_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineSquare=/*#__PURE__*/function(_React$Component){_inherits(PipelineSquare,_React$Component);var _super=_createSuper(PipelineSquare);function PipelineSquare(props){var _this;_classCallCheck(this,PipelineSquare);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleScrollIntel",function(){var scrollContainer=_this.scrollContainerRef.current;var listContainer=_this.listContainerRef.current;var squareList=_this.props.config.list;if(!scrollContainer||!listContainer||squareList.length<=5)return;cancelAnimationFrame(_this.animationFrame);var direction='left';var itemWidth=listContainer.querySelector('.branchVenue-item').clientWidth+7;var speedPerSecond=73;// 注释原因：由于图像懒加载，使用克隆方法图片显示不出来，换成squareList直接复制一份
// 克隆整组一次（仅执行一次）
// if (!listContainer.dataset.cloned) {
//   const cloneGroup = listContainer.cloneNode(true);
//   cloneGroup.dataset.clone = 'true';
//   listContainer.parentElement.appendChild(cloneGroup);
//   listContainer.dataset.cloned = 'true';
//   // 设置容器布局，保证两组横向并列
//   listContainer.parentElement.style.display = 'flex';
// }
var lastTime=0;var scrollStep=function scrollStep(now){if(!_this.canInterval)return;var totalWidth=listContainer.scrollWidth/2;var curX=scrollContainer.scrollLeft;if(!lastTime)lastTime=now;var dt=(now-lastTime)/1000;lastTime=now;var delta=speedPerSecond*dt;if(direction==='left'){curX+=delta;if(curX>=totalWidth){curX=0;}}else{curX-=delta;if(curX<=0){curX=totalWidth;}}scrollContainer.scrollLeft=curX;_this.animationFrame=requestAnimationFrame(scrollStep);};_this.animationFrame=requestAnimationFrame(scrollStep);});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(!item.link){// 空白不跳转
return;}if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}var options={link:item.link,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"initVisibilityObserver",function(){if(!_this.wrapperRef.current)return;_this.observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting&&entry.intersectionRatio>=1){_this.canInterval=true;_this.handleScrollIntel();}else{_this.canInterval=false;cancelAnimationFrame(_this.animationFrame);}});},{threshold:[0,0.5,1]});_this.observer.observe(_this.wrapperRef.current);});_this.interval=null;_this.scrollInterval=null;_this.canInterval=true;_this.observer=null;_this.wrapperRef=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef();_this.scrollContainerRef=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef();_this.listContainerRef=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createRef();return _this;}_createClass(PipelineSquare,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.initVisibilityObserver();this.timerID=setTimeout(function(){console.log('3333');_this2.handleScrollIntel();},100);}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timerID);clearInterval(this.interval);clearInterval(this.scrollInterval);cancelAnimationFrame(this.animationFrame);if(this.observer)this.observer.disconnect();}// 法一：通过DOM移动卡片实现无限循环滚动（该方法因为频繁操作DOM会出现卡顿现象被优化为法二）
// handleScrollIntel = () => {
//   const scrollContainer = document.querySelector('.branchVenue');
//   const listContainer = document.querySelector('.branchVenue-list');
//   const squareList = this.props.config.list;
//   if (squareList.length > 5 && scrollContainer) {
//     cancelAnimationFrame(this.animationFrame);
//     const direction = 'left';                     // 默认向左滚动
//     const itemWidth = document.querySelector('.branchVenue-item').clientWidth + 7;
//     let scrollSpeed = Math.max(1, itemWidth / 60) // 滚动速度 每帧滚动1px 每秒滚动60px
//     let targetX = 0;                              // 目标滚动位置
//     const scrollStep = () => {
//       if (!this.canInterval) return;
//       const curX = scrollContainer.scrollLeft;
//       // 第一个魔方结束移到最后 实现循环
//       if (curX >= itemWidth && listContainer && listContainer.firstElementChild) {
//         const firstItem = listContainer.firstElementChild;
//         listContainer.appendChild(firstItem);
//         scrollContainer.scrollLeft = curX - itemWidth;
//         targetX = curX - itemWidth;              // 更新targetX下一个魔方的起始位置
//         return requestAnimationFrame(scrollStep);
//       }
//       targetX = curX + itemWidth;
//       // 执行滚动动画
//       const newX = direction === 'left' ? 
//         Math.min(curX + scrollSpeed, targetX) : 
//         Math.max(curX - scrollSpeed, targetX);
//       scrollContainer.scrollTo({ left: newX });
//       this.animationFrame = requestAnimationFrame(scrollStep);
//     };
//     this.animationFrame = requestAnimationFrame(scrollStep);
//   }
// };
// checkManualScrollBoundaries = () => {
//   const scrollContainer = document.querySelector('.branchVenue');
//   const listContainer = document.querySelector('.branchVenue-list');
//   if (!scrollContainer || !listContainer) return;
//   const itemWidth = document.querySelector('.branchVenue-item').clientWidth + 7;
//   const currentScroll = scrollContainer.scrollLeft;
//   const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
//   // 情况1：向左滑动（从右往左），超过一个项目宽度 → 第一个项目移到末尾
//   if (currentScroll >= itemWidth) {
//     const firstItem = listContainer.firstElementChild;
//     if (firstItem) {
//       listContainer.appendChild(firstItem);
//       scrollContainer.scrollLeft = currentScroll - itemWidth;
//       console.log('向左滑动，第一个项目移到末尾');
//     }
//   }
//   // 情况2：向右滑动（从左往右），滚动到最左端 → 最后一个项目移到开头
//   else if (currentScroll <= 0) {
//     const lastItem = listContainer.lastElementChild;
//     if (lastItem) {
//       listContainer.insertBefore(lastItem, listContainer.firstElementChild);
//       scrollContainer.scrollLeft = currentScroll + itemWidth;
//       console.log('向右滑动1，最后一个项目移到开头');
//     }
//   }
//   // 情况3：向右滑动（从左往右），接近最右端 → 最后一个项目移到开头
//   else if (currentScroll >= maxScroll - itemWidth) {
//     const lastItem = listContainer.lastElementChild;
//     if (lastItem) {
//       listContainer.insertBefore(lastItem, listContainer.firstElementChild);
//       scrollContainer.scrollLeft = currentScroll - itemWidth;
//       console.log('向右滑动2，最后一个项目移到开头');
//     }
//   }
// };
// 法二：通过DOM复制列表实现无限循环滚动
},{key:"render",value:function render(){var _this3=this;var customAttributes={"data-component-id":this.props["data-component-id"],"data-component-name":this.props["data-component-name"]};// 基本配置信息
var baseConfig=this.props.config.baseConfig;// 魔方列表
var squareList=this.props.config.list;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",_extends({className:"pipeline-square-wrapper",ref:this.wrapperRef,id:this.props['customAttributes']['data-component-id']},this.props['customAttributes'],{style:{marginTop:baseConfig.moduleMarginTop||'0px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"branchVenue",ref:this.scrollContainerRef,onTouchStart:function onTouchStart(e){// const scrollContainer = e.currentTarget;
// const listContainer = document.querySelector('.branchVenue-list');
var scrollContainer=_this3.scrollContainerRef.current;var listContainer=_this3.listContainerRef.current;if(!scrollContainer||!listContainer||squareList.length<=5)return;cancelAnimationFrame(_this3.animationFrame);// 停止上一次自动滚动
_this3.canInterval=false;// 停止自动滚动
if(_this3.restartTimer)clearTimeout(_this3.restartTimer);// 清除之前延迟
_this3.startX=e.touches[0].clientX;// 记录触摸起始位置
_this3.scrollStartLeft=e.currentTarget.scrollLeft;// 记录滚动起始位置
},onTouchMove:function onTouchMove(e){if(_this3.startX===null)return;var scrollContainer=_this3.scrollContainerRef.current;var listContainer=_this3.listContainerRef.current;if(!scrollContainer||!listContainer||squareList.length<=5)return;var deltaX=e.touches[0].clientX-_this3.startX;var newScroll=_this3.scrollStartLeft-deltaX;// 左滑增加 scrollLeft
var totalWidth=listContainer.scrollWidth/2;// 原列表宽度
// 无限循环滚动
if(newScroll>=totalWidth){newScroll-=totalWidth;}else if(newScroll<=0){newScroll+=totalWidth;}e.currentTarget.scrollLeft=newScroll;},onTouchEnd:function onTouchEnd(e){var scrollContainer=_this3.scrollContainerRef.current;var listContainer=_this3.listContainerRef.current;if(!scrollContainer||!listContainer||squareList.length<=5)return;_this3.startX=null;_this3.canInterval=true;// 恢复自动滚动
_this3.restartTimer=setTimeout(function(){_this3.handleScrollIntel();// 1s后重新启动自动滚动
},1000);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"branchVenue-content ".concat(squareList.some(function(item){return item.showSubTitle;})?'has-subtitile':'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"branchVenue-list",ref:this.listContainerRef},(squareList.length>5?[].concat(_toConsumableArray(squareList),_toConsumableArray(squareList)):squareList).map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].getExposureData(_this3.props,{link:item.link,sort:index})),key:"item_".concat(index),className:"branchVenue-item",onClick:_this3.handleItemClick.bind(_this3,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"img-area"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"branchVenue-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].formatImgUrl(item.img,_this3.props.webpSupport),effect:"opacity"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"main-title"},item.mainTitle),item.showSubTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement("div",{className:"sub-title"},item.subTitle));})))));}}]);return PipelineSquare;}(__WEBPACK_IMPORTED_MODULE_20_react___default.a.Component);PipelineSquare.propTypes={config:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSquare);

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSpikeProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_parseParams__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSpikeProduct=/*#__PURE__*/function(_React$Component){_inherits(PipelineSpikeProduct,_React$Component);var _super=_createSuper(PipelineSpikeProduct);function PipelineSpikeProduct(props){var _this;_classCallCheck(this,PipelineSpikeProduct);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"showView",function(){if(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].isShihuo()){if(!__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].isAndroid()&&__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].SHDiffVersion(_this.app_version,'7.11.0')&&__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].SHDiffVersion('7.20.0',_this.app_version))return false;return true;}return true;});_defineProperty(_assertThisInitialized(_this),"onRemind",function(seckill_id){if(_this.remindDisable){return;}_this.remindDisable=true;__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default()({url:'https://miaosha.shihuo.cn/app_swoole_seckill_v2/subMsg',method:'post',withCredentials:true,headers:{"Content-Type":"application/x-www-form-urlencoded"},data:Object(__WEBPACK_IMPORTED_MODULE_22__utils_parseParams__["a" /* default */])({seckill_id:seckill_id})}).then(function(res){var _res$data=res.data,status=_res$data.status,msg=_res$data.msg;if(status==0){_this.setState({show_toast:true,toast_text:"订阅成功",toast_sub_text:""});_this.getProductData();// 订阅成功后，刷新秒杀信息
}else{_this.setState({show_toast:true,toast_text:msg,toast_sub_text:""});}setTimeout(function(){_this.remindDisable=false;},1000);});});_defineProperty(_assertThisInitialized(_this),"handleSeckillBtn",function(item){__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].uploadTrack(_this.props);/**
     * 秒杀状态 status:
        1 未开始
        2 进行中
        3 已抢光
        4 已结束
     */if(item.status===1){if(item.subscription===0){// 未订阅
!_this.remindDisable&&_this.onRemind(item.id);}else{// 已订阅
_this.productClick(item);}}else{_this.productClick(item);}});_defineProperty(_assertThisInitialized(_this),"productClick",function(item){// 秒杀商品跳转
if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:_this.props});return;}var options={};__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.url,item.url,options,-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"setTimeCountDown",function(){// 设置倒计时
var self=_assertThisInitialized(_this);var spikeProduct=_this.state.spikeProduct||{};var distanceSecond=Number(spikeProduct.start_time)-__WEBPACK_IMPORTED_MODULE_23_moment___default()().unix();countDownCalculate.apply(_assertThisInitialized(_this));clearInterval(_this.countDownIntel);_this.countDownIntel=setInterval(countDownCalculate.bind(_assertThisInitialized(_this)),1000);// 倒计时的计算
function countDownCalculate(){if(distanceSecond<=0){// 清除时间循环，重新开始请求商品数据计算
clearInterval(this.countDownIntel);this.getProductData();return;}distanceSecond-=1;// 计算倒计时时分秒
var hour=parseInt(distanceSecond/3600,10);var lastSeconds=distanceSecond%3600;// 除过小时之后剩余时间
var minute=parseInt(lastSeconds/60,10);var second=distanceSecond%60;var countDown={hour:hour<10?"0".concat(hour):hour,minute:minute<10?"0".concat(minute):minute,second:second<10?"0".concat(second):second};self.setState({countDown:countDown});}});_defineProperty(_assertThisInitialized(_this),"renderToast",function(){var _this$state=_this.state,show_toast=_this$state.show_toast,toast_text=_this$state.toast_text,toast_sub_text=_this$state.toast_sub_text;if(show_toast){if(!_this.toastInterval){_this.toastInterval=setTimeout(function(){_this.setState({show_toast:false,toast_text:''});_this.toastInterval&&clearTimeout(_this.toastInterval);_this.toastInterval=null;},2500);}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"toast",style:{padding:"".concat(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('6px')," ").concat(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('12px')),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('4px'),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('16px')}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("p",null,toast_text),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("p",null,toast_sub_text));}else{return null;}});_defineProperty(_assertThisInitialized(_this),"renderBtnText",function(item){var subscription=item.subscription,status=item.status;if(status===1){if(subscription===0){return'预约秒杀';}else{return'已预约';}}else{return'去秒杀';}});_this.state={spikeProduct:{},countDown:{hour:'00',minute:'00',second:'00'},show_toast:false,toast_text:'',toast_sub_text:''};_this.countDownIntel='';_this.remindDisable=false;_this.toastInterval=null;_this.app_version='';return _this;}_createClass(PipelineSpikeProduct,[{key:"componentDidMount",value:function componentDidMount(){this.app_version=__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].getVersion();this.getProductData();this.focusWebview();}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.countDownIntel);}},{key:"getProductData",value:function getProductData(){var _this2=this;var itemList=this.props.config.itemList;var idList=[];itemList.forEach(function(item){if(item.id){idList.push(item.id);}});var params={seckill_ids:idList.join(','),user_indentify:"auto"};var reqUrl='https://miaosha.shihuo.cn/app_swoole_seckill_v2/getSeckillByIds';__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default()({url:reqUrl,method:"get",withCredentials:true,params:_objectSpread(_objectSpread({},params),{},{token:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].parseToken(params)})}).then(function(res){if(res.data.status===0){var dataList=res.data.data.sec_list||[];var spikeProduct={};// 秒杀开始时间大于当前时间三十秒，使用这个商品作为展示
for(var i=0;i<dataList.length;i+=1){var nowTime=__WEBPACK_IMPORTED_MODULE_23_moment___default()().unix();if(Number(dataList[i].start_time)>nowTime||Number(dataList[i].start_time)<=nowTime&&Number(dataList[i].end_time)>=nowTime){spikeProduct=dataList[i];spikeProduct.start_time=Number(spikeProduct.start_time);break;}}if(!spikeProduct.id&&dataList.length>0){// 如果找不到秒杀商品（代表当前组件中所配置的所有秒杀场次均已结束），展示最后一个秒杀场次的信息
spikeProduct=dataList[dataList.length-1];}_this2.setState({spikeProduct:spikeProduct},function(){// 有秒杀商品且开始时间在当天内，开始倒计时
if(spikeProduct&&__WEBPACK_IMPORTED_MODULE_23_moment___default()(__WEBPACK_IMPORTED_MODULE_23_moment___default.a.unix(Number(spikeProduct.start_time))).isSame(__WEBPACK_IMPORTED_MODULE_23_moment___default()(),'day')&&Number(spikeProduct.start_time>=__WEBPACK_IMPORTED_MODULE_23_moment___default()().unix())){_this2.setTimeCountDown();}});}});}// 订阅秒杀
},{key:"render",value:function render(){var baseConfig=this.props.config.baseConfig;var spikeProduct=this.state.spikeProduct;if(!spikeProduct.id){return null;}if(!this.showView()&&spikeProduct.pd_type==4){return null;}var spikeTimeSlogan='';if(__WEBPACK_IMPORTED_MODULE_23_moment___default()(__WEBPACK_IMPORTED_MODULE_23_moment___default.a.unix(Number(spikeProduct.start_time))).isSame(__WEBPACK_IMPORTED_MODULE_23_moment___default()(),'day')){// 使用倒计时
var countDown=this.state.countDown;spikeTimeSlogan="".concat(countDown.hour,":").concat(countDown.minute,":").concat(countDown.second," \u540E\u79D2\u6740\u5F00\u59CB");}else{// 设置秒杀日期文案
var startTime=__WEBPACK_IMPORTED_MODULE_23_moment___default.a.unix(Number(spikeProduct.start_time));var month=startTime.get('month')+1<10?"0".concat(startTime.get('month')+1):startTime.get('month')+1;var date=startTime.get('date')<10?"0".concat(startTime.get('date')):startTime.get('date');var hour=startTime.get('hour')<10?"0".concat(startTime.get('hour')):startTime.get('hour');var minutes=startTime.get('minute')<10?"0".concat(startTime.get('minute')):startTime.get('minute');spikeTimeSlogan="".concat(month,"\u6708").concat(date,"\u65E5 ").concat(hour,":").concat(minutes," \u5F00\u542F");}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",_extends({className:"pipeline-spike-product"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"spike-wrapper",style:{padding:"".concat(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('8px')," ").concat(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('25px')," ").concat(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('8px')," ").concat(Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('14px')),backgroundImage:"url('".concat(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(baseConfig.bgImg,this.props.webpSupport),"')")}},spikeProduct.pic_1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{className:"product-img",src:__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(spikeProduct.pic_1,this.props.webpSupport),alt:"\u5546\u54C1\u56FE",style:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('71px'),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('71px'),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('4px'),borderRadius:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('6px')}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"detail-info",style:{paddingTop:spikeProduct.status===1?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('5px'):Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('8px')}},(spikeProduct.status===1||spikeProduct.status===4)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"spike-time",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('12px'),color:baseConfig.timeTextColor}},spikeProduct.status===1?spikeTimeSlogan:'活动已结束'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"product-name",style:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('150px'),marginTop:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('4px'),marginBottom:spikeProduct.status===1?Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('-3px'):Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('6px'),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('13px')}},spikeProduct.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"price-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"price-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"price",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('1px')}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("img",{src:baseConfig.spikePriceIcon||'https://static.shihuocdn.cn/admin/files/20220210/85d4dc36fbcff9aacd98f392e4bb3d3d.png',alt:"",className:"price-icon",style:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('34px'),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('13px'),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('2px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('-1px')}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{className:"symbol",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('14px'),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('2px'),marginRight:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('1px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("span",{style:{display:'inline-block',fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('20px')}},parseFloat(spikeProduct.price))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"origin-price",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('11px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('-4px')}},"\u539F\u4EF7\xA5",parseFloat(spikeProduct.original_price))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_19_react___default.a.createElement("div",{className:"spike-btn",style:{width:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('80px'),height:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('29px'),backgroundSize:"100% 100%",backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].formatImgUrl(baseConfig.spikeIcon,this.props.webpSupport),")"),fontSize:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('15px'),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_25__utils_px2rem__["a" /* default */])('-2px')},onClick:this.handleSeckillBtn.bind(this,spikeProduct)},this.renderBtnText(spikeProduct))))),this.renderToast());}},{key:"focusWebview",value:function focusWebview(){var _this3=this;if(__WEBPACK_IMPORTED_MODULE_24__utils_utils__["a" /* default */].isAndroid()){window.Jockey.on("focus:webview",function(){// 刷新秒杀状态
_this3.getProductData();});}else{document.addEventListener("visibilitychange",function(){if(document.hidden){return;}else{// 刷新秒杀状态
_this3.getProductData();return;}},false);}}}]);return PipelineSpikeProduct;}(__WEBPACK_IMPORTED_MODULE_19_react___default.a.Component);PipelineSpikeProduct.propTypes={config:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSpikeProduct);

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineGames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CountDown__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Games__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PrizesList__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineGames=/*#__PURE__*/function(_React$Component){_inherits(PipelineGames,_React$Component);var _super=_createSuper(PipelineGames);function PipelineGames(props){var _this;_classCallCheck(this,PipelineGames);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"queryIsLogin",function(){_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=setInterval(function(){var isLogin=_this.state.isLogin;if(!isLogin){var CookieUA=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');Promise.all([CookieUA,CookieU]).then(function(result){_this.setState({isLogin:result&&result[0]&&result[1]});});}else{_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=null;}},1000);});_defineProperty(_assertThisInitialized(_this),"getActivityDetail",function(){__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/info?access_token=&unique_id='+_this.unique_id,method:'get',headers:{"Abtest-Control":_this.abtest_tag},withCredentials:true}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var prize_list=data.prize_list,draw=data.draw,show=data.show;_this.setState({prize_list:prize_list,draw:draw,show:show===1});}});});_defineProperty(_assertThisInitialized(_this),"queryDrawUsage",function(){__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/usage?&unique_id='+_this.unique_id,method:'get',headers:{"Abtest-Control":_this.abtest_tag},withCredentials:true}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){_this.setState({count:data.count});}else{_this.setState({count:2});}});});_defineProperty(_assertThisInitialized(_this),"handleLuckyDraw",function(){if(typeof window!=='undefined'){window.__dace.sendEvent('draw_gift',{from:"topic_page_game_sale",block:"draw_gift"});}__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/start?unique_id='+_this.unique_id,method:'post',withCredentials:true,data:{unique_id:_this.unique_id},headers:{"Abtest-Control":_this.abtest_tag}}).then(function(res){var _res$data3=res.data,status=_res$data3.status,msg=_res$data3.msg,data=_res$data3.data;if(status==0){if(data.winning){// 中奖了，查询奖品列表
_this.setState({result:data,startSlotMachine:true});_this.queryWinningRecord();}else{// 未中奖，如何处理？（动画是否播放）
}}else{_this.setState({show_toast:true,toast_text:msg});}});});_defineProperty(_assertThisInitialized(_this),"queryWinningRecord",function(){__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/record?&unique_id='+_this.unique_id,method:'get',headers:{"Abtest-Control":_this.abtest_tag},withCredentials:true}).then(function(res){var _res$data4=res.data,status=_res$data4.status,data=_res$data4.data;if(status===0){var list=data.list;_this.setState({record:list});}});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(){window.__dace.sendEvent('new_user_redpacket',{from:'make_up_land_page',block:'new_user_redpacket'});});_defineProperty(_assertThisInitialized(_this),"renderCouponsList",function(){var _this$state=_this.state,coupon_list=_this$state.coupon_list,expire_time=_this$state.expire_time;var couponsConfig=_this.props.config.couponsConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"coupons-info",style:{backgroundColor:couponsConfig.couponBackgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"title"},couponsConfig.couponTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"coupon-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"scroll"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("ul",null,coupon_list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"coupon-item",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].formatImgUrl(couponsConfig.couponBackgroundImage,_this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"money"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("span",null,"\uFFE5"),parseFloat(item.cash_back)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"desc"},parseFloat(item.start_amount)>0?"\u6EE1".concat(parseFloat(item.start_amount),"\u8FD4"):'无门槛')));})))),!couponsConfig.noCountDown&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"count-down"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_CountDown__["a" /* default */],{end_time:expire_time})));});_defineProperty(_assertThisInitialized(_this),"renderToast",function(){var _this$state2=_this.state,show_toast=_this$state2.show_toast,toast_text=_this$state2.toast_text;if(show_toast){_this.interval&&clearTimeout(_this.interval);_this.interval=setTimeout(function(){_this.setState({show_toast:false,toast_text:''});},2500);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"toast"},toast_text);}else{return null;}});_defineProperty(_assertThisInitialized(_this),"showToast",function(show_toast,toast_text){_this.setState({show_toast:show_toast,toast_text:toast_text});});_defineProperty(_assertThisInitialized(_this),"login",function(){if(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].isShihuo()){// 未登陆，请先进行微信登陆
window.Jockey.send("subscribe",{},function(publishData){if(publishData.type==="loginSuccess"){_this.queryIsLogin();}});window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});_defineProperty(_assertThisInitialized(_this),"closeGame",function(){_this.setState({show:false});});_defineProperty(_assertThisInitialized(_this),"createScript",function(){var head=document.querySelector('head');var script=document.createElement('script');script.type="text/javascript";script.src="https://www.shihuo.cn/js/lib/vFramePlayer.min.js";head.appendChild(script);});_this.state={isLogin:false,// 是否已登录
prize_list:[],// 老虎机奖品列表
draw:{},// 场次信息
show:false,// 是否展示游戏弹窗
count:0,// 剩余抽奖次数，为0时也不展示游戏弹窗
record:[],// 中奖记录
result:{},// 中奖结果
show_toast:false,toast_text:'',startSlotMachine:false};_this.interval=null;_this.loginInterval=null;return _this;}_createClass(PipelineGames,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.createScript();var baseConfig=this.props.config.baseConfig;this.unique_id=baseConfig.uniqueId;// 获取本地Cookie
if(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].isShihuo()){var CookieUA=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');Promise.all([CookieUA,CookieU]).then(function(result){_this2.setState({isLogin:result&&result[0]&&result[1]});});// 获取设备信息
var device_info={};window.Jockey.send("device",function(res){if(typeof res=="string"){res=JSON.parse(res);}device_info=Object.assign(device_info,res);_this2.abtest_tag=device_info.abtest_tag||"";_this2.getActivityDetail();_this2.queryDrawUsage();_this2.queryWinningRecord();});}else{this.getActivityDetail();this.queryDrawUsage();this.queryWinningRecord();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.loginInterval&&clearInterval(this.loginInterval);this.loginInterval=null;}// 查询是否登录
},{key:"render",value:function render(){var _this3=this;var _this$state3=this.state,isLogin=_this$state3.isLogin,prize_list=_this$state3.prize_list,show=_this$state3.show,count=_this$state3.count,record=_this$state3.record,result=_this$state3.result,startSlotMachine=_this$state3.startSlotMachine;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({className:"pipeline-games-coupons"},this.props['customAttributes']),show&&count>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Games__["a" /* default */],{visable:show&&count>0,prize_list:prize_list,unique_id:this.unique_id,abtest_tag:this.abtest_tag,info:result,isLogin:isLogin,config:this.props.config,startSlotMachine:startSlotMachine,showToast:this.showToast,login:this.login,queryWinningRecord:this.queryWinningRecord,handleLuckyDraw:this.handleLuckyDraw,closeGame:this.closeGame}),record&&record.length>0&&record.map(function(item,index){if(item.recevied!=0&&item.prize_type!=2){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_PrizesList__["a" /* default */],{key:index,unique_id:_this3.unique_id,abtest_tag:_this3.abtest_tag,info:item,isLogin:isLogin,config:_this3.props.config,showToast:_this3.showToast,login:_this3.login,queryWinningRecord:_this3.queryWinningRecord});}else{return null;}}),this.renderToast());}}]);return PipelineGames;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineGames);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_less__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_utils__ = __webpack_require__(7);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Games=/*#__PURE__*/function(_Component){_inherits(Games,_Component);var _super=_createSuper(Games);function Games(props){var _this;_classCallCheck(this,Games);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"playGames",function(){var casino1=document.querySelector('#casino1');var casino2=document.querySelector('#casino2');var casino3=document.querySelector('#casino3');_this.mCasino1=new window.SlotMachine(casino1,{active:0,delay:400,transition:"ease-in-out",direction:"down",onComplete:function onComplete(){_this.mCasino2.stop();}});_this.mCasino2=new window.SlotMachine(casino2,{active:1,delay:500,transition:"ease-in-out",direction:"down",onComplete:function onComplete(){_this.mCasino3.stop();}});_this.mCasino3=new window.SlotMachine(casino3,{active:2,delay:600,transition:"ease-in-out",direction:"down",onComplete:function onComplete(){setTimeout(function(){document.getElementsByClassName("result")[0].style.display="flex";_this.startFramePlayer2(0,228,_this.state.imgArr2);},300);}});});_defineProperty(_assertThisInitialized(_this),"getCoupons",function(record_id){var _this$props=_this.props,unique_id=_this$props.unique_id,abtest_tag=_this$props.abtest_tag;__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/get?unique_id='+unique_id,method:'post',withCredentials:true,data:{id:record_id},headers:{"Abtest-Control":abtest_tag}}).then(function(res){var _res$data=res.data,status=_res$data.status,msg=_res$data.msg,data=_res$data.data;if(status==0){_this.props.showToast(true,"领取成功");_this.props.queryWinningRecord();_this.gameClose();if(data&&data.jump_url){window.Jockey.send("action",{url:data.jump_url});}}else{_this.props.showToast(true,"领取失败，请联系客服人员");}});});_this.state={imgArr1:["https://static.shihuocdn.cn/admin/files/20210907/82ce2556596ff7fcc5e6e5ca66ea9e40.png","https://static.shihuocdn.cn/admin/files/20210907/94e649f5356f3b4ddd9f71a6c3d56cd5.png","https://static.shihuocdn.cn/admin/files/20210907/c5b071097df9e12690078955df506b1f.png","https://static.shihuocdn.cn/admin/files/20210907/9169ca1c671e7d445e0de1676c689a98.png","https://static.shihuocdn.cn/admin/files/20210907/9169ca1c671e7d445e0de1676c689a98.png","https://static.shihuocdn.cn/admin/files/20210907/3a35f1348612e52f6ff39f6f32b19490.png","https://static.shihuocdn.cn/admin/files/20210907/0801d119d1fb259da0b905f4c50703a8.png","https://static.shihuocdn.cn/admin/files/20210907/5d8940af9f2c2b015303bc09319ae390.png","https://static.shihuocdn.cn/admin/files/20210907/7c6738acddcc88dac915d7e5ccf5b6b5.png","https://static.shihuocdn.cn/admin/files/20210907/54c0ba61ae7b019a36ad80aa831cb867.png","https://static.shihuocdn.cn/admin/files/20210907/04a52f367a8a4e436ed7de664c74418b.png","https://static.shihuocdn.cn/admin/files/20210907/8a1e3fff48d14a930dd8ab353755f22f.png","https://static.shihuocdn.cn/admin/files/20210907/38310b4ada4906bdab8a3462c415c7e4.png","https://static.shihuocdn.cn/admin/files/20210907/e1bffc3ddfedd89b915e2ebebe44096b.png","https://static.shihuocdn.cn/admin/files/20210907/87f71e4f2d29135bc37bdd027e06696f.png","https://static.shihuocdn.cn/admin/files/20210907/0b32ef3a542b0f5433f4dc1e250ba8d2.png","https://static.shihuocdn.cn/admin/files/20210907/9835834a0b8ec7c5f7b6193b88267a6e.png","https://static.shihuocdn.cn/admin/files/20210907/80744784a64659c943f5bfca9ed8e89a.png","https://static.shihuocdn.cn/admin/files/20210907/35fe619526d62ecbf036dd3501b50771.png","https://static.shihuocdn.cn/admin/files/20210907/81c7fee295647bdc3e8675bec79e7119.png","https://static.shihuocdn.cn/admin/files/20210908/9db6482505ac903990d730bc7ca0ce03.png","https://static.shihuocdn.cn/admin/files/20210908/08f2b1aec1e70c1bbdf2a693365e8b6c.png"],imgArr2:["https://static.shihuocdn.cn/admin/files/20210908/77566000069baafbed7d89b4fb3fc206.png","https://static.shihuocdn.cn/admin/files/20210908/2cd44548695e39639ee361e153fb8983.png","https://static.shihuocdn.cn/admin/files/20210908/b8b7391cee5935ab0d7f1f32aaf98a34.png","https://static.shihuocdn.cn/admin/files/20210908/4ec2a8e71b4342e4abb5a5694d31b9b1.png","https://static.shihuocdn.cn/admin/files/20210908/2c90b3d808ee47b8b50ebabf1b7870b9.png","https://static.shihuocdn.cn/admin/files/20210908/c81d70631001d3923de496310e79da48.png","https://static.shihuocdn.cn/admin/files/20210908/4e285cdf846e370228515c513ea52efe.png","https://static.shihuocdn.cn/admin/files/20210908/42d3ce02e783117edc6104771a7e8354.png","https://static.shihuocdn.cn/admin/files/20210908/ccd21aea264cf442938fcc31cefcba0a.png","https://static.shihuocdn.cn/admin/files/20210908/7a40264b440a10a6742d9b72902c558f.png","https://static.shihuocdn.cn/admin/files/20210908/1f90577f7000ce1b7e757e9a33ba177b.png","https://static.shihuocdn.cn/admin/files/20210908/b5eb017f7cd0f44bb924fd9bb2338155.png","https://static.shihuocdn.cn/admin/files/20210908/e3493e93eb06ca221c84debfd4d9d071.png","https://static.shihuocdn.cn/admin/files/20210908/87292e9f262a72a627d6078ff44a0c43.png","https://static.shihuocdn.cn/admin/files/20210908/c61e312ddeafa3a8c3ae8cabc7b25c95.png","https://static.shihuocdn.cn/admin/files/20210908/86f6d9b738a3852fa1e6164531143c91.png","https://static.shihuocdn.cn/admin/files/20210908/609b26329abcc335423e7899924b42eb.png","https://static.shihuocdn.cn/admin/files/20210908/ff3e2c94fe786f056d58f2f13ceacd1b.png","https://static.shihuocdn.cn/admin/files/20210908/b013d24b2612d8c64dfc16deeddc9310.png"],prizeShow:false};_this.framePlayer1=null;_this.framePlayer2=null;return _this;}_createClass(Games,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var app_version=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].getVersion();if(typeof window!=='undefined'&&app_version&&__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].SHDiffVersion(app_version,'6.71.0')){window.Jockey.send("uploadExposures",{list:["".concat(this.props.unique_id,".be..topic_page_game_sale.draw_gift.......")]},function(){});}var _this$state=this.state,imgArr1=_this$state.imgArr1,imgArr2=_this$state.imgArr2;this.loadFramePlayer(imgArr1,imgArr2);setTimeout(function(){_this2.playGames();_this2.setState({prizeShow:true});},500);}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){var _this3=this;var prize_list=nextProps.prize_list,info=nextProps.info,startSlotMachine=nextProps.startSlotMachine;if(this.props.startSlotMachine!=startSlotMachine){prize_list.forEach(function(item,index){if(item.prize_name&&info.prize_name&&item.prize_name==info.prize_name){_this3.stopIndex=index;_this3.startFramePlayer1(0,264,_this3.state.imgArr1);}});}return true;}},{key:"gameClose",value:function gameClose(from,block){if(typeof window!=='undefined'&&from&&block){window.__dace.sendEvent(block,{from:from,block:block});}this.props.closeGame();}},{key:"render",value:function render(){var _this4=this;var prizeShow=this.state.prizeShow;var _this$props2=this.props,visable=_this$props2.visable,prize_list=_this$props2.prize_list;var prize_pic=this.props.info.prize_pic;if(!visable){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"game-dialog"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"mask"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"game-content luck"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"framePlayer1",onClick:function onClick(){return _this4.props.handleLuckyDraw();}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210907/82ce2556596ff7fcc5e6e5ca66ea9e40.png",alt:"",className:"first-frame"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("ul",{className:"prize-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("li",{id:"casino1",className:prizeShow?'show':'hide'},prize_list&&prize_list.length>0&&prize_list.map(function(item,index){if(item.prize_pic&&item.prize_pic[0]){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:item.prize_pic[0],alt:"",className:"slot slot".concat(index),key:index});}else{return null;}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("li",{id:"casino2",className:prizeShow?'show':'hide'},prize_list&&prize_list.length>0&&prize_list.map(function(item,index){if(item.prize_pic&&item.prize_pic[0]){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:item.prize_pic[0],alt:"",className:"slot slot".concat(index),key:index});}else{return null;}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("li",{id:"casino3",className:prizeShow?'show':'hide'},prize_list&&prize_list.length>0&&prize_list.map(function(item,index){if(item.prize_pic&&item.prize_pic[0]){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:item.prize_pic[0],alt:"",className:"slot slot".concat(index),key:index});}else{return null;}})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"game-content result"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"framePlayer2",onClick:function onClick(){return _this4.handleGetPrizes();}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:prize_pic&&prize_pic[0]||prize_pic,alt:"",className:"prize",onClick:function onClick(){return _this4.handleGetPrizes();}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20210912/e596e2c89d336b492bd4b2c40fe573dc.png",alt:"",className:"close",onClick:function onClick(){return _this4.gameClose('topic_page_game_sale','close_draw');}}));}},{key:"loadImages",value:function loadImages(_ref){var loadArr=_ref.loadArr,complete=_ref.complete;var sources=loadArr;var loadingPercent="";var count=0;var images={};var imgNum=sources.length;for(var src in sources){var path=src;images[path]=new Image();images[path].onload=function(){count++;if(count>=imgNum){complete(images);}};images[path].onerror=function(){count++;if(count>=imgNum){complete(images);}};images[path].src=sources[path];}}},{key:"loadFramePlayer",value:function loadFramePlayer(imgArr1,imgArr2){var _this5=this;this.loadImages({loadArr:imgArr1,complete:function complete(){_this5.framePlayer1=new window.vFramePlayer({dom:document.getElementsByClassName("framePlayer1")[0],imgArr:imgArr1,useCanvas:true});_this5.framePlayer1.on("play",function(){});}});this.loadImages({loadArr:imgArr2,complete:function complete(){_this5.framePlayer2=new window.vFramePlayer({dom:document.getElementsByClassName("framePlayer2")[0],imgArr:imgArr2,useCanvas:true});_this5.framePlayer2.on("play",function(){});}});}// 开始播放序列帧1
},{key:"startFramePlayer1",value:function startFramePlayer1(start,end,imgArr){var _this6=this;this.framePlayer1.play(start,end,{fps:12,onComplete:function onComplete(){_this6.framePlayer1.stop();},onUpdate:function onUpdate(frame,times,asc){document.getElementsByClassName("first-frame")[0].style.display="none";if(frame>=imgArr.length-1){_this6.framePlayer1.stop();_this6.mCasino1.shuffle(10,_this6.stopIndex);_this6.mCasino2.shuffle(10,_this6.stopIndex);_this6.mCasino3.shuffle(10,_this6.stopIndex);setTimeout(function(){_this6.mCasino1.stop();},3000);}}});}// 开始播放序列帧2
},{key:"startFramePlayer2",value:function startFramePlayer2(start,end,imgArr){var _this7=this;var luckStyle=document.getElementsByClassName("luck")[0].style;var prizeStyle=document.getElementsByClassName("prize")[0].style;this.framePlayer2.play(start,end,{fps:12,onComplete:function onComplete(){_this7.framePlayer2.stop();},onUpdate:function onUpdate(frame,times,asc){if(frame>=3&&luckStyle.display!="none"){luckStyle.display="none";}if(frame>=5){prizeStyle.display="block";}if(frame>=imgArr.length-1){_this7.framePlayer2.stop();}}});}},{key:"handleGetPrizes",value:function handleGetPrizes(){if(typeof window!=='undefined'){window.__dace.sendEvent('quick_acquire',{from:"topic_page_game_sale",block:"quick_acquire"});}var isLogin=this.props.isLogin;var _this$props$info=this.props.info,prize_type=_this$props$info.prize_type,jump_url=_this$props$info.jump_url,record_id=_this$props$info.record_id,recevied=_this$props$info.recevied;switch(prize_type){case 2:// 淘礼金
if(recevied==0){// 领取淘礼金
this.getCoupons(record_id);}else{jump_url&&window.Jockey.send("action",{url:jump_url});this.gameClose();}break;case 4:// 生活服务券
if(!isLogin){this.props.login();return;}if(recevied==0){// 领券
this.getCoupons(record_id);}else{window.Jockey.send("action",{url:jump_url});this.gameClose();}break;case 5:// 返现券
if(recevied==0){// 领券
this.getCoupons(record_id);}else{window.Jockey.send("action",{url:jump_url});this.gameClose();}break;default:break;}}// 领券
}]);return Games;}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Games);

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CountDown__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_less__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_utils__ = __webpack_require__(7);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var PrizesList=/*#__PURE__*/function(_Component){_inherits(PrizesList,_Component);var _super=_createSuper(PrizesList);function PrizesList(props){var _this;_classCallCheck(this,PrizesList);_this=_super.call(this,props);_this.state={};return _this;}_createClass(PrizesList,[{key:"componentDidMount",value:function componentDidMount(){var app_version=__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].getVersion();if(typeof window!=='undefined'&&app_version&&__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].SHDiffVersion(app_version,'6.71.0')){window.Jockey.send("uploadExposures",{list:["".concat(this.props.unique_id,".bz..topic_page_game_sale.pull_down_coupon.......")]},function(){});}}},{key:"handleGetPrizes",value:function handleGetPrizes(){if(typeof window!=='undefined'){window.__dace.sendEvent('draw_gift',{from:"topic_page_game_sale",block:"pull_down_coupon"});}var isLogin=this.props.isLogin;var _this$props$info=this.props.info,prize_type=_this$props$info.prize_type,jump_url=_this$props$info.jump_url;switch(prize_type){case 2:window.Jockey.send("action",{url:jump_url});break;case 4:// 生活服务券
if(!isLogin){this.props.login();return;}window.Jockey.send("action",{url:jump_url});break;case 5:// 返现券
window.Jockey.send("action",{url:jump_url});break;default:break;}}},{key:"render",value:function render(){var _this2=this;var prizesConfig=this.props.config.prizesConfig;var info=this.props.info;var prize_pic=info.prize_pic,end_time=info.end_time;var baseStyle={backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(prizesConfig.backgroundImage,this.props.webpSupport),")"),backgroundSize:"100% 100%"};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"games-prizes-wrap",style:baseStyle,onClick:function onClick(){return _this2.handleGetPrizes();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img",{src:prizesConfig.maskImage,alt:"",className:"mask-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("ul",null,prize_pic&&prize_pic.length>1&&prize_pic.map(function(item,index){if(index>=1){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("li",{key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img",{src:item,alt:""}));}else{return null;}})),end_time&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:end_time*1000<new Date().getTime()?'count-down-end':'count-down'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__CountDown__["a" /* default */],{end_time:end_time})));}}]);return PrizesList;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PrizesList);

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgSwiper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_swiper_components_pagination_pagination_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_components_effect_coverflow_effect_coverflow_less__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_components_effect_coverflow_effect_coverflow_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_swiper_components_effect_coverflow_effect_coverflow_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineImgSwiper=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgSwiper,_React$Component);var _super=_createSuper(PipelineImgSwiper);function PipelineImgSwiper(props){var _this;_classCallCheck(this,PipelineImgSwiper);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:item.link,type:baseConfig.sortType,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_this.state={};_this.swiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_15_react__["createRef"])();_this.swiperPaginationRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_15_react__["createRef"])();return _this;}_createClass(PipelineImgSwiper,[{key:"componentDidMount",value:function componentDidMount(){// 轮播组件初始化
var delayTime=isNaN(Number(this.props.config.baseConfig.time))?3000:Number(this.props.config.baseConfig.time);var swiper=new __WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js___default.a(this.swiperRef.current,{effect:'coverflow',coverflowEffect:{rotate:46},loop:true,slidesPerView:1.5,spaceBetween:0,centeredSlides:true,pagination:{el:this.swiperPaginationRef.current,clickable:true},autoplay:{delay:delayTime}});}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({className:"pipeline-imgSwiper",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"swiper-container",ref:this.swiperRef},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"swiper-wrapper"},imgsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"swiper-slide",onClick:_this2.handleItemClick.bind(_this2,item,index),key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{className:"img-item",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),alt:""}));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"swiper-pagination",ref:this.swiperPaginationRef})));}}]);return PipelineImgSwiper;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineImgSwiper.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgSwiper);

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSearchCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSearchCard=/*#__PURE__*/function(_React$Component){_inherits(PipelineSearchCard,_React$Component);var _super=_createSuper(PipelineSearchCard);function PipelineSearchCard(props){var _this;_classCallCheck(this,PipelineSearchCard);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:item.link,type:baseConfig.sortType,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handleViewAll",function(){var viewAllLink=_this.props.config.baseConfig.viewAllLink;if(!viewAllLink){return;}var options={link:viewAllLink};var convertUrl=__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].convertHref(viewAllLink);__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,viewAllLink,options,-1,_this.props,false,{id:'legoSearchCard:watch_more',name:'pipeline-searchCard',from:'lego_search_card',block:'watch_more',tpName:_this.props.searchWords});});_defineProperty(_assertThisInitialized(_this),"renderCard",function(_ref){var item=_ref.item,index=_ref.index,scroll=_ref.scroll,isLast=_ref.isLast;var imgSize=scroll?Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('90px',false):Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('103px',false);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"card-item",onClick:_this.handleItemClick.bind(_assertThisInitialized(_this),item,index),"data-dot":JSON.stringify({id:'legoSearchCard:card',name:'pipeline-searchCard',href:'',//跳转的 href, 非必传
exposekey:'card',//必传
pti_refer:{// pageId: this.pageId,
root:{// pageId: this.pageId,
biz:''},parent:{}}}),ref:function ref(ele){if(ele){_this.exp.add({el:ele});}},style:{marginRight:isLast?0:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('8px',false)}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"img-container",style:{width:imgSize,height:imgSize}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"img",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl(item.src,_this.props.webpSupport),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Fragment,null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"name",style:{width:imgSize,height:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('17px',false),marginTop:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('4px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('0px',false),fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('12px',false),lineHeight:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('17px',false)}},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"price",style:{height:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('18px',false)}},item.price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"rmb-icon",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('11px',false)}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"rmb-num",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('16px',false)}},item.price))));});_this.state={};_this.exp=new __WEBPACK_IMPORTED_MODULE_20_shihuo_lib_dist_shihuo_lib__["Exposure"]();// 曝光
_this.screenRatio=1;if(typeof window!=='undefined'){_this.screenRatio=document.body.clientWidth/375;}return _this;}_createClass(PipelineSearchCard,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;var cardList=_toConsumableArray(imgsList);var scroll=Boolean(cardList.length>3);var Card=this.renderCard;var cardListElement=cardList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(Card,{item:item,scroll:scroll,index:index,isLast:index===cardList.length-1});});return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",_extends({className:"pipeline-search-card",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('10px',false)}}),scroll?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"card-list scroll-card-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{style:{paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('12px',false),height:10}}),cardListElement,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"all-btn",onClick:this.handleViewAll,style:{height:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('90px',false),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('8px',false)},"data-dot":JSON.stringify({id:'legoSearchCard:watch_more',name:'pipeline-searchCard',href:'',//跳转的 href, 非必传
exposekey:'watch_more',//必传
pti_refer:{// pageId: this.pageId,
root:{// pageId: this.pageId,
biz:''},parent:{}}}),ref:function ref(ele){if(ele){_this2.exp.add({el:ele});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"all-img",src:__WEBPACK_IMPORTED_MODULE_21__utils_utils__["a" /* default */].formatImgUrl('https://static.shihuocdn.cn/admin/files/20211014/ffc32c3ae5754a3b5983eb245f2cd4da.png',this.props.webpSupport),alt:"all",style:{width:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('30px',false),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('17px',false),marginRight:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('17px',false),marginTop:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('28px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('6px',false)}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('11px',false),color:'#333',textAlign:'center'}},"\u67E5\u770B\u5168\u90E8")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{style:{paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('12px',false),height:10}})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"card-list",style:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('12px',false),marginRight:Object(__WEBPACK_IMPORTED_MODULE_22__utils_px2rem__["a" /* default */])('12px',false)}},cardListElement));}}]);return PipelineSearchCard;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);PipelineSearchCard.propTypes={config:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSearchCard);

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImgList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_swiper_components_pagination_pagination_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */// import { LazyLoadImage } from 'react-lazy-load-image-component';
var PipelineImgList=/*#__PURE__*/function(_React$Component){_inherits(PipelineImgList,_React$Component);var _super=_createSuper(PipelineImgList);function PipelineImgList(props){var _this;_classCallCheck(this,PipelineImgList);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].handleToufangClick({link:item.link,props:_this.props,index:index});return;}if(!item.link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:item.link,type:baseConfig.sortType,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].convertHref(item.link);__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.link,options,-1,_this.props,false);});_this.state={};_this.swiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_14_react__["createRef"])();_this.swiperPaginationRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_14_react__["createRef"])();_this.exp=new __WEBPACK_IMPORTED_MODULE_19_shihuo_lib_dist_shihuo_lib__["Exposure"]();// 曝光
_this.screenRatio=1;if(typeof window!=='undefined'){_this.screenRatio=window.document.body.clientWidth/375;}return _this;}_createClass(PipelineImgList,[{key:"componentDidMount",value:function componentDidMount(){// 轮播组件初始化
var autoplay=this.props.config.baseConfig.autoPlay==='是'?{delay:3000,disableOnInteraction:false}:false;var swiper=new __WEBPACK_IMPORTED_MODULE_15_swiper_swiper_bundle_min_js___default.a(this.swiperRef.current,{pagination:{el:this.swiperPaginationRef.current},// lazy: true,
autoplay:autoplay,loop:true,enabled:this.props.config.imgsList.length>1});// 2100ms之后加载剩余图片
// setTimeout(() => {
//   const imgLength = this.props.config.imgsList.length;
//   for (let index = 1; index < imgLength; index += 1) {
//     swiper.lazy.loadInSlide(index);
//   }
// }, 2100);
}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,imgsList=_this$props$config.imgsList;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",_extends({className:"pipeline-search-swiper",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('8px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('12px',false),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])("12px",false),marginRight:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])("12px",false)}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"swiper-container",ref:this.swiperRef,style:{height:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('152px',false)}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"swiper-wrapper"},imgsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"swiper-slide",key:index,onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("img",{className:"slide-img",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(item.src,_this2.props.webpSupport),"data-dot":JSON.stringify({id:'legoSearchCard:activity_banner',name:'pipeline-searchSwiper',href:'',//跳转的 href, 非必传
exposekey:'activity_banner',//必传
from_sort:index,pti_refer:{// pageId: this.pageId,
root:{// pageId: this.pageId,
biz:''},parent:{}}}),ref:function ref(ele){if(ele){_this2.exp.add({el:ele});}},alt:""}));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement("div",{className:"swiper-pagination",ref:this.swiperPaginationRef})));}}]);return PipelineImgList;}(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Component);PipelineImgList.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImgList);

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSearchSlogan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSearchSlogan=/*#__PURE__*/function(_React$Component){_inherits(PipelineSearchSlogan,_React$Component);var _super=_createSuper(PipelineSearchSlogan);function PipelineSearchSlogan(props){var _this;_classCallCheck(this,PipelineSearchSlogan);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(link){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].handleToufangClick({link:link,props:_this.props});return;}if(!link){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={link:link,type:baseConfig.sortType};var convertUrl=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].convertHref(link);__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,link,options,-1,_this.props,false,{bizExtra:{href:convertUrl,title:baseConfig.title}});});_this.state={};_this.screenRatio=1;if(typeof window!=='undefined'){_this.screenRatio=document.body.clientWidth/375;}return _this;}_createClass(PipelineSearchSlogan,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var baseConfig=this.props.config.baseConfig;var moreText=baseConfig.moreText||'';if(moreText.length>4){moreText=moreText.slice(0,4);}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({className:"pipeline-search-slogan"},this.props['customAttributes'],{onClick:this.handleItemClick.bind(this,baseConfig.moreUrl),style:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('12px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('9px',false),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('12px',false),marginRight:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('12px',false),height:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('36px',false)}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{className:"logo-title",src:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].formatImgUrl(baseConfig.titleImg,this.props.webpSupport),style:{width:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('36px',false),height:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('36px',false),borderRadius:'2px'},alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"title-content",style:{width:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('190px',false),paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('8px',false),paddingRight:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('20px',false)}},baseConfig.title&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"title-1",style:{height:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('22px',false),fontSize:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('16px',false),lineHeight:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('22px',false)}},baseConfig.title),baseConfig.subTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"title-2",style:{height:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('12px',false),fontSize:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('10px',false),lineHeight:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('12px',false)}},baseConfig.subTitle)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"more-link absolute",style:{height:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('18px',false)}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"more-text",style:{height:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('18px',false),fontSize:Object(__WEBPACK_IMPORTED_MODULE_16__utils_px2rem__["a" /* default */])('13px',false)}},moreText),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("svg",{className:"more-icon",t:"1769417691178","class":"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"http://www.w3.org/2000/svg","p-id":"4067",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("path",{d:"M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z","p-id":"4068",fill:"var(--subtitle-color)"}))));}}]);return PipelineSearchSlogan;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);PipelineSearchSlogan.propTypes={config:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSearchSlogan);

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSearchProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react_lazy_load_image_component_src_effects_opacity_css__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSearchProduct=/*#__PURE__*/function(_React$Component){_inherits(PipelineSearchProduct,_React$Component);var _super=_createSuper(PipelineSearchProduct);function PipelineSearchProduct(props){var _this;_classCallCheck(this,PipelineSearchProduct);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:_this.props,index:index});return;}if(!item.url){// 空白不跳转
return;}var baseConfig=_this.props.config.baseConfig;var options={url:item.url,type:baseConfig.sortType,sort:index,name:item.title};var convertUrl=__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].convertHref(item.url);__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.url,options,-1,_this.props,false,{bizExtra:{goods_id:item.goods_id||'',style_id:item.style_id||'',sku_id:item.sku_id||'',title:item.custom_title||item.title}});});_defineProperty(_assertThisInitialized(_this),"handleViewAll",function(){var viewAllLink=_this.props.config.baseConfig.viewAllLink;if(!viewAllLink){return;}var options={link:viewAllLink};var convertUrl=__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].convertHref(viewAllLink);__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,viewAllLink,options,-1,_this.props,false,{id:'legoSearchCard:watch_more',name:'pipeline-searchProduct',from:'lego_search_card',block:'watch_more',tpName:_this.props.searchWords});});_defineProperty(_assertThisInitialized(_this),"renderCard",function(_ref){var item=_ref.item,index=_ref.index,scroll=_ref.scroll,isLast=_ref.isLast;var imgSize=scroll?Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('90px',false):Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('103px',false);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"card-item",onClick:_this.handleItemClick.bind(_assertThisInitialized(_this),item,index),"data-dot":JSON.stringify({id:'legoSearchCard:card',name:'pipeline-searchProduct',href:'',//跳转的 href, 非必传
exposekey:'card',//必传
pti_refer:{// pageId: this.pageId,
root:{// pageId: this.pageId,
biz:''},parent:{}}}),ref:function ref(ele){if(ele){_this.exp.add({el:ele});}},style:{marginRight:isLast?0:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('8px',false)}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"img-container",style:{width:imgSize,height:imgSize,borderRadius:'4px',overflow:'hidden'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__["LazyLoadImage"],{className:"img",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl(item.image,_this.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Fragment,null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"name",style:{width:imgSize,height:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('17px',false),marginTop:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('4px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('0px',false),fontSize:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('12px',false),lineHeight:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('17px',false)}},item.useCustomName==='是'?item.custom_title||item.title:item.title||item.custom_title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price",style:{height:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('18px',false)}},item.price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"rmb-icon",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('11px',false)}},"\uFFE5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"rmb-num",style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('16px',false)}},item.price)))));});_this.state={list:[]};_this.screenRatio=1;_this.exp=new __WEBPACK_IMPORTED_MODULE_22_shihuo_lib_dist_shihuo_lib__["Exposure"]();// 曝光
if(typeof window!=='undefined'){_this.screenRatio=document.body.clientWidth/375;}return _this;}_createClass(PipelineSearchProduct,[{key:"componentDidMount",value:function componentDidMount(){this.getProductListData();}},{key:"getProductListData",value:function getProductListData(){var _this2=this;var itemList=this.props.config.itemList;var itemDataObj={};var idList=itemList.map(function(item){if(item.id){itemDataObj[item.id]=item;}return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";var productType=this.props.config.baseConfig.productType;if(productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="配色id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="skuId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";}__WEBPACK_IMPORTED_MODULE_19_axios_dist_axios_min_js___default()({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:0,filter_subsidy:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;list.forEach(function(product){var customItem=itemList.find&&itemList.find(function(item){return item.id==product.id;});if(customItem){product.custom_title=customItem.name;product.useCustomName=customItem.useCustomName||'否';}});_this2.setState({list:list});}});}},{key:"render",value:function render(){var _this3=this;var baseConfig=this.props.config.baseConfig;var list=this.state.list.length?this.state.list:[];var scroll=Boolean(list.length>3);var Card=this.renderCard;var cardListElement=list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(Card,{item:item,scroll:scroll,key:item.id,index:index,isLast:index===list.length-1});});return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-search-product",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{marginTop:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('8px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('10px',false)}}),scroll?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"card-list scroll-card-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{style:{paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('12px',false),height:10}}),cardListElement,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"all-btn",onClick:this.handleViewAll,style:{height:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('90px',false),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('8px',false)},"data-dot":JSON.stringify({id:'legoSearchCard:watch_more',name:'pipeline-searchProduct',href:'',//跳转的 href, 非必传
exposekey:'watch_more',//必传
pti_refer:{// pageId: this.pageId,
root:{// pageId: this.pageId,
biz:''},parent:{}}}),ref:function ref(ele){if(ele){_this3.exp.add({el:ele});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{className:"all-img",src:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].formatImgUrl('https://static.shihuocdn.cn/admin/files/20211014/ffc32c3ae5754a3b5983eb245f2cd4da.png',this.props.webpSupport),alt:"all",style:{width:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('30px',false),marginLeft:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('17px',false),marginRight:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('17px',false),marginTop:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('28px',false),marginBottom:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('6px',false)}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('11px',false),textAlign:'center'},className:"check-all"},"\u67E5\u770B\u5168\u90E8")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{style:{paddingLeft:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('12px',false),height:10}})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"card-list",style:{marginLeft:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('12px',false),marginRight:Object(__WEBPACK_IMPORTED_MODULE_21__utils_px2rem__["a" /* default */])('12px',false)}},cardListElement));}}]);return PipelineSearchProduct;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineSearchProduct.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSearchProduct);

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSpringFestivalFloor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_shihuo_lib_dist_shihuo_lib__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */// import { LazyLoadImage } from 'react-lazy-load-image-component';
var PipelineSpringFestivalFloor=/*#__PURE__*/function(_React$Component){_inherits(PipelineSpringFestivalFloor,_React$Component);var _super=_createSuper(PipelineSpringFestivalFloor);function PipelineSpringFestivalFloor(props){var _this;_classCallCheck(this,PipelineSpringFestivalFloor);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"goodsListByIds",function(ids){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{goods_id:ids,goods_type:_this.goods_type}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var list=data.goods_list;resolve(list);}else{resolve([]);}});});});_defineProperty(_assertThisInitialized(_this),"goodsListByCate",function(ids){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_26_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cate:ids,page_size:60,page_on:1,goods_type:_this.goods_type,from:window.location.href,scene:'ACTIVITY_11_GOODSLIST_REC',goods_from:0}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){var list=data.goods_list;resolve(list);}else{resolve([]);}});});});_defineProperty(_assertThisInitialized(_this),"getMainPushGoodsList",function(){var requestIndex=0;// 楼层数据请求的数量
var senceTabList=_this.props.config.senceTabList;senceTabList.length>0&&senceTabList.forEach(function(senceTabItem,senceTabIndex){var _senceTabItem$senceFl=senceTabItem.senceFloor,floorBgImage=_senceTabItem$senceFl.floorBgImage,mainPush=_senceTabItem$senceFl.mainPush,categoryTabBgImage=_senceTabItem$senceFl.categoryTabBgImage,categoryTabHoverBgImage=_senceTabItem$senceFl.categoryTabHoverBgImage,categoryListBgImage=_senceTabItem$senceFl.categoryListBgImage,categoryTab=_senceTabItem$senceFl.categoryTab;var moduleElement={index:senceTabIndex,tabTitle:senceTabItem.tabTitle,tabBgImage:senceTabItem.tabBgImage,tabHoverBgImage:senceTabItem.tabHoverBgImage,tabCurIndex:0,floorBgImage:floorBgImage,categoryTabBgImage:categoryTabBgImage,categoryTabHoverBgImage:categoryTabHoverBgImage,categoryListBgImage:categoryListBgImage,mainTitle:mainPush.mainTitle,subTitle:mainPush.subTitle,showBrowserMore:mainPush.showBrowserMore,browserMoreImage:mainPush.browserMoreImage,browserMoreLink:mainPush.browserMoreLink,mainPushProBgImage:mainPush.mainPushProBgImage,configType:mainPush.configType,categoryTab:categoryTab,mainPushList:[]};var pref=mainPush.configType==="商品id"?'g':'p';var itemList=mainPush.mainPushProductList;var idList=itemList.map(function(item){return isNaN(Number(item.id))?0:pref+item.id;});_this.goodsListByIds(idList).then(function(res){// 插入定制化内容
if(!res){return;}res.length>0&&res.forEach(function(product,indexNum){if(mainPush.configType==="商品id"){var customItem=itemList.find&&itemList.find(function(item){return item.id==product.goodsId;});if(customItem){product.custom_image=customItem.image;product.custom_title=customItem.title;product.custom_subTitle=customItem.subTitle;}}else{var _customItem=itemList.find&&itemList.find(function(item){return item.id==product.styleId;});if(_customItem){product.custom_image=_customItem.image;product.custom_title=_customItem.title;product.custom_subTitle=_customItem.subTitle;}}});Object.assign(moduleElement,{mainPushList:res.length>2?_this.getRandomMainPush(res,2):res});var goodsList=_this.state.goodsList;goodsList.push(moduleElement);goodsList=_this.handleFloorSort(goodsList);_this.setState({goodsList:goodsList},function(){requestIndex++;if(requestIndex>=3){_this.getFloorCategoryInfo();}});});});});_defineProperty(_assertThisInitialized(_this),"getFloorCategoryGoodsInfo",function(dataSource,targetCate,senceTabIndex,targetIndex,isInit){if(!targetCate){return;}console.log('targetCate',targetCate);var goodsList=_this.state.goodsList;var tabName=targetCate.tabName,configType=targetCate.configType,layout_goodsId=targetCate.layout_goodsId,layout_styleId=targetCate.layout_styleId,layout_categoryId=targetCate.layout_categoryId,layout_custom=targetCate.layout_custom;var activeCateProInfo={configType:configType,tabName:tabName,showRangeStart:0,showRangeEnd:6,showSwitch:true,list:[]};if(configType==="商品id(维度)"||configType==="配色id(维度)"){var prefix=configType==="商品id(维度)"?'g':'p';var itemList=(layout_goodsId&&layout_goodsId.id||layout_styleId&&layout_styleId.id).split(",")||[];var ids=itemList.map(function(item){return isNaN(Number(item))?0:prefix+item;});_this.goodsListByIds(ids).then(function(res){var list=res;Object.assign(activeCateProInfo,{list:list,showSwitch:activeCateProInfo.showRangeEnd<=list.length&&activeCateProInfo.showRangeEnd+6<=list.length});if(isInit){Object.assign(goodsList[senceTabIndex],{categoryTab:dataSource,curCategoryTab:activeCateProInfo});}else{Object.assign(goodsList[senceTabIndex],{curCategoryTab:activeCateProInfo,tabCurIndex:targetIndex});}_this.setState({goodsList:goodsList});});}else if(configType==="二级类目id(维度)"){var _ids=layout_categoryId.id&&layout_categoryId.id.split(",")||[];_this.goodsListByCate(_ids).then(function(res){var list=res;Object.assign(activeCateProInfo,{list:list,showSwitch:activeCateProInfo.showRangeEnd<=list.length&&activeCateProInfo.showRangeEnd+6<=list.length});if(isInit){Object.assign(goodsList[senceTabIndex],{categoryTab:dataSource,curCategoryTab:activeCateProInfo});}else{Object.assign(goodsList[senceTabIndex],{curCategoryTab:activeCateProInfo,tabCurIndex:targetIndex});}_this.setState({goodsList:goodsList});});}else{console.log('layout_custom',layout_custom);var list=layout_custom.categoryProductList;Object.assign(activeCateProInfo,{list:list,showSwitch:activeCateProInfo.showRangeEnd<=list.length&&activeCateProInfo.showRangeEnd+6<=list.length});if(isInit){Object.assign(goodsList[senceTabIndex],{categoryTab:dataSource,curCategoryTab:activeCateProInfo});}else{Object.assign(goodsList[senceTabIndex],{curCategoryTab:activeCateProInfo,tabCurIndex:targetIndex});}_this.setState({goodsList:goodsList});}});_defineProperty(_assertThisInitialized(_this),"handleCategoryTab",function(floorIndex,categoryTabIndex,tabName,floorItem){var options={page_id:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getPageId(),miniSence:tabName,floor_name:floorItem.tabTitle,tab_name:tabName,tabChName:floorItem.tabTitle,model_block:'小场景Tab'};__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{ptiId:"lego-specialTopic:senceFloor-categorySet-tab:".concat(categoryTabIndex),bizExtra:options});var goodsList=_this.state.goodsList;var categoryTab=goodsList[floorIndex].categoryTab;var targetTab=goodsList[floorIndex].categoryTab[categoryTabIndex];_this.getFloorCategoryGoodsInfo(categoryTab,targetTab,floorIndex,categoryTabIndex,false);});_defineProperty(_assertThisInitialized(_this),"getRandomMainPush",function(arr,n){var result=[];for(var i=0;i<n;i++){var random=Math.floor(Math.random()*arr.length);if(result.includes&&result.includes(arr[random])){continue;}result.push(arr[random]);arr.splice(random,1);}return result;});_defineProperty(_assertThisInitialized(_this),"onScroll",function(){var tabBar=window.document.querySelector('.sence-nav-container');if(!tabBar){return;}var tabBarHeight=tabBar.clientHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navOffsetTop=tabBar.offsetTop-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()?-44:0);var navFixed=scrollHeight-navOffsetTop>=0&&scrollHeight-navOffsetTop<=window.document.querySelector('.pipeline-springFestival-floor').clientHeight-tabBarHeight;if(navFixed!=_this.state.navFixed){_this.setState({navFixed:navFixed});}var list=window.document.querySelectorAll('.sence-floor')||[];var stopIndex=list.length-1;for(var i=0;i<list.length;i+=1){var item=list[i];if(item&&scrollHeight>=item.offsetTop-tabBarHeight-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()?-45:0)){if(i==list.length-1||scrollHeight<list[i+1].offsetTop-tabBarHeight-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()?-45:0)){var curTabIndex=i>stopIndex?stopIndex:i;if(curTabIndex!=_this.state.curTabIndex){_this.setState({curTabIndex:curTabIndex});}break;}}}});_defineProperty(_assertThisInitialized(_this),"handleFloorSort",function(arr){return arr.sort(function(a,b){return a.index-b.index;});;});_defineProperty(_assertThisInitialized(_this),"handleSwitch",function(target,dataSource){var tabTitle=dataSource.tabTitle;var options={floor_name:tabTitle,tab_name:target.tabName,tabChName:tabTitle,model_block:'换一换'};__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{ptiId:"lego-specialTopic:senceFloor-categorySet-tab_".concat(dataSource.tabCurIndex,"-changed"),bizExtra:options});if(target.configType==='商品id(维度)'||target.configType==='配色id(维度)'||target.configType==='自定义(维度)'){if(target.list>=12){target.showSwitch=true;}target.showRangeStart+=6;target.showRangeEnd+=6;if(target.showRangeEnd>target.list.length){target.showRangeStart=0;target.showRangeEnd=6;}_this.setState({});}else{if(target.list>=12){target.showSwitch=true;}target.showRangeStart+=6;target.showRangeEnd+=6;if(target.showRangeEnd>target.list.length){target.showRangeStart=0;target.showRangeEnd=6;}_this.setState({});}});_this.state={goodsList:[],curTabIndex:0,navFixed:false};_this.templateId=85992400;_this.canExposure=false;_this.goods_type=2;_this.pageId=typeof window!=="undefined"&&window.location.host==="zt-public.shihuo.cn"?window.location.href.indexOf('zt-public.shihuo.cn/stage')>-1?window.location.pathname.split("/")[3]:window.location.pathname.split("/")[2]:0;return _this;}_createClass(PipelineSpringFestivalFloor,[{key:"componentDidMount",value:function componentDidMount(){var baseConfig=this.props.config.baseConfig;this.goods_type=baseConfig.squareStageType=='预售'?1:baseConfig.squareStageType=='预热'?2:baseConfig.squareStageType=='全部商品'?0:3;this.getMainPushGoodsList();window.addEventListener("scroll",this.onScroll);}// 基于商品id / 配色id 抓取商品信息
},{key:"getFloorCategoryInfo",value:// 获取楼层类目商品列表
function getFloorCategoryInfo(){var _this2=this;var goodsList=this.state.goodsList;goodsList.length>0&&goodsList.forEach(function(senceTabItem,senceTabIndex){var categoryTab=senceTabItem.categoryTab;var curTab=categoryTab&&categoryTab.length>0&&categoryTab[0];_this2.getFloorCategoryGoodsInfo(categoryTab,curTab,senceTabIndex,0,true);});}// 获取楼层类目商品信息
/**
   * 
   * @param {*} dataSource     目标楼层数据源
   * @param {*} targetCate     目标楼层中的目标类目
   * @param {*} senceTabIndex  目标楼层索引
   * @param {*} targetIndex    目标楼层中的目标类目索引
   * @param {*} isInit         是否是初始化
   * @returns 
   */},{key:"handleTabItemClick",value:// 场景Tab点击
function handleTabItemClick(item,index){var options={page_id:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getPageId(),block_name:'楼层Tab',tabChName:item.tabTitle,model_block:'楼层Tab'};__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(this.props,{sort:index,name:item.tabTitle},{ptiId:"lego-specialTopic:senceFloor-tab:".concat(index),bizExtra:options});var scrollerY=window.document.querySelectorAll('.sence-floor')[index].offsetTop-this.props.navigationBarHeight-window.document.querySelector('.sence-nav-container').clientHeight;window.scrollTo(0,scrollerY);this.setState({curTabIndex:index});}},{key:"renderSwitch",value:function renderSwitch(target,dataSource){var _this3=this;if(!target||!target.configType){return null;}var showSwitch=false;if(target.configType==='商品id'||target.configType==='配色id'||'自定义'){showSwitch=target.showSwitch;}else{showSwitch=true;}if(showSwitch){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"switch-btn",onClick:function onClick(){return _this3.handleSwitch(target,dataSource);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20211216/2cbac0d9b02c7c0b6159f4218f801d8d.png",alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",null,"\u6362\u4E00\u6362"));}else{return null;}}},{key:"render",value:function render(){var _this4=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,senceTabList=_this$props$config.senceTabList;var _this$state=this.state,curTabIndex=_this$state.curTabIndex,navFixed=_this$state.navFixed,goodsList=_this$state.goodsList;if(goodsList.length<0){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",_extends({className:"pipeline-springFestival-floor"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"sence-nav-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("ul",{className:"sence-tab-list",style:{position:navFixed?'fixed':'relative',top:navFixed?this.props.navigationBarHeight:0,backgroundColor:navFixed?window.backgroundColor:'transparent',zIndex:10}},goodsList.map(function(tabItem,tabIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("li",{className:curTabIndex==tabIndex?"tab-item selected":'tab-item',key:tabIndex,style:{backgroundImage:"url('".concat(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(curTabIndex==tabIndex?tabItem.tabHoverBgImage:tabItem.tabBgImage,_this4.props.webpSupport),"')"),backgroundSize:"contain",backgroundRepeat:"no-repeat"},onClick:_this4.handleTabItemClick.bind(_this4,tabItem,tabIndex)});}))),goodsList.map(function(floorItem,floorIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"sence-floor",key:floorIndex,style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(floorItem.floorBgImage,_this4.props.webpSupport),") no-repeat"),backgroundSize:"100% 100%",marginTop:floorIndex===0&&8}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"main-push-pro"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("h3",{className:"main-title"},floorItem.mainTitle&&floorItem.mainTitle.slice(0,6)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"sub-title"},floorItem.subTitle),floorItem.showBrowserMore==='是'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"view-more",onClick:function onClick(){var options={floor_name:floorItem.tabTitle,tabChName:floorItem.tabTitle,model_block:'查看更多'};var detailHref=floorItem.browserMoreLink;__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,detailHref,detailHref,{},-1,_this4.props,false,{ptiId:"lego-specialTopic:senceFloor-more",bizExtra:options});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(floorItem.browserMoreImage,_this4.props.webpSupport),alt:""})),floorItem.mainPushList.map(function(mainPushItem,mainPushIndex){var pic=mainPushItem.pic,goodsName=mainPushItem.goodsName,price=mainPushItem.price,detailHref=mainPushItem.detailHref,custom_image=mainPushItem.custom_image,custom_title=mainPushItem.custom_title,custom_subTitle=mainPushItem.custom_subTitle,goodsId=mainPushItem.goodsId,styleId=mainPushItem.styleId;if(_this4.canExposure){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"main-push-item",key:mainPushIndex,style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(floorItem.mainPushProBgImage,_this4.props.webpSupport),") no-repeat"),backgroundSize:"100% 100%"},onClick:function onClick(){var options={tabChName:floorItem.tabTitle,model_block:'主推商品',goods_id:mainPushItem.goodsId,style_id:mainPushItem.styleId,floor_name:floorItem.tabTitle};__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,detailHref,detailHref,{goods_id:goodsId,style_id:styleId},-1,_this4.props,false,{ptiId:"lego-specialTopic:senceFloor-mainGoods:".concat(mainPushIndex),bizExtra:options});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(custom_image||pic,_this4.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"pro-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"title"},custom_title||goodsName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"desc"},custom_subTitle&&custom_subTitle.slice(0,8)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"price"},"\xA5",price)));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"main-push-item",key:mainPushIndex,style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(floorItem.mainPushProBgImage,_this4.props.webpSupport),") no-repeat"),backgroundSize:"100% 100%"},onClick:function onClick(){var options={tabChName:floorItem.tabTitle,model_block:'主推商品',goods_id:mainPushItem.goodsId,style_id:mainPushItem.styleId,floor_name:floorItem.tabTitle};__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,detailHref,detailHref,{goods_id:goodsId,style_id:styleId},-1,_this4.props,false,{ptiId:"lego-specialTopic:senceFloor-mainGoods:".concat(mainPushIndex),bizExtra:options});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(custom_image||pic,_this4.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"pro-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"title"},custom_title||goodsName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"desc"},custom_subTitle&&custom_subTitle.slice(0,8)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"price"},"\xA5",price)));}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("ul",{className:"category-tab-list"},floorItem.categoryTab&&floorItem.categoryTab.map(function(categoryTabItem,categoryTabIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("li",{className:"category-tab-item",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(categoryTabIndex===floorItem.tabCurIndex?floorItem.categoryTabHoverBgImage:floorItem.categoryTabBgImage,_this4.props.webpSupport),")"),backgroundSize:"100% 100%"},key:categoryTabIndex,onClick:function onClick(){return _this4.handleCategoryTab(floorIndex,categoryTabIndex,categoryTabItem.tabName,floorItem);}},categoryTabItem.tabName);})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"category-pro-wrap",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(floorItem.categoryListBgImage,_this4.props.webpSupport),")"),backgroundSize:"100% 100%"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("ul",{className:"category-pro-list"},floorItem.curCategoryTab&&floorItem.curCategoryTab.list.slice(floorItem.curCategoryTab.showRangeStart,floorItem.curCategoryTab.showRangeEnd).map(function(categoryProItem,categoryProIndex){if(_this4.canExposure){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("li",{key:categoryProIndex,onClick:function onClick(){var options={tab_name:floorItem.curCategoryTab.tabName,goods_id:categoryProItem.goodsId,style_id:categoryProItem.styleId,floor_name:floorItem.tabTitle,tabChName:floorItem.tabTitle,model_block:'小场景卡片'};var detailHref=categoryProItem.detailHref||categoryProItem.link;__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,detailHref,detailHref,{goods_id:categoryProItem.goodsId||categoryProItem.id,style_id:categoryProItem.styleId||categoryProItem.id},-1,_this4.props,false,{ptiId:"lego-specialTopic:senceFloor-list:".concat(floorIndex),bizExtra:options});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(categoryProItem.pic||categoryProItem.image,_this4.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"pro-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"title"},categoryProItem.goodsName||categoryProItem.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"hot"},categoryProItem.tag||categoryProItem.subTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"price"},"\xA5",categoryProItem.price)));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("li",{key:categoryProIndex,onClick:function onClick(){var options={tab_name:floorItem.curCategoryTab.tabName,goods_id:categoryProItem.goodsId,style_id:categoryProItem.styleId,floor_name:floorItem.tabTitle,tabChName:floorItem.tabTitle,model_block:'小场景卡片'};var detailHref=categoryProItem.detailHref||categoryProItem.link;__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,detailHref,detailHref,{goods_id:categoryProItem.goodsId||categoryProItem.id,style_id:categoryProItem.styleId||categoryProItem.id},-1,_this4.props,false,{ptiId:"lego-specialTopic:senceFloor-list:".concat(floorIndex),bizExtra:options});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(categoryProItem.pic||categoryProItem.image,_this4.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"pro-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"title"},categoryProItem.goodsName||categoryProItem.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"hot"},categoryProItem.tag||categoryProItem.subTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"price"},"\xA5",categoryProItem.price)));}})),_this4.renderSwitch(floorItem.curCategoryTab,floorItem)));})));}}]);return PipelineSpringFestivalFloor;}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);PipelineSpringFestivalFloor.propTypes={config:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSpringFestivalFloor);

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSenceFloor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__style_less__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_react_lazy_load_image_component__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var clientWidth=375;if(typeof window!=='undefined'){clientWidth=window.document.body.clientWidth;}var screenRatio=clientWidth/375;var bgList=[{bgColor:'#ff7d8a',topUrl:'https://static.shihuocdn.cn/admin/files/20220427/ad2e8c87c6da20326a3d70e883999f28.png',// bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/9878709ff2985001cf147deed9e14e1d.png',
btnUrl:'https://static.shihuocdn.cn/admin/files/20220427/dc7ad3cad73314d08a18b4dd8f27ba74.png',bigBtnUrl:'https://static.shihuocdn.cn/admin/files/20220513/16dce660c61f04878789a08cb516bd14.png'},{bgColor:'#ff7dcb',topUrl:'https://static.shihuocdn.cn/admin/files/20220505/a5de89556459fef847eb2517e279a002.png',// bgUrl: 'https://static.shihuocdn.cn/admin/files/20220126/7bcef9be2b7c5474bb414f20240b7b34.png',
btnUrl:'https://static.shihuocdn.cn/admin/files/20220505/f42f08d85fd97239ccd01465f8ebb7bd.png',bigBtnUrl:'https://static.shihuocdn.cn/admin/files/20220513/3440d6174d6492664cc503928aca4e2a.png'},{bgColor:'#aa7dff',topUrl:'https://static.shihuocdn.cn/admin/files/20220505/9142055ef4c8e71a5e299260c947cb6e.png',// bgUrl: 'https://static.shihuocdn.cn/admin/files/20220126/b588866f88a38103095f80f82724ebe7.png',
btnUrl:'https://static.shihuocdn.cn/admin/files/20220505/a3e53c1172664c6e59da30f8b5b296d2.png',bigBtnUrl:'https://static.shihuocdn.cn/admin/files/20220513/35c53556e05556b5c49ddaf428413fd2.png'},{bgColor:'#9a9fff',topUrl:'https://static.shihuocdn.cn/admin/files/20220506/1e9b933b4474fbc99487fc99c46fbc0d.png',// bgUrl: 'https://static.shihuocdn.cn/admin/files/20220126/9b77591cfd7df4e0467a13a2d74928a7.png',
btnUrl:'https://static.shihuocdn.cn/admin/files/20220505/5d7cc4fd4ea7dd39066bee76a74eefd5.png',bigBtnUrl:'https://static.shihuocdn.cn/admin/files/20220513/9e6b28a68b84386a02f22f89405069aa.png'}];var searchKeyHref='shihuo://www.shihuo.cn?route=goodsList&keywords=';var PipelineSenceFloor=/*#__PURE__*/function(_React$Component){_inherits(PipelineSenceFloor,_React$Component);var _super=_createSuper(PipelineSenceFloor);function PipelineSenceFloor(props){var _this;_classCallCheck(this,PipelineSenceFloor);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getMainPushGoodsList",function(){var requestIndex=0;// 楼层数据请求的数量
var typeConfig=_this.props.config.typeConfig;// console.log('this.props.config===', this.props.config);
var _typeConfig$typeList=typeConfig.typeList,typeList=_typeConfig$typeList===void 0?[]:_typeConfig$typeList;typeList&&typeList.forEach(function(senceTabItem,senceTabIndex){var mainPush=senceTabItem.mainPush;var moduleElement=_objectSpread(_objectSpread({index:senceTabIndex,tabCurIndex:0,configType:mainPush.configType},senceTabItem),{},{mainPushList:[]});if(mainPush.configType==="商品id(维度)"||mainPush.configType==="配色id(维度)"){var pref=mainPush.configType==="商品id(维度)"?'g':'p';var itemList=(pref=='g'&&mainPush.layout_goodsId.id||mainPush.layout_styleId.id).split(",");var idList=itemList.map(function(item){return isNaN(Number(item))?0:pref+item;});__WEBPACK_IMPORTED_MODULE_35_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{goods_id:idList,goods_type:_this.goods_type}}).then(function(res){if(res.data.status===0){var list=res.data.data.goods_list||[];// 插入定制化内容
list.forEach(function(product,indexNum){var customItem=null;if(mainPush.configType==="商品id"){customItem=itemList.find&&itemList.find(function(item){return item.id==product.goodsId;});}else{customItem=itemList.find&&itemList.find(function(item){return item.id==product.styleId;});}if(customItem){product.custom_image=customItem.image;product.custom_title=customItem.title;product.custom_subTitle=customItem.subTitle;}});Object.assign(moduleElement,{mainPushList:list});if(moduleElement.searchKeyList&&moduleElement.searchKeyList.length>0){moduleElement.searchKeyList=_this.handleSearchKeySort(moduleElement.searchKeyList);}var goodsList=_this.state.goodsList;goodsList.push(moduleElement);if(goodsList&&goodsList.length>0){goodsList&&goodsList.map(function(item,index){if(item.mainPushList&&item.mainPushList.length>0){item.showMore=item.mainPushList.length>6;item.endRange=item.mainPushList.length>=6?6:item.mainPushList.length;item.clickMoreNum=0;}var _item$categoryRecomme=item.categoryRecommendTab,categoryRecommendTab=_item$categoryRecomme===void 0?[]:_item$categoryRecomme;categoryRecommendTab&&categoryRecommendTab.map(function(imgItem){var _imgItem$imgList=imgItem.imgList,imgList=_imgItem$imgList===void 0?[]:_imgItem$imgList;var img='';// console.log('imgList',imgItem);
if(imgList&&imgList.length>0){var currentBg=imgList[Math.round(Math.random()*(imgList.length-1))]||{};img=currentBg.image||imgList[0].image;}imgItem.img=img;});});goodsList=goodsList.sort(_this.compareList('index'));}_this.setState({goodsList:goodsList},function(){requestIndex++;});}});}else if(mainPush.configType==="二级类目id(维度)"){var _itemList=(mainPush.layout_categoryId.id||mainPush.layout_categoryId.id).split(",");var _idList=_itemList.map(function(item){return isNaN(Number(item))?0:item;});__WEBPACK_IMPORTED_MODULE_35_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cate:_idList,page_size:66,page_on:1,goods_type:_this.goods_type,from:window.location.href,scene:'ACTIVITY_11_GOODSLIST_REC',goods_from:0,gender:_this.gender}}).then(function(res){if(res.data.status===0){var list=res.data.data.goods_list||[];// 插入定制化内容
list.forEach(function(product,indexNum){var customItem=null;if(mainPush.configType==="商品id"){customItem=_itemList.find&&_itemList.find(function(item){return item.id==product.goodsId;});}else{customItem=_itemList.find&&_itemList.find(function(item){return item.id==product.styleId;});}if(customItem){product.custom_image=customItem.image;product.custom_title=customItem.title;product.custom_subTitle=customItem.subTitle;}});Object.assign(moduleElement,{mainPushList:list});if(moduleElement.searchKeyList&&moduleElement.searchKeyList.length>0){moduleElement.searchKeyList=_this.handleSearchKeySort(moduleElement.searchKeyList);}var goodsList=_this.state.goodsList;goodsList.push(moduleElement);if(goodsList&&goodsList.length>0){goodsList&&goodsList.map(function(item,index){if(item.mainPushList&&item.mainPushList.length>0){item.showMore=item.mainPushList.length>6;item.endRange=item.mainPushList.length>=6?6:item.mainPushList.length;item.clickMoreNum=0;}var _item$categoryRecomme2=item.categoryRecommendTab,categoryRecommendTab=_item$categoryRecomme2===void 0?[]:_item$categoryRecomme2;categoryRecommendTab&&categoryRecommendTab.map(function(imgItem){var _imgItem$imgList2=imgItem.imgList,imgList=_imgItem$imgList2===void 0?[]:_imgItem$imgList2;var img='';// console.log('imgList',imgItem);
if(imgList&&imgList.length>0){var currentBg=imgList[Math.round(Math.random()*(imgList.length-1))]||{};img=currentBg.image||imgList[0].image;}imgItem.img=img;});});goodsList=goodsList.sort(_this.compareList('index'));}_this.setState({goodsList:goodsList},function(){requestIndex++;});}});}});});_defineProperty(_assertThisInitialized(_this),"getRandomMainPush",function(arr,n){var result=[];for(var i=0;i<n;i++){var random=Math.floor(Math.random()*arr.length);if(result.includes&&result.includes(arr[random])){continue;}result.push(arr[random]);arr.splice(random,1);}return result;});_defineProperty(_assertThisInitialized(_this),"onScroll",function(){if(typeof window=="undefined"){return;}var tabBar=typeof window!=="undefined"&&window.document.querySelector('.sence-nav-container');if(!tabBar){return;}var tabBarHeight=tabBar.clientHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navOffsetTop=tabBar.offsetTop-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].isAndroid()?0:0);var navFixed=window.document.querySelector('.pipeline-sence-floor')&&scrollHeight-navOffsetTop>=0&&scrollHeight-navOffsetTop<=window.document.querySelector('.pipeline-sence-floor').clientHeight-tabBarHeight;if(navFixed!=_this.state.navFixed){_this.setState({navFixed:navFixed});}var list=window.document.querySelectorAll('.sence-floor')||[];var stopIndex=list.length-1;for(var i=0;i<list.length;i+=1){var item=list[i];if(item&&scrollHeight>=item.offsetTop-tabBarHeight-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].isAndroid()?0:0)){if(i==list.length-1||scrollHeight<list[i+1].offsetTop-tabBarHeight-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].isAndroid()?0:0)){var curTabIndex=i>stopIndex?stopIndex:i;if(curTabIndex!=_this.state.curTabIndex){_this.setState({curTabIndex:curTabIndex});}break;}}}});_defineProperty(_assertThisInitialized(_this),"handleSearchKeySort",function(arr){return arr.sort(function(){return Math.random()-0.5;});});_defineProperty(_assertThisInitialized(_this),"getCookie",function(name){var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");if(arr=document.cookie.match(reg)){return unescape(arr[2]);}else{return null;}});_defineProperty(_assertThisInitialized(_this),"handleMore",function(target,dataSource,floorIndex){var curTabIndex=_this.state.curTabIndex;var tabTitle=dataSource.tabTitle;// shihuo.uploadTrack({
//   pti: {
//     id: `lego-valentineDay:sence-floor-tab_${curTabIndex + 1}-more:`,
//     pageId: this.pageId,
//   }
// })
var newProps=JSON.parse(JSON.stringify(_this.props));Object.assign(newProps,{tabChName:'查看更多',floor_name:tabTitle});__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].uploadTrack(newProps,{sort:curTabIndex},{bizExtra:{model_block:'more',floor_name:tabTitle}});// console.log('target', target);
var _target$mainPushList=target.mainPushList,mainPushList=_target$mainPushList===void 0?[]:_target$mainPushList,endRange=target.endRange,_target$clickMoreNum=target.clickMoreNum,clickMoreNum=_target$clickMoreNum===void 0?0:_target$clickMoreNum;if(mainPushList&&mainPushList.length>endRange&&clickMoreNum<2){++target.clickMoreNum;if(mainPushList.length>=target.clickMoreNum*30+6){target.endRange+=30;}else{target.endRange+=mainPushList.length;}target.showMore=mainPushList.length>target.endRange&&target.clickMoreNum<2;console.log('进入修改',target);_this.setState({});}else{target.showMore=false;_this.setState({});}});_defineProperty(_assertThisInitialized(_this),"transformPx",function(num){// 对单位进行转换
num=Number(num);if(isNaN(num)){num=0;}var realNum=Math.round(num*screenRatio);return realNum;});_this.exp=new __WEBPACK_IMPORTED_MODULE_37_shihuo_lib_dist_shihuo_lib__["Exposure"]();_this.state={goodsList:[],curTabIndex:0,navFixed:false};_this.tabActive=__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].getParams('tabActive');_this.clickMoreNum=0;_this.goods_type=3;// this.goods_type = typeof window !== "undefined" && (window.squareStageType == '预售' ? 1 : (window.squareStageType == '预热' ? 2 : (window.squareStageType == '全部商品' ? 0 : 3)))
_this.pageId=typeof window!=="undefined"&&window.location.host==="zt-public.shihuo.cn"?window.location.href.indexOf('zt-public.shihuo.cn/stage')>-1?window.location.pathname.split("/")[3]:window.location.pathname.split("/")[2]:0;return _this;}_createClass(PipelineSenceFloor,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.getMenuBarConfigSex();case 2:this.gender=_context.sent;this.getMainPushGoodsList();typeof window!=="undefined"&&window.addEventListener("scroll",this.onScroll);case 5:case"end":return _context.stop();}}},_callee,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"getMenuBarConfigSex",value:function getMenuBarConfigSex(){var _this$props$allCompon=this.props.allComponents,allComponents=_this$props$allCompon===void 0?[]:_this$props$allCompon;var menuData=null;allComponents&&allComponents.map(function(item){if(item.name=='pipeline-menuBar'){menuData=item.data&&item.data.containerConfig&&item.data.containerConfig.grains;}});var title='';if(menuData&&menuData.length>this.tabActive){title=menuData[this.tabActive]&&menuData[this.tabActive].menuName;}if(title)return title.indexOf('男')>-1?'male':title.indexOf('女')>-1?'female':'common';return'common';}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){if(this.props.tabActive!=nextProps.tabActive){this.setState({curTabIndex:0,navFixed:false});}return true;}// 场景Tab点击
},{key:"handleTabItemClick",value:function handleTabItemClick(index){var item=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};// const { goodsList = [] } = this.state;
// shihuo.uploadTrack({
//   page_id: this.pageId,
//   pti: {
//     id: `lego-valentineDay:sence-floor-tab:${index}`,
//     pageId: this.pageId,
//     page_id: this.pageId,
//     name: goodsList && goodsList[index] && goodsList[index].tabTitle
//   }
// });
var _item$tabTitle=item.tabTitle,tabTitle=_item$tabTitle===void 0?'':_item$tabTitle;var newProps=JSON.parse(JSON.stringify(this.props));Object.assign(newProps,{tabChName:tabTitle,floor_name:tabTitle});__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].uploadTrack(newProps,{sort:index},{bizExtra:{model_block:'tab',floor_name:tabTitle}});var scrollerY=window.document.querySelectorAll('.sence-floor')[index].offsetTop-this.props.navigationBarHeight-window.document.querySelector('.sence-nav-container').clientHeight+(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].isAndroid()?4:0);window.scrollTo(0,scrollerY);this.setState({curTabIndex:index});}// 获取楼层主推商品列表
},{key:"compareList",value:function compareList(property){return function(a,b){var value1=a[property];var value2=b[property];return value1-value2;};}// 楼层主推商品随机展示
},{key:"renderMoreView",value:function renderMoreView(target,dataSource,floorIndex){var _this2=this;if(!target||!target.configType){return null;}if(target.showMore){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"show-more-btn",onClick:function onClick(){return _this2.handleMore(target,dataSource,floorIndex);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",null,"\u67E5\u770B\u66F4\u591A"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20230117/3e1a3b5b8cbe350cb444cffbee3608a7.png",alt:""}));}else{return null;}}},{key:"render",value:function render(){var _this3=this;var customAttributes={"data-component-id":this.props["data-component-id"],"data-component-name":this.props["data-component-name"]};var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,typeConfig=_this$props$config.typeConfig;var _this$state=this.state,navFixed=_this$state.navFixed,goodsList=_this$state.goodsList,curTabIndex=_this$state.curTabIndex;if(goodsList.length<1){return null;}var title=typeConfig.title,titleFontColor=typeConfig.titleFontColor,titleBgImage=typeConfig.titleBgImage;// const marginRight = this.transformPx(clientWidth - this.transformPx(100 * 3 + 26 * 2)) / 2
// const left = this.transformPx(marginRight);
// console.log('=goodslist==', goodsList);
var windowColor='';if(typeof window!='undefined'&&window.backgroundColor){windowColor=window.backgroundColor;}else if(document.querySelector('body').style.backgroundColor){windowColor=document.querySelector('body').style.backgroundColor;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",_extends({className:"pipeline-sence-floor"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"sence-nav-container-top"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"sence-tab-title",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(titleBgImage,this.props.webpSupport),")"),backgroundSize:"contain",backgroundRepeat:"no-repeat",color:titleFontColor||'#FFFFFF'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("span",{style:{fontSize:20,fontWeight:'bold'}},title)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"sence-nav-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("ul",{className:"sence-tab-list",style:{position:navFixed?'fixed':'relative',// position: 'sticky',
top:navFixed?this.props.navigationBarHeight:0,backgroundColor:navFixed?this.props.tabContainerBgColor||windowColor:'transparent',zIndex:10}},goodsList.map(function(tabItem,tabIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("li",{className:'tab-item',key:tabIndex,style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(curTabIndex==tabIndex?tabItem.tabSelectedImage:tabItem.tabImage,_this3.props.webpSupport),")"),// backgroundSize: "contain"
backgroundSize:"100% 100%"},onClick:_this3.handleTabItemClick.bind(_this3,tabIndex,tabItem)});})))),goodsList.map(function(floorItem,floorIndex){var titleIcon=floorItem.titleIcon,tabTitle=floorItem.tabTitle,tabTitleFontColor=floorItem.tabTitleFontColor,tabDesc=floorItem.tabDesc,tabDescFontColor=floorItem.tabDescFontColor,_floorItem$searchKeyL=floorItem.searchKeyList,searchKeyList=_floorItem$searchKeyL===void 0?[]:_floorItem$searchKeyL,searchKeyBgColor=floorItem.searchKeyBgColor,searchKeyFontColor=floorItem.searchKeyFontColor,_floorItem$categoryRe=floorItem.categoryRecommendTab,categoryRecommendTab=_floorItem$categoryRe===void 0?[]:_floorItem$categoryRe,_floorItem$mainPushLi=floorItem.mainPushList,mainPushList=_floorItem$mainPushLi===void 0?[]:_floorItem$mainPushLi,endRange=floorItem.endRange;var bgColor=floorItem.bgColor,topUrl=floorItem.topUrl,btnUrl=floorItem.btnUrl;bgColor=bgColor||bgList[0].bgColor;topUrl=topUrl||bgList[0].topUrl;btnUrl=btnUrl||bgList[0].btnUrl;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"sence-floor",key:floorIndex,style:{backgroundColor:bgColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-push-pro"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top",style:{zIndex:1,position:'absolute',top:0,left:0}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(topUrl,_this3.props.webpSupport),effect:"opacity"})),titleIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top",style:{zIndex:2,position:'absolute',top:'5px',left:'35%',width:'auto'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38_react_lazy_load_image_component__["LazyLoadImage"],{width:"90px",threshold:500,height:"90px",src:__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(titleIcon,_this3.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top",style:{zIndex:3,paddingTop:'12px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("h3",{className:"main-top-title",style:{color:tabTitleFontColor||'#000000'}},tabTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"sub-top-title",style:{color:tabDescFontColor||'#000000'}},tabDesc)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top-right"},searchKeyList&&searchKeyList.map(function(mainPushProduct,mainPushIndex){if(!mainPushProduct.title){return null;}// const ptiId = `lego-valentineDay:sence-floor-tab_${floorIndex + 1}-keywords:${mainPushIndex + 1}`
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{key:mainPushIndex,className:"main-top-right-item",style:{backgroundColor:searchKeyBgColor||'#00000040',color:searchKeyFontColor||'#FFFFFF'},onClick:function onClick(){// utils.handleItemClick(this.props.routeParams,
//   `${searchKeyHref}${encodeURIComponent(mainPushProduct.title)}`,
//   {},
//   { ptiId, page_id: this.pageId, pageId: this.pageId, typeName: tabTitle },
//   { id: ptiId })
var detailHref="".concat(searchKeyHref).concat(encodeURIComponent(mainPushProduct.title));var options={sort:mainPushIndex,tabChName:mainPushProduct.title,floor_name:tabTitle};__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,detailHref,detailHref,options,-1,_objectSpread(_objectSpread({},_this3.props),options),false,{typeName:tabTitle,bizExtra:{model_block:'keywords',floor_name:tabTitle}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("span",{style:{textAlign:'center',lineHeight:'20px',marginBottom:__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].isAndroid()?'-2px':'0px'}},mainPushProduct.title));})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"category-pro-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("ul",{className:"category-pro-list"},categoryRecommendTab&&categoryRecommendTab.slice(0,3).map(function(categoryProItem,categoryProIndex){var btnName=categoryProItem.btnName,_categoryProItem$imgL=categoryProItem.imgList,imgList=_categoryProItem$imgL===void 0?[]:_categoryProItem$imgL,_categoryProItem$img=categoryProItem.img,img=_categoryProItem$img===void 0?'':_categoryProItem$img;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("li",{key:categoryProIndex,onClick:function onClick(){var detailHref=categoryProItem.detailHref||categoryProItem.link;var goods_id=categoryProItem.goodsId||categoryProItem.id;var style_id=categoryProItem.styleId||categoryProItem.id;var options={sort:categoryProIndex,tabChName:categoryProItem.title||categoryProItem.goodsName,floor_name:tabTitle};__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,detailHref,detailHref,options,-1,_objectSpread(_objectSpread({},_this3.props),options),false,{typeName:categoryProItem.title||categoryProItem.goodsName,floor_name:tabTitle,name:categoryProItem.title||categoryProItem.goodsName,goods_id:goods_id,style_id:style_id,bizExtra:{model_block:'recommendCategory',floor_name:tabTitle}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-parent"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("img",{className:"pro-item-img",src:__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(img,_this3.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-one"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",{className:"title"},categoryProItem.title||categoryProItem.goodsName))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"btn",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(btnUrl,_this3.props.webpSupport),")"),backgroundSize:"100% 100%"}},btnName,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("img",{className:"btn-arrow-img",src:__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl('https://static.shihuocdn.cn/admin/files/20220512/1d3b780d8f34171ec441f7bdbe4237c1.png',_this3.props.webpSupport)})));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("ul",{className:"category-pro-list"},mainPushList&&mainPushList.slice(0,endRange).map(function(categoryProItem,categoryProIndex){var detailHref=categoryProItem.detailHref||categoryProItem.link;var ptiId="lego-valentineDay:sence-floor-tab_".concat(floorIndex,"-goods:").concat(categoryProIndex);var goods_id=categoryProItem.goodsId||categoryProItem.id;var style_id=categoryProItem.styleId||categoryProItem.id;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("li",{key:categoryProIndex,onClick:function onClick(){var options={sort:categoryProIndex,tabChName:categoryProItem.goodsName||categoryProItem.title,floor_name:tabTitle};__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,detailHref,detailHref,options,-1,_objectSpread(_objectSpread({},_this3.props),options),false,{typeName:categoryProItem.goodsName||categoryProItem.title,floor_name:tabTitle,goods_id:goods_id,style_id:style_id,bizExtra:{model_block:'goods',floor_name:tabTitle}});},"data-dot":JSON.stringify({id:ptiId,name:'',href:'',biz:JSON.stringify({ptiId:ptiId,page_id:_this3.pageId,pageId:_this3.pageId,typeName:tabTitle,goods_id:goods_id,style_id:style_id}),exposekey:"floor_categoryProIndex_".concat(categoryProIndex),pti_refer:{pageId:'',root:{id:'',pageId:'',name:'',biz:''},parent:{id:'',pageId:'',name:'',biz:''}}}),ref:function ref(ele){if(ele){_this3.exp.add({el:ele});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-parent"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("img",{className:"pro-item-img",src:__WEBPACK_IMPORTED_MODULE_36__utils_utils__["a" /* default */].formatImgUrl(categoryProItem.pic||categoryProItem.image,_this3.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",{className:"title"},categoryProItem.goodsName||categoryProItem.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",{className:"price"},"\xA5",categoryProItem.price))));})),_this3.renderMoreView(floorItem,floorItem,floorIndex)));})));}}]);return PipelineSenceFloor;}(__WEBPACK_IMPORTED_MODULE_32_react___default.a.Component);PipelineSenceFloor.propTypes={config:__WEBPACK_IMPORTED_MODULE_33_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSenceFloor);

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSenceSwiper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_swiper_components_pagination_pagination_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__style_less__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__recommendSwiper__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_px2rem__ = __webpack_require__(42);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var clientWidth=375;if(typeof window!=='undefined'){clientWidth=window.document.body.clientWidth;}var screenRatio=clientWidth/375;// const bgList = [
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/8ab09c6bfda95cae41dfb1ad162f7681.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/02d5324a0d93028cbb8081b74932c491.png',
//   },
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/0af1ff6261fa00da6f03402969b4c50d.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/e5e7c38f2e4e2a9cf1240069c250d4a5.png',
//   },
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/8d153d5162ea5ddcbc9dee304e62cdc9.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/74149e87c1f54d8d6af6ae4865179ccb.png',
//   },
//   {
//     bgUrl: 'https://static.shihuocdn.cn/admin/files/20220427/fa98d29f09bd0f6f5c60258fdd7c971b.png',
//     imgBottomUrl: 'https://static.shihuocdn.cn/admin/files/20220427/7b5305ccc2cc1c9fd69ba7e247c06c2c.png',
//   }
// ];
var searchKeyHref='shihuo://www.shihuo.cn?route=goodsList&keywords=';var PipelineSenceSwiper=/*#__PURE__*/function(_React$Component){_inherits(PipelineSenceSwiper,_React$Component);var _super=_createSuper(PipelineSenceSwiper);function PipelineSenceSwiper(props){var _this;_classCallCheck(this,PipelineSenceSwiper);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getMainPushGoodsList",function(){var requestIndex=0;// 楼层数据请求的数量
var categoryList=_this.props.config.categoryList;var titleCategoryIdList=[];var newCategoryList=[];categoryList&&categoryList.map(function(item,index){if(item.titleCategoryId){titleCategoryIdList.push({key:String(index),cate:item.titleCategoryId});}else{newCategoryList.push(item);}});if(titleCategoryIdList&&titleCategoryIdList.length>0){__WEBPACK_IMPORTED_MODULE_36_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cateList:titleCategoryIdList,scene:'ACTIVITY_11_TAB_REC',from:window.location.href}}).then(function(res){res=res.data;if(res.status==0){var _ref=res.data||{},_ref$orderCateList=_ref.orderCateList,orderCateList=_ref$orderCateList===void 0?[]:_ref$orderCateList;orderCateList.forEach(function(key){categoryList.forEach(function(item,index){if(key==index){newCategoryList.push(item);}});});console.log('newCategoryList',newCategoryList);_this.getListData(newCategoryList);}});}else{_this.getListData(newCategoryList);}});_defineProperty(_assertThisInitialized(_this),"handleSearchKeySort",function(arr){return arr.sort(function(){return Math.random()-0.5;});});_defineProperty(_assertThisInitialized(_this),"getRandomMainPush",function(arr,n){var result=[];for(var i=0;i<n;i++){var random=Math.floor(Math.random()*arr.length);if(result.includes&&result.includes(arr[random])){continue;}result.push(arr[random]);arr.splice(random,1);}return result;});_defineProperty(_assertThisInitialized(_this),"handleFloorSort",function(arr){var pageIds=_this.getCookie('pageIds');if(pageIds&&pageIds.indexOf(_this.pageId)>=0){// 非首次进入，随机排序展示
return arr.sort(function(){return Math.random()-0.5;});}else{// 首次进入，按顺序展示
return arr.sort(function(a,b){return a.index-b.index;});;}});_defineProperty(_assertThisInitialized(_this),"getCookie",function(name){var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");if(arr=document.cookie.match(reg)){return unescape(arr[2]);}else{return null;}});_defineProperty(_assertThisInitialized(_this),"handleSlideChange",function(swiper){var activeIndex=swiper.realIndex;var that=_assertThisInitialized(_this);_this.setState({activeIndex:activeIndex},function(){var targetTabContainer,view;if(_this.props.tabActive){targetTabContainer=window.document.querySelectorAll('.tab-container')[_this.props.tabActive];view=targetTabContainer&&targetTabContainer.querySelector(".bottom-img-ul");}else{view=document.getElementById('bottom-img-container');}that.scroll(view.scrollLeft,(activeIndex-1)*120/2);});});_defineProperty(_assertThisInitialized(_this),"slideClick",function(clickIndex){_this.setState({activeIndex:clickIndex});});_defineProperty(_assertThisInitialized(_this),"transformPx",function(num){// 对单位进行转换
num=Number(num);if(isNaN(num)){num=0;}var realNum=Math.round(num*screenRatio);return realNum;});_this.state={activeIndex:0,goodsList:[]};_this.tabActive=__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].getParams('tabActive');_this.exp=new __WEBPACK_IMPORTED_MODULE_38_shihuo_lib_dist_shihuo_lib__["Exposure"]();_this.swiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_32_react__["createRef"])();_this.goods_type=3;// this.goods_type = typeof window !== "undefined" && (window.squareStageType == '预售' ? 1 : (window.squareStageType == '预热' ? 2 : (window.squareStageType == '全部商品' ? 0 : 3)))
_this.pageId=typeof window!=="undefined"&&window.location.host==="zt-public.shihuo.cn"?window.location.href.indexOf('zt-public.shihuo.cn/stage')>-1?window.location.pathname.split("/")[3]:window.location.pathname.split("/")[2]:0;return _this;}_createClass(PipelineSenceSwiper,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.getMenuBarConfigSex();case 2:this.gender=_context.sent;this.getMainPushGoodsList();case 4:case"end":return _context.stop();}}},_callee,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"getMenuBarConfigSex",value:function getMenuBarConfigSex(){var _this$props$allCompon=this.props.allComponents,allComponents=_this$props$allCompon===void 0?[]:_this$props$allCompon;var menuData=null;allComponents&&allComponents.map(function(item){if(item.name=='pipeline-menuBar'){menuData=item.data&&item.data.containerConfig&&item.data.containerConfig.grains;}});var title='';if(menuData&&menuData.length>this.tabActive){title=menuData[this.tabActive]&&menuData[this.tabActive].menuName;}if(title)return title.indexOf('男')>-1?'male':title.indexOf('女')>-1?'female':'common';return'common';}},{key:"initSwiper",value:function initSwiper(){var _this2=this;// 轮播组件初始化
this.initListener&&clearTimeout(this.initListener);this.initListener=null;this.initListener=setTimeout(function(){_this2.swiper=new __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js___default.a(_this2.swiperRef.current,{// slidesPerView: 2,
spaceBetween:0,centeredSlides:true,// pagination: {
//   el: this.swiperPaginationRef.current,
//   type: 'progressbar',
//   clickable: true,
// },
autoplay:false,loop:false});_this2.swiper.on('slideChange',function(){_this2.handleSlideChange(_this2.swiper);});_this2.handleSlideChange({realIndex:0});},1000);}// 获取楼层主推商品列表
},{key:"getListData",value:function getListData(){var _this3=this;var categoryList=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];categoryList.length>0&&categoryList.forEach(function(senceTabItem,senceTabIndex){var mainPush=senceTabItem.mainPush;var moduleElement=_objectSpread({index:senceTabIndex,tabCurIndex:0,configType:mainPush.configType,mainPushList:[]},senceTabItem);if(mainPush.configType==="商品id(维度)"||mainPush.configType==="配色id(维度)"){var pref=mainPush.configType==="商品id(维度)"?'g':'p';var itemList=(pref=='g'&&mainPush.layout_goodsId.id||mainPush.layout_styleId.id||'').split(",");var idList=itemList.map(function(item){return isNaN(Number(item))?0:pref+item;});__WEBPACK_IMPORTED_MODULE_36_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{goods_id:idList,goods_type:_this3.goods_type}}).then(function(res){if(res.data.status===0){var list=res.data.data.goods_list||[];// 插入定制化内容
list.forEach(function(product,indexNum){var customItem=null;if(mainPush.configType==="商品id"){customItem=itemList.find&&itemList.find(function(item){return item.id==product.goodsId;});}else{customItem=itemList.find&&itemList.find(function(item){return item.id==product.styleId;});}if(customItem){product.custom_image=customItem.image;product.custom_title=customItem.title;product.custom_subTitle=customItem.subTitle;}});Object.assign(moduleElement,{mainPushList:list.length>4?_this3.getRandomMainPush(list,4):list});if(moduleElement.searchKeyList&&moduleElement.searchKeyList.length>0){moduleElement.searchKeyList=_this3.handleSearchKeySort(moduleElement.searchKeyList);}var goodsList=_this3.state.goodsList;goodsList.push(moduleElement);goodsList=_this3.handleFloorSort(goodsList);// goodsList && goodsList.map(item => {
//   const currentBg = bgList[Math.round(Math.random() * 3)] || {}
//   item.currentBg = currentBg
// })
_this3.setState({goodsList:goodsList},function(){_this3.initSwiper();});}});}else if(mainPush.configType==="二级类目id(维度)"){var _itemList=(mainPush.layout_categoryId.id||mainPush.layout_categoryId.id).split(",");var _idList=_itemList.map(function(item,index){return isNaN(Number(item))?0:item;});__WEBPACK_IMPORTED_MODULE_36_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cate:_idList,page_size:66,page_on:1,goods_type:_this3.goods_type,from:window.location.href,scene:'ACTIVITY_11_GOODSLIST_REC',goods_from:0,gender:_this3.gender}}).then(function(res){if(res.data.status===0){var list=res.data.data.goods_list||[];// 插入定制化内容
list.forEach(function(product,indexNum){var customItem=null;if(mainPush.configType==="商品id"){customItem=_itemList.find&&_itemList.find(function(item){return item.id==product.goodsId;});}else{customItem=_itemList.find&&_itemList.find(function(item){return item.id==product.styleId;});}if(customItem){product.custom_image=customItem.image;product.custom_title=customItem.title;product.custom_subTitle=customItem.subTitle;}});Object.assign(moduleElement,{mainPushList:list.length>4?_this3.getRandomMainPush(list,4):list});if(moduleElement.searchKeyList&&moduleElement.searchKeyList.length>0){moduleElement.searchKeyList=_this3.handleSearchKeySort(moduleElement.searchKeyList);}var goodsList=_this3.state.goodsList;goodsList.push(moduleElement);// goodsList = this.handleFloorSort(goodsList);
// goodsList && goodsList.map(item => {
//   const currentBg = bgList[Math.round(Math.random() * 3)] || {}
//   item.currentBg = currentBg
// })
console.log('goodsList',goodsList);_this3.setState({goodsList:goodsList},function(){_this3.initSwiper();});}});}// const pref = mainPush.configType === "商品id" ? 'g' : 'p'
// const itemList = mainPush.mainPushProductList;
// const idList = itemList.map((item) => {
//   return isNaN(Number(item.id)) ? 0 : pref + item.id;
// });
// axios({
//   baseURL: 'https://sh-gateway.shihuo.cn',
//   url: '/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
//   method: "post",
//   withCredentials: true,
//   data: {
//     goods_id: idList,
//     goods_type: this.goods_type
//   },
// }).then((res) => {
//   if (res.data.status === 0) {
//     const list = res.data.data.goods_list || [];
//     // 插入定制化内容
//     list.forEach((product, indexNum) => {
//       let customItem = null;
//       if (mainPush.configType === "商品id") {
//         customItem = itemList.find && itemList.find((item) => item.id == product.goodsId);
//       } else {
//         customItem = itemList.find && itemList.find((item) => item.id == product.styleId);
//       }
//       if (customItem) {
//         product.custom_image = customItem.image;
//         product.custom_title = customItem.title;
//         product.custom_subTitle = customItem.subTitle;
//       }
//     });
//     Object.assign(moduleElement, {
//       mainPushList: list.length > 4 ? this.getRandomMainPush(list, 4) : list
//     })
//     let goodsList = this.state.goodsList;
//     goodsList.push(moduleElement);
//     goodsList = this.handleFloorSort(goodsList);
//     goodsList && goodsList.map(item => {
//       const currentBg = bgList[Math.round(Math.random() * 3)] || {}
//       item.currentBg = currentBg
//     })
//     this.setState({
//       goodsList
//     }, () => {
//       requestIndex++;
//       if (requestIndex == categoryList.length) {
//         this.initSwiper();
//       }
//     })
//   }
// });
});}// 搜索词随机排序
},{key:"scroll",value:function scroll(currentY,targetY){var _this4=this;// 计算需要移动的距离
var needScrollTop=targetY-currentY;var _currentY=currentY;setTimeout(function(){// 一次调用滑动帧数，每次调用会不一样
var dist=Math.ceil(needScrollTop/10);_currentY+=dist;var targetTabContainer=null;if(_this4.props.tabActive){targetTabContainer=window.document.querySelectorAll('.tab-container')[_this4.props.tabActive];targetTabContainer&&targetTabContainer.querySelector(".bottom-img-ul").scrollTo(_currentY,0);}else{document.getElementById('bottom-img-container').scrollTo(_currentY,0);}// 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
if(needScrollTop>10||needScrollTop<-10){_this4.scroll(_currentY,targetY);}else{if(_this4.props.tabActive){targetTabContainer&&targetTabContainer.querySelector(".bottom-img-ul").scrollTo(_currentY,0);}else{document.getElementById('bottom-img-container').scrollTo(_currentY,0);}}},1);}},{key:"handleTabItemClick",value:// 场景Tab点击
function handleTabItemClick(ptiId,categoryName,index){var _this5=this;// shihuo.uploadTrack({
//   page_id: this.pageId,
//   pti: {
//     id: ptiId,
//     pageId: this.pageId,
//     page_id: this.pageId,
//     name: categoryName
//   }
// });
var newProps=JSON.parse(JSON.stringify(this.props));Object.assign(newProps,{tabChName:categoryName,floor_name:categoryName});__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].uploadTrack(newProps,{sort:index},{bizExtra:{model_block:'tab',floor_name:categoryName}});this.setState({curTabIndex:index},function(){// console.log('this.swiperRef', this.swiper);
_this5.swiper&&_this5.swiper.slideTo(index,300,false);// console.log('this.swiperRef', this.swiper && this.swiper.slideTo(index, 500, false));
});}},{key:"render",value:function render(){var _this6=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,tabFontColor=_this$props$config.tabFontColor,tabSelectedFontColor=_this$props$config.tabSelectedFontColor;var _this$state$goodsList=this.state.goodsList,goodsList=_this$state$goodsList===void 0?[]:_this$state$goodsList;var activeIndex=this.state.activeIndex;if(!goodsList||goodsList.length<activeIndex){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",_extends({className:"pipeline-sence-swiper"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"swiper-container-parent"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"swiper-container",ref:this.swiperRef},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"swiper-wrapper"},goodsList.map(function(floorItem,floorIndex){var title=floorItem.title,titleFontColor=floorItem.titleFontColor,_floorItem$searchKeyL=floorItem.searchKeyList,searchKeyList=_floorItem$searchKeyL===void 0?[]:_floorItem$searchKeyL,searchKeyBgColor=floorItem.searchKeyBgColor,searchKeyFontColor=floorItem.searchKeyFontColor,categoryRecommend=floorItem.categoryRecommend,_floorItem$mainPushLi=floorItem.mainPushList,mainPushList=_floorItem$mainPushLi===void 0?[]:_floorItem$mainPushLi,categoryCard=floorItem.categoryCard;// const { bgUrl } = currentBg;
var categoryCardBgImage=floorItem.categoryCardBgImage,categoryCardRecommendIcon=floorItem.categoryCardRecommendIcon,floorBgColor=floorItem.floorBgColor,floorBgImage=floorItem.floorBgImage;categoryCardBgImage=categoryCardBgImage||'https://static.shihuocdn.cn/admin/files/20220427/02d5324a0d93028cbb8081b74932c491.png';floorBgImage=!floorBgImage&&!floorBgColor?'https://static.shihuocdn.cn/admin/files/20220427/8ab09c6bfda95cae41dfb1ad162f7681.png':floorBgImage;// console.log(floorItem, 'floorBgColor, floorBgImage', floorBgColor, floorBgImage);
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"swiper-slide",key:floorIndex},floorBgImage?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:10,height:_this6.transformPx(384),src:__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].formatImgUrl(floorBgImage,_this6.props.webpSupport),effect:"opacity",style:{zIndex:-1,position:'absolute',top:0,left:0,right:0}}):floorBgColor?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{style:{width:'100%',height:_this6.transformPx(384),zIndex:-1,position:'absolute',top:0,left:0,right:0,backgroundColor:floorBgColor,overflow:'hidden',borderRadius:'12px'}}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"product-detail",onClick:_this6.slideClick.bind(_this6,floorIndex)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-push-pro"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("h3",{className:"main-top-title",style:{color:titleFontColor||'#FFFFFF'}},title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top-desc"},searchKeyList&&searchKeyList.map(function(mainPushProduct,mainPushIndex){if(!mainPushProduct.title){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{key:mainPushIndex,className:"main-top-desc-item",style:{backgroundColor:searchKeyBgColor||'#00000040',color:searchKeyFontColor||'#FFFFFF'},onClick:function onClick(){var detailHref="".concat(searchKeyHref).concat(encodeURIComponent(mainPushProduct.title));var options={sort:mainPushIndex,tabChName:mainPushProduct.title,floor_name:title};__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].jumpToUrl(_this6.props.routeParams,detailHref,detailHref,options,-1,_objectSpread(_objectSpread({},_this6.props),options),false,{bizExtra:{model_block:'keywords',floor_name:title},categoryName:title});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("span",{style:{textAlign:'center',lineHeight:'20px',marginBottom:__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].isAndroid()?'-2px':'0px'}},mainPushProduct.title));})),(categoryCard||categoryRecommend)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__recommendSwiper__["a" /* default */],_extends({categoryName:title,routeParams:_this6.props.routeParams,categoryCardBgImage:categoryCardBgImage,categoryCardRecommendIcon:categoryCardRecommendIcon,categoryRecommend:categoryRecommend,categoryCard:categoryCard,floorIndex:floorIndex},_this6.props))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"main-top-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("ul",{className:"main-top-list"},mainPushList&&mainPushList.slice(0,4).map(function(categoryProItem,categoryProIndex){if(categoryProIndex>3)return;var ptiId="lego-valentineDay:sence-swiper-tab_".concat(floorIndex,"-goods:").concat(categoryProIndex);var goods_id=categoryProItem.goodsId||categoryProItem.id;var style_id=categoryProItem.styleId||categoryProItem.id;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("li",{className:"main-top-li",key:categoryProIndex,onClick:function onClick(){var detailHref=categoryProItem.detailHref||categoryProItem.link;var options={sort:categoryProIndex,tabChName:categoryProItem.goodsName||categoryProItem.title,floor_name:title};__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].jumpToUrl(_this6.props.routeParams,detailHref,detailHref,options,-1,_objectSpread(_objectSpread({},_this6.props),options),false,{bizExtra:{model_block:'goods',floor_name:title},categoryName:title,goods_id:goods_id,style_id:style_id});},"data-dot":JSON.stringify({id:ptiId,name:'',href:'',biz:JSON.stringify({ptiId:ptiId,page_id:_this6.pageId,pageId:_this6.pageId,categoryName:title,goods_id:goods_id,style_id:style_id}),exposekey:"categoryProIndex_".concat(categoryProIndex),pti_refer:{pageId:'',root:{id:'',pageId:'',name:'',biz:''},parent:{id:'',pageId:'',name:'',biz:''}}}),ref:function ref(ele){if(ele){_this6.exp.add({el:ele});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-parent"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-img-two"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].formatImgUrl(categoryProItem.pic||categoryProItem.image,_this6.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-two"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",{className:"title"},categoryProItem.goodsName||categoryProItem.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",{className:"price"},"\xA5",categoryProItem.price)),categoryProItem.tag&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"pro-item-two-tag",style:{background:"url(https://static.shihuocdn.cn/admin/imgs/20230117/e5b10a1108cc5cddf0f62b49c6b8c245_137x41.png) no-repeat",backgroundSize:"100% 100%"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("p",{className:"title"},categoryProItem.tag))));})))))));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"bottom-img-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("ul",{className:"bottom-img-ul",id:"bottom-img-container"+(this.props.tabActive||'')},goodsList.map(function(item,index){var isSelected=activeIndex==index;var ptiId="lego-valentineDay:sence-swiper-tab:".concat(activeIndex+1);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("li",{key:index,className:"bottom-img-li-parent",style:{marginLeft:index==0?'9px':'0px',marginRight:index==goodsList.length-1?'15px':'8px',marginBottom:isSelected?0:'6px'},onClick:function onClick(){_this6.handleTabItemClick(ptiId,item.title,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:isSelected?"bottom-img-li-float":'bottom-img-li',style:{marginLeft:'5px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].formatImgUrl(isSelected?item.floorIconImage:item.floorUnSelectedIconImage,_this6.props.webpSupport),effect:"opacity"})),item.floorIconTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:isSelected?'bottom-btn-li-selected':'bottom-btn-li',style:{bottom:!__WEBPACK_IMPORTED_MODULE_40__utils_utils__["a" /* default */].isAndroid()?isSelected?'2px':'-10px':isSelected?'0px':'1px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"bottom-btn-li-title",style:{color:isSelected?tabSelectedFontColor||'#FFFFFF':tabFontColor||'#FF8D8D'}},item.floorIconTitle)));}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{style:{width:'1px'}}))),goodsList.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"bottom-swiper-pagination-parent"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"bottom-swiper-pagination",style:{width:goodsList.length*10}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement("div",{className:"bottom-swiper-pagination-fill",style:{marginLeft:activeIndex*10}})))));}}]);return PipelineSenceSwiper;}(__WEBPACK_IMPORTED_MODULE_32_react___default.a.Component);PipelineSenceSwiper.propTypes={config:__WEBPACK_IMPORTED_MODULE_33_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineSenceSwiper);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_swiper_components_pagination_pagination_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_less__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var RecommendSwiper=/*#__PURE__*/function(_React$Component){_inherits(RecommendSwiper,_React$Component);var _super=_createSuper(RecommendSwiper);function RecommendSwiper(props){var _this;_classCallCheck(this,RecommendSwiper);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(index){var jumpLink=_this.props.config.itemList[index].link;if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].handleToufangClick({link:jumpLink,props:_this.props,index:index});return;}var options={link:jumpLink,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].convertHref(jumpLink);__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,jumpLink,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handleSlideChange",function(swiper){var activeIndex=swiper.realIndex;_this.setState({activeIndex:activeIndex});});_defineProperty(_assertThisInitialized(_this),"slideClick",function(clickIndex){_this.setState({activeIndex:clickIndex});if(clickIndex===_this.state.activeIndex){_this.handleItemClick(clickIndex);}});_this.state={activeIndex:0};_this.swiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_18_react__["createRef"])();return _this;}_createClass(RecommendSwiper,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;setTimeout(function(){_this2.initSwiper();},800);}},{key:"initSwiper",value:function initSwiper(){// 轮播组件初始化
this.swiper=new __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js___default.a(this.swiperRef.current,{spaceBetween:0,centeredSlides:true,autoplay:{delay:3000}});// this.swiper.on('slideChange', () => {
//   this.handleSlideChange(this.swiper)
// });
// this.handleSlideChange({ realIndex: 0 });
}},{key:"render",value:function render(){var _this3=this;var _this$props=this.props,_this$props$categoryC=_this$props.categoryCard,categoryCard=_this$props$categoryC===void 0?{}:_this$props$categoryC,categoryCardRecommendIcon=_this$props.categoryCardRecommendIcon,categoryRecommend=_this$props.categoryRecommend,categoryName=_this$props.categoryName,categoryCardBgImage=_this$props.categoryCardBgImage;var _categoryCard$imgList=categoryCard.imgList,imgList=_categoryCard$imgList===void 0?[]:_categoryCard$imgList,title=categoryCard.title;// const { imgBottomUrl } = currentBg;
// console.log('item==this.props==imgList', this.props, imgList);
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"main-top-left-single"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"main-top-left-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"main-top-left-item-bg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:categoryCardBgImage,effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"swiper-container-child",ref:this.swiperRef},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"swiper-wrapper"},imgList&&imgList.map(function(categoryCardItem,categoryCardIndex){var image=categoryCardItem.image,link=categoryCardItem.link;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"swiper-slide",key:categoryCardIndex},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"pro-item-img",src:image,onClick:function onClick(){var options={sort:categoryCardIndex,tabChName:title,floor_name:categoryName};__WEBPACK_IMPORTED_MODULE_23__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,link,link,options,-1,_objectSpread(_objectSpread({},_this3.props),options),false,{bizExtra:{model_block:'zone',floor_name:categoryName},categoryName:categoryName});}}));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"pro-item-three",style:{// bottom: utils.isAndroid() ? '22px':'20px'
}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",{className:"pro-item-three-title"},title)),categoryCardRecommendIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{className:"pro-item-top-icon",src:categoryCardRecommendIcon})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn"},categoryRecommend));}}]);return RecommendSwiper;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RecommendSwiper);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSenceTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_less__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_shihuo_lib_dist_shihuo_lib__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: cuixinming
 * @Date: 2021-12-14 13:58:46
 * @Last Modified by: cuixinming
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSenceTab=/*#__PURE__*/function(_React$Component){_inherits(PipelineSenceTab,_React$Component);var _super=_createSuper(PipelineSenceTab);function PipelineSenceTab(props){var _this;_classCallCheck(this,PipelineSenceTab);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleImageClick",function(href,senceTabIndex,index){__WEBPACK_IMPORTED_MODULE_16_shihuo_lib_dist_shihuo_lib___default.a.uploadTrack({from:'lego-valentineDay',block:"tab:".concat(index),page_id:_this.pageId,pti:{id:"lego-valentineDay:tab:".concat(index,":"),pageId:_this.pageId,page_id:_this.pageId,tab:senceTabIndex}});var currentSenceTab=_this.props.config.currentSenceTab;if(currentSenceTab===senceTabIndex){return;}if(__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].isShihuo()){__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].handleItemClick(_this.props.routeParams,href);}else{typeof window!=="undefined"&&(window.location.href=href);}});_this.state={isIphoneX:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].isIphoneX()};_this.pageId=typeof window!=="undefined"?window.location.host==="zt-public.shihuo.cn"?window.location.href.indexOf('zt-public.shihuo.cn/stage')>-1?window.location.pathname.split("/")[3]:window.location.pathname.split("/")[2]:0:0;return _this;}_createClass(PipelineSenceTab,[{key:"render",value:function render(){var _this2=this;var customAttributes={"data-component-id":this.props["data-component-id"],"data-component-name":this.props["data-component-name"]};var _this$props$config=this.props.config,firstTabConfig=_this$props$config.firstTabConfig,secondTabConfig=_this$props$config.secondTabConfig,thirdTabConfig=_this$props$config.thirdTabConfig,currentSenceTab=_this$props$config.currentSenceTab;console.log('this.props',this.props);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({className:this.state.isIphoneX?"pipeline-sence-tab isIphoneX":"pipeline-sence-tab"},customAttributes),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"tab"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:currentSenceTab==='场景1'?'sence-tab-1 sence-tab active':'sence-tab-1 sence-tab',onClick:function onClick(){return _this2.handleImageClick(firstTabConfig.jumpUrl,'场景1',0);}},currentSenceTab==='场景1'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(firstTabConfig.firstTabHoverBgImage,this.props.webpSupport),alt:""}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(firstTabConfig.firstTabBgImage,this.props.webpSupport),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:currentSenceTab==='场景2'?"sence-tab-2 sence-tab active":"sence-tab-2 sence-tab",onClick:function onClick(){return _this2.handleImageClick(secondTabConfig.jumpUrl,'场景2',1);}},currentSenceTab==='场景2'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(secondTabConfig.secondTabHoverBgImage,this.props.webpSupport),alt:""}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(secondTabConfig.secondTabBgImage,this.props.webpSupport),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:currentSenceTab==='场景3'?"sence-tab-3 sence-tab active":"sence-tab-3 sence-tab",onClick:function onClick(){return _this2.handleImageClick(thirdTabConfig.jumpUrl,'场景3',2);}},currentSenceTab==='场景3'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(thirdTabConfig.thirdTabHoverBgImage,this.props.webpSupport),alt:""}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].formatImgUrl(thirdTabConfig.thirdTabBgImage,this.props.webpSupport),alt:""}))));}}]);return PipelineSenceTab;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineSenceTab);

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineRecommendFeeds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__style_less__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_shihuo_lib_dist_shihuo_lib__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */function hexColorToRgba(hexColor,opacity){var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}var PipelineRecommendFeeds=/*#__PURE__*/function(_React$Component){_inherits(PipelineRecommendFeeds,_React$Component);var _super=_createSuper(PipelineRecommendFeeds);function PipelineRecommendFeeds(props){var _this;_classCallCheck(this,PipelineRecommendFeeds);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getData",function(){var tabIndex=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var page=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _this$props$config$li=_this.props.config.list,curList=_this$props$config$li===void 0?[]:_this$props$config$li;var curItem=curList&&curList[tabIndex]||{};var _curItem$mainPush=curItem.mainPush,mainPush=_curItem$mainPush===void 0?{}:_curItem$mainPush;if(mainPush.configType==="商品id(维度)"||mainPush.configType==="配色id(维度)"){var pref=mainPush.configType==="商品id(维度)"?'g':'p';var layout_goodsId=mainPush.layout_goodsId,layout_styleId=mainPush.layout_styleId;var itemList=(pref=='g'&&layout_goodsId&&layout_goodsId.id||layout_styleId&&layout_styleId.id).split(",");var idList=itemList&&itemList.map(function(item){return isNaN(Number(item))?0:pref+item;});var tabList=curList;tabList[tabIndex].isLoading=true;tabList[tabIndex].goodsList=[];tabList[tabIndex].page=1;_this.setState({tabList:tabList},function(){__WEBPACK_IMPORTED_MODULE_30_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{goods_id:idList,goods_type:_this.goods_type}}).then(function(res){if(res.data.status===0){var list=res.data.data.goods_list||[];res=res.data;var goodsList=tabList[tabIndex].goodsList||[];goodsList=goodsList.concat(list.map(function(goods){return _objectSpread(_objectSpread({},goods),{},{image:goods.pic,title:goods.level=="g"?goods.goodsName:goods.goodsName+' '+goods.styleName,original_price:goods.officialPrice,url:goods.detailHref,recommend:goods.tag||''});}));tabList[tabIndex].isLoading=false;tabList[tabIndex].page=1;tabList[tabIndex].noMore=false;var adList=tabList[tabIndex].adList||[];adList.forEach(function(ad){var startTime=ad.startTime,endTime=ad.endTime,img=ad.img,position=ad.position;var pos=+position.trim()-1;var now=new Date().getTime();if(startTime&&endTime&&img&&pos>=0&&now>=new Date(startTime).getTime()&&now<=new Date(endTime).getTime()){ad.type='ad';goodsList=goodsList.slice(0,pos).concat([ad]).concat(goodsList.slice(pos,goodsList.length));}});tabList[tabIndex].goodsList=goodsList;tabList[tabIndex].noMore=true;_this.setState({tabList:tabList});}});});}else if(mainPush.configType==="二级类目id(维度)"){if(page===1){var _itemList=curList.map(function(feedsItem,feedsIndex){var _feedsItem$mainPush=feedsItem.mainPush,_feedsItem$mainPush$l=_feedsItem$mainPush.layout_categoryId,layout_categoryId=_feedsItem$mainPush$l===void 0?{}:_feedsItem$mainPush$l,_feedsItem$mainPush$l2=_feedsItem$mainPush.layout_goodsId,layout_goodsId=_feedsItem$mainPush$l2===void 0?{}:_feedsItem$mainPush$l2,_feedsItem$mainPush$l3=_feedsItem$mainPush.layout_styleId,layout_styleId=_feedsItem$mainPush$l3===void 0?{}:_feedsItem$mainPush$l3;var cateIds=layout_categoryId.id||layout_goodsId.id||layout_styleId.id;return cateIds;});var cateList=[];_itemList&&_itemList.map(function(cateItem,cateIndex){if(cateItem){cateList.push({"key":cateIndex+"","cate":cateItem});}});__WEBPACK_IMPORTED_MODULE_30_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cateList:cateList,scene:'ACTIVITY_11_TAB_REC',from:window.location.href}}).then(function(res){res=res.data;var _this$props$config$li2=_this.props.config.list,list=_this$props$config$li2===void 0?[]:_this$props$config$li2;var copyList=JSON.parse(JSON.stringify(list));var tabList=list;if(res.status==0&&!_this.isRequestTabOrder){_this.isRequestTabOrder=true;var _ref=res.data||{},_ref$orderCateList=_ref.orderCateList,orderCateList=_ref$orderCateList===void 0?[]:_ref$orderCateList;var mapIndex=0;orderCateList.forEach(function(key){tabList.forEach(function(item,index){if(key==index){for(var i=mapIndex;i<copyList.length;i++){var _copyList$i$mainPush=copyList[i].mainPush,_copyList$i$mainPush$=_copyList$i$mainPush.layout_categoryId,layout_categoryId=_copyList$i$mainPush$===void 0?{}:_copyList$i$mainPush$,_copyList$i$mainPush$2=_copyList$i$mainPush.layout_goodsId,_layout_goodsId=_copyList$i$mainPush$2===void 0?{}:_copyList$i$mainPush$2,_copyList$i$mainPush$3=_copyList$i$mainPush.layout_styleId,_layout_styleId=_copyList$i$mainPush$3===void 0?{}:_copyList$i$mainPush$3;var cateIds=layout_categoryId.id||_layout_goodsId.id||_layout_styleId.id;if(cateIds){tabList[i]=copyList[+key];mapIndex=i+1;break;}}}});});}tabList.forEach(function(tab,tabIndex){// 推荐置顶
if(tab.tabName=="推荐"){tabList.splice(tabIndex,1);tabList.unshift(tab);}tab.goodsList=[];tab.page=1;});tabList[tabIndex].isLoading=false;_this.setState({tabList:tabList},function(){var tabBarHeight=_this.state.tabBarHeight;setTimeout(function(){_this.setState({outScreen:typeof window!=="undefined"&&window.squareType=='主会场'?true:document.querySelector('.single-line')&&document.querySelector('.single-line').scrollWidth>document.querySelector('.recommend-feeds-tab-list').clientWidth,tabBarHeight:tabBarHeight>0?tabBarHeight:typeof window!=="undefined"&&window.document.querySelector('.recommend-feeds-tab').clientHeight});},0);_this.getGoodsList(tabIndex,1);});});}else{_this.getGoodsList(tabIndex,page);}}});_defineProperty(_assertThisInitialized(_this),"getGoodsList",function(tabIndex,page){var tabList=_this.state.tabList;var tab=tabList[tabIndex]||{};if(tab.isLoading){return;}if(tab.noMore){return;}tab.isLoading=true;_this.setState({tabList:tabList});var page_size=window.squareType=='主会场'?21:20;if(page==1){tab.from='recommend';}var _tab$mainPush=tab.mainPush,mainPush=_tab$mainPush===void 0?{}:_tab$mainPush;var itemList=(mainPush.layout_categoryId&&mainPush.layout_categoryId.id||'').split(",")||[];var idList=itemList&&itemList.map(function(item){return isNaN(Number(item))?0:item;});var squareStageType=window.squareStageType;var goods_type=0;switch(squareStageType){case"预售":goods_type=1;break;case"预热":goods_type=2;break;case"正式":goods_type=3;break;case"全部商品":goods_type=0;break;default:break;}__WEBPACK_IMPORTED_MODULE_30_axios_dist_axios_min_js___default()({baseURL:'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cate:idList,page_size:page_size,page_on:page,goods_type:goods_type,from:window.location.href,scene:'ACTIVITY_11_GOODSLIST_REC',goods_from:tab.from=='search'?1:0}}).then(function(res){tab.isLoading=false;_this.setState({tabList:tabList});res=res.data;if(res.status==0){var list=res.data.goods_list||[];var goodsList=page==1?[]:tab.goodsList||[];goodsList=goodsList.concat(list.map(function(goods){return _objectSpread(_objectSpread({},goods),{},{image:goods.pic,title:goods.level=="g"?goods.goodsName:goods.goodsName+' '+goods.styleName,original_price:goods.officialPrice,url:goods.detailHref,recommend:goods.tag||''});}));tab.page=page;tab.noMore=list.length<20;_this.isReset=false;if(page==1){var adList=tab.adList||[];adList.forEach(function(ad){var startTime=ad.startTime,endTime=ad.endTime,img=ad.img,position=ad.position;var pos=+position.trim()-1;var now=new Date().getTime();if(startTime&&endTime&&img&&pos>=0&&now>=new Date(startTime).getTime()&&now<=new Date(endTime).getTime()){ad.type='ad';goodsList=goodsList.slice(0,pos).concat([ad]).concat(goodsList.slice(pos,goodsList.length));}});}if(tab.from!=res.data.from&&res.data.from=='search'){page=1;tab.page=1;_this.isReset=true;}tab.from=res.data.from;tab.goodsList=goodsList;_this.setState({tabList:tabList});}else{tab.noMore=true;_this.setState({tabList:tabList});}});});_defineProperty(_assertThisInitialized(_this),"handleBodyScroll",function(){var targetTabContainer;if(_this.props.tabActive){targetTabContainer=window.document.querySelectorAll('.tab-container')[_this.props.tabActive];if(!targetTabContainer||!targetTabContainer.querySelector('.recommend-feeds-tab')){return;}}if(!window.document.querySelector('.recommend-feeds-tab')){return;}var navOffsetTop,navFixed;var tabBarHeight=_this.state.tabBarHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;if(_this.props.tabActive){navOffsetTop=targetTabContainer&&targetTabContainer.querySelector('.recommend-feeds-tab')&&targetTabContainer.querySelector('.recommend-feeds-tab').offsetTop-_this.props.navigationBarHeight;}else{navOffsetTop=window.document.querySelector('.recommend-feeds-tab').offsetTop-_this.props.navigationBarHeight;}var isMain=window.squareType=='主会场';// const navMarginTop = Number(this.props.config.baseConfig.moduleMarginTop); // 导航模块上边距
// let navMarginTop = isMain ? (tabBarHeight / 36 - 1) * 36 : 0; // 导航模块上边距
var navMarginTop=isMain?0:0;if(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].isAndroid()){// navMarginTop = navMarginTop - 44
}if(_this.props.tabActive){navFixed=targetTabContainer.querySelector('.recommend-feeds-wrapper')&&scrollHeight-navOffsetTop>navMarginTop&&scrollHeight-navOffsetTop-targetTabContainer.querySelector('.recommend-feeds-wrapper').clientHeight<navMarginTop-tabBarHeight;}else{navFixed=scrollHeight-navOffsetTop>navMarginTop&&scrollHeight-navOffsetTop-window.document.querySelector('.recommend-feeds-wrapper').clientHeight<navMarginTop-tabBarHeight;}if(navFixed!=_this.state.navFixed){if(navFixed){_this.setState({navFixed:true,tabExpand:false},function(){var tabItemEls;if(_this.props.tabActive){tabItemEls=targetTabContainer.querySelectorAll('.recommend-feeds-tab-item');}else{tabItemEls=window.document.querySelectorAll('.recommend-feeds-tab-item');}var index=_this.state.tabIndex;if(tabItemEls&&tabItemEls[index]){tabItemEls[index].scrollIntoView();}});}else{_this.setState({navFixed:false,tabExpand:false});}}var tabIndex=_this.state.tabIndex;var sHeight=document.documentElement.scrollHeight||document.body.scrollHeight;var scrollTop=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop;var height=document.documentElement.clientHeight||document.body.clientHeight;if(scrollTop+height>sHeight-280&&!_this.changed){_this.getGoodsList(tabIndex,_this.state.tabList[tabIndex]?_this.state.tabList[tabIndex].page+1:1);}});_defineProperty(_assertThisInitialized(_this),"handleTabClick",function(index){var tabBarHeight=_this.state.tabBarHeight;var tabList=_this.state.tabList;var newProps=JSON.parse(JSON.stringify(_this.props));Object.assign(newProps,{tabChName:tabList[index]&&tabList[index].tabName});__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].uploadTrack(newProps,{sort:index},{bizExtra:{model_block:'tab'}});if(typeof window=="undefined"){return;}var targetTabContainer=window.document.querySelectorAll('.tab-container')[newProps.tabActive];var scrollTop;if(_this.props.tabActive){scrollTop=targetTabContainer&&targetTabContainer.querySelector('.recommend-feeds-wrapper')&&targetTabContainer.querySelector('.recommend-feeds-wrapper').offsetTop-_this.props.navigationBarHeight+(window.squareType=='主会场'?(tabBarHeight/36-1)*36+5:10);}else{scrollTop=window.document.querySelector('.recommend-feeds-wrapper').offsetTop-_this.props.navigationBarHeight+(window.squareType=='主会场'?(tabBarHeight/36-1)*36+5:10);}if(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].isAndroid()){// scrollTop = scrollTop - 38
}window.scrollTo(0,scrollTop);var changed=index!=_this.state.tabIndex;_this.changed=changed;if(changed){tabList[index].goodsList=[];tabList[index].noMore=false;_this.getData(index,1);setTimeout(function(){_this.changed=false;},1000);}_this.setState({tabIndex:index,navFixed:true,tabExpand:false},function(){var tabItemEls;if(_this.props.tabActive){tabItemEls=targetTabContainer.querySelectorAll('.recommend-feeds-tab-item');if(tabItemEls&&tabItemEls[index]){if(targetTabContainer.querySelector('.single-line')){targetTabContainer.querySelector('.single-line').scrollLeft=tabItemEls[index].offsetLeft-window.innerWidth/2+tabItemEls[index].clientWidth/2;}}}else{tabItemEls=window.document.querySelectorAll('.recommend-feeds-tab-item');if(tabItemEls&&tabItemEls[index]){if(window.document.querySelector('.single-line')){window.document.querySelector('.single-line').scrollLeft=tabItemEls[index].offsetLeft-window.innerWidth/2+tabItemEls[index].clientWidth/2;}}}});});_defineProperty(_assertThisInitialized(_this),"expandClick",function(){var tabExpand=!_this.state.tabExpand;var index=_this.state.tabIndex;_this.setState({tabExpand:tabExpand},function(){if(!tabExpand){var tabItemEls=window.document.querySelectorAll('.recommend-feeds-tab-item');if(tabItemEls&&tabItemEls[index]){if(window.document.querySelector('.single-line')){window.document.querySelector('.single-line').scrollLeft=tabItemEls[index].offsetLeft-window.innerWidth/2+tabItemEls[index].clientWidth/2;}}}});});_this.exp=new __WEBPACK_IMPORTED_MODULE_33_shihuo_lib_dist_shihuo_lib__["Exposure"]();_this.state={tabList:[],tabIndex:0,navFixed:false,tabExpand:false,outScreen:false,tabBarHeight:0};_this.changed=false;_this.isRequestTabOrder=false;_this.canExposure=true;_this.from=typeof window!=="undefined"?window.squareType=='主会场'?'sales_main_square':window.squareName:'';_this.goods_type=0;// this.goods_type = typeof window !== "undefined" && (window.squareStageType == '预售' ? 1 : (window.squareStageType == '预热' ? 2 : (window.squareStageType == '全部商品' ? 0 : 3)))
_this.pageId=typeof window!=="undefined"?window.location.host==="zt-public.shihuo.cn"?window.location.href.indexOf('zt-public.shihuo.cn/stage')>-1?window.location.pathname.split("/")[3]:window.location.pathname.split("/")[2]:0:0;_this.isReset=false;_this.changed=false;return _this;}_createClass(PipelineRecommendFeeds,[{key:"componentDidMount",value:function componentDidMount(){this.getData();typeof window!=="undefined"&&window.addEventListener("scroll",this.handleBodyScroll);}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){if(this.props.tabActive!=nextProps.tabActive){this.setState({navFixed:false});}return true;}//获取商品数据
},{key:"render",value:function render(){var _this2=this;var customAttributes={"data-component-id":this.props["data-component-id"],"data-component-name":this.props["data-component-name"]};var baseConfig=this.props.config.baseConfig;var _this$state=this.state,tabList=_this$state.tabList,tabIndex=_this$state.tabIndex,navFixed=_this$state.navFixed,tabExpand=_this$state.tabExpand,outScreen=_this$state.outScreen,tabBarHeight=_this$state.tabBarHeight;if(tabList.length==0){return null;}var tab=tabList[tabIndex];if(typeof window=="undefined"){return;}var isMain=window.squareType=='主会场';var windowColor='';if(typeof window!='undefined'&&window.backgroundColor){windowColor=window.backgroundColor;}else if(document.querySelector('body').style.backgroundColor){windowColor=document.querySelector('body').style.backgroundColor;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",_extends({className:"recommend-feeds-wrapper"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),tabExpand&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"goods-mask",onClick:this.expandClick}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"recommend-feeds-tab "+(isMain?'':'fen')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"recommend-feeds-tab-list ".concat(isMain&&navFixed||!isMain&&outScreen?'single':''),style:{position:navFixed?'fixed':'relative',top:navFixed?this.props.navigationBarHeight:0,background:this.props.tabContainerBgColor||windowColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"cont single-line ".concat(tabExpand?'expand':''),style:{background:this.props.tabContainerBgColor||windowColor}},tabList&&tabList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{onClick:_this2.handleTabClick.bind(_this2,index),className:"recommend-feeds-tab-item tab-item-new ".concat(tabIndex==index?'active':''),key:index},item.tabName);})))),navFixed&&isMain&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{style:{height:tabBarHeight}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"goods-block-list",style:{minHeight:'100vh',marginTop:0}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"recommend-item",key:tabIndex},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"goods-list",style:{minHeight:'30vh'}},tab.goodsList&&tab.goodsList.map(function(item,index){if(item.type=='ad'){if(_this2.canExposure){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{// className={isMain ? `goods-item` : 'goods-item-2' + ' ad'} 
className:'goods-item'+' ad',key:"".concat(index),"data-dot":JSON.stringify({id:"lego-sales:tab_".concat(tabIndex,"-list:").concat(index),name:'',href:'',biz:JSON.stringify({ptiId:"lego-sales:tab_".concat(tabIndex,"-list:").concat(index),page_id:_this2.pageId,pageId:_this2.pageId,from_sort:index,tabChName:tab.tabName,goods_id:item.goodsId||item.id||'',style_id:item.styleId||''}),exposekey:".za..".concat(_this2.from,".feed_list....").concat(index,"......").concat(tab.tabName,"@").concat(new Date().valueOf()),pti_refer:{pageId:'',root:{id:'',pageId:'',name:'',biz:''},parent:{id:'',pageId:'',name:'',biz:''}}}),ref:function ref(ele){if(ele){_this2.exp.add({el:ele});}},onClick:function onClick(){var options={sort:index,tabChName:tab.tabName};__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.url,item.url,options,-1,_objectSpread(_objectSpread({},_this2.props),options),false,{bizExtra:{model_block:'list'},tabChName:tab.tabName,goods_id:item.goodsId||item.id||'',style_id:item.styleId||''});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.img,_this2.props.webpSupport),effect:"opacity"}));}else{/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{// className={isMain ? `goods-item` : 'goods-item-2' + ' ad'} 
className:"goods-item"+' ad',key:"".concat(index),onClick:function onClick(){var options={sort:index,tabChName:tab.tabName};__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.url,item.url,options,-1,_objectSpread(_objectSpread({},_this2.props),options),false,{bizExtra:{model_block:'list'},tabChName:tab.tabName,goods_id:item.goodsId||item.id||'',style_id:item.styleId||''});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.img,_this2.props.webpSupport),effect:"opacity"}));}}else{if(_this2.canExposure){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{// className={isMain ? `goods-item` : 'goods-item-2'} 
className:"goods-item",key:"".concat(index),"data-dot":JSON.stringify({id:"lego-sales:tab_".concat(tabIndex,"-list:").concat(index),name:'',href:'',biz:JSON.stringify({ptiId:"lego-sales:tab_".concat(tabIndex,"-list:").concat(index),page_id:_this2.pageId,pageId:_this2.pageId,from_sort:index,tabChName:tab.tabName,goods_id:item.goodsId||item.id||'',style_id:item.styleId||''}),exposekey:".zf.goodsDetail.".concat(_this2.from,".favor_recommend..").concat(item.goodsId||item.id||'',".").concat(item.styleId||'',".").concat(index,"...").concat(tab.tabName,"@").concat(new Date().valueOf()),pti_refer:{pageId:'',root:{id:'',pageId:'',name:'',biz:''},parent:{id:'',pageId:'',name:'',biz:''}}}),ref:function ref(ele){if(ele){_this2.exp.add({el:ele});}},onClick:function onClick(){var options={sort:index,tabChName:tab.tabName};__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.url,item.url,options,-1,_objectSpread(_objectSpread({},_this2.props),options),false,{bizExtra:{model_block:'list'},tabChName:tab.tabName,goods_id:item.goodsId||item.id||'',style_id:item.styleId||''});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"goods-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.image,_this2.props.webpSupport),effect:"opacity"}),item.tag2&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"top-tag"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"tag-cont a".concat(['识货补贴','百亿补贴','京东秒杀'].indexOf(item.tag2))},item.tag2))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span",{className:"cur-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span",null,"\xA5"),item.price||'--'),item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.original_price)),item.recommend&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"tag-block"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"tag"},item.recommend)),window.squareType=='分会场'&&item.hits>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"hot"},"\u70ED\u5EA6",item.hits));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{// className={isMain ? `goods-item` : 'goods-item-2'} 
className:"goods-item",key:"".concat(index),onClick:function onClick(){var options={sort:index,tabChName:tab.tabName};__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.url,item.url,options,-1,_objectSpread(_objectSpread({},_this2.props),options),false,{bizExtra:{model_block:'list'},tabChName:tab.tabName,goods_id:item.goodsId||item.id||'',style_id:item.styleId||''});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"goods-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.image,_this2.props.webpSupport),effect:"opacity"}),item.tag2&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"top-tag"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"tag-cont a".concat(['识货补贴','百亿补贴','京东秒杀'].indexOf(item.tag2))},item.tag2))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span",{className:"cur-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span",null,"\xA5"),item.price||'--'),item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.original_price)),item.recommend&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"tag-block"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"tag"},item.recommend)),window.squareType=='分会场'&&item.hits>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"hot"},"\u70ED\u5EA6",item.hits));}}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div",{className:"bottom-status ".concat(tab.isLoading||tab.noMore?'no-more':''),onClick:this.getGoodsList.bind(this,tabIndex,tab.page+1)},tab.isLoading?'加载中..':tab.noMore?'- 没有更多了 -':'加载中..'))));}}]);return PipelineRecommendFeeds;}(__WEBPACK_IMPORTED_MODULE_27_react___default.a.Component);PipelineRecommendFeeds.propTypes={config:__WEBPACK_IMPORTED_MODULE_28_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineRecommendFeeds);

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineLottery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_less__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__turntableGame__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mock__ = __webpack_require__(501);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineLottery=/*#__PURE__*/function(_React$Component){_inherits(PipelineLottery,_React$Component);var _super=_createSuper(PipelineLottery);function PipelineLottery(props){var _this;_classCallCheck(this,PipelineLottery);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getActivityDetail",function(){__WEBPACK_IMPORTED_MODULE_13_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/outside_info?from=not_shihuo&unique_id='+_this.unique_id,method:'get',withCredentials:true}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var prize_list=data.prize_list,draw=data.draw;// const { prize_list, draw } = mock
_this.setState({prize_list:prize_list,draw:draw,lucky_image:draw.button_dynamic||"https://static.shihuocdn.cn/admin/files/20220626/3d7fdc585c7541ecc6bf441921910832.png"},function(){setTimeout(function(){_this.showPrizeList();},500);if(draw.model_id!=4){var initSlotMachine=setInterval(function(){if(window.SlotMachine){clearInterval(initSlotMachine);setTimeout(function(){_this.initGames();},600);}},50);}});}});});_defineProperty(_assertThisInitialized(_this),"initGames",function(){var casino1=document.querySelector('#casino1');var casino2=document.querySelector('#casino2');var casino3=document.querySelector('#casino3');_this.mCasino1=window.SlotMachine&&new window.SlotMachine(casino1,{active:1,delay:500,transition:"ease-in-out",direction:"down",distance:20.5,onComplete:function onComplete(){_this.mCasino2.stop();}});_this.mCasino2=window.SlotMachine&&new window.SlotMachine(casino2,{active:2,delay:500,transition:"ease-in-out",direction:"down",distance:20.5,onComplete:function onComplete(){_this.mCasino3.stop();}});_this.mCasino3=window.SlotMachine&&new window.SlotMachine(casino3,{active:3,delay:500,transition:"ease-in-out",direction:"down",distance:20.5,onComplete:function onComplete(){__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'winning-show'});_this.setState({mask_show:true,success_show:true,click_limit:false});}});_this.setState({page_show:true});});_defineProperty(_assertThisInitialized(_this),"playGames",function(){__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'start'});if(_this.state.click_limit){return;}if(_this.state.lucky_count>0){_this.setState({lucky_image:_this.state.draw.button_static||"https://static.shihuocdn.cn/admin/files/20220626/3d7fdc585c7541ecc6bf441921910832.png",click_limit:true,lucky_count:_this.state.lucky_count-1});}else{// Toast.info("今日次数已用完", 2000);
return;}_this.mCasino1.shuffle(9999,2);_this.mCasino2.shuffle(9999,2);_this.mCasino3.shuffle(9999,2);setTimeout(function(){_this.mCasino1.stop();},2000);});_defineProperty(_assertThisInitialized(_this),"showPrizeList",function(){if(_this.state.showPrize){__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'prize-show'});_this.setState({mask_show:true,prize_show:true,count_down:2,mask_show_prop:true});_this.countDownInterVal=setInterval(function(){if(_this.state.count_down<=0){clearInterval(_this.countDownInterVal);_this.countDownInterVal=null;_this.setState({mask_show:false,prize_show:false,mask_show_prop:false});}_this.setState({count_down:_this.state.count_down-1});},1000);}});_defineProperty(_assertThisInitialized(_this),"handleJump",function(){__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'prize-skip'});if(_this.countDownInterVal){clearInterval(_this.countDownInterVal);_this.countDownInterVal=null;}_this.setState({mask_show:false,prize_show:false,mask_show_prop:false});});_defineProperty(_assertThisInitialized(_this),"handleRule",function(){_this.setState({mask_show:true,rule_show:true});});_defineProperty(_assertThisInitialized(_this),"handleDownLoad",function(){var _this$props=_this.props,_this$props$from=_this$props.from,from=_this$props$from===void 0?"":_this$props$from,_this$props$customAtt=_this$props.customAttributes,customAttributes=_this$props$customAtt===void 0?{}:_this$props$customAtt;var block=customAttributes["data-component-block"];window.sa&&window.sa.track('pcClick',{env:'toufang',version:'1.0.0',extra:from,sort:0,action:"".concat(block),page:window.location.href});__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{blockName:'winning-download'});var link="https://www.shihuo.cn";__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].handleToufangClick({link:link,props:_this.props});});_defineProperty(_assertThisInitialized(_this),"closePopup",function(){_this.setState({mask_show:false,prize_show:false,success_show:false,rule_show:false});});_defineProperty(_assertThisInitialized(_this),"createScript",function(){var head=document.querySelector('head');var script=document.createElement('script');script.type="text/javascript";script.src="https://www.shihuo.cn/js/lib/vFramePlayer.min.js";head.appendChild(script);});_this.state={page_show:false,prize_list:[],draw:{},lucky_count:1,showPrize:_this.props.config.isPrizePopupShow==='是',lucky_image:'',click_limit:false,mask_show:false,prize_show:false,success_show:false,rule_show:false,mask_show_prop:false};_this.unique_id=_this.props.config.uniqueId;// this.unique_id = '2a0e6f9a-680b-4235-8f83-56145cb2'
_this.count=3;_this.delay=4000;_this.countDownInterVal=null;return _this;}_createClass(PipelineLottery,[{key:"componentDidMount",value:function componentDidMount(){this.createScript();this.getActivityDetail();}// 活动详情
},{key:"render",value:function render(){var _this2=this;var _this$state=this.state,page_show=_this$state.page_show,draw=_this$state.draw,prize_list=_this$state.prize_list,count_down=_this$state.count_down,mask_show=_this$state.mask_show,prize_show=_this$state.prize_show,success_show=_this$state.success_show,lucky_count=_this$state.lucky_count,lucky_image=_this$state.lucky_image,rule_show=_this$state.rule_show,mask_show_prop=_this$state.mask_show_prop;if(!draw.model_id){return null;}if(draw.model_id==4){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__turntableGame__["a" /* default */],_extends({props:this.props},this.state,{handleJump:this.handleJump,closePopup:this.closePopup,handleDownLoad:this.handleDownLoad,unique_id:this.unique_id}));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",_extends({className:"pipeline-lottery"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"games-area",style:{backgroundImage:"url(".concat(draw.outside_bgimg||'https://static.shihuocdn.cn/admin/files/20220626/b258b8227f4d251bc496c7963ddfd395.png',")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("ul",{className:"games-content fadeIn"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("li",{id:"casino1",className:page_show?'show':'hide'},prize_list&&prize_list.length>0&&prize_list.map(function(item,index){if(item.prize_pic&&item.prize_pic[0]){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"prize-item-wrap",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:item.prize_pic[0],alt:"",className:"slot slot".concat(index),key:index}));}else{return null;}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("li",{id:"casino2",className:page_show?'show':'hide'},prize_list&&prize_list.length>0&&prize_list.map(function(item,index){if(item.prize_pic&&item.prize_pic[0]){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"prize-item-wrap",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:item.prize_pic[0],alt:"",className:"slot slot".concat(index),key:index}));}else{return null;}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("li",{id:"casino3",className:page_show?'show':'hide'},prize_list&&prize_list.length>0&&prize_list.map(function(item,index){if(item.prize_pic&&item.prize_pic[0]){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"prize-item-wrap",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:item.prize_pic[0],alt:"",className:"slot slot".concat(index),key:index}));}else{return null;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"count-times"},"\u2014 \u4ECA\u65E5\u6709",lucky_count,"\u6B21\u8F6C\u52A8\u673A\u4F1A \u2014"),lucky_image&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:lucky_image,alt:"",className:"lucky-btn",onClick:function onClick(){return _this2.playGames();}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"operation"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"btn left",onClick:function onClick(){return _this2.handleDownLoad();}},"\u4E0B\u8F7D\u5B89\u88C5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"line"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"btn right",onClick:function onClick(){return _this2.handleRule();}},"\u6D3B\u52A8\u89C4\u5219")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:draw.back_pic||"https://static.shihuocdn.cn/admin/files/20220626/2865ff110ac593ceb000c0478a3e2a4a.png",alt:"",className:"games-cover"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"persuade"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:draw.outside_bgimg_2?draw.outside_bgimg_2:'https://static.shihuocdn.cn/admin/files/20220113/56df51be172702ebb2a0e02710c0c97b.jpg',className:"bg-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"shihuo-logo"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20211123/0b9ae6e1f574c47b057e44faa5c38123.png",alt:"",className:"logo"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"\u8FD0\u52A8\u6F6E\u6D41\u597D\u7269"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"\u7CBE\u9009\u6B63\u54C1\u597D\u4EF7")))),mask_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"mask"}),prize_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{style:{backgroundImage:"url(".concat(draw.prize_popup?draw.prize_popup:"https://static.shihuocdn.cn/admin/files/20211119/cfd14a042a08f75681cccb78137305a4.png",")")},className:"prize-list"},prize_list&&prize_list.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:prize_list[1]&&prize_list[1].prize_pic[0],alt:"",className:"img-left"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:prize_list[2]&&prize_list[2].prize_pic[0],alt:"",className:"img-middle"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:prize_list[3]&&prize_list[3].prize_pic[0],alt:"",className:"img-right"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"count-down",onClick:function onClick(){_this2.handleJump();}},"\u8DF3\u8FC7",count_down))),success_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"success-info",style:{backgroundImage:"url(".concat(draw.winprize_popup?draw.winprize_popup:'https://static.shihuocdn.cn/admin/files/20220118/40c40dc29cfbae09a1e64f8909a97611.png',")")}},prize_list&&prize_list.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"prize-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:prize_list[2]&&prize_list[2].prize_pic[0],className:"prize-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"prize-name"},prize_list[2]&&prize_list[2].prize_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",{className:"prize-desc"},draw.outside_desc)),draw.outside_download_img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:draw.outside_download_img,alt:"",className:"download-btn"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"download-area",onClick:function onClick(){return _this2.handleDownLoad();}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:"https://sh1.shihuocdn.cn/images/bargain/close.png",alt:"",className:"close",onClick:function onClick(){return _this2.closePopup();}}))),rule_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"rule-popup"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",{className:"content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"\u53C2\u4E0E\u6E38\u620F\u8D62\u5F97\u6D3B\u52A8\u673A\u4F1A\uFF0C\u7528\u6237\u53EF\u4E0B\u8F7D\u5B89\u88C5\u8BC6\u8D27APP\uFF0C\u53C2\u52A0\u4EE5\u4E0B\u6D3B\u52A8"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"1.\u83B7\u5F97\u79D2\u6740\u673A\u4F1A\u7684\u7528\u6237\uFF0C\u5728\u6D3B\u52A8\u9875\u9762\u70B9\u51FB\u4E0B\u8F7D\u8BC6\u8D27APP\u6253\u5F00\u540E\uFF0C\u4F1A\u81EA\u52A8\u8DF3\u8F6C\u8FDB\u5165\u79D2\u6740\u9875\u9762\u53C2\u4E0E\u79D2\u6740\u3002"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"2.\u4E3A\u4E86\u8BA9\u66F4\u591A\u7528\u6237\u4EAB\u53D7\u5230\u6D3B\u52A8\u798F\u5229\uFF0C\u8BE5\u79D2\u6740\u6D3B\u52A8\u7684\u6240\u6709\u6D3B\u52A8\u5546\u54C1\u6216\u4F18\u60E0\u5238\u6BCF\u4F4D\u7528\u6237\u9650\u62A2\u4E00\u5355\u3002"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"3.\u540C\u4E00\u624B\u673A\u8BBE\u5907\u3001\u624B\u673A\u53F7\u3001\u5FAE\u4FE1\u8D26\u6237\u3001IP\u5730\u5740\u7B49\u4FE1\u606F\u7684\u4EFB\u610F\u4E00\u9879\u6216\u6570\u9879\u76F8\u540C\u6216\u91CD\u53E0\u7684\uFF0C\u5747\u5C06\u88AB\u8BA4\u5B9A\u4E3A\u540C\u4E00\u7528\u6237\u3002 \u540C\u4E00\u7528\u6237\u4EC5\u652F\u6301\u4E00\u4E2A\u8D26\u53F7\u767B\u5F55\u8FDB\u884C\u8BE5\u6D3B\u52A8\u3002\u5982\u7528\u6237\u591A\u62CD\uFF0C\u6D3B\u52A8\u65B9\u6709\u6743\u53D6\u6D88\u8BA2\u5355\u4E14\u65E0\u9700\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002 "),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"4.\u53C2\u4E0E\u6D3B\u52A8\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u679C\u6709\u2F64\u2F3E\u51FA\u73B0\u8FDD\u89C4\u2F8F\u4E3A\uFF08\u5982\u4F5C\u5F0A\u8D2D\u4E70\u3001\u6076\u610F\u5957\u73B0\u3001\u865A\u5047\u4EA4\u6613\u7B49)\uFF0C\u8BC6\u8D27\u6709\u6743\u53D6\u6D88\u8FDD\u89C4\u2F64\u2F3E\u7684\u83B7\u53D6\u8D44\u683C\uFF1B"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p",null,"5.\u6D3B\u52A8\u4E2D\u82E5\u6D89\u53CA\u90AE\u8D39\u53EF\u80FD\u9700\u8981\u53C2\u4E0E\u8005\u2F83\u7406\uFF1B\u6B64\u6D3B\u52A8\u771F\u5B9E\u6709\u6548\uFF0C\u7279\u6B64\u8BF4\u660E\u3002")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{src:"https://sh1.shihuocdn.cn/images/bargain/close.png",alt:"",className:"close",onClick:function onClick(){return _this2.closePopup();}})));}}// 立即下载
}]);return PipelineLottery;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineLottery);

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_search_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_search_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_search_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_date_to_string_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_date_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_date_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_to_string_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_less__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__index_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var _default=/*#__PURE__*/function(_React$Component){_inherits(_default,_React$Component);var _super=_createSuper(_default);function _default(props){var _this;_classCallCheck(this,_default);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getLubnoData",function(){__WEBPACK_IMPORTED_MODULE_17_axios_dist_axios_min_js___default()({url:"//sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi//new_draw/lunbo?unique_id=".concat(_this.props.unique_id),method:"get",withCredentials:true}).then(function(res){var _res$data=res.data,data=_res$data.data,status=_res$data.status;if(status===0){var _res=data.res;_this.setState({winnerList:_res},function(){var swiper=new __WEBPACK_IMPORTED_MODULE_19_swiper_swiper_bundle_min_js___default.a(_this.swiperRef.current,{direction:"vertical",loop:true,autoplay:{delay:1000//1秒切换一次
},noSwiping:true,speed:300});});}});});_defineProperty(_assertThisInitialized(_this),"remainFun",function(){var leaveStatus=0;var tit=document.title;var path="";var search=window.location.search;// 首次进入页面时才加入#leaveStatus；当只是刷新页面时，不再重复加入#leaveStatus
if(search&&!__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getParams('leaveStatus')){path="".concat(search,"&leaveStatus=1");// 将追加了hash的链接推入history中
window.history.pushState({title:tit,path:path},tit,path);}// if (window.location.hash != "#leaveStatus") {
//   path = window.location.href.replace(/#.*$/, "") + "#leaveStatus";
//   // 将追加了hash的链接推入history中
//   window.history.pushState(
//     {
//       title: tit,
//       path: path,
//     },
//     tit,
//     path
//   );
// }
leaveStatus=1;window.addEventListener("popstate",function(ev){if(leaveStatus==1){leaveStatus=0;console.log('11111',"remain_status");_this.setState({retain_show:true,mask_show_end:true,success_show:false});}});// const {remain_status} = this.state
// if(!remain_status) {
//   this.setState({
//     remain_status: true
//   })
// } 
// console.log(remain_status,"remain_status")
// window.addEventListener("popstate", (ev) => {
//   console.log(remain_status,"remain_status")
//   if (remain_status) {
//     this.setState({
//       retain_show: true,
//       mask_show_end: true,
//       success_show: false,
//       remain_status: false
//     });
//   }
// });
});_defineProperty(_assertThisInitialized(_this),"remainFun2",function(){var leaveStatus=0;window.addEventListener("load",function(){var tit=document.title;var path="";//首次进入页面时才加入#leaveStatus；当只是刷新页面时，不再重复加入#leaveStatus
if(window.location.hash!="ban_back"){window.location.hash="ban_back";leaveStatus=1;}});if(!leaveStatus){window.addEventListener("hashchange",function(){_this.setState({retain_show:true,mask_show_end:true});});}});_defineProperty(_assertThisInitialized(_this),"closeAwardPop",function(){_this.setState({success_show:false,mask_show_end:false});});_defineProperty(_assertThisInitialized(_this),"closeRetainPop",function(){_this.setState({retain_show:false,mask_show_end:false});// window.history.go(-1)
});_this.state={num:8,// 九宫格：8   12宫格：12
allAwards:props.prize_list,count:0,// 九宫格的下标
times:60,// 跳到下一个格子需要的时间
timer:null,// 定时器
nowTime:null,awardsId:null,isRolling:false,trophy:null,//奖品
visible:false,//控制弹窗
success_show:false,mask_show_end:false,retain_show:false,beganClick:0,winnerList:[],remain_status:false};_this.swiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_16_react__["createRef"])();_this.handleBegan=_this.handleBegan.bind(_assertThisInitialized(_this));_this.decelerate=_this.decelerate.bind(_assertThisInitialized(_this));return _this;}/***
   * 点击抽奖按钮
   */_createClass(_default,[{key:"handleBegan",value:function handleBegan(){var _this2=this;__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].uploadTrack(this.props.props,{},{blockName:'start'});if(!this.state.isRolling){var _this$setState;// 初始化数据之后才可以开始
this.setState((_this$setState={count:0,times:60,timer:null,nowTime:null,awardsId:null,isRolling:true},_defineProperty(_this$setState,"nowTime",new Date()),_defineProperty(_this$setState,"beganClick",1),_this$setState),function(){_this2.handlePlay();});}}// 开始抽奖
},{key:"handlePlay",value:function handlePlay(){var _this3=this;var timer=setTimeout(function(){var con=_this3.state.count;if(_this3.state.num==8&&con===7){con=0;}else if(_this3.state.num==12&&con===11){con=0;}else{con++;}_this3.setState({count:con});if(new Date()-_this3.state.nowTime>480){_this3.decelerate();}if(_this3.state.isRolling){_this3.handlePlay();}},this.state.times);this.setState({timer:timer});}/***
   * 减速
   */},{key:"decelerate",value:function decelerate(){if(new Date()-this.state.nowTime>=480&&new Date()-this.state.nowTime<1480){this.setState({times:125//控制速度减的快慢
});}else if(new Date()-this.state.nowTime>=1480&&new Date()-this.state.nowTime<3080){this.setState({times:200//控制速度减的快慢
});}else{this.setState({times:300//控制速度减的快慢
});}// 模拟从后端获取到的中奖的数据
this.setState({awardsId:3});// }
// 判断获取的中奖id和当前id相同，则停止。
if(this.state.times==300&&this.state.count==2// this.state.awardsId === this.state.allAwards[this.state.count].id
){clearTimeout(this.state.timer);this.state.isRolling=false;__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].uploadTrack(this.props.props,{},{blockName:'winning-show'});this.setState({success_show:true,mask_show_end:true});}}// 获取轮播数据
},{key:"componentDidMount",value:function componentDidMount(){var draw=this.props.draw;draw.coupons=draw.coupons?draw.coupons:[];if(draw.coupons.length){this.remainFun();}this.getLubnoData();}},{key:"render",value:function render(){var _this4=this;var _this$props=this.props,page_show=_this$props.page_show,draw=_this$props.draw,prize_list=_this$props.prize_list,count_down=_this$props.count_down,mask_show_prop=_this$props.mask_show_prop,prize_show=_this$props.prize_show,lucky_count=_this$props.lucky_count,lucky_image=_this$props.lucky_image,rule_show=_this$props.rule_show,handleJump=_this$props.handleJump,closePopup=_this$props.closePopup,handleDownLoad=_this$props.handleDownLoad;var _this$state=this.state,winnerList=_this$state.winnerList,success_show=_this$state.success_show,mask_show_end=_this$state.mask_show_end,retain_show=_this$state.retain_show,count=_this$state.count,beganClick=_this$state.beganClick;draw.coupons=draw.coupons?draw.coupons:[];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({className:"pipeline-lottery2"},this.props["customAttributes"]),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"games-area",style:{backgroundImage:"url(".concat(draw.outside_bgimg||"https://static.shihuocdn.cn/admin/files/20221110/5f7b0f0fce3f76df803ccbaa4471fc16.png",")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"games-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"swiper",ref:this.swiperRef,style:{backgroundImage:"url(".concat(draw.lantern_pic||"https://static.shihuocdn.cn/admin/files/20221111/487a42158d1e4bf4cd9956480bb05266.png",")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"swiper-wrapper"},winnerList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"swiper-slide swiper-no-swiping",key:"slide-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{style:{backgroundImage:"url(".concat(item.avatar,")")},className:"swiper-avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"swiper-title",style:{color:draw.font_color}},item.title));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"backGameImg",style:{backgroundImage:"url(".concat(draw.back_pic||"https://static.shihuocdn.cn/admin/files/20221113/fefd2e4655d2cf9cc1f68ab48b7cf688.png",")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",{className:"award-container "+(this.state.num===12?"award-container-handle":"")},prize_list.length&&prize_list.map(function(item,index){var shows="shade";// shows += this.state.count === index ? ' show' : ''
shows=count===index&&beganClick?" shade":"";return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{key:item.id+""+index,className:"award-item award-item-left award-item-"+index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"base-img",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221113/a5a79139c02f603e229b37c4affc598a.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:shows,style:{backgroundImage:"url(".concat(draw.select_pic||"https://static.shihuocdn.cn/admin/files/20221121/5e434218fe2ce7f2a0f9fe41fe3422a7.png",")")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"base-goods-img",src:prize_list[index].prize_pic[0]// src="https://static.shihuocdn.cn/admin/files/20221115/ffe553085d1d2cd44f5c931f487925d4.png"
}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"base-goods-name"},prize_list[index].prize_name)));}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{className:["award-item award-item-handle "+(this.state.num===12?"award-item-handle-12":""),"".concat(!beganClick?"award-item-handle-animate":"")].join(" "),style:{backgroundImage:"url(".concat(draw.button_static||"https://static.shihuocdn.cn/admin/files/20221123/53b5e88522033648f154fe5a252422b7.png",")")},onClick:this.handleBegan})),!beganClick&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{onClick:this.handleBegan,className:"teach-touch",style:{backgroundImage:"url(".concat(draw.finger_pic||"https://static.shihuocdn.cn/admin/imgs/20221209/f71dc39e2fdd50382bb99f8bb91ca925_240x240.png",")")}})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"persuade_turntableGame"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:draw.outside_bgimg_2?draw.outside_bgimg_2:"https://static.shihuocdn.cn/admin/files/20221110/5ac88480da4b44701eb9ee91b0f5229d.png",className:"bg-image"})),(mask_show_end||mask_show_prop)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"mask"}),prize_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{style:{backgroundImage:"url(".concat(draw.prize_popup?draw.prize_popup:"https://static.shihuocdn.cn/admin/files/20221114/a99ff3bac45c341979cfdc0081665ef7.png",")")},className:"prize-list"},prize_list&&prize_list.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:prize_list[2]&&prize_list[2].prize_pic[0]// src={
//   "https://static.shihuocdn.cn/admin/files/20221115/44a78a2b729c45810d0a3356054ab417.png"
// }
,alt:"",className:"img-middle"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"rec-goods-message"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"rec-goods-name"},prize_list[2]&&prize_list[2].prize_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"rec-goods-price"},draw.outside_desc)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"count-down",onClick:function onClick(){handleJump();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\u8DF3\u8FC7",count_down)))),prize_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"light",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221201/a6be95474811c79b2fd43eb890bc38d7.png')"}}),success_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:["success-info","".concat(!draw.coupons.length?"success-info2":null)].join(" "),style:{backgroundImage:"url(".concat(draw.winprize_popup?draw.winprize_popup:"https://static.shihuocdn.cn/admin/files/20221207/e0b7b7d9601be79928aaf03ebf741fcc.png",")")}// style={{
//   backgroundImage: `url(https://static.shihuocdn.cn/admin/files/20221121/e037a516850608cc31ffe2445c73338c.png)`,
// }}
},prize_list&&prize_list.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:prize_list[2]&&prize_list[2].prize_pic[0]// src={
//   "https://static.shihuocdn.cn/admin/files/20221115/44a78a2b729c45810d0a3356054ab417.png"
// }
,className:"prize-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"prize-name"},prize_list[2]&&prize_list[2].prize_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"prize-desc"},draw.outside_desc),draw.outside_download_img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{// src={draw.outside_download_img}
src:draw.outside_download_img||"https://static.shihuocdn.cn/admin/files/20221115/5eef5c1f14288557265fdffc3b619e4c.png",alt:"",className:"download-btn",onClick:function onClick(){handleDownLoad();}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons"},draw.coupons.length==1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-background",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221116/96ed3ec223e9e604bfe04ffcd7eccd37.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),draw.coupons[0].price.length<=3?draw.coupons[0].price:draw.coupons[0].price.toString().substring(0,3)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-dec"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].sub_title))),draw.coupons.length==2&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-background-left",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-price-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),draw.coupons[0].price.length<=3?draw.coupons[0].price:draw.coupons[0].price.toString().substring(0,3)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-dec-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].sub_title))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-background-right",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-price-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),draw.coupons[1].price.length<=3?draw.coupons[1].price:draw.coupons[1].price.toString().substring(0,3)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-dec-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[1].title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[1].sub_title))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221226/ceab8c8de1a6373675898799f28e1e0d.png",alt:"",className:"close",onClick:this.closeAwardPop.bind(this)}))),retain_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:["success-info","\"success-info2\" : null}"].join(" "),style:{backgroundImage:"url(".concat(draw.retain_pic?draw.retain_pic:"https://static.shihuocdn.cn/admin/files/20221124/60290b84d47e37e4470b45b2d2e21ef5.png",")")}// style={{
//   backgroundImage: `url(https://static.shihuocdn.cn/admin/files/20221121/e037a516850608cc31ffe2445c73338c.png)`,
// }}
},prize_list&&prize_list.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:prize_list[2]&&prize_list[2].prize_pic[0]// src={
//   "https://static.shihuocdn.cn/admin/files/20221115/44a78a2b729c45810d0a3356054ab417.png"
// }
,className:"prize-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"prize-name"},prize_list[2]&&prize_list[2].prize_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"prize-desc"},draw.outside_desc),draw.outside_download_img&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{// src={draw.outside_download_img}
src:draw.outside_download_img||"https://static.shihuocdn.cn/admin/files/20221115/5eef5c1f14288557265fdffc3b619e4c.png",alt:"",className:"download-btn",onClick:function onClick(){handleDownLoad();_this4.setState({retain_show:false,mask_show_end:false});}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons"},draw.coupons.length==1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-background",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221116/96ed3ec223e9e604bfe04ffcd7eccd37.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),draw.coupons[0].price.length<=3?draw.coupons[0].price:draw.coupons[0].price.toString().substring(0,3)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-dec"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].sub_title))),draw.coupons.length==2&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-background-left",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-price-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),draw.coupons[0].price.length<=3?draw.coupons[0].price:draw.coupons[0].price.toString().substring(0,3)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-dec-left"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[0].sub_title))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-background-right",style:{backgroundImage:"url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-price-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"\xA5"),draw.coupons[1].price.length<=3?draw.coupons[1].price:draw.coupons[1].price.toString().substring(0,3)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-coupons-dec-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[1].title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,draw.coupons[1].sub_title))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221115/8bcb9ed30a362b966228ddbfbffe270e.png",alt:"",className:"close",onClick:this.closeRetainPop.bind(this)}))));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var data={"prize_list":[{"prize_name":"Nike dunk White/Black 低帮","prize_desc":"","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/7ecbd751107560cda447f5731c2e232a_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/7ecbd751107560cda447f5731c2e232a_240x240.png"},{"prize_name":"尔木萄散粉原价￥98","prize_desc":"","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/888344b005d1193d36c5d67b21dd783a_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/888344b005d1193d36c5d67b21dd783a_240x240.png"},{"prize_name":"mistine防晒霜 原价￥136","prize_desc":"","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/11154051a3be50141d58e3c2cfcc9657_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/11154051a3be50141d58e3c2cfcc9657_240x240.png"},{"prize_name":"11","prize_desc":"1","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/0bb838a908ad32a9eb4b219508930fd1_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20220317/6d5b25f3eb5a2a42260117ad39886b23_262x316.png"},{"prize_name":"test-0001","prize_desc":"测试的","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/8365cbedd2597c6265f8d9b7ec0c8182_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20220317/6b742aadc73c7e0a4bf99d74a0880eef_1125x2172.png"},{"prize_name":"3333","prize_desc":"33333","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/bd9189b567cea8cbab8a99f3b0d83878_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/bd9189b567cea8cbab8a99f3b0d83878_240x240.png"},{"prize_name":"1312","prize_desc":"13221","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/53eb780b92bcd39b04e86d30edf2267b_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/53eb780b92bcd39b04e86d30edf2267b_240x240.png"},{"prize_name":"错误tlj","prize_desc":"12312","prize_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/e6d4eaac42a0f6f82ccb90c25093510e_240x240.png"],"award_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/e6d4eaac42a0f6f82ccb90c25093510e_240x240.png"}],"draw":{"id":13,"draw_name":"test_jiugg","draw_pic":["https://static.shihuocdn.cn/admin/imgs/20221123/6294113815f46c8c8106de6bb2c184be_880x880.jpeg"],"draw_desc":"测试","model_id":4,"default_usage":0,"cfg":null,"show_type":1,"outside_bgimg":"https://static.shihuocdn.cn/admin/files/20221123/88eaef19be7977e71c260f99b2a11b8c.png","outside_desc":"¥8888","outside_download_img":"https://static.shihuocdn.cn/admin/imgs/20221123/6afc8a4e4fa8e81d475952fa3961bda7_660x150.png","created_at":"2022-11-14T14:55:44+08:00","updated_at":"2022-11-23T17:26:42+08:00","prize_popup":"https://static.shihuocdn.cn/admin/imgs/20221123/3f581a29e7d80700ed461e8784d89d91_1125x1218.png","button_static":"https://static.shihuocdn.cn/admin/files/20221113/8cf320867a60ad1a85fd947d034b39ed.png","button_dynamic":"https://static.shihuocdn.cn/admin/files/20211125/bb1ff12b9ed449f8c75f70a001fd28cf.png","back_pic":"https://static.shihuocdn.cn/admin/files/20221113/fefd2e4655d2cf9cc1f68ab48b7cf688.png",// "winprize_popup": "https://static.shihuocdn.cn/admin/files/20221123/22bf2be9e9bcb272c2ff5a4df9ec9e5d.png",
"winprize_popup":"https://static.shihuocdn.cn/admin/files/20221123/791290c0ba69c272dc8b69abea9be596.png","outside_bgimg_2":"https://static.shihuocdn.cn/admin/files/20221123/6bb34b1534ee7104983f6056d3a182d7.png","lantern_pic":"https://static.shihuocdn.cn/admin/files/20221123/f5a21e4d977b0e7d87930902f72453c4.png","finger_pic":"https://static.shihuocdn.cn/admin/files/20221123/cdd74d8bc8f75b6aa7b729a6f4ccdcae.png","select_pic":"https://static.shihuocdn.cn/admin/files/20221123/dd8976de204a4ef60b60765e8b06b39d.png","coupons":[{"price":360,"title":"识货补贴","sub_title":"仅限新用户"},{"price":360,"title":"品牌专享劵","sub_title":"无门槛"}],"retain_pic":""},"show":1};/* unused harmony default export */ var _unused_webpack_default_export = (data);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCommunityShaiwu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_less__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineCommunityShaiwu=/*#__PURE__*/function(_React$Component){_inherits(PipelineCommunityShaiwu,_React$Component);var _super=_createSuper(PipelineCommunityShaiwu);function PipelineCommunityShaiwu(props){var _this;_classCallCheck(this,PipelineCommunityShaiwu);_this=_super.call(this,props);_this.state={moduleDescText:'',gearsList:null};return _this;}_createClass(PipelineCommunityShaiwu,[{key:"componentDidMount",value:function componentDidMount(){this.getNoteList();}// 获取用户模板笔记列表
},{key:"getNoteList",value:function getNoteList(){var _this2=this;var caskTemplateId=this.props.config.templateConfig.caskTemplateId;__WEBPACK_IMPORTED_MODULE_14_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-gocommunity/x/v1/cash/note_list',method:"get",withCredentials:true,params:{id:caskTemplateId}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var desc=data.desc,list=data.list;_this2.setState({moduleDescText:desc,gearsList:list});}});}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:this.props,index:index});return;}var options={sort:index};__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.href,item.href,options,item.id,this.props);}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,templateConfig=_this$props$config.templateConfig;var _this$state=this.state,moduleDescText=_this$state.moduleDescText,gearsList=_this$state.gearsList;if(!gearsList){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({className:gearsList.length<=0?'pipeline-communityShaiwu no-data':'pipeline-communityShaiwu'},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("h3",{className:"comps-title",style:{color:templateConfig.moduleDescTextColor}},moduleDescText),gearsList&&gearsList.length>0&&gearsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"note-list",key:"item_".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("h3",{className:"gears-title",style:{color:templateConfig.gearsTextColor}},item.desc),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("ul",{className:"gears-ul"},item.list&&item.list.length>0&&item.list.map(function(value,key){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("li",{key:"shawu_".concat(key),className:"item-shaiwu",onClick:_this3.handleItemClick.bind(_this3,value,key)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:value.img,alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"name"},value.desc));})));}),gearsList.length<=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"no-notes"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20220330/37e491913ed9de52e67dd0e07169b4e3.png",alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{className:"tips"},"\u6682\u65E0\u521D\u5BA1\u901A\u8FC7\u7684\u7B14\u8BB0")));}}]);return PipelineCommunityShaiwu;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineCommunityShaiwu);

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_ends_with_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_ends_with_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_ends_with_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_fixedHeightComps__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__style_less__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _createForOfIteratorHelper(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return{s:F,n:function n(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};},e:function e(_e2){throw _e2;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return{s:function s(){it=it.call(o);},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e3){didErr=true;err=_e3;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var screenHeight=typeof window!=="undefined"&&window.innerHeight;var PipelineTab=/*#__PURE__*/function(_React$Component){_inherits(PipelineTab,_React$Component);var _super=_createSuper(PipelineTab);function PipelineTab(props){var _this;_classCallCheck(this,PipelineTab);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"modifyPageBackgroundColor",function(){var grains=_this.props.config.containerConfig.grains;if(grains&&grains.length>0){var tabContainerBgColor=grains[_this.state.selected].tabTitle.tabContainerBgColor;if(tabContainerBgColor){document.querySelector('html').style.backgroundColor=tabContainerBgColor;document.querySelector('body').style.backgroundColor=tabContainerBgColor;}}});_defineProperty(_assertThisInitialized(_this),"handleTabSelect",function(event,item,index){event.preventDefault();if(index===_this.state.selected){return;}var _this$state$selectRec=_this.state.selectRecord,selectRecord=_this$state$selectRec===void 0?[0]:_this$state$selectRec;var hasRecord=selectRecord.findIndex(function(item){return item===index;});var navigationBarHeight=_this.props.navigationBarHeight;var tabFixed=_this.state.tabFixed;var newProps=JSON.parse(JSON.stringify(_this.props));var tabBarOffsetTop=0;if(tabFixed){tabBarOffsetTop=_this.tabItemPlaceholderRef&&_this.tabItemPlaceholderRef.offsetTop;}else{tabBarOffsetTop=_this.tabItemRef&&_this.tabItemRef.offsetTop;}Object.assign(newProps,{tabChName:item.tabTitle.tabName});__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].uploadTrack(newProps,{sort:index});if(hasRecord<0){selectRecord.push(index);}_this.setState({selected:index,selectRecord:selectRecord,tabChName:item.tabTitle.tabName,reRender:true},function(){tabFixed&&tabBarOffsetTop>0&&window.scrollTo(0,tabBarOffsetTop-navigationBarHeight+1);_this.updateNavPostion();});});_defineProperty(_assertThisInitialized(_this),"onScroll",function(){var navigationBarHeight=_this.props.navigationBarHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navOffsetTop=_this.pipelineTabRef?_this.pipelineTabRef.offsetTop-navigationBarHeight:0;var tabItem=_this.tabItemRef;var tabItemContent=_this.tabItemContentRef;var tabItemClientHeight=tabItem?tabItem.clientHeight:0;var bottomOffsetTop=tabItemContent?tabItemContent.offsetTop+tabItemContent.clientHeight:0;if(scrollHeight-navOffsetTop>0&&scrollHeight<bottomOffsetTop-navigationBarHeight-tabItemClientHeight){!_this.state.tabFixed&&_this.setState({tabFixed:true,reRender:true});}else{_this.state.tabFixed&&_this.setState({tabFixed:false,reRender:true});}// this.setNavigationBarHeight();
});_defineProperty(_assertThisInitialized(_this),"setNavigationBarHeight",function(){if(_this.initSet){return;}var allComponents=_this.props.allComponents||[];var componentId=_this.props['customAttributes']?_this.props['customAttributes']['data-component-id']:'';var componentIdx=allComponents.findIndex(function(item){return item&&item.id===componentId;});var pipelineNavigationIdx=allComponents.findIndex(function(item){return item&&item.name==='pipeline-navigation';});var setHeight=function setHeight(){var navigationBar=document.querySelector('.navigation-bar-wrapper');if(navigationBar&&_this.tabItemRef){window.navigationBarHeight=navigationBar.clientHeight+_this.tabItemRef.clientHeight-1.5;_this.initSet=true;}};if(pipelineNavigationIdx>=0){if(componentIdx<pipelineNavigationIdx){setHeight();}else{_this.initSet=true;}}else{setHeight();}});_defineProperty(_assertThisInitialized(_this),"updateNavPostion",function(){// 导航条切换选中后，调整当前导航到居中位置
var navigationBar=document.querySelector('.tab-scroll');var checkedNavItem=document.querySelector(".tab-item-nav-active");// 当前选中的导航item
var navWidth=navigationBar.offsetWidth;// 导航栏宽度
var checkedItemOffsetLeft=checkedNavItem.offsetLeft;// 元素距离左边距离
var checkedItemWidth=checkedNavItem.offsetWidth;// 需要滚动的距离
var shouldUpdateScroll=checkedItemOffsetLeft-(navWidth/2-checkedItemWidth/2)-16;if(navigationBar.scrollWidth>navWidth){// 如果导航条可以滚动，执行滚动操作
navigationBar.scroll({top:0,left:shouldUpdateScroll,behavior:'smooth'});// 顶部固定导航条也执行滚动操作
document.querySelector('.tab-scroll').scroll({top:0,left:shouldUpdateScroll,behavior:'smooth'});}});_this.state={tabItemComponent:[],selected:0,tabFixed:false,tabChName:'',selectRecord:[0],// 记录被点击过的Tab索引，未被记录的，对应Tab下的内容不加载
reRender:false,isAndroid:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].isAndroid()};_this.isIframe=__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].getParams('isIframe')==1;_this.pipelineTabRef=null;_this.tabItemRef=null;_this.tabItemContentRef=null;_this.tabItemPlaceholderRef=null;_this.initSet=false;// 滚动事件监听
if(typeof window!=='undefined'){window.addEventListener('scroll',function(e){_this.onScroll();});}return _this;}_createClass(PipelineTab,[{key:"componentDidMount",value:function componentDidMount(){var useTabContainerBgColor=this.props.config.baseConfig.useTabContainerBgColor;useTabContainerBgColor&&this.modifyPageBackgroundColor();if(typeof window!=='undefined'&&window.parent&&this.isIframe){// 在iframe中打开，获取组件尺寸并发送后台编辑器
__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].postComponentSizeToEditor();}}// 修改页面背景色
},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,_this$props$osVersion=_this$props.osVersion,osVersion=_this$props$osVersion===void 0?'':_this$props$osVersion,_this$props$legoAb=_this$props.legoAb,legoAb=_this$props$legoAb===void 0?'':_this$props$legoAb;var _this$state=this.state,isAndroid=_this$state.isAndroid,selected=_this$state.selected,tabFixed=_this$state.tabFixed,_this$state$selectRec2=_this$state.selectRecord,selectRecord=_this$state$selectRec2===void 0?[0]:_this$state$selectRec2,reRender=_this$state.reRender;var _this$props$config$ba=this.props.config.baseConfig,moduleMarginTop=_this$props$config$ba.moduleMarginTop,tabType=_this$props$config$ba.tabType,fontColor=_this$props$config$ba.fontColor;var grains=this.props.config.containerConfig.grains;if(!grains||grains.length<=0){return null;}var navList=[];var pipelineTabItem=this.props.allComponents.filter(function(item){return item.name==='pipeline-tabItem';});var pipelineFilterTabItem=this.props.allComponents.filter(function(item){return item.name!=='pipeline-tabItem';});var findIndexPipelineTab=pipelineFilterTabItem.findIndex(function(item){return item.name==='pipeline-tab';});var tabBarHeight=0;var tabItemComponent=[];if(this.tabItemRef){tabBarHeight=this.tabItemRef.clientHeight;}var _iterator=_createForOfIteratorHelper(pipelineTabItem.entries()),_step;try{var _loop=function _loop(){var _step$value=_slicedToArray(_step.value,2),tabIndex=_step$value[0],tabItem=_step$value[1];tabItem.data.forEach(function(item,index){if(item.name=='pipeline-ab'){// if (!legoAb || typeof window == 'undefined') {
//   // 将组件名置空，不进行渲染
//   item.name = ''
//   return
// }
var list=item.data||[];list.forEach(function(comp){if(comp.id.endsWith("TEST_".concat(legoAb))){tabItem.data[index]=comp;item=comp;}});}});var Components=tabItem.data.map(function(oneComponent,index){if(['pipeline-product','pipeline-goodsRecommend','pipeline-rank','pipeline-imgHotMap','pipeline-community','pipeline-communityArticle','pipeline-pkRank','pipeline-product-customize','pipeline-productCollection','pipeline-productGather','pipeline-productLayout3','pipeline-hotSellRankList'].includes(oneComponent.name)&&oneComponent.data&&oneComponent.data.baseConfig&&oneComponent.data.baseConfig.addToNav&&oneComponent.data.baseConfig.title&&navList.indexOf(oneComponent.data.baseConfig.title)===-1){navList.push({id:oneComponent.id,title:oneComponent.data.baseConfig.title});}if(oneComponent.name==='pipeline-imgList'&&oneComponent.data&&oneComponent.data.baseConfig&&oneComponent.data.baseConfig.addToNav&&oneComponent.data.baseConfig.title){navList.push({id:oneComponent.id,title:oneComponent.data.baseConfig.title});}// 给Tab子组件添加blockName
if(oneComponent.name&&oneComponent.id&&!oneComponent.blockName){oneComponent.blockName=oneComponent.id;var json=null;try{json=__webpack_require__(247)("./".concat(oneComponent.name,"/package.json"));}catch(e){console.log('not found');}if(json&&json.pipeline){oneComponent.blockName+="-".concat(json.pipeline.title);if(oneComponent.data&&oneComponent.data.baseConfig&&oneComponent.data.baseConfig.title){oneComponent.blockName+="_".concat(oneComponent.data.baseConfig.title);}}}var otherProps={isLastComponent:index===tabItem.data.length-1,osVersion:_this2.props.osVersion,showCompMarginBottom:_this2.props.showCompMarginBottom};// 渲染Tab子组件
var OneComponent=_this2.props.baseAllComponents[oneComponent.name];var componentSize=oneComponent.data.componentSize;var containerStyle={};// if (componentSize && componentSize.height !== "" && FixedHeightComps.indexOf(oneComponent.name) >= 0 && !this.isIframe) {
//   Object.assign(containerStyle, {
//     minHeight: oneComponent.name != 'pipeline-navigation' ? px2rem(`${componentSize.height}px`) : px2rem('40px')
//   })
// }
return OneComponent&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"component-wrapper",style:_objectSpread({},containerStyle),key:"OneComponent-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(OneComponent,_extends({componentIndex:index,componentLength:tabItem.data.length,key:oneComponent.id,from:_this2.props.from,downloadUrl:_this2.props.downloadUrl,kouling:_this2.props.kouling,navList:navList,hasNavigation:_this2.props.hasNavigation,customAttributes:{"data-component-id":oneComponent.id,"data-component-name":oneComponent.name,"data-component-block":oneComponent.blockName,"data-component-belong":"tab"},config:oneComponent.data,dataSourceStr:_this2.props.dataSourceStr,navigationBarHeight:_this2.props.navigationBarHeight+tabBarHeight-0.5,navigationBarPaddingTop:_this2.props.navigationBarPaddingTop,routeParams:_this2.props.routeParams,webpSupport:_this2.props.webpSupport,backgroundColor:_this2.props.backgroundColor,templateName:_this2.props.templateName,allModals:_this2.props.allModals,templatePti:_this2.props.templatePti,tabChName:_this2.state.tabChName||grains[tabIndex].tabTitle.tabName,legoAb:_this2.props.legoAb,tabIndex:tabIndex,tabActive:selected,tabFixed:tabFixed,componentSize:componentSize,tabContainerBgColor:grains[selected].tabTitle.tabContainerBgColor,reRender:reRender,lotteryState:_this2.props.lotteryState,communityVoteState:_this2.props.communityVoteState,updateLotteryState:_this2.props.updateLotteryState,updateCommunityVoteState:_this2.props.updateCommunityVoteState},otherProps,{exp:function exp(ele){if(ele){_this2.props.exp&&_this2.props.exp(ele);}}})));});tabItemComponent.push(Components);};for(_iterator.s();!(_step=_iterator.n()).done;){_loop();}}catch(err){_iterator.e(err);}finally{_iterator.f();}var tabItemClass="tab-item",tabScroller=false,adaptive=false;if(!isAndroid&&(osVersion=='15.1'||osVersion=='15.2')){adaptive=true;}tabItemClass+=tabType==="文字Tab"?' type-text':' type-img';adaptive&&(tabItemClass+=tabFixed?' fixed':'');if(tabType==="文字Tab"){if(grains.length>=4){tabItemClass+=' scroller';tabScroller=true;}}else{if(grains.length>4){tabItemClass+=' scroller';tabScroller=true;}}// 计算tabItem区域的最小高度
var contentHeight=screenHeight;var pipelineTab=document.querySelector('.pipeline-tab');var tabScroll=document.querySelector('.tab-scroll');var navigationBarWrapper=document.querySelector('.navigation-bar-wrapper');if(navigationBarWrapper){contentHeight=contentHeight-navigationBarWrapper.clientHeight;}if(pipelineTab&&tabScroll){contentHeight=contentHeight-pipelineTab.offsetTop-tabScroll.clientHeight;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",_extends({ref:function ref(_ref5){return _this2.pipelineTabRef=_ref5;},className:"pipeline-tab ".concat(tabType==='文字Tab'?'text-type':'img-type')},this.props['customAttributes'],{style:{marginTop:"".concat(moduleMarginTop,"px")}}),adaptive?tabFixed&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{ref:function ref(_ref){return _this2.tabItemPlaceholderRef=_ref;},className:"placeholder tab-item-placeholder",style:{height:tabBarHeight}}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{ref:function ref(_ref2){return _this2.tabItemPlaceholderRef=_ref2;},className:"placeholder tab-item-placeholder"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{ref:function ref(_ref3){return _this2.tabItemRef=_ref3;},className:"".concat(tabItemClass," tab-nav"),style:{top:this.props.navigationBarHeight,backgroundColor:this.props.backgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("ul",{className:tabScroller?'tab-scroll custom-padding':'tab-scroll'},grains.map(function(item,index){var tabNavClass="";tabNavClass=selected==index?'tab-item-nav tab-item-nav-active active':'tab-item-nav';tabNavClass+=tabScroller?' customWidth':' autoWidth';console.log('item',item);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this2.props.exp&&_this2.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].getExposureData(_this2.props,{sort:index})),className:tabNavClass,key:"tab-item-nav-".concat(index),onClick:function onClick(event){return _this2.handleTabSelect(event,item,index);}},tabType!=='文字Tab'?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:selected==index?item.tabTitle.selectedImg:item.tabTitle.unselectedImg}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{style:{color:selected==index?fontColor:fontColor,opacity:selected==index?1:.7}},item.tabTitle.tabName),selected===index&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"underline",style:{backgroundColor:fontColor}}));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{ref:function ref(_ref4){return _this2.tabItemContentRef=_ref4;},className:"tab-item-content tab-content",style:{backgroundColor:grains[selected].tabTitle.tabContainerBgColor,minHeight:findIndexPipelineTab===pipelineFilterTabItem.length-1?contentHeight:'auto'}},tabItemComponent.map(function(item,index){var hasRecord=selectRecord.findIndex(function(item){return item===index;});if(hasRecord>=0){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{"data-component-id":pipelineTabItem[index]&&pipelineTabItem[index]['id'],"data-component-name":pipelineTabItem[index]&&pipelineTabItem[index]['name'],key:"tab-container-".concat(index),className:selected==index?"tab-container ".concat(_this2.isIframe?'iframe':'app'," show"):"tab-container ".concat(_this2.isIframe?'iframe':'app'," hide")},item);}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{"data-component-id":pipelineTabItem[index]&&pipelineTabItem[index]['id'],"data-component-name":pipelineTabItem[index]&&pipelineTabItem[index]['name'],key:"tab-container-".concat(index),className:selected==index?"tab-container ".concat(_this2.isIframe?'iframe':'app'," show"):"tab-container ".concat(_this2.isIframe?'iframe':'app'," hide")},_this2.isIframe?item:null);}})));}}]);return PipelineTab;}(__WEBPACK_IMPORTED_MODULE_26_react___default.a.Component);PipelineTab.propTypes={config:__WEBPACK_IMPORTED_MODULE_27_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineTab);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 需要固定高度的组件
var FixedHeightComps=['pipeline-brand','pipeline-cashBack','pipeline-cashBackAct','pipeline-community','pipeline-communityArticle','pipeline-goodsHorizontal','pipeline-hotspots','pipeline-image','pipeline-imgHotMap','pipeline-imgList','pipeline-imgAnimate','pipeline-product','pipeline-productLayout3','pipeline-imgListScroll','pipeline-imgs','pipeline-imgSwiper','pipeline-navigation','pipeline-pkRank','pipeline-productSwiper','pipeline-rank','pipeline-rankList','pipeline-springFestivalFloor','pipeline-square','pipeline-subsidy','pipeline-subsidyList','pipeline-vote'];/* unused harmony default export */ var _unused_webpack_default_export = (FixedHeightComps);

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-brand","title":"品牌馆组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-btnRadioText","title":"单选按钮组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-button","title":"按钮组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-cashBack","title":"返现券组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-cashBackAct","title":"返现券活动组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-cashBackActNew","title":"新返现券活动组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-checkAppDetail","title":"渠道检查专用商品详情页组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-checkAppProduct","title":"渠道检查专用商品组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-community","title":"讨论区组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-communityActImage","title":"社区活动图文组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-communityActText","title":"社区活动文本组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-communityArticle","title":"社区笔记组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-communityArticleScroll","title":"笔记横滑组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-communityCustom","title":"社区自定义组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-communityShaiwu","title":"社区晒物组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-communityVote","title":"社区投票组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-completion","title":"文本填空","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-cutPriceGoodsList","title":"实时降价尖货组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-date-range","title":"阶段组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-depreciateTop","title":"降价榜Top组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-double11Floor","title":"双十一楼层组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-floor","title":"楼层组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-floorBarTitle","title":"楼层条标题组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-free-subsidy","title":"免息补贴组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-games","title":"游戏互动组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-goodsHorizontal","title":"横向滚动商品组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-goodsInfoPreview","title":"商品信息预览组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-goodsRecommend","title":"推荐信息流组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-headlines","title":"话题组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-hintStatement","title":"提示声明","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-hotSellRankList","title":"热销排行榜组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-hotspots","title":"商品热区组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-image","title":"下载按钮组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-imageText","title":"图文编辑组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-imgAnimate","title":"动图组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-imgHotMap","title":"热区组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-imgList","title":"图片组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-imgListScroll","title":"图片滑动组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-imgSwiper","title":"图片轮播组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-imgs","title":"图片列表组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-inteligenceDetail","title":"详细配置","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-inteligenceOverview","title":"概览配置","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-intelligent","title":"达人组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-interactMessage","title":"留言组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-inventoryHorizontal","title":"清单横滑聚合组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-lottery","title":"抽奖组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-matrixScaleQuestion","title":"矩阵量表题","type":"qs-mark","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-menuBar","title":"菜单栏组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-modal","title":"弹窗组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-multipleChoiceQuestion","title":"多选题","type":"qs-choice","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-navBar","title":"导航组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-navigation","title":"锚点TAB","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-npsQuestion","title":"NPS评分题","type":"qs-mark","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-paging","title":"分页按钮","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-paragraph","title":"段落说明","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-pkRank","title":"pk榜组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-priceTrend","title":"价格趋势组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-product","title":"商品组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-productCollection","title":"商品集合卡组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-productCustomize","title":"自定义商品组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-productGather","title":"商品集合组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-productLayout3","title":"商品组件一行三","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-productList","title":"商品列表组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-productSwiper","title":"商品轮播组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-rank","title":"排行榜组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-rankCollection","title":"排行榜集合组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-rankList","title":"排行榜列表组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-recommend-feeds","title":"信息流组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-recommend","title":"推荐组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-recommendTopGoods","title":"推荐榜单商品组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-regionalSelect","title":"省市区选择","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-scaleQuestion","title":"量表题","type":"qs-mark","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-lottery","title":"抽奖组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-searchCard","title":"图片横滑组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-searchProduct","title":"商品横滑组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-searchSlogan","title":"搜索专区组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-searchSwiper","title":"搜索轮播组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-sence-floor","title":"情人节类型楼层","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-sence-swiper","title":"情人节类目楼层","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-sence-tab","title":"场景Tab组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-sequenceQuestion","title":"排序题","type":"qs-choice","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-sideBar","title":"侧边栏组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-singleChoiceQuestion","title":"单选题","type":"qs-choice","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-spikeProduct","title":"秒杀商品组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-springFestivalFloor","title":"年货节楼层组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-square","title":"品牌清单组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-subsidy","title":"补贴组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-subsidyList","title":"补贴列表组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-suctionBottomBtns","title":"吸底按钮组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-tab","title":"页面切换TAB","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-telephone","title":"手机号","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-textarea","title":"富文本组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"pipeline":{"name":"pipeline-timedLottery","title":"定时开奖组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-uploadImages","title":"图片上传","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-video","title":"视频组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-vote","title":"投票组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineRankCollection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */// import { uploadExposure } from '../../utils/exposureRequest';
// import ExposureView from '../../baseComponents/ExposureView'
var topIndexImgs=['https://static.shihuocdn.cn/admin/files/20210805/bd00c7aa7856085cd5ac906372598e45.png','https://static.shihuocdn.cn/admin/files/20210805/1837a593c1bf571b0b6553390f22fb1c.png','https://static.shihuocdn.cn/admin/files/20210805/748329a8aedc56e45f6d723832188a5b.png'];var cateMap={'鞋类':{bg:'https://static.shihuocdn.cn/admin/files/20211216/351bf146eb012937e400543ed9bd3efc.png',color:'#2b52a2',cateIds:['9','12','14','16','43','51','63','70','491','538','540']},'服装配饰':{bg:'https://static.shihuocdn.cn/admin/files/20210806/cb3b60c26eeeb42d3cddf81159f7f75a.png',color:'#a04cd9',cateIds:['11','20','21','45','33','84','155','348','454','455','456','457']},'综合':{bg:'https://static.shihuocdn.cn/admin/files/20210806/db3d382c1eb744ad70bec05bec8fafe9.png',color:'#6634C3',cateIds:['62','177','532','541','120','122','518','530','459','461','772','499','572','671','673','674','676','688','762']},'数码':{bg:'https://static.shihuocdn.cn/admin/files/20210806/e3170460c6cfae4a8558d1b00ccbcf63.png',color:'#2570b5',cateIds:['187','197','198','199','202','203','215','216','219','317','229','230','484','485','488','507','470','471','472','473','474','476','478','664','486','492','494','500','501','503','504','505','656','665','708','317']},'美妆':{bg:'https://static.shihuocdn.cn/admin/files/20210806/7a7dfba90c82adfa87602b0b43cdde7d.png',color:'#cb406b',cateIds:['262','264','266','268','269','294','303','335','366','367','406','340','342','346','347','360','361','362','365','368']},'手表':{bg:'https://static.shihuocdn.cn/admin/files/20211216/f983d97d2889db2912f37a10f53b0623.png',color:'#078da5',cateIds:['61']},'箱包':{bg:'https://static.shihuocdn.cn/admin/files/20211216/f94a3a6a7c41a875062285649e07e875.png',color:'#d75b51',cateIds:['57','150','352','412','148']}};var uselessRankIds=[6372,5998,5971,5973,5975,6012,6015,6380,6256,6260,6264,6272,6273,6274,6280,6283,6285,6288,6290,6297,6302,6305,6311,6316,6318,6321,6329,6339,6341,6343,6345,5958,5961,6095];var PipelineRankCollection=/*#__PURE__*/function(_React$Component){_inherits(PipelineRankCollection,_React$Component);var _super=_createSuper(PipelineRankCollection);function PipelineRankCollection(props){var _this;_classCallCheck(this,PipelineRankCollection);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getRankInfo",function(navIndex,rangeIndex){var list=_this.state.list;var _ref=list[navIndex]||{},priceRanges=_ref.priceRanges;if(!priceRanges)return;var range=priceRanges[rangeIndex]||{};var ranks=range.ranks;var useabelList=[];var uselessList=[];ranks.forEach(function(item){if(uselessRankIds.includes(+item.rank_id)){uselessList.push(item);}else{useabelList.push(item);}});var arr=[];for(var i=0;i<21;i++){var random=Math.random();if(random<0.3&&uselessList.length>0){var randomIndex=Math.floor(Math.random()*uselessList.length);var item=uselessList.splice(randomIndex,1)[0];arr.push({cate_id:+item.cate_id,rank_id:+item.rank_id,rank_subTitle:item.subTitle,rank_background:item.backgroundImage});}else if(useabelList.length>0){var _randomIndex=Math.floor(Math.random()*useabelList.length);var _item=useabelList.splice(_randomIndex,1)[0];arr.push({cate_id:+_item.cate_id,rank_id:+_item.rank_id,rank_subTitle:_item.subTitle,rank_background:_item.backgroundImage});}}__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default()({baseURL: false?'':'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/rankInfoByIds?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{ranks:arr}}).then(function(res){res=res.data;if(res.status==0){range.rankList=res.data.list||[];range.rankList.forEach(function(rank,rankIndex){rank.rankIndex=rankIndex;var rank_subTitle=(arr.find(function(item){return item.rank_id==rank.id;})||{}).rank_subTitle;var rank_background=(arr.find(function(item){return item.rank_id==rank.id;})||{}).rank_background;var cate_id=(arr.find(function(item){return item.rank_id==rank.id;})||{}).cate_id;rank.rank_subTitle=rank_subTitle;rank.rank_background=rank_background;if(cate_id){for(var key in cateMap){var _item2=cateMap[key];if(_item2.cateIds.includes(cate_id+'')){rank.bg=_item2.bg;rank.color=_item2.color;break;}}if(!rank.bg){rank.bg='https://static.shihuocdn.cn/admin/files/20211216/351bf146eb012937e400543ed9bd3efc.png';rank.color='#6634C3';}}});range.curGroup=range.rankList.slice(0,3);range.expandLength=3;_this.setState({list:list},function(){setTimeout(function(){range.rankList.forEach(function(rank,rankIndex){_this.handleXScroll(navIndex,rankIndex,true);});},1000);});}});});_defineProperty(_assertThisInitialized(_this),"handleBodyScroll",function(){var tabBar=window.document.querySelector('.present-nav-container');var tabBarHeight=tabBar.clientHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navOffsetTop=tabBar.offsetTop-_this.props.navigationBarHeight;var navFixed=scrollHeight-navOffsetTop>=0&&scrollHeight-navOffsetTop<=window.document.querySelector('.pipeline-present').clientHeight-tabBarHeight;if(navFixed!=_this.state.navFixed){_this.setState({navFixed:navFixed});}var list=window.document.querySelectorAll('.present-item')||[];var stopIndex=list.length-1;for(var i=0;i<list.length;i+=1){var item=list[i];if(item&&scrollHeight>=item.offsetTop-tabBarHeight-_this.props.navigationBarHeight){if(i==list.length-1||scrollHeight<list[i+1].offsetTop-tabBarHeight-_this.props.navigationBarHeight){var curNavIndex=i>stopIndex?stopIndex:i;if(curNavIndex!=_this.state.curNavIndex){_this.setState({curNavIndex:curNavIndex});}break;}}}});_defineProperty(_assertThisInitialized(_this),"handleNavItemClick",function(navIndex){document.documentElement.scrollTop=window.document.querySelectorAll('.present-item')[navIndex].offsetTop-_this.props.navigationBarHeight-window.document.querySelector('.present-nav-container').clientHeight+(__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].isAndroid()?1:1);document.body.scrollTop=window.document.querySelectorAll('.present-item')[navIndex].offsetTop-_this.props.navigationBarHeight-window.document.querySelector('.present-nav-container').clientHeight+(__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].isAndroid()?1:1);_this.setState({curNavIndex:navIndex});});_defineProperty(_assertThisInitialized(_this),"changeRankGroup",function(curRange,navIndex){curRange.expandLength=curRange.expandLength+3>=curRange.rankList.length?curRange.rankList.length:curRange.expandLength+3;curRange.curGroup=curRange.rankList.slice(0,curRange.expandLength);_this.setState({});for(var i=0;i<3;i++){var scrollEl=document.querySelector(".rank-goods-list-".concat(navIndex,"-").concat(i));if(scrollEl){scrollEl.scrollTo(0,0);}}});_defineProperty(_assertThisInitialized(_this),"getGiftType",function(navIndex){switch(navIndex){case 1:return 1;case 0:return 2;case 2:return 3;default:return'';}});_defineProperty(_assertThisInitialized(_this),"goRankPage",function(rank,type,navIndex){var options={link:rank.href};__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,rank.href,rank.href,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handleGoodsClick",function(goodsItem,goodsIndex,rank,navIndex){var options={link:goodsItem.detailHref,sort:goodsIndex};__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,goodsItem.detailHref,goodsItem.detailHref,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handlePriceRangeClick",function(item,rangeIndex,navIndex){item.curRangeIndex=rangeIndex;_this.setState({});var list=_this.state.list;var range=list[navIndex].priceRanges[rangeIndex];if(!range.rankList||range.rankList.length==0){_this.getRankInfo(navIndex,rangeIndex);}if(navIndex!=_this.state.curNavIndex){document.documentElement.scrollTop=window.document.querySelectorAll('.present-item')[navIndex].offsetTop-_this.props.navigationBarHeight-window.document.querySelector('.present-nav-container').clientHeight+(__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].isAndroid()?0:42);document.body.scrollTop=window.document.querySelectorAll('.present-item')[navIndex].offsetTop-_this.props.navigationBarHeight-window.document.querySelector('.present-nav-container').clientHeight+(__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].isAndroid()?0:42);}});_defineProperty(_assertThisInitialized(_this),"handleXScroll",function(navIndex,rankIndex,init){var scrollEl=document.querySelector(".rank-goods-list-".concat(navIndex,"-").concat(rankIndex));var value=_this.props.routeParams;var tpExtra={};if(value){var obj=typeof value=="string"?JSON.parse(value):value;tpExtra=obj&&obj.tpExtra?obj.tpExtra:{};}tpExtra=__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].getTPExtra(tpExtra);var newTPExtra=__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatTPExtraData(encodeURIComponent(JSON.stringify({})),tpExtra);if(scrollEl){var goodsVisible=[];var from=window.squareType=='主会场'?'christmas_main_square':window.squareName;var subs=scrollEl.querySelectorAll('.goods-item')||[];var listener=function listener(){var list=_this.state.list;var rangeIndex=list[navIndex].curRangeIndex;var curRange=list[navIndex].priceRanges[rangeIndex];var rank=curRange.rankList[rankIndex];for(var i=0;i<subs.length;i++){var el=subs[i];var item=rank.items[i];var visible=scrollEl&&el&&el.getBoundingClientRect().left>0&&el.getBoundingClientRect().left<scrollEl.clientWidth;if(!goodsVisible[i]&&visible&&item){var action_time=new Date().valueOf();var exposure_str=".xb.goodsDetail.".concat(from,".gift_list..").concat(item.goodsId,".").concat(item.styleId,".").concat(i,".").concat(_this.getGiftType(navIndex),".").concat(curRange.title,".").concat(newTPExtra,".").concat(rank.id,".").concat(rank.top_name_text,".@").concat(action_time);if(exposure_str){// uploadExposure({
//   exposure_str
// })
}}goodsVisible[i]=visible;}};if(init){scrollEl.addEventListener('scroll',listener);}else{listener();}}});_defineProperty(_assertThisInitialized(_this),"formatSaleNum",function(saleNum){if(saleNum>10000){return(saleNum/10000).toFixed(1)+'w';}return saleNum;});_this.state={list:_this.props.config.list.slice(0,3),curNavIndex:0,navFixed:false};_this.inView=false;return _this;}_createClass(PipelineRankCollection,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.getRankInfo(0,0);this.getRankInfo(1,0);this.getRankInfo(2,0);if(typeof window!=="undefined"){window.addEventListener('scroll',function(e){_this2.handleBodyScroll();});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('scroll',function(){});}},{key:"render",value:function render(){var _this3=this;var customAttributes={"data-component-id":this.props["data-component-id"],"data-component-name":this.props["data-component-name"]};var baseConfig=this.props.config.baseConfig;var _this$state=this.state,list=_this$state.list,curNavIndex=_this$state.curNavIndex,navFixed=_this$state.navFixed;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",_extends({className:"pipeline-present"},customAttributes,{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px"),marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"present-nav-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:list.length===2?"present-nav-list layout-2":"present-nav-list",style:{position:navFixed?'fixed':'relative',top:navFixed?this.props.navigationBarHeight:0,backgroundColor:window.backgroundColor}},list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:[curNavIndex==index?list.length===2?"nav-item layout-2 selected":"nav-item layout-3 selected":list.length===2?'nav-item layout-2':'nav-item layout-3'],key:index,style:{backgroundImage:curNavIndex!=index?"url(".concat(item.unSelectedImage,")"):"url(".concat(item.selectedImage,")"),backgroundRepeat:"no-repeat",backgroundSize:"contain"},onClick:_this3.handleNavItemClick.bind(_this3,index)});}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{style:{paddingTop:-10}},list.map(function(item,index){if(item.curRangeIndex==undefined){item.curRangeIndex=0;}var priceRanges=item.priceRanges;var curRange=item.priceRanges[item.curRangeIndex];if(!curRange)return null;if(curRange.rankList==undefined){curRange.rankList=[];}if(curRange.curGroup==undefined){curRange.curGroup=[];}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{key:index,className:"present-item"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"img-title",style:{background:"url(".concat(item.titleImage,") center no-repeat"),backgroundSize:'contain'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:priceRanges.length<=1?"present-container no-price-range":"present-container",style:{backgroundColor:item.backgroundColor}},priceRanges.length>1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"sub-nav-list"},priceRanges.map(function(rangeItem,idx){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:item.curRangeIndex==idx?"sub-nav-item selected":'sub-nav-item',key:idx,onClick:_this3.handlePriceRangeClick.bind(_this3,item,idx,index)},rangeItem.title);})),curRange.curGroup.length==0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"loading"},"\u52A0\u8F7D\u4E2D..."),curRange.curGroup.map(function(rank,rankIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{key:rankIndex,className:"rank-item",style:{background:rank.rank_background?"url(".concat(rank.rank_background,") center no-repeat"):"url(".concat(rank.bg,") center no-repeat")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"head-title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"title"},rank.top_name_text),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"sub-title"},rank.rank_subTitle||"".concat(_this3.formatSaleNum(rank.sale_num),"\u4EBA\u5728\u901B")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"all-nav",onClick:_this3.goRankPage.bind(_this3,rank,1,index)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"goods-list rank-goods-list-".concat(index,"-").concat(rankIndex)},rank.items&&rank.items.slice(0,8).map(function(goodsItem,goodsIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{key:goodsIndex,className:"goods-item",onClick:_this3.handleGoodsClick.bind(_this3,goodsItem,goodsIndex,rank,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:goodsItem.pic,effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"name"},goodsItem.goodsName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"bottom-cont"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"t1"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"price"},goodsItem.price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"t1"},"\u8D77"),+goodsItem.officialPrice>+goodsItem.price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"origin-price"},"\xA5",goodsItem.officialPrice)),goodsIndex<3&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"top-index",style:{background:"url(".concat(topIndexImgs[goodsIndex],") center no-repeat")}}),(goodsItem.discountLabel||goodsItem.tag)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"tag"},goodsItem.discountLabel||goodsItem.tag));}),rank.items&&rank.items.length>4&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"bottom-status"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"bottom-content",onClick:_this3.goRankPage.bind(_this3,rank,2,index)},"\u70B9\u51FB\u67E5\u770B\u66F4\u591A"))));}),curRange.rankList.length>3&&curRange.curGroup.length<curRange.rankList.length?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"btn-change",onClick:_this3.changeRankGroup.bind(_this3,curRange,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("p",null,"\u5C55\u793A\u66F4\u591A"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20211216/f152ca5cbfd094e557c0b3c6cb264874.png",alt:""})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:"no-more"})));})));}}]);return PipelineRankCollection;}(__WEBPACK_IMPORTED_MODULE_18_react___default.a.Component);PipelineRankCollection.propTypes={config:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineRankCollection);

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineFloor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_some_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_some_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_some_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_less__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_swiper_components_pagination_pagination_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var mainFloorBgs=[{blockBigBg:'https://static.shihuocdn.cn/admin/files/20211031/1d8858fe6c65b99895c8242173cdfc6c.png',blockSmallBg:'https://static.shihuocdn.cn/admin/files/20211101/cd03087fdf18e347806fa68d18d619ed.png',blockBg:'https://static.shihuocdn.cn/admin/files/20211031/eb9cfe3ad6674dcabcff6fe17c4c4116.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/20b34e10ae82b654e697065dd0e4093d.png',tagBg:'#e8387f'},{blockBigBg:'https://static.shihuocdn.cn/admin/files/20211031/bef333f62b9e72570342fe8210fad28b.png',blockSmallBg:'https://static.shihuocdn.cn/admin/files/20211101/8089f0e79982596b3629c2483d38fcfe.png',blockBg:'https://static.shihuocdn.cn/admin/files/20211031/357723701640d2b8535a125f0a457c9b.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/f5d2d3688e65ea8e9c06d0cf240ae5ea.png',tagBg:'#ee8600'},{blockBigBg:'https://static.shihuocdn.cn/admin/files/20211031/e76b0c19a6ae2194ab85541d81ad3c56.png',blockSmallBg:'https://static.shihuocdn.cn/admin/files/20211101/5dd5d6a7302873ae6cf98f19e70cc714.png',blockBg:'https://static.shihuocdn.cn/admin/files/20211031/444aff6be31adee806c2cab2908d0ce6.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/b8250e416f8b4978e4ff6477f10a0161.png',tagBg:'#7450ff'}];var oldMainFloorBgs=[{blockBigBg:'https://static.shihuocdn.cn/admin/files/20211103/b4722bc34c1e9293791a191c152a46b1.png'},{blockBigBg:'https://static.shihuocdn.cn/admin/files/20211103/d29151a6de44cdfab0388f3408a62123.png'},{blockBigBg:'https://static.shihuocdn.cn/admin/files/20211103/be86c273ecedd8fffaed313c92da305f.png'}];var fenFloorBgs=[{blockBg:'https://static.shihuocdn.cn/admin/files/20211031/fa8cdef3fc98c2dc5f9aa6cf335069a5.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/9523ae12edc01dc2bf36bfe24d715b4f.png',tagBg:''},{blockBg:'https://static.shihuocdn.cn/admin/files/20211031/982ccbb6d50524f3ec0e25be1f72a61a.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/7d6c2a20d6ad42d5f0c770212f1f4d4e.png',tagBg:''},{blockBg:'https://static.shihuocdn.cn/admin/files/20211031/ef155578d362e3e625fb596f4f4eff77.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/b2dce2cbde31e03e1bb502c09d56e0b1.png',tagBg:''},{blockBg:'https://static.shihuocdn.cn/admin/files/20211031/0534882c972c450250cd98e2001dc141.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/57693d530a826816686fb02bcf528323.png',tagBg:''},{blockBg:'https://static.shihuocdn.cn/admin/files/20211031/c42fbcd7755920dc443f91cbf5ab840b.png',collectionBg:'https://static.shihuocdn.cn/admin/files/20211031/db3e4a04ed4c53f474629624ad3268de.png',tagBg:''}];var PipelineFloor=/*#__PURE__*/function(_React$Component){_inherits(PipelineFloor,_React$Component);var _super=_createSuper(PipelineFloor);function PipelineFloor(props){var _this;_classCallCheck(this,PipelineFloor);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getData",function(){var _this$props$config$li=_this.props.config.list,list=_this$props$config$li===void 0?[]:_this$props$config$li;list=list.filter(function(item){return item.type=='普通楼层'&&item.goodsConfig.type=='商品id';}).concat(list.filter(function(item){return item.type!='普通楼层'||item.goodsConfig.type!='商品id';}));var cateList=[];list.map(function(item,index){if(item.cateIds&&item.type=='普通楼层'&&item.goodsConfig.type=='二级类目id'){cateList.push({"key":index+"","cate":item.cateIds});}});__WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js___default()({baseURL: false?'':'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cateList:cateList,scene:'ACTIVITY_618_TAB_REC',from:window.location.href}}).then(function(res){res=res.data;var copyList=JSON.parse(JSON.stringify(list));var floorList=list;if(res.status==0){var _ref=res.data||{},_ref$orderCateList=_ref.orderCateList,orderCateList=_ref$orderCateList===void 0?[]:_ref$orderCateList;var mapIndex=0;orderCateList.forEach(function(key){floorList.forEach(function(item,index){if(key==index){for(var i=mapIndex;i<copyList.length;i++){if(copyList[i].cateIds&&copyList[i].goodsConfig.type=='二级类目id'&&copyList[i].type=='普通楼层'){floorList[i]=copyList[+key];mapIndex=i+1;break;}}}});});}var tabList=[];var lastClickTabName=window.localStorage.getItem('last_click_tab_name')||'';window.localStorage.removeItem('last_click_tab_name');var lastClickTabIndex=-1;floorList.forEach(function(item,floorIndex){// 指定会场置顶
if(item.tabName==_this.state.venue){floorList.splice(floorIndex,1);floorList.unshift(item);}item.showPage=1;item.keywordsList=[];var collectionList=item.collectionList;var collectionArrList=[];var avg=Math.ceil(collectionList.length/2);for(var i=0;i<3;i++){var arr=[];for(var j=0;j<avg;j++){var collection=collectionList[j*2+i];if(collection){arr.push(collection);}}if(arr.length>0){collectionArrList.push(arr);}}item.collectionList=collectionArrList;item.collectionList.forEach(function(item,index){_this.setLotterySwiper(floorIndex,index);});if(item.type=='普通楼层'){tabList.push(item.tabName);}else if(item.type=='包表配楼层'&&!tabList.some(function(tabName){return tabName==item.tabName;})){tabList.push(item.tabName);}if(window.squareType=='分会场'&&lastClickTabName==item.name&&lastClickTabIndex==-1){lastClickTabIndex=floorIndex;}var goodsConfig=item.goodsConfig;goodsConfig.goodsList=[];});if(window.squareType=='分会场'&&lastClickTabIndex>0){var floor=floorList.splice(lastClickTabIndex,1);floorList=[floor].concat(floorList);}_this.state.venue&&tabList.forEach(function(tabItem,tabIndex){// 指定会场置顶
if(tabItem==_this.state.venue){tabList.splice(tabIndex,1);tabList.unshift(tabItem);}});_this.setState({tabList:tabList,floorList:floorList},function(){floorList.forEach(function(floor,floorIndex){_this.getGoodsList(floorIndex,1);if(window.squareType=='主会场'){_this.getKeywordsList(floorIndex);}});setTimeout(function(){var _this$props$config$zt=_this.props.config.ztAdList,ztAdList=_this$props$config$zt===void 0?[]:_this$props$config$zt;if(__WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js___default.a&&ztAdList.length>0){_this.adSwiper=new __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js___default.a('.zt-content',{autoplay:ztAdList.length>1?{disableOnInteraction:false}:false,speed:500,loop:ztAdList.length>1?true:false});}},1000);});});});_defineProperty(_assertThisInitialized(_this),"getKeywordsList",function(floorIndex){var floorList=_this.state.floorList;var floor=floorList[floorIndex];if(!floor.breakCateId){return;}__WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js___default()({baseURL: false?'':'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/keywords?access_token=znSnA7pxO35wtPBaur',method:'get',withCredentials:true,params:{master_cate_id:+floor.breakCateId}}).then(function(res){res=res.data;if(res.status==0){floor.keywordsList=res.data||[];}});});_defineProperty(_assertThisInitialized(_this),"getGoodsList",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(floorIndex,page){var isMain,squareStageType,floorList,floor,goodsConfig,goods_type,res,itemList,pref,idList,goodsList,adList,pageSize;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:isMain=window.squareType=='主会场';squareStageType=window.squareStageType;floorList=_this.state.floorList;floor=floorList[floorIndex];goodsConfig=floor.goodsConfig;goods_type=0;_context.t0=squareStageType;_context.next=_context.t0==="预售"?9:_context.t0==="预热"?11:_context.t0==="正式"?13:_context.t0==="全部商品"?15:17;break;case 9:goods_type=1;return _context.abrupt("break",18);case 11:goods_type=2;return _context.abrupt("break",18);case 13:goods_type=3;return _context.abrupt("break",18);case 15:goods_type=0;return _context.abrupt("break",18);case 17:return _context.abrupt("break",18);case 18:if(!(goodsConfig.type=='二级类目id')){_context.next=24;break;}_context.next=21;return __WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js___default()({baseURL: false?'':'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cate:floor.cateIds.split(','),page_size:60,page_on:page,goods_type:goods_type,from:window.location.href,scene:'ACTIVITY_618_GOODSLIST_REC',goods_from:0}});case 21:res=_context.sent;_context.next=30;break;case 24:itemList=goodsConfig.goodsIds?goodsConfig.goodsIds.split(','):goodsConfig.goodsList;pref=goodsConfig.productType==="商品id"?'g':'p';idList=itemList.map(function(item){var id=pref+(goodsConfig.goodsIds?item:item.id);return id;});_context.next=29;return __WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js___default()({baseURL: false?'':'https://sh-gateway.shihuo.cn',url:'/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{goods_id:idList}});case 29:res=_context.sent;case 30:if(res.data.status===0){goodsList=(res.data.data.goods_list||[]).map(function(goods){return _objectSpread(_objectSpread({},goods),{},{image:goods.pic,title:goods.level=="g"?goods.goodsName:goods.goodsName+' '+goods.styleName,original_price:goods.officialPrice,url:goods.detailHref,recommend:goods.tag||''});});// 指定会场里的指定商品置顶显示
if(_this.state.venue&&_this.state.venue==floor.tabName&&_this.state.venueGoodsId){goodsList.forEach(function(goodsItem,goodsIndex){if(_this.state.venue&&_this.state.venueGoodsId==goodsItem.goodsId&&goodsItem.styleId&&_this.state.venueStyleId==goodsItem.styleId){goodsList.splice(goodsIndex,1);goodsList.unshift(goodsItem);}});}if(!(floor.type=='包表配楼层')){adList=goodsConfig.adList||[];adList.forEach(function(ad){var startTime=ad.startTime,endTime=ad.endTime,img=ad.img,position=ad.position;var pos=+position.trim()-1;var now=new Date().getTime();if(startTime&&endTime&&img&&pos>=0&&now>=new Date(startTime).getTime()&&now<=new Date(endTime).getTime()){ad.type='ad';goodsList=goodsList.slice(0,pos).concat([ad]).concat(goodsList.slice(pos,goodsList.length));}});}pageSize=Math.ceil((goodsList.length-3)/24)+1;floor.pageSize=pageSize>=3?3:pageSize;goodsConfig.goodsList=goodsList;// const adConfig = goodsConfig.adConfig
// if (adConfig.img && goodsList.length >= 3) {
//   adConfig.type = 'ad'
//   goodsConfig.goodsList = goodsList.slice(0, 3).concat([adConfig]).concat(goodsList.slice(3, goodsList.length))
// }
_this.setState({floorList:floorList},function(){_this.handleXScroll(floorIndex,true);});}case 31:case"end":return _context.stop();}}},_callee);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleXScroll",function(floorIndex,init){var isMain=typeof window!=="undefined"&&window.squareType=='主会场';setTimeout(function(){var goodsVisible=[];var tagVisible=[];var from=window.squareType=='主会场'?'618_main_square':window.squareName;var goodsScrollEl=document.querySelector(".goods-block-".concat(floorIndex));var floorList=_this.state.floorList;var floor=floorList[floorIndex];var goodsNumCell=floor.goodsConfig.goodsList.length>=20&&isMain&&floorIndex==0?2:1;if(goodsScrollEl){var block=window.squareType=='主会场'?"".concat(floor.type=='普通楼层'?'headstorey':'middlestorey',"_goodslist"):'storey_goods';var subs=goodsScrollEl.querySelectorAll('.goods-arr-item')||[];var goodsArr=floor.goodsArr||[];// const goodsNumCell = floor.collectionList.length >= 3 ? 1 : 2
var listener=function listener(){var exposure_str="";var _loop=function _loop(i){var el=subs[i];var visible=goodsScrollEl&&el&&el.getBoundingClientRect().left>0&&el.getBoundingClientRect().left<goodsScrollEl.clientWidth;if(!goodsVisible[i]&&visible){var action_time=new Date().valueOf();var arr=goodsArr[i];if(arr){arr.forEach(function(item,index){if(item.type=='ad'){exposure_str+=(exposure_str?'#':'')+".za..".concat(from,".goods_list_ad....").concat(i*goodsNumCell+index,".").concat(floor.breakCateId,".....").concat(floor.title,".").concat(floorIndex,".").concat(goodsNumCell,"@").concat(action_time);}else{exposure_str+=(exposure_str?'#':'')+".za.goodsDetail.".concat(from,".").concat(block,"..").concat(item.goodsId,".").concat(item.styleId,".").concat(i*goodsNumCell+index,".").concat(floor.breakCateId,".....").concat(floor.title,".").concat(floorIndex,".").concat(goodsNumCell,"@").concat(action_time);}});}}goodsVisible[i]=visible;};for(var i=0;i<subs.length;i++){_loop(i);}if(exposure_str){}};if(init){goodsScrollEl.addEventListener('scroll',listener);}else{listener();}}var tagScrollEl=document.querySelector(".footer-".concat(floorIndex));if(tagScrollEl){var _subs=tagScrollEl.querySelectorAll('.tag-item')||[];var _listener=function _listener(){for(var i=0;i<_subs.length;i++){var el=_subs[i];var item=floor.keywordsList[i];var visible=tagScrollEl&&el&&el.getBoundingClientRect().left>0&&el.getBoundingClientRect().left<tagScrollEl.clientWidth;if(!tagVisible[i]&&visible&&item){var action_time=new Date().valueOf();var exposure_str=".za.RNProgram.".concat(from,".headstorey_dynamicLabels....").concat(i,".").concat(floor.breakCateId,"....").concat(item,".").concat(floor.title,".").concat(floorIndex,".").concat(goodsNumCell,"@").concat(action_time);if(exposure_str){}}tagVisible[i]=visible;}};if(init){tagScrollEl.addEventListener('scroll',_listener);}else{_listener();}}},1000);});_defineProperty(_assertThisInitialized(_this),"handleBodyScroll",function(){if(!window.document.querySelector('.floor-tab')){return;}var tabBarHeight=window.document.querySelector('.floor-tab-list').clientHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navOffsetTop=window.document.querySelector('.floor-tab').offsetTop-_this.props.navigationBarHeight;var navMarginTop=0;var navFixed=scrollHeight-navOffsetTop>=navMarginTop&&scrollHeight<window.document.querySelector('.floor-wrapper').clientHeight+navOffsetTop-window.document.querySelector('.more-item').clientHeight;if(navFixed!=_this.state.navFixed){_this.setState({navFixed:navFixed});}var list=window.document.querySelectorAll('.floor-item')||[];var stopIndex=window.squareType=='主会场'?list.length-1:list.length-1;for(var i=0;i<list.length;i+=1){var item=list[i];if(item&&scrollHeight>=item.offsetTop-tabBarHeight-_this.props.navigationBarHeight){if(i==list.length-1||scrollHeight<list[i+1].offsetTop-tabBarHeight-_this.props.navigationBarHeight){var _ret=function(){var tabIndex=i>stopIndex?stopIndex:i;if(tabIndex!=_this.state.tabIndex){_this.setState({tabIndex:tabIndex},function(){if(navFixed){var tabItemEls=window.document.querySelectorAll('.floor-tab-item');if(tabItemEls&&tabItemEls[tabIndex]){tabItemEls[tabIndex].scrollIntoView();}}});}return"break";}();if(_ret==="break")break;}}}});_defineProperty(_assertThisInitialized(_this),"handleTabClick",function(index){var list=window.document.querySelectorAll('.floor-item')||[];var tabBarHeight=window.document.querySelector('.floor-tab-list').clientHeight;if(list[index]){document.documentElement.scrollTop=list[index].offsetTop-tabBarHeight-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].isAndroid()?3:0);document.body.scrollTop=list[index].offsetTop-tabBarHeight-_this.props.navigationBarHeight+(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].isAndroid()?3:0);}var tabItemEls=window.document.querySelectorAll('.floor-tab-item');if(tabItemEls&&tabItemEls[index]){if(window.document.querySelector('.floor-tab-list')){window.document.querySelector('.floor-tab-list').scrollLeft=tabItemEls[index].offsetLeft-window.innerWidth/2+tabItemEls[index].clientWidth/2;}// tabItemEls[index].scrollIntoView()
}var _this$state=_this.state,floorList=_this$state.floorList,tabList=_this$state.tabList;// utils.handleItemClick(this.props.routeParams, '', 'storey_tab', { from_sort: index, tabChName: tabList[index], child_category_id: floorList[index].cateIds })
var options={sort:index,name:tabList[index],tabChName:tabList[index],child_category_id:floorList[index].cateIds};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].uploadTrack(_this.props,options,{bizExtra:{model_block:'tab',tabChName:tabList[index]}});// utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);
});_this.state={tabList:[],tabIndex:0,floorList:[],navFixed:false,venue:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getQueryString('venue'),venueGoodsId:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getParams('venueGoodsId')||'',venueStyleId:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getParams('venueStyleId')||''};_this.lotteryInterval={};_this.adSwiper=null;_this.isSetLotterySwiper=false;return _this;}_createClass(PipelineFloor,[{key:"componentDidMount",value:function componentDidMount(){this.getData();}},{key:"componentWillUnmount",value:function componentWillUnmount(){var _this2=this;Object.keys(this.lotteryInterval).forEach(function(key){_this2.lotteryInterval[key]&&clearInterval(_this2.lotteryInterval[key]);});}},{key:"setLotterySwiper",value:function setLotterySwiper(floorIndex,index){if(this.isSetLotterySwiper){return;}this.isSetLotterySwiper=true;setTimeout(function(){var collectionAll=document.querySelectorAll('.collection-arr');for(var elIndex=0;elIndex<collectionAll.length;elIndex++){var elClass=collectionAll[elIndex].getAttribute('class');var swiperTarget=elClass.split(" ")[2];if(index>1){break;}new __WEBPACK_IMPORTED_MODULE_34_swiper_swiper_bundle_min_js___default.a(".".concat(swiperTarget),{direction:'vertical',slidesPerView:1,simulateTouch:false,spaceBetween:0,centeredSlides:false,autoplay:{delay:3000,disableOnInteraction:false},loop:true});}},2000);}},{key:"setLottery",value:function setLottery(floorIndex,index){var _this3=this;setTimeout(function(){var floorList=_this3.state.floorList;var list=floorList[floorIndex].collectionList;clearInterval(_this3.lotteryInterval[".interval-".concat(floorIndex,"-").concat(index)]);var el=document.querySelector(".lottery-all-".concat(floorIndex,"-").concat(index));if(list&&list.length>0&&list[index].length>1&&el){list[index]=list[index].concat(list[index].slice(0,1));_this3.setState({list:list});var pos=0;var itemHeight=0;if(itemHeight==0&&document.querySelectorAll(".lottery-item-".concat(index)).length>0){itemHeight=document.querySelectorAll(".lottery-item-".concat(index))[0].clientHeight;}_this3.lotteryInterval[".interval-".concat(floorIndex,"-").concat(index)]=setInterval(function(){pos++;el.style.transform="translate3d(0,".concat(-itemHeight*pos,"px,0)");el.style.transitionDuration="500ms";if(pos==list[index].length-1){setTimeout(function(){pos=0;el.style.transform="translate3d(0,0,0)";el.style.transitionDuration="0ms";},500);}},3500);}},(floorIndex+1)*1600);}},{key:"render",value:function render(){var _this4=this;var customAttributes={"data-component-id":this.props["data-component-id"],"data-component-name":this.props["data-component-name"]};var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,moreInfo=_this$props$config.moreInfo,_this$props$config$zt2=_this$props$config.ztAdList,ztAdList=_this$props$config$zt2===void 0?[]:_this$props$config$zt2;var _this$state2=this.state,tabList=_this$state2.tabList,tabIndex=_this$state2.tabIndex,floorList=_this$state2.floorList,navFixed=_this$state2.navFixed;if(tabList.length==0){return null;}var isMain=window.squareType=='主会场';var isHotStyle=window.isHotStyle=='是';var moreFloorBg=isHotStyle?'https://static.shihuocdn.cn/admin/imgs/20211102/5d2c145ce0747c1baa8e9c8ec1c1c7c3_702x560.png':moreInfo.bgImg;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",_extends({className:"floor-wrapper"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px")// marginLeft: `${baseConfig.moduleMarginHorizon}px`,
// marginRight: `${baseConfig.moduleMarginHorizon}px`,
// background: `url(${baseConfig.bgImg}) center no-repeat`
}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"floor-tab"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"floor-tab-list",style:{position:navFixed?'fixed':'relative',top:navFixed?this.props.navigationBarHeight:0,zIndex:navFixed?10:0,background:window.backgroundColor}},tabList.map(function(name,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{onClick:_this4.handleTabClick.bind(_this4,index),className:"floor-tab-item tab-item ".concat(tabIndex==index?'active':''," ").concat(isMain?'':'fen'),key:index},name);}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"empty-item"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"floor-list"},floorList.map(function(floor,floorIndex){// const goodsNumCell = floor.collectionList.length >= 3 || floor.type != '普通楼层' ? 1 : 2
var goodsList=floor.goodsConfig.goodsList;var goodsNumCell=goodsList.length>=20&&isMain&&floorIndex==0?1:1;var heightClassName='';var isXxsFloor=false;if(goodsNumCell==2){heightClassName='height-xl';}else if(floor.type=='包表配楼层'){heightClassName='height-xxs';isXxsFloor=true;}else if(floor.keywordsList.length==0&&floor.collectionList.length>0){heightClassName='height-m';}else if(floor.keywordsList.length>0&&floor.collectionList.length==0){heightClassName='height-s';}else if(floor.keywordsList.length==0&&floor.collectionList.length==0){heightClassName='height-xs';}var totalCell=Math.ceil(floor.goodsConfig.goodsList.length/goodsNumCell);var goodsArr=[];if(!isXxsFloor){for(var i=0;i<totalCell;i++){var arr=[];for(var j=0;j<goodsNumCell;j++){var idx=i*goodsNumCell+j;if(idx<goodsList.length){arr.push(goodsList[idx]);}}if(arr.length==goodsNumCell){goodsArr.push(arr);}}}if(floor.showPage<=1){goodsArr=goodsArr.slice(0,3);}else if(floor.showPage>=2&&floor.showPage<=3){goodsArr=goodsArr.slice(0,(floor.showPage-1)*24);}else{goodsArr=goodsArr.slice(0,2*24);}floor.goodsArr=goodsArr;var ztAdView=null;if(floorIndex==0&&ztAdList.length>0){ztAdView=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{key:"zt-ad-".concat(floorIndex),className:"zt-ad",onClick:function onClick(){if(!_this4.adSwiper){return;}var ztIndex=_this4.adSwiper.realIndex;var ztAd=ztAdList[ztIndex];if(ztAd){// utils.handleItemClick(this.props.routeParams, ztAd.link, 'middle_ad', { from_sort: ztIndex })
var options={sort:ztIndex};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,ztAd.link,ztAd.link,options,-1,_this4.props,false,{bizExtra:{model_block:'advertising',floor_name:floor.tabName}});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"zt-content swiper-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"swiper-wrapper"},ztAdList.map(function(ztAd,ztIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{key:ztIndex,alt:"",className:"cont swiper-slide",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(ztAd.img,_this4.props.webpSupport)});}))));}var floorItemBgSmall=floor.bgImgSmall;var floorItemBgMiddle=floor.bgImgMiddle;var floorItemBgLarge=floor.bgImg;var floorItemBg='';if(floor.showPage==1){floorItemBg=floor.bgImgSmall;}else if(floor.showPage==2){floorItemBg=floor.bgImgMiddle;}else{floorItemBg=floor.bgImg;}var collectionBg=floor.bgCollectionImg;var tagColor=floor.tagColor;if(isMain&&isHotStyle){if(floor.title.indexOf('美妆')!=-1||floor.title.indexOf('配饰')!=-1){floorItemBg=goodsNumCell==2?mainFloorBgs[0].blockBigBg:floor.type=='包表配楼层'?mainFloorBgs[0].blockSmallBg:mainFloorBgs[0].blockBg;collectionBg=mainFloorBgs[0].collectionBg;tagColor=mainFloorBgs[0].tagBg;}else if(floor.title.indexOf('服')!=-1||floor.title.indexOf('箱包')!=-1){floorItemBg=goodsNumCell==2?mainFloorBgs[1].blockBigBg:floor.type=='包表配楼层'?mainFloorBgs[1].blockSmallBg:mainFloorBgs[1].blockBg;collectionBg=mainFloorBgs[1].collectionBg;tagColor=mainFloorBgs[1].tagBg;}else{floorItemBg=goodsNumCell==2?mainFloorBgs[2].blockBigBg:floor.type=='包表配楼层'?mainFloorBgs[2].blockSmallBg:mainFloorBgs[2].blockBg;collectionBg=mainFloorBgs[2].collectionBg;tagColor=mainFloorBgs[2].tagBg;}}else if(!isMain&&isHotStyle){if(window.document.title.indexOf('鞋')!=-1){floorItemBg=fenFloorBgs[0].blockBg;collectionBg=fenFloorBgs[0].collectionBg;}else if(window.document.title.indexOf('服')!=-1){floorItemBg=fenFloorBgs[1].blockBg;collectionBg=fenFloorBgs[1].collectionBg;}else if(window.document.title.indexOf('数码')!=-1){floorItemBg=fenFloorBgs[2].blockBg;collectionBg=fenFloorBgs[2].collectionBg;}else if(window.document.title.indexOf('美妆')!=-1){floorItemBg=fenFloorBgs[3].blockBg;collectionBg=fenFloorBgs[3].collectionBg;}else{floorItemBg=fenFloorBgs[4].blockBg;collectionBg=fenFloorBgs[4].collectionBg;}}else if(isMain&&!isHotStyle&&floor.type!='包表配楼层'&&goodsNumCell==2){if(floor.title.indexOf('美妆')!=-1||floor.title.indexOf('配饰')!=-1){floorItemBg=oldMainFloorBgs[0].blockBigBg;}else if(floor.title.indexOf('服')!=-1||floor.title.indexOf('箱包')!=-1){floorItemBg=oldMainFloorBgs[1].blockBigBg;}else{floorItemBg=oldMainFloorBgs[2].blockBigBg;}}return[/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"floor-item ".concat(floor.type=='普通楼层'?'normal':''," ").concat(isMain?'':'fen-floor'," ").concat(heightClassName),key:"floor-item-".concat(floorIndex)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"header-wrap",style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(floor.bgHeaderImg,_this4.props.webpSupport),") no-repeat"),backgroundSize:"contain"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:floor.type=='包表配楼层'?"header bbp":'header'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"main-title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"title"},floor.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"nav",onClick:function onClick(){// utils.handleItemClick(this.props.routeParams, floor.link, floor.type == '普通楼层' ? 'headstorey_branch' : 'middlestorey_branch', { from_sort: floorIndex, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
var options={sort:floorIndex};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,floor.link,floor.link,options,-1,_this4.props,false,{bizExtra:{model_block:'more',floor_name:floor.tabName}});}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sub-title"},floor.subTitle)),isXxsFloor&&goodsList.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"hot-list"},goodsList.slice(0,3).map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"hot-item",key:index,onClick:function onClick(){// utils.handleItemClick(this.props.routeParams, item.url, 'middlestorey_explosive', { from_sort: index, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, from_floor: floor.title, goods_id: item.goodsId, style_id: item.styleId, line_total: goodsNumCell, from_floor_sort: floorIndex })
var options={sort:index};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,item.url,item.url,options,-1,_this4.props,false);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"hot-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.image,_this4.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"hot-title",style:{backgroundColor:tagColor}},"\xA5",item.price||'--'));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"footer footer-".concat(floorIndex)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"tag-list"},floor.keywordsList.length>0&&floor.keywordsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{style:{background:tagColor,borderColor:floor.tagBorderColor},className:isHotStyle?"tag-item hot":"tag-item",key:index,onClick:function onClick(){// utils.handleItemClick(this.props.routeParams, `shihuo://www.shihuo.cn?route=homeSearchList&keywords=${encodeURIComponent(item)}&user_input=${encodeURIComponent(item)}`, isMain ? 'headstorey_dynamicLabels' : 'storey_dynamicLabels', { from_sort: index, tag_name: item, vertical_id: floor.breakCateId, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
var options={sort:index};var url="shihuo://www.shihuo.cn?route=homeSearchList&keywords=".concat(encodeURIComponent(item),"&user_input=").concat(encodeURIComponent(item));__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,url,url,options,-1,_this4.props,false,{bizExtra:{model_block:'keywords',tabChName:item,floor_name:floor.tabName}});}},item);}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"empty-item"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"collection-list"},floor.collectionList.length>0&&floor.collectionList.slice(0,2).map(function(list,listIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"swiper-container collection-arr lottery-all-".concat(floorIndex,"-").concat(listIndex," swiper-no-swiping"),key:listIndex},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"swiper-wrapper"},list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(collectionBg||'https://static.shihuocdn.cn/admin/imgs/20211018/f75c4e2e94230d9f5f55a184d87bbb7b_325x102.png',_this4.props.webpSupport),") center top no-repeat")},className:"swiper-slide collection-item lottery-item-".concat(listIndex),key:index,onClick:function onClick(){// utils.handleItemClick(this.props.routeParams, item.link, isMain ? 'headstorey_goodsset' : 'storey_goodsset', { from_sort: index, set_name: item.title, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex });
var options={sort:index};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,item.link,item.link,options,-1,_this4.props,false,{bizExtra:{model_block:'collection',tabChName:item.title,floor_name:floor.tabName}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"collection-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.img,_this4.props.webpSupport),alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"collection-title"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"collection-sub-title"},item.subTitle));})));}))),(floor.collectionList.length>=2||goodsArr.length>0)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].isAndroid()?"content android":"content",style:{// backgroundImage: `url(${utils.formatImgUrl(floorItemBg, this.props.webpSupport)})`,
// backgroundRepeat: "no-repeat",
// backgroundSize: "100% 100%"
}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:floorItemBgSmall,alt:"",className:floor.showPage==1?"floor-item-bg-small show":"floor-item-bg-small hide"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:floorItemBgMiddle,alt:"",className:floor.showPage==2?"floor-item-bg-middle show":"floor-item-bg-middle hide"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:floorItemBgLarge,alt:"",className:floor.showPage==3?"floor-item-bg-large show":"floor-item-bg-large hide"}),goodsArr.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-block goods-block-".concat(floorIndex)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-list"},goodsArr.map(function(arr,arrIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{key:arrIndex,className:"goods-arr-item"},arr.map(function(item,index){if(item.type=='ad'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-ad",key:"".concat(arrIndex,"-").concat(index),onClick:function onClick(){// utils.handleItemClick(this.props.routeParams, item.link, `goods_list_ad`, { from_sort: arrIndex * goodsNumCell + index, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, goods_id: '', style_id: '', is_advertise: 1, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
var options={sort:arrIndex*goodsNumCell+index};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,item.link,item.link,options,-1,_this4.props,false,{bizExtra:{model_block:'goodsAd',floor_name:floor.tabName,goods_href:item.link}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:item.img,effect:"opacity"}));}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item goods-item",key:"".concat(arrIndex,"-").concat(index),onClick:function onClick(){// utils.handleItemClick(this.props.routeParams, item.url, isMain ? `${floor.type == '普通楼层' ? 'headstorey' : 'middlestorey'}_goodslist` : 'storey_goods', { from_sort: arrIndex * goodsNumCell + index, child_category_id: floor.cateIds, vertical_id: floor.breakCateId, goods_id: item.goodsId, style_id: item.styleId, is_advertise: 0, from_floor: floor.title, line_total: goodsNumCell, from_floor_sort: floorIndex })
var options={sort:arrIndex*goodsNumCell+index};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,item.url,item.url,options,-1,_this4.props,false,{bizExtra:{model_block:'goods',floor_name:floor.tabName,goods_id:item.goodsId,style_id:item.styleId}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.image,_this4.props.webpSupport),effect:"opacity"})),item.tag2&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"top-tag"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"tag-cont a".concat(['识货补贴','百亿补贴','京东秒杀'].indexOf(item.tag2))},item.tag2)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"cur-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",null,"\xA5"),item.price||'--'),item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.original_price)));}));})),floor.showPage<floor.pageSize&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"fold-btn",onClick:function onClick(){floor.showPage=floor.showPage+1>floor.pageSize?1:floor.showPage+1;_this4.setState({});__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].uploadTrack(_this4.props,{},{bizExtra:{model_block:'expand',floor_name:floor.tabName}});}},floor.showPage>=floor.pageSize?'收起':'展开',/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:floor.showPage>=floor.pageSize?'https://static.shihuocdn.cn/admin/files/20220428/ae4dfe25d91e90343e93d55a384f68a0.png':'https://static.shihuocdn.cn/admin/files/20220428/4f43946372964067d1206acec4518fe8.png',alt:"",className:floor.showPage>=floor.pageSize?'up':'down'}))))),ztAdView];})),isMain&&moreInfo.moreList.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"more-item",style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(moreFloorBg,this.props.webpSupport),") center no-repeat")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"list"},moreInfo.moreList.slice(0,10).map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"item",key:index,style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.bgImg,_this4.props.webpSupport),") center no-repeat")},onClick:function onClick(){window.localStorage.setItem('last_click_tab_name',item.title);// utils.handleItemClick(this.props.routeParams, item.link, 'tailstorey_more', { from_sort: index })
var options={sort:index};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this4.props.routeParams,item.link,item.link,options,-1,_this4.props,false,{bizExtra:{model_block:"otherVenue",tabChName:item.title}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.img,_this4.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"title"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sub-title"},item.subTitle));}))));}}]);return PipelineFloor;}(__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component);PipelineFloor.propTypes={config:__WEBPACK_IMPORTED_MODULE_29_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineFloor);

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineDateRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_utils__ = __webpack_require__(7);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineDateRange=/*#__PURE__*/function(_React$Component){_inherits(PipelineDateRange,_React$Component);var _super=_createSuper(PipelineDateRange);function PipelineDateRange(props){var _this;_classCallCheck(this,PipelineDateRange);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"renderCountDown",function(){var _this$state$count_dow=_this.state.count_down,d=_this$state$count_dow.d,h=_this$state$count_dow.h,m=_this$state$count_dow.m,s=_this$state$count_dow.s;var countDownTitle=_this.state.countDownTitle;var prefix="";if(d=='00'&&h=='00'&&m=='00'&&s=='00'){return null;}else{return"".concat(countDownTitle,"\uFF1A").concat(prefix).concat(d,"\u5929").concat(h,"\u5C0F\u65F6").concat(m,"\u5206").concat(s,"\u79D2");}});_this.state={count_down:{d:"00",h:"00",m:"00",s:"00"},curRange:null,endTime:'',countDownTitle:''};_this.timer=null;return _this;}_createClass(PipelineDateRange,[{key:"componentDidMount",value:function componentDidMount(){var endTime='';var _this$props$config=this.props.config,list=_this$props$config.list,countDownList=_this$props$config.countDownList;list&&list[0]&&list[0].dateRangeList.slice(0,4).forEach(function(range,rangeIndex){var startTimeStamp=null,endTimeStamp=null;var startDate=range.startDate,endDate=range.endDate;startDate=startDate.replace('T',' ');endDate=endDate.replace('T',' ');startTimeStamp=new Date(startDate.replace(/-/g,'/')).getTime();endTimeStamp=new Date(endDate.replace(/-/g,'/')).getTime();if(startDate.indexOf('59')>=0){startTimeStamp=startTimeStamp+59*1000;}if(endDate.indexOf('59')>=0){endTimeStamp=endTimeStamp+59*1000;}var now=new Date().getTime();if(startDate&&endDate&&now>=startTimeStamp&&now<=endTimeStamp){range.active=true;}else{range.active=false;}});var countDownTitle='';for(var index=0;index<countDownList.length;index++){var element=countDownList[index];var title=element.title,startDate=element.startDate,endDate=element.endDate;startDate=startDate.replace('T',' ');endDate=endDate.replace('T',' ');var now=new Date().getTime();if(startDate&&endDate&&now>=new Date(startDate.replace(/-/g,'/')).getTime()&&now<=new Date(endDate.replace(/-/g,'/')).getTime()){endTime=endDate;countDownTitle=title;break;}}endTime&&this.startCountDown(endTime);this.setState({curRange:list[0],endTime:endTime,countDownTitle:countDownTitle});}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);this.timer=null;}},{key:"render",value:function render(){var _this2=this;if(typeof window=='undefined'){return null;}var curRange=this.state.curRange;if(!curRange){return null;}var baseConfig=this.props.config.baseConfig;var bgRangeImg='';var showHotRange=false;var _this$state$count_dow2=this.state.count_down,d=_this$state$count_dow2.d,h=_this$state$count_dow2.h,m=_this$state$count_dow2.m,s=_this$state$count_dow2.s;var rangeBgClass='range-bg';if(baseConfig.showCountDown&&(d!='00'||h!='00'||m!='00'||s!='00')){rangeBgClass+=' hasTime';bgRangeImg=curRange.rangeBgLarge;}else{bgRangeImg=curRange.rangeBgSmall;}if(__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].isIphoneX()){rangeBgClass+=' iphoneX';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react__["Fragment"],null,curRange&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({ref:function ref(_ref){return _this2.rangeRef=_ref;},className:rangeBgClass},this.props['customAttributes'],{style:{backgroundImage:"url(".concat(bgRangeImg,")"),backgroundRepeat:"no-repeat",backgroundSize:"contain"}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"range-line"},curRange.dateRangeList.slice(0,4).map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:item.active?showHotRange?"range-item active hot":"range-item active":"range-item",key:index},!showHotRange&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Fragment,null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"range-date"},item.startDate.split("T")[0].substring(5).replace('-','.').replace('0',''),"-",item.endDate.split("T")[0].substring(5).replace('-','.').replace('0','')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"range-title"},item.title)));})),baseConfig.showCountDown&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:__WEBPACK_IMPORTED_MODULE_20__utils_utils__["a" /* default */].isAndroid()?"range-count-down android":"range-count-down ios"},this.renderCountDown())));}},{key:"countDown",value:function countDown(t){var n=new Date().getTime(),c=t-n,d,h,m,s;// 结束执行
if(c<=0){return{d:"00",h:"00",m:"00",s:"00"};}d=parseInt(c/1000/60/60/24);h=parseInt(c/1000/60/60-24*d);m=parseInt(c/1000/60-24*60*d-60*h);s=parseInt(c/1000-24*60*60*d-60*60*h-60*m);// if (s < 10) {
//   s = "0" + s;
// }
// if (m < 10) {
//   m = "0" + m;
// }
// if (h < 10) {
//   h = "0" + h;
// }
// if (d < 10) {
//   d = "0" + d;
// }
return{d:d,h:h,m:m,s:s};}},{key:"startCountDown",value:function startCountDown(end_time){var _this3=this;if(this.timer){clearInterval(this.timer);this.timer=null;}var timestramp=end_time.replace(/-/g,"/");var finish_time=new Date(timestramp).getTime();var count_down=this.countDown(finish_time);this.setState({count_down:count_down});this.timer=setInterval(function(){// 计算倒计时
finish_time=new Date(timestramp).getTime();count_down=_this3.countDown(finish_time);_this3.setState({count_down:count_down});},1000);}}]);return PipelineDateRange;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineDateRange.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineDateRange);

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineMenuBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_some_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_some_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_some_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_preaload__ = __webpack_require__(611);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineMenuBar=/*#__PURE__*/function(_React$Component){_inherits(PipelineMenuBar,_React$Component);var _super=_createSuper(PipelineMenuBar);function PipelineMenuBar(props){var _this;_classCallCheck(this,PipelineMenuBar);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleMenuSelect",function(event,item,index){event.preventDefault();if(index===_this.state.selected){return;}_this.setState({selected:index});if(item.menuHref){item.menuHref=item.menuHref.replace(/\s/g,'');var isStage=window.location.href.indexOf('/stage/page')>=0;if(!isStage){window.location.href="https://zt-public.shihuo.cn/page/".concat(item.menuHref,"/index.html?tabActive=").concat(index);}else{window.location.href="https://zt-public.shihuo.cn/stage/page/".concat(item.menuHref,"/index.html?tabActive=").concat(index);}}var newProps=JSON.parse(JSON.stringify(_this.props));Object.assign(newProps,{tabChName:item.menuName});__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].uploadTrack(newProps,{sort:index});});_this.state={selected:__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].getParams('tabActive')};_this.pageId=__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].getPageId();return _this;}_createClass(PipelineMenuBar,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;if(typeof window!=="undefined"){window.onload=function(){var menuHeight=document.querySelector(".menu-item-wrap").clientHeight;document.querySelector('.App').style.paddingBottom=menuHeight+15+"px";};var grains=this.props.config.containerConfig.grains;var preadload=[];grains&&grains.length>0&&grains.some(function(item,index){preadload.push(item.selectedImg);preadload.push(item.unselectedImg);if(item.menuHref&&item.menuHref.replace(/\s/g,'')==_this2.pageId){_this2.setState({selected:index},function(){var tabChName=grains[_this2.state.selected]&&grains[_this2.state.selected].menuName;window.sessionStorage.setItem('tabChName',tabChName);});return true;}});Object(__WEBPACK_IMPORTED_MODULE_19__utils_preaload__["a" /* default */])(preadload,function(complete){if(complete){console.log('加载完了');}});}}},{key:"render",value:function render(){var _this3=this;var selected=this.state.selected;var backgroundColor=this.props.config.baseConfig.backgroundColor;var grains=this.props.config.containerConfig.grains;if(!grains||grains.length<=0){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({className:"pipeline-menuBar"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"menu-item-wrap menu-num-".concat(grains.length),style:{backgroundColor:backgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("ul",null,grains.map(function(item,index){var menuClassNav="";menuClassNav=selected==index?'menu-item-nav active':'menu-item-nav';return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].getExposureData(_this3.props,{tabChName:item.menuName,sort:index})),className:menuClassNav,key:"menu-item-nav-".concat(index),onClick:function onClick(event){return _this3.handleMenuSelect(event,item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("img",{src:selected==index?item.selectedImg:item.unselectedImg}));})),(__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].isIphoneX()||__WEBPACK_IMPORTED_MODULE_17__utils_utils__["a" /* default */].isIphone14ProMax())&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:"safe-line"})));}}]);return PipelineMenuBar;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineMenuBar.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineMenuBar);

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function loadImage(images,callback,timeout){// 加载图片的计数器
var count=0;// 全部图片加载成功的一个标志位
var success=true;// 超时timer的id
var timeoutId=0;// 是否加载超时的标志位
var isTimeout=false;// 对图片数据或对象进行遍历
for(var key in images){// 过滤prototype上的属性
if(!images.hasOwnProperty(key)){continue;}// 获得每个图片元素
// 期望格式是个object: {src: xxxx}
var item=images[key];if(typeof item==='string'){item=images[key]={src:item};}// 如果格式不满足要求，则丢弃，遍历下一条数据
if(!item||!item.src){continue;}// 计数器+1
count++;// 设置图片id，保证每次调用id都不同
item.id='__img__'+key+getId();// 设置图片元素的img，它是一个img对象
item.img=window[item.id]=new Image();doLoad(item);}// 如果images是一个空数组或空对象，直接执行回调
if(!count){callback(success);}else if(timeout){// 如果用户传递了超时时间
timeoutId=setTimeout(onTimeout,timeout);}/**
   * 加载图片
   * @param item
   */function doLoad(item){item.status='loading';var img=item.img;// 定义图片加载成功或者失败的回调函数
img.onload=function(){success=success&&true;item.status='loaded';done();};img.onerror=function(){success=false;item.status='error';done();};// 发起一个http的图片请求
img.src=item.src;/**
     * 每张图片加载完成的回调函数
     */function done(){// 清理事件
img.onload=img.onerror=null;try{delete window[item.id];}catch(e){}// 每张图片加载完成，计数器减一，当所有图片加载完毕且没有超时的情况下，
// 清除超时计时器，且执行回调函数
if(! --count&&!isTimeout){clearTimeout(timeoutId);callback(success);}}}function onTimeout(){isTimeout=true;callback(false);}}var __id=0;function getId(){return __id++;}/* harmony default export */ __webpack_exports__["a"] = (loadImage);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCheckAppProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_object_values_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_object_values_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es7_object_values_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__style_less__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_json2csv__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_json2csv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_json2csv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_file_saver__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _toConsumableArray(arr){return _arrayWithoutHoles(arr)||_iterableToArray(arr)||_unsupportedIterableToArray(arr)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _iterableToArray(iter){if(typeof Symbol!=="undefined"&&iter[Symbol.iterator]!=null||iter["@@iterator"]!=null)return Array.from(iter);}function _arrayWithoutHoles(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var details={"goodsId":123,"goodsName":"iPhone 18","subtitle":"买就送air pods","goodsUrl":"https://item.taobao.com/item.htm?id=684824549373","imgUrl":"https://static.shihuocdn.cn/admin/files/20221211/1d91ecea5b28a6a426fe74c59d2455f8.jpeg","price":"99.80","discountPrice":"88.80","sale":"1000w+","tags":["包邮","假一赔万"],"shopName":"苹果官网","shopId":"666888","shopUrl":"https://shop.m.taobao.com/shop/shop_index.htm?user_id=890482188&item_id=681719765292","specs":[{"name":"颜色","attrs":[{"name":"白色","image":"https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"},{"name":"黑色","image":"https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"}]},{"name":"尺码","attrs":[{"name":"46.8"},{"name":"M"},{"name":"S"}]}],"postage":"免运费","Details":[{"Type":"Image","Content":"https://img.alicdn.com/imgextra/i2/2819894826/O1CN01qgh0Yl1lWLzzGS4Op_%21%212819894826.jpg"},{"Type":"Image","Content":"https://img.alicdn.com/imgextra/i3/2819894826/O1CN019NgjxY1lWLzyCSxcL_%21%212819894826.jpg"},{"Type":"Text","Content":"这是图文详情的文本类型"}],"extraShow":["自定义1","自定义2"],"extraExport":["自定义3","自定义4"]};var productStyle=typeof window!=="undefined"&&window.localStorage.getItem('productStyle')||'';var PipelineCheckAppProduct=/*#__PURE__*/function(_React$Component){_inherits(PipelineCheckAppProduct,_React$Component);var _super=_createSuper(PipelineCheckAppProduct);function PipelineCheckAppProduct(props){var _this;_classCallCheck(this,PipelineCheckAppProduct);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"initSwiper",function(){var mySwiper=new __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default.a('.banner',{autoplay:true,loop:true});});_defineProperty(_assertThisInitialized(_this),"receiveMessage",function(event){var _event$data=event.data,_event$data$messageTy=_event$data.messageType,messageType=_event$data$messageTy===void 0?'':_event$data$messageTy,_event$data$data=_event$data.data,data=_event$data$data===void 0?'':_event$data$data;switch(messageType){case'列表数据':_this.addList(data);break;case'清除数据':_this.clearData();break;case'记录导出':_this.exportRecord(messageType);break;case'执行导出':_this.exportRecord(messageType);break;case'展示风格':_this.showType(data);break;case'刷新列表':_this.refreshList(data);break;default:break;}});_defineProperty(_assertThisInitialized(_this),"refreshList",function(data){var productStyle=data==='单列展示'?'一行一个':'一行两个';typeof window!=="undefined"&&window.localStorage.setItem('productStyle',productStyle);_this.clearData();});_defineProperty(_assertThisInitialized(_this),"showType",function(data){var productStyle=data==='单列展示'?'一行一个':'一行两个';if(productStyle===_this.state.productStyle){return;}var list=_this.state.list;if(list&&list.length>0){window.parent&&window.parent.postMessage({messageType:'refreshTips',data:data},'*');}else{_this.setState({productStyle:productStyle});}});_defineProperty(_assertThisInitialized(_this),"imgProxy",function(origin){var base64=window.btoa(unescape(encodeURIComponent(origin)));base64=base64.replace(new RegExp("/","g"),"_");base64=base64.replace(new RegExp('\\+',"g"),"-");base64=base64.replace(new RegExp('=',"g"),"");return"https://proxy.shihuocdn.cn/".concat(base64);});_defineProperty(_assertThisInitialized(_this),"goShop",function(url){url&&window.open(url);});_this.state={list:[],showPage:1,pageSize:0,url:"",detail:{},"export":"off",page_type:"",productStyle:productStyle||props.config.cardBaseConfig.productStyle};_this.delayScroll=null;_this.delayUpload=null;_this.exportLock=false;return _this;}_createClass(PipelineCheckAppProduct,[{key:"componentDidMount",value:function componentDidMount(){window.addEventListener("message",this.receiveMessage,false);document.getElementsByTagName('body')[0].style.paddingLeft='20%';document.getElementsByTagName('body')[0].style.paddingRight='10%';var testData={"type":"list","clear_data":false,"message":"","data":"[{\"discountPrice\":\"994.00\",\"goodsId\":\"662634038106\",\"goodsName\":\"Jordan官方耐克乔丹AIR JORDAN 1 ELEVATE 女子运动鞋休闲DH7004\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=662634038106\",\"imgUrl\":\"https://g.search3.alicdn.com/img/i3/125054740/O1CN01wGS2y11ksy799eshr_!!0-saturn_solar.jpg\",\"price\":\"994.00\",\"sale\":\"0\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵5元红包\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"694331772832\",\"goodsName\":\"Nike Air Force 1 AF1纯白空军一号低帮男女经典板鞋 315123-111\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694331772832\",\"imgUrl\":\"https://g.search2.alicdn.com/img/bao/uploaded/i4/i3/3413497412/O1CN01vyQuJM24ckROiGxFi_!!3413497412.jpg\",\"price\":\"0.00\",\"sale\":\"13\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"高帮（帮高大于20cm)包裹性系带\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"799.00\",\"goodsId\":\"693954468956\",\"goodsName\":\"Nike耐克AIR FORCE 1空军一号AF1纯白高低帮男女鞋小白鞋休闲板鞋\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=693954468956\",\"imgUrl\":\"https://g.search1.alicdn.com/img/bao/uploaded/i4/i4/2214817327669/O1CN01kAqMub26WSE5Wq97T_!!2214817327669.jpg\",\"price\":\"213.00\",\"sale\":\"139\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"休闲鞋透气橡胶底\",\"tags\":[\"已抵5元红包\",\"公益宝贝\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"694343489841\",\"goodsName\":\"Air Jordan 1 Low AJ1激光蓝黑红蓝黄黑粉脚趾低帮板鞋男女\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694343489841\",\"imgUrl\":\"https://g.search2.alicdn.com/img/bao/uploaded/i4/i1/2206780516183/O1CN01tKsudz1vXrfnF6tqH_!!2206780516183.jpg\",\"price\":\"0.00\",\"sale\":\"18\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"799.00\",\"goodsId\":\"694535278762\",\"goodsName\":\"耐克女鞋Nike Air Force 1空军一号AF1奶咖板鞋男鞋高低帮运动鞋\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694535278762\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i3/2214817327669/O1CN01IW8cSa26WSE0olBNH_!!2214817327669.jpg\",\"price\":\"213.00\",\"sale\":\"68\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"休闲鞋透气橡胶底\",\"tags\":[\"已抵5元红包\",\"公益宝贝\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"695089763975\",\"goodsName\":\"Court Borough Low 黑曜石蓝白女子低帮休闲板鞋 BQ5448-107\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=695089763975\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i1/2209262481110/O1CN01Zzbo9q1K4QQpxoYmG_!!2209262481110.jpg\",\"price\":\"0.00\",\"sale\":\"13\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"低帮（帮高小于10cm)轻质系带\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"0.01\",\"goodsId\":\"694123784296\",\"goodsName\":\"Nike Dunk Low 玫瑰粉黑白熊猫蓝灰青苹果蓝树莓耐克休闲低帮板鞋\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694123784296\",\"imgUrl\":\"https://g.search1.alicdn.com/img/bao/uploaded/i4/i4/2208059819997/O1CN01VTuhR72NigGhHWrts_!!2208059819997.jpg\",\"price\":\"0.00\",\"sale\":\"26\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"低帮（帮高小于10cm)速干系带\",\"tags\":[\"已抵0.01元红包\",\"包邮\"]},{\"discountPrice\":\"310.00\",\"goodsId\":\"694131788030\",\"goodsName\":\"耐克Nike Dunk Low 米棕绿复古潮流低帮男子滑板鞋FB7160-231\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694131788030\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i4/2214883121136/O1CN01S0fmHm1KGKjGj6R00_!!2214883121136.jpg\",\"price\":\"305.00\",\"sale\":\"58\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"低帮（帮高小于10cm)耐磨系带\",\"tags\":[\"已抵5元红包\",\"包邮\"]},{\"discountPrice\":\"168.00\",\"goodsId\":\"691708986443\",\"goodsName\":\"Nike耐克鸭舌帽男女可调节\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=691708986443\",\"imgUrl\":\"https://g.search.alicdn.com/img/bao/uploaded/i4/i2/1970687638/O1CN01o9TbsN26IFwGEUxsc_!!1970687638.png\",\"price\":\"55.00\",\"sale\":\"902\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵5元红包\",\"直降21元\",\"新品\",\"全球购\",\"包邮\"]},{\"discountPrice\":\"629.00\",\"goodsId\":\"682350583983\",\"goodsName\":\"Nike耐克男子训练鞋透气\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=682350583983\",\"imgUrl\":\"https://g.search1.alicdn.com/img/bao/uploaded/i4/i4/890482188/O1CN01pVHLFU1S29NPvhN8n_!!2-item_pic.png\",\"price\":\"374.00\",\"sale\":\"2758\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"\",\"tags\":[\"已抵5元红包\",\"新品\",\"包邮\"]},{\"discountPrice\":\"799.00\",\"goodsId\":\"694765962335\",\"goodsName\":\"耐克NIKE AIR FORCE 1空军一号AF1纯白低帮女鞋小白鞋休闲板鞋男\",\"goodsUrl\":\"https://item.taobao.com/item.htm?id=694765962335\",\"imgUrl\":\"https://g.search2.alicdn.com/img/bao/uploaded/i4/i3/2214954659527/O1CN01NAtRt42KFQ7MwuDRY_!!2214954659527.jpg\",\"price\":\"303.00\",\"sale\":\"17\",\"shopId\":\"\",\"shopName\":\"\",\"shopUrl\":\"\",\"subtitle\":\"休闲鞋透气橡胶底\",\"tags\":[\"已抵5元红包\",\"公益宝贝\",\"包邮\"]}]"};// this.addList(testData);
setTimeout(function(){typeof window!=="undefined"&&window.parent&&window.parent.postMessage({messageType:'initList'},'*');},1000);}},{key:"destroyed",value:function destroyed(){typeof window!=="undefined"&&window.removeEventListener("message",this.receiveMessage,false);if(this.delayScroll){clearTimeout(this.delayScroll);this.delayScroll=null;}}},{key:"getDetail",value:// 详情页数据
function getDetail(data){var _this2=this;var detail={};if(data){detail=data.data?JSON.parse(data.data):{};}else{detail=details;}this.setState({page_type:"detail",detail:detail},function(){_this2.initSwiper();});}// 清楚数据
},{key:"clearData",value:function clearData(){this.setState({list:[]},function(){typeof window!=="undefined"&&window.location.reload();});}// 记录导出
},{key:"exportRecord",value:function exportRecord(messageType){this.setState({"export":messageType==="记录导出"?"on":"off"});}},{key:"imageUrl",value:function imageUrl(origin){return"https://proxy.shihuocdn.cn/".concat(window.btoa(unescape(encodeURIComponent(origin))));}},{key:"addList",value:function addList(data){var _this3=this;console.log('======== addList Lego获取到数据 =======',data);// 后端通知主动清除列表数据
if(data.clear_data){this.setState({page_type:"list",list:[]});}// 数据格式转换
var listLength=this.state.list.length;var list_original=JSON.parse(data.data);var list=list_original.map(function(item){var element={id:null,goods_id:item.goodsId,title:item.goodsName,sub_title:item.subtitle,url:item.goodsUrl,image:_this3.imgProxy(item.imgUrl),price:item.price,original_price:'',recommend:item.recommendReason,sell_point:item.sale,sell_point_str:item.sale,shop_id:item.shopId,shop_name:item.shopName,tags:item.tags,extraShow:item.extraShow,extraExport:item.extraExport};return element;});this.setState({page_type:"list",list:[].concat(_toConsumableArray(this.state.list),_toConsumableArray(list))},function(){// 翻到指定位置
if(_this3.state.list.length>0){try{var productItem=document.getElementsByClassName("product-item-"+(_this3.state.list.length-list.length));if(_this3.delayScroll){clearTimeout(_this3.delayScroll);_this3.delayScroll=null;}_this3.delayScroll=setTimeout(function(){if(listLength<=0){window.scrollTo(0,5);}else{window.scrollTo(0,productItem[0].offsetTop);}setTimeout(function(){// 整合渠道检查数据，进行上报
console.log('上报开关 ======',_this3.state["export"]);if(_this3.state["export"]==="on"){_this3.exportCsv(list_original,listLength);}},4000);},2000);}catch(e){console.log(e.message);}}});}},{key:"exportCsv",value:function(){var _exportCsv=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var list,start,uploadData,index,item,uploadItem,projectClass,dataItem,_args=arguments;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:list=_args.length>0&&_args[0]!==undefined?_args[0]:[];start=_args.length>1&&_args[1]!==undefined?_args[1]:0;if(!(this.exportLock||list.length<=0)){_context.next=4;break;}return _context.abrupt("return");case 4:this.exportLock=true;try{uploadData=[];for(index in list){item=list[index];uploadItem={"raw_data":item,"plugin_data":[]};projectClass=document.getElementsByClassName("product-item-"+(Number(index)+Number(start)));if(projectClass&&projectClass[0]){dataItem=projectClass[0].getAttribute("data-item");Object.assign(uploadItem,{"plugin_data":dataItem?JSON.parse(dataItem):[]});}uploadData.push(uploadItem);}console.log('uploadData',uploadData);window.parent&&window.parent.postMessage({messageType:'uploadData',data:uploadData},'*');this.exportLock=false;}catch(e){console.log('upload err',e);this.exportLock=false;}finally{this.exportLock=false;}case 6:case"end":return _context.stop();}}},_callee,this);}));function exportCsv(){return _exportCsv.apply(this,arguments);}return exportCsv;}()},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:this.props,index:index});return;}var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,cardBaseConfig=_this$props$config.cardBaseConfig;var options={title:baseConfig.title,type:this.state.productStyle,sort:index,name:item.title};if(baseConfig.productType==="商品id"||cardBaseConfig&&cardBaseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}if(cardBaseConfig.jumpType==='新标签页跳转'){window.open(item.url);}else{__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);}}// 进入店铺
},{key:"render",value:function render(){var _this4=this;var _this$state=this.state,list=_this$state.list,showPage=_this$state.showPage,_this$state$page_type=_this$state.page_type,page_type=_this$state$page_type===void 0?"":_this$state$page_type,productStyle=_this$state.productStyle;var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,cardBaseConfig=_this$props$config2.cardBaseConfig,cardInfoConfig=_this$props$config2.cardInfoConfig;var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;var productList=[];// 判断不同布局方式下的间距取值
if(productStyle==="一行一个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_1);productList=baseConfig.showFoldBtn?showPage<=1?list.slice(0,6):list.slice(0,6+10*(showPage-1)):list;}else if(productStyle==="一行两个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_2);productList=baseConfig.showFoldBtn?showPage<=1?list.slice(0,6):list.slice(0,6+10*(showPage-1)):list;}// 转为数字处理，后续参与计算
cardBaseConfig.itemMargin=isNaN(Number(cardBaseConfig.itemMargin))?0:Number(cardBaseConfig.itemMargin);var inputWidth="calc((100% - 342px))";if(page_type==="list"){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",_extends({className:"pipeline-checkAppProduct",id:baseConfig.title},this.props['customAttributes']),productStyle!=="一行一排"?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"product-list"},productList.map(function(item,index){var rowItemNumber=3;// 每行排列数量
if(productStyle==="一行一个"){rowItemNumber=1;}else if(productStyle==="一行两个"){rowItemNumber=2;}// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*cardBaseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,marginTop:isFirstRow?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginBottom:isLasthRow?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginLeft:isFirstColumn?"0":"".concat(cardBaseConfig.itemMargin/2,"px"),marginRight:isLastColumn?"0":"".concat(cardBaseConfig.itemMargin/2,"px")};cardBaseConfig.cardBackground&&Object.assign(itemStyle,{backgroundImage:"url(".concat(cardBaseConfig.cardBackground,")"),backgroundSize:"100% 100%",backgroundColor:"transparent",backgroundRepeat:"no-repeat",borderRadius:"inherit"});var productItem;if(productStyle==="一行一个"){// 三个展示都存在时，隐藏销量
if((cardInfoConfig.originPrice||cardInfoConfig.discount)&&cardInfoConfig.saleNum&&cardInfoConfig.priceIcon){cardInfoConfig.saleNum=false;}productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:["product-item","row-one-item","product-item-"+index].join(" "),key:"productItem-".concat(index),style:itemStyle,onClick:_this4.handleItemClick.bind(_this4,item,index),"data-url":item.url+"&SHRANDOM=".concat(parseInt(Math.random()*(999999-100000)+100000))// 杨祺要求的
,"data-shopid":item.shop_id,"data-shopname":item.shop_name},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_react_lazy_load_image_component__["LazyLoadImage"],{width:88,height:88,src:item.image})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:cardInfoConfig.slogen&&cardInfoConfig.unitPrice?"name line-clamp-2":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.useCustomName?item.custom_title:item.title),item.sub_title&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"sub-title",style:{WebkitBoxOrient:"vertical"}},item.sub_title),cardInfoConfig.slogen&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommendType==='推荐理由'?item.recommend:item.custom_recommend),item.shoppersLabel==='单位价格'&&cardInfoConfig.unitPrice&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),item.shoppersLabel==='自定义'&&cardInfoConfig.unitPrice&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,_this4.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price)),item.sell_point&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str)),item.tags.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"shop-tags"},item.tags.map(function(item,index){if(item){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{key:"tag-".concat(index)},item);}else{return null;}}))),cardInfoConfig.markIcon&&(item.custom_markIcon||cardBaseConfig.markIcon)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{className:"mark-icon",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(item.custom_markIcon||cardBaseConfig.markIcon,_this4.props.webpSupport)}));}else if(productStyle==="一行两个"){// 四个展示都存在是，隐藏销量
if((cardInfoConfig.originPrice||cardInfoConfig.discount)&&cardInfoConfig.saleNum&&cardBaseConfig.priceIcon){cardInfoConfig.saleNum=false;}// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-242-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin))/2-8;productImgWidth=productImgWidth>268?268:productImgWidth;var extraShow=item.extraShow?Object.values(item.extraShow):[];productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:["product-item","row-two-item","product-item-"+index].join(" "),key:"productItem-".concat(index),style:itemStyle,onClick:_this4.handleItemClick.bind(_this4,item,index),"data-url":item.url+"&SHRANDOM=".concat(parseInt(Math.random()*(999999-100000)+100000))// 杨祺要求的
,"data-shopid":item.shop_id,"data-shopname":item.shop_name},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"product-img-panel",style:{marginTop:4,marginBottom:4,paddingLeft:4,paddingRight:4}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:productImgWidth,src:item.image}),item.beltImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(item.beltImg,_this4.props.webpSupport),alt:"",className:"beltImg"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),item.sub_title&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"sub-title",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.sub_title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommendType==='推荐理由'?item.recommend:item.custom_recommend),item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,_this4.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price)),item.sell_point&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str)),item.tags.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"shop-tags"},item.tags.map(function(item,index){if(item){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{key:"tag-".concat(index)},item);}else{return null;}})),item.shop_name&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"shop-name"},item.shop_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"custom-info"},extraShow&&extraShow.length>0&&extraShow.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{key:"custom-field-".concat(index),className:"custom-field"},item);}))));}return productItem;})):this.renderLayoutRow());}else if(page_type==="detail"){return this.renderDetail();}else{return null;}}},{key:"renderDetail",value:function renderDetail(){var _this5=this;var _this$state$detail=this.state.detail,detail=_this$state$detail===void 0?{}:_this$state$detail;var _detail$specs=detail.specs,specs=_detail$specs===void 0?[]:_detail$specs;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"pipeline-checkAppDetail"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"banner swiper"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"swiper-wrapper"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"swiper-slide"},detail.imgUrl&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:detail.imgUrl,alt:""})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"detail-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"price-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"price"},detail.price&&"\xA5".concat(detail.price)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"discount-price"},detail.discountPrice&&"\u5238\u540E\u4EF7 \xA5".concat(detail.discountPrice," \u8D77"))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"title"},detail.goodsName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:"sub-title"},detail.subtitle)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"size-color"},specs&&specs.length>0&&specs.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"attr-wrap",key:"attr-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("label",{className:"label"},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("ul",{className:"attr"},item&&item.attrs&&item.attrs.length>0&&item.attrs.map(function(value,key){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("li",{key:"attr-item-".concat(key)},value.image?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:value.image,alt:""}):value.name);})));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"service"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"freight"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("label",{className:"label"},"\u8FD0\u8D39"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",null,detail.postage)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("ul",{className:"tags"},detail.tags&&detail.tags.length>0&&detail.tags.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("li",{key:"tag-item-".concat(index)},item);}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"extra-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"shop-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:"",alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{className:""},detail.shopName)),detail.shopUrl&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"shop-btn",onClick:function onClick(){return _this5.goShop(detail.shopUrl);}},"\u8FDB\u5165\u5E97\u94FA"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"desc-info"},detail.Details&&detail.Details.length>0&&detail.Details.map(function(item,index){if(item.Type==='Image'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{key:"desc-item-".concat(index),src:item.Content,alt:""});}if(item.Type==='Text'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("p",{key:"desc-item-".concat(index)},item.Content);}}))));}},{key:"renderLayoutRow",value:function renderLayoutRow(){return null;}}]);return PipelineCheckAppProduct;}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);PipelineCheckAppProduct.propTypes={config:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCheckAppProduct);

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.json2csv = {}));
}(this, function (exports) { 'use strict';

  var domain;

  // This constructor is used to store event handlers. Instantiating this is
  // faster than explicitly calling `Object.create(null)` to get a "clean" empty
  // object (tested with v8 v4.9).
  function EventHandlers() {}
  EventHandlers.prototype = Object.create(null);

  function EventEmitter() {
    EventEmitter.init.call(this);
  }

  // nodejs oddity
  // require('events') === require('events').EventEmitter
  EventEmitter.EventEmitter = EventEmitter;

  EventEmitter.usingDomains = false;

  EventEmitter.prototype.domain = undefined;
  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined;

  // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.
  EventEmitter.defaultMaxListeners = 10;

  EventEmitter.init = function() {
    this.domain = null;
    if (EventEmitter.usingDomains) {
      // if there is an active domain, then attach to it.
      if (domain.active && !(this instanceof domain.Domain)) ;
    }

    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    }

    this._maxListeners = this._maxListeners || undefined;
  };

  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.
  EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n))
      throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
  };

  function $getMaxListeners(that) {
    if (that._maxListeners === undefined)
      return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
  }

  EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $getMaxListeners(this);
  };

  // These standalone emit* functions are used to optimize calling of event
  // handlers for fast cases because emit() itself often has a variable number of
  // arguments and can be deoptimized because of that. These functions always have
  // the same number of arguments and thus do not get deoptimized, so the code
  // inside them can execute faster.
  function emitNone(handler, isFn, self) {
    if (isFn)
      handler.call(self);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self);
    }
  }
  function emitOne(handler, isFn, self, arg1) {
    if (isFn)
      handler.call(self, arg1);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1);
    }
  }
  function emitTwo(handler, isFn, self, arg1, arg2) {
    if (isFn)
      handler.call(self, arg1, arg2);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1, arg2);
    }
  }
  function emitThree(handler, isFn, self, arg1, arg2, arg3) {
    if (isFn)
      handler.call(self, arg1, arg2, arg3);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1, arg2, arg3);
    }
  }

  function emitMany(handler, isFn, self, args) {
    if (isFn)
      handler.apply(self, args);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].apply(self, args);
    }
  }

  EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = (type === 'error');

    events = this._events;
    if (events)
      doError = (doError && events.error == null);
    else if (!doError)
      return false;

    domain = this.domain;

    // If there is no 'error' event listener then throw.
    if (doError) {
      er = arguments[1];
      if (domain) {
        if (!er)
          er = new Error('Uncaught, unspecified "error" event');
        er.domainEmitter = this;
        er.domain = domain;
        er.domainThrown = false;
        domain.emit('error', er);
      } else if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
      return false;
    }

    handler = events[type];

    if (!handler)
      return false;

    var isFn = typeof handler === 'function';
    len = arguments.length;
    switch (len) {
      // fast cases
      case 1:
        emitNone(handler, isFn, this);
        break;
      case 2:
        emitOne(handler, isFn, this, arguments[1]);
        break;
      case 3:
        emitTwo(handler, isFn, this, arguments[1], arguments[2]);
        break;
      case 4:
        emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
        break;
      // slower
      default:
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        emitMany(handler, isFn, this, args);
    }

    return true;
  };

  function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;

    if (typeof listener !== 'function')
      throw new TypeError('"listener" argument must be a function');

    events = target._events;
    if (!events) {
      events = target._events = new EventHandlers();
      target._eventsCount = 0;
    } else {
      // To avoid recursion in the case that type === "newListener"! Before
      // adding it to the listeners, first emit "newListener".
      if (events.newListener) {
        target.emit('newListener', type,
                    listener.listener ? listener.listener : listener);

        // Re-assign `events` because a newListener handler could have caused the
        // this._events to be assigned to a new object
        events = target._events;
      }
      existing = events[type];
    }

    if (!existing) {
      // Optimize the case of one listener. Don't need the extra array object.
      existing = events[type] = listener;
      ++target._eventsCount;
    } else {
      if (typeof existing === 'function') {
        // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [listener, existing] :
                                            [existing, listener];
      } else {
        // If we've already got an array, just append.
        if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
      }

      // Check for listener leak
      if (!existing.warned) {
        m = $getMaxListeners(target);
        if (m && m > 0 && existing.length > m) {
          existing.warned = true;
          var w = new Error('Possible EventEmitter memory leak detected. ' +
                              existing.length + ' ' + type + ' listeners added. ' +
                              'Use emitter.setMaxListeners() to increase limit');
          w.name = 'MaxListenersExceededWarning';
          w.emitter = target;
          w.type = type;
          w.count = existing.length;
          emitWarning(w);
        }
      }
    }

    return target;
  }
  function emitWarning(e) {
    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
  }
  EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
  };

  EventEmitter.prototype.on = EventEmitter.prototype.addListener;

  EventEmitter.prototype.prependListener =
      function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
      };

  function _onceWrap(target, type, listener) {
    var fired = false;
    function g() {
      target.removeListener(type, g);
      if (!fired) {
        fired = true;
        listener.apply(target, arguments);
      }
    }
    g.listener = listener;
    return g;
  }

  EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function')
      throw new TypeError('"listener" argument must be a function');
    this.on(type, _onceWrap(this, type, listener));
    return this;
  };

  EventEmitter.prototype.prependOnceListener =
      function prependOnceListener(type, listener) {
        if (typeof listener !== 'function')
          throw new TypeError('"listener" argument must be a function');
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
      };

  // emits a 'removeListener' event iff the listener was removed
  EventEmitter.prototype.removeListener =
      function removeListener(type, listener) {
        var list, events, position, i, originalListener;

        if (typeof listener !== 'function')
          throw new TypeError('"listener" argument must be a function');

        events = this._events;
        if (!events)
          return this;

        list = events[type];
        if (!list)
          return this;

        if (list === listener || (list.listener && list.listener === listener)) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else {
            delete events[type];
            if (events.removeListener)
              this.emit('removeListener', type, list.listener || listener);
          }
        } else if (typeof list !== 'function') {
          position = -1;

          for (i = list.length; i-- > 0;) {
            if (list[i] === listener ||
                (list[i].listener && list[i].listener === listener)) {
              originalListener = list[i].listener;
              position = i;
              break;
            }
          }

          if (position < 0)
            return this;

          if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
              this._events = new EventHandlers();
              return this;
            } else {
              delete events[type];
            }
          } else {
            spliceOne(list, position);
          }

          if (events.removeListener)
            this.emit('removeListener', type, originalListener || listener);
        }

        return this;
      };

  EventEmitter.prototype.removeAllListeners =
      function removeAllListeners(type) {
        var listeners, events;

        events = this._events;
        if (!events)
          return this;

        // not listening for removeListener, no need to emit
        if (!events.removeListener) {
          if (arguments.length === 0) {
            this._events = new EventHandlers();
            this._eventsCount = 0;
          } else if (events[type]) {
            if (--this._eventsCount === 0)
              this._events = new EventHandlers();
            else
              delete events[type];
          }
          return this;
        }

        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
          var keys = Object.keys(events);
          for (var i = 0, key; i < keys.length; ++i) {
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
          }
          this.removeAllListeners('removeListener');
          this._events = new EventHandlers();
          this._eventsCount = 0;
          return this;
        }

        listeners = events[type];

        if (typeof listeners === 'function') {
          this.removeListener(type, listeners);
        } else if (listeners) {
          // LIFO order
          do {
            this.removeListener(type, listeners[listeners.length - 1]);
          } while (listeners[0]);
        }

        return this;
      };

  EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;

    if (!events)
      ret = [];
    else {
      evlistener = events[type];
      if (!evlistener)
        ret = [];
      else if (typeof evlistener === 'function')
        ret = [evlistener.listener || evlistener];
      else
        ret = unwrapListeners(evlistener);
    }

    return ret;
  };

  EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') {
      return emitter.listenerCount(type);
    } else {
      return listenerCount.call(emitter, type);
    }
  };

  EventEmitter.prototype.listenerCount = listenerCount;
  function listenerCount(type) {
    var events = this._events;

    if (events) {
      var evlistener = events[type];

      if (typeof evlistener === 'function') {
        return 1;
      } else if (evlistener) {
        return evlistener.length;
      }
    }

    return 0;
  }

  EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };

  // About 1.5x faster than the two-arg version of Array#splice().
  function spliceOne(list, index) {
    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
      list[i] = list[k];
    list.pop();
  }

  function arrayClone(arr, i) {
    var copy = new Array(i);
    while (i--)
      copy[i] = arr[i];
    return copy;
  }

  function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for (var i = 0; i < ret.length; ++i) {
      ret[i] = arr[i].listener || arr[i];
    }
    return ret;
  }

  var global$1 = (typeof global !== "undefined" ? global :
              typeof self !== "undefined" ? self :
              typeof window !== "undefined" ? window : {});

  var lookup = [];
  var revLookup = [];
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
  var inited = false;
  function init () {
    inited = true;
    var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    for (var i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }

    revLookup['-'.charCodeAt(0)] = 62;
    revLookup['_'.charCodeAt(0)] = 63;
  }

  function toByteArray (b64) {
    if (!inited) {
      init();
    }
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;

    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4')
    }

    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);

    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;

    var L = 0;

    for (i = 0, j = 0; i < l; i += 4, j += 3) {
      tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
      arr[L++] = (tmp >> 16) & 0xFF;
      arr[L++] = (tmp >> 8) & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    if (placeHolders === 2) {
      tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
      arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
      tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
      arr[L++] = (tmp >> 8) & 0xFF;
      arr[L++] = tmp & 0xFF;
    }

    return arr
  }

  function tripletToBase64 (num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
  }

  function encodeChunk (uint8, start, end) {
    var tmp;
    var output = [];
    for (var i = start; i < end; i += 3) {
      tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
      output.push(tripletToBase64(tmp));
    }
    return output.join('')
  }

  function fromByteArray (uint8) {
    if (!inited) {
      init();
    }
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = '';
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3

    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
    }

    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
      tmp = uint8[len - 1];
      output += lookup[tmp >> 2];
      output += lookup[(tmp << 4) & 0x3F];
      output += '==';
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
      output += lookup[tmp >> 10];
      output += lookup[(tmp >> 4) & 0x3F];
      output += lookup[(tmp << 2) & 0x3F];
      output += '=';
    }

    parts.push(output);

    return parts.join('')
  }

  function read (buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? (nBytes - 1) : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];

    i += d;

    e = s & ((1 << (-nBits)) - 1);
    s >>= (-nBits);
    nBits += eLen;
    for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    m = e & ((1 << (-nBits)) - 1);
    e >>= (-nBits);
    nBits += mLen;
    for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

    if (e === 0) {
      e = 1 - eBias;
    } else if (e === eMax) {
      return m ? NaN : ((s ? -1 : 1) * Infinity)
    } else {
      m = m + Math.pow(2, mLen);
      e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
  }

  function write (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
    var i = isLE ? 0 : (nBytes - 1);
    var d = isLE ? 1 : -1;
    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

    value = Math.abs(value);

    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0;
      e = eMax;
    } else {
      e = Math.floor(Math.log(value) / Math.LN2);
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--;
        c *= 2;
      }
      if (e + eBias >= 1) {
        value += rt / c;
      } else {
        value += rt * Math.pow(2, 1 - eBias);
      }
      if (value * c >= 2) {
        e++;
        c /= 2;
      }

      if (e + eBias >= eMax) {
        m = 0;
        e = eMax;
      } else if (e + eBias >= 1) {
        m = (value * c - 1) * Math.pow(2, mLen);
        e = e + eBias;
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
        e = 0;
      }
    }

    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

    e = (e << mLen) | m;
    eLen += mLen;
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

    buffer[offset + i - d] |= s * 128;
  }

  var toString = {}.toString;

  var isArray = Array.isArray || function (arr) {
    return toString.call(arr) == '[object Array]';
  };

  var INSPECT_MAX_BYTES = 50;

  /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Use Object implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * Due to various browser bugs, sometimes the Object implementation will be used even
   * when the browser supports typed arrays.
   *
   * Note:
   *
   *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
   *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
   *
   *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
   *
   *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
   *     incorrect length in some situations.

   * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
   * get the Object implementation, which is slower but behaves correctly.
   */
  Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
    ? global$1.TYPED_ARRAY_SUPPORT
    : true;

  function kMaxLength () {
    return Buffer.TYPED_ARRAY_SUPPORT
      ? 0x7fffffff
      : 0x3fffffff
  }

  function createBuffer (that, length) {
    if (kMaxLength() < length) {
      throw new RangeError('Invalid typed array length')
    }
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = new Uint8Array(length);
      that.__proto__ = Buffer.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      if (that === null) {
        that = new Buffer(length);
      }
      that.length = length;
    }

    return that
  }

  /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */

  function Buffer (arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
      return new Buffer(arg, encodingOrOffset, length)
    }

    // Common case.
    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new Error(
          'If encoding is specified then the first argument must be a string'
        )
      }
      return allocUnsafe(this, arg)
    }
    return from(this, arg, encodingOrOffset, length)
  }

  Buffer.poolSize = 8192; // not used by this implementation

  // TODO: Legacy, not needed anymore. Remove in next major version.
  Buffer._augment = function (arr) {
    arr.__proto__ = Buffer.prototype;
    return arr
  };

  function from (that, value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('"value" argument must not be a number')
    }

    if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
      return fromArrayBuffer(that, value, encodingOrOffset, length)
    }

    if (typeof value === 'string') {
      return fromString(that, value, encodingOrOffset)
    }

    return fromObject(that, value)
  }

  /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/
  Buffer.from = function (value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length)
  };

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
  }

  function assertSize (size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be a number')
    } else if (size < 0) {
      throw new RangeError('"size" argument must not be negative')
    }
  }

  function alloc (that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(that, size)
    }
    if (fill !== undefined) {
      // Only pay attention to encoding if it's a string. This
      // prevents accidentally sending in a number that would
      // be interpretted as a start offset.
      return typeof encoding === 'string'
        ? createBuffer(that, size).fill(fill, encoding)
        : createBuffer(that, size).fill(fill)
    }
    return createBuffer(that, size)
  }

  /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/
  Buffer.alloc = function (size, fill, encoding) {
    return alloc(null, size, fill, encoding)
  };

  function allocUnsafe (that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) {
      for (var i = 0; i < size; ++i) {
        that[i] = 0;
      }
    }
    return that
  }

  /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */
  Buffer.allocUnsafe = function (size) {
    return allocUnsafe(null, size)
  };
  /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */
  Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(null, size)
  };

  function fromString (that, string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8';
    }

    if (!Buffer.isEncoding(encoding)) {
      throw new TypeError('"encoding" must be a valid string encoding')
    }

    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);

    var actual = that.write(string, encoding);

    if (actual !== length) {
      // Writing a hex string, for example, that contains invalid characters will
      // cause everything after the first invalid character to be ignored. (e.g.
      // 'abxxcd' will be treated as 'ab')
      that = that.slice(0, actual);
    }

    return that
  }

  function fromArrayLike (that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for (var i = 0; i < length; i += 1) {
      that[i] = array[i] & 255;
    }
    return that
  }

  function fromArrayBuffer (that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer

    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('\'offset\' is out of bounds')
    }

    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('\'length\' is out of bounds')
    }

    if (byteOffset === undefined && length === undefined) {
      array = new Uint8Array(array);
    } else if (length === undefined) {
      array = new Uint8Array(array, byteOffset);
    } else {
      array = new Uint8Array(array, byteOffset, length);
    }

    if (Buffer.TYPED_ARRAY_SUPPORT) {
      // Return an augmented `Uint8Array` instance, for best performance
      that = array;
      that.__proto__ = Buffer.prototype;
    } else {
      // Fallback: Return an object instance of the Buffer class
      that = fromArrayLike(that, array);
    }
    return that
  }

  function fromObject (that, obj) {
    if (internalIsBuffer(obj)) {
      var len = checked(obj.length) | 0;
      that = createBuffer(that, len);

      if (that.length === 0) {
        return that
      }

      obj.copy(that, 0, 0, len);
      return that
    }

    if (obj) {
      if ((typeof ArrayBuffer !== 'undefined' &&
          obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
        if (typeof obj.length !== 'number' || isnan(obj.length)) {
          return createBuffer(that, 0)
        }
        return fromArrayLike(that, obj)
      }

      if (obj.type === 'Buffer' && isArray(obj.data)) {
        return fromArrayLike(that, obj.data)
      }
    }

    throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
  }

  function checked (length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                           'size: 0x' + kMaxLength().toString(16) + ' bytes')
    }
    return length | 0
  }
  Buffer.isBuffer = isBuffer;
  function internalIsBuffer (b) {
    return !!(b != null && b._isBuffer)
  }

  Buffer.compare = function compare (a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
      throw new TypeError('Arguments must be Buffers')
    }

    if (a === b) return 0

    var x = a.length;
    var y = b.length;

    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break
      }
    }

    if (x < y) return -1
    if (y < x) return 1
    return 0
  };

  Buffer.isEncoding = function isEncoding (encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true
      default:
        return false
    }
  };

  Buffer.concat = function concat (list, length) {
    if (!isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }

    if (list.length === 0) {
      return Buffer.alloc(0)
    }

    var i;
    if (length === undefined) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }

    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
      var buf = list[i];
      if (!internalIsBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }
      buf.copy(buffer, pos);
      pos += buf.length;
    }
    return buffer
  };

  function byteLength (string, encoding) {
    if (internalIsBuffer(string)) {
      return string.length
    }
    if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
        (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
      return string.byteLength
    }
    if (typeof string !== 'string') {
      string = '' + string;
    }

    var len = string.length;
    if (len === 0) return 0

    // Use a for loop to avoid recursion
    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len
        case 'utf8':
        case 'utf-8':
        case undefined:
          return utf8ToBytes(string).length
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2
        case 'hex':
          return len >>> 1
        case 'base64':
          return base64ToBytes(string).length
        default:
          if (loweredCase) return utf8ToBytes(string).length // assume utf8
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer.byteLength = byteLength;

  function slowToString (encoding, start, end) {
    var loweredCase = false;

    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.

    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) {
      start = 0;
    }
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) {
      return ''
    }

    if (end === undefined || end > this.length) {
      end = this.length;
    }

    if (end <= 0) {
      return ''
    }

    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;

    if (end <= start) {
      return ''
    }

    if (!encoding) encoding = 'utf8';

    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end)

        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end)

        case 'ascii':
          return asciiSlice(this, start, end)

        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end)

        case 'base64':
          return base64Slice(this, start, end)

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end)

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = (encoding + '').toLowerCase();
          loweredCase = true;
      }
    }
  }

  // The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
  // Buffer instances.
  Buffer.prototype._isBuffer = true;

  function swap (b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
  }

  Buffer.prototype.swap16 = function swap16 () {
    var len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits')
    }
    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }
    return this
  };

  Buffer.prototype.swap32 = function swap32 () {
    var len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits')
    }
    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }
    return this
  };

  Buffer.prototype.swap64 = function swap64 () {
    var len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits')
    }
    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }
    return this
  };

  Buffer.prototype.toString = function toString () {
    var length = this.length | 0;
    if (length === 0) return ''
    if (arguments.length === 0) return utf8Slice(this, 0, length)
    return slowToString.apply(this, arguments)
  };

  Buffer.prototype.equals = function equals (b) {
    if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
    if (this === b) return true
    return Buffer.compare(this, b) === 0
  };

  Buffer.prototype.inspect = function inspect () {
    var str = '';
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
      str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
      if (this.length > max) str += ' ... ';
    }
    return '<Buffer ' + str + '>'
  };

  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) {
      throw new TypeError('Argument must be a Buffer')
    }

    if (start === undefined) {
      start = 0;
    }
    if (end === undefined) {
      end = target ? target.length : 0;
    }
    if (thisStart === undefined) {
      thisStart = 0;
    }
    if (thisEnd === undefined) {
      thisEnd = this.length;
    }

    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index')
    }

    if (thisStart >= thisEnd && start >= end) {
      return 0
    }
    if (thisStart >= thisEnd) {
      return -1
    }
    if (start >= end) {
      return 1
    }

    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;

    if (this === target) return 0

    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);

    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);

    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break
      }
    }

    if (x < y) return -1
    if (y < x) return 1
    return 0
  };

  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
  //
  // Arguments:
  // - buffer - a Buffer to search
  // - val - a string, Buffer, or number
  // - byteOffset - an index into `buffer`; will be clamped to an int32
  // - encoding - an optional encoding, relevant is val is a string
  // - dir - true for indexOf, false for lastIndexOf
  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1

    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff;
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000;
    }
    byteOffset = +byteOffset;  // Coerce to Number.
    if (isNaN(byteOffset)) {
      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
      byteOffset = dir ? 0 : (buffer.length - 1);
    }

    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
      if (dir) return -1
      else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0;
      else return -1
    }

    // Normalize val
    if (typeof val === 'string') {
      val = Buffer.from(val, encoding);
    }

    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
      // Special case: looking for empty string/buffer always fails
      if (val.length === 0) {
        return -1
      }
      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    } else if (typeof val === 'number') {
      val = val & 0xFF; // Search for a byte value [0-255]
      if (Buffer.TYPED_ARRAY_SUPPORT &&
          typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
        }
      }
      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    }

    throw new TypeError('val must be string, number or Buffer')
  }

  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;

    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase();
      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
          encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }

    function read (buf, i) {
      if (indexSize === 1) {
        return buf[i]
      } else {
        return buf.readUInt16BE(i * indexSize)
      }
    }

    var i;
    if (dir) {
      var foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i;
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
        } else {
          if (foundIndex !== -1) i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        var found = true;
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break
          }
        }
        if (found) return i
      }
    }

    return -1
  }

  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1
  };

  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
  };

  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
  };

  function hexWrite (buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }

    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

    if (length > strLen / 2) {
      length = strLen / 2;
    }
    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (isNaN(parsed)) return i
      buf[offset + i] = parsed;
    }
    return i
  }

  function utf8Write (buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
  }

  function asciiWrite (buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length)
  }

  function latin1Write (buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length)
  }

  function base64Write (buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length)
  }

  function ucs2Write (buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
  }

  Buffer.prototype.write = function write (string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
      encoding = 'utf8';
      length = this.length;
      offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset;
      length = this.length;
      offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
      offset = offset | 0;
      if (isFinite(length)) {
        length = length | 0;
        if (encoding === undefined) encoding = 'utf8';
      } else {
        encoding = length;
        length = undefined;
      }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else {
      throw new Error(
        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
      )
    }

    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;

    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds')
    }

    if (!encoding) encoding = 'utf8';

    var loweredCase = false;
    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length)

        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length)

        case 'ascii':
          return asciiWrite(this, string, offset, length)

        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length)

        case 'base64':
          // Warning: maxLength not taken into account in base64Write
          return base64Write(this, string, offset, length)

        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length)

        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = ('' + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };

  Buffer.prototype.toJSON = function toJSON () {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    }
  };

  function base64Slice (buf, start, end) {
    if (start === 0 && end === buf.length) {
      return fromByteArray(buf)
    } else {
      return fromByteArray(buf.slice(start, end))
    }
  }

  function utf8Slice (buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];

    var i = start;
    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = (firstByte > 0xEF) ? 4
        : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
        : 1;

      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint;

        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte;
            }
            break
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint;
              }
            }
            break
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint;
              }
            }
            break
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint;
              }
            }
        }
      }

      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xFFFD;
        bytesPerSequence = 1;
      } else if (codePoint > 0xFFFF) {
        // encode to utf16 (surrogate pair dance)
        codePoint -= 0x10000;
        res.push(codePoint >>> 10 & 0x3FF | 0xD800);
        codePoint = 0xDC00 | codePoint & 0x3FF;
      }

      res.push(codePoint);
      i += bytesPerSequence;
    }

    return decodeCodePointsArray(res)
  }

  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
  // the lowest limit is Chrome, with 0x10000 args.
  // We go 1 magnitude less, for safety
  var MAX_ARGUMENTS_LENGTH = 0x1000;

  function decodeCodePointsArray (codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    }

    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(
        String,
        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
      );
    }
    return res
  }

  function asciiSlice (buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F);
    }
    return ret
  }

  function latin1Slice (buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);

    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret
  }

  function hexSlice (buf, start, end) {
    var len = buf.length;

    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;

    var out = '';
    for (var i = start; i < end; ++i) {
      out += toHex(buf[i]);
    }
    return out
  }

  function utf16leSlice (buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res
  }

  Buffer.prototype.slice = function slice (start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;

    if (start < 0) {
      start += len;
      if (start < 0) start = 0;
    } else if (start > len) {
      start = len;
    }

    if (end < 0) {
      end += len;
      if (end < 0) end = 0;
    } else if (end > len) {
      end = len;
    }

    if (end < start) end = start;

    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      newBuf = this.subarray(start, end);
      newBuf.__proto__ = Buffer.prototype;
    } else {
      var sliceLen = end - start;
      newBuf = new Buffer(sliceLen, undefined);
      for (var i = 0; i < sliceLen; ++i) {
        newBuf[i] = this[i + start];
      }
    }

    return newBuf
  };

  /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */
  function checkOffset (offset, ext, length) {
    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
  }

  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }

    return val
  };

  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      checkOffset(offset, byteLength, this.length);
    }

    var val = this[offset + --byteLength];
    var mul = 1;
    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul;
    }

    return val
  };

  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset]
  };

  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | (this[offset + 1] << 8)
  };

  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return (this[offset] << 8) | this[offset + 1]
  };

  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return ((this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16)) +
        (this[offset + 3] * 0x1000000)
  };

  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] * 0x1000000) +
      ((this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      this[offset + 3])
  };

  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var val = this[offset];
    var mul = 1;
    var i = 0;
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val
  };

  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);

    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul;
    }
    mul *= 0x80;

    if (val >= mul) val -= Math.pow(2, 8 * byteLength);

    return val
  };

  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return (this[offset])
    return ((0xff - this[offset] + 1) * -1)
  };

  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | (this[offset + 1] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  };

  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | (this[offset] << 8);
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  };

  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16) |
      (this[offset + 3] << 24)
  };

  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);

    return (this[offset] << 24) |
      (this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      (this[offset + 3])
  };

  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4)
  };

  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4)
  };

  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8)
  };

  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8)
  };

  function checkInt (buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
  }

  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
      checkInt(this, value, offset, byteLength, maxBytes, 0);
    }

    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = (value & 0xff);
    return offset + 1
  };

  function objectWriteUInt16 (buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
      buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
        (littleEndian ? i : 1 - i) * 8;
    }
  }

  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2
  };

  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 8);
      this[offset + 1] = (value & 0xff);
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2
  };

  function objectWriteUInt32 (buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
      buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
    }
  }

  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset + 3] = (value >>> 24);
      this[offset + 2] = (value >>> 16);
      this[offset + 1] = (value >>> 8);
      this[offset] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4
  };

  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 24);
      this[offset + 1] = (value >>> 16);
      this[offset + 2] = (value >>> 8);
      this[offset + 3] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4
  };

  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength - 1);

      checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }

    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
    }

    return offset + byteLength
  };

  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = (value & 0xff);
    return offset + 1
  };

  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
    } else {
      objectWriteUInt16(this, value, offset, true);
    }
    return offset + 2
  };

  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 8);
      this[offset + 1] = (value & 0xff);
    } else {
      objectWriteUInt16(this, value, offset, false);
    }
    return offset + 2
  };

  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value & 0xff);
      this[offset + 1] = (value >>> 8);
      this[offset + 2] = (value >>> 16);
      this[offset + 3] = (value >>> 24);
    } else {
      objectWriteUInt32(this, value, offset, true);
    }
    return offset + 4
  };

  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      this[offset] = (value >>> 24);
      this[offset + 1] = (value >>> 16);
      this[offset + 2] = (value >>> 8);
      this[offset + 3] = (value & 0xff);
    } else {
      objectWriteUInt32(this, value, offset, false);
    }
    return offset + 4
  };

  function checkIEEE754 (buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    if (offset < 0) throw new RangeError('Index out of range')
  }

  function writeFloat (buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4
  }

  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert)
  };

  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert)
  };

  function writeDouble (buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8
  }

  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert)
  };

  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert)
  };

  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;

    // Copy 0 bytes; we're done
    if (end === start) return 0
    if (target.length === 0 || this.length === 0) return 0

    // Fatal error conditions
    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds')
    }
    if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
    if (end < 0) throw new RangeError('sourceEnd out of bounds')

    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }

    var len = end - start;
    var i;

    if (this === target && start < targetStart && targetStart < end) {
      // descending copy from end
      for (i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start];
      }
    } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
      // ascending copy from start
      for (i = 0; i < len; ++i) {
        target[i + targetStart] = this[i + start];
      }
    } else {
      Uint8Array.prototype.set.call(
        target,
        this.subarray(start, start + len),
        targetStart
      );
    }

    return len
  };

  // Usage:
  //    buffer.fill(number[, offset[, end]])
  //    buffer.fill(buffer[, offset[, end]])
  //    buffer.fill(string[, offset[, end]][, encoding])
  Buffer.prototype.fill = function fill (val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === 'string') {
        encoding = end;
        end = this.length;
      }
      if (val.length === 1) {
        var code = val.charCodeAt(0);
        if (code < 256) {
          val = code;
        }
      }
      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string')
      }
      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding)
      }
    } else if (typeof val === 'number') {
      val = val & 255;
    }

    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index')
    }

    if (end <= start) {
      return this
    }

    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;

    if (!val) val = 0;

    var i;
    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = internalIsBuffer(val)
        ? val
        : utf8ToBytes(new Buffer(val, encoding).toString());
      var len = bytes.length;
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }

    return this
  };

  // HELPER FUNCTIONS
  // ================

  var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

  function base64clean (str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return ''
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while (str.length % 4 !== 0) {
      str = str + '=';
    }
    return str
  }

  function stringtrim (str) {
    if (str.trim) return str.trim()
    return str.replace(/^\s+|\s+$/g, '')
  }

  function toHex (n) {
    if (n < 16) return '0' + n.toString(16)
    return n.toString(16)
  }

  function utf8ToBytes (string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];

    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i);

      // is surrogate component
      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        // last char was a lead
        if (!leadSurrogate) {
          // no lead yet
          if (codePoint > 0xDBFF) {
            // unexpected trail
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue
          } else if (i + 1 === length) {
            // unpaired lead
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            continue
          }

          // valid lead
          leadSurrogate = codePoint;

          continue
        }

        // 2 leads in a row
        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          leadSurrogate = codePoint;
          continue
        }

        // valid surrogate pair
        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
      } else if (leadSurrogate) {
        // valid bmp char, but last char was a lead
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
      }

      leadSurrogate = null;

      // encode utf8
      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break
        bytes.push(codePoint);
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break
        bytes.push(
          codePoint >> 0x6 | 0xC0,
          codePoint & 0x3F | 0x80
        );
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break
        bytes.push(
          codePoint >> 0xC | 0xE0,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        );
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break
        bytes.push(
          codePoint >> 0x12 | 0xF0,
          codePoint >> 0xC & 0x3F | 0x80,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        );
      } else {
        throw new Error('Invalid code point')
      }
    }

    return bytes
  }

  function asciiToBytes (str) {
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      // Node's code seems to be doing this and not & 0x7F..
      byteArray.push(str.charCodeAt(i) & 0xFF);
    }
    return byteArray
  }

  function utf16leToBytes (str, units) {
    var c, hi, lo;
    var byteArray = [];
    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break

      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }

    return byteArray
  }


  function base64ToBytes (str) {
    return toByteArray(base64clean(str))
  }

  function blitBuffer (src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if ((i + offset >= dst.length) || (i >= src.length)) break
      dst[i + offset] = src[i];
    }
    return i
  }

  function isnan (val) {
    return val !== val // eslint-disable-line no-self-compare
  }


  // the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
  }

  function isFastBuffer (obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
  }

  // For Node v0.10 support. Remove this eventually.
  function isSlowBuffer (obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
  }

  // shim for using process in browser
  // based off https://github.com/defunctzombie/node-process/blob/master/browser.js

  function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout () {
      throw new Error('clearTimeout has not been defined');
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global$1.setTimeout === 'function') {
      cachedSetTimeout = setTimeout;
  }
  if (typeof global$1.clearTimeout === 'function') {
      cachedClearTimeout = clearTimeout;
  }

  function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
      } catch(e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
          } catch(e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
          }
      }


  }
  function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
      } catch (e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
          } catch (e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
          }
      }



  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
      if (!draining || !currentQueue) {
          return;
      }
      draining = false;
      if (currentQueue.length) {
          queue = currentQueue.concat(queue);
      } else {
          queueIndex = -1;
      }
      if (queue.length) {
          drainQueue();
      }
  }

  function drainQueue() {
      if (draining) {
          return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;

      var len = queue.length;
      while(len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
              if (currentQueue) {
                  currentQueue[queueIndex].run();
              }
          }
          queueIndex = -1;
          len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
  }
  function nextTick(fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
          }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
      }
  }
  // v8 likes predictible objects
  function Item(fun, array) {
      this.fun = fun;
      this.array = array;
  }
  Item.prototype.run = function () {
      this.fun.apply(null, this.array);
  };

  // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
  var performance = global$1.performance || {};
  var performanceNow =
    performance.now        ||
    performance.mozNow     ||
    performance.msNow      ||
    performance.oNow       ||
    performance.webkitNow  ||
    function(){ return (new Date()).getTime() };

  var inherits;
  if (typeof Object.create === 'function'){
    inherits = function inherits(ctor, superCtor) {
      // implementation from standard node.js 'util' module
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    inherits = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    };
  }
  var inherits$1 = inherits;

  var formatRegExp = /%[sdj%]/g;
  function format(f) {
    if (!isString(f)) {
      var objects = [];
      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }
      return objects.join(' ');
    }

    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
      if (x === '%%') return '%';
      if (i >= len) return x;
      switch (x) {
        case '%s': return String(args[i++]);
        case '%d': return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
        default:
          return x;
      }
    });
    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }
    return str;
  }

  // Mark that a method should not be used.
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.
  function deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global$1.process)) {
      return function() {
        return deprecate(fn, msg).apply(this, arguments);
      };
    }

    var warned = false;
    function deprecated() {
      if (!warned) {
        {
          console.error(msg);
        }
        warned = true;
      }
      return fn.apply(this, arguments);
    }

    return deprecated;
  }

  var debugs = {};
  var debugEnviron;
  function debuglog(set) {
    if (isUndefined(debugEnviron))
      debugEnviron =  '';
    set = set.toUpperCase();
    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = 0;
        debugs[set] = function() {
          var msg = format.apply(null, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function() {};
      }
    }
    return debugs[set];
  }

  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */
  /* legacy: obj, showHidden, depth, colors*/
  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      _extend(ctx, opts);
    }
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }

  // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
  inspect.colors = {
    'bold' : [1, 22],
    'italic' : [3, 23],
    'underline' : [4, 24],
    'inverse' : [7, 27],
    'white' : [37, 39],
    'grey' : [90, 39],
    'black' : [30, 39],
    'blue' : [34, 39],
    'cyan' : [36, 39],
    'green' : [32, 39],
    'magenta' : [35, 39],
    'red' : [31, 39],
    'yellow' : [33, 39]
  };

  // Don't use 'blue' not visible on cmd.exe
  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };


  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];

    if (style) {
      return '\u001b[' + inspect.colors[style][0] + 'm' + str +
             '\u001b[' + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }


  function stylizeNoColor(str, styleType) {
    return str;
  }


  function arrayToHash(array) {
    var hash = {};

    array.forEach(function(val, idx) {
      hash[val] = true;
    });

    return hash;
  }


  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect &&
        value &&
        isFunction(value.inspect) &&
        // Filter out the util module, it's inspect function is special
        value.inspect !== inspect &&
        // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);
      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }
      return ret;
    }

    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) {
      return primitive;
    }

    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);

    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    }

    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value)
        && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    }

    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }
      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }
      if (isError(value)) {
        return formatError(value);
      }
    }

    var base = '', array = false, braces = ['{', '}'];

    // Make Array say that they are Array
    if (isArray$1(value)) {
      array = true;
      braces = ['[', ']'];
    }

    // Make functions say that they are functions
    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    }

    // Make RegExps say that they are RegExps
    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    }

    // Make dates with properties first say the date
    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    }

    // Make error with message first say the error
    if (isError(value)) {
      base = ' ' + formatError(value);
    }

    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }

    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }

    ctx.seen.push(value);

    var output;
    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }

    ctx.seen.pop();

    return reduceToSingleString(output, base, braces);
  }


  function formatPrimitive(ctx, value) {
    if (isUndefined(value))
      return ctx.stylize('undefined', 'undefined');
    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                               .replace(/'/g, "\\'")
                                               .replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }
    if (isNumber(value))
      return ctx.stylize('' + value, 'number');
    if (isBoolean(value))
      return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if (isNull(value))
      return ctx.stylize('null', 'null');
  }


  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }


  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            String(i), true));
      } else {
        output.push('');
      }
    }
    keys.forEach(function(key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            key, true));
      }
    });
    return output;
  }


  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }
    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }
    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }
        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function(line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function(line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }
    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }
      name = JSON.stringify('' + key);
      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'")
                   .replace(/\\"/g, '"')
                   .replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }

    return name + ': ' + str;
  }


  function reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
      if (cur.indexOf('\n') >= 0) ;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);

    if (length > 60) {
      return braces[0] +
             (base === '' ? '' : base + '\n ') +
             ' ' +
             output.join(',\n  ') +
             ' ' +
             braces[1];
    }

    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  }


  // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.
  function isArray$1(ar) {
    return Array.isArray(ar);
  }

  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }

  function isNull(arg) {
    return arg === null;
  }

  function isNumber(arg) {
    return typeof arg === 'number';
  }

  function isString(arg) {
    return typeof arg === 'string';
  }

  function isUndefined(arg) {
    return arg === void 0;
  }

  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }

  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }

  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }

  function isError(e) {
    return isObject(e) &&
        (objectToString(e) === '[object Error]' || e instanceof Error);
  }

  function isFunction(arg) {
    return typeof arg === 'function';
  }

  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }

  function _extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;

    var keys = Object.keys(add);
    var i = keys.length;
    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }
    return origin;
  }
  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  function BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function (v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function (v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function () {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function () {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function (s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function (n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      p.data.copy(ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  // Copyright Joyent, Inc. and other Node contributors.
  var isBufferEncoding = Buffer.isEncoding
    || function(encoding) {
         switch (encoding && encoding.toLowerCase()) {
           case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
           default: return false;
         }
       };


  function assertEncoding(encoding) {
    if (encoding && !isBufferEncoding(encoding)) {
      throw new Error('Unknown encoding: ' + encoding);
    }
  }

  // StringDecoder provides an interface for efficiently splitting a series of
  // buffers into a series of JS strings without breaking apart multi-byte
  // characters. CESU-8 is handled as part of the UTF-8 encoding.
  //
  // @TODO Handling all encodings inside a single object makes it very difficult
  // to reason about this code, so it should be split up in the future.
  // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
  // points as used by CESU-8.
  function StringDecoder(encoding) {
    this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
    assertEncoding(encoding);
    switch (this.encoding) {
      case 'utf8':
        // CESU-8 represents each of Surrogate Pair by 3-bytes
        this.surrogateSize = 3;
        break;
      case 'ucs2':
      case 'utf16le':
        // UTF-16 represents each of Surrogate Pair by 2-bytes
        this.surrogateSize = 2;
        this.detectIncompleteChar = utf16DetectIncompleteChar;
        break;
      case 'base64':
        // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
        this.surrogateSize = 3;
        this.detectIncompleteChar = base64DetectIncompleteChar;
        break;
      default:
        this.write = passThroughWrite;
        return;
    }

    // Enough space to store all bytes of a single character. UTF-8 needs 4
    // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
    this.charBuffer = new Buffer(6);
    // Number of bytes received for the current incomplete multi-byte character.
    this.charReceived = 0;
    // Number of bytes expected for the current incomplete multi-byte character.
    this.charLength = 0;
  }

  // write decodes the given buffer and returns it as JS string that is
  // guaranteed to not contain any partial multi-byte characters. Any partial
  // character found at the end of the buffer is buffered up, and will be
  // returned when calling write again with the remaining bytes.
  //
  // Note: Converting a Buffer containing an orphan surrogate to a String
  // currently works, but converting a String to a Buffer (via `new Buffer`, or
  // Buffer#write) will replace incomplete surrogates with the unicode
  // replacement character. See https://codereview.chromium.org/121173009/ .
  StringDecoder.prototype.write = function(buffer) {
    var charStr = '';
    // if our last write ended with an incomplete multibyte character
    while (this.charLength) {
      // determine how many remaining bytes this buffer has to offer for this char
      var available = (buffer.length >= this.charLength - this.charReceived) ?
          this.charLength - this.charReceived :
          buffer.length;

      // add the new bytes to the char buffer
      buffer.copy(this.charBuffer, this.charReceived, 0, available);
      this.charReceived += available;

      if (this.charReceived < this.charLength) {
        // still not enough chars in this buffer? wait for more ...
        return '';
      }

      // remove bytes belonging to the current character from the buffer
      buffer = buffer.slice(available, buffer.length);

      // get the character that was split
      charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

      // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
      var charCode = charStr.charCodeAt(charStr.length - 1);
      if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        this.charLength += this.surrogateSize;
        charStr = '';
        continue;
      }
      this.charReceived = this.charLength = 0;

      // if there are no more bytes in this buffer, just emit our char
      if (buffer.length === 0) {
        return charStr;
      }
      break;
    }

    // determine and set charLength / charReceived
    this.detectIncompleteChar(buffer);

    var end = buffer.length;
    if (this.charLength) {
      // buffer the incomplete character bytes we got
      buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
      end -= this.charReceived;
    }

    charStr += buffer.toString(this.encoding, 0, end);

    var end = charStr.length - 1;
    var charCode = charStr.charCodeAt(end);
    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      var size = this.surrogateSize;
      this.charLength += size;
      this.charReceived += size;
      this.charBuffer.copy(this.charBuffer, size, 0, size);
      buffer.copy(this.charBuffer, 0, 0, size);
      return charStr.substring(0, end);
    }

    // or just emit the charStr
    return charStr;
  };

  // detectIncompleteChar determines if there is an incomplete UTF-8 character at
  // the end of the given buffer. If so, it sets this.charLength to the byte
  // length that character, and sets this.charReceived to the number of bytes
  // that are available for this character.
  StringDecoder.prototype.detectIncompleteChar = function(buffer) {
    // determine how many bytes we have to check at the end of this buffer
    var i = (buffer.length >= 3) ? 3 : buffer.length;

    // Figure out if one of the last i bytes of our buffer announces an
    // incomplete char.
    for (; i > 0; i--) {
      var c = buffer[buffer.length - i];

      // See http://en.wikipedia.org/wiki/UTF-8#Description

      // 110XXXXX
      if (i == 1 && c >> 5 == 0x06) {
        this.charLength = 2;
        break;
      }

      // 1110XXXX
      if (i <= 2 && c >> 4 == 0x0E) {
        this.charLength = 3;
        break;
      }

      // 11110XXX
      if (i <= 3 && c >> 3 == 0x1E) {
        this.charLength = 4;
        break;
      }
    }
    this.charReceived = i;
  };

  StringDecoder.prototype.end = function(buffer) {
    var res = '';
    if (buffer && buffer.length)
      res = this.write(buffer);

    if (this.charReceived) {
      var cr = this.charReceived;
      var buf = this.charBuffer;
      var enc = this.encoding;
      res += buf.slice(0, cr).toString(enc);
    }

    return res;
  };

  function passThroughWrite(buffer) {
    return buffer.toString(this.encoding);
  }

  function utf16DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 2;
    this.charLength = this.charReceived ? 2 : 0;
  }

  function base64DetectIncompleteChar(buffer) {
    this.charReceived = buffer.length % 3;
    this.charLength = this.charReceived ? 3 : 0;
  }

  Readable.ReadableState = ReadableState;

  var debug = debuglog('stream');
  inherits$1(Readable, EventEmitter);

  function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') {
      return emitter.prependListener(event, fn);
    } else {
      // This is a hack to make sure that our error handler is attached before any
      // userland ones.  NEVER DO THIS. This is here only because this code needs
      // to continue to work with older versions of Node.js that do not include
      // the prependListener() method. The goal is to eventually remove this hack.
      if (!emitter._events || !emitter._events[event])
        emitter.on(event, fn);
      else if (Array.isArray(emitter._events[event]))
        emitter._events[event].unshift(fn);
      else
        emitter._events[event] = [fn, emitter._events[event]];
    }
  }
  function listenerCount$1 (emitter, type) {
    return emitter.listeners(type).length;
  }
  function ReadableState(options, stream) {

    options = options || {};

    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;

    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

    // cast to ints.
    this.highWaterMark = ~ ~this.highWaterMark;

    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;

    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;

    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;

    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';

    // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false;

    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;

    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;

    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
      this.decoder = new StringDecoder(options.encoding);
      this.encoding = options.encoding;
    }
  }
  function Readable(options) {

    if (!(this instanceof Readable)) return new Readable(options);

    this._readableState = new ReadableState(options, this);

    // legacy
    this.readable = true;

    if (options && typeof options.read === 'function') this._read = options.read;

    EventEmitter.call(this);
  }

  // Manually shove something into the read() buffer.
  // This returns true if the highWaterMark has not been hit yet,
  // similar to how Writable.write() returns true if you should
  // write() some more.
  Readable.prototype.push = function (chunk, encoding) {
    var state = this._readableState;

    if (!state.objectMode && typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
    }

    return readableAddChunk(this, state, chunk, encoding, false);
  };

  // Unshift should *always* be something directly out of read()
  Readable.prototype.unshift = function (chunk) {
    var state = this._readableState;
    return readableAddChunk(this, state, chunk, '', true);
  };

  Readable.prototype.isPaused = function () {
    return this._readableState.flowing === false;
  };

  function readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (chunk === null) {
      state.reading = false;
      onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (state.ended && !addToFront) {
        var e = new Error('stream.push() after EOF');
        stream.emit('error', e);
      } else if (state.endEmitted && addToFront) {
        var _e = new Error('stream.unshift() after end event');
        stream.emit('error', _e);
      } else {
        var skipAdd;
        if (state.decoder && !addToFront && !encoding) {
          chunk = state.decoder.write(chunk);
          skipAdd = !state.objectMode && chunk.length === 0;
        }

        if (!addToFront) state.reading = false;

        // Don't add to the buffer if we've decoded to an empty string chunk and
        // we're not in object mode
        if (!skipAdd) {
          // if we want the data now, just emit it.
          if (state.flowing && state.length === 0 && !state.sync) {
            stream.emit('data', chunk);
            stream.read(0);
          } else {
            // update the buffer info.
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

            if (state.needReadable) emitReadable(stream);
          }
        }

        maybeReadMore(stream, state);
      }
    } else if (!addToFront) {
      state.reading = false;
    }

    return needMoreData(state);
  }

  // if it's past the high water mark, we can push in some more.
  // Also, if we have no data yet, we can stand some
  // more bytes.  This is to work around cases where hwm=0,
  // such as the repl.  Also, if the push() triggered a
  // readable event, and the user called read(largeNumber) such that
  // needReadable was set, then we ought to push more, so that another
  // 'readable' event will be triggered.
  function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
  }

  // backwards compatibility.
  Readable.prototype.setEncoding = function (enc) {
    this._readableState.decoder = new StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
  };

  // Don't raise the hwm > 8MB
  var MAX_HWM = 0x800000;
  function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) {
      n = MAX_HWM;
    } else {
      // Get the next highest power of 2 to prevent increasing hwm excessively in
      // tiny amounts
      n--;
      n |= n >>> 1;
      n |= n >>> 2;
      n |= n >>> 4;
      n |= n >>> 8;
      n |= n >>> 16;
      n++;
    }
    return n;
  }

  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
      // Only flow one buffer at a time
      if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    }
    return state.length;
  }

  // you can override either this method, or the async _read(n) below.
  Readable.prototype.read = function (n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;

    if (n !== 0) state.emittedReadable = false;

    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
      debug('read: emitReadable', state.length, state.ended);
      if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
      return null;
    }

    n = howMuchToRead(n, state);

    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
      if (state.length === 0) endReadable(this);
      return null;
    }

    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.

    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug('need readable', doRead);

    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
      doRead = true;
      debug('length less than watermark', doRead);
    }

    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
      doRead = false;
      debug('reading or ended', doRead);
    } else if (doRead) {
      debug('do read');
      state.reading = true;
      state.sync = true;
      // if the length is currently zero, then we *need* a readable event.
      if (state.length === 0) state.needReadable = true;
      // call internal read method
      this._read(state.highWaterMark);
      state.sync = false;
      // If _read pushed data synchronously, then `reading` will be false,
      // and we need to re-evaluate how much data we can return to the user.
      if (!state.reading) n = howMuchToRead(nOrig, state);
    }

    var ret;
    if (n > 0) ret = fromList(n, state);else ret = null;

    if (ret === null) {
      state.needReadable = true;
      n = 0;
    } else {
      state.length -= n;
    }

    if (state.length === 0) {
      // If we have nothing in the buffer, then we want to know
      // as soon as we *do* get something into the buffer.
      if (!state.ended) state.needReadable = true;

      // If we tried to read() past the EOF, then emit end on the next tick.
      if (nOrig !== n && state.ended) endReadable(this);
    }

    if (ret !== null) this.emit('data', ret);

    return ret;
  };

  function chunkInvalid(state, chunk) {
    var er = null;
    if (!isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
      er = new TypeError('Invalid non-string/buffer chunk');
    }
    return er;
  }

  function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) {
        state.buffer.push(chunk);
        state.length += state.objectMode ? 1 : chunk.length;
      }
    }
    state.ended = true;

    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
  }

  // Don't emit readable right away in sync mode, because this can trigger
  // another read() call => stack overflow.  This way, it might trigger
  // a nextTick recursion warning, but that's not so bad.
  function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
      debug('emitReadable', state.flowing);
      state.emittedReadable = true;
      if (state.sync) nextTick(emitReadable_, stream);else emitReadable_(stream);
    }
  }

  function emitReadable_(stream) {
    debug('emit readable');
    stream.emit('readable');
    flow(stream);
  }

  // at this point, the user has presumably seen the 'readable' event,
  // and called read() to consume some data.  that may have triggered
  // in turn another _read(n) call, in which case reading = true if
  // it's in progress.
  // However, if we're not ended, or reading, and the length < hwm,
  // then go ahead and try to read some more preemptively.
  function maybeReadMore(stream, state) {
    if (!state.readingMore) {
      state.readingMore = true;
      nextTick(maybeReadMore_, stream, state);
    }
  }

  function maybeReadMore_(stream, state) {
    var len = state.length;
    while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
      debug('maybeReadMore read 0');
      stream.read(0);
      if (len === state.length)
        // didn't get any data, stop spinning.
        break;else len = state.length;
    }
    state.readingMore = false;
  }

  // abstract method.  to be overridden in specific implementation classes.
  // call cb(er, data) where data is <= n in length.
  // for virtual (non-string, non-buffer) streams, "length" is somewhat
  // arbitrary, and perhaps not very meaningful.
  Readable.prototype._read = function (n) {
    this.emit('error', new Error('not implemented'));
  };

  Readable.prototype.pipe = function (dest, pipeOpts) {
    var src = this;
    var state = this._readableState;

    switch (state.pipesCount) {
      case 0:
        state.pipes = dest;
        break;
      case 1:
        state.pipes = [state.pipes, dest];
        break;
      default:
        state.pipes.push(dest);
        break;
    }
    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

    var doEnd = (!pipeOpts || pipeOpts.end !== false);

    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);

    dest.on('unpipe', onunpipe);
    function onunpipe(readable) {
      debug('onunpipe');
      if (readable === src) {
        cleanup();
      }
    }

    function onend() {
      debug('onend');
      dest.end();
    }

    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);

    var cleanedUp = false;
    function cleanup() {
      debug('cleanup');
      // cleanup event handlers once the pipe is broken
      dest.removeListener('close', onclose);
      dest.removeListener('finish', onfinish);
      dest.removeListener('drain', ondrain);
      dest.removeListener('error', onerror);
      dest.removeListener('unpipe', onunpipe);
      src.removeListener('end', onend);
      src.removeListener('end', cleanup);
      src.removeListener('data', ondata);

      cleanedUp = true;

      // if the reader is waiting for a drain event from this
      // specific writer, then it would cause it to never start
      // flowing again.
      // So, if this is awaiting a drain, then we just call it now.
      // If we don't know, then assume that we are waiting for one.
      if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }

    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
      debug('ondata');
      increasedAwaitDrain = false;
      var ret = dest.write(chunk);
      if (false === ret && !increasedAwaitDrain) {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
          debug('false write response, pause', src._readableState.awaitDrain);
          src._readableState.awaitDrain++;
          increasedAwaitDrain = true;
        }
        src.pause();
      }
    }

    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
      debug('onerror', er);
      unpipe();
      dest.removeListener('error', onerror);
      if (listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
    }

    // Make sure our error handler is attached before userland ones.
    prependListener(dest, 'error', onerror);

    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
      dest.removeListener('finish', onfinish);
      unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
      debug('onfinish');
      dest.removeListener('close', onclose);
      unpipe();
    }
    dest.once('finish', onfinish);

    function unpipe() {
      debug('unpipe');
      src.unpipe(dest);
    }

    // tell the dest that it's being piped to
    dest.emit('pipe', src);

    // start the flow if it hasn't been started already.
    if (!state.flowing) {
      debug('pipe resume');
      src.resume();
    }

    return dest;
  };

  function pipeOnDrain(src) {
    return function () {
      var state = src._readableState;
      debug('pipeOnDrain', state.awaitDrain);
      if (state.awaitDrain) state.awaitDrain--;
      if (state.awaitDrain === 0 && src.listeners('data').length) {
        state.flowing = true;
        flow(src);
      }
    };
  }

  Readable.prototype.unpipe = function (dest) {
    var state = this._readableState;

    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;

    // just one destination.  most common case.
    if (state.pipesCount === 1) {
      // passed in one, but it's not the right one.
      if (dest && dest !== state.pipes) return this;

      if (!dest) dest = state.pipes;

      // got a match.
      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;
      if (dest) dest.emit('unpipe', this);
      return this;
    }

    // slow case. multiple pipe destinations.

    if (!dest) {
      // remove all.
      var dests = state.pipes;
      var len = state.pipesCount;
      state.pipes = null;
      state.pipesCount = 0;
      state.flowing = false;

      for (var _i = 0; _i < len; _i++) {
        dests[_i].emit('unpipe', this);
      }return this;
    }

    // try to find the right one.
    var i = indexOf(state.pipes, dest);
    if (i === -1) return this;

    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];

    dest.emit('unpipe', this);

    return this;
  };

  // set up data events if they are asked for
  // Ensure readable listeners eventually get something
  Readable.prototype.on = function (ev, fn) {
    var res = EventEmitter.prototype.on.call(this, ev, fn);

    if (ev === 'data') {
      // Start flowing on next tick if stream isn't explicitly paused
      if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
      var state = this._readableState;
      if (!state.endEmitted && !state.readableListening) {
        state.readableListening = state.needReadable = true;
        state.emittedReadable = false;
        if (!state.reading) {
          nextTick(nReadingNextTick, this);
        } else if (state.length) {
          emitReadable(this);
        }
      }
    }

    return res;
  };
  Readable.prototype.addListener = Readable.prototype.on;

  function nReadingNextTick(self) {
    debug('readable nexttick read 0');
    self.read(0);
  }

  // pause() and resume() are remnants of the legacy readable stream API
  // If the user uses them, then switch into old mode.
  Readable.prototype.resume = function () {
    var state = this._readableState;
    if (!state.flowing) {
      debug('resume');
      state.flowing = true;
      resume(this, state);
    }
    return this;
  };

  function resume(stream, state) {
    if (!state.resumeScheduled) {
      state.resumeScheduled = true;
      nextTick(resume_, stream, state);
    }
  }

  function resume_(stream, state) {
    if (!state.reading) {
      debug('resume read 0');
      stream.read(0);
    }

    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
  }

  Readable.prototype.pause = function () {
    debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
      debug('pause');
      this._readableState.flowing = false;
      this.emit('pause');
    }
    return this;
  };

  function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);
    while (state.flowing && stream.read() !== null) {}
  }

  // wrap an old-style stream as the async data source.
  // This is *not* part of the readable stream interface.
  // It is an ugly unfortunate mess of history.
  Readable.prototype.wrap = function (stream) {
    var state = this._readableState;
    var paused = false;

    var self = this;
    stream.on('end', function () {
      debug('wrapped end');
      if (state.decoder && !state.ended) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) self.push(chunk);
      }

      self.push(null);
    });

    stream.on('data', function (chunk) {
      debug('wrapped data');
      if (state.decoder) chunk = state.decoder.write(chunk);

      // don't skip over falsy values in objectMode
      if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

      var ret = self.push(chunk);
      if (!ret) {
        paused = true;
        stream.pause();
      }
    });

    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for (var i in stream) {
      if (this[i] === undefined && typeof stream[i] === 'function') {
        this[i] = function (method) {
          return function () {
            return stream[method].apply(stream, arguments);
          };
        }(i);
      }
    }

    // proxy certain important events.
    var events = ['error', 'close', 'destroy', 'pause', 'resume'];
    forEach(events, function (ev) {
      stream.on(ev, self.emit.bind(self, ev));
    });

    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self._read = function (n) {
      debug('wrapped _read', n);
      if (paused) {
        paused = false;
        stream.resume();
      }
    };

    return self;
  };

  // exposed for testing purposes only.
  Readable._fromList = fromList;

  // Pluck off n bytes from an array of buffers.
  // Length is the combined lengths of all the buffers in the list.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;

    var ret;
    if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
      // read it all, truncate the list
      if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
      state.buffer.clear();
    } else {
      // read part of list
      ret = fromListPartial(n, state.buffer, state.decoder);
    }

    return ret;
  }

  // Extracts only enough buffered data to satisfy the amount requested.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
      // slice is the same for buffers and strings
      ret = list.head.data.slice(0, n);
      list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) {
      // first chunk is a perfect match
      ret = list.shift();
    } else {
      // result spans more than one buffer
      ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    }
    return ret;
  }

  // Copies a specified amount of characters from the list of buffered data
  // chunks.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while (p = p.next) {
      var str = p.data;
      var nb = n > str.length ? str.length : n;
      if (nb === str.length) ret += str;else ret += str.slice(0, n);
      n -= nb;
      if (n === 0) {
        if (nb === str.length) {
          ++c;
          if (p.next) list.head = p.next;else list.head = list.tail = null;
        } else {
          list.head = p;
          p.data = str.slice(nb);
        }
        break;
      }
      ++c;
    }
    list.length -= c;
    return ret;
  }

  // Copies a specified amount of bytes from the list of buffered data chunks.
  // This function is designed to be inlinable, so please take care when making
  // changes to the function body.
  function copyFromBuffer(n, list) {
    var ret = Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while (p = p.next) {
      var buf = p.data;
      var nb = n > buf.length ? buf.length : n;
      buf.copy(ret, ret.length - n, 0, nb);
      n -= nb;
      if (n === 0) {
        if (nb === buf.length) {
          ++c;
          if (p.next) list.head = p.next;else list.head = list.tail = null;
        } else {
          list.head = p;
          p.data = buf.slice(nb);
        }
        break;
      }
      ++c;
    }
    list.length -= c;
    return ret;
  }

  function endReadable(stream) {
    var state = stream._readableState;

    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

    if (!state.endEmitted) {
      state.ended = true;
      nextTick(endReadableNT, state, stream);
    }
  }

  function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
      state.endEmitted = true;
      stream.readable = false;
      stream.emit('end');
    }
  }

  function forEach(xs, f) {
    for (var i = 0, l = xs.length; i < l; i++) {
      f(xs[i], i);
    }
  }

  function indexOf(xs, x) {
    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) return i;
    }
    return -1;
  }

  // A bit simpler than readable streams.
  Writable.WritableState = WritableState;
  inherits$1(Writable, EventEmitter);

  function nop() {}

  function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
  }

  function WritableState(options, stream) {
    Object.defineProperty(this, 'buffer', {
      get: deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
    options = options || {};

    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;

    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16 * 1024;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

    // cast to ints.
    this.highWaterMark = ~ ~this.highWaterMark;

    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;

    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;

    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';

    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;

    // a flag to see when we're in the middle of a write.
    this.writing = false;

    // when true all writes will be buffered until .uncork() call
    this.corked = 0;

    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;

    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;

    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function (er) {
      onwrite(stream, er);
    };

    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;

    // the amount that is being written when _write is called.
    this.writelen = 0;

    this.bufferedRequest = null;
    this.lastBufferedRequest = null;

    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;

    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;

    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;

    // count buffered requests
    this.bufferedRequestCount = 0;

    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
  }

  WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while (current) {
      out.push(current);
      current = current.next;
    }
    return out;
  };
  function Writable(options) {

    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

    this._writableState = new WritableState(options, this);

    // legacy.
    this.writable = true;

    if (options) {
      if (typeof options.write === 'function') this._write = options.write;

      if (typeof options.writev === 'function') this._writev = options.writev;
    }

    EventEmitter.call(this);
  }

  // Otherwise people can pipe Writable streams, which is just wrong.
  Writable.prototype.pipe = function () {
    this.emit('error', new Error('Cannot pipe, not readable'));
  };

  function writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    nextTick(cb, er);
  }

  // If we get something that is not a buffer, string, null, or undefined,
  // and we're not in objectMode, then that's an error.
  // Otherwise stream chunks are all considered to be of length=1, and the
  // watermarks determine how many objects to keep in the buffer, rather than
  // how many bytes or characters.
  function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) {
      er = new TypeError('May not write null values to stream');
    } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
      er = new TypeError('Invalid non-string/buffer chunk');
    }
    if (er) {
      stream.emit('error', er);
      nextTick(cb, er);
      valid = false;
    }
    return valid;
  }

  Writable.prototype.write = function (chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;

    if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

    if (typeof cb !== 'function') cb = nop;

    if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
      state.pendingcb++;
      ret = writeOrBuffer(this, state, chunk, encoding, cb);
    }

    return ret;
  };

  Writable.prototype.cork = function () {
    var state = this._writableState;

    state.corked++;
  };

  Writable.prototype.uncork = function () {
    var state = this._writableState;

    if (state.corked) {
      state.corked--;

      if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
  };

  Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
  };

  function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
      chunk = Buffer.from(chunk, encoding);
    }
    return chunk;
  }

  // if we're already writing something, then just put this
  // in the queue, and wait our turn.  Otherwise, call _write
  // If we return false, then we need a drain event, so set that flag.
  function writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = decodeChunk(state, chunk, encoding);

    if (Buffer.isBuffer(chunk)) encoding = 'buffer';
    var len = state.objectMode ? 1 : chunk.length;

    state.length += len;

    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;

    if (state.writing || state.corked) {
      var last = state.lastBufferedRequest;
      state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
      if (last) {
        last.next = state.lastBufferedRequest;
      } else {
        state.bufferedRequest = state.lastBufferedRequest;
      }
      state.bufferedRequestCount += 1;
    } else {
      doWrite(stream, state, false, len, chunk, encoding, cb);
    }

    return ret;
  }

  function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
  }

  function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) nextTick(cb, er);else cb(er);

    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  }

  function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
  }

  function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;

    onwriteStateUpdate(state);

    if (er) onwriteError(stream, state, sync, er, cb);else {
      // Check if we're actually ready to finish, but don't emit yet
      var finished = needFinish(state);

      if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
        clearBuffer(stream, state);
      }

      if (sync) {
        /*<replacement>*/
          nextTick(afterWrite, stream, state, finished, cb);
        /*</replacement>*/
      } else {
          afterWrite(stream, state, finished, cb);
        }
    }
  }

  function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
  }

  // Must force callback to be called on nextTick, so that we don't
  // emit 'drain' before the write() consumer gets the 'false' return
  // value, and has a chance to attach a 'drain' listener.
  function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
      state.needDrain = false;
      stream.emit('drain');
    }
  }

  // if there's something in the buffer waiting, then process it
  function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;

    if (stream._writev && entry && entry.next) {
      // Fast case, write everything using _writev()
      var l = state.bufferedRequestCount;
      var buffer = new Array(l);
      var holder = state.corkedRequestsFree;
      holder.entry = entry;

      var count = 0;
      while (entry) {
        buffer[count] = entry;
        entry = entry.next;
        count += 1;
      }

      doWrite(stream, state, true, state.length, buffer, '', holder.finish);

      // doWrite is almost always async, defer these to save a bit of time
      // as the hot path ends with doWrite
      state.pendingcb++;
      state.lastBufferedRequest = null;
      if (holder.next) {
        state.corkedRequestsFree = holder.next;
        holder.next = null;
      } else {
        state.corkedRequestsFree = new CorkedRequest(state);
      }
    } else {
      // Slow case, write chunks one-by-one
      while (entry) {
        var chunk = entry.chunk;
        var encoding = entry.encoding;
        var cb = entry.callback;
        var len = state.objectMode ? 1 : chunk.length;

        doWrite(stream, state, false, len, chunk, encoding, cb);
        entry = entry.next;
        // if we didn't call the onwrite immediately, then
        // it means that we need to wait until it does.
        // also, that means that the chunk and cb are currently
        // being processed, so move the buffer counter past them.
        if (state.writing) {
          break;
        }
      }

      if (entry === null) state.lastBufferedRequest = null;
    }

    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
  }

  Writable.prototype._write = function (chunk, encoding, cb) {
    cb(new Error('not implemented'));
  };

  Writable.prototype._writev = null;

  Writable.prototype.end = function (chunk, encoding, cb) {
    var state = this._writableState;

    if (typeof chunk === 'function') {
      cb = chunk;
      chunk = null;
      encoding = null;
    } else if (typeof encoding === 'function') {
      cb = encoding;
      encoding = null;
    }

    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

    // .end() fully uncorks
    if (state.corked) {
      state.corked = 1;
      this.uncork();
    }

    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) endWritable(this, state, cb);
  };

  function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
  }

  function prefinish(stream, state) {
    if (!state.prefinished) {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }

  function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
      if (state.pendingcb === 0) {
        prefinish(stream, state);
        state.finished = true;
        stream.emit('finish');
      } else {
        prefinish(stream, state);
      }
    }
    return need;
  }

  function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
      if (state.finished) nextTick(cb);else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
  }

  // It seems a linked list but it is not
  // there will be only 2 of these for each stream
  function CorkedRequest(state) {
    var _this = this;

    this.next = null;
    this.entry = null;

    this.finish = function (err) {
      var entry = _this.entry;
      _this.entry = null;
      while (entry) {
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
      }
      if (state.corkedRequestsFree) {
        state.corkedRequestsFree.next = _this;
      } else {
        state.corkedRequestsFree = _this;
      }
    };
  }

  inherits$1(Duplex, Readable);

  var keys = Object.keys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
  function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);

    Readable.call(this, options);
    Writable.call(this, options);

    if (options && options.readable === false) this.readable = false;

    if (options && options.writable === false) this.writable = false;

    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

    this.once('end', onend);
  }

  // the no-half-open enforcer
  function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;

    // no more data can be written.
    // But allow more writes to happen in this tick.
    nextTick(onEndNT, this);
  }

  function onEndNT(self) {
    self.end();
  }

  // a transform stream is a readable/writable stream where you do
  inherits$1(Transform, Duplex);

  function TransformState(stream) {
    this.afterTransform = function (er, data) {
      return afterTransform(stream, er, data);
    };

    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
  }

  function afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;

    var cb = ts.writecb;

    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

    ts.writechunk = null;
    ts.writecb = null;

    if (data !== null && data !== undefined) stream.push(data);

    cb(er);

    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) {
      stream._read(rs.highWaterMark);
    }
  }
  function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);

    Duplex.call(this, options);

    this._transformState = new TransformState(this);

    // when the writable side finishes, then flush out anything remaining.
    var stream = this;

    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;

    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;

    if (options) {
      if (typeof options.transform === 'function') this._transform = options.transform;

      if (typeof options.flush === 'function') this._flush = options.flush;
    }

    this.once('prefinish', function () {
      if (typeof this._flush === 'function') this._flush(function (er) {
        done(stream, er);
      });else done(stream);
    });
  }

  Transform.prototype.push = function (chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
  };

  // This is the part where you do stuff!
  // override this function in implementation classes.
  // 'chunk' is an input chunk.
  //
  // Call `push(newChunk)` to pass along transformed output
  // to the readable side.  You may call 'push' zero or more times.
  //
  // Call `cb(err)` when you are done with this chunk.  If you pass
  // an error, then that'll put the hurt on the whole operation.  If you
  // never call cb(), then you'll never get another chunk.
  Transform.prototype._transform = function (chunk, encoding, cb) {
    throw new Error('Not implemented');
  };

  Transform.prototype._write = function (chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
      var rs = this._readableState;
      if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
  };

  // Doesn't matter what the args are here.
  // _transform does all the work.
  // That we got here means that the readable side wants more data.
  Transform.prototype._read = function (n) {
    var ts = this._transformState;

    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
      ts.transforming = true;
      this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else {
      // mark that we need a transform, so that any data that comes in
      // will get processed, now that we've asked for it.
      ts.needTransform = true;
    }
  };

  function done(stream, er) {
    if (er) return stream.emit('error', er);

    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;

    if (ws.length) throw new Error('Calling transform done when ws.length != 0');

    if (ts.transforming) throw new Error('Calling transform done when still transforming');

    return stream.push(null);
  }

  inherits$1(PassThrough, Transform);
  function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);

    Transform.call(this, options);
  }

  PassThrough.prototype._transform = function (chunk, encoding, cb) {
    cb(null, chunk);
  };

  inherits$1(Stream, EventEmitter);
  Stream.Readable = Readable;
  Stream.Writable = Writable;
  Stream.Duplex = Duplex;
  Stream.Transform = Transform;
  Stream.PassThrough = PassThrough;

  // Backwards-compat with node 0.4.x
  Stream.Stream = Stream;

  // old-style streams.  Note that the pipe method (the only relevant
  // part of this class) is overridden in the Readable class.

  function Stream() {
    EventEmitter.call(this);
  }

  Stream.prototype.pipe = function(dest, options) {
    var source = this;

    function ondata(chunk) {
      if (dest.writable) {
        if (false === dest.write(chunk) && source.pause) {
          source.pause();
        }
      }
    }

    source.on('data', ondata);

    function ondrain() {
      if (source.readable && source.resume) {
        source.resume();
      }
    }

    dest.on('drain', ondrain);

    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
      source.on('end', onend);
      source.on('close', onclose);
    }

    var didOnEnd = false;
    function onend() {
      if (didOnEnd) return;
      didOnEnd = true;

      dest.end();
    }


    function onclose() {
      if (didOnEnd) return;
      didOnEnd = true;

      if (typeof dest.destroy === 'function') dest.destroy();
    }

    // don't leave dangling pipes when there are errors.
    function onerror(er) {
      cleanup();
      if (EventEmitter.listenerCount(this, 'error') === 0) {
        throw er; // Unhandled stream error in pipe.
      }
    }

    source.on('error', onerror);
    dest.on('error', onerror);

    // remove all the event listeners that were added.
    function cleanup() {
      source.removeListener('data', ondata);
      dest.removeListener('drain', ondrain);

      source.removeListener('end', onend);
      source.removeListener('close', onclose);

      source.removeListener('error', onerror);
      dest.removeListener('error', onerror);

      source.removeListener('end', cleanup);
      source.removeListener('close', cleanup);

      dest.removeListener('close', cleanup);
    }

    source.on('end', cleanup);
    source.on('close', cleanup);

    dest.on('close', cleanup);

    dest.emit('pipe', source);

    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
  };

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  /*
  The MIT License (MIT)

  Copyright (c) 2016 CoderPuppy

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  */
  var _endianness;
  function endianness() {
    if (typeof _endianness === 'undefined') {
      var a = new ArrayBuffer(2);
      var b = new Uint8Array(a);
      var c = new Uint16Array(a);
      b[0] = 1;
      b[1] = 2;
      if (c[0] === 258) {
        _endianness = 'BE';
      } else if (c[0] === 513){
        _endianness = 'LE';
      } else {
        throw new Error('unable to figure out endianess');
      }
    }
    return _endianness;
  }

  function hostname() {
    if (typeof global$1.location !== 'undefined') {
      return global$1.location.hostname
    } else return '';
  }

  function loadavg() {
    return [];
  }

  function uptime() {
    return 0;
  }

  function freemem() {
    return Number.MAX_VALUE;
  }

  function totalmem() {
    return Number.MAX_VALUE;
  }

  function cpus() {
    return [];
  }

  function type() {
    return 'Browser';
  }

  function release () {
    if (typeof global$1.navigator !== 'undefined') {
      return global$1.navigator.appVersion;
    }
    return '';
  }

  function networkInterfaces(){}
  function getNetworkInterfaces(){}

  function tmpDir() {
    return '/tmp';
  }
  var tmpdir = tmpDir;

  var EOL = '\n';
  var os = {
    EOL: EOL,
    tmpdir: tmpdir,
    tmpDir: tmpDir,
    networkInterfaces:networkInterfaces,
    getNetworkInterfaces: getNetworkInterfaces,
    release: release,
    type: type,
    cpus: cpus,
    totalmem: totalmem,
    freemem: freemem,
    uptime: uptime,
    loadavg: loadavg,
    hostname: hostname,
    endianness: endianness,
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** `Object#toString` result references. */
  var funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      symbolTag = '[object Symbol]';

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */
  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }
    return result;
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var objectToString$1 = objectProto.toString;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /** Built-in value references. */
  var Symbol$1 = root.Symbol,
      splice = arrayProto.splice;

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash,
      'map': new (Map || ListCache),
      'string': new Hash
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);

    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject$1(value) || isMasked(value)) {
      return false;
    }
    var pattern = (isFunction$1(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value) {
    return isArray$2(value) ? value : stringToPath(value);
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray$2(value)) {
      return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
      (object != null && value in Object(object));
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoize(function(string) {
    string = toString$1(string);

    var result = [];
    if (reLeadingDot.test(string)) {
      result.push('');
    }
    string.replace(rePropName, function(match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
  });

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
  }

  // Assign cache to `_.memoize`.
  memoize.Cache = MapCache;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray$2 = Array.isArray;

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction$1(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject$1(value) ? objectToString$1.call(value) : '';
    return tag == funcTag || tag == genTag;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject$1(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' ||
      (isObjectLike(value) && objectToString$1.call(value) == symbolTag);
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString$1(value) {
    return value == null ? '' : baseToString(value);
  }

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  var lodash_get = get;

  function getProp(obj, path, defaultValue) {
    return obj[path] === undefined ? defaultValue : obj[path];
  }

  function setProp(obj, path, value) {
    var pathArray = Array.isArray(path) ? path : path.split('.');

    var _pathArray = _toArray(pathArray),
        key = _pathArray[0],
        restPath = _pathArray.slice(1);

    return _objectSpread({}, obj, _defineProperty({}, key, pathArray.length > 1 ? setProp(obj[key] || {}, restPath, value) : value));
  }

  function unsetProp(obj, path) {
    var pathArray = Array.isArray(path) ? path : path.split('.');

    var _pathArray2 = _toArray(pathArray),
        key = _pathArray2[0],
        restPath = _pathArray2.slice(1);

    if (_typeof(obj[key]) !== 'object') {
      // This will never be hit in the current code because unwind does the check before calling unsetProp

      /* istanbul ignore next */
      return obj;
    }

    if (pathArray.length === 1) {
      return Object.keys(obj).filter(function (prop) {
        return prop !== key;
      }).reduce(function (acc, prop) {
        return Object.assign(acc, _defineProperty({}, prop, obj[prop]));
      }, {});
    }

    return Object.keys(obj).reduce(function (acc, prop) {
      return _objectSpread({}, acc, _defineProperty({}, prop, prop !== key ? obj[prop] : unsetProp(obj[key], restPath)));
    }, {});
  }

  function flattenReducer(acc, arr) {
    try {
      // This is faster but susceptible to `RangeError: Maximum call stack size exceeded`
      acc.push.apply(acc, _toConsumableArray(arr));
      return acc;
    } catch (err) {
      // Fallback to a slower but safer option
      return acc.concat(arr);
    }
  }

  function fastJoin(arr, separator) {
    var isFirst = true;
    return arr.reduce(function (acc, elem) {
      if (elem === null || elem === undefined) {
        elem = '';
      }

      if (isFirst) {
        isFirst = false;
        return "".concat(elem);
      }

      return "".concat(acc).concat(separator).concat(elem);
    }, '');
  }

  var utils = {
    getProp: getProp,
    setProp: setProp,
    unsetProp: unsetProp,
    fastJoin: fastJoin,
    flattenReducer: flattenReducer
  };

  var getProp$1 = utils.getProp,
      fastJoin$1 = utils.fastJoin,
      flattenReducer$1 = utils.flattenReducer;

  var JSON2CSVBase =
  /*#__PURE__*/
  function () {
    function JSON2CSVBase(opts) {
      _classCallCheck(this, JSON2CSVBase);

      this.opts = this.preprocessOpts(opts);
    }
    /**
     * Check passing opts and set defaults.
     *
     * @param {Json2CsvOptions} opts Options object containing fields,
     * delimiter, default value, quote mark, header, etc.
     */


    _createClass(JSON2CSVBase, [{
      key: "preprocessOpts",
      value: function preprocessOpts(opts) {
        var processedOpts = Object.assign({}, opts);
        processedOpts.transforms = !Array.isArray(processedOpts.transforms) ? processedOpts.transforms ? [processedOpts.transforms] : [] : processedOpts.transforms;
        processedOpts.delimiter = processedOpts.delimiter || ',';
        processedOpts.eol = processedOpts.eol || os.EOL;
        processedOpts.quote = typeof processedOpts.quote === 'string' ? processedOpts.quote : '"';
        processedOpts.escapedQuote = typeof processedOpts.escapedQuote === 'string' ? processedOpts.escapedQuote : "".concat(processedOpts.quote).concat(processedOpts.quote);
        processedOpts.header = processedOpts.header !== false;
        processedOpts.includeEmptyRows = processedOpts.includeEmptyRows || false;
        processedOpts.withBOM = processedOpts.withBOM || false;
        return processedOpts;
      }
      /**
       * Check and normalize the fields configuration.
       *
       * @param {(string|object)[]} fields Fields configuration provided by the user
       * or inferred from the data
       * @returns {object[]} preprocessed FieldsInfo array
       */

    }, {
      key: "preprocessFieldsInfo",
      value: function preprocessFieldsInfo(fields) {
        var _this = this;

        return fields.map(function (fieldInfo) {
          if (typeof fieldInfo === 'string') {
            return {
              label: fieldInfo,
              value: fieldInfo.includes('.') || fieldInfo.includes('[') ? function (row) {
                return lodash_get(row, fieldInfo, _this.opts.defaultValue);
              } : function (row) {
                return getProp$1(row, fieldInfo, _this.opts.defaultValue);
              }
            };
          }

          if (_typeof(fieldInfo) === 'object') {
            var defaultValue = 'default' in fieldInfo ? fieldInfo.default : _this.opts.defaultValue;

            if (typeof fieldInfo.value === 'string') {
              return {
                label: fieldInfo.label || fieldInfo.value,
                value: fieldInfo.value.includes('.') || fieldInfo.value.includes('[') ? function (row) {
                  return lodash_get(row, fieldInfo.value, defaultValue);
                } : function (row) {
                  return getProp$1(row, fieldInfo.value, defaultValue);
                }
              };
            }

            if (typeof fieldInfo.value === 'function') {
              var label = fieldInfo.label || fieldInfo.value.name || '';
              var field = {
                label: label,
                default: defaultValue
              };
              return {
                label: label,
                value: function value(row) {
                  var value = fieldInfo.value(row, field);
                  return value === null || value === undefined ? defaultValue : value;
                }
              };
            }
          }

          throw new Error('Invalid field info option. ' + JSON.stringify(fieldInfo));
        });
      }
      /**
       * Create the title row with all the provided fields as column headings
       *
       * @returns {String} titles as a string
       */

    }, {
      key: "getHeader",
      value: function getHeader() {
        var _this2 = this;

        return fastJoin$1(this.opts.fields.map(function (fieldInfo) {
          return _this2.processValue(fieldInfo.label);
        }), this.opts.delimiter);
      }
      /**
       * Preprocess each object according to the given transforms (unwind, flatten, etc.).
       * @param {Object} row JSON object to be converted in a CSV row
       */

    }, {
      key: "preprocessRow",
      value: function preprocessRow(row) {
        return this.opts.transforms.reduce(function (rows, transform) {
          return rows.map(function (row) {
            return transform(row);
          }).reduce(flattenReducer$1, []);
        }, [row]);
      }
      /**
       * Create the content of a specific CSV row
       *
       * @param {Object} row JSON object to be converted in a CSV row
       * @returns {String} CSV string (row)
       */

    }, {
      key: "processRow",
      value: function processRow(row) {
        var _this3 = this;

        if (!row) {
          return undefined;
        }

        var processedRow = this.opts.fields.map(function (fieldInfo) {
          return _this3.processCell(row, fieldInfo);
        });

        if (!this.opts.includeEmptyRows && processedRow.every(function (field) {
          return field === undefined;
        })) {
          return undefined;
        }

        return fastJoin$1(processedRow, this.opts.delimiter);
      }
      /**
       * Create the content of a specfic CSV row cell
       *
       * @param {Object} row JSON object representing the  CSV row that the cell belongs to
       * @param {FieldInfo} fieldInfo Details of the field to process to be a CSV cell
       * @returns {String} CSV string (cell)
       */

    }, {
      key: "processCell",
      value: function processCell(row, fieldInfo) {
        return this.processValue(fieldInfo.value(row));
      }
      /**
       * Create the content of a specfic CSV row cell
       *
       * @param {Any} value Value to be included in a CSV cell
       * @returns {String} Value stringified and processed
       */

    }, {
      key: "processValue",
      value: function processValue(value) {
        if (value === null || value === undefined) {
          return undefined;
        }

        var valueType = _typeof(value);

        if (valueType !== 'boolean' && valueType !== 'number' && valueType !== 'string') {
          value = JSON.stringify(value);

          if (value === undefined) {
            return undefined;
          }

          if (value[0] === '"') {
            value = value.replace(/^"(.+)"$/, '$1');
          }
        }

        if (typeof value === 'string') {
          if (this.opts.excelStrings) {
            if (value.includes(this.opts.quote)) {
              value = value.replace(new RegExp(this.opts.quote, 'g'), "".concat(this.opts.escapedQuote).concat(this.opts.escapedQuote));
            }

            value = "\"=\"\"".concat(value, "\"\"\"");
          } else {
            if (value.includes(this.opts.quote)) {
              value = value.replace(new RegExp(this.opts.quote, 'g'), this.opts.escapedQuote);
            }

            value = "".concat(this.opts.quote).concat(value).concat(this.opts.quote);
          }
        }

        return value;
      }
    }]);

    return JSON2CSVBase;
  }();

  var JSON2CSVBase_1 = JSON2CSVBase;

  var fastJoin$2 = utils.fastJoin,
      flattenReducer$2 = utils.flattenReducer;

  var JSON2CSVParser =
  /*#__PURE__*/
  function (_JSON2CSVBase) {
    _inherits(JSON2CSVParser, _JSON2CSVBase);

    function JSON2CSVParser(opts) {
      var _this;

      _classCallCheck(this, JSON2CSVParser);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVParser).call(this, opts));

      if (_this.opts.fields) {
        _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);
      }

      return _this;
    }
    /**
     * Main function that converts json to csv.
     *
     * @param {Array|Object} data Array of JSON objects to be converted to CSV
     * @returns {String} The CSV formated data as a string
     */


    _createClass(JSON2CSVParser, [{
      key: "parse",
      value: function parse(data) {
        var processedData = this.preprocessData(data);

        if (!this.opts.fields) {
          this.opts.fields = processedData.reduce(function (fields, item) {
            Object.keys(item).forEach(function (field) {
              if (!fields.includes(field)) {
                fields.push(field);
              }
            });
            return fields;
          }, []);
          this.opts.fields = this.preprocessFieldsInfo(this.opts.fields);
        }

        var header = this.opts.header ? this.getHeader() : '';
        var rows = this.processData(processedData);
        var csv = (this.opts.withBOM ? "\uFEFF" : '') + header + (header && rows ? this.opts.eol : '') + rows;
        return csv;
      }
      /**
       * Preprocess the data according to the give opts (unwind, flatten, etc.)
        and calculate the fields and field names if they are not provided.
       *
       * @param {Array|Object} data Array or object to be converted to CSV
       */

    }, {
      key: "preprocessData",
      value: function preprocessData(data) {
        var _this2 = this;

        var processedData = Array.isArray(data) ? data : [data];

        if (!this.opts.fields && (processedData.length === 0 || _typeof(processedData[0]) !== 'object')) {
          throw new Error('Data should not be empty or the "fields" option should be included');
        }

        if (this.opts.transforms.length === 0) return processedData;
        return processedData.map(function (row) {
          return _this2.preprocessRow(row);
        }).reduce(flattenReducer$2, []);
      }
      /**
       * Create the content row by row below the header
       *
       * @param {Array} data Array of JSON objects to be converted to CSV
       * @returns {String} CSV string (body)
       */

    }, {
      key: "processData",
      value: function processData(data) {
        var _this3 = this;

        return fastJoin$2(data.map(function (row) {
          return _this3.processRow(row);
        }).filter(function (row) {
          return row;
        }), // Filter empty rows
        this.opts.eol);
      }
    }]);

    return JSON2CSVParser;
  }(JSON2CSVBase_1);

  var JSON2CSVParser_1 = JSON2CSVParser;

  /*global Buffer*/
  // Named constants with unique integer values
  var C = {};
  // Tokens
  var LEFT_BRACE    = C.LEFT_BRACE    = 0x1;
  var RIGHT_BRACE   = C.RIGHT_BRACE   = 0x2;
  var LEFT_BRACKET  = C.LEFT_BRACKET  = 0x3;
  var RIGHT_BRACKET = C.RIGHT_BRACKET = 0x4;
  var COLON         = C.COLON         = 0x5;
  var COMMA         = C.COMMA         = 0x6;
  var TRUE          = C.TRUE          = 0x7;
  var FALSE         = C.FALSE         = 0x8;
  var NULL          = C.NULL          = 0x9;
  var STRING        = C.STRING        = 0xa;
  var NUMBER        = C.NUMBER        = 0xb;
  // Tokenizer States
  var START   = C.START   = 0x11;
  var STOP    = C.STOP    = 0x12;
  var TRUE1   = C.TRUE1   = 0x21;
  var TRUE2   = C.TRUE2   = 0x22;
  var TRUE3   = C.TRUE3   = 0x23;
  var FALSE1  = C.FALSE1  = 0x31;
  var FALSE2  = C.FALSE2  = 0x32;
  var FALSE3  = C.FALSE3  = 0x33;
  var FALSE4  = C.FALSE4  = 0x34;
  var NULL1   = C.NULL1   = 0x41;
  var NULL2   = C.NULL2   = 0x42;
  var NULL3   = C.NULL3   = 0x43;
  var NUMBER1 = C.NUMBER1 = 0x51;
  var NUMBER3 = C.NUMBER3 = 0x53;
  var STRING1 = C.STRING1 = 0x61;
  var STRING2 = C.STRING2 = 0x62;
  var STRING3 = C.STRING3 = 0x63;
  var STRING4 = C.STRING4 = 0x64;
  var STRING5 = C.STRING5 = 0x65;
  var STRING6 = C.STRING6 = 0x66;
  // Parser States
  var VALUE   = C.VALUE   = 0x71;
  var KEY     = C.KEY     = 0x72;
  // Parser Modes
  var OBJECT  = C.OBJECT  = 0x81;
  var ARRAY   = C.ARRAY   = 0x82;
  // Character constants
  var BACK_SLASH =      "\\".charCodeAt(0);
  var FORWARD_SLASH =   "\/".charCodeAt(0);
  var BACKSPACE =       "\b".charCodeAt(0);
  var FORM_FEED =       "\f".charCodeAt(0);
  var NEWLINE =         "\n".charCodeAt(0);
  var CARRIAGE_RETURN = "\r".charCodeAt(0);
  var TAB =             "\t".charCodeAt(0);

  var STRING_BUFFER_SIZE = 64 * 1024;

  function Parser() {
    this.tState = START;
    this.value = undefined;

    this.string = undefined; // string data
    this.stringBuffer = Buffer.alloc ? Buffer.alloc(STRING_BUFFER_SIZE) : new Buffer(STRING_BUFFER_SIZE);
    this.stringBufferOffset = 0;
    this.unicode = undefined; // unicode escapes
    this.highSurrogate = undefined;

    this.key = undefined;
    this.mode = undefined;
    this.stack = [];
    this.state = VALUE;
    this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
    this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
    this.temp_buffs = { "2": new Buffer(2), "3": new Buffer(3), "4": new Buffer(4) }; // for rebuilding chars split before boundary is reached

    // Stream offset
    this.offset = -1;
  }

  // Slow code to string converter (only used when throwing syntax errors)
  Parser.toknam = function (code) {
    var keys = Object.keys(C);
    for (var i = 0, l = keys.length; i < l; i++) {
      var key = keys[i];
      if (C[key] === code) { return key; }
    }
    return code && ("0x" + code.toString(16));
  };

  var proto = Parser.prototype;
  proto.onError = function (err) { throw err; };
  proto.charError = function (buffer, i) {
    this.tState = STOP;
    this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + Parser.toknam(this.tState)));
  };
  proto.appendStringChar = function (char) {
    if (this.stringBufferOffset >= STRING_BUFFER_SIZE) {
      this.string += this.stringBuffer.toString('utf8');
      this.stringBufferOffset = 0;
    }

    this.stringBuffer[this.stringBufferOffset++] = char;
  };
  proto.appendStringBuf = function (buf, start, end) {
    var size = buf.length;
    if (typeof start === 'number') {
      if (typeof end === 'number') {
        if (end < 0) {
          // adding a negative end decreeses the size
          size = buf.length - start + end;
        } else {
          size = end - start;
        }
      } else {
        size = buf.length - start;
      }
    }

    if (size < 0) {
      size = 0;
    }

    if (this.stringBufferOffset + size > STRING_BUFFER_SIZE) {
      this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
      this.stringBufferOffset = 0;
    }

    buf.copy(this.stringBuffer, this.stringBufferOffset, start, end);
    this.stringBufferOffset += size;
  };
  proto.write = function (buffer) {
    if (typeof buffer === "string") buffer = new Buffer(buffer);
    var n;
    for (var i = 0, l = buffer.length; i < l; i++) {
      if (this.tState === START){
        n = buffer[i];
        this.offset++;
        if(n === 0x7b){ this.onToken(LEFT_BRACE, "{"); // {
        }else if(n === 0x7d){ this.onToken(RIGHT_BRACE, "}"); // }
        }else if(n === 0x5b){ this.onToken(LEFT_BRACKET, "["); // [
        }else if(n === 0x5d){ this.onToken(RIGHT_BRACKET, "]"); // ]
        }else if(n === 0x3a){ this.onToken(COLON, ":");  // :
        }else if(n === 0x2c){ this.onToken(COMMA, ","); // ,
        }else if(n === 0x74){ this.tState = TRUE1;  // t
        }else if(n === 0x66){ this.tState = FALSE1;  // f
        }else if(n === 0x6e){ this.tState = NULL1; // n
        }else if(n === 0x22){ // "
          this.string = "";
          this.stringBufferOffset = 0;
          this.tState = STRING1;
        }else if(n === 0x2d){ this.string = "-"; this.tState = NUMBER1; // -
        }else{
          if (n >= 0x30 && n < 0x40) { // 1-9
            this.string = String.fromCharCode(n); this.tState = NUMBER3;
          } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) ; else {
            return this.charError(buffer, i);
          }
        }
      }else if (this.tState === STRING1){ // After open quote
        n = buffer[i]; // get current byte from buffer
        // check for carry over of a multi byte char split between data chunks
        // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
        if (this.bytes_remaining > 0) {
          for (var j = 0; j < this.bytes_remaining; j++) {
            this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
          }

          this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]);
          this.bytes_in_sequence = this.bytes_remaining = 0;
          i = i + j - 1;
        } else if (this.bytes_remaining === 0 && n >= 128) { // else if no remainder bytes carried over, parse multi byte (>=128) chars one at a time
          if (n <= 193 || n > 244) {
            return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + Parser.toknam(this.tState)));
          }
          if ((n >= 194) && (n <= 223)) this.bytes_in_sequence = 2;
          if ((n >= 224) && (n <= 239)) this.bytes_in_sequence = 3;
          if ((n >= 240) && (n <= 244)) this.bytes_in_sequence = 4;
          if ((this.bytes_in_sequence + i) > buffer.length) { // if bytes needed to complete char fall outside buffer length, we have a boundary split
            for (var k = 0; k <= (buffer.length - 1 - i); k++) {
              this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
            }
            this.bytes_remaining = (i + this.bytes_in_sequence) - buffer.length;
            i = buffer.length - 1;
          } else {
            this.appendStringBuf(buffer, i, i + this.bytes_in_sequence);
            i = i + this.bytes_in_sequence - 1;
          }
        } else if (n === 0x22) {
          this.tState = START;
          this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
          this.stringBufferOffset = 0;
          this.onToken(STRING, this.string);
          this.offset += Buffer.byteLength(this.string, 'utf8') + 1;
          this.string = undefined;
        }
        else if (n === 0x5c) {
          this.tState = STRING2;
        }
        else if (n >= 0x20) { this.appendStringChar(n); }
        else {
            return this.charError(buffer, i);
        }
      }else if (this.tState === STRING2){ // After backslash
        n = buffer[i];
        if(n === 0x22){ this.appendStringChar(n); this.tState = STRING1;
        }else if(n === 0x5c){ this.appendStringChar(BACK_SLASH); this.tState = STRING1;
        }else if(n === 0x2f){ this.appendStringChar(FORWARD_SLASH); this.tState = STRING1;
        }else if(n === 0x62){ this.appendStringChar(BACKSPACE); this.tState = STRING1;
        }else if(n === 0x66){ this.appendStringChar(FORM_FEED); this.tState = STRING1;
        }else if(n === 0x6e){ this.appendStringChar(NEWLINE); this.tState = STRING1;
        }else if(n === 0x72){ this.appendStringChar(CARRIAGE_RETURN); this.tState = STRING1;
        }else if(n === 0x74){ this.appendStringChar(TAB); this.tState = STRING1;
        }else if(n === 0x75){ this.unicode = ""; this.tState = STRING3;
        }else{
          return this.charError(buffer, i);
        }
      }else if (this.tState === STRING3 || this.tState === STRING4 || this.tState === STRING5 || this.tState === STRING6){ // unicode hex codes
        n = buffer[i];
        // 0-9 A-F a-f
        if ((n >= 0x30 && n < 0x40) || (n > 0x40 && n <= 0x46) || (n > 0x60 && n <= 0x66)) {
          this.unicode += String.fromCharCode(n);
          if (this.tState++ === STRING6) {
            var intVal = parseInt(this.unicode, 16);
            this.unicode = undefined;
            if (this.highSurrogate !== undefined && intVal >= 0xDC00 && intVal < (0xDFFF + 1)) { //<56320,57343> - lowSurrogate
              this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate, intVal)));
              this.highSurrogate = undefined;
            } else if (this.highSurrogate === undefined && intVal >= 0xD800 && intVal < (0xDBFF + 1)) { //<55296,56319> - highSurrogate
              this.highSurrogate = intVal;
            } else {
              if (this.highSurrogate !== undefined) {
                this.appendStringBuf(new Buffer(String.fromCharCode(this.highSurrogate)));
                this.highSurrogate = undefined;
              }
              this.appendStringBuf(new Buffer(String.fromCharCode(intVal)));
            }
            this.tState = STRING1;
          }
        } else {
          return this.charError(buffer, i);
        }
      } else if (this.tState === NUMBER1 || this.tState === NUMBER3) {
          n = buffer[i];

          switch (n) {
            case 0x30: // 0
            case 0x31: // 1
            case 0x32: // 2
            case 0x33: // 3
            case 0x34: // 4
            case 0x35: // 5
            case 0x36: // 6
            case 0x37: // 7
            case 0x38: // 8
            case 0x39: // 9
            case 0x2e: // .
            case 0x65: // e
            case 0x45: // E
            case 0x2b: // +
            case 0x2d: // -
              this.string += String.fromCharCode(n);
              this.tState = NUMBER3;
              break;
            default:
              this.tState = START;
              var result = Number(this.string);

              if (isNaN(result)){
                return this.charError(buffer, i);
              }

              if ((this.string.match(/[0-9]+/) == this.string) && (result.toString() != this.string)) {
                // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
                this.onToken(STRING, this.string);
              } else {
                this.onToken(NUMBER, result);
              }

              this.offset += this.string.length - 1;
              this.string = undefined;
              i--;
              break;
          }
      }else if (this.tState === TRUE1){ // r
        if (buffer[i] === 0x72) { this.tState = TRUE2; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === TRUE2){ // u
        if (buffer[i] === 0x75) { this.tState = TRUE3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === TRUE3){ // e
        if (buffer[i] === 0x65) { this.tState = START; this.onToken(TRUE, true); this.offset+= 3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE1){ // a
        if (buffer[i] === 0x61) { this.tState = FALSE2; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE2){ // l
        if (buffer[i] === 0x6c) { this.tState = FALSE3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE3){ // s
        if (buffer[i] === 0x73) { this.tState = FALSE4; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === FALSE4){ // e
        if (buffer[i] === 0x65) { this.tState = START; this.onToken(FALSE, false); this.offset+= 4; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === NULL1){ // u
        if (buffer[i] === 0x75) { this.tState = NULL2; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === NULL2){ // l
        if (buffer[i] === 0x6c) { this.tState = NULL3; }
        else { return this.charError(buffer, i); }
      }else if (this.tState === NULL3){ // l
        if (buffer[i] === 0x6c) { this.tState = START; this.onToken(NULL, null); this.offset += 3; }
        else { return this.charError(buffer, i); }
      }
    }
  };
  proto.onToken = function (token, value) {
    // Override this to get events
  };

  proto.parseError = function (token, value) {
    this.tState = STOP;
    this.onError(new Error("Unexpected " + Parser.toknam(token) + (value ? ("(" + JSON.stringify(value) + ")") : "") + " in state " + Parser.toknam(this.state)));
  };
  proto.push = function () {
    this.stack.push({value: this.value, key: this.key, mode: this.mode});
  };
  proto.pop = function () {
    var value = this.value;
    var parent = this.stack.pop();
    this.value = parent.value;
    this.key = parent.key;
    this.mode = parent.mode;
    this.emit(value);
    if (!this.mode) { this.state = VALUE; }
  };
  proto.emit = function (value) {
    if (this.mode) { this.state = COMMA; }
    this.onValue(value);
  };
  proto.onValue = function (value) {
    // Override me
  };
  proto.onToken = function (token, value) {
    if(this.state === VALUE){
      if(token === STRING || token === NUMBER || token === TRUE || token === FALSE || token === NULL){
        if (this.value) {
          this.value[this.key] = value;
        }
        this.emit(value);
      }else if(token === LEFT_BRACE){
        this.push();
        if (this.value) {
          this.value = this.value[this.key] = {};
        } else {
          this.value = {};
        }
        this.key = undefined;
        this.state = KEY;
        this.mode = OBJECT;
      }else if(token === LEFT_BRACKET){
        this.push();
        if (this.value) {
          this.value = this.value[this.key] = [];
        } else {
          this.value = [];
        }
        this.key = 0;
        this.mode = ARRAY;
        this.state = VALUE;
      }else if(token === RIGHT_BRACE){
        if (this.mode === OBJECT) {
          this.pop();
        } else {
          return this.parseError(token, value);
        }
      }else if(token === RIGHT_BRACKET){
        if (this.mode === ARRAY) {
          this.pop();
        } else {
          return this.parseError(token, value);
        }
      }else{
        return this.parseError(token, value);
      }
    }else if(this.state === KEY){
      if (token === STRING) {
        this.key = value;
        this.state = COLON;
      } else if (token === RIGHT_BRACE) {
        this.pop();
      } else {
        return this.parseError(token, value);
      }
    }else if(this.state === COLON){
      if (token === COLON) { this.state = VALUE; }
      else { return this.parseError(token, value); }
    }else if(this.state === COMMA){
      if (token === COMMA) {
        if (this.mode === ARRAY) { this.key++; this.state = VALUE; }
        else if (this.mode === OBJECT) { this.state = KEY; }

      } else if (token === RIGHT_BRACKET && this.mode === ARRAY || token === RIGHT_BRACE && this.mode === OBJECT) {
        this.pop();
      } else {
        return this.parseError(token, value);
      }
    }else{
      return this.parseError(token, value);
    }
  };

  Parser.C = C;

  var jsonparse = Parser;

  var Transform$1 = Stream.Transform;

  var JSON2CSVTransform =
  /*#__PURE__*/
  function (_Transform) {
    _inherits(JSON2CSVTransform, _Transform);

    function JSON2CSVTransform(opts, transformOpts) {
      var _this;

      _classCallCheck(this, JSON2CSVTransform);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(JSON2CSVTransform).call(this, transformOpts)); // Inherit methods from JSON2CSVBase since extends doesn't
      // allow multiple inheritance and manually preprocess opts

      Object.getOwnPropertyNames(JSON2CSVBase_1.prototype).forEach(function (key) {
        return _this[key] = JSON2CSVBase_1.prototype[key];
      });
      _this.opts = _this.preprocessOpts(opts);
      _this._data = '';
      _this._hasWritten = false;

      if (_this._readableState.objectMode) {
        _this.initObjectModeParse();
      } else if (_this.opts.ndjson) {
        _this.initNDJSONParse();
      } else {
        _this.initJSONParser();
      }

      if (_this.opts.withBOM) {
        _this.push("\uFEFF");
      }

      if (_this.opts.fields) {
        _this.opts.fields = _this.preprocessFieldsInfo(_this.opts.fields);

        _this.pushHeader();
      }

      return _this;
    }
    /**
     * Init the transform with a parser to process data in object mode.
     * It receives JSON objects one by one and send them to `pushLine for processing.
     */


    _createClass(JSON2CSVTransform, [{
      key: "initObjectModeParse",
      value: function initObjectModeParse() {
        var transform = this;
        this.parser = {
          write: function write(line) {
            transform.pushLine(line);
          },
          getPendingData: function getPendingData() {
            return undefined;
          }
        };
      }
      /**
       * Init the transform with a parser to process NDJSON data.
       * It maintains a buffer of received data, parses each line
       * as JSON and send it to `pushLine for processing.
       */

    }, {
      key: "initNDJSONParse",
      value: function initNDJSONParse() {
        var transform = this;
        this.parser = {
          _data: '',
          write: function write(chunk) {
            this._data += chunk.toString();

            var lines = this._data.split('\n').map(function (line) {
              return line.trim();
            }).filter(function (line) {
              return line !== '';
            });

            var pendingData = false;
            lines.forEach(function (line, i) {
              try {
                transform.pushLine(JSON.parse(line));
              } catch (e) {
                if (i === lines.length - 1) {
                  pendingData = true;
                } else {
                  e.message = "Invalid JSON (".concat(line, ")");
                  transform.emit('error', e);
                }
              }
            });
            this._data = pendingData ? this._data.slice(this._data.lastIndexOf('\n')) : '';
          },
          getPendingData: function getPendingData() {
            return this._data;
          }
        };
      }
      /**
       * Init the transform with a parser to process JSON data.
       * It maintains a buffer of received data, parses each as JSON 
       * item if the data is an array or the data itself otherwise
       * and send it to `pushLine` for processing.
       */

    }, {
      key: "initJSONParser",
      value: function initJSONParser() {
        var transform = this;
        this.parser = new jsonparse();

        this.parser.onValue = function (value) {
          if (this.stack.length !== this.depthToEmit) return;
          transform.pushLine(value);
        };

        this.parser._onToken = this.parser.onToken;

        this.parser.onToken = function (token, value) {
          transform.parser._onToken(token, value);

          if (this.stack.length === 0 && !transform.opts.fields && this.mode !== jsonparse.C.ARRAY && this.mode !== jsonparse.C.OBJECT) {
            this.onError(new Error('Data should not be empty or the "fields" option should be included'));
          }

          if (this.stack.length === 1) {
            if (this.depthToEmit === undefined) {
              // If Array emit its content, else emit itself
              this.depthToEmit = this.mode === jsonparse.C.ARRAY ? 1 : 0;
            }

            if (this.depthToEmit !== 0 && this.stack.length === 1) {
              // No need to store the whole root array in memory
              this.value = undefined;
            }
          }
        };

        this.parser.getPendingData = function () {
          return this.value;
        };

        this.parser.onError = function (err) {
          if (err.message.includes('Unexpected')) {
            err.message = "Invalid JSON (".concat(err.message, ")");
          }

          transform.emit('error', err);
        };
      }
      /**
       * Main function that send data to the parse to be processed.
       *
       * @param {Buffer} chunk Incoming data
       * @param {String} encoding Encoding of the incoming data. Defaults to 'utf8'
       * @param {Function} done Called when the proceesing of the supplied chunk is done
       */

    }, {
      key: "_transform",
      value: function _transform(chunk, encoding, done) {
        this.parser.write(chunk);
        done();
      }
    }, {
      key: "_flush",
      value: function _flush(done) {
        if (this.parser.getPendingData()) {
          done(new Error('Invalid data received from stdin', this.parser.getPendingData()));
        }

        done();
      }
      /**
       * Generate the csv header and pushes it downstream.
       */

    }, {
      key: "pushHeader",
      value: function pushHeader() {
        if (this.opts.header) {
          var header = this.getHeader();
          this.emit('header', header);
          this.push(header);
          this._hasWritten = true;
        }
      }
      /**
       * Transforms an incoming json data to csv and pushes it downstream.
       *
       * @param {Object} data JSON object to be converted in a CSV row
       */

    }, {
      key: "pushLine",
      value: function pushLine(data) {
        var _this2 = this;

        var processedData = this.preprocessRow(data);

        if (!this._hasWritten) {
          this.opts.fields = this.opts.fields || this.preprocessFieldsInfo(Object.keys(processedData[0]));
          this.pushHeader();
        }

        processedData.forEach(function (row) {
          var line = _this2.processRow(row, _this2.opts);

          if (line === undefined) return;

          _this2.emit('line', line);

          _this2.push(_this2._hasWritten ? _this2.opts.eol + line : line);

          _this2._hasWritten = true;
        });
      }
    }]);

    return JSON2CSVTransform;
  }(Transform$1);

  var JSON2CSVTransform_1 = JSON2CSVTransform;

  var Transform$2 = Stream.Transform;
  var fastJoin$3 = utils.fastJoin;

  var JSON2CSVAsyncParser =
  /*#__PURE__*/
  function () {
    function JSON2CSVAsyncParser(opts, transformOpts) {
      _classCallCheck(this, JSON2CSVAsyncParser);

      this.input = new Transform$2(transformOpts);

      this.input._read = function () {};

      this.transform = new JSON2CSVTransform_1(opts, transformOpts);
      this.processor = this.input.pipe(this.transform);
    }

    _createClass(JSON2CSVAsyncParser, [{
      key: "fromInput",
      value: function fromInput(input) {
        if (this._input) {
          throw new Error('Async parser already has an input.');
        }

        this._input = input;
        this.input = this._input.pipe(this.processor);
        return this;
      }
    }, {
      key: "throughTransform",
      value: function throughTransform(transform) {
        if (this._output) {
          throw new Error('Can\'t add transforms once an output has been added.');
        }

        this.processor = this.processor.pipe(transform);
        return this;
      }
    }, {
      key: "toOutput",
      value: function toOutput(output) {
        if (this._output) {
          throw new Error('Async parser already has an output.');
        }

        this._output = output;
        this.processor = this.processor.pipe(output);
        return this;
      }
    }, {
      key: "promise",
      value: function promise() {
        var _this = this;

        var returnCSV = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return new Promise(function (resolve, reject) {
          if (!returnCSV) {
            _this.processor.on('finish', function () {
              return resolve();
            }).on('error', function (err) {
              return reject(err);
            });

            return;
          }

          var csvBuffer = [];

          _this.processor.on('data', function (chunk) {
            return csvBuffer.push(chunk.toString());
          }).on('finish', function () {
            return resolve(fastJoin$3(csvBuffer, ''));
          }).on('error', function (err) {
            return reject(err);
          });
        });
      }
    }]);

    return JSON2CSVAsyncParser;
  }();

  var JSON2CSVAsyncParser_1 = JSON2CSVAsyncParser;

  /**
   * Performs the flattening of a data row recursively
   *
   * @param {String} separator Separator to be used as the flattened field name
   * @returns {Object => Object} Flattened object
   */
  function flatten() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$objects = _ref.objects,
        objects = _ref$objects === void 0 ? true : _ref$objects,
        _ref$arrays = _ref.arrays,
        arrays = _ref$arrays === void 0 ? false : _ref$arrays,
        _ref$separator = _ref.separator,
        separator = _ref$separator === void 0 ? '.' : _ref$separator;

    function step(obj, flatDataRow, currentPath) {
      Object.keys(obj).forEach(function (key) {
        var newPath = currentPath ? "".concat(currentPath).concat(separator).concat(key) : key;
        var value = obj[key];

        if (objects && _typeof(value) === 'object' && value !== null && !Array.isArray(value) && Object.prototype.toString.call(value.toJSON) !== '[object Function]' && Object.keys(value).length) {
          step(value, flatDataRow, newPath);
          return;
        }

        if (arrays && Array.isArray(value)) {
          step(value, flatDataRow, newPath);
          return;
        }

        flatDataRow[newPath] = value;
      });
      return flatDataRow;
    }

    return function (dataRow) {
      return step(dataRow, {});
    };
  }

  var flatten_1 = flatten;

  var setProp$1 = utils.setProp,
      unsetProp$1 = utils.unsetProp,
      flattenReducer$3 = utils.flattenReducer;

  function getUnwindablePaths(obj, currentPath) {
    return Object.keys(obj).reduce(function (unwindablePaths, key) {
      var newPath = currentPath ? "".concat(currentPath, ".").concat(key) : key;
      var value = obj[key];

      if (_typeof(value) === 'object' && value !== null && !Array.isArray(value) && Object.prototype.toString.call(value.toJSON) !== '[object Function]' && Object.keys(value).length) {
        unwindablePaths = unwindablePaths.concat(getUnwindablePaths(value, newPath));
      } else if (Array.isArray(value)) {
        unwindablePaths.push(newPath);
        unwindablePaths = unwindablePaths.concat(value.map(function (arrObj) {
          return getUnwindablePaths(arrObj, newPath);
        }).reduce(flattenReducer$3, []).filter(function (item, index, arr) {
          return arr.indexOf(item) !== index;
        }));
      }

      return unwindablePaths;
    }, []);
  }
  /**
   * Performs the unwind recursively in specified sequence
   *
   * @param {String[]} unwindPaths The paths as strings to be used to deconstruct the array
   * @returns {Object => Array} Array of objects containing all rows after unwind of chosen paths
  */


  function unwind() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$paths = _ref.paths,
        paths = _ref$paths === void 0 ? undefined : _ref$paths,
        _ref$blankOut = _ref.blankOut,
        blankOut = _ref$blankOut === void 0 ? false : _ref$blankOut;

    function unwindReducer(rows, unwindPath) {
      return rows.map(function (row) {
        var unwindArray = lodash_get(row, unwindPath);

        if (!Array.isArray(unwindArray)) {
          return row;
        }

        if (!unwindArray.length) {
          return unsetProp$1(row, unwindPath);
        }

        return unwindArray.map(function (unwindRow, index) {
          var clonedRow = blankOut && index > 0 ? {} : row;
          return setProp$1(clonedRow, unwindPath, unwindRow);
        });
      }).reduce(flattenReducer$3, []);
    }

    paths = Array.isArray(paths) ? paths : paths ? [paths] : undefined;
    return function (dataRow) {
      return (paths || getUnwindablePaths(dataRow)).reduce(unwindReducer, [dataRow]);
    };
  }

  var unwind_1 = unwind;

  var Readable$1 = Stream.Readable;
  var Parser$1 = JSON2CSVParser_1;
  var AsyncParser = JSON2CSVAsyncParser_1;
  var Transform$3 = JSON2CSVTransform_1; // Convenience method to keep the API similar to version 3.X

  var parse = function parse(data, opts) {
    return new JSON2CSVParser_1(opts).parse(data);
  };

  var parseAsync = function parseAsync(data, opts, transformOpts) {
    try {
      if (!(data instanceof Readable$1)) {
        transformOpts = Object.assign({}, transformOpts, {
          objectMode: true
        });
      }

      var asyncParser = new JSON2CSVAsyncParser_1(opts, transformOpts);
      var promise = asyncParser.promise();

      if (Array.isArray(data)) {
        data.forEach(function (item) {
          return asyncParser.input.push(item);
        });
        asyncParser.input.push(null);
      } else if (data instanceof Readable$1) {
        asyncParser.fromInput(data);
      } else {
        asyncParser.input.push(data);
        asyncParser.input.push(null);
      }

      return promise;
    } catch (err) {
      return Promise.reject(err);
    }
  };

  var transforms = {
    flatten: flatten_1,
    unwind: unwind_1
  };
  var json2csv = {
    Parser: Parser$1,
    AsyncParser: AsyncParser,
    Transform: Transform$3,
    parse: parse,
    parseAsync: parseAsync,
    transforms: transforms
  };

  exports.AsyncParser = AsyncParser;
  exports.Parser = Parser$1;
  exports.Transform = Transform$3;
  exports.default = json2csv;
  exports.parse = parse;
  exports.parseAsync = parseAsync;
  exports.transforms = transforms;

  Object.defineProperty(exports, '__esModule', { value: true });

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)))

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(173)))

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCutPriceGoodsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_simple_pull_to_refresh__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var PipelineCutPriceGoodsList=/*#__PURE__*/function(_React$Component){_inherits(PipelineCutPriceGoodsList,_React$Component);var _super=_createSuper(PipelineCutPriceGoodsList);function PipelineCutPriceGoodsList(props){var _this;_classCallCheck(this,PipelineCutPriceGoodsList);_this=_super.call(this,props);_this.state={update_time:'',list:[],showText:false};return _this;}_createClass(PipelineCutPriceGoodsList,[{key:"componentDidMount",value:function componentDidMount(){var arrObj=window.location.href.split("?");var params={};if(arrObj.length>1){var arrPara=arrObj[1].split("&");var arr;for(var i=0;i<arrPara.length;i++){arr=arrPara[i].split("=");if(arr!=null&&arr[0]){params[arr[0]]=arr[1];}}this.goods_id=params&&params.goods_id||'';this.style_id=params&&params.style_id||'';this.sku_id=params&&params.sku_id||'';}this.getData();// 点击埋点
var options={lego_page_id:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId(),legoAb:this.props.abValue,h5Url:window.location.href};Object(__WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"lego-sales:show:",biz:JSON.stringify(options),pageOptions:options}});}},{key:"getData",value:function getData(){var _this2=this;var isRefresh=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_21_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/goods_price/list?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{is_all:1,list_type:2,page_id:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId()}}).then(function(res){setTimeout(function(){resolve();},1000);if(res.data.status===0){var _ref=res.data.data||{},_ref$update_time=_ref.update_time,update_time=_ref$update_time===void 0?'':_ref$update_time,_ref$goods_list=_ref.goods_list,goods_list=_ref$goods_list===void 0?[]:_ref$goods_list;var list=[];if(isRefresh){list=goods_list;}else{var addIndex=-1;goods_list&&goods_list.map(function(item,index){var goods_id=item.goods_id,style_id=item.style_id,sku_id=item.sku_id;if(goods_id==_this2.goods_id&&style_id==_this2.style_id&&sku_id==_this2.sku_id){addIndex=index;list.push(item);}});if(addIndex==-1){list=list.concat(goods_list);}else{goods_list&&goods_list.map(function(item,index){if(addIndex!=index){list.push(item);}});}}_this2.setState({list:list||[],update_time:update_time,showText:true});}})["catch"](function(res){resolve();});});}},{key:"getDateDifference",value:function getDateDifference(endTime){if(!endTime)return'';//当前时间
var nowTime=__WEBPACK_IMPORTED_MODULE_24_moment___default()(new Date().getTime()).format('YYYY/MM/DD HH:mm:ss');var time=__WEBPACK_IMPORTED_MODULE_24_moment___default()(new Date(endTime.replace(/-/g,'/'))).diff(__WEBPACK_IMPORTED_MODULE_24_moment___default()(nowTime),'days');var day=Math.abs(parseInt(time))||0;if(day==0){return __WEBPACK_IMPORTED_MODULE_24_moment___default()(new Date(endTime.replace(/-/g,'/')).getTime()).format('HH:mm');}else if(day==1){return'昨天'+__WEBPACK_IMPORTED_MODULE_24_moment___default()(new Date(endTime.replace(/-/g,'/')).getTime()).format('HH:mm');}else if(day==2){return'2天前'+__WEBPACK_IMPORTED_MODULE_24_moment___default()(new Date(endTime.replace(/-/g,'/')).getTime()).format('HH:mm');}return endTime;}},{key:"render",value:function render(){var _this3=this;var _this$state=this.state,_this$state$list=_this$state.list,list=_this$state$list===void 0?[]:_this$state$list,_this$state$update_ti=_this$state.update_time,update_time=_this$state$update_ti===void 0?'':_this$state$update_ti,_this$state$showText=_this$state.showText,showText=_this$state$showText===void 0?false:_this$state$showText;var baseConfig=this.props.config.baseConfig;var isIphoneX=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isIphoneX();return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_simple_pull_to_refresh__["a" /* default */],{refreshingContent:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"pulldown-wrapper",style:{paddingTop:isIphoneX?'32px':'18px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221010/aa28dc1214348a5b360be2767f2d8f43.gif"})),onRefresh:/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this3.getData(true);case 2:case"end":return _context.stop();}}},_callee);}))},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({className:"pipeline-cutPriceGoodsList"// id={baseConfig.title}
},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"item-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"top-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"top-one-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221019/5cd88a3a3d835a9a2378fae5dce4e93c.png"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"update-time"},"\u4EF7\u683C\u66F4\u65B0\u4E8E",this.getDateDifference(update_time)||'--')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"top-two-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl('https://static.shihuocdn.cn/admin/files/20221011/35b513c4e89a292c3021a5dfd359224f.png',this.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"content-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"left-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"top-title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221018/d0bae45ce978c4aadc43361870ea8bc6.gif"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"title"},"\u5168\u5546\u54C1\u6839\u636E\u7CFB\u7EDF\u76D1\u63A7\uFF0C\u5B9E\u65F6\u8C03\u4EF7")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"top-desc"},"\u4E25\u9009\u6B63\u54C1 \xB7 \u6709\u9519\u5FC5\u8D54 \xB7 \u552E\u540E\u65E0\u5FE7")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{onClick:function onClick(){var href='shihuo://www.shihuo.cn?route=fastWebview&url=https%3A%2F%2Fm.shihuo.cn%2Fapp%2Fassets%2Fh5app%2FwrongCompensation.html&navigationBar=false';var ptiOptions={ptiId:"lego-sales:compensation:"};__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,href,href,{},-1,_this3.props,false,ptiOptions);},className:"right-view",src:"https://static.shihuocdn.cn/admin/files/20221011/82283b3a9b3008a735ef5e5e409e690a.png"})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"list-view"},list.map(function(item,index){var _item$pic=item.pic,pic=_item$pic===void 0?'':_item$pic,_item$title=item.title,title=_item$title===void 0?'':_item$title,_item$avg_order_price=item.avg_order_price_30,avg_order_price_30=_item$avg_order_price===void 0?'':_item$avg_order_price,_item$now_price=item.now_price,now_price=_item$now_price===void 0?'':_item$now_price,_item$price_off=item.price_off,price_off=_item$price_off===void 0?'':_item$price_off,_item$style_id=item.style_id,style_id=_item$style_id===void 0?'':_item$style_id,_item$goods_id=item.goods_id,goods_id=_item$goods_id===void 0?'':_item$goods_id,_item$href=item.href,href=_item$href===void 0?'':_item$href,_item$sku_id=item.sku_id,sku_id=_item$sku_id===void 0?0:_item$sku_id;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{key:index,className:"img-item",onClick:function onClick(){var options={sort:index,name:title,goods_id:goods_id,style_id:style_id};var ptiOptions={ptiId:"lego-sales:list:".concat(index),bizExtra:{goods_id:goods_id,style_id:style_id,tab_name:'',goods_sku_id:sku_id}};__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this3.props.routeParams,href,href,options,-1,_this3.props,false,ptiOptions);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"img-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:pic,className:"img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"img-bg"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"right-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"title"},title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"price-bg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"red-bg",src:"https://static.shihuocdn.cn/admin/files/20221019/90d08c38b1d643bf9bd42fd82138b1a5.png"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"pink-bg"},"\xA5",price_off||'--')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"gray-text"},"\u8FD130\u65E5\u6210\u4EA4\u5747\u4EF7 \xA5",avg_order_price_30||'--')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"right-bottom-bg-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"right-bottom-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"bottom-right-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"right-text"},"\u7ACB\u5373\u62A2")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"bottom-left-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"tag",src:"https://static.shihuocdn.cn/admin/files/20221019/15f7336a683ae77a6f36b96f401e0712.png"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"price-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"unit"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"price"},now_price||'--'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"price-desc"},"\u53CC12\u771F\u4F4E\u4EF7")))))));}),showText?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"bottom-desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"left-line"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"center-desc"},"\u6CA1\u6709\u66F4\u591A\u4E86"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"right-line"})):null)))));}}]);return PipelineCutPriceGoodsList;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);PipelineCutPriceGoodsList.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCutPriceGoodsList);

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var DIRECTION;
(function (DIRECTION) {
    DIRECTION[DIRECTION["UP"] = -1] = "UP";
    DIRECTION[DIRECTION["DOWN"] = 1] = "DOWN";
})(DIRECTION || (DIRECTION = {}));

function isOverflowScrollable(element) {
    var overflowType = getComputedStyle(element).overflowY;
    if (element === document.scrollingElement && overflowType === 'visible') {
        return true;
    }
    if (overflowType !== 'scroll' && overflowType !== 'auto') {
        return false;
    }
    return true;
}
function isScrollable(element, direction) {
    if (!isOverflowScrollable(element)) {
        return false;
    }
    if (direction === DIRECTION.DOWN) {
        var bottomScroll = element.scrollTop + element.clientHeight;
        return bottomScroll < element.scrollHeight;
    }
    if (direction === DIRECTION.UP) {
        return element.scrollTop > 0;
    }
    throw new Error('unsupported direction');
}
/**
 * Returns whether a given element or any of its ancestors (up to rootElement) is scrollable in a given direction.
 */
function isTreeScrollable(element, direction) {
    if (isScrollable(element, direction)) {
        return true;
    }
    if (element.parentElement == null) {
        return false;
    }
    return isTreeScrollable(element.parentElement, direction);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".lds-ellipsis {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  height: 64px; }\n\n.lds-ellipsis div {\n  position: absolute;\n  top: 27px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: #363636;\n  animation-timing-function: cubic-bezier(0, 1, 1, 0); }\n\n.lds-ellipsis div:nth-child(1) {\n  left: 6px;\n  animation: lds-ellipsis1 0.6s infinite; }\n\n.lds-ellipsis div:nth-child(2) {\n  left: 6px;\n  animation: lds-ellipsis2 0.6s infinite; }\n\n.lds-ellipsis div:nth-child(3) {\n  left: 26px;\n  animation: lds-ellipsis2 0.6s infinite; }\n\n.lds-ellipsis div:nth-child(4) {\n  left: 45px;\n  animation: lds-ellipsis3 0.6s infinite; }\n\n@keyframes lds-ellipsis1 {\n  0% {\n    transform: scale(0); }\n  100% {\n    transform: scale(1); } }\n\n@keyframes lds-ellipsis3 {\n  0% {\n    transform: scale(1); }\n  100% {\n    transform: scale(0); } }\n\n@keyframes lds-ellipsis2 {\n  0% {\n    transform: translate(0, 0); }\n  100% {\n    transform: translate(19px, 0); } }\n";
styleInject(css);

// Source: https://loading.io/css/
var RefreshingContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "lds-ellipsis" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null)));
};

var PullingContent = function () {
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "\u21A7\u00A0\u00A0pull to refresh\u00A0\u00A0\u21A7")));
};

var css$1 = ".ptr,\n.ptr__children {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  position: relative; }\n\n.ptr.ptr--fetch-more-treshold-breached .ptr__fetch-more {\n  display: block; }\n\n.ptr__fetch-more {\n  display: none; }\n\n/**\n  * Pull down transition \n  */\n.ptr__children,\n.ptr__pull-down {\n  transition: transform 0.2s cubic-bezier(0, 0, 0.31, 1); }\n\n.ptr__pull-down {\n  position: absolute;\n  overflow: hidden;\n  left: 0;\n  right: 0;\n  top: 0;\n  visibility: hidden; }\n  .ptr__pull-down > div {\n    display: none; }\n\n.ptr--dragging {\n  /**\n    * Hide PullMore content is treshold breached\n    */\n  /**\n    * Otherwize, display content\n    */ }\n  .ptr--dragging.ptr--pull-down-treshold-breached .ptr__pull-down--pull-more {\n    display: none; }\n  .ptr--dragging .ptr__pull-down--pull-more {\n    display: block; }\n\n.ptr--pull-down-treshold-breached {\n  /**\n    * Force opacity to 1 is pull down trashold breached\n    */\n  /**\n    * And display loader\n    */ }\n  .ptr--pull-down-treshold-breached .ptr__pull-down {\n    opacity: 1 !important; }\n  .ptr--pull-down-treshold-breached .ptr__pull-down--loading {\n    display: block; }\n\n.ptr__loader {\n  margin: 0 auto;\n  text-align: center; }\n";
styleInject(css$1);

var PullToRefresh = function (_a) {
    var _b = _a.isPullable, isPullable = _b === void 0 ? true : _b, _c = _a.canFetchMore, canFetchMore = _c === void 0 ? false : _c, onRefresh = _a.onRefresh, onFetchMore = _a.onFetchMore, _d = _a.refreshingContent, refreshingContent = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RefreshingContent, null) : _d, _e = _a.pullingContent, pullingContent = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PullingContent, null) : _e, children = _a.children, _f = _a.pullDownThreshold, pullDownThreshold = _f === void 0 ? 67 : _f, _g = _a.fetchMoreThreshold, fetchMoreThreshold = _g === void 0 ? 100 : _g, _h = _a.maxPullDownDistance, maxPullDownDistance = _h === void 0 ? 95 : _h, // max distance to scroll to trigger refresh
    _j = _a.resistance, // max distance to scroll to trigger refresh
    resistance = _j === void 0 ? 1 : _j, backgroundColor = _a.backgroundColor, _k = _a.className, className = _k === void 0 ? '' : _k;
    var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var childrenRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var pullDownRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var fetchMoreRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var pullToRefreshThresholdBreached = false;
    var fetchMoreTresholdBreached = false; // if true, fetchMore loader is displayed
    var isDragging = false;
    var startY = 0;
    var currentY = 0;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!isPullable || !childrenRef || !childrenRef.current)
            return;
        var childrenEl = childrenRef.current;
        childrenEl.addEventListener('touchstart', onTouchStart, { passive: true });
        childrenEl.addEventListener('mousedown', onTouchStart);
        childrenEl.addEventListener('touchmove', onTouchMove, { passive: false });
        childrenEl.addEventListener('mousemove', onTouchMove);
        window.addEventListener('scroll', onScroll);
        childrenEl.addEventListener('touchend', onEnd);
        childrenEl.addEventListener('mouseup', onEnd);
        document.body.addEventListener('mouseleave', onEnd);
        return function () {
            childrenEl.removeEventListener('touchstart', onTouchStart);
            childrenEl.removeEventListener('mousedown', onTouchStart);
            childrenEl.removeEventListener('touchmove', onTouchMove);
            childrenEl.removeEventListener('mousemove', onTouchMove);
            window.removeEventListener('scroll', onScroll);
            childrenEl.removeEventListener('touchend', onEnd);
            childrenEl.removeEventListener('mouseup', onEnd);
            document.body.removeEventListener('mouseleave', onEnd);
        };
    }, [
        children,
        isPullable,
        onRefresh,
        pullDownThreshold,
        maxPullDownDistance,
        canFetchMore,
        fetchMoreThreshold,
    ]);
    /**
     * Check onMount / canFetchMore becomes true
     *  if fetchMoreThreshold is already breached
     */
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var _a;
        /**
         * Check if it is already in fetching more state
         */
        if (!((_a = containerRef) === null || _a === void 0 ? void 0 : _a.current))
            return;
        var isAlreadyFetchingMore = containerRef.current.classList.contains('ptr--fetch-more-treshold-breached');
        if (isAlreadyFetchingMore)
            return;
        /**
         * Proceed
         */
        if (canFetchMore && getScrollToBottomValue() < fetchMoreThreshold && onFetchMore) {
            containerRef.current.classList.add('ptr--fetch-more-treshold-breached');
            fetchMoreTresholdBreached = true;
            onFetchMore().then(initContainer).catch(initContainer);
        }
    }, [canFetchMore, children]);
    /**
     * Returns distance to bottom of the container
     */
    var getScrollToBottomValue = function () {
        if (!childrenRef || !childrenRef.current)
            return -1;
        var scrollTop = window.scrollY; // is the pixels hidden in top due to the scroll. With no scroll its value is 0.
        var scrollHeight = childrenRef.current.scrollHeight; // is the pixels of the whole container
        return scrollHeight - scrollTop - window.innerHeight;
    };
    var initContainer = function () {
        requestAnimationFrame(function () {
            /**
             * Reset Styles
             */
            if (childrenRef.current) {
                childrenRef.current.style.overflowX = 'hidden';
                childrenRef.current.style.overflowY = 'auto';
                childrenRef.current.style.transform = "unset";
            }
            if (pullDownRef.current) {
                pullDownRef.current.style.opacity = '0';
            }
            if (containerRef.current) {
                containerRef.current.classList.remove('ptr--pull-down-treshold-breached');
                containerRef.current.classList.remove('ptr--dragging');
                containerRef.current.classList.remove('ptr--fetch-more-treshold-breached');
            }
            if (pullToRefreshThresholdBreached)
                pullToRefreshThresholdBreached = false;
            if (fetchMoreTresholdBreached)
                fetchMoreTresholdBreached = false;
        });
    };
    var onTouchStart = function (e) {
        isDragging = false;
        if (e instanceof MouseEvent) {
            startY = e.pageY;
        }
        if (window.TouchEvent && e instanceof TouchEvent) {
            startY = e.touches[0].pageY;
        }
        currentY = startY;
        // Check if element can be scrolled
        if (e.type === 'touchstart' && isTreeScrollable(e.target, DIRECTION.UP)) {
            return;
        }
        // Top non visible so cancel
        if (childrenRef.current.getBoundingClientRect().top < 0) {
            return;
        }
        isDragging = true;
    };
    var onTouchMove = function (e) {
        if (!isDragging) {
            return;
        }
        if (window.TouchEvent && e instanceof TouchEvent) {
            currentY = e.touches[0].pageY;
        }
        else {
            currentY = e.pageY;
        }
        containerRef.current.classList.add('ptr--dragging');
        if (currentY < startY) {
            isDragging = false;
            return;
        }
        if (e.cancelable) {
            e.preventDefault();
        }
        var yDistanceMoved = Math.min((currentY - startY) / resistance, maxPullDownDistance);
        // Limit to trigger refresh has been breached
        if (yDistanceMoved >= pullDownThreshold) {
            isDragging = true;
            pullToRefreshThresholdBreached = true;
            containerRef.current.classList.remove('ptr--dragging');
            containerRef.current.classList.add('ptr--pull-down-treshold-breached');
        }
        // maxPullDownDistance breached, stop the animation
        if (yDistanceMoved >= maxPullDownDistance) {
            return;
        }
        pullDownRef.current.style.opacity = ((yDistanceMoved) / 65).toString();
        childrenRef.current.style.overflow = 'visible';
        childrenRef.current.style.transform = "translate(0px, " + yDistanceMoved + "px)";
        pullDownRef.current.style.visibility = 'visible';
    };
    var onScroll = function (e) {
        /**
         * Check if component has already called onFetchMore
         */
        if (fetchMoreTresholdBreached)
            return;
        /**
         * Check if user breached fetchMoreThreshold
         */
        if (canFetchMore && getScrollToBottomValue() < fetchMoreThreshold && onFetchMore) {
            fetchMoreTresholdBreached = true;
            containerRef.current.classList.add('ptr--fetch-more-treshold-breached');
            onFetchMore().then(initContainer).catch(initContainer);
        }
    };
    var onEnd = function () {
        isDragging = false;
        startY = 0;
        currentY = 0;
        // Container has not been dragged enough, put it back to it's initial state
        if (!pullToRefreshThresholdBreached) {
            if (pullDownRef.current)
                pullDownRef.current.style.visibility = 'hidden';
            initContainer();
            return;
        }
        if (childrenRef.current) {
            childrenRef.current.style.overflow = 'visible';
            childrenRef.current.style.transform = "translate(0px, " + pullDownThreshold + "px)";
        }
        onRefresh().then(initContainer).catch(initContainer);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr " + className, style: { backgroundColor: backgroundColor }, ref: containerRef },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr__pull-down", ref: pullDownRef },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr__loader ptr__pull-down--loading" }, refreshingContent),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr__pull-down--pull-more" }, pullingContent)),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr__children", ref: childrenRef },
            children,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr__fetch-more", ref: fetchMoreRef },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "ptr__loader ptr__fetch-more--loading" }, refreshingContent)))));
};

/* harmony default export */ __webpack_exports__["a"] = (PullToRefresh);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineDepreciateTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var isAndroid=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].isAndroid();var topTagImage=[{index:0,img:'https://static.shihuocdn.cn/admin/files/20221017/bcfbb4a2309b146b11e93ee119eac7e5.png',color:'#6A5322'},{index:1,img:'https://static.shihuocdn.cn/admin/files/20221017/946d40a745c8a60540f09b06c894c57b.png',color:'#1C3E56'},{index:2,img:'https://static.shihuocdn.cn/admin/files/20221017/785ac283075d8f02656162558b6e2b01.png',color:'#792E2F'},{index:3,img:'https://static.shihuocdn.cn/admin/files/20221017/02d2a5d5468bb94fbfb3d743710c375f.png',color:'#4D5A6D'}];var PipelineDepreciateTop=/*#__PURE__*/function(_React$Component){_inherits(PipelineDepreciateTop,_React$Component);var _super=_createSuper(PipelineDepreciateTop);function PipelineDepreciateTop(props){var _this;_classCallCheck(this,PipelineDepreciateTop);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getAllTabData",function(){var grains=_this.props.config.containerConfig.grains;grains.forEach(/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(item,index){var tabList,goods_list,listItem;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(index>0)){_context.next=8;break;}tabList=_this.state.tabList;_context.next=4;return _this.getDepreciateTopData(index);case 4:goods_list=_context.sent;listItem={tabName:item.tabTitle.tabName,tabIndex:index,list:goods_list||[]};tabList.push(listItem);_this.setState({tabList:tabList.sort(function(a,b){return a.tabIndex-b.tabIndex;})});case 8:case"end":return _context.stop();}}},_callee);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());});_defineProperty(_assertThisInitialized(_this),"getDepreciateTopData",function(tab_key){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_18_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/goods_price/list',method:"get",withCredentials:true,params:{is_all:1,list_type:1,tab_key:tab_key,page_id:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId()}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;var goods_list=data.goods_list||[];resolve(goods_list);})["catch"](function(err){console.log(err);});});});_defineProperty(_assertThisInitialized(_this),"handleTabSelect",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(event,item,index){var grains,navigationBarHeight,_this$state,tabFixed,tabBarOffsetTop,newProps,goods_list,tabList,listItem,options;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();if(!(index==_this.state.selected)){_context2.next=3;break;}return _context2.abrupt("return");case 3:grains=_this.props.config.containerConfig.grains;navigationBarHeight=_this.props.navigationBarHeight;_this$state=_this.state,tabFixed=_this$state.tabFixed,tabBarOffsetTop=_this$state.tabBarOffsetTop;newProps=JSON.parse(JSON.stringify(_this.props));Object.assign(newProps,{tabName:item.tabTitle.tabName});_context2.next=10;return _this.getDepreciateTopData(index);case 10:goods_list=_context2.sent;tabList=[];listItem={tabName:grains[index].tabTitle.tabName,tabIndex:index,list:goods_list||[]};tabList.push(listItem);_this.setState({selected:index,tabName:item.tabTitle.tabName,tabList:tabList},function(){tabFixed&&tabBarOffsetTop>0&&window.scrollTo(0,tabBarOffsetTop-navigationBarHeight+1);_this.updateNavPostion();});// 点击埋点
options={tab_name:item.tabTitle.tabName,lego_page_id:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getPageId(),legoAb:_this.props.abValue,h5Url:window.location.href};Object(__WEBPACK_IMPORTED_MODULE_23_shihuo_lib_dist_shihuo_lib__["uploadTrack"])({pti:{id:"lego-sales:tab:".concat(index),biz:JSON.stringify(options),pageOptions:options}});case 17:case"end":return _context2.stop();}}},_callee2);}));return function(_x3,_x4,_x5){return _ref2.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"onScroll",function(){var navigationBarHeight=_this.props.navigationBarHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var depreciateTop=window.document.querySelector('.pipeline-depreciateTop');var navOffsetTop=depreciateTop?depreciateTop.offsetTop-navigationBarHeight:0;var tabFixed=scrollHeight-navOffsetTop>0;if(_this.state.tabFixed!=tabFixed){_this.setState({tabFixed:tabFixed});}});_defineProperty(_assertThisInitialized(_this),"updateNavPostion",function(){// 导航条切换选中后，调整当前导航到居中位置
var navigationBar=document.querySelector('.tab-scroll');var checkedNavItem=document.querySelector(".tab-item-nav-active");// 当前选中的导航item
var navWidth=navigationBar.offsetWidth;// 导航栏宽度
var checkedItemOffsetLeft=checkedNavItem.offsetLeft;// 元素距离左边距离
var checkedItemWidth=checkedNavItem.offsetWidth;// 需要滚动的距离
var shouldUpdateScroll=checkedItemOffsetLeft-(navWidth/2-checkedItemWidth/2)-16;if(navigationBar.scrollWidth>navWidth){// 如果导航条可以滚动，执行滚动操作
navigationBar.scroll({top:0,left:shouldUpdateScroll,behavior:'smooth'});// 顶部固定导航条也执行滚动操作
document.querySelector('.tab-scroll').scroll({top:0,left:shouldUpdateScroll,behavior:'smooth'});}});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){var _item$goods_id=item.goods_id,goods_id=_item$goods_id===void 0?'':_item$goods_id,_item$style_id=item.style_id,style_id=_item$style_id===void 0?'':_item$style_id,_item$cate_id=item.cate_id,cate_id=_item$cate_id===void 0?'':_item$cate_id,_item$sku_id=item.sku_id,sku_id=_item$sku_id===void 0?0:_item$sku_id;var options={sort:index,name:item.title,goods_id:goods_id,style_id:style_id,cate_id:cate_id};var ptiOptions={ptiId:"lego-sales:list:".concat(index),ptiName:'降价Top100',bizExtra:{goods_id:goods_id,style_id:style_id,cate_id:cate_id,goods_sku_id:sku_id,tab_name:_this.state.tabName}};__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.href,item.href,options,-1,_this.props,false,ptiOptions);});_defineProperty(_assertThisInitialized(_this),"avgOrderPriceView",function(price){var sparePrice=null;if(price>10000){sparePrice=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].priceConversion(price,2);}if(sparePrice&&sparePrice.list){var sparePriceList=sparePrice.list;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"price-text"},"\xA5",sparePriceList[0],sparePriceList[1]?".".concat(sparePriceList[1]):'',sparePrice.unit);}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"price-text"},"\xA5",price);}});_defineProperty(_assertThisInitialized(_this),"nowPriceView",function(value,grains,selected){var sparePrice=null;if(value.now_price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].priceConversion(value.now_price,2);}if(sparePrice&&sparePrice.list){var sparePriceList=sparePrice.list;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"nowPriceView"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('12px'),marginTop:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('4px')}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('18px')}},sparePriceList[0]),sparePriceList[1]&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('13px'),marginTop:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('2px')}},".",sparePriceList[1]),sparePrice.unit&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('12px'),marginTop:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('3px')}},sparePrice.unit),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"desc",style:{top:Object(__WEBPACK_IMPORTED_MODULE_20__utils_px2rem__["a" /* default */])('2px')}},value.tag_name||grains[selected].tabInfoConfig.productTag));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"rmb"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"price"},value.now_price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"desc"},value.tag_name||grains[selected].tabInfoConfig.productTag));}});_this.state={tabItemComponent:[],selected:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].getParams('tab_key')||0,tabFixed:false,tabBarHeight:0,tabBarOffsetTop:0,tabName:'',scrollHeight:0,tabList:[],pageShow:false};// 滚动事件监听
if(typeof window!=='undefined'){window.addEventListener('scroll',function(e){_this.onScroll();});}return _this;}_createClass(PipelineDepreciateTop,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var _this2=this;var _this$state$selected,selected,grains,tabList,goods_list,listItem;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(typeof window!=="undefined"){setTimeout(function(){var tabBarHeight=document.querySelector('.tab-item')&&document.querySelector('.tab-item').clientHeight;var tabBarOffsetTop=document.querySelector('.tab-item')&&document.querySelector('.tab-item').offsetTop;_this2.setState({tabBarHeight:tabBarHeight,tabBarOffsetTop:tabBarOffsetTop});},1000);}_this$state$selected=this.state.selected,selected=_this$state$selected===void 0?0:_this$state$selected;grains=this.props.config.containerConfig.grains;tabList=[];_context3.next=6;return this.getDepreciateTopData(selected);case 6:goods_list=_context3.sent;listItem={tabName:grains[selected].tabTitle.tabName,tabIndex:selected,list:goods_list||[]};tabList.push(listItem);this.setState({tabList:tabList,pageShow:true});case 10:case"end":return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()// 
},{key:"render",value:function render(){var _this3=this;var _this$props$osVersion=this.props.osVersion,osVersion=_this$props$osVersion===void 0?'':_this$props$osVersion;var _this$state2=this.state,selected=_this$state2.selected,tabFixed=_this$state2.tabFixed,tabBarHeight=_this$state2.tabBarHeight,tabList=_this$state2.tabList,pageShow=_this$state2.pageShow;var _this$props$config$ba=this.props.config.baseConfig,moduleMarginTop=_this$props$config$ba.moduleMarginTop,tabType=_this$props$config$ba.tabType,fontColor=_this$props$config$ba.fontColor;var grains=this.props.config.containerConfig.grains;if(!grains||grains.length<=0||!pageShow){return null;}var tabItemClass="tab-item type-text",tabScroller=false,adaptive=false;if(!isAndroid&&(osVersion=='15.1'||osVersion=='15.2')){adaptive=true;}adaptive&&(tabItemClass+=tabFixed?' fixed':'');if(grains.length>=4){tabItemClass+=' scroller';tabScroller=true;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({className:"pipeline-depreciateTop"},this.props['customAttributes'],{style:{marginTop:"".concat(moduleMarginTop,"px")}}),adaptive?tabFixed&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{ref:function ref(_ref3){return _this3.tabItemPlaceholderRef=_ref3;},className:"placeholder tab-item-placeholder",style:{height:tabBarHeight}}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{ref:function ref(_ref4){return _this3.tabItemPlaceholderRef=_ref4;},className:"placeholder tab-item-placeholder"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:tabItemClass,style:{top:this.props.navigationBarHeight,backgroundColor:this.props.backgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",{className:tabScroller?'tab-scroll custom-padding':'tab-scroll'},grains.map(function(item,index){var tabNavClass="";tabNavClass=selected==index?'tab-item-nav tab-item-nav-active active':'tab-item-nav';tabNavClass+=tabScroller?' customWidth':' autoWidth';return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{className:tabNavClass,key:"tab-item-nav-".concat(index),onClick:function onClick(event){return _this3.handleTabSelect(event,item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{style:{color:selected==index?fontColor:fontColor,opacity:selected==index?1:.7}},item.tabTitle.tabName),selected===index&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"underline",style:{backgroundColor:fontColor}}));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"tab-item-content"},tabList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",{className:selected==index?'tab-content':'tab-content',key:"tab-content-".concat(index)},item.list.map(function(value,key){var topTagImg='',topTagColor='';if(key<=3){topTagImg=topTagImage[key].img;topTagColor=topTagImage[key].color;}else{topTagImg=topTagImage[3].img;topTagColor=topTagImage[3].color;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{key:"list-item-".concat(key),onClick:function onClick(){return _this3.handleItemClick(value,key);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:isAndroid?'top-tag android':'top-tag ios',style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(topTagImg,_this3.props.webpSupport),")"),backgroundSize:"contain",color:topTagColor}},"TOP",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{style:{color:topTagColor}},key+1<10?"0".concat(key+1):key+1)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_lazy_load_image_component__["LazyLoadImage"],{width:130,height:130,src:__WEBPACK_IMPORTED_MODULE_19__utils_utils__["a" /* default */].formatImgUrl(value.pic,_this3.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"mask"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"item-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"name",style:{WebkitBoxOrient:"vertical"}},value.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"price-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:isAndroid?'sale-price android':'sale-price ios'},"\u76F4\u964D ",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",null,"\xA5",value.price_off)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"price"},_this3.avgOrderPriceView(value.avg_order_price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"tips"},value.avg_order_price_text)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"desc"},"\u5373\u5C06\u6062\u590D")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"btn-info"},_this3.nowPriceView(value,grains,selected),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"buy-btn"},"\u53BB\u62A2\u8D2D"))));}));}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"bottom-desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"left-line"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"center-desc"},"\u6CA1\u6709\u66F4\u591A\u4E86"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"right-line"}))));}}]);return PipelineDepreciateTop;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);PipelineDepreciateTop.propTypes={config:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineDepreciateTop);

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineDouble11Floor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_trim_js__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_trim_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_trim_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_link_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_link_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_string_link_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_anchor_link_smooth_scroll__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_anchor_link_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react_anchor_link_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_swiper_components_pagination_pagination_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function hexColorToRgba(hexColor,opacity){var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}var bigCategory=['鞋类','服饰','数码','美妆','箱包','手表','配饰'];var PipelineDouble11Floor=/*#__PURE__*/function(_React$Component){_inherits(PipelineDouble11Floor,_React$Component);var _super=_createSuper(PipelineDouble11Floor);function PipelineDouble11Floor(props){var _this$state;var _this;_classCallCheck(this,PipelineDouble11Floor);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getData",function(){var _this$props$config$co=_this.props.config.containerConfig.grains,grains=_this$props$config$co===void 0?[]:_this$props$config$co;var floorList=grains;var cateList=[];floorList.map(function(item,index){var _item$selectRuleList=item.selectRuleList,selectRuleList=_item$selectRuleList===void 0?[]:_item$selectRuleList;var cateIds=[];selectRuleList.forEach(function(value,key){cateIds.push(value.categoryId);});cateIds=cateIds.join(',');cateList.push({"key":String(index),"cate":cateIds});});__WEBPACK_IMPORTED_MODULE_27_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',method:'post',withCredentials:true,data:{cateList:cateList,scene:'ACTIVITY_11_TAB_REC',from:window.location.href}}).then(function(res){res=res.data;var copyList=JSON.parse(JSON.stringify(floorList));if(res.status==0){var _ref=res.data||{},_ref$orderCateList=_ref.orderCateList,orderCateList=_ref$orderCateList===void 0?[]:_ref$orderCateList;// const orderCateList = ['2', '1', '0', '3', '4', '5', '6'];
var mapIndex=0;orderCateList.forEach(function(key,tabKey){floorList.forEach(function(item,index){if(key==index){for(var i=mapIndex;i<copyList.length;i++){floorList[i]=copyList[+key];floorList[i]['tab_key']=index;mapIndex=i+1;break;}}});});var tabList=[];floorList.forEach(function(item,floorIndex){// 指定会场置顶
if(item.tabName==_this.state.venue){floorList.splice(floorIndex,1);floorList.unshift(item);}item.showPage=1;tabList.push(item.tabName);});_this.state.venue&&tabList.forEach(function(tabItem,tabIndex){// 指定会场置顶
if(tabItem==_this.state.venue){tabList.splice(tabIndex,1);tabList.unshift(tabItem);}});_this.setState({tabList:tabList,floorList:floorList},function(){floorList.forEach(function(floor,floorIndex){_this.getGoodsList(floor.tab_key,floorIndex);});setTimeout(function(){var _this$props$config$zt=_this.props.config.ztAdList,ztAdList=_this$props$config$zt===void 0?[]:_this$props$config$zt;if(__WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default.a&&ztAdList.length>0){_this.adSwiper=new __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default.a('.zt-content',{autoplay:ztAdList.length>1?{disableOnInteraction:false}:false,speed:500,loop:ztAdList.length>1?true:false});}},1000);});}});});_defineProperty(_assertThisInitialized(_this),"getGoodsList",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(floorTabKey,floorIndex){var squareStageType,floorList,floor,goods_type,res,_res$data,status,data,goodsList,adList,pageSize;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:squareStageType=window.squareStageType;floorList=_this.state.floorList;floor=floorList[floorIndex];goods_type=0;_context.t0=squareStageType;_context.next=_context.t0==="预售"?7:_context.t0==="预热"?9:_context.t0==="正式"?11:_context.t0==="全部商品"?13:15;break;case 7:goods_type=1;return _context.abrupt("break",16);case 9:goods_type=2;return _context.abrupt("break",16);case 11:goods_type=3;return _context.abrupt("break",16);case 13:goods_type=0;return _context.abrupt("break",16);case 15:return _context.abrupt("break",16);case 16:_context.next=18;return __WEBPACK_IMPORTED_MODULE_27_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/goods_price/list',method:'get',withCredentials:true,params:{is_all:1,list_type:3,tab_key:floorTabKey,page_id:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].getPageId()}});case 18:res=_context.sent;_res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){goodsList=data.goods_list||[];// 指定会场里的指定商品置顶显示
if(_this.state.venue&&_this.state.venue==floor.tabName&&_this.state.venueGoodsId){goodsList.forEach(function(goodsItem,goodsIndex){if(_this.state.venue&&_this.state.venueGoodsId==goodsItem.goodsId&&goodsItem.styleId&&_this.state.venueStyleId==goodsItem.styleId){goodsList.splice(goodsIndex,1);goodsList.unshift(goodsItem);}});}// 插入广告
adList=floor.adList||[];adList.forEach(function(ad){var startTime=ad.startTime,endTime=ad.endTime,img=ad.img,position=ad.position;var pos=+position.trim()-1;var now=new Date().getTime();if(startTime&&endTime&&img&&pos>=0&&now>=new Date(startTime).getTime()&&now<=new Date(endTime).getTime()){ad.type='ad';goodsList=goodsList.slice(0,pos).concat([ad]).concat(goodsList.slice(pos,goodsList.length));}});pageSize=Math.ceil((goodsList.length-6)/30)+1;floor.pageSize=pageSize>=4?4:pageSize;floor.goodsList=goodsList;_this.setState({floorList:floorList,disableRender:false});}case 21:case"end":return _context.stop();}}},_callee);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleBodyScroll",function(){var floorTabList=window.document.querySelector('.floor-tab-list');if(!floorTabList){return;}var tabBarHeight=floorTabList.clientHeight;var navigationBarHeight=_this.props.navigationBarHeight;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;var navOffsetTop=window.document.querySelector('.navigation-container-static-wrap').offsetTop-_this.props.navigationBarHeight;var navMarginTop=Number(_this.props.config.baseConfig.moduleMarginTop);// 导航模块上边距
var productComList=window.document.querySelectorAll('.floor-item')||[];var checkedNav='',checkedIndex=0;var distance=window.document.querySelector('.pipeline-double11-floor').clientHeight+navOffsetTop-window.document.querySelector('.more-item').clientHeight;var navFixed=scrollHeight-navOffsetTop>=navMarginTop&&scrollHeight<distance-20;if(scrollHeight<distance-50){document.querySelector('.navigation-container-fixed-wrap').style.opacity=1;}else if(scrollHeight>=distance-50&&scrollHeight<distance-15){var opacity=scrollHeight<distance?((scrollHeight-(distance-50))/20).toFixed(2):1;console.log('1 - opacity',1-opacity);document.querySelector('.navigation-container-fixed-wrap').style.opacity=1-opacity;}else{document.querySelector('.navigation-container-fixed-wrap').style.opacity=0;}for(var i=0;i<productComList.length;i+=1){if(scrollHeight+_this.navigationContentHeight+navigationBarHeight>productComList[i].offsetTop){checkedNav=productComList[i].getAttribute('id');checkedIndex=i;}}if(navFixed!=_this.state.navFixed){_this.setState({navFixed:navFixed});}if(checkedNav!=_this.state.checkedNav){_this.setState({checkedNav:checkedNav});}var list=window.document.querySelectorAll('.floor-item')||[];var stopIndex=list.length-1;for(var _i=0;_i<list.length;_i+=1){var item=list[_i];if(item&&scrollHeight>=item.offsetTop-tabBarHeight-_this.props.navigationBarHeight){if(_i==list.length-1||scrollHeight<list[_i+1].offsetTop-tabBarHeight-_this.props.navigationBarHeight){var _ret=function(){var tabIndex=_i>stopIndex?stopIndex:_i;if(tabIndex!=_this.state.tabIndex){_this.setState({tabIndex:tabIndex},function(){if(navFixed){var tabItemEls=window.document.querySelectorAll('.floor-tab-item');if(tabItemEls&&tabItemEls[tabIndex]){tabItemEls[tabIndex].scrollIntoView();}}});}return"break";}();if(_ret==="break")break;}}}// 对导航滚动防抖
if(_this.debounceTimer){clearTimeout(_this.debounceTimer);}_this.debounceTimer=setTimeout(function(){_this.updateNavPostion(checkedNav);},60);});_defineProperty(_assertThisInitialized(_this),"navClick",function(item,index){__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].uploadTrack(_this.props,{sort:index},{ptiId:"lego-sales:tab:".concat(index),ptiName:'楼层Tab',bizExtra:{model_block:'floorTab',tab_name:item}});// 导航跳转
_this.setState({checkedNav:item,tabExpand:false,hideMask:true});if(typeof window!=='undefined'){// window.location.href = `#${item}`;
// 使用replace代替href跳转，避免在history中留下记录
window.location.replace("#".concat(item));}// 向下继续滚动this.navigationContentHeight - 3单位
setTimeout(function(){var scrollTop=(document.documentElement.scrollTop||document.body.scrollTop)-(_this.navigationContentHeight-3)-_this.props.navigationBarHeight;window.scrollTo(0,scrollTop);},60);});_defineProperty(_assertThisInitialized(_this),"expandClick",function(){var navMarginTop=Number(_this.props.config.baseConfig.moduleMarginTop);// 导航模块上边距
var offsetTop=0;if(!_this.isAnchorInSwitchTab){offsetTop=window.document.querySelector('.navigation-container-static-wrap').offsetTop+navMarginTop;}else{var targetTabContainer=window.document.querySelectorAll('.tab-container')[_this.props.tabIndex];offsetTop=targetTabContainer.querySelector('.navigation-container-static-wrap').offsetTop+navMarginTop;}!_this.state.navFixed&&window.scrollTo(0,offsetTop);var tabExpand=!_this.state.tabExpand;_this.setState({tabExpand:tabExpand,hideMask:false});setTimeout(function(){_this.setState({hideMask:!tabExpand});},250);});_defineProperty(_assertThisInitialized(_this),"updateNavPostion",function(checkedNav){// 导航条切换选中后，调整当前导航到居中位置
var navigationBar,checkedNavItem;navigationBar=document.querySelector('.navigation-container-fixed');checkedNavItem=document.querySelector(".navigation-container-fixed a[href=\"#".concat(checkedNav,"\"]"));// 当前选中的导航item
if(!checkedNav||!checkedNavItem){return;}var navWidth=navigationBar.offsetWidth;// 导航栏宽度
var checkedItemOffsetLeft=checkedNavItem.offsetLeft;// 元素距离左边距离
var checkedItemWidth=checkedNavItem.offsetWidth;// 需要滚动的距离
var shouldUpdateScroll=checkedItemOffsetLeft-(navWidth/2-checkedItemWidth/2)-16;if(navigationBar.scrollWidth>navWidth){// 如果导航条可以滚动，执行滚动操作
navigationBar.scroll({top:0,left:shouldUpdateScroll,behavior:'smooth'});// 顶部固定导航条也执行滚动操作
document.querySelector('.navigation-container-static').scroll({top:0,left:shouldUpdateScroll,behavior:'smooth'});}});_this.state=(_this$state={tabList:[],tabIndex:0,floorList:[],navFixed:false,venue:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].getQueryString('venue'),venueGoodsId:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].getParams('venueGoodsId')||'',venueStyleId:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].getParams('venueStyleId')||'',checkedNav:'',checkedIndex:0},_defineProperty(_this$state,"navFixed",false),_defineProperty(_this$state,"tabExpand",false),_defineProperty(_this$state,"hideMask",true),_defineProperty(_this$state,"navList",[]),_defineProperty(_this$state,"navPosition",0),_defineProperty(_this$state,"disableRender",true),_this$state);_this.adSwiper=null;_this.navigationContentHeight=44;// 导航条的高度值
_this.debounceTimer='';_this.lastNavCompOffsetTop=0;_this.navPosition=0;_this.navigationTab=null;_this.isAnchorInSwitchTab=false;// 滚动事件监听
if(typeof window!=='undefined'){window.addEventListener('scroll',function(e){_this.handleBodyScroll();});}return _this;}_createClass(PipelineDouble11Floor,[{key:"componentDidMount",value:function componentDidMount(){this.getData();document.querySelector('.nav-mask')&&document.querySelector('.nav-mask').addEventListener('touchmove',function(e){e.preventDefault();},false);}},{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,_this$props$config$zt2=_this$props$config.ztAdList,ztAdList=_this$props$config$zt2===void 0?[]:_this$props$config$zt2,_this$props$config$mo=_this$props$config.moreInfo,moreInfo=_this$props$config$mo===void 0?{}:_this$props$config$mo;var _this$state2=this.state,tabList=_this$state2.tabList,tabIndex=_this$state2.tabIndex,floorList=_this$state2.floorList,navFixed=_this$state2.navFixed,disableRender=_this$state2.disableRender;var moreFloorBg=moreInfo.bgImg;if(disableRender||tabList.length==0){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",_extends({className:"pipeline-double11-floor"},this.props['customAttributes'],{style:{marginTop:"".concat(baseConfig.moduleMarginTop,"px")}}),this.renderNavigation(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"floor-list"},floorList.map(function(floor,floorIndex){var goodsList=floor.goodsList||[];var goodsNumCell=goodsList.length>=20&&floorIndex==0?1:1;var totalCell=Math.ceil(goodsList.length/goodsNumCell);var goodsArr=[];for(var i=0;i<totalCell;i++){var arr=[];for(var j=0;j<goodsNumCell;j++){var idx=i*goodsNumCell+j;if(idx<goodsList.length){arr.push(goodsList[idx]);}}if(arr.length==goodsNumCell){goodsArr.push(arr);}}if(bigCategory.indexOf(floor.tabName)>=0){if(floor.showPage<=1){goodsArr=goodsArr.slice(0,6);}else if(floor.showPage>=2&&floor.showPage<=4){goodsArr=goodsArr.slice(0,(floor.showPage-1)*30+6);}else{goodsArr=goodsArr.slice(0,96);}}else{if(floor.showPage<=1){goodsArr=goodsArr.slice(0,3);}else if(floor.showPage>=2&&floor.showPage<=4){goodsArr=goodsArr.slice(0,(floor.showPage-1)*30+3);}else{goodsArr=goodsArr.slice(0,93);}}floor.goodsArr=goodsArr;var ztAdView=null;if(floorIndex==0&&ztAdList.length>0){ztAdView=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{key:"zt-ad-".concat(floorIndex),className:"zt-ad",onClick:function onClick(){if(!_this2.adSwiper){return;}var ztIndex=_this2.adSwiper.realIndex;var ztAd=ztAdList[ztIndex];if(ztAd){var options={sort:ztIndex};__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,ztAd.link,ztAd.link,options,-1,_this2.props,false,{ptiId:"lego-sales:middleBanner:".concat(ztIndex),ptiName:'楼层广告位',bizExtra:{model_block:'floorAdvertising',floor_name:floor.tabName}});}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"zt-content swiper-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"swiper-wrapper"},ztAdList.map(function(ztAd,ztIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("img",{key:ztIndex,alt:"",className:"cont swiper-slide",src:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(ztAd.img,_this2.props.webpSupport)});}))));}return[/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{id:floor.tabName,className:"floor-item normal",key:"floor-item-".concat(floorIndex)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"floor-title",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(floor.headerImg,_this2.props.webpSupport),")"),backgroundSize:"100% 100%"}},floor.tabName),goodsArr.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].isAndroid()?"content android":"content",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(floor.floorBgImg,_this2.props.webpSupport),")"),backgroundSize:"100% 100%",backgroundRepeat:"no-repeat",backgroundColor:floor.floorBgColor}},goodsArr.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"goods-block goods-block-".concat(floorIndex)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"goods-list"},goodsArr.map(function(arr,arrIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{key:arrIndex,className:"goods-arr-item"},arr.map(function(item,index){if(item.type=='ad'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"goods-ad",key:"".concat(arrIndex,"-").concat(index),onClick:function onClick(){var options={sort:arrIndex};__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.link,item.link,options,-1,_this2.props,false,{ptiId:"lego-sales:floor:".concat(arrIndex),ptiName:'楼层商品',bizExtra:{model_block:'floorGoods',floor_name:floor.tabName,goods_href:item.link,goods_id:item.goods_id,style_id:item.style_id,cate_id:item.cate_id,goods_sku_id:item.sku_id||0}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:item.img,effect:"opacity"}));}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"goods-item goods-item",key:"".concat(arrIndex,"-").concat(index),onClick:function onClick(){var options={sort:arrIndex};__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.href,item.href,options,-1,_this2.props,false,{ptiId:"lego-sales:floor:".concat(arrIndex),ptiName:'楼层商品',bizExtra:{model_block:'floorGoods',floor_name:floor.tabName,goods_href:item.href,goods_id:item.goods_id,style_id:item.style_id,cate_id:item.cate_id,goods_sku_id:item.sku_id||0}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"goods-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(item.pic,_this2.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221205/6dfc91e4f598d9249b33f5e60789de9f.png",alt:"",className:"top-tag"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"name",style:{WebkitBoxOrient:"vertical"}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("span",{className:"cur-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("span",null,"\xA5"),item.now_price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("span",{className:"origin-price"},"\xA5",item.avg_order_price_30)));}));})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"fold-btn",style:{color:baseConfig.moreTextColor},onClick:function onClick(){var scrollTop=0;if(floor.showPage==1){// 记录当前滚动条位置，点收起按钮时，页面要回滚到该位置
scrollTop=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop;floor.startScrollTop=scrollTop;}if(floor.showPage+1>floor.pageSize){floor.showPage=1;window.scrollTo(0,floor.startScrollTop);}else{floor.showPage=floor.showPage+1;}_this2.setState({});__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].uploadTrack(_this2.props,{},{bizExtra:{model_block:'expand',floor_name:floor.tabName}});}},floor.showPage>=floor.pageSize?'收起':'展开更多',floor.showPage>=floor.pageSize?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("svg",{t:"1666004348086",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1731",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("path",{d:"M169.344 694.656a32 32 0 0 0 40.832 3.648l4.48-3.648L512 397.248l297.344 297.408a32 32 0 0 0 40.832 3.648l4.48-3.648a32 32 0 0 0 3.648-40.832l-3.648-4.48-320-320a32 32 0 0 0-40.832-3.648l-4.48 3.648-320 320a32 32 0 0 0 0 45.312z","p-id":"1732",fill:baseConfig.moreTextColor})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("svg",{t:"1665649025900",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"1547",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("path",{d:"M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z","p-id":"1548",fill:baseConfig.moreTextColor})))))),ztAdView];})),moreInfo.moreList&&moreInfo.moreList.length>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"more-item",style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(moreFloorBg,this.props.webpSupport),") center no-repeat")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"list"},moreInfo.moreList.slice(0,10).map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"item",key:index,style:{background:"url(".concat(__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(item.bgImg,_this2.props.webpSupport),") center no-repeat")},onClick:function onClick(){window.localStorage.setItem('last_click_tab_name',item.title);var options={sort:index};__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.link,item.link,options,-1,_this2.props,false,{ptiId:"lego-sales:floor",ptiName:'其他分会场',bizExtra:{model_block:"otherVenue",floor_name:item.title}});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(item.img,_this2.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"title"},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"sub-title"},item.subTitle));}))):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"more-item",style:{background:moreFloorBg?"url(".concat(__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].formatImgUrl(moreFloorBg,this.props.webpSupport),") center no-repeat"):'',height:!moreFloorBg&&'0px',marginTop:!moreFloorBg&&'0px'}}));}// 导航栏
},{key:"renderNavigation",value:function renderNavigation(){var _this3=this;var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,containerConfig=_this$props$config2.containerConfig;var _containerConfig$grai=containerConfig.grains,grains=_containerConfig$grai===void 0?[]:_containerConfig$grai;var _this$state3=this.state,tabExpand=_this$state3.tabExpand,hideMask=_this$state3.hideMask,navPosition=_this$state3.navPosition;var navList=grains.map(function(item){return item.tabName;});var hasMore=navList.length>3;var navigationWrapperClass='floor-navigation';var maskClass=tabExpand?"nav-mask show":"nav-mask hide";if(hideMask){maskClass+=' hide-mask';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:navigationWrapperClass},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:maskClass,onTouchEnd:this.expandClick}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"navigation-container-static-wrap",style:{paddingTop:"".concat(baseConfig.moduleMarginTop,"px"),backgroundColor:this.props.backgroundColor,visibility:this.state.navFixed?'hidden':'visible'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:hasMore?'floor-tab-list navigation-container-static has-more':'floor-tab-list navigation-container-static not-more'},navList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:navList.length<=4?"nav-item auto-width":"nav-item fixed-width",key:index,onClick:_this3.navClick.bind(_this3,item,index),style:{color:_this3.state.checkedNav===item?baseConfig.fontSelectedColor:baseConfig.fontColor,fontFamily:_this3.state.checkedNav===item?'PingFangSC-Medium':'PingFangSC-Regular',fontWeight:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].isAndroid()?_this3.state.checkedNav===item?'500':'normal':'normal'}},item);})),hasMore&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"expand-bar",onClick:this.expandClick,style:{top:"".concat(Number(baseConfig.moduleMarginTop),"px"),backgroundImage:"linear-gradient(to right, ".concat(hexColorToRgba(this.props.backgroundColor,0)," 0%, ").concat(hexColorToRgba(this.props.backgroundColor,1)," 30%, ").concat(hexColorToRgba(this.props.backgroundColor,1)," 100%)")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("svg",{className:"arrow ".concat(tabExpand?'on':''),width:"16px",height:"16px",viewBox:"0 0 16 16",version:"1.1",xmlns:"https://www.w3.org/2000/svg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("g",{id:"lego_open",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("g",{id:"",transform:"translate(2.500000, 5.000000)",fill:baseConfig.fontColor,fillRule:"nonzero"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("path",{d:"M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L5.5,4.793 L10.1464466,0.146446609 C10.320013,-0.0271197425 10.5894374,-0.0464048927 10.7843055,0.0885911588 L10.8535534,0.146446609 C11.0271197,0.320012961 11.0464049,0.589437362 10.9114088,0.784305503 L10.8535534,0.853553391 L5.85355339,5.85355339 C5.67998704,6.02711974 5.41056264,6.04640489 5.2156945,5.91140884 L5.14644661,5.85355339 L0.146446609,0.853553391 C-0.0488155365,0.658291245 -0.0488155365,0.341708755 0.146446609,0.146446609 Z",id:"\u8DEF\u5F84"})))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"navigation-container-fixed-wrap",ref:function ref(_ref3){return _this3.navigationTab=_ref3;},style:{position:'fixed',backgroundColor:this.props.backgroundColor,display:this.state.navFixed||navPosition>0?'block':'none',top:this.props.navigationBarHeight}},tabExpand&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("p",{className:"all-classify",style:{color:baseConfig.fontColor,fontFamily:'PingFangSC-Regular'}},"\u5168\u90E8\u5206\u7C7B"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"navigation-container-fixed ".concat(tabExpand?'expand ':'').concat(hasMore?'has-more':'not-more')},navList.map(function(item,index){return/*#__PURE__*/ (// offset值为 导航栏高度（45）- 3，
__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_react_anchor_link_smooth_scroll___default.a,{key:"anchorlink_".concat(index),offset:function offset(){__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].uploadTrack(_this3.props,{sort:index},{ptiId:"lego-sales:tab:".concat(index),ptiName:'楼层Tab',bizExtra:{model_block:'floorTab',tab_name:item}});return _this3.props.navigationBarHeight+_this3.navigationContentHeight-3;},href:"#".concat(item)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:navList.length<=4?"nav-item auto-width":"nav-item fixed-width",key:index,onClick:function onClick(){_this3.setState({tabExpand:false,hideMask:true});},style:{color:_this3.state.checkedNav===item?baseConfig.fontSelectedColor:baseConfig.fontColor,fontFamily:_this3.state.checkedNav===item?'PingFangSC-Medium':'PingFangSC-Regular',fontWeight:__WEBPACK_IMPORTED_MODULE_28__utils_utils__["a" /* default */].isAndroid()?_this3.state.checkedNav===item?'500':'normal':'normal'}},item)));})),hasMore&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"expand-bar",onClick:this.expandClick,style:{backgroundImage:"linear-gradient(to right, ".concat(hexColorToRgba(this.props.backgroundColor,0)," 0%, ").concat(hexColorToRgba(this.props.backgroundColor,1)," 30%, ").concat(hexColorToRgba(this.props.backgroundColor,1)," 100%)")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("svg",{className:"arrow ".concat(tabExpand?'on':''),width:"16px",height:"16px",viewBox:"0 0 16 16",version:"1.1",xmlns:"https://www.w3.org/2000/svg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("g",{id:"lego_open",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("g",{id:"",transform:"translate(2.500000, 5.000000)",fill:baseConfig.fontColor,fillRule:"nonzero"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("path",{d:"M0.146446609,0.146446609 C0.320012961,-0.0271197425 0.589437362,-0.0464048927 0.784305503,0.0885911588 L0.853553391,0.146446609 L5.5,4.793 L10.1464466,0.146446609 C10.320013,-0.0271197425 10.5894374,-0.0464048927 10.7843055,0.0885911588 L10.8535534,0.146446609 C11.0271197,0.320012961 11.0464049,0.589437362 10.9114088,0.784305503 L10.8535534,0.853553391 L5.85355339,5.85355339 C5.67998704,6.02711974 5.41056264,6.04640489 5.2156945,5.91140884 L5.14644661,5.85355339 L0.146446609,0.853553391 C-0.0488155365,0.658291245 -0.0488155365,0.341708755 0.146446609,0.146446609 Z",id:"\u8DEF\u5F84"})))))));}}]);return PipelineDouble11Floor;}(__WEBPACK_IMPORTED_MODULE_24_react___default.a.Component);PipelineDouble11Floor.propTypes={config:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineDouble11Floor);

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineButton=/*#__PURE__*/function(_React$Component){_inherits(PipelineButton,_React$Component);var _super=_createSuper(PipelineButton);function PipelineButton(props){var _this;_classCallCheck(this,PipelineButton);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"queryIsLogin",function(){_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=setInterval(function(){var isLogin=_this.state.isLogin;if(!isLogin){var CookieUA=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].getCookie('u');Promise.all([CookieUA,CookieU]).then(function(result){var isLogin=result&&result[0]&&result[1];_this.setState({isLogin:isLogin});if(isLogin){_this.joindAct();}});}else{_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=null;}},1000);});_defineProperty(_assertThisInitialized(_this),"login",function(){if(__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].isShihuo()){// 未登陆，请先进行微信登陆
window.Jockey.send("subscribe",{},function(publishData){if(publishData.type==="loginSuccess"){_this.queryIsLogin();}});window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});_defineProperty(_assertThisInitialized(_this),"joindAct",function(isSubmit){__WEBPACK_IMPORTED_MODULE_16_axios_dist_axios_min_js___default()({url:"//sh-gateway.shihuo.cn/v4/services/sh-gocashbackapi/account/join-activity",method:isSubmit?'post':'get',withCredentials:true}).then(function(res){_this.isSubmiting=false;var _res$data=res.data,status=_res$data.status,data=_res$data.data,msg=_res$data.msg;if(status===0){if(isSubmit){__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].toast('参与成功');}_this.setState({joined:data.is_join});}else{__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].toast(msg||'参与失败');}if(!_this.state.showBtn){_this.setState({showBtn:true});}})["catch"](function(e){_this.isSubmiting=false;if(!_this.state.showBtn){_this.setState({showBtn:true});}});});_defineProperty(_assertThisInitialized(_this),"joinClick",function(){__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].uploadTrack(_this.props);if(!_this.state.isLogin){_this.login();return;}if(!_this.state.joined&&!_this.isSubmiting){_this.isSubmiting=true;_this.joindAct(true);}});_this.state={joined:false,isLogin:false,showBtn:false};_this.loginInterval=null;_this.isSubmiting=false;return _this;}_createClass(PipelineButton,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var CookieUA=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].getCookie('u');Promise.all([CookieUA,CookieU]).then(function(result){var isLogin=result&&result[0]&&result[1];_this2.setState({isLogin:isLogin});if(isLogin){_this2.joindAct();}else{_this2.setState({showBtn:true});}});}// 查询是否登录
},{key:"render",value:function render(){var baseConfig=this.props.config.baseConfig;var _this$state=this.state,joined=_this$state.joined,showBtn=_this$state.showBtn;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div",_extends({className:"pipeline-button"},this.props['customAttributes']),baseConfig.type==='周末折扣活动'&&showBtn&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("img",{className:"discount-act-btn",width:"100%",src:__WEBPACK_IMPORTED_MODULE_15__utils_utils__["a" /* default */].formatImgUrl(joined?baseConfig.successBtnImg:baseConfig.btnImg,this.props.webpSupport),onClick:this.joinClick}));}}]);return PipelineButton;}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);PipelineButton.propTypes={config:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineButton);

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelinePriceTrend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__antv_f2_react__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__antv_f2__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var iamgeGuideW=typeof window!="undefined"&&window.screen.width<410?84:94;var iamgeGuideH=typeof window!="undefined"&&window.screen.width<410?40:44;var iamgeGuideX=typeof window!="undefined"&&window.screen.width<410?-11:-13;var textGuideY=typeof window!="undefined"&&window.screen.width<410?-15.5:-17;var PipelinePriceTrend=/*#__PURE__*/function(_React$Component){_inherits(PipelinePriceTrend,_React$Component);var _super=_createSuper(PipelinePriceTrend);function PipelinePriceTrend(props){var _this;_classCallCheck(this,PipelinePriceTrend);_this=_super.call(this,props);_this.state={goods_info:{goodsName:'',name:''},price_trend:[],rate:[{}],min:0,max:0,show:false};return _this;}_createClass(PipelinePriceTrend,[{key:"componentDidMount",value:function componentDidMount(){this.getPriceTrend();}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){if(this.props['customAttributes']["data-component-belong"]==='tab'){if(this.state.show!=nextState.show&&nextState.show||!nextProps.reRender){return true;}else{return false;}}else{return true;}}},{key:"getPriceTrend",value:function getPriceTrend(){var _this2=this;var _this$props$config$pr=this.props.config.productInfoConig,styleId=_this$props$config$pr.styleId,styleName=_this$props$config$pr.styleName,productImage=_this$props$config$pr.productImage,recommend=_this$props$config$pr.recommend,_this$props$config$pr2=_this$props$config$pr.finalTimeType,finalTimeType=_this$props$config$pr2===void 0?'实时时间':_this$props$config$pr2,_this$props$config$pr3=_this$props$config$pr.finalTime,finalTime=_this$props$config$pr3===void 0?'':_this$props$config$pr3,_this$props$config$pr4=_this$props$config$pr.interval,interval=_this$props$config$pr4===void 0?'3':_this$props$config$pr4;interval=Number(interval);Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/lego_goods_price/style',method:"get",withCredentials:true,params:{style_id:styleId}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var goods_info=data.goods_info,goods_price=data.goods_price;var list=goods_price&&goods_price.list&&goods_price.list[0]&&goods_price.list[0].values&&goods_price.list[0].values||[];if(finalTimeType==='实时时间'){var result=_this2.getPriceCoord(list,1,interval);var resultSort=JSON.parse(JSON.stringify(result));resultSort.sort(function(a,b){return a.y-b.y;});var min=resultSort[0].y;var max=resultSort[resultSort.length-1].y;if(styleName){Object.assign(goods_info,{goodsName:styleName});}if(productImage){Object.assign(goods_info,{pic:productImage});}Object.assign(goods_info,{recommend:recommend});_this2.setState({goods_info:goods_info,price_trend:result,rate:goods_price.rate||[{}],min:min,max:max,show:true});}else{finalTime=finalTime.replace(/-/g,'/');var current_date=parseInt(new Date("".concat(finalTime," 00:00:00")).getTime()/1000);var start=list.findIndex(function(item){return item.x==current_date;});var _result=_this2.getPriceCoord(list,start,interval);var _resultSort=JSON.parse(JSON.stringify(_result));_resultSort.sort(function(a,b){return a.y-b.y;});var _min=_resultSort[0].y;var _max=_resultSort[_resultSort.length-1].y;if(styleName){Object.assign(goods_info,{goodsName:styleName});}if(productImage){Object.assign(goods_info,{pic:productImage});}Object.assign(goods_info,{recommend:recommend});_this2.setState({goods_info:goods_info,price_trend:_result,rate:goods_price.rate||[{}],min:_min,max:_max,show:true});}}});}// 获取价格坐标
},{key:"getPriceCoord",value:function getPriceCoord(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var start=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var interval=arguments.length>2?arguments[2]:undefined;var result=[];var copy_list=JSON.parse(JSON.stringify(list));var last=0,fill=0,isLast=false,transitPoint=null,transitIndex=0;for(var index=0;index<5;index++){var element=list[start+interval*index];if(!element){fill+=1;if(!isLast){isLast=true;last=index-1;transitPoint={x:Number(copy_list[start+interval*last].x),y:copy_list[start+interval*last].y,type:'虚点',bubble:false};transitPoint['x']=this.formatTimes(transitPoint.x);transitPoint['y']=parseFloat(transitPoint.y);result.push(transitPoint);}element={x:Number(copy_list[start+interval*last].x)-86400*fill*interval,y:copy_list[start+interval*last].y,type:'虚点',bubble:false};}else{element['type']='实点';element['bubble']=true;}element['x']=this.formatTimes(element.x);element['y']=parseFloat(element.y);result.push(element);}result.reverse();return result;}// 时间戳转日期
},{key:"formatTimes",value:function formatTimes(timestamp){var time=new Date(Number(timestamp)*1000);var month=time.getMonth()+1;var day=time.getDate();if(month<10){month="0".concat(month);}if(day<10){day="0".concat(day);}return"".concat(month,"-").concat(day);}},{key:"handleJump",value:function handleJump(){var goods_info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var url=goods_info.detailHref;__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,url,url,{},-1,this.props,false,{bizExtra:{goods_id:goods_info.goodsId,style_id:goods_info.id}});}},{key:"render",value:function render(){var _this3=this;var _this$props$config$st=this.props.config.styleConfig,_this$props$config$st2=_this$props$config$st.theme,theme=_this$props$config$st2===void 0?'浅色样式':_this$props$config$st2,lineChartBgImage=_this$props$config$st.lineChartBgImage,bubbleBgImage=_this$props$config$st.bubbleBgImage,dateGridColor=_this$props$config$st.dateGridColor,lineChartColor=_this$props$config$st.lineChartColor,priceFieldColor=_this$props$config$st.priceFieldColor,bottomPriceColor=_this$props$config$st.bottomPriceColor,bottomBackgroundColor=_this$props$config$st.bottomBackgroundColor;var _this$props$config$pr5=this.props.config.productInfoConig.styleName,styleName=_this$props$config$pr5===void 0?'':_this$props$config$pr5;var baseConfig=this.props.config.baseConfig;var _this$state=this.state,_this$state$goods_inf=_this$state.goods_info,goods_info=_this$state$goods_inf===void 0?{}:_this$state$goods_inf,_this$state$price_tre=_this$state.price_trend,price_trend=_this$state$price_tre===void 0?[]:_this$state$price_tre,_this$state$rate=_this$state.rate,rate=_this$state$rate===void 0?[{}]:_this$state$rate,min=_this$state.min,max=_this$state.max;var _rate$=rate[0],_rate$$yMaxRate=_rate$.yMaxRate,yMaxRate=_rate$$yMaxRate===void 0?1:_rate$$yMaxRate,_rate$$yMinRate=_rate$.yMinRate,yMinRate=_rate$$yMinRate===void 0?1:_rate$$yMinRate;var isDark=theme==='深色样式';if(!lineChartBgImage){lineChartBgImage=!isDark?'https://static.shihuocdn.cn/admin/files/20221117/d3bc6b7af0770e9970484f3afaa87b85.png':'https://static.shihuocdn.cn/admin/files/20221117/7545a699adf93380d7f5c2ede7626639.png';}if(!bubbleBgImage){bubbleBgImage=!isDark?'https://static.shihuocdn.cn/admin/files/20221116/b1882fec5231102af5454d7e53a4203e.png':'https://static.shihuocdn.cn/admin/files/20221117/469465adf3076da4c1f331d889e33701.png';}if(!dateGridColor){dateGridColor=!isDark?'#999':'#fff';}if(!lineChartColor){lineChartColor=!isDark?'#FF4338':'#FFDDBC';}if(!priceFieldColor){priceFieldColor=!isDark?'#666':'rgba(255,255,255,0.8)';}if(!bottomPriceColor){bottomPriceColor=!isDark?'#FF4338':'#FFDDBC';}var sparePriceList1=[];var sparePrice=null;if(goods_info.price>1000){sparePrice=__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].priceConversion(goods_info.price,2);if(sparePrice&&sparePrice.list){sparePriceList1=sparePrice.list;}}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",_extends({className:"pipeline-priceTrend"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:!isDark?'theme-wrap theme-light':'theme-wrap theme-dark',style:{height:'100%',backgroundColor:bottomBackgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"image"},goods_info.pic&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].formatImgUrl(goods_info.pic,this.props.webpSupport),alt:"",className:"image"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"title"},styleName?styleName:goods_info.goodsName+' '+goods_info.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"description",style:{whiteSpace:'pre-wrap'}},goods_info.recommend))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price-trend",style:{backgroundImage:"url(".concat(lineChartBgImage,")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"cover"}),price_trend.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__antv_f2_react__["a" /* default */],{pixelRatio:window.devicePixelRatio},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["c" /* Chart */],{data:price_trend,scale:{y:{min:min*yMinRate,max:max*yMaxRate,nice:true}}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["a" /* Axis */],{field:"x",tickCount:5,style:{label:{fontSize:12,textBaseline:'middle'},line:{lineWidth:0.5,stroke:dateGridColor,strokeOpacity:0.3},grid:{lineDash:null,lineWidth:0.5,stroke:dateGridColor,strokeOpacity:0.2}}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["a" /* Axis */],{field:"y",tickCount:5,visible:true,style:{label:{fontSize:0},line:{lineWidth:0,stroke:dateGridColor,strokeOpacity:0.3},grid:{lineDash:null,lineWidth:0.5,stroke:dateGridColor,strokeOpacity:0.2}}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["f" /* Line */],{x:"x",y:"y",color:lineChartColor,style:{lineWidth:1},shape:{field:'type',callback:function callback(type){if(type==='实点'){return'line';}else{return'dash';}}}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["g" /* Point */],{x:"x",y:"y",color:lineChartColor,size:2}),bubbleBgImage&&price_trend.map(function(item,index){if(!item.bubble){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["e" /* ImageGuide */],{key:"ImageGuide-".concat(index),records:[item],src:bubbleBgImage,attrs:{width:iamgeGuideW,height:iamgeGuideH},offsetY:-15// offsetX={iamgeGuideX}
});}),price_trend.map(function(item,index){var y=item.y;var offsetX=0,fontSize=0;if(y<100){if(window.screen.width<410){offsetX=-12;fontSize=22;}else{offsetX=-13;fontSize=23;}}else if(y>=100&&y<1000){if(window.screen.width<410){offsetX=-13;fontSize=22;}else{offsetX=-15;fontSize=23;}}else if(y>=1000&&y<10000){//万
if(window.screen.width<410){offsetX=-15;fontSize=22;}else{offsetX=-17;fontSize=23;}}else if(y>=10000&&y<100000){//10万
if(window.screen.width<410){offsetX=-18;fontSize=20;}else{offsetX=-20;fontSize=22;}}else if(y>=100000&&y<1000000){//100万
if(window.screen.width<410){offsetX=-17;fontSize=17;}else{offsetX=-20;fontSize=19;}}else if(y>=1000000&&y<10000000){//1000万
if(window.screen.width<410){offsetX=-19;fontSize=16;}else{offsetX=-20.5;fontSize=18;}}else if(y>=10000000&&y<100000000){//1亿
if(window.screen.width<410){offsetX=-19;fontSize=15;}else{offsetX=-21;fontSize=16;}}else if(y>=100000000){//超过1亿
if(window.screen.width<410){offsetX=-18;fontSize=20;}else{offsetX=-20;fontSize=22;}}else{if(window.screen.width<410){offsetX=-19;fontSize=14;}else{offsetX=-21;fontSize=14;}}if(!item.bubble){return null;}var superMillionList=__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].truncateDecimals(y,2,10000*10000);var sparePriceList=[];if(superMillionList.length>0){//判断是否是超过亿
sparePriceList=superMillionList;}else{sparePriceList=__WEBPACK_IMPORTED_MODULE_22__utils_utils__["a" /* default */].truncateDecimals(y,2);}if(sparePriceList.length==1){//表示整数
offsetX+=6;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__antv_f2__["h" /* TextGuide */],{key:"TextGuide-".concat(index),records:[item],content:"\xA5".concat(sparePriceList.length>0?sparePriceList[0]+(sparePriceList.length>1?'.'+(sparePriceList[1]||0):'')+(superMillionList.length>0?'亿':'万'):y),style:{fill:priceFieldColor,fontSize:fontSize+'px',fontFamily:'PingFangSC-Medium, PingFang SC'},offsetY:textGuideY,offsetX:offsetX});}))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"action-btn"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price",style:{color:bottomPriceColor}},"\u5F53\u524D\u4EF7",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:'14px'}},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:'20px'}},sparePriceList1.length>0?sparePriceList1[0]:goods_info.price),sparePriceList1.length>1?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:'15px'}},".",sparePriceList1[1]||0):null,sparePrice&&sparePrice.unit?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("span",{style:{fontSize:'14px'}},sparePrice.unit):null)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:!isDark?'https://static.shihuocdn.cn/admin/files/20221028/fc6a818516614dff9285280456f8448e.png':'https://static.shihuocdn.cn/admin/files/20221115/622fbc9a30ce7760757990f43304addc.png',alt:"",onClick:function onClick(){return _this3.handleJump(goods_info);}}))));}}]);return PipelinePriceTrend;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelinePriceTrend.propTypes={config:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelinePriceTrend);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_f2__ = __webpack_require__(249);









var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(ErrorBoundary, _React$Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, _errorInfo) {
      var onError = this.props.onError;
      console.error('图表渲染失败: ', error);

      if (typeof onError === 'function') {
        onError(error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        var fallback = this.props.fallback;
        return fallback || null;
      } // @ts-ignore


      return this.props.children || null;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(_error) {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

function pickElement(children) {
  if (!children) return children;
  var result = __WEBPACK_IMPORTED_MODULE_7__antv_f2__["d" /* Children */].map(children, function (item) {
    if (!item) return item;
    var key = item.key,
        ref = item.ref,
        type = item.type,
        props = item.props;
    return {
      key: key,
      ref: ref,
      type: type,
      props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
        children: pickElement(props.children)
      })
    };
  });
  return result;
}

var ReactCanvas = /*#__PURE__*/function (_React$Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(ReactCanvas, _React$Component2);

  var _super2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ReactCanvas);

  function ReactCanvas(props) {
    var _this2;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ReactCanvas);

    _this2 = _super2.call(this, props);

    _this2.getProps = function () {
      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2),
          canvasRef = _assertThisInitialize.canvasRef,
          props = _assertThisInitialize.props;

      var canvasEl = canvasRef.current;
      var context = canvasEl.getContext('2d'); //  去掉 react 生成的 element 中无用属性

      var children = pickElement(props.children);
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        // 已经有高清方案，这里默认用1
        pixelRatio: 1
      }, props), {}, {
        children: children,
        // context 内部创建，不能被覆盖
        context: context
      });
    };

    var canvasRef = props.canvasRef;
    _this2.canvasRef = canvasRef || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();
    return _this2;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(ReactCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pickProps = this.getProps();
      var canvas = new __WEBPACK_IMPORTED_MODULE_7__antv_f2__["b" /* Canvas */](pickProps);
      this.canvas = canvas;
      canvas.render();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var canvas = this.canvas;
      var pickProps = this.getProps();
      canvas.update(pickProps);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var _props$className = props.className,
          className = _props$className === void 0 ? '' : _props$className;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('canvas', {
        className: "f2-chart ".concat(className),
        ref: this.canvasRef,
        style: {
          width: '100%',
          height: '100%',
          display: 'block',
          padding: 0,
          margin: 0
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var canvas = this.canvas;
      canvas.destroy();
    }
  }]);

  return ReactCanvas;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react__["forwardRef"])(function (props, ref) {
  var fallback = props.fallback,
      onError = props.onError;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ErrorBoundary, {
    fallback: fallback,
    onError: onError,
    children: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ReactCanvas, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
      ref: ref
    }))
  });
}));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filter__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contains__ = __webpack_require__(174);


/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to inspect.
 * @param {Array} values The values to exclude.
 * @return {Array} Returns the new array of filtered values.
 * @example
 * difference([2, 1], [2, 3]);  // => [1]
 */
var difference = function (arr, values) {
    if (values === void 0) { values = []; }
    return Object(__WEBPACK_IMPORTED_MODULE_0__filter__["a" /* default */])(arr, function (value) { return !Object(__WEBPACK_IMPORTED_MODULE_1__contains__["a" /* default */])(values, value); });
};
/* unused harmony default export */ var _unused_webpack_default_export = (difference);
//# sourceMappingURL=difference.js.map

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_function__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_match__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_plain_object__ = __webpack_require__(121);




function find(arr, predicate) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__is_array__["a" /* default */])(arr))
        return null;
    var _predicate;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_function__["a" /* default */])(predicate)) {
        _predicate = predicate;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__is_plain_object__["a" /* default */])(predicate)) {
        _predicate = function (a) { return Object(__WEBPACK_IMPORTED_MODULE_1__is_match__["a" /* default */])(a, predicate); };
    }
    if (_predicate) {
        for (var i = 0; i < arr.length; i += 1) {
            if (_predicate(arr[i])) {
                return arr[i];
            }
        }
    }
    return null;
}
/* harmony default export */ __webpack_exports__["a"] = (find);
//# sourceMappingURL=find.js.map

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function findIndex(arr, predicate, fromIndex) {
    if (fromIndex === void 0) { fromIndex = 0; }
    for (var i = fromIndex; i < arr.length; i++) {
        if (predicate(arr[i], i)) {
            // 找到终止循环
            return i;
        }
    }
    return -1;
}
/* harmony default export */ __webpack_exports__["a"] = (findIndex);
//# sourceMappingURL=find-index.js.map

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_nil__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_array__ = __webpack_require__(48);


var firstValue = function (data, name) {
    var rst = null;
    for (var i = 0; i < data.length; i++) {
        var obj = data[i];
        var value = obj[name];
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_nil__["a" /* default */])(value)) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is_array__["a" /* default */])(value)) {
                rst = value[0]; // todo 这里是否应该使用递归，调用 firstValue @绝云
            }
            else {
                rst = value;
            }
            break;
        }
    }
    return rst;
};
/* unused harmony default export */ var _unused_webpack_default_export = (firstValue);
//# sourceMappingURL=first-value.js.map

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);

/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to flatten.
 * @return {Array} Returns the new flattened array.
 * @example
 *
 * flatten([1, [2, [3, [4]], 5]]);  // => [1, 2, [3, [4]], 5]
 */
var flatten = function (arr) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr)) {
        return [];
    }
    var rst = [];
    for (var i = 0; i < arr.length; i++) {
        rst = rst.concat(arr[i]);
    }
    return rst;
};
/* harmony default export */ __webpack_exports__["a"] = (flatten);
//# sourceMappingURL=flatten.js.map

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);

/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to flatten.
 * @param {Array} result The array to return.
 * @return {Array} Returns the new flattened array.
 * @example
 *
 * flattenDeep([1, [2, [3, [4]], 5]]);  // => [1, 2, 3, 4, 5]
 */
var flattenDeep = function (arr, result) {
    if (result === void 0) { result = []; }
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr)) {
        result.push(arr);
    }
    else {
        for (var i = 0; i < arr.length; i += 1) {
            flattenDeep(arr[i], result);
        }
    }
    return result;
};
/* unused harmony default export */ var _unused_webpack_default_export = (flattenDeep);
//# sourceMappingURL=flatten-deep.js.map

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__max__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__min__ = __webpack_require__(254);



var getRange = function (values) {
    // 存在 NaN 时，min,max 判定会出问题
    var filterValues = values.filter(function (v) { return !isNaN(v); });
    if (!filterValues.length) {
        // 如果没有数值则直接返回0
        return {
            min: 0,
            max: 0,
        };
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(values[0])) {
        var tmp = [];
        for (var i = 0; i < values.length; i++) {
            tmp = tmp.concat(values[i]);
        }
        filterValues = tmp;
    }
    var max = Object(__WEBPACK_IMPORTED_MODULE_1__max__["a" /* default */])(filterValues);
    var min = Object(__WEBPACK_IMPORTED_MODULE_2__min__["a" /* default */])(filterValues);
    return {
        min: min,
        max: max,
    };
};
/* harmony default export */ __webpack_exports__["a"] = (getRange);
//# sourceMappingURL=get-range.js.map

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var arrPrototype = Array.prototype;
var splice = arrPrototype.splice;
var indexOf = arrPrototype.indexOf;
var pull = function (arr) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        var fromIndex = -1;
        while ((fromIndex = indexOf.call(arr, value)) > -1) {
            splice.call(arr, fromIndex, 1);
        }
    }
    return arr;
};
/* unused harmony default export */ var _unused_webpack_default_export = (pull);
//# sourceMappingURL=pull.js.map

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pull_at__ = __webpack_require__(255);


var remove = function (arr, predicate) {
    /**
     * const arr = [1, 2, 3, 4]
     * const evens = remove(arr, n => n % 2 == 0)
     * console.log(arr) // => [1, 3]
     * console.log(evens) // => [2, 4]
     */
    var result = [];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(arr)) {
        return result;
    }
    var i = -1;
    var indexes = [];
    var length = arr.length;
    while (++i < length) {
        var value = arr[i];
        if (predicate(value, i, arr)) {
            result.push(value);
            indexes.push(i);
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__pull_at__["a" /* default */])(arr, indexes);
    return result;
};
/* unused harmony default export */ var _unused_webpack_default_export = (remove);
//# sourceMappingURL=remove.js.map

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_string__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_function__ = __webpack_require__(67);



function sortBy(arr, key) {
    var comparer;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is_function__["a" /* default */])(key)) {
        comparer = function (a, b) { return key(a) - key(b); };
    }
    else {
        var keys_1 = [];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__is_string__["a" /* default */])(key)) {
            keys_1.push(key);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(key)) {
            keys_1 = key;
        }
        comparer = function (a, b) {
            for (var i = 0; i < keys_1.length; i += 1) {
                var prop = keys_1[i];
                if (a[prop] > b[prop]) {
                    return 1;
                }
                if (a[prop] < b[prop]) {
                    return -1;
                }
            }
            return 0;
        };
    }
    arr.sort(comparer);
    return arr;
}
/* unused harmony default export */ var _unused_webpack_default_export = (sortBy);
//# sourceMappingURL=sort-by.js.map

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uniq__ = __webpack_require__(257);

var union = function () {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__uniq__["a" /* default */])([].concat.apply([], sources));
};
/* unused harmony default export */ var _unused_webpack_default_export = (union);
//# sourceMappingURL=union.js.map

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_nil__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = (function (data, name) {
    var rst = [];
    var tmpMap = {};
    for (var i = 0; i < data.length; i++) {
        var obj = data[i];
        var value = obj[name];
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__is_nil__["a" /* default */])(value)) {
            // flatten
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(value)) {
                value = [value];
            }
            for (var j = 0; j < value.length; j++) {
                var val = value[j];
                // unique
                if (!tmpMap[val]) {
                    rst.push(val);
                    tmpMap[val] = true;
                }
            }
        }
    }
    return rst;
});
//# sourceMappingURL=values-of-key.js.map

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = head;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

function head(o) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(o)) {
        return o[0];
    }
    return undefined;
}
//# sourceMappingURL=head.js.map

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = last;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

function last(o) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(o)) {
        var arr = o;
        return arr[arr.length - 1];
    }
    return undefined;
}
//# sourceMappingURL=last.js.map

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_string__ = __webpack_require__(80);


function startsWith(arr, e) {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__is_string__["a" /* default */])(arr)) ? arr[0] === e : false;
}
/* unused harmony default export */ var _unused_webpack_default_export = (startsWith);
//# sourceMappingURL=starts-with.js.map

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_string__ = __webpack_require__(80);


function endsWith(arr, e) {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__is_string__["a" /* default */])(arr)) ? arr[arr.length - 1] === e : false;
}
/* unused harmony default export */ var _unused_webpack_default_export = (endsWith);
//# sourceMappingURL=ends-with.js.map

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 只要有一个不满足条件就返回 false
 * @param arr
 * @param func
 */
var every = function (arr, func) {
    for (var i = 0; i < arr.length; i++) {
        if (!func(arr[i], i))
            return false;
    }
    return true;
};
/* unused harmony default export */ var _unused_webpack_default_export = (every);
//# sourceMappingURL=every.js.map

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 只要有一个满足条件就返回 true
 * @param arr
 * @param func
 */
var some = function (arr, func) {
    for (var i = 0; i < arr.length; i++) {
        if (func(arr[i], i))
            return true;
    }
    return false;
};
/* unused harmony default export */ var _unused_webpack_default_export = (some);
//# sourceMappingURL=some.js.map

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__group_to_map__ = __webpack_require__(258);

/* harmony default export */ __webpack_exports__["a"] = (function (data, condition) {
    if (!condition) {
        // 没有条件，则自身改成数组
        return [data];
    }
    var groups = Object(__WEBPACK_IMPORTED_MODULE_0__group_to_map__["a" /* default */])(data, condition);
    var array = [];
    for (var i in groups) {
        array.push(groups[i]);
    }
    return array;
});
//# sourceMappingURL=group.js.map

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取封装的事件
 * @protected
 * @param  {Object} obj   对象
 * @param  {String} action 事件名称
 * @return {Function}        返回事件处理函数
 */
function getWrapBehavior(obj, action) {
    return obj['_wrap_' + action];
}
/* unused harmony default export */ var _unused_webpack_default_export = (getWrapBehavior);
//# sourceMappingURL=get-wrap-behavior.js.map

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 封装事件，便于使用上下文this,和便于解除事件时使用
 * @protected
 * @param  {Object} obj   对象
 * @param  {String} action 事件名称
 * @return {Function}        返回事件处理函数
 */
function wrapBehavior(obj, action) {
    if (obj['_wrap_' + action]) {
        return obj['_wrap_' + action];
    }
    var method = function (e) {
        obj[action](e);
    };
    obj['_wrap_' + action] = method;
    return method;
}
/* unused harmony default export */ var _unused_webpack_default_export = (wrapBehavior);
//# sourceMappingURL=wrap-behavior.js.map

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var numColorCache = {};
function numberToColor(num) {
    // 增加缓存
    var color = numColorCache[num];
    if (!color) {
        var str = num.toString(16);
        for (var i = str.length; i < 6; i++) {
            str = '0' + str;
        }
        color = '#' + str;
        numColorCache[num] = color;
    }
    return color;
}
/* unused harmony default export */ var _unused_webpack_default_export = (numberToColor);
//# sourceMappingURL=number2color.js.map

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);

function parseRadius(radius) {
    var r1 = 0, r2 = 0, r3 = 0, r4 = 0;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(radius)) {
        if (radius.length === 1) {
            r1 = r2 = r3 = r4 = radius[0];
        }
        else if (radius.length === 2) {
            r1 = r3 = radius[0];
            r2 = r4 = radius[1];
        }
        else if (radius.length === 3) {
            r1 = radius[0];
            r2 = r4 = radius[1];
            r3 = radius[2];
        }
        else {
            r1 = radius[0];
            r2 = radius[1];
            r3 = radius[2];
            r4 = radius[3];
        }
    }
    else {
        r1 = r2 = r3 = r4 = radius;
    }
    return {
        r1: r1,
        r2: r2,
        r3: r3,
        r4: r4
    };
}
/* unused harmony default export */ var _unused_webpack_default_export = (parseRadius);
//# sourceMappingURL=parse-radius.js.map

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var clamp = function (a, min, max) {
    if (a < min) {
        return min;
    }
    else if (a > max) {
        return max;
    }
    return a;
};
/* unused harmony default export */ var _unused_webpack_default_export = (clamp);
//# sourceMappingURL=clamp.js.map

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fixedBase = function (v, base) {
    var str = base.toString();
    var index = str.indexOf('.');
    if (index === -1) {
        return Math.round(v);
    }
    var length = str.substr(index + 1).length;
    if (length > 20) {
        length = 20;
    }
    return parseFloat(v.toFixed(length));
};
/* harmony default export */ __webpack_exports__["a"] = (fixedBase);
//# sourceMappingURL=fixed-base.js.map

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);

var isDecimal = function (num) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(num) && num % 1 !== 0;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isDecimal);
//# sourceMappingURL=is-decimal.js.map

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);

var isEven = function (num) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(num) && num % 2 === 0;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isEven);
//# sourceMappingURL=is-even.js.map

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);

var isInteger = Number.isInteger ? Number.isInteger : function (num) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(num) && num % 1 === 0;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isInteger);
//# sourceMappingURL=is-integer.js.map

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);

var isNegative = function (num) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(num) && num < 0;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isNegative);
//# sourceMappingURL=is-negative.js.map

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumberEqual;
var PRECISION = 0.00001; // numbers less than this is considered as 0
function isNumberEqual(a, b, precision) {
    if (precision === void 0) { precision = PRECISION; }
    return Math.abs((a - b)) < precision;
}
;
//# sourceMappingURL=is-number-equal.js.map

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);

var isOdd = function (num) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(num) && num % 2 !== 0;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isOdd);
//# sourceMappingURL=is-odd.js.map

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);

var isPositive = function (num) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(num) && num > 0;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isPositive);
//# sourceMappingURL=is-positive.js.map

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


/**
 * @param {Array} arr The array to iterate over.
 * @param {Function} [fn] The iteratee invoked per element.
 * @return {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (arr, fn) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr)) {
        return undefined;
    }
    var maxItem;
    var max = -Infinity;
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        var v = Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(fn) ? fn(item) : item[fn];
        if (v > max) {
            maxItem = item;
            max = v;
        }
    }
    return maxItem;
});
//# sourceMappingURL=max-by.js.map

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


/**
 * @param {Array} arr The array to iterate over.
 * @param {Function} [fn] The iteratee invoked per element.
 * @return {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * minBy(objects, 'n');
 * // => { 'n': 1 }
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (arr, fn) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(arr)) {
        return undefined;
    }
    var minItem;
    var min = Infinity;
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        var v = Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(fn) ? fn(item) : item[fn];
        if (v < min) {
            minItem = item;
            min = v;
        }
    }
    return minItem;
});
//# sourceMappingURL=min-by.js.map

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mod = function (n, m) {
    return ((n % m) + m) % m;
};
/* unused harmony default export */ var _unused_webpack_default_export = (mod);
//# sourceMappingURL=mod.js.map

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DEGREE = 180 / Math.PI;
var toDegree = function (radian) {
    return DEGREE * radian;
};
/* unused harmony default export */ var _unused_webpack_default_export = (toDegree);
//# sourceMappingURL=to-degree.js.map

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (parseInt);
//# sourceMappingURL=to-integer.js.map

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var RADIAN = Math.PI / 180;
var toRadian = function (degree) {
    return RADIAN * degree;
};
/* unused harmony default export */ var _unused_webpack_default_export = (toRadian);
//# sourceMappingURL=to-radian.js.map

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__each__ = __webpack_require__(103);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__each__["a" /* default */]);
//# sourceMappingURL=for-in.js.map

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has__ = __webpack_require__(260);

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__has__["a" /* default */]);
//# sourceMappingURL=has-key.js.map

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contains__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values__ = __webpack_require__(176);


/* unused harmony default export */ var _unused_webpack_default_export = (function (obj, value) { return Object(__WEBPACK_IMPORTED_MODULE_0__contains__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__values__["a" /* default */])(obj), value); });
//# sourceMappingURL=has-value.js.map

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_string__ = __webpack_require__(104);

var lowerCase = function (str) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__to_string__["a" /* default */])(str).toLowerCase();
};
/* unused harmony default export */ var _unused_webpack_default_export = (lowerCase);
//# sourceMappingURL=lower-case.js.map

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_string__ = __webpack_require__(104);

var lowerFirst = function (value) {
    var str = Object(__WEBPACK_IMPORTED_MODULE_0__to_string__["a" /* default */])(value);
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/* unused harmony default export */ var _unused_webpack_default_export = (lowerFirst);
//# sourceMappingURL=lower-first.js.map

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function substitute(str, o) {
    if (!str || !o) {
        return str;
    }
    return str.replace(/\\?\{([^{}]+)\}/g, function (match, name) {
        if (match.charAt(0) === '\\') {
            return match.slice(1);
        }
        return (o[name] === undefined) ? '' : o[name];
    });
}
/* harmony default export */ __webpack_exports__["a"] = (substitute);
//# sourceMappingURL=substitute.js.map

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_string__ = __webpack_require__(104);

var upperCase = function (str) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__to_string__["a" /* default */])(str).toUpperCase();
};
/* unused harmony default export */ var _unused_webpack_default_export = (upperCase);
//# sourceMappingURL=upper-case.js.map

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_string__ = __webpack_require__(104);

var upperFirst = function (value) {
    var str = Object(__WEBPACK_IMPORTED_MODULE_0__to_string__["a" /* default */])(value);
    return str.charAt(0).toUpperCase() + str.substring(1);
};
/* harmony default export */ __webpack_exports__["a"] = (upperFirst);
//# sourceMappingURL=upper-first.js.map

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);
/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */

var isArguments = function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Arguments');
};
/* unused harmony default export */ var _unused_webpack_default_export = (isArguments);
//# sourceMappingURL=is-arguments.js.map

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);
/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */

var isBoolean = function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Boolean');
};
/* harmony default export */ __webpack_exports__["a"] = (isBoolean);
//# sourceMappingURL=is-boolean.js.map

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);

var isDate = function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Date');
};
/* harmony default export */ __webpack_exports__["a"] = (isDate);
//# sourceMappingURL=is-date.js.map

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);
/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */

var isError = function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(value, 'Error');
};
/* unused harmony default export */ var _unused_webpack_default_export = (isError);
//# sourceMappingURL=is-error.js.map

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_number__ = __webpack_require__(81);
/**
 * 判断是否为有限数
 * @return {Boolean}
 */

/* unused harmony default export */ var _unused_webpack_default_export = (function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_number__["a" /* default */])(value) && isFinite(value);
});
//# sourceMappingURL=is-finite.js.map

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isNull = function (value) {
    return value === null;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isNull);
//# sourceMappingURL=is-null.js.map

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_type__ = __webpack_require__(70);

var isRegExp = function (str) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_type__["a" /* default */])(str, 'RegExp');
};
/* unused harmony default export */ var _unused_webpack_default_export = (isRegExp);
//# sourceMappingURL=is-reg-exp.js.map

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isUndefined = function (value) {
    return value === undefined;
};
/* harmony default export */ __webpack_exports__["a"] = (isUndefined);
//# sourceMappingURL=is-undefined.js.map

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */
var isElement = function (o) {
    return o instanceof Element || o instanceof HTMLDocument;
};
/* unused harmony default export */ var _unused_webpack_default_export = (isElement);
//# sourceMappingURL=is-element.js.map

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function requestAnimationFrame(fn) {
    var method = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        // @ts-ignore
        window.mozRequestAnimationFrame ||
        // @ts-ignore
        window.msRequestAnimationFrame ||
        function (f) {
            return setTimeout(f, 16);
        };
    return method(fn);
}
;
//# sourceMappingURL=request-animation-frame.js.map

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function cancelAnimationFrame(handler) {
    var method = window.cancelAnimationFrame ||
        window.webkitCancelAnimationFrame ||
        // @ts-ignore
        window.mozCancelAnimationFrame ||
        // @ts-ignore
        window.msCancelAnimationFrame ||
        clearTimeout;
    method(handler);
}
;
//# sourceMappingURL=clear-animation-frame.js.map

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mix__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


var augment = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var c = args[0];
    for (var i = 1; i < args.length; i++) {
        var obj = args[i];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(obj)) {
            obj = obj.prototype;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__mix__["a" /* default */])(c.prototype, obj);
    }
};
/* unused harmony default export */ var _unused_webpack_default_export = (augment);
//# sourceMappingURL=augment.js.map

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);

var clone = function (obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    var rst;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(obj)) {
        rst = [];
        for (var i = 0, l = obj.length; i < l; i++) {
            if (typeof obj[i] === 'object' && obj[i] != null) {
                rst[i] = clone(obj[i]);
            }
            else {
                rst[i] = obj[i];
            }
        }
    }
    else {
        rst = {};
        for (var k in obj) {
            if (typeof obj[k] === 'object' && obj[k] != null) {
                rst[k] = clone(obj[k]);
            }
            else {
                rst[k] = obj[k];
            }
        }
    }
    return rst;
};
/* harmony default export */ __webpack_exports__["a"] = (clone);
//# sourceMappingURL=clone.js.map

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
/* unused harmony default export */ var _unused_webpack_default_export = (debounce);
//# sourceMappingURL=debounce.js.map

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_plain_object__ = __webpack_require__(121);


var MAX_MIX_LEVEL = 5;
function _deepMix(dist, src, level, maxLevel) {
    level = level || 0;
    maxLevel = maxLevel || MAX_MIX_LEVEL;
    for (var key in src) {
        if (src.hasOwnProperty(key)) {
            var value = src[key];
            if (value !== null && Object(__WEBPACK_IMPORTED_MODULE_1__is_plain_object__["a" /* default */])(value)) {
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__is_plain_object__["a" /* default */])(dist[key])) {
                    dist[key] = {};
                }
                if (level < maxLevel) {
                    _deepMix(dist[key], value, level + 1, maxLevel);
                }
                else {
                    dist[key] = src[key];
                }
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_0__is_array__["a" /* default */])(value)) {
                dist[key] = [];
                dist[key] = dist[key].concat(value);
            }
            else if (value !== undefined) {
                dist[key] = value;
            }
        }
    }
}
// todo 重写
var deepMix = function (rst) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < args.length; i += 1) {
        _deepMix(rst, args[i]);
    }
    return rst;
};
/* harmony default export */ __webpack_exports__["a"] = (deepMix);
//# sourceMappingURL=deep-mix.js.map

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mix__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_function__ = __webpack_require__(67);


var extend = function (subclass, superclass, overrides, staticOverrides) {
    // 如果只提供父类构造函数，则自动生成子类构造函数
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__is_function__["a" /* default */])(superclass)) {
        overrides = superclass;
        superclass = subclass;
        subclass = function () { };
    }
    var create = Object.create ?
        function (proto, c) {
            return Object.create(proto, {
                constructor: {
                    value: c
                }
            });
        } :
        function (proto, c) {
            function Tmp() { }
            Tmp.prototype = proto;
            var o = new Tmp();
            o.constructor = c;
            return o;
        };
    var superObj = create(superclass.prototype, subclass); // new superclass(),//实例化父类作为子类的prototype
    subclass.prototype = Object(__WEBPACK_IMPORTED_MODULE_0__mix__["a" /* default */])(superObj, subclass.prototype); // 指定子类的prototype
    subclass.superclass = create(superclass.prototype, superclass);
    Object(__WEBPACK_IMPORTED_MODULE_0__mix__["a" /* default */])(superObj, overrides);
    Object(__WEBPACK_IMPORTED_MODULE_0__mix__["a" /* default */])(subclass, staticOverrides);
    return subclass;
};
/* unused harmony default export */ var _unused_webpack_default_export = (extend);
//# sourceMappingURL=extend.js.map

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

var indexOf = function (arr, obj) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(arr)) {
        return -1;
    }
    var m = Array.prototype.indexOf;
    if (m) {
        return m.call(arr, obj);
    }
    var index = -1;
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === obj) {
            index = i;
            break;
        }
    }
    return index;
};
/* harmony default export */ __webpack_exports__["a"] = (indexOf);
//# sourceMappingURL=index-of.js.map

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_nil__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_array_like__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__get_type__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_prototype__ = __webpack_require__(262);




var hasOwnProperty = Object.prototype.hasOwnProperty;
function isEmpty(value) {
    /**
     * isEmpty(null) => true
     * isEmpty() => true
     * isEmpty(true) => true
     * isEmpty(1) => true
     * isEmpty([1, 2, 3]) => false
     * isEmpty('abc') => false
     * isEmpty({ a: 1 }) => false
     */
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_nil__["a" /* default */])(value)) {
        return true;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is_array_like__["a" /* default */])(value)) {
        return !value.length;
    }
    var type = Object(__WEBPACK_IMPORTED_MODULE_2__get_type__["a" /* default */])(value);
    if (type === 'Map' || type === 'Set') {
        return !value.size;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__is_prototype__["a" /* default */])(value)) {
        return !Object.keys(value).length;
    }
    for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
            return false;
        }
    }
    return true;
}
/* harmony default export */ __webpack_exports__["a"] = (isEmpty);
//# sourceMappingURL=is-empty.js.map

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_function__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_equal__ = __webpack_require__(264);


/**
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [fn] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * isEqualWith(array, other, customizer);  // => true
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (value, other, fn) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_function__["a" /* default */])(fn)) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__is_equal__["a" /* default */])(value, other);
    }
    return !!fn(value, other);
});
//# sourceMappingURL=is-equal-with.js.map

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

var map = function (arr, func) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(arr)) {
        // @ts-ignore
        return arr;
    }
    var result = [];
    for (var index = 0; index < arr.length; index++) {
        var value = arr[index];
        result.push(func(value, index));
    }
    return result;
};
/* harmony default export */ __webpack_exports__["a"] = (map);
//# sourceMappingURL=map.js.map

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_nil__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_object__ = __webpack_require__(139);


var identity = function (v) { return v; };
/* harmony default export */ __webpack_exports__["a"] = (function (object, func) {
    if (func === void 0) { func = identity; }
    var r = {};
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is_object__["a" /* default */])(object) && !Object(__WEBPACK_IMPORTED_MODULE_0__is_nil__["a" /* default */])(object)) {
        Object.keys(object).forEach(function (key) {
            // @ts-ignore
            r[key] = func(object[key], key);
        });
    }
    return r;
});
//# sourceMappingURL=map-values.js.map

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_string__ = __webpack_require__(80);

/**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param key
 * @param defaultValue
 */
/* harmony default export */ __webpack_exports__["a"] = (function (obj, key, defaultValue) {
    var p = 0;
    var keyArr = Object(__WEBPACK_IMPORTED_MODULE_0__is_string__["a" /* default */])(key) ? key.split('.') : key;
    while (obj && p < keyArr.length) {
        obj = obj[keyArr[p++]];
    }
    return (obj === undefined || p < keyArr.length) ? defaultValue : obj;
});
//# sourceMappingURL=get.js.map

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_object__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_string__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_number__ = __webpack_require__(81);



/**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param path
 * @param value
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (obj, path, value) {
    var o = obj;
    var keyArr = Object(__WEBPACK_IMPORTED_MODULE_1__is_string__["a" /* default */])(path) ? path.split('.') : path;
    keyArr.forEach(function (key, idx) {
        // 不是最后一个
        if (idx < keyArr.length - 1) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__is_object__["a" /* default */])(o[key])) {
                o[key] = Object(__WEBPACK_IMPORTED_MODULE_2__is_number__["a" /* default */])(keyArr[idx + 1]) ? [] : {};
            }
            o = o[key];
        }
        else {
            o[key] = value;
        }
    });
    return obj;
});
//# sourceMappingURL=set.js.map

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__each__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_plain_object__ = __webpack_require__(121);


var hasOwnProperty = Object.prototype.hasOwnProperty;
/* harmony default export */ __webpack_exports__["a"] = (function (object, keys) {
    if (object === null || !Object(__WEBPACK_IMPORTED_MODULE_1__is_plain_object__["a" /* default */])(object)) {
        return {};
    }
    var result = {};
    Object(__WEBPACK_IMPORTED_MODULE_0__each__["a" /* default */])(keys, function (key) {
        if (hasOwnProperty.call(object, key)) {
            result[key] = object[key];
        }
    });
    return result;
});
//# sourceMappingURL=pick.js.map

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reduce__ = __webpack_require__(256);

/* harmony default export */ __webpack_exports__["a"] = (function (obj, keys) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__reduce__["a" /* default */])(obj, function (r, curr, key) {
        if (!keys.includes(key)) {
            r[key] = curr;
        }
        return r;
    }, {});
});
//# sourceMappingURL=omit.js.map

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options)
        options = {};
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout)
            context = args = null;
    };
    var throttled = function () {
        var now = Date.now();
        if (!previous && options.leading === false)
            previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout)
                context = args = null;
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
    throttled.cancel = function () {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
});
//# sourceMappingURL=throttle.js.map

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_array_like__ = __webpack_require__(66);

/* unused harmony default export */ var _unused_webpack_default_export = (function (value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__is_array_like__["a" /* default */])(value) ? Array.prototype.slice.call(value) : [];
});
//# sourceMappingURL=to-array.js.map

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var map = {};
/* unused harmony default export */ var _unused_webpack_default_export = (function (prefix) {
    prefix = prefix || 'g';
    if (!map[prefix]) {
        map[prefix] = 1;
    }
    else {
        map[prefix] += 1;
    }
    return prefix + map[prefix];
});
//# sourceMappingURL=unique-id.js.map

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function () { });
//# sourceMappingURL=noop.js.map

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (v) { return v; });
//# sourceMappingURL=identity.js.map

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = size;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_nil__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_array_like__ = __webpack_require__(66);


function size(o) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is_nil__["a" /* default */])(o)) {
        return 0;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is_array_like__["a" /* default */])(o)) {
        return o.length;
    }
    return Object.keys(o).length;
}
//# sourceMappingURL=size.js.map

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["a"] = __spreadArrays;
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_string__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__to_string__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__measure_text_width__ = __webpack_require__(265);



/**
 * 获取文本的 ... 文本。
 * 算法（减少每次 measureText 的长度，measureText 的性能跟字符串时间相关）：
 * 1. 先通过 STEP 逐步计算，找到最后一个小于 maxWidth 的字符串
 * 2. 然后对最后这个字符串二分计算
 * @param text 需要计算的文本, 由于历史原因 除了支持string，还支持空值,number和数组等
 * @param maxWidth 最大宽度
 * @param font 字体
 * @param str 要替换的文本
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (text, maxWidth, font, str) {
    if (str === void 0) { str = '...'; }
    var STEP = 16; // 每次 16，调参工程师
    var PLACEHOLDER_WIDTH = Object(__WEBPACK_IMPORTED_MODULE_2__measure_text_width__["a" /* default */])(str, font);
    var leftText = !Object(__WEBPACK_IMPORTED_MODULE_0__is_string__["a" /* default */])(text) ? Object(__WEBPACK_IMPORTED_MODULE_1__to_string__["a" /* default */])(text) : text;
    var leftWidth = maxWidth;
    var r = []; // 最终的分段字符串
    var currentText;
    var currentWidth;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__measure_text_width__["a" /* default */])(text, font) <= maxWidth) {
        return text;
    }
    // 首先通过 step 计算，找出最大的未超出长度的
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // 更新字符串
        currentText = leftText.substr(0, STEP);
        // 计算宽度
        currentWidth = Object(__WEBPACK_IMPORTED_MODULE_2__measure_text_width__["a" /* default */])(currentText, font);
        // 超出剩余宽度，则停止
        if (currentWidth + PLACEHOLDER_WIDTH > leftWidth) {
            if (currentWidth > leftWidth) {
                break;
            }
        }
        r.push(currentText);
        // 没有超出，则计算剩余宽度
        leftWidth -= currentWidth;
        leftText = leftText.substr(STEP);
        // 字符串整体没有超出
        if (!leftText) {
            return r.join('');
        }
    }
    // 最下的最后一个 STEP，使用 1 递增（用二分效果更高）
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // 更新字符串
        currentText = leftText.substr(0, 1);
        // 计算宽度
        currentWidth = Object(__WEBPACK_IMPORTED_MODULE_2__measure_text_width__["a" /* default */])(currentText, font);
        // 超出剩余宽度，则停止
        if (currentWidth + PLACEHOLDER_WIDTH > leftWidth) {
            break;
        }
        r.push(currentText);
        // 没有超出，则计算剩余宽度
        leftWidth -= currentWidth;
        leftText = leftText.substr(1);
        if (!leftText) {
            return r.join('');
        }
    }
    return "" + r.join('') + str;
});
//# sourceMappingURL=get-ellipsis-text.js.map

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * k-v 存储
 */
var default_1 = /** @class */ (function () {
    function default_1() {
        this.map = {};
    }
    default_1.prototype.has = function (key) {
        return this.map[key] !== undefined;
    };
    default_1.prototype.get = function (key, def) {
        var v = this.map[key];
        return v === undefined ? def : v;
    };
    default_1.prototype.set = function (key, value) {
        this.map[key] = value;
    };
    default_1.prototype.clear = function () {
        this.map = {};
    };
    default_1.prototype.delete = function (key) {
        delete this.map[key];
    };
    default_1.prototype.size = function () {
        return Object.keys(this.map).length;
    };
    return default_1;
}());
/* harmony default export */ __webpack_exports__["a"] = (default_1);
//# sourceMappingURL=cache.js.map

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__children__ = __webpack_require__(102);








var Timeline = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Timeline, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Timeline);

  function Timeline(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Timeline);

    _this = _super.call(this, props);

    _this.next = function () {
      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          state = _assertThisInitialize.state,
          props = _assertThisInitialize.props;

      var index = state.index,
          count = state.count,
          delay = state.delay;
      var loop = props.loop;
      var next = loop ? (index + 1) % count : index + 1;

      if (next < count) {
        setTimeout(function () {
          _this.setState({
            index: next
          });
        }, delay || 0);
      }
    };

    var delay = props.delay,
        _props$start = props.start,
        start = _props$start === void 0 ? 0 : _props$start,
        children = props.children;
    var count = __WEBPACK_IMPORTED_MODULE_6__children__["a" /* default */].toArray(children).length;
    _this.state = {
      delay: delay,
      count: count,
      index: start
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Timeline, [{
    key: "didMount",
    value: function didMount() {
      var context = this.context;
      var root = context.root;
      root.on('animationEnd', this.next);
    }
  }, {
    key: "didUnmount",
    value: function didUnmount() {
      var context = this.context;
      var root = context.root;
      root.off('animationEnd', this.next);
    }
  }, {
    key: "render",
    value: function render() {
      var state = this.state,
          props = this.props;
      var children = props.children;
      var index = state.index;
      var childrenArray = __WEBPACK_IMPORTED_MODULE_6__children__["a" /* default */].toArray(children);
      return childrenArray[index];
    }
  }]);

  return Timeline;
}(__WEBPACK_IMPORTED_MODULE_5__base_component__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (Timeline);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_event_emitter__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_f2_graphic__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_diff__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_equal__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__base_updater__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__theme__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__animation__ = __webpack_require__(751);


















function measureText(canvas, px2hd) {
  return function (text, font) {
    var _ref = font || {},
        fontSize = _ref.fontSize,
        fontFamily = _ref.fontFamily,
        fontStyle = _ref.fontStyle,
        fontWeight = _ref.fontWeight,
        fontVariant = _ref.fontVariant;

    var shape = canvas.addShape('text', {
      attrs: {
        x: 0,
        y: 0,
        fontSize: px2hd(fontSize),
        fontFamily: fontFamily,
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        fontVariant: fontVariant,
        text: text
      }
    });

    var _shape$getBBox = shape.getBBox(),
        width = _shape$getBBox.width,
        height = _shape$getBBox.height;

    shape.remove(true);
    return {
      width: width,
      height: height
    };
  };
} // 顶层Canvas标签


var Canvas = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Canvas, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Canvas);

  function Canvas(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Canvas);

    _this = _super.call(this, props);
    var context = props.context,
        pixelRatio = props.pixelRatio,
        width = props.width,
        height = props.height,
        _props$animate = props.animate,
        animate = _props$animate === void 0 ? true : _props$animate,
        customPx2hd = props.px2hd,
        customTheme = props.theme,
        customStyle = props.style,
        createImage = props.createImage,
        landscape = props.landscape;
    var px2hd = Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["v" /* isFunction */])(customPx2hd) ? Object(__WEBPACK_IMPORTED_MODULE_15__util__["a" /* batch2hd */])(customPx2hd) : __WEBPACK_IMPORTED_MODULE_15__util__["e" /* px2hd */];
    var theme = px2hd(Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["d" /* deepMix */])({}, __WEBPACK_IMPORTED_MODULE_14__theme__["a" /* default */], customTheme)); // 创建G的canvas

    var canvas = Object(__WEBPACK_IMPORTED_MODULE_7__antv_f2_graphic__["f" /* createCanvas */])({
      context: context,
      pixelRatio: pixelRatio,
      fontFamily: theme.fontFamily,
      width: width,
      height: height,
      createImage: createImage,
      landscape: landscape
    }); // 组件更新器

    var updater = Object(__WEBPACK_IMPORTED_MODULE_13__base_updater__["a" /* createUpdater */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // 供全局使用的一些变量

    var componentContext = {
      root: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
      canvas: canvas,
      theme: theme,
      px2hd: px2hd,
      measureText: measureText(canvas, px2hd)
    }; // 动画模块

    var animation = new __WEBPACK_IMPORTED_MODULE_16__animation__["a" /* default */](canvas);
    _this.canvas = canvas;
    _this.container = canvas;
    _this.context = componentContext;
    _this.updater = updater;
    _this.animate = animate;
    _this.animation = animation;
    _this.theme = theme;
    _this._ee = new __WEBPACK_IMPORTED_MODULE_6__antv_event_emitter__["a" /* default */]();

    _this.updateLayout(props);

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Canvas, [{
    key: "renderComponents",
    value: function renderComponents(components) {
      if (!components || !components.length) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_10__base_diff__["c" /* renderComponent */])(components);
      this.draw();
    }
  }, {
    key: "update",
    value: function update(nextProps) {
      var props = this.props;

      if (Object(__WEBPACK_IMPORTED_MODULE_11__base_equal__["a" /* default */])(nextProps, props)) {
        return;
      }

      this.props = nextProps;
      this.render();
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      var _this$canvas$_attrs = this.canvas._attrs,
          canvasWidth = _this$canvas$_attrs.width,
          canvasHeight = _this$canvas$_attrs.height;
      this.canvas.changeSize(width || canvasWidth, height || canvasHeight); // this.canvas.clear();
      // this.children = null;

      this.updateLayout(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.props), {}, {
        width: width,
        height: height
      }));
      this.render();
    }
  }, {
    key: "updateLayout",
    value: function updateLayout(props) {
      var _this$canvas$_attrs2 = this.canvas._attrs,
          canvasWidth = _this$canvas$_attrs2.width,
          canvasHeight = _this$canvas$_attrs2.height;
      var style = this.context.px2hd(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        left: 0,
        top: 0,
        width: (props === null || props === void 0 ? void 0 : props.width) || canvasWidth,
        height: (props === null || props === void 0 ? void 0 : props.height) || canvasHeight,
        padding: this.theme.padding
      }, props.style));
      this.layout = __WEBPACK_IMPORTED_MODULE_12__base_layout__["a" /* default */].fromStyle(style);
      this.context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.context), {}, {
        left: this.layout.left,
        top: this.layout.top,
        width: this.layout.width,
        height: this.layout.height
      });
    }
  }, {
    key: "draw",
    value: function draw() {
      var canvas = this.canvas,
          animate = this.animate;

      if (animate === false) {
        canvas.draw();
        return;
      }

      this.play();
    }
  }, {
    key: "play",
    value: function play() {
      var _this2 = this;

      var canvas = this.canvas,
          animation = this.animation; // 执行动画

      animation.abort();
      animation.play(canvas, function () {
        _this2.emit('animationEnd');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var lastChildren = this.children,
          props = this.props;
      var nextChildren = props.children;
      Object(__WEBPACK_IMPORTED_MODULE_10__base_diff__["b" /* renderChildren */])(this, nextChildren, lastChildren);
      this.draw();
      return null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var canvas = this.canvas,
          children = this.children;
      Object(__WEBPACK_IMPORTED_MODULE_10__base_diff__["a" /* destroyElement */])(children);
      canvas.destroy();
    }
  }, {
    key: "on",
    value: function on(type, listener) {
      this._ee.on(type, listener);
    }
  }, {
    key: "emit",
    value: function emit(type, event) {
      this._ee.emit(type, event);
    }
  }, {
    key: "off",
    value: function off(type, listener) {
      this._ee.off(type, listener);
    }
  }]);

  return Canvas;
}(__WEBPACK_IMPORTED_MODULE_9__base_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Canvas);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var WILDCARD = '*';
/* event-emitter */
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this._events = {};
    }
    /**
     * 监听一个事件
     * @param evt
     * @param callback
     * @param once
     */
    EventEmitter.prototype.on = function (evt, callback, once) {
        if (!this._events[evt]) {
            this._events[evt] = [];
        }
        this._events[evt].push({
            callback: callback,
            once: !!once,
        });
        return this;
    };
    /**
     * 监听一个事件一次
     * @param evt
     * @param callback
     */
    EventEmitter.prototype.once = function (evt, callback) {
        return this.on(evt, callback, true);
    };
    /**
     * 触发一个事件
     * @param evt
     * @param args
     */
    EventEmitter.prototype.emit = function (evt) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var events = this._events[evt] || [];
        var wildcardEvents = this._events[WILDCARD] || [];
        // 实际的处理 emit 方法
        var doEmit = function (es) {
            var length = es.length;
            for (var i = 0; i < length; i++) {
                if (!es[i]) {
                    continue;
                }
                var _a = es[i], callback = _a.callback, once = _a.once;
                if (once) {
                    es.splice(i, 1);
                    if (es.length === 0) {
                        delete _this._events[evt];
                    }
                    length--;
                    i--;
                }
                callback.apply(_this, args);
            }
        };
        doEmit(events);
        doEmit(wildcardEvents);
    };
    /**
     * 取消监听一个事件，或者一个channel
     * @param evt
     * @param callback
     */
    EventEmitter.prototype.off = function (evt, callback) {
        if (!evt) {
            // evt 为空全部清除
            this._events = {};
        }
        else {
            if (!callback) {
                // evt 存在，callback 为空，清除事件所有方法
                delete this._events[evt];
            }
            else {
                // evt 存在，callback 存在，清除匹配的
                var events = this._events[evt] || [];
                var length_1 = events.length;
                for (var i = 0; i < length_1; i++) {
                    if (events[i].callback === callback) {
                        events.splice(i, 1);
                        length_1--;
                        i--;
                    }
                }
                if (events.length === 0) {
                    delete this._events[evt];
                }
            }
        }
        return this;
    };
    /* 当前所有的事件 */
    EventEmitter.prototype.getEvents = function () {
        return this._events;
    };
    return EventEmitter;
}());
/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);
//# sourceMappingURL=index.js.map

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canvas__ = __webpack_require__(713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__canvas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__group__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shape__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__shape__["a"]; });




/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_emit__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_controller__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__canvas_element__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_dom__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__group__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_requestAnimationFrame__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lang__ = __webpack_require__(731);













var getPixelRatio = __WEBPACK_IMPORTED_MODULE_8__util_dom__["d" /* getPixelRatio */],
    getDomById = __WEBPACK_IMPORTED_MODULE_8__util_dom__["b" /* getDomById */],
    getWidth = __WEBPACK_IMPORTED_MODULE_8__util_dom__["e" /* getWidth */],
    getHeight = __WEBPACK_IMPORTED_MODULE_8__util_dom__["c" /* getHeight */],
    isCanvasElement = __WEBPACK_IMPORTED_MODULE_8__util_dom__["f" /* isCanvasElement */];

var Canvas = /*#__PURE__*/function (_EventEmit) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(Canvas, _EventEmit);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Canvas);

  function Canvas(cfg) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Canvas);

    _this = _super.call(this);
    var title = cfg.title;
    var ariaLabel = title ? Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["K" /* substitute */])(__WEBPACK_IMPORTED_MODULE_12__lang__["a" /* default */].general.withTitle, {
      title: title
    }) : __WEBPACK_IMPORTED_MODULE_12__lang__["a" /* default */].general.title;
    _this._attrs = Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["G" /* mix */])({
      type: 'canvas',
      children: [],
      ariaLabel: ariaLabel
    }, cfg);

    _this._initPixelRatio();

    _this._initCanvas();

    return _this;
  }
  /* eslint-enable */


  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Canvas, [{
    key: "get",
    value: function get(name) {
      return this._attrs[name];
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this._attrs[name] = value;
    }
  }, {
    key: "_initPixelRatio",
    value: function _initPixelRatio() {
      var pixelRatio = this.get('pixelRatio');

      if (!pixelRatio) {
        this.set('pixelRatio', getPixelRatio());
      }
    }
  }, {
    key: "beforeDraw",
    value: function beforeDraw() {
      var context = this._attrs.context;
      var el = this._attrs.el;
      context && context.clearRect && context.clearRect(0, 0, el.width, el.height);
    }
  }, {
    key: "_initCanvas",
    value: function _initCanvas() {
      var el = this.get('el');
      var context = this.get('context');

      if (!el && !context) {
        throw new Error('Please specify the id, el or context of the chart!');
      }

      var canvas;

      if (el) {
        // DOMElement or String
        canvas = Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["B" /* isString */])(el) ? getDomById(el) : el;
      } else {
        // 说明没有指定el
        canvas = __WEBPACK_IMPORTED_MODULE_6__canvas_element__["a" /* default */].create(context);
      }

      if (context && canvas && !canvas.getContext) {
        canvas.getContext = function () {
          return context;
        };
      }

      var width = this.get('width') || getWidth(canvas) || canvas.width;
      var height = this.get('height') || getHeight(canvas) || canvas.height;
      this.set('canvas', this);
      this.set('el', canvas);
      this.set('context', context || canvas.getContext('2d'));
      this.changeSize(width, height); // 初始化事件控制器

      var eventController = new __WEBPACK_IMPORTED_MODULE_5__event_controller__["a" /* default */]({
        canvas: this,
        el: canvas
      });
      this.set('eventController', eventController);
    }
  }, {
    key: "changeSize",
    value: function changeSize(width, height) {
      var pixelRatio = this.get('pixelRatio');
      var canvasDOM = this.get('el'); // HTMLCanvasElement or canvasElement
      // 浏览器环境设置style样式

      if (canvasDOM.style) {
        canvasDOM.style.width = width + 'px';
        canvasDOM.style.height = height + 'px';
      }

      if (isCanvasElement(canvasDOM)) {
        canvasDOM.width = width * pixelRatio;
        canvasDOM.height = height * pixelRatio;

        if (pixelRatio !== 1) {
          var ctx = this.get('context');
          ctx.scale(pixelRatio, pixelRatio);
        }
      }

      this.set('width', width);
      this.set('height', height);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var pixelRatio = this.get('pixelRatio');
      var width = this.get('width');
      return width * pixelRatio;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      var pixelRatio = this.get('pixelRatio');
      var height = this.get('height');
      return height * pixelRatio;
    }
  }, {
    key: "getPointByClient",
    value: function getPointByClient(clientX, clientY) {
      var el = this.get('el');
      var bbox = el.getBoundingClientRect();
      var width = bbox.right - bbox.left;
      var height = bbox.bottom - bbox.top;
      return {
        x: (clientX - bbox.left) * (el.width / width),
        y: (clientY - bbox.top) * (el.height / height)
      };
    }
  }, {
    key: "_beginDraw",
    value: function _beginDraw() {
      this._attrs.toDraw = true;
    }
  }, {
    key: "_endDraw",
    value: function _endDraw() {
      this._attrs.toDraw = false;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this2 = this;

      var drawInner = function drawInner() {
        _this2.set('animateHandler', Object(__WEBPACK_IMPORTED_MODULE_11__util_requestAnimationFrame__["a" /* requestAnimationFrame */])(function () {
          _this2.set('animateHandler', undefined);

          if (_this2.get('toDraw')) {
            drawInner();
          }
        }));

        _this2.beforeDraw();

        try {
          var context = _this2._attrs.context;

          _this2.drawChildren(context); // 支付宝，微信小程序，需要调context.draw才能完成绘制， 所以这里直接判断是否有.draw方法


          if (context.draw) {
            context.draw();
          } // 设置无障碍文本


          _this2.setAriaLabel();
        } catch (ev) {
          console.warn('error in draw canvas, detail as:');
          console.warn(ev);

          _this2._endDraw();
        }

        _this2._endDraw();
      };

      if (this.get('destroyed')) {
        return;
      }

      if (this.get('animateHandler')) {
        this._beginDraw();
      } else {
        drawInner();
      }
    } // 设置无障碍文本

  }, {
    key: "setAriaLabel",
    value: function setAriaLabel() {
      var el = this._attrs.el;

      var ariaLabel = this._getAriaLabel();

      if (ariaLabel && el.setAttribute) {
        el.setAttribute('aria-label', ariaLabel);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.get('destroyed')) {
        return;
      } // 需要清理 canvas 画布内容，否则会导致 spa 应用 ios 下 canvas 白屏
      // https://stackoverflow.com/questions/52532614/total-canvas-memory-use-exceeds-the-maximum-limit-safari-12
      // https://github.com/antvis/F2/issues/630


      var el = this.get('el');
      el.width = 0;
      el.height = 0;
      this.clear();
      this._attrs = {};
      this.set('destroyed', true);
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return this.get('destroyed');
    }
  }]);

  return Canvas;
}(__WEBPACK_IMPORTED_MODULE_4__event_emit__["a" /* default */]); // @ts-ignore


Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["G" /* mix */])(Canvas.prototype, __WEBPACK_IMPORTED_MODULE_9__container__["a" /* default */], {
  getGroupClass: function getGroupClass() {
    return __WEBPACK_IMPORTED_MODULE_10__group__["a" /* default */];
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Canvas);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_dom__ = __webpack_require__(178);



var convertPoints = __WEBPACK_IMPORTED_MODULE_2__util_dom__["a" /* convertPoints */]; // 计算滑动的方向

var calcDirection = function calcDirection(start, end) {
  var xDistance = end.x - start.x;
  var yDistance = end.y - start.y; // x 的距离大于y 说明是横向，否则就是纵向

  if (Math.abs(xDistance) > Math.abs(yDistance)) {
    return xDistance > 0 ? 'right' : 'left';
  }

  return yDistance > 0 ? 'down' : 'up';
}; // 计算2点之间的距离


var calcDistance = function calcDistance(point1, point2) {
  var xDistance = Math.abs(point2.x - point1.x);
  var yDistance = Math.abs(point2.y - point1.y);
  return Math.sqrt(xDistance * xDistance + yDistance * yDistance);
};

var getCenter = function getCenter(point1, point2) {
  var x = point1.x + (point2.x - point1.x) / 2;
  var y = point1.y + (point2.y - point1.y) / 2;
  return {
    x: x,
    y: y
  };
};

var PRESS_DELAY = 250;

var EventController = /*#__PURE__*/function () {
  function EventController(_ref) {
    var _this = this;

    var canvas = _ref.canvas,
        el = _ref.el;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EventController);

    this._click = function (ev) {
      var points = convertPoints(ev, _this.canvas);
      ev.points = points;

      _this.emitEvent('click', ev);
    };

    this._start = function (ev) {
      var points = convertPoints(ev, _this.canvas);

      if (!points) {
        return;
      }

      ev.points = points;

      _this.emitEvent('touchstart', ev); // 防止上次的内容没有清理掉，重新reset下


      _this.reset(); // 记录touch start 的时间


      _this.startTime = Date.now(); // 记录touch start 的点

      _this.startPoints = points;

      if (points.length > 1) {
        _this.startDistance = calcDistance(points[0], points[1]);
        _this.center = getCenter(points[0], points[1]);
      } else {
        // 如果touchstart后停顿250ms, 则也触发press事件
        _this.pressTimeout = setTimeout(function () {
          // 这里固定触发press事件
          var eventType = 'press';
          var direction = 'none';
          ev.direction = direction;

          _this.emitStart(eventType, ev);

          _this.emitEvent(eventType, ev);

          _this.eventType = eventType;
          _this.direction = direction;
        }, PRESS_DELAY);
      }
    };

    this._move = function (ev) {
      var points = convertPoints(ev, _this.canvas);
      if (!points) return;

      _this.clearPressTimeout();

      ev.points = points;

      _this.emitEvent('touchmove', ev);

      var startPoints = _this.startPoints;
      if (!startPoints) return; // 多指触控

      if (points.length > 1) {
        // touchstart的距离
        var startDistance = _this.startDistance;
        var currentDistance = calcDistance(points[0], points[1]);
        ev.zoom = currentDistance / startDistance;
        ev.center = _this.center; // 触发缩放事件

        _this.emitStart('pinch', ev);

        _this.emitEvent('pinch', ev);
      } else {
        var deltaX = points[0].x - startPoints[0].x;
        var deltaY = points[0].y - startPoints[0].y;
        var direction = _this.direction || calcDirection(startPoints[0], points[0]);
        _this.direction = direction; // 获取press或者pan的事件类型
        // press 按住滑动, pan表示平移
        // 如果start后立刻move，则触发pan, 如果有停顿，则触发press

        var eventType = _this.getEventType(points);

        ev.direction = direction;
        ev.deltaX = deltaX;
        ev.deltaY = deltaY;

        _this.emitStart(eventType, ev);

        _this.emitEvent(eventType, ev); // 记录最后2次move的时间和坐标，为了给swipe事件用


        var prevMoveTime = _this.lastMoveTime;
        var now = Date.now(); // 最后2次的时间间隔一定要大于0，否则swipe没发计算

        if (now - prevMoveTime > 0) {
          _this.prevMoveTime = prevMoveTime;
          _this.prevMovePoints = _this.lastMovePoints;
          _this.lastMoveTime = now;
          _this.lastMovePoints = points;
        }
      }
    };

    this._end = function (ev) {
      var points = convertPoints(ev, _this.canvas);
      ev.points = points;

      _this.emitEnd(ev);

      _this.emitEvent('touchend', ev); // swipe事件处理, 在touchend之后触发


      var lastMoveTime = _this.lastMoveTime;
      var now = Date.now(); // 做这个判断是为了最后一次touchmove后到end前，还有一个停顿的过程
      // 100 是拍的一个值，理论这个值会很短，一般不卡顿的话在10ms以内

      if (now - lastMoveTime < 100) {
        var prevMoveTime = _this.prevMoveTime || _this.startTime;
        var intervalTime = lastMoveTime - prevMoveTime; // 时间间隔一定要大于0, 否则计算没意义

        if (intervalTime > 0) {
          var prevMovePoints = _this.prevMovePoints || _this.startPoints;
          var lastMovePoints = _this.lastMovePoints; // move速率

          var velocity = calcDistance(prevMovePoints[0], lastMovePoints[0]) / intervalTime; // 0.3 是参考hammerjs的设置

          if (velocity > 0.3) {
            ev.velocity = velocity;
            ev.direction = calcDirection(prevMovePoints[0], lastMovePoints[0]);
            ev.velocityX = (lastMovePoints[0].x - prevMovePoints[0].x) / intervalTime;
            ev.velocityY = (lastMovePoints[0].y - prevMovePoints[0].y) / intervalTime;

            _this.emitEvent('swipe', ev);
          }
        }
      }

      _this.reset();

      var touches = ev.touches; // 当多指只释放了1指时也会触发end, 这时重新触发一次start

      if (touches && touches.length > 0) {
        _this._start(ev);
      }
    };

    this._cancel = function (ev) {
      _this.emitEvent('touchcancel', ev);

      _this.reset();
    }; // canvasEl


    this.canvas = canvas;
    this.delegateEvent(el); // 用来记录当前触发的事件

    this.processEvent = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(EventController, [{
    key: "delegateEvent",
    value: function delegateEvent(canvasEl) {
      // 代理这几个事件
      canvasEl.addEventListener('click', this._click);
      canvasEl.addEventListener('touchstart', this._start);
      canvasEl.addEventListener('touchmove', this._move);
      canvasEl.addEventListener('touchend', this._end);
      canvasEl.addEventListener('touchcancel', this._cancel);
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(type, ev) {
      var canvas = this.canvas;
      canvas.emit(type, ev);
    }
  }, {
    key: "getEventType",
    value: function getEventType(points) {
      var eventType = this.eventType,
          canvas = this.canvas,
          startTime = this.startTime,
          startPoints = this.startPoints;

      if (eventType) {
        return eventType;
      }

      var type;
      var panEventListeners = canvas.__events.pan; // 如果没有pan事件的监听，默认都是press

      if (!panEventListeners || !panEventListeners.length) {
        type = 'press';
      } else {
        // 如果有pan事件的处理，press则需要停顿250ms, 且移动距离小于10
        var now = Date.now();

        if (now - startTime > PRESS_DELAY && calcDistance(startPoints[0], points[0]) < 10) {
          type = 'press';
        } else {
          type = 'pan';
        }
      }

      this.eventType = type;
      return type;
    }
  }, {
    key: "enable",
    value: function enable(eventType) {
      this.processEvent[eventType] = true;
    } // 是否进行中的事件

  }, {
    key: "isProcess",
    value: function isProcess(eventType) {
      return this.processEvent[eventType];
    } // 触发start事件

  }, {
    key: "emitStart",
    value: function emitStart(type, ev) {
      if (this.isProcess(type)) {
        return;
      }

      this.enable(type);
      this.emitEvent("".concat(type, "start"), ev);
    } // 触发end事件

  }, {
    key: "emitEnd",
    value: function emitEnd(ev) {
      var _this2 = this;

      var processEvent = this.processEvent;
      Object.keys(processEvent).forEach(function (type) {
        _this2.emitEvent("".concat(type, "end"), ev);

        delete processEvent[type];
      });
    }
  }, {
    key: "clearPressTimeout",
    value: function clearPressTimeout() {
      if (this.pressTimeout) {
        clearTimeout(this.pressTimeout);
        this.pressTimeout = null;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.clearPressTimeout();
      this.startTime = 0;
      this.startPoints = null;
      this.startDistance = 0;
      this.direction = null;
      this.eventType = null;
      this.pinch = false;
      this.prevMoveTime = 0;
      this.prevMovePoints = null;
      this.lastMoveTime = 0;
      this.lastMovePoints = null;
    }
  }]);

  return EventController;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventController);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_emit__ = __webpack_require__(268);






var CanvasElement = /*#__PURE__*/function (_EventEmit) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(CanvasElement, _EventEmit);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(CanvasElement);

  /* eslint-enable */
  function CanvasElement(ctx) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, CanvasElement);

    _this = _super.call(this);
    _this.context = ctx; // canvas实际的宽高 (width/height) * pixelRatio
    // 有可能是 node canvas 创建的 context 对象

    var canvas = ctx.canvas || {};
    _this.width = canvas.width || 0;
    _this.height = canvas.height || 0;
    _this.style = {};
    _this.currentStyle = {};
    _this.attrs = {}; // 用来标识是CanvasElement实例

    _this.isCanvasElement = true;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(CanvasElement, [{
    key: "getContext",
    value: function
      /* type */
    getContext() {
      return this.context;
    }
  }, {
    key: "getBoundingClientRect",
    value: function getBoundingClientRect() {
      var width = this.width;
      var height = this.height; // 默认都处理成可视窗口的顶部位置

      return {
        top: 0,
        right: width,
        bottom: height,
        left: 0
      };
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(key, value) {
      this.attrs[key] = value;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      this.on(type, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      this.off(type, listener);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, e) {
      this.emit(type, e);
    }
  }]);

  return CanvasElement;
}(__WEBPACK_IMPORTED_MODULE_4__event_emit__["a" /* default */]);

function supportEventListener(canvas) {
  if (!canvas) {
    return false;
  } // 非 HTMLCanvasElement


  if (canvas.nodeType !== 1 || !canvas.nodeName || canvas.nodeName.toLowerCase() !== 'canvas') {
    return false;
  } // 微信小程序canvas.getContext('2d')时也是CanvasRenderingContext2D
  // 也会有ctx.canvas, 而且nodeType也是1，所以还要在看下是否支持addEventListener


  var support = false;

  try {
    canvas.addEventListener('eventTest', function () {
      support = true;
    });
    canvas.dispatchEvent(new Event('eventTest'));
  } catch (error) {
    support = false;
  }

  return support;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  create: function create(ctx) {
    if (!ctx) {
      return null;
    }

    if (supportEventListener(ctx.canvas)) {
      return ctx.canvas;
    }

    return new CanvasElement(ctx);
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_array__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_matrix__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_style_parse__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_vector2__ = __webpack_require__(122);








var ALIAS_ATTRS_MAP = {
  stroke: 'strokeStyle',
  fill: 'fillStyle',
  opacity: 'globalAlpha'
};
var SHAPE_ATTRS = ['fillStyle', 'font', 'globalAlpha', 'lineCap', 'lineWidth', 'lineJoin', 'miterLimit', 'shadowBlur', 'shadowColor', 'shadowOffsetX', 'shadowOffsetY', 'strokeStyle', 'textAlign', 'textBaseline', 'lineDash', 'shadow' // 兼容支付宝小程序
];
var CLIP_SHAPES = ['circle', 'sector', 'polygon', 'rect', 'polyline', 'custom'];

var Element = /*#__PURE__*/function () {
  function Element(cfg) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Element);

    this._initProperties();

    Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["G" /* mix */])(this._attrs, cfg);
    var attrs = this._attrs.attrs;

    if (attrs) {
      this.initAttrs(attrs);
    }

    this.initTransform();
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Element, [{
    key: "_initProperties",
    value: function _initProperties() {
      this._attrs = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this._attrs), {}, {
        zIndex: 0,
        visible: true,
        destroyed: false
      });
    }
  }, {
    key: "get",
    value: function get(name) {
      return this._attrs[name];
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this._attrs[name] = value;
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return this.get('isGroup');
    }
  }, {
    key: "isShape",
    value: function isShape() {
      return this.get('isShape');
    }
  }, {
    key: "initAttrs",
    value: function initAttrs(attrs) {
      this.attr(Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["G" /* mix */])(this.getDefaultAttrs(), attrs));
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {};
    }
  }, {
    key: "_setAttr",
    value: function _setAttr(name, value) {
      var attrs = this._attrs.attrs;

      if (name === 'clip') {
        value = this._setAttrClip(value);
      } else {
        var alias = ALIAS_ATTRS_MAP[name];

        if (alias) {
          attrs[alias] = value;
        }
      }

      attrs[name] = value;
    }
  }, {
    key: "_getAttr",
    value: function _getAttr(name) {
      var _this$_attrs, _this$_attrs$attrs;

      return (_this$_attrs = this._attrs) === null || _this$_attrs === void 0 ? void 0 : (_this$_attrs$attrs = _this$_attrs.attrs) === null || _this$_attrs$attrs === void 0 ? void 0 : _this$_attrs$attrs[name];
    }
  }, {
    key: "_afterAttrsSet",
    value: function _afterAttrsSet() {}
  }, {
    key: "_setAttrClip",
    value: function _setAttrClip(clip) {
      if (clip && CLIP_SHAPES.indexOf(clip._attrs.type) > -1) {
        if (clip.get('canvas') === null) {
          clip = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, clip);
        }

        clip.set('parent', this.get('parent'));
        clip.set('context', this.get('context'));
        return clip;
      }

      return null;
    }
  }, {
    key: "attr",
    value: function attr(name, value) {
      if (this.get('destroyed')) return null;
      var argumentsLen = arguments.length;

      if (argumentsLen === 0) {
        return this._attrs.attrs;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["z" /* isObject */])(name)) {
        this._attrs.bbox = null;

        for (var k in name) {
          this._setAttr(k, name[k]);
        }

        if (this._afterAttrsSet) {
          this._afterAttrsSet();
        }

        return this;
      }

      if (argumentsLen === 2) {
        this._attrs.bbox = null;

        this._setAttr(name, value);

        if (this._afterAttrsSet) {
          this._afterAttrsSet();
        }

        return this;
      }

      return this._getAttr(name);
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this.get('parent');
    }
  }, {
    key: "draw",
    value: function draw(context) {
      if (this.get('destroyed')) {
        return;
      }

      if (this.get('visible')) {
        this.setContext(context);
        this.drawInner(context);
        this.restoreContext(context);
      }
    }
  }, {
    key: "setContext",
    value: function setContext(context) {
      var clip = this._attrs.attrs.clip;
      context.save();

      if (clip && !clip._attrs.destroyed) {
        clip.resetTransform(context);
        clip.createPath(context);
        context.clip();
      }

      this.resetContext(context);
      this.resetTransform(context);
    }
  }, {
    key: "restoreContext",
    value: function restoreContext(context) {
      context.restore();
    }
  }, {
    key: "resetContext",
    value: function resetContext(context) {
      var elAttrs = this._attrs.attrs;

      for (var k in elAttrs) {
        if (SHAPE_ATTRS.indexOf(k) > -1) {
          var v = elAttrs[k];

          if ((k === 'fillStyle' || k === 'strokeStyle') && v) {
            v = Object(__WEBPACK_IMPORTED_MODULE_6__util_style_parse__["a" /* parseStyle */])(v, this, context);
          }

          if (k === 'lineDash' && context.setLineDash && Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["r" /* isArray */])(v)) {
            context.setLineDash(v);
          } else {
            context[k] = v;
          }
        }
      }
    }
  }, {
    key: "hasFill",
    value: function hasFill() {
      return this.get('canFill') && this._attrs.attrs.fillStyle;
    }
  }, {
    key: "hasStroke",
    value: function hasStroke() {
      return this.get('canStroke') && this._attrs.attrs.strokeStyle;
    }
  }, {
    key: "drawInner",
    value: function drawInner(_context) {}
  }, {
    key: "show",
    value: function show() {
      this.set('visible', true);
      return this;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.set('visible', false);
      return this;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.get('visible');
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel() {
      var _this$_attrs2 = this._attrs,
          destroyed = _this$_attrs2.destroyed,
          visible = _this$_attrs2.visible,
          isShape = _this$_attrs2.isShape,
          aria = _this$_attrs2.aria;

      if (destroyed || !visible || isShape && !aria) {
        return;
      }

      return this._getAriaLabel();
    }
  }, {
    key: "_getAriaLabel",
    value: function _getAriaLabel() {
      return this._attrs.ariaLabel;
    }
  }, {
    key: "_removeFromParent",
    value: function _removeFromParent() {
      var parent = this.get('parent');

      if (parent) {
        var children = parent.get('children');
        Object(__WEBPACK_IMPORTED_MODULE_4__util_array__["a" /* remove */])(children, this);
      }

      return this;
    }
  }, {
    key: "remove",
    value: function remove(destroy) {
      if (destroy) {
        this.destroy();
      } else {
        this._removeFromParent();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var destroyed = this.get('destroyed');

      if (destroyed) {
        return null;
      }

      this._removeFromParent(); // 保留 attrs


      var attrs = this._attrs.attrs;
      this._attrs = {
        attrs: attrs
      };
      this.set('destroyed', true);
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      return {
        minX: 0,
        maxX: 0,
        minY: 0,
        maxY: 0,
        width: 0,
        height: 0
      };
    }
  }, {
    key: "initTransform",
    value: function initTransform() {
      var attrs = this._attrs.attrs;

      if (!attrs) {
        attrs = {};
      }

      if (!attrs.matrix) {
        attrs.matrix = [1, 0, 0, 1, 0, 0];
      }

      this._attrs.attrs = attrs;
    }
  }, {
    key: "getMatrix",
    value: function getMatrix() {
      return this._attrs.attrs.matrix;
    }
  }, {
    key: "setMatrix",
    value: function setMatrix(m) {
      this._attrs.attrs.matrix = [m[0], m[1], m[2], m[3], m[4], m[5]];
    }
  }, {
    key: "transform",
    value: function transform(actions) {
      var matrix = this._attrs.attrs.matrix;
      this._attrs.attrs.matrix = __WEBPACK_IMPORTED_MODULE_5__util_matrix__["a" /* default */].transform(matrix, actions);
      return this;
    }
  }, {
    key: "setTransform",
    value: function setTransform(actions) {
      this._attrs.attrs.matrix = [1, 0, 0, 1, 0, 0];
      return this.transform(actions);
    }
  }, {
    key: "translate",
    value: function translate(x, y) {
      var matrix = this._attrs.attrs.matrix;
      __WEBPACK_IMPORTED_MODULE_5__util_matrix__["a" /* default */].translate(matrix, matrix, [x, y]);
    }
  }, {
    key: "rotate",
    value: function rotate(rad) {
      var matrix = this._attrs.attrs.matrix;
      __WEBPACK_IMPORTED_MODULE_5__util_matrix__["a" /* default */].rotate(matrix, matrix, rad);
    }
  }, {
    key: "scale",
    value: function scale(sx, sy) {
      var matrix = this._attrs.attrs.matrix;
      __WEBPACK_IMPORTED_MODULE_5__util_matrix__["a" /* default */].scale(matrix, matrix, [sx, sy]);
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      var cx = this._attrs.x || 0;
      var cy = this._attrs.y || 0;
      this.translate(x - cx, y - cy);
      this.set('x', x);
      this.set('y', y);
    }
  }, {
    key: "apply",
    value: function apply(v) {
      var m = this._attrs.attrs.matrix;
      __WEBPACK_IMPORTED_MODULE_7__util_vector2__["a" /* default */].transformMat2d(v, v, m);
      return this;
    }
  }, {
    key: "resetTransform",
    value: function resetTransform(context) {
      var mo = this._attrs.attrs.matrix;

      if (__WEBPACK_IMPORTED_MODULE_5__util_matrix__["a" /* default */].isChanged(mo)) {
        context.transform(mo[0], mo[1], mo[2], mo[3], mo[4], mo[5]);
      }
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return this.get('destroyed');
    }
  }]);

  return Element;
}();

/* harmony default export */ __webpack_exports__["a"] = (Element);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);


function _mod(n, m) {
  return (n % m + m) % m;
}

function _addStop(steps, gradient) {
  Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["e" /* each */])(steps, function (item) {
    item = item.split(':');
    gradient.addColorStop(Number(item[0]), item[1]);
  });
} // the string format: 'l(0) 0:#ffffff 0.5:#7ec2f3 1:#1890ff'


function _parseLineGradient(color, shape, context) {
  var arr = color.split(' ');
  var angle = arr[0].slice(2, arr[0].length - 1);
  angle = _mod(parseFloat(angle) * Math.PI / 180, Math.PI * 2);
  var steps = arr.slice(1);

  var _shape$getBBox = shape.getBBox(),
      minX = _shape$getBBox.minX,
      minY = _shape$getBBox.minY,
      maxX = _shape$getBBox.maxX,
      maxY = _shape$getBBox.maxY;

  var start;
  var end;

  if (angle >= 0 && angle < 0.5 * Math.PI) {
    start = {
      x: minX,
      y: minY
    };
    end = {
      x: maxX,
      y: maxY
    };
  } else if (0.5 * Math.PI <= angle && angle < Math.PI) {
    start = {
      x: maxX,
      y: minY
    };
    end = {
      x: minX,
      y: maxY
    };
  } else if (Math.PI <= angle && angle < 1.5 * Math.PI) {
    start = {
      x: maxX,
      y: maxY
    };
    end = {
      x: minX,
      y: minY
    };
  } else {
    start = {
      x: minX,
      y: maxY
    };
    end = {
      x: maxX,
      y: minY
    };
  }

  var tanTheta = Math.tan(angle);
  var tanTheta2 = tanTheta * tanTheta;
  var x = (end.x - start.x + tanTheta * (end.y - start.y)) / (tanTheta2 + 1) + start.x;
  var y = tanTheta * (end.x - start.x + tanTheta * (end.y - start.y)) / (tanTheta2 + 1) + start.y;
  var gradient = context.createLinearGradient(start.x, start.y, x, y);

  _addStop(steps, gradient);

  return gradient;
} // the string format: 'r(0.5, 0.5, 0.1) 0:#ffffff 1:#1890ff'


function _parseRadialGradient(color, shape, context) {
  var arr = color.split(' ');
  var circleCfg = arr[0].slice(2, arr[0].length - 1);
  circleCfg = circleCfg.split(',');
  var fx = parseFloat(circleCfg[0]);
  var fy = parseFloat(circleCfg[1]);
  var fr = parseFloat(circleCfg[2]);
  var steps = arr.slice(1); // if radius is 0, no gradient, stroke with the last color

  if (fr === 0) {
    var _color = steps[steps.length - 1];
    return _color.split(':')[1];
  }

  var _shape$getBBox2 = shape.getBBox(),
      width = _shape$getBBox2.width,
      height = _shape$getBBox2.height,
      minX = _shape$getBBox2.minX,
      minY = _shape$getBBox2.minY;

  var r = Math.sqrt(width * width + height * height) / 2;
  var gradient = context.createRadialGradient(minX + width * fx, minY + height * fy, fr * r, minX + width / 2, minY + height / 2, r);

  _addStop(steps, gradient);

  return gradient;
}

function parseStyle(color, shape, context) {
  if (color[1] === '(') {
    try {
      var firstCode = color[0];

      if (firstCode === 'l') {
        return _parseLineGradient(color, shape, context);
      } else if (firstCode === 'r') {
        return _parseRadialGradient(color, shape, context);
      }
    } catch (ev) {
      console.error('error in parsing gradient string, please check if there are any extra whitespaces.');
      console.error(ev);
    }
  }

  return color;
}


/* unused harmony default export */ var _unused_webpack_default_export = ({
  parseStyle: parseStyle
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _superPropBase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(43);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(object);
    if (object === null) break;
  }

  return object;
}

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rect__ = __webpack_require__(179);








var imageCaches = {};

var ImageShape = /*#__PURE__*/function (_Rect) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(ImageShape, _Rect);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ImageShape);

  function ImageShape() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ImageShape);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ImageShape, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ImageShape.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = false;
      this._attrs.canStroke = false;
      this._attrs.loading = false;
      this._attrs.image = null;
      this._attrs.type = 'image';
    }
  }, {
    key: "draw",
    value: function draw(context) {
      var _this = this;

      // 如果图片还在loading中直接返回，等下次绘制
      if (this.get('loading')) {
        return;
      } // 如果已经有image对象，直接绘制，会调用createPath绘制


      var image = this.get('image');

      if (image) {
        Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ImageShape.prototype), "draw", this).call(this, context);

        return;
      }

      var attrs = this.get('attrs');
      var src = attrs.src;

      if (src) {
        var cacheImage = this.get('cacheImage'); // 如果有缓存，则直接从缓存中拿

        if (cacheImage && imageCaches[src]) {
          this.set('image', imageCaches[src]);
          this.draw(context);
          return;
        }

        var _image = null;
        var canvas = this.get('canvas');

        if (canvas && canvas.get('createImage')) {
          var createImage = canvas.get('createImage');
          _image = createImage();
        } else if (window.Image) {
          _image = new Image();
        }

        if (_image) {
          this.set('loading', true); // 设置跨域, 等同于 image.crossOrigin = 'anonymous'

          _image.crossOrigin = '';

          _image.onload = function () {
            _this.set('loading', false);

            _this.set('image', _image); // this.draw(context);
            // 这里需要调用 canvas.draw 进行重新绘制，否则 image 会一直在最上层


            canvas.draw();
          }; // src 一定要在 crossOrigin 之后，否则 toDataURL 就会报 SecurityError


          _image.src = src; // 设置全局缓存

          if (cacheImage) {
            imageCaches[src] = _image;
          }
        }
      }
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var image = this.get('image');
      this.drawImage(context, image);
    }
  }, {
    key: "drawImage",
    value: function drawImage(context, image) {
      var _this$_attrs = this._attrs,
          attrs = _this$_attrs.attrs,
          destroyed = _this$_attrs.destroyed;

      if (destroyed) {
        return;
      }

      var x = attrs.x,
          y = attrs.y,
          width = attrs.width,
          height = attrs.height,
          sx = attrs.sx,
          sy = attrs.sy,
          swidth = attrs.swidth,
          sheight = attrs.sheight,
          radius = attrs.radius,
          fillOpacity = attrs.fillOpacity;

      if (radius) {
        context.save();
        this.createRadiusPath(context, x, y, width, height, radius);
        context.clip();
      } // 设置透明度


      var originOpacity = context.globalAlpha;

      if (!Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(fillOpacity)) {
        context.globalAlpha = fillOpacity;
      }

      if (!Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(sx) && !Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(sy) && !Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(swidth) && !Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(sheight)) {
        context.drawImage(image, sx, sy, swidth, sheight, x, y, width, height);
      } else {
        context.drawImage(image, x, y, width, height);
      }

      context.globalAlpha = originOpacity;

      if (radius) {
        // 因为 save 和 restore 会一定程度上影响绘图性能，所以只在必要是调用
        context.restore();
      }
    }
  }]);

  return ImageShape;
}(__WEBPACK_IMPORTED_MODULE_7__rect__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ImageShape);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);








var Circle = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Circle, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Circle);

  function Circle() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Circle);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Circle, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Circle.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'circle';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        x: 0,
        y: 0,
        r: 0,
        lineWidth: 0
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          r = attrs.r;
      context.beginPath();
      context.arc(x, y, r, 0, Math.PI * 2, false);
      context.closePath();
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          r = attrs.r;
      return {
        minX: x - r,
        maxX: x + r,
        minY: y - r,
        maxY: y + r
      };
    }
  }]);

  return Circle;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Circle);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_bbox__ = __webpack_require__(106);









var Line = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Line, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Line);

  function Line() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Line);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Line, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Line.prototype), "_initProperties", this).call(this);

      this._attrs.canStroke = true;
      this._attrs.type = 'line';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        lineWidth: 1
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      context.beginPath();
      context.moveTo(x1, y1);
      context.lineTo(x2, y2);
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2,
          lineWidth = attrs.lineWidth;
      return Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromLine"])(x1, y1, x2, y2, lineWidth);
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_bbox__ = __webpack_require__(106);









var Polygon = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Polygon, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Polygon);

  function Polygon() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Polygon);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Polygon, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Polygon.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'polygon';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        points: null,
        lineWidth: 0
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var points = attrs.points;
      context.beginPath();

      for (var i = 0, len = points.length; i < len; i++) {
        var point = points[i];

        if (i === 0) {
          context.moveTo(point.x, point.y);
        } else {
          context.lineTo(point.x, point.y);
        }
      }

      context.closePath();
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var points = attrs.points;
      return Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromPoints"])(points);
    }
  }]);

  return Polygon;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Polygon);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_bbox__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_smooth__ = __webpack_require__(267);








 // filter the point which x or y is NaN

function _filterPoints(points) {
  var filteredPoints = [];

  for (var i = 0, len = points.length; i < len; i++) {
    var point = points[i];

    if (!isNaN(point.x) && !isNaN(point.y)) {
      filteredPoints.push(point);
    }
  }

  return filteredPoints;
}

var Polyline = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Polyline, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Polyline);

  function Polyline() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Polyline);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Polyline, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Polyline.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'polyline';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        points: null,
        lineWidth: 1,
        smooth: false
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var points = attrs.points,
          smooth = attrs.smooth;

      var filteredPoints = _filterPoints(points);

      context.beginPath();

      if (filteredPoints.length) {
        context.moveTo(filteredPoints[0].x, filteredPoints[0].y);

        if (smooth) {
          var constaint = [[0, 0], [1, 1]];
          var sps = __WEBPACK_IMPORTED_MODULE_8__util_smooth__["smooth"](filteredPoints, false, constaint);

          for (var i = 0, n = sps.length; i < n; i++) {
            var sp = sps[i];
            context.bezierCurveTo(sp[1], sp[2], sp[3], sp[4], sp[5], sp[6]);
          }
        } else {
          var _i;

          var l;

          for (_i = 1, l = filteredPoints.length - 1; _i < l; _i++) {
            context.lineTo(filteredPoints[_i].x, filteredPoints[_i].y);
          }

          context.lineTo(filteredPoints[l].x, filteredPoints[l].y);
        }
      }
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var points = attrs.points,
          smooth = attrs.smooth,
          lineWidth = attrs.lineWidth;

      var filteredPoints = _filterPoints(points);

      if (smooth) {
        var newPoints = [];
        var constaint = [[0, 0], [1, 1]];
        var sps = __WEBPACK_IMPORTED_MODULE_8__util_smooth__["smooth"](filteredPoints, false, constaint);

        for (var i = 0, n = sps.length; i < n; i++) {
          var sp = sps[i];

          if (i === 0) {
            newPoints.push([filteredPoints[0].x, filteredPoints[0].y, sp[1], sp[2], sp[3], sp[4], sp[5], sp[6]]);
          } else {
            var lastPoint = sps[i - 1];
            newPoints.push([lastPoint[5], lastPoint[6], sp[1], sp[2], sp[3], sp[4], sp[5], sp[6]]);
          }
        }

        return Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromBezierGroup"])(newPoints, lineWidth);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromPoints"])(filteredPoints, lineWidth);
    }
  }]);

  return Polyline;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Polyline);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_bbox__ = __webpack_require__(106);









var Arc = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Arc, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Arc);

  function Arc() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Arc);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Arc, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Arc.prototype), "_initProperties", this).call(this);

      this._attrs.canStroke = true;
      this._attrs.canFill = true;
      this._attrs.type = 'arc';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        x: 0,
        y: 0,
        r: 0,
        startAngle: 0,
        endAngle: Math.PI * 2,
        anticlockwise: false,
        lineWidth: 1
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          r = attrs.r,
          startAngle = attrs.startAngle,
          endAngle = attrs.endAngle,
          anticlockwise = attrs.anticlockwise;
      context.beginPath();

      if (startAngle !== endAngle) {
        context.arc(x, y, r, startAngle, endAngle, anticlockwise);
      }
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          r = attrs.r,
          startAngle = attrs.startAngle,
          endAngle = attrs.endAngle,
          anticlockwise = attrs.anticlockwise;
      return Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromArc"])(x, y, r, startAngle, endAngle, anticlockwise);
    }
  }]);

  return Arc;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Arc);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_bbox__ = __webpack_require__(106);









var Sector = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Sector, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Sector);

  function Sector() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Sector);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Sector, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Sector.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'sector';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        x: 0,
        y: 0,
        lineWidth: 0,
        r: 0,
        r0: 0,
        startAngle: 0,
        endAngle: Math.PI * 2,
        anticlockwise: false
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          startAngle = attrs.startAngle,
          r = attrs.r,
          r0 = attrs.r0,
          anticlockwise = attrs.anticlockwise; // 最大为整个圆

      var endAngle = Math.min(attrs.endAngle, startAngle + Math.PI * 2);
      context.beginPath();
      var unitX = Math.cos(startAngle);
      var unitY = Math.sin(startAngle);
      context.moveTo(unitX * r0 + x, unitY * r0 + y);
      context.lineTo(unitX * r + x, unitY * r + y); // 当扇形的角度非常小的时候，就不进行弧线的绘制；或者整个只有1个扇形时，会出现end<0的情况不绘制

      if (Math.abs(endAngle - startAngle) > 0.0001 || startAngle === 0 && endAngle < 0) {
        context.arc(x, y, r, startAngle, endAngle, anticlockwise);
        context.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);

        if (r0 !== 0) {
          context.arc(x, y, r0, endAngle, startAngle, !anticlockwise);
        }
      }

      context.closePath();
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          r = attrs.r,
          r0 = attrs.r0,
          startAngle = attrs.startAngle,
          endAngle = attrs.endAngle,
          anticlockwise = attrs.anticlockwise;
      var outerBBox = Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromArc"])(x, y, r, startAngle, endAngle, anticlockwise);
      var innerBBox = Object(__WEBPACK_IMPORTED_MODULE_7__util_bbox__["getBBoxFromArc"])(x, y, r0, startAngle, endAngle, anticlockwise);
      return {
        minX: Math.min(outerBBox.minX, innerBBox.minX),
        minY: Math.min(outerBBox.minY, innerBBox.minY),
        maxX: Math.max(outerBBox.maxX, innerBBox.maxX),
        maxY: Math.max(outerBBox.maxY, innerBBox.maxY)
      };
    }
  }]);

  return Sector;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Sector);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_dom__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_rect__ = __webpack_require__(727);










var measureText = __WEBPACK_IMPORTED_MODULE_7__util_dom__["g" /* measureText */];
var textWidthCacheCounter = 0;
var textWidthCache = {};
var TEXT_CACHE_MAX = 5000;

var Text = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Text, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Text);

  function Text() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Text);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Text, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Text.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'text';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        lineWidth: 0,
        lineCount: 1,
        fontSize: 12,
        fontFamily: '',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontVariant: 'normal',
        textAlign: 'start',
        textBaseline: 'bottom',
        lineHeight: null,
        textArr: null
      };
    }
  }, {
    key: "_getFontStyle",
    value: function _getFontStyle() {
      var attrs = this._attrs.attrs;
      var fontSize = attrs.fontSize,
          fontFamily = attrs.fontFamily,
          fontWeight = attrs.fontWeight,
          fontStyle = attrs.fontStyle,
          fontVariant = attrs.fontVariant;
      return "".concat(fontStyle, " ").concat(fontVariant, " ").concat(fontWeight, " ").concat(fontSize, "px ").concat(fontFamily);
    }
  }, {
    key: "_afterAttrsSet",
    value: function _afterAttrsSet() {
      var attrs = this._attrs.attrs;
      attrs.font = this._getFontStyle();

      if (attrs.text) {
        var text = attrs.text;
        var textArr = null;
        var lineCount = 1;

        if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["B" /* isString */])(text) && text.indexOf('\n') !== -1) {
          textArr = text.split('\n');
          lineCount = textArr.length;
        }

        attrs.lineCount = lineCount;
        attrs.textArr = textArr;
      }

      this.set('attrs', attrs);
    }
  }, {
    key: "_getTextHeight",
    value: function _getTextHeight() {
      var attrs = this._attrs.attrs;

      if (attrs.height) {
        return attrs.height;
      }

      var lineCount = attrs.lineCount;
      var fontSize = attrs.fontSize * 1;

      if (lineCount > 1) {
        var spaceingY = this._getSpaceingY();

        return fontSize * lineCount + spaceingY * (lineCount - 1);
      }

      return fontSize;
    }
  }, {
    key: "_getSpaceingY",
    value: function _getSpaceingY() {
      var attrs = this._attrs.attrs;
      var lineHeight = attrs.lineHeight;
      var fontSize = attrs.fontSize * 1;
      return lineHeight ? lineHeight - fontSize : fontSize * 0.14;
    }
  }, {
    key: "drawInner",
    value: function drawInner(context) {
      var attrs = this._attrs.attrs;
      var text = attrs.text;
      var x = attrs.x;
      var y = attrs.y;

      if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(text) || isNaN(x) || isNaN(y)) {
        // text will be 0
        return;
      }

      var textArr = attrs.textArr;
      var fontSize = attrs.fontSize * 1;

      var spaceingY = this._getSpaceingY();

      if (attrs.rotate) {
        // do rotation
        context.translate(x, y);
        context.rotate(attrs.rotate);
        x = 0;
        y = 0;
      }

      var textBaseline = attrs.textBaseline;
      var height;

      if (textArr) {
        height = this._getTextHeight();
      }

      var subY; // context.beginPath();

      if (this.hasFill()) {
        var fillOpacity = attrs.fillOpacity;

        if (!Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(fillOpacity) && fillOpacity !== 1) {
          context.globalAlpha = fillOpacity;
        }

        if (textArr) {
          for (var i = 0, len = textArr.length; i < len; i++) {
            var subText = textArr[i];
            subY = y + i * (spaceingY + fontSize) - height + fontSize; // bottom;

            if (textBaseline === 'middle') {
              subY += height - fontSize - (height - fontSize) / 2;
            }

            if (textBaseline === 'top') {
              subY += height - fontSize;
            }

            context.fillText(subText, x, subY);
          }
        } else {
          context.fillText(text, x, y);
        }
      }

      if (this.hasStroke()) {
        if (textArr) {
          for (var _i = 0, _len = textArr.length; _i < _len; _i++) {
            var _subText = textArr[_i];
            subY = y + _i * (spaceingY + fontSize) - height + fontSize; // bottom;

            if (textBaseline === 'middle') {
              subY += height - fontSize - (height - fontSize) / 2;
            }

            if (textBaseline === 'top') {
              subY += height - fontSize;
            }

            context.strokeText(_subText, x, subY);
          }
        } else {
          context.strokeText(text, x, y);
        }
      }
    }
  }, {
    key: "_getAriaLabel",
    value: function _getAriaLabel() {
      return this._attrs.attrs.text;
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this._attrs.attrs;
      var x = attrs.x,
          y = attrs.y,
          textAlign = attrs.textAlign,
          textBaseline = attrs.textBaseline;

      var width = this._getTextWidth(); // attrs.width


      if (!width) {
        return {
          minX: x,
          minY: y,
          maxX: x,
          maxY: y
        };
      }

      var height = this._getTextHeight(); // attrs.height


      if (attrs.rotate) {
        var rotatedBox = __WEBPACK_IMPORTED_MODULE_9__util_rect__["a" /* default */].calcRotatedBox({
          width: width,
          height: height,
          rotate: attrs.rotate
        });
        width = rotatedBox.width;
        height = rotatedBox.height;
      }

      var point = {
        x: x,
        y: y - height
      }; // default textAlign: start, textBaseline: bottom

      if (textAlign) {
        if (textAlign === 'end' || textAlign === 'right') {
          point.x -= width;
        } else if (textAlign === 'center') {
          point.x -= width / 2;
        }
      }

      if (textBaseline) {
        if (textBaseline === 'top') {
          point.y += height;
        } else if (textBaseline === 'middle') {
          point.y += height / 2;
        }
      }

      return {
        minX: point.x,
        minY: point.y,
        maxX: point.x + width,
        maxY: point.y + height
      };
    }
  }, {
    key: "_getTextWidth",
    value: function _getTextWidth() {
      var attrs = this._attrs.attrs;

      if (attrs.width) {
        return attrs.width;
      }

      var text = attrs.text;
      var context = this.get('context');
      if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(text)) return undefined;
      var font = attrs.font;
      var textArr = attrs.textArr;
      var key = text + '' + font;

      if (textWidthCache[key]) {
        return textWidthCache[key];
      }

      var width = 0;

      if (textArr) {
        for (var i = 0, length = textArr.length; i < length; i++) {
          var subText = textArr[i];
          width = Math.max(width, measureText(subText, font, context).width);
        }
      } else {
        width = measureText(text, font, context).width;
      }

      if (textWidthCacheCounter > TEXT_CACHE_MAX) {
        textWidthCacheCounter = 0;
        textWidthCache = {};
      }

      textWidthCacheCounter++;
      textWidthCache[key] = width;
      return width;
    }
  }]);

  return Text;
}(__WEBPACK_IMPORTED_MODULE_8__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Rect = {
  calcRotatedBox: function calcRotatedBox(_ref) {
    var width = _ref.width,
        height = _ref.height,
        rotate = _ref.rotate;
    var absRotate = Math.abs(rotate);
    return {
      width: Math.abs(width * Math.cos(absRotate) + height * Math.sin(absRotate)),
      height: Math.abs(height * Math.cos(absRotate) + width * Math.sin(absRotate))
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Rect);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape__ = __webpack_require__(71);








var Custom = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Custom, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Custom);

  function Custom() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Custom);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Custom, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Custom.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.createPath = null;
      this._attrs.type = 'custom';
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var createPath = this.get('createPath');
      createPath && createPath.call(this, context);
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var calculateBox = this.get('calculateBox');
      return calculateBox && calculateBox.call(this);
    }
  }]);

  return Custom;
}(__WEBPACK_IMPORTED_MODULE_6__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Custom);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape__ = __webpack_require__(71);







/**
 * marker shapes，used for tooltip and legend
 */


var SYMBOLS = {
  circle: function circle(x, y, r, ctx) {
    ctx.arc(x, y, r, 0, Math.PI * 2, false);
  },
  square: function square(x, y, r, ctx) {
    ctx.moveTo(x - r, y - r);
    ctx.lineTo(x + r, y - r);
    ctx.lineTo(x + r, y + r);
    ctx.lineTo(x - r, y + r);
    ctx.closePath();
  }
};

var Marker = /*#__PURE__*/function (_Shape) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Marker, _Shape);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Marker);

  function Marker() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Marker);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Marker, [{
    key: "_initProperties",
    value: function _initProperties() {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Marker.prototype), "_initProperties", this).call(this);

      this._attrs.canFill = true;
      this._attrs.canStroke = true;
      this._attrs.type = 'marker';
    }
  }, {
    key: "getDefaultAttrs",
    value: function getDefaultAttrs() {
      return {
        x: 0,
        y: 0,
        lineWidth: 0
      };
    }
  }, {
    key: "createPath",
    value: function createPath(context) {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          radius = attrs.radius;
      var symbol = attrs.symbol || 'circle';
      var method;

      if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(symbol)) {
        method = symbol;
      } else {
        method = SYMBOLS[symbol];
      }

      context.beginPath();
      method(x, y, radius, context, this);
    }
  }, {
    key: "calculateBox",
    value: function calculateBox() {
      var attrs = this.get('attrs');
      var x = attrs.x,
          y = attrs.y,
          radius = attrs.radius;
      return {
        minX: x - radius,
        minY: y - radius,
        maxX: x + radius,
        maxY: y + radius
      };
    }
  }]);

  return Marker;
}(__WEBPACK_IMPORTED_MODULE_7__shape__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Marker);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestAnimationFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);

var requestAnimationFrame = (typeof window === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(window)) === 'object' && window.requestAnimationFrame ? window.requestAnimationFrame : function (fn) {
  return setTimeout(fn, 16);
};


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  general: {
    title: '这是一个图表，',
    withTitle: '这是一个关于“{title}”的图表。'
  },
  coord: {
    cartesian: 'X轴是{xLabel}Y轴是{yLabel}' // polar: '弧度是{xLabel}半径是{yLabel}'

  },
  scale: {
    linear: '数值型，数据最小值为{min}，最大值为{max}；',
    cat: '分类型, 分类类型有：{values}；',
    timeCat: '时间型，时间范围从{start}到{end}；'
  },
  geometry: {
    prefix: '共有{count}种分类组成，',
    oneData: '第{index}类是{name}，数据是{values};',
    partData: '第{index}类是{name}，共有{count}项数据，前{part}项是{values};',
    allData: '第{index}类是{name}，有{count}项数据，分别是{values};'
  },
  legend: {
    prefix: '图例分类有：'
  }
});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsx;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);

var _excluded = ["key", "ref"];
// 实现jsx-classic 入口
function jsx(type, config) {
  var _ref = config || {},
      key = _ref.key,
      ref = _ref.ref,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, _excluded); // 保持和automatic模式一致


  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (children.length) {
    props.children = children.length === 1 ? children[0] : children;
  }

  return {
    key: key,
    ref: ref,
    type: type,
    props: props,
    // 存储一些过程中的cache值
    _cache: {}
  };
}

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (props) {
  return props.children;
});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// @ts-nocheck
// from css-layout
var CSS_UNDEFINED;
var CSS_DIRECTION_INHERIT = 'inherit';
var CSS_DIRECTION_LTR = 'ltr';
var CSS_DIRECTION_RTL = 'rtl';
var CSS_FLEX_DIRECTION_ROW = 'row';
var CSS_FLEX_DIRECTION_ROW_REVERSE = 'row-reverse';
var CSS_FLEX_DIRECTION_COLUMN = 'column';
var CSS_FLEX_DIRECTION_COLUMN_REVERSE = 'column-reverse';
var CSS_JUSTIFY_FLEX_START = 'flex-start';
var CSS_JUSTIFY_CENTER = 'center';
var CSS_JUSTIFY_FLEX_END = 'flex-end';
var CSS_JUSTIFY_SPACE_BETWEEN = 'space-between';
var CSS_JUSTIFY_SPACE_AROUND = 'space-around';
var CSS_ALIGN_FLEX_START = 'flex-start';
var CSS_ALIGN_CENTER = 'center';
var CSS_ALIGN_FLEX_END = 'flex-end';
var CSS_ALIGN_STRETCH = 'stretch';
var CSS_POSITION_RELATIVE = 'relative';
var CSS_POSITION_ABSOLUTE = 'absolute';
var leading = {
  row: 'left',
  'row-reverse': 'right',
  column: 'top',
  'column-reverse': 'bottom'
};
var trailing = {
  row: 'right',
  'row-reverse': 'left',
  column: 'bottom',
  'column-reverse': 'top'
};
var pos = {
  row: 'left',
  'row-reverse': 'right',
  column: 'top',
  'column-reverse': 'bottom'
};
var dim = {
  row: 'width',
  'row-reverse': 'width',
  column: 'height',
  'column-reverse': 'height'
}; // When transpiled to Java / C the node type has layout, children and style
// properties. For the JavaScript version this function adds these properties
// if they don't already exist.

function fillNodes(node) {
  if (!node.layout || node.isDirty) {
    node.layout = {
      width: undefined,
      height: undefined,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    };
  }

  if (!node.style) {
    node.style = {};
  }

  if (!node.children) {
    node.children = [];
  }

  node.children.forEach(fillNodes);
  return node;
}

function isUndefined(value) {
  return value === undefined;
}

function isRowDirection(flexDirection) {
  return flexDirection === CSS_FLEX_DIRECTION_ROW || flexDirection === CSS_FLEX_DIRECTION_ROW_REVERSE;
}

function isColumnDirection(flexDirection) {
  return flexDirection === CSS_FLEX_DIRECTION_COLUMN || flexDirection === CSS_FLEX_DIRECTION_COLUMN_REVERSE;
}

function getLeadingMargin(node, axis) {
  if (node.style.marginStart !== undefined && isRowDirection(axis)) {
    return node.style.marginStart;
  }

  var value = null;

  switch (axis) {
    case 'row':
      value = node.style.marginLeft;
      break;

    case 'row-reverse':
      value = node.style.marginRight;
      break;

    case 'column':
      value = node.style.marginTop;
      break;

    case 'column-reverse':
      value = node.style.marginBottom;
      break;
  }

  if (value !== undefined) {
    return value;
  }

  if (node.style.margin !== undefined) {
    return node.style.margin;
  }

  return 0;
}

function getTrailingMargin(node, axis) {
  if (node.style.marginEnd !== undefined && isRowDirection(axis)) {
    return node.style.marginEnd;
  }

  var value = null;

  switch (axis) {
    case 'row':
      value = node.style.marginRight;
      break;

    case 'row-reverse':
      value = node.style.marginLeft;
      break;

    case 'column':
      value = node.style.marginBottom;
      break;

    case 'column-reverse':
      value = node.style.marginTop;
      break;
  }

  if (value != null) {
    return value;
  }

  if (node.style.margin !== undefined) {
    return node.style.margin;
  }

  return 0;
}

function getLeadingPadding(node, axis) {
  if (node.style.paddingStart !== undefined && node.style.paddingStart >= 0 && isRowDirection(axis)) {
    return node.style.paddingStart;
  }

  var value = null;

  switch (axis) {
    case 'row':
      value = node.style.paddingLeft;
      break;

    case 'row-reverse':
      value = node.style.paddingRight;
      break;

    case 'column':
      value = node.style.paddingTop;
      break;

    case 'column-reverse':
      value = node.style.paddingBottom;
      break;
  }

  if (value != null && value >= 0) {
    return value;
  }

  if (node.style.padding !== undefined && node.style.padding >= 0) {
    return node.style.padding;
  }

  return 0;
}

function getTrailingPadding(node, axis) {
  if (node.style.paddingEnd !== undefined && node.style.paddingEnd >= 0 && isRowDirection(axis)) {
    return node.style.paddingEnd;
  }

  var value = null;

  switch (axis) {
    case 'row':
      value = node.style.paddingRight;
      break;

    case 'row-reverse':
      value = node.style.paddingLeft;
      break;

    case 'column':
      value = node.style.paddingBottom;
      break;

    case 'column-reverse':
      value = node.style.paddingTop;
      break;
  }

  if (value != null && value >= 0) {
    return value;
  }

  if (node.style.padding !== undefined && node.style.padding >= 0) {
    return node.style.padding;
  }

  return 0;
}

function getLeadingBorder(node, axis) {
  if (node.style.borderStartWidth !== undefined && node.style.borderStartWidth >= 0 && isRowDirection(axis)) {
    return node.style.borderStartWidth;
  }

  var value = null;

  switch (axis) {
    case 'row':
      value = node.style.borderLeftWidth;
      break;

    case 'row-reverse':
      value = node.style.borderRightWidth;
      break;

    case 'column':
      value = node.style.borderTopWidth;
      break;

    case 'column-reverse':
      value = node.style.borderBottomWidth;
      break;
  }

  if (value != null && value >= 0) {
    return value;
  }

  if (node.style.borderWidth !== undefined && node.style.borderWidth >= 0) {
    return node.style.borderWidth;
  }

  return 0;
}

function getTrailingBorder(node, axis) {
  if (node.style.borderEndWidth !== undefined && node.style.borderEndWidth >= 0 && isRowDirection(axis)) {
    return node.style.borderEndWidth;
  }

  var value = null;

  switch (axis) {
    case 'row':
      value = node.style.borderRightWidth;
      break;

    case 'row-reverse':
      value = node.style.borderLeftWidth;
      break;

    case 'column':
      value = node.style.borderBottomWidth;
      break;

    case 'column-reverse':
      value = node.style.borderTopWidth;
      break;
  }

  if (value != null && value >= 0) {
    return value;
  }

  if (node.style.borderWidth !== undefined && node.style.borderWidth >= 0) {
    return node.style.borderWidth;
  }

  return 0;
}

function getLeadingPaddingAndBorder(node, axis) {
  return getLeadingPadding(node, axis) + getLeadingBorder(node, axis);
}

function getTrailingPaddingAndBorder(node, axis) {
  return getTrailingPadding(node, axis) + getTrailingBorder(node, axis);
}

function getBorderAxis(node, axis) {
  return getLeadingBorder(node, axis) + getTrailingBorder(node, axis);
}

function getMarginAxis(node, axis) {
  return getLeadingMargin(node, axis) + getTrailingMargin(node, axis);
}

function getPaddingAndBorderAxis(node, axis) {
  return getLeadingPaddingAndBorder(node, axis) + getTrailingPaddingAndBorder(node, axis);
}

function getJustifyContent(node) {
  if (node.style.justifyContent) {
    return node.style.justifyContent;
  }

  return 'flex-start';
}

function getAlignContent(node) {
  if (node.style.alignContent) {
    return node.style.alignContent;
  }

  return 'flex-start';
}

function getAlignItem(node, child) {
  if (child.style.alignSelf) {
    return child.style.alignSelf;
  }

  if (node.style.alignItems) {
    return node.style.alignItems;
  }

  return 'stretch';
}

function resolveAxis(axis, direction) {
  if (direction === CSS_DIRECTION_RTL) {
    if (axis === CSS_FLEX_DIRECTION_ROW) {
      return CSS_FLEX_DIRECTION_ROW_REVERSE;
    } else if (axis === CSS_FLEX_DIRECTION_ROW_REVERSE) {
      return CSS_FLEX_DIRECTION_ROW;
    }
  }

  return axis;
}

function resolveDirection(node, parentDirection) {
  var direction;

  if (node.style.direction) {
    direction = node.style.direction;
  } else {
    direction = CSS_DIRECTION_INHERIT;
  }

  if (direction === CSS_DIRECTION_INHERIT) {
    direction = parentDirection === undefined ? CSS_DIRECTION_LTR : parentDirection;
  }

  return direction;
}

function getFlexDirection(node) {
  if (node.style.flexDirection) {
    return node.style.flexDirection;
  }

  return CSS_FLEX_DIRECTION_COLUMN;
}

function getCrossFlexDirection(flexDirection, direction) {
  if (isColumnDirection(flexDirection)) {
    return resolveAxis(CSS_FLEX_DIRECTION_ROW, direction);
  } else {
    return CSS_FLEX_DIRECTION_COLUMN;
  }
}

function getPositionType(node) {
  if (node.style.position) {
    return node.style.position;
  }

  return 'relative';
}

function isFlex(node) {
  return getPositionType(node) === CSS_POSITION_RELATIVE && node.style.flex > 0;
}

function isFlexWrap(node) {
  return node.style.flexWrap === 'wrap';
}

function getDimWithMargin(node, axis) {
  return node.layout[dim[axis]] + getMarginAxis(node, axis);
}

function isDimDefined(node, axis) {
  return node.style[dim[axis]] !== undefined && node.style[dim[axis]] >= 0;
}

function isPosDefined(node, pos) {
  return node.style[pos] !== undefined;
}

function isMeasureDefined(node) {
  return node.style.measure !== undefined;
}

function getPosition(node, pos) {
  if (node.style[pos] !== undefined) {
    return node.style[pos];
  }

  return 0;
}

function boundAxis(node, axis, value) {
  var min = {
    row: node.style.minWidth,
    'row-reverse': node.style.minWidth,
    column: node.style.minHeight,
    'column-reverse': node.style.minHeight
  }[axis];
  var max = {
    row: node.style.maxWidth,
    'row-reverse': node.style.maxWidth,
    column: node.style.maxHeight,
    'column-reverse': node.style.maxHeight
  }[axis];
  var boundValue = value;

  if (max !== undefined && max >= 0 && boundValue > max) {
    boundValue = max;
  }

  if (min !== undefined && min >= 0 && boundValue < min) {
    boundValue = min;
  }

  return boundValue;
}

function fmaxf(a, b) {
  if (a > b) {
    return a;
  }

  return b;
} // When the user specifically sets a value for width or height


function setDimensionFromStyle(node, axis) {
  // The parent already computed us a width or height. We just skip it
  if (node.layout[dim[axis]] !== undefined) {
    return;
  } // We only run if there's a width or height defined


  if (!isDimDefined(node, axis)) {
    return;
  } // The dimensions can never be smaller than the padding and border


  node.layout[dim[axis]] = fmaxf(boundAxis(node, axis, node.style[dim[axis]]), getPaddingAndBorderAxis(node, axis));
}

function setTrailingPosition(node, child, axis) {
  child.layout[trailing[axis]] = node.layout[dim[axis]] - child.layout[dim[axis]] - child.layout[pos[axis]];
} // If both left and right are defined, then use left. Otherwise return
// +left or -right depending on which is defined.


function getRelativePosition(node, axis) {
  if (node.style[leading[axis]] !== undefined) {
    return getPosition(node, leading[axis]);
  }

  return -getPosition(node, trailing[axis]);
}

function layoutNodeImpl(node, parentMaxWidth,
/*css_direction_t*/
parentDirection) {
  var
  /*css_direction_t*/
  direction = resolveDirection(node, parentDirection);
  var
  /*(c)!css_flex_direction_t*/

  /*(java)!int*/
  mainAxis = resolveAxis(getFlexDirection(node), direction);
  var
  /*(c)!css_flex_direction_t*/

  /*(java)!int*/
  crossAxis = getCrossFlexDirection(mainAxis, direction);
  var
  /*(c)!css_flex_direction_t*/

  /*(java)!int*/
  resolvedRowAxis = resolveAxis(CSS_FLEX_DIRECTION_ROW, direction); // Handle width and height style attributes

  setDimensionFromStyle(node, mainAxis);
  setDimensionFromStyle(node, crossAxis); // Set the resolved resolution in the node's layout

  node.layout.direction = direction; // The position is set by the parent, but we need to complete it with a
  // delta composed of the margin and left/top/right/bottom

  node.layout[leading[mainAxis]] += getLeadingMargin(node, mainAxis) + getRelativePosition(node, mainAxis);
  node.layout[trailing[mainAxis]] += getTrailingMargin(node, mainAxis) + getRelativePosition(node, mainAxis);
  node.layout[leading[crossAxis]] += getLeadingMargin(node, crossAxis) + getRelativePosition(node, crossAxis);
  node.layout[trailing[crossAxis]] += getTrailingMargin(node, crossAxis) + getRelativePosition(node, crossAxis); // Inline immutable values from the target node to avoid excessive method
  // invocations during the layout calculation.

  var
  /*int*/
  childCount = node.children.length;
  var
  /*float*/
  paddingAndBorderAxisResolvedRow = getPaddingAndBorderAxis(node, resolvedRowAxis);

  if (isMeasureDefined(node)) {
    var
    /*bool*/
    isResolvedRowDimDefined = !isUndefined(node.layout[dim[resolvedRowAxis]]);
    var
    /*float*/
    width = CSS_UNDEFINED;

    if (isDimDefined(node, resolvedRowAxis)) {
      width = node.style.width;
    } else if (isResolvedRowDimDefined) {
      width = node.layout[dim[resolvedRowAxis]];
    } else {
      width = parentMaxWidth - getMarginAxis(node, resolvedRowAxis);
    }

    width -= paddingAndBorderAxisResolvedRow; // We only need to give a dimension for the text if we haven't got any
    // for it computed yet. It can either be from the style attribute or because
    // the element is flexible.

    var
    /*bool*/
    isRowUndefined = !isDimDefined(node, resolvedRowAxis) && !isResolvedRowDimDefined;
    var
    /*bool*/
    isColumnUndefined = !isDimDefined(node, CSS_FLEX_DIRECTION_COLUMN) && isUndefined(node.layout[dim[CSS_FLEX_DIRECTION_COLUMN]]); // Let's not measure the text if we already know both dimensions

    if (isRowUndefined || isColumnUndefined) {
      var
      /*css_dim_t*/
      measureDim = node.style.measure(
      /*(c)!node->context,*/

      /*(java)!layoutContext.measureOutput,*/
      width);

      if (isRowUndefined) {
        node.layout.width = measureDim.width + paddingAndBorderAxisResolvedRow;
      }

      if (isColumnUndefined) {
        node.layout.height = measureDim.height + getPaddingAndBorderAxis(node, CSS_FLEX_DIRECTION_COLUMN);
      }
    }

    if (childCount === 0) {
      return;
    }
  }

  var
  /*bool*/
  isNodeFlexWrap = isFlexWrap(node);
  var
  /*css_justify_t*/
  justifyContent = getJustifyContent(node);
  var
  /*float*/
  leadingPaddingAndBorderMain = getLeadingPaddingAndBorder(node, mainAxis);
  var
  /*float*/
  leadingPaddingAndBorderCross = getLeadingPaddingAndBorder(node, crossAxis);
  var
  /*float*/
  paddingAndBorderAxisMain = getPaddingAndBorderAxis(node, mainAxis);
  var
  /*float*/
  paddingAndBorderAxisCross = getPaddingAndBorderAxis(node, crossAxis);
  var
  /*bool*/
  isMainDimDefined = !isUndefined(node.layout[dim[mainAxis]]);
  var
  /*bool*/
  isCrossDimDefined = !isUndefined(node.layout[dim[crossAxis]]);
  var
  /*bool*/
  isMainRowDirection = isRowDirection(mainAxis);
  var
  /*int*/
  i;
  var
  /*int*/
  ii;
  var
  /*css_node_t**/
  child;
  var
  /*(c)!css_flex_direction_t*/

  /*(java)!int*/
  axis;
  var
  /*css_node_t**/
  firstAbsoluteChild = null;
  var
  /*css_node_t**/
  currentAbsoluteChild = null;
  var
  /*float*/
  definedMainDim = CSS_UNDEFINED;

  if (isMainDimDefined) {
    definedMainDim = node.layout[dim[mainAxis]] - paddingAndBorderAxisMain;
  } // We want to execute the next two loops one per line with flex-wrap


  var
  /*int*/
  startLine = 0;
  var
  /*int*/
  endLine = 0; // var/*int*/ nextOffset = 0;

  var
  /*int*/
  alreadyComputedNextLayout = 0; // We aggregate the total dimensions of the container in those two variables

  var
  /*float*/
  linesCrossDim = 0;
  var
  /*float*/
  linesMainDim = 0;
  var
  /*int*/
  linesCount = 0;

  while (endLine < childCount) {
    // <Loop A> Layout non flexible children and count children by type
    // mainContentDim is accumulation of the dimensions and margin of all the
    // non flexible children. This will be used in order to either set the
    // dimensions of the node if none already exist, or to compute the
    // remaining space left for the flexible children.
    var
    /*float*/
    mainContentDim = 0; // There are three kind of children, non flexible, flexible and absolute.
    // We need to know how many there are in order to distribute the space.

    var
    /*int*/
    flexibleChildrenCount = 0;
    var
    /*float*/
    totalFlexible = 0;
    var
    /*int*/
    nonFlexibleChildrenCount = 0; // Use the line loop to position children in the main axis for as long
    // as they are using a simple stacking behaviour. Children that are
    // immediately stacked in the initial loop will not be touched again
    // in <Loop C>.

    var
    /*bool*/
    isSimpleStackMain = isMainDimDefined && justifyContent === CSS_JUSTIFY_FLEX_START || !isMainDimDefined && justifyContent !== CSS_JUSTIFY_CENTER;
    var
    /*int*/
    firstComplexMain = isSimpleStackMain ? childCount : startLine; // Use the initial line loop to position children in the cross axis for
    // as long as they are relatively positioned with alignment STRETCH or
    // FLEX_START. Children that are immediately stacked in the initial loop
    // will not be touched again in <Loop D>.

    var
    /*bool*/
    isSimpleStackCross = true;
    var
    /*int*/
    firstComplexCross = childCount;
    var
    /*css_node_t**/
    firstFlexChild = null;
    var
    /*css_node_t**/
    currentFlexChild = null;
    var
    /*float*/
    mainDim = leadingPaddingAndBorderMain;
    var
    /*float*/
    crossDim = 0;
    var
    /*float*/
    maxWidth;

    for (i = startLine; i < childCount; ++i) {
      child = node.children[i];
      child.lineIndex = linesCount;
      child.nextAbsoluteChild = null;
      child.nextFlexChild = null;
      var
      /*css_align_t*/
      alignItem = getAlignItem(node, child); // Pre-fill cross axis dimensions when the child is using stretch before
      // we call the recursive layout pass

      if (alignItem === CSS_ALIGN_STRETCH && getPositionType(child) === CSS_POSITION_RELATIVE && isCrossDimDefined && !isDimDefined(child, crossAxis)) {
        child.layout[dim[crossAxis]] = fmaxf(boundAxis(child, crossAxis, node.layout[dim[crossAxis]] - paddingAndBorderAxisCross - getMarginAxis(child, crossAxis)), // You never want to go smaller than padding
        getPaddingAndBorderAxis(child, crossAxis));
      } else if (getPositionType(child) === CSS_POSITION_ABSOLUTE) {
        // Store a private linked list of absolutely positioned children
        // so that we can efficiently traverse them later.
        if (firstAbsoluteChild === null) {
          firstAbsoluteChild = child;
        }

        if (currentAbsoluteChild !== null) {
          currentAbsoluteChild.nextAbsoluteChild = child;
        }

        currentAbsoluteChild = child; // Pre-fill dimensions when using absolute position and both offsets for the axis are defined (either both
        // left and right or top and bottom).

        for (ii = 0; ii < 2; ii++) {
          axis = ii !== 0 ? CSS_FLEX_DIRECTION_ROW : CSS_FLEX_DIRECTION_COLUMN;

          if (!isUndefined(node.layout[dim[axis]]) && !isDimDefined(child, axis) && isPosDefined(child, leading[axis]) && isPosDefined(child, trailing[axis])) {
            child.layout[dim[axis]] = fmaxf(boundAxis(child, axis, node.layout[dim[axis]] - getPaddingAndBorderAxis(node, axis) - getMarginAxis(child, axis) - getPosition(child, leading[axis]) - getPosition(child, trailing[axis])), // You never want to go smaller than padding
            getPaddingAndBorderAxis(child, axis));
          }
        }
      }

      var
      /*float*/
      nextContentDim = 0; // It only makes sense to consider a child flexible if we have a computed
      // dimension for the node.

      if (isMainDimDefined && isFlex(child)) {
        flexibleChildrenCount++;
        totalFlexible += child.style.flex; // Store a private linked list of flexible children so that we can
        // efficiently traverse them later.

        if (firstFlexChild === null) {
          firstFlexChild = child;
        }

        if (currentFlexChild !== null) {
          currentFlexChild.nextFlexChild = child;
        }

        currentFlexChild = child; // Even if we don't know its exact size yet, we already know the padding,
        // border and margin. We'll use this partial information, which represents
        // the smallest possible size for the child, to compute the remaining
        // available space.

        nextContentDim = getPaddingAndBorderAxis(child, mainAxis) + getMarginAxis(child, mainAxis);
      } else {
        maxWidth = CSS_UNDEFINED;

        if (!isMainRowDirection) {
          if (isDimDefined(node, resolvedRowAxis)) {
            maxWidth = node.layout[dim[resolvedRowAxis]] - paddingAndBorderAxisResolvedRow;
          } else {
            maxWidth = parentMaxWidth - getMarginAxis(node, resolvedRowAxis) - paddingAndBorderAxisResolvedRow;
          }
        } // This is the main recursive call. We layout non flexible children.


        if (alreadyComputedNextLayout === 0) {
          layoutNode(
          /*(java)!layoutContext, */
          child, maxWidth, direction);
        } // Absolute positioned elements do not take part of the layout, so we
        // don't use them to compute mainContentDim


        if (getPositionType(child) === CSS_POSITION_RELATIVE) {
          nonFlexibleChildrenCount++; // At this point we know the final size and margin of the element.

          nextContentDim = getDimWithMargin(child, mainAxis);
        }
      } // The element we are about to add would make us go to the next line


      if (isNodeFlexWrap && isMainDimDefined && mainContentDim + nextContentDim > definedMainDim && // If there's only one element, then it's bigger than the content
      // and needs its own line
      i !== startLine) {
        nonFlexibleChildrenCount--;
        alreadyComputedNextLayout = 1;
        break;
      } // Disable simple stacking in the main axis for the current line as
      // we found a non-trivial child. The remaining children will be laid out
      // in <Loop C>.


      if (isSimpleStackMain && (getPositionType(child) !== CSS_POSITION_RELATIVE || isFlex(child))) {
        isSimpleStackMain = false;
        firstComplexMain = i;
      } // Disable simple stacking in the cross axis for the current line as
      // we found a non-trivial child. The remaining children will be laid out
      // in <Loop D>.


      if (isSimpleStackCross && (getPositionType(child) !== CSS_POSITION_RELATIVE || alignItem !== CSS_ALIGN_STRETCH && alignItem !== CSS_ALIGN_FLEX_START || isUndefined(child.layout[dim[crossAxis]]))) {
        isSimpleStackCross = false;
        firstComplexCross = i;
      }

      if (isSimpleStackMain) {
        child.layout[pos[mainAxis]] += mainDim;

        if (isMainDimDefined) {
          setTrailingPosition(node, child, mainAxis);
        }

        mainDim += getDimWithMargin(child, mainAxis);
        crossDim = fmaxf(crossDim, boundAxis(child, crossAxis, getDimWithMargin(child, crossAxis)));
      }

      if (isSimpleStackCross) {
        child.layout[pos[crossAxis]] += linesCrossDim + leadingPaddingAndBorderCross;

        if (isCrossDimDefined) {
          setTrailingPosition(node, child, crossAxis);
        }
      }

      alreadyComputedNextLayout = 0;
      mainContentDim += nextContentDim;
      endLine = i + 1;
    } // <Loop B> Layout flexible children and allocate empty space
    // In order to position the elements in the main axis, we have two
    // controls. The space between the beginning and the first element
    // and the space between each two elements.


    var
    /*float*/
    leadingMainDim = 0;
    var
    /*float*/
    betweenMainDim = 0; // The remaining available space that needs to be allocated

    var
    /*float*/
    remainingMainDim = 0;

    if (isMainDimDefined) {
      remainingMainDim = definedMainDim - mainContentDim;
    } else {
      remainingMainDim = fmaxf(mainContentDim, 0) - mainContentDim;
    } // If there are flexible children in the mix, they are going to fill the
    // remaining space


    if (flexibleChildrenCount !== 0) {
      var
      /*float*/
      flexibleMainDim = remainingMainDim / totalFlexible;
      var
      /*float*/
      baseMainDim;
      var
      /*float*/
      boundMainDim; // If the flex share of remaining space doesn't meet min/max bounds,
      // remove this child from flex calculations.

      currentFlexChild = firstFlexChild;

      while (currentFlexChild !== null) {
        baseMainDim = flexibleMainDim * currentFlexChild.style.flex + getPaddingAndBorderAxis(currentFlexChild, mainAxis);
        boundMainDim = boundAxis(currentFlexChild, mainAxis, baseMainDim);

        if (baseMainDim !== boundMainDim) {
          remainingMainDim -= boundMainDim;
          totalFlexible -= currentFlexChild.style.flex;
        }

        currentFlexChild = currentFlexChild.nextFlexChild;
      }

      flexibleMainDim = remainingMainDim / totalFlexible; // The non flexible children can overflow the container, in this case
      // we should just assume that there is no space available.

      if (flexibleMainDim < 0) {
        flexibleMainDim = 0;
      }

      currentFlexChild = firstFlexChild;

      while (currentFlexChild !== null) {
        // At this point we know the final size of the element in the main
        // dimension
        currentFlexChild.layout[dim[mainAxis]] = boundAxis(currentFlexChild, mainAxis, flexibleMainDim * currentFlexChild.style.flex + getPaddingAndBorderAxis(currentFlexChild, mainAxis));
        maxWidth = CSS_UNDEFINED;

        if (isDimDefined(node, resolvedRowAxis)) {
          maxWidth = node.layout[dim[resolvedRowAxis]] - paddingAndBorderAxisResolvedRow;
        } else if (!isMainRowDirection) {
          maxWidth = parentMaxWidth - getMarginAxis(node, resolvedRowAxis) - paddingAndBorderAxisResolvedRow;
        } // And we recursively call the layout algorithm for this child


        layoutNode(
        /*(java)!layoutContext, */
        currentFlexChild, maxWidth, direction);
        child = currentFlexChild;
        currentFlexChild = currentFlexChild.nextFlexChild;
        child.nextFlexChild = null;
      } // We use justifyContent to figure out how to allocate the remaining
      // space available

    } else if (justifyContent !== CSS_JUSTIFY_FLEX_START) {
      if (justifyContent === CSS_JUSTIFY_CENTER) {
        leadingMainDim = remainingMainDim / 2;
      } else if (justifyContent === CSS_JUSTIFY_FLEX_END) {
        leadingMainDim = remainingMainDim;
      } else if (justifyContent === CSS_JUSTIFY_SPACE_BETWEEN) {
        remainingMainDim = fmaxf(remainingMainDim, 0);

        if (flexibleChildrenCount + nonFlexibleChildrenCount - 1 !== 0) {
          betweenMainDim = remainingMainDim / (flexibleChildrenCount + nonFlexibleChildrenCount - 1);
        } else {
          betweenMainDim = 0;
        }
      } else if (justifyContent === CSS_JUSTIFY_SPACE_AROUND) {
        // Space on the edges is half of the space between elements
        betweenMainDim = remainingMainDim / (flexibleChildrenCount + nonFlexibleChildrenCount);
        leadingMainDim = betweenMainDim / 2;
      }
    } // <Loop C> Position elements in the main axis and compute dimensions
    // At this point, all the children have their dimensions set. We need to
    // find their position. In order to do that, we accumulate data in
    // variables that are also useful to compute the total dimensions of the
    // container!


    mainDim += leadingMainDim;

    for (i = firstComplexMain; i < endLine; ++i) {
      child = node.children[i];

      if (getPositionType(child) === CSS_POSITION_ABSOLUTE && isPosDefined(child, leading[mainAxis])) {
        // In case the child is position absolute and has left/top being
        // defined, we override the position to whatever the user said
        // (and margin/border).
        child.layout[pos[mainAxis]] = getPosition(child, leading[mainAxis]) + getLeadingBorder(node, mainAxis) + getLeadingMargin(child, mainAxis);
      } else {
        // If the child is position absolute (without top/left) or relative,
        // we put it at the current accumulated offset.
        child.layout[pos[mainAxis]] += mainDim; // Define the trailing position accordingly.

        if (isMainDimDefined) {
          setTrailingPosition(node, child, mainAxis);
        } // Now that we placed the element, we need to update the variables
        // We only need to do that for relative elements. Absolute elements
        // do not take part in that phase.


        if (getPositionType(child) === CSS_POSITION_RELATIVE) {
          // The main dimension is the sum of all the elements dimension plus
          // the spacing.
          mainDim += betweenMainDim + getDimWithMargin(child, mainAxis); // The cross dimension is the max of the elements dimension since there
          // can only be one element in that cross dimension.

          crossDim = fmaxf(crossDim, boundAxis(child, crossAxis, getDimWithMargin(child, crossAxis)));
        }
      }
    }

    var
    /*float*/
    containerCrossAxis = node.layout[dim[crossAxis]];

    if (!isCrossDimDefined) {
      containerCrossAxis = fmaxf( // For the cross dim, we add both sides at the end because the value
      // is aggregate via a max function. Intermediate negative values
      // can mess this computation otherwise
      boundAxis(node, crossAxis, crossDim + paddingAndBorderAxisCross), paddingAndBorderAxisCross);
    } // <Loop D> Position elements in the cross axis


    for (i = firstComplexCross; i < endLine; ++i) {
      child = node.children[i];

      if (getPositionType(child) === CSS_POSITION_ABSOLUTE && isPosDefined(child, leading[crossAxis])) {
        // In case the child is absolutely positionned and has a
        // top/left/bottom/right being set, we override all the previously
        // computed positions to set it correctly.
        child.layout[pos[crossAxis]] = getPosition(child, leading[crossAxis]) + getLeadingBorder(node, crossAxis) + getLeadingMargin(child, crossAxis);
      } else {
        var
        /*float*/
        leadingCrossDim = leadingPaddingAndBorderCross; // For a relative children, we're either using alignItems (parent) or
        // alignSelf (child) in order to determine the position in the cross axis

        if (getPositionType(child) === CSS_POSITION_RELATIVE) {
          // This variable is intentionally re-defined as the code is transpiled to a block scope language
          var
          /*css_align_t*/
          alignItem = getAlignItem(node, child);

          if (alignItem === CSS_ALIGN_STRETCH) {
            // You can only stretch if the dimension has not already been set
            // previously.
            if (isUndefined(child.layout[dim[crossAxis]])) {
              child.layout[dim[crossAxis]] = fmaxf(boundAxis(child, crossAxis, containerCrossAxis - paddingAndBorderAxisCross - getMarginAxis(child, crossAxis)), // You never want to go smaller than padding
              getPaddingAndBorderAxis(child, crossAxis));
            }
          } else if (alignItem !== CSS_ALIGN_FLEX_START) {
            // The remaining space between the parent dimensions+padding and child
            // dimensions+margin.
            var
            /*float*/
            remainingCrossDim = containerCrossAxis - paddingAndBorderAxisCross - getDimWithMargin(child, crossAxis);

            if (alignItem === CSS_ALIGN_CENTER) {
              leadingCrossDim += remainingCrossDim / 2;
            } else {
              // CSS_ALIGN_FLEX_END
              leadingCrossDim += remainingCrossDim;
            }
          }
        } // And we apply the position


        child.layout[pos[crossAxis]] += linesCrossDim + leadingCrossDim; // Define the trailing position accordingly.

        if (isCrossDimDefined) {
          setTrailingPosition(node, child, crossAxis);
        }
      }
    }

    linesCrossDim += crossDim;
    linesMainDim = fmaxf(linesMainDim, mainDim);
    linesCount += 1;
    startLine = endLine;
  } // <Loop E>
  //
  // Note(prenaux): More than one line, we need to layout the crossAxis
  // according to alignContent.
  //
  // Note that we could probably remove <Loop D> and handle the one line case
  // here too, but for the moment this is safer since it won't interfere with
  // previously working code.
  //
  // See specs:
  // http://www.w3.org/TR/2012/CR-css3-flexbox-20120918/#layout-algorithm
  // section 9.4
  //


  if (linesCount > 1 && isCrossDimDefined) {
    var
    /*float*/
    nodeCrossAxisInnerSize = node.layout[dim[crossAxis]] - paddingAndBorderAxisCross;
    var
    /*float*/
    remainingAlignContentDim = nodeCrossAxisInnerSize - linesCrossDim;
    var
    /*float*/
    crossDimLead = 0;
    var
    /*float*/
    currentLead = leadingPaddingAndBorderCross;
    var
    /*css_align_t*/
    alignContent = getAlignContent(node);

    if (alignContent === CSS_ALIGN_FLEX_END) {
      currentLead += remainingAlignContentDim;
    } else if (alignContent === CSS_ALIGN_CENTER) {
      currentLead += remainingAlignContentDim / 2;
    } else if (alignContent === CSS_ALIGN_STRETCH) {
      if (nodeCrossAxisInnerSize > linesCrossDim) {
        crossDimLead = remainingAlignContentDim / linesCount;
      }
    }

    var
    /*int*/
    endIndex = 0;

    for (i = 0; i < linesCount; ++i) {
      var
      /*int*/
      startIndex = endIndex; // compute the line's height and find the endIndex

      var
      /*float*/
      lineHeight = 0;

      for (ii = startIndex; ii < childCount; ++ii) {
        child = node.children[ii];

        if (getPositionType(child) !== CSS_POSITION_RELATIVE) {
          continue;
        }

        if (child.lineIndex !== i) {
          break;
        }

        if (!isUndefined(child.layout[dim[crossAxis]])) {
          lineHeight = fmaxf(lineHeight, child.layout[dim[crossAxis]] + getMarginAxis(child, crossAxis));
        }
      }

      endIndex = ii;
      lineHeight += crossDimLead;

      for (ii = startIndex; ii < endIndex; ++ii) {
        child = node.children[ii];

        if (getPositionType(child) !== CSS_POSITION_RELATIVE) {
          continue;
        }

        var
        /*css_align_t*/
        alignContentAlignItem = getAlignItem(node, child);

        if (alignContentAlignItem === CSS_ALIGN_FLEX_START) {
          child.layout[pos[crossAxis]] = currentLead + getLeadingMargin(child, crossAxis);
        } else if (alignContentAlignItem === CSS_ALIGN_FLEX_END) {
          child.layout[pos[crossAxis]] = currentLead + lineHeight - getTrailingMargin(child, crossAxis) - child.layout[dim[crossAxis]];
        } else if (alignContentAlignItem === CSS_ALIGN_CENTER) {
          var
          /*float*/
          childHeight = child.layout[dim[crossAxis]];
          child.layout[pos[crossAxis]] = currentLead + (lineHeight - childHeight) / 2;
        } else if (alignContentAlignItem === CSS_ALIGN_STRETCH) {
          child.layout[pos[crossAxis]] = currentLead + getLeadingMargin(child, crossAxis); // TODO(prenaux): Correctly set the height of items with undefined
          //                (auto) crossAxis dimension.
        }
      }

      currentLead += lineHeight;
    }
  }

  var
  /*bool*/
  needsMainTrailingPos = false;
  var
  /*bool*/
  needsCrossTrailingPos = false; // If the user didn't specify a width or height, and it has not been set
  // by the container, then we set it via the children.

  if (!isMainDimDefined) {
    node.layout[dim[mainAxis]] = fmaxf( // We're missing the last padding at this point to get the final
    // dimension
    boundAxis(node, mainAxis, linesMainDim + getTrailingPaddingAndBorder(node, mainAxis)), // We can never assign a width smaller than the padding and borders
    paddingAndBorderAxisMain);

    if (mainAxis === CSS_FLEX_DIRECTION_ROW_REVERSE || mainAxis === CSS_FLEX_DIRECTION_COLUMN_REVERSE) {
      needsMainTrailingPos = true;
    }
  }

  if (!isCrossDimDefined) {
    node.layout[dim[crossAxis]] = fmaxf( // For the cross dim, we add both sides at the end because the value
    // is aggregate via a max function. Intermediate negative values
    // can mess this computation otherwise
    boundAxis(node, crossAxis, linesCrossDim + paddingAndBorderAxisCross), paddingAndBorderAxisCross);

    if (crossAxis === CSS_FLEX_DIRECTION_ROW_REVERSE || crossAxis === CSS_FLEX_DIRECTION_COLUMN_REVERSE) {
      needsCrossTrailingPos = true;
    }
  } // <Loop F> Set trailing position if necessary


  if (needsMainTrailingPos || needsCrossTrailingPos) {
    for (i = 0; i < childCount; ++i) {
      child = node.children[i];

      if (needsMainTrailingPos) {
        setTrailingPosition(node, child, mainAxis);
      }

      if (needsCrossTrailingPos) {
        setTrailingPosition(node, child, crossAxis);
      }
    }
  } // <Loop G> Calculate dimensions for absolutely positioned elements


  currentAbsoluteChild = firstAbsoluteChild;

  while (currentAbsoluteChild !== null) {
    // Pre-fill dimensions when using absolute position and both offsets for
    // the axis are defined (either both left and right or top and bottom).
    for (ii = 0; ii < 2; ii++) {
      axis = ii !== 0 ? CSS_FLEX_DIRECTION_ROW : CSS_FLEX_DIRECTION_COLUMN;

      if (!isUndefined(node.layout[dim[axis]]) && !isDimDefined(currentAbsoluteChild, axis) && isPosDefined(currentAbsoluteChild, leading[axis]) && isPosDefined(currentAbsoluteChild, trailing[axis])) {
        currentAbsoluteChild.layout[dim[axis]] = fmaxf(boundAxis(currentAbsoluteChild, axis, node.layout[dim[axis]] - getBorderAxis(node, axis) - getMarginAxis(currentAbsoluteChild, axis) - getPosition(currentAbsoluteChild, leading[axis]) - getPosition(currentAbsoluteChild, trailing[axis])), // You never want to go smaller than padding
        getPaddingAndBorderAxis(currentAbsoluteChild, axis));
      }

      if (isPosDefined(currentAbsoluteChild, trailing[axis]) && !isPosDefined(currentAbsoluteChild, leading[axis])) {
        currentAbsoluteChild.layout[leading[axis]] = node.layout[dim[axis]] - currentAbsoluteChild.layout[dim[axis]] - getPosition(currentAbsoluteChild, trailing[axis]);
      }
    }

    child = currentAbsoluteChild;
    currentAbsoluteChild = currentAbsoluteChild.nextAbsoluteChild;
    child.nextAbsoluteChild = null;
  }
} // 在外层做的margin补丁


function saveMargin(node) {
  var style = node.style;
  var margin = {};
  ['marginTop', 'marginRight', 'marginBottom', 'marginLeft' // 只支持marginLeft
  ].forEach(function (key) {
    // 只处理百分号
    var value = style[key];

    if (value && /^-?\d+%$/.test(value)) {
      margin[key] = value;
      style[key] = 0;
    }
  });
  node.margin = margin;
}

function percent2Num(value) {
  var percent = Number(value.substr(0, value.length - 1));
  return percent / 100;
}

function layoutMargin(node) {
  var margin = node.margin,
      layout = node.layout;
  Object.keys(margin).forEach(function (key) {
    var percent = percent2Num(margin[key]);

    if ((key === 'marginLeft' || key === 'marginRight') && layout.width) {
      layout.left += layout.width * percent;
    } else if ((key === 'marginTop' || key === 'marginBottom') && layout.height) {
      layout.top += layout.height * percent;
    }
  });
}

function layoutNode(node, parentMaxWidth, parentDirection) {
  node.shouldUpdate = true; // hack

  saveMargin(node);
  var direction = node.style.direction || CSS_DIRECTION_LTR;
  var skipLayout = !node.isDirty && node.lastLayout && node.lastLayout.requestedHeight === node.layout.height && node.lastLayout.requestedWidth === node.layout.width && node.lastLayout.parentMaxWidth === parentMaxWidth && node.lastLayout.direction === direction;

  if (skipLayout) {
    node.layout.width = node.lastLayout.width;
    node.layout.height = node.lastLayout.height;
    node.layout.top = node.lastLayout.top;
    node.layout.left = node.lastLayout.left;
  } else {
    if (!node.lastLayout) {
      node.lastLayout = {};
    }

    node.lastLayout.requestedWidth = node.layout.width;
    node.lastLayout.requestedHeight = node.layout.height;
    node.lastLayout.parentMaxWidth = parentMaxWidth;
    node.lastLayout.direction = direction; // Reset child layouts

    node.children.forEach(function (child) {
      child.layout.width = undefined;
      child.layout.height = undefined;
      child.layout.top = 0;
      child.layout.left = 0;
    });
    layoutNodeImpl(node, parentMaxWidth, parentDirection);
    node.lastLayout.width = node.layout.width;
    node.lastLayout.height = node.layout.height;
    node.lastLayout.top = node.layout.top;
    node.lastLayout.left = node.layout.left;
  } // hack


  layoutMargin(node);
}
/* eslint-enable */


function computeLayout(node) {
  if (!node) return node;
  var style = node.style,
      children = node.children;

  if (style) {
    fillNodes(node);
    layoutNode(node, null, null);
    return node;
  }

  if (children && children.length) {
    for (var i = 0, len = children.length; i < len; i++) {
      computeLayout(children[i]);
    }
  }

  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (computeLayout);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rect__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__text__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__circle__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__marker__ = __webpack_require__(742);





var map = {
  rect: __WEBPACK_IMPORTED_MODULE_0__rect__["a" /* default */],
  line: __WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */],
  text: __WEBPACK_IMPORTED_MODULE_2__text__["a" /* default */],
  circle: __WEBPACK_IMPORTED_MODULE_3__circle__["a" /* default */],
  marker: __WEBPACK_IMPORTED_MODULE_4__marker__["a" /* default */],
  group: __WEBPACK_IMPORTED_MODULE_0__rect__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (function (type, layout) {
  if (!layout) return null;
  var fn = map[type] || __WEBPACK_IMPORTED_MODULE_0__rect__["a" /* default */];
  return fn(layout);
});

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (layout) {
  var left = layout.left,
      top = layout.top,
      width = layout.width,
      height = layout.height;
  return {
    x: left,
    y: top,
    width: width,
    height: height
  };
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (layout) {
  var left = layout.left,
      top = layout.top,
      width = layout.width,
      height = layout.height;
  return {
    x1: left,
    y1: top,
    x2: left + width,
    y2: top + height
  };
});

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (layout) {
  var height = layout.height,
      left = layout.left,
      top = layout.top;
  return {
    x: left,
    y: top + height / 2,
    // 通过middle + top 才能比较好的实现文本对齐
    textBaseline: 'middle'
  };
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (layout) {
  var left = layout.left,
      top = layout.top,
      width = layout.width;
  var r = width / 2;
  return {
    x: left + r,
    y: top + r,
    r: r
  };
});

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (layout) {
  var left = layout.left,
      top = layout.top,
      width = layout.width;
  var r = width / 2;
  return {
    x: left + r,
    y: top,
    radius: r
  };
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementStatus__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createClipElement__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_util__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["a"] = (function (element, animation, nextAttrs, lastAttrs) {
  if (!animation) return null; // 获取shape的默认属性

  var status = element.get('status');
  var clip = animation.clip,
      start = animation.start,
      end = animation.end,
      easing = animation.easing,
      delay = animation.delay,
      duration = animation.duration;
  var clipConfig = Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["v" /* isFunction */])(clip) ? clip(element._attrs.attrs) : clip; // 裁剪动画

  if (clipConfig) {
    var type = clipConfig.type,
        attrs = clipConfig.attrs,
        clipStart = clipConfig.start;
    var clipElement = Object(__WEBPACK_IMPORTED_MODULE_2__createClipElement__["a" /* default */])(type, {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, attrs), clipStart)
    }); // 默认用 animation 配置里的 easing 和 duration

    clipConfig.easing = clipConfig.easing || easing;
    clipConfig.delay = typeof clipConfig.delay === 'number' ? clipConfig.delay : delay;
    clipConfig.duration = clipConfig.duration || duration;
    clipConfig.element = clipElement;
  }

  var defaultAttrs = element.getDefaultAttrs();
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, animation), {}, {
    clip: clipConfig,
    start: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultAttrs), lastAttrs), start),
    end: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, status === __WEBPACK_IMPORTED_MODULE_1__elementStatus__["ELEMENT_DELETE"] ? null : nextAttrs), end)
  });
});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__children__ = __webpack_require__(102);

 // 主要是把function节点，全部转换成string标签节点

function renderJSXElement(element, context, updater) {
  if (!element) return element;

  var _element = element,
      type = _element.type,
      key = _element.key,
      ref = _element.ref,
      props = _element.props,
      _element$_cache = _element._cache,
      _cache = _element$_cache === void 0 ? {} : _element$_cache; // render children first


  var children = __WEBPACK_IMPORTED_MODULE_1__children__["a" /* default */].map(props.children, function (child) {
    return renderJSXElement(child, context, updater);
  });
  element = {
    type: type,
    key: key,
    ref: ref,
    _cache: _cache,
    props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
      children: children
    })
  };

  if (typeof type === 'function') {
    // @ts-ignore
    var newElement = type(element.props, context, updater);
    if (!newElement) return newElement; // recursive render until type is string

    return renderJSXElement(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, newElement), {}, {
      // 保留原始的key和ref
      key: key !== undefined ? key : newElement.key,
      ref: ref !== undefined ? ref : newElement.ref
    }), context, updater);
  } // return element if type is string


  return element;
}

/* harmony default export */ __webpack_exports__["a"] = (function (element, context, updater) {
  return renderJSXElement(element, context, updater);
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__children__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elementStatus__ = __webpack_require__(142);


var _excluded = ["children", "animation"],
    _excluded2 = ["children", "animation"],
    _excluded3 = ["children", "animation"],
    _excluded4 = ["animation"],
    _excluded5 = ["animation"];
// 比较2颗shape树，并返回新的渲染树


 // 处理删除的元素

function deleteElement(element) {
  // 是否有非空的子元素
  var hasElement = false;
  var receiveElement = __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(element, function (item) {
    if (!item) return item;
    var ref = item.ref,
        key = item.key,
        type = item.type,
        props = item.props,
        _cache = item._cache;

    var children = props.children,
        animation = props.animation,
        receiveProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded);

    var status = __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_DELETE"];
    var receiveAnimation = animation && animation.leave;
    var receiveChildren = deleteElement(children); // 没有子元素，且自身也不需要动画，则直接删除

    if (!receiveChildren && !receiveAnimation) {
      return null;
    }

    hasElement = true;
    return {
      ref: ref,
      key: key,
      type: type,
      props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, receiveProps), {}, {
        children: receiveChildren
      }),
      _cache: _cache,
      animation: receiveAnimation,
      status: status
    };
  }); // 如果没有非空的子元素，都删除

  if (!hasElement) {
    return null;
  }

  return receiveElement;
}

function appearElement(element) {
  return __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(element, function (item) {
    if (!item) return item;
    var ref = item.ref,
        key = item.key,
        type = item.type,
        props = item.props,
        _cache = item._cache;

    var children = props.children,
        animation = props.animation,
        receiveProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, _excluded2);

    var status = __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_APPEAR"];
    var receiveAnimation = animation && animation.appear;
    var receiveChildren = appearElement(children);
    return {
      ref: ref,
      key: key,
      type: type,
      props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, receiveProps), {}, {
        children: receiveChildren
      }),
      _cache: _cache,
      animation: receiveAnimation,
      status: status
    };
  });
}

function updateElement(nextElement, lastElement) {
  var ref = nextElement.ref,
      key = nextElement.key,
      type = nextElement.type,
      _nextCache = nextElement._cache,
      nextProps = nextElement.props;
  var _lastCache = lastElement._cache,
      lastProps = lastElement.props;

  var nextChildren = nextProps.children,
      nextAnimation = nextProps.animation,
      nextReceiveProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(nextProps, _excluded3);

  var lastChildren = lastProps.children; // 继续比较子元素

  var children = compareElement(nextChildren, lastChildren); // 保留缓存值

  var _cache = Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["G" /* mix */])(_nextCache, _lastCache); // 动画


  var animation = nextAnimation && nextAnimation.update; // 生成新对象

  return {
    ref: ref,
    key: key,
    type: type,
    props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, nextReceiveProps), {}, {
      children: children
    }),
    _cache: _cache,
    animation: animation,
    status: __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_UPDATE"]
  };
} // 形变动画， TODO


function morphElement(nextElement, lastElement) {
  return [deleteElement(lastElement), appearElement(nextElement)];
}

function changeTypeToGroup(nextGroupElement, lastShapeElement) {
  var key = nextGroupElement.key,
      type = nextGroupElement.type,
      ref = nextGroupElement.ref,
      groupProps = nextGroupElement.props,
      _groupCache = nextGroupElement._cache;
  var lastType = lastShapeElement.type,
      _lastCache = lastShapeElement._cache;
  var groupChildren = groupProps.children; // let existTransform = false;

  var children = __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(groupChildren, function (nextElement) {
    if (!nextElement) return nextElement;
    var key = nextElement.key,
        ref = nextElement.ref,
        nextType = nextElement.type,
        nextProps = nextElement.props,
        _nextCache = nextElement._cache; // if (nextType === 'group') {
    //   return changeTypeToGroup(nextElement, lastShapeElement);
    // }

    if (nextType !== lastType) {
      return morphElement(nextElement, lastShapeElement);
    } // existTransform = true;


    var nextAnimation = nextProps.animation,
        nextReceiveProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(nextProps, _excluded4);

    var animation = nextAnimation && nextAnimation.update;
    return {
      ref: ref,
      key: key,
      type: nextType,
      props: nextReceiveProps,
      _cache: Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["G" /* mix */])(_nextCache, _lastCache),
      animation: animation,
      status: __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_UPDATE"]
    };
  });
  return {
    key: key,
    type: type,
    ref: ref,
    props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, groupProps), {}, {
      children: children
    }),
    _cache: _groupCache,
    status: __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_UPDATE"]
  };
}

function changeTypeFromGroup(nextShapeElement, lastGroupElement) {
  var nextRef = nextShapeElement.ref,
      nextKey = nextShapeElement.key,
      nextType = nextShapeElement.type,
      nextShapeProps = nextShapeElement.props,
      _nextCache = nextShapeElement._cache;
  var lastType = lastGroupElement.type,
      lastProps = lastGroupElement.props;

  var nextAnimation = nextShapeProps.animation,
      nextReceiveProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(nextShapeProps, _excluded5);

  var groupChildren = lastProps.children;
  var animation = nextAnimation && nextAnimation.update;

  if (!animation) {
    return [deleteElement(lastGroupElement), appearElement[nextShapeElement]];
  }

  var transformChild = null;
  var children = __WEBPACK_IMPORTED_MODULE_2__children__["a" /* default */].map(groupChildren, function (child) {
    if (!child) return child;
    var childType = child.type,
        _childCache = child._cache;

    if (childType !== nextType) {
      // TODO: child 形变
      return deleteElement(child);
    }

    if (!transformChild) {
      transformChild = child;
    }

    return {
      type: nextType,
      props: nextShapeProps,
      _cache: _childCache,
      animation: animation,
      status: __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_UPDATE"]
    };
  });

  if (!transformChild) {
    return [deleteElement(lastGroupElement), appearElement(nextShapeElement)];
  }

  var nextElement = {
    ref: nextRef,
    key: nextKey,
    type: nextType,
    props: nextReceiveProps,
    _cache: Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["G" /* mix */])(_nextCache, transformChild._cache),
    animation: animation,
    status: __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_UPDATE"]
  }; // 保留group 结构

  return [{
    type: lastType,
    props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, lastProps), {}, {
      children: children
    }),
    status: __WEBPACK_IMPORTED_MODULE_4__elementStatus__["ELEMENT_DELETE"]
  }, nextElement];
}

function changeElementType(nextElement, lastElement) {
  var nextType = nextElement.type;
  var lastType = lastElement.type;

  if (nextType === 'group') {
    return changeTypeToGroup(nextElement, lastElement);
  }

  if (lastType === 'group') {
    return changeTypeFromGroup(nextElement, lastElement);
  } // 都不是group, 形变动画 TODO


  return morphElement(nextElement, lastElement);
} // 对比2个数组


function compareArray(nextElements, lastElements) {
  var keyed = {};
  var nextLength = nextElements.length;
  var lastLength = lastElements.length;

  for (var i = 0; i < lastLength; i++) {
    var element = lastElements[i];

    if (element && !Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["w" /* isNil */])(element.key)) {
      var key = element.key;
      keyed[key] = element;
    }
  } // 比较元素


  var maxLength = Math.max(nextLength, lastLength);
  var returnElements = [];

  for (var _i = 0; _i < maxLength; _i++) {
    var nextElement = nextElements[_i];

    if (!nextElement) {
      returnElements.push(compareElement(nextElement, lastElements[_i]));
      continue;
    }

    var _key = nextElement.key; // 有key值定义

    if (!Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["w" /* isNil */])(_key)) {
      var lastElement = keyed[_key];
      if (lastElement) delete keyed[_key];
      returnElements.push(compareElement(nextElement, lastElement));
      continue;
    }

    returnElements.push(compareElement(nextElement, lastElements[_i]));
  } // 说明是删除的元素


  Object.keys(keyed).forEach(function (key) {
    returnElements.push(compareElement(null, keyed[key]));
  });
  return returnElements;
} // 比较2个元素，会被递归执行


function compareElement(nextElement, lastElement) {
  // 都为空
  if (!nextElement && !lastElement) {
    return null;
  } // 新增


  if (!lastElement) {
    return appearElement(nextElement);
  } // 删除


  if (!nextElement) {
    return deleteElement(lastElement);
  } // nextElement & lastElement 都不为空了
  // 如果有数组，比较数组


  if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["r" /* isArray */])(nextElement) || Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["r" /* isArray */])(lastElement)) {
    var nextElementArray = Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["r" /* isArray */])(nextElement) ? nextElement : [nextElement];
    var lastElementArray = Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["r" /* isArray */])(lastElement) ? lastElement : [lastElement];
    return compareArray(nextElementArray, lastElementArray);
  } // 普通的jsx元素, 且都非空


  var nextKey = nextElement.key,
      nextType = nextElement.type;
  var lastKey = lastElement.key,
      lastType = lastElement.type; // key 值不相等

  if (!Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["w" /* isNil */])(nextKey) && nextKey !== lastKey) {
    return [deleteElement(lastElement), appearElement(nextElement)];
  } // shape 类型的变化


  if (nextType !== lastType) {
    // return [deleteElement(lastElement), nextElement];
    return changeElementType(nextElement, lastElement);
  }

  return updateElement(nextElement, lastElement);
} // 因为要实现删除元素的动画，所以需要保留删除的元素，diff 后需要创建一颗新树， 实际渲染也需要拿这颗树来进行


/* harmony default export */ __webpack_exports__["a"] = (compareElement);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUpdater; });
function createUpdater(canvas) {
  var setStateQueue = [];
  var renderQueue = [];
  var callbackQueue = [];

  function process() {
    var item; // let component;

    while (item = setStateQueue.shift()) {
      var _item = item,
          state = _item.state,
          component = _item.component,
          callback = _item.callback;

      if (component.destroyed) {
        continue;
      } // 如果没有prevState，则将当前的state作为初始的prevState


      if (!component.prevState) {
        component.prevState = Object.assign({}, component.state);
      } // 如果stateChange是一个方法，也就是setState的第二种形式


      if (typeof state === 'function') {
        Object.assign(component.state, state(component.prevState, component.props));
      } else {
        // 如果stateChange是一个对象，则直接合并到setState中
        Object.assign(component.state, state);
      }

      component.prevState = component.state;

      if (typeof callback === 'function') {
        callbackQueue.push({
          callback: callback,
          component: component
        });
      }
    }

    var renderComponents = [].concat(renderQueue);
    canvas.renderComponents(renderComponents); // callback queue

    commitRenderQueue(); // 清空

    renderQueue.length = 0;
    callbackQueue.length = 0;
  }

  function enqueueSetState(component, state, callback) {
    if (setStateQueue.length === 0) {
      setTimeout(process, 0);
    }

    setStateQueue.push({
      component: component,
      state: state,
      callback: callback
    });

    if (renderQueue.indexOf(component) < 0) {
      renderQueue.push(component);
    }
  }

  function commitRenderQueue() {
    for (var i = 0; i < callbackQueue.length; i++) {
      var _callbackQueue$i = callbackQueue[i],
          callback = _callbackQueue$i.callback,
          component = _callbackQueue$i.component;
      callback.call(component);
    }
  }

  var updater = {
    // isMounted: function(publicInstance) {
    //   return false;
    // },
    enqueueForceUpdate: enqueueSetState,
    // enqueueReplaceState: function(publicInstance, completeState) {
    // },
    enqueueSetState: enqueueSetState
  };
  return updater;
}



/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var axis = {
  labelOffset: '15px',
  line: {
    stroke: '#E8E8E8',
    lineWidth: '1px'
  },
  label: {
    fill: '#808080',
    fontSize: '20px'
  },
  grid: {
    stroke: '#E8E8E8',
    lineWidth: '1px',
    lineDash: ['4px']
  }
};
var guide = {
  line: {
    style: {
      stroke: '#a3a3a3',
      lineWidth: 1
    },
    offsetX: 0,
    offsetY: 0
  },
  text: {
    style: {
      fill: '#787878',
      // textAlign: 'center',
      textBaseline: 'middle'
    },
    offsetX: 0,
    offsetY: 0
  },
  rect: {
    style: {
      fill: '#fafafa'
    }
  },
  arc: {
    style: {
      stroke: '#a3a3a3'
    }
  },
  html: {
    offsetX: 0,
    offsetY: 0,
    alignX: 'center',
    alignY: 'middle'
  },
  tag: {
    offsetX: 0,
    offsetY: 0,
    side: 4,
    background: {
      padding: 5,
      radius: 2,
      fill: '#1890FF'
    },
    textStyle: {
      fontSize: 12,
      fill: '#fff',
      textAlign: 'center',
      textBaseline: 'middle'
    }
  },
  point: {
    offsetX: 0,
    offsetY: 0,
    style: {
      fill: '#fff',
      r: 3,
      lineWidth: 2,
      stroke: '#1890ff'
    }
  }
};
var chart = {
  padding: ['30px', '30px', '30px', '30px']
};
var Theme = {
  fontFamily: '"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif',
  pixelRatio: 1,
  padding: [0, 0, 0, 0],
  chart: chart,
  colors: ['#1890FF', '#2FC25B', '#FACC14', '#223273', '#8543E0', '#13C2C2', '#3436C7', '#F04864'],
  shapes: {
    line: ['line', 'dash', 'smooth'],
    point: ['circle', 'hollowCircle', 'rect'],
    area: ['area', 'smooth'],
    interval: ['rect', 'pyramid', 'funnel']
  },
  sizes: ['4px', '6px', '8px', '10px', '12px'],
  shape: {
    line: {
      default: {
        lineWidth: '4px',
        lineJoin: 'round',
        lineCap: 'round'
      },
      smooth: {
        smooth: true
      },
      dash: {
        lineDash: ['8px', '8px']
      }
    },
    point: {
      default: {
        size: '6px'
      },
      hollowCircle: {
        lineWidth: '2px'
      }
    },
    area: {
      default: {
        fillOpacity: 0.1
      }
    },
    interval: {
      default: {}
    }
  },
  axis: axis,
  guide: guide
};
/* harmony default export */ __webpack_exports__["a"] = (Theme);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timelime__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animator__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsx__ = __webpack_require__(20);




 // 遍历全部节点

function eachElement(element, fn) {
  fn(element);
  var children = element.get('children');

  if (children && children.length) {
    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      eachElement(child, fn);
    }
  }
}

var Animation = /*#__PURE__*/function () {
  function Animation(canvas) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Animation);

    this.timeline = new __WEBPACK_IMPORTED_MODULE_2__timelime__["a" /* default */]();
    this.canvas = canvas;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Animation, [{
    key: "createAnimator",
    value: function createAnimator(element, animation) {
      var duration = animation.duration,
          property = animation.property,
          onFrame = animation.onFrame; // 校验关键参数

      if (!duration || (!property || !property.length) && !onFrame) {
        return;
      }

      return new __WEBPACK_IMPORTED_MODULE_3__animator__["a" /* default */](element, animation);
    }
  }, {
    key: "play",
    value: function play(container, onAnimationEnd) {
      var _this = this;

      var canvas = this.canvas;
      var animators = [];
      var maxDuration = 0;
      var deleteElements = []; // 遍历整个树，找到全部需要动画的元素

      eachElement(container, function (element) {
        // TODO: status 需要提取状态
        var _element$_attrs = element._attrs,
            animation = _element$_attrs.animation,
            status = _element$_attrs.status;

        if (!animation) {
          if (status === __WEBPACK_IMPORTED_MODULE_4__jsx__["a" /* ElementStatus */].ELEMENT_DELETE) {
            // element.remove(true);
            deleteElements.push(element);
          }

          return;
        }

        var animator = _this.createAnimator(element, animation);

        if (animator) {
          maxDuration = Math.max(maxDuration, animator.totalDuration);
          animators.push(animator);
        }

        var clip = animation.clip; // 如果有裁剪区动画，处理裁剪区动画

        if (clip) {
          clip.isClip = true;
          var clipElement = clip.element;

          var _animator = _this.createAnimator(clipElement, clip);

          if (_animator) {
            maxDuration = Math.max(maxDuration, _animator.totalDuration);
            element.attr('clip', clipElement);
            animators.push(_animator);
          }
        }
      });

      for (var i = 0, len = deleteElements.length; i < len; i++) {
        var element = deleteElements[i];
        var children = element._attrs.children; // 因为group的子元素也有可能有动画，所以这里先把叶子节点删除掉，等动画结束后，再把所有删除的元素删除掉

        if (!children || !children.length) {
          element.remove(true);
        }
      } // 开始播放动画


      this.timeline.play(maxDuration, function (time) {
        for (var _i = 0, _len = animators.length; _i < _len; _i++) {
          var animator = animators[_i];
          animator.to(time);
        } // 最后一帧放在end里统一draw， 避免重复draw


        if (time < maxDuration) {
          canvas.draw();
        }
      }, function () {
        for (var _i2 = 0, _len2 = deleteElements.length; _i2 < _len2; _i2++) {
          var _element = deleteElements[_i2];

          _element.remove(true);
        }

        canvas.draw();
        onAnimationEnd && onAnimationEnd();
      });
    } // 直接跳到动画最终态

  }, {
    key: "end",
    value: function end() {
      this.timeline.end();
    }
  }, {
    key: "abort",
    value: function abort() {
      this.timeline.abort();
    }
  }]);

  return Animation;
}();

/* harmony default export */ __webpack_exports__["a"] = (Animation);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(88);



var requestAnimationFrame = (typeof window === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(window)) === 'object' && window.requestAnimationFrame ? window.requestAnimationFrame : function (fn) {
  return setTimeout(fn, 16);
};
var cancelAnimationFrame = (typeof window === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(window)) === 'object' && window.cancelAnimationFrame ? window.cancelAnimationFrame : function (number) {
  return clearTimeout(number);
};
var clock = (typeof performance === "undefined" ? "undefined" : Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(performance)) === 'object' && performance.now ? performance : Date;

var Timeline = /*#__PURE__*/function () {
  function Timeline() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Timeline);

    this.playing = false; // 暂停中

    this.paused = false; // 暂停的时间点

    this.pausedTime = 0;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Timeline, [{
    key: "play",
    value: function play(duration, onUpdate, onEnd) {
      var _this = this;

      if (duration <= 0) {
        onEnd();
        return;
      } // 上次动画未结束


      if (this.playing) {
        return;
      } // 记录 duration、onUpdate、onEnd


      this.duration = duration;
      this.onUpdate = onUpdate;
      this.onEnd = onEnd;
      var paused = this.paused,
          pausedTime = this.pausedTime;
      this.playing = true;
      var startTime = clock.now(); // 如果当前正在暂停状态， 从暂停态继续播放

      if (paused && pausedTime) {
        startTime = startTime - pausedTime;
        this.paused = false;
        this.pausedTime = 0;
      }

      var play = function play() {
        var now = clock.now();
        var time = now - startTime;

        if (time >= duration) {
          onUpdate(duration);
          onEnd();
          _this.playing = false;
          return;
        }

        if (_this.paused) {
          onUpdate(time);
          _this.pausedTime = time;
          _this.playing = false;
          return;
        }

        onUpdate(time);
        _this.animationFrameNumber = requestAnimationFrame(play);
      };

      this.animationFrameNumber = requestAnimationFrame(play);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.playing = false;
    }
  }, {
    key: "end",
    value: function end() {
      if (!this.playing) {
        return;
      } // 停掉动画


      this.abort(); // 更新到最后一帧状态

      this.onUpdate(this.duration);
      this.onEnd();
    }
  }, {
    key: "abort",
    value: function abort() {
      if (!this.animationFrameNumber) {
        return;
      }

      cancelAnimationFrame(this.animationFrameNumber);
      this.playing = false;
      this.animationFrameNumber = null;
    }
  }]);

  return Timeline;
}();

/* harmony default export */ __webpack_exports__["a"] = (Timeline);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interpolate__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__easing__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);








var Animator = /*#__PURE__*/function () {
  function Animator(element, animation) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Animator);

    // 是否是裁剪动画
    this.isClip = false;
    this.end = false;
    this.element = element;
    this.animation = animation;
    var _animation$property = animation.property,
        property = _animation$property === void 0 ? [] : _animation$property,
        easing = animation.easing,
        duration = animation.duration,
        _animation$delay = animation.delay,
        delay = _animation$delay === void 0 ? 0 : _animation$delay,
        start = animation.start,
        end = animation.end,
        onFrame = animation.onFrame,
        isClip = animation.isClip;
    var interpolates = property.map(function (name) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["B" /* isString */])(name)) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__interpolate__["a" /* default */])(start[name], end[name]);
      } // @ts-ignore


      if (name.interpolate) {
        // @ts-ignore
        return name.interpolate(start, end);
      }
    });
    this.easing = typeof easing === 'function' ? easing : __WEBPACK_IMPORTED_MODULE_4__easing__[easing] || __WEBPACK_IMPORTED_MODULE_4__easing__["linear"];
    this.property = property;
    this.interpolates = interpolates;
    this.duration = duration;
    this.delay = delay;
    this.onFrame = onFrame;
    this.totalDuration = duration + delay;
    this.isClip = isClip; // 更新到初始状态

    this.update(0, 0);
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Animator, [{
    key: "to",
    value: function to(time) {
      var duration = this.duration,
          delay = this.delay,
          totalDuration = this.totalDuration,
          easing = this.easing,
          end = this.end; // 已结束

      if (end) {
        return;
      } // 未开始


      if (time <= delay || !duration) {
        return;
      } // 最大为1


      var t = time >= totalDuration ? 1 : (time - delay) / duration;
      this.update(easing(t), time); // 最后一帧

      if (t === 1) {
        this.onEnd();
      }
    }
  }, {
    key: "update",
    value: function update(t, time) {
      var element = this.element,
          interpolates = this.interpolates,
          property = this.property,
          onFrame = this.onFrame;
      var attrs = {};

      for (var i = property.length - 1; i >= 0; i--) {
        var name = property[i];

        if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["B" /* isString */])(name)) {
          attrs[name] = interpolates[i](t);
        } else {
          // @ts-ignore
          attrs[name.name] = interpolates[i](t);
        }
      }

      if (onFrame) {
        attrs = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, attrs), this.onFrame(t, time));
      }

      element.attr(attrs);
    }
  }, {
    key: "onEnd",
    value: function onEnd() {
      var animation = this.animation,
          isClip = this.isClip,
          element = this.element;
      var onEnd = animation.onEnd;
      onEnd && onEnd.call(this);

      if (isClip) {
        // 如果是裁剪区动画，要移除裁剪区
        element.remove(true);
      } // 如果当前元素状态被标记为删除，等动画结束后直接删除


      if (element._attrs.status === __WEBPACK_IMPORTED_MODULE_5__jsx__["a" /* ElementStatus */].ELEMENT_DELETE) {
        element.remove(true);
      } // 清空 不需要重复执行


      element.set('animation', null);
      this.end = true;
    }
  }]);

  return Animator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Animator);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deps_d3_interpolate_src__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interpolateObjectArray__ = __webpack_require__(770);


/* harmony default export */ __webpack_exports__["a"] = (function (a, b) {
  if (typeof b === 'string') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__deps_d3_interpolate_src__["e" /* interpolateRgb */])(a, b);
  }

  if (Array.isArray(b)) {
    if (typeof b[0] !== 'number') {
      // if (hasNaN(a[0])) {
      //   return interpolateObjectArray(b, b);
      // }
      return Object(__WEBPACK_IMPORTED_MODULE_1__interpolateObjectArray__["a" /* default */])(a, b);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__deps_d3_interpolate_src__["c" /* interpolateNumberArray */])(a, b);
  } // if (isNaN(a)) {
  //   return interpolateNumber(b, b);
  // }


  return Object(__WEBPACK_IMPORTED_MODULE_0__deps_d3_interpolate_src__["b" /* interpolateNumber */])(a, b);
});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(276);


 // https://observablehq.com/@mbostock/lab-and-rgb

var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
      x,
      z;
  if (r === g && g === b) x = z = y;else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}
Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function brighter(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function darker(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function rgb() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* degrees */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* radians */];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function brighter(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function darker(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function rgb() {
    return hcl2lab(this).rgb();
  }
}));

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(276);



var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
      // NaN if l=0 or l=1
  h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* degrees */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function brighter(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function darker(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* radians */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
  }
}));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(108);

/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color_js__["c" /* hue */])(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (a, b) {
  return a = +a, b = +b, function (t) {
    return Math.round(a * (1 - t) + b * t);
  };
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(761);



function interpolateTransform(parse, pxComma, pxParen, degParen) {
  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({
        i: i - 4,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)
      }, {
        i: i - 2,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)
      });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path

      q.push({
        i: s.push(pop(s) + "rotate(", null, degParen) - 2,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({
        i: s.push(pop(s) + "skewX(", null, degParen) - 2,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)
      }, {
        i: i - 2,
        x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)
      });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function (a, b) {
    var s = [],
        // string constants and placeholders
    q = []; // number interpolators

    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc

    return function (t) {
      var i = -1,
          n = q.length,
          o;

      while (++i < n) {
        s[(o = q[i]).i] = o.x(t);
      }

      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["b" /* parseSvg */], ", ", ")", ")");

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose_js__ = __webpack_require__(762);

var svgNode;
/* eslint-disable no-undef */

function parseCss(value) {
  var m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */] : Object(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* default */])(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;
var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
/* harmony default export */ __webpack_exports__["a"] = (function (a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

/* unused harmony default export */ var _unused_webpack_default_export = ((function zoomRho(rho, rho2, rho4) {
  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0],
        uy0 = p0[1],
        w0 = p0[2],
        ux1 = p1[0],
        uy1 = p1[1],
        w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S; // Special case for u0 ≅ u1.

    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;

      i = function i(t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };
    } // General case.
    else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;

      i = function i(t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
      };
    }

    i.duration = S * 1000 * rho / Math.SQRT2;
    return i;
  }

  zoom.rho = function (_) {
    var _1 = Math.max(1e-3, +_),
        _2 = _1 * _1,
        _4 = _2 * _2;

    return zoomRho(_1, _2, _4);
  };

  return zoom;
})(Math.SQRT2, 2, 4));

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__d3_color_src__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(108);



function hsl(hue) {
  return function (start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + '';
    };
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__d3_color_src__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(108);


function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
  return function (t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + '';
  };
}

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__d3_color_src__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(108);



function hcl(hue) {
  return function (start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + '';
    };
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__d3_color_src__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(108);



function cubehelix(hue) {
  return function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0__d3_color_src__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + '';
      };
    }

    cubehelix.gamma = cubehelixGamma;
    return cubehelix;
  }(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(143);

function piecewise(interpolate, values) {
  if (values === undefined) values = interpolate, interpolate = __WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */];
  var i = 0,
      n = values.length - 1,
      v = values[0],
      I = new Array(n < 0 ? 0 : n);

  while (i < n) {
    I[i] = interpolate(v, v = values[++i]);
  }

  return function (t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (interpolator, n) {
  var samples = new Array(n);

  for (var i = 0; i < n; ++i) {
    samples[i] = interpolator(i / (n - 1));
  }

  return samples;
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deps_d3_interpolate_src__ = __webpack_require__(182);


function interpolateObjectArray(a, b) {
  var na = a ? a.length : 0;
  var nb = b ? b.length : 0;
  var maxLen = Math.max(nb, na);
  var c = new Array(maxLen);
  var x = new Array(maxLen);
  var i; // 将a、b长度补齐后再进行插值计算

  for (i = 0; i < maxLen; i++) {
    var ia = i < na ? (a || [])[i] : (a || [])[na - 1];
    var ib = i < nb ? (b || [])[i] : (b || [])[nb - 1];
    x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__deps_d3_interpolate_src__["d" /* interpolateObject */])(ia, ib);
  }

  return function (t) {
    // 清除补间的多余点
    if (t >= 1) {
      return b;
    }

    for (i = 0; i < maxLen; ++i) {
      c[i] = x[i](t);
    }

    return c;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (interpolateObjectArray);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quadraticIn", function() { return quadraticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quadraticOut", function() { return quadraticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quadraticInOut", function() { return quadraticInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cubicIn", function() { return cubicIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cubicOut", function() { return cubicOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cubicInOut", function() { return cubicInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quarticIn", function() { return quarticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quarticOut", function() { return quarticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quarticInOut", function() { return quarticInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elasticIn", function() { return elasticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elasticOut", function() { return elasticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elasticInOut", function() { return elasticInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backIn", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backOut", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backInOut", function() { return backInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bounceIn", function() { return bounceIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bounceOut", function() { return bounceOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bounceInOut", function() { return bounceInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exponentialIn", function() { return exponentialIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exponentialOut", function() { return exponentialOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quinticIn", function() { return quinticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quinticOut", function() { return quinticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quinticInOut", function() { return quinticInOut; });
// https://github.com/tweenjs/tween.js
function linear(k) {
  return k;
}

function quadraticIn(k) {
  return k * k;
}

function quadraticOut(k) {
  return k * (2 - k);
}

function quadraticInOut(k) {
  if ((k *= 2) < 1) {
    return 0.5 * k * k;
  }

  return -0.5 * (--k * (k - 2) - 1);
}

function cubicIn(k) {
  return k * k * k;
}

function cubicOut(k) {
  return --k * k * k + 1;
}

function cubicInOut(k) {
  if ((k *= 2) < 1) {
    return 0.5 * k * k * k;
  }

  return 0.5 * ((k -= 2) * k * k + 2);
}

function quarticIn(k) {
  return k * k * k * k;
}

function quarticOut(k) {
  return 1 - k * k * k * k;
}

function quarticInOut(k) {
  if ((k *= 2) < 1) {
    return 0.5 * k * k * k * k;
  }

  return -0.5 * ((k -= 2) * k * k * k - 2);
}

function quinticIn(k) {
  return k * k * k * k * k;
}

function quinticOut(k) {
  return --k * k * k * k * k + 1;
}

function quinticInOut(k) {
  if ((k *= 2) < 1) {
    return 0.5 * k * k * k * k * k;
  }

  return 0.5 * ((k -= 2) * k * k * k * k + 2);
}

function exponentialIn(k) {
  return k === 0 ? 0 : Math.pow(1024, k - 1);
}

function exponentialOut(k) {
  return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
}

function elasticIn(k) {
  var s;
  var a = 0.1;
  var p = 0.4;
  if (k === 0) return 0;
  if (k === 1) return 1;

  if (!p) {
    p = 0.3;
  }

  if (!a || a < 1) {
    a = 1;
    s = p / 4;
  } else {
    s = p / (2 * Math.PI) * Math.asin(1 / a);
  }

  return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
}

function elasticOut(k) {
  var s;
  var a = 0.1;
  var p = 0.4;
  if (k === 0) return 0;
  if (k === 1) return 1;

  if (!p) {
    p = 0.3;
  }

  if (!a || a < 1) {
    a = 1;
    s = p / 4;
  } else {
    s = p / (2 * Math.PI) * Math.asin(1 / a);
  }

  return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
}

function elasticInOut(k) {
  var s;
  var a = 0.1;
  var p = 0.4;
  if (k === 0) return 0;
  if (k === 1) return 1;

  if (!p) {
    p = 0.3;
  }

  if (!a || a < 1) {
    a = 1;
    s = p / 4;
  } else {
    s = p / (2 * Math.PI) * Math.asin(1 / a);
  }

  if ((k *= 2) < 1) {
    return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
  }

  return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
}

function backIn(k) {
  var s = 1.70158;
  return k * k * ((s + 1) * k - s);
}

function backOut(k) {
  var s = 1.70158;
  return (k = k - 1) * k * ((s + 1) * k + s) + 1;
}

function backInOut(k) {
  var s = 1.70158 * 1.525;

  if ((k *= 2) < 1) {
    return 0.5 * (k * k * ((s + 1) * k - s));
  }

  return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
}

function bounceIn(k) {
  return 1 - bounceOut(1 - k);
}

function bounceOut(k) {
  if ((k /= 1) < 1 / 2.75) {
    return 7.5625 * k * k;
  } else if (k < 2 / 2.75) {
    return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
  } else if (k < 2.5 / 2.75) {
    return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
  }

  return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
}

function bounceInOut(k) {
  if (k < 0.5) {
    return bounceIn(k * 2) * 0.5;
  }

  return bounceOut(k * 2 - 1) * 0.5 + 0.5;
}



/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_equal__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__children__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controller_layout__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__controller_coord__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controller_scale__ = __webpack_require__(777);










 // types



 // 统计图表

var Chart = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Chart, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Chart);

  function Chart(props, context, updater) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Chart);

    _this = _super.call(this, props, context, updater);
    _this.componentsPosition = [];
    var data = props.data,
        coordOption = props.coord,
        _props$scale = props.scale,
        scale = _props$scale === void 0 ? [] : _props$scale;
    _this.layoutController = new __WEBPACK_IMPORTED_MODULE_11__controller_layout__["a" /* default */]();
    _this.coordController = new __WEBPACK_IMPORTED_MODULE_12__controller_coord__["a" /* default */]();
    _this.scaleController = new __WEBPACK_IMPORTED_MODULE_13__controller_scale__["a" /* default */](data);
    _this.scale = _this.scaleController;

    var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
        layoutController = _assertThisInitialize.layoutController,
        coordController = _assertThisInitialize.coordController,
        scaleController = _assertThisInitialize.scaleController; // 布局


    var style = _this.getStyle(props, context);

    _this.layout = layoutController.create(style); // 坐标系

    _this.coord = coordController.create(coordOption, _this.layout); // scale

    scaleController.create(scale);
    _this.data = data; // state

    _this.state = {
      filters: {}
    };
    return _this;
  } // props 更新


  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Chart, [{
    key: "willReceiveProps",
    value: function willReceiveProps(nextProps, context) {
      var layoutController = this.layoutController,
          coordController = this.coordController,
          scaleController = this.scaleController,
          lastProps = this.props;
      var nextStyle = nextProps.style,
          nextData = nextProps.data,
          nextScale = nextProps.scale;
      var lastStyle = lastProps.style,
          lastData = lastProps.data,
          lastScale = lastProps.scale; // 布局

      if (!Object(__WEBPACK_IMPORTED_MODULE_9__base_equal__["a" /* default */])(nextStyle, lastStyle) || context !== this.context) {
        var style = this.getStyle(nextProps, context);
        this.layout = layoutController.create(style);
        coordController.updateLayout(this.layout);
      }

      if (nextData !== lastData) {
        scaleController.changeData(nextData);
      } // scale


      if (!Object(__WEBPACK_IMPORTED_MODULE_9__base_equal__["a" /* default */])(nextScale, lastScale)) {
        scaleController.update(nextScale);
      }
    }
  }, {
    key: "willUpdate",
    value: function willUpdate() {
      var coordController = this.coordController,
          props = this.props; // render 时要重置 coord 范围，重置后需要让所有子组件都重新render
      // 所以这里不比较是否有差异，每次都新建，让所有子组件重新render

      this.coord = coordController.create(props.coord, this.layout);
    }
  }, {
    key: "getStyle",
    value: function getStyle(props, context) {
      var theme = context.theme,
          px2hd = context.px2hd,
          left = context.left,
          top = context.top,
          width = context.width,
          height = context.height;
      var style = props.style;
      return px2hd(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        left: left,
        top: top,
        width: width,
        height: height
      }, theme.chart), style));
    } // 给需要显示的组件留空

  }, {
    key: "layoutCoord",
    value: function layoutCoord(layout) {
      var coord = this.coord;
      var position = layout.position,
          boxWidth = layout.width,
          boxHeight = layout.height;
      var left = coord.left,
          top = coord.top,
          width = coord.width,
          height = coord.height;

      switch (position) {
        case 'left':
          left += boxWidth;
          width = Math.max(0, width - boxWidth);
          break;

        case 'right':
          width = Math.max(0, width - boxWidth);
          break;

        case 'top':
          top += boxHeight;
          height = Math.max(0, height - boxHeight);
          break;

        case 'bottom':
          height = Math.max(0, height - boxHeight);
          break;
      }

      coord.update({
        left: left,
        top: top,
        width: width,
        height: height
      });
    }
  }, {
    key: "resetCoordLayout",
    value: function resetCoordLayout() {
      var coord = this.coord,
          layout = this.layout;
      coord.update(layout);
    }
  }, {
    key: "updateCoordLayout",
    value: function updateCoordLayout(layout) {
      var _this2 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["r" /* isArray */])(layout)) {
        layout.forEach(function (item) {
          _this2.layoutCoord(item);
        });
        return;
      }

      this.layoutCoord(layout);
    }
  }, {
    key: "updateCoordFor",
    value: function updateCoordFor(component, layout) {
      var _this3 = this;

      if (!layout) return;
      var componentsPosition = this.componentsPosition;
      var componentPosition = {
        component: component,
        layout: layout
      };
      var existIndex = Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["h" /* findIndex */])(componentsPosition, function (item) {
        return item.component === component;
      }); // 说明是已经存在的组件

      if (existIndex > -1) {
        componentsPosition.splice(existIndex, 1, componentPosition); // 先重置，然后整体重新算一次

        this.resetCoordLayout();
        componentsPosition.forEach(function (componentPosition) {
          var layout = componentPosition.layout;

          _this3.updateCoordLayout(layout);
        });
        return;
      } // 是新组件，直接添加


      componentsPosition.push(componentPosition);
      this.updateCoordLayout(layout);
    }
  }, {
    key: "getGeometrys",
    value: function getGeometrys() {
      var children = this.children;
      var geometrys = []; // @ts-ignore

      __WEBPACK_IMPORTED_MODULE_10__children__["a" /* default */].toArray(children).forEach(function (element) {
        if (!element) return false;
        var component = element.component;

        if (component && component.isGeometry) {
          geometrys.push(component);
        }
      });
      return geometrys;
    }
    /**
     * calculate dataset's position on canvas
     * @param  {Object} record the dataset
     * @return {Object} return the position
     */

  }, {
    key: "getPosition",
    value: function getPosition(record) {
      var coord = this.getCoord();
      var xScale = this.getXScales()[0];
      var xField = xScale.field;
      var yScales = this.getYScales(); // default first

      var yScale = yScales[0];
      var yField = yScale.field;

      for (var i = 0, len = yScales.length; i < len; i++) {
        var scale = yScales[i];
        var field = scale.field;

        if (record[field]) {
          yScale = scale;
          yField = field;
          break;
        }
      }

      var x = xScale.scale(record[xField]);
      var y = yScale.scale(record[yField]);
      return coord.convertPoint({
        x: x,
        y: y
      });
    }
  }, {
    key: "getSnapRecords",
    value: function getSnapRecords(point, inCoordRange) {
      var geometrys = this.getGeometrys();
      if (!geometrys.length) return; // @ts-ignore

      return geometrys[0].getSnapRecords(point, inCoordRange);
    }
  }, {
    key: "getLegendItems",
    value: function getLegendItems(point) {
      var geometrys = this.getGeometrys();
      if (!geometrys.length) return; // @ts-ignore

      return geometrys[0].getLegendItems(point);
    }
  }, {
    key: "setScale",
    value: function setScale(field, option) {
      this.scaleController.setScale(field, option);
    }
  }, {
    key: "getScale",
    value: function getScale(field) {
      return this.scaleController.getScale(field);
    }
  }, {
    key: "getScales",
    value: function getScales() {
      return this.scaleController.getScales();
    }
  }, {
    key: "getXScales",
    value: function getXScales() {
      var geometrys = this.getGeometrys();
      return geometrys.map(function (component) {
        // @ts-ignore
        return component.getXScale();
      });
    }
  }, {
    key: "getYScales",
    value: function getYScales() {
      var geometrys = this.getGeometrys();
      return geometrys.map(function (component) {
        // @ts-ignore
        return component.getYScale();
      });
    }
  }, {
    key: "getCoord",
    value: function getCoord() {
      return this.coord;
    }
  }, {
    key: "filter",
    value: function filter(field, condition) {
      var filters = this.state.filters;
      this.setState({
        filters: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, filters), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, field, condition))
      });
    }
  }, {
    key: "_getRenderData",
    value: function _getRenderData() {
      var props = this.props,
          state = this.state;
      var data = props.data;
      var filters = state.filters;

      if (!filters || !Object.keys(filters).length) {
        return data;
      }

      var filteredData = data;
      Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["e" /* each */])(filters, function (condition, field) {
        if (!condition) return;
        filteredData = filteredData.filter(function (record) {
          return condition(record[field], record);
        });
      });
      return filteredData;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props,
          layout = this.layout,
          coord = this.coord;
      var children = props.children,
          originData = props.data;
      if (!originData) return null;

      var data = this._getRenderData();

      return __WEBPACK_IMPORTED_MODULE_10__children__["a" /* default */].map(children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_10__children__["a" /* default */].cloneElement(child, {
          chart: _this4,
          coord: coord,
          data: data,
          layout: layout
        });
      });
    }
  }]);

  return Chart;
}(__WEBPACK_IMPORTED_MODULE_8__base_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Chart);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_layout__ = __webpack_require__(180);





var LayoutController = /*#__PURE__*/function () {
  function LayoutController() {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LayoutController);
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(LayoutController, [{
    key: "getRectRange",
    value: function getRectRange(style) {
      var left = style.left,
          top = style.top,
          width = style.width,
          height = style.height,
          padding = style.padding;

      var _padding = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(padding, 4),
          paddingTop = _padding[0],
          paddingRight = _padding[1],
          paddingBottom = _padding[2],
          paddingLeft = _padding[3];

      return {
        left: left + paddingLeft,
        top: top + paddingTop,
        width: width - paddingLeft - paddingRight,
        height: height - paddingTop - paddingBottom
      };
    }
  }, {
    key: "create",
    value: function create(style) {
      var rectRange = this.getRectRange(style);
      var layout = new __WEBPACK_IMPORTED_MODULE_3__base_layout__["a" /* default */](rectRange);
      this.layout = layout;
      return layout;
    }
  }, {
    key: "update",
    value: function update(style) {
      var rectRange = this.getRectRange(style);
      var layout = this.layout;
      layout.update(rectRange);
      return layout;
    }
  }]);

  return LayoutController;
}();

/* harmony default export */ __webpack_exports__["a"] = (LayoutController);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__rect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__polar__["a"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__base__["a" /* default */]);


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base__ = __webpack_require__(188);








var Rect = /*#__PURE__*/function (_Base) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Rect, _Base);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Rect);

  function Rect() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Rect);

    _this = _super.apply(this, arguments);
    _this.type = 'rect';
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Rect, [{
    key: "update",
    value: function update(option) {
      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Rect.prototype), "update", this).call(this, option);

      var left = this.left,
          top = this.top,
          right = this.right,
          bottom = this.bottom;
      var x = [left, right];
      var y = [bottom, top];
      this.x = x;
      this.y = y;
      return this;
    }
  }]);

  return Rect;
}(__WEBPACK_IMPORTED_MODULE_6__base__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Rect);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__antv_f2_graphic__ = __webpack_require__(105);










var Polar = /*#__PURE__*/function (_Base) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Polar, _Base);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Polar);

  function Polar() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Polar);

    _this = _super.apply(this, arguments);
    _this.type = 'polar';
    _this.isPolar = true;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Polar, [{
    key: "update",
    value: function update(option) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Polar.prototype), "update", this).call(this, option);

      if (!this.option) {
        this.option = option;
      }

      var _this$option = this.option,
          _this$option$radius = _this$option.radius,
          radiusRatio = _this$option$radius === void 0 ? 1 : _this$option$radius,
          _this$option$innerRad = _this$option.innerRadius,
          innerRadiusRatio = _this$option$innerRad === void 0 ? 0 : _this$option$innerRad;
      var width = this.width,
          height = this.height,
          _this$startAngle = this.startAngle,
          startAngle = _this$startAngle === void 0 ? -Math.PI / 2 : _this$startAngle,
          _this$endAngle = this.endAngle,
          endAngle = _this$endAngle === void 0 ? Math.PI * 3 / 2 : _this$endAngle; // 半径取宽高的最小值

      var radius = radiusRatio * (Math.min(width, height) / 2); // 极坐标下 x 表示弧度， y 代表 半径

      var x = [startAngle, endAngle];
      var y = [innerRadiusRatio * radius, radius];
      this.x = x;
      this.y = y;
      this.startAngle = startAngle;
      this.endAngle = endAngle;
      this.radius = radius;
      this.innnerRadius = innerRadiusRatio * radius;
      return this;
    }
  }, {
    key: "isCyclic",
    value: function isCyclic() {
      var startAngle = this.startAngle,
          endAngle = this.endAngle;

      if (endAngle - startAngle < Math.PI * 2) {
        return false;
      }

      return true;
    }
  }, {
    key: "convertPoint",
    value: function convertPoint(point) {
      var center = this.center,
          transposed = this.transposed,
          x = this.x,
          y = this.y;
      var xDim = transposed ? 'y' : 'x';
      var yDim = transposed ? 'x' : 'y';

      var _x = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(x, 2),
          xStart = _x[0],
          xEnd = _x[1];

      var _y = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(y, 2),
          yStart = _y[0],
          yEnd = _y[1];

      var angle = xStart + (xEnd - xStart) * point[xDim];
      var radius = yStart + (yEnd - yStart) * point[yDim];
      return {
        x: center.x + Math.cos(angle) * radius,
        y: center.y + Math.sin(angle) * radius
      };
    }
  }, {
    key: "invertPoint",
    value: function invertPoint(point) {
      var center = this.center,
          transposed = this.transposed,
          x = this.x,
          y = this.y;
      var xDim = transposed ? 'y' : 'x';
      var yDim = transposed ? 'x' : 'y';

      var _x2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(x, 2),
          xStart = _x2[0],
          xEnd = _x2[1];

      var _y2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(y, 2),
          yStart = _y2[0],
          yEnd = _y2[1];

      var m = [1, 0, 0, 1, 0, 0];
      __WEBPACK_IMPORTED_MODULE_8__antv_f2_graphic__["b" /* Matrix */].rotate(m, m, xStart);
      var startV = [1, 0];
      __WEBPACK_IMPORTED_MODULE_8__antv_f2_graphic__["e" /* Vector2 */].transformMat2d(startV, startV, m);
      startV = [startV[0], startV[1]];
      var pointV = [point.x - center.x, point.y - center.y];

      if (__WEBPACK_IMPORTED_MODULE_8__antv_f2_graphic__["e" /* Vector2 */].zero(pointV)) {
        return {
          x: 0,
          y: 0
        };
      }

      var theta = __WEBPACK_IMPORTED_MODULE_8__antv_f2_graphic__["e" /* Vector2 */].angleTo(startV, pointV, xEnd < xStart);

      if (Math.abs(theta - Math.PI * 2) < 0.001) {
        theta = 0;
      }

      var l = __WEBPACK_IMPORTED_MODULE_8__antv_f2_graphic__["e" /* Vector2 */].length(pointV);
      var percentX = theta / (xEnd - xStart);
      percentX = xEnd - xStart > 0 ? percentX : -percentX;
      var percentY = (l - yStart) / (yEnd - yStart);
      var rst = {};
      rst[xDim] = percentX;
      rst[yDim] = percentY;
      return rst;
    }
  }]);

  return Polar;
}(__WEBPACK_IMPORTED_MODULE_7__base__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Polar);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_scale__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scale_cat_tick__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scale_linear_tick__ = __webpack_require__(799);






 // 覆盖0.3.x的 cat 方法

Object(__WEBPACK_IMPORTED_MODULE_3__antv_scale__["f" /* registerTickMethod */])('cat', __WEBPACK_IMPORTED_MODULE_5__scale_cat_tick__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_3__antv_scale__["f" /* registerTickMethod */])('time-cat', __WEBPACK_IMPORTED_MODULE_5__scale_cat_tick__["a" /* default */]); // 覆盖linear 度量的tick算法

Object(__WEBPACK_IMPORTED_MODULE_3__antv_scale__["f" /* registerTickMethod */])('wilkinson-extended', __WEBPACK_IMPORTED_MODULE_6__scale_linear_tick__["a" /* default */]);

var ScaleController = /*#__PURE__*/function () {
  function ScaleController(data) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScaleController);

    this.data = data;
    this.options = {};
    this.scales = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScaleController, [{
    key: "_getType",
    value: function _getType(option) {
      var type = option.type,
          values = option.values,
          field = option.field;

      if (type) {
        return type;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["x" /* isNumber */])(field) || Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["w" /* isNil */])(values[0]) && field) {
        return 'identity';
      }

      if (typeof values[0] === 'number') {
        return 'linear';
      }

      return 'cat';
    }
  }, {
    key: "_getOption",
    value: function _getOption(option) {
      var values = option.values,
          field = option.field,
          justifyContent = option.justifyContent;

      var type = this._getType(option);

      option.type = type; // identity

      if (type === 'identity') {
        option.field = field.toString();
        option.values = [field];
        return option;
      } // linear 类型


      if (type === 'linear') {
        // 设置默认nice
        if (typeof option.nice !== 'boolean') {
          option.nice = true;
        } // 重置最大最小


        var _getRange = Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["l" /* getRange */])(values),
            min = _getRange.min,
            max = _getRange.max;

        if (Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["w" /* isNil */])(option.min)) {
          option.min = min;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["w" /* isNil */])(option.max)) {
          option.max = max;
        }

        option.values = values.sort(function (a, b) {
          return a - b;
        });
        return option;
      } // 分类类型和 timeCat 类型，调整 range


      if (type === 'cat' || type === 'timeCat') {
        if (option.range) {
          return option;
        }

        var count = values.length;
        var range = [0, 1]; // 如果只有一项，显示在中间

        if (count === 1) {
          range = [0.5, 1];
        } else if (justifyContent) {
          // 居中
          var offset = 1 / count * 0.5;
          range = [offset, 1 - offset];
        } else {
          // 最后留 1 / count
          var _offset = 1 / count;

          range = [0, 1 - _offset];
        }

        option.range = range;
      }

      return option;
    }
  }, {
    key: "createScale",
    value: function createScale(option) {
      var type = option.type;

      if (Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["v" /* isFunction */])(type)) {
        return new type(option);
      }

      var ScaleClass = Object(__WEBPACK_IMPORTED_MODULE_3__antv_scale__["d" /* getScale */])(type);
      return new ScaleClass(option);
    } // 更新或创建scale

  }, {
    key: "setScale",
    value: function setScale(field, option) {
      var options = this.options,
          scales = this.scales;
      options[field] = Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["G" /* mix */])({}, options[field], option); // 如果scale有更新，scale 也需要重新创建

      if (scales[field]) {
        delete scales[field];
      }
    }
  }, {
    key: "create",
    value: function create(options) {
      this.update(options);
    }
  }, {
    key: "update",
    value: function update(options) {
      var _this = this;

      if (!options) return;
      Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["e" /* each */])(options, function (option, field) {
        _this.setScale(field, option);
      }); // 为了让外部感知到scale有变化

      this.scales = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, this.scales);
    }
  }, {
    key: "changeData",
    value: function changeData(data) {
      this.data = data;
      this.scales = {};
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getScale",
    value: function getScale(field) {
      var scales = this.scales,
          options = this.options,
          data = this.data;
      var scale = scales[field];

      if (scale) {
        return scale;
      }

      var option = options[field];

      if (!option) {
        return null;
      }

      var values = option.values ? option.values : data ? Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["M" /* valuesOfKey */])(data, field) : [];

      var scaleOption = this._getOption(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, option), {}, {
        field: field,
        values: values
      }));

      var newScale = this.createScale(scaleOption);
      scales[field] = newScale;
      return newScale;
    }
  }, {
    key: "getScales",
    value: function getScales() {
      var _this2 = this;

      var options = this.options,
          scales = this.scales;
      Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["e" /* each */])(options, function (option, field) {
        _this2.getScale(field);
      });
      return scales;
    }
  }, {
    key: "adjustStartZero",
    value: function adjustStartZero(scale) {
      var options = this.options;
      var field = scale.field,
          min = scale.min,
          max = scale.max;
      var option = options[field]; // 如果有定义，则不处理

      if (option && option.min) {
        return;
      }

      if (min > 0) {
        scale.change({
          min: 0
        });
      } else if (max < 0) {
        scale.change({
          max: 0
        });
      }
    } // 饼图下的scale调整

  }, {
    key: "adjustPieScale",
    value: function adjustPieScale(scale) {
      var options = this.options;
      var field = scale.field;
      var option = options[field];

      if (option && !Object(__WEBPACK_IMPORTED_MODULE_4__antv_util__["w" /* isNil */])(option.nice)) {
        return null;
      }

      scale.change({
        nice: false
      });
    } // 获取scale 在 0点对位置的值

  }, {
    key: "getZeroValue",
    value: function getZeroValue(scale) {
      var min = scale.min,
          max = scale.max;
      var value;

      if (min >= 0) {
        value = min;
      } else if (max <= 0) {
        value = max;
      } else {
        value = 0;
      }

      return scale.scale(value);
    }
  }]);

  return ScaleController;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScaleController);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_time__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(285);




/**
 * 时间分类度量
 * @class
 */
var TimeCat = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TimeCat, _super);
    function TimeCat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'timeCat';
        return _this;
    }
    /**
     * @override
     */
    TimeCat.prototype.translate = function (value) {
        value = Object(__WEBPACK_IMPORTED_MODULE_2__util_time__["i" /* toTimeStamp */])(value);
        var index = this.values.indexOf(value);
        if (index === -1) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(value) && value < this.values.length) {
                index = value;
            }
            else {
                index = NaN;
            }
        }
        return index;
    };
    /**
     * 由于时间类型数据需要转换一下，所以复写 getText
     * @override
     */
    TimeCat.prototype.getText = function (value, tickIndex) {
        var index = this.translate(value);
        if (index > -1) {
            var result = this.values[index];
            var formatter = this.formatter;
            result = formatter ? formatter(result, tickIndex) : Object(__WEBPACK_IMPORTED_MODULE_2__util_time__["h" /* timeFormat */])(result, this.mask);
            return result;
        }
        return value;
    };
    TimeCat.prototype.initCfg = function () {
        this.tickMethod = 'time-cat';
        this.mask = 'YYYY-MM-DD';
        this.tickCount = 7; // 一般时间数据会显示 7， 14， 30 天的数字
    };
    TimeCat.prototype.setDomain = function () {
        var values = this.values;
        // 针对时间分类类型，会将时间统一转换为时间戳
        Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */])(values, function (v, i) {
            values[i] = Object(__WEBPACK_IMPORTED_MODULE_2__util_time__["i" /* toTimeStamp */])(v);
        });
        values.sort(function (v1, v2) {
            return v1 - v2;
        });
        _super.prototype.setDomain.call(this);
    };
    return TimeCat;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (TimeCat);
//# sourceMappingURL=time.js.map

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);

/**
 * 二分右侧查找
 * https://github.com/d3/d3-array/blob/master/src/bisector.js
 */
/* harmony default export */ __webpack_exports__["a"] = (function (getter) {
    /**
     * x: 目标值
     * lo: 起始位置
     * hi: 结束位置
     */
    return function (a, x, _lo, _hi) {
        var lo = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(_lo) ? 0 : _lo;
        var hi = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(_hi) ? a.length : _hi;
        while (lo < hi) {
            var mid = (lo + hi) >>> 1;
            if (getter(a[mid]) > x) {
                hi = mid;
            }
            else {
                lo = mid + 1;
            }
        }
        return lo;
    };
});
//# sourceMappingURL=bisector.js.map

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_math__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(146);



/**
 * Log 度量，处理非均匀分布
 */
var Log = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Log, _super);
    function Log() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        return _this;
    }
    /**
     * @override
     */
    Log.prototype.invert = function (value) {
        var base = this.base;
        var max = Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, this.max);
        var rangeMin = this.rangeMin();
        var range = this.rangeMax() - rangeMin;
        var min;
        var positiveMin = this.positiveMin;
        if (positiveMin) {
            if (value === 0) {
                return 0;
            }
            min = Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, positiveMin / base);
            var appendPercent = (1 / (max - min)) * range; // 0 到 positiveMin的占比
            if (value < appendPercent) {
                // 落到 0 - positiveMin 之间
                return (value / appendPercent) * positiveMin;
            }
        }
        else {
            min = Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, this.min);
        }
        var percent = (value - rangeMin) / range;
        var tmp = percent * (max - min) + min;
        return Math.pow(base, tmp);
    };
    Log.prototype.initCfg = function () {
        this.tickMethod = 'log';
        this.base = 10;
        this.tickCount = 6;
        this.nice = true;
    };
    // 设置
    Log.prototype.setDomain = function () {
        _super.prototype.setDomain.call(this);
        var min = this.min;
        if (min < 0) {
            throw new Error('When you use log scale, the minimum value must be greater than zero!');
        }
        if (min === 0) {
            this.positiveMin = Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["b" /* getLogPositiveMin */])(this.values, this.base, this.max);
        }
    };
    // 根据当前值获取占比
    Log.prototype.getScalePercent = function (value) {
        var max = this.max;
        var min = this.min;
        if (max === min) {
            return 0;
        }
        // 如果值小于等于0，则按照0处理
        if (value <= 0) {
            return 0;
        }
        var base = this.base;
        var positiveMin = this.positiveMin;
        // 如果min == 0, 则根据比0大的最小值，计算比例关系。这个最小值作为坐标轴上的第二个tick，第一个是0但是不显示
        if (positiveMin) {
            min = (positiveMin * 1) / base;
        }
        var percent;
        // 如果数值小于次小值，那么就计算 value / 次小值 占整体的比例
        if (value < positiveMin) {
            percent = value / positiveMin / (Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, max) - Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, min));
        }
        else {
            percent = (Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, value) - Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, min)) / (Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, max) - Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["c" /* log */])(base, min));
        }
        return percent;
    };
    return Log;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Log);
//# sourceMappingURL=log.js.map

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_math__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(146);



/**
 * Pow 度量，处理非均匀分布
 */
var Pow = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Pow, _super);
    function Pow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'pow';
        return _this;
    }
    /**
     * @override
     */
    Pow.prototype.invert = function (value) {
        var percent = this.getInvertPercent(value);
        var exponent = this.exponent;
        var max = Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["a" /* calBase */])(exponent, this.max);
        var min = Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["a" /* calBase */])(exponent, this.min);
        var tmp = percent * (max - min) + min;
        var factor = tmp >= 0 ? 1 : -1;
        return Math.pow(tmp, exponent) * factor;
    };
    Pow.prototype.initCfg = function () {
        this.tickMethod = 'pow';
        this.exponent = 2;
        this.tickCount = 5;
        this.nice = true;
    };
    // 获取度量计算时，value占的定义域百分比
    Pow.prototype.getScalePercent = function (value) {
        var max = this.max;
        var min = this.min;
        if (max === min) {
            return 0;
        }
        var exponent = this.exponent;
        var percent = (Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["a" /* calBase */])(exponent, value) - Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["a" /* calBase */])(exponent, min)) / (Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["a" /* calBase */])(exponent, max) - Object(__WEBPACK_IMPORTED_MODULE_1__util_math__["a" /* calBase */])(exponent, min));
        return percent;
    };
    return Pow;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Pow);
//# sourceMappingURL=pow.js.map

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_time__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linear__ = __webpack_require__(287);




/**
 * 时间度量
 * @class
 */
var Time = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'time';
        return _this;
    }
    /**
     * @override
     */
    Time.prototype.getText = function (value, index) {
        var numberValue = this.translate(value);
        var formatter = this.formatter;
        return formatter ? formatter(numberValue, index) : Object(__WEBPACK_IMPORTED_MODULE_2__util_time__["h" /* timeFormat */])(numberValue, this.mask);
    };
    /**
     * @override
     */
    Time.prototype.scale = function (value) {
        var v = value;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["B" /* isString */])(v) || Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["t" /* isDate */])(v)) {
            v = this.translate(v);
        }
        return _super.prototype.scale.call(this, v);
    };
    /**
     * 将时间转换成数字
     * @override
     */
    Time.prototype.translate = function (v) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_time__["i" /* toTimeStamp */])(v);
    };
    Time.prototype.initCfg = function () {
        this.tickMethod = 'time-pretty';
        this.mask = 'YYYY-MM-DD';
        this.tickCount = 7;
        this.nice = false;
    };
    Time.prototype.setDomain = function () {
        var values = this.values;
        // 是否设置了 min, max，而不是直接取 this.min, this.max
        var minConfig = this.getConfig('min');
        var maxConfig = this.getConfig('max');
        // 如果设置了 min,max 则转换成时间戳
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(minConfig) || !Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(minConfig)) {
            this.min = this.translate(this.min);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(maxConfig) || !Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(maxConfig)) {
            this.max = this.translate(this.max);
        }
        // 没有设置 min, max 时
        if (values && values.length) {
            // 重新计算最大最小值
            var timeStamps_1 = [];
            var min_1 = Infinity; // 最小值
            var secondMin_1 = min_1; // 次小值
            var max_1 = 0;
            // 使用一个循环，计算min,max,secondMin
            Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */])(values, function (v) {
                var timeStamp = Object(__WEBPACK_IMPORTED_MODULE_2__util_time__["i" /* toTimeStamp */])(v);
                if (isNaN(timeStamp)) {
                    throw new TypeError("Invalid Time: " + v + " in time scale!");
                }
                if (min_1 > timeStamp) {
                    secondMin_1 = min_1;
                    min_1 = timeStamp;
                }
                else if (secondMin_1 > timeStamp) {
                    secondMin_1 = timeStamp;
                }
                if (max_1 < timeStamp) {
                    max_1 = timeStamp;
                }
                timeStamps_1.push(timeStamp);
            });
            // 存在多个值时，设置最小间距
            if (values.length > 1) {
                this.minTickInterval = secondMin_1 - min_1;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(minConfig)) {
                this.min = min_1;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(maxConfig)) {
                this.max = max_1;
            }
        }
    };
    return Time;
}(__WEBPACK_IMPORTED_MODULE_3__linear__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Time);
//# sourceMappingURL=time.js.map

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quantize__ = __webpack_require__(288);


var Quantile = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Quantile, _super);
    function Quantile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'quantile';
        return _this;
    }
    Quantile.prototype.initCfg = function () {
        this.tickMethod = 'quantile';
        this.tickCount = 5;
        this.nice = true;
    };
    return Quantile;
}(__WEBPACK_IMPORTED_MODULE_1__quantize__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Quantile);
//# sourceMappingURL=quantile.js.map

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return registerClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(124);
/* unused harmony reexport Scale */

var map = {};
function getClass(key) {
    return map[key];
}
function registerClass(key, cls) {
    if (getClass(key)) {
        throw new Error("type '" + key + "' existed.");
    }
    map[key] = cls;
}

//# sourceMappingURL=factory.js.map

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(124);



/**
 * identity scale原则上是定义域和值域一致，scale/invert方法也是一致的
 * 参考R的实现：https://github.com/r-lib/scales/blob/master/R/pal-identity.r
 * 参考d3的实现（做了下转型）：https://github.com/d3/d3-scale/blob/master/src/identity.js
 */
var Identity = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Identity, _super);
    function Identity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'identity';
        _this.isIdentity = true;
        return _this;
    }
    Identity.prototype.calculateTicks = function () {
        return this.values;
    };
    Identity.prototype.scale = function (value) {
        // 如果传入的值不等于 identity 的值，则直接返回，用于一维图时的 dodge
        if (this.values[0] !== value && Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["x" /* isNumber */])(value)) {
            return value;
        }
        return this.range[0];
    };
    Identity.prototype.invert = function (value) {
        var range = this.range;
        if (value < range[0] || value > range[1]) {
            return NaN;
        }
        return this.values[0];
    };
    return Identity;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Identity);
//# sourceMappingURL=index.js.map

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cat__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__d3_linear__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pow__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__quantile__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__r_prettry__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__register__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__time__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__time_cat__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__time_pretty__ = __webpack_require__(797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__register__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__register__["b"]; });











Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('cat', __WEBPACK_IMPORTED_MODULE_0__cat__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('time-cat', __WEBPACK_IMPORTED_MODULE_9__time_cat__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('wilkinson-extended', __WEBPACK_IMPORTED_MODULE_2__linear__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('r-pretty', __WEBPACK_IMPORTED_MODULE_6__r_prettry__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('time', __WEBPACK_IMPORTED_MODULE_8__time__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('time-pretty', __WEBPACK_IMPORTED_MODULE_10__time_pretty__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('log', __WEBPACK_IMPORTED_MODULE_3__log__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('pow', __WEBPACK_IMPORTED_MODULE_4__pow__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('quantile', __WEBPACK_IMPORTED_MODULE_5__quantile__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__register__["b" /* registerTickMethod */])('d3-linear', __WEBPACK_IMPORTED_MODULE_1__d3_linear__["a" /* default */]);

//# sourceMappingURL=index.js.map

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = d3LinearTickMethod;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_d3_linear__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_interval__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_strict_limit__ = __webpack_require__(190);




function d3LinearTickMethod(cfg) {
    var min = cfg.min, max = cfg.max, tickInterval = cfg.tickInterval, minLimit = cfg.minLimit, maxLimit = cfg.maxLimit;
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_d3_linear__["a" /* default */])(cfg);
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(minLimit) || !Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(maxLimit)) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_strict_limit__["a" /* default */])(cfg, Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["p" /* head */])(ticks), Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(ticks));
    }
    if (tickInterval) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_interval__["a" /* default */])(min, max, tickInterval).ticks;
    }
    return ticks;
}
//# sourceMappingURL=d3-linear.js.map

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = d3Linear;
/* unused harmony export D3Linear */
function d3Linear(cfg) {
    var min = cfg.min, max = cfg.max, nice = cfg.nice, tickCount = cfg.tickCount;
    var linear = new D3Linear();
    linear.domain([min, max]);
    if (nice) {
        linear.nice(tickCount);
    }
    return linear.ticks(tickCount);
}
var DEFAULT_COUNT = 5;
var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);
// https://github.com/d3/d3-scale
var D3Linear = /** @class */ (function () {
    function D3Linear() {
        this._domain = [0, 1];
    }
    D3Linear.prototype.domain = function (domain) {
        if (domain) {
            this._domain = Array.from(domain, Number);
            return this;
        }
        return this._domain.slice();
    };
    D3Linear.prototype.nice = function (count) {
        var _a, _b;
        if (count === void 0) { count = DEFAULT_COUNT; }
        var d = this._domain.slice();
        var i0 = 0;
        var i1 = this._domain.length - 1;
        var start = this._domain[i0];
        var stop = this._domain[i1];
        var step;
        if (stop < start) {
            _a = [stop, start], start = _a[0], stop = _a[1];
            _b = [i1, i0], i0 = _b[0], i1 = _b[1];
        }
        step = tickIncrement(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = tickIncrement(start, stop, count);
        }
        else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = tickIncrement(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            this.domain(d);
        }
        else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            this.domain(d);
        }
        return this;
    };
    D3Linear.prototype.ticks = function (count) {
        if (count === void 0) { count = DEFAULT_COUNT; }
        return d3ArrayTicks(this._domain[0], this._domain[this._domain.length - 1], count || DEFAULT_COUNT);
    };
    return D3Linear;
}());

function d3ArrayTicks(start, stop, count) {
    var reverse;
    var i = -1;
    var n;
    var ticks;
    var step;
    (stop = +stop), (start = +start), (count = +count);
    if (start === stop && count > 0) {
        return [start];
    }
    // tslint:disable-next-line
    if ((reverse = stop < start)) {
        (n = start), (start = stop), (stop = n);
    }
    // tslint:disable-next-line
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) {
        return [];
    }
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array((n = Math.ceil(stop - start + 1)));
        while (++i < n) {
            ticks[i] = (start + i) * step;
        }
    }
    else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array((n = Math.ceil(start - stop + 1)));
        while (++i < n) {
            ticks[i] = (start - i) / step;
        }
    }
    if (reverse) {
        ticks.reverse();
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count);
    var power = Math.floor(Math.log(step) / Math.LN10);
    var error = step / Math.pow(10, power);
    return power >= 0
        ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
        : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
//# sourceMappingURL=d3-linear.js.map

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_extended__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_interval__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_strict_limit__ = __webpack_require__(190);




/**
 * 计算线性的 ticks，使用 wilkinson extended 方法
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function linear(cfg) {
    var min = cfg.min, max = cfg.max, tickCount = cfg.tickCount, nice = cfg.nice, tickInterval = cfg.tickInterval, minLimit = cfg.minLimit, maxLimit = cfg.maxLimit;
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_extended__["a" /* default */])(min, max, tickCount, nice).ticks;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(minLimit) || !Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(maxLimit)) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_strict_limit__["a" /* default */])(cfg, Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["p" /* head */])(ticks), Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(ticks));
    }
    if (tickInterval) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_interval__["a" /* default */])(min, max, tickInterval).ticks;
    }
    return ticks;
}
//# sourceMappingURL=linear.js.map

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_Q */
/* unused harmony export ALL_Q */
/* harmony export (immutable) */ __webpack_exports__["a"] = extended;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pretty_number__ = __webpack_require__(290);


var DEFAULT_Q = [1, 5, 2, 2.5, 4, 3];
var ALL_Q = [1, 5, 2, 2.5, 4, 3, 1.5, 7, 6, 8, 9];
var eps = Number.EPSILON * 100;
function mod(n, m) {
    return ((n % m) + m) % m;
}
function round(n) {
    return Math.round(n * 1e12) / 1e12;
}
function simplicity(q, Q, j, lmin, lmax, lstep) {
    var n = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["J" /* size */])(Q);
    var i = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["q" /* indexOf */])(Q, q);
    var v = 0;
    var m = mod(lmin, lstep);
    if ((m < eps || lstep - m < eps) && lmin <= 0 && lmax >= 0) {
        v = 1;
    }
    return 1 - i / (n - 1) - j + v;
}
function simplicityMax(q, Q, j) {
    var n = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["J" /* size */])(Q);
    var i = Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["q" /* indexOf */])(Q, q);
    var v = 1;
    return 1 - i / (n - 1) - j + v;
}
function density(k, m, dMin, dMax, lMin, lMax) {
    var r = (k - 1) / (lMax - lMin);
    var rt = (m - 1) / (Math.max(lMax, dMax) - Math.min(dMin, lMin));
    return 2 - Math.max(r / rt, rt / r);
}
function densityMax(k, m) {
    if (k >= m) {
        return 2 - (k - 1) / (m - 1);
    }
    return 1;
}
function coverage(dMin, dMax, lMin, lMax) {
    var range = dMax - dMin;
    return 1 - (0.5 * (Math.pow((dMax - lMax), 2) + Math.pow((dMin - lMin), 2))) / Math.pow((0.1 * range), 2);
}
function coverageMax(dMin, dMax, span) {
    var range = dMax - dMin;
    if (span > range) {
        var half = (span - range) / 2;
        return 1 - Math.pow(half, 2) / Math.pow((0.1 * range), 2);
    }
    return 1;
}
function legibility() {
    return 1;
}
/**
 * An Extension of Wilkinson's Algorithm for Position Tick Labels on Axes
 * https://www.yuque.com/preview/yuque/0/2019/pdf/185317/1546999150858-45c3b9c2-4e86-4223-bf1a-8a732e8195ed.pdf
 * @param dMin 最小值
 * @param dMax 最大值
 * @param m tick个数
 * @param onlyLoose 是否允许扩展min、max，不绝对强制，例如[3, 97]
 * @param Q nice numbers集合
 * @param w 四个优化组件的权重
 */
function extended(dMin, dMax, n, onlyLoose, Q, w) {
    if (n === void 0) { n = 5; }
    if (onlyLoose === void 0) { onlyLoose = true; }
    if (Q === void 0) { Q = DEFAULT_Q; }
    if (w === void 0) { w = [0.25, 0.2, 0.5, 0.05]; }
    // 处理小于 0 和小数的 tickCount
    var m = n < 0 ? 0 : Math.round(n);
    // nan 也会导致异常
    if (Number.isNaN(dMin) || Number.isNaN(dMax) || typeof dMin !== 'number' || typeof dMax !== 'number' || !m) {
        return {
            min: 0,
            max: 0,
            ticks: [],
        };
    }
    // js 极大值极小值问题，差值小于 1e-15 会导致计算出错
    if (dMax - dMin < 1e-15 || m === 1) {
        return {
            min: dMin,
            max: dMax,
            ticks: [dMin],
        };
    }
    // js 超大值问题
    if (dMax - dMin > 1e148) {
        var count = n || 5;
        var step_1 = (dMax - dMin) / count;
        return {
            min: dMin,
            max: dMax,
            ticks: Array(count).fill(null).map(function (_, idx) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__pretty_number__["a" /* prettyNumber */])(dMin + step_1 * idx);
            }),
        };
    }
    var best = {
        score: -2,
        lmin: 0,
        lmax: 0,
        lstep: 0,
    };
    var j = 1;
    while (j < Infinity) {
        for (var i = 0; i < Q.length; i += 1) {
            var q = Q[i];
            var sm = simplicityMax(q, Q, j);
            if (w[0] * sm + w[1] + w[2] + w[3] < best.score) {
                j = Infinity;
                break;
            }
            var k = 2;
            while (k < Infinity) {
                var dm = densityMax(k, m);
                if (w[0] * sm + w[1] + w[2] * dm + w[3] < best.score) {
                    break;
                }
                var delta = (dMax - dMin) / (k + 1) / j / q;
                var z = Math.ceil(Math.log10(delta));
                while (z < Infinity) {
                    var step = j * q * Math.pow(10, z);
                    var cm = coverageMax(dMin, dMax, step * (k - 1));
                    if (w[0] * sm + w[1] * cm + w[2] * dm + w[3] < best.score) {
                        break;
                    }
                    var minStart = Math.floor(dMax / step) * j - (k - 1) * j;
                    var maxStart = Math.ceil(dMin / step) * j;
                    if (minStart <= maxStart) {
                        var count = maxStart - minStart;
                        for (var i_1 = 0; i_1 <= count; i_1 += 1) {
                            var start = minStart + i_1;
                            var lMin = start * (step / j);
                            var lMax = lMin + step * (k - 1);
                            var lStep = step;
                            var s = simplicity(q, Q, j, lMin, lMax, lStep);
                            var c = coverage(dMin, dMax, lMin, lMax);
                            var g = density(k, m, dMin, dMax, lMin, lMax);
                            var l = legibility();
                            var score = w[0] * s + w[1] * c + w[2] * g + w[3] * l;
                            if (score > best.score && (!onlyLoose || (lMin <= dMin && lMax >= dMax))) {
                                best.lmin = lMin;
                                best.lmax = lMax;
                                best.lstep = lStep;
                                best.score = score;
                            }
                        }
                    }
                    z += 1;
                }
                k += 1;
            }
        }
        j += 1;
    }
    // 处理精度问题，保证这三个数没有精度问题
    var lmax = Object(__WEBPACK_IMPORTED_MODULE_1__pretty_number__["a" /* prettyNumber */])(best.lmax);
    var lmin = Object(__WEBPACK_IMPORTED_MODULE_1__pretty_number__["a" /* prettyNumber */])(best.lmin);
    var lstep = Object(__WEBPACK_IMPORTED_MODULE_1__pretty_number__["a" /* prettyNumber */])(best.lstep);
    // 加 round 是为处理 extended(0.94, 1, 5)
    // 保证生成的 tickCount 没有精度问题
    var tickCount = Math.floor(round((lmax - lmin) / lstep)) + 1;
    var ticks = new Array(tickCount);
    // 少用乘法：防止出现 -1.2 + 1.2 * 3 = 2.3999999999999995 的情况
    ticks[0] = Object(__WEBPACK_IMPORTED_MODULE_1__pretty_number__["a" /* prettyNumber */])(lmin);
    for (var i = 1; i < tickCount; i++) {
        ticks[i] = Object(__WEBPACK_IMPORTED_MODULE_1__pretty_number__["a" /* prettyNumber */])(ticks[i - 1] + lstep);
    }
    return {
        min: Math.min(dMin, Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["p" /* head */])(ticks)),
        max: Math.max(dMax, Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(ticks)),
        ticks: ticks,
    };
}
//# sourceMappingURL=extended.js.map

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateLogTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_math__ = __webpack_require__(147);

/**
 * 计算 log 的 ticks，考虑 min = 0 的场景
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function calculateLogTicks(cfg) {
    var base = cfg.base, tickCount = cfg.tickCount, min = cfg.min, max = cfg.max, values = cfg.values;
    var minTick;
    var maxTick = Object(__WEBPACK_IMPORTED_MODULE_0__util_math__["c" /* log */])(base, max);
    if (min > 0) {
        minTick = Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__util_math__["c" /* log */])(base, min));
    }
    else {
        var positiveMin = Object(__WEBPACK_IMPORTED_MODULE_0__util_math__["b" /* getLogPositiveMin */])(values, base, max);
        minTick = Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__util_math__["c" /* log */])(base, positiveMin));
    }
    var count = maxTick - minTick;
    var avg = Math.ceil(count / tickCount);
    var ticks = [];
    for (var i = minTick; i < maxTick + avg; i = i + avg) {
        ticks.push(Math.pow(base, i));
    }
    if (min <= 0) {
        // 最小值 <= 0 时显示 0
        ticks.unshift(0);
    }
    return ticks;
}
//# sourceMappingURL=log.js.map

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculatePowTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_math__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_pretty__ = __webpack_require__(291);


/**
 * 计算 Pow 的 ticks
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function calculatePowTicks(cfg) {
    var exponent = cfg.exponent, tickCount = cfg.tickCount;
    var max = Math.ceil(Object(__WEBPACK_IMPORTED_MODULE_0__util_math__["a" /* calBase */])(exponent, cfg.max));
    var min = Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__util_math__["a" /* calBase */])(exponent, cfg.min));
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_pretty__["a" /* default */])(min, max, tickCount).ticks;
    return ticks.map(function (tick) {
        var factor = tick >= 0 ? 1 : -1;
        return Math.pow(tick, exponent) * factor;
    });
}
//# sourceMappingURL=pow.js.map

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateTicks;
/**
 * 计算几分位 https://github.com/simple-statistics/simple-statistics/blob/master/src/quantile_sorted.js
 * @param x  数组
 * @param p  百分比
 */
function quantileSorted(x, p) {
    var idx = x.length * p;
    /*if (x.length === 0) { // 当前场景这些条件不可能命中
      throw new Error('quantile requires at least one value.');
    } else if (p < 0 || p > 1) {
      throw new Error('quantiles must be between 0 and 1');
    } else */
    if (p === 1) {
        // If p is 1, directly return the last element
        return x[x.length - 1];
    }
    else if (p === 0) {
        // If p is 0, directly return the first element
        return x[0];
    }
    else if (idx % 1 !== 0) {
        // If p is not integer, return the next element in array
        return x[Math.ceil(idx) - 1];
    }
    else if (x.length % 2 === 0) {
        // If the list has even-length, we'll take the average of this number
        // and the next value, if there is one
        return (x[idx - 1] + x[idx]) / 2;
    }
    else {
        // Finally, in the simple case of an integer value
        // with an odd-length list, return the x value at the index.
        return x[idx];
    }
}
function calculateTicks(cfg) {
    var tickCount = cfg.tickCount, values = cfg.values;
    if (!values || !values.length) {
        return [];
    }
    var sorted = values.slice().sort(function (a, b) {
        return a - b;
    });
    var ticks = [];
    for (var i = 0; i < tickCount; i++) {
        var p = i / (tickCount - 1);
        ticks.push(quantileSorted(sorted, p));
    }
    return ticks;
}
//# sourceMappingURL=quantile.js.map

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linearPretty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_interval__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_pretty__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_strict_limit__ = __webpack_require__(190);




/**
 * 计算线性的 ticks，使用 R's pretty 方法
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function linearPretty(cfg) {
    var min = cfg.min, max = cfg.max, tickCount = cfg.tickCount, tickInterval = cfg.tickInterval, minLimit = cfg.minLimit, maxLimit = cfg.maxLimit;
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_2__util_pretty__["a" /* default */])(min, max, tickCount).ticks;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(minLimit) || !Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["w" /* isNil */])(maxLimit)) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_strict_limit__["a" /* default */])(cfg, Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["p" /* head */])(ticks), Object(__WEBPACK_IMPORTED_MODULE_0__antv_util__["D" /* last */])(ticks));
    }
    if (tickInterval) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__util_interval__["a" /* default */])(min, max, tickInterval).ticks;
    }
    return ticks;
}
//# sourceMappingURL=r-prettry.js.map

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateTimeTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_time__ = __webpack_require__(145);

function calculateTimeTicks(cfg) {
    var min = cfg.min, max = cfg.max, minTickInterval = cfg.minTickInterval;
    var tickInterval = cfg.tickInterval;
    var tickCount = cfg.tickCount;
    // 指定 tickInterval 后 tickCount 不生效，需要重新计算
    if (tickInterval) {
        tickCount = Math.ceil((max - min) / tickInterval);
    }
    else {
        tickInterval = Object(__WEBPACK_IMPORTED_MODULE_0__util_time__["g" /* getTickInterval */])(min, max, tickCount)[1];
        var count = (max - min) / tickInterval;
        var ratio = count / tickCount;
        if (ratio > 1) {
            tickInterval = tickInterval * Math.ceil(ratio);
        }
        // 如果设置了最小间距，则使用最小间距
        if (minTickInterval && tickInterval < minTickInterval) {
            tickInterval = minTickInterval;
        }
    }
    tickInterval = Math.max(Math.floor((max - min) / (Math.pow(2, 12) - 1)), tickInterval);
    var ticks = [];
    for (var i = min; i < max + tickInterval; i += tickInterval) {
        ticks.push(i);
    }
    return ticks;
}
//# sourceMappingURL=time.js.map

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeCat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cat__ = __webpack_require__(289);


/**
 * 计算时间分类的 ticks, 保头，保尾
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function timeCat(cfg) {
    // 默认保留最后一条
    var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__cat__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ showLast: true }, cfg));
    return ticks;
}
//# sourceMappingURL=time-cat.js.map

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timePretty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_time__ = __webpack_require__(145);

function getYear(date) {
    return new Date(date).getFullYear();
}
function createYear(year) {
    return new Date(year, 0, 1).getTime();
}
function getMonth(date) {
    return new Date(date).getMonth();
}
function diffMonth(min, max) {
    var minYear = getYear(min);
    var maxYear = getYear(max);
    var minMonth = getMonth(min);
    var maxMonth = getMonth(max);
    return (maxYear - minYear) * 12 + ((maxMonth - minMonth) % 12);
}
function creatMonth(year, month) {
    return new Date(year, month, 1).getTime();
}
function diffDay(min, max) {
    return Math.ceil((max - min) / __WEBPACK_IMPORTED_MODULE_0__util_time__["a" /* DAY */]);
}
function diffHour(min, max) {
    return Math.ceil((max - min) / __WEBPACK_IMPORTED_MODULE_0__util_time__["b" /* HOUR */]);
}
function diffMinus(min, max) {
    return Math.ceil((max - min) / (60 * 1000));
}
/**
 * 计算 time 的 ticks，对 month, year 进行 pretty 处理
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function timePretty(cfg) {
    var min = cfg.min, max = cfg.max, minTickInterval = cfg.minTickInterval, tickCount = cfg.tickCount;
    var tickInterval = cfg.tickInterval;
    var ticks = [];
    // 指定 tickInterval 后 tickCount 不生效，需要重新计算
    if (!tickInterval) {
        tickInterval = (max - min) / tickCount;
        // 如果设置了最小间距，则使用最小间距
        if (minTickInterval && tickInterval < minTickInterval) {
            tickInterval = minTickInterval;
        }
    }
    tickInterval = Math.max(Math.floor((max - min) / (Math.pow(2, 12) - 1)), tickInterval);
    var minYear = getYear(min);
    // 如果间距大于 1 年，则将开始日期从整年开始
    if (tickInterval > __WEBPACK_IMPORTED_MODULE_0__util_time__["f" /* YEAR */]) {
        var maxYear = getYear(max);
        var yearInterval = Math.ceil(tickInterval / __WEBPACK_IMPORTED_MODULE_0__util_time__["f" /* YEAR */]);
        for (var i = minYear; i <= maxYear + yearInterval; i = i + yearInterval) {
            ticks.push(createYear(i));
        }
    }
    else if (tickInterval > __WEBPACK_IMPORTED_MODULE_0__util_time__["d" /* MONTH */]) {
        // 大于月时
        var monthInterval = Math.ceil(tickInterval / __WEBPACK_IMPORTED_MODULE_0__util_time__["d" /* MONTH */]);
        var mmMoth = getMonth(min);
        var dMonths = diffMonth(min, max);
        for (var i = 0; i <= dMonths + monthInterval; i = i + monthInterval) {
            ticks.push(creatMonth(minYear, i + mmMoth));
        }
    }
    else if (tickInterval > __WEBPACK_IMPORTED_MODULE_0__util_time__["a" /* DAY */]) {
        // 大于天
        var date = new Date(min);
        var year = date.getFullYear();
        var month = date.getMonth();
        var mday = date.getDate();
        var day = Math.ceil(tickInterval / __WEBPACK_IMPORTED_MODULE_0__util_time__["a" /* DAY */]);
        var ddays = diffDay(min, max);
        for (var i = 0; i < ddays + day; i = i + day) {
            ticks.push(new Date(year, month, mday + i).getTime());
        }
    }
    else if (tickInterval > __WEBPACK_IMPORTED_MODULE_0__util_time__["b" /* HOUR */]) {
        // 大于小时
        var date = new Date(min);
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var hour = date.getHours();
        var hours = Math.ceil(tickInterval / __WEBPACK_IMPORTED_MODULE_0__util_time__["b" /* HOUR */]);
        var dHours = diffHour(min, max);
        for (var i = 0; i <= dHours + hours; i = i + hours) {
            ticks.push(new Date(year, month, day, hour + i).getTime());
        }
    }
    else if (tickInterval > __WEBPACK_IMPORTED_MODULE_0__util_time__["c" /* MINUTE */]) {
        // 大于分钟
        var dMinus = diffMinus(min, max);
        var minutes = Math.ceil(tickInterval / __WEBPACK_IMPORTED_MODULE_0__util_time__["c" /* MINUTE */]);
        for (var i = 0; i <= dMinus + minutes; i = i + minutes) {
            ticks.push(min + i * __WEBPACK_IMPORTED_MODULE_0__util_time__["c" /* MINUTE */]);
        }
    }
    else {
        // 小于分钟
        var interval = tickInterval;
        if (interval < __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */]) {
            interval = __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */];
        }
        var minSecond = Math.floor(min / __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */]) * __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */];
        var dSeconds = Math.ceil((max - min) / __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */]);
        var seconds = Math.ceil(interval / __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */]);
        for (var i = 0; i < dSeconds + seconds; i = i + seconds) {
            ticks.push(minSecond + i * __WEBPACK_IMPORTED_MODULE_0__util_time__["e" /* SECOND */]);
        }
    }
    // 最好是能从算法能解决这个问题，但是如果指定了 tickInterval，计算 ticks，也只能这么算，所以
    // 打印警告提示
    if (ticks.length >= 512) {
        console.warn("Notice: current ticks length(" + ticks.length + ") >= 512, may cause performance issues, even out of memory. Because of the configure \"tickInterval\"(in milliseconds, current is " + tickInterval + ") is too small, increase the value to solve the problem!");
    }
    return ticks;
}
//# sourceMappingURL=time-pretty.js.map

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// cat平均算法，保头保尾
/* harmony default export */ __webpack_exports__["a"] = (function (cfg) {
  var values = cfg.values,
      tickCount = cfg.tickCount;

  if (!tickCount) {
    return values;
  }

  if (values.length <= 1) {
    return values;
  } // 获取间隔步长, 最小是1


  var step = Math.floor(values.length / (tickCount - 1)) || 1;
  var ticks = []; // 按间隔数取对应节点

  for (var index = 0; index < values.length; index = index + step) {
    ticks.push(values[index]);
  }

  var last = values[values.length - 1]; // 如果最后一个tick不等于原数据的最后一个

  if (ticks[ticks.length - 1] !== last) {
    if (ticks.length >= tickCount) {
      // 如果当前的tick个数满足要求
      ticks[ticks.length - 1] = last;
    } else {
      // 不满足tickCount则直接加入最后一个
      ticks.push(last);
    }
  }

  return ticks;
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 认为是nice的刻度
var SNAP_COUNT_ARRAY = [1, 1.2, 1.5, 2, 2.2, 2.4, 2.5, 3, 4, 5, 6, 7.5, 8, 10];
var DEFAULT_COUNT = 5; // 默认刻度值

/* harmony default export */ __webpack_exports__["a"] = (function (cfg) {
  var _ref = cfg || {},
      tickCount = _ref.tickCount,
      tickInterval = _ref.tickInterval;

  var _ref2 = cfg || {},
      min = _ref2.min,
      max = _ref2.max;

  min = isNaN(min) ? 0 : min;
  max = isNaN(max) ? 0 : max;
  var count = tickCount && tickCount >= 2 ? tickCount : DEFAULT_COUNT; // 计算interval， 优先取tickInterval

  var interval = tickInterval || getBestInterval({
    tickCount: count,
    max: max,
    min: min
  }); // 通过interval计算最小tick

  var minTick = Math.floor(min / interval) * interval; // 如果指定了tickInterval, count 需要根据指定的tickInterval来算计

  if (tickInterval) {
    var intervalCount = Math.abs(Math.ceil((max - minTick) / tickInterval)) + 1; // tickCount 作为最小 count 处理

    count = Math.max(count, intervalCount);
  }

  var ticks = [];
  var tickLength = 0;
  var fixedLength = getFixedLength(interval);

  while (tickLength < count) {
    ticks.push(toFixed(minTick + tickLength * interval, fixedLength));
    tickLength++;
  }

  return ticks;
});
var DECIMAL_LENGTH = 12;

function getFactor(number) {
  // 取正数
  number = Math.abs(number);
  var factor = 1;

  if (number === 0) {
    return factor;
  } // 小于1,逐渐放大


  if (number < 1) {
    var count = 0;

    while (number < 1) {
      factor = factor / 10;
      number = number * 10;
      count++;
    } // 浮点数计算出现问题


    if (factor.toString().length > DECIMAL_LENGTH) {
      factor = parseFloat(factor.toFixed(count));
    }

    return factor;
  } // 大于10逐渐缩小


  while (number > 10) {
    factor = factor * 10;
    number = number / 10;
  }

  return factor;
} // 获取最佳匹配刻度


function getBestInterval(_ref3) {
  var tickCount = _ref3.tickCount,
      min = _ref3.min,
      max = _ref3.max;

  // 如果最大最小相等，则直接按1处理
  if (min === max) {
    return 1 * getFactor(max);
  } // 1.计算平均刻度间隔


  var avgInterval = (max - min) / (tickCount - 1); // 2.数据标准归一化 映射到[1-10]区间

  var factor = getFactor(avgInterval);
  var calInterval = avgInterval / factor;
  var calMax = max / factor;
  var calMin = min / factor; // 根据平均值推算最逼近刻度值

  var similarityIndex = 0;

  for (var index = 0; index < SNAP_COUNT_ARRAY.length; index++) {
    var item = SNAP_COUNT_ARRAY[index];

    if (calInterval <= item) {
      similarityIndex = index;
      break;
    }
  }

  var similarityInterval = getInterval(similarityIndex, tickCount, calMin, calMax); // 小数点位数还原到数据的位数, 因为similarityIndex有可能是小数，所以需要保留similarityIndex自己的小数位数

  var fixedLength = getFixedLength(similarityInterval) + getFixedLength(factor);
  return toFixed(similarityInterval * factor, fixedLength);
}

function getInterval(startIndex, tickCount, min, max) {
  var verify = false;
  var interval = SNAP_COUNT_ARRAY[startIndex]; // 刻度值校验，如果不满足，循环下去

  for (var i = startIndex; i < SNAP_COUNT_ARRAY.length; i++) {
    if (intervalIsVerify({
      interval: SNAP_COUNT_ARRAY[i],
      tickCount: tickCount,
      max: max,
      min: min
    })) {
      // 有符合条件的interval
      interval = SNAP_COUNT_ARRAY[i];
      verify = true;
      break;
    }
  } // 如果不满足, 依次缩小10倍，再计算


  if (!verify) {
    return 10 * getInterval(0, tickCount, min / 10, max / 10);
  }

  return interval;
} // 刻度是否满足展示需求


function intervalIsVerify(_ref4) {
  var interval = _ref4.interval,
      tickCount = _ref4.tickCount,
      max = _ref4.max,
      min = _ref4.min;
  var minTick = Math.floor(min / interval) * interval;

  if (minTick + (tickCount - 1) * interval >= max) {
    return true;
  }

  return false;
} // 计算小数点应该保留的位数


function getFixedLength(num) {
  var str = num.toString();
  var index = str.indexOf('.');
  var indexOfExp = str.indexOf('e-');
  var length = indexOfExp >= 0 ? parseInt(str.substr(indexOfExp + 2), 10) : str.substr(index + 1).length;

  if (length > 20) {
    // 最多保留20位小数
    length = 20;
  }

  return length;
} // @antv/util fixedbase不支持科学计数法的判断，需要提mr


function toFixed(v, length) {
  return parseFloat(v.toFixed(length));
}

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geometry__ = __webpack_require__(148);
/* unused harmony reexport Geometry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(812);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__line__["a"]; });
/* unused harmony reexport withLine */
/* unused harmony reexport LineView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area__ = __webpack_require__(817);
/* unused harmony reexport Area */
/* unused harmony reexport withArea */
/* unused harmony reexport AreaView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interval__ = __webpack_require__(820);
/* unused harmony reexport Interval */
/* unused harmony reexport withInterval */
/* unused harmony reexport IntervalView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(827);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__point__["a"]; });
/* unused harmony reexport withPoint */
/* unused harmony reexport PointView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axis__ = __webpack_require__(830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__axis__["a"]; });
/* unused harmony reexport withAxis */
/* unused harmony reexport AxisView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__legend__ = __webpack_require__(839);
/* unused harmony reexport Legend */
/* unused harmony reexport withLegend */
/* unused harmony reexport LegendView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__guide__ = __webpack_require__(842);
/* unused harmony reexport Guide */
/* unused harmony reexport withGuide */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__guide__["b"]; });
/* unused harmony reexport PointGuide */
/* unused harmony reexport LineGuide */
/* unused harmony reexport ArcGuide */
/* unused harmony reexport RectGuide */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__guide__["a"]; });
/* unused harmony reexport TagGuide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tooltip__ = __webpack_require__(851);
/* unused harmony reexport Tooltip */
/* unused harmony reexport withTooltip */
/* unused harmony reexport TooltipView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treemap__ = __webpack_require__(854);
/* unused harmony reexport Treemap */
/* unused harmony reexport withTreemap */
/* unused harmony reexport TreemapView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sunburst__ = __webpack_require__(881);
/* unused harmony reexport Sunburst */
/* unused harmony reexport withSunburst */
/* unused harmony reexport SunburstView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pieLabel__ = __webpack_require__(884);
/* unused harmony reexport PieLabel */
/* unused harmony reexport withPieLabel */
/* unused harmony reexport PieLabelView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__gauge__ = __webpack_require__(887);
/* unused harmony reexport Gauge */
/* unused harmony reexport withGauge */
/* unused harmony reexport GaugeView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zoom__ = __webpack_require__(309);
/* unused harmony reexport Zoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__scrollBar__ = __webpack_require__(891);
/* unused harmony reexport ScrollBar */
/* unused harmony reexport withScrollBar */
/* unused harmony reexport ScrollBarView */
















/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_equal__ = __webpack_require__(82);









function isEqual(origin1, origin2, fields) {
  if (origin1 === origin2) {
    return true;
  }

  for (var i = 0, len = fields.length; i < len; i++) {
    var field = fields[i];

    if (origin1[field] !== origin2[field]) {
      return false;
    }
  }

  return true;
}

var Selection = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Selection, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Selection);

  function Selection(props, context) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Selection);

    _this = _super.call(this, props, context);
    var selection = props.selection;
    if (!selection) return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(_this);
    var defaultSelected = selection.defaultSelected;
    _this.state.selected = defaultSelected;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Selection, [{
    key: "didMount",
    value: function didMount() {
      var _this2 = this;

      var props = this.props,
          state = this.state,
          container = this.container;
      var canvas = container.get('canvas');
      var selection = props.selection,
          chart = props.chart;
      if (!selection) return; // 默认为 click

      var _selection$triggerOn = selection.triggerOn,
          triggerOn = _selection$triggerOn === void 0 ? 'click' : _selection$triggerOn;
      canvas.on(triggerOn, function (ev) {
        var points = ev.points;

        var records = _this2.getSnapRecords(points[0]);

        var _selection$type = selection.type,
            type = _selection$type === void 0 ? 'single' : _selection$type,
            _selection$cancelable = selection.cancelable,
            cancelable = _selection$cancelable === void 0 ? true : _selection$cancelable;

        if (!records || !records.length) {
          if (cancelable) {
            _this2.setState({
              selected: null
            });
          }

          return;
        }

        var selected = state.selected;
        var origins = records.map(function (record) {
          return record.origin;
        });

        if (!selected || !selected.length) {
          _this2.setState({
            selected: origins
          });
        }

        if (type === 'single') {
          if (!cancelable) {
            _this2.setState({
              selected: origins
            });

            return;
          }

          var _newSelected = [];
          records.forEach(function (record) {
            if (!_this2.isSelected(record)) {
              _newSelected.push(record.origin);
            }
          });

          _this2.setState({
            selected: _newSelected
          });

          return;
        } // 多选


        var scales = chart.getScales();
        var fields = Object.keys(scales);
        var selectedMap = {};
        selected.forEach(function (item) {
          var key = fields.map(function (field) {
            return item[field];
          }).join('-');
          selectedMap[key] = item;
        });
        records.forEach(function (record) {
          var origin = record.origin;
          var key = fields.map(function (field) {
            return origin[field];
          }).join('-');
          selectedMap[key] = selectedMap[key] ? null : origin;
        });
        var newSelected = Object.keys(selectedMap).map(function (key) {
          return selectedMap[key];
        }).filter(Boolean);

        _this2.setState({
          selected: newSelected
        });
      });
    }
  }, {
    key: "willReceiveProps",
    value: function willReceiveProps(nextProps) {
      var nextSelection = nextProps.selection;
      var lastSelection = this.props.selection;

      if (!nextSelection || !lastSelection) {
        return;
      }

      var nextDefaultSelected = nextSelection.defaultSelected;
      var lastDefaultSelected = lastSelection.defaultSelected;

      if (!Object(__WEBPACK_IMPORTED_MODULE_7__base_equal__["a" /* default */])(nextDefaultSelected, lastDefaultSelected)) {
        this.state.selected = nextDefaultSelected;
      }
    }
  }, {
    key: "getSnapRecords",
    value: function getSnapRecords(_point) {
      return null;
    }
  }, {
    key: "isSelected",
    value: function isSelected(record) {
      var state = this.state,
          props = this.props;
      var selected = state.selected;

      if (!selected || !selected.length) {
        return false;
      }

      var chart = props.chart;
      var scales = chart.getScales();
      var fields = Object.keys(scales);

      for (var i = 0, len = selected.length; i < len; i++) {
        var item = selected[i];

        if (isEqual(record.origin, item, fields)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "getSelectionStyle",
    value: function getSelectionStyle(record) {
      var state = this.state,
          props = this.props;
      var selected = state.selected;

      if (!selected || !selected.length) {
        return null;
      }

      var selection = props.selection;
      var selectedStyle = selection.selectedStyle,
          unSelectedStyle = selection.unSelectedStyle;
      var isSelected = this.isSelected(record);

      if (isSelected) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__antv_util__["v" /* isFunction */])(selectedStyle) ? selectedStyle(record) : selectedStyle;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_5__antv_util__["v" /* isFunction */])(unSelectedStyle) ? unSelectedStyle(record) : unSelectedStyle;
    }
  }]);

  return Selection;
}(__WEBPACK_IMPORTED_MODULE_6__base_component__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Selection);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adjusts_adjust__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjusts_dodge__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adjusts_jitter__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__adjusts_stack__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adjusts_symmetric__ = __webpack_require__(807);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__factory__, "getAdjust")) __webpack_require__.d(__webpack_exports__, "getAdjust", function() { return __WEBPACK_IMPORTED_MODULE_0__factory__["getAdjust"]; });
/* unused harmony reexport registerAdjust */
/* unused harmony reexport Adjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interface__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__interface__);
/* unused harmony namespace reexport */






// 注册内置的 adjust
Object(__WEBPACK_IMPORTED_MODULE_0__factory__["registerAdjust"])('Dodge', __WEBPACK_IMPORTED_MODULE_2__adjusts_dodge__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_0__factory__["registerAdjust"])('Jitter', __WEBPACK_IMPORTED_MODULE_3__adjusts_jitter__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_0__factory__["registerAdjust"])('Stack', __WEBPACK_IMPORTED_MODULE_4__adjusts_stack__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_0__factory__["registerAdjust"])('Symmetric', __WEBPACK_IMPORTED_MODULE_5__adjusts_symmetric__["a" /* default */]);
// 最终暴露给外部的方法


//# sourceMappingURL=index.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAdjust", function() { return getAdjust; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerAdjust", function() { return registerAdjust; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adjusts_adjust__ = __webpack_require__(109);
/* unused harmony reexport Adjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interface__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__interface__);
/* unused harmony namespace reexport */

var ADJUST_MAP = {};
/**
 * 根据类型获取 Adjust 类
 * @param type
 */
var getAdjust = function (type) {
    return ADJUST_MAP[type.toLowerCase()];
};
/**
 * 注册自定义 Adjust
 * @param type
 * @param ctor
 */
var registerAdjust = function (type, ctor) {
    // 注册的时候，需要校验 type 重名，不区分大小写
    if (getAdjust(type)) {
        throw new Error("Adjust type '" + type + "' existed.");
    }
    // 存储到 map 中
    ADJUST_MAP[type.toLowerCase()] = ctor;
};


//# sourceMappingURL=factory.js.map

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adjust__ = __webpack_require__(109);




var Dodge = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Dodge, _super);
    function Dodge(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.cacheMap = {};
        _this.adjustDataArray = [];
        _this.mergeData = [];
        var _a = cfg.marginRatio, marginRatio = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_2__constant__["d" /* MARGIN_RATIO */] : _a, _b = cfg.dodgeRatio, dodgeRatio = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_2__constant__["b" /* DODGE_RATIO */] : _b, dodgeBy = cfg.dodgeBy, intervalPadding = cfg.intervalPadding, dodgePadding = cfg.dodgePadding, xDimensionLength = cfg.xDimensionLength, groupNum = cfg.groupNum, defaultSize = cfg.defaultSize, maxColumnWidth = cfg.maxColumnWidth, minColumnWidth = cfg.minColumnWidth, columnWidthRatio = cfg.columnWidthRatio, customOffset = cfg.customOffset;
        _this.marginRatio = marginRatio;
        _this.dodgeRatio = dodgeRatio;
        _this.dodgeBy = dodgeBy;
        _this.intervalPadding = intervalPadding;
        _this.dodgePadding = dodgePadding;
        _this.xDimensionLegenth = xDimensionLength;
        _this.groupNum = groupNum;
        _this.defaultSize = defaultSize;
        _this.maxColumnWidth = maxColumnWidth;
        _this.minColumnWidth = minColumnWidth;
        _this.columnWidthRatio = columnWidthRatio;
        _this.customOffset = customOffset;
        return _this;
    }
    Dodge.prototype.process = function (groupDataArray) {
        var groupedDataArray = __WEBPACK_IMPORTED_MODULE_1__antv_util__["c" /* clone */](groupDataArray);
        // 将数据数组展开一层
        var mergeData = __WEBPACK_IMPORTED_MODULE_1__antv_util__["j" /* flatten */](groupedDataArray);
        var dodgeBy = this.dodgeBy;
        // 如果指定了分组 dim 的字段
        var adjustDataArray = dodgeBy ? __WEBPACK_IMPORTED_MODULE_1__antv_util__["m" /* group */](mergeData, dodgeBy) : groupedDataArray;
        this.cacheMap = {};
        this.adjustDataArray = adjustDataArray;
        this.mergeData = mergeData;
        this.adjustData(adjustDataArray, mergeData);
        this.adjustDataArray = [];
        this.mergeData = [];
        return groupedDataArray;
    };
    Dodge.prototype.adjustDim = function (dim, values, data, frameIndex) {
        var _this = this;
        var customOffset = this.customOffset;
        var map = this.getDistribution(dim);
        var groupData = this.groupData(data, dim); // 根据值分组
        __WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */](groupData, function (group, key) {
            var range;
            // xField 中只有一个值，不需要做 dodge
            if (values.length === 1) {
                range = {
                    pre: values[0] - 1,
                    next: values[0] + 1,
                };
            }
            else {
                // 如果有多个，则需要获取调整的范围
                range = _this.getAdjustRange(dim, parseFloat(key), values);
            }
            __WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */](group, function (d) {
                var value = d[dim];
                var valueArr = map[value];
                var valIndex = valueArr.indexOf(frameIndex);
                if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](customOffset)) {
                    var pre = range.pre, next = range.next;
                    d[dim] = __WEBPACK_IMPORTED_MODULE_1__antv_util__["v" /* isFunction */](customOffset) ? customOffset(d, range) : (pre + next) / 2 + customOffset;
                }
                else {
                    d[dim] = _this.getDodgeOffset(range, valIndex, valueArr.length);
                }
            });
        });
        return [];
    };
    Dodge.prototype.getDodgeOffset = function (range, idx, len) {
        var _a = this, dodgeRatio = _a.dodgeRatio, marginRatio = _a.marginRatio, intervalPadding = _a.intervalPadding, dodgePadding = _a.dodgePadding;
        var pre = range.pre, next = range.next;
        var tickLength = next - pre;
        var position;
        // 分多种输入情况
        if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](intervalPadding) && __WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](dodgePadding) && intervalPadding >= 0) {
            // 仅配置intervalPadding
            var offset = this.getIntervalOnlyOffset(len, idx);
            position = pre + offset;
        }
        else if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](dodgePadding) && __WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](intervalPadding) && dodgePadding >= 0) {
            // 仅配置dodgePadding
            var offset = this.getDodgeOnlyOffset(len, idx);
            position = pre + offset;
        }
        else if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](intervalPadding) &&
            !__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](dodgePadding) &&
            intervalPadding >= 0 &&
            dodgePadding >= 0) {
            // 同时配置intervalPadding和dodgePadding
            var offset = this.getIntervalAndDodgeOffset(len, idx);
            position = pre + offset;
        }
        else {
            // 默认情况
            var width = (tickLength * dodgeRatio) / len;
            var margin = marginRatio * width;
            var offset = (1 / 2) * (tickLength - len * width - (len - 1) * margin) +
                ((idx + 1) * width + idx * margin) -
                (1 / 2) * width -
                (1 / 2) * tickLength;
            position = (pre + next) / 2 + offset;
        }
        return position;
    };
    Dodge.prototype.getIntervalOnlyOffset = function (len, idx) {
        var _a = this, defaultSize = _a.defaultSize, intervalPadding = _a.intervalPadding, xDimensionLegenth = _a.xDimensionLegenth, groupNum = _a.groupNum, dodgeRatio = _a.dodgeRatio, maxColumnWidth = _a.maxColumnWidth, minColumnWidth = _a.minColumnWidth, columnWidthRatio = _a.columnWidthRatio;
        var normalizedIntervalPadding = intervalPadding / xDimensionLegenth;
        var normalizedDodgePadding = (1 - (groupNum - 1) * normalizedIntervalPadding) / groupNum * dodgeRatio / (len - 1);
        var geomWidth = ((1 - normalizedIntervalPadding * (groupNum - 1)) / groupNum - normalizedDodgePadding * (len - 1)) / len;
        // 根据columnWidthRatio/defaultSize/maxColumnWidth/minColumnWidth调整宽度
        geomWidth = (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](columnWidthRatio)) ? 1 / groupNum / len * columnWidthRatio : geomWidth;
        if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](maxColumnWidth)) {
            var normalizedMaxWidht = maxColumnWidth / xDimensionLegenth;
            geomWidth = Math.min(geomWidth, normalizedMaxWidht);
        }
        if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](minColumnWidth)) {
            var normalizedMinWidht = minColumnWidth / xDimensionLegenth;
            geomWidth = Math.max(geomWidth, normalizedMinWidht);
        }
        geomWidth = defaultSize ? (defaultSize / xDimensionLegenth) : geomWidth;
        // 调整组内间隔
        normalizedDodgePadding = ((1 - (groupNum - 1) * normalizedIntervalPadding) / groupNum - len * geomWidth) / (len - 1);
        var offset = ((1 / 2 + idx) * geomWidth + idx * normalizedDodgePadding +
            (1 / 2) * normalizedIntervalPadding) * groupNum -
            normalizedIntervalPadding / 2;
        return offset;
    };
    Dodge.prototype.getDodgeOnlyOffset = function (len, idx) {
        var _a = this, defaultSize = _a.defaultSize, dodgePadding = _a.dodgePadding, xDimensionLegenth = _a.xDimensionLegenth, groupNum = _a.groupNum, marginRatio = _a.marginRatio, maxColumnWidth = _a.maxColumnWidth, minColumnWidth = _a.minColumnWidth, columnWidthRatio = _a.columnWidthRatio;
        var normalizedDodgePadding = dodgePadding / xDimensionLegenth;
        var normalizedIntervalPadding = 1 * marginRatio / (groupNum - 1);
        var geomWidth = ((1 - normalizedIntervalPadding * (groupNum - 1)) / groupNum - normalizedDodgePadding * (len - 1)) / len;
        // 根据columnWidthRatio/defaultSize/maxColumnWidth/minColumnWidth调整宽度
        geomWidth = columnWidthRatio ? 1 / groupNum / len * columnWidthRatio : geomWidth;
        if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](maxColumnWidth)) {
            var normalizedMaxWidht = maxColumnWidth / xDimensionLegenth;
            geomWidth = Math.min(geomWidth, normalizedMaxWidht);
        }
        if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](minColumnWidth)) {
            var normalizedMinWidht = minColumnWidth / xDimensionLegenth;
            geomWidth = Math.max(geomWidth, normalizedMinWidht);
        }
        geomWidth = defaultSize ? (defaultSize / xDimensionLegenth) : geomWidth;
        // 调整组间距
        normalizedIntervalPadding = (1 - (geomWidth * len + normalizedDodgePadding * (len - 1)) * groupNum) / (groupNum - 1);
        var offset = ((1 / 2 + idx) * geomWidth + idx * normalizedDodgePadding +
            (1 / 2) * normalizedIntervalPadding) * groupNum -
            normalizedIntervalPadding / 2;
        return offset;
    };
    Dodge.prototype.getIntervalAndDodgeOffset = function (len, idx) {
        var _a = this, intervalPadding = _a.intervalPadding, dodgePadding = _a.dodgePadding, xDimensionLegenth = _a.xDimensionLegenth, groupNum = _a.groupNum;
        var normalizedIntervalPadding = intervalPadding / xDimensionLegenth;
        var normalizedDodgePadding = dodgePadding / xDimensionLegenth;
        var geomWidth = ((1 - normalizedIntervalPadding * (groupNum - 1)) / groupNum - normalizedDodgePadding * (len - 1)) / len;
        var offset = ((1 / 2 + idx) * geomWidth + idx * normalizedDodgePadding +
            (1 / 2) * normalizedIntervalPadding) * groupNum -
            normalizedIntervalPadding / 2;
        return offset;
    };
    Dodge.prototype.getDistribution = function (dim) {
        var groupedDataArray = this.adjustDataArray;
        var cacheMap = this.cacheMap;
        var map = cacheMap[dim];
        if (!map) {
            map = {};
            __WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */](groupedDataArray, function (data, index) {
                var values = __WEBPACK_IMPORTED_MODULE_1__antv_util__["M" /* valuesOfKey */](data, dim);
                if (!values.length) {
                    values.push(0);
                }
                __WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */](values, function (val) {
                    if (!map[val]) {
                        map[val] = [];
                    }
                    map[val].push(index);
                });
            });
            cacheMap[dim] = map;
        }
        return map;
    };
    return Dodge;
}(__WEBPACK_IMPORTED_MODULE_3__adjust__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Dodge);
//# sourceMappingURL=dodge.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adjust__ = __webpack_require__(109);




function randomNumber(min, max) {
    return (max - min) * Math.random() + min;
}
var Jitter = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Jitter, _super);
    function Jitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Jitter.prototype.process = function (groupDataArray) {
        var groupedDataArray = __WEBPACK_IMPORTED_MODULE_1__antv_util__["c" /* clone */](groupDataArray);
        // 之前分组之后的数据，然后有合并回去（和分组前可以理解成是一样的）
        var mergeData = __WEBPACK_IMPORTED_MODULE_1__antv_util__["j" /* flatten */](groupedDataArray);
        // 返回值
        this.adjustData(groupedDataArray, mergeData);
        return groupedDataArray;
    };
    /**
     * 当前数据分组（index）中，按照维度 dim 进行 jitter 调整
     * @param dim
     * @param values
     * @param dataArray
     */
    Jitter.prototype.adjustDim = function (dim, values, dataArray) {
        var _this = this;
        // 在每一个分组中，将数据再按照 dim 分组，用于散列
        var groupDataArray = this.groupData(dataArray, dim);
        return __WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */](groupDataArray, function (data, dimValue) {
            return _this.adjustGroup(data, dim, parseFloat(dimValue), values);
        });
    };
    // 随机出来的字段值
    Jitter.prototype.getAdjustOffset = function (range) {
        var pre = range.pre, next = range.next;
        // 随机的范围
        var margin = (next - pre) * __WEBPACK_IMPORTED_MODULE_2__constant__["c" /* GAP */];
        return randomNumber(pre + margin, next - margin);
    };
    // adjust group data
    Jitter.prototype.adjustGroup = function (group, dim, dimValue, values) {
        var _this = this;
        // 调整范围
        var range = this.getAdjustRange(dim, dimValue, values);
        __WEBPACK_IMPORTED_MODULE_1__antv_util__["e" /* each */](group, function (data) {
            data[dim] = _this.getAdjustOffset(range); // 获取调整的位置
        });
        return group;
    };
    return Jitter;
}(__WEBPACK_IMPORTED_MODULE_3__adjust__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Jitter);
//# sourceMappingURL=jitter.js.map

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjust__ = __webpack_require__(109);



var Cache = __WEBPACK_IMPORTED_MODULE_1__antv_util__["a" /* Cache */];
var Stack = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Stack, _super);
    function Stack(cfg) {
        var _this = _super.call(this, cfg) || this;
        var _a = cfg.adjustNames, adjustNames = _a === void 0 ? ['y'] : _a, _b = cfg.height, height = _b === void 0 ? NaN : _b, _c = cfg.size, size = _c === void 0 ? 10 : _c, _d = cfg.reverseOrder, reverseOrder = _d === void 0 ? false : _d;
        _this.adjustNames = adjustNames;
        _this.height = height;
        _this.size = size;
        _this.reverseOrder = reverseOrder;
        return _this;
    }
    /**
     * 方法入参是经过数据分组、数据数字化之后的二维数组
     * @param groupDataArray 分组之后的数据
     */
    Stack.prototype.process = function (groupDataArray) {
        var _a = this, yField = _a.yField, reverseOrder = _a.reverseOrder;
        // 如果有指定 y 字段，那么按照 y 字段来 stack
        // 否则，按照高度均分
        var d = yField ? this.processStack(groupDataArray) : this.processOneDimStack(groupDataArray);
        return reverseOrder ? this.reverse(d) : d;
    };
    Stack.prototype.reverse = function (groupedDataArray) {
        return groupedDataArray.slice(0).reverse();
    };
    Stack.prototype.processStack = function (groupDataArray) {
        var _a = this, xField = _a.xField, yField = _a.yField, reverseOrder = _a.reverseOrder;
        // 层叠顺序翻转
        var groupedDataArray = reverseOrder ? this.reverse(groupDataArray) : groupDataArray;
        // 用来缓存，正数和负数的堆叠问题
        var positive = new Cache();
        var negative = new Cache();
        return groupedDataArray.map(function (dataArray) {
            return dataArray.map(function (data) {
                var _a;
                var x = __WEBPACK_IMPORTED_MODULE_1__antv_util__["k" /* get */](data, xField, 0);
                var y = __WEBPACK_IMPORTED_MODULE_1__antv_util__["k" /* get */](data, [yField]);
                var xKey = x.toString();
                // todo 是否应该取 _origin？因为 y 可能取到的值不正确，比如先 symmetric，再 stack！
                y = __WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */](y) ? y[1] : y;
                if (!__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */](y)) {
                    var cache = y >= 0 ? positive : negative;
                    if (!cache.has(xKey)) {
                        cache.set(xKey, 0);
                    }
                    var xValue = cache.get(xKey);
                    var newXValue = y + xValue;
                    // 存起来
                    cache.set(xKey, newXValue);
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, data), (_a = {}, _a[yField] = [xValue, newXValue], _a));
                }
                // 没有修改，则直接返回
                return data;
            });
        });
    };
    Stack.prototype.processOneDimStack = function (groupDataArray) {
        var _this = this;
        var _a = this, xField = _a.xField, height = _a.height, reverseOrder = _a.reverseOrder;
        var yField = 'y';
        // 如果层叠的顺序翻转
        var groupedDataArray = reverseOrder ? this.reverse(groupDataArray) : groupDataArray;
        // 缓存累加数据
        var cache = new Cache();
        return groupedDataArray.map(function (dataArray) {
            return dataArray.map(function (data) {
                var _a;
                var size = _this.size;
                var xValue = data[xField];
                // todo 没有看到这个 stack 计算原理
                var stackHeight = (size * 2) / height;
                if (!cache.has(xValue)) {
                    cache.set(xValue, stackHeight / 2); // 初始值大小
                }
                var stackValue = cache.get(xValue);
                // 增加一层 stackHeight
                cache.set(xValue, stackValue + stackHeight);
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, data), (_a = {}, _a[yField] = stackValue, _a));
            });
        });
    };
    return Stack;
}(__WEBPACK_IMPORTED_MODULE_2__adjust__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Stack);
//# sourceMappingURL=stack.js.map

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjust__ = __webpack_require__(109);



var Symmetric = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Symmetric, _super);
    function Symmetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Symmetric.prototype.process = function (groupDataArray) {
        var mergeData = __WEBPACK_IMPORTED_MODULE_1__antv_util__["j" /* flatten */](groupDataArray);
        var _a = this, xField = _a.xField, yField = _a.yField;
        // 每个 x 值对应的 最大值
        var cache = this.getXValuesMaxMap(mergeData);
        // 所有数据的最大的值
        var max = Math.max.apply(Math, Object.keys(cache).map(function (key) { return cache[key]; }));
        return __WEBPACK_IMPORTED_MODULE_1__antv_util__["E" /* map */](groupDataArray, function (dataArray) {
            return __WEBPACK_IMPORTED_MODULE_1__antv_util__["E" /* map */](dataArray, function (data) {
                var _a, _b;
                var yValue = data[yField];
                var xValue = data[xField];
                // 数组处理逻辑
                if (__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */](yValue)) {
                    var off_1 = (max - cache[xValue]) / 2;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, data), (_a = {}, _a[yField] = __WEBPACK_IMPORTED_MODULE_1__antv_util__["E" /* map */](yValue, function (y) { return off_1 + y; }), _a));
                }
                // 非数组处理逻辑
                var offset = (max - yValue) / 2;
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, data), (_b = {}, _b[yField] = [offset, yValue + offset], _b));
            });
        });
    };
    // 获取每个 x 对应的最大的值
    Symmetric.prototype.getXValuesMaxMap = function (mergeData) {
        var _this = this;
        var _a = this, xField = _a.xField, yField = _a.yField;
        // 根据 xField 的值进行分组
        var groupDataArray = __WEBPACK_IMPORTED_MODULE_1__antv_util__["n" /* groupBy */](mergeData, function (data) { return data[xField]; });
        // 获取每个 xField 值中的最大值
        return __WEBPACK_IMPORTED_MODULE_1__antv_util__["F" /* mapValues */](groupDataArray, function (dataArray) { return _this.getDimMaxValue(dataArray, yField); });
    };
    Symmetric.prototype.getDimMaxValue = function (mergeData, dim) {
        // 所有的 value 值
        var dimValues = __WEBPACK_IMPORTED_MODULE_1__antv_util__["E" /* map */](mergeData, function (data) { return __WEBPACK_IMPORTED_MODULE_1__antv_util__["k" /* get */](data, dim, []); });
        // 将数组打平（dim value 有可能是数组，比如 stack 之后的）
        var flattenValues = __WEBPACK_IMPORTED_MODULE_1__antv_util__["j" /* flatten */](dimValues);
        // 求出数组的最大值
        return Math.max.apply(Math, flattenValues);
    };
    return Symmetric;
}(__WEBPACK_IMPORTED_MODULE_2__adjust__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (Symmetric);
//# sourceMappingURL=symmetric.js.map

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__attr__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_equal__ = __webpack_require__(82);






var Identity = __WEBPACK_IMPORTED_MODULE_4__attr__["Identity"],
    Linear = __WEBPACK_IMPORTED_MODULE_4__attr__["Linear"],
    Category = __WEBPACK_IMPORTED_MODULE_4__attr__["Category"]; // 需要映射的属性名

var ATTRS = ['x', 'y', 'color', 'size', 'shape']; // 分组处理的属性

var GROUP_ATTRS = ['color', 'size', 'shape'];

function cloneScale(scale, scaleConfig) {
  // @ts-ignore
  return new scale.constructor(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, scale.__cfg__), scaleConfig));
}

var AttrController = /*#__PURE__*/function () {
  function AttrController(scaleController, attrsRange) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, AttrController);

    this.scaleController = scaleController;
    this.attrsRange = attrsRange;
    this.options = {};
    this.attrs = {};
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(AttrController, [{
    key: "parseOption",
    value: function parseOption(option, attrName) {
      if (!option) {
        return {
          type: 'identity'
        };
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["B" /* isString */])(option)) {
        return {
          field: option,
          type: 'category'
        };
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["x" /* isNumber */])(option)) {
        if (attrName === 'size') {
          return {
            type: 'identity',
            field: option
          };
        }
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["r" /* isArray */])(option)) {
        return {
          field: option[0],
          range: option[1]
        };
      }

      return option;
    }
  }, {
    key: "getAttrOptions",
    value: function getAttrOptions(props, justifyContentCenter) {
      var _this = this;

      if (!props.x || !props.y) {
        throw new Error('x, y are required !');
      }

      var options = {};
      var ranges = this.attrsRange;
      ATTRS.forEach(function (attrName) {
        if (!props[attrName]) return;

        var option = _this.parseOption(props[attrName], attrName);

        if (!option.range) {
          option.range = ranges[attrName];
        }

        options[attrName] = option;
      }); // @ts-ignore

      var x = options.x,
          y = options.y;
      x.justifyContent = justifyContentCenter; // x, y 都是固定Linear 映射

      x.type = Linear;
      y.type = Linear;
      return options;
    }
  }, {
    key: "getDefaultAttrValues",
    value: function getDefaultAttrValues() {
      var _this$attrsRange = this.attrsRange,
          color = _this$attrsRange.color,
          shape = _this$attrsRange.shape;
      return {
        color: color[0],
        shape: shape && shape[0]
      };
    }
  }, {
    key: "getGroupScales",
    value: function getGroupScales() {
      var attrs = this.attrs;
      var scales = [];
      Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["e" /* each */])(GROUP_ATTRS, function (attrName) {
        var attr = attrs[attrName];

        if (!attr) {
          return;
        }

        var scale = attr.scale;

        if (scale && scale.isCategory && scales.indexOf(scale) === -1) {
          scales.push(scale);
        }
      });
      return scales;
    }
  }, {
    key: "createAttr",
    value: function createAttr(option) {
      var type = option.type,
          field = option.field,
          scaleConfig = option.scale;

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["w" /* isNil */])(field) || type === Identity) {
        return new Identity(option);
      }

      var scale = this.scaleController.getScale(field);

      var attrOption = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, option), {}, {
        data: this.scaleController.getData(),
        // scaleConfig 只在属性映射中生效
        scale: scaleConfig ? cloneScale(scale, scaleConfig) : scale
      }); // identity


      if (scale && scale.type === 'identity') {
        return new Identity(attrOption);
      } // Attr的默认类型和scale类型保持一致


      var AttrConstructor = scale.isLinear ? Linear : Category; // custom Attr Constructor

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["v" /* isFunction */])(type)) {
        AttrConstructor = type;
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["B" /* isString */])(type) && __WEBPACK_IMPORTED_MODULE_4__attr__[Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["L" /* upperFirst */])(type)]) {
        AttrConstructor = __WEBPACK_IMPORTED_MODULE_4__attr__[Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["L" /* upperFirst */])(type)];
      }

      return new AttrConstructor(attrOption);
    }
  }, {
    key: "create",
    value: function create(options) {
      this.update(options);
    }
  }, {
    key: "update",
    value: function update(nextOptions) {
      var scaleController = this.scaleController,
          lastOptions = this.options,
          lastAttrs = this.attrs;
      var nextAttrs = {};
      Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["e" /* each */])(nextOptions, function (nextOption, attrName) {
        var lastOption = lastOptions[attrName];

        if (Object(__WEBPACK_IMPORTED_MODULE_5__base_equal__["a" /* default */])(nextOption, lastOption)) {
          nextAttrs[attrName] = lastAttrs[attrName];
        }

        var field = nextOption.field,
            justifyContent = nextOption.justifyContent;

        if (field) {
          scaleController.setScale(field, {
            justifyContent: justifyContent
          });
        }
      });
      this.options = nextOptions;
      this.attrs = nextAttrs;
    }
  }, {
    key: "getAttr",
    value: function getAttr(attrName) {
      var attrs = this.attrs,
          options = this.options;
      var attr = attrs[attrName];

      if (attr) {
        return attr;
      }

      var option = options[attrName];

      if (!option) {
        return null;
      }

      var newAttr = this.createAttr(option);
      attrs[attrName] = newAttr;
      return newAttr;
    }
  }, {
    key: "getAttrs",
    value: function getAttrs() {
      var _this2 = this;

      var options = this.options,
          attrs = this.attrs;
      Object(__WEBPACK_IMPORTED_MODULE_3__antv_util__["e" /* each */])(options, function (option, attrName) {
        _this2.getAttr(attrName);
      });
      return attrs;
    }
  }, {
    key: "isGroupAttr",
    value: function isGroupAttr(attrName) {
      return GROUP_ATTRS.indexOf(attrName) !== -1;
    }
  }, {
    key: "getAttrsByLinear",
    value: function getAttrsByLinear() {
      var attrs = this.attrs;
      var attrNames = Object.keys(attrs);
      var linearAttrs = [];
      var nonlinearAttrs = [];
      attrNames.forEach(function (attrName) {
        if (attrName === 'x' || attrName === 'y') {
          linearAttrs.push(attrName);
          return;
        }

        var scale = attrs[attrName].scale;

        if (scale && scale.type === 'linear') {
          linearAttrs.push(attrName);
        } else {
          nonlinearAttrs.push(attrName);
        }
      });
      return {
        linearAttrs: linearAttrs,
        nonlinearAttrs: nonlinearAttrs
      };
    }
  }]);

  return AttrController;
}();

/* harmony default export */ __webpack_exports__["a"] = (AttrController);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_scale__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deps_d3_interpolate_src__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base__ = __webpack_require__(150);












var Linear = /*#__PURE__*/function (_Base) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Linear, _Base);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Linear);

  function Linear(options) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Linear);

    _this = _super.call(this, options);

    _this._updateInterpolate();

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Linear, [{
    key: "createScale",
    value: function createScale(scaleConfig) {
      return new __WEBPACK_IMPORTED_MODULE_7__antv_scale__["c" /* Linear */](scaleConfig);
    }
  }, {
    key: "_updateInterpolate",
    value: function _updateInterpolate() {
      var _this$range = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(this.range, 2),
          min = _this$range[0],
          max = _this$range[1];

      this.interpolate = Object(__WEBPACK_IMPORTED_MODULE_9__deps_d3_interpolate_src__["a" /* interpolate */])(min, max);
    }
  }, {
    key: "update",
    value: function update(options) {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Linear.prototype), "update", this).call(this, options);

      this._updateInterpolate();
    }
  }, {
    key: "_mapping",
    value: function _mapping(value) {
      var scale = this.scale,
          interpolate = this.interpolate;

      if (Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["r" /* isArray */])(value)) {
        return value.map(function (v) {
          return interpolate(scale.scale(v));
        });
      }

      return interpolate(scale.scale(value));
    }
  }, {
    key: "normalize",
    value: function normalize(value) {
      var scale = this.scale;

      if (Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["r" /* isArray */])(value)) {
        return value.map(function (v) {
          return scale.scale(v);
        });
      }

      return scale.scale(value);
    }
  }, {
    key: "convert",
    value: function convert(value) {
      var range = this.range;

      var _range = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(range, 2),
          min = _range[0],
          max = _range[1];

      if (Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["r" /* isArray */])(value)) {
        return value.map(function (v) {
          return min + (max - min) * v;
        });
      }

      return min + (max - min) * value;
    }
  }]);

  return Linear;
}(__WEBPACK_IMPORTED_MODULE_10__base__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Linear);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__antv_scale__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base__ = __webpack_require__(150);







var Category = /*#__PURE__*/function (_Base) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(Category, _Base);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Category);

  function Category() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Category);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Category, [{
    key: "createScale",
    value: function createScale(scaleConfig) {
      return new __WEBPACK_IMPORTED_MODULE_4__antv_scale__["a" /* Category */](scaleConfig);
    }
  }, {
    key: "_mapping",
    value: function _mapping(value) {
      var scale = this.scale,
          range = this.range;

      if (scale.type === 'cat') {
        var _index = scale.translate(value);

        return range[_index % range.length];
      }

      var normalizeValue = scale.scale(value);
      var index = Math.round(normalizeValue * (range.length - 1));
      return range[index];
    }
  }]);

  return Category;
}(__WEBPACK_IMPORTED_MODULE_5__base__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Category);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__antv_scale__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base__ = __webpack_require__(150);







var Identity = /*#__PURE__*/function (_Base) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(Identity, _Base);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Identity);

  function Identity() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Identity);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Identity, [{
    key: "createScale",
    value: function createScale(scaleConfig) {
      return new __WEBPACK_IMPORTED_MODULE_4__antv_scale__["b" /* Identity */](scaleConfig);
    }
  }, {
    key: "_mapping",
    value: function _mapping() {
      var field = this.field,
          range = this.range;
      return field || range && range[0];
    }
  }]);

  return Identity;
}(__WEBPACK_IMPORTED_MODULE_5__base__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Identity);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withLine__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lineView__ = __webpack_require__(816);
/* unused harmony reexport withLine */
/* unused harmony reexport LineView */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__withLine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__lineView__["a" /* default */]));

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(275);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsx__ = __webpack_require__(20);




function concatPoints(children) {
  var result = [];

  for (var i = 0; i < children.length; i++) {
    var child = children[i];
    result = result.concat(child.points);
  }

  return result;
}

function formatPoint(point) {
  var y = point.y;
  return {
    x: point.x,
    y: Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["r" /* isArray */])(y) ? y[1] : y
  };
}

function getPoint(points, t) {
  var formatedPoints = points.map(function (p) {
    return formatPoint(p);
  });
  var firstPoint = formatedPoints[0];
  var lastPoint = formatedPoints[formatedPoints.length - 1];
  var xOffset = lastPoint.x - firstPoint.x;
  var x = firstPoint.x + xOffset * t;

  for (var i = 1; i < formatedPoints.length; i++) {
    var point = formatedPoints[i];
    var prevPoint = formatedPoints[i - 1];

    if (x >= prevPoint.x && x <= point.x) {
      // x 在 2 点之间的比例，根据比例再算出 y 的值
      var ratio = (x - prevPoint.x) / (point.x - prevPoint.x);
      return {
        x: x,
        y: prevPoint.y + (point.y - prevPoint.y) * ratio
      };
    }
  }
}

function AnimationEndView(props) {
  var record = props.record,
      appear = props.appear,
      EndView = props.EndView;
  var children = record.children;
  var points = concatPoints(children);
  var origin = points[0].origin;
  return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
    animation: {
      appear: {
        easing: appear.easing,
        duration: appear.duration,
        onFrame: function onFrame(t) {
          // 这段逻辑有点恶心。。
          var element = this.element;
          var children = element.get('children');
          var point = getPoint(points, t);
          children.forEach(function (child) {
            child.moveTo(point.x, point.y);
          });
        }
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])(EndView, {
    origin: origin
  }));
}

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var records = props.records,
      coord = props.coord,
      animation = props.animation,
      EndView = props.endView,
      clip = props.clip;
  var left = coord.left,
      top = coord.top,
      width = coord.width,
      height = coord.height,
      center = coord.center,
      startAngle = coord.startAngle,
      endAngle = coord.endAngle,
      radius = coord.radius;
  var appear = coord.isPolar ? {
    easing: 'quadraticOut',
    duration: 450,
    clip: {
      type: 'sector',
      property: ['endAngle'],
      attrs: {
        x: center.x,
        y: center.y,
        startAngle: startAngle,
        r: radius
      },
      start: {
        endAngle: startAngle
      },
      end: {
        endAngle: endAngle
      }
    }
  } : {
    easing: 'quadraticOut',
    duration: 450,
    clip: {
      type: 'rect',
      property: ['width'],
      attrs: {
        x: left,
        y: top,
        height: height
      },
      start: {
        width: 0
      },
      end: {
        width: width
      }
    }
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
    attrs: {
      clip: clip
    }
  }, records.map(function (record) {
    var key = record.key,
        children = record.children;
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
      key: key
    }, children.map(function (child) {
      var points = child.points,
          color = child.color,
          size = child.size,
          shape = child.shape;
      return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("polyline", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          points: points.map(function (point) {
            return {
              x: point.x,
              y: point.y
            };
          }),
          stroke: color
        }, shape), {}, {
          lineWidth: size || shape.lineWidth
        }),
        animation: Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["d" /* deepMix */])({
          update: {
            easing: 'linear',
            duration: 450,
            property: ['points']
          },
          appear: appear
        }, animation)
      });
    }), EndView ? Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])(AnimationEndView, {
      record: record,
      EndView: EndView,
      appear: appear
    }) : null);
  }));
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withArea__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__areaView__ = __webpack_require__(819);
/* unused harmony reexport withArea */
/* unused harmony reexport AreaView */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withArea__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__areaView__["a" /* default */]));

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__line_withLine__ = __webpack_require__(293);







/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_withLine) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Area, _withLine);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Area);

    function Area() {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Area);

      return _super.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Area, [{
      key: "getDefaultCfg",
      value: function getDefaultCfg() {
        return {
          geomType: 'area',
          // 面积图默认设为从0开始
          startOnZero: true,
          // 点需要排序
          sortable: true
        };
      }
    }, {
      key: "mapping",
      value: function mapping() {
        var records = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Area.prototype), "mapping", this).call(this); // 坐标轴 y0


        var y0 = this.getY0Value();
        var props = this.props,
            defaultStartOnZero = this.startOnZero;
        var coord = props.coord,
            _props$startOnZero = props.startOnZero,
            startOnZero = _props$startOnZero === void 0 ? defaultStartOnZero : _props$startOnZero;
        var baseY = coord.y[0];

        if (startOnZero) {
          // 零点映射到绝对坐标
          var originCoord = coord.convertPoint({
            x: 0,
            y: y0
          });
          baseY = originCoord.y;
        }

        for (var i = 0, len = records.length; i < len; i++) {
          var record = records[i];
          var children = record.children;

          for (var j = 0, _len = children.length; j < _len; j++) {
            var child = children[j];
            var points = child.points,
                bottomPoints = child.bottomPoints;

            if (bottomPoints && bottomPoints.length) {
              bottomPoints.reverse();
              child.points = points.concat(bottomPoints);
            } else {
              points.push({
                x: points[points.length - 1].x,
                y: baseY
              });
              points.push({
                x: points[0].x,
                y: baseY
              });
            }
          }
        }

        return records;
      }
    }]);

    return Area;
  }(Object(__WEBPACK_IMPORTED_MODULE_6__line_withLine__["a" /* default */])(View));
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__antv_f2_graphic__ = __webpack_require__(105);




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var coord = props.coord,
      records = props.records,
      shape = props.shape,
      animation = props.animation;
  var isSmooth = shape === 'smooth';
  var left = coord.left,
      top = coord.top,
      width = coord.width,
      height = coord.height,
      center = coord.center,
      startAngle = coord.startAngle,
      endAngle = coord.endAngle,
      radius = coord.radius;
  var appear = coord.isPolar ? {
    easing: 'quadraticOut',
    duration: 450,
    clip: {
      type: 'sector',
      property: ['endAngle'],
      attrs: {
        x: center.x,
        y: center.y,
        startAngle: startAngle,
        r: radius
      },
      start: {
        endAngle: startAngle
      },
      end: {
        endAngle: endAngle
      }
    }
  } : {
    easing: 'quadraticOut',
    duration: 450,
    clip: {
      type: 'rect',
      property: ['width'],
      attrs: {
        x: left,
        y: top,
        height: height
      },
      start: {
        width: 0
      },
      end: {
        width: width
      }
    }
  };
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, records.map(function (record) {
    var key = record.key,
        children = record.children;
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
      key: key
    }, children.map(function (child) {
      var points = child.points,
          bottomPoints = child.bottomPoints,
          color = child.color,
          shape = child.shape;

      if (isSmooth) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("custom", {
          attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
            points: points,
            lineWidth: '2px',
            fill: color
          }, shape),
          createPath: function createPath(context) {
            var constaint = [[0, 0], [1, 1]];
            var bottomPointsLen = (bottomPoints === null || bottomPoints === void 0 ? void 0 : bottomPoints.length) || 0;
            var topPoints = points.slice(0, points.length - bottomPointsLen);
            var topSps = __WEBPACK_IMPORTED_MODULE_3__antv_f2_graphic__["d" /* Smooth */].smooth(topPoints, false, constaint);
            context.beginPath();
            context.moveTo(topPoints[0].x, topPoints[0].y);

            for (var i = 0, n = topSps.length; i < n; i++) {
              var sp = topSps[i];
              context.bezierCurveTo(sp[1], sp[2], sp[3], sp[4], sp[5], sp[6]);
            }

            if (bottomPointsLen) {
              var bottomSps = __WEBPACK_IMPORTED_MODULE_3__antv_f2_graphic__["d" /* Smooth */].smooth(bottomPoints, false, constaint);
              context.lineTo(bottomPoints[0].x, bottomPoints[0].y);

              for (var _i = 0, _n = bottomSps.length; _i < _n; _i++) {
                var _sp = bottomSps[_i];
                context.bezierCurveTo(_sp[1], _sp[2], _sp[3], _sp[4], _sp[5], _sp[6]);
              }
            }

            context.closePath();
          },
          calculateBox: function calculateBox() {
            return __WEBPACK_IMPORTED_MODULE_3__antv_f2_graphic__["a" /* BBox */].getBBoxFromPoints(points);
          }
        });
      }

      return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("polygon", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          points: points,
          lineWidth: '2px',
          fill: color
        }, shape),
        animation: Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])({
          appear: appear,
          update: {
            easing: 'linear',
            duration: 450,
            property: ['points']
          }
        }, animation)
      });
    }));
  }));
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withInterval__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_intervalView__ = __webpack_require__(297);
/* unused harmony reexport withInterval */
/* unused harmony reexport IntervalView */




/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withInterval__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__view__));

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__geometry__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__label__ = __webpack_require__(822);










/* harmony default export */ __webpack_exports__["a"] = (function (Views) {
  return /*#__PURE__*/function (_Geometry) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Interval, _Geometry);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Interval);

    function Interval() {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Interval);

      return _super.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Interval, [{
      key: "getDefaultCfg",
      value: function getDefaultCfg() {
        return {
          geomType: 'interval',
          justifyContent: true,
          startOnZero: true
        };
      }
    }, {
      key: "getDefaultSize",
      value: function getDefaultSize() {
        var attrs = this.attrs,
            props = this.props,
            adjust = this.adjust,
            records = this.records;
        var coord = props.coord,
            sizeRatio = props.sizeRatio;
        var x = attrs.x;
        var scale = x.scale;
        var values = scale.values;

        if (sizeRatio) {
          return 1 / values.length * sizeRatio;
        }

        var defaultWithRatio = {
          column: 1 / 2,
          rose: 0.999999,
          multiplePie: 3 / 4 // 多饼图

        };
        var count = values.length;
        var ratio;

        if (coord.isPolar) {
          if (coord.transposed && count > 1) {
            ratio = defaultWithRatio.multiplePie;
          } else {
            ratio = defaultWithRatio.rose;
          }
        } else {
          ratio = defaultWithRatio.column;
        }

        var size = 1 / values.length * ratio; // 分组时size要除以类别个数

        if (adjust && adjust.type === 'dodge') {
          return size / records.length;
        }

        return size;
      }
    }, {
      key: "mapping",
      value: function mapping() {
        var records = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Interval.prototype), "mapping", this).call(this);

        var props = this.props;
        var coord = props.coord;
        var y0 = this.getY0Value();
        var defaultSize = this.getDefaultSize();

        for (var i = 0, len = records.length; i < len; i++) {
          var record = records[i];
          var children = record.children;

          for (var j = 0, _len = children.length; j < _len; j++) {
            var child = children[j];
            var normalized = child.normalized,
                mappedSize = child.size; // 没有指定size，则根据数据来计算默认size

            if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["w" /* isNil */])(mappedSize)) {
              var x = normalized.x,
                  y = normalized.y,
                  _normalized$size = normalized.size,
                  size = _normalized$size === void 0 ? defaultSize : _normalized$size;
              Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["G" /* mix */])(child, coord.convertRect({
                x: x,
                y: y,
                y0: y0,
                size: size
              }));
            } else {
              var _x = child.x,
                  _y = child.y;
              var rect = {
                size: mappedSize,
                x: _x,
                y: _y,
                y0: y0
              };
              Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["G" /* mix */])(child, coord.transformToRect(rect));
            }

            Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["G" /* mix */])(child.shape, this.getSelectionStyle(child));
          }
        }

        return records;
      } // 获取Y轴坐标零点的画布位置

    }, {
      key: "getPointY0",
      value: function getPointY0() {
        var props = this.props;
        var coord = props.coord;
        var y0 = this.getY0Value();
        var y0Point = coord.convertPoint({
          y: y0,
          x: 0
        });
        return y0Point === null || y0Point === void 0 ? void 0 : y0Point.y;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            state = this.state,
            container = this.container;
        var coord = props.coord,
            _props$shape = props.shape,
            shape = _props$shape === void 0 ? 'rect' : _props$shape,
            animation = props.animation,
            showLabel = props.showLabel,
            customLabelCfg = props.labelCfg;
        var View = Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(Views) ? Views : Views[shape];
        var LabelView = __WEBPACK_IMPORTED_MODULE_9__label__[shape];
        var labelCfg = Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["d" /* deepMix */])({
          label: null,
          offsetX: 0,
          offsetY: 0
        }, customLabelCfg);
        if (!View) return null;
        var selected = state.selected;
        var records = this.mapping();
        var pointY0 = this.getPointY0();
        var clip = this.getClip();
        return Object(__WEBPACK_IMPORTED_MODULE_7__jsx__["c" /* jsx */])(View, {
          coord: coord,
          records: records,
          selected: selected,
          shape: shape,
          animation: animation,
          showLabel: showLabel,
          labelCfg: labelCfg,
          LabelView: LabelView,
          y0: pointY0,
          clip: clip
        });
      }
    }]);

    return Interval;
  }(__WEBPACK_IMPORTED_MODULE_8__geometry__["a" /* default */]);
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonLabel__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pyramid", function() { return __WEBPACK_IMPORTED_MODULE_0__polygonLabel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "funnel", function() { return __WEBPACK_IMPORTED_MODULE_0__polygonLabel__["a"]; });



/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intervalView__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rect", function() { return __WEBPACK_IMPORTED_MODULE_0__intervalView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polygonView__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pyramid", function() { return __WEBPACK_IMPORTED_MODULE_1__polygonView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "funnel", function() { return __WEBPACK_IMPORTED_MODULE_1__polygonView__["a"]; });
// 柱图/条图
 // 金字塔图

 // 漏斗图



/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsx__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var records = props.records,
      animation = props.animation,
      y0 = props.y0,
      clip = props.clip;
  return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
    attrs: {
      clip: clip
    }
  }, records.map(function (record) {
    var key = record.key,
        children = record.children;
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
      key: key
    }, children.map(function (item) {
      var key = item.key,
          xMin = item.xMin,
          xMax = item.xMax,
          yMin = item.yMin,
          yMax = item.yMax,
          color = item.color,
          shape = item.shape;

      if (isNaN(xMin) || isNaN(xMax) || isNaN(yMin) || isNaN(yMax)) {
        return null;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("rect", {
        key: key,
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          x: xMin,
          y: yMin,
          width: xMax - xMin,
          height: yMax - yMin,
          fill: color
        }, shape),
        animation: Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["d" /* deepMix */])({
          appear: {
            easing: 'linear',
            duration: 450,
            property: ['y', 'height'],
            start: {
              y: y0,
              height: 0
            }
          },
          update: {
            easing: 'linear',
            duration: 450,
            property: ['x', 'y', 'width', 'height']
          }
        }, animation)
      });
    }));
  }));
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var coord = props.coord,
      records = props.records,
      animation = props.animation;
  var center = coord.center,
      startAngle = coord.startAngle,
      endAngle = coord.endAngle,
      radius = coord.radius;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
    animation: {
      appear: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        easing: 'quadraticOut',
        duration: 450
      }, animation && animation.appear), {}, {
        clip: {
          type: 'sector',
          property: ['endAngle'],
          attrs: {
            x: center.x,
            y: center.y,
            startAngle: startAngle,
            r: radius
          },
          start: {
            endAngle: startAngle
          },
          end: {
            endAngle: endAngle
          }
        }
      })
    }
  }, records.map(function (record) {
    var key = record.key,
        children = record.children;
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
      key: key
    }, children.map(function (item) {
      var key = item.key,
          xMin = item.xMin,
          xMax = item.xMax,
          yMin = item.yMin,
          yMax = item.yMax,
          color = item.color,
          shape = item.shape;
      return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("sector", {
        key: key,
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          x: center.x,
          y: center.y,
          fill: color,
          startAngle: xMin,
          endAngle: xMax,
          r0: yMin,
          r: yMax
        }, shape),
        animation: Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])({
          update: {
            easing: 'linear',
            duration: 450,
            property: ['x', 'y', 'startAngle', 'endAngle', 'r0', 'r']
          }
        }, animation)
      });
    }));
  }));
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPoints; });
function convertToPoints(_ref) {
  var xMin = _ref.xMin,
      xMax = _ref.xMax,
      yMin = _ref.yMin,
      yMax = _ref.yMax;
  return [{
    x: xMin,
    y: yMin
  }, {
    x: xMax,
    y: yMin
  }, {
    x: xMax,
    y: yMax
  }, {
    x: xMin,
    y: yMax
  } // bl
  ];
}



/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withPoint__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pointView__ = __webpack_require__(829);
/* unused harmony reexport PointView */
/* unused harmony reexport withPoint */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__withPoint__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__pointView__["a" /* default */]));

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__geometry__ = __webpack_require__(148);







/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Geometry) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Point, _Geometry);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Point);

    function Point() {
      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Point);

      return _super.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Point, [{
      key: "getDefaultCfg",
      value: function getDefaultCfg() {
        return {
          geomType: 'point'
        };
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            container = this.container;
        var coord = props.coord;
        var records = this.mapping();
        var clip = this.getClip();
        return Object(__WEBPACK_IMPORTED_MODULE_5__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          coord: coord,
          records: records,
          clip: clip
        }));
      }
    }]);

    return Point;
  }(__WEBPACK_IMPORTED_MODULE_6__geometry__["a" /* default */]);
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsx__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var records = props.records,
      animation = props.animation,
      clip = props.clip;
  return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
    attrs: {
      clip: clip
    }
  }, records.map(function (record) {
    var key = record.key,
        children = record.children;
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
      key: key
    }, children.map(function (item) {
      var x = item.x,
          y = item.y,
          size = item.size,
          color = item.color,
          shapeName = item.shapeName,
          shape = item.shape;

      if (isNaN(x) || isNaN(y)) {
        return null;
      }

      if (shapeName === 'rect') {
        var rectSize = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(size) ? shape.size : size;
        return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("rect", {
          attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
            x: x - rectSize,
            y: y - rectSize,
            fill: color,
            stroke: color
          }, shape), {}, {
            width: rectSize * 2,
            height: rectSize * 2
          }),
          animation: Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["d" /* deepMix */])({
            appear: {
              easing: 'linear',
              duration: 450
            },
            update: {
              easing: 'linear',
              duration: 450,
              property: ['x', 'y', 'width', 'height', 'fill']
            }
          }, animation)
        });
      }

      return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("circle", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          x: x,
          y: y,
          fill: shapeName === 'circle' ? color : null,
          stroke: shapeName === 'hollowCircle' ? color : null
        }, shape), {}, {
          r: Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["w" /* isNil */])(size) ? shape.size : size
        }),
        animation: Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["d" /* deepMix */])({
          appear: {
            easing: 'linear',
            duration: 450
          },
          update: {
            easing: 'linear',
            duration: 450,
            property: ['x', 'y', 'r', 'fill']
          }
        }, animation)
      });
    }));
  }));
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withAxis__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axisView__ = __webpack_require__(832);
/* unused harmony reexport withAxis */
/* unused harmony reexport AxisView */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__withAxis__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__axisView__["a" /* default */]));

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_equal__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_component__ = __webpack_require__(58);










/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Axis, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Axis);

    function Axis(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Axis);

      _this = _super.call(this, props);
      _this.style = {};
      var _this$props = _this.props,
          chart = _this$props.chart,
          field = _this$props.field;

      var scaleOption = _this.getScaleOption(props);

      chart.setScale(field, scaleOption);
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Axis, [{
      key: "willReceiveProps",
      value: function willReceiveProps(nextProps) {
        var lastProps = this.props;
        var chart = nextProps.chart,
            field = nextProps.field;
        var nextScaleOption = this.getScaleOption(nextProps);
        var lastScaleOption = this.getScaleOption(lastProps);

        if (!Object(__WEBPACK_IMPORTED_MODULE_8__base_equal__["a" /* default */])(nextScaleOption, lastScaleOption)) {
          chart.setScale(field, nextScaleOption);
        }
      }
    }, {
      key: "willMount",
      value: function willMount() {
        this.updateCoord();
      }
    }, {
      key: "willUpdate",
      value: function willUpdate() {
        this.updateCoord();
      }
    }, {
      key: "getScaleOption",
      value: function getScaleOption(props) {
        var type = props.type,
            tickCount = props.tickCount,
            range = props.range,
            mask = props.mask,
            formatter = props.formatter,
            ticks = props.ticks,
            min = props.min,
            max = props.max,
            nice = props.nice;
        return {
          type: type,
          tickCount: tickCount,
          range: range,
          mask: mask,
          formatter: formatter,
          min: min,
          max: max,
          nice: nice,
          ticks: ticks
        };
      }
    }, {
      key: "_getDimType",
      value: function _getDimType() {
        var props = this.props;
        var field = props.field,
            chart = props.chart;
        var xScales = chart.getXScales();
        var scales = xScales.filter(function (scale) {
          return scale.field === field;
        });
        return scales.length > 0 ? 'x' : 'y';
      } // 获取ticks最大的宽高

    }, {
      key: "getMaxBBox",
      value: function getMaxBBox(ticks, style) {
        var context = this.context;
        var measureText = context.measureText;
        var label = style.label,
            labelOffset = style.labelOffset;
        var width = 0;
        var height = 0;
        ticks.forEach(function (tick) {
          if (!label) return;
          var _tick$labelStyle = tick.labelStyle,
              labelStyle = _tick$labelStyle === void 0 ? {} : _tick$labelStyle,
              text = tick.text;
          var bbox = measureText(labelStyle.text || text, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, label), labelStyle));
          width = Math.max(width, bbox.width);
          height = Math.max(height, bbox.height);
        });

        if (!width && !height) {
          return {
            width: width,
            height: height
          };
        }

        var bbox = {
          width: width + labelOffset,
          height: height + labelOffset
        };
        return bbox;
      }
    }, {
      key: "_getPosition",
      value: function _getPosition() {
        var props = this.props;
        var position = props.position,
            coord = props.coord;

        if (position) {
          return position;
        }

        var dimType = this._getDimType();

        if (coord.transposed) {
          return dimType === 'x' ? 'left' : 'bottom';
        }

        return dimType === 'x' ? 'bottom' : 'left';
      }
    }, {
      key: "getTicks",
      value: function getTicks() {
        var props = this.props;
        var field = props.field,
            chart = props.chart;
        var scale = chart.getScale(field);
        var ticks = scale.getTicks(); // 设置tick的样式

        ticks = this._setTicksStyle(ticks);
        ticks = this._generateGridPoints(ticks);
        return ticks;
      }
      /**
       * 生成极坐标下网格线的交叉点
       * @param ticks
       * @returns
       */

    }, {
      key: "_generateGridPoints",
      value: function _generateGridPoints(ticks) {
        var props = this.props;
        var chart = props.chart,
            coord = props.coord;

        if (!coord.isPolar) {
          return ticks;
        }

        var dimType = this._getDimType(); // 只需要在 y 的时候生成


        if (dimType !== 'y') {
          return ticks;
        }

        var xScale = chart.getXScales()[0];
        var xTicks = xScale.getTicks();
        ticks.forEach(function (tick) {
          var gridPoints = xTicks.map(function (xTick) {
            return coord.convertPoint({
              x: xTick.value,
              y: tick.value
            });
          }); // 添加第 1 个点，形成环状

          gridPoints.push(gridPoints[0]);
          tick.gridPoints = gridPoints;
        });
        return ticks;
      }
    }, {
      key: "_setTicksStyle",
      value: function _setTicksStyle(ticks) {
        var _this2 = this;

        var props = this.props,
            context = this.context;
        var theme = context.theme,
            px2hd = context.px2hd;
        var _props$style = props.style,
            style = _props$style === void 0 ? {} : _props$style;
        var themeAxis = theme.axis;
        Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["e" /* each */])(themeAxis, function (value, key) {
          // 关闭tick的样式
          if (style[key] === null) {
            return;
          }

          var styleValue = Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(style[key]) ? undefined : style[key];

          if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["B" /* isString */])(value) || Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["x" /* isNumber */])(value)) {
            _this2.style[key] = px2hd(styleValue) || value;
          } else {
            _this2.style[key] = px2hd(Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["d" /* deepMix */])(Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["c" /* clone */])(value), styleValue));
          }
        });
        return ticks.map(function (tick, index) {
          var label = style.label,
              grid = style.grid;
          var defaultLabelStyle = themeAxis.label,
              defaultGridStyle = themeAxis.grid;

          if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(label)) {
            tick.labelStyle = px2hd(Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["G" /* mix */])({}, defaultLabelStyle, label(tick.text, index, ticks)));
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(grid)) {
            tick.gridStyle = px2hd(Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["G" /* mix */])({}, defaultGridStyle, grid(tick.text, index, ticks.length)));
          }

          return tick;
        });
      }
    }, {
      key: "convertTicks",
      value: function convertTicks(ticks) {
        var props = this.props;
        var coord = props.coord;

        var dimType = this._getDimType();

        var otherDim = dimType === 'x' ? 'y' : 'x';
        return ticks.map(function (tick) {
          var _coord$convertPoint, _coord$convertPoint2;

          var start = coord.convertPoint((_coord$convertPoint = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_coord$convertPoint, dimType, tick.value), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_coord$convertPoint, otherDim, 0), _coord$convertPoint));
          var end = coord.convertPoint((_coord$convertPoint2 = {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_coord$convertPoint2, dimType, tick.value), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_coord$convertPoint2, otherDim, 1), _coord$convertPoint2));
          return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, tick), {}, {
            points: [start, end]
          });
        });
      }
    }, {
      key: "measureLayout",
      value: function measureLayout() {
        var props = this.props;
        var visible = props.visible,
            coord = props.coord;

        if (visible === false) {
          return null;
        }

        var ticks = this.getTicks();
        var bbox = this.getMaxBBox(ticks, this.style);
        var isPolar = coord.isPolar;

        var dimType = this._getDimType();

        var width = bbox.width,
            height = bbox.height;

        if (isPolar) {
          // 机坐标系的 y 不占位置
          if (dimType === 'y') {
            return null;
          } // 4 个方向都需要留空


          return ['top', 'right', 'bottom', 'left'].map(function (position) {
            return {
              position: position,
              width: width,
              height: height
            };
          });
        } // 直角坐标系下


        var position = this._getPosition();

        return {
          position: position,
          width: width,
          height: height
        };
      } // 主要是计算coord的布局

    }, {
      key: "updateCoord",
      value: function updateCoord() {
        var props = this.props;
        var chart = props.chart;
        var layout = this.measureLayout();
        chart.updateCoordFor(this, layout);
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            style = this.style;
        var visible = props.visible,
            coord = props.coord;

        if (visible === false) {
          return null;
        }

        var ticks = this.getTicks();

        var position = this._getPosition();

        var dimType = this._getDimType();

        return Object(__WEBPACK_IMPORTED_MODULE_7__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          style: style,
          ticks: this.convertTicks(ticks),
          coord: coord,
          position: position,
          dimType: dimType
        }));
      }
    }]);

    return Axis;
  }(__WEBPACK_IMPORTED_MODULE_9__base_component__["a" /* default */]);
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_polar_x__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_polar_y__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rect_top__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rect_bottom__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rect_right__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rect_left__ = __webpack_require__(838);









function isPolar(props) {
  return props.coord.isPolar;
}

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  // 极坐标
  if (isPolar(props)) {
    var dimType = props.dimType;

    if (dimType === 'x') {
      return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_2__polar_polar_x__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_3__polar_polar_y__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  }

  var position = props.position; // 直角坐标

  if (position === 'right') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_6__rect_right__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  }

  if (position === 'left') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_7__rect_left__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  }

  if (position === 'top') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_4__rect_top__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_5__rect_bottom__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_f2_graphic__ = __webpack_require__(105);


 // const { Vector2 } = G;
// 相对圆心偏移量的点

function getOffsetPoint(center, point, offset) {
  var vectorX = point.x - center.x;
  var vectorY = point.y - center.y;
  var vector = [vectorX, vectorY];
  var vectorLength = __WEBPACK_IMPORTED_MODULE_2__antv_f2_graphic__["e" /* Vector2 */].length(vector);
  var offsetLength = vectorLength + offset;
  var x = vectorX / vectorLength * offsetLength;
  var y = vectorY / vectorLength * offsetLength;
  return {
    x: center.x + x,
    y: center.y + y
  };
} // 获取文本的对齐方式


function getTextAlignInfo(center, point) {
  // 文本点向量
  var vector = [point.x - center.x, point.y - center.y];
  var align;
  var baseLine; // 水平对齐

  if (vector[0] > 0) {
    align = 'left';
  } else if (vector[0] < 0) {
    align = 'right';
  } else {
    align = 'center';
  } // 垂直对齐


  if (vector[1] > 0) {
    baseLine = 'top';
  } else if (vector[1] < 0) {
    baseLine = 'bottom';
  } else {
    baseLine = 'middle';
  }

  return {
    textAlign: align,
    textBaseline: baseLine
  };
}

var Line = function Line(props) {
  var line = props.line,
      gridType = props.gridType,
      center = props.center,
      radius = props.radius,
      ticks = props.ticks;
  if (!line) return null;

  if (gridType !== 'line') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("arc", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: center.x,
        y: center.y,
        r: radius
      }, line)
    });
  }

  var points = ticks.map(function (tick) {
    var points = tick.points;
    return points[points.length - 1];
  }); // 头尾相连

  points.push(points[0]);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("polyline", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      points: points
    }, line)
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var ticks = props.ticks,
      coord = props.coord,
      style = props.style,
      gridType = props.grid;
  var center = coord.center;
  var grid = style.grid,
      tickLine = style.tickLine,
      line = style.line,
      labelOffset = style.labelOffset,
      label = style.label;
  var firstTicks = ticks[0];
  var points = firstTicks.points;
  var end = points[points.length - 1];
  var radius = __WEBPACK_IMPORTED_MODULE_2__antv_f2_graphic__["e" /* Vector2 */].length([end.x - center.x, end.y - center.y]);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, grid ? ticks.map(function (tick) {
    var points = tick.points,
        gridStyle = tick.gridStyle;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: center.x,
        y1: center.y,
        x2: end.x,
        y2: end.y
      }, grid), gridStyle)
    });
  }) : null, tickLine && tickLine.length ? ticks.map(function (tick) {
    var points = tick.points;
    var end = points[points.length - 1];
    var offsetPoint = getOffsetPoint(center, end, tickLine.length);
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: end.x,
        y1: end.y,
        x2: offsetPoint.x,
        y2: offsetPoint.y
      }, tickLine)
    });
  }) : null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(Line, {
    line: line,
    gridType: gridType,
    center: center,
    radius: radius,
    ticks: ticks
  }), label ? ticks.map(function (tick) {
    var points = tick.points,
        text = tick.text,
        labelStyle = tick.labelStyle;
    var end = points[points.length - 1];
    var offsetPoint = getOffsetPoint(center, end, labelOffset);
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: offsetPoint.x,
        y: offsetPoint.y,
        text: text
      }, getTextAlignInfo(center, end)), label), labelStyle)
    });
  }) : null);
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_f2_graphic__ = __webpack_require__(105);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var ticks = props.ticks,
      coord = props.coord,
      style = props.style,
      gridType = props.grid;
  var center = coord.center;
  var grid = style.grid,
      tickLine = style.tickLine,
      line = style.line,
      labelOffset = style.labelOffset,
      label = style.label;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, grid ? ticks.map(function (tick) {
    var points = tick.points,
        gridStyle = tick.gridStyle,
        gridPoints = tick.gridPoints;
    var end = points[points.length - 1];

    if (gridType !== 'line') {
      return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("arc", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          x: center.x,
          y: center.y,
          r: __WEBPACK_IMPORTED_MODULE_2__antv_f2_graphic__["e" /* Vector2 */].length([end.x - center.x, end.y - center.y])
        }, grid), gridStyle)
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("polyline", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        points: gridPoints
      }, grid), gridStyle)
    });
  }) : null, tickLine && tickLine.length ? ticks.map(function (tick) {
    var points = tick.points;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: end.x,
        y1: end.y,
        x2: end.x - tickLine.length,
        y2: end.y
      }, tickLine)
    });
  }) : null, line ? Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: ticks[0].points[0].x,
      y1: ticks[0].points[0].y,
      x2: ticks[ticks.length - 1].points[0].x,
      y2: ticks[ticks.length - 1].points[0].y
    }, line)
  }) : null, label ? ticks.map(function (tick) {
    var points = tick.points,
        text = tick.text,
        labelStyle = tick.labelStyle;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: end.x - labelOffset,
        y: end.y,
        text: text,
        textAlign: 'right',
        textBaseline: 'middle'
      }, label), labelStyle)
    });
  }) : null);
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var ticks = props.ticks,
      coord = props.coord,
      style = props.style;
  var left = coord.left,
      top = coord.top,
      right = coord.right;
  var grid = style.grid,
      tickLine = style.tickLine,
      line = style.line,
      labelOffset = style.labelOffset,
      label = style.label;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, grid ? ticks.map(function (tick) {
    var points = tick.points,
        gridStyle = tick.gridStyle;
    var start = points[0];
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
      }, grid), gridStyle)
    });
  }) : null, tickLine && tickLine.length ? ticks.map(function (tick) {
    var points = tick.points;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: end.x,
        y1: end.y,
        x2: end.x,
        y2: end.y - tickLine.length
      }, tickLine)
    });
  }) : null, line ? Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: left,
      y1: top,
      x2: right,
      y2: top
    }, line)
  }) : null, label ? ticks.map(function (tick, _index) {
    var points = tick.points,
        text = tick.text,
        labelStyle = tick.labelStyle;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: end.x,
        y: end.y - labelOffset,
        textAlign: 'center',
        textBaseline: 'bottom',
        text: text
      }, label), labelStyle)
    });
  }) : null);
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var ticks = props.ticks,
      coord = props.coord,
      style = props.style,
      animation = props.animation;
  var px2hd = context.px2hd;
  var left = coord.left,
      right = coord.right,
      bottom = coord.bottom;
  var grid = style.grid,
      tickLine = style.tickLine,
      line = style.line,
      labelOffset = style.labelOffset,
      label = style.label;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, grid ? ticks.map(function (tick) {
    var points = tick.points,
        tickValue = tick.tickValue,
        gridStyle = tick.gridStyle;
    var start = points[0];
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      key: tickValue,
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
      }, grid), gridStyle)
    });
  }) : null, tickLine && tickLine.length ? ticks.map(function (tick) {
    var points = tick.points,
        tickValue = tick.tickValue;
    var start = points[0];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      key: tickValue,
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: start.x,
        y1: start.y,
        x2: start.x,
        y2: start.y + px2hd(tickLine.length)
      }, tickLine)
    });
  }) : null, line ? Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: left,
      y1: bottom,
      x2: right,
      y2: bottom
    }, line)
  }) : null, label ? ticks.map(function (tick, index) {
    var points = tick.points,
        text = tick.text,
        tickValue = tick.tickValue,
        labelStyle = tick.labelStyle;
    var start = points[0];

    var _ref = labelStyle || label || {},
        _ref$align = _ref.align,
        align = _ref$align === void 0 ? 'center' : _ref$align;

    var textAttrs = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x: start.x,
      y: start.y + labelOffset,
      textBaseline: 'top',
      text: text
    }, label), labelStyle);

    if (align === 'between') {
      if (index === 0) {
        textAttrs.textAlign = 'start';
      } else if (index === ticks.length - 1) {
        textAttrs.textAlign = 'end';
      } else {
        textAttrs.textAlign = 'center';
      }
    } else {
      textAttrs.textAlign = align;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      key: tickValue,
      attrs: textAttrs,
      animation: animation || {
        appear: {
          easing: 'linear',
          duration: 300,
          delay: 0,
          property: ['fillOpacity'],
          start: {
            fillOpacity: 0
          },
          end: {
            fillOpacity: 1
          }
        },
        update: {
          easing: 'linear',
          duration: 450,
          delay: 0,
          property: ['x', 'y']
        },
        leave: {
          easing: 'linear',
          duration: 450,
          delay: 0,
          property: ['fillOpacity'],
          start: {
            fillOpacity: 1
          },
          end: {
            fillOpacity: 0
          }
        }
      }
    });
  }) : null);
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var ticks = props.ticks,
      coord = props.coord,
      style = props.style;
  var top = coord.top,
      right = coord.right,
      bottom = coord.bottom;
  var grid = style.grid,
      tickLine = style.tickLine,
      line = style.line,
      labelOffset = style.labelOffset,
      label = style.label;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, grid ? ticks.map(function (tick) {
    var points = tick.points,
        gridStyle = tick.gridStyle;
    var start = points[0];
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
      }, grid), gridStyle)
    });
  }) : null, tickLine && tickLine.length ? ticks.map(function (tick) {
    var points = tick.points;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: end.x,
        y1: end.y,
        x2: end.x + tickLine.length,
        y2: end.y
      }, tickLine)
    });
  }) : null, line ? Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: right,
      y1: top,
      x2: right,
      y2: bottom
    }, line)
  }) : null, label ? ticks.map(function (tick, _index) {
    var points = tick.points,
        text = tick.text,
        labelStyle = tick.labelStyle;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: end.x + labelOffset,
        y: end.y,
        textAlign: 'left',
        textBaseline: 'middle',
        text: text
      }, label), labelStyle)
    });
  }) : null);
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var ticks = props.ticks,
      coord = props.coord,
      style = props.style,
      animation = props.animation;
  var left = coord.left,
      top = coord.top,
      bottom = coord.bottom;
  var grid = style.grid,
      tickLine = style.tickLine,
      line = style.line,
      labelOffset = style.labelOffset,
      label = style.label;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, grid ? ticks.map(function (tick) {
    var points = tick.points,
        tickValue = tick.tickValue,
        gridStyle = tick.gridStyle;
    var start = points[0];
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      key: tickValue,
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y
      }, grid), gridStyle)
    });
  }) : null, tickLine && tickLine.length ? ticks.map(function (tick) {
    var points = tick.points,
        tickValue = tick.tickValue;
    var start = points[0];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
      key: tickValue,
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: start.x,
        y1: start.y,
        x2: start.x - tickLine.length,
        y2: start.y
      }, tickLine)
    });
  }) : null, line ? Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: left,
      y1: top,
      x2: left,
      y2: bottom
    }, line)
  }) : null, label ? ticks.map(function (tick, _index) {
    var tickValue = tick.tickValue,
        points = tick.points,
        text = tick.text,
        labelStyle = tick.labelStyle;
    var start = points[0];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      key: tickValue,
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: start.x - labelOffset,
        y: start.y,
        textAlign: 'right',
        textBaseline: 'middle',
        text: text
      }, label), labelStyle),
      animation: animation || {
        appear: {
          easing: 'linear',
          duration: 300,
          delay: 0,
          property: ['fillOpacity'],
          start: {
            fillOpacity: 0
          },
          end: {
            fillOpacity: 1
          }
        },
        update: {
          easing: 'linear',
          duration: 450,
          delay: 0,
          property: ['x', 'y']
        },
        leave: {
          easing: 'linear',
          duration: 450,
          delay: 0,
          property: ['fillOpacity'],
          start: {
            fillOpacity: 1
          },
          end: {
            fillOpacity: 0
          }
        }
      }
    });
  }) : null);
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withLegend__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__legendView__ = __webpack_require__(841);
/* unused harmony reexport withLegend */
/* unused harmony reexport LegendView */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withLegend__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__legendView__["a" /* default */]));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_diff__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(98);











/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Legend, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Legend);

    function Legend(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Legend);

      _this = _super.call(this, props);
      _this.state = {
        filtered: {},
        items: []
      };
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(Legend, [{
      key: "getOriginItems",
      value: function getOriginItems() {
        var chart = this.props.chart;
        return chart.getLegendItems();
      }
    }, {
      key: "getItems",
      value: function getItems() {
        var _props$items;

        var props = this.props,
            state = this.state;
        var filtered = state.filtered;
        var renderItems = ((_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.length) ? props.items : this.getOriginItems();
        if (!renderItems) return null;
        return renderItems.map(function (item) {
          var tickValue = item.tickValue;
          return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, item), {}, {
            filtered: filtered[tickValue]
          });
        });
      }
    }, {
      key: "setItems",
      value: function setItems(items) {
        this.setState({
          items: items
        });
      }
    }, {
      key: "getMaxItemBox",
      value: function getMaxItemBox(legendShape) {
        var maxItemWidth = 0;
        var maxItemHeight = 0;
        (legendShape.get('children') || []).forEach(function (child) {
          var _child$get = child.get('attrs'),
              width = _child$get.width,
              height = _child$get.height;

          maxItemWidth = Math.max(maxItemWidth, width);
          maxItemHeight = Math.max(maxItemHeight, height);
        });
        return {
          width: maxItemWidth,
          height: maxItemHeight
        };
      } // 计算 legend 的位置

    }, {
      key: "_init",
      value: function _init() {
        var props = this.props,
            context = this.context;
        var parentLayout = props.layout,
            customWidth = props.width,
            customHeight = props.height,
            _props$position = props.position,
            position = _props$position === void 0 ? 'top' : _props$position;
        var items = this.getItems();
        if (!items || !items.length) return;
        var left = parentLayout.left,
            top = parentLayout.top,
            right = parentLayout.right,
            bottom = parentLayout.bottom,
            layoutWidth = parentLayout.width,
            layoutHeight = parentLayout.height;
        var width = context.px2hd(customWidth) || layoutWidth;
        var shape = Object(__WEBPACK_IMPORTED_MODULE_7__base_diff__["d" /* renderShape */])(this, this.render(), false);

        var _this$getMaxItemBox = this.getMaxItemBox(shape),
            itemMaxWidth = _this$getMaxItemBox.width,
            itemMaxHeight = _this$getMaxItemBox.height; // 每行最多的个数


        var lineMaxCount = Math.floor(width / itemMaxWidth);
        var itemCount = items.length; // legend item 的行数

        var lineCount = Math.ceil(itemCount / lineMaxCount);
        var itemWidth = width / lineMaxCount;
        var autoHeight = itemMaxHeight * lineCount;
        var style = {
          left: left,
          top: top,
          width: width,
          // height 默认自适应
          height: undefined,
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }; // 如果只有一行，2端对齐

        if (lineCount === 1) {
          style.justifyContent = 'space-between';
        }

        if (position === 'top') {
          style.height = customHeight ? customHeight : autoHeight;
        }

        if (position === 'left') {
          style.flexDirection = 'column';
          style.justifyContent = 'center';
          style.width = itemMaxWidth;
          style.height = customHeight ? customHeight : layoutHeight;
        }

        if (position === 'right') {
          style.flexDirection = 'column';
          style.alignItems = 'flex-start';
          style.justifyContent = 'center';
          style.width = itemMaxWidth;
          style.height = customHeight ? customHeight : layoutHeight;
          style.left = right - itemMaxWidth;
        }

        if (position === 'bottom') {
          style.top = bottom - autoHeight;
          style.height = customHeight ? customHeight : autoHeight;
        }

        this.itemWidth = itemWidth;
        this.style = style;
        shape.remove();
      }
    }, {
      key: "updateCoord",
      value: function updateCoord() {
        var context = this.context,
            props = this.props,
            style = this.style;
        var _props$position2 = props.position,
            position = _props$position2 === void 0 ? 'top' : _props$position2,
            _props$margin = props.margin,
            margin = _props$margin === void 0 ? '30px' : _props$margin,
            chart = props.chart;
        var width = style.width,
            height = style.height;
        var marginNumber = context.px2hd(margin);
        chart.updateCoordFor(this, {
          position: position,
          width: width + marginNumber,
          height: height + marginNumber
        });
      }
    }, {
      key: "willMount",
      value: function willMount() {
        var items = this.getItems();
        if (!items || !items.length) return;

        this._init();

        this.updateCoord();
      }
    }, {
      key: "didMount",
      value: function didMount() {
        this._initEvent();
      }
    }, {
      key: "willUpdate",
      value: function willUpdate() {
        var items = this.getItems();
        if (!items || !items.length) return;
        this.updateCoord();
      }
    }, {
      key: "_initEvent",
      value: function _initEvent() {
        var _this2 = this;

        var context = this.context,
            props = this.props,
            container = this.container;
        var canvas = context.canvas;
        var chart = props.chart,
            _props$clickable = props.clickable,
            clickable = _props$clickable === void 0 ? true : _props$clickable,
            onClick = props.onClick;
        if (!clickable) return; // item 点击事件

        canvas.on('click', function (ev) {
          var points = ev.points;
          var point = points[0];
          var bbox = container.getBBox();

          if (!Object(__WEBPACK_IMPORTED_MODULE_10__util__["d" /* isInBBox */])(bbox, point)) {
            return;
          }

          var legendItems = Object(__WEBPACK_IMPORTED_MODULE_10__util__["c" /* getElementsByClassName */])('legend-item', container);

          if (!legendItems.length) {
            return;
          }

          var clickItem = Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["g" /* find */])(legendItems, function (item) {
            var itemBBox = item.getBBox();
            return Object(__WEBPACK_IMPORTED_MODULE_10__util__["d" /* isInBBox */])(itemBBox, point);
          });

          if (!clickItem) {
            return;
          }

          var dataItem = clickItem.get('data-item');

          if (!dataItem) {
            return;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["v" /* isFunction */])(onClick)) {
            onClick(dataItem);
          }

          var field = dataItem.field,
              tickValue = dataItem.tickValue;
          var prevFiltered = _this2.state.filtered;

          var filtered = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, prevFiltered), {}, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, tickValue, !prevFiltered[tickValue]));

          _this2.setState({
            filtered: filtered
          });

          chart.filter(field, function (value) {
            return !filtered[value];
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            itemWidth = this.itemWidth,
            style = this.style;
        var items = this.getItems();

        if (!items || !items.length) {
          return null;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_6__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          items: items,
          itemWidth: itemWidth,
          style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, style), props.style)
        }));
      }
    }]);

    return Legend;
  }(__WEBPACK_IMPORTED_MODULE_8__base_component__["a" /* default */]);
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsx__ = __webpack_require__(20);




var Marker = function Marker(_ref) {
  var type = _ref.type,
      color = _ref.color;

  if (type === 'square') {
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("rect", {
      style: {
        width: '12px',
        height: '12px',
        marginRight: '10px'
      },
      attrs: {
        fill: color
      }
    });
  }

  if (type === 'line') {
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("line", {
      style: {
        width: '19px',
        marginRight: '10px'
      },
      attrs: {
        strokeStyle: color,
        lineCap: 'round',
        lineWidth: '4px'
      }
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("circle", {
    style: {
      width: '12px',
      height: '12px',
      marginRight: '10px'
    },
    attrs: {
      fill: color
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var items = props.items,
      itemWidth = props.itemWidth,
      itemFormatter = props.itemFormatter,
      style = props.style,
      _props$marker = props.marker,
      marker = _props$marker === void 0 ? 'circle' : _props$marker,
      itemStyle = props.itemStyle,
      nameStyle = props.nameStyle,
      valueStyle = props.valueStyle,
      valuePrefix = props.valuePrefix;

  var formatValue = function formatValue(value) {
    var valuePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ': ';
    return "".concat(valuePrefix).concat(value);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
    style: style
  }, items.map(function (item) {
    var color = item.color,
        name = item.name,
        value = item.value,
        filtered = item.filtered,
        tickValue = item.tickValue;
    var valueText = Object(__WEBPACK_IMPORTED_MODULE_1__antv_util__["v" /* isFunction */])(itemFormatter) ? itemFormatter(value, tickValue) : value;
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("group", {
      className: "legend-item",
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        width: itemWidth,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: ['6px', '6px', '6px', 0]
      }, itemStyle),
      "data-item": item
    }, Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])(Marker, {
      color: filtered ? '#bfbfbf' : color,
      type: marker
    }), Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("text", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        fill: filtered ? '#bfbfbf' : '#808080',
        text: name
      }, nameStyle)
    }), valueText ? Object(__WEBPACK_IMPORTED_MODULE_2__jsx__["c" /* jsx */])("text", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        fill: '#808080',
        text: formatValue(valueText, valuePrefix)
      }, valueStyle)
    }) : null);
  }));
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TextGuide; });
/* unused harmony export PointGuide */
/* unused harmony export ArcGuide */
/* unused harmony export LineGuide */
/* unused harmony export RectGuide */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageGuide; });
/* unused harmony export TagGuide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withGuide__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Text__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Point__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Line__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Arc__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Rect__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Image__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Tag__ = __webpack_require__(850);
/* unused harmony reexport withGuide */









var DefaultGuideView = function DefaultGuideView() {
  return null;
};

var TextGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__views_Text__["a" /* default */]);
var PointGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__views_Point__["a" /* default */]);
var LineGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__views_Line__["a" /* default */]);
var ArcGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__views_Arc__["a" /* default */]);
var RectGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__views_Rect__["a" /* default */]);
var ImageGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__views_Image__["a" /* default */]);
var TagGuide = Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__views_Tag__["a" /* default */]);
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withGuide__["a" /* default */])(DefaultGuideView));


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__base_diff__ = __webpack_require__(140);












function isInBBox(bbox, point) {
  var minX = bbox.minX,
      maxX = bbox.maxX,
      minY = bbox.minY,
      maxY = bbox.maxY;
  var x = point.x,
      y = point.y;
  return minX <= x && maxX >= x && minY <= y && maxY >= y;
}

/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(Guide, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Guide);

    function Guide(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Guide);

      _this = _super.call(this, props); // 创建ref

      _this.triggerRef = {};
      _this.state = {};
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Guide, [{
      key: "willMount",
      value: function willMount() {
        Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Guide.prototype), "willMount", this).call(this);

        this.getGuideBBox();
      }
    }, {
      key: "didMount",
      value: function didMount() {
        var _this2 = this;

        var context = this.context,
            props = this.props;
        var canvas = context.canvas;
        var onClick = props.onClick;
        canvas.on('click', function (ev) {
          var points = ev.points;
          var shape = _this2.triggerRef.current;
          if (!shape || shape.isDestroyed()) return;
          var bbox = shape.getBBox();

          if (isInBBox(bbox, points[0])) {
            ev.shape = shape;
            onClick && onClick(ev);
          }
        });
      }
    }, {
      key: "didUpdate",
      value: function didUpdate() {
        Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Guide.prototype), "didUpdate", this).call(this);

        var shape = this.triggerRef.current;
        if (!shape || shape.isDestroyed()) return;

        var _shape$get = shape.get('attrs'),
            x = _shape$get.x,
            y = _shape$get.y,
            width = _shape$get.width,
            height = _shape$get.height;

        var bbox = {
          minX: x,
          minY: y,
          maxX: x + width,
          maxY: y + height,
          width: width,
          height: height
        };
        this.setState({
          guideBBox: bbox
        });
      }
    }, {
      key: "getGuideBBox",
      value: function getGuideBBox() {
        var shape = Object(__WEBPACK_IMPORTED_MODULE_10__base_diff__["d" /* renderShape */])(this, this.render(), false);

        var _shape$get2 = shape.get('attrs'),
            x = _shape$get2.x,
            y = _shape$get2.y,
            width = _shape$get2.width,
            height = _shape$get2.height; // getBBox 没有包含 padding 所以这里手动计算 bbox


        var bbox = {
          minX: x,
          minY: y,
          maxX: x + width,
          maxY: y + height,
          width: width,
          height: height
        };
        this.setState({
          guideBBox: bbox
        });
        shape.destroy();
      } // 解析record里的模板字符串，如min、max、50%...

    }, {
      key: "parseReplaceStr",
      value: function parseReplaceStr(value, scale) {
        var replaceMap = {
          min: 0,
          max: 1,
          median: 0.5
        }; // 传入的是 min、max、median 的

        if (!Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["w" /* isNil */])(replaceMap[value])) {
          return replaceMap[value];
        } // 传入的是 xx%


        if (Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["B" /* isString */])(value) && value.indexOf('%') != -1 && !isNaN(Number(value.slice(0, -1)))) {
          var rateValue = Number(value.slice(0, -1));
          var percent = rateValue / 100;
          return percent;
        }

        return scale.scale(value);
      }
    }, {
      key: "parsePoint",
      value: function parsePoint(record) {
        var props = this.props;
        var chart = props.chart,
            coord = props.coord;
        var xScale = chart.getXScales()[0]; // 只取第一个yScale

        var yScale = chart.getYScales()[0]; // 解析 record 为归一化后的坐标

        var x = this.parseReplaceStr(record[xScale.field], xScale);
        var y = this.parseReplaceStr(record[yScale.field], yScale);
        return coord.convertPoint({
          x: x,
          y: y
        });
      }
    }, {
      key: "convertPoints",
      value: function convertPoints(records) {
        var _this3 = this;

        return records.map(function (record) {
          return _this3.parsePoint(record);
        });
      }
    }, {
      key: "getGuideTheme",
      value: function getGuideTheme() {
        var context = this.context;
        var theme = context.theme;
        return theme.guide;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            context = this.context;
        var coord = props.coord,
            _props$records = props.records,
            records = _props$records === void 0 ? [] : _props$records,
            animation = props.animation,
            chart = props.chart;
        var width = context.width,
            height = context.height;
        var points = this.convertPoints(records);
        var theme = this.getGuideTheme();
        var guideBBox = this.state.guideBBox;
        var animationCfg = animation;

        if (Object(__WEBPACK_IMPORTED_MODULE_9__antv_util__["v" /* isFunction */])(animation)) {
          // 透传绘制关键点和chart实例
          animationCfg = animation(points, chart);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_7__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          triggerRef: this.triggerRef,
          points: points,
          theme: theme,
          coord: coord
        }, props), {}, {
          canvasWidth: width,
          canvasHeight: height,
          guideBBox: guideBBox,
          animation: animationCfg
        }));
      }
    }]);

    return Guide;
  }(__WEBPACK_IMPORTED_MODULE_8__base_component__["a" /* default */]);
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme;

  var _deepMix = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, theme.text), props),
      points = _deepMix.points,
      style = _deepMix.style,
      offsetX = _deepMix.offsetX,
      offsetY = _deepMix.offsetY,
      content = _deepMix.content,
      animation = _deepMix.animation;

  var _ref = points[0] || {},
      x = _ref.x,
      y = _ref.y;

  var offsetXNum = context.px2hd(offsetX);
  var offsetYNum = context.px2hd(offsetY);
  var posX = x + (offsetXNum || 0);
  var posY = y + (offsetYNum || 0);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      text: content,
      x: posX,
      y: posY
    }, style),
    animation: Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])({
      update: {
        easing: 'linear',
        duration: 450,
        property: ['x', 'y']
      }
    }, animation)
  });
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var theme = props.theme;

  var _deepMix = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, theme.point), props),
      points = _deepMix.points,
      style = _deepMix.style,
      offsetX = _deepMix.offsetX,
      offsetY = _deepMix.offsetY,
      animation = _deepMix.animation;

  var _ref = points[0] || {},
      x = _ref.x,
      y = _ref.y;

  var offsetXNum = context.px2hd(offsetX);
  var offsetYNum = context.px2hd(offsetY);
  var posX = x + (offsetXNum || 0);
  var posY = y + (offsetYNum || 0);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("circle", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x: posX,
      y: posY
    }, style),
    animation: animation
  }));
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme;

  var _deepMix = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, theme.line), props),
      points = _deepMix.points,
      style = _deepMix.style,
      offsetX = _deepMix.offsetX,
      offsetY = _deepMix.offsetY,
      animation = _deepMix.animation;

  var _ref = points[0] || {},
      x1 = _ref.x,
      y1 = _ref.y;

  var _ref2 = points[1] || {},
      x2 = _ref2.x,
      y2 = _ref2.y;

  var offsetXNum = context.px2hd(offsetX);
  var offsetYNum = context.px2hd(offsetY);
  var posX1 = x1 + (Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["r" /* isArray */])(offsetXNum) ? offsetXNum[0] || 0 : offsetXNum || 0);
  var posY1 = y1 + (Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["r" /* isArray */])(offsetYNum) ? offsetYNum[0] || 0 : offsetYNum || 0);
  var posX2 = x2 + (Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["r" /* isArray */])(offsetXNum) ? offsetXNum[1] || 0 : offsetXNum || 0);
  var posY2 = y2 + (Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["r" /* isArray */])(offsetYNum) ? offsetYNum[1] || 0 : offsetYNum || 0);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: posX1,
      y1: posY1,
      x2: posX2,
      y2: posY2
    }, style),
    animation: animation
  }));
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme;

  var _deepMix = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, theme.line), props),
      coord = _deepMix.coord,
      points = _deepMix.points,
      style = _deepMix.style,
      animation = _deepMix.animation;

  var start = points[0] || {};
  var end = points[1] || {};
  var coordCenter = coord.center;
  var radius = Math.sqrt((start.x - coordCenter.x) * (start.x - coordCenter.x) + (start.y - coordCenter.y) * (start.y - coordCenter.y));
  var startAngle = Math.atan2(start.y - coordCenter.y, start.x - coordCenter.x);
  var endAngle = Math.atan2(end.y - coordCenter.y, end.x - coordCenter.x);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("arc", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x: coordCenter.x,
      y: coordCenter.y,
      r: radius,
      startAngle: startAngle,
      endAngle: endAngle
    }, style),
    animation: animation
  }));
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? {} : _props$theme;

  var _deepMix = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, theme.rect), props),
      points = _deepMix.points,
      style = _deepMix.style,
      animation = _deepMix.animation;

  var start = points[0] || {};
  var end = points[1] || {};
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("rect", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x: Math.min(start.x, end.x),
      y: Math.min(start.y, end.y),
      width: Math.abs(end.x - start.x),
      height: Math.abs(start.y - end.y)
    }, style),
    animation: animation
  }));
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);



var defaultProps = {
  offsetX: 0,
  offsetY: 0,
  points: [],
  src: ''
};
var baseAttrs = {
  height: '20px',
  width: '20px'
};
/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var cfg = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])({}, defaultProps, props);
  var points = cfg.points,
      style = cfg.style,
      attrs = cfg.attrs,
      offsetX = cfg.offsetX,
      offsetY = cfg.offsetY,
      src = cfg.src,
      animation = cfg.animation;

  var _ref = points[0] || {},
      x = _ref.x,
      y = _ref.y;

  var _attrs$height = attrs.height,
      height = _attrs$height === void 0 ? 0 : _attrs$height,
      _attrs$width = attrs.width,
      width = _attrs$width === void 0 ? 0 : _attrs$width;
  var heightNum = context.px2hd(height + 'px');
  var widthNum = context.px2hd(width + 'px');
  var offsetXNum = context.px2hd(offsetX);
  var offsetYNum = context.px2hd(offsetY);
  var posX = x + (offsetXNum || 0) - widthNum / 2;
  var posY = y + (offsetYNum || 0) - heightNum / 2;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
    style: style
  }, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("image", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, baseAttrs), attrs), {}, {
      height: heightNum,
      width: widthNum,
      x: posX,
      y: posY,
      src: src
    }),
    cacheImage: true,
    animation: Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["d" /* deepMix */])({
      update: {
        easing: 'linear',
        duration: 450,
        property: ['x', 'y']
      }
    }, animation)
  }));
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


var defaultProps = {
  offsetX: 0,
  offsetY: 0,
  points: [],
  direct: 'tl',
  side: 6,
  autoAdjust: true
};
var defaultStyle = {
  container: {
    fill: '#1677FF',
    radius: 2,
    padding: [3, 5]
  },
  text: {
    fontSize: '22px',
    fill: '#fff'
  },
  arrow: {
    fill: '#1677FF'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var cfg = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultProps), props);

  var points = cfg.points,
      content = cfg.content,
      offsetX = cfg.offsetX,
      offsetY = cfg.offsetY,
      direct = cfg.direct,
      side = cfg.side,
      autoAdjust = cfg.autoAdjust,
      canvasWidth = cfg.canvasWidth,
      canvasHeight = cfg.canvasHeight,
      guideBBox = cfg.guideBBox,
      background = cfg.background,
      textStyle = cfg.textStyle,
      triggerRef = cfg.triggerRef;

  var _ref = points[0] || {},
      x = _ref.x,
      y = _ref.y;

  var _ref2 = guideBBox || {},
      guideWidth = _ref2.width,
      guideHeight = _ref2.height;

  var offsetXNum = context.px2hd(offsetX);
  var offsetYNum = context.px2hd(offsetY);
  var posX = x + (offsetXNum || 0);
  var posY = y + (offsetYNum || 0);

  var _getDirect = function _getDirect(point) {
    var newDirect = direct;
    var x = point.x,
        y = point.y;
    var vertical = newDirect[0];
    var horizontal = newDirect[1]; // adjust for vertical direction

    if (vertical === 't' && y - side - guideHeight < 0) {
      vertical = 'b';
    } else if (vertical === 'b' && y + side + guideHeight > canvasHeight) {
      vertical = 't';
    } // adjust for horizontal direction


    var diff = vertical === 'c' ? side : 0;

    if (horizontal === 'l' && x - diff - guideWidth < 0) {
      horizontal = 'r';
    } else if (horizontal === 'r' && x + diff + guideWidth > canvasWidth) {
      horizontal = 'l';
    } else if (horizontal === 'c') {
      if (guideWidth / 2 + x + diff > canvasWidth) {
        horizontal = 'l';
      } else if (x - guideWidth / 2 - diff < 0) {
        horizontal = 'r';
      }
    }

    newDirect = vertical + horizontal;
    return newDirect;
  };

  var _getArrowPoints = function _getArrowPoints(direct) {
    var arrowPoints = []; // const { minX, minY } = guideBBox || {};

    if (direct === 'tl') {
      arrowPoints = [{
        x: posX,
        y: posY - side - 1
      }, {
        x: posX,
        y: posY
      }, {
        x: posX - side,
        y: posY - side - 1
      }];
      posX -= guideWidth || 0;
      posY = posY - (guideHeight || 0) - side;
    } else if (direct === 'cl') {
      arrowPoints = [{
        x: posX - side - 1,
        y: posY - side
      }, {
        x: posX - side - 1,
        y: posY + side
      }, {
        x: posX,
        y: posY
      }];
      posX = posX - (guideWidth || 0) - side;
      posY -= guideHeight / 2 || 0;
    } else if (direct === 'bl') {
      arrowPoints = [{
        x: posX,
        y: posY
      }, {
        x: posX,
        y: posY + side + 1
      }, {
        x: posX - side,
        y: posY + side + 1
      }];
      posX = posX - (guideWidth || 0);
      posY += side;
    } else if (direct === 'bc') {
      // 有问题
      arrowPoints = [{
        x: posX,
        y: posY
      }, {
        x: posX - side,
        y: posY + side + 1
      }, {
        x: posX + side,
        y: posY + side + 1
      }];
      posX = posX - (guideWidth / 2 || 0);
      posY = posY + side;
    } else if (direct === 'br') {
      arrowPoints = [{
        x: posX,
        y: posY
      }, {
        x: posX,
        y: posY + side + 1
      }, {
        x: posX + side,
        y: posY + side + 1
      }];
      posY += side;
    } else if (direct === 'cr') {
      arrowPoints = [{
        x: posX,
        y: posY
      }, {
        x: posX + side,
        y: posY - side
      }, {
        x: posX + side,
        y: posY + side
      }];
      posX += side;
      posY -= guideHeight / 2 || 0;
    } else if (direct === 'tr') {
      arrowPoints = [{
        x: posX,
        y: posY
      }, {
        x: posX,
        y: posY - side - 1
      }, {
        x: posX + side,
        y: posY - side - 1
      }];
      posY = posY - (guideHeight || 0) - side;
    } else if (direct === 'tc') {
      arrowPoints = [{
        x: posX,
        y: posY
      }, {
        x: posX - side,
        y: posY - side - 1
      }, {
        x: posX + side,
        y: posY - side - 1
      }];
      posX -= guideWidth / 2 || 0;
      posY = posY - (guideHeight || 0) - side;
    }

    return arrowPoints;
  };

  var dr = autoAdjust ? _getDirect(points[0]) : direct;

  var arrowPoints = _getArrowPoints(dr);

  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      fill: defaultStyle.container.fill,
      radius: defaultStyle.container.radius
    }, background),
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      left: posX,
      top: posY,
      padding: defaultStyle.container.padding
    }, background),
    ref: triggerRef
  }, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      text: content,
      fontSize: defaultStyle.text.fontSize,
      fill: defaultStyle.text.fill
    }, textStyle)
  }), guideBBox && Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("polygon", {
    attrs: {
      points: arrowPoints,
      fill: (background === null || background === void 0 ? void 0 : background.fill) || defaultStyle.arrow.fill
    }
  }));
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTooltip__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltipView__ = __webpack_require__(853);
/* unused harmony reexport withTooltip */
/* unused harmony reexport TooltipView */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withTooltip__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__tooltipView__["a" /* default */]));

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__base_equal__ = __webpack_require__(82);










/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Tooltip, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Tooltip);

    function Tooltip(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Tooltip);

      _this = _super.call(this, props);

      _this._triggerOn = function (ev) {
        var points = ev.points;

        _this.show(points[0], ev);
      };

      _this._triggerOff = function () {
        var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
            _assertThisInitialize2 = _assertThisInitialize.props.alwaysShow,
            alwaysShow = _assertThisInitialize2 === void 0 ? false : _assertThisInitialize2;

        if (!alwaysShow) {
          _this.hide();
        }
      };

      _this.state = {
        records: null
      };
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Tooltip, [{
      key: "updateCoord",
      value: function updateCoord() {
        var props = this.props,
            context = this.context;
        var _props$padding = props.padding,
            padding = _props$padding === void 0 ? '10px' : _props$padding,
            chart = props.chart;
        chart.updateCoordFor(this, {
          position: 'top',
          width: 0,
          height: context.px2hd(padding)
        });
      }
    }, {
      key: "willMount",
      value: function willMount() {
        this.updateCoord();
      }
    }, {
      key: "didMount",
      value: function didMount() {
        this._initShow();

        this._initEvent();
      }
    }, {
      key: "willReceiveProps",
      value: function willReceiveProps(nextProps) {
        var nextDefaultItem = nextProps.defaultItem,
            nextCoord = nextProps.coord;
        var _this$props = this.props,
            lastDefaultItem = _this$props.defaultItem,
            lastCoord = _this$props.coord; // 默认元素或坐标有变动，均需重新渲染

        if (!Object(__WEBPACK_IMPORTED_MODULE_9__base_equal__["a" /* default */])(nextDefaultItem, lastDefaultItem) || !Object(__WEBPACK_IMPORTED_MODULE_9__base_equal__["a" /* default */])(nextCoord, lastCoord)) {
          this._showByData(nextDefaultItem);
        }
      }
    }, {
      key: "_initShow",
      value: function _initShow() {
        var props = this.props;
        var defaultItem = props.defaultItem;

        this._showByData(defaultItem);
      }
    }, {
      key: "_showByData",
      value: function _showByData(dataItem) {
        var _this2 = this;

        if (!dataItem) return;
        var props = this.props;
        var chart = props.chart; // 因为 tooltip 有可能在 geometry 之前，所以需要等 geometry render 完后再执行

        setTimeout(function () {
          var point = chart.getPosition(dataItem);

          _this2.show(point);
        }, 0);
      }
    }, {
      key: "_initEvent",
      value: function _initEvent() {
        var context = this.context,
            props = this.props;
        var canvas = context.canvas;
        var _props$triggerOn = props.triggerOn,
            triggerOn = _props$triggerOn === void 0 ? 'press' : _props$triggerOn,
            _props$triggerOff = props.triggerOff,
            triggerOff = _props$triggerOff === void 0 ? 'pressend' : _props$triggerOff;
        canvas.on(triggerOn, this._triggerOn);
        canvas.on(triggerOff, this._triggerOff);
      }
    }, {
      key: "didUnmount",
      value: function didUnmount() {
        this._clearEvents();
      }
    }, {
      key: "_clearEvents",
      value: function _clearEvents() {
        var context = this.context,
            props = this.props;
        var canvas = context.canvas;
        var _props$triggerOn2 = props.triggerOn,
            triggerOn = _props$triggerOn2 === void 0 ? 'press' : _props$triggerOn2,
            _props$triggerOff2 = props.triggerOff,
            triggerOff = _props$triggerOff2 === void 0 ? 'pressend' : _props$triggerOff2; // 解绑事件

        canvas.off(triggerOn, this._triggerOn);
        canvas.off(triggerOff, this._triggerOff);
      }
    }, {
      key: "show",
      value: function show(point, _ev) {
        var props = this.props;
        var chart = props.chart,
            onChange = props.onChange;
        var snapRecords = chart.getSnapRecords(point, true); // 超出边界会自动调整

        if (!snapRecords || !snapRecords.length) return;
        var legendItems = chart.getLegendItems();
        var _snapRecords$ = snapRecords[0],
            xField = _snapRecords$.xField,
            yField = _snapRecords$.yField;
        var xScale = chart.getScale(xField);
        var yScale = chart.getScale(yField);
        var records = snapRecords.map(function (record) {
          var origin = record.origin,
              xField = record.xField,
              yField = record.yField;
          var value = yScale.getText(origin[yField]); // 默认取 alias 的配置

          var name = yScale.alias;

          if (!name) {
            name = xScale.getText(origin[xField]);

            if (legendItems && legendItems.length) {
              var item = Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["g" /* find */])(legendItems, function (item) {
                var field = item.field,
                    tickValue = item.tickValue;
                return origin[field] === tickValue;
              });

              if (item && item.name) {
                name = item.name;
              }
            }
          }

          return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, record), {}, {
            name: name,
            value: value
          });
        });

        if (!Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["r" /* isArray */])(records) || !records.length) {
          return;
        }

        this.setState({
          records: records
        });

        if (Object(__WEBPACK_IMPORTED_MODULE_7__antv_util__["v" /* isFunction */])(onChange)) {
          onChange(records);
        }
      }
    }, {
      key: "hide",
      value: function hide() {
        this.setState({
          records: null
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            state = this.state;
        var visible = props.visible;

        if (visible === false) {
          return null;
        }

        var records = state.records;
        if (!records || !records.length) return null;
        return Object(__WEBPACK_IMPORTED_MODULE_6__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          records: records
        }));
      }
    }]);

    return Tooltip;
  }(__WEBPACK_IMPORTED_MODULE_8__base_component__["a" /* default */]);
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createRef__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__jsx__ = __webpack_require__(20);









 // view 的默认配置

var defaultStyle = {
  showTitle: false,
  showCrosshairs: false,
  crosshairsType: 'y',
  crosshairsStyle: {
    stroke: 'rgba(0, 0, 0, 0.25)',
    lineWidth: '2px'
  },
  showTooltipMarker: false,
  markerBackgroundStyle: {
    fill: '#CCD6EC',
    opacity: 0.3,
    padding: '6px'
  },
  tooltipMarkerStyle: {
    fill: '#fff',
    lineWidth: '3px'
  },
  background: {
    radius: '4px',
    fill: 'rgba(0, 0, 0, 0.65)',
    padding: ['6px', '10px']
  },
  titleStyle: {
    fontSize: '24px',
    fill: '#fff',
    textAlign: 'start',
    textBaseline: 'top'
  },
  nameStyle: {
    fontSize: '24px',
    fill: 'rgba(255, 255, 255, 0.65)',
    textAlign: 'start',
    textBaseline: 'middle'
  },
  valueStyle: {
    fontSize: '24px',
    fill: '#fff',
    textAlign: 'start',
    textBaseline: 'middle'
  },
  joinString: ': ',
  showItemMarker: true,
  itemMarkerStyle: {
    width: '12px',
    radius: '6px',
    symbol: 'circle',
    lineWidth: '2px',
    stroke: '#fff'
  },
  layout: 'horizontal',
  snap: false,
  xTipTextStyle: {
    fontSize: '24px',
    fill: '#fff'
  },
  yTipTextStyle: {
    fontSize: '24px',
    fill: '#fff'
  },
  xTipBackground: {
    radius: '4px',
    fill: 'rgba(0, 0, 0, 0.65)',
    padding: ['6px', '10px'],
    marginLeft: '-50%',
    marginTop: '6px'
  },
  yTipBackground: {
    radius: '4px',
    fill: 'rgba(0, 0, 0, 0.65)',
    padding: ['6px', '10px'],
    marginLeft: '-100%',
    marginTop: '-50%'
  }
};

function directionEnabled(mode, dir) {
  if (mode === undefined) {
    return true;
  } else if (typeof mode === 'string') {
    return mode.indexOf(dir) !== -1;
  }

  return false;
}

var RenderItemMarker = function RenderItemMarker(props) {
  var records = props.records,
      coord = props.coord,
      context = props.context,
      markerBackgroundStyle = props.markerBackgroundStyle;
  var point = coord.convertPoint({
    x: 1,
    y: 1
  });
  var padding = context.px2hd(markerBackgroundStyle.padding || '6px');
  var xPoints = [].concat(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(records.map(function (record) {
    return record.xMin;
  })), Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(records.map(function (record) {
    return record.xMax;
  })));
  var yPoints = [].concat(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(records.map(function (record) {
    return record.yMin;
  })), Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(records.map(function (record) {
    return record.yMax;
  })));

  if (coord.transposed) {
    xPoints.push(point.x);
  } else {
    yPoints.push(point.y);
  }

  var xMin = Math.min.apply(null, xPoints);
  var xMax = Math.max.apply(null, xPoints);
  var yMin = Math.min.apply(null, yPoints);
  var yMax = Math.max.apply(null, yPoints);
  var x = coord.transposed ? xMin : xMin - padding;
  var y = coord.transposed ? yMin - padding : yMin;
  var width = coord.transposed ? xMax - xMin : xMax - xMin + 2 * padding;
  var height = coord.transposed ? yMax - yMin + 2 * padding : yMax - yMin;
  return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("rect", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x: x,
      y: y,
      width: width,
      height: height
    }, markerBackgroundStyle)
  });
};

var RenderCrosshairs = function RenderCrosshairs(props) {
  var records = props.records,
      coord = props.coord,
      chart = props.chart,
      crosshairsType = props.crosshairsType,
      crosshairsStyle = props.crosshairsStyle;
  var coordLeft = coord.left,
      coordTop = coord.top,
      coordRight = coord.right,
      coordBottom = coord.bottom,
      center = coord.center;
  var firstRecord = records[0];
  var x = firstRecord.x,
      y = firstRecord.y,
      origin = firstRecord.origin,
      xField = firstRecord.xField;

  if (coord.isPolar) {
    // 极坐标下的辅助线
    var xScale = chart.getScale(xField);
    var ticks = xScale.getTicks();
    var tick = Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["g" /* find */])(ticks, function (tick) {
      return origin[xField] === tick.tickValue;
    });
    var end = coord.convertPoint({
      x: tick.value,
      y: 1
    });
    return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("line", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x1: center.x,
        y1: center.y,
        x2: end.x,
        y2: end.y
      }, crosshairsStyle)
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", null, directionEnabled(crosshairsType, 'x') ? Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: coordLeft,
      y1: y,
      x2: coordRight,
      y2: y
    }, crosshairsStyle)
  }) : null, directionEnabled(crosshairsType, 'y') ? Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("line", {
    attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
      x1: x,
      y1: coordTop,
      x2: x,
      y2: coordBottom
    }, crosshairsStyle)
  }) : null);
};

var TooltipView = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(TooltipView, _Component);

  var _super = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createSuper__["a" /* default */])(TooltipView);

  function TooltipView(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, TooltipView);

    _this = _super.call(this, props);
    _this.rootRef = Object(__WEBPACK_IMPORTED_MODULE_8__createRef__["a" /* default */])();
    _this.arrowRef = Object(__WEBPACK_IMPORTED_MODULE_8__createRef__["a" /* default */])();
    return _this;
  } // 调整 显示的位置


  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(TooltipView, [{
    key: "_position",
    value: function _position() {
      var props = this.props,
          context = this.context,
          rootRef = this.rootRef,
          arrowRef = this.arrowRef;
      var group = rootRef.current;

      if (!group) {
        return;
      }

      var records = props.records,
          coord = props.coord;
      var arrowWidth = context.px2hd('6px');
      var record = records[0]; // 中心点

      var x = record.x;
      var coordLeft = coord.left,
          coordWidth = coord.width;

      var _group$get = group.get('attrs'),
          y = _group$get.y,
          width = _group$get.width,
          height = _group$get.height,
          radius = _group$get.radius;

      var halfWidth = width / 2; // 让 tooltip 限制在 coord 的显示范围内

      var offsetX = Math.min(Math.max(x - coordLeft - halfWidth, -arrowWidth - radius), coordWidth - width + arrowWidth + radius); // 因为默认是从 coord 的范围内显示的，所以要往上移，移出 coord，避免挡住 geometry

      var offset = Math.min(y, height + arrowWidth); // 因为不能超出 canvas 画布区域，所以最大只能是 y

      group.moveTo(offsetX, -offset);
      arrowRef.current.moveTo(0, height - offset);
    }
  }, {
    key: "didMount",
    value: function didMount() {
      this._position();
    }
  }, {
    key: "didUpdate",
    value: function didUpdate() {
      this._position();
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
          context = this.context;
      var records = props.records,
          coord = props.coord;
      var coordLeft = coord.left,
          coordTop = coord.top,
          coordBottom = coord.bottom;
      var firstRecord = records[0];
      var x = firstRecord.x,
          y = firstRecord.y;
      var xFirstText = firstRecord.name,
          yFirstText = firstRecord.value;
      var chart = props.chart,
          customBackground = props.background,
          _props$showTooltipMar = props.showTooltipMarker,
          showTooltipMarker = _props$showTooltipMar === void 0 ? defaultStyle.showTooltipMarker : _props$showTooltipMar,
          _props$markerBackgrou = props.markerBackgroundStyle,
          markerBackgroundStyle = _props$markerBackgrou === void 0 ? defaultStyle.markerBackgroundStyle : _props$markerBackgrou,
          _props$showItemMarker = props.showItemMarker,
          showItemMarker = _props$showItemMarker === void 0 ? defaultStyle.showItemMarker : _props$showItemMarker,
          customItemMarkerStyle = props.itemMarkerStyle,
          nameStyle = props.nameStyle,
          valueStyle = props.valueStyle,
          _props$joinString = props.joinString,
          joinString = _props$joinString === void 0 ? defaultStyle.joinString : _props$joinString,
          _props$showCrosshairs = props.showCrosshairs,
          showCrosshairs = _props$showCrosshairs === void 0 ? defaultStyle.showCrosshairs : _props$showCrosshairs,
          crosshairsStyle = props.crosshairsStyle,
          _props$crosshairsType = props.crosshairsType,
          crosshairsType = _props$crosshairsType === void 0 ? defaultStyle.crosshairsType : _props$crosshairsType,
          _props$snap = props.snap,
          snap = _props$snap === void 0 ? defaultStyle.snap : _props$snap,
          _props$tooltipMarkerS = props.tooltipMarkerStyle,
          tooltipMarkerStyle = _props$tooltipMarkerS === void 0 ? defaultStyle.tooltipMarkerStyle : _props$tooltipMarkerS,
          showXTip = props.showXTip,
          showYTip = props.showYTip,
          xTip = props.xTip,
          yTip = props.yTip,
          _props$xTipTextStyle = props.xTipTextStyle,
          xTipTextStyle = _props$xTipTextStyle === void 0 ? defaultStyle.xTipTextStyle : _props$xTipTextStyle,
          _props$yTipTextStyle = props.yTipTextStyle,
          yTipTextStyle = _props$yTipTextStyle === void 0 ? defaultStyle.yTipTextStyle : _props$yTipTextStyle,
          _props$xTipBackground = props.xTipBackground,
          xTipBackground = _props$xTipBackground === void 0 ? defaultStyle.xTipBackground : _props$xTipBackground,
          _props$yTipBackground = props.yTipBackground,
          yTipBackground = _props$yTipBackground === void 0 ? defaultStyle.yTipBackground : _props$yTipBackground,
          _props$custom = props.custom,
          custom = _props$custom === void 0 ? false : _props$custom,
          customText = props.customText;

      var itemMarkerStyle = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, customItemMarkerStyle), defaultStyle.itemMarkerStyle);

      var background = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.background), customBackground);

      var arrowWidth = context.px2hd('6px');
      return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
        style: {
          left: coordLeft,
          top: coordTop
        }
      }, !custom && Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
        ref: this.rootRef,
        style: background,
        attrs: background
      }, Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          padding: [0, 0, 0, '6px']
        }
      }, records.map(function (record) {
        var name = record.name,
            value = record.value;
        return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
          style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: [0, '6px', 0, 0]
          }
        }, showItemMarker ? Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("marker", {
          style: {
            width: itemMarkerStyle.width,
            marginRight: '6px'
          },
          attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, itemMarkerStyle), {}, {
            fill: record.color
          })
        }) : null, customText && Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(customText) ? customText(record) : Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
          style: {
            display: 'flex',
            flexDirection: 'row'
          }
        }, Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("text", {
          attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.nameStyle), nameStyle), {}, {
            text: value ? "".concat(name).concat(joinString) : name
          })
        }), Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("text", {
          attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.valueStyle), valueStyle), {}, {
            text: value
          })
        })));
      }))), Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("polygon", {
        ref: this.arrowRef,
        attrs: {
          points: [{
            x: x - arrowWidth,
            y: coordTop
          }, {
            x: x + arrowWidth,
            y: coordTop
          }, {
            x: x,
            y: coordTop + arrowWidth
          }],
          fill: background.fill
        }
      })), showTooltipMarker ? Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])(RenderItemMarker, {
        coord: coord,
        context: context,
        records: records,
        markerBackgroundStyle: markerBackgroundStyle
      }) : null, showCrosshairs ? Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])(RenderCrosshairs, {
        chart: chart,
        coord: coord,
        records: records,
        crosshairsType: crosshairsType,
        crosshairsStyle: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.crosshairsStyle), crosshairsStyle)
      }) : null, snap ? records.map(function (item) {
        var x = item.x,
            y = item.y,
            color = item.color,
            shape = item.shape;
        return Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("circle", {
          attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
            x: x,
            y: y,
            r: '6px',
            stroke: color,
            fill: color
          }, shape), tooltipMarkerStyle)
        });
      }) : null), showXTip && Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
        style: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          left: x,
          top: coordBottom
        }, defaultStyle.xTipBackground), xTipBackground),
        attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.xTipBackground), xTipBackground)
      }, Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("text", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.xTipTextStyle), xTipTextStyle), {}, {
          text: Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(xTip) ? xTip(xFirstText) : xFirstText
        })
      })), showYTip && Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("group", {
        style: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          left: coordLeft,
          top: y
        }, defaultStyle.yTipBackground), yTipBackground),
        attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.yTipBackground), yTipBackground)
      }, Object(__WEBPACK_IMPORTED_MODULE_9__jsx__["c" /* jsx */])("text", {
        attrs: Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, defaultStyle.yTipTextStyle), yTipTextStyle), {}, {
          text: Object(__WEBPACK_IMPORTED_MODULE_6__antv_util__["v" /* isFunction */])(yTip) ? yTip(yFirstText) : yFirstText
        })
      })));
    }
  }]);

  return TooltipView;
}(__WEBPACK_IMPORTED_MODULE_7__base_component__["a" /* default */]);



/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTreemap__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemapView__ = __webpack_require__(880);
/* unused harmony reexport withTreemap */
/* unused harmony reexport TreemapView */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withTreemap__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__treemapView__["a" /* default */]));

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__attr__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__controller_coord__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deps_d3_hierarchy_src__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__jsx__ = __webpack_require__(20);











/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Treemap, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Treemap);

    function Treemap(props, context, updater) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Treemap);

      _this = _super.call(this, props, context, updater);
      var coord = props.coord,
          color = props.color,
          data = props.data;
      var width = context.width,
          height = context.height,
          theme = context.theme;
      _this.coordController = new __WEBPACK_IMPORTED_MODULE_8__controller_coord__["a" /* default */]();

      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          coordController = _assertThisInitialize.coordController;

      _this.coord = coordController.create(coord, {
        width: width,
        height: height
      });
      _this.color = new __WEBPACK_IMPORTED_MODULE_6__attr__["Category"](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        range: theme.colors
      }, color), {}, {
        data: data
      }));
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Treemap, [{
      key: "treemapLayout",
      value: function treemapLayout() {
        var props = this.props,
            coord = this.coord,
            colorAttr = this.color;
        var data = props.data,
            value = props.value;
        var root = Object(__WEBPACK_IMPORTED_MODULE_9__deps_d3_hierarchy_src__["a" /* hierarchy */])({
          children: data
        }).sum(function (d) {
          return d[value];
        }).sort(function (a, b) {
          return b[value] - a[value];
        });
        var treemapLayout = Object(__WEBPACK_IMPORTED_MODULE_9__deps_d3_hierarchy_src__["c" /* treemap */])() // 默认treemapSquarify
        .tile(__WEBPACK_IMPORTED_MODULE_9__deps_d3_hierarchy_src__["d" /* treemapBinary */]) // .size([1, 1])
        // @ts-ignore
        .round(false); // .padding(space)
        // .paddingInner(space);
        // .paddingOuter(options.paddingOuter)
        // .paddingTop(options.paddingTop)
        // .paddingRight(options.paddingRight)
        // .paddingBottom(options.paddingBottom)
        // .paddingLeft(options.paddingLeft);

        var nodes = treemapLayout(root);
        return nodes.children.map(function (item) {
          var data = item.data,
              x0 = item.x0,
              y0 = item.y0,
              x1 = item.x1,
              y1 = item.y1;
          var color = colorAttr.mapping(data[colorAttr.field]);
          var rect = coord.convertRect({
            x: [x0, x1],
            y: [y0, y1]
          });
          return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
            key: data.key,
            origin: data,
            color: color
          }, rect);
        });
      }
    }, {
      key: "render",
      value: function render() {
        var nodes = this.treemapLayout();
        var props = this.props,
            coord = this.coord;
        return Object(__WEBPACK_IMPORTED_MODULE_10__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          nodes: nodes
        }, props), {}, {
          coord: coord
        }));
      }
    }]);

    return Treemap;
  }(__WEBPACK_IMPORTED_MODULE_7__base_component__["a" /* default */]);
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;

  while (children = node.children) {
    node = children[0];
  }

  return node;
}

function leafRight(node) {
  var children;

  while (children = node.children) {
    node = children[children.length - 1];
  }

  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0; // First walk, computing the initial x & y values.

    root.eachAfter(function (node) {
      var children = node.children;

      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });
    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2; // Second walk, normalizing x & y to the desired size.

    return root.eachAfter(nodeSize ? function (node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function (node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function (x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function (x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [dx, dy];
  };

  cluster.nodeSize = function (x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [dx, dy] : null;
  };

  return cluster;
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;else while (--i >= 0) {
    sum += children[i].value;
  }
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return this.eachAfter(count);
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createForOfIteratorHelper__ = __webpack_require__(301);

/* harmony default export */ __webpack_exports__["a"] = (function (callback, that) {
  var index = -1;

  var _iterator = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createForOfIteratorHelper__["a" /* default */])(this),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      callback.call(that, node, ++index, this);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return this;
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (callback, that) {
  var node = this,
      nodes = [node],
      children,
      i,
      index = -1;

  while (node = nodes.pop()) {
    callback.call(that, node, ++index, this);

    if (children = node.children) {
      for (i = children.length - 1; i >= 0; --i) {
        nodes.push(children[i]);
      }
    }
  }

  return this;
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (callback, that) {
  var node = this,
      nodes = [node],
      next = [],
      children,
      i,
      n,
      index = -1;

  while (node = nodes.pop()) {
    next.push(node);

    if (children = node.children) {
      for (i = 0, n = children.length; i < n; ++i) {
        nodes.push(children[i]);
      }
    }
  }

  while (node = next.pop()) {
    callback.call(that, node, ++index, this);
  }

  return this;
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createForOfIteratorHelper__ = __webpack_require__(301);

/* harmony default export */ __webpack_exports__["a"] = (function (callback, that) {
  var index = -1;

  var _iterator = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createForOfIteratorHelper__["a" /* default */])(this),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;

      if (callback.call(that, node, ++index, this)) {
        return node;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return this.eachAfter(function (node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;

    while (--i >= 0) {
      sum += children[i].value;
    }

    node.value = sum;
  });
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (compare) {
  return this.eachBefore(function (node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];

  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }

  var k = nodes.length;

  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }

  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();

  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }

  return c;
}

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var node = this,
      nodes = [node];

  while (node = node.parent) {
    nodes.push(node);
  }

  return nodes;
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return Array.from(this);
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var leaves = [];
  this.eachBefore(function (node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var root = this,
      links = [];
  root.each(function (node) {
    if (node !== root) {
      // Don’t include the root’s parent, if any.
      links.push({
        source: node.parent,
        target: node
      });
    }
  });
  return links;
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);


var _marked = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(_callee);

function _callee() {
  var node, current, next, children, i, n;
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          node = this, next = [node];

        case 1:
          current = next.reverse(), next = [];

        case 2:
          if (!(node = current.pop())) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return node;

        case 5:
          if (children = node.children) {
            for (i = 0, n = children.length; i < n; ++i) {
              next.push(children[i]);
            }
          }

          _context.next = 2;
          break;

        case 8:
          if (next.length) {
            _context.next = 1;
            break;
          }

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(871);


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(305);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;

    if (radius) {
      root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* constantZero */], 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }

    return root;
  }

  pack.radius = function (x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors_js__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function (x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function (node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function (node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;
      if (r) for (i = 0; i < n; ++i) {
        children[i].r += r;
      }
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings_js__["a" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) {
        children[i].r -= r;
      }
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function (node) {
    var parent = node.parent;
    node.r *= k;

    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice_js__ = __webpack_require__(125);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 = root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round_js__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function (node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice_js__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }

      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function (x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function (x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__ = __webpack_require__(193);


var preroot = {
  depth: -1
},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var nodes = Array.from(data),
        n = nodes.length,
        d,
        i,
        root,
        parent,
        node,
        nodeId,
        nodeKey,
        nodeByKey = new Map();

    for (i = 0; i < n; ++i) {
      d = nodes[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__["a" /* Node */](d);

      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = node.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
      }

      if ((nodeId = parentId(d, i, data)) != null && (nodeId += "")) {
        node.parent = nodeId;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i];

      if (nodeId = node.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);else parent.children = [node];
        node.parent = parent;
      } else {
        if (root) throw new Error("multiple roots");
        root = node;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function (node) {
      node.depth = node.parent.depth + 1;
      --n;
    }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");
    return root;
  }

  stratify.id = function (x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors_js__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function (x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors_js__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index_js__ = __webpack_require__(193);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
} // function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.


function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
} // This function works analogously to nextLeft.


function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
} // Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.


function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
} // All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).


function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;

  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
} // If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.


function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor

  this.a = this; // ancestor

  this.z = 0; // prelim

  this.m = 0; // mod

  this.c = 0; // change

  this.s = 0; // shift

  this.t = null; // thread

  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index_js__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);

      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
} // Node-link tree diagram using the Reingold-Tilford "tidy" algorithm


/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root); // Compute the layout using Buchheim et al.’s algorithm.

    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk); // If a fixed node size is specified, scale x and y.

    if (nodeSize) root.eachBefore(sizeNode); // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function (node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function (node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }
    return root;
  } // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.


  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;

    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;

      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }

    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  } // Computes all real x-coordinates by summing up the modifiers recursively.


  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  } // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).


  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;

      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);

        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }

        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }

      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }

      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }

    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function (x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function (x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [dx, dy];
  };

  tree.nodeSize = function (x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [dx, dy] : null;
  };

  return tree;
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_js__ = __webpack_require__(305);




/* harmony default export */ __webpack_exports__["a"] = (function () {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify_js__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */];

  function treemap(root) {
    root.x0 = root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round_js__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;

    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function (x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function (x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function (x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors_js__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function (x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function (x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function (x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function (x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function (x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function (x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function (x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i,
      n = nodes.length,
      sum,
      sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = value / 2 + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;else hi = mid;
    }

    if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if (x1 - x0 > y1 - y0) {
      var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(151);


/* unused harmony default export */ var _unused_webpack_default_export = (function (parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice_js__["a" /* default */])(parent, x0, y0, x1, y1);
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify_js__ = __webpack_require__(195);



/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(ratio) {
  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && rows.ratio === ratio) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;

        for (i = row.value = 0, n = nodes.length; i < n; ++i) {
          row.value += nodes[i].value;
        }

        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice_js__["a" /* default */])(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);else Object(__WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */])(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify_js__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function (x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify_js__["b" /* phi */]));

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsx__ = __webpack_require__(20);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var nodes = props.nodes,
      coord = props.coord;

  if (coord.isPolar) {
    var center = coord.center;
    var x = center.x,
        y = center.y;
    return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, nodes.map(function (node) {
      var xMin = node.xMin,
          xMax = node.xMax,
          yMin = node.yMin,
          yMax = node.yMax,
          color = node.color;
      return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("sector", {
        attrs: {
          x: x,
          y: y,
          lineWidth: '1px',
          stroke: '#fff',
          startAngle: xMin,
          endAngle: xMax,
          r0: yMin,
          r: yMax,
          anticlockwise: false,
          fill: color
        }
      });
    }));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, nodes.map(function (node) {
    var key = node.key,
        xMin = node.xMin,
        xMax = node.xMax,
        yMin = node.yMin,
        yMax = node.yMax,
        color = node.color;
    return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("rect", {
      key: key,
      attrs: {
        x: xMin,
        y: yMin,
        width: xMax - xMin,
        height: yMax - yMin,
        fill: color,
        lineWidth: '4px',
        stroke: '#fff',
        radius: '8px'
      },
      animation: {
        appear: {
          easing: 'linear',
          duration: 450,
          property: ['fillOpacity', 'strokeOpacity'],
          start: {
            fillOpacity: 0,
            strokeOpacity: 0
          },
          end: {
            fillOpacity: 1,
            strokeOpacity: 1
          }
        },
        update: {
          easing: 'linear',
          duration: 450,
          property: ['x', 'y', 'width', 'height', 'radius', 'lineWidth']
        }
      }
    });
  }));
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withSunburst__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sunburstView__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icicleView__ = __webpack_require__(308);
/* unused harmony reexport withSunburst */
/* unused harmony reexport SunburstView */
/* unused harmony reexport IcicleView */





/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withSunburst__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__view__["a" /* default */]));

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deps_d3_hierarchy_src__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__attr__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controller_coord__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__antv_util__ = __webpack_require__(14);














function rootParent(data) {
  var d = data;

  while (d.depth > 1) {
    d = d.parent;
  }

  return d;
}

/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Sunburst, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Sunburst);

    function Sunburst(props, context) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Sunburst);

      _this = _super.call(this, props, context);
      var coord = props.coord,
          color = props.color,
          data = props.data;
      var width = context.width,
          height = context.height,
          theme = context.theme;
      _this.coordController = new __WEBPACK_IMPORTED_MODULE_11__controller_coord__["a" /* default */]();

      var _assertThisInitialize = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this),
          coordController = _assertThisInitialize.coordController;

      _this.coord = coordController.create(coord, {
        width: width,
        height: height
      });
      _this.color = new __WEBPACK_IMPORTED_MODULE_9__attr__["Category"](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        range: theme.colors
      }, color), {}, {
        data: data
      }));
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Sunburst, [{
      key: "didMount",
      value: function didMount() {
        var _this2 = this;

        var props = this.props,
            container = this.container;
        var onClick = props.onClick;
        var canvas = container.get('canvas');
        this.triggerRef = [];
        canvas.on('click', function (ev) {
          var points = ev.points;

          var shape = _this2.triggerRef.find(function (ref) {
            return Object(__WEBPACK_IMPORTED_MODULE_10__util__["d" /* isInBBox */])(ref.current.getBBox(), points[0]);
          });

          if (shape) {
            ev.shape = shape; // @ts-ignore

            ev.payload = shape.payload;
            onClick && onClick(ev);
          }
        });
      }
    }, {
      key: "_mapping",
      value: function _mapping(children) {
        var colorAttr = this.color,
            coord = this.coord;

        for (var i = 0, len = children.length; i < len; i++) {
          var node = children[i];
          var root = rootParent(node);
          var color = colorAttr.mapping(root.data[colorAttr.field]);
          node.color = color;
          var x0 = node.x0,
              x1 = node.x1,
              y0 = node.y0,
              y1 = node.y1;
          var rect = coord.convertRect({
            x: [x0, x1],
            y: [y0, y1]
          });
          Object(__WEBPACK_IMPORTED_MODULE_12__antv_util__["G" /* mix */])(node, rect); // 递归处理

          if (node.children && node.children.length) {
            this._mapping(node.children);
          }
        }
      }
    }, {
      key: "sunburst",
      value: function sunburst() {
        var props = this.props;
        var data = props.data,
            value = props.value,
            _props$sort = props.sort,
            sort = _props$sort === void 0 ? true : _props$sort;
        var root = Object(__WEBPACK_IMPORTED_MODULE_8__deps_d3_hierarchy_src__["a" /* hierarchy */])({
          children: data
        }).sum(function (d) {
          return d[value];
        }); // 内置按value大小顺序排序，支持传入sort函数

        if (sort === true || Object(__WEBPACK_IMPORTED_MODULE_12__antv_util__["v" /* isFunction */])(sort)) {
          var sortFn = Object(__WEBPACK_IMPORTED_MODULE_12__antv_util__["v" /* isFunction */])(sort) ? sort : function (a, b) {
            return b[value] - a[value];
          };
          root.sort(sortFn);
        }

        var nodes = Object(__WEBPACK_IMPORTED_MODULE_8__deps_d3_hierarchy_src__["b" /* partition */])()(root);
        var children = nodes.children;

        this._mapping(children);

        return nodes;
      }
    }, {
      key: "render",
      value: function render() {
        var node = this.sunburst();
        var coord = this.coord,
            props = this.props;
        return Object(__WEBPACK_IMPORTED_MODULE_6__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          coord: coord,
          node: node,
          triggerRef: this.triggerRef
        }));
      }
    }]);

    return Sunburst;
  }(__WEBPACK_IMPORTED_MODULE_7__base_component__["a" /* default */]);
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sunburstView__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icicleView__ = __webpack_require__(308);




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var coord = props.coord;

  if (coord.type === 'polar') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_2__sunburstView__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_3__icicleView__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withPieLabel__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pieLabeView__ = __webpack_require__(886);
/* unused harmony reexport PieLabelView */
/* unused harmony reexport withPieLabel */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withPieLabel__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__pieLabeView__["a" /* default */]));

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_component__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(98);










var DEFAULT_CONFIG = {
  anchorOffset: '10px',
  inflectionOffset: '30px',
  sidePadding: '15px',
  height: '64px',
  adjustOffset: '30',
  triggerOn: 'click',
  // activeShape: false, // 当有图形被选中的时候，是否激活图形
  // activeStyle: {
  //   offset: '1px',
  //   appendRadius: '8px',
  //   fillOpacity: 0.5,
  // },
  label1OffsetY: '-4px',
  label2OffsetY: '4px'
};

function getEndPoint(center, angle, r) {
  return {
    x: center.x + r * Math.cos(angle),
    y: center.y + r * Math.sin(angle)
  };
} // 计算中间角度


function getMiddleAngle(startAngle, endAngle) {
  if (endAngle < startAngle) {
    endAngle += Math.PI * 2;
  }

  return (endAngle + startAngle) / 2;
}

function move(from, to, count, center) {
  var x = center.x;
  var sort = from.sort(function (a, b) {
    var aDistance = Math.abs(a.x - x);
    var bDistance = Math.abs(b.x - x);
    return bDistance - aDistance;
  });
  return [sort.slice(0, sort.length - count), sort.slice(sort.length - count).concat(to)];
} // 第一象限


function isFirstQuadrant(angle) {
  return angle >= -Math.PI / 2 && angle < 0;
} // 第二象限


function isSecondQuadrant(angle) {
  return angle >= 0 && angle < Math.PI / 2;
}

function isThirdQuadrant(angle) {
  return angle >= Math.PI / 2 && angle < Math.PI;
}

function isFourthQuadrant(angle) {
  return angle >= Math.PI && angle < Math.PI * 3 / 2;
}

function findShapeByClassName(shape, point, className) {
  var targetShapes = Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* getElementsByClassName */])(className, shape);

  for (var i = 0, len = targetShapes.length; i < len; i++) {
    var _shape = targetShapes[i];

    if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isInBBox */])(_shape.getBBox(), point)) {
      return _shape;
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(PieLabel, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createSuper__["a" /* default */])(PieLabel);

    function PieLabel(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, PieLabel);

      _this = _super.call(this, props);

      _this._handleEvent = function (ev) {
        var _this$props = _this.props,
            chart = _this$props.chart,
            onClick = _this$props.onClick;
        var ele = _this.triggerRef.current;
        var point = ev.points[0];
        var shape = findShapeByClassName(ele, point, 'click');
        var pieData = chart.getSnapRecords(point);

        if (typeof onClick === 'function') {
          // 点击label
          if (shape) {
            onClick(shape.get('data'));
          } // 点击饼图
          else if (Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["r" /* isArray */])(pieData) && pieData.length > 0) {
            onClick(pieData);
          }
        }
      };

      _this.triggerRef = {};
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(PieLabel, [{
      key: "willMount",
      value: function willMount() {}
      /**
       * 绑定事件
       */

    }, {
      key: "didMount",
      value: function didMount() {
        this._initEvent();
      }
    }, {
      key: "getLabels",
      value: function getLabels(props) {
        var chart = props.chart,
            coord = props.coord,
            anchorOffset = props.anchorOffset,
            inflectionOffset = props.inflectionOffset,
            label1 = props.label1,
            label2 = props.label2,
            itemHeight = props.height,
            sidePadding = props.sidePadding;
        var center = coord.center,
            radius = coord.radius,
            coordWidth = coord.width,
            coordHeight = coord.height,
            coordLeft = coord.left,
            coordRight = coord.right,
            coordTop = coord.top;
        var maxCountForOneSide = Math.floor(coordHeight / itemHeight);
        var maxCount = maxCountForOneSide * 2;
        var geometry = chart.getGeometrys()[0];
        var records = geometry.flatRecords() // 按角度大到小排序
        .sort(function (a, b) {
          var angle1 = a.xMax - a.xMin;
          var angle2 = b.xMax - b.xMin;
          return angle2 - angle1;
        }) // 只取前 maxCount 个显示
        .slice(0, maxCount); // 存储左右 labels

        var halves = [[], [] // right
        ];
        records.forEach(function (record) {
          var xMin = record.xMin,
              xMax = record.xMax,
              color = record.color,
              origin = record.origin; // 锚点角度

          var anchorAngle = getMiddleAngle(xMin, xMax); // 锚点坐标

          var anchorPoint = getEndPoint(center, anchorAngle, radius + anchorOffset); // 拐点坐标

          var inflectionPoint = getEndPoint(center, anchorAngle, radius + inflectionOffset); // 锚点方向

          var side = anchorPoint.x < center.x ? 'left' : 'right';
          var label = {
            origin: origin,
            angle: anchorAngle,
            anchor: anchorPoint,
            inflection: inflectionPoint,
            side: side,
            x: inflectionPoint.x,
            y: inflectionPoint.y,
            r: radius + inflectionOffset,
            color: color,
            label1: Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["v" /* isFunction */])(label1) ? label1(origin, record) : label1,
            label2: Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["v" /* isFunction */])(label2) ? label2(origin, record) : label2
          }; // 判断文本的方向

          if (side === 'left') {
            halves[0].push(label);
          } else {
            halves[1].push(label);
          }
        }); // 判断是有一边超过了显示的最大

        if (halves[0].length > maxCountForOneSide) {
          halves = move(halves[0], halves[1], halves[0].length - maxCountForOneSide, center);
        } else if (halves[1].length > maxCountForOneSide) {
          var _move = move(halves[1], halves[0], halves[1].length - maxCountForOneSide, center),
              _move2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_move, 2),
              right = _move2[0],
              left = _move2[1];

          halves = [left, right];
        } // label 的最大宽度


        var labelWidth = coordWidth / 2 - radius - anchorOffset - inflectionOffset - 2 * sidePadding;
        var labels = [];
        halves.forEach(function (half, index) {
          var showSide = index === 0 ? 'left' : 'right'; // 顺时针方向排序

          half.sort(function (a, b) {
            var aAngle = a.angle;
            var bAngle = b.angle;

            if (showSide === 'left') {
              // 是否在第一象限
              aAngle = isFirstQuadrant(aAngle) ? aAngle + Math.PI * 2 : aAngle;
              bAngle = isFirstQuadrant(bAngle) ? bAngle + Math.PI * 2 : bAngle;
              return bAngle - aAngle;
            } else {
              // 是否在第四象限
              aAngle = isFourthQuadrant(aAngle) ? aAngle - Math.PI * 2 : aAngle;
              bAngle = isFourthQuadrant(bAngle) ? bAngle - Math.PI * 2 : bAngle;
              return aAngle - bAngle;
            }
          });
          var pointsY = half.map(function (label) {
            return label.y;
          });
          var maxY = Math.max.apply(null, pointsY);
          var minY = Math.min.apply(null, pointsY); // 每个 label 占用的高度

          var labelCount = half.length;
          var labelHeight = coordHeight / labelCount;
          var halfLabelHeight = labelHeight / 2; // 线之间的间隔

          var lineInterval = 2;

          if (showSide === 'left') {
            half.forEach(function (label, index) {
              var anchor = label.anchor,
                  inflection = label.inflection,
                  angle = label.angle,
                  x = label.x,
                  y = label.y;
              var points = [anchor, inflection];
              var endX = coordLeft + sidePadding;
              var endY = coordTop + halfLabelHeight + labelHeight * index; // 文本开始点

              var labelStart = {
                x: endX + labelWidth + lineInterval * index,
                y: endY
              }; // 文本结束点

              var labelEnd = {
                x: endX,
                y: endY
              }; // 第四象限

              if (isFirstQuadrant(angle)) {
                var pointY = minY - lineInterval * (labelCount - index);
                points.push({
                  x: x,
                  y: pointY
                });
                points.push({
                  x: labelStart.x,
                  y: pointY
                });
              } else if (isThirdQuadrant(angle) || isFourthQuadrant(angle)) {
                points.push({
                  x: labelStart.x,
                  y: y
                });
              } else if (isSecondQuadrant(angle)) {
                var _pointY = maxY + lineInterval * index;

                points.push({
                  x: x,
                  y: _pointY
                });
                points.push({
                  x: labelStart.x,
                  y: _pointY
                });
              }

              points.push(labelStart);
              points.push(labelEnd);
              label.points = points;
              label.side = showSide;
              labels.push(label);
            });
          } else {
            half.forEach(function (label, index) {
              var anchor = label.anchor,
                  inflection = label.inflection,
                  angle = label.angle,
                  x = label.x,
                  y = label.y; // 折线的点

              var points = [anchor, inflection];
              var endX = coordRight - sidePadding;
              var endY = coordTop + halfLabelHeight + labelHeight * index; // 文本开始点

              var labelStart = {
                x: endX - labelWidth - lineInterval * index,
                y: endY
              }; // 文本结束点

              var labelEnd = {
                x: endX,
                y: endY
              }; // 第四象限

              if (isFourthQuadrant(angle)) {
                var pointY = minY - lineInterval * (labelCount - index);
                points.push({
                  x: x,
                  y: pointY
                });
                points.push({
                  x: labelStart.x,
                  y: pointY
                });
              } else if (isFirstQuadrant(angle) || isSecondQuadrant(angle)) {
                points.push({
                  x: labelStart.x,
                  y: y
                });
              } else if (isThirdQuadrant(angle)) {
                var _pointY2 = maxY + lineInterval * index;

                points.push({
                  x: x,
                  y: _pointY2
                });
                points.push({
                  x: labelStart.x,
                  y: _pointY2
                });
              }

              points.push(labelStart);
              points.push(labelEnd);
              label.points = points;
              label.side = showSide;
              labels.push(label);
            });
          }
        });
        return labels;
      }
    }, {
      key: "_initEvent",
      value: function _initEvent() {
        var context = this.context,
            props = this.props;
        var canvas = context.canvas;
        var _props$triggerOn = props.triggerOn,
            triggerOn = _props$triggerOn === void 0 ? DEFAULT_CONFIG.triggerOn : _props$triggerOn;
        canvas.on(triggerOn, this._handleEvent);
      }
    }, {
      key: "render",
      value: function render() {
        var context = this.context;
        var props = context.px2hd(Object(__WEBPACK_IMPORTED_MODULE_8__antv_util__["d" /* deepMix */])({}, DEFAULT_CONFIG, this.props));
        var labels = this.getLabels(props);
        return Object(__WEBPACK_IMPORTED_MODULE_6__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          labels: labels
        }, props), {}, {
          triggerRef: this.triggerRef
        }));
      }
    }]);

    return PieLabel;
  }(__WEBPACK_IMPORTED_MODULE_7__base_component__["a" /* default */]);
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var lineStyle = props.lineStyle,
      anchorStyle = props.anchorStyle,
      labels = props.labels,
      label1OffsetY = props.label1OffsetY,
      label2OffsetY = props.label2OffsetY,
      triggerRef = props.triggerRef;
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
    ref: triggerRef
  }, labels.map(function (label) {
    var origin = label.origin,
        anchor = label.anchor,
        side = label.side,
        color = label.color,
        label1 = label.label1,
        label2 = label.label2,
        points = label.points;
    var end = points[points.length - 1];
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("circle", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        r: '4px',
        x: anchor.x,
        y: anchor.y,
        fill: color
      }, anchorStyle)
    }), Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("polyline", {
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        points: points,
        lineWidth: '2px',
        stroke: color
      }, lineStyle)
    }), Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      className: "click",
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: end.x,
        y: end.y + label1OffsetY,
        fontSize: '24px',
        lineHeight: '24px',
        fill: color,
        textBaseline: 'bottom',
        textAlign: side === 'left' ? 'left' : 'right'
      }, label1),
      data: origin
    }), Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("text", {
      className: "click",
      attrs: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
        x: end.x,
        y: end.y + label2OffsetY,
        fontSize: '24px',
        lineHeight: '24px',
        fill: '#808080',
        textBaseline: 'top',
        textAlign: side === 'left' ? 'left' : 'right'
      }, label2),
      data: origin
    }));
  }));
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withGauge__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gaugeView__ = __webpack_require__(889);
/* unused harmony reexport withGauge */
/* unused harmony reexport GaugeView */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withGauge__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__gaugeView__["a" /* default */]));

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_component__ = __webpack_require__(58);








var getPoint = function getPoint(cener, angle, r) {
  var x = cener.x + Math.cos(angle) * r;
  var y = cener.y + Math.sin(angle) * r;
  return {
    x: x,
    y: y
  };
};

var getTicks = function getTicks(start, end, tickCount, center, r, tickOffset, tickLength) {
  var ticks = [];
  var diff = end - start;

  for (var i = 0; i <= tickCount; i++) {
    var tickValue = start + diff * i / tickCount;
    var startPoint = getPoint(center, tickValue, r + tickOffset - tickLength);
    var endPoint = getPoint(center, tickValue, r + tickOffset);
    ticks.push({
      tickValue: tickValue,
      start: startPoint,
      end: endPoint
    });
  }

  return ticks;
};

/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inherits__["a" /* default */])(Guage, _Component);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createSuper__["a" /* default */])(Guage);

    function Guage() {
      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Guage);

      return _super.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Guage, [{
      key: "render",
      value: function render() {
        var props = this.props,
            context = this.context;
        var startAngle = props.startAngle,
            endAngle = props.endAngle,
            tickCount = props.tickCount,
            center = props.center,
            r = props.r,
            tickOffset = props.tickOffset,
            tickLength = props.tickLength;
        var ticks = getTicks(startAngle, endAngle, tickCount, center, context.px2hd(r), context.px2hd(tickOffset), context.px2hd(tickLength));
        return Object(__WEBPACK_IMPORTED_MODULE_5__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props), {}, {
          ticks: ticks
        }));
      }
    }]);

    return Guage;
  }(__WEBPACK_IMPORTED_MODULE_6__base_component__["a" /* default */]);
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsx__ = __webpack_require__(20);

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var center = props.center,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      r = props.r,
      percent = props.percent,
      ticks = props.ticks;
  var x = center.x,
      y = center.y;
  var diff = endAngle - startAngle;
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("arc", {
    attrs: {
      x: x,
      y: y,
      r: r,
      startAngle: startAngle,
      endAngle: endAngle,
      lineWidth: '20px',
      lineCap: 'round',
      stroke: '#e7e7e7'
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("arc", {
    attrs: {
      x: x,
      y: y,
      r: r,
      startAngle: startAngle,
      endAngle: startAngle,
      lineWidth: '40px',
      lineCap: 'round',
      stroke: '#0075ff'
    },
    animation: {
      appear: {
        easing: 'linear',
        duration: 500,
        property: ['endAngle'],
        start: {
          endAngle: startAngle
        },
        end: {
          endAngle: startAngle + diff * percent
        }
      }
    }
  }), ticks.map(function (tick) {
    var start = tick.start,
        end = tick.end;
    return Object(__WEBPACK_IMPORTED_MODULE_0__jsx__["c" /* jsx */])("line", {
      attrs: {
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y,
        lineWidth: '6px',
        lineCap: 'round',
        stroke: '#e7e7e7'
      }
    });
  }));
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateFollow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__antv_scale__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__antv_util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(98);



 // 判断新老values是否相等，这里只要判断前后是否相等即可

function isValuesEqual(values, newValues) {
  if (values.length !== newValues.length) {
    return false;
  }

  var lastIndex = values.length - 1;
  return values[0] === newValues[0] && values[lastIndex] === newValues[lastIndex];
}

function updateCategoryRange(scale, originScale, range) {
  var currentValues = scale.values,
      currentTicks = scale.ticks,
      tickMethod = scale.tickMethod,
      tickCount = scale.tickCount;
  var originValues = originScale.values;

  var _range = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(range, 2),
      start = _range[0],
      end = _range[1];

  var len = originValues.length;
  var valueStart = start * len;
  var valueEnd = end * len; // 保持滑动时个数的稳定

  var count = Math.round(valueEnd - valueStart);
  var sliceSatrt = Math.round(valueStart); // 从原始数据里截取需要显示的数据

  var newValues = originValues.slice(sliceSatrt, sliceSatrt + count); // 根据当前数据的比例，和定义的tickCount计算应该需要多少个ticks

  var newTickCount = Math.round(tickCount * originValues.length / newValues.length); // 计算新的ticks

  var catTicks = Object(__WEBPACK_IMPORTED_MODULE_1__antv_scale__["e" /* getTickMethod */])(tickMethod);
  var newTicks = catTicks({
    tickCount: newTickCount,
    values: originValues
  }); // 如果新数组和当前显示的数组相同，则不更新

  if (isValuesEqual(currentValues, newValues) && isValuesEqual(currentTicks, newTicks)) {
    return;
  }

  scale.change({
    values: newValues,
    ticks: newTicks
  });
  return scale;
}

function updateLinearRange(scale, originScale, range) {
  var min = originScale.min,
      max = originScale.max;

  var _range2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(range, 2),
      start = _range2[0],
      end = _range2[1];

  var newMin = min + (max - min) * start;
  var newMax = min + (max - min) * end;
  scale.change({
    min: newMin,
    max: newMax,
    nice: false
  });
}

function updateScale(scale, values) {
  var isLinear = scale.isLinear;

  if (isLinear) {
    var _getRange = Object(__WEBPACK_IMPORTED_MODULE_2__antv_util__["l" /* getRange */])(values),
        min = _getRange.min,
        max = _getRange.max;

    return scale.change({
      min: min,
      max: max,
      nice: true
    });
  }
}

function updateRange(scale, originScale, range) {
  var isCategory = scale.isCategory,
      isLinear = scale.isLinear;

  if (isCategory) {
    return updateCategoryRange(scale, originScale, range);
  }

  if (isLinear) {
    return updateLinearRange(scale, originScale, range);
  }
}

function updateFollow(scales, mainScale, data) {
  var mainField = mainScale.field,
      mainType = mainScale.type,
      mainValues = mainScale.values; // 转成 map 提高查询性能

  var mainValuesMap = {};
  mainValues.forEach(function (item) {
    mainValuesMap[item] = true;
  });
  return scales.map(function (scale) {
    var followField = scale.field;
    var values = [];
    data.forEach(function (item) {
      var value = mainType === 'timeCat' ? Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* toTimeStamp */])(item[mainField]) : item[mainField];

      if (mainValuesMap[value]) {
        values.push(item[followField]);
      }
    });
    return updateScale(scale, values);
  });
}



/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withScrollBar__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scrollBarView__ = __webpack_require__(893);
/* unused harmony reexport withScrollBar */
/* unused harmony reexport ScrollBarView */



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__withScrollBar__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__scrollBarView__["a" /* default */]));

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__zoom__ = __webpack_require__(309);









/* harmony default export */ __webpack_exports__["a"] = (function (View) {
  return /*#__PURE__*/function (_Zoom) {
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollBar, _Zoom);

    var _super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createSuper__["a" /* default */])(ScrollBar);

    function ScrollBar() {
      Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollBar);

      return _super.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollBar, [{
      key: "willMount",
      value: function willMount() {
        Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_get__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollBar.prototype), "willMount", this).call(this);

        var context = this.context,
            props = this.props;
        var visible = props.visible,
            _props$position = props.position,
            position = _props$position === void 0 ? 'bottom' : _props$position,
            _props$margin = props.margin,
            margin = _props$margin === void 0 ? '16px' : _props$margin,
            chart = props.chart;
        var marginNumber = context.px2hd(margin);

        if (visible === false) {
          return null;
        }

        chart.updateCoordFor(this, {
          position: position,
          width: position === 'left' || position === 'right' ? marginNumber : 0,
          height: position === 'bottom' || position === 'top' ? marginNumber : 0
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
            state = this.state;
        var visible = props.visible;

        if (visible === false) {
          return null;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_7__jsx__["c" /* jsx */])(View, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({
          position: "bottom"
        }, props), state));
      }
    }]);

    return ScrollBar;
  }(__WEBPACK_IMPORTED_MODULE_8__zoom__["a" /* default */]);
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__horizontal__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vertical__ = __webpack_require__(895);




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var position = props.position,
      mode = props.mode;

  if (mode.length > 1) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", null, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_3__vertical__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props)), Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_2__horizontal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props)));
  }

  if (position === 'left' || position === 'right') {
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_3__vertical__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_2__horizontal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, props));
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var coord = props.coord,
      range = props.range,
      position = props.position,
      layout = props.layout;
  var left = coord.left,
      width = coord.width;
  var top = layout.top,
      height = layout.height;

  var _ref = (range === null || range === void 0 ? void 0 : range.x) || (range === null || range === void 0 ? void 0 : range.y),
      _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  var barLeft = width * start;
  var barWidth = width * (end - start);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
    style: {
      left: left,
      top: position === 'top' ? top - context.px2hd('8px') : top + height
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    style: {
      position: 'absolute',
      left: 0,
      width: width,
      height: 0
    },
    attrs: {
      stroke: 'rgba(202, 215, 239, .2)',
      lineCap: 'round',
      lineWidth: '8px'
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    style: {
      position: 'absolute',
      left: barLeft,
      width: barWidth,
      height: 0
    },
    attrs: {
      stroke: 'rgba(202, 215, 239, .5)',
      lineCap: 'round',
      lineWidth: '8px'
    }
  }));
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsx__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = (function (props, context) {
  var coord = props.coord,
      range = props.range,
      position = props.position,
      layout = props.layout;
  var top = coord.top,
      height = coord.height;
  var left = layout.left,
      width = layout.width;

  var _ref = (range === null || range === void 0 ? void 0 : range.y) || (range === null || range === void 0 ? void 0 : range.x),
      _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  var barTop = height * start;
  var barHeight = height * (end - start);
  return Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("group", {
    style: {
      top: top,
      left: position === 'left' ? left - context.px2hd('8px') : left + width
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 0,
      height: height
    },
    attrs: {
      stroke: 'rgba(202, 215, 239, .2)',
      lineCap: 'round',
      lineWidth: '8px'
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1__jsx__["c" /* jsx */])("line", {
    style: {
      position: 'absolute',
      top: barTop,
      width: 0,
      height: barHeight
    },
    attrs: {
      stroke: 'rgba(202, 215, 239, .5)',
      lineCap: 'round',
      lineWidth: '8px'
    }
  }));
});

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCheckAppDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var details={"goodsId":123,"goodsName":"iPhone 18","subtitle":"买就送air pods","goodsUrl":"https://item.taobao.com/item.htm?id=684824549373","imgUrl":"https://static.shihuocdn.cn/admin/files/20221211/1d91ecea5b28a6a426fe74c59d2455f8.jpeg","price":"99.80","discountPrice":"88.80","sale":"1000w+","tags":["包邮","假一赔万"],"shopName":"苹果官网","shopId":"666888","shopUrl":"https://shop.m.taobao.com/shop/shop_index.htm?user_id=890482188&item_id=681719765292","specs":[{"name":"颜色","attrs":[{"name":"白色","image":"https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"},{"name":"黑色","image":"https://img.alicdn.com/bao/uploaded/i2/2783679443/O1CN01NWPSVC2JcwqQBChAd_%21%212783679443.jpg_120x120.jpg"}]},{"name":"尺码","attrs":[{"name":"L"},{"name":"M"},{"name":"S"}]}],"postage":"免运费","Details":[{"Type":"Image","Content":"https://img.alicdn.com/imgextra/i2/2819894826/O1CN01qgh0Yl1lWLzzGS4Op_%21%212819894826.jpg"},{"Type":"Image","Content":"https://img.alicdn.com/imgextra/i3/2819894826/O1CN019NgjxY1lWLzyCSxcL_%21%212819894826.jpg"},{"Type":"Text","Content":"这是图文详情的文本类型"}],"extraShow":["自定义1","自定义2"],"extraExport":["自定义3","自定义4"]};var PipelineCheckAppDetail=/*#__PURE__*/function(_React$Component){_inherits(PipelineCheckAppDetail,_React$Component);var _super=_createSuper(PipelineCheckAppDetail);function PipelineCheckAppDetail(props){var _this;_classCallCheck(this,PipelineCheckAppDetail);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"imgProxy",function(origin){var base64=window.btoa(unescape(encodeURIComponent(origin)));base64=base64.replace(new RegExp("/","g"),"_");base64=base64.replace(new RegExp('\\+',"g"),"-");base64=base64.replace(new RegExp('=',"g"),"");return"https://proxy.shihuocdn.cn/".concat(base64);});_defineProperty(_assertThisInitialized(_this),"getDetail",/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(data){var detail,platform,id;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('======== getDetail Lego获取到数据 ========',data);detail={},platform='';if(data){detail=data.data?JSON.parse(data.data):{};}else{detail=details;}if(!(detail.imgUrl&&detail.imgUrl.indexOf('shihuo')>=0)){_context.next=10;break;}console.log('识货平台');id=detail.goodsId;platform='shihuo';_context.next=9;return _this.getProductDetail('goodsId',id);case 9:detail=_context.sent;case 10:_this.setState({pageShow:true,platform:platform,detail:detail},function(){_this.initSwiper();});case 11:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"getProductDetail",function(type,id){var reqUrl;if(type==="goodsId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else if(type==="styleId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}else if(type==="skuId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";}else{reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}var idList=[id];return new Promise(function(resolve){Object(__WEBPACK_IMPORTED_MODULE_19__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:0}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;var result={};if(list&&list.length>0){var _list$=list[0],goods_id=_list$.goods_id,title=_list$.title,recommend=_list$.recommend,url=_list$.url,image=_list$.image,price=_list$.price,sell_point_str=_list$.sell_point_str;result={"goodsId":goods_id,"goodsName":title,"subtitle":recommend,"goodsUrl":url,"imgUrl":image,"price":price,"discountPrice":"","sale":sell_point_str,"tags":[],"shopName":"","shopId":"","shopUrl":"","specs":[],"postage":"","Details":[],"extraShow":[],"extraExport":[]};}resolve(result);}else{resolve({});}});});});_defineProperty(_assertThisInitialized(_this),"initSwiper",function(){var mySwiper=new __WEBPACK_IMPORTED_MODULE_20_swiper_swiper_bundle_min_js___default.a('.banner',{autoplay:false,loop:false});});_defineProperty(_assertThisInitialized(_this),"receiveMessage",function(event){console.log('receiveMessage',event);var _event$data=event.data,_event$data$messageTy=_event$data.messageType,messageType=_event$data$messageTy===void 0?'':_event$data$messageTy,_event$data$data=_event$data.data,data=_event$data$data===void 0?'':_event$data$data;switch(messageType){case'详情数据':_this.getDetail(data);break;case'清除数据':_this.clearData();break;default:break;}});_defineProperty(_assertThisInitialized(_this),"clearData",function(){_this.setState({pageShow:false,detail:{}},function(){typeof window!=="undefined"&&window.location.reload();});});_defineProperty(_assertThisInitialized(_this),"goShop",function(url){url&&window.open(url);});_this.state={platform:"",detail:{},url:"",pageShow:false};return _this;}_createClass(PipelineCheckAppDetail,[{key:"componentDidMount",value:function componentDidMount(){window.addEventListener("message",this.receiveMessage,false);}},{key:"destroyed",value:function destroyed(){typeof window!=="undefined"&&window.removeEventListener("message",this.receiveMessage,false);}},{key:"imageUrl",value:function imageUrl(origin){return"https://proxy.shihuocdn.cn/".concat(window.btoa(unescape(encodeURIComponent(origin))));}// 进入店铺
},{key:"render",value:function render(){var _this2=this;var _this$state=this.state,_this$state$detail=_this$state.detail,detail=_this$state$detail===void 0?{}:_this$state$detail,_this$state$platform=_this$state.platform,platform=_this$state$platform===void 0?'':_this$state$platform,pageShow=_this$state.pageShow;var _detail$specs=detail.specs,specs=_detail$specs===void 0?[]:_detail$specs;if(!pageShow){return null;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"pipeline-checkAppDetail"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"banner swiper"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"swiper-wrapper"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"swiper-slide"},detail.imgUrl&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:this.imgProxy(detail.imgUrl),alt:""})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"detail-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"price-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"price"},detail.price&&"\xA5".concat(detail.price)),detail.discountPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"discount-price"},"\u5238\u540E\u4EF7 \xA5".concat(detail.discountPrice," \u8D77")),platform==='shihuo'&&detail.goodsId&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"goods-id"},"goodsId\uFF1A".concat(detail.goodsId))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"title"},detail.goodsName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:"sub-title"},detail.subtitle)),specs&&specs.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"size-color"},specs.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"attr-wrap",key:"attr-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label",{className:"label"},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",{className:"attr"},item&&item.attrs&&item.attrs.length>0&&item.attrs.map(function(value,key){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("li",{key:"attr-item-".concat(key),style:{padding:value.image&&0,fontSize:value.image&&0,lineHeight:value.image&&"normal"}},value.image?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:_this2.imgProxy(value.image),alt:""}):value.name);})));})),platform!=='shihuo'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"service"},detail.postage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"freight"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("label",{className:"label"},"\u8FD0\u8D39"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",null,detail.postage)),detail.tags&&detail.tags.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("ul",{className:"tags"},detail.tags.map(function(item,index){if(item){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("li",{key:"tag-item-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221214/6b3c18f9b4aaaa33469af8e9211d485c.png",alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",null,item));}else{return null;}}))),platform!=='shihuo'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"extra-info"},detail.shopName&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"shop-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{className:""},detail.shopName)),detail.shopUrl&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"shop-btn",onClick:function onClick(){return _this2.goShop(detail.shopUrl);}},"\u8FDB\u5165\u5E97\u94FA"),detail.Details&&detail.Details.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("div",{className:"desc-info"},detail.Details.map(function(item,index){if(item.Type==='Image'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("img",{key:"desc-item-".concat(index),src:_this2.imgProxy(item.Content),alt:""});}if(item.Type==='Text'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_17_react___default.a.createElement("p",{key:"desc-item-".concat(index)},item.Content);}}))));}}]);return PipelineCheckAppDetail;}(__WEBPACK_IMPORTED_MODULE_17_react___default.a.Component);PipelineCheckAppDetail.propTypes={config:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCheckAppDetail);

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineTextarea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */var PipelineTextarea=/*#__PURE__*/function(_React$Component){_inherits(PipelineTextarea,_React$Component);var _super=_createSuper(PipelineTextarea);function PipelineTextarea(props){var _this;_classCallCheck(this,PipelineTextarea);_this=_super.call(this,props);_this.state={};return _this;}_createClass(PipelineTextarea,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var textarea=document.querySelector('.pipeline-textarea');if(textarea){var childNodes=textarea.getElementsByTagName('*');var childNodesArr=Array.prototype.slice.call(childNodes);var allTagA=childNodesArr.filter(function(item){return item.tagName==='A';});allTagA.forEach(function(item){item.onclick=function(event){event.preventDefault();if(item.href){if(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].isShihuo()){if(item.href.indexOf('sh-gateway.shihuo.cn')>=0){window.Jockey.send('action',{url:"shihuo://www.shihuo.cn?route=fastWebview&url=".concat(encodeURIComponent(item.href))});}else{__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.href,item.href,{},-1,_this2.props,false,{},{},false);}}else{__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,item.href,item.href,{},-1,_this2.props,false,{},{},false);}}};});}}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$te=_this$props$config.textareaConfig,textareaConfig=_this$props$config$te===void 0?{}:_this$props$config$te;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",_extends({ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getExposureData(this.props)),className:textareaConfig.textareaContent.indexOf('table')>=0?"pipeline-textarea has-table":"pipeline-textarea"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_15_react___default.a.createElement("div",{className:textareaConfig.textareaContent.indexOf('table')>=0?'textarea-content has-table':'textarea-content',dangerouslySetInnerHTML:{__html:textareaConfig.textareaContent}}));}}]);return PipelineTextarea;}(__WEBPACK_IMPORTED_MODULE_15_react___default.a.Component);PipelineTextarea.propTypes={config:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineTextarea);

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineImageText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_less__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */var PipelineImageText=/*#__PURE__*/function(_React$Component){_inherits(PipelineImageText,_React$Component);var _super=_createSuper(PipelineImageText);function PipelineImageText(props){var _this;_classCallCheck(this,PipelineImageText);_this=_super.call(this,props);_this.state={};return _this;}_createClass(PipelineImageText,[{key:"componentDidMount",value:function componentDidMount(){}},{key:"render",value:function render(){var _this$props$config=this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$im=_this$props$config.imageTextConfig,imageTextConfig=_this$props$config$im===void 0?{}:_this$props$config$im;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",_extends({className:"pipeline-imageText"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img",{src:imageTextConfig.image,alt:""}));}}]);return PipelineImageText;}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);PipelineImageText.propTypes={config:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineImageText);

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineInteractMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__relyon__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: cuixinming
 * @Last Modified time: Do not edit
 * @Description:
 */var praised_icon='https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png';//选中后
var un_praised_icon='https://static.shihuocdn.cn/admin/files/20241030/3fb5328f73d6e71f26565f4cab026ce1.png';//未点赞
var praised_animated='https://static.shihuocdn.cn/admin/files/20241030/0b93aed2556da7d4fa0f20fd71a83687.svga';//点赞动效
var cancel_praised_animated='https://static.shihuocdn.cn/admin/files/20241030/04da2106cd39ebf948c4dc3d033b46ad.svga';//取消点赞
var startX=0;// 初始触摸点的X坐标
var startY=0;// 初始触摸点的Y坐标
var isSwiping=false;// 是否正在进行滑动手势
var PipelineInteractMessage=/*#__PURE__*/function(_React$Component){_inherits(PipelineInteractMessage,_React$Component);var _super=_createSuper(PipelineInteractMessage);function PipelineInteractMessage(props){var _this;_classCallCheck(this,PipelineInteractMessage);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"peloadingSvg",function(url){//预加载图片资源
if(_this.praiseHiddenRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){var player=new SVGA.Player(_this.praiseHiddenRef);var parser=new SVGA.Parser(_this.praiseHiddenRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(url,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){player.stopAnimation(true);if(url.includes('/0b93aed2556da7d4fa0f20fd71a83687')){_this.peloadingSvg(cancel_praised_animated);}});});});}});_defineProperty(_assertThisInitialized(_this),"resetBulletList",function(){var bulletList=_this.state.bulletList;if(bulletList&&bulletList.length>0){bulletList.forEach(function(item){var bullet={id:item.id,avatar:item.avatar,name:item.name,comment:item.comment,like_cnt:item.like_cnt,self_like:item.self_like,is_self:item.is_self,hot:item.hot};_this.BulletScreen.push(_this.renderStyledBullet(bullet));});}});_defineProperty(_assertThisInitialized(_this),"initBulletScreen",function(){_this.BulletScreen=new __WEBPACK_IMPORTED_MODULE_23__relyon__["a" /* default */](_this.ref,{trackHeight:40,onStart:function onStart(id,index,total){if(index===total-1){_this.state.bulletList.forEach(function(item){var bullet={id:item.id,uid:item.uid,avatar:item.avatar,name:item.name,comment:item.comment,like_cnt:item.like_cnt,self_like:item.self_like,is_self:item.is_self,hot:item.hot};_this.BulletScreen.push(_this.renderStyledBullet(bullet));});}},onEnd:function onEnd(id,index){}});});_defineProperty(_assertThisInitialized(_this),"handleTouchStart",function(event){startX=event.touches[0].clientX;startY=event.touches[0].clientY;isSwiping=false;});_defineProperty(_assertThisInitialized(_this),"handleTouchMove",function(event){if(!startX||!startY){return;// 未初始化或已经重置了起始点
}var deltaX=event.touches[0].clientX-startX;var deltaY=event.touches[0].clientY-startY;// 判断滑动距离是否足够触发滑动手势
if(Math.abs(deltaX)>10||Math.abs(deltaY)>10){isSwiping=true;_this.inputRef&&_this.inputRef.blur();}});_defineProperty(_assertThisInitialized(_this),"handleTouchEnd",function(){// 重置触摸点和滑动状态
startX=0;startY=0;isSwiping=false;});_defineProperty(_assertThisInitialized(_this),"getBulletList",function(){Object(__WEBPACK_IMPORTED_MODULE_24__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/hot?access_token=znSnA7pxO35wtPBaur',method:"get",withCredentials:true,params:{page:1,page_size:50,pos:_this.state.pageId}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var list=data.list;var count=data.count;var randomUsers=_this.getArrayItems(list,3);var topThree=_this.signLikeCntTopThree(list);topThree.forEach(function(item){list.forEach(function(value){if(value.like_cnt===item.like_cnt&&value.like_cnt!=0){value['hot']=1;}});});_this.setState({bulletList:list,randomUsers:randomUsers,count:count},function(){list.forEach(function(item){var bullet={id:item.id,avatar:item.avatar,name:item.name,comment:item.comment,like_cnt:item.like_cnt,self_like:item.self_like,is_self:item.is_self,hot:item.hot};_this.BulletScreen.push(_this.renderStyledBullet(bullet));});});}});});_defineProperty(_assertThisInitialized(_this),"showPraiseSvga",function(svgaUrl,id,bulletIndex){var praiseRef=window.document.getElementById("praise-icon-svga-".concat(id));var praiseIconRef=window.document.getElementById("praise-icon-".concat(id));console.log(id,'---showPraiseSvga1-',_this.praiseRefMap,praiseRef,praiseIconRef);if(praiseRef){var bulletList=_this.state.bulletList;__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){praiseRef.style.display="flex";praiseIconRef.style.display="none";var player=new SVGA.Player("#praise-icon-svga-".concat(id));var parser=new SVGA.Parser("#praise-icon-svga-".concat(id));// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(svgaUrl,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){praiseRef.style.display="none";_this.BulletScreen._changeStatus(bulletList[bulletIndex].id,bulletList[bulletIndex].like_cnt,bulletList[bulletIndex].self_like);player.stopAnimation(true);});});});}});_defineProperty(_assertThisInitialized(_this),"handlePraise",/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(e,bullet){var userCookie,bulletList,bulletIndex,toggleStatus;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getCookie('u');case 2:userCookie=_context.sent;if(userCookie){_context.next=6;break;}window.Jockey.send('login');return _context.abrupt("return");case 6:bulletList=_this.state.bulletList;bulletIndex=bulletList.findIndex(function(item){return item.id===bullet.id;});toggleStatus=bulletList[bulletIndex].self_like?0:1;// 切换状态
bulletList[bulletIndex].self_like=Boolean(toggleStatus);console.log('-handlePraise--',toggleStatus);if(toggleStatus===1){bulletList[bulletIndex].like_cnt+=1;_this.showPraiseSvga(praised_animated,bullet.id,bulletIndex);}else{_this.showPraiseSvga(cancel_praised_animated,bullet.id,bulletIndex);bulletList[bulletIndex].like_cnt-=1;}if(userCookie){_this.setState({bulletList:bulletList});// 点赞与取消
Object(__WEBPACK_IMPORTED_MODULE_24__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/like?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{comment_id:bulletList[bulletIndex].id,status:toggleStatus}}).then(function(res){if(res.data.status===0){// 操作成功
}});}case 13:case"end":return _context.stop();}}},_callee);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleMessageChange",function(event){_this.setState({message:event.target.value});});_defineProperty(_assertThisInitialized(_this),"handleSendMessage",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this$state,message,bulletList,userCookie;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this$state=_this.state,message=_this$state.message,bulletList=_this$state.bulletList;if(message){_context2.next=4;break;}_this.setState({show_toast:true,toast_text:'请输入留言信息'});return _context2.abrupt("return");case 4:_context2.next=6;return __WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getCookie('u');case 6:userCookie=_context2.sent;if(userCookie){Object(__WEBPACK_IMPORTED_MODULE_24__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/save?access_token=znSnA7pxO35wtPBaur',method:"post",withCredentials:true,data:{comment:message,pos:_this.state.pageId}}).then(function(res){if(res.data.status===0){// 将新发布的一条消息推入列表
var _res$data$data$commen=res.data.data.comment,id=_res$data$data$commen.id,name=_res$data$data$commen.name,avatar=_res$data$data$commen.avatar,comment=_res$data$data$commen.comment,like_cnt=_res$data$data$commen.like_cnt,self_like=_res$data$data$commen.self_like;var option={id:id,avatar:avatar,name:name,comment:comment,like_cnt:like_cnt,self_like:self_like,is_self:1};_this.BulletScreen.push(_this.renderStyledBullet(option),{},'unshift');bulletList.push(option);_this.setState({bulletList:bulletList,message:'',show_toast:true,toast_text:'留言发布成功'});}else{_this.setState({show_toast:true,toast_text:res.data.msg});}});}else if(typeof window!=='undefined'){window.Jockey.send('login');}case 8:case"end":return _context2.stop();}}},_callee2);})));_defineProperty(_assertThisInitialized(_this),"getUserName",function(){var username=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';if(username.length<=0){return'C*o';}else if(username.length>0&&username.length<2){return username;}else if(username.length===2){var firstChar=username[0];username=firstChar+'*';return username;}else{var _firstChar=username[0];var lastChar=username[username.length-1];username=_firstChar+'*'+lastChar;return username;}});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(){var href="shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Activity&page=InteractionMessage&options=".concat(encodeURIComponent(JSON.stringify({pageId:_this.state.pageId})));__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,href,href,{},-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"renderToast",function(){var _this$state2=_this.state,show_toast=_this$state2.show_toast,toast_text=_this$state2.toast_text;if(show_toast){_this.interval&&clearTimeout(_this.interval);_this.interval=setTimeout(function(){_this.setState({show_toast:false,toast_text:''});},3000);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"toast"},toast_text);}else{return null;}});_defineProperty(_assertThisInitialized(_this),"getArrayItems",function(arr,num){arr=_this.removeDuplicate(arr);//新建一个数组,将传入的数组复制过来,用于运算,而不要直接操作传入的数组;
var temp_array=new Array();for(var index in arr){temp_array.push(arr[index]);}//取出的数值项,保存在此数组
var return_array=new Array();for(var i=0;i<num;i++){//判断如果数组还有可以取出的元素,以防下标越界
if(temp_array.length>0){//在数组中产生一个随机索引
var arrIndex=Math.floor(Math.random()*temp_array.length);//将此随机索引的对应的数组元素值复制出来
return_array[i]=temp_array[arrIndex];//然后删掉此索引的数组元素,这时候temp_array变为新的数组
temp_array.splice(arrIndex,1);}else{//数组中数据项取完后,退出循环,比如数组本来只有10项,但要求取出20项.
break;}}return return_array;});_this.state={bulletList:[],randomUsers:[],count:0,message:'',show_toast:false,toast_text:'',pageId:__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getPageId()};_this.BulletScreen=null;_this.interval=null;_this.inputRef=null;_this.praiseRefMap={};_this.praiseImgRefMap={};return _this;}_createClass(PipelineInteractMessage,[{key:"componentDidMount",value:function componentDidMount(){this.getBulletList();this.initBulletScreen();// document.addEventListener("visibilitychange", () => {
//   var string = document.visibilityState
//   if (string === 'hidden') {
//     this.BulletScreen.pause();
//   }
//   if (string === 'visible') {
//     this.BulletScreen.resume();
//   }
// });
// 添加事件监听器
document.addEventListener('touchstart',this.handleTouchStart);document.addEventListener('touchmove',this.handleTouchMove);document.addEventListener('touchend',this.handleTouchEnd);this.peloadingSvg(praised_animated);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var isAnchorInSwitchTab=this.props['customAttributes']["data-component-belong"]==='tab';if(isAnchorInSwitchTab&&nextProps.tabActive!=nextProps.tabIndex){if(this.BulletScreen){this.BulletScreen.clear();this.BulletScreen.stop=true;}}else{if(this.BulletScreen){this.BulletScreen.stop=false;}}if(nextProps.playerState==='pause'){// 暂停播放
if(this.BulletScreen){this.BulletScreen.destory();}}else if(nextProps.playerState==='play'){this.BulletScreen=null;this.initBulletScreen();this.resetBulletList();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.interval);this.interval=null;document.removeEventListener('touchstart',this.handleTouchStart);document.removeEventListener('touchmove',this.handleTouchMove);document.removeEventListener('touchend',this.handleTouchEnd);}},{key:"scrollSmoothTo",value:function scrollSmoothTo(position){if(!window.requestAnimationFrame){window.requestAnimationFrame=function(callback,element){return setTimeout(callback,17);};}// 当前滚动高度
var scrollTop=document.documentElement.scrollTop||document.body.scrollTop;// 滚动step方法
var step=function step(){// 距离目标滚动距离
var distance=position-scrollTop;// 目标滚动位置
scrollTop=scrollTop+distance/5;if(Math.abs(distance)<1){window.scrollTo(0,position);}else{window.scrollTo(0,scrollTop);requestAnimationFrame(step);}};step();}// 获取留言信息
},{key:"removeDuplicate",value:function removeDuplicate(arr){var map={};var result=[];for(var i=0;i<arr.length;i++){var item=arr[i];if(!map[item.name]){map[item.name]=true;// 标记id已经出现过
result.push(item);}}return result;}// 获取点赞前三的评论
},{key:"signLikeCntTopThree",value:function signLikeCntTopThree(arr){return arr.map(function(item,i){//  重构，将数组每项绑定相应索引
return{index:i,like_cnt:item.like_cnt};}).sort(function(a,b){//  排序，根据每项数值排序
return b.like_cnt-a.like_cnt;}).filter(function(item,i){//  筛选，获取排序后前三项
return i<3;}).map(function(item){//  提取，获取前三项原始索引
return item;});}},{key:"renderStyledBullet",value:// 渲染留言弹幕
function renderStyledBullet(bullet){var _this2=this;var _this$props$config$st=this.props.config.styleConfig,styleConfig=_this$props$config$st===void 0?{}:_this$props$config$st;var id=bullet.id,avatar=bullet.avatar,name=bullet.name,comment=bullet.comment,like_cnt=bullet.like_cnt,self_like=bullet.self_like,hot=bullet.hot,is_self=bullet.is_self;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"bullet-item bullet-item-".concat(id," ").concat(hot==1?'hot':''," ").concat(is_self==1?'active':''),style:{color:styleConfig.barrageTextColor,background:"linear-gradient(90deg, ".concat(__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].hexColorToRgba(styleConfig.barrageBgColorFrom,is_self==1?1:0.7)," 0%, ").concat(__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].hexColorToRgba(styleConfig.barrageBgColorTo,is_self==1?1:0.7)," 100%)")}},hot==1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240220/eaf51770a87e6db641054a93b272efd7.png",alt:"",className:"hot-tag"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:avatar||'https://static.shihuocdn.cn/admin/files/20240220/fedaec1a685a6b957fef5d37a7efb899.png',alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"nickname"},this.getUserName(name),is_self==1&&'(我)',"\uFF1A"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"message"},comment.length>12?comment.slice(0,12)+'...':comment),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"praise"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"praise-icon-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"self-like"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:!self_like?un_praised_icon:praised_icon,alt:"",className:"icon",ref:function ref(r){_this2.praiseImgRefMap[id]=r;},id:"praise-icon-".concat(id)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"praise-icon-svga"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{style:{width:'100%',height:'100%',alignItems:'center',justifyContent:'center'},id:"praise-icon-svga-".concat(id),ref:function ref(r){_this2.praiseRefMap[id]=r;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"like-cnt"},like_cnt>0?like_cnt:'')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"praise-cover",onClick:function onClick(e){return _this2.handlePraise(e,bullet);}}));}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$st2=_this$props$config.styleConfig,styleConfig=_this$props$config$st2===void 0?{}:_this$props$config$st2;var _ref3=styleConfig||{},backgroundColorType=_ref3.backgroundColorType,backgroundColor=_ref3.backgroundColor,messagefuncBackgroundColor=_ref3.messagefuncBackgroundColor,backgroundImage=_ref3.backgroundImage;var _this$state3=this.state,message=_this$state3.message,_this$state3$randomUs=_this$state3.randomUsers,randomUsers=_this$state3$randomUs===void 0?[]:_this$state3$randomUs,count=_this$state3.count;var contentStyle=backgroundColorType=="纯色背景"?{backgroundColor:backgroundColor}:backgroundColorType=="图片背景"?{backgroundImage:"url(".concat(backgroundImage,")")}:{};var inputStyle={backgroundColor:backgroundColorType=="纯色背景"?messagefuncBackgroundColor:"transparent"};return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",_extends({ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getExposureData(this.props)),className:"pipeline-interactMessage"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:"".concat(baseConfig.moduleMarginHorizon,"px"),marginRight:"".concat(baseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"content",style:contentStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"header",style:{color:styleConfig.titleColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"title-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"title-name"},"\u8BC4\u8BBA\u7559\u8A00\u533A"),count>10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"users"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"user-avatar"},randomUsers.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:item.avatar||'https://static.shihuocdn.cn/admin/files/20240220/fedaec1a685a6b957fef5d37a7efb899.png',alt:"",key:index,className:"img-".concat(index+1)});})),count&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"join-num"},count,"\u4EBA\u53C2\u4E0E"))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"more",onClick:function onClick(){return _this3.handleItemClick();}},"\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("svg",{t:"1680593620629",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2293",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"2294",fill:styleConfig.titleColor})))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"screen",ref:function ref(_ref4){return _this3.ref=_ref4;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("p",{className:"tips"},"\u4E00\u5927\u6CE2\u7559\u8A00\u6B63\u5728\u6765\u88AD...")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"send-message",style:inputStyle},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"input-message"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("svg",{t:"1680593264243",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2099",width:"16",height:"16"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("path",{d:"M793.344 822.848a34.112 34.112 0 0 1 6.144 67.712l-6.144 0.576H520.32a34.112 34.112 0 0 1-6.144-67.712l6.144-0.576h273.024zM803.52 230.912l-48.256-48.256a102.4 102.4 0 0 0-144.832 0L219.008 574.08a102.4 102.4 0 0 0-26.368 45.44l-33.856 124.032a68.288 68.288 0 0 0 83.84 83.84l124.032-33.92a102.4 102.4 0 0 0 45.44-26.304l391.424-391.424a102.4 102.4 0 0 0 0-144.832z m-96.576 0l48.32 48.32a34.112 34.112 0 0 1 0 48.256l-391.424 391.36a34.112 34.112 0 0 1-15.168 8.832l-124.032 33.856 33.92-124.032a34.112 34.112 0 0 1 8.768-15.168l391.36-391.424a34.112 34.112 0 0 1 48.256 0z","p-id":"2100",fill:"#979797"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("input",{id:"inputRef",ref:function ref(_ref5){return _this3.inputRef=_ref5;},type:"text",placeholder:styleConfig.inputPlaceholder||'留言弹幕，和大家互动起来',value:message,onChange:this.handleMessageChange})),styleConfig.sendMessageBtnImage?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("img",{src:styleConfig.sendMessageBtnImage,alt:"",className:"send-btn-img",onClick:function onClick(){return _this3.handleSendMessage();}}):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{className:"send-btn",onClick:function onClick(){return _this3.handleSendMessage();},style:{backgroundColor:styleConfig.sendMessageBtnBgColor,color:styleConfig.sendMessageBtnTextColor}},"\u53D1\u9001")),this.renderToast(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_22_react___default.a.createElement("div",{style:{width:0,height:0,overflow:'hidden',position:'absolute',left:0,top:0},ref:function ref(_ref6){return _this3.praiseHiddenRef=_ref6;}})));}// 渲染Toast
}]);return PipelineInteractMessage;}(__WEBPACK_IMPORTED_MODULE_22_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineInteractMessage);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyledBullet__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulletScreen__ = __webpack_require__(908);
/* unused harmony reexport StyledBullet */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__BulletScreen__["a" /* default */]);

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(312);
var route = __webpack_require__(907);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(312);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BulletScreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_fill_js__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_fill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_fill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dom__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helper__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__StyledBullet__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_px2rem__ = __webpack_require__(42);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _createForOfIteratorHelper(o,allowArrayLike){var it=typeof Symbol!=="undefined"&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return{s:F,n:function n(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};},e:function e(_e2){throw _e2;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return{s:function s(){it=it.call(o);},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e3){didErr=true;err=_e3;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var BulletScreen=/*#__PURE__*/function(){function BulletScreen(ele){var _this=this;var opts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_classCallCheck(this,BulletScreen);_defineProperty(this,"target",null);_defineProperty(this,"options",__WEBPACK_IMPORTED_MODULE_22__helper__["a" /* defaultOptions */]);_defineProperty(this,"bullets",[]);_defineProperty(this,"allPaused",false);_defineProperty(this,"allHide",false);_defineProperty(this,"tracks",[]);_defineProperty(this,"queues",[]);_defineProperty(this,"bulletStartIndex",0);_defineProperty(this,"stop",false);_defineProperty(this,"animationId",null);_defineProperty(this,"_render",function(item,container,track,top){_this.target.appendChild(container);var _this$options=_this.options,gap=_this$options.gap,trackHeight=_this$options.trackHeight;// 弹幕渲染进屏幕
__WEBPACK_IMPORTED_MODULE_21_react_dom___default.a.render(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.isValidElement(item)||typeof item==='string'?item:Object(__WEBPACK_IMPORTED_MODULE_22__helper__["e" /* isPlainObject */])(item)?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_20_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__StyledBullet__["a" /* default */],item):null,container,function(){container.style.animationDuration="".concat(_this._getAnimateDuration(container.clientWidth),"s");container.style.animationPlayState='running';var trackTop=track*trackHeight;container.dataset.track=track;container.style.top=top?top:Object(__WEBPACK_IMPORTED_MODULE_24__utils_px2rem__["a" /* default */])("".concat(trackTop,"px"));var options={root:_this.target,rootMargin:"0px ".concat(gap," 0px 0px"),threshold:1.0};_this._requestAnimationFrameDom(container);// let observer = new IntersectionObserver(entries => {
//   entries.forEach(entry => {
//     // 完全处于视窗之内
//     const { intersectionRatio, target } = entry;
//     if (intersectionRatio >= 1) {
//       let trackIdx = target.dataset.track;
//       if (this.queues.length) {
//         const [item, container, customTop] = this.queues.shift();
//         this._render(item, container, trackIdx, customTop);
//       } else {
//         this.tracks[trackIdx] = 'feed';
//       }
//     }
//   });
// }, options);
// observer.observe(container);
});});_defineProperty(this,"_changeStatus",function(id,like_cnt,self_like){var targetBullets=document.querySelectorAll(".bullet-item-".concat(id));var _iterator=_createForOfIteratorHelper(targetBullets),_step;try{for(_iterator.s();!(_step=_iterator.n()).done;){var item=_step.value;item.querySelector('.like-cnt').innerHTML=like_cnt>0?like_cnt:'';item.querySelector('.self-like').innerHTML=!self_like?"<img id='praise-icon-".concat(id,"' src=\"https://static.shihuocdn.cn/admin/files/20241030/3fb5328f73d6e71f26565f4cab026ce1.png\" alt=\"\" class=\"icon\" />"):"<img id='praise-icon-".concat(id,"' src=\"https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png\" alt=\"\" class=\"icon\" />");}}catch(err){_iterator.e(err);}finally{_iterator.f();}});_defineProperty(this,"_toggleAnimateStatus",function(id){var status=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'paused';var currItem=_this.bullets.find(function(item){return item.id==id;});if(currItem){currItem.style.animationPlayState=status;return;}_this.allPaused=status==='paused'?true:false;_this.bullets.forEach(function(item){item.style.animationPlayState=status;});});// 更新默认配置项
this.options=Object.assign(this.options,opts);var _trackHeight=this.options.trackHeight;// 设置弹幕目标
if(typeof ele==='string'){this.target=document.querySelector(ele);if(!this.target){throw new Error('The display target does not exist');}}else if(ele instanceof HTMLElement){this.target=ele;}else{throw new Error('The display target of the barrage must be set');}// 初始化跑道，全部是空闲状态
var _this$target$getBound=this.target.getBoundingClientRect(),height=_this$target$getBound.height;this.tracks=new Array(3).fill('idle');// 屏幕目标必须具备的CSS样式
var _getComputedStyle=getComputedStyle(this.target),position=_getComputedStyle.position;if(position==='static'){this.target.style.position='relative';// this.target.style.overflow = 'hidden';
}// 插入css animation
Object(__WEBPACK_IMPORTED_MODULE_22__helper__["d" /* initBulletAnimate */])(this.target);}_createClass(BulletScreen,[{key:"_getTrack",value:function _getTrack(){var readyIdxs=[];var idx=-1;// 优先取空闲状态的
this.tracks.forEach(function(st,idx){if(st==='idle'){readyIdxs.push(idx);}});if(readyIdxs.length){idx=readyIdxs[Math.floor(Math.random()*readyIdxs.length)];}if(idx===-1){// 其次是可以接上状态的
this.tracks.forEach(function(st,idx){if(st==='feed'){readyIdxs.push(idx);}});if(readyIdxs.length){idx=readyIdxs[Math.floor(Math.random()*readyIdxs.length)];}}if(idx!==-1){this.tracks[idx]='running';}return idx;}},{key:"push",value:function push(item){var _this2=this;var opts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'push';var options=Object.assign({},this.options,opts);var onStart=options.onStart,onEnd=options.onEnd,top=options.top;var bulletContainer=Object(__WEBPACK_IMPORTED_MODULE_22__helper__["b" /* getContainer */])(_objectSpread(_objectSpread({},options),{},{currScreen:this}));// 加入当前存在的弹幕列表
this.bullets.push(bulletContainer);var currIdletrack=this._getTrack();if(currIdletrack===-1||this.allPaused){// 考虑到全部暂停的情景
if(type==='push'){this.queues.push([item,bulletContainer,top]);}else{this.queues.unshift([item,bulletContainer,top]);}}else{this._render(item,bulletContainer,currIdletrack,top);}if(onStart){// 创建一个监听弹幕动画开始的事件
bulletContainer.addEventListener('animationstart',function(){if(onStart){_this2.bulletStartIndex=_this2.bullets.findIndex(function(obj){return obj.id===bulletContainer.id;});onStart.call(null,bulletContainer.id,_this2.bulletStartIndex,_this2.bullets.length,_this2);}});}// 创建一个监听弹幕动画完成的事件
bulletContainer.addEventListener('animationend',function(){// 如果设置了动画完成自定义函数，则执行
if(onEnd){_this2.bulletStartIndex=_this2.bullets.findIndex(function(obj){return obj.id===bulletContainer.id;});onEnd.call(null,bulletContainer.id,_this2.bulletStartIndex,_this2.bullets.length,_this2);}// 从集合中剔除
_this2.bullets=_this2.bullets.filter(function(obj){return obj.id!==bulletContainer.id;});__WEBPACK_IMPORTED_MODULE_21_react_dom___default.a.unmountComponentAtNode(bulletContainer);bulletContainer.remove();});// 返回该容器的ID
return bulletContainer.id;}},{key:"_requestAnimationFrameDom",value:function _requestAnimationFrameDom(dom){var _this3=this;this.animationId=window.requestAnimationFrame(function(){var getBoundingClientRect=dom.getBoundingClientRect();if(!_this3.stop&&getBoundingClientRect.right<window.innerWidth-23){var trackIdx=dom.dataset.track;if(_this3.queues.length){var _this3$queues$shift=_this3.queues.shift(),_this3$queues$shift2=_slicedToArray(_this3$queues$shift,3),item=_this3$queues$shift2[0],container=_this3$queues$shift2[1],customTop=_this3$queues$shift2[2];_this3._render(item,container,trackIdx,customTop);}else{_this3.tracks[trackIdx]='feed';}}else{_this3._requestAnimationFrameDom(dom);}});}},{key:"_getAnimateDuration",value:function _getAnimateDuration(width){return(width+351)/40.7;}},{key:"pause",value:function pause(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;this._toggleAnimateStatus(id,'paused');}},{key:"resume",value:function resume(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;this._toggleAnimateStatus(id,'running');}},{key:"hide",value:function hide(){this.allHide=true;this.bullets.forEach(function(item){item.style.opacity=0;});}},{key:"show",value:function show(){this.allHide=false;this.bullets.forEach(function(item){item.style.opacity=1;});}},{key:"clear",value:function clear(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;// const currItem = this.bullets.find(item => item.id == id);
// if (currItem) {
//   ReactDOM.unmountComponentAtNode(currItem);
//   currItem.remove();
//   this.bullets = this.bullets.filter(function (item) {
//     return item.id !== id;
//   });
//   return;
// }
this.bullets.forEach(function(item){__WEBPACK_IMPORTED_MODULE_21_react_dom___default.a.unmountComponentAtNode(item);item.remove();});// const { height } = this.target.getBoundingClientRect();
// this.tracks = new Array(Math.floor(height / this.options.trackHeight)).fill('idle');
// this.queues = [];
// this.bullets = [];
}},{key:"destory",value:function destory(){this.bullets.forEach(function(item){__WEBPACK_IMPORTED_MODULE_21_react_dom___default.a.unmountComponentAtNode(item);item.remove();});cancelAnimationFrame(this.animationId);this.target=null;this.options=__WEBPACK_IMPORTED_MODULE_22__helper__["a" /* defaultOptions */];this.bullets=[];this.allPaused=false;this.allHide=false;this.tracks=[];this.queues=[];this.bulletStartIndex=0;this.stop=false;this.animationId=null;}}]);return BulletScreen;}();

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(30);

$export($export.P, 'Array', { fill: __webpack_require__(910) });

__webpack_require__(116)('fill');


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(75);
var toAbsoluteIndex = __webpack_require__(128);
var toLength = __webpack_require__(68);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineIntelligent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_axios_dist_axios_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__style_less__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */// 乐高页面类目和类目新人补贴类目对应关系
var CategoryNewcomer={"鞋类":1,"服饰":2,"运动":3,"数码":4,"美妆":5,"潮玩":6,"配饰":7,"手表":8,"箱包":9,"酒水":10,"居家":12,"/":12,"母婴":13,"宠物":14,"营养保健":15,"电器":16,"个护":17,"生活服务":18};var PipelineIntelligent=/*#__PURE__*/function(_React$Component){_inherits(PipelineIntelligent,_React$Component);var _super=_createSuper(PipelineIntelligent);function PipelineIntelligent(props){var _this;_classCallCheck(this,PipelineIntelligent);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getIfNewUser",function(params){Object(__WEBPACK_IMPORTED_MODULE_32__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/activity/cate_new_status',method:"get",withCredentials:true,params:params}).then(function(res){var _res$data=res.data,status=_res$data.status,_res$data$data=_res$data.data,data=_res$data$data===void 0?{}:_res$data$data;if(status===0){_this.setState({isCateNewUser:data.cate_new_user});}});});_defineProperty(_assertThisInitialized(_this),"productBannerGo",function(url){if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].handleToufangClick({link:url,props:_this.props});return;}// 商品banner跳转
var options={};var convertUrl=__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].convertHref(url);__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,url,options,-1,_this.props,false);});_defineProperty(_assertThisInitialized(_this),"handleExpandMore",function(){var _this$state=_this.state,showPage=_this$state.showPage,pageSize=_this$state.pageSize;_this.setState({showPage:showPage+1>pageSize?1:showPage+1});});var _props$config$cardBas=props.config.cardBaseConfig,cardBaseConfig=_props$config$cardBas===void 0?{}:_props$config$cardBas;var sortType=cardBaseConfig.sortType;// 初始化商品id列表数据
var initList=[];_this.initList=initList;_this.state={productList:initList,isFold:false,showPage:1,pageSize:0,visiable:false,mask_show:false,noticeVersionShow:false,backCount:3,isCateNewUser:false,selectedItem:{},selectedIndex:''};_this.countDownInterVal=null;_this.sortTypeMap={'自定义排序':0,'销量':4,'GMV':6,'上新时间':8};_this.formTable=false;_this.formType='';_this.page=1;_this.hasNext=true;_this.isLoading=false;_this.dataSourceConfig={};// 自定义表单数据源配置信息
_this.fieldMapTable={};// 当前选用的字段映射表
_this.initLayoutRowScroll=false;_this.speed=__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].isAndroid()?0.5:1;// 滚动速度，每次增加的值
_this.scrollState='paused';_this.scrollAnimation=null;_this.isScrollEnd=false;_this.delayTimeout=null;_this.isAndroid=__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].isAndroid();_this.author_name=__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].getQueryString('author_name')||'默认达人昵称';_this.author_avatar=__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].getParams('author_avatar')||'https://static.shihuocdn.cn/admin/files/20230613/68d710d769ea97e026852ea21ad3d2cd.png';_this.style_ids=__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].getParams('style_ids')||'';return _this;}_createClass(PipelineIntelligent,[{key:"componentDidMount",value:function componentDidMount(){var verticals=window.classifyName;this.getIfNewUser({verticals:CategoryNewcomer[verticals]});this.getProductListData();}},{key:"getProductListData",value:function getProductListData(){var _this2=this;var itemList=[];var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,cardBaseConfig=_this$props$config.cardBaseConfig;var sortType=baseConfig.sortType||cardBaseConfig&&cardBaseConfig.sortType;var shihuoSubsidy=baseConfig.shihuoSubsidy||cardBaseConfig&&cardBaseConfig.shihuoSubsidy;var productStyle=baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle;if(sortType==='自定义排序'){itemList=JSON.parse(JSON.stringify(this.initList));}else{itemList=[];}var itemDataObj={};var idList=this.style_ids?this.style_ids.split(','):[];idList=idList.map(function(item){if(item){return Number(item);}});var reqUrl="",firstPageNum=0,addBaseNum=0;if(productStyle==='一行一个'){firstPageNum=6;addBaseNum=10;}else if(productStyle==='一行两个'){firstPageNum=6;addBaseNum=10;}else if(productStyle==='一行三个'){firstPageNum=12;addBaseNum=9;}else{firstPageNum=0;addBaseNum=0;}reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";Object(__WEBPACK_IMPORTED_MODULE_32__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:this.sortTypeMap[sortType]||0,filter_subsidy:shihuoSubsidy==='是'?1:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var list=res.data.data.List;if(sortType==='自定义排序'){itemList.forEach(function(item,index){if(item.id=='0'){var _element;// 无渠道商品，插入列表中
var element=(_element={id:item.id,image:item.productImageCustom,price:item.productPrice,title:item.name,url:item.productHref,useCustomName:item.useCustomName},_defineProperty(_element,"title",item.name),_defineProperty(_element,"recommendType",item.recommendType),_defineProperty(_element,"shoppersLabel",item.shoppersLabel),_defineProperty(_element,"recommend",item.recommend),_defineProperty(_element,"custom_unitPrice",item.shoppersLabelText),_defineProperty(_element,"image",item.productImageCustom),_defineProperty(_element,"custom_markIcon",item.markIconCustom),_defineProperty(_element,"custom_actionButton",item.actionButtonCustom),_element);list.splice(index,0,element);}});// 插入定制化内容
itemList.forEach(function(product){try{var customItem=list.find(function(item){return item.id==product.id;});if(customItem&&customItem.id!='0'){Object.assign(product,_objectSpread(_objectSpread({},customItem),{},{image:product.image&&product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2')<0?product.image:customItem.image,title:customItem.title,recommend:product.recommend||customItem.recommend,custom_markIcon:product.markIconCustom,custom_actionButton:product.actionButtonCustom}));}}catch(error){var customItem_beta=itemDataObj[product.id];if(customItem_beta){product.useCustomName=customItem_beta.useCustomName;product.title=customItem_beta.name;product.recommend=customItem_beta.recommend;}}});_this2.setState({visiable:true,productList:itemList,pageSize:Math.ceil((itemList.length-firstPageNum)/addBaseNum)+1});}else{// 非自定义排序，以实时抓取的数据顺序展示
itemList.forEach(function(item,index){if(item.id=='0'){var _element2;// 无渠道商品，插入列表中
var element=(_element2={id:item.id,image:item.productImageCustom,price:item.productPrice,title:item.name,url:item.productHref,useCustomName:item.useCustomName},_defineProperty(_element2,"title",item.name),_defineProperty(_element2,"recommendType",item.recommendType),_defineProperty(_element2,"shoppersLabel",item.shoppersLabel),_defineProperty(_element2,"recommend",item.recommend),_defineProperty(_element2,"custom_unitPrice",item.shoppersLabelText),_defineProperty(_element2,"image",item.productImageCustom),_defineProperty(_element2,"custom_markIcon",item.markIconCustom),_defineProperty(_element2,"custom_actionButton",item.actionButtonCustom),_element2);list.splice(index,0,element);}});// 插入定制化内容
list.forEach(function(product){try{var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem&&customItem.id!='0'){product.useCustomName=customItem.useCustomName;product.recommendType=customItem.recommendType;product.shoppersLabel=customItem.shoppersLabel;product.custom_unitPrice=customItem.shoppersLabelText;product.custom_markIcon=customItem.markIconCustom;product.custom_actionButton=customItem.actionButtonCustom;product.price=customItem.productPrice||product.price;product.url=customItem.productHref||product.url;product.title=customItem.useCustomName?customItem.name:product.title;product.recommend=customItem.recommend||product.recommend;product.image=customItem.productImageCustom||product.image;}}catch(error){console.log('商品组件数据遍历错误');var customItem_beta=itemDataObj[product.id];if(customItem_beta){product.useCustomName=customItem_beta.useCustomName;product.title=customItem_beta.name;product.recommend=customItem_beta.recommend;}}});_this2.setState({visiable:true,productList:list,pageSize:Math.ceil((list.length-firstPageNum)/addBaseNum)+1});}_this2.isLoading=false;}});}},{key:"findKey",value:function findKey(obj,value){var compare=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(a,b){return a===b;};return Object.keys(obj).find(function(k){return compare(obj[k],value);});}//判断版本号
},{key:"appVersion",value:function appVersion(){return __WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].SHDiffVersion(__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].getVersion(),'7.28.0');// 前面版本号大
}},{key:"linkClick",value:function linkClick(){var _this$state2=this.state,isCateNewUser=_this$state2.isCateNewUser,selectedItem=_this$state2.selectedItem,selectetIndex=_this$state2.selectetIndex;if(isCateNewUser&&!this.appVersion()){if(__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].isAndroid()){window.location.href='https://www.shihuo.cn/app3/download';}else{window.location.href='itms-apps://itunes.apple.com/app/id875177200?mt=8';}// window.Jockey.send("action", {
//   url: "https://www.shihuo.cn/webview/upgrade?v=2.2#",
// });
}else{if(this.countDownInterVal){clearInterval(this.countDownInterVal);this.countDownInterVal=null;this.setState({mask_show:false,noticeVersionShow:false,backCount:3});}this.handleItemClick(selectedItem,selectetIndex);}}//新人类目价
},{key:"handleItemPerNewUserClick",value:function handleItemPerNewUserClick(item,index){var _this3=this;var isCateNewUser=this.state.isCateNewUser;var cardInfoConfig=this.props.config.cardInfoConfig;if(cardInfoConfig.newUserPrice){if(!isCateNewUser||isCateNewUser&&!this.appVersion()){this.setState({mask_show:true,noticeVersionShow:true,selectedItem:item,selectetIndex:index// backCount: 3
});if(!isCateNewUser){clearInterval(this.countDownInterVal);this.countDownInterVal=setInterval(function(){if(_this3.state.backCount<=1){clearInterval(_this3.countDownInterVal);_this3.countDownInterVal=null;_this3.setState({mask_show:false,noticeVersionShow:false,backCount:3});_this3.handleItemClick(item,index);}else{_this3.setState({backCount:_this3.state.backCount-1});}},1000);}}else{this.handleItemClick(item,index);}}else{this.handleItemClick(item,index);}}// 关闭弹窗
},{key:"closeNewUserDialog",value:function closeNewUserDialog(){if(this.countDownInterVal){clearInterval(this.countDownInterVal);this.countDownInterVal=null;}this.setState({mask_show:false,noticeVersionShow:false,backCount:3});}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:this.props,index:index});return;}var _this$props$config2=this.props.config,baseConfig=_this$props$config2.baseConfig,cardBaseConfig=_this$props$config2.cardBaseConfig;var options={title:baseConfig.title,type:baseConfig.productStyle||cardBaseConfig&&cardBaseConfig.productStyle,sort:index,name:item.title};if(baseConfig.productType==="商品id"||cardBaseConfig&&cardBaseConfig.productType==="商品id"){options.goods_id=item.id;}else{options.style_id=item.id;}__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.url,item.url,options,item.id,this.props);}},{key:"render",value:function render(){var _this4=this;var _this$state3=this.state,showPage=_this$state3.showPage,pageSize=_this$state3.pageSize,visiable=_this$state3.visiable,mask_show=_this$state3.mask_show,noticeVersionShow=_this$state3.noticeVersionShow,backCount=_this$state3.backCount,isCateNewUser=_this$state3.isCateNewUser;var _this$props$config3=this.props.config,baseConfig=_this$props$config3.baseConfig,cardBaseConfig=_this$props$config3.cardBaseConfig,cardInfoConfig=_this$props$config3.cardInfoConfig;if(cardBaseConfig.productStyle==="一行一个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_1);}else if(cardBaseConfig.productStyle==="一行两个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_2);}else if(cardBaseConfig.productStyle==="一行三个"){Object.assign(cardBaseConfig,cardBaseConfig.layout_3);}else if(cardBaseConfig.productStyle==="一行一排"){Object.assign(cardBaseConfig,cardBaseConfig.layout_row);}if(!visiable){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",_extends({className:"pipeline-intelligent",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginLeft:cardBaseConfig.productStyle!='一行一排'&&"".concat(cardBaseConfig.moduleMarginHorizon,"px"),marginRight:cardBaseConfig.productStyle!='一行一排'&&"".concat(cardBaseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}));}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",_extends({className:"pipeline-intelligent",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{marginTop:"".concat(cardBaseConfig.moduleMarginTop,"px"),marginLeft:cardBaseConfig.productStyle!='一行一排'&&"".concat(cardBaseConfig.moduleMarginHorizon,"px"),marginRight:cardBaseConfig.productStyle!='一行一排'&&"".concat(cardBaseConfig.moduleMarginHorizon,"px"),marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),(baseConfig.showTitle&&baseConfig.title||baseConfig.showSubTitle&&baseConfig.subTitle)&&cardBaseConfig.productStyle!=="一行一排"&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"title-area"},baseConfig.showTitle&&baseConfig.title&&['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title.slice(0,16)),baseConfig.showSubTitle&&baseConfig.subTitle&&['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sub-title",style:{color:baseConfig.titleColor},dangerouslySetInnerHTML:{__html:baseConfig.subTitle}})),cardBaseConfig.imgUrl&&['一行一个','一行两个','一行三个'].indexOf(cardBaseConfig.productStyle)>=0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"product-banner",onClick:this.productBannerGo.bind(this,cardBaseConfig.imgLink),src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.imgUrl,this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"referral",style:{backgroundColor:cardBaseConfig.headBgColor,backgroundImage:"url(".concat(cardBaseConfig.headBgImageUrl,")"),backgroundSize:"100% 100%",backgroundRepeat:"no-repeat"}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"referral-avatar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:this.author_avatar,alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"referral-name",style:{color:baseConfig.titleColor}},'@'+this.author_name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"referral-desc",style:{color:baseConfig.titleColor}},"\u4E3A\u4F60\u63A8\u8350")),cardBaseConfig.productCardType!=='促销样式'?this.renderNormalType():this.renderPromotionType(),baseConfig.showFoldBtn&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"fold-btn",style:{color:baseConfig.titleColor,borderColor:baseConfig.titleColor?this.hexColorToRgba(baseConfig.titleColor,0.8):baseConfig.titleColor},onClick:function onClick(){return _this4.handleExpandMore();}},showPage>=pageSize?'收起':'展开更多',showPage>=pageSize?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("svg",{t:"1664182775303",className:"icon up",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2222"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("path",{d:"M169.344 694.656a32 32 0 0 0 40.832 3.648l4.48-3.648L512 397.248l297.344 297.408a32 32 0 0 0 40.832 3.648l4.48-3.648a32 32 0 0 0 3.648-40.832l-3.648-4.48-320-320a32 32 0 0 0-40.832-3.648l-4.48 3.648-320 320a32 32 0 0 0 0 45.312z","p-id":"2223",fill:baseConfig.titleColor})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("svg",{t:"1664182701343",className:"icon down",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2002"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("path",{d:"M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z","p-id":"2003",fill:baseConfig.titleColor}))),mask_show&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"pipeline-product-mask"}),noticeVersionShow&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:["pipeline-product-notice-version","".concat(!isCateNewUser?"pipeline-product-notice-version2":null)].join(" ")},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"pipeline-product-notice-version-title"},!isCateNewUser?"\u6D3B\u52A8\u4EC5\u9650".concat(window.classifyName,"\u65B0\u7528\u6237"):'当前版本过低'),!isCateNewUser?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"pipeline-product-notice-version-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",null,"\u62B1\u6B49\uFF0C\u4F60\u65E0\u6CD5\u4EAB\u53D7\u65B0\u4EBA\u4EF7"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",null,"\u53EF\u7EE7\u7EED\u67E5\u770B\u5168\u7F51\u5E95\u4EF7")):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"pipeline-product-notice-version-content"},"\u8BF7\u5347\u7EA7\u6700\u65B0\u7248\u672C\uFF0C\u4EAB\u53D7\u8865\u8D34"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"pipeline-product-notice-version-button",onClick:this.linkClick.bind(this)},!isCateNewUser?"\u53BB\u67E5\u770B\uFF08".concat(backCount,"s\uFF09"):'去升级'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20221226/ceab8c8de1a6373675898799f28e1e0d.png",alt:"",className:"pipeline-product-notice-version-close",onClick:this.closeNewUserDialog.bind(this)})));}// 常规样式
},{key:"renderNormalType",value:function renderNormalType(){var _this5=this;var _this$state4=this.state,_this$state4$productL=_this$state4.productList,productList=_this$state4$productL===void 0?[]:_this$state4$productL,showPage=_this$state4.showPage,pageSize=_this$state4.pageSize,visiable=_this$state4.visiable,mask_show=_this$state4.mask_show,noticeVersionShow=_this$state4.noticeVersionShow,backCount=_this$state4.backCount,isCateNewUser=_this$state4.isCateNewUser;var _this$props$config4=this.props.config,baseConfig=_this$props$config4.baseConfig,cardBaseConfig=_this$props$config4.cardBaseConfig,cardInfoConfig=_this$props$config4.cardInfoConfig;var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;// 判断不同布局方式下的间距取值
Object.assign(cardBaseConfig,cardBaseConfig.layout_2);productList=productList;// 转为数字处理，后续参与计算
cardBaseConfig.itemMargin=isNaN(Number(cardBaseConfig.itemMargin))?0:Number(cardBaseConfig.itemMargin);var remainder=productList.length%2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-list product-list-normal",style:{backgroundColor:cardBaseConfig.moduleBgColor}},productList.map(function(item,index){var rowItemNumber=2;// 每行排列数量
if(remainder!=0&&index===0){rowItemNumber=1;}else{rowItemNumber=2;// 每行排列数量
}// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*cardBaseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth,backgroundColor:cardBaseConfig.cardBackgroundColor};if(!cardBaseConfig.cardBackgroundColor){cardBaseConfig.cardBackground&&Object.assign(itemStyle,{backgroundImage:"url(".concat(cardBaseConfig.cardBackground,")"),backgroundSize:"100% 100%",backgroundColor:"transparent",backgroundRepeat:"no-repeat",borderRadius:"inherit"});}else{Object.assign(itemStyle,{backgroundColor:cardBaseConfig.cardBackgroundColor});}var productItem;if(remainder!=0&&index===0){// 三个展示都存在时，隐藏销量
if((cardInfoConfig.originPrice||cardInfoConfig.discount)&&cardInfoConfig.saleNum&&cardInfoConfig.priceIcon){cardInfoConfig.saleNum=false;}productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-item row-one-item",key:index,style:itemStyle,onClick:_this5.handleItemPerNewUserClick.bind(_this5,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__["LazyLoadImage"],{width:108,height:108,placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:108,height:108}}),src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.image,_this5.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:cardInfoConfig.slogen&&cardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),cardInfoConfig.slogen&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend),item.shoppersLabel==='单位价格'&&cardInfoConfig.unitPrice&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),item.shoppersLabel==='自定义'&&cardInfoConfig.unitPrice&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,_this5.props.webpSupport)}),item.price&&!cardInfoConfig.newUserPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),cardInfoConfig.newUserPrice&&item.new_user_price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.new_user_price),cardInfoConfig.originPrice&&item.original_price>item.price&&item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),!cardInfoConfig.originPrice&&cardInfoConfig.discount&&discountRate!=10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298")),cardInfoConfig.saleNum&&item.id&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),cardInfoConfig.markIcon&&(item.custom_markIcon||cardBaseConfig.markIcon)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"mark-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.custom_markIcon||cardBaseConfig.markIcon,_this5.props.webpSupport)}),cardInfoConfig.actionButton&&(item.custom_actionButton||cardBaseConfig.actionButton)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"action-button",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.custom_actionButton||cardBaseConfig.actionButton,_this5.props.webpSupport)}));}else{// 四个展示都存在是，隐藏销量
if((cardInfoConfig.originPrice||cardInfoConfig.discount)&&cardInfoConfig.saleNum&&cardBaseConfig.priceIcon){cardInfoConfig.saleNum=false;}// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin))/2-8;productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:cardInfoConfig.slogen||cardInfoConfig.unitPrice?"product-item row-two-item has-benefit":"product-item row-two-item no-benefit",key:index,style:itemStyle,onClick:_this5.handleItemPerNewUserClick.bind(_this5,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-img-panel",style:{marginTop:4,marginBottom:4,paddingLeft:4,paddingRight:4}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:productImgWidth,placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:productImgWidth,height:productImgWidth}}),src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.image,_this5.props.webpSupport)}),item.beltImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.beltImg,_this5.props.webpSupport),alt:"",className:"beltImg"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:cardInfoConfig.slogen&&cardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),cardInfoConfig.slogen&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend),item.shoppersLabel==='单位价格'&&cardInfoConfig.unitPrice&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),item.shoppersLabel==='自定义'&&cardInfoConfig.unitPrice&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,_this5.props.webpSupport)}),item.price&&!cardInfoConfig.newUserPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.price),cardInfoConfig.newUserPrice&&item.new_user_price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.new_user_price),cardInfoConfig.originPrice&&item.original_price>item.price&&item.original_price>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),!cardInfoConfig.originPrice&&cardInfoConfig.discount&&discountRate!=10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298")),cardInfoConfig.saleNum&&item.id&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"num",style:{color:baseConfig.priceInfoColor}},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),cardInfoConfig.markIcon&&(item.custom_markIcon||cardBaseConfig.markIcon)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"mark-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.custom_markIcon||cardBaseConfig.markIcon,_this5.props.webpSupport)}));}return productItem;}));}// 促销样式
},{key:"renderPromotionType",value:function renderPromotionType(){var _this6=this;var _this$state5=this.state,_this$state5$productL=_this$state5.productList,productList=_this$state5$productL===void 0?[]:_this$state5$productL,showPage=_this$state5.showPage,pageSize=_this$state5.pageSize,visiable=_this$state5.visiable,mask_show=_this$state5.mask_show,noticeVersionShow=_this$state5.noticeVersionShow,backCount=_this$state5.backCount,isCateNewUser=_this$state5.isCateNewUser;var _this$props$config5=this.props.config,baseConfig=_this$props$config5.baseConfig,cardBaseConfig=_this$props$config5.cardBaseConfig,cardInfoConfig=_this$props$config5.cardInfoConfig,_this$props$config5$p=_this$props$config5.promotionCardInfoConfig,promotionCardInfoConfig=_this$props$config5$p===void 0?{}:_this$props$config5$p;var bodyWidth=typeof window!=="undefined"?window.document.body.clientWidth:375;// 判断不同布局方式下的间距取值
Object.assign(cardBaseConfig,cardBaseConfig.layout_2);productList=baseConfig.showFoldBtn?showPage<=1?productList.slice(0,6):productList.slice(0,6+10*(showPage-1)):productList;// 转为数字处理，后续参与计算
cardBaseConfig.itemMargin=isNaN(Number(cardBaseConfig.itemMargin))?0:Number(cardBaseConfig.itemMargin);var remainder=productList.length%2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-list product-list-promotion",style:{backgroundColor:cardBaseConfig.moduleBgColor}},productList.map(function(item,index){var rowItemNumber=2;// 每行排列数量
if(remainder!=0&&index===0){rowItemNumber=1;}else{rowItemNumber=2;// 每行排列数量
}// 折扣计算
var discountRate=item.price/item.original_price;if(discountRate>1||isNaN(discountRate)||item.original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));// 直降计算
var plummet=0;if(item.original_price&&item.original_price>item.price){plummet=Math.floor(item.original_price-item.price);}// 行数计算
var currentRowIndex=Math.floor(index/rowItemNumber)+1;var totalRowNum=Math.ceil(productList.length/rowItemNumber);var isFirstRow=Boolean(currentRowIndex===1);// 该项是否在首行
var isLasthRow=Boolean(totalRowNum===currentRowIndex);// 该项是否在未行
var isFirstColumn=Boolean(index%rowItemNumber===0);var isLastColumn=Boolean((index+1)%rowItemNumber===0);// 该项是否在未列
// 是否展示销量
var showSaleNum=promotionCardInfoConfig.saleNum&&item.sell_point>0;// 计算每个项的宽度
var totalMargin=(rowItemNumber-1)*cardBaseConfig.itemMargin;var itemWidth="calc((100% - ".concat(totalMargin,"px) / ").concat(rowItemNumber,")");var itemStyle={width:itemWidth};var productItem;if(remainder!=0&&index===0){productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-item row-one-item",key:index,style:itemStyle,onClick:_this6.handleItemPerNewUserClick.bind(_this6,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__["LazyLoadImage"],{width:108,height:108,placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:108,height:108}}),src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.image,_this6.props.webpSupport)})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:promotionCardInfoConfig.slogen&&promotionCardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),promotionCardInfoConfig.slogen&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend),promotionCardInfoConfig.unitPrice&&item.shoppersLabel==='单位价格'&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),promotionCardInfoConfig.unitPrice&&item.shoppersLabel==='自定义'&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sale"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price-container"},cardBaseConfig.priceIcon&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"price-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(cardBaseConfig.priceIcon,_this6.props.webpSupport)}),item.price&&!cardInfoConfig.newUserPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:String(parseFloat(item.price)).length>=5?'price large':'price small'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:String(parseFloat(item.price)).length>=5?'large':'small'},item.price)),cardInfoConfig.newUserPrice&&item.new_user_price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:String(parseFloat(item.price)).length>=5?'price large':'price small'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:String(parseFloat(item.price)).length>=5?'large':'small'},item.new_user_price)),promotionCardInfoConfig.priceInfo==='原价'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"origin-price",style:{textDecoration:item.original_price>0&&item.original_price!=item.price?'line-through':'none'}},item.original_price&&item.original_price>0&&item.original_price!=item.price?"\xA5".concat(item.original_price):'爆款好价'),promotionCardInfoConfig.priceInfo==='折扣'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"discount"},discountRate!=10?"".concat(discountRate,"\u6298"):'爆款好价'),promotionCardInfoConfig.priceInfo==='直降'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"plummet"},plummet>0?"\u76F4\u964D\xA5".concat(plummet):'爆款好价')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"action-btn"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:showSaleNum?'scramble show-sale-num':'scramble'},"\u62A2"),showSaleNum&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"sale-num"},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E")))),promotionCardInfoConfig.markIcon&&(item.custom_markIcon||cardBaseConfig.markIcon)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"mark-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.custom_markIcon||cardBaseConfig.markIcon,_this6.props.webpSupport)}));}else{// 计算一行二商品图片宽度
var productImgWidth=(bodyWidth-Number(cardBaseConfig.moduleMarginHorizon)*2-Number(cardBaseConfig.itemMargin))/2-8;var priceExtra='';if(promotionCardInfoConfig.priceInfo==='原价'){priceExtra=item.original_price>0&&item.original_price!=item.price&&"\xA5".concat(item.original_price);}else if(promotionCardInfoConfig.priceInfo==='折扣'){priceExtra=discountRate!=10&&"".concat(discountRate,"\u6298");}else if(promotionCardInfoConfig.priceInfo==='直降'){priceExtra=plummet>0&&"\u76F4\u964D\xA5".concat(plummet);}if(item.hasOwnProperty('id')&&!priceExtra){priceExtra='爆款好价';}productItem=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:promotionCardInfoConfig.benefit!=="无"?"product-item row-two-item has-benefit":"product-item row-two-item no-benefit",key:index,style:itemStyle,onClick:_this6.handleItemPerNewUserClick.bind(_this6,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-img-panel"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__["LazyLoadImage"],{width:productImgWidth,height:productImgWidth,placeholder:/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"lazy-load-placeholder",style:{display:'inline-block',width:productImgWidth,height:productImgWidth}}),src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.image,_this6.props.webpSupport)}),item.beltImg&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.beltImg,_this6.props.webpSupport),alt:"",className:"beltImg"}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"product-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:promotionCardInfoConfig.slogen&&promotionCardInfoConfig.unitPrice?"name line-clamp-1":"name",style:{WebkitBoxOrient:"vertical",color:cardBaseConfig.productNameColor}},item.title),promotionCardInfoConfig.benefit==='推荐理由'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"tag",style:{color:cardBaseConfig.productTagColor}},item.recommend),promotionCardInfoConfig.benefit==='单位价格'&&item.shoppersLabel==='单位价格'&&item.unit_price_text&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.unit_price_text),promotionCardInfoConfig.benefit==='单位价格'&&item.shoppersLabel==='自定义'&&item.custom_unitPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"unit-price",style:{color:cardBaseConfig.productTagColor}},item.custom_unitPrice)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"sale"},item.price&&!cardInfoConfig.newUserPrice&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:String(parseFloat(item.price)).length>=5?'price large':'price small'},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:String(parseFloat(item.price)).length>=5?'large':'small'},item.price)),cardInfoConfig.newUserPrice&&item.new_user_price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),item.new_user_price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"origin-price",style:{textDecoration:'none'}},priceExtra),item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"num"},item.sell_point_str.indexOf('W')<0?item.sell_point_str:item.sell_point_str.replace('W','w'),"\u4EBA\u4ED8\u6B3E"))),promotionCardInfoConfig.markIcon&&(item.custom_markIcon||cardBaseConfig.markIcon)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{className:"mark-icon",src:__WEBPACK_IMPORTED_MODULE_33__utils_utils__["a" /* default */].formatImgUrl(item.custom_markIcon||cardBaseConfig.markIcon,_this6.props.webpSupport)}));}return productItem;}));}},{key:"hexColorToRgba",value:function hexColorToRgba(hexColor,opacity){var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}}]);return PipelineIntelligent;}(__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component);PipelineIntelligent.propTypes={config:__WEBPACK_IMPORTED_MODULE_29_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineIntelligent);

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineGoodsInfoPreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_date_now_js__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_date_now_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_date_now_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_swiper_components_pagination_pagination_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_qrcode_react__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_qrcode_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_qrcode_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__style_less__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//链接商品预览
var mallTypes=[{key:0,mall:'得物',url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/dewu_preview'},{key:1,mall:'抖音',url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/douyin_preview'},{key:2,mall:'拼多多',url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/pdd_preview'},{key:3,mall:'通用',url:'https://sh-gateway.shihuo.cn/v4/services/sh-elance-api/preview/common_preview'}];var channelShowType=["识货状态","关联商品","商品状态","同步时间","店铺ID","店铺名称","店铺状态","识货固定位","营销文案","操作选项"];var PipelineGoodsInfoPreview=/*#__PURE__*/function(_React$Component){_inherits(PipelineGoodsInfoPreview,_React$Component);var _super=_createSuper(PipelineGoodsInfoPreview);function PipelineGoodsInfoPreview(props){var _this;_classCallCheck(this,PipelineGoodsInfoPreview);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"dealData",function(data){if(data.skus&&data.skus.length>0){var attr=data.skus[0].attr||[];var nameArr=[];attr.map(function(item){nameArr.push(item.name);});data.skus=data.skus.map(function(item){return _objectSpread(_objectSpread({},item),{},{attr:item.attr?item.attr.sort(function(a,b){return nameArr.indexOf(a.name)-nameArr.indexOf(b.name);}):[]});});}else{_this.setState({NODATA:true});return;}var _ref=data||{},_ref$skus=_ref.skus,skus=_ref$skus===void 0?[]:_ref$skus;var skuTitleList=[];if(skus&&skus.length>0){var _attr=skus[0].attr||[];_attr.map(function(item){skuTitleList.push({name:item.name});});}else{_this.setState({NODATA:true});return;}skuTitleList&&skuTitleList.map(function(item,index){var _item$name=item.name,name=_item$name===void 0?'':_item$name;var attrObj={};skus&&skus.map(function(skuItem){var _skuItem$attr=skuItem.attr,attr=_skuItem$attr===void 0?[]:_skuItem$attr;attr&&attr.map(function(attrItem){if(attrItem.name==name){skus&&skus.map(function(sItem){var sku_id=sItem.sku_id;var fIndex=sItem.attr?sItem.attr.findIndex(function(aItem){return aItem.propertyValueId==attrItem.propertyValueId;}):-1;if(fIndex==0&&sItem.attr&&sItem.attr.length==1){attrObj[attrItem.propertyValueId]=_objectSpread(_objectSpread({},attrItem),{},{sku_id:sku_id});}else if(fIndex==0&&sItem.attr&&sItem.attr.length>1){var _objectSpread2;attrObj[attrItem.propertyValueId+'-'+sItem.attr[1].propertyValueId]=_objectSpread(_objectSpread({},attrItem),{},(_objectSpread2={},_defineProperty(_objectSpread2,sItem.attr[1].propertyValueId,sItem.attr[1]),_defineProperty(_objectSpread2,"sku_id",sku_id),_objectSpread2));}else if(fIndex==1&&sItem.attr&&sItem.attr.length>0){var _objectSpread3;attrObj[sItem.attr[0].propertyValueId+'-'+attrItem.propertyValueId]=_objectSpread(_objectSpread({},attrItem),{},(_objectSpread3={},_defineProperty(_objectSpread3,sItem.attr[0].propertyValueId,sItem.attr[0]),_defineProperty(_objectSpread3,"sku_id",sku_id),_objectSpread3));}});}});});skuTitleList[index].attrObj=attrObj;});var skuDataList=[];var selectedValue=[];if(skus&&skus.length>0){var _attr2=skus[0].attr||[];_attr2.map(function(item){skuDataList.push({name:item.name,list:[]});selectedValue.push({name:item.name,value:''});});skus.map(function(sku){sku.attr&&sku.attr.map(function(item,index){var ind=skuDataList.findIndex(function(e){return e.name==item.name;});if(ind!=-1){skuDataList[ind].list.push(_objectSpread(_objectSpread({},item),{},{image:sku.image}));}});});}var selectedId=['','',''];if(skus&&skus.length>0&&skus[0].attr&&skus[0].attr.length==1){selectedId=[skus[0].attr[0].propertyValueId,'',skus[0].sku_id];}else if(skus&&skus.length>0&&skus[0].attr&&skus[0].attr.length==2){selectedId=[skus[0].attr[0].propertyValueId,skus[0].attr[1].propertyValueId,skus[0].sku_id];}// selectedId[0] = ''
_this.setState({goodsData:data||{},selectedId:selectedId,skuTitleList:skuTitleList,skuDataList:skuDataList,_skuDataList:skuDataList,selectedValue:selectedValue,loading:false},function(){// 轮播组件初始化
_this.swiper=new __WEBPACK_IMPORTED_MODULE_31_swiper_swiper_bundle_min_js___default.a(_this.swiperRef.current,{spaceBetween:0,centeredSlides:true,autoplay:false,loop:false});_this.swiper.on('slideChange',function(){_this.handleSlideChange(_this.swiper);});_this.handleSlideChange({realIndex:0});if(_this.fromPreview==1){//需要切换并滚动到商详
var children=document.querySelector('.tab-container').children||[];for(var i=0;i<children.length;i++){var child=children[i];if(child.innerText=='商详图片'){_this.setState({tabIndex:i},function(){setTimeout(function(){window.scrollTo(0,document.querySelector('.tab-container').offsetTop);},300);});}}}_this.getChannelData();});});_defineProperty(_assertThisInitialized(_this),"uploadLog",function(mallType,code){var userInfo=window.localStorage.getItem('userInfo')?JSON.parse(window.localStorage.getItem('userInfo')):{};console.log('userInfo',userInfo);typeof window!=='undefined'&&Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["uploadPcTrack"])({pti:{id:'H5preview_plugin',biz:JSON.stringify({channel_url:decodeURIComponent(_this.url),operator_name:_this.username,store:mallType&&mallType.mall,platform:_this.platform,preview_result:_this.state.NODATA?'暂无数据':code===0?'成功':'失败',operate_from:_this.operate_from})},urlinfo:'',channel:'',client_code:userInfo&&userInfo.uid});});_defineProperty(_assertThisInitialized(_this),"handleSlideChange",function(swiper){var imgActiveIndex=swiper.realIndex;var that=_assertThisInitialized(_this);_this.setState({imgActiveIndex:imgActiveIndex},function(){var view=document.querySelector(".bottom-img-ul");view&&that.scroll(view.scrollLeft,(imgActiveIndex-1)*120/2);});});_defineProperty(_assertThisInitialized(_this),"handleImgItemClick",function(item,index){console.log('handleImgItemClick===',item);_this.uploadClickTrack({id:'previewGoodsBigImg',biz:JSON.stringify({url:decodeURIComponent(item)})});window.parent.postMessage({type:'previewGoodsBigImg',url:item},'*');});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){_this.setState({imgActiveIndex:index},function(){_this.uploadClickTrack({id:'imgSwiper',biz:JSON.stringify({index:index})});_this.swiper&&_this.swiper.slideTo(index,300,false);});});_defineProperty(_assertThisInitialized(_this),"selectItem",function(idStr){var i=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var sku_id=arguments.length>2?arguments[2]:undefined;var _this$state=_this.state,_this$state$goodsData=_this$state.goodsData,goodsData=_this$state$goodsData===void 0?{}:_this$state$goodsData,_this$state$skuTitleL=_this$state.skuTitleList,skuTitleList=_this$state$skuTitleL===void 0?[]:_this$state$skuTitleL,_this$state$selectedI=_this$state.selectedId,selectedId=_this$state$selectedI===void 0?[]:_this$state$selectedI;var imgActiveIndex=_this.state.imgActiveIndex;// const { skus = [] } = goodsData || {}
// const lastId = selectedId[i]
var ids=idStr.split('-')||[];// const item = skuTitleList[i == 0 ? 1 : 0] || {}
// const { attrObj = {} } = item || {}
// let attrStrList = Object.keys(attrObj) || []
// const index = attrStrList.findIndex((aItem) => aItem.split('-')[i == 0 ? 1 : 0] == ids[i])
// if (index == -1) {
//   return utils.toast('请选择其他选项')
// }
if(i==0&&selectedId[i]==ids[i]){selectedId[i]='';}else{selectedId[i]=ids[i];imgActiveIndex=0;}selectedId[2]=sku_id;// selectedId[0] = ''
_this.setState({selectedId:selectedId,imgActiveIndex:imgActiveIndex},function(){_this.swiper&&_this.swiper.slideTo(0,300,false);_this.uploadClickTrack({id:'itemSelect',biz:JSON.stringify({selectedId:selectedId,index:imgActiveIndex})});});});_defineProperty(_assertThisInitialized(_this),"handleClick",/*#__PURE__*/function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(listItem){var res;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!listItem.href){_context.next=4;break;}window.open(listItem.href,'_blank');_context.next=9;break;case 4:if(!listItem.fetch){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_35__utils_request__["a" /* default */])({url:listItem.fetch,method:"get"});case 7:res=_context.sent;if(res.data.status==0){__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].toast('请求成功');}case 9:_this.uploadClickTrack({id:'channelClick',biz:JSON.stringify({listItem:listItem})});case 10:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref2.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"handleSwitchChannel",function(supplier_id){_this.supplier_id=supplier_id;_this.getAttrData();_this.uploadClickTrack({id:'channelSwitch',biz:JSON.stringify({supplier_id:supplier_id})});});_this.state={imgActiveIndex:0,tabIndex:0,selectedId:[],skuDataList:[],selectedValue:[],goodsData:{},lastModiefied:{name:'',value:''},_skuDataList:[],NODATA:false,loading:true,channelList:[],attrRelatedList:[],attrToUniqueIdMap:{}// 新增属性
};_this.swiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_29_react__["createRef"])();_this.height=620;_this.mallType=mallTypes[3];_this.hasUserScrolledX=false;_this.hasUserScrolledY=false;_this._isUserInteracting=false;_this._uiTimer=null;_this._lastScroll={x:0,y:0};_this._hScrollEl=null;_this._lastHScrollX=0;window.addEventListener("message",function(_ref3){var data=_ref3.data;if(data.type==='showPreviewData'&&data.data){//FIXME 接收父组件发送的数据，渲染页面
_this.dealData(data.data);}},false);//FIXME 通知父组件，该组件已加载
window.parent.postMessage({type:'sendMsgToPreviewParent'},'https://backstage.shihuo.cn');_this._onUserInteract=function(){_this._isUserInteracting=true;_this._uiTimer&&clearTimeout(_this._uiTimer);_this._uiTimer=setTimeout(function(){_this._isUserInteracting=false;},200);};_this._handleScroll=function(){var de=document.documentElement;var b=document.body;var scrollTop=de&&de.scrollTop||b&&b.scrollTop||0;var scrollLeft=de&&de.scrollLeft||b&&b.scrollLeft||0;var dx=scrollLeft-(_this._lastScroll&&_this._lastScroll.x||0);var dy=scrollTop-(_this._lastScroll&&_this._lastScroll.y||0);var manualX=!!_this._isUserInteracting&&Math.abs(dx)>0;var manualY=!!_this._isUserInteracting&&Math.abs(dy)>0;_this._lastScroll={x:scrollLeft,y:scrollTop};// console.log('manualX',manualX,manualY, this._lastScroll, scrollLeft, scrollTop)
// 若没有新方向被检测到，直接返回（避免重复发送）
var firstX=!_this.hasUserScrolledX&&manualX;var firstY=!_this.hasUserScrolledY&&manualY;if(!firstX&&!firstY)return;// 更新方向标记
if(firstX)_this.hasUserScrolledX=true;if(firstY)_this.hasUserScrolledY=true;// 仅在首次检测到对应方向时发送一次消息
var payload={type:'previewIframeScroll',scrollTop:scrollTop,scrollLeft:scrollLeft,at:Date.now(),manualX:!!firstX,manualY:!!firstY};_this.uploadClickTrack({id:'pageHorizontalScroll'});window.parent&&window.parent.postMessage(payload,'*');// 若两个方向均已检测到，移除 window 的滚动监听，避免额外开销
if(_this.hasUserScrolledX&&_this.hasUserScrolledY){document.querySelector('body').removeEventListener('scroll',_this._handleScroll);}};_this._handleHorizContainerScroll=function(){if(!_this._hScrollEl)return;var x=_this._hScrollEl.scrollLeft||0;var dx=x-(_this._lastHScrollX||0);var manualX=!!_this._isUserInteracting&&Math.abs(dx)>0;_this._lastHScrollX=x;// 只在首次横向手动滚动时发送一次
if(!manualX||_this.hasUserScrolledX)return;_this.hasUserScrolledX=true;var de=document.documentElement;var b=document.body;var payload={type:'previewIframeScroll',scrollTop:de&&de.scrollTop||b&&b.scrollTop||0,scrollLeft:de&&de.scrollLeft||b&&b.scrollLeft||0,at:Date.now(),manualX:true,manualY:false,container:'bottom-img-ul',containerScrollLeft:x};_this.uploadClickTrack({id:'pageHorizontalScroll'});window.parent&&window.parent.postMessage(payload,'*');// 横向首次已上报，可移除容器滚动监听
_this._hScrollEl&&_this._hScrollEl.removeEventListener('scroll',_this._handleHorizContainerScroll);// 如果纵向也已检测到，则移除 window 滚动监听
if(_this.hasUserScrolledY){document.querySelector('body').removeEventListener('scroll',_this._handleScroll);}};return _this;}_createClass(PipelineGoodsInfoPreview,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var arrObj=window.location.href.split("?");var params={};var type=mallTypes[3];if(arrObj.length>1){var arrPara=arrObj[1].split("&");var arr;for(var i=0;i<arrPara.length;i++){arr=arrPara[i].split("=");if(arr!=null&&arr[0]){params[arr[0]]=arr[1];}}this.operate_from=decodeURIComponent(params&&params.operate_from||'');this.platform=decodeURIComponent(params&&params.platform||'');this.username=decodeURIComponent(params&&params.username||'');this.fromPreview=params&&params.fromPreview||'';var previewDataFlag=params&&params.previewDataFlag||false;this.url=params&&params.url||'';if(!previewDataFlag){var _url=decodeURIComponent(this.url);if(_url.indexOf('m.poizon.com')!=-1||_url.indexOf('m.dewu.com')!=-1){type=mallTypes[0];}else if(_url.indexOf('mobile.yangkeduo.com')!=-1){type.mall=mallTypes[2].mall;}else if(_url.indexOf('haohuo.jinritemai.com')!=-1){type.mall=mallTypes[1].mall;}else if(_url.indexOf('item.taobao.com/item.htm')!=-1){type.mall='淘宝';}else if(_url.indexOf('detail.tmall')!=-1){type.mall='天猫';}else if(_url.indexOf('item.jd')!=-1){type.mall='京东';}else if(_url.indexOf('detail.vip.com/detail')!=-1){type.mall='唯品会';}else if(_url.indexOf('yunmall.shihuo.cn')!=-1){type.mall='云mall';}else if(_url.indexOf('app.kwaixiaodian.com')!=-1){type.mall='快手';}else if(_url.indexOf('www.95fenapp.com')!=-1){type.mall='95分';}else if(_url.indexOf('www.goofish.com')!=-1){type.mall='闲鱼';}this.mallType=type;this.getData(type);}if(params&&params.hiddenOverflowY==1){document.querySelector('html').style.overflowY='hidden';}}else{__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].toast('渠道链接无效');}this.changeHeightInterval&&clearInterval(this.changeHeightInterval);this.changeHeightInterval=null;this.changeHeightInterval=setInterval(function(){if(document.querySelector('.pipeline-goodsInfoPreview').clientHeight){var height=document.querySelector('.pipeline-goodsInfoPreview').clientHeight;if(height!==_this2.height){_this2.height=height;console.log('====',height);window.parent.postMessage({type:'previewGoodsChangeHeight',height:height},'*');}}},1000);// 绑定 window 滚动与用户交互监听
document.querySelector('body').addEventListener('scroll',this._handleScroll,{passive:true});['wheel','touchstart','mousedown','keydown'].forEach(function(evt){document.querySelector('body').addEventListener(evt,_this2._onUserInteract,{passive:true});});}},{key:"componentWillUnmount",value:function componentWillUnmount(){var _this3=this;this.changeHeightInterval&&clearInterval(this.changeHeightInterval);this._uiTimer&&clearTimeout(this._uiTimer);// 清理 window 监听
document.querySelector('body').removeEventListener('scroll',this._handleScroll);['wheel','touchstart','mousedown','keydown'].forEach(function(evt){document.querySelector('body').removeEventListener(evt,_this3._onUserInteract);});}},{key:"getData",value:function(){var _getData=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var mallType,params,res,data,_args2=arguments;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:mallType=_args2.length>0&&_args2[0]!==undefined?_args2[0]:{};params={mall:mallType.mall,project_name:'goods-detail',project_key:decodeURIComponent(this.url)};_context2.prev=2;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_35__utils_request__["a" /* default */])({url:mallType.url,method:"get",params:params});case 5:res=_context2.sent;if(res.data.code===0){data=res.data.data;this.dealData(data);}else{// utils.toast(res.data.msg)
this.setState({loading:false,NODATA:true});}this.uploadLog(mallType,res.data.code);_context2.next=12;break;case 10:_context2.prev=10;_context2.t0=_context2["catch"](2);case 12:case"end":return _context2.stop();}}},_callee2,this,[[2,10]]);}));function getData(){return _getData.apply(this,arguments);}return getData;}()},{key:"getMallType",value:function getMallType(){var type={};var _url=decodeURIComponent(this.url);console.log('=====url=====',_url);if(_url.indexOf('m.poizon.com')!=-1||_url.indexOf('m.dewu.com')!=-1){type=mallTypes[0];}else if(_url.indexOf('mobile.yangkeduo.com')!=-1){type.mall=mallTypes[2].mall;}else if(_url.indexOf('haohuo.jinritemai.com')!=-1){type.mall=mallTypes[1].mall;}else if(_url.indexOf('item.taobao.com/item.htm')!=-1){type.mall='淘宝';}else if(_url.indexOf('detail.tmall')!=-1){type.mall='天猫';}else if(_url.indexOf('item.jd')!=-1){type.mall='京东';}else if(_url.indexOf('detail.vip.com/detail')!=-1){type.mall='唯品会';}else if(_url.indexOf('yunmall.shihuo.cn')!=-1){type.mall='云mall';}else if(_url.indexOf('app.kwaixiaodian.com')!=-1){type.mall='快手';}else if(_url.indexOf('www.95fenapp.com')!=-1){type.mall='95分';}else if(_url.indexOf('www.goofish.com')!=-1){type.mall='闲鱼';}this.mallType=type;}},{key:"getChannelData",value:function(){var _getChannelData=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var _this4=this;var params,res,data,statusRule;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:params={url:decodeURIComponent(this.url)};_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_35__utils_request__["a" /* default */])({url:"//sh-gateway.shihuo.cn/v4/services/sh-supplierextendadmin/supplier/check/rule",method:"get",params:params});case 4:res=_context3.sent;this.getMallType();if(this.mallType.mall!='淘宝'&&this.mallType.mall!='天猫'){this.getChannelCheckListData();}if(res.data.code==0){data=res.data.data||[];statusRule=null;this.attrRule=null;data.map(function(item){if(item.report.url.indexOf('status')!=-1){statusRule={rule_id:item.rule_id,url:item.report.url,store:item.store};}else if(item.report.url.indexOf('attr')!=-1&&!_this4.attrRule){_this4.attrRule={rule_id:item.rule_id,url:item.report.url,store:item.store};}});if(statusRule){this.getChannelListData(statusRule);}if(this.attrRule){this.getAttrData();}}_context3.next=12;break;case 10:_context3.prev=10;_context3.t0=_context3["catch"](1);case 12:case"end":return _context3.stop();}}},_callee3,this,[[1,10]]);}));function getChannelData(){return _getChannelData.apply(this,arguments);}return getChannelData;}()},{key:"getChannelCheckListData",value:function(){var _getChannelCheckListData=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){var unique_id,params,res,data;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:unique_id=decodeURIComponent(this.url);params={supplier_urls:[unique_id],supplier_store:this.mallType.mall};_context4.prev=2;_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_35__utils_request__["a" /* default */])({url:"//sh-gateway.shihuo.cn/v4/services/sh-supplierextendadmin/supplier/check",method:"post",data:params});case 5:res=_context4.sent;if(res.data.code==0){data=res.data.data||{};console.log('===channelList===',data.detail[unique_id]);this.setState({channelList:data.detail[unique_id]||[]});}_context4.next=11;break;case 9:_context4.prev=9;_context4.t0=_context4["catch"](2);case 11:case"end":return _context4.stop();}}},_callee4,this,[[2,9]]);}));function getChannelCheckListData(){return _getChannelCheckListData.apply(this,arguments);}return getChannelCheckListData;}()},{key:"getChannelListData",value:function(){var _getChannelListData=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(statusRule){var unique_id,params,res,data;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:unique_id="extracted0_".concat(statusRule.rule_id);params={data:[{shop_id:"",shop_id_href:"",shop_name:"",supplier_url:decodeURIComponent(this.url),unique_id:unique_id}],rule_id:statusRule.rule_id,store:statusRule.store,need_record:0};_context5.prev=2;_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_35__utils_request__["a" /* default */])({url:statusRule.url,method:"post",data:params});case 5:res=_context5.sent;if(res.data.code==0){data=res.data.data||{};console.log('===channelList===',data.detail[unique_id]);this.setState({channelList:data.detail[unique_id]||[]});}_context5.next=11;break;case 9:_context5.prev=9;_context5.t0=_context5["catch"](2);case 11:case"end":return _context5.stop();}}},_callee5,this,[[2,9]]);}));function getChannelListData(_x2){return _getChannelListData.apply(this,arguments);}return getChannelListData;}()},{key:"getAttrData",value:function(){var _getAttrData=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(){var _this5=this;var _skuDataList,list,index,attrToUniqueIdMap,params,res,data;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_skuDataList=this.state._skuDataList;console.log('===_skuDataList==',_skuDataList);list=[];index=0;// 创建一个映射表，记录每个属性值对应的 unique_id
attrToUniqueIdMap={};_skuDataList.map(function(item){item.list.map(function(i){if(!list.find(function(e){return e.attr_name==i.value;})){var uniqueId="extracted".concat(index,"_").concat(_this5.attrRule.rule_id);list.push({attr_name:i.value,supplier_url:decodeURIComponent(_this5.url),unique_id:uniqueId});// 保存属性值和 unique_id 的映射关系
attrToUniqueIdMap[i.value]=uniqueId;++index;}});});params={data:list,rule_id:this.attrRule.rule_id,store:this.attrRule.store,need_record:0};if(this.supplier_id){params.supplier_id=this.supplier_id;}_context6.prev=8;_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_35__utils_request__["a" /* default */])({url:this.attrRule.url,method:"post",data:params});case 11:res=_context6.sent;if(res.data.code==0){data=res.data.data;// 保存 attrToUniqueIdMap 到 state，以便在渲染时使用
this.setState({attrRelatedList:data.detail,attrToUniqueIdMap:attrToUniqueIdMap});}_context6.next=17;break;case 15:_context6.prev=15;_context6.t0=_context6["catch"](8);case 17:case"end":return _context6.stop();}}},_callee6,this,[[8,15]]);}));function getAttrData(){return _getAttrData.apply(this,arguments);}return getAttrData;}()},{key:"uploadClickTrack",value:function uploadClickTrack(){var pti=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};Object(__WEBPACK_IMPORTED_MODULE_36_shihuo_lib_dist_shihuo_lib__["uploadPcTrack"])({pti:pti,urlinfo:'',channel:'H5Preview'});}},{key:"scrollToX",value:function scrollToX(){var isAdd=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var view=document.querySelector(".bottom-img-ul");var x=isAdd?view.scrollLeft+104:view.scrollLeft-104;view&&this.scroll(view.scrollLeft,x);}},{key:"scroll",value:function scroll(currentY,targetY){var _this6=this;// 计算需要移动的距离
var needScrollTop=targetY-currentY;var _currentY=currentY;setTimeout(function(){// 一次调用滑动帧数，每次调用会不一样
var dist=Math.ceil(needScrollTop/10);_currentY+=dist;document.querySelector(".bottom-img-ul").scrollTo(_currentY,0);// 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
if(needScrollTop>10||needScrollTop<-10){_this6.scroll(_currentY,targetY);}},1);}},{key:"renderGoodsImgList",value:function renderGoodsImgList(){var _this7=this;var imgActiveIndex=this.state.imgActiveIndex;var _this$state2=this.state,_this$state2$goodsDat=_this$state2.goodsData,goodsData=_this$state2$goodsDat===void 0?{}:_this$state2$goodsDat,_this$state2$selected=_this$state2.selectedId,selectedId=_this$state2$selected===void 0?[]:_this$state2$selected,selectedValue=_this$state2.selectedValue;var _ref4=goodsData||{},_ref4$skus=_ref4.skus,skus=_ref4$skus===void 0?[]:_ref4$skus;if(!skus||skus.length==0)return null;var sku_id=selectedId[2];var index=selectedValue?selectedValue.findIndex(function(e){return e.name=='颜色';}):-1;index=index==-1?0:index;var skuValue=selectedValue&&selectedValue[index]?selectedValue[index].value:'';var i=skus.findIndex(function(item){return item.attr&&item.attr.findIndex(function(e){return e.value==skuValue;})!=-1;});// const i = skus.findIndex((item) => item.sku_id == sku_id)
var spu_images=[];if(i>-1){spu_images=skus[i].image||[];}if(skuValue==''){spu_images=goodsData.spu_images||[];}if(!spu_images||spu_images.length==0){spu_images=goodsData.spu_images||[];}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"swiper-container",ref:this.swiperRef,style:{width:300,height:300}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"swiper-wrapper"},spu_images&&spu_images.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"swiper-slide",onClick:_this7.handleImgItemClick.bind(_this7,item,index),key:"img_"+index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"img-item",style:{maxWidth:300,maxHeight:300}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("img",{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].formatImgUrl(item,_this7.props.webpSupport),effect:"opacity"})));}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"bottom-img-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"left-icon-bg",onClick:function onClick(){_this7.scrollToX(false);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"left-icon"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("ul",{className:"bottom-img-ul"},spu_images&&spu_images.map(function(item,index){var isSelected=imgActiveIndex==index;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("li",{key:index,className:"bottom-img-li-parent",style:{marginLeft:index==0?'9px':'0px',marginRight:index==spu_images.length-1?'15px':'8px'},onClick:function onClick(){_this7.handleItemClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:isSelected?"bottom-img-li-float":'bottom-img-li',style:{marginLeft:'5px'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("img",{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].formatImgUrl(item,_this7.props.webpSupport),effect:"opacity"})));}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{style:{width:1}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"right-icon-bg",onClick:function onClick(){_this7.scrollToX(true);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"right-icon"}))));}},{key:"renderTitle",value:function renderTitle(){var _this$state$goodsData2=this.state.goodsData,goodsData=_this$state$goodsData2===void 0?{}:_this$state$goodsData2;var _ref5=goodsData||{},_ref5$title=_ref5.title,title=_ref5$title===void 0?'':_ref5$title,_ref5$mall=_ref5.mall,mall=_ref5$mall===void 0?'':_ref5$mall,onTime=_ref5.onTime;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-title-container"},mall?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"iconTxt"},mall):null,onTime==1?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"iconGreenTxt"},"\u5B9E\u65F6"):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"title"},title));}},{key:"renderSKUNum",value:function renderSKUNum(){var _this$state3=this.state,_this$state3$goodsDat=_this$state3.goodsData,goodsData=_this$state3$goodsDat===void 0?{}:_this$state3$goodsDat,_this$state3$selected=_this$state3.selectedId,selectedId=_this$state3$selected===void 0?[]:_this$state3$selected,selectedValue=_this$state3.selectedValue;var _ref6=goodsData||{},_ref6$skus=_ref6.skus,skus=_ref6$skus===void 0?[]:_ref6$skus,sellCount=_ref6.sellCount;var v=null;if(!skus||skus.length==0){}else{// const sku_id = selectedId[2]
// const item = skus.find((item) => item.sku_id == sku_id)
var index=selectedValue.findIndex(function(e){return e.name=='颜色';});var skuValue=selectedValue[0].value||'';var i=skus.findIndex(function(item){return item.attr.findIndex(function(e){return e.value==skuValue;})!=-1;});var item=skus[i];if(!item){v=null;}else{v=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info-view"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info"},"\u5E93\u5B58\uFF1A",item.status==1?'有':'--'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info"},"\u9500\u91CF\uFF1A",item.sale_count),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info"},"\u8BC4\u4EF7\u6570\uFF1A",item.appraisal));}}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-sku-num-container"},v,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"total"},"\u603B\u9500\u91CF\uFF1A",sellCount));}},{key:"renderDescInfo",value:function renderDescInfo(){var _this$state4=this.state,_this$state4$goodsDat=_this$state4.goodsData,goodsData=_this$state4$goodsDat===void 0?{}:_this$state4$goodsDat,_this$state4$selected=_this$state4.selectedId,selectedId=_this$state4$selected===void 0?[]:_this$state4$selected,selectedValue=_this$state4.selectedValue;var _ref7=goodsData||{},_ref7$skus=_ref7.skus,skus=_ref7$skus===void 0?[]:_ref7$skus;if(!skus||skus.length==0)return null;// const sku_id = selectedId[2]
// const item = skus.find((item) => item.sku_id == sku_id)
var index=selectedValue.findIndex(function(e){return e.name=='颜色';});var skuValue=selectedValue[0].value||'';var i=skus.findIndex(function(item){return item.attr.findIndex(function(e){return e.value==skuValue;})!=-1;});var item=skus[i];if(!item)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-desc-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"title"},item.trade_info||''));}},{key:"deRepeat",value:function deRepeat(list){var resList=[];var map=[];list.map(function(e){if(!map.includes(e.value)){resList.push(e);map.push(e.value);}});return resList;}},{key:"renderSKUList",value:function renderSKUList(){var _this8=this;var _this$state5=this.state,_this$state5$skuTitle=_this$state5.skuTitleList,skuTitleList=_this$state5$skuTitle===void 0?[]:_this$state5$skuTitle,_this$state5$goodsDat=_this$state5.goodsData,goodsData=_this$state5$goodsDat===void 0?{}:_this$state5$goodsDat,selectedId=_this$state5.selectedId;var _ref8=goodsData||{},_ref8$skus=_ref8.skus,skus=_ref8$skus===void 0?[]:_ref8$skus;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-sku-list-container"},skuTitleList&&skuTitleList.map(function(item,index){var _item$name2=item.name,name=_item$name2===void 0?'':_item$name2,_item$attrObj=item.attrObj,attrObj=_item$attrObj===void 0?{}:_item$attrObj;var list=Object.keys(attrObj)||[];console.log('--list--',list,skuTitleList);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{key:index,className:"item-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"title"},name+"："),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"list"},list&&list.map(function(cItem,cIndex){var id0=cItem.split('-')[0];var id1=cItem.split('-')[1];if(index==0&&_this8.state.selectedId[1]!=''&&id1!=_this8.state.selectedId[1])return null;if(index==1&&id0!=_this8.state.selectedId[0])return null;var childItem=attrObj[cItem];var isSelected=false;if(index==0){isSelected=_this8.state.selectedId[0]==id0;}else if(index==1){isSelected=_this8.state.selectedId[1]==id1;}var i=skus.findIndex(function(item){return item.sku_id==childItem.sku_id;});var spu_image='';if(skuTitleList.length>1&&index==0&&i>-1&&skus[i].image&&skus[i].image.length>0){spu_image=skus[i].image[0]||'';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{key:index+"_child_"+cIndex,id:"listItem",className:isSelected?"list-item-selected":"list-item",style:{minHeight:spu_image?'26px':'18px'},onClick:function onClick(){_this8.selectItem(cItem,index,childItem.sku_id);}},spu_image&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("img",{// width="100%"
threshold:500// height="100%"
,style:{width:'0.53rem',height:'0.53rem',position:'relative',top:'-0.54rem'},src:__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].formatImgUrl(spu_image,_this8.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"content"},childItem.value));})));}));}},{key:"renderSKUListNew",value:function renderSKUListNew(){var _this9=this;var _this$state6=this.state,_this$state6$skuDataL=_this$state6.skuDataList,skuDataList=_this$state6$skuDataL===void 0?[]:_this$state6$skuDataL,_this$state6$goodsDat=_this$state6.goodsData,goodsData=_this$state6$goodsDat===void 0?{}:_this$state6$goodsDat,selectedValue=_this$state6.selectedValue,_skuDataList=_this$state6._skuDataList,attrRelatedList=_this$state6.attrRelatedList,attrToUniqueIdMap=_this$state6.attrToUniqueIdMap;var _ref9=goodsData||{},_ref9$skus=_ref9.skus,skus=_ref9$skus===void 0?[]:_ref9$skus;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-sku-list-container"},_skuDataList.map(function(attrs,index){var attrList=_this9.deRepeat(attrs.list);// console.log("attrList",attrList)
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{key:index,className:"item-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"title"},attrs.name+"："),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"list"},attrList.map(function(cItem,cIndex){var image=cItem.name=='颜色'&&cItem.image?cItem.image[0]:null;var isSelect=selectedValue.find(function(e){return e.value==cItem.value;})?true:false;var hasRelated=attrRelatedList&&attrToUniqueIdMap&&attrToUniqueIdMap[cItem.value]&&attrRelatedList[attrToUniqueIdMap[cItem.value]];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{key:index+"_child_"+cIndex,id:"listItem",className:isSelect?"list-item-selected":"list-item",onClick:function onClick(e){e.stopPropagation();_this9.filterItem(cItem,cIndex);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"item-main-content"},image&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("img",{threshold:500// style={{width:'0.5rem',height:'0.5rem',position:'relative',top:'-0.55rem'}}
,src:__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].formatImgUrl(image,_this9.props.webpSupport),effect:"opacity"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"content"},cItem.value)),hasRelated&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"item-related-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"related",onClick:function onClick(e){e.stopPropagation();if(attrRelatedList[attrToUniqueIdMap[cItem.value]].href)window.open(attrRelatedList[attrToUniqueIdMap[cItem.value]].href,'_blank');},dangerouslySetInnerHTML:{__html:attrRelatedList[attrToUniqueIdMap[cItem.value]].html_status}})));})));}));}},{key:"filterItem",value:function filterItem(item){var _this10=this;var _this$state7=this.state,_this$state7$skuDataL=_this$state7.skuDataList,skuDataList=_this$state7$skuDataL===void 0?[]:_this$state7$skuDataL,_this$state7$goodsDat=_this$state7.goodsData,goodsData=_this$state7$goodsDat===void 0?{}:_this$state7$goodsDat,selectedValue=_this$state7.selectedValue;var _ref10=goodsData||{},_ref10$skus=_ref10.skus,skus=_ref10$skus===void 0?[]:_ref10$skus;var _selectedValue=JSON.parse(JSON.stringify(selectedValue));var lastModiefied={};var index=_selectedValue.findIndex(function(e){return e.name==item.name;});//修改的筛选项类型
if(_selectedValue[index].value==''||_selectedValue[index].value!=item.value){_selectedValue[index].value=item.value;lastModiefied={name:item.name,value:item.value};}else{_selectedValue[index].value='';lastModiefied={name:item.name,value:''};}var _skuDataList=[];// selectedValue[index].value != '' && _selectedValue[index].value == item.value
if(skus&&skus.length>0){var attr=skus[0].attr||[];attr.map(function(item){_skuDataList.push({name:item.name,list:[]});});skus.map(function(sku){sku.attr.map(function(item,index){if(lastModiefied.value==''){_skuDataList[index].list.push(_objectSpread(_objectSpread({},item),{},{image:sku.image}));}else{if(lastModiefied.name==item.name){_skuDataList[index].list=_this10.state._skuDataList[index].list;}else{if(sku.attr.findIndex(function(e){return e.value==lastModiefied.value;})!=-1){_skuDataList[index].list.push(_objectSpread(_objectSpread({},item),{},{image:sku.image}));}}}});});this.setState({_skuDataList:JSON.parse(JSON.stringify(_skuDataList))});}this.setState({selectedValue:_selectedValue,lastModiefied:lastModiefied},function(){_this10.swiper&&_this10.swiper.slideTo(0,300,false);_this10.uploadClickTrack({id:'skuSelect',biz:JSON.stringify({selectedValue:_selectedValue})});});}},{key:"renderBaseInfo",value:function renderBaseInfo(){var _this$state$goodsData3=this.state.goodsData,goodsData=_this$state$goodsData3===void 0?{}:_this$state$goodsData3;var _ref11=goodsData||{},_ref11$brandName=_ref11.brandName,brandName=_ref11$brandName===void 0?'':_ref11$brandName,_ref11$categoryName=_ref11.categoryName,categoryName=_ref11$categoryName===void 0?'':_ref11$categoryName,_ref11$commissionRate=_ref11.commissionRate,commissionRate=_ref11$commissionRate===void 0?'':_ref11$commissionRate;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-service-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"title"},"\u57FA\u672C\u4FE1\u606F"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"baseInfo"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info-item"},"\u7AD9\u5916\u5206\u7C7B\uFF1A",categoryName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info-item"},"\u7AD9\u5916\u54C1\u724C\uFF1A",brandName),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"info-item"},"\u4F63\u91D1\uFF1A",commissionRate)));}},{key:"renderService",value:function renderService(){var _this$state$goodsData4=this.state.goodsData,goodsData=_this$state$goodsData4===void 0?{}:_this$state$goodsData4;var _ref12=goodsData||{},_ref12$service=_ref12.service,service=_ref12$service===void 0?'':_ref12$service;if(!service)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-service-container",style:{marginTop:20}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"title"},"\u670D\u52A1"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"content"},service));}},{key:"renderTabView",value:function renderTabView(){var _this11=this;var _this$state8=this.state,_this$state8$goodsDat=_this$state8.goodsData,goodsData=_this$state8$goodsDat===void 0?{}:_this$state8$goodsDat,_this$state8$tabIndex=_this$state8.tabIndex,tabIndex=_this$state8$tabIndex===void 0?0:_this$state8$tabIndex;var _ref13=goodsData||{},_ref13$baseProperties=_ref13.baseProperties,baseProperties=_ref13$baseProperties===void 0?{}:_ref13$baseProperties,_ref13$sizeInfo=_ref13.sizeInfo,sizeInfo=_ref13$sizeInfo===void 0?{}:_ref13$sizeInfo,_ref13$imageAndText=_ref13.imageAndText,imageAndText=_ref13$imageAndText===void 0?[]:_ref13$imageAndText;var _ref14=baseProperties||[],_ref14$list=_ref14.list,list=_ref14$list===void 0?[]:_ref14$list;var _ref15=sizeInfo||{},sizeTemplate=_ref15.sizeTemplate;var titleList=[];if(list&&list.length>0){titleList.push('商品参数');}if(imageAndText&&imageAndText.length>0){var hasImage=false;imageAndText.map(function(item,index){var _item$images=item.images,images=_item$images===void 0?[]:_item$images;if(images&&images.length>0){hasImage=true;}});if(hasImage){titleList.push('商详图片');}}if(sizeTemplate&&sizeTemplate&&sizeTemplate.list&&sizeTemplate.list.length>0){titleList.push('尺码');}titleList.push('二维码查看');return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"top-tab-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"tab-container"},titleList.map(function(item,index){var isSelected=tabIndex==index;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:isSelected?"tab-item-selected":"tab-item",key:index,onClick:function onClick(){_this11.setState({tabIndex:index});_this11.uploadClickTrack({id:'tabSelect',biz:JSON.stringify({tabIndex:index})});}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",null,item));})),this.renderTableOne(list,titleList[tabIndex]),this.renderTableTwo(imageAndText,titleList[tabIndex]),this.renderTableThree(sizeTemplate&&sizeTemplate.list,titleList[tabIndex]),this.renderTableFour(titleList[tabIndex]));}},{key:"renderTableOne",value:function renderTableOne(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var title=arguments.length>1?arguments[1]:undefined;if(!list||list.length==0)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:title=='商品参数'?"table-one show":"table-one hide"},list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"line"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"title"},item.key),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"value"},item.value));}));}},{key:"renderTableTwo",value:function renderTableTwo(){var _this12=this;var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var title=arguments.length>1?arguments[1]:undefined;if(!list||list.length==0)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:title=='商详图片'?"table-two show":"table-two hide"},list.map(function(item,index){var _item$images2=item.images,images=_item$images2===void 0?[]:_item$images2;if(!images||images.length==0)return null;var view=images.map(function(cItem,cIndex){if(!cItem.url)return null;var width=cItem.width,height=cItem.height;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("img",{width:"100%",threshold:500,height:"auto",key:'p-'+index+'c-'+cIndex,src:__WEBPACK_IMPORTED_MODULE_34__utils_utils__["a" /* default */].formatImgUrl(cItem.url,_this12.props.webpSupport),effect:"opacity"});});return view;}));}},{key:"renderTableThree",value:function renderTableThree(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var title=arguments.length>1?arguments[1]:undefined;if(!list||list.length==0)return null;var sizeList=list[0].sizeValue.split(',')||[];var contentList=[];sizeList.map(function(item,index){var i={};list&&list.map(function(cItem,cIndex){i['v'+cIndex]=cItem.sizeValue.split(',')[index];});contentList.push(i);});return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:title=='尺码'?"table-three show":"table-three hide"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"line"},list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{key:'key-'+index,className:"title"},item.sizeKey);})),contentList.map(function(item,index){var ls=Object.keys(item)||[];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"line",key:'value-'+index},ls&&ls.map(function(cItem,cIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"value",key:'value-'+index+'-child'+cIndex},item[cItem]);}));}));}},{key:"renderTableFour",value:function renderTableFour(title){var _this$state$goodsData5=this.state.goodsData,goodsData=_this$state$goodsData5===void 0?{}:_this$state$goodsData5;var _ref16=goodsData||{},url=_ref16.url,mall=_ref16.mall;var _url=mall=='云mall'&&url?url:decodeURIComponent(this.url);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:title=='二维码查看'?"table-four show":"table-four hide"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37_qrcode_react___default.a,{value:_url,size:250,className:"qrcode",level:"H"}));}},{key:"renderBtnView",value:function renderBtnView(){var _this13=this;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"btn",onClick:function onClick(){window.parent.postMessage({type:'show_right_float_view',url:decodeURIComponent(_this13.url)},'*');}},"\u8BD5\u8BD5\u901A\u7528\u9884\u89C8\u5DE5\u5177");}},{key:"renderChannelList",value:function renderChannelList(){var _this14=this;var _this$state$channelLi=this.state.channelList,channelList=_this$state$channelLi===void 0?[]:_this$state$channelLi;if(!channelList||channelList.length===0){return null;}var hasMultipleChannels=channelList.length>1;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"channel-info-section"},channelList.map(function(item,index){if(!item||item.length===0)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"channel-list",key:'channel-list-'+index},item.filter(function(cItem){return channelShowType.includes(cItem.title);}).map(function(cItem,cIndex){var _cItem$title=cItem.title,title=_cItem$title===void 0?'':_cItem$title,_cItem$list=cItem.list,list=_cItem$list===void 0?[]:_cItem$list,supplier_id=cItem.supplier_id;if(!list||list.length===0)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"channel",key:'channel-'+cIndex},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"channel-title"},title,":"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"channel-content"},list.map(function(listItem,listIndex){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{key:'channel-content-'+listIndex,onClick:function onClick(){return _this14.handleClick(listItem);},className:listItem.href||listItem.fetch?'clickable-item':'',dangerouslySetInnerHTML:{__html:listItem.html_value}});})),hasMultipleChannels&&title==='识货状态'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"channel-switch-btn",onClick:function onClick(){return _this14.handleSwitchChannel(supplier_id);}},"\u5207\u6362\u8BE5\u6E20\u9053"));}));}));}},{key:"render",value:function render(){var baseConfig=this.props.config.baseConfig;var _this$state9=this.state,NODATA=_this$state9.NODATA,loading=_this$state9.loading;var _url=decodeURIComponent(this.url);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",_extends({className:"pipeline-goodsInfoPreview",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes']),NODATA&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"no-data"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37_qrcode_react___default.a,{value:_url,size:250,className:"qrcode",level:"H"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"title"},"\u6682\u65E0\u6570\u636E\uFF0C\u53EF\u4F7F\u7528\u624B\u673A\u626B\u63CF\u4E8C\u7EF4\u7801\u8BBF\u95EE")),!NODATA&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",null,loading?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"next-loading-fusion-reactor"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"next-loading-dot"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"next-loading-dot"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"next-loading-dot"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("span",{className:"next-loading-dot"})):/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"goods-info-parent"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"goods-item-left-list"},this.renderGoodsImgList(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"goods-info-container"},this.renderChannelList())),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"goods-item-right-list"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_29_react___default.a.createElement("div",{className:"goods-info-container"},this.renderTitle(),this.renderSKUNum(),this.renderDescInfo(),this.renderSKUListNew(),this.renderBaseInfo(),this.renderService(),this.renderTabView())))));}}]);return PipelineGoodsInfoPreview;}(__WEBPACK_IMPORTED_MODULE_29_react___default.a.Component);PipelineGoodsInfoPreview.propTypes={config:__WEBPACK_IMPORTED_MODULE_30_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineGoodsInfoPreview);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(30);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["value", "size", "level", "bgColor", "fgColor", "style", "includeMargin", "imageSettings"],
    _excluded2 = ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"],
    _excluded3 = ["renderAs"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);

var PropTypes = __webpack_require__(15); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.


var QRCodeImpl = __webpack_require__(917);

var ErrorCorrectLevel = __webpack_require__(314); // TODO: pull this off of the QRCode class type so it matches.


// Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
function convertStr(str) {
  var out = '';

  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);

    if (charcode < 0x0080) {
      out += String.fromCharCode(charcode);
    } else if (charcode < 0x0800) {
      out += String.fromCharCode(0xc0 | charcode >> 6);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      out += String.fromCharCode(0xe0 | charcode >> 12);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    } else {
      // This is a surrogate pair, so we'll reconsitute the pieces and work
      // from that
      i++;
      charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      out += String.fromCharCode(0xf0 | charcode >> 18);
      out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
      out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
      out += String.fromCharCode(0x80 | charcode & 0x3f);
    }
  }

  return out;
}

var DEFAULT_PROPS = {
  size: 128,
  level: 'L',
  bgColor: '#FFFFFF',
  fgColor: '#000000',
  includeMargin: false
};
var PROP_TYPES =  false ? {
  value: PropTypes.string.isRequired,
  size: PropTypes.number,
  level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
  bgColor: PropTypes.string,
  fgColor: PropTypes.string,
  includeMargin: PropTypes.bool,
  imageSettings: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    excavate: PropTypes.bool,
    x: PropTypes.number,
    y: PropTypes.number
  })
} : {};
var MARGIN_SIZE = 4; // This is *very* rough estimate of max amount of QRCode allowed to be covered.
// It is "wrong" in a lot of ways (area is a terrible way to estimate, it
// really should be number of modules covered), but if for some reason we don't
// get an explicit height or width, I'd rather default to something than throw.

var DEFAULT_IMG_SCALE = 0.1;

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        // M0 0h7v1H0z injects the space with the move and drops the comma,
        // saving a char per operation
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      } // end of row, clean up or skip


      if (x === row.length - 1) {
        if (!cell) {
          // We would have closed the op above already so this can only mean
          // 2+ light modules in a row.
          return;
        }

        if (start === null) {
          // Just a single dark module.
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          // Otherwise finish the current line.
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
} // We could just do this in generatePath, except that we want to support
// non-Path2D canvas, so we need to keep it an explicit step.


function excavateModules(modules, excavation) {
  return modules.slice().map(function (row, y) {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }

    return row.map(function (cell, x) {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }

      return false;
    });
  });
}

function getImageSettings(props, cells) {
  var imageSettings = props.imageSettings,
      size = props.size,
      includeMargin = props.includeMargin;

  if (imageSettings == null) {
    return null;
  }

  var margin = includeMargin ? MARGIN_SIZE : 0;
  var numCells = cells.length + margin * 2;
  var defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  var scale = numCells / size;
  var w = (imageSettings.width || defaultSize) * scale;
  var h = (imageSettings.height || defaultSize) * scale;
  var x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  var y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  var excavation = null;

  if (imageSettings.excavate) {
    var floorX = Math.floor(x);
    var floorY = Math.floor(y);
    var ceilW = Math.ceil(w + x - floorX);
    var ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }

  return {
    x: x,
    y: y,
    h: h,
    w: w,
    excavation: excavation
  };
} // For canvas we're going to switch our drawing mode based on whether or not
// the environment supports Path2D. We only need the constructor to be
// supported, but Edge doesn't actually support the path (string) type
// argument. Luckily it also doesn't support the addPath() method. We can
// treat that as the same thing.


var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }

  return true;
}();

var QRCodeCanvas = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(QRCodeCanvas, _React$PureComponent);

  var _super = _createSuper(QRCodeCanvas);

  function QRCodeCanvas() {
    var _this;

    _classCallCheck(this, QRCodeCanvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_canvas", void 0);

    _defineProperty(_assertThisInitialized(_this), "_image", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      imgLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleImageLoad", function () {
      _this.setState({
        imgLoaded: true
      });
    });

    return _this;
  }

  _createClass(QRCodeCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._image && this._image.complete) {
        this.handleImageLoad();
      }

      this.update();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props$imageSett, _nextProps$imageSetti;

      var currentSrc = (_this$props$imageSett = this.props.imageSettings) === null || _this$props$imageSett === void 0 ? void 0 : _this$props$imageSett.src;
      var nextSrc = (_nextProps$imageSetti = nextProps.imageSettings) === null || _nextProps$imageSetti === void 0 ? void 0 : _nextProps$imageSetti.src;

      if (currentSrc !== nextSrc) {
        this.setState({
          imgLoaded: false
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      var _this$props = this.props,
          value = _this$props.value,
          size = _this$props.size,
          level = _this$props.level,
          bgColor = _this$props.bgColor,
          fgColor = _this$props.fgColor,
          includeMargin = _this$props.includeMargin,
          imageSettings = _this$props.imageSettings; // We'll use type===-1 to force QRCode to automatically pick the best type

      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();

      if (this._canvas != null) {
        var canvas = this._canvas;
        var ctx = canvas.getContext('2d');

        if (!ctx) {
          return;
        }

        var cells = qrcode.modules;

        if (cells === null) {
          return;
        }

        var margin = includeMargin ? MARGIN_SIZE : 0;
        var numCells = cells.length + margin * 2;
        var calculatedImageSettings = getImageSettings(this.props, cells);

        if (imageSettings != null && calculatedImageSettings != null) {
          if (calculatedImageSettings.excavation != null) {
            cells = excavateModules(cells, calculatedImageSettings.excavation);
          }
        } // We're going to scale this so that the number of drawable units
        // matches the number of cells. This avoids rounding issues, but does
        // result in some potentially unwanted single pixel issues between
        // blocks, only in environments that don't support Path2D.


        var pixelRatio = window.devicePixelRatio || 1;
        canvas.height = canvas.width = size * pixelRatio;
        var scale = size / numCells * pixelRatio;
        ctx.scale(scale, scale); // Draw solid background, only paint dark modules.

        ctx.fillStyle = bgColor;
        ctx.fillRect(0, 0, numCells, numCells);
        ctx.fillStyle = fgColor;

        if (SUPPORTS_PATH2D) {
          // $FlowFixMe: Path2D c'tor doesn't support args yet.
          ctx.fill(new Path2D(generatePath(cells, margin)));
        } else {
          cells.forEach(function (row, rdx) {
            row.forEach(function (cell, cdx) {
              if (cell) {
                ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
              }
            });
          });
        }

        if (this.state.imgLoaded && this._image && calculatedImageSettings != null) {
          ctx.drawImage(this._image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          value = _this$props2.value,
          size = _this$props2.size,
          level = _this$props2.level,
          bgColor = _this$props2.bgColor,
          fgColor = _this$props2.fgColor,
          style = _this$props2.style,
          includeMargin = _this$props2.includeMargin,
          imageSettings = _this$props2.imageSettings,
          otherProps = _objectWithoutProperties(_this$props2, _excluded);

      var canvasStyle = _objectSpread({
        height: size,
        width: size
      }, style);

      var img = null;
      var imgSrc = imageSettings && imageSettings.src;

      if (imageSettings != null && imgSrc != null) {
        img = /*#__PURE__*/React.createElement("img", {
          src: imgSrc,
          style: {
            display: 'none'
          },
          onLoad: this.handleImageLoad,
          ref: function ref(_ref) {
            return _this2._image = _ref;
          }
        });
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("canvas", _extends({
        style: canvasStyle,
        height: size,
        width: size,
        ref: function ref(_ref2) {
          return _this2._canvas = _ref2;
        }
      }, otherProps)), img);
    }
  }]);

  return QRCodeCanvas;
}(React.PureComponent);

_defineProperty(QRCodeCanvas, "defaultProps", DEFAULT_PROPS);

if (false) {
  QRCodeCanvas.propTypes = PROP_TYPES;
}

var QRCodeSVG = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(QRCodeSVG, _React$PureComponent2);

  var _super2 = _createSuper(QRCodeSVG);

  function QRCodeSVG() {
    _classCallCheck(this, QRCodeSVG);

    return _super2.apply(this, arguments);
  }

  _createClass(QRCodeSVG, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          size = _this$props3.size,
          level = _this$props3.level,
          bgColor = _this$props3.bgColor,
          fgColor = _this$props3.fgColor,
          includeMargin = _this$props3.includeMargin,
          imageSettings = _this$props3.imageSettings,
          otherProps = _objectWithoutProperties(_this$props3, _excluded2); // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
      qrcode.addData(convertStr(value));
      qrcode.make();
      var cells = qrcode.modules;

      if (cells === null) {
        return null;
      }

      var margin = includeMargin ? MARGIN_SIZE : 0;
      var numCells = cells.length + margin * 2;
      var calculatedImageSettings = getImageSettings(this.props, cells);
      var image = null;

      if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }

        image = /*#__PURE__*/React.createElement("image", {
          xlinkHref: imageSettings.src,
          height: calculatedImageSettings.h,
          width: calculatedImageSettings.w,
          x: calculatedImageSettings.x + margin,
          y: calculatedImageSettings.y + margin,
          preserveAspectRatio: "none"
        });
      } // Drawing strategy: instead of a rect per module, we're going to create a
      // single path for the dark modules and layer that on top of a light rect,
      // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
      // way faster than DOM ops.
      // For level 1, 441 nodes -> 2
      // For level 40, 31329 -> 2


      var fgPath = generatePath(cells, margin);
      return /*#__PURE__*/React.createElement("svg", _extends({
        shapeRendering: "crispEdges",
        height: size,
        width: size,
        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
      }, otherProps), /*#__PURE__*/React.createElement("path", {
        fill: bgColor,
        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
      }), /*#__PURE__*/React.createElement("path", {
        fill: fgColor,
        d: fgPath
      }), image);
    }
  }]);

  return QRCodeSVG;
}(React.PureComponent);

_defineProperty(QRCodeSVG, "defaultProps", DEFAULT_PROPS);

if (false) {
  QRCodeSVG.propTypes = PROP_TYPES;
}

var QRCode = function QRCode(props) {
  var renderAs = props.renderAs,
      otherProps = _objectWithoutProperties(props, _excluded3);

  var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
  return /*#__PURE__*/React.createElement(Component, otherProps);
};

QRCode.defaultProps = _objectSpread({
  renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(918);
var RSBlock = __webpack_require__(919);
var BitBuffer = __webpack_require__(920);
var util = __webpack_require__(921);
var Polynomial = __webpack_require__(315);

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode.prototype;

proto.addData = function(data) {
	var newData = new BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

module.exports = QRCode;



/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(313);

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;



/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(314);

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
}

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ECL.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ECL.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ECL.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ECL.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
}

module.exports = QRRSBlock;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(313);
var Polynomial = __webpack_require__(315);
var math = __webpack_require__(316);

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 10;
		    case Mode.MODE_ALPHA_NUM 	: return 9;
		    case Mode.MODE_8BIT_BYTE	: return 8;
		    case Mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 12;
		    case Mode.MODE_ALPHA_NUM 	: return 11;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode) {
		    case Mode.MODE_NUMBER 	: return 14;
		    case Mode.MODE_ALPHA_NUM	: return 13;
		    case Mode.MODE_8BIT_BYTE	: return 16;
		    case Mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

module.exports = QRUtil;


/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCommunityCustom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_starts_with_js__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_starts_with_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_starts_with_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_ends_with_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_ends_with_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_ends_with_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_some_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_some_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_some_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_date_to_string_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_date_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_date_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_regexp_to_string_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__style_less__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CookieUtil={getRaw:function getRaw(key,str){if(CookieUtil._isValidKey(key)){var reg=new RegExp('(^| )'+key+'=([^;]*)(;|$)'),cookie=str||document.cookie,result=reg.exec(cookie);if(result){return result[2]||'';}}return'';},_isValidKey:function _isValidKey(key){return new RegExp("^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$").test(key);}};var formulaFuncs=[{label:'ROUNDDOWN() 向下舍入到指定位数',value:'ROUNDDOWN(, 1)'},{label:'ROUNDUP() 向上舍入到指定位数',value:'ROUNDUP(, 1)'},{label:'CALC() 混合运算',value:'CALC()'}];var textFormulaFuncs=[{label:'CONCATENATE(文本1, 文本2, ...) 将多个文本串联',value:'CONCATENATE()'}];var PipelineCommunityCustom=/*#__PURE__*/function(_React$Component){_inherits(PipelineCommunityCustom,_React$Component);var _super=_createSuper(PipelineCommunityCustom);function PipelineCommunityCustom(props){var _this;_classCallCheck(this,PipelineCommunityCustom);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getDmpData",function(openApiUrl,uid){var _this$props$config$as=_this.props.config.associateConfig.filterConditions,filterConditions=_this$props$config$as===void 0?[]:_this$props$config$as;var app_version=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].getVersion();var isAndroid=__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].isAndroid();var $and=[],filter={};if(filterConditions.length>0){var filterType=filterConditions[0].filterType;if(filterType==='number'){uid=Number(uid);}}filter[filterConditions[0].filterValue]={$eq:uid};$and.push(filter);if(!isAndroid||isAndroid&&__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].SHDiffVersion(app_version,'7.70.0')){Object(__WEBPACK_IMPORTED_MODULE_28__utils_request__["a" /* default */])({url:openApiUrl,method:'post',withCredentials:true,data:{option:{filters:{$and:$and},orders:[]}}}).then(function(res){var _res$data=res.data,status=_res$data.status,_res$data$data=_res$data.data,data=_res$data$data===void 0?{}:_res$data$data;if(status===0&&data.list&&data.list.length>0){var result=data.list[0];_this.handleFilterQuoteField(result,uid);}else{_this.handleFilterQuoteField();}});}else{__WEBPACK_IMPORTED_MODULE_27_axios___default()({url:openApiUrl,method:'post',withCredentials:true,data:{option:{filters:{$and:$and},orders:[]}}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,_res$data2$data=_res$data2.data,data=_res$data2$data===void 0?{}:_res$data2$data;if(status===0&&data.list&&data.list.length>0){var result=data.list[0];_this.handleFilterQuoteField(result,uid);}else{_this.handleFilterQuoteField();}});}});_defineProperty(_assertThisInitialized(_this),"handleFilterQuoteField",function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var uid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var showFields=[];var _this$props$config=_this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$fi=_this$props$config.fieldsNameList,fieldsNameList=_this$props$config$fi===void 0?[]:_this$props$config$fi,_this$props$config$fo=_this$props$config.formula,formula=_this$props$config$fo===void 0?{}:_this$props$config$fo;var _this$props$config$as2=_this.props.config.associateConfig.quoteFields,quoteFields=_this$props$config$as2===void 0?'':_this$props$config$as2;var additiveVal=0;quoteFields=quoteFields.split(',');fieldsNameList.forEach(function(field){var fieldKey=field.originalName;var fieldValue=field.componentType!=='formula'?result[fieldKey]:_this.calculateFormula(field.content||[],result);var temp={key:fieldKey,value:fieldValue,componentType:field.componentType,showRmbSymbol:field.showRmbSymbol};showFields.push(temp);});// 使用自定义字段名称
showFields.forEach(function(field){var key=field.key;var match=fieldsNameList.find(function(item){return item.originalName===key;});if(match&&match.changeName){field['key']=match.changeName;}});if(uid){if(formula.content.length>0){// 计算加和值
var _this$props$config$fo2=_this.props.config.formula.content,content=_this$props$config$fo2===void 0?[]:_this$props$config$fo2;additiveVal=_this.calculateFormula(content,result);}else{if(baseConfig.formula){additiveVal=result[baseConfig.formula]||0;}}}_this.setState({result:result,showFields:showFields,additiveVal:additiveVal});});_defineProperty(_assertThisInitialized(_this),"calculateFormula",function(){var content=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var result=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var formula='',calculateResult=0;var funcs=[].concat(formulaFuncs,textFormulaFuncs);var nearestFunc='';content.forEach(function(item){if(item.type=='placeholder-text'){if(nearestFunc.startsWith('CONCATENATE')){var val=result[item.value];formula+=typeof val=='number'?val:"\"".concat(val||'',"\"");}else{var numberValue=+(result[item.value]||'');formula+="".concat(isNaN(numberValue)?0:numberValue);}}else if(item.type=='text'){formula+=item.value;var func=funcs.find(function(func){return"".concat(item.value).endsWith("".concat(func.value.split('(')[0],"("));});if(func){nearestFunc=func.value;}}});try{// 这里定义的方法提供给eval的内部使用，请不要删除
var ROUNDDOWN=function ROUNDDOWN(value,n){return eval(value).toFixed(n);};var ROUNDUP=function ROUNDUP(value,n){var ratio=Math.pow(10,n);return Math.ceil(eval(value)*ratio)/ratio;};var CONCATENATE=function CONCATENATE(){var result='';for(var _len=arguments.length,values=new Array(_len),_key=0;_key<_len;_key++){values[_key]=arguments[_key];}values.forEach(function(o){if(typeof o=='string'&&!funcs.some(function(func){return o.indexOf(func.value.split('(')[0])!==-1;})){result+=o;}else{result+=eval(o);}});return result;};var CALC=function CALC(){var result='';for(var _len2=arguments.length,values=new Array(_len2),_key2=0;_key2<_len2;_key2++){values[_key2]=arguments[_key2];}values.forEach(function(o){result+=eval(o);});return result;};calculateResult=eval(formula);}catch(error){}if(typeof calculateResult!='string'){calculateResult='';}return calculateResult?parseFloat(calculateResult).toString():calculateResult;});_defineProperty(_assertThisInitialized(_this),"getUid",function(){return new Promise(function(resolve,reject){if(__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].isShihuo()){window.Jockey.send('fetchCookies',{url:'https://www.shihuo.cn'},function(res){if(res.status==0&&res.data&&res.data.str){__WEBPACK_IMPORTED_MODULE_30__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{bizExtra:{cookie:res.data.str}});var cookieStr=res.data.str.split(';').join('; ');var u=decodeURIComponent(CookieUtil.getRaw('u',cookieStr));var uid=u?u.split('|')[0]:'';resolve(uid);}});}else{resolve(_this.props.config.baseConfig.authorId);}});});_this.state={result:[],showFields:[],additiveVal:0};_this.openApiUrl='';return _this;}_createClass(PipelineCommunityCustom,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$props$config$as3,openApiUrl,uid;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props$config$as3=this.props.config.associateConfig.openApiUrl,openApiUrl=_this$props$config$as3===void 0?'':_this$props$config$as3;_context.next=3;return this.getUid();case 3:uid=_context.sent;if(openApiUrl&&uid){this.getDmpData(openApiUrl,uid);}else{this.handleFilterQuoteField();}case 5:case"end":return _context.stop();}}},_callee,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"render",value:function render(){var _this$props$config$ba2=this.props.config.baseConfig,baseConfig=_this$props$config$ba2===void 0?{}:_this$props$config$ba2;var _this$state=this.state,_this$state$showField=_this$state.showFields,showFields=_this$state$showField===void 0?[]:_this$state$showField,additiveVal=_this$state.additiveVal;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",_extends({className:"pipeline-communityCustom"},this.props['customAttributes'],{style:{marginTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),baseConfig.additiveTxt&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"data-desc"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"desc-additive"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"desc-label"},baseConfig.additiveTxt.slice(0,12))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"desc-value"},baseConfig.showRmbSymbol!==false&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",null,"\xA5"),additiveVal)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"data-fields"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("ul",null,showFields.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("li",{key:"field-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"fields-value"},item.showRmbSymbol&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",null,"\xA5"),item.value&&item.value>9999?parseFloat((item.value/10000).toFixed(1))+'w':(item.value&&item.value.toString().indexOf('\N'))>=0?0:item.value||0),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"fields-label"},item.key.slice(0,10)));}))));}}]);return PipelineCommunityCustom;}(__WEBPACK_IMPORTED_MODULE_26_react___default.a.Component);PipelineCommunityCustom.propTypes={config:__WEBPACK_IMPORTED_MODULE_29_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCommunityCustom);

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(30);
var toLength = __webpack_require__(68);
var context = __webpack_require__(164);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(165)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineTopic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineTopic=/*#__PURE__*/function(_React$Component){_inherits(PipelineTopic,_React$Component);var _super=_createSuper(PipelineTopic);function PipelineTopic(props){var _this;_classCallCheck(this,PipelineTopic);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"scrollEvent",function(){var _this$props$config$ba=_this.props.config.baseConfig.topicTheme,topicTheme=_this$props$config$ba===void 0?'':_this$props$config$ba;var scrollHeight=document.documentElement.scrollTop||document.body.scrollTop;if(scrollHeight>=200){_this.headLinesRef.setAttribute('class',"pipeline-headlines ".concat(topicTheme==='浅色模式'?'light':'dark'," hide"));}else{_this.headLinesRef.setAttribute('class',"pipeline-headlines ".concat(topicTheme==='浅色模式'?'light':'dark'," show"));}});_this.state={};_this.topicSwiper=null;_this.headLinesRef=null;return _this;}_createClass(PipelineTopic,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _this$props$config$it=this.props.config.itemList,itemList=_this$props$config$it===void 0?[]:_this$props$config$it;if(itemList.length>0){this.topicSwiper=new __WEBPACK_IMPORTED_MODULE_17_swiper_swiper_bundle_min_js___default.a('.topic-swiper',{direction:'vertical',autoplay:itemList.length>1,speed:500,loop:true,spaceBetween:20,allowTouchMove:false,// 禁止触摸滑动
on:{click:function click(swiper,event){var url=event.target.getAttribute('dataurl')||event.target.parentNode.getAttribute('dataurl');__WEBPACK_IMPORTED_MODULE_16__utils_utils__["a" /* default */].jumpToUrl(_this2.props.routeParams,url,url,{},-1,_this2.props,false);}}});}window.addEventListener('scroll',this.scrollEvent);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('scroll',this.scrollEvent);}},{key:"render",value:function render(){var _this3=this;var _this$props$config=this.props.config,_this$props$config$ba2=_this$props$config.baseConfig,baseConfig=_this$props$config$ba2===void 0?{}:_this$props$config$ba2,_this$props$config$it2=_this$props$config.itemList,itemList=_this$props$config$it2===void 0?[]:_this$props$config$it2;var _baseConfig$topicThem=baseConfig.topicTheme,topicTheme=_baseConfig$topicThem===void 0?'':_baseConfig$topicThem,_baseConfig$titleImag=baseConfig.titleImage,titleImage=_baseConfig$titleImag===void 0?'':_baseConfig$titleImag,_baseConfig$expireTim=baseConfig.expireTime,expireTime=_baseConfig$expireTim===void 0?'':_baseConfig$expireTim;if(!expireTime){return null;}var currentTime=new Date().getTime();expireTime=expireTime.replace('T',' ');if(new Date(expireTime).getTime()<currentTime){// 话题已过期
return null;}if(!titleImage){// 没有配置标题图片时，基于topicTheme使用兜底图片
if(topicTheme==='浅色模式'){titleImage='https://static.shihuocdn.cn/admin/files/20230821/4aa33bd68bbe0b2559c7a0cd207aaff1.png';}else{titleImage='https://static.shihuocdn.cn/admin/files/20230821/1e6490f79e68e28ac6edc864a57b3143.png';}}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({ref:function ref(ele){_this3.headLinesRef=ele;if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_16__utils_utils__["a" /* default */].getExposureData(this.props)),className:topicTheme==='浅色模式'?'pipeline-headlines show light':'pipeline-headlines show dark'},this.props['customAttributes'],{style:{top:this.props.navigationBarHeight+4}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"topic-title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:titleImage,alt:""})),itemList.length>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"topic-swiper swiper-container"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"topic-lottery-all swiper-wrapper"},itemList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",{className:"topic-lottery-item swiper-slide",key:index,dataUrl:item.topicUrl},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("p",{style:{color:topicTheme==='浅色模式'?'#333':'#fff'}},item.topicTitle),item.topicHot==='是'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20230821/ea4bdd455ad13fefa8231c72a8614026.png",alt:"",className:"hot-tag"}));}))));}}]);return PipelineTopic;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);PipelineTopic.propTypes={config:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineTopic);

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProductCollection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_split_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_swiper_swiper_less__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_swiper_swiper_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_swiper_swiper_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_swiper_components_pagination_pagination_less__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_swiper_components_pagination_pagination_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_swiper_components_pagination_pagination_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__style_less__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */function componentDataFormat(props){var _props$config=props.config,config=_props$config===void 0?{}:_props$config,createTime=props.createTime;if(createTime&&Number(createTime)>1713960000000){return config;}var _config$baseConfig=config.baseConfig,baseConfig=_config$baseConfig===void 0?{}:_config$baseConfig,_config$grains=config.grains,grains=_config$grains===void 0?[]:_config$grains;if(grains&&grains[0]&&!grains[0].cardGroup){var data={baseConfig:{moduleMarginTop:baseConfig.moduleMarginTop,title:baseConfig.title,addToNav:baseConfig.addToNav},grains:grains.map(function(item){var _item$cardBaseConfig=item.cardBaseConfig,cardBaseConfig=_item$cardBaseConfig===void 0?{}:_item$cardBaseConfig,_item$commonCard=item.commonCard,commonCard=_item$commonCard===void 0?{}:_item$commonCard,_item$hotCard=item.hotCard,hotCard=_item$hotCard===void 0?{}:_item$hotCard;return{cardBaseConfig:{backgroundImage:cardBaseConfig.backgroundImage,buttonText:"",buttonColor:"#6707ff"},cardGroup:[{commonCard:commonCard,hotCard:hotCard}]};})};return data;}else{return config;}}var PipelineProductCollection=/*#__PURE__*/function(_React$Component){_inherits(PipelineProductCollection,_React$Component);var _super=_createSuper(PipelineProductCollection);function PipelineProductCollection(props){var _this;_classCallCheck(this,PipelineProductCollection);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"initSwiper",function(){var collectionList=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(collectionList.length>1&&!_this.isLock){_this.isLock=true;_this.mySwiper=new __WEBPACK_IMPORTED_MODULE_29_swiper_swiper_bundle_min_js___default.a(_this.mySwiperRef.current,{autoplay:collectionList.length>1?{disableOnInteraction:false,delay:2000}:false,loop:false,allowSlidePrev:true,allowSlideNext:true,slidesPerView:'auto',on:{slideChange:function slideChange(swiper){var realIndex=swiper.realIndex;// this.mySwiper.allowSlidePrev = !swiper.isBeginning;
// this.mySwiper.allowSlideNext = !swiper.isEnd;
_this.mySwiper&&_this.mySwiper.autoplay.start();_this.addClickEventHandlers(swiper);_this.setState({currentCollectIdx:realIndex},function(){_this.updateTabPosition();});}}});_this.mySwiperRef.current.style.backgroundColor='rgba(0, 0, 0, 0.2)';}else{_this.addClickEventHandlers();}});_defineProperty(_assertThisInitialized(_this),"addClickEventHandlers",function(swiper){// 获取当前活动的 slide
var activeSlide=null;if(swiper){activeSlide=swiper.slides[swiper.activeIndex];}else{activeSlide=_this.productCollectionRef.querySelector('.swiper-slide');}if(!activeSlide){return;}var clickEventHandler=activeSlide.getAttribute('click-event-handler');if(clickEventHandler){return;}var switchArea=activeSlide.querySelector('.switch');// 换一换
if(switchArea){var clickEventHandlers=function clickEventHandlers(){_this.mySwiper&&_this.mySwiper.autoplay.stop();var slideIdx=swiper?swiper.realIndex:0;var collectionList=_this.state.collectionList;if(collectionList[slideIdx].groupIdx<collectionList[slideIdx].cardGroup.length-1){collectionList[slideIdx].groupIdx=collectionList[slideIdx].groupIdx+1;}else{collectionList[slideIdx].groupIdx=0;}_this.setState({collectionList:collectionList});};switchArea.addEventListener('click',clickEventHandlers);}var hotCradArea=activeSlide.querySelector('.hot-card');// 爆款商品卡点击
if(hotCradArea){var _clickEventHandlers=function _clickEventHandlers(){var collectIndex=hotCradArea.getAttribute('collectindex');var goodsId=hotCradArea.getAttribute('goodsid');var styleId=hotCradArea.getAttribute('styleid');var title=hotCradArea.getAttribute('title');var url=hotCradArea.getAttribute('url');var options={name:title,goods_id:goodsId,style_id:styleId};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,url,url,options,-1,_this.props,false,{ptiId:"".concat(_this.props.templatePti,":productCollection_").concat(collectIndex,"-hotCard"),bizExtra:{model_block:'爆款商品卡'}});};hotCradArea.addEventListener('click',_clickEventHandlers);}var commonCardAreas=activeSlide.querySelectorAll('.commonCard');// 常规商品卡点击
commonCardAreas.forEach(function(area){if(area){var _clickEventHandlers2=function _clickEventHandlers2(){var collectIndex=area.getAttribute('collectindex');var goodsId=area.getAttribute('goodsid');var styleId=area.getAttribute('styleid');var title=area.getAttribute('title');var sort=area.getAttribute('sort');var url=area.getAttribute('url');var options={sort:sort,name:title,goods_id:goodsId,style_id:styleId};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,url,url,options,-1,_this.props,false,{ptiId:"".concat(_this.props.templatePti,":productCollection_").concat(collectIndex,"-commonCard:").concat(sort),bizExtra:{model_block:'常规商品卡'}});};area.addEventListener('click',_clickEventHandlers2);}});activeSlide.setAttribute('click-event-handler',true);});_defineProperty(_assertThisInitialized(_this),"getProductListData",function(){var productType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var sortType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:4;var shihuoSubsidy=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'否';var ids=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];var itemList=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var requestUrl='';switch(productType){case'商品id':requestUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur';break;case'配色id':requestUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur';break;case'skuId':requestUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur';break;default:break;}return new Promise(function(resolve){Object(__WEBPACK_IMPORTED_MODULE_30__utils_request__["a" /* default */])({url:requestUrl,method:"post",withCredentials:true,data:{ids:ids,sort_tag:_this.sortTypeMap[sortType]||0,filter_subsidy:shihuoSubsidy==='是'?1:0}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0){var notFoundList=[];var list=data.List;if(data.NotFound&&data.NotFound.length>0){notFoundList=data.NotFound;}if(data.NotShow&&data.NotShow.length>0){notFoundList=data.NotShow;}if(sortType==='自定义排序'){list=itemList.map(function(product){var findItem=list.find(function(item){return item.id==product.id;});if(findItem&&findItem.id!=0){// 商品维度，商品图片和价格均要实时获取
Object.assign(product,_objectSpread(_objectSpread({},findItem),{},{image:productType!=='商品id'?findItem.image:product.image,title:product.useCustomName==='是'?product.title:findItem.title,price:product!=='商品id'?findItem.price:product.price,recommend:product.recommendType==='自定义'?product.recommend:findItem.recommend}));}return product;});}else{list=list&&list.map(function(product){var findItem=itemList.find(function(item){return item.id==product.id;});if(findItem&&findItem.id!=0){product.useCustomName=findItem.useCustomName;product.recommendType=findItem.recommendType;product.title=findItem.useCustomName==='是'?findItem.title:product.title;product.recommend=findItem.recommendType==='自定义'?findItem.recommend:product.recommend;// 商品维度，商品图片和价格均要实时获取
if(productType!=='商品id'){product.image=findItem.image&&findItem.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2')<0?findItem.image:product.image;}}return product;});if(notFoundList.length>0){notFoundList.forEach(function(id){var findItem=itemList.find(function(item){return item.id==id;});if(findItem){Object.assign(findItem,{title:findItem.title,price:'--'});list.push(findItem);}});}}resolve(list||[]);}});});});_defineProperty(_assertThisInitialized(_this),"isTextOverflowed",function(element){var divHeight=element.offsetHeight;var lineHeight=parseInt(window.getComputedStyle(element).lineHeight);var lineCount=Math.round(divHeight/lineHeight);return lineCount>1;});_defineProperty(_assertThisInitialized(_this),"renderPriceDom",function(){var price=arguments.length>0&&arguments[0]!==undefined?arguments[0]:9988999;var priceDom=null,decimals='',suffix='';if(price>9999){price=parseFloat((price/10000).toFixed(1))+'万';}else{price=String(price);}if(price.indexOf('.')>=0){price=price.split('.');}if(Array.isArray(price)){if(price[1]&&price[1].indexOf('万')>=0){decimals=price[1].replace('万','');suffix='万';}else{decimals=price[1];}priceDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"price ".concat(_this.isAndroid?'android':'ios')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",{className:"symbol"},"\xA5"),price[0],".",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",{className:"decimals"},decimals),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",{className:"suffix"},suffix));}else{priceDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"price ".concat(_this.isAndroid?'android':'ios')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("span",{className:"symbol"},"\xA5"),price);}return priceDom;});_defineProperty(_assertThisInitialized(_this),"updateTabPosition",function(){var collectionTabWidth=_this.collectionTabRef.offsetWidth;var activeTab=_this.collectionTabRef.querySelector('.active');if(activeTab){var tabItemOffsetLeft=activeTab.offsetLeft;// 元素距离左边距离
var checkedItemWidth=activeTab.offsetWidth;var move=tabItemOffsetLeft-(collectionTabWidth/2-checkedItemWidth/2);if(_this.collectionTabRef.scrollWidth>collectionTabWidth){_this.collectionTabRef.scroll({top:0,left:move,behavior:'smooth'});}}});_defineProperty(_assertThisInitialized(_this),"handleTabClick",function(index){_this.setState({currentCollectIdx:index},function(){_this.mySwiper.slideTo(index);_this.updateTabPosition();});});_defineProperty(_assertThisInitialized(_this),"tabCharacters",function(str){var result='';var maxLength=0;for(var i=0;i<str.length;i++){var _char=str.charAt(i);if(/[\u4e00-\u9fa5]/.test(_char)){// 中文
if(maxLength+2<=10){maxLength+=2;result+=str[i];}}else{// 其他，如空格、特殊符号等
if(maxLength+1<=10){maxLength+=1;result+=str[i];}}}return result;});var dataSource=componentDataFormat(props);var _collectionList=dataSource.grains.map(function(grainItem){grainItem.cardGroup=grainItem.cardGroup.map(function(groupItem){if(groupItem.commonCard.sortType!=='自定义排序'){groupItem.commonCard.itemList=groupItem.commonCard.itemList.map(function(item){return{id:item.id,price:'',title:item.useCustomName==='是'?item.title:'',recommend:item.recommendType==='自定义'?item.recommend:'',useCustomName:item.useCustomName,recommendType:item.recommendType,image:'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'};});}else{groupItem.commonCard.itemList=groupItem.commonCard.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{price:''});});}return groupItem;});grainItem.groupIdx=0;return grainItem;});_this.state={collectionList:_collectionList,currentCollectIdx:0};_this.sortTypeMap={'自定义排序':0,'销量':4,'GMV':6,'上新时间':8};_this.isAndroid=__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].isAndroid();_this.mySwiper=null;_this.mySwiperRef=/*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_26_react__["createRef"])();_this.collectionTabRef=null;_this.productCollectionRef=null;_this.isLock=false;return _this;}_createClass(PipelineProductCollection,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this2=this;var _componentDataFormat,_componentDataFormat$,grains,collectionList,_loop,index;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_componentDataFormat=componentDataFormat(this.props),_componentDataFormat$=_componentDataFormat.grains,grains=_componentDataFormat$===void 0?[]:_componentDataFormat$;collectionList=JSON.parse(JSON.stringify(grains));_loop=function _loop(index){var grainItem=collectionList[index];var _loop2=function _loop2(key){var delayInterval=setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var groupItem,_groupItem$commonCard,commonCard,_groupItem$hotCard,hotCard,hotCardList,commonCardList,_hotCard$item,id,title,url,image,useCustomName,ids,itemList,productType,sortType,shihuoSubsidy,_commonCard$itemList,_itemList,_ids;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:groupItem=grainItem.cardGroup[key];_groupItem$commonCard=groupItem.commonCard,commonCard=_groupItem$commonCard===void 0?{}:_groupItem$commonCard,_groupItem$hotCard=groupItem.hotCard,hotCard=_groupItem$hotCard===void 0?{}:_groupItem$hotCard;hotCardList=[],commonCardList=[];if(!hotCard.item.id){_context.next=11;break;}_hotCard$item=hotCard.item,id=_hotCard$item.id,title=_hotCard$item.title,url=_hotCard$item.url,image=_hotCard$item.image,useCustomName=_hotCard$item.useCustomName;ids=[Number(id)];itemList=[{id:id,title:useCustomName==='是'?title:'',url:url,image:image,useCustomName:useCustomName}];_context.next=9;return _this2.getProductListData(hotCard.productType,4,hotCard.shihuoSubsidy,ids,itemList);case 9:hotCardList=_context.sent;if(hotCardList[0]){Object.assign(collectionList[index].cardGroup[key].hotCard,{item:hotCardList[0]});}case 11:if(!(commonCard.itemList.length>0)){_context.next=18;break;}productType=commonCard.productType,sortType=commonCard.sortType,shihuoSubsidy=commonCard.shihuoSubsidy,_commonCard$itemList=commonCard.itemList,_itemList=_commonCard$itemList===void 0?[]:_commonCard$itemList;_ids=_itemList.map(function(item){return isNaN(Number(item.id))?0:Number(item.id);});_context.next=16;return _this2.getProductListData(productType,sortType,shihuoSubsidy,_ids,_itemList);case 16:commonCardList=_context.sent;Object.assign(collectionList[index].cardGroup[key].commonCard,{itemList:commonCardList});case 18:_this2.setState({collectionList:collectionList},function(){_this2.initSwiper(collectionList);});case 19:case"end":return _context.stop();}}},_callee);})),key===0?0:3000);};for(var key=0;key<grainItem.cardGroup.length;key++){_loop2(key);}};for(index=0;index<collectionList.length;index++){_loop(index);}case 4:case"end":return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"renderCollectionTab",value:function renderCollectionTab(){var _this3=this;var _this$state=this.state,_this$state$collectio=_this$state.collectionList,collectionList=_this$state$collectio===void 0?[]:_this$state$collectio,_this$state$currentCo=_this$state.currentCollectIdx,currentCollectIdx=_this$state$currentCo===void 0?0:_this$state$currentCo;var className='';if(collectionList.length>3){className='fixedWidth';}else{className='flexWidth';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("ul",{className:"collection-tab",ref:function ref(_ref2){return _this3.collectionTabRef=_ref2;}},collectionList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("li",{className:className+=index===currentCollectIdx?' active':'',key:"tab-".concat(index),style:{backgroundColor:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].hexColorToRgba(index===currentCollectIdx?item.cardBaseConfig.buttonColor||'#6707ff':'#ffffff',index===currentCollectIdx?1:0.25)},onClick:function onClick(){return _this3.handleTabClick(index);}},_this3.tabCharacters(item.cardBaseConfig.buttonText));}));}},{key:"render",value:function render(){var _this4=this;var baseConfig=this.props.config.baseConfig;var _this$state$collectio2=this.state.collectionList,collectionList=_this$state$collectio2===void 0?[]:_this$state$collectio2;var renderTab=collectionList.length>1;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",_extends({ref:function ref(_ref3){return _this4.productCollectionRef=_ref3;},className:"pipeline-productCollection ".concat(renderTab?'large':'small'),id:this.props['customAttributes']['data-component-id'],name:baseConfig.title,style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}},this.props['customAttributes']),renderTab&&this.renderCollectionTab(),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"product-collection swiper-container",ref:this.mySwiperRef},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"swiper-wrapper"},collectionList.map(function(collectItem,collectIndex){var _collectItem$cardBase=collectItem.cardBaseConfig,cardBaseConfig=_collectItem$cardBase===void 0?{}:_collectItem$cardBase,_collectItem$cardGrou=collectItem.cardGroup,cardGroup=_collectItem$cardGrou===void 0?[]:_collectItem$cardGrou,_collectItem$groupIdx=collectItem.groupIdx,groupIdx=_collectItem$groupIdx===void 0?0:_collectItem$groupIdx;var _cardGroup$groupIdx=cardGroup[groupIdx],_cardGroup$groupIdx$c=_cardGroup$groupIdx.commonCard,commonCard=_cardGroup$groupIdx$c===void 0?{}:_cardGroup$groupIdx$c,_cardGroup$groupIdx$h=_cardGroup$groupIdx.hotCard,hotCard=_cardGroup$groupIdx$h===void 0?{}:_cardGroup$groupIdx$h;var backgroundImageUrl=cardBaseConfig.backgroundImage||'https://static.shihuocdn.cn/admin/files/20240401/aaeb2145f3a26d32952a7ff09457a70b.png';return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{key:"slide-".concat(collectIndex),className:"swiper-slide",style:{backgroundImage:"url(".concat(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(backgroundImageUrl,_this4.props.webpSupport),")"),backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"module-left"},hotCard.item.id&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:cardGroup.length>1?'hot-card has-switch':'hot-card no-switch',collectindex:collectIndex,goodsid:hotCard.item.goods_id,styleid:hotCard.item.style_id,url:hotCard.item.url,title:hotCard.item.title,style:{backgroundColor:hotCard.backgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"product-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_31__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_31__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(hotCard.item.image,_this4.props.webpSupport)})),hotCard.label&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(hotCard.label,_this4.props.webpSupport),className:"tag-img",alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"product-title"},hotCard.item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"product-price"},hotCard.item.price&&_this4.renderPriceDom(hotCard.item.price))),cardGroup.length>1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240401/c9e2635074b971dc8618c6703d882e09.png",alt:"\u6362\u4E00\u6362",className:"switch",groupidx:groupIdx})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("ul",{className:"module-right"},commonCard.itemList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("li",{key:"slide-".concat(collectIndex,"-commonCard-").concat(index),className:"commonCard commonCard-".concat(index+1),collectindex:collectIndex,goodsid:item.goods_id,styleid:item.style_id,title:item.title,url:item.url,sort:index,style:{backgroundColor:commonCard.backgroundColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_31__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_31__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.image,_this4.props.webpSupport),className:"product-img"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:commonCard.showRecommend==='是'&&item.recommend?'product-name line-clamp-1':'product-name line-clamp-2'},item.title),commonCard.showRecommend==='是'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("p",{className:"product-recommend"},item.recommend),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_26_react___default.a.createElement("div",{className:"product-price"},item.price&&_this4.renderPriceDom(item.price)));})));}))));}}]);return PipelineProductCollection;}(__WEBPACK_IMPORTED_MODULE_26_react___default.a.Component);PipelineProductCollection.propTypes={config:__WEBPACK_IMPORTED_MODULE_27_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProductCollection);

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProductGather */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_regexp_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_regexp_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__style_less__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */function hexColorToRgba(hexColor,opacity){if(!hexColor){return hexColor;}var alphaMaxVal=1;hexColor=hexColor.replace("#","");//用于分割16进制色彩通道
var reg=new RegExp("\\w{1,2}","g");//分割颜色通道
var rgbaArray255=hexColor.match(reg);rgbaArray255=rgbaArray255&&rgbaArray255.map(function(channel,index){//计算每个通道的10进制值
var colorVal=parseInt(channel,16);if(index===3){//这是alpha通道
return Math.round(colorVal/(255/alphaMaxVal)*100)/100;}return colorVal;});return"rgb(".concat(rgbaArray255.join(','),",").concat(opacity,")");}var PipelineProductGather=/*#__PURE__*/function(_React$Component){_inherits(PipelineProductGather,_React$Component);var _super=_createSuper(PipelineProductGather);function PipelineProductGather(props){var _this;_classCallCheck(this,PipelineProductGather);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"addEventListenerScroll",function(){var goodsScroll=_this.goodsScrollRef;var progressBg=_this.carouselBgRef;var progress=_this.progressRef;if(goodsScroll&&progressBg&&progress){var goodsScrollWidth=goodsScroll.scrollWidth-goodsScroll.clientWidth;var progressWidth=progressBg.clientWidth-progress.clientWidth;goodsScroll.addEventListener('scroll',function(){if(goodsScroll.scrollLeft>=goodsScrollWidth){_this.isScrollEnd=true;}var progressLeft=goodsScroll.scrollLeft/goodsScrollWidth*progressWidth;progress.style.left=progressLeft+'px';});}});_defineProperty(_assertThisInitialized(_this),"setSalesVisiable",function(){var _this$props$config$ca=_this.props.config.cardInfoConfig,cardInfoConfig=_this$props$config$ca===void 0?{}:_this$props$config$ca;if(cardInfoConfig.priceInfo==='销量'&&_this.gatherRef){_this.gatherRef.querySelectorAll('.goods-item').forEach(function(item,index){var goodsItemBottom=item.querySelector('.goods-item-bottom');var goodsItemPrice=item.querySelector('.goods-item-price');var priceInfoW=goodsItemBottom?goodsItemBottom.offsetWidth:0;var priceW=goodsItemPrice?goodsItemPrice.clientWidth:0;var sales=item.querySelector('.sales');if(sales){var salesW=sales.clientWidth;if(salesW+priceW<priceInfoW){sales.style.visibility='visible';}}});}});_defineProperty(_assertThisInitialized(_this),"getDiscountRate",function(price,original_price){var discountRate=price/original_price;if(discountRate>1||isNaN(discountRate)||original_price===0){discountRate=1;}discountRate=discountRate*10;discountRate=parseFloat(discountRate.toFixed(1));return discountRate;});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){var _this$props$config=_this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$ca2=_this$props$config.cardBaseConfig,cardBaseConfig=_this$props$config$ca2===void 0?{}:_this$props$config$ca2;var options={title:baseConfig.title,type:cardBaseConfig.productStyle,sort:index,name:item.title};__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.url,item.url,options,item.id,_this.props);});_defineProperty(_assertThisInitialized(_this),"handleMoreClick",function(){var _this$props$config$ba2=_this.props.config.baseConfig,baseConfig=_this$props$config$ba2===void 0?{}:_this$props$config$ba2;var browserMoreHref=baseConfig.browserMoreHref;if(browserMoreHref){var convertUrl=__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].convertHref(browserMoreHref);__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,convertUrl,{},-1,_this.props,false);}});var _props$config$cardBas=props.config.cardBaseConfig,_cardBaseConfig=_props$config$cardBas===void 0?{}:_props$config$cardBas;var sortType=_cardBaseConfig.sortType;// 初始化商品id列表数据
var initList=sortType==='自定义排序'?props.config.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{title:item.name,url:item.productHref,image:item.productImageCustom||'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'});}):props.config.itemList.map(function(item){return{image:'https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png'// 空白占位图
};});_this.initList=initList;_this.state={list:[]};_this.sortTypeMap={'自定义排序':0,'销量':4,'GMV':6,'上新时间':8,'热度':18};_this.saleTypeMap={'默认':4,'近1天':10,'近7天':12,'近14天':14,'近30天':16};_this.gatherRef=null;return _this;}_createClass(PipelineProductGather,[{key:"componentDidMount",value:function componentDidMount(){this.getProductListData();}},{key:"getProductListData",value:function getProductListData(){var _this2=this;var itemList=[];var _this$props$config$ca3=this.props.config.cardBaseConfig,cardBaseConfig=_this$props$config$ca3===void 0?{}:_this$props$config$ca3;var productType=cardBaseConfig.productType,productStyle=cardBaseConfig.productStyle,sortType=cardBaseConfig.sortType,dateRange=cardBaseConfig.dateRange,shihuoSubsidy=cardBaseConfig.shihuoSubsidy,showRectImg=cardBaseConfig.showRectImg;if(sortType==='自定义排序'){itemList=JSON.parse(JSON.stringify(this.initList));}else{itemList=this.props.config.itemList;}var itemDataObj={};var idList=itemList.map(function(item){if(item.id){itemDataObj[item.id]=item;}return isNaN(Number(item.id))?0:Number(item.id);});var reqUrl="";if(productType==="商品id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="配色id"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";}else if(productType==="skuId"){reqUrl="https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur";}var sort_tag=0;if(sortType==='销量'){if(!dateRange||dateRange==='默认'){sort_tag=4;}else{sort_tag=this.saleTypeMap[dateRange];}}else{sort_tag=this.sortTypeMap[sortType];}Object(__WEBPACK_IMPORTED_MODULE_31__utils_request__["a" /* default */])({url:reqUrl,method:"post",withCredentials:true,data:{ids:idList,sort_tag:sort_tag,filter_subsidy:shihuoSubsidy==='是'?1:0,from:this.props.specialApiFrom}}).then(function(res){if(res.data.status===0){var _res$data$data=res.data.data,_res$data$data$List=_res$data$data.List,List=_res$data$data$List===void 0?[]:_res$data$data$List,_res$data$data$notFou=_res$data$data.notFoundList,notFoundList=_res$data$data$notFou===void 0?[]:_res$data$data$notFou;if(sortType==='自定义排序'){itemList.forEach(function(item,index){if(item.id=='0'){var _element;// 无渠道商品，插入列表中
var element=(_element={id:item.id,image:item.productImageCustom,price:item.productPrice,title:item.name,url:item.productHref,useCustomName:item.useCustomName},_defineProperty(_element,"title",item.name),_defineProperty(_element,"recommendType",item.recommendType),_defineProperty(_element,"shoppersLabel",item.shoppersLabel),_defineProperty(_element,"recommend",item.recommend),_defineProperty(_element,"pocket",'超值好物'),_defineProperty(_element,"custom_unitPrice",item.shoppersLabelText),_defineProperty(_element,"image",item.productImageCustom),_element);List.splice(index,0,element);}});// 插入定制化内容
var rectImgs=0,_showRectImg=false;itemList.forEach(function(product){try{var customItem=List.find(function(item){return item.id==product.id;});if(sortType==='销量'){switch(dateRange){case'近1天':customItem.sell_point=customItem.realSaleNum;customItem.sell_point_str=String(customItem.realSaleNum);break;case'近7天':customItem.sell_point=customItem.realSaleNum7;customItem.sell_point_str=String(customItem.realSaleNum7);break;case'近14天':customItem.sell_point=customItem.realSaleNum14;customItem.sell_point_str=String(customItem.realSaleNum14);break;case'近30天':customItem.sell_point=customItem.realSaleNum30;customItem.sell_point_str=String(customItem.realSaleNum30);break;default:break;}}if(customItem&&customItem.id!='0'){// 商品维度，商品图片和价格均要实时获取
Object.assign(product,_objectSpread(_objectSpread({},customItem),{},{image:productType!=='商品id'?product.image&&product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2')<0?product.image:customItem.image:customItem.image,title:product.useCustomName?product.name:customItem.title,price:productType!=='商品id'?product.productPrice||customItem.price:customItem.price,recommend:product.recommendType==='自定义'?product.recommend:customItem.recommend,pocket:'超值好物'}));}if(product.rectImg){rectImgs++;}}catch(error){var customItem_beta=itemDataObj[product.id];if(customItem_beta){product.useCustomName=customItem_beta.useCustomName;product.title=customItem_beta.name;product.recommend=customItem_beta.recommend;}}});if(cardBaseConfig.showRectImg==='是'&&rectImgs==itemList.length){_showRectImg=true;}if(notFoundList.length>0){// 删除 notFoundList 中存在的商品
itemList=itemList.filter(function(product){var notFound=notFoundList.find(function(item){return item==product.id;});return notFound?false:true;});}_this2.setState({visiable:true,showRectImg:_showRectImg,list:itemList},function(){_this2.setSalesVisiable();_this2.addEventListenerScroll();});}else{// 非自定义排序，以实时抓取的数据顺序展示
itemList.forEach(function(item,index){if(item.id=='0'){var _element2;// 无渠道商品，插入列表中
var element=(_element2={id:item.id,image:item.productImageCustom,price:item.productPrice,title:item.name,url:item.productHref,useCustomName:item.useCustomName},_defineProperty(_element2,"title",item.name),_defineProperty(_element2,"recommendType",item.recommendType),_defineProperty(_element2,"shoppersLabel",item.shoppersLabel),_defineProperty(_element2,"recommend",item.recommend),_defineProperty(_element2,"pocket",'超值好物'),_defineProperty(_element2,"custom_unitPrice",item.shoppersLabelText),_defineProperty(_element2,"image",item.productImageCustom),_element2);List.splice(index,0,element);}});// 插入定制化内容
var _rectImgs=0,_showRectImg2=false;List.forEach(function(product){if(sortType==='销量'){switch(dateRange){case'近1天':product.sell_point=product.realSaleNum;product.sell_point_str=String(product.realSaleNum);break;case'近7天':product.sell_point=product.realSaleNum7;product.sell_point_str=String(product.realSaleNum7);break;case'近14天':product.sell_point=product.realSaleNum14;product.sell_point_str=String(product.realSaleNum14);break;case'近30天':product.sell_point=product.realSaleNum30;product.sell_point_str=String(product.realSaleNum30);break;default:break;}}try{var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem&&customItem.id!='0'){product.useCustomName=customItem.useCustomName;product.recommendType=customItem.recommendType;product.shoppersLabel=customItem.shoppersLabel;product.custom_unitPrice=customItem.shoppersLabelText;product.title=customItem.useCustomName?customItem.name:product.title;product.recommend=customItem.recommendType==='自定义'?customItem.recommend:product.recommend;product.pocket='超值好物';// 商品维度，商品图片、价格、跳转地址均要实时获取
if(productType!=='商品id'){product.image=customItem.productImageCustom||product.image;product.price=customItem.productPrice||product.price;product.url=customItem.productHref||product.url;}}if(product.rectImg){_rectImgs++;}}catch(error){var customItem_beta=itemDataObj[product.id];if(customItem_beta){product.useCustomName=customItem_beta.useCustomName;product.title=customItem_beta.name;product.recommend=customItem_beta.recommend;}}});if(cardBaseConfig.showRectImg==='是'&&_rectImgs==List.length){_showRectImg2=true;}_this2.setState({visiable:true,list:List,showRectImg:_showRectImg2},function(){_this2.setSalesVisiable();_this2.addEventListenerScroll();});}_this2.isLoading=false;}});}},{key:"formatUnitPrice",value:// 格式化单位价
function formatUnitPrice(price){var match=price.match(/^([^\d]*)(\d+)(\.\d+)?(.*)$/);if(!match)return price;var _match=_slicedToArray(match,5),symbol=_match[1],integer=_match[2],_match$=_match[3],decimal=_match$===void 0?"":_match$,_match$2=_match[4],unit=_match$2===void 0?"":_match$2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('16px')}},integer),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{style:{fontSize:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('10px')}},decimal,unit));}},{key:"renderBenefitDom",value:function renderBenefitDom(item){var _this$props$config$ca4=this.props.config.cardInfoConfig,cardInfoConfig=_this$props$config$ca4===void 0?{}:_this$props$config$ca4;var benefitDom=null;if(cardInfoConfig.benefit==='标签&推荐理由'){if(cardInfoConfig.priority==='优先展示标签'){if(item.labels&&item.labels.length>0){benefitDom=this.renderLabels(item.labels);}else{benefitDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"goods-item-benefit"},item.recommend||item.pocket);}}else{if(item.recommend){benefitDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"goods-item-benefit"},item.recommend);}else{if(item.labels&&item.labels.length>0){benefitDom=this.renderLabels(item.labels);}else{benefitDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"goods-item-benefit"},item.pocket);}}}}else if(cardInfoConfig.benefit==='单位价格'){if(cardInfoConfig.unitPriceReplacePrice&&item.unit_price_text){// 设置优先展示单位价且单位价存在时，此处展示总价
benefitDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"goods-item-benefit",style:{color:'#FF6000'}},"\u603B\u4EF7\xA5",item.price);}else{benefitDom=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"goods-item-benefit"},item.unit_price_text);}}return benefitDom;}// 单行商品滑动
},{key:"renderSingularRow",value:function renderSingularRow(){var _this3=this;var _this$props$config2=this.props.config,_this$props$config2$b=_this$props$config2.baseConfig,baseConfig=_this$props$config2$b===void 0?{}:_this$props$config2$b,_this$props$config2$c=_this$props$config2.cardBaseConfig,cardBaseConfig=_this$props$config2$c===void 0?{}:_this$props$config2$c,_this$props$config2$c2=_this$props$config2.cardInfoConfig,cardInfoConfig=_this$props$config2$c2===void 0?{}:_this$props$config2$c2,_this$props$config2$i=_this$props$config2.itemList,itemList=_this$props$config2$i===void 0?[]:_this$props$config2$i;var _this$state$list=this.state.list,list=_this$state$list===void 0?[]:_this$state$list;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"conatiner"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(this.props,{title:baseConfig.title||''},{bizExtra:{model_block:'模块标题'}})),className:"module-title",onClick:function onClick(){return _this3.handleMoreClick();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(baseConfig.titleBgImage,this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:baseConfig.browserMoreHref?'gradient has-btn':'gradient',style:{background:baseConfig.showGradientColor||baseConfig.showGradientColor===undefined?"linear-gradient(180deg, ".concat(hexColorToRgba(baseConfig.gradientColor,0)," 0%, ").concat(hexColorToRgba(baseConfig.gradientColor,1)," 41%, ").concat(hexColorToRgba(baseConfig.gradientColor,1)," 100%)"):'transparent'}},(baseConfig.showTitle||baseConfig.showTitle===undefined)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title.slice(0,8)),baseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(this.props,{},{bizExtra:{model_block:'查看更多'}})),className:"browser-more-btn",style:{color:baseConfig.titleColor,borderColor:baseConfig.titleColor}},"\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("svg",{t:"1701673137576",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2359",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("path",{d:"M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z","p-id":"2360",fill:baseConfig.titleColor}))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-body",ref:function ref(_ref2){return _this3.goodsBodyRef=_ref2;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:list.length>20&&baseConfig.browserMoreHref?"goods-scroll has-browser-more":"goods-scroll",ref:function ref(_ref){return _this3.goodsScrollRef=_ref;}},this.renderCard(list.slice(0,20)),list.length>20&&baseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(this.props,{},{bizExtra:{model_block:'查看更多'}})),className:"browser-more",onClick:function onClick(){return _this3.handleMoreClick();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"btn",style:{backgroundColor:cardBaseConfig.browserMoreBgColor,color:cardBaseConfig.browserMoreTxtColor}},"\u67E5\u770B\u66F4\u591A"))),this.renderCarouselBar()));}// 双行商品滑动
},{key:"renderDuplicateRow",value:function renderDuplicateRow(){var _this4=this;var _this$props$config3=this.props.config,_this$props$config3$b=_this$props$config3.baseConfig,baseConfig=_this$props$config3$b===void 0?{}:_this$props$config3$b,_this$props$config3$c=_this$props$config3.cardBaseConfig,cardBaseConfig=_this$props$config3$c===void 0?{}:_this$props$config3$c;var _this$state$list2=this.state.list,list=_this$state$list2===void 0?[]:_this$state$list2;var isEvenNum=list.length%2;if(isEvenNum!==0){list.pop();}var middle=parseInt(list.length/2);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"conatiner"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-body",ref:function ref(_ref4){return _this4.goodsBodyRef=_ref4;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:list.length>40&&baseConfig.browserMoreHref?"goods-scroll has-browser-more":"goods-scroll",ref:function ref(_ref3){return _this4.goodsScrollRef=_ref3;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(this.props,{title:baseConfig.title||''},{bizExtra:{model_block:'模块标题'}})),className:"module-title",onClick:function onClick(){return _this4.handleMoreClick();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(baseConfig.titleBgImage,this.props.webpSupport),alt:""}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:baseConfig.browserMoreHref?'gradient has-btn':'gradient',style:{background:baseConfig.showGradientColor||baseConfig.showGradientColor===undefined?"linear-gradient(180deg, ".concat(hexColorToRgba(baseConfig.gradientColor,0)," 0%, ").concat(hexColorToRgba(baseConfig.gradientColor,1)," 41%, ").concat(hexColorToRgba(baseConfig.gradientColor,1)," 100%)"):'transparent'}},(baseConfig.showTitle||baseConfig.showTitle===undefined)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"title",style:{color:baseConfig.titleColor}},baseConfig.title.slice(0,8)),baseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(this.props,{},{bizExtra:{model_block:'查看更多'}})),className:"browser-more-btn",style:{color:baseConfig.titleColor,borderColor:baseConfig.titleColor}},"\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("svg",{t:"1701673137576",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"2359",width:"12",height:"12"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("path",{d:"M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z","p-id":"2360",fill:baseConfig.titleColor}))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:list.length>40&&baseConfig.browserMoreHref?"scroll-wrap has-browser-more":"scroll-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"scroll-item"},this.renderCard(list.slice(0,middle))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"scroll-item"},this.renderCard(list.slice(middle,list.length),middle))),list.length>40&&baseConfig.browserMoreHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(this.props,{},{bizExtra:{model_block:'查看更多'}})),className:"browser-more",onClick:function onClick(){return _this4.handleMoreClick();}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"btn",style:{backgroundColor:cardBaseConfig.browserMoreBgColor,color:cardBaseConfig.browserMoreTxtColor}},"\u67E5\u770B\u66F4\u591A"))))),this.renderCarouselBar());}// 渲染价格
},{key:"renderPrice",value:function renderPrice(item){var _this$props$config4=this.props.config,_this$props$config4$b=_this$props$config4.baseConfig,baseConfig=_this$props$config4$b===void 0?{}:_this$props$config4$b,_this$props$config4$c=_this$props$config4.cardInfoConfig,cardInfoConfig=_this$props$config4$c===void 0?{}:_this$props$config4$c;var unit_price_text=item.unit_price_text.replace('¥','');if(cardInfoConfig.benefit==='单位价格'&&cardInfoConfig.unitPriceReplacePrice&&item.unit_price_text){// 优先展示单位价
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item-price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:String(parseFloat(item.unit_price_text)).length>5?'long':'small'},this.formatUnitPrice(unit_price_text)));}else{// 正常展示价格
if(item.price>=0&&(!cardInfoConfig.newUserPrice||cardInfoConfig.newUserPrice==='无')){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item-price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:String(parseFloat(item.price)).length>5?'long':'small'},item.price&&parseFloat(item.price)));}}}},{key:"renderCard",value:function renderCard(){var _this5=this;var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var baseIndex=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var _this$props$config5=this.props.config,_this$props$config5$b=_this$props$config5.baseConfig,baseConfig=_this$props$config5$b===void 0?{}:_this$props$config5$b,_this$props$config5$c=_this$props$config5.cardBaseConfig,cardBaseConfig=_this$props$config5$c===void 0?{}:_this$props$config5$c,_this$props$config5$c2=_this$props$config5.cardInfoConfig,cardInfoConfig=_this$props$config5$c2===void 0?{}:_this$props$config5$c2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react__["Fragment"],null,list.map(function(item,index){// 折扣计算
var discountRate=_this5.getDiscountRate(item.price,item.original_price);var benefitDom=_this5.renderBenefitDom(item);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this5.props.exp&&_this5.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].getExposureData(_this5.props,{title:baseConfig.title,type:cardBaseConfig.productStyle,sort:baseIndex+index,name:item.title})),className:index===list.length-1?'goods-item last-one':'goods-item',key:"goods-".concat(baseIndex+index),onClick:function onClick(){return _this5.handleItemClick(item,baseIndex+index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_32__utils_utils__["a" /* default */].formatImgUrl(item.image,_this5.props.webpSupport,'card')}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"mask"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"goods-item-title",style:{color:cardBaseConfig.productNameColor}},item.title),benefitDom),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item-bottom",style:{justifyContent:['原价','折扣'].indexOf(cardInfoConfig.priceInfo)>=0?'flex-start':'space-between'}},_this5.renderPrice(item),cardInfoConfig.newUserPrice==='新人价'&&item.new_user_price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-item-price",style:{color:baseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{className:"rmb-icon"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:String(parseFloat(item.new_user_price)).length>5?'long':'small'},item.new_user_price&&parseFloat(item.new_user_price))),cardInfoConfig.priceInfo==='原价'&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"origin-price",style:{color:baseConfig.priceInfoColor}},"\xA5",item.original_price),cardInfoConfig.priceInfo==='折扣'&&discountRate!=10&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"discount",style:{color:baseConfig.priceInfoColor}},discountRate,"\u6298"),cardInfoConfig.priceInfo==='销量'&&item.sell_point>0&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"sales",style:{color:baseConfig.priceInfoColor}},item.sell_point_str,"\u4EBA\u4ED8\u6B3E")));}));}},{key:"render",value:function render(){var _this6=this;var _this$props$config6=this.props.config,_this$props$config6$b=_this$props$config6.baseConfig,baseConfig=_this$props$config6$b===void 0?{}:_this$props$config6$b,_this$props$config6$c=_this$props$config6.cardBaseConfig,cardBaseConfig=_this$props$config6$c===void 0?{}:_this$props$config6$c,_this$props$config6$c2=_this$props$config6.cardInfoConfig,cardInfoConfig=_this$props$config6$c2===void 0?{}:_this$props$config6$c2;var className="pipeline-productGather ".concat(cardBaseConfig.slideType==='单行商品滑动'?'singular-row':'duplicate-row'," ").concat(cardInfoConfig.benefit!=='无'?'has-benefit':'not-benefit');return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",_extends({ref:function ref(_ref5){return _this6.gatherRef=_ref5;},id:this.props['customAttributes']['data-component-id'],className:className,name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),cardBaseConfig.slideType==='单行商品滑动'?this.renderSingularRow():this.renderDuplicateRow());}// 轮播条
},{key:"renderCarouselBar",value:function renderCarouselBar(){var _this7=this;var cardBaseConfig=this.props.config.cardBaseConfig;var carouselBgColor,progressColor;switch(cardBaseConfig.carouselBarColor){case'白色':// carouselBgColor = 'rgba(255, 255, 255, 0.3)';
progressColor='#ff4338';break;case'黑色':// carouselBgColor = 'rgba(202, 202, 202, 0.3)';
progressColor='#ff4338';break;default:// carouselBgColor = 'rgba(255, 255, 255, 0.3)';
progressColor='#ff4338';break;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"carousel-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"carousel-bg",style:{backgroundColor:carouselBgColor},ref:function ref(_ref6){return _this7.carouselBgRef=_ref6;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"carousel-progress",style:{backgroundColor:progressColor},ref:function ref(_ref7){return _this7.progressRef=_ref7;}}));}// 标签
},{key:"renderLabels",value:function renderLabels(){var _this8=this;var labels=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"labels"},labels.map(function(item,index){var color='',borderColor='',backgroundColor='';if(item.type==='NEW_GOODS'){color='#3E455E';borderColor='#C8CEE4';backgroundColor='transparent';}else{color='#FF4338';borderColor='#FFB4B3';backgroundColor='transparent';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{key:"label-".concat(index),className:_this8.isAndroid?'android':'ios',style:{color:color,borderColor:borderColor,backgroundColor:backgroundColor}},item.text);}));}}]);return PipelineProductGather;}(__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component);PipelineProductGather.propTypes={config:__WEBPACK_IMPORTED_MODULE_29_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProductGather);

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSchoolLottery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var PipelineSchoolLottery=/*#__PURE__*/function(_React$Component){_inherits(PipelineSchoolLottery,_React$Component);var _super=_createSuper(PipelineSchoolLottery);function PipelineSchoolLottery(props){var _this;_classCallCheck(this,PipelineSchoolLottery);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getActivityDetail",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _yield$Request,_yield$Request$data,data;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_17__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/basketball/lottery/offline/detail',method:"get",withCredentials:true,params:{lottery_code:_this.state.pageId}});case 2:_yield$Request=_context.sent;_yield$Request$data=_yield$Request.data;data=_yield$Request$data===void 0?{}:_yield$Request$data;if(data.status===0){_this.setState({prizes:data.data.prizes,receive_prizes:data.data.receive_prizes,is_can_enter:data.data.is_can_enter,is_receive:data.data.is_receive,is_has_enter:data.data.is_has_enter,is_lottery:data.data.is_receive||!data.data.is_receive&&data.data.is_has_enter,award_text:data.data.award_text},function(){var initSlotMachine=setInterval(function(){if(window.SlotMachine&&!_this.init){clearInterval(initSlotMachine);setTimeout(function(){var _data$data=data.data,_data$data$prizes=_data$data.prizes,prizes=_data$data$prizes===void 0?[]:_data$data$prizes,is_receive=_data$data.is_receive,_data$data$receive_pr=_data$data.receive_prizes,receive_prizes=_data$data$receive_pr===void 0?{}:_data$data$receive_pr;if(is_receive&&receive_prizes&&receive_prizes.style_id){var activeIdx=prizes.findIndex(function(item){return item.style_id===receive_prizes.style_id;});_this.initGames(activeIdx);}else{_this.initGames();}},600);}},50);});}else{window.Jockey.send('toast',{text:data.msg});}case 6:case"end":return _context.stop();}}},_callee);})));_defineProperty(_assertThisInitialized(_this),"getCommunityActDetail",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var update,_yield$Request2,_yield$Request2$data,data,_data$data2,prizes,receive_prizes,is_vote,is_can_enter,is_receive,is_has_enter,award_text,is_lottery,_args2=arguments;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:update=_args2.length>0&&_args2[0]!==undefined?_args2[0]:false;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_17__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/lottery/award',method:"get",withCredentials:true,params:{code:_this.state.pageId}});case 3:_yield$Request2=_context2.sent;_yield$Request2$data=_yield$Request2.data;data=_yield$Request2$data===void 0?{}:_yield$Request2$data;if(data.status===0){_data$data2=data.data,prizes=_data$data2.prizes,receive_prizes=_data$data2.receive_prizes,is_vote=_data$data2.is_vote,is_can_enter=_data$data2.is_can_enter,is_receive=_data$data2.is_receive,is_has_enter=_data$data2.is_has_enter,award_text=_data$data2.award_text;is_lottery=is_receive||!is_receive&&is_has_enter;_this.setState({is_lottery:update?false:is_lottery,receive_prizes:receive_prizes,is_vote:is_vote,is_can_enter:is_can_enter,is_receive:is_receive,is_has_enter:is_has_enter,award_text:award_text,prizes:prizes},function(){var initSlotMachine=setInterval(function(){if(window.SlotMachine&&!_this.init){clearInterval(initSlotMachine);setTimeout(function(){if(is_receive&&receive_prizes&&receive_prizes.style_id){var activeIdx=prizes.findIndex(function(item){return item.style_id===receive_prizes.style_id;});_this.initGames(activeIdx);}else{_this.initGames();}},600);}},50);});}else{window.Jockey.send('toast',{text:data.msg});}case 7:case"end":return _context2.stop();}}},_callee2);})));_defineProperty(_assertThisInitialized(_this),"initGames",function(activeIdx){var casino1=document.querySelector('#casino1');var casino2=document.querySelector('#casino2');var casino3=document.querySelector('#casino3');_this.init=true;_this.mCasino1=window.SlotMachine&&new window.SlotMachine(casino1,{active:activeIdx||activeIdx==0?activeIdx:0,delay:500,transition:"ease-in-out",direction:"down",distance:20.5,onComplete:function onComplete(){_this.mCasino2.stop();}});_this.mCasino2=window.SlotMachine&&new window.SlotMachine(casino2,{active:activeIdx||activeIdx==0?activeIdx:1,delay:500,transition:"ease-in-out",direction:"down",distance:20.5,onComplete:function onComplete(){_this.mCasino3.stop();}});_this.mCasino3=window.SlotMachine&&new window.SlotMachine(casino3,{active:activeIdx||activeIdx==0?activeIdx:2,delay:500,transition:"ease-in-out",direction:"down",distance:20.5,onComplete:function onComplete(){_this.isLock=false;var _this$state=_this.state,is_can_enter=_this$state.is_can_enter,is_receive=_this$state.is_receive,is_has_enter=_this$state.is_has_enter,_this$state$receive_p=_this$state.receive_prizes,receive_prizes=_this$state$receive_p===void 0?{}:_this$state$receive_p;var is_lottery=true;_this.setState({is_lottery:is_lottery,winningPopup:receive_prizes&&receive_prizes.style_id?true:false});}});_this.setState({visiable:true});});_defineProperty(_assertThisInitialized(_this),"handleLottery",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var CookieUA,CookieU,_yield$Request3,_yield$Request3$data,data;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('ua');case 2:CookieUA=_context3.sent;_context3.next=5;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');case 5:CookieU=_context3.sent;if(!((!CookieUA||!CookieU)&&!window.isLogin)){_context3.next=9;break;}// 未登录
window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});return _context3.abrupt("return");case 9:if(_this.state.is_can_enter){_context3.next=12;break;}window.Jockey.send('toast',{text:'暂无抽奖机会'});return _context3.abrupt("return");case 12:if(!_this.isLock){_context3.next=14;break;}return _context3.abrupt("return");case 14:_this.isLock=true;_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_17__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/basketball/lottery/offline/start',method:'post',withCredentials:true,data:{lottery_code:_this.state.pageId}});case 17:_yield$Request3=_context3.sent;_yield$Request3$data=_yield$Request3.data;data=_yield$Request3$data===void 0?{}:_yield$Request3$data;if(data.status===0){_this.setState({is_receive:data.data.is_receive,is_can_enter:data.data.is_can_enter,receive_prizes:data.data.receive_prizes,is_has_enter:true},function(){if(data.data.is_receive){var style_id=data.data.receive_prizes.style_id;var stopIdx=_this.state.prizes.findIndex(function(item){return item.style_id===style_id;});_this.playGames(stopIdx);}else{_this.playGames();}});}else{window.Jockey.send('toast',{text:data.msg});}case 21:case"end":return _context3.stop();}}},_callee3);})));_defineProperty(_assertThisInitialized(_this),"handleCommunityLottery",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){var CookieUA,CookieU,_this$state2,is_vote,is_can_enter,is_has_enter,is_receive,_yield$Request4,_yield$Request4$data,data,_data$data3,_is_receive,_data$data3$receive_p,receive_prizes;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('ua');case 2:CookieUA=_context4.sent;_context4.next=5;return __WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getCookie('u');case 5:CookieU=_context4.sent;if(!(!CookieUA||!CookieU)){_context4.next=9;break;}// 未登录
window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});return _context4.abrupt("return");case 9:_this$state2=_this.state,is_vote=_this$state2.is_vote,is_can_enter=_this$state2.is_can_enter,is_has_enter=_this$state2.is_has_enter,is_receive=_this$state2.is_receive;if(is_receive){_context4.next=16;break;}if(is_can_enter){_context4.next=14;break;}if(is_vote===0){window.Jockey.send('toast',{text:'投票后可参与抽奖'});}else{window.Jockey.send('toast',{text:'暂无抽奖机会'});}return _context4.abrupt("return");case 14:_context4.next=17;break;case 16:return _context4.abrupt("return");case 17:if(!_this.isLock){_context4.next=19;break;}return _context4.abrupt("return");case 19:_this.isLock=true;_context4.next=22;return Object(__WEBPACK_IMPORTED_MODULE_17__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-venueapi/delivery/lottery/award',method:'post',withCredentials:true,data:{code:_this.state.pageId}});case 22:_yield$Request4=_context4.sent;_yield$Request4$data=_yield$Request4.data;data=_yield$Request4$data===void 0?{}:_yield$Request4$data;if(data.status===0){_data$data3=data.data,_is_receive=_data$data3.is_receive,_data$data3$receive_p=_data$data3.receive_prizes,receive_prizes=_data$data3$receive_p===void 0?{}:_data$data3$receive_p;_this.setState({is_receive:_is_receive,receive_prizes:receive_prizes,is_has_enter:true},function(){if(_is_receive){var style_id=receive_prizes.style_id;var stopIdx=_this.state.prizes.findIndex(function(item){return item.style_id===style_id;});_this.playGames(stopIdx);}else{_this.playGames();}// 抽奖完刷新详情接口
_this.getCommunityActDetail(true);});}else{window.Jockey.send('toast',{text:data.msg});}case 26:case"end":return _context4.stop();}}},_callee4);})));_defineProperty(_assertThisInitialized(_this),"playGames",function(stopIdx){_this.mCasino1.shuffle(100,stopIdx||stopIdx==0?stopIdx:0);_this.mCasino2.shuffle(100,stopIdx||stopIdx==0?stopIdx:1);_this.mCasino3.shuffle(100,stopIdx||stopIdx==0?stopIdx:2);setTimeout(function(){_this.mCasino1.stop();},2000);});_defineProperty(_assertThisInitialized(_this),"createScript",function(){var head=document.querySelector('head');var script=document.createElement('script');script.type="text/javascript";script.src="https://www.shihuo.cn/js/lib/vFramePlayer.min.js";head.appendChild(script);});_this.state={visiable:false,pageId:__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getPageId(),is_vote:0,is_can_enter:false,is_has_enter:false,is_receive:false,is_lottery:false,receive_prizes:{style_id:null,name:'',img:''},prizes:[],award_text:'',winningPopup:false};_this.init=false;_this.isLock=false;_this.isShihuo=__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].isShihuo();return _this;}_createClass(PipelineSchoolLottery,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var acticityScene=this.props.config.acticityScene;this.createScript();if(acticityScene!=='社区投票'){this.getActivityDetail();}else{this.getCommunityActDetail();}document.addEventListener("visibilitychange",function(){if(document.hidden){return;}else{// 刷新秒杀状态
if(acticityScene!=='社区投票'){_this2.getActivityDetail();}else{_this2.getCommunityActDetail();}return;}},false);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.lotteryState){this.props.updateLotteryState(false);this.getCommunityActDetail();}}// 校园活动抽奖详情
},{key:"renderWinningPopup",value:// 中奖弹窗
function renderWinningPopup(){var _this3=this;var _this$state$receive_p2=this.state.receive_prizes,receive_prizes=_this$state$receive_p2===void 0?{}:_this$state$receive_p2;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"mask"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"winning-popup"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"success-info"},receive_prizes&&receive_prizes.style_id&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:receive_prizes.img,className:"prize-image"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"prize-name"},receive_prizes.name)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"https://sh1.shihuocdn.cn/images/bargain/close.png",alt:"",className:"close",onClick:function onClick(){return _this3.setState({winningPopup:false});}})))));}},{key:"render",value:function render(){var _this4=this;var _this$props$config=this.props.config,acticityScene=_this$props$config.acticityScene,lotteryBgImage=_this$props$config.lotteryBgImage,lotteryCoverImage=_this$props$config.lotteryCoverImage,lotteryBtnImage=_this$props$config.lotteryBtnImage,lotteryHasJoinBtnImage=_this$props$config.lotteryHasJoinBtnImage;var _this$state3=this.state,visiable=_this$state3.visiable,prizes=_this$state3.prizes,is_can_enter=_this$state3.is_can_enter,is_has_enter=_this$state3.is_has_enter,is_receive=_this$state3.is_receive,is_lottery=_this$state3.is_lottery,_this$state3$receive_=_this$state3.receive_prizes,receive_prizes=_this$state3$receive_===void 0?{}:_this$state3$receive_,award_text=_this$state3.award_text,winningPopup=_this$state3.winningPopup;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",_extends({ref:function ref(ele){if(ele){_this4.props.exp&&_this4.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_18__utils_utils__["a" /* default */].getExposureData(this.props)),className:"pipeline-schoolLottery"},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"games-area",style:{backgroundImage:"url(".concat(lotteryBgImage||'https://static.shihuocdn.cn/admin/files/20240411/0e3c1650c7335851cba16e40f51c90a8.png',")")}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",{className:"games-content fadeIn"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{id:"casino1",className:visiable?'show':'hide'},prizes&&prizes.length>0&&prizes.map(function(item,index){if(item.img){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-item-wrap",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:item.img,alt:"",className:"slot slot".concat(index),key:index}));}else{return null;}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{id:"casino2",className:visiable?'show':'hide'},prizes&&prizes.length>0&&prizes.map(function(item,index){if(item.img){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-item-wrap",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:item.img,alt:"",className:"slot slot".concat(index),key:index}));}else{return null;}})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{id:"casino3",className:visiable?'show':'hide'},prizes&&prizes.length>0&&prizes.map(function(item,index){if(item.img){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"prize-item-wrap",key:index},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:item.img,alt:"",className:"slot slot".concat(index),key:index}));}else{return null;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:is_can_enter?lotteryBtnImage||"https://static.shihuocdn.cn/admin/files/20240411/a6258e964f00118b57a65fbb779a9aae.png":is_has_enter?lotteryHasJoinBtnImage||"https://static.shihuocdn.cn/admin/files/20240411/1375350d353bab59e675db435fa6f368.png":lotteryBtnImage||"https://static.shihuocdn.cn/admin/files/20240411/a6258e964f00118b57a65fbb779a9aae.png",alt:"",className:"lucky-btn",onClick:function onClick(){if(acticityScene!=='社区投票'){_this4.handleLottery();}else{_this4.handleCommunityLottery();}}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:lotteryCoverImage||'https://static.shihuocdn.cn/admin/files/20240411/991ffb314f8cad83615ecda2f883780a.png',alt:"",className:"games-cover"})),is_lottery&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("p",{className:"result"},is_receive?"\u606D\u559C\u83B7\u5F97\u3010".concat(receive_prizes.name,"\u3011").concat(award_text?'，'+award_text:''):'很遗憾未中奖'),winningPopup&&this.renderWinningPopup());}}]);return PipelineSchoolLottery;}(__WEBPACK_IMPORTED_MODULE_16_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineSchoolLottery);

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineCommunityVote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */var praised_icon='https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png';//选中后
var un_praised_icon='https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png';//未点赞
var praised_animated='https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga';//点赞动效
var cancel_praised_animated='https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga';//取消点赞
var PipelineCommunityVote=/*#__PURE__*/function(_React$Component){_inherits(PipelineCommunityVote,_React$Component);var _super=_createSuper(PipelineCommunityVote);function PipelineCommunityVote(props){var _this;_classCallCheck(this,PipelineCommunityVote);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"peloadingSvg",function(url){//预加载图片资源
if(_this.praiseHiddenRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){var player=new SVGA.Player(_this.praiseHiddenRef);var parser=new SVGA.Parser(_this.praiseHiddenRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(url,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){player.stopAnimation(true);if(url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')){_this.peloadingSvg(cancel_praised_animated);}});});});}});_defineProperty(_assertThisInitialized(_this),"handleVoteClick",/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(uid){var is_login;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this.lock){_context.next=2;break;}return _context.abrupt("return");case 2:_this.lock=true;is_login=_this.state.is_login;if(is_login){_context.next=8;break;}// 未登录
_this.lock=false;window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});return _context.abrupt("return");case 8:__WEBPACK_IMPORTED_MODULE_24_axios___default()({url:"https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comm/vote",method:"post",withCredentials:true,data:{special_id:_this.pageId,option_id:uid}}).then(function(res){var _res$data=res.data,status=_res$data.status,msg=_res$data.msg;if(status===0){// 投票成功后刷新列表数据及投票资格
_this.props.updateCommunityVoteState(true);_this.props.updateLotteryState(true);}else{window.Jockey.send('toast',{text:msg});}_this.lock=false;})["catch"](function(err){_this.lock=false;});case 9:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"showPraiseSvga",function(svgaUrl,id){var praiseRef=_this.praiseRefMap[id];var praiseIconRef=_this.praiseImgRefMap[id];if(praiseRef){__webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 78)).then(function(SVGA){praiseRef.style.display="flex";praiseIconRef.style.display="none";var player=new SVGA.Player(praiseRef);var parser=new SVGA.Parser(praiseRef);// 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
parser.load(svgaUrl,function(videoItem){player.loops=1;player.setVideoItem(videoItem);player.startAnimation();player.onFinished(function(){praiseRef.style.display="none";praiseIconRef.style.display="flex";player.stopAnimation(true);});});});}});_defineProperty(_assertThisInitialized(_this),"handJumpHomeInfo",function(href){__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,href,href,{},-1,_this.props);});_defineProperty(_assertThisInitialized(_this),"formatPraiseNum",function(praise){if(typeof praise==='number'&&praise>9999){praise=parseFloat((praise/10000).toFixed(1))+'w';}return praise;});_defineProperty(_assertThisInitialized(_this),"getVoteToastText",function(){var voteConfig=_this.props.config.voteConfig;if(voteConfig.endTime){var endTime=new Date(voteConfig.endTime);// 获取当前时间（本地时间）
var now=new Date();// 将截止时间转换为本地时间  
var deadlineLocalYear=endTime.getFullYear();var deadlineLocalMonth=endTime.getMonth()+1;var deadlineLocalDate=endTime.getDate();// 获取当前日期的年份、月份和日期  
var currentYear=now.getFullYear();var currentMonth=now.getMonth()+1;var currentDate=now.getDate();var toast='';// 判断当前日期是否在截止日期之前  
if(currentYear<deadlineLocalYear||currentYear===deadlineLocalYear&&currentMonth<deadlineLocalMonth||currentYear===deadlineLocalYear&&currentMonth===deadlineLocalMonth&&currentDate<deadlineLocalDate){// 按日且今日不是活动周期的最后一天：“今日票数已用尽，明天再来吧～”
toast='今日票数已用尽，明天再来吧～';}else{// 按活动总周期投票/按日且今日为活动周期的最后一天：“投票次数已用尽，下次再来吧～”
toast='投票次数已用尽，下次再来吧～';}window.Jockey.send('toast',{text:toast});}});_defineProperty(_assertThisInitialized(_this),"shuffleArray",function(array){if(array.length<=0){return array;}// 创建数组的副本，以避免修改原数组
var shuffledArray=array.slice();for(var i=shuffledArray.length-1;i>0;i--){// 生成 [0, i] 之间的随机索引  
var j=Math.floor(Math.random()*(i+1));// 交换元素  
var _ref2=[shuffledArray[j],shuffledArray[i]];shuffledArray[i]=_ref2[0];shuffledArray[j]=_ref2[1];}return shuffledArray;});_this.state={list:[],status:0,is_vote:0,is_login:false,showAnimated:false};_this.praiseTimer=null;_this.isAndroid=__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].isAndroid();_this.pageId=__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getPageId();_this.isIphone14ProMax=__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].isIphone14ProMax();_this.praiseRefMap={};_this.praiseImgRefMap={};_this.init=false;_this.lock=false;_this.delayTimeout=null;return _this;}_createClass(PipelineCommunityVote,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.getCardListData();this.peloadingSvg(praised_animated);document.addEventListener("visibilitychange",function(){if(document.hidden){return;}else{// 刷新秒杀状态
if(_this2.delayTimeout){clearTimeout(_this2.delayTimeout);_this2.delayTimeout=null;}_this2.delayTimeout=setTimeout(function(){_this2.getCardListData();},500);return;}},false);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.communityVoteState){this.props.updateCommunityVoteState(false);this.getCardListData();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.praiseTimer){clearTimeout(this.praiseTimer);this.praiseTimer=null;}}},{key:"getCardListData",value:function getCardListData(){var _this3=this;var defaultList=this.state.list;var itemList=this.props.config.itemList;var option_ids=itemList.map(function(item){return item.uid;});__WEBPACK_IMPORTED_MODULE_24_axios___default()({url:"https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comm/vote/info",method:"post",withCredentials:true,data:{special_id:this.pageId,option_ids:option_ids}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){var list=data.option_list||[];list=itemList.map(function(item){var target=list.find(function(value){return value.uid==item.uid;});return target;}).filter(function(item){return Boolean(item);});if(data.status===2){list=list.sort(function(a,b){return a.rank-b.rank;});};if(!_this3.init){if(data.status!==2){_this3.init=true;list=_this3.shuffleArray(list);}}else{list=defaultList.map(function(item){var target=list.find(function(value){return value.uid===item.uid;});if(target){item=target;}return item;});}_this3.setState({is_vote:data.is_vote,status:data.status,is_login:Boolean(data.uid),list:list},function(){window.isLogin=Boolean(data.uid);});}});}// 投票
},{key:"handlePraiseClick",value:function handlePraiseClick(event,id,channel_type,status,value,key,item,index){var _this4=this;var list=this.state.list;event.stopPropagation();var reqUrl="https://sh-gateway.shihuo.cn/v3/apps/app_swoole_common/praise";__WEBPACK_IMPORTED_MODULE_24_axios___default()({url:reqUrl,method:"get",withCredentials:true,params:{id:id,channel_type:channel_type,status:status}}).then(function(res){var _res$data3=res.data,data=_res$data3===void 0?{}:_res$data3;if(data.status==0){if(value.is_like===1){value.is_like=0;value.like_num=Number(value.like_num)-1;value.like_num_text=_this4.formatPraiseNum(value.like_num);list[index].note_list[key]=value;_this4.setState({list:list});_this4.showPraiseSvga(cancel_praised_animated,id);}else{value.is_like=1;value.like_num=Number(value.like_num)+1;value.like_num_text=_this4.formatPraiseNum(value.like_num);list[index].note_list[key]=value;_this4.setState({list:list});_this4.showPraiseSvga(praised_animated,id);}}else if(data.status==3){window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:this.props,index:index});return;}var baseConfig=this.props.config.baseConfig;var options={title:baseConfig.title,sort:index};__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,item.href,item.href,options,item.id,this.props);}},{key:"renderVoteState",value:function renderVoteState(item){var _this5=this;var voteConfig=this.props.config.voteConfig;var _this$state=this.state,status=_this$state.status,is_vote=_this$state.is_vote;if(status!==2){// 活动未开始或进行中
if(item.status===0){// 当日未投票
if(is_vote!==1){// 本天/本周期 未投票
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-area type-1"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-btn",style:{backgroundColor:voteConfig.btnBgColor,color:voteConfig.btnTextColor},onClick:function onClick(){return _this5.handleVoteClick(item.uid);}},"\u6295\u7968"));}else{// 本天/本周期 已投票
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-area type-2"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"vote-num"},item.vote_num,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",null,"\u7968")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-btn",style:{backgroundColor:voteConfig.btnBgColor,color:voteConfig.btnTextColor},onClick:function onClick(){return _this5.handleVoteClick(item.uid);}},"\u6295\u7968"));}}else if(item.status===1){// 已投票
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-area type-3"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"vote-num"},item.vote_num,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",null,"\u7968")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"has-voted"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20241216/e5d45fe8642241ab180392cf15b541d0.png",alt:"",className:"icon"}),"\u5DF2\u6295\u7968"));}else if(item.status===2){// 无余票（当天已投完）
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-area type-4"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"vote-num"},item.vote_num,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("span",null,"\u7968")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-btn disabled",onClick:function onClick(){return _this5.getVoteToastText();}},"\u6295\u7968"));}else if(item.status===3){// 活动已结束
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-area type-5"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"ranking"},"\u7B2C",item.rank,"\u540D"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"vote-num"},item.vote_num,"\u7968"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"status"},"\u6D3B\u52A8\u5DF2\u7ED3\u675F"));}else{return null;}}else{// 活动已结束
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"vote-area type-5"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"ranking"},"\u7B2C",item.rank,"\u540D"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"vote-num"},item.vote_num,"\u7968"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"status"},"\u6D3B\u52A8\u5DF2\u7ED3\u675F"));}}},{key:"render",value:function render(){var _this6=this;var _this$props$config=this.props.config,baseConfig=_this$props$config.baseConfig,voteConfig=_this$props$config.voteConfig;var _this$state2=this.state,status=_this$state2.status,is_vote=_this$state2.is_vote,_this$state2$list=_this$state2.list,list=_this$state2$list===void 0?[]:_this$state2$list;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",_extends({ref:function ref(ele){if(ele){_this6.props.exp&&_this6.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].getExposureData(this.props)),className:"pipeline-communityVote",id:this.props['customAttributes']['data-component-id'],name:baseConfig.title},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),list.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"user-note",key:"item-".concat(index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"head-vote ".concat(_this6.isAndroid?'android':'ios')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"user-info",onClick:function onClick(){return _this6.handJumpHomeInfo(item.href);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{src:item.avatar,alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"user-name"},item.username),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"signature"},item.sign))),_this6.renderVoteState(item),status!==2&&is_vote===1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"rank"},"\u5F53\u524D\u7B2C",item.rank,"\u540D")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"scroll-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("ul",null,item.note_list&&item.note_list.length>0&&item.note_list.map(function(value,key){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("li",{key:"user-".concat(index,"-note-").concat(key),onClick:function onClick(){return _this6.handleItemClick(value,key);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"note-img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_lazy_load_image_component__["LazyLoadImage"],{effect:"opacity",src:__WEBPACK_IMPORTED_MODULE_25__utils_utils__["a" /* default */].formatImgUrl(value.pic,_this6.props.webpSupport,'card'),alt:"",className:"note-img"}),value.is_video===1&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20240506/37c435801c77b97c25a32861a0e26148.png",alt:"",className:"video-logo"})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"note-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:"note-title"},value.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"note-author"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"user-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{src:value.avatar,alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:_this6.isAndroid?'username android':'username ios'},value.username)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"praise-info",onClick:function onClick(event){return _this6.handlePraiseClick(event,value.id,4,value.is_like===0?1:2,value,key,item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"praise-icon-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("img",{className:"praise-icon",src:value.is_like===1?praised_icon:un_praised_icon,alt:"",id:"praise-icon-".concat(value.id),ref:function ref(r){_this6.praiseImgRefMap[value.id]=r;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{className:"praise-icon-svga"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:{width:'100%',height:'100%',alignItems:'center',justifyContent:'center'},id:"praise-icon-svga-".concat(value.id),ref:function ref(r){_this6.praiseRefMap[value.id]=r;}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("p",{className:_this6.isAndroid?'praise-num android':'praise-num ios'},_this6.formatPraiseNum(value.like_num))))));}))));}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_21_react___default.a.createElement("div",{style:{width:0,height:0,overflow:'hidden',position:'absolute',left:0,top:0},ref:function ref(_ref3){return _this6.praiseHiddenRef=_ref3;}}));}// 获取投票toast文案
// 数组随机打散
// shuffleArray = (array, is_vote) => {
//   if (array.length <= 0) {
//     return array;
//   }
//   let hasVoteArr = [], notVoteArr = []; // 定义未投票和已投票的数据
//   if (is_vote === 1) {
//     // 已投票状态下，先把投过票的达人按照顺序提取出来放在最前面，剩余未给予投票的达人随机打散放在后面
//     for (const item of array) {
//       if (item.status === 0) {
//         // 未投票
//         notVoteArr.push(item);
//       } else {
//         hasVoteArr.push(item);
//       }
//     }
//   } else {
//     notVoteArr = array;
//   }
//   // 创建数组的副本，以避免修改原数组
//   let shuffledArray = notVoteArr.slice();
//   for (let i = shuffledArray.length - 1; i > 0; i--) {  
//     // 生成 [0, i] 之间的随机索引  
//     const j = Math.floor(Math.random() * (i + 1));
//     // 交换元素  
//     [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
//   }
//   const resultArr = [...hasVoteArr, ...shuffledArray];
//   return resultArr;  
// } 
}]);return PipelineCommunityVote;}(__WEBPACK_IMPORTED_MODULE_21_react___default.a.Component);PipelineCommunityVote.propTypes={config:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineCommunityVote);

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineProductLayout3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_index_of_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_index_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_index_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_H5PreApiFetch__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__style_less__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var placeholder='https://static.shihuocdn.cn/admin/files/20210406/8d9ebe0ba03eeade62495c93303d6de2.png';var PipelineProductLayout3=/*#__PURE__*/function(_React$Component){_inherits(PipelineProductLayout3,_React$Component);var _super=_createSuper(PipelineProductLayout3);function PipelineProductLayout3(props){var _this;_classCallCheck(this,PipelineProductLayout3);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getH5PreApiRequestData",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$props$config,cardBaseConfig,goodsDataConfig,list,_this$getIdsReqConf,url,params,data,showNum,result,topGoodsIdx,topGoods,showAll;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props$config=_this.props.config,cardBaseConfig=_this$props$config.cardBaseConfig,goodsDataConfig=_this$props$config.goodsDataConfig;list=_this.state.list;_this$getIdsReqConf=_this.getIdsReqConf(list,goodsDataConfig),url=_this$getIdsReqConf.url,params=_this$getIdsReqConf.params;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_34__utils_H5PreApiFetch__["a" /* default */])({url:url,method:'post',params:params,isH5PreApi:true});case 5:data=_context.sent;showNum=cardBaseConfig.displayLineNum==='1行'?3:6;result=data.List||[];if(_this.pageId=='17701912601330096'&&_this.props['customAttributes']['data-component-id']=='pipeline-productLayout3-1770192375034'&&_this.top_id){// 2026情人节会场指定页面，指定组件ID，顶部商品置顶（基于配色ID）
topGoodsIdx=result.findIndex(function(item){return item.id==_this.top_id;});if(topGoodsIdx>=0){topGoods=result[topGoodsIdx];result.splice(topGoodsIdx,1);result.unshift(topGoods);}}showAll=result.length<=showNum?true:false;_this.setState({list:result,showAll:showAll},function(){if(_this.compRef){_this.compOffsetTop=_this.compRef.offsetTop;}if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)&&cardBaseConfig.isAutoCarousel==='是'){_this.onScrollLayoutRow();}});case 11:case"end":return _context.stop();}}},_callee);})));_defineProperty(_assertThisInitialized(_this),"getItemListData",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this$props$config2,cardBaseConfig,goodsDataConfig,itemCollectList,showNum,list,productType,result,showAll,collectIds;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this$props$config2=_this.props.config,cardBaseConfig=_this$props$config2.cardBaseConfig,goodsDataConfig=_this$props$config2.goodsDataConfig,itemCollectList=_this$props$config2.itemCollectList;showNum=cardBaseConfig.displayLineNum==='1行'?3:6;list=_this.state.list;productType=goodsDataConfig.productType;result=[],showAll=true;if(!['商品id','配色id','skuId'].includes(productType)){_context2.next=11;break;}_context2.next=8;return _this.getListData(list,goodsDataConfig);case 8:result=_context2.sent;_context2.next=17;break;case 11:_context2.next=13;return _this.getCollectIds(itemCollectList,goodsDataConfig);case 13:collectIds=_context2.sent;_context2.next=16;return _this.getCollectListData(collectIds,goodsDataConfig);case 16:result=_context2.sent;case 17:showAll=result.length<=showNum?true:false;_this.setState({list:result,showAll:showAll},function(){if(_this.compRef){_this.compOffsetTop=_this.compRef.offsetTop;}if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)&&cardBaseConfig.isAutoCarousel==='是'){_this.onScrollLayoutRow();}});case 19:case"end":return _context2.stop();}}},_callee2);})));_defineProperty(_assertThisInitialized(_this),"getTabListData",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){var cardBaseConfig,showNum,tabList,result,showAll,_loop,index;return regeneratorRuntime.wrap(function _callee5$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:cardBaseConfig=_this.props.config.cardBaseConfig;showNum=cardBaseConfig.displayLineNum==='1行'?3:6;tabList=_this.state.tabList;result=[],showAll=true;_loop=/*#__PURE__*/regeneratorRuntime.mark(function _loop(index){var getDataFunc,delayTimeout;return regeneratorRuntime.wrap(function _loop$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:getDataFunc=/*#__PURE__*/function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(delayTimeout){var productType,collectIds;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:productType=tabList[index].goodsDataConfig.productType;if(!['商品id','配色id','skuId'].includes(productType)){_context3.next=7;break;}_context3.next=4;return _this.getListData(tabList[index].itemList,tabList[index].goodsDataConfig);case 4:result=_context3.sent;_context3.next=13;break;case 7:_context3.next=9;return _this.getCollectIds(tabList[index].itemCollectList,tabList[index].goodsDataConfig);case 9:collectIds=_context3.sent;_context3.next=12;return _this.getCollectListData(collectIds,tabList[index].goodsDataConfig);case 12:result=_context3.sent;case 13:showAll=result.length<=showNum?true:false;tabList[index]['itemList']=result;tabList[index]['showAll']=showAll;tabList[index]['showNum']=showNum;_this.setState({tabList:tabList},function(){if(delayTimeout){clearTimeout(delayTimeout);}});case 18:case"end":return _context3.stop();}}},_callee3);}));return function getDataFunc(_x){return _ref4.apply(this,arguments);};}();if(!(index===0)){_context5.next=8;break;}_context5.next=4;return getDataFunc();case 4:if(_this.compRef){_this.compOffsetTop=_this.compRef.offsetTop;}if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)&&cardBaseConfig.isAutoCarousel==='是'){_this.onScrollLayoutRow();}_context5.next=9;break;case 8:delayTimeout=setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:getDataFunc(delayTimeout);case 1:case"end":return _context4.stop();}}},_callee4);})),2000);case 9:case"end":return _context5.stop();}}},_loop);});index=0;case 6:if(!(index<tabList.length)){_context6.next=11;break;}return _context6.delegateYield(_loop(index),"t0",8);case 8:index++;_context6.next=6;break;case 11:case"end":return _context6.stop();}}},_callee5);})));_defineProperty(_assertThisInitialized(_this),"getIdsReqConf",function(){var initList=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var goodsDataConfig=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var productType=goodsDataConfig.productType,sortType=goodsDataConfig.sortType,dateRange=goodsDataConfig.dateRange,shihuoSubsidy=goodsDataConfig.shihuoSubsidy;var reqUrl='';switch(productType){case'商品id':reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur';break;case'配色id':reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur';break;case'skuId':reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/sku/info?access_token=znSnA7pxO35wtPBaur';break;case'商品集合id':reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur';break;case'配色集合id':reqUrl='https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur';break;default:break;}var sort_tag=0;if(sortType==='销量'){if(!dateRange||dateRange==='默认'){sort_tag=4;}else{sort_tag=_this.saleTypeMap[dateRange];}}else{sort_tag=_this.sortTypeMap[sortType];}var filter_subsidy=shihuoSubsidy==='是'?1:0;var from=_this.props.specialApiFrom||'';var itemList=JSON.parse(JSON.stringify(initList));var ids=itemList.map(function(item){if(typeof item==='number'){return Number(item)||0;}else{return Number(item.id)||0;}});var config={url:reqUrl,params:{filter_subsidy:filter_subsidy,sort_tag:sort_tag,from:from,ids:ids},itemList:itemList};return config;});_defineProperty(_assertThisInitialized(_this),"getListData",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(){var initList,goodsDataConfig,cardBaseConfig,productType,sortType,dateRange,_this$getIdsReqConf2,url,params,itemList,result,_result$data,status,data,list,_args7=arguments;return regeneratorRuntime.wrap(function _callee6$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:initList=_args7.length>0&&_args7[0]!==undefined?_args7[0]:[];goodsDataConfig=_args7.length>1&&_args7[1]!==undefined?_args7[1]:{};cardBaseConfig=_this.props.config.cardBaseConfig;productType=goodsDataConfig.productType,sortType=goodsDataConfig.sortType,dateRange=goodsDataConfig.dateRange;_this$getIdsReqConf2=_this.getIdsReqConf(initList,goodsDataConfig),url=_this$getIdsReqConf2.url,params=_this$getIdsReqConf2.params,itemList=_this$getIdsReqConf2.itemList;_context7.next=7;return Object(__WEBPACK_IMPORTED_MODULE_30__utils_request__["a" /* default */])({url:url,method:"post",withCredentials:true,data:params});case 7:result=_context7.sent;_result$data=result.data,status=_result$data.status,data=_result$data.data;if(!(status===0)){_context7.next=12;break;}list=_this.handleListData({data:data,itemList:itemList,cardBaseConfig:cardBaseConfig,productType:productType,sortType:sortType,dateRange:dateRange});return _context7.abrupt("return",list);case 12:case"end":return _context7.stop();}}},_callee6);})));_defineProperty(_assertThisInitialized(_this),"handleListData",function(){var _ref7=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},data=_ref7.data,itemList=_ref7.itemList,cardBaseConfig=_ref7.cardBaseConfig,productType=_ref7.productType,sortType=_ref7.sortType,dateRange=_ref7.dateRange;var list=data.List||[];var notFoundList=data.NotFound||[];if(sortType==='自定义排序'){itemList.forEach(function(product){var customItem=list.find(function(item){return item.id==product.id;});if(sortType==='销量'){switch(dateRange){case'近1天':customItem.sell_point=customItem.realSaleNum;customItem.sell_point_str=String(customItem.realSaleNum);break;case'近7天':customItem.sell_point=customItem.realSaleNum7;customItem.sell_point_str=String(customItem.realSaleNum7);break;case'近14天':customItem.sell_point=customItem.realSaleNum14;customItem.sell_point_str=String(customItem.realSaleNum14);break;case'近30天':customItem.sell_point=customItem.realSaleNum30;customItem.sell_point_str=String(customItem.realSaleNum30);break;default:break;}}if(customItem&&customItem.id!='0'){var optionsAssign={image:productType!=='商品id'?product.image&&product.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2')<0?product.image:customItem.image:customItem.image,price:productType!=='商品id'?product.price||customItem.price:customItem.price,title:product.useCustomName?product.name||customItem.title:customItem.title,cornerMark:product.cornerMark||cardBaseConfig.cornerMark,url:product.url||customItem.url};Object.assign(product,_objectSpread(_objectSpread({},customItem),optionsAssign));}});if(notFoundList.length>0){// 删除 notFoundList 中存在的商品
itemList=itemList.filter(function(item){var notFound=notFoundList.find(function(val){return val==item.id;});return notFound?false:true;});}return itemList;}else{list.forEach(function(product){if(sortType==='销量'){switch(dateRange){case'近1天':product.sell_point=product.realSaleNum;product.sell_point_str=String(product.realSaleNum);break;case'近7天':product.sell_point=product.realSaleNum7;product.sell_point_str=String(product.realSaleNum7);break;case'近14天':product.sell_point=product.realSaleNum14;product.sell_point_str=String(product.realSaleNum14);break;case'近30天':product.sell_point=product.realSaleNum30;product.sell_point_str=String(product.realSaleNum30);break;default:break;}}var customItem=itemList.find(function(item){return item.id==product.id;});if(customItem&&customItem.id!='0'){product.useCustomName=customItem.useCustomName;product.cornerMark=customItem.cornerMark||cardBaseConfig.cornerMark;product.title=customItem.useCustomName?customItem.name:product.title;// 商品维度，商品图片、价格、跳转地址均要实时获取
if(productType!=='商品id'){product.url=customItem.url||product.url;product.price=customItem.price||product.price;product.image=(customItem.image&&customItem.image.indexOf('8d9ebe0ba03eeade62495c93303d6de2')<0?customItem.image:product.image)||product.image;}}});if(_this.pageId=='17701912601330096'&&_this.props['customAttributes']['data-component-id']=='pipeline-productLayout3-1770192375034'&&_this.top_id){// 2026情人节会场指定页面，指定组件ID，顶部商品置顶（基于配色ID）
var topGoodsIdx=list.findIndex(function(item){return item.id==_this.top_id;});if(topGoodsIdx>=0){var topGoods=list[topGoodsIdx];list.splice(topGoodsIdx,1);list.unshift(topGoods);}}return list;}});_defineProperty(_assertThisInitialized(_this),"getCollectIds",/*#__PURE__*/function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(itemCollectList,goodsDataConfig){var productType,idList,result,_result$data2,status,data,collectList,collectIds;return regeneratorRuntime.wrap(function _callee7$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:productType=goodsDataConfig.productType;idList=[];itemCollectList.forEach(function(item){if(item.id){idList.push({id:Number(item.id),limit:isNaN(item.limit)?20:Number(item.limit),source:productType==='商品集合id'?1:2});}});_context8.next=5;return Object(__WEBPACK_IMPORTED_MODULE_30__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-goodssetapi/set/lego?token=7a08a813-faf1-03e5-d547-cf6bdd1c9ddb&client_name=theme',method:"post",withCredentials:true,data:{idList:idList}});case 5:result=_context8.sent;_result$data2=result.data,status=_result$data2.status,data=_result$data2.data;if(!(status===0)){_context8.next=14;break;}collectList=data||[];collectIds=[];collectList.forEach(function(item){var list=item.list||[];list.forEach(function(value){var id=productType==='商品集合id'?value.goods_id:value.style_id;if(!collectIds.includes(id)){collectIds.push(id);}});});return _context8.abrupt("return",collectIds);case 14:return _context8.abrupt("return",[]);case 15:case"end":return _context8.stop();}}},_callee7);}));return function(_x2,_x3){return _ref8.apply(this,arguments);};}());_defineProperty(_assertThisInitialized(_this),"getCollectListData",/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(){var collectIds,goodsDataConfig,_this$getIdsReqConf3,url,params,result,_result$data3,status,data,list,_args9=arguments;return regeneratorRuntime.wrap(function _callee8$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:collectIds=_args9.length>0&&_args9[0]!==undefined?_args9[0]:[];goodsDataConfig=_args9.length>1?_args9[1]:undefined;_this$getIdsReqConf3=_this.getIdsReqConf(collectIds,goodsDataConfig),url=_this$getIdsReqConf3.url,params=_this$getIdsReqConf3.params;_context9.next=5;return Object(__WEBPACK_IMPORTED_MODULE_30__utils_request__["a" /* default */])({url:url,method:"post",withCredentials:true,data:params});case 5:result=_context9.sent;_result$data3=result.data,status=_result$data3.status,data=_result$data3.data;if(!(status===0)){_context9.next=13;break;}list=data.List;if(_this.props.config.cardBaseConfig.cornerMark){list=list.map(function(item){item['cornerMark']=_this.props.config.cardBaseConfig.cornerMark;return item;});}return _context9.abrupt("return",list);case 13:return _context9.abrupt("return",[]);case 14:case"end":return _context9.stop();}}},_callee8);})));_defineProperty(_assertThisInitialized(_this),"onScroll",function(event){var element=_this.goodsBodyRef;if(event.target===document&&element){var _this$isElementInView=_this.isElementInViewport(element),verticalVisible=_this$isElementInView.verticalVisible,visibilityRatio=_this$isElementInView.visibilityRatio;if(verticalVisible&&visibilityRatio>=0.5){// 进去可视区，切露出超过一半时，开始自动轮播
_this.inViewArea=true;_this.startScrolling();}else{// 停止轮播
_this.inViewArea=false;_this.stopScrolling();}}});_defineProperty(_assertThisInitialized(_this),"getScrollPosition",function(){if(!_this.isScrollEnd){var elementRect=_this.goodsScrollRef.getBoundingClientRect();var viewportWidth=window.innerWidth||document.documentElement.clientWidth;var rightEdgeVisible=elementRect.right<=viewportWidth-16;if(rightEdgeVisible){_this.isScrollEnd=true;}else{var offset=window.innerWidth-_this.goodsBodyRef.clientWidth;var progressWidth=_this.carouselBgRef.clientWidth-_this.progressRef.clientWidth;var progressLeft=(_this.goodsScrollRef.clientWidth-(elementRect.right-offset/2))/(_this.goodsScrollRef.clientWidth-viewportWidth+offset)*progressWidth;_this.progressRef.style.left=progressLeft+'px';}return _this.isScrollEnd;}else{return true;}});_defineProperty(_assertThisInitialized(_this),"requestAnimationFrameScroll",function(){var isScrollEnd=_this.getScrollPosition();// 处理实时滚动位置的逻辑
if(!isScrollEnd){_this.scrollAnimation=requestAnimationFrame(_this.requestAnimationFrameScroll);}else{// 滚动到底了
cancelAnimationFrame(_this.scrollAnimation);var offset=window.innerWidth-_this.goodsBodyRef.clientWidth;_this.scrollAnimation=null;_this.goodsScrollRef.style.animationPlayState='paused';_this.goodsBodyRef.scrollTo({top:0,left:_this.goodsScrollRef.clientWidth-window.screen.width+offset});_this.goodsScrollRef.style.animation='none';}});_defineProperty(_assertThisInitialized(_this),"getAnimationDuration",function(){var duration=_this.goodsScrollRef.clientWidth/(1316/40);return parseInt(duration);});_defineProperty(_assertThisInitialized(_this),"onScrollLayoutRow",function(){if(_this.props.config.cardBaseConfig.isAutoCarousel==='否'){return;}if(_this.initLayoutRowScroll){return;}_this.initLayoutRowScroll=true;var goodsBody=_this.goodsBodyRef;var progressBg=_this.carouselBgRef;var progress=_this.progressRef;if(goodsBody&&progressBg&&progress){var goodsScrollWidth=goodsBody.scrollWidth-goodsBody.clientWidth;var progressWidth=progressBg.clientWidth-progress.clientWidth;goodsBody.addEventListener('scroll',function(){if(goodsBody.scrollLeft>=goodsScrollWidth){_this.isScrollEnd=true;}var progressLeft=goodsBody.scrollLeft/goodsScrollWidth*progressWidth;progress.style.left=progressLeft+'px';});}_this.handleScrollEvent();});_defineProperty(_assertThisInitialized(_this),"handleScrollEvent",function(){if(!_this.goodsScrollRef){return;}_this.goodsScrollRef.addEventListener('touchstart',function(){if(_this.goodsScrollRef.style.animationPlayState=='paused'||!_this.inViewArea){return;}_this.goodsScrollRef.style.animationPlayState='paused';_this.setGoodsBodyScrollLeft();_this.goodsScrollRef.style.animation='none';});_this.goodsScrollRef.addEventListener('touchend',function(){if(!_this.inViewArea){return;}if(_this.delayTimeout){clearTimeout(_this.delayTimeout);_this.delayTimeout=null;}_this.delayTimeout=setTimeout(function(){if(!_this.isScrollEnd){var animationDuration=_this.getAnimationDuration();var animation="scrollAnimation ".concat(animationDuration,"s linear 0s forwards");_this.goodsScrollRef.style.animation=animation;}},1500);});});_defineProperty(_assertThisInitialized(_this),"setGoodsBodyScrollLeft",function(){var transformStyle=window.getComputedStyle(_this.goodsScrollRef).getPropertyValue('transform');var matrix=new window.WebKitCSSMatrix(transformStyle);var pausePosition=matrix.m41;var goodsScrollLeft=_this.goodsBodyRef.scrollLeft;if(pausePosition!=0){_this.goodsBodyRef.scrollTo({top:0,left:-pausePosition+goodsScrollLeft});}});_defineProperty(_assertThisInitialized(_this),"startScrolling",function(){if(_this.scrollState==='paused'){_this.scrollState='running';if(!_this.isScrollEnd){var animationDuration=_this.getAnimationDuration();var animation="scrollAnimation ".concat(animationDuration,"s linear 1s forwards");_this.goodsScrollRef.style.animation=animation;_this.scrollAnimation=requestAnimationFrame(_this.requestAnimationFrameScroll);}}});_defineProperty(_assertThisInitialized(_this),"stopScrolling",function(){_this.scrollState='paused';cancelAnimationFrame(_this.scrollAnimation);_this.scrollAnimation=null;_this.goodsScrollRef.style.animationPlayState='paused';if(_this.isScrollEnd){// 滚动到底部时，移除css animaton
_this.goodsBodyRef.scrollTo({top:0,left:_this.goodsScrollRef.clientWidth-window.screen.width});_this.goodsScrollRef.style.animation='none';}else{_this.setGoodsBodyScrollLeft();_this.goodsScrollRef.style.animation='none';}});_defineProperty(_assertThisInitialized(_this),"onTitleClick",function(href){if(href){__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,href,href,{},-1,_this.props,false);}});_defineProperty(_assertThisInitialized(_this),"onTabClick",function(index){var tabText=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].uploadTrack(_this.props,{sort:index},{ptiId:"".concat(_this.props.templatePti,":pipeline-productLayout3-tab:").concat(index),bizExtra:{model_block:'tab',tabChName:tabText||''}});var cardBaseConfig=_this.props.config.cardBaseConfig;if(_this.tabFixed&&_this.compOffsetTop>0&&_this.tabRef){window.scrollTo(0,_this.compOffsetTop+_this.tabRef.clientHeight+1);}if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)&&cardBaseConfig.isAutoCarousel==='是'){_this.stopScrolling();_this.goodsBodyRef.scrollTo({top:0,left:0});}_this.setState({currentIdx:index},function(){_this.updateTabPosition();});});_defineProperty(_assertThisInitialized(_this),"onSwitchClick",function(){__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{ptiId:"".concat(_this.props.templatePti,":pipeline-productLayout3-switch"),bizExtra:{model_block:'switch'}});var _this$state=_this.state,tabList=_this$state.tabList,currentIdx=_this$state.currentIdx;if(currentIdx+1<tabList.length){currentIdx=currentIdx+1;}else{currentIdx=0;}_this.setState({currentIdx:currentIdx});});_defineProperty(_assertThisInitialized(_this),"updateTabPosition",function(){var offsetWidth=_this.tabRef.offsetWidth;var activeTab=_this.tabRef.querySelector('.active');if(activeTab){var tabItemOffsetLeft=activeTab.offsetLeft;// 元素距离左边距离
var checkedItemWidth=activeTab.offsetWidth;var move=tabItemOffsetLeft-(offsetWidth/2-checkedItemWidth/2);if(_this.tabRef.scrollWidth>offsetWidth){_this.tabRef.scroll({top:0,left:move,behavior:'smooth'});}}});_defineProperty(_assertThisInitialized(_this),"onExpandMore",function(){var tabConfig=_this.props.config.tabConfig;var _this$state2=_this.state,list=_this$state2.list,tabList=_this$state2.tabList,currentIdx=_this$state2.currentIdx,showAll=_this$state2.showAll,showNum=_this$state2.showNum;if(tabConfig.tabType==='无Tab'){__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{ptiId:"".concat(_this.props.templatePti,":pipeline-productLayout3-more"),bizExtra:{model_block:'more',tabChName:''}});if(showNum<list.length){if(showNum+6<list.length){showAll=false;showNum=showNum+6;}else{showAll=true;showNum=list.length;}}else{showAll=true;showNum=list.length;}_this.setState({showAll:showAll,showNum:showNum});}else{__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].uploadTrack(_this.props,{},{ptiId:"".concat(_this.props.templatePti,":pipeline-productLayout3-tab_").concat(currentIdx,"-more"),bizExtra:{model_block:'more',tabChName:tabList&&tabList[currentIdx]?tabList[currentIdx].tabText||'':''}});var _showNum2=tabList[currentIdx].showNum;if(_showNum2<tabList[currentIdx].itemList.length){if(_showNum2+6<tabList[currentIdx].itemList.length){tabList[currentIdx]['showNum']=_showNum2+6;tabList[currentIdx]['showAll']=false;}else{tabList[currentIdx]['showNum']=tabList[currentIdx].itemList.length;tabList[currentIdx]['showAll']=true;}}_this.setState({tabList:tabList});}});_defineProperty(_assertThisInitialized(_this),"renderHorizontalList",function(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var cardBaseConfig=_this.props.config.cardBaseConfig;var renderList=function renderList(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var midIdx=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"scroll-list"},list&&list.length>0&&list.map(function(item,index){var others='';switch(cardBaseConfig.displayPriceInfo){case'原价':if(item.original_price>0){others="\xA5".concat(item.original_price);}break;case'折扣':// 折扣计算
if(item.original_price>0&&item.price<item.original_price){var rate=item.price/item.original_price;rate=parseFloat((rate*10).toFixed(1));others="".concat(rate,"\u6298");}break;case'直降':var reduce=0;if(item.original_price&&item.original_price>item.price){reduce=Math.floor(item.original_price-item.price);}if(reduce>0){others="\u76F4\u964D".concat(reduce);}break;case'销量':others="\u5DF2\u552E".concat(item.sell_point_str);break;default:break;}if(!others&&item.price){others='爆款好价';}var price=item.price;if(price>9999){price="".concat(parseFloat((price/10000).toFixed(1)),"w");}var _this$getTrackData=_this.getTrackData(item,midIdx+index),options=_this$getTrackData.options,ptiOptions=_this$getTrackData.ptiOptions;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this.props.exp&&_this.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getExposureData(_this.props,options,ptiOptions)),key:"card-".concat(midIdx+index+1),className:"card-item",style:{backgroundColor:cardBaseConfig.cardBgColor},onClick:function onClick(){return _this.handleItemClick(item,midIdx+index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('96px'),height:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('96px'),effect:"opacity",className:"image",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.image,_this.props.webpSupport,'card')}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"name",style:{color:cardBaseConfig.productNameColor}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price-info",style:{backgroundImage:"url(".concat(cardBaseConfig.priceBgImageSmall||'https://static.shihuocdn.cn/admin/files/20250313/941bfb8dd1892e93148758d9fb3d526f.png',")"),backgroundSize:'conatin',backgroundRepeat:'no-repeat'}},item.id&&item.price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"price",style:{color:cardBaseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",null,"\xA5"),item.price),item.id&&others&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"others",style:{color:cardBaseConfig.priceInfoColor}},others)),item.cornerMark&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.cornerMark,_this.props.webpSupport,'card'),alt:"",className:"corner-mark"}));}));};if(cardBaseConfig.displayLineNum==='1行多个（横滑）'){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("ul",{className:"list horizontal-list",ref:function ref(_ref11){return _this.goodsBodyRef=_ref11;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-scroll",ref:function ref(_ref10){return _this.goodsScrollRef=_ref10;}},renderList(list)));}else{var midIdx=Math.ceil(list.length/2);// 计算中间索引，向上取整  
var list1=list.slice(0,midIdx);// 前半部分  
var list2=list.slice(midIdx);// 后半部分      
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("ul",{className:"list horizontal-list",ref:function ref(_ref13){return _this.goodsBodyRef=_ref13;}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"goods-scroll",ref:function ref(_ref12){return _this.goodsScrollRef=_ref12;}},renderList(list1),renderList(list2,midIdx)));}});_defineProperty(_assertThisInitialized(_this),"renderVerticalList",function(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var showNum=arguments.length>1?arguments[1]:undefined;var cardBaseConfig=_this.props.config.cardBaseConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("ul",{className:"list vertical-list"},list&&list.length>0&&list.slice(0,showNum).map(function(item,index){var others='';switch(cardBaseConfig.displayPriceInfo){case'原价':if(item.original_price>0){others="\xA5".concat(item.original_price);}break;case'折扣':// 折扣计算
if(item.original_price>0&&item.price<item.original_price){var rate=item.price/item.original_price;rate=parseFloat((rate*10).toFixed(1));others="".concat(rate,"\u6298");}break;case'直降':var reduce=0;if(item.original_price&&item.original_price>item.price){reduce=Math.floor(item.original_price-item.price);}if(reduce>0){others="\u76F4\u964D".concat(reduce);}break;case'销量':others="\u5DF2\u552E".concat(item.sell_point_str);break;default:break;}if(!others&&item.price){others='爆款好价';}var price=item.price;if(price>9999){price="".concat(parseFloat((price/10000).toFixed(1)),"w");}var _this$getTrackData2=_this.getTrackData(item,index),options=_this$getTrackData2.options,ptiOptions=_this$getTrackData2.ptiOptions;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this.props.exp&&_this.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getExposureData(_this.props,options,ptiOptions)),className:"card-item",key:"card-".concat(index+1),style:{backgroundColor:cardBaseConfig.cardBgColor},onClick:function onClick(){return _this.handleItemClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('106px'),height:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('106px'),effect:"opacity",className:"image",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.image,_this.props.webpSupport,'card')}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"name",style:{color:cardBaseConfig.productNameColor}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"price-info",style:{backgroundImage:"url(".concat(cardBaseConfig.priceBgImage||'https://static.shihuocdn.cn/admin/files/20241223/69ea17e2f62b1a99387bda573fe01f9d.png',")"),backgroundSize:'conatin',backgroundRepeat:'no-repeat'}},item.id&&item.price&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"price",style:{color:cardBaseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",null,"\xA5"),price),item.id&&others&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"others",style:{color:cardBaseConfig.priceInfoColor}},others)),item.cornerMark&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.cornerMark,_this.props.webpSupport,'card'),alt:"",className:"corner-mark"}));}));});_defineProperty(_assertThisInitialized(_this),"renderNormalList",function(){var list=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var showNum=arguments.length>1?arguments[1]:undefined;var cardBaseConfig=_this.props.config.cardBaseConfig;if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)){return _this.renderHorizontalList(list,showNum);}else{return _this.renderVerticalList(list,showNum);}});_defineProperty(_assertThisInitialized(_this),"renderTabList",function(){var _this$state3=_this.state,tabList=_this$state3.tabList,currentIdx=_this$state3.currentIdx;if(tabList.length>0){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react__["Fragment"],null,_this.renderNormalList(tabList[currentIdx].itemList,tabList[currentIdx].showNum),_this.renderExpandMore(tabList[currentIdx].showAll));}else{return null;}});_defineProperty(_assertThisInitialized(_this),"renderTabNav",function(){var tabConfig=_this.props.config.tabConfig;var _this$state4=_this.state,tabList=_this$state4.tabList,currentIdx=_this$state4.currentIdx;var className=tabList.length>4?'fixedWidth':'flexWidth';if(tabConfig.tabType==='文字Tab'){// 文字Tab
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("ul",{className:"text-tab",style:{minHeight:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])("".concat(tabConfig.tabSize.height||0,"px"))// top: this.props.navigationBarHeight
},ref:function ref(_ref14){return _this.tabRef=_ref14;}},tabList&&tabList.length>0&&tabList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("li",{className:index===currentIdx?"".concat(className," active"):className,key:"tab-".concat(index),style:{backgroundColor:index===currentIdx?tabConfig.tabActiveBgColor:tabConfig.tabUnActiveBgColor,color:index===currentIdx?tabConfig.tabActiveTextColor:tabConfig.tabUnActiveTextColor},onClick:function onClick(){return _this.onTabClick(index,item.tabText);}},_this.tabCharacters(item.tabText,10));}));}else{var tabNum=tabList.length<=5?tabList.length:'auto';// 图片Tab
return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("ul",{className:"image-tab",style:{minHeight:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])("".concat(tabConfig.tabSize.height||0,"px"))// top: this.props.navigationBarHeight
},ref:function ref(_ref15){return _this.tabRef=_ref15;}},tabList&&tabList.length>0&&tabList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("li",{className:index===currentIdx?"tab-num-".concat(tabNum," active"):"tab-num-".concat(tabNum),key:"tab-".concat(index),onClick:function onClick(){return _this.onTabClick(index,item.tabText);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{effect:"opacity",className:"un-active",visibleByDefault:_this.isIframe,src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.tabUnActiveBgImage,_this.props.webpSupport)}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{effect:"opacity",className:"active",visibleByDefault:_this.isIframe,src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.tabActiveBgImage,_this.props.webpSupport)}));}));}});_defineProperty(_assertThisInitialized(_this),"renderExpandMore",function(showAll){var _this$props$config3=_this.props.config,baseConfig=_this$props$config3.baseConfig,cardBaseConfig=_this$props$config3.cardBaseConfig;if(['1行','2行'].includes(cardBaseConfig.displayLineNum)){if(!showAll){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"expand",style:{color:baseConfig.browserMoreColor},onClick:function onClick(){return _this.onExpandMore();}},"\u67E5\u770B\u66F4\u591A",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("svg",{t:"1735023368687",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"16874",width:"200",height:"200"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("path",{d:"M169.344 329.344a32 32 0 0 1 40.832-3.648l4.48 3.648L512 626.752l297.344-297.408a32 32 0 0 1 40.832-3.648l4.48 3.648a32 32 0 0 1 3.648 40.832l-3.648 4.48-320 320a32 32 0 0 1-40.832 3.648l-4.48-3.648-320-320a32 32 0 0 1 0-45.312z","p-id":"16875",fill:baseConfig.browserMoreColor||'#666666'})));}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"line",style:{height:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('4px')}});}}else{return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"line",style:{height:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('10px')}},cardBaseConfig.isAutoCarousel==='是'&&_this.renderCarouselBar());}});_defineProperty(_assertThisInitialized(_this),"tabCharacters",function(str,limit){var result='';var maxLength=0;for(var i=0;i<str.length;i++){var _char=str.charAt(i);if(/[\u4e00-\u9fa5]/.test(_char)){// 中文
if(maxLength+2<=limit){maxLength+=2;result+=str[i];}}else{// 其他，如空格、特殊符号等
if(maxLength+1<=limit){maxLength+=1;result+=str[i];}}}return result;});var _props$config=props.config,theme=_props$config.theme,_props$config$cardBas=_props$config.cardBaseConfig,_cardBaseConfig=_props$config$cardBas===void 0?{}:_props$config$cardBas,_props$config$goodsDa=_props$config.goodsDataConfig,_goodsDataConfig=_props$config$goodsDa===void 0?{}:_props$config$goodsDa,_props$config$tabList=_props$config.tabList,_tabList=_props$config$tabList===void 0?[]:_props$config$tabList,_props$config$switchG=_props$config.switchGroup,switchGroup=_props$config$switchG===void 0?[]:_props$config$switchG;var _showNum=_cardBaseConfig.displayLineNum==='1行'?3:6;var _showAll=props.config.itemList.length<=_showNum?true:false;var _initList=_goodsDataConfig.sortType==='自定义排序'?props.config.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{title:item.title,url:item.url,image:item.image||placeholder,price:''});}):props.config.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{image:placeholder,price:''});});var initTabList=[];if(theme==='AI主题'){_tabList=switchGroup;}initTabList=_tabList.map(function(tabItem){if(tabItem.goodsDataConfig.sortType==='自定义排序'){tabItem.itemList=tabItem.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{title:item.title,url:item.url,image:item.image||placeholder});});tabItem['showAll']=tabItem.itemList.length<=_showNum?true:false;tabItem['showNum']=_showNum;}else{tabItem.itemList=tabItem.itemList.map(function(item){return _objectSpread(_objectSpread({},item),{},{image:placeholder});});tabItem['showAll']=tabItem.itemList.length<=_showNum?true:false;tabItem['showNum']=_showNum;}return tabItem;});_this.state={tabList:initTabList,list:_initList,currentIdx:0,showNum:_showNum,showAll:_showAll,tabFixed:false};_this.isIframe=__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getParams('isIframe')==1;_this.initList=_initList;_this.sortTypeMap={'自定义排序':0,'销量':4,'GMV':6,'上新时间':8,'热度':18};_this.saleTypeMap={'默认':4,'近1天':10,'近7天':12,'近14天':14,'近30天':16};_this.compOffsetTop=0;_this.initLayoutRowScroll=false;_this.scrollState='paused';_this.scrollAnimation=null;_this.isScrollEnd=false;_this.delayTimeout=null;_this.inViewArea=false;_this.pageId=__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getPageId();_this.top_id=__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getParams('top_id');return _this;}_createClass(PipelineProductLayout3,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(){var _this$props$config4,theme,cardBaseConfig,tabConfig;return regeneratorRuntime.wrap(function _callee9$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_this$props$config4=this.props.config,theme=_this$props$config4.theme,cardBaseConfig=_this$props$config4.cardBaseConfig,tabConfig=_this$props$config4.tabConfig;if(theme==='AI主题'){this.getTabListData();}else{if(tabConfig.tabType==='无Tab'){if(this.props['customAttributes']['data-component-id']=='pipeline-productLayout3-1770192375034'){this.getH5PreApiRequestData();}this.getItemListData();}else{this.getTabListData();}}if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)&&cardBaseConfig.isAutoCarousel==='是'){window.addEventListener('scroll',this.onScroll,true);}case 3:case"end":return _context10.stop();}}},_callee9,this);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"componentWillUnmount",value:function componentWillUnmount(){var cardBaseConfig=this.props.config.cardBaseConfig;if(['1行多个（横滑）','2行多个（横滑）'].includes(cardBaseConfig.displayLineNum)&&cardBaseConfig.isAutoCarousel==='是'){window.removeEventListener('scroll',this.onScroll,true);}}},{key:"getTrackData",value:function getTrackData(item,index){var templatePti=this.props.templatePti;var _this$state5=this.state,tabList=_this$state5.tabList,currentIdx=_this$state5.currentIdx;var _this$props$config5=this.props.config,theme=_this$props$config5.theme,baseConfig=_this$props$config5.baseConfig,tabConfig=_this$props$config5.tabConfig,goodsDataConfig=_this$props$config5.goodsDataConfig;var options={title:baseConfig.title,sort:index,name:item.title};if(goodsDataConfig.productType==="商品id"){options['goods_id']=item.id;}else{options['style_id']=item.id;}var ptiOptions={};if(theme==='AI主题'){ptiOptions={ptiId:"".concat(templatePti,":pipeline-productLayout3-switch_").concat(currentIdx,"-goods:").concat(index),bizExtra:{goods_id:item.goods_id||'',style_id:item.style_id||'',sku_id:item.sku_id||'',tabChName:'',model_block:'goods'}};}else{if(tabConfig.tabType==='无Tab'){ptiOptions={ptiId:"".concat(templatePti,":pipeline-productLayout3:").concat(index),bizExtra:{goods_id:item.goods_id||'',style_id:item.style_id||'',sku_id:item.sku_id||'',tabChName:'',model_block:'goods'}};}else{var tabChName=tabList&&tabList[currentIdx]?tabList[currentIdx].tabText||'':'';options['tabChName']=tabChName;ptiOptions={ptiId:"".concat(templatePti,":pipeline-productLayout3-tab_").concat(currentIdx,"-goods:").concat(index),bizExtra:{goods_id:item.goods_id||'',style_id:item.style_id||'',sku_id:item.sku_id||'',tabChName:tabChName,model_block:'goods'}};}}return{options:options,ptiOptions:ptiOptions};}},{key:"handleItemClick",value:function handleItemClick(item,index){if(this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].handleToufangClick({link:item.url,props:this.props,index:index});return;}var _this$getTrackData3=this.getTrackData(item,index),options=_this$getTrackData3.options,ptiOptions=_this$getTrackData3.ptiOptions;var convertUrl=__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].convertHref(item.url);__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].jumpToUrl(this.props.routeParams,convertUrl,convertUrl,options,item.id,this.props,false,ptiOptions);}// 更新被选中Tab的位置
},{key:"renderNormalTheme",value:// 渲染常规主题
function renderNormalTheme(){var _this2=this;var _this$props$config6=this.props.config,baseConfig=_this$props$config6.baseConfig,tabConfig=_this$props$config6.tabConfig,tabList=_this$props$config6.tabList;var _this$state6=this.state,list=_this$state6.list,showAll=_this$state6.showAll,showNum=_this$state6.showNum;var isRenderTab=tabConfig.tabType!=='无Tab'&&tabList&&tabList.length>1;var showTitle=baseConfig.title&&baseConfig.showTitle;var _ref16=baseConfig||{},backgroundColorType=_ref16.backgroundColorType,titleBackgroundColor=_ref16.titleBackgroundColor,titleBgColorFrom=_ref16.titleBgColorFrom,titleBgColorTo=_ref16.titleBgColorTo,backgroundColor=_ref16.backgroundColor,titleImage=_ref16.titleImage,titleHref=_ref16.titleHref,titleColor=_ref16.titleColor,title=_ref16.title;var titleStyle=backgroundColorType=="纯色背景"?{backgroundColor:backgroundColorType=="纯色背景"?titleBackgroundColor:'#FFFFFF'}:{background:backgroundColorType=="渐变色背景"?"linear-gradient(180deg, ".concat(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].hexColorToRgba(titleBgColorFrom,1)," 0%, ").concat(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].hexColorToRgba(titleBgColorTo,1)," 100%), #FFFFFF"):'#FFFFFF'};var _utils$getAdaptImageS=__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getAdaptImageSize(baseConfig.titleImageSize),width=_utils$getAdaptImageS.width,height=_utils$getAdaptImageS.height;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"theme-normal-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{style:{position:'relative'}},backgroundColorType=="图片背景"&&titleImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{className:"title-image",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(titleImage,this.props.webpSupport),style:{width:'100%',height:height},visibleByDefault:true,onClick:function onClick(){return _this2.onTitleClick(titleHref);}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"title ".concat(showTitle?'show':'hide'),style:_objectSpread(_objectSpread({color:titleColor},titleStyle),backgroundColorType=="图片背景"&&titleImage?{position:'absolute',top:0,left:0,width:'100%',height:'100%',backgroundColor:'transparent'}:{}),onClick:function onClick(){return _this2.onTitleClick(titleHref);}},showTitle&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react__["Fragment"],null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"title-text"},this.tabCharacters(title,28)),title&&titleHref&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("svg",{t:"1735026654807",className:"icon",viewBox:"0 0 1024 1024",version:"1.1",xmlns:"https://www.w3.org/2000/svg","p-id":"17123",width:"200",height:"200"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("path",{d:"M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z","p-id":"17124",fill:baseConfig.titleColor}))))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"content",style:{backgroundColor:backgroundColor}},isRenderTab&&this.renderTabNav(),tabConfig.tabType==='无Tab'?this.renderNormalList(list,showNum):this.renderTabList(),tabConfig.tabType==='无Tab'&&this.renderExpandMore(showAll)));}// 渲染AI主题
},{key:"renderAiTehme",value:function renderAiTehme(){var _this3=this;var _this$props$config7=this.props.config,baseConfig=_this$props$config7.baseConfig,cardBaseConfig=_this$props$config7.cardBaseConfig;var _this$state7=this.state,tabList=_this$state7.tabList,currentIdx=_this$state7.currentIdx;var list=[],desc='';if(tabList[currentIdx]){list=tabList[currentIdx].itemList||[];desc=tabList[currentIdx].tabText||'';}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"theme-ai-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"title-image",style:{backgroundImage:"url(".concat(baseConfig.moduleBgImage||'https://static.shihuocdn.cn/admin/files/20250302/efa261cbe66a7fe2b0016e2c9bc0d1eb.png',")"),backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:baseConfig.robotImage||'https://static.shihuocdn.cn/admin/files/20250302/c0a19bed08508093799fb73148c081ef.webp',alt:"",className:"robot"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"tips"},"\u5654\u5654\uFF01\u60A8\u7684AI\u8D2D\u7269\u7BA1\u5BB6\u4E0A\u7EBF\u5566~\u53D1\u73B0\u60A8\u6700\u8FD1\u5BF9\u201C",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",null,desc),"\u201D\u7C7B\u7684\u5546\u54C1\u5F88\u611F\u5174\u8DA3\uFF0C\u672CAI\u4E3A\u60A8\u7CBE\u5FC3\u6311\u9009\u4E86\u4EE5\u4E0B\u4E13\u5C5E\u5546\u54C1\u54E6~",/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20250302/b5f32169cf63e5bed6b861fb9e9b8f2b.png",alt:"",className:"switch",onClick:function onClick(){return _this3.onSwitchClick();}}))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("ul",{className:"content",style:{backgroundColor:baseConfig.backgroundColor}},list&&list.length>0&&list.slice(0,6).map(function(item,index){var _this3$getTrackData=_this3.getTrackData(item,index),options=_this3$getTrackData.options,ptiOptions=_this3$getTrackData.ptiOptions;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("li",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].getExposureData(_this3.props,options,ptiOptions)),className:"card-item",key:"card-".concat(index+1),style:{backgroundColor:cardBaseConfig.cardBgColor},onClick:function onClick(){return _this3.handleItemClick(item,index);}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('106px'),height:Object(__WEBPACK_IMPORTED_MODULE_33__utils_px2rem__["a" /* default */])('106px'),effect:"opacity",className:"image",src:__WEBPACK_IMPORTED_MODULE_31__utils_utils__["a" /* default */].formatImgUrl(item.image,_this3.props.webpSupport,'card')}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"name",style:{color:cardBaseConfig.productNameColor}},item.title),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("p",{className:"price",style:{color:cardBaseConfig.priceColor}},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("span",{style:{color:cardBaseConfig.priceColor}},"\xA5"),item.price));})));}},{key:"render",value:function render(){var _this4=this;var _this$props$config8=this.props.config,theme=_this$props$config8.theme,baseConfig=_this$props$config8.baseConfig;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",_extends({id:this.props['customAttributes']['data-component-id'],className:"pipeline-productLayout3 ".concat(theme==='AI主题'?'theme-ai':'theme-normal')},this.props['customAttributes'],{ref:function ref(_ref17){return _this4.compRef=_ref17;},name:baseConfig.title,style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginBottom:this.props.showCompMarginBottom?'8px':'0px'}}),theme==='AI主题'?this.renderAiTehme():this.renderNormalTheme());}// 轮播条
},{key:"renderCarouselBar",value:function renderCarouselBar(){var _this5=this;var cardBaseConfig=this.props.config.cardBaseConfig;var carouselBgColor,progressColor;switch(cardBaseConfig.carouselBarColor){case'白色':carouselBgColor='rgba(255, 255, 255, 0.3)';progressColor='#fff';break;case'黑色':carouselBgColor='rgba(202, 202, 202, 0.3)';progressColor='#CACACA';break;default:carouselBgColor='rgba(255, 255, 255, 0.3)';progressColor='#fff';break;}return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"carousel-bar"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"carousel-bg",style:{backgroundColor:carouselBgColor},ref:function ref(_ref18){return _this5.carouselBgRef=_ref18;}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_28_react___default.a.createElement("div",{className:"carousel-progress",style:{backgroundColor:progressColor},ref:function ref(_ref19){return _this5.progressRef=_ref19;}}));}},{key:"isElementInViewport",value:function isElementInViewport(element){var rect=element.getBoundingClientRect();var windowHeight=window.innerHeight||document.documentElement.clientHeight;var windowWidth=window.innerWidth||document.documentElement.clientWidth;// 判断元素是否垂直方向上可见
var verticalVisible=rect.top<=windowHeight&&rect.bottom>=0;// 判断元素是否水平方向上可见
var horizontalVisible=rect.left<=windowWidth&&rect.right>=0;// 计算已经暴露在可视区的比例
var visibleArea=Math.max(0,Math.min(rect.right,windowWidth)-Math.max(rect.left,0))*Math.max(0,Math.min(rect.bottom,windowHeight)-Math.max(rect.top,0));var totalArea=rect.width*rect.height;var visibilityRatio=visibleArea/totalArea;return{verticalVisible:verticalVisible,horizontalVisible:horizontalVisible,visibilityRatio:visibilityRatio};}// 字符串截取（指定截取的最大长度，每个中文占2个字符，其他占1个字符）
}]);return PipelineProductLayout3;}(__WEBPACK_IMPORTED_MODULE_28_react___default.a.Component);PipelineProductLayout3.propTypes={config:__WEBPACK_IMPORTED_MODULE_32_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineProductLayout3);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__H5PreApiMonitor__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(7);
function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}var pageId=__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getPageId();var preApiMonitor=new __WEBPACK_IMPORTED_MODULE_3__H5PreApiMonitor__["a" /* default */]("zt-public.shihuo.cn/page/".concat(pageId,"/index.html"));// 清单横画组件数据接口前置封装
var fetchH5PreApiRequestData=/*#__PURE__*/function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _ref2,url,_ref2$method,method,params,isH5PreApi,_yield$fetchH5Request,data,_args=arguments;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_ref2=_args.length>0&&_args[0]!==undefined?_args[0]:{},url=_ref2.url,_ref2$method=_ref2.method,method=_ref2$method===void 0?'get':_ref2$method,params=_ref2.params,isH5PreApi=_ref2.isH5PreApi;if(isH5PreApi){_context.next=7;break;}_context.next=4;return fetchH5RequestData({url:url,method:method,params:params});case 4:_yield$fetchH5Request=_context.sent;data=_yield$fetchH5Request.data;return _context.abrupt("return",data);case 7:return _context.abrupt("return",new Promise(function(resolve,reject){preApiMonitor.getPreData(function(){return fetchH5RequestData({url:url,method:method,params:params});},url,'').then(function(successData){var status=successData.status,data=successData.data,msg=successData.msg;if(status==0){resolve(data);}else{reject({code:status,msg:msg});}})["catch"](function(error){reject(error);});}));case 8:case"end":return _context.stop();}}},_callee);}));return function fetchH5PreApiRequestData(){return _ref.apply(this,arguments);};}();// 清单横画组件数据接口API获取数据
var fetchH5RequestData=function fetchH5RequestData(){var _ref3=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},url=_ref3.url,_ref3$method=_ref3.method,method=_ref3$method===void 0?'post':_ref3$method,params=_ref3.params;return new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_4__request__["a" /* default */])({url:url,method:method,withCredentials:true,data:params}).then(function(res){resolve(res.data);})["catch"](function(){resolve({});});});};/* harmony default export */ __webpack_exports__["a"] = (fetchH5PreApiRequestData);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return H5PreApiMonitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js__);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}// 接口前置的工具类。https://poizon.feishu.cn/docx/TUxRdPxcpoSbEcxNJqAcgaePnQh
var H5PreApiMonitor=/*#__PURE__*/function(){function H5PreApiMonitor(page){_classCallCheck(this,H5PreApiMonitor);this.page=page;}// h5RequestPromise: rn发起请求的promise，低版本客户端或者客户端因为未拿到配置信息导致没有未发起前置接口时，仍然使用原始rn方法发起请求
// url: 请求的api全路径，不用携带参数
// appVersion: 可选，如果有值，则进行版本判断
_createClass(H5PreApiMonitor,[{key:"getPreData",value:function(){var _getPreData=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(h5RequestPromise,url){var _this=this;var appVersion,_yield$Promise,_yield$Promise2,code,data,_args=arguments;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:appVersion=_args.length>2&&_args[2]!==undefined?_args[2]:'';_context.next=3;return new Promise(function(resolve,reject){window.Jockey.send('getPreApiData',{page:_this.page,url:url},function(res){if(res){var _code=res.code,_data=res.data;resolve([_code,_data||{}]);}else{resolve([-1,{}]);}});});case 3:_yield$Promise=_context.sent;_yield$Promise2=_slicedToArray(_yield$Promise,2);code=_yield$Promise2[0];data=_yield$Promise2[1];if(!(code==1)){_context.next=11;break;}return _context.abrupt("return",new Promise(function(resolve,reject){resolve(data);}));case 11:return _context.abrupt("return",h5RequestPromise());case 12:case"end":return _context.stop();}}},_callee);}));function getPreData(_x,_x2){return _getPreData.apply(this,arguments);}return getPreData;}()}]);return H5PreApiMonitor;}();

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineSideBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_less__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineSideBar=/*#__PURE__*/function(_React$Component){_inherits(PipelineSideBar,_React$Component);var _super=_createSuper(PipelineSideBar);function PipelineSideBar(props){var _this;_classCallCheck(this,PipelineSideBar);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"handleSideBarClick",function(item,index){if(item.href){var options={sort:index};__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,item.href,item.href,options,-1,_this.props,false,{ptiId:"".concat(_this.props.templatePti,":sideBar:").concat(index+1),bizExtra:{model_block:'sideBar',block_name:item.name}});}});_this.state={sideMenu:[]};_this.isIphoneX=__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].isIphoneX();_this.isIphone14ProMax=__WEBPACK_IMPORTED_MODULE_14__utils_utils__["a" /* default */].isIphone14ProMax();return _this;}_createClass(PipelineSideBar,[{key:"render",value:function render(){var _this2=this;var _this$props$config=this.props.config,_this$props$config$ba=_this$props$config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba,_this$props$config$im=_this$props$config.imgsList,imgsList=_this$props$config$im===void 0?[]:_this$props$config$im;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("div",_extends({className:this.isIphoneX||this.isIphone14ProMax?'pipeline-sideBar iphoneX':'pipeline-sideBar'},this.props['customAttributes']),baseConfig.titleImage&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:baseConfig.titleImage,alt:"",className:"side-title"}),imgsList.length>0&&imgsList.map(function(item,index){return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement("img",{src:item.image,alt:"",className:"side-entry",key:"side-".concat(index),onClick:function onClick(){return _this2.handleSideBarClick(item,index);}});}));}}]);return PipelineSideBar;}(__WEBPACK_IMPORTED_MODULE_13_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineSideBar);

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PipelineTimedLottery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_keys_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_keys_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_keys_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_own_property_descriptor_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_own_property_descriptor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_object_get_own_property_descriptor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es7_object_get_own_property_descriptors_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_object_define_properties_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_px2rem__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_request__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component_src_effects_opacity_css__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component_src_effects_opacity_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_react_lazy_load_image_component_src_effects_opacity_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__style_less__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function asyncGeneratorStep(gen,resolve,reject,_next,_throw,key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{Promise.resolve(value).then(_next,_throw);}}function _asyncToGenerator(fn){return function(){var self=this,args=arguments;return new Promise(function(resolve,reject){var gen=fn.apply(self,args);function _next(value){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"next",value);}function _throw(err){asyncGeneratorStep(gen,resolve,reject,_next,_throw,"throw",err);}_next(undefined);});};}function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);enumerableOnly&&(symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;})),keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=null!=arguments[i]?arguments[i]:{};i%2?ownKeys(Object(source),!0).forEach(function(key){_defineProperty(target,key,source[key]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(target,Object.getOwnPropertyDescriptors(source)):ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
 * @Author: cascade
 * @Description: 定时开奖组件（列表样式）
 */var PipelineTimedLottery=/*#__PURE__*/function(_React$Component){_inherits(PipelineTimedLottery,_React$Component);var _super=_createSuper(PipelineTimedLottery);function PipelineTimedLottery(props){var _this;_classCallCheck(this,PipelineTimedLottery);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"getLotteryDetail",function(){var _ref=_this.props.config||{},_ref$prizeList=_ref.prizeList,prizeList=_ref$prizeList===void 0?[]:_ref$prizeList;if(prizeList.length>0){var ids=prizeList.map(function(item){return item.actId;}).join(',');Object(__WEBPACK_IMPORTED_MODULE_29__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-lotteryapi/draw/activity/list',method:'get',withCredentials:true,params:{ids:ids}}).then(function(res){var _res$data=res.data,status=_res$data.status,data=_res$data.data;if(status===0&&data&&data.length>0){prizeList=prizeList.map(function(item){var target=data.find(function(i){return i.id==item.actId;});if(target){var name=target.name,start_time=target.start_time,end_time=target.end_time,price=target.price,_status=target.status;return _objectSpread(_objectSpread({},item),{},{name:item.name||name,startTime:start_time,endTime:end_time,price:price,status:_status});}return item;});_this.setState({prizeList:prizeList});}})["catch"](function(error){});}});_defineProperty(_assertThisInitialized(_this),"getLotteryInfo",function(){return new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_29__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-lotteryapi/draw/help/info',method:'get',withCredentials:true,params:{task_id:_this.task_id}}).then(function(res){var _res$data2=res.data,status=_res$data2.status,data=_res$data2.data;if(status===0){resolve(data);}else{resolve({});}})["catch"](function(error){reject({});});});});_defineProperty(_assertThisInitialized(_this),"onDrawHelp",function(){return new Promise(function(resolve,reject){Object(__WEBPACK_IMPORTED_MODULE_29__utils_request__["a" /* default */])({url:'https://sh-gateway.shihuo.cn/v4/services/sh-lotteryapi/draw/help',method:'post',withCredentials:true,data:{task_id:Number(_this.task_id)}}).then(function(res){var _res$data3=res.data,status=_res$data3.status,data=_res$data3.data,msg=_res$data3.msg;if(status===0){resolve(data);}else{window.Jockey.send('toast',{text:msg});resolve({status:-1,tips:''});}})["catch"](function(error){reject({});});});});_defineProperty(_assertThisInitialized(_this),"startTicker",function(){if(_this.ticker){clearInterval(_this.ticker);_this.ticker=null;}// 立即刷新一次，避免等待首个间隔
_this.setState(function(prev){return{now:__WEBPACK_IMPORTED_MODULE_26_moment___default()(),tick:(prev.tick+1)%1000000000};});_this.ticker=setInterval(function(){_this.setState(function(prev){return{now:__WEBPACK_IMPORTED_MODULE_26_moment___default()(),tick:(prev.tick+1)%1000000000};});},1000);});_defineProperty(_assertThisInitialized(_this),"handleVisibilityChange",function(){if(document.hidden){if(_this.ticker){clearInterval(_this.ticker);_this.ticker=null;}}else{_this.startTicker();}});_defineProperty(_assertThisInitialized(_this),"handleLogin",function(){if(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isShihuo()){// 未登陆，请先进行微信登陆
if(_this.loginInterVal){return;}_this.setState({modalVisible:false,modalClosing:false});if(!__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].isAndroid()&&__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].SHDiffVersion(_this.app_version,'6.86.0')){_this.judgeIsLogin();}else{window.Jockey.send("subscribe",{},function(publishData){if(publishData.type==="loginSuccess"){_this.loginInterVal=setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var isLogin,_yield$_this$onDrawHe,status,tips;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.queryLoginStatus();case 2:isLogin=_context.sent;if(!isLogin){_context.next=12;break;}clearInterval(_this.loginInterVal);_this.loginInterVal=null;_context.next=8;return _this.onDrawHelp();case 8:_yield$_this$onDrawHe=_context.sent;status=_yield$_this$onDrawHe.status;tips=_yield$_this$onDrawHe.tips;_this.setState({modalVisible:status!==-1,helpStatus:status,isLogin:true,tips:tips});case 12:case"end":return _context.stop();}}},_callee);})),500);}});}window.Jockey.send("action",{url:"shihuo://www.shihuo.cn?route=login"});}});_defineProperty(_assertThisInitialized(_this),"judgeIsLogin",function(){_this.loginInterval&&clearInterval(_this.loginInterval);_this.loginInterval=setInterval(function(){var isLogin=_this.state.isLogin;if(!isLogin){var CookieUA=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getCookie('ua');var CookieU=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getCookie('u');if(CookieUA&&CookieU){Promise.all([CookieUA,CookieU]).then(function(result){_this.setState({isLogin:result&&result[0]&&result[1]},/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _yield$_this$onDrawHe2,status,tips;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!_this.state.isLogin){_context2.next=8;break;}_this.removeInterval();_context2.next=4;return _this.onDrawHelp();case 4:_yield$_this$onDrawHe2=_context2.sent;status=_yield$_this$onDrawHe2.status;tips=_yield$_this$onDrawHe2.tips;_this.setState({modalVisible:status!==-1,helpStatus:status,isLogin:true,tips:tips});case 8:case"end":return _context2.stop();}}},_callee2);})));});}}else{_this.removeInterval();}},500);});_defineProperty(_assertThisInitialized(_this),"queryLoginStatus",function(){return new Promise(function(resolve,reject){try{Object(__WEBPACK_IMPORTED_MODULE_29__utils_request__["a" /* default */])({url:"https://sh-gateway.shihuo.cn/v4/services/sh-user/user/baseInfo?from=".concat(_this.pageId,"&need_wechat_info=false&complicate=true"),method:'get',withCredentials:true}).then(function(res){var _res$data4=res.data,status=_res$data4.status,data=_res$data4.data;if(status===0){if(data.user_info&&data.user_info.uid){_this.removeInterval();resolve(true);}else{resolve(false);}}else{// 用户未登录
resolve(false);}});}catch(error){reject(false);}});});_defineProperty(_assertThisInitialized(_this),"getActivityState",function(item){var _ref4=item||{},_ref4$startTime=_ref4.startTime,startTime=_ref4$startTime===void 0?'':_ref4$startTime,_ref4$endTime=_ref4.endTime,endTime=_ref4$endTime===void 0?'':_ref4$endTime;var now=_this.state.now;var start=startTime?__WEBPACK_IMPORTED_MODULE_26_moment___default()(startTime*1000):null;var end=endTime?__WEBPACK_IMPORTED_MODULE_26_moment___default()(endTime*1000):null;// 状态1: 进行中 (startTime <= now < endTime)
if(start&&end&&now.isSameOrAfter(start)&&now.isBefore(end)){var d=__WEBPACK_IMPORTED_MODULE_26_moment___default.a.duration(end.diff(now));var days=Math.floor(d.asDays());var hours=d.hours();var minutes=d.minutes();var seconds=d.seconds();return{slogan:"".concat(days>0?days+'天':'',"<span class=\"count-down\">").concat(hours<10?'0'+hours:hours,":").concat(minutes<10?'0'+minutes:minutes,":").concat(seconds<10?'0'+seconds:seconds,"</span>\u540E\u6D3B\u52A8\u7ED3\u675F"),statusClass:'status-inprogress'};}// 状态2: 未开始 (startTime > now)
if(start&&now.isBefore(start)){var _d=__WEBPACK_IMPORTED_MODULE_26_moment___default.a.duration(start.diff(now));var _days=Math.floor(_d.asDays());var _hours=_d.hours();var _minutes=_d.minutes();var _seconds=_d.seconds();return{slogan:"".concat(_days>0?_days+'天':'',"<span class=\"count-down\">").concat(_hours<10?'0'+_hours:_hours,":").concat(_minutes<10?'0'+_minutes:_minutes,":").concat(_seconds<10?'0'+_seconds:_seconds,"</span>\u540E\u6D3B\u52A8\u5F00\u59CB"),statusClass:'status-notstarted'};}// 状态3: 已结束 (endTime < now)
if(start&&end&&now.isAfter(end)){return{slogan:"".concat(end.format('M月D日HH:mm'),"\u6D3B\u52A8\u5DF2\u5F00\u5956"),statusClass:'status-ended'};}// 默认或异常状态
return{slogan:'活动已结束',statusClass:'status-ended'};});_defineProperty(_assertThisInitialized(_this),"handleClick",function(item,index,remain_time){var link="shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Activity&page=TimedLotteryDraw&options=".concat(encodeURIComponent(JSON.stringify({act_id:item.actId})));__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,link,link,{},-1,_this.props,false,{ptiId:"".concat(_this.props.templatePti,":timedLottery:").concat(index+1),ptiName:'查看活动',bizExtra:{text:item.name,activity_id:item.actId,remain_time:remain_time,model_block:'查看活动'}});});_defineProperty(_assertThisInitialized(_this),"handlePopClick",function(act_id,helpStatus,tips){var link="shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Activity&page=TimedLotteryDraw&options=".concat(encodeURIComponent(JSON.stringify({act_id:act_id})));__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,link,link,{},-1,_this.props,false,{ptiId:"".concat(_this.props.templatePti,":timedLotteryPopGo:"),ptiName:'timedLotteryPopGo',bizExtra:{text:helpStatus===0?'助力成功，感谢你的助力！':tips,button_name:'我也要参与，查看活动'}});_this.setState({modalVisible:false,modalClosing:false});});_defineProperty(_assertThisInitialized(_this),"openModal",function(item){_this.setState({modalVisible:true,modalClosing:false});});_defineProperty(_assertThisInitialized(_this),"closeModal",function(){if(!_this.state.modalVisible)return;_this.setState({modalClosing:true});setTimeout(function(){_this.setState({modalVisible:false,modalClosing:false});},300);});_this.state={prizeList:[],now:__WEBPACK_IMPORTED_MODULE_26_moment___default()(),tick:0,modalVisible:false,modalClosing:false,isLogin:false,drawInfo:{},helpStatus:null,tips:''};_this.task_id=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getQueryString('id')||'';_this.loginInterVal=null;_this.app_version=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getVersion();_this.ticker=null;return _this;}_createClass(PipelineTimedLottery,[{key:"componentDidMount",value:function(){var _componentDidMount=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var _this2=this;var drawInfo,isLogin,_yield$this$onDrawHel,status,tips;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// 先启动倒计时，避免请求失败导致未启动
this.getLotteryDetail();drawInfo={};if(!this.task_id){_context3.next=12;break;}_context3.prev=3;_context3.next=6;return this.getLotteryInfo();case 6:drawInfo=_context3.sent;_context3.next=12;break;case 9:_context3.prev=9;_context3.t0=_context3["catch"](3);drawInfo={};case 12:if(!this.task_id){_context3.next=28;break;}_context3.next=15;return this.queryLoginStatus();case 15:isLogin=_context3.sent;if(isLogin){_context3.next=20;break;}this.setState({modalVisible:true,drawInfo:drawInfo,isLogin:isLogin},function(){_this2.startTicker();});_context3.next=26;break;case 20:_context3.next=22;return this.onDrawHelp();case 22:_yield$this$onDrawHel=_context3.sent;status=_yield$this$onDrawHel.status;tips=_yield$this$onDrawHel.tips;this.setState({modalVisible:true,helpStatus:status,drawInfo:drawInfo,isLogin:isLogin,tips:tips},function(){_this2.startTicker();});case 26:_context3.next=29;break;case 28:this.setState({drawInfo:drawInfo},function(){_this2.startTicker();});case 29:document.addEventListener('visibilitychange',this.handleVisibilityChange,false);case 30:case"end":return _context3.stop();}}},_callee3,this,[[3,9]]);}));function componentDidMount(){return _componentDidMount.apply(this,arguments);}return componentDidMount;}()},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener('visibilitychange',this.handleVisibilityChange);this.removeInterval();}// 获取抽奖详情
},{key:"removeInterval",value:// 移除定时器
function removeInterval(){this.loginInterVal&&clearInterval(this.loginInterVal);this.loginInterVal=null;this.loginInterval&&clearInterval(this.loginInterval);this.loginInterval=null;this.ticker&&clearInterval(this.ticker);this.ticker=null;this.countdownTimer&&clearTimeout(this.countdownTimer);this.countdownTimer=null;}// 登录
},{key:"render",value:function render(){var _this3=this;var _ref5=this.props.config||{},_ref5$baseConfig=_ref5.baseConfig,baseConfig=_ref5$baseConfig===void 0?{}:_ref5$baseConfig;var _this$state=this.state,modalVisible=_this$state.modalVisible,modalClosing=_this$state.modalClosing,isLogin=_this$state.isLogin,_this$state$drawInfo=_this$state.drawInfo,drawInfo=_this$state$drawInfo===void 0?{}:_this$state$drawInfo,helpStatus=_this$state.helpStatus,tips=_this$state.tips,_this$state$prizeList=_this$state.prizeList,prizeList=_this$state$prizeList===void 0?[]:_this$state$prizeList;if(!prizeList||!prizeList.length)return null;return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",_extends({className:"pipeline-timed-lottery"},this.props['customAttributes'],{style:{paddingTop:baseConfig.moduleMarginTop>=0?"".concat(baseConfig.moduleMarginTop,"px"):0,marginTop:baseConfig.moduleMarginTop<0?"".concat(baseConfig.moduleMarginTop,"px"):0}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-list"},prizeList.map(function(it,idx){var activityState=_this3.getActivityState(it);return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getExposureData(_this3.props,{},{ptiId:"".concat(_this3.props.templatePti,":timedLottery:").concat(idx+1),ptiName:'timedLottery',bizExtra:{text:it.name,activity_id:it.actId,remain_time:activityState.slogan,model_block:'查看活动'}})),className:"tl-item",key:idx,onClick:function onClick(){return _this3.handleClick(it,idx,activityState.slogan);}},it.image?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-img-wrap"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_lazy_load_image_component__["LazyLoadImage"],{width:Object(__WEBPACK_IMPORTED_MODULE_28__utils_px2rem__["a" /* default */])('108px'),height:Object(__WEBPACK_IMPORTED_MODULE_28__utils_px2rem__["a" /* default */])('108px'),className:"tl-img",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(it.image,_this3.props.webpSupport),alt:"\u5956\u54C1\u56FE",effect:"opacity"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-img-mask"})):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-status ".concat(activityState.statusClass),dangerouslySetInnerHTML:{__html:activityState.slogan}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-name"},it.name||'奖品名称'),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"now"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"now-symbol"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"now-price"},"0")),it.price>0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"origin"},"\xA5",it.price):null)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-action"},"\u67E5\u770B\u6D3B\u52A8"));})),modalVisible&&!isLogin?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getExposureData(this.props,{},{ptiId:"".concat(this.props.templatePti,":timedLotteryPopShow:"),ptiName:'timedLotteryPopShow',bizExtra:{text:'好友正在参与抽奖活动，帮TA助力！'}})),className:"tl-modal-root ".concat(modalClosing?'tl-leave':'tl-enter')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-mask ".concat(modalClosing?'tl-leave':'tl-enter'),onClick:this.closeModal}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog type_1 ".concat(modalClosing?'tl-leave':'tl-enter')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog-title"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:drawInfo.avatar,alt:"",className:"avatar"}),"\u597D\u53CB\u6B63\u5728\u53C2\u4E0E\u62BD\u5956\u6D3B\u52A8"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog-title"},"\u5E2ETA\u52A9\u529B\uFF01"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog-card"},drawInfo&&drawInfo.img?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{className:"tl-card-img",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(drawInfo.img,this.props.webpSupport),alt:"\u5956\u54C1"}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-card-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-card-name"},drawInfo&&drawInfo.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-card-tag"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",null,"\u9650\u65F6\u514D\u8D39\u62BD"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"tl-card-tag-price"},"\xA5",drawInfo.price)))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getExposureData(this.props,{},{ptiId:"".concat(this.props.templatePti,":timedLotteryPopGo:"),ptiName:'timedLotteryPopGo',bizExtra:{text:'好友正在参与抽奖活动，帮TA助力！',button_name:'去登录帮TA助力'}})),className:"tl-dialog-btn",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this3.props,{},{ptiId:"".concat(_this3.props.templatePti,":timedLotteryPopGo:"),ptiName:'timedLotteryPopGo',bizExtra:{text:'好友正在参与抽奖活动，帮TA助力！',button_name:'去登录帮TA助力'}});_this3.handleLogin();}},"\u53BB\u767B\u5F55\u5E2ETA\u52A9\u529B"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20230227/3824f46f10ed91f4d71e53c141c9ebf4.png",alt:"",className:"tl-dialog-close",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this3.props,{},{ptiId:"".concat(_this3.props.templatePti,":timedLotteryPopClose:"),ptiName:'timedLotteryPopClose',bizExtra:{text:'好友正在参与抽奖活动，帮TA助力！'}});_this3.closeModal();}}))):null,modalVisible&&isLogin&&helpStatus>=0?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getExposureData(this.props,{},{ptiId:"".concat(this.props.templatePti,":timedLotteryPopShow:"),ptiName:'timedLotteryPopShow',bizExtra:{text:helpStatus===0?'助力成功，感谢你的助力！':tips}})),className:"tl-modal-root ".concat(modalClosing?'tl-leave':'tl-enter')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-mask ".concat(modalClosing?'tl-leave':'tl-enter'),onClick:this.closeModal}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog type_2 ".concat(modalClosing?'tl-leave':'tl-enter')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog-title"},helpStatus===0?'助力成功，感谢你的助力！':tips),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog-subtitle"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:drawInfo.avatar,alt:"",className:"avatar"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",null,helpStatus===0?'好友额外获得1张抽奖码':'好友正在参与抽奖活动')),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-dialog-card"},drawInfo&&drawInfo.img?/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{className:"tl-card-img",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(drawInfo.img,this.props.webpSupport),alt:"\u5956\u54C1"}):null,/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-card-info"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-card-name"},drawInfo&&drawInfo.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{className:"tl-card-tag"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",null,"\u9650\u65F6\u514D\u8D39\u62BD"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("span",{className:"tl-card-tag-price"},"\xA5",drawInfo.price)))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("div",{ref:function ref(ele){if(ele){_this3.props.exp&&_this3.props.exp(ele);}},"data-dot":JSON.stringify(__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].getExposureData(this.props,{},{ptiId:"".concat(this.props.templatePti,":timedLotteryPopGo:"),ptiName:'timedLotteryPopGo',bizExtra:{text:helpStatus===0?'助力成功，感谢你的助力！':tips,button_name:'我也要参与，查看活动'}})),className:"tl-dialog-btn",onClick:function onClick(){return _this3.handlePopClick(drawInfo.act_id,helpStatus,tips);}},"\u6211\u4E5F\u8981\u53C2\u4E0E\uFF0C\u67E5\u770B\u6D3B\u52A8"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_23_react___default.a.createElement("img",{src:"https://static.shihuocdn.cn/admin/files/20230227/3824f46f10ed91f4d71e53c141c9ebf4.png",alt:"",className:"tl-dialog-close",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].uploadTrack(_this3.props,{},{ptiId:"".concat(_this3.props.templatePti,":timedLotteryPopClose:"),ptiName:'timedLotteryPopClose',bizExtra:{text:helpStatus===0?'助力成功，感谢你的助力！':tips}});_this3.closeModal();}}))):null);}}]);return PipelineTimedLottery;}(__WEBPACK_IMPORTED_MODULE_23_react___default.a.Component);PipelineTimedLottery.propTypes={config:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PipelineTimedLottery);

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_sort_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_sort_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_sort_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_array_find_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_string_includes_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_string_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_string_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_map_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_replace_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_regexp_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_number_constructor_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_index_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_find_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_function_bind_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_axios_dist_axios_min_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_axios_dist_axios_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_axios_dist_axios_min_js__);
function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PipelineHotSellRankList=/*#__PURE__*/function(_React$Component){_inherits(PipelineHotSellRankList,_React$Component);var _super=_createSuper(PipelineHotSellRankList);function PipelineHotSellRankList(props){var _this;_classCallCheck(this,PipelineHotSellRankList);_this=_super.call(this,props);_defineProperty(_assertThisInitialized(_this),"state",{showTags:{},productsList:[]});_defineProperty(_assertThisInitialized(_this),"checkAllTagOverflow",function(){var productsList=_this.state.productsList;var showTags={};var componentId=_this.props['customAttributes']['data-component-id'];var canvas=document.createElement("canvas");var ctx=canvas.getContext("2d");_this.timerID=setTimeout(function(){productsList.forEach(function(item,index){var tagKey="".concat(componentId,"-").concat(item.sort,"-").concat(index);var tag=_this.tagRefs[tagKey];if(tag){ctx.font=window.getComputedStyle(tag).font;var textWidth=ctx.measureText(tag.textContent).width;showTags[tagKey]=textWidth<=tag.clientWidth;}});_this.setState({showTags:showTags});},0);});_defineProperty(_assertThisInitialized(_this),"getDisplayLabel",function(item){if(!item||!Array.isArray(item.label))return'';var priorityList=['365天新低价','低于往年双11价','低于618价','低于','全网低价'];var displayLabel='';var _loop=function _loop(){var keyword=_priorityList[_i];var match=item.label.find(function(label){return label.includes(keyword);});if(match){displayLabel=match;return{v:displayLabel};}};for(var _i=0,_priorityList=priorityList;_i<_priorityList.length;_i++){var _ret=_loop();if(_typeof(_ret)==="object")return _ret.v;}var validLabels=(item.label||[]).filter(function(label){return label.length<=6;});if(!displayLabel&&validLabels.length>0){displayLabel=validLabels[0];}return displayLabel;});_defineProperty(_assertThisInitialized(_this),"getRankList",function(){var _this$props$config$ba=_this.props.config.baseConfig,baseConfig=_this$props$config$ba===void 0?{}:_this$props$config$ba;var _ref=baseConfig||{},_ref$sortType=_ref.sortType,sortType=_ref$sortType===void 0?'默认':_ref$sortType;var productsList=_this.props.config.list;var skuIds=productsList.map(function(item){return item.skuId?item.skuId:0;});__WEBPACK_IMPORTED_MODULE_29_axios_dist_axios_min_js___default()({url:'https://sh-gateway.shihuo.cn/v4/services/sh-topapi/legotop/goods-sku',method:'post',withCredentials:true,data:{skuIds:skuIds}}).then(function(res){if(res.data.status===0){var list=res.data.data||[];list.forEach(function(item){var customProduct=productsList.find(function(product){return product.skuId==item.skuId;});if(customProduct){item.img=customProduct.img?customProduct.img:item.img;item.auxiliaryLabel=customProduct.auxiliaryLabel;item.name=customProduct.title?customProduct.title:item.name;item.sellingPoint=customProduct.sellingPoint;item.displayLabel=_this.getDisplayLabel(item);if(typeof item.saleNum==='string'){if(item.saleNum.includes('w')){item.saleNum=parseFloat(item.saleNum.replace('w',''))*10000;}else{item.saleNum=Number(item.saleNum);}}}});if(sortType==='默认'){// 按schema配置的顺序排序
list.sort(function(a,b){var indexA=productsList.findIndex(function(p){return p.skuId==a.skuId;});var indexB=productsList.findIndex(function(p){return p.skuId==b.skuId;});return indexA-indexB;});}else if(sortType==='销量'){// 按销量排序
list.sort(function(a,b){return b.saleNum-a.saleNum;});}// 设置排名序号
list.forEach(function(item,index){item.sort=index+1;});_this.setState({productsList:list});}});});_defineProperty(_assertThisInitialized(_this),"handleItemClick",function(item,index){if(!item.href){return;}if(_this.props.templateName==='toufang'){__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].handleToufangClick({link:item.href,props:_this.props,index:index});return;}var options={link:item.href,sort:index};var convertUrl=__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].convertHref(item.href);__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].jumpToUrl(_this.props.routeParams,convertUrl,item.href,options,-1,_this.props,false);});_this.tagRefs={};return _this;}_createClass(PipelineHotSellRankList,[{key:"componentDidMount",value:function componentDidMount(){this.getRankList();this.checkAllTagOverflow();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(prevState.productsList!==this.state.productsList){this.checkAllTagOverflow();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timerID);}},{key:"render",value:function render(){var _this2=this;var baseConfig=this.props.config.baseConfig;// const productsList = this.props.config.list;
var _this$state=this.state,productsList=_this$state.productsList,showTags=_this$state.showTags;var tagRefs=this.tagRefs;var topTagImgUrl={1:'http://static.shihuocdn.cn/admin/files/20250928/49575901a21e04d163b9df063c4ab960.png',2:'http://static.shihuocdn.cn/admin/files/20250928/8abf5c7f0a02fee5892ff85460ca4006.png',3:'http://static.shihuocdn.cn/admin/files/20250928/3b55566fd83f0653c22af57a6ea5ecef.png',4:'http://static.shihuocdn.cn/admin/files/20250928/427b43c3a957de32852c64f7de17a1c8.png'};var fireImgUrl={1:'http://static.shihuocdn.cn/admin/files/20250928/de79682fc8e52b1a6a47671f21bc615f.png',2:'http://static.shihuocdn.cn/admin/files/20250928/c3b777328a2f6bafda88de3dd0be83e0.png',3:'http://static.shihuocdn.cn/admin/files/20250928/b3b140d72738f7ad23730f7794eb4d16.png',4:'http://static.shihuocdn.cn/admin/files/20250928/869648906e7bf0790a97c1b706af5810.png'};var componentId=this.props['customAttributes']['data-component-id'];return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",_extends({className:"pipeline-hotSellRankList",id:componentId},this.props['customAttributes']),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"pipeline-hotSellRankList-container"},productsList.map(function(item,index){var tagKey="".concat(componentId,"-").concat(item.sort,"-").concat(index);return/*#__PURE__*/ (// 商品卡片
__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-item ".concat(item.sort<4?"rank".concat(item.sort):''),key:"item_".concat(index,"_").concat(item.sort),onClick:_this2.handleItemClick.bind(_this2,item,index)},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-rank-tag"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(item.sort<4?topTagImgUrl[item.sort]:topTagImgUrl[4],baseConfig.webpSupport),className:"icon"}),item.sort>=4&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("span",{className:"number"},item.sort)),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-left ".concat(item.sort<4?"rank1-3":'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-img"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_react_lazy_load_image_component__["LazyLoadImage"],{width:"100%",threshold:500,height:"100%",src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(item.img,baseConfig.webpSupport),effect:"opacity"})),item.auxiliaryLabel&&showTags[tagKey]!==false&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{ref:function ref(el){return tagRefs[tagKey]=el;},className:"product-tag"},item.auxiliaryLabel)),item.sort<4&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-hot-selling-top3"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(fireImgUrl[item.sort],baseConfig.webpSupport),className:"fire-icon-top3"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("span",{className:"hot-selling-text-top3 ".concat(item.sort<4?"rank".concat(item.sort):'')},"\u5168\u7F51\u70ED\u9500",item.saleNum<10000?item.saleNum:item.saleNum/10000+'万+',"\u4EF6")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-right"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-right-content"},!(item.sort<4)&&/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-hot-selling"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__utils_utils__["a" /* default */].formatImgUrl(fireImgUrl[4],baseConfig.webpSupport),className:"fire-icon"}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("span",{className:"hot-selling-text"},"\u5168\u7F51\u70ED\u9500",item.saleNum<10000?item.saleNum:item.saleNum/10000+'万+',"\u4EF6")),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-title ".concat(item.sort<4?"rank1-3":'')},item.name),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-selling-point"},item.sellingPoint),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-price-section ".concat(item.sort<4?"rank1-3":'')},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-price-content"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"product-price"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"char"},"\xA5"),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"price"},item.price),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("div",{className:"displayLabel"},item.displayLabel))),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_react___default.a.createElement("button",{className:"product-btn"},"\u7ACB\u5373\u62A2\u8D2D")))))));})));}}]);return PipelineHotSellRankList;}(__WEBPACK_IMPORTED_MODULE_24_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineHotSellRankList);

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_set_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_object_get_prototype_of_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_reflect_construct_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_object_create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_object_define_property_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_object_assign_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_less__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_less__);
function _typeof(obj){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj;}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;},_typeof(obj);}function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};return _extends.apply(this,arguments);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);Object.defineProperty(Constructor,"prototype",{writable:false});return Constructor;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function");}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,writable:true,configurable:true}});Object.defineProperty(subClass,"prototype",{writable:false});if(superClass)_setPrototypeOf(subClass,superClass);}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=_getPrototypeOf(Derived),result;if(hasNativeReflectConstruct){var NewTarget=_getPrototypeOf(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return _possibleConstructorReturn(this,result);};}function _possibleConstructorReturn(self,call){if(call&&(_typeof(call)==="object"||typeof call==="function")){return call;}else if(call!==void 0){throw new TypeError("Derived constructors may only return object or undefined");}return _assertThisInitialized(self);}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}var PipelineFloorBarTitle=/*#__PURE__*/function(_React$Component){_inherits(PipelineFloorBarTitle,_React$Component);var _super=_createSuper(PipelineFloorBarTitle);function PipelineFloorBarTitle(props){_classCallCheck(this,PipelineFloorBarTitle);return _super.call(this,props);}_createClass(PipelineFloorBarTitle,[{key:"formatTitle",value:function formatTitle(title,maxChineseChars){var result='';var count=0;for(var i=0;i<title.length;i++){var _char=title[i];var isChinese=/[\u4e00-\u9fa5]/.test(_char);var weight=isChinese?1:0.5;if(count+weight>maxChineseChars)break;result+=_char;count+=weight;}return result;}},{key:"render",value:function render(){var baseConfig=this.props.config.baseConfig;var moduleMarginTop=baseConfig.moduleMarginTop,title=baseConfig.title,titleColor=baseConfig.titleColor,titleStyle=baseConfig.titleStyle,leftImg=baseConfig.leftImg,rightImg=baseConfig.rightImg;var displayTitle=this.formatTitle(title,8);var leftImgUrl=titleStyle==='自定义样式'?leftImg||'':"https://static.shihuocdn.cn/admin/files/20260212/73b5a345869ec5fb7b07c89886278986.png";var rightImgUrl=titleStyle==='自定义样式'?rightImg||'':"https://static.shihuocdn.cn/admin/files/20260212/cb7616c822cbd5759718a8ef20ff8a64.png";return/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",_extends({className:"pipeline-floorBarTitle",id:this.props['customAttributes']['data-component-id']},this.props['customAttributes'],{style:{marginTop:"".concat(moduleMarginTop,"px")}}),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"leftImg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img",{src:leftImgUrl,alt:""})),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"title",style:{color:titleColor||'#333333'}},displayTitle),/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:"rightImg"},/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("img",{src:rightImgUrl,alt:""})));}}]);return PipelineFloorBarTitle;}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PipelineFloorBarTitle);

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = interveneTest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_array_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es7_array_includes_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es7_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es7_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_for_each_js__);
// 页面干预逻辑
function interveneTest(pipelineComponents,pageId,group){if(pageId==='17675052474380033'){// 美妆-26年货节会场
if(group==='B'){// 实验组需要过滤掉白名单中的组件
var whiteList=['pipeline-imgList-1760532328610','pipeline-tab-1747367798794','pipeline-tabItem-1767684951256','pipeline-tabItem-1767684950989','pipeline-imgList-1732675745105','pipeline-rank-1745496956488','pipeline-rank-1747363276414','pipeline-rank-1747363278410','pipeline-rank-1747363350932','pipeline-rank-1760532598837','pipeline-imgList-1747373949398','pipeline-rank-1747363971378','pipeline-rank-1747364005780','pipeline-rank-1747364007693','pipeline-rank-1747373854192','pipeline-rank-1747373882002','pipeline-rank-1760533925227','pipeline-rank-1760533617865','pipeline-goodsRecommend-1769665913631','navigation-bar'];/**
       * 递归过滤组件函数
       * @param {Array} components 组件数组
       * @returns {Array} 过滤后的组件数组
       */var filterComponents=function filterComponents(components){if(!Array.isArray(components))return components;return components.filter(function(comp){// 1. pipeline-ab 特殊处理：保留且不处理内部组件
if(comp.name==='pipeline-ab'){return true;}// 2. 命中白名单的组件保留
var isWhitelisted=whiteList.includes(comp.id);// 3. 处理递归逻辑 (pipeline-tab 和 pipeline-tabItem)
if(comp.name==='pipeline-tabItem'){// pipeline-tabItem 的 data 是组件数组
if(Array.isArray(comp.data)){comp.data=filterComponents(comp.data);}}else if(comp.name==='pipeline-tab'){// pipeline-tab 的 grains 下有 components 数组
var grains=comp.data.containerConfig.grains;if(Array.isArray(grains)){grains.forEach(function(grain){if(Array.isArray(grain.components)){// pipeline-tab 的子组件结构是 { component: 'id' }
grain.components=grain.components.filter(function(item){return whiteList.includes(item.component);});}});}}return isWhitelisted;});};return filterComponents(pipelineComponents);}else{// 对照组过滤掉推荐信息流组件
pipelineComponents=pipelineComponents.filter(function(comp){return comp.id!=='pipeline-goodsRecommend-1769665913631';});}}return pipelineComponents;}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = {"classifyName":"","title":"","pageScene":"","startTime":"","endTime":"","backgroundColor":"#FFFFFF","shareTitle":"","shareContent":"","shareImg":"","navigatorBarTranslucent":"是","searchBoxDisplay":"否","searchWords":"","searchGuideText":"","searchGuideColor":"","navigatorBarTheme":"黑","abTestEnable":"否","abPreviewValue":"A","abPercent":50,"commentEnable":"否","ruleEntryShow":"否","ruleEntryHref":"","dataSource":[],"dataSourceStr":"","createTime":""}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = {"classifyName":"","title":"","pageScene":"","startTime":"","endTime":"","backgroundColor":"#FFFFFF","shareTitle":"","shareContent":"","shareImg":"","navigatorBarTranslucent":"是","searchBoxDisplay":"否","searchWords":"","searchGuideText":"","searchGuideColor":"","navigatorBarTheme":"黑","abTestEnable":"否","abPreviewValue":"A","abPercent":50,"commentEnable":"否","ruleEntryShow":"否","ruleEntryHref":"","dataSource":[],"dataSourceStr":"","createTime":""}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = [{"id":"pipeline-imgList-1769763696660","name":"pipeline-imgList","data":{"baseConfig":{"sortType":"banner","layout_1":{"moduleMarginTop":"0","moduleMarginHorizon":"12","imgMarginVertical":"0","imgMarginHorizon":"12"},"layout_2":{"moduleMarginTop":"0","moduleMarginHorizon":"12","imgMarginVertical":"12","imgMarginHorizon":"12"},"layout_3":{"moduleMarginTop":"0","moduleMarginHorizon":"12","imgMarginVertical":"12","imgMarginHorizon":"6"},"layout_multiple":{"moduleMarginTop":"0","moduleMarginHorizon":"0","imgMarginHorizon":"0","imgWidth":"100"},"layout_banner":{"moduleMarginTop":"0","moduleMarginHorizon":"0","imgMarginVertical":"0","imgMarginHorizon":"0"},"noImgRadius":false,"addToNav":false,"title":"","subTitle":""},"imgsList":[{"link":"","src":"https://static.shihuocdn.cn/admin/imgs/20230926/4f0eaee7813805035fad9de4711125d1_1125x489.png"}]}},{"id":"pipeline-productGather-1769763367546","name":"pipeline-productGather","data":{"baseConfig":{"showTitle":false,"showGradientColor":false,"addToNav":true,"titleBgImage":"https://static.shihuocdn.cn/admin/imgs/20251113/9a0e30a3aeb0092741d6e171156f0d16_251x516.png","moduleMarginTop":"12","browserMoreHref":""},"cardBaseConfig":{"slideType":"单行商品滑动","productType":"商品id","sortType":"GMV","shihuoSubsidy":"否","showRectImg":"否"},"cardInfoConfig":{"priceInfo":"销量","benefit":"单位价格","unitPriceReplacePrice":true},"itemList":[{"id":"602587","name":"HR/赫莲娜 黑绷带面霜 玻色因溶液抗皱紧致修复抗老化舒缓淡纹活颜","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"舒缓肌肤 减缓眼部细纹暗沉 有效抗老","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=602587&styleId=714415424&topStyleId=714415424&imgId=207303590","productImageCustom":"http://static.shihuocdn.cn/common/b713696d2c344ce285089af0200a0620.jpeg"},{"id":"593217","name":"Kiehl's/科颜氏 角鲨烷高保湿面霜 补水滋润修护舒缓防干裂","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"深层补水 强韧肌肤 神经酰胺 修护肌肤","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593217&styleId=441801507&topStyleId=441801507&imgId=207289940","productImageCustom":"http://static.shihuocdn.cn/common/9518ea4ac52f4dfca58aee048676cfe8.jpeg"},{"id":"1558971","name":"C咖 氨基酸祛痘双管洗面奶 控油净痘清洁黑头毛孔清透油修护敏感肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"一清一洗 洗卸合一","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=1558971&styleId=850770613&topStyleId=850770613&imgId=218662588","productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wMy1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MTEyOTEzMjkxMjZGRUJBNUMzNTQxOUM5NTZGOEVFLTM4MDgtMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UtdjEuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc2NDQ4MDU1NSZ4LXNpZ25hdHVyZT1mSm03byUyRlUlMkY2MVVRbWgxVENLbkRlNTF1VVhnJTNE"},{"id":"593204","name":"LA MER/海蓝之谜 焕新精粹水精华水 控油保湿提亮修护淡纹抗老抗皱舒缓","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"澎湃能量水 肌肤活力源 调节水油 保湿功效","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593204&styleId=34754006&topStyleId=34754006&imgId=207355248","productImageCustom":"http://static.shihuocdn.cn/common/9170fd7c8f8a45519cc621949c53aa9f.jpeg"},{"id":"628103","name":"laroche posay/理肤泉 B5多效修复面霜 补水保湿淡化痘印屏障修护舒缓泛红印痕祛痘","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"淡化印痕痘印 呵护受损肌肤 多重修复锁水","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=628103&styleId=838738825&topStyleId=838738825&imgId=216294376","productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wOS1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MTExOTE3NTUxMEZFRDYzNUEzMTE2QzU4N0I5OEY2LTMyODEtMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UtdjEuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc2MzYzMjUxMSZ4LXNpZ25hdHVyZT1CJTJCSGJGcTNtVFBSUGVodkNQeHlzbTZra0lLRSUzRA"},{"id":"567118","name":"Freeplus/芙丽芳丝 氨基酸净润洁面奶 温和保湿清洁焕亮敏肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"洁面界黑马 油痘肌必备 清洁修护两手抓 ","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=567118&styleId=51126484&topStyleId=51126484&imgId=169672751","productImageCustom":"http://static.shihuocdn.cn/goods/locrevise/20250706/8ba7f42a-5a66-11f0-8519-d6a4b3869ac4_1181x1181.jpeg"},{"id":"1755070","name":"CeraVe/适乐肤 水杨酸温和嫩肤泡沫洁面啫喱 清洁保湿控油祛痘去闭口去黑头去角质疏通毛孔油痘肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"3重神经酰胺 呵护肌肤屏障","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=1755070&styleId=147273813&topStyleId=147273813&imgId=182294824","productImageCustom":"http://static.shihuocdn.cn/common/0f3f4c838ae64453943b5e78f1409052.jpeg"},{"id":"4727605","name":"【男士专用】海洋至尊 三棱镜氨基酸洁面乳 保湿控乳油祛痘长效清洁黑头双效合一","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=4727605&styleId=140882980&topStyleId=140882980&imgId=183574438","productImageCustom":"http://static.shihuocdn.cn/common/12086ef4ea9e45b58c7e9572ef4cbb68.jpeg"}],"itemCollectionList":[],"componentSize":{"width":"350.486","height":"347.483","delayLoad":true}}},{"id":"pipeline-productGather-1769763670464","name":"pipeline-productGather","data":{"baseConfig":{"showTitle":false,"showGradientColor":false,"addToNav":true,"titleBgImage":"https://static.shihuocdn.cn/admin/imgs/20251113/2cddce5717d5da8ca4870958977464e9_288x1043.png","moduleMarginTop":"4","browserMoreHref":""},"cardBaseConfig":{"slideType":"双行商品滑动","productType":"商品id","sortType":"GMV","shihuoSubsidy":"否","showRectImg":"否"},"cardInfoConfig":{"priceInfo":"销量","benefit":"单位价格","unitPriceReplacePrice":true},"itemList":[{"id":"602587","name":"HR/赫莲娜 黑绷带面霜 玻色因溶液抗皱紧致修复抗老化舒缓淡纹活颜","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"舒缓肌肤 减缓眼部细纹暗沉 有效抗老","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=602587&styleId=714415424&topStyleId=714415424&imgId=207303590","productImageCustom":"http://static.shihuocdn.cn/common/b713696d2c344ce285089af0200a0620.jpeg"},{"id":"593217","name":"Kiehl's/科颜氏 角鲨烷高保湿面霜 补水滋润修护舒缓防干裂","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"深层补水 强韧肌肤 神经酰胺 修护肌肤","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593217&styleId=441801507&topStyleId=441801507&imgId=207289940","productImageCustom":"http://static.shihuocdn.cn/common/9518ea4ac52f4dfca58aee048676cfe8.jpeg"},{"id":"1558971","name":"C咖 氨基酸祛痘双管洗面奶 控油净痘清洁黑头毛孔清透油修护敏感肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"一清一洗 洗卸合一","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=1558971&styleId=850770613&topStyleId=850770613&imgId=218662588","productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wMy1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MTEyOTEzMjkxMjZGRUJBNUMzNTQxOUM5NTZGOEVFLTM4MDgtMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UtdjEuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc2NDQ4MDU1NSZ4LXNpZ25hdHVyZT1mSm03byUyRlUlMkY2MVVRbWgxVENLbkRlNTF1VVhnJTNE"},{"id":"593204","name":"LA MER/海蓝之谜 焕新精粹水精华水 控油保湿提亮修护淡纹抗老抗皱舒缓","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"澎湃能量水 肌肤活力源 调节水油 保湿功效","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593204&styleId=34754006&topStyleId=34754006&imgId=207355248","productImageCustom":"http://static.shihuocdn.cn/common/9170fd7c8f8a45519cc621949c53aa9f.jpeg"},{"id":"628103","name":"laroche posay/理肤泉 B5多效修复面霜 补水保湿淡化痘印屏障修护舒缓泛红印痕祛痘","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"淡化印痕痘印 呵护受损肌肤 多重修复锁水","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=628103&styleId=838738825&topStyleId=838738825&imgId=216294376","productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wOS1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MTExOTE3NTUxMEZFRDYzNUEzMTE2QzU4N0I5OEY2LTMyODEtMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UtdjEuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc2MzYzMjUxMSZ4LXNpZ25hdHVyZT1CJTJCSGJGcTNtVFBSUGVodkNQeHlzbTZra0lLRSUzRA"},{"id":"567118","name":"Freeplus/芙丽芳丝 氨基酸净润洁面奶 温和保湿清洁焕亮敏肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"洁面界黑马 油痘肌必备 清洁修护两手抓 ","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=567118&styleId=51126484&topStyleId=51126484&imgId=169672751","productImageCustom":"http://static.shihuocdn.cn/goods/locrevise/20250706/8ba7f42a-5a66-11f0-8519-d6a4b3869ac4_1181x1181.jpeg"},{"id":"1755070","name":"CeraVe/适乐肤 水杨酸温和嫩肤泡沫洁面啫喱 清洁保湿控油祛痘去闭口去黑头去角质疏通毛孔油痘肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"3重神经酰胺 呵护肌肤屏障","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=1755070&styleId=147273813&topStyleId=147273813&imgId=182294824","productImageCustom":"http://static.shihuocdn.cn/common/0f3f4c838ae64453943b5e78f1409052.jpeg"},{"id":"4727605","name":"【男士专用】海洋至尊 三棱镜氨基酸洁面乳 保湿控乳油祛痘长效清洁黑头双效合一","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=4727605&styleId=140882980&topStyleId=140882980&imgId=183574438","productImageCustom":"http://static.shihuocdn.cn/common/12086ef4ea9e45b58c7e9572ef4cbb68.jpeg"},{"id":"609701","name":"Kiehl's/科颜氏 亚马逊白泥涂抹式泥膜面膜 清洁毛孔补水去黑头控油","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"黑头克星 深层清洁 收缩毛孔 ","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=609701&styleId=714399284&topStyleId=714399284&imgId=206966516","productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wMjYtYWlvcC1zaWduLmJ5dGVpbWcuY29tL3Rvcy1jbi1pLXZ1cWhvcmg1OWkvMjAyNTEwMTYxNTI0MjI1QzI1RDEwNDk2QjgyNEE3QjE4MS0yNjg0LTB-dHBsdi12dXFob3JoNTlpLWltYWdlLXYxLmltYWdlP3JrM3M9N2Y5ZTcwMmQmeC1leHBpcmVzPTE3NjA2ODU4NjMmeC1zaWduYXR1cmU9dEV3RExNWTY0dm5jTXNEdnM4R00lMkZCdHpOY1ElM0Q"},{"id":"1182409","name":"smpcare/溪木源 氨基酸慕斯洗面奶 云朵泡沫绵密清洁毛孔温和敏肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"氨基酸工艺 敏感肌专研 温和清洁","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=1182409&styleId=47183301&topStyleId=47183301&imgId=109383273","productImageCustom":"http://static.shihuocdn.cn/goods/locrevise/20240609/AFDFA3E161264750952FCBCAF7C9A7D2_2500x2500.jpeg"},{"id":"820496","name":"Rellet/颐莲 玻尿酸喷雾 长效深层补水保湿小分子","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"细腻水雾 深层补水镇定 舒缓肌肤 ","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=820496&styleId=7029013&topStyleId=7029013&imgId=207337919","productImageCustom":"http://static.shihuocdn.cn/common/7e52b8076e3e44389922ea17802a05d3.jpeg"},{"id":"3888552","name":"Peterson’s Lab/毕生之研 厚脸皮屏障修护精华水 保湿舒缓褪红提亮","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=3888552&imgId=207169394","productImageCustom":"http://static.shihuocdn.cn/goods/locrevise/20251017/8a9571f8-ab0a-11f0-a8ae-96058044d6f3_895x895.jpeg"},{"id":"614352","name":"CeraVe/适乐肤 C乳神经酰胺乳液 屏障修护长效保湿","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"神经酰胺 透明质酸 全天水润 敏感肌适用","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=614352&styleId=261557329&topStyleId=261557329&imgId=149780186","productImageCustom":"http://static.shihuocdn.cn/common/2b035c43bbb44b50852514646e5afb5f.jpeg"},{"id":"593233","name":"Curel/珂润 润浸保湿面霜 修护舒缓","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"干燥敏感肌必备面霜 持久水润 滋润修护 ","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593233&styleId=4924383&topStyleId=4924383&imgId=132121295","productImageCustom":"http://static.shihuocdn.cn/common/5e3a135859ee47d789d1ff8b6ff0b3c8.jpeg"},{"id":"731197","name":"PROYA/珀莱雅 双抗精华液 保湿透亮抗氧化抗氧糖淡纹去黄提亮","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"抗氧抗糖抗初老 肌肤日益鲜活透亮","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=731197&styleId=641072301&topStyleId=641072301&imgId=185026607","productImageCustom":"http://static.shihuocdn.cn/common/7d9f97eb71174cb5b7ab1e4d781fabe7.jpeg"},{"id":"7718901","name":"ddg 卸妆膏 温和深层清洁不糊眼敏肌","useCustomName":false,"productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=7718901&styleId=869235873&topStyleId=869235873&imgId=222208326","productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wOS1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MDcxNjE4MTAxOEI0MENDQkZGQzNFNEVDNTFDRDE1LTQxOTgtMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc1Mjc0NzAxOSZ4LXNpZ25hdHVyZT1OY1djY0dEb2slMkJ5R3o5RnE4Z1lRczkwcDNYUSUzRA"}],"itemCollectionList":[],"componentSize":{"width":"350.486","height":"347.483","delayLoad":true}}},{"id":"pipeline-product-1769762879664","name":"pipeline-product","data":{"baseConfig":{"showTitle":false,"showSubTitle":false,"addToNav":false,"showFoldBtn":false,"title":"一行二","subTitle":"","titleColor":"#ffffff","titleColorRow":"#333333","priceColor":"#ff4338","priceInfoColor":"#999999","dataSourceType":"手动导入"},"cardBaseConfig":{"productCardType":"常规样式","productStyle":"一行两个","layout_2":{"moduleMarginTop":"12","moduleMarginHorizon":"12","itemMargin":"8"},"productType":"商品id","sortType":"GMV","shihuoSubsidy":"否","showRectImg":"否","titleBgImage":"","titleImageSize":{"width":"","height":""},"titlePrefixImage":"","moduleBgColor":"#000000","imgUrl":"","imgLink":"","productNameColor":"#333333","productTagColor":"#c28a58","priceIcon":"","markIcon":"","cardBackground":"","cardBackgroundColor":"#ffffff"},"cardInfoConfig":{"priceInfo":"原价","saleNum":"销量","newUserPrice":"无","benefitLabel":"","slogen":true,"unitPrice":true,"unitPriceReplacePrice":true,"priority":"优先展示推荐理由"},"itemList":[{"id":"736751","name":"SK-II 神仙水清莹露丝带护肤礼盒 保湿滋润控油提亮紧致抗老淡纹","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/ed3338f087fc4dd0a4b46d8123223b50.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"补水保湿 收缩毛孔 淡化细纹 弹力紧致","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=736751&styleId=542277438&topStyleId=542277438&imgId=183386958","markIconCustom":"","actionButtonCustom":""},{"id":"593124","name":"SK-II 神仙水精华液 平衡水油补水保湿抗老淡纹提亮","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/83c658a8cb3b47ddaa0b4aec6c00d644.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"油痘肌挚爱神仙水 细嫩弹润 维稳修护","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593124&styleId=4922421&topStyleId=4922421&imgId=109454295","markIconCustom":"","actionButtonCustom":""},{"id":"602587","name":"HR/赫莲娜 黑绷带面霜 玻色因溶液抗皱紧致修复抗老化舒缓淡纹活颜","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/b713696d2c344ce285089af0200a0620.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"舒缓肌肤 减缓眼部细纹暗沉 有效抗老","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=602587&styleId=714415424&topStyleId=714415424&imgId=207303590","markIconCustom":"","actionButtonCustom":""},{"id":"5072100","name":"SK-II 神仙水护肤礼盒 修护保湿提亮晶透润泽抗老","useCustomName":false,"productImageCustom":"https://proxy.shihuocdn.cn/aHR0cHM6Ly9wMjYtYWlvcC1zaWduLmJ5dGVpbWcuY29tL3Rvcy1jbi1pLXZ1cWhvcmg1OWkvMjAyNTA3MTcxNzEwMjI1RTE4QzcwM0E0MjJBODBDODVGQi0yNDI2LTB-dHBsdi12dXFob3JoNTlpLWltYWdlLmltYWdlP3JrM3M9N2Y5ZTcwMmQmeC1leHBpcmVzPTE3NTI4Mjk4MjMmeC1zaWduYXR1cmU9YkdiUUlob2xxVnN6VnQxeElXZGhwOGlUbHU0JTNE","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=5072100&styleId=158617388&topStyleId=158617388&imgId=49898964","markIconCustom":"","actionButtonCustom":""}],"itemCollectionList":[],"componentSize":{"width":"350.486","height":"2721.88","delayLoad":true}}},{"id":"pipeline-product-1769763264992","name":"pipeline-product","data":{"baseConfig":{"showTitle":false,"showSubTitle":false,"addToNav":false,"showFoldBtn":false,"title":"一行三","subTitle":"","titleColor":"#ffffff","titleColorRow":"#333333","priceColor":"#ff4338","priceInfoColor":"#999999","dataSourceType":"手动导入"},"cardBaseConfig":{"productCardType":"常规样式","productStyle":"一行三个","layout_3":{"moduleMarginTop":"4","moduleMarginHorizon":"12","itemMargin":"4"},"productType":"商品id","sortType":"GMV","shihuoSubsidy":"否","showRectImg":"否","titleBgImage":"","titleImageSize":{"width":"","height":""},"titlePrefixImage":"","moduleBgColor":"#000000","imgUrl":"","imgLink":"","productNameColor":"#333333","productTagColor":"#c28a58","priceIcon":"","markIcon":"","cardBackground":"","cardBackgroundColor":"#ffffff"},"cardInfoConfig":{"priceInfo":"无","saleNum":"销量","newUserPrice":"无","benefitLabel":"","slogen":true,"unitPrice":true,"unitPriceReplacePrice":true,"priority":"优先展示推荐理由"},"itemList":[{"id":"736751","name":"SK-II 神仙水清莹露丝带护肤礼盒 保湿滋润控油提亮紧致抗老淡纹","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/ed3338f087fc4dd0a4b46d8123223b50.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"补水保湿 收缩毛孔 淡化细纹 弹力紧致","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=736751&styleId=542277438&topStyleId=542277438&imgId=183386958","markIconCustom":"","actionButtonCustom":""},{"id":"593124","name":"SK-II 神仙水精华液 平衡水油补水保湿抗老淡纹提亮","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/83c658a8cb3b47ddaa0b4aec6c00d644.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"油痘肌挚爱神仙水 细嫩弹润 维稳修护","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593124&styleId=4922421&topStyleId=4922421&imgId=109454295","markIconCustom":"","actionButtonCustom":""},{"id":"602587","name":"HR/赫莲娜 黑绷带面霜 玻色因溶液抗皱紧致修复抗老化舒缓淡纹活颜","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/b713696d2c344ce285089af0200a0620.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"舒缓肌肤 减缓眼部细纹暗沉 有效抗老","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=602587&styleId=714415424&topStyleId=714415424&imgId=207303590","markIconCustom":"","actionButtonCustom":""},{"id":"5072100","name":"SK-II 神仙水护肤礼盒 修护保湿提亮晶透润泽抗老","useCustomName":false,"productImageCustom":"https://proxy.shihuocdn.cn/aHR0cHM6Ly9wMjYtYWlvcC1zaWduLmJ5dGVpbWcuY29tL3Rvcy1jbi1pLXZ1cWhvcmg1OWkvMjAyNTA3MTcxNzEwMjI1RTE4QzcwM0E0MjJBODBDODVGQi0yNDI2LTB-dHBsdi12dXFob3JoNTlpLWltYWdlLmltYWdlP3JrM3M9N2Y5ZTcwMmQmeC1leHBpcmVzPTE3NTI4Mjk4MjMmeC1zaWduYXR1cmU9YkdiUUlob2xxVnN6VnQxeElXZGhwOGlUbHU0JTNE","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=5072100&styleId=158617388&topStyleId=158617388&imgId=49898964","markIconCustom":"","actionButtonCustom":""},{"id":"593166","name":"CLARINS/娇韵诗 黄金双萃赋活精华液 御龄紧致抗皱抗老淡纹保湿修护轻感","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/10b2c3fd953e4654a23facf14bc9192b.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"焕活肌肤 植萃保护 紧实弹润 细腻毛孔","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593166&styleId=4922321&topStyleId=4922321&imgId=207341847","markIconCustom":"","actionButtonCustom":""},{"id":"712329","name":"Estee lauder/雅诗兰黛 小棕瓶精华 补水保湿抗老修护淡纹","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/e88f2216e683494ca58e12a7239734c8.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"平滑抚纹 弹力紧实 匀净透亮 拥有自然光泽肌肤","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=712329&styleId=5721125&topStyleId=5721125&imgId=183574174","markIconCustom":"","actionButtonCustom":""},{"id":"1558971","name":"C咖 氨基酸双管洗面奶 控油净痘清洁黑头毛孔清透油","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/cd340f11bd57407faa6da72ededa1a34.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"一清一洗 洗卸合一","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=1558971&styleId=48914475&topStyleId=48914475&imgId=182294513","markIconCustom":"","actionButtonCustom":""},{"id":"593227","name":"Esteelauder/雅诗兰黛 紧塑胶原面霜 抗老紧致修护淡纹","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/59d9c9357e514c80b1a78230dd4b408c.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"深彻滋养 淡褪细纹 嫩滑娇柔肌肤","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593227&styleId=5495726&topStyleId=5495726&imgId=207300574","markIconCustom":"","actionButtonCustom":""},{"id":"593217","name":"Kiehl's/科颜氏 角鲨烷高保湿面霜 补水滋润修护舒缓防干裂","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/common/aafcbf1b7d1f4a6b8cb2598e4021c5fa.jpeg","productPrice":"","recommendType":"推荐理由","recommend":"深层补水 强韧肌肤 神经酰胺 修护肌肤","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=593217&styleId=4923004&topStyleId=4923004&imgId=207294928","markIconCustom":"","actionButtonCustom":""},{"id":"8269768","name":"young dream 美肤面罩仪 淡印嫩肤亮白大小排灯家用","useCustomName":false,"productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wOS1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MTAyMjEwNTkwMDY2OUExMDQzMTBBM0I2OEZDRDc4LTUxNzItMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UtdjEuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc2MTE4ODM0MSZ4LXNpZ25hdHVyZT1RVW5kNkVKRVRxa216ejNwUU93dXZaRXVzdE0lM0Q","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=8269768&styleId=804345648&topStyleId=804345648&imgId=208492050","markIconCustom":"","actionButtonCustom":""},{"id":"8223128","name":"润百颜 玻尿酸白纱布屏障调理次抛精华液 修护维稳舒缓","useCustomName":false,"productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wMjYtYWlvcC1zaWduLmJ5dGVpbWcuY29tL3Rvcy1jbi1pLXZ1cWhvcmg1OWkvMjAyNTEwMTQxMTU2MDcwQUU0RDlBNzY5QzMyRkFDN0QwNi02OTE4LTB-dHBsdi12dXFob3JoNTlpLWltYWdlLXYxLmltYWdlP3JrM3M9N2Y5ZTcwMmQmeC1leHBpcmVzPTE3NjA1MDA1NjgmeC1zaWduYXR1cmU9ODZZbWFKJTJCZE85YyUyQndEaFZZdUJ4SmJBbGN3byUzRA","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=8223128&styleId=795029587&topStyleId=795029587&imgId=206359754","markIconCustom":"","actionButtonCustom":""},{"id":"8336355","name":"CURRENTBODY 6合1兜底多维面罩美容仪 祛痘","useCustomName":false,"productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wMy1haW9wLXNpZ24uYnl0ZWltZy5jb20vdG9zLWNuLWktdnVxaG9yaDU5aS8yMDI1MTEwMzIwMTA1NjY1NjI5RTQ5QkQ0N0FDMTc5Q0U3LTYxMDctMH50cGx2LXZ1cWhvcmg1OWktaW1hZ2UtdjEuaW1hZ2U_cmszcz03ZjllNzAyZCZ4LWV4cGlyZXM9MTc2MjI1ODI1OCZ4LXNpZ25hdHVyZT1ZNjZocnolMkZwWlR6VElwVyUyRjNlR0N6dUIxam9jJTNE","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=8336355&styleId=819552617&topStyleId=819552617&imgId=211732555","markIconCustom":"","actionButtonCustom":""},{"id":"8372157","name":"光渐 抛光精华液 祛痘去黑头闭口控油痘肌VC提亮肤色","useCustomName":false,"productImageCustom":"http://proxy.shihuocdn.cn/aHR0cHM6Ly9wMjYtYWlvcC1zaWduLmJ5dGVpbWcuY29tL3Rvcy1jbi1pLXZ1cWhvcmg1OWkvMjAyNTExMTEyMTI0MTVBRjlCQzNCQjlGQTVDMDIxMjVFOS00NzU0LTB-dHBsdi12dXFob3JoNTlpLWltYWdlLXYxLmltYWdlP3JrM3M9N2Y5ZTcwMmQmeC1leHBpcmVzPTE3NjI5NTM4NTYmeC1zaWduYXR1cmU9YXJTS2Fuc3YlMkJIdmpMOTJIOCUyQmI3WEY5OEQ4NCUzRA","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=8372157&styleId=829571480&topStyleId=829571480&imgId=214229875","markIconCustom":"","actionButtonCustom":""},{"id":"8551403","name":"Kiehl's/科颜氏 高保湿急护霜 敏感肌舒缓褪红修护屏障","useCustomName":false,"productImageCustom":"http://static.shihuocdn.cn/goods/locrevise/20251224/718BE316FA0843A9AA5D2F1E59E66F22_1445x1445.png","productPrice":"","recommendType":"推荐理由","recommend":"","shoppersLabel":"单位价格","shoppersLabelText":"","productHref":"shihuo://www.shihuo.cn?route=goodsDetail&detailRouteType=common&grade=4&id=8551403&styleId=879484868&topStyleId=879484868&imgId=224190262","markIconCustom":"","actionButtonCustom":""}],"itemCollectionList":[],"componentSize":{"width":"350.486","height":"2721.88","delayLoad":true}}}]

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = undefined;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  =====================================================================
 * @tencent/aegis-web-sdk@1.24.47 (c) 2021 Tencent Application Monitor.
 * Author pumpkincai.
 * Last Release Time Fri Dec 17 2021 14:45:25 GMT+0800 (GMT+08:00).
 * Released under the MIT License.
 * Thanks for supporting TAM & Aegis!
 * =====================================================================
 **/
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Aegis=t()}(this,function(){"use strict";var t,n;function e(e){this.name="__st"+(1e9*Math.random()>>>0)+t+"__",null==e||e.forEach(this.add,this),t+=1}Array.prototype.find||Object.defineProperty(Array.prototype,"find",{configurable:!0,writable:!0,value:function(e){if(null===this)throw new TypeError('"this" is null or not defined');var t=Object(this),n=t.length>>>0;if("function"!=typeof e)throw new TypeError("predicate must be a function");for(var i=arguments[1],o=0;o<n;){var r=t[o];if(e.call(i,r,o,t))return r;o+=1}}}),String.prototype.startsWith||Object.defineProperty(String.prototype,"startsWith",{value:function(e,t){return this.substring(t=!t||t<0?0:+t,t+e.length)===e}}),window.WeakSet||(t=Date.now()%1e9,e.prototype.add=function(e){var t=this.name;return e[t]||Object.defineProperty(e,t,{value:!0,writable:!0}),this},e.prototype.delete=function(e){return!!e[this.name]&&!(e[this.name]=void 0)},e.prototype.has=function(e){return!!e[this.name]},n=e,Object.defineProperty(window,"WeakSet",{value:function(e){return new n(e)}})),Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:function(e){if(null==e)throw new TypeError("Cannot convert first argument to object");for(var t=Object(e),n=1;n<arguments.length;n++)if(null!=(i=arguments[n]))for(var i=Object(i),o=Object.keys(Object(i)),r=0,s=o.length;r<s;r++){var a=o[r],u=Object.getOwnPropertyDescriptor(i,a);null!=u&&u.enumerable&&(t[a]=i[a])}return t}});var i=function(e,t){return(i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])})(e,t)},E=function(){return(E=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function u(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;for(var i=Array(e),o=0,t=0;t<n;t++)for(var r=arguments[t],s=0,a=r.length;s<a;s++,o++)i[o]=r[s];return i}function R(e){return(e=Array.isArray(e)?e:[e]).map(function(t,n){return Object.getOwnPropertyNames(t).map(function(e){return o(e)+"["+n+"]="+(void 0===t[e]?"":o(t[e]))}).join("&")}).join("&")+(e.length?"&count="+e.length:"")}var h,r=(s.prototype.indexOf=function(e,t){for(var n=0;n<e.length;n++)if(e[n].callback===t)return n;return-1},s.prototype.on=function(e,t,n){if(void 0===n&&(n=0),this){var i=this.eventsList[e];return(i||(this.eventsList[e]=[],i=this.eventsList[e]),-1!==this.indexOf(i,t))?this:(i.push({name:e,type:n||0,callback:t}),this)}},s.prototype.one=function(e,t){this.on(e,t,1)},s.prototype.remove=function(e,t){if(this){var n=this.eventsList[e];if(!n)return null;if(t)return n.length&&(t=this.indexOf(n,t),n.splice(t,1)),this;try{delete this.eventsList[e]}catch(e){}return null}},s.prototype.clear=function(){this.eventsList={}},s),o=function(t){try{return encodeURIComponent(decodeURIComponent(t))}catch(e){return t}};function s(){var s=this;this.emit=function(e,t){if(s){var n;if(null!=(i=s.eventsList[e])&&i.length)for(var i=i.slice(),o=0;o<i.length;o++){n=i[o];try{var r=n.callback.apply(s,[t]);if(1===n.type&&s.remove(e,n.callback),!1===r)break}catch(e){throw e}}return s}},this.eventsList={}}(se=h=h||{})[se.number=-1]="number",se.string="";function a(e,t){return"number"==typeof e||"string"==typeof e?e:t?h.string:h.number}function g(e,t){return"string"==typeof e?e.split("?")[t?1:0]||"":e}function v(e){return"string"==typeof e&&e.startsWith("//")?"undefined"!=typeof location&&"https:"===location.protocol:/^https/.test(e)}function f(t){return l.some(function(e){return-1!==t.indexOf(e)})}var O,T,c,l=["application/octet-stream","application/xhtml+xml","application/xml","application/pdf","application/pkcs12","application/javascript","application/ecmascript","application/vnd.mspowerpoint","application/ogg","text/html","text/css","text/javascript","image","audio","video"],d=["ret","retcode","code","errcode"],m=function(e,t,n){var i;try{if("function"==typeof(null==t?void 0:t.retCodeHandler)){var o=t.retCodeHandler(e,null==n?void 0:n.url,null==n?void 0:n.ctx)||{};return{code:void 0===(r=o.code)?"unknown":r,isErr:o.isErr}}"string"==typeof e&&(e=JSON.parse(e)),"function"==typeof(null===(i=null==t?void 0:t.ret)||void 0===i?void 0:i.join)&&(d=[].concat(t.ret.map(function(e){return e.toLowerCase()})));var r,s=Object.getOwnPropertyNames(e).filter(function(e){return-1!==d.indexOf(e.toLowerCase())});return s.length?{code:""+(r=Number(e[s[0]])),isErr:0!==r}:{code:"unknown",isErr:!1}}catch(e){return{code:"unknown",isErr:!1}}},L=function(e){if("string"==typeof e)return e;try{return(JSON.stringify(e,(i=[],o=[],function(e,t){if(t instanceof Error)return"Error.message: "+t.message+" \n  Error.stack: "+t.stack;if("object"==typeof t&&null!==t){var n=i.indexOf(t);if(-1!==n)return"[Circular "+o[n]+"]";i.push(t),o.push(e||"root")}return t}),4)||"undefined").replace(/"/gim,"")}catch(e){return"error happen when aegis stringify: \n "+e.message+" \n "+e.stack}var i,o},y=function(n,i){void 0===i&&(i=3);var o,r,s,a="";return Array.isArray(n)?(a+="[",o=n.length,n.forEach(function(e,t){a+="object"==typeof e&&1<i?y(e,i-1):w(e),a+=t===o-1?"":","}),a+="]"):n instanceof Object?(a="{",r=Object.keys(n),s=r.length,r.forEach(function(e,t){"object"==typeof n[e]&&1<i?a+='"'+e+'":'+y(n[e],i-1):a+=p(e,n[e]),a+=t===s-1||t<s-1&&void 0===n[r[t+1]]?"":","}),a+="}"):a+=n,a},p=function(e,t){var n=typeof t,i="";return"string"==n||"object"==n?i+='"'+e+'":"'+t+'"':"function"==typeof t?i+='"'+e+'":"function '+t.name+'"':"symbol"==typeof t?i+='"'+e+'":"symbol"':"number"!=typeof t&&"boolean"!=n||(i+='"'+e+'": '+t),i},w=function(e){var t=typeof e;return""+("undefined"==t||"symbol"==t||"function"==t?"null":"string"==t||"object"==t?'"'+e+'"':e)},b=(P.prototype.sourceURL=function(){return this.data.responseURL},P.prototype.status=function(){return Number(this.data.status)},P.prototype.headers=function(){var e=this.data.getAllResponseHeaders().split("\n"),n={};return e.forEach(function(e){var t;e&&(e=(t=e.split(": "))[0],t=t[1].trim(),n[e]=t)}),n},P),S=(x.prototype.sourceURL=function(){return this.data.url},x.prototype.status=function(){return Number(this.data.status)},x.prototype.headers=function(){var n={};return this.data.headers.forEach(function(e,t){n[t]=e}),n},x);function x(e,t){this.type="fetch",this.data=e||{},this.data.response=t}function P(e){this.type="xhr",this.data=e}(Be=O=O||{}).INFO_ALL="-1",Be.API_RESPONSE="1",Be.INFO="2",Be.ERROR="4",Be.PROMISE_ERROR="8",Be.AJAX_ERROR="16",Be.SCRIPT_ERROR="32",Be.IMAGE_ERROR="64",Be.CSS_ERROR="128",Be.CONSOLE_ERROR="256",Be.MEDIA_ERROR="512",Be.RET_ERROR="1024",Be.REPORT="2048",Be.PV="4096",Be.EVENT="8192",(qe={})[qe.android=1]="android",qe[qe.ios=2]="ios",qe[qe.windows=3]="windows",qe[qe.macos=4]="macos",qe[qe.linux=5]="linux",qe[qe.devtools=6]="devtools",qe[qe.other=100]="other",(we={})[we.unknown=100]="unknown",we[we.wifi=1]="wifi",we[we.net2g=2]="net2g",we[we.net3g=3]="net3g",we[we.net4g=4]="net4g",we[we.net5g=5]="net5g",we[we.net6g=6]="net6g",(Re=T=T||{}).LOG="log",Re.SPEED="speed",Re.PERFORMANCE="performance",Re.OFFLINE="offline",Re.WHITE_LIST="whiteList",Re.VITALS="vitals",Re.PV="pv",Re.CUSTOM_PV="customPV",Re.EVENT="event",Re.CUSTOM="custom",Re.SDK_ERROR="sdkError",(Te=c=c||{}).production="production",Te.gray="gray",Te.pre="pre",Te.daily="daily",Te.local="local",Te.test="test",Te.others="others";function I(e){return e.filter(function(n,i){return"static"!==n.type||!e.find(function(e,t){return i!==t&&n.url===e.url&&200===n.status})})}function C(e){e.level===O.INFO_ALL&&(e.level=O.INFO)}function A(o){return function(e,t){o.lifeCycle.emit("modifyRequest",e);var n=o.config.modifyRequest;if("function"==typeof n)try{var i=n(e);"object"==typeof i&&"url"in i&&(e=i)}catch(e){console.error(e)}t(e)}}function N(i){return function(e,t){i.lifeCycle.emit("afterRequest",e);var n=i.config.afterRequest;"function"==typeof n&&!1===n(e)||t(e)}}function k(){}function _(t,n){Object.getOwnPropertyNames(t).forEach(function(e){"function"==typeof t[e]&&"constructor"!==e&&(n?n[e]="sendPipeline"===e?function(){return function(){}}:function(){}:t[e]=function(){})})}function U(t){if(t.payload){var n={};return Object.keys(t).forEach(function(e){"payload"!==e&&(n[e]=t[e])}),n}return t}function j(){return void 0!==window.performance&&"function"==typeof performance.clearResourceTimings&&"function"==typeof performance.getEntriesByType&&"function"==typeof performance.now}function F(t){if(ie.find(function(e){return e.name===t.name}))throw new Error("name '"+t.name+"' is already in hackXHR option list");var n,i;ie.push(t),!ne&&window.XMLHttpRequest&&(ne=!0,n=window.XMLHttpRequest.prototype.send,i=window.XMLHttpRequest.prototype.open,window.XMLHttpRequest.prototype.open=function(){if(this.aegisMethod=arguments[0],this.aegisUrl=arguments[1],this.aegisXhrStartTime=Date.now(),!this.sendByAegis)for(var e=0;e<ie.length;e++){var t=ie[e];try{"function"==typeof t.open&&t.open(this)}catch(e){}}return i.apply(this,arguments)},window.XMLHttpRequest.prototype.send=function(){if(!this.sendByAegis)for(var e=0;e<ie.length;e++){var t=ie[e];try{"function"==typeof t.send&&t.send(this,arguments[0])}catch(e){}}return n.apply(this,arguments)})}function q(t){var e=ie.findIndex(function(e){return e.name===t.name});-1!==e&&ie.splice(e,1)}var D,H,M=function(i,o){return function(e,t){var n=o.logCreated;if("function"!=typeof n)return i("beforeWrite",e),t(e);e=e.filter(function(e){return!1!==n(e)});return i("beforeWrite",e),t(e)}},B=function(e,n){var i,o=[],r=e.config;return e.lifeCycle.on("destroy",function(){o.length=0}),function(e,t){if(o.push(e),n&&o.length>=n)return o=I(o),t(o.splice(0,o.length)),void(i&&clearTimeout(i));i&&clearTimeout(i),i=setTimeout(function(){i=null,0<(o=I(o)).length&&t(o.splice(0,o.length))},r.delay)}},V=function(e,t){return Array.isArray(e)?t(e.map(function(e){return E(E({},e),{msg:"string"==typeof e.msg?e.msg:[].concat(e.msg).map(L).join(" ")})})):t(E(E({},e),{msg:"string"==typeof e.msg?e.msg:L(e.msg)}))},W=function(s){var e,a=!1,u=!1,t=!1,c=[];return s.lifeCycle.on("onConfigChange",function(){e&&clearTimeout(e),e=setTimeout(function(){var e,n;!t&&s.config&&(t=!0,e=s.config.whiteListUrl,(n=void 0===e?"":e)&&s.sendPipeline([function(e,t){t({url:n,type:T.WHITE_LIST,success:function(e){u=!0;try{var t=e.data||JSON.parse(e),n=t.retcode,i=t.result,o=void 0===i?{}:i;if(0===n){if(a=o.is_in_white_list,s.isWhiteList=a,o.shutdown)return void s.destroy();0<=o.rate&&o.rate<=1&&(s.config.random=o.rate,s.isGetSample=!1)}s.isWhiteList&&c.length?$(s)(c.splice(0),function(){}):!s.isWhiteList&&c.length&&(c.length=0);var r=s.config.onWhitelist;"function"==typeof r&&r(a)}catch(e){}},fail:function(e){"403 forbidden"===e&&s.destroy(),u=!0}})}],T.WHITE_LIST)(null),t=!1)},s.config.uin?50:500)}),s.lifeCycle.on("destroy",function(){c.length=0}),function(e,t){var n;a||null!==(n=null===(n=s.config)||void 0===n?void 0:n.api)&&void 0!==n&&n.reportRequest?t(e.concat(c.splice(0)).map(function(e){return C(e),e})):(e=e.filter(function(e){return e.level!==O.INFO&&e.level!==O.API_RESPONSE?(C(e),!0):(u||(c.push(e),200<=c.length&&(c.length=200)),!1)})).length&&t(e)}},X=function(i){return setTimeout(function(){var e=i.config.pvUrl,n=void 0===e?"":e;n&&i.sendPipeline([function(e,t){t({url:n,type:T.PV,fail:function(e){"403 forbidden"===e&&i.destroy()}})}],T.PV)(null)},100),function(e,t){t(e)}},G=function(o){var r={};return function(e,t){var n,i;o.speedSample?(i="object"==typeof o.repeat?o.repeat:{repeat:o.repeat},n=+i.speed||+i.repeat||5,Array.isArray(e)?(i=e.filter(function(e){var t=!r[e.url]||r[e.url]<n;return r[e.url]=1+~~r[e.url],t})).length&&t(i):(!r[e.url]||r[e.url]<n)&&(r[e.url]=1+~~r[e.url],t(e))):t(e)}},J=function(i){var o={};return function(e,t){var n="number"==typeof i.repeat?i.repeat:5;if(0===n)return t(e);t(e.filter(function(e){return e.level!==O.ERROR&&e.level!==O.PROMISE_ERROR&&e.level!==O.AJAX_ERROR&&e.level!==O.SCRIPT_ERROR&&e.level!==O.IMAGE_ERROR&&e.level!==O.CSS_ERROR&&e.level!==O.MEDIA_ERROR||(o[e.msg]=o[e.msg]||0,o[e.msg]+=1,!(o[e.msg]>n))}))}},$=function(i){return function(e){return i.sendPipeline([function(e,n){return n({url:i.config.url||"",data:R(e),method:"post",contentType:"application/x-www-form-urlencoded",type:T.LOG,log:e,success:function(){var t=i.config.onReport;"function"==typeof t&&e.forEach(function(e){t(e)}),"function"==typeof n&&n([])},fail:function(e){"403 forbidden"===e&&i.destroy()}})}],T.LOG)(e)}},Q=function(n){if(!n||!n.reduce||!n.length)throw new TypeError("createPipeline need at least one function param");return 1===n.length?function(e,t){n[0](e,t||k)}:n.reduce(function(n,i){return function(e,t){return void 0===t&&(t=k),n(e,function(e){return null==i?void 0:i(e,t)})}})},K=(Object.defineProperty(ue.prototype,"__version__",{get:function(){return console.warn("__version__ has discard, please use version"),"1.24.47"},enumerable:!1,configurable:!0}),Object.defineProperty(ue.prototype,"LogType",{get:function(){return console.warn("LogType has discard, please use logType"),O},enumerable:!1,configurable:!0}),ue.prototype.init=function(e){this.setConfig(e);for(var t=0;t<ue.installedPlugins.length;t++)try{ue.installedPlugins[t].patch(this)}catch(e){this.sendSDKError(e)}this.lifeCycle.emit("onInited")},ue.prototype.setConfig=function(e){Object.assign(this.config,e);var t=this.config,n=t.id,i=t.uin,o=t.version,r=t.ext1,s=t.ext2,a=t.ext3,e=t.aid,t=t.env,u=void 0===t?"production":t,t=this.bean.id!==n||this.bean.uin!==i||this.bean.aid!==e;return this.bean.id=n||"",this.bean.uin=i||"",this.bean.version=o||"1.24.47",this.bean.aid=e||"",this.bean.env=function(){switch(u){case c.production:case c.gray:case c.pre:case c.daily:case c.local:case c.others:return 1;default:return}}()?u:c.others,r&&(this.bean.ext1=encodeURIComponent(r)),s&&(this.bean.ext2=encodeURIComponent(s)),a&&(this.bean.ext3=encodeURIComponent(a)),t&&this.lifeCycle.emit("onConfigChange",this.config),this.config},ue.use=function(e){-1===ue.installedPlugins.indexOf(e)&&e.aegisPlugin&&ue.installedPlugins.push(e)},ue.unuse=function(e){e=ue.installedPlugins.indexOf(e);-1!==e&&ue.installedPlugins.splice(e,1)},ue.prototype.info=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n={level:O.INFO,msg:e};1===e.length&&e[0].msg&&Object.assign(n,E({},e[0]),{level:O.INFO}),this.normalLogPipeline(n)},ue.prototype.infoAll=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n={level:O.INFO_ALL,msg:e};1===e.length&&e[0].msg&&Object.assign(n,E({},e[0]),{level:O.INFO_ALL}),this.normalLogPipeline(n)},ue.prototype.report=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n={level:O.REPORT,msg:e};1===e.length&&e[0].msg&&Object.assign(n,E({},e[0])),this.normalLogPipeline(n)},ue.prototype.error=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var n={level:O.ERROR,msg:e};1===e.length&&e[0].msg&&Object.assign(n,E({},e[0]),{level:O.ERROR}),this.normalLogPipeline(n)},ue.prototype.speedLogPipeline=function(e){throw new Error('You need to override "speedLogPipeline" method')},ue.prototype.reportPv=function(n){var i,o=this;n&&(console.warn("reportPv is deprecated, please use reportEvent"),i=""+Object.getOwnPropertyNames(this.bean).filter(function(e){return"id"!==e}).map(function(e){return e+"="+o.bean[e]}).join("&"),this.sendPipeline([function(e,t){t({url:o.config.url+"/"+n+"?"+i,addBean:!1,type:T.CUSTOM_PV,fail:function(e){"403 forbidden"===e&&o.destroy()}})}],T.CUSTOM_PV)(null))},ue.prototype.reportEvent=function(e){e&&((e="string"==typeof e?{name:e,ext1:this.config.ext1||"",ext2:this.config.ext2||"",ext3:this.config.ext3||""}:e).name?this.eventPipeline(e):console.warn("reportEvent params error"))},ue.prototype.reportTime=function(e,t){if("object"==typeof e)return this.reportT(e);"string"==typeof e?"number"==typeof t?t<0||6e4<t?console.warn("reportTime: duration must between 0 and 60000"):this.submitCustomTime(e,t):console.warn("reportTime: second param must be number"):console.warn("reportTime: first param must be a string")},ue.prototype.reportT=function(e){var t=e.name,n=e.duration,i=e.ext1,o=void 0===i?"":i,r=e.ext2,i=void 0===r?"":r,r=e.ext3,r=void 0===r?"":r,e=e.from;if("string"==typeof t&&"number"==typeof n&&"string"==typeof o&&"string"==typeof i&&"string"==typeof r){if(!(n<0||6e4<n))return this.submitCustomTime(t,n,o,i,r,void 0===e?"":e);console.warn("reportTime: duration must between 0 and 60000")}else console.warn("reportTime: params error")},ue.prototype.time=function(e){"string"==typeof e?this.timeMap[e]?console.warn("Timer "+e+" already exists"):this.timeMap[e]=Date.now():console.warn("time: first param must be a string")},ue.prototype.timeEnd=function(e){"string"==typeof e?this.timeMap[e]?(this.submitCustomTime(e,Date.now()-this.timeMap[e]),delete this.timeMap[e]):console.warn("Timer "+e+" does not exist"):console.warn("timeEnd: first param must be a string")},ue.prototype.submitCustomTime=function(e,t,n,i,o,r){this.customTimePipeline({name:e,duration:t,ext1:n||this.config.ext1,ext2:i||this.config.ext2,ext3:o||this.config.ext3,from:r||void 0})},ue.prototype.extendBean=function(e,t){this.bean[e]=t},ue.prototype.sendPipeline=function(e,t){var n,r,s,a=this;return Q(u([function(e,t){if("number"!=typeof n.config.random&&(console.warn("random must in [0, 1], default is 1."),n.config.random=1),!n.isHidden||!n.isGetSample)if(n.isGetSample)n.isHidden||t(e);else{if(n.isGetSample=!0,Math.random()<n.config.random)return n.isHidden=!1,t(e);n.isHidden=!0}},(s=t,function(e,t){var n=Array.isArray(e),i=n?e:[e];r.lifeCycle.emit("beforeRequest",e);var o=r.config.beforeRequest;(i="function"==typeof o?i.map(function(t){try{var e=o({logs:t,logType:s});return(null==e?void 0:e.logType)===s&&null!=e&&e.logs?e.logs:!1!==e&&t}catch(e){return t}}).filter(function(e){return!1!==e}):i).length&&(i=function(e,t){if(!Array.isArray(e)||e.length<=1)return e;var n=[],i=[];return!(i="string"==typeof t?[t]:t)||i.length<=0||(i.forEach(function(t){e.forEach(function(e){null!=e&&e[t]&&n.push(t)})}),0<n.length&&(e=e.map(function(e){var t={};return n.forEach(function(e){t[e]=""}),E(E({},t),e)}))),e}(i,["ext1","ext2","ext3"]),t(n?i:i[0]))})],e,[A(r=n=this),function(i,o){a.request(i,function(){for(var e,t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];o({isErr:!1,result:t,logType:null==i?void 0:i.type,logs:null==i?void 0:i.log}),null===(e=null==i?void 0:i.success)||void 0===e||e.call.apply(e,u([i],t))},function(){for(var e,t=[],n=0;n<arguments.length;n++)t[n]=arguments[n];o({isErr:!0,result:t,logType:null==i?void 0:i.type,logs:null==i?void 0:i.log}),null===(e=null==i?void 0:i.fail)||void 0===e||e.call.apply(e,u([i],t))})},N(this)]))},ue.prototype.send=function(e,o,r){var t=this;return Q([A(this),function(n,i){t.request(n,function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];i({isErr:!1,result:e,logType:n.type,logs:n.log}),null==o||o.apply(void 0,e)},function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];i({isErr:!0,result:e,logType:n.type,logs:n.log}),null==r||r.apply(void 0,e)})},N(this)])(e)},ue.prototype.request=function(e,t,n){throw new Error('You need to override "request" method')},ue.prototype.sendSDKError=function(e){var n=this;this.sendPipeline([function(e,t){t({url:n.config.url+"?id=1085&msg[0]="+encodeURIComponent(L(e))+"&level[0]=2&from="+n.config.id+"&count=1&version="+n.config.id+"(1.24.47)",addBean:!1,method:"get",type:T.SDK_ERROR,log:e})}],T.SDK_ERROR)(e)},ue.prototype.destroy=function(e){void 0===e&&(e=!1);var t,n,i=ue.instances.indexOf(this);-1!==i&&ue.instances.splice(i,1);for(var o=ue.installedPlugins.length-1;0<=o;o--)try{ue.installedPlugins[o].unpatch(this)}catch(e){this.sendSDKError(e)}if(this.lifeCycle.emit("destroy"),this.lifeCycle.clear(),e)t=this,n=Object.getOwnPropertyDescriptors(t),Object.keys(n).forEach(function(e){n[e].writable&&(t[e]=null)}),Object.setPrototypeOf(this,null);else{for(var r=this;r.constructor!==Object&&_(r,this),r=Object.getPrototypeOf(r););0===ue.instances.length&&(e=Object.getPrototypeOf(this).constructor,_(e),_(ue))}},ue.version="1.24.47",ue.instances=[],ue.logType=O,ue.environment=c,ue.installedPlugins=[],ue),Y=(ae.prototype.patch=function(e){this.canUse(e)&&this.exist(e)&&(this.instances.push(e),this.triggerInit(e),this.triggerOnNewAegis(e))},ae.prototype.unpatch=function(e){e=this.instances.indexOf(e);-1!==e&&this.instances.splice(e,1)},ae.prototype.countInstance=function(){return this.instances.length},ae.prototype.uninstall=function(){var e;null===(e=null===(e=this.option)||void 0===e?void 0:e.destroy)||void 0===e||e.apply(this)},ae.prototype.walk=function(n){var i=this;this.instances.forEach(function(e){var t=i.canUse(e);t&&n(e,t)})},ae.prototype.canUse=function(e){e=this.getConfig(e);return!(!e||"object"!=typeof e)||!!e},ae.prototype.getConfig=function(e){return null===(e=e.config)||void 0===e?void 0:e[this.name]},ae.prototype.exist=function(e){return-1===this.instances.indexOf(e)},ae.prototype.triggerInit=function(e){var t;this.inited||(this.inited=!0,null===(t=null===(t=this.option)||void 0===t?void 0:t.init)||void 0===t||t.call(this.option,this.getConfig(e)))},ae.prototype.triggerOnNewAegis=function(e){var t;null===(t=null===(t=this.option)||void 0===t?void 0:t.onNewAegis)||void 0===t||t.call(this.option,e,this.getConfig(e))},ae),z=new Y({name:"aid",aid:"",init:function(e){try{var t=!0!==e&&e||window.localStorage.getItem("AEGIS_ID");t||(t="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)}),window.localStorage.setItem("AEGIS_ID",t)),this.aid=t}catch(e){}},onNewAegis:function(e){e.bean.aid=this.aid,e.config.aid=this.aid}}),Z=function(e,t){var n,i={fetch:[],static:[]},o=new FormData;return Array.isArray(e)?e.forEach(function(e){var t=U(e);i[e.type].push(t)}):(n=U(e),i[e.type].push(n)),o.append("payload",JSON.stringify(E({duration:i},t))),o},ee=new Y({name:"reportAssetSpeed"}),te=ee=new Y({name:"reportAssetSpeed",collectCur:0,ASSETS_INITIATOR_TYPE:["img","css","script","link","audio","video"],onNewAegis:function(e){var t=this;j()&&(this.collectSuccessLog(e),this.collectFailLog(e),performance.onresourcetimingbufferfull=function(){t.collectCur=0,performance.clearResourceTimings()})},publish:function(t){this.$walk(function(e){e.speedLogPipeline(t)})},collectSuccessLog:function(e){function n(e){for(var t=0,n=e.length;t<n;t++){var i=e[t];-1!==o.ASSETS_INITIATOR_TYPE.indexOf(i.initiatorType)&&-1===i.name.indexOf("cdn-go.cn/aegis/aegis-sdk")&&o.publish(o.generateLog(i,r))}}var t,i,o=this,r=e.config;"function"==typeof window.PerformanceObserver?(n(performance.getEntriesByType("resource")),(t=new window.PerformanceObserver(function(e){n(e.getEntries())})).observe({entryTypes:["resource"]}),e.lifeCycle.on("destroy",function(){0===ee.countInstance()&&t.disconnect()})):(i=setInterval(function(){var e=performance.getEntriesByType("resource"),t=e.slice(o.collectCur);o.collectCur=e.length,n(t)},3e3),e.lifeCycle.on("destroy",function(){0===ee.countInstance()&&clearInterval(i)}))},collectFailLog:function(e){function t(e){var t,n;e&&(e=e.target||e.srcElement,t=(null==e?void 0:e.src)||(null==e?void 0:e.href),e=null==e?void 0:e.tagName,t&&"string"==typeof t&&("IMG"===e&&-1<window.location.href.indexOf(t)||(e="function"==typeof(null===(e=o.api)||void 0===e?void 0:e.resourceTypeHandler)?null===(n=o.api)||void 0===n?void 0:n.resourceTypeHandler(t):"",n=performance.getEntriesByType("resource").find(function(e){return e.name===t}),e={url:g(t),status:400,duration:Number(((null==n?void 0:n.duration)||0).toFixed(2)),method:"get",type:e||"static",isHttps:v(t),urlQuery:g(t,!0),domainLookup:0,connectTime:0},i.publish(e))))}var i=this,o=e.config;window.document.addEventListener("error",t,!0),e.lifeCycle.on("destroy",function(){0===ee.countInstance()&&window.document.removeEventListener("error",t,!0)})},generateLog:function(e,t){var n,i="function"==typeof(null===(n=t.api)||void 0===n?void 0:n.resourceTypeHandler)?null===(i=t.api)||void 0===i?void 0:i.resourceTypeHandler(e.name):"";return{url:g(e.name),method:"get",duration:Number(e.duration.toFixed(2)),status:200,type:i||"static",isHttps:v(e.name),urlQuery:g(e.name,!0),domainLookup:a(e.domainLookupEnd-e.domainLookupStart),connectTime:a(e.connectEnd-e.connectStart)}},destroy:function(){this.option.publish=function(){}}}),ne=!1,ie=[],oe=!1,re=[],se=(new Y({name:"reportApiSpeed"}),new Y({name:"reportApiSpeed",override:!1,onNewAegis:function(e){this.override||(this.override=!0,this.overrideFetch(e.config),this.overrideXhr(e.config))},overrideFetch:function(c){var l=this,e={name:this.name,then:function(o,r,s,a){var e,u,t,n;c.hostUrl&&-1<s.indexOf(c.hostUrl)||(u={url:o.url,isHttps:v(o.url),method:(null==a?void 0:a.method)||"get",duration:r,type:"fetch",status:o.status||0},"fetch"!==(n="function"==typeof(null===(e=c.api)||void 0===e?void 0:e.resourceTypeHandler)?null===(t=c.api)||void 0===t?void 0:t.resourceTypeHandler(o.url):n)&&"static"!==n&&(t=o.headers?o.headers.get("content-type"):"",n=o.ok&&"string"==typeof t&&f(t)?"static":"fetch"),"fetch"===n?o.clone().text().then(function(e){var t=null===(i=c.api)||void 0===i?void 0:i.apiDetail,n=o.status<=0||400<=o.status,i=(n?"FETCH_ERROR: "+e+" \n\n":"")+"req url: "+s+" \n                                \nreq method: "+((null==a?void 0:a.method)||"get")+" \n                                \nreq param: "+(t?y(null==a?void 0:a.body):"")+" \n                                \nres duration: "+r+" \n                                \nres status: "+(o.status||0)+" \n                                \nres data: "+(t?e:"");u.payload=new S(o,e);t=m(e,c.api,{url:s,ctx:o}),e=t.code,t=t.isErr;u.ret=e,u.isErr=+t,l.publishNormalLog({msg:i,level:n?O.AJAX_ERROR:t?O.RET_ERROR:O.API_RESPONSE,code:e})}):Object.assign(u,{type:"static",urlQuery:g(o.url,!0),domainLookup:h.number,connectTime:h.number}),l.publishSpeed(u))},catch:function(e,t,n,i){if(!(c.hostUrl&&-1<n.indexOf(c.hostUrl))){var o={url:n,isHttps:v(n),method:(null==i?void 0:i.method)||"get",duration:t,type:"fetch",status:0};l.publishSpeed(o);o=null===(o=c.api)||void 0===o?void 0:o.apiDetail,i="AJAX_ERROR: "+e+"\n                          \nres status: 0\n                          \nres duration: "+t+"\n                          \nreq url: "+n+"\n                          \nreq method: "+((null==i?void 0:i.method)||"get")+"\n                          \nreq param: "+(o?y(null==i?void 0:i.body):"");throw l.publishNormalLog({msg:i,level:O.AJAX_ERROR,code:-400}),e}}};this.hackFetchOptions=e,function(t){if(re.find(function(e){return e.name===t.name}))throw new Error("name '"+t.name+"' is already in hackFetch option list");var s;re.push(t),!oe&&window.fetch&&(oe=!0,s=window.fetch,window.fetch=function(e,i){void 0===i&&(i={});for(var o="string"==typeof e?e:e.url,t=0;t<re.length;t++){var n=re[t];try{"function"==typeof n.beforeFetch&&n.beforeFetch(o,i)}catch(e){}}var r=Date.now();return s(e,i).then(function(e){for(var t=0;t<re.length;t++){var n=re[t];try{"function"==typeof n.then&&n.then(e,Date.now()-r,o,i)}catch(e){}}return e}).catch(function(e){for(var t=0;t<re.length;t++){var n=re[t];try{"function"==typeof n.catch&&n.catch(e,Date.now()-r,o,i)}catch(e){}}throw e})})}(this.hackFetchOptions)},getRequestType:function(e,t,n){var i,o="function"==typeof(null===(i=e.api)||void 0===i?void 0:i.resourceTypeHandler)?null===(o=e.api)||void 0===o?void 0:o.resourceTypeHandler(n):"";return"fetch"!==o&&"static"!==o&&(n=t.getResponseHeader("content-type"),o=400<=t.status||"string"!=typeof n||!f(n)?"fetch":"static"),o},overrideXhr:function(d){var p=this,e={name:this.name,send:function(c,l){var f=Date.now();c.addEventListener("loadend",function(){var e,t=c.aegisUrl;if(t){var n=Date.now()-f,i={url:t,isHttps:v(t),status:c.status||0,method:c.aegisMethod||"get",type:"fetch",duration:n,payload:new b(c)};if("fetch"===p.getRequestType(d,c,t))try{var o=null===(e=d.api)||void 0===e?void 0:e.apiDetail,r="req url: "+t+" \n                                \nreq method: "+i.method+" \n                                \nreq param: "+(o?y(l):"")+" \n                                \nres duration: "+n+" \n                                \nres status: "+i.status+" \n                                \nres data: "+(o?y(c.response):""),s=m(c.response,d.api,{url:t,ctx:c}),a=s.code,u=s.isErr;i.ret=a,i.isErr=+u,p.publishNormalLog({msg:r,level:u?O.RET_ERROR:O.API_RESPONSE,code:a})}catch(e){i.ret="unknown"}else Object.assign(i,{type:"static",urlQuery:g(t,!0),domainLookup:h.number,connectTime:h.number});p.publishSpeed(i)}})}};this.hackXHROptions=e,F(this.hackXHROptions)},publishSpeed:function(n){var i=this;n.url=g(n.url),this.$walk(function(e){var t=i.$getConfig(e);"fetch"===n.type&&t&&"function"==typeof t.urlHandler?e.speedLogPipeline(E(E({},n),{url:encodeURIComponent(t.urlHandler(n.url,n.payload))})):e.speedLogPipeline(n)})},publishNormalLog:function(t){this.$walk(function(e){e.normalLogPipeline(t)})},destroy:function(){var t,e;this.option.publishSpeed=function(){},this.option.publishNormalLog=function(){},this.option.hackXHROptions&&q(this.option.hackXHROptions),this.option.hackFetchOptions&&(t=this.option.hackFetchOptions,-1!==(e=re.findIndex(function(e){return e.name===t.name}))&&re.splice(e,1))}}));function ae(e){this.aegisPlugin=!0,this.name="",this.instances=[],this.inited=!1,e.$walk=this.walk.bind(this),e.$getConfig=this.getConfig.bind(this),this.option=e,this.name=e.name}function ue(e){var n,t,o=this;this.isGetSample=!1,this.isHidden=!1,this.config={version:0,delay:1e3,onError:!0,repeat:5,random:1,aid:!0,device:!0,pagePerformance:!0,webVitals:!0,speedSample:!0,hostUrl:"https://aegis.qq.com",env:"production",url:"",offlineUrl:"",whiteListUrl:"",pvUrl:"",speedUrl:"",customTimeUrl:"",performanceUrl:"",webVitalsUrl:"",eventUrl:""},this.isWhiteList=!1,this.lifeCycle=new r,this.bean={},this.normalLogPipeline=Q([B(this,5),V,function(e,t){var i=n.config;t(e=e.map(function(e){var t,n=i.maxLength||204800;try{if(!e.msg||e.msg.length<=n)return e;e.msg=null===(t=e.msg)||void 0===t?void 0:t.substring(0,n)}catch(t){e.msg=L(e.msg).substring(0,i.maxLength)}return e}))},J((n=this).config),M(this.lifeCycle.emit,this.config),X(this),W(this),function(e,t){var n=JSON.parse(JSON.stringify(e));o.lifeCycle.emit("beforeReport",n);var i=o.config.beforeReport;(e="function"==typeof i?e.filter(function(e){return!1!==i(e)}):e).length&&t(e)},$(this)]),this.eventPipeline=Q([B(this,5),function(e){o.sendPipeline([function(e,t){var n=e.map(function(e){return{name:e.name,ext1:e.ext1||o.config.ext1||"",ext2:e.ext2||o.config.ext2||"",ext3:e.ext3||o.config.ext3||""}});t({url:o.config.eventUrl+"?payload="+encodeURIComponent(JSON.stringify(n)),type:T.EVENT,log:e,fail:function(e){"403 forbidden"===e&&o.destroy()}})}],T.EVENT)(e)}]),this.timeMap={},this.customTimePipeline=Q([B(this,5),function(e){return o.sendPipeline([function(e,t){t({url:o.config.customTimeUrl+"?payload="+encodeURIComponent(JSON.stringify({custom:e})),type:T.CUSTOM,log:e,fail:function(e){"403 forbidden"===e&&o.destroy()}})}],T.CUSTOM)(e)}]),this.config=(t=this.config,void 0===(e=e.hostUrl)&&(e="https://aegis.qq.com"),t.url=t.url||e+"/collect",t.offlineUrl=t.offlineUrl||e+"/offline",t.whiteListUrl=t.whiteListUrl||e+"/collect/whitelist",t.pvUrl=t.pvUrl||e+"/collect/pv",t.eventUrl=t.eventUrl||e+"/collect/events",t.speedUrl=t.speedUrl||e+"/speed",t.customTimeUrl=t.customTimeUrl||e+"/speed/custom",t.performanceUrl=t.performanceUrl||e+"/speed/performance",t.webVitalsUrl=t.webVitalsUrl||e+"/speed/webvitals",t),ue.instances.push(this)}(Be=D=D||{})[Be.unknown=100]="unknown",Be[Be.wifi=1]="wifi",Be[Be.net2g=2]="net2g",Be[Be.net3g=3]="net3g",Be[Be.net4g=4]="net4g",Be[Be.net5g=5]="net5g",Be[Be.net6g=6]="net6g",(qe=H=H||{})[qe.android=1]="android",qe[qe.ios=2]="ios",qe[qe.windows=3]="windows",qe[qe.macos=4]="macos",qe[qe.linux=5]="linux",qe[qe.other=100]="other";var ce,le,fe,de,pe,he,ge,ve,me,ye,we=new Y({name:"device",onNewAegis:function(e){e.extendBean("platform",this.getPlatform()),e.extendBean("netType",D.unknown),this.getDpi(e),this.refreshNetworkTypeToBean(e)},getDpi:function(e){e.extendBean("vp",window.innerWidth+" * "+window.innerHeight),window.screen&&e.extendBean("sr",window.screen.width+" * "+window.screen.height)},getPlatform:function(){var t={android:/\bAndroid\s*([^;]+)/,ios:/\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/,windows:/\b(Windows NT)/,macos:/\b(Mac OS)/,linux:/\b(Linux)/i},e=Object.keys(t).find(function(e){return t[e].test(navigator.userAgent)});return e?H[e]:H.other},refreshNetworkTypeToBean:function(t){var n=this,e=t.config;e&&("function"==typeof e.getNetworkType?e.getNetworkType:be)(function(e){D[e]||(e=D.unknown),t.extendBean("netType",e),n.NetworkRefreshTimer=setTimeout(function(){n.refreshNetworkTypeToBean(t),clearTimeout(n.NetworkRefreshTimer)},1e4)})}}),be=function(e){var t="",n=navigator.userAgent.match(/NetType\/(\w+)/);n?t=n[1]:navigator.connection&&(t=navigator.connection.effectiveType||navigator.connection.type),e((t=t=t||"unknown",0<=(t=String(t).toLowerCase()).indexOf("4g")?D.net4g:0<=t.indexOf("wifi")?D.wifi:0<=t.indexOf("5g")?D.net5g:0<=t.indexOf("6g")?D.net6g:0<=t.indexOf("3g")?D.net3g:0<=t.indexOf("2g")?D.net2g:D.unknown))},Ee=new Y({name:"onError"}),Re=Ee=new Y({name:"onError",onNewAegis:function(e){this.startListen(e)},startListen:function(o){var i=this,n=window.onerror;window.onerror=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];i.publishErrorLog({msg:(L(e[0])||"")+" @ ("+(L(e[1])||"")+":"+(e[2]||0)+":"+(e[3]||0)+")\n          \n"+L(e[4]||""),level:O.ERROR}),null==n||n.call.apply(n,u([window],e))};function e(e){e=e&&L(e.reason),i.publishErrorLog({msg:"PROMISE_ERROR: "+e,level:O.PROMISE_ERROR})}window.addEventListener("unhandledrejection",e);function t(e){if(e=(null==e?void 0:e.target)||(null==e?void 0:e.srcElement)){var t=e.src||e.href,e=e.tagName;if("string"==typeof t&&e){var n={msg:e+" load fail: "+t,level:O.INFO};switch(e.toLowerCase()){case"script":n.level=O.SCRIPT_ERROR;break;case"link":n.level=O.CSS_ERROR;break;case"img":if(-1<window.location.href.indexOf(t))return;n.level=O.IMAGE_ERROR;break;case"audio":case"video":n.level=O.MEDIA_ERROR;break;default:return}i.publishErrorLog(n)}}}window.document.addEventListener("error",t,!0),o.lifeCycle.on("destroy",function(){0===Ee.countInstance()&&(window.document.removeEventListener("unhandledrejection",e),window.document.removeEventListener("error",t,!0))});var r=this,s={name:this.name,send:function(n,i){n.addEventListener("loadend",function(){var e,t="";this.failType?t=this.failType:this.status?400<=this.status&&(t="error"):t="failed",o.config.hostUrl&&this.aegisUrl&&-1<this.aegisUrl.indexOf(o.config.hostUrl)||(e=null===(e=o.config.api)||void 0===e?void 0:e.apiDetail,t&&r.publishErrorLog({msg:"AJAX_ERROR: request "+t+"\n                      \nres status: "+(this.status||0)+"\n                      \nres duration: "+(Date.now()-n.aegisXhrStartTime)+"\n                      \nreq url: "+this.aegisUrl+"\n                      \nreq method: "+this.aegisMethod+"\n                      \nreq param: "+(e?y(i):"")+"\n                      \nres data: "+(e?null===(e=(e=n).responseType&&"text"!==e.responseType?"":e.responseText)||void 0===e?void 0:e.slice(0,1e3):""),level:O.AJAX_ERROR}))}),n.addEventListener("timeout",function(){n.failType="timeout"}),n.addEventListener("error",function(){n.failType="error"}),n.addEventListener("abort",function(){n.failType="abort"})}};this.hackXHROptions=s,F(this.hackXHROptions)},publishErrorLog:function(t){this.$walk(function(e){e.normalLogPipeline(t)})},destroy:function(){this.option.publishErrorLog=function(){},this.option.hackXHROptions&&q(this.option.hackXHROptions)}}),Oe=(new Y({name:"pagePerformance"}),1),Te=new Y({name:"pagePerformance",onNewAegis:function(i){var o=this;if(j())if(ce)this.publish(ce,i);else try{this.getFirstScreenTiming(i,function(e){var t,n=performance.timing;n&&(t=n.loadEventStart-n.domInteractive,ce={dnsLookup:n.domainLookupEnd-n.domainLookupStart,tcp:n.connectEnd-n.connectStart,ssl:0===n.secureConnectionStart?0:n.requestStart-n.secureConnectionStart,ttfb:n.responseStart-n.requestStart,contentDownload:n.responseEnd-n.responseStart,domParse:n.domInteractive-n.domLoading,resourceDownload:t=t<0?1070:t,firstScreenTiming:Math.floor(e)},o.publish(ce,i))})}catch(i){}},publish:function(e,s){var a=this;s.sendPipeline([function(e,t){var n,i=[];for(n in e)i.push(n+"="+e[n]);var o=a.$getConfig(s);if(o){var r=-1===s.config.performanceUrl.indexOf("?")?"?":"&";return"function"==typeof o.urlHandler?t({url:s.config.performanceUrl+r+i.join("&")+"&from="+(encodeURIComponent(o.urlHandler())||window.location.href),beanFilter:["from"],type:T.PERFORMANCE,log:e}):t({url:s.config.performanceUrl+r+i.join("&"),type:T.PERFORMANCE,log:e})}}],T.PERFORMANCE)(e)},getFirstScreenTiming:function(r,n){r.lifeCycle.on("destroy",function(){f&&clearTimeout(f)});var i=["script","style","link","br"],s=[],a=this,u={},c=new MutationObserver(function(e){var t={roots:[],rootsDomNum:[],time:performance.now()};e.forEach(function(e){e&&e.addedNodes&&e.addedNodes.forEach&&e.addedNodes.forEach(function(e){1===e.nodeType&&(e.hasAttribute("AEGIS-FIRST-SCREEN-TIMING")||e.querySelector("[AEGIS-FIRST-SCREEN-TIMING]"))?(Object.prototype.hasOwnProperty.apply(u,[t.time])||(u[t.time]=[]),u[t.time].push(e)):1!==e.nodeType||-1!==i.indexOf(e.nodeName.toLocaleLowerCase())||a.isEleInArray(e,t.roots)||e.hasAttribute("AEGIS-IGNORE-FIRST-SCREEN-TIMING")||(t.roots.push(e),t.rootsDomNum.push(a.walkAndCount(e)||0))})}),t.roots.length&&s.push(t)});c.observe(document,{childList:!0,subtree:!0});var l=function(){var e,i=0,o=0,t=Object.keys(u).filter(function(e){return u[+e].find(function(e){return a.isInFirstScreen(e)})});t.length?(o=Math.max.apply(null,t),("object"!=typeof(null===(t=r.config)||void 0===t?void 0:t.pagePerformance)||null!==(e=r.config.pagePerformance)&&void 0!==e&&e.firstScreenInfo)&&(r.firstScreenInfo={element:null===(e=u[o])||void 0===e?void 0:e[0],timing:o,markDoms:u})):s.forEach(function(e){for(var t,n=0;n<e.roots.length;n++)e.rootsDomNum[n]>i&&a.isInFirstScreen(e.roots[n])&&(i=e.rootsDomNum[n],o=e.time,("object"!=typeof(null===(t=r.config)||void 0===t?void 0:t.pagePerformance)||null!==(t=r.config.pagePerformance)&&void 0!==t&&t.firstScreenInfo)&&(r.firstScreenInfo={element:e.roots[n],timing:o}))}),!o&&Oe?f=setTimeout(function(){return l()},3e3):(c.disconnect(),null==n||n(o)),--Oe},f=setTimeout(function(){return l()},3e3)},isEleInArray:function(e,t){return!(!e||e===document.documentElement)&&(-1!==t.indexOf(e)||this.isEleInArray(e.parentElement,t))},isInFirstScreen:function(e){if(!e||"function"!=typeof e.getBoundingClientRect)return!1;var t=e.getBoundingClientRect(),n=window.innerHeight,e=window.innerWidth;return 0<=t.left&&t.left<e&&0<=t.top&&t.top<n&&0<t.width&&0<t.height},walkAndCount:function(e){var t=0;if(e&&1===e.nodeType){t+=1;var n=e.children;if(null!=n&&n.length)for(var i=0;i<n.length;i++)t+=this.walkAndCount(n[i])}return t}});function Le(){pe=[],fe=-1,le=null,me(addEventListener)}function Se(e,t){le||(le=t,fe=e,de=new Date,me(removeEventListener),ve())}function xe(e){var t,n,i,o;function r(){Se(n,i),o()}function s(){o()}e.cancelable&&(t=(1e12<e.timeStamp?new Date:performance.now())-e.timeStamp,"pointerdown"==e.type?(n=t,i=e,o=function(){removeEventListener("pointerup",r,he),removeEventListener("pointercancel",s,he)},addEventListener("pointerup",r,he),addEventListener("pointercancel",s,he)):Se(t,e))}he={passive:!0,capture:!0},ge=new Date,ve=function(){var t;0<=fe&&fe<de-ge&&(t={entryType:"first-input",name:le.type,target:le.target,cancelable:le.cancelable,startTime:le.timeStamp,processingStart:le.timeStamp+fe},pe.forEach(function(e){e(t)}),pe=[])},me=function(t){["mousedown","keydown","touchstart","pointerdown"].forEach(function(e){return t(e,xe,he)})},ye="hidden"===document.visibilityState?0:1/0,addEventListener("visibilitychange",function e(t){"hidden"===document.visibilityState&&(ye=t.timeStamp,removeEventListener("visibilitychange",e,!0))},!0),Le(),self.webVitals={firstInputPolyfill:function(e){pe.push(e),ve()},resetFirstInputPolyfill:Le,get firstHiddenTime(){return ye}};function Pe(e,t){return{name:e,value:void 0===t?-1:t,delta:0,entries:[],id:"v1-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12)}}function Ie(e,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){if("first-input"===e&&!("PerformanceEventTiming"in self))return;var n=new PerformanceObserver(function(e){return e.getEntries().map(t)});return n.observe({type:e,buffered:!0}),n}}catch(e){}}function Ce(t,n){function i(e){"pagehide"!==e.type&&"hidden"!==document.visibilityState||(t(e),n&&(removeEventListener("visibilitychange",i,!0),removeEventListener("pagehide",i,!0)))}addEventListener("visibilitychange",i,!0),addEventListener("pagehide",i,!0)}function Ae(t){addEventListener("pageshow",function(e){e.persisted&&t(e)},!0)}function Ne(e,t,n){var i;return function(){0<=t.value&&(n||De.has(t)||"hidden"===document.visibilityState)&&(t.delta=t.value-(i||0),!t.delta&&void 0!==i||(i=t.value,e(t)))}}function ke(){Ce(function(e){e=e.timeStamp;He=e},!0)}function _e(){return He<0&&((He=self.webVitals.firstHiddenTime)===1/0&&ke(),Ae(function(){setTimeout(function(){He="hidden"===document.visibilityState?0:1/0,ke()},0)})),{get timeStamp(){return He}}}function Ue(e){var t=e.name,e=e.value;Me[t]=e}var je,Fe,qe,De=new("function"==typeof WeakSet?WeakSet:Set),He=-1,Me=(new Y({name:"webVitals"}),{FCP:-1,LCP:-1,FID:-1,CLS:-1}),Be=new Y({name:"webVitals",onNewAegis:function(e){var t,n,i,o,r,s,a,u,c,l,f,d,p,h,g,v,m,y,w,b,E,R,O;if(j()&&"function"==typeof window.PerformanceObserver)try{y=Ue,b=_e(),E=Pe("FCP"),R=performance.getEntriesByName("first-contentful-paint")[0],O=R?null:Ie("paint",x),(R||O)&&(w=Ne(y,E,void 0),R&&x(R),Ae(function(e){E=Pe("FCP"),w=Ne(y,E,void 0),requestAnimationFrame(function(){requestAnimationFrame(function(){E.value=performance.now()-e.timeStamp,De.add(E),w()})})})),d=Ue,g=_e(),v=Pe("LCP"),(m=Ie("largest-contentful-paint",S))&&(p=Ne(d,v,void 0),h=function(){De.has(v)||(m.takeRecords().map(S),m.disconnect(),De.add(v),p())},["keydown","click"].forEach(function(e){addEventListener(e,h,{once:!0,capture:!0})}),Ce(h,!0),Ae(function(e){v=Pe("LCP"),p=Ne(d,v,void 0),requestAnimationFrame(function(){requestAnimationFrame(function(){v.value=performance.now()-e.timeStamp,De.add(v),p()})})})),a=Ue,u=_e(),c=Pe("FID"),l=Ie("first-input",L),f=Ne(a,c,void 0),l&&Ce(function(){l.takeRecords().map(L),l.disconnect()},!0),l||window.webVitals.firstInputPolyfill(L),Ae(function(){c=Pe("FID"),f=Ne(a,c,void 0),window.webVitals.resetFirstInputPolyfill(),window.webVitals.firstInputPolyfill(L)}),i=Ue,r=Pe("CLS",0),(s=Ie("layout-shift",T))&&(o=Ne(i,r,void 0),Ce(function(){s.takeRecords().map(T),o()}),Ae(function(){r=Pe("CLS",0),o=Ne(i,r,void 0)})),t=this.publish.bind(this,e),n=function(e){"pagehide"!==e.type&&"hidden"!==document.visibilityState||(t(e),removeEventListener("visibilitychange",n,!0),removeEventListener("pagehide",n,!0))},addEventListener("visibilitychange",n,!0),addEventListener("pagehide",n,!0)}catch(e){}function T(e){e.hadRecentInput||(r.value+=e.value,r.entries.push(e),o())}function L(e){e.startTime<u.timeStamp&&(c.value=e.processingStart-e.startTime,c.entries.push(e),De.add(c),f())}function S(e){var t=e.startTime;t<g.timeStamp&&(v.value=t,v.entries.push(e)),p()}function x(e){"first-contentful-paint"===e.name&&(O&&O.disconnect(),e.startTime<b.timeStamp&&(E.value=e.startTime,E.entries.push(e),De.add(E),w()))}},publish:function(r){r.sendPipeline([function(e,t){var n,i=[];for(n in e)i.push(n+"="+e[n]);var o=-1===r.config.performanceUrl.indexOf("?")?"?":"&";t({url:r.config.webVitalsUrl+o+i.join("&"),type:T.VITALS,log:e,sendBeacon:!0})}],T.VITALS)(Me)},destroy:function(){this.option.publish=function(){}}}),Ve=0,We=(i(Fe=Ge,qe=je=K),Fe.prototype=null===qe?Object.create(qe):(Je.prototype=qe.prototype,new Je),Ge.prototype.getBean=function(t){var n=this;return void 0===t&&(t=[]),""+Object.getOwnPropertyNames(this.bean).filter(function(e){return-1===t.indexOf(e)}).map(function(e){return e+"="+n.bean[e]}).join("&")},Ge.prototype.request=function(e,t,n){var i=this;if(e&&"string"==typeof e.url&&""!==e.url&&this.bean.id)if(this.requesting)this.requestQueue.push({options:e,success:t,fail:n});else{this.requesting=!0;var o=e.url;!1!==e.addBean&&(o=o+(-1===o.indexOf("?")?"?":"&")+this.getBean(e.beanFilter)),e.url=o;var r=e.method||"get",o=this.config.onBeforeRequest;if(!(e=o?o(e,this):e))return console.log("Sending request blocked");if(!e.url)return console.warn("Please handle the parameters reasonably, options.url is necessary");if(navigator.sendBeacon&&e.sendBeacon)return navigator.sendBeacon(e.url,e.data);var s=new XMLHttpRequest;s.sendByAegis=!0,s.addEventListener("readystatechange",function(){var e;4===s.readyState&&(i.requesting=!1,i.requestQueue&&((e=i.requestQueue.shift())&&i.request(e.options,e.success,e.fail),400<=s.status||0===s.status?null==n||n(s.response):null==t||t(s.response)))}),"get"===r.toLocaleLowerCase()?(s.open("get",function(e,n){if("string"!=typeof e)return"";if("object"==typeof n&&n){var t=Object.getOwnPropertyNames(n).map(function(e){var t=n[e];return e+"="+("string"==typeof t?encodeURIComponent(t):encodeURIComponent(JSON.stringify(t)))}).join("&").replace(/eval/gi,"evaI");return e+(-1===e.indexOf("?")?"?":"&")+t}return e}(e.url,e.data)),s.send()):(s.open("post",e.url),e.contentType&&s.setRequestHeader("Content-Type",e.contentType),"string"==typeof e.data&&(e.data=e.data.replace(/eval/gi,"evaI")),s.send(e.data))}},Ge.useAsyncPlugin=function(s,e){var t=(e=void 0===e?{}:e).exportsConstructor,a=void 0===t?"aegis-plugin-"+Ve:t,t=e.onAegisInit,u=void 0===t?function(){}:t,e=e.onAegisInitAndPluginLoaded,c=void 0===e?function(){}:e;if(Ve+=1,"string"!=typeof s)throw new TypeError("useAsyncPlugin first param must be string");if("function"!=typeof u||"function"!=typeof c)throw new TypeError("onAegisInit and onAegisInitAndPluginLoaded must be function");this.use(new Y({name:"asyncPlugin",onNewAegis:function(t){try{u(t),Ge.asyncPlugin[s]?c(t,window[Ge.asyncPlugin[s]]):(e=s,n=a,i=function(e){e||(Ge.asyncPlugin[s]=a,e=window[a],c(t,e))},o=document.createElement("script"),r=document.head,"function"==typeof n&&(i=n,n=""),o.src=e,o.setAttribute("name",n),o.name=n,o.setAttribute("crossorigin","anonymous"),o.crossorigin="anonymous",o.defer=!0,o.hasLoaded=!1,o.onreadystatechange=function(){o.hasLoaded||o.readyState&&"loaded"!==o.readyState&&"complete"!==o.readyState||(o.hasLoaded=!0,"function"==typeof i&&i(!1),setTimeout(function(){r.contains(o)&&r.removeChild(o)}))},o.onload=o.onreadystatechange,o.onerror=function(){"function"==typeof i&&i(!0),setTimeout(function(){r.contains(o)&&r.removeChild(o)})},"complete"===document.readyState?r.appendChild(o):window.addEventListener("load",function(){r.appendChild(o)}))}catch(e){console.log("error on below is caused by "+s+" "),console.error(e)}var e,n,i,o,r}}))},Ge.prototype.uploadLogs=function(e,t){this.lifeCycle.emit("uploadLogs",e=void 0===e?{}:e,t=void 0===t?{}:t)},Ge.sessionID="session-"+Date.now(),Ge.asyncPlugin={},Ge.urls={aegisCollect:"https://aegis.qq.com/collect",flog:"https://cdn-go.cn/vasdev/web_webpersistance_v2/v1.8.2/flog.core.min.js",shadowLog:""},Ge),Xe=new Y({name:"offlineLog"}),K=Xe=new Y({name:"offlineLog",onNewAegis:function(e){var t=We.urls.flog,h=e.config,g=[],v=null,m=null,y=function(e){m=e},w=function(e){g=g.concat(e)},b=function(e,t){v={conds:e=void 0===e?{}:e,params:t=void 0===t?{}:t}};We.useAsyncPlugin(t,{exportsConstructor:"Flog",onAegisInit:function(e){e.lifeCycle.on("beforeWrite",w),e.lifeCycle.on("uploadLogs",b),e.lifeCycle.on("onConfigChange",y)},onAegisInitAndPluginLoaded:function(i,e){var t,n,o,r,s,a=h.dbConfig,u=void 0===a?{}:a,c=h.url,l=void 0===c?We.urls.aegisCollect:c,f=h.offlineLogExp,d=void 0===f?3:f,a=h.id,c=h.uin;null===(f=i.lifeCycle)||void 0===f||f.remove("beforeWrite",w),null===(f=i.lifeCycle)||void 0===f||f.remove("uploadLogs",b),null===(f=i.lifeCycle)||void 0===f||f.remove("onConfigChange",y);u=Object.assign({lookupUrl:l+"/offlineAuto?id="+a,preservedDay:d,id:a,uin:c,aid:(null===(c=i.bean)||void 0===c?void 0:c.aid)||"",beforeRequest:i.config.beforeRequest,afterRequest:i.config.afterRequest},u,{sessionId:We.sessionID});try{var p=new e(u);g.forEach(function(e){p.add(E(E({},e),{level:e.level===O.INFO_ALL?O.INFO:e.level}))}),null===(t=i.lifeCycle)||void 0===t||t.on("beforeWrite",function(e){(e=void 0===e?[]:e).forEach(function(e){p.add(E(E({},e),{level:e.level===O.INFO_ALL?O.INFO:e.level}))})}),null===(n=i.lifeCycle)||void 0===n||n.on("uploadLogs",function(e,t){var n;void 0===e&&(e={}),void 0===t&&(t={}),p.uploadLogs(Object.assign({id:h.id,uin:h.uin,aid:null===(n=i.bean)||void 0===n?void 0:n.aid},e),t)}),null===(o=i.lifeCycle)||void 0===o||o.on("onConfigChange",function(e){p.setConfig(e)}),null===(r=i.lifeCycle)||void 0===r||r.on("destroy",function(){0===Xe.countInstance()&&(g.length=0,"function"==typeof((v=null)==p?void 0:p.destroy)&&p.destroy())}),p.on("PERREVENT",function(e){i.sendPipeline([function(e,t){var n=R({msg:L(e),level:O.INFO});t({type:T.OFFLINE,data:n,contentType:"application/x-www-form-urlencoded",method:"post",addBean:!1,url:h.url+"?id=893&sessionId="+We.sessionID+"&uin="+h.uin+"&from="+h.id+"&count=1&version=1.24.47",log:e})}],T.OFFLINE)(e)}),m&&(p.setConfig(m),m=null),v&&(null===(s=i.lifeCycle)||void 0===s||s.emit("uploadLogs",v.conds,v.params),v=null),i.flog=p}catch(i){console.log(i)}}})}}),qe=(new Y({name:"spa"}),new Y({name:"spa",init:function(){history.pushState=this.wr("pushState")||history.pushState,history.replaceState=this.wr("replaceState")||history.replaceState;var e=(null===(e=location.href)||void 0===e?void 0:e.split("?"))[0];this.$fireUrl=e,this.sendPv=this.sendPv.bind(this),this.onPageChange()},onPageChange:function(){window.addEventListener("replaceState",this.sendPv),window.addEventListener("pushState",this.sendPv),window.addEventListener("popstate",this.sendPv)},wr:function(n){var i=history[n];return"function"==typeof i&&!history.__hasWrittenByTamSpa&&(Object.defineProperty(history,"__hasWrittenByTamSpa",{value:!0,enumerable:!1}),function(){var e=i.apply(this,arguments),t=null;return"function"==typeof Event?t=new Event(n):(t=document.createEvent("HTMLEvents")).initEvent(n,!1,!0),window.dispatchEvent(t),e})},sendPv:function(){var n=this;setTimeout(function(){var t=location.href,e=(null===(e=location.href)||void 0===e?void 0:e.split("?"))[0];e&&e!==n.$fireUrl&&(n.$walk(function(e){e.send({url:e.config.pvUrl+"?from="+encodeURIComponent(t),beanFilter:["from"],type:T.WHITE_LIST})}),n.$fireUrl=e)},0)},destroy:function(){window.removeEventListener("replaceState",this.option.sendPv),window.removeEventListener("pushState",this.option.sendPv),window.removeEventListener("popstate",this.option.sendPv)}}));function Ge(e){var t,n,i,r=je.call(this,e)||this;r.requestQueue=[],r.requesting=!1,r.speedLogPipeline=Q([G(r.config),B(r),(i=r,function(t,n){be(function(e){i.extendBean("netType",e),n(t)})}),function(e,t){r.lifeCycle.emit("beforeReportSpeed",e);var o=r.config.beforeReportSpeed;if((e="function"==typeof o?e.filter(function(e){var t,n,i=!1!==o(e);return"fetch"===e.type&&void 0===e.ret&&e.payload&&(t=(n=m(e.payload.data.response,r.config.api,{url:e.payload.data.url,ctx:e.payload.data})||{}).code,n=n.isErr,e.ret=t,e.isErr=+n),i}):e).length)return t(e)},function(e){return r.sendPipeline([function(e,t){t({type:T.SPEED,url:""+r.config.speedUrl,method:"post",data:Z(e,r.bean),log:e})}],T.SPEED)(e)}]),e.asyncPlugin=!0;try{"undefined"!=typeof document&&(e.uin=e.uin||(null!==(t=document.cookie.match(/\buin=\D+(\d*)/))&&void 0!==t?t:[])[1]||(null!==(n=document.cookie.match(/\bilive_uin=\D*(\d+)/))&&void 0!==n?n:[])[1]||""),r.init(e),r.extendBean("sessionId",Ge.sessionID),r.extendBean("from",encodeURIComponent(e.pageUrl||location.href)),"undefined"!=typeof document&&r.extendBean("referer",encodeURIComponent(document.referrer||"")),e.ext1&&r.extendBean("ext1",e.ext1),e.ext2&&r.extendBean("ext2",e.ext2),e.ext3&&r.extendBean("ext3",e.ext3)}catch(e){console.warn(e),console.log("%cThe above error occurred in the process of initializing Aegis, which will affect your normal use of Aegis.\nIt is recommended that you contact us for feedback and thank you for your support.","color: red"),r.sendSDKError(e)}return r}function Je(){this.constructor=Fe}return new Y({name:"ie"}),We.use(Re),We.use(se),We.use(te),We.use(Te),We.use(Be),We.use(z),We.use(we),We.use(K),We.use(qe),We});


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_regexp_match_js__);
(function(win,lib){var doc=win.document;var docEl=doc.documentElement;var metaEl=doc.querySelector('meta[name="viewport"]');var flexibleEl=doc.querySelector('meta[name="flexible"]');var dpr=0;var scale=0;var tid;var flexible=lib.flexible||(lib.flexible={});var isMobile=/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);var isTablet=/iPad|Android|Tablet/i.test(navigator.userAgent)||win.innerWidth>=768&&win.innerHeight>=1024||win.innerWidth>=1024&&win.innerHeight>=768;if(metaEl){console.warn("将根据已有的meta标签来设置缩放比例");var match=metaEl.getAttribute("content").match(/initial\-scale=([\d\.]+)/);if(match){scale=parseFloat(match[1]);dpr=parseInt(1/scale);}}else if(flexibleEl){var content=flexibleEl.getAttribute("content");if(content){var initialDpr=content.match(/initial\-dpr=([\d\.]+)/);var maximumDpr=content.match(/maximum\-dpr=([\d\.]+)/);if(initialDpr){dpr=parseFloat(initialDpr[1]);scale=parseFloat((1/dpr).toFixed(2));}if(maximumDpr){dpr=parseFloat(maximumDpr[1]);scale=parseFloat((1/dpr).toFixed(2));}}}if(!dpr&&!scale){var isIPhone=win.navigator.appVersion.match(/iphone/gi);var devicePixelRatio=win.devicePixelRatio;if(isIPhone){if(devicePixelRatio>=3&&(!dpr||dpr>=3)){dpr=3;}else if(devicePixelRatio>=2&&(!dpr||dpr>=2)){dpr=2;}else{dpr=1;}}else{dpr=1;}if(isTablet){dpr=devicePixelRatio>=2?2:1;}scale=1/dpr;}docEl.setAttribute("data-dpr",dpr);if(!metaEl){metaEl=doc.createElement("meta");metaEl.setAttribute("name","viewport");metaEl.setAttribute("content","initial-scale="+scale+", maximum-scale="+scale+", minimum-scale="+scale+", user-scalable=no");if(docEl.firstElementChild){docEl.firstElementChild.appendChild(metaEl);}else{var wrap=doc.createElement("div");wrap.appendChild(metaEl);doc.write(wrap.innerHTML);}}function refreshRem(){var width=docEl.getBoundingClientRect().width;var rem=width/10;if(win.innerWidth>1024&&!isMobile){rem=102.4;}docEl.style.fontSize=rem+"px";flexible.rem=win.rem=rem;}win.addEventListener("resize",function(){clearTimeout(tid);tid=setTimeout(refreshRem,300);},false);win.addEventListener("pageshow",function(e){if(e.persisted){clearTimeout(tid);tid=setTimeout(refreshRem,300);}},false);if(doc.readyState==="complete"){doc.body.style.fontSize=12*dpr+"px";}else{doc.addEventListener("DOMContentLoaded",function(e){doc.body.style.fontSize=12*dpr+"px";},false);}refreshRem();flexible.dpr=win.dpr=dpr;flexible.refreshRem=refreshRem;flexible.rem2px=function(d){var val=parseFloat(d)*this.rem;if(typeof d==="string"&&d.match(/rem$/)){val+="px";}return val;};flexible.px2rem=function(d){var val=parseFloat(d)/this.rem;if(typeof d==="string"&&d.match(/px$/)){val+="rem";}return val;};})(window,window["lib"]||(window["lib"]={}));

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOfflineWebData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_array_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es7_object_entries_js__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es7_object_entries_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es7_object_entries_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_is_array_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_is_array_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_array_is_array_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_symbol_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_string_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_array_iterator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_web_dom_iterable_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_array_slice_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_array_from_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(7);
function _slicedToArray(arr,i){return _arrayWithHoles(arr)||_iterableToArrayLimit(arr,i)||_unsupportedIterableToArray(arr,i)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _iterableToArrayLimit(arr,i){var _i=arr==null?null:typeof Symbol!=="undefined"&&arr[Symbol.iterator]||arr["@@iterator"];if(_i==null)return;var _arr=[];var _n=true;var _d=false;var _s,_e;try{for(_i=_i.call(arr);!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"]!=null)_i["return"]();}finally{if(_d)throw _e;}}return _arr;}function _arrayWithHoles(arr){if(Array.isArray(arr))return arr;}function getOfflineWebData(){return new Promise(function(resolve,reject){var appVersion=__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].getVersion();var isAndroid=__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].isAndroid();if(!isAndroid&&__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].SHDiffVersion(appVersion,'8.24.0')||isAndroid&&__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* default */].SHDiffVersion(appVersion,'8.25.0')){// IOS 8.24.0 开始支持离线包
// Android 8.25.0 开始支持离线包
window.Jockey&&window.Jockey.send('getOfflinePageData',function(res){if(res&&res.baseConfig&&res.components){var baseConfig=res.baseConfig,components=res.components;baseConfig=typeof baseConfig==='string'?JSON.parse(baseConfig):baseConfig;components=typeof components==='string'?JSON.parse(components):components;// 设置页面标题
document.title=baseConfig.title;// 设置页面背景色
document.documentElement.style.backgroundColor=baseConfig.backgroundColor;document.body.style.backgroundColor=baseConfig.backgroundColor;// 设置全局页面基本配置
Object.entries(baseConfig).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];if(window.hasOwnProperty(key)){window[key]=value;}});// 设置全局组件配置
window.INIT_DATA=components;resolve({});}else{resolve({});}});}else{resolve({});}});}

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(30);
var $entries = __webpack_require__(220)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/main.f061a3c1.js